
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3UDh4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Roadmap", () => $2fdfe2cefe086e3d$export$a30ff54f42f5beca);
$parcel$export(module.exports, "RoadmapWithExperienceTracker", () => $2fdfe2cefe086e3d$export$44c65390e6d85d61);
$parcel$export(module.exports, "default", () => $2fdfe2cefe086e3d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $dpXKE = parcelRequire("dpXKE");

var $9EHc8 = parcelRequire("9EHc8");

var $5GxEP = parcelRequire("5GxEP");

var $huI7r = parcelRequire("huI7r");

var $ciulY = parcelRequire("ciulY");

var $SEaoU = parcelRequire("SEaoU");

var $jkWSB = parcelRequire("jkWSB");

var $bU6C3 = parcelRequire("bU6C3");

var $eIp1n = parcelRequire("eIp1n");

var $9ohLM = parcelRequire("9ohLM");


var $6M8Uw = parcelRequire("6M8Uw");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $hADNA = parcelRequire("hADNA");

var $eIXz9 = parcelRequire("eIXz9");

var $fOHQR = parcelRequire("fOHQR");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $2fdfe2cefe086e3d$var$clearCache = ()=>{};
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $2fdfe2cefe086e3d$var$updateCache = ()=>{};
const $2fdfe2cefe086e3d$var$getKeys = (routeContext, cloudId)=>{
    const projectKey = routeContext.match.params.projectKey || '';
    const boardId = routeContext.match.params.boardId || '';
    return [
        projectKey,
        boardId,
        (0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: boardId
        })
    ];
};
const $2fdfe2cefe086e3d$var$useRoadmapResource = (0, $ciulY.withSuspense)(()=>(0, $lB25E.useResource)((0, $bU6C3.nextGenRoadmapResource)));
const $2fdfe2cefe086e3d$export$a30ff54f42f5beca = (projectKey, boardId, sourceAri)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const roadmapDataResource = $2fdfe2cefe086e3d$var$useRoadmapResource();
    const [{ data: containerData }] = (0, $SEaoU.useContainerContext)();
    const projectName = containerData && 'project' in containerData && containerData.project.name || '';
    const prefetchDataId = `software/roadmap:${boardId}`;
    const prefetchData = {
        data: roadmapDataResource.data,
        loading: roadmapDataResource.loading,
        error: roadmapDataResource.error,
        clearCache: $2fdfe2cefe086e3d$var$clearCache,
        updateCache: $2fdfe2cefe086e3d$var$updateCache,
        id: prefetchDataId
    };
    if (!(containerData && 'project' in containerData && containerData.project)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkWSB.MetaAPIConsumer), null, (getMeta)=>(0, $eIXz9.default)((0, $27ecaf74a39e2b82$export$296f840b5ae7056e), boardId, projectName, sourceAri, getMeta, tenantContext, prefetchData));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkWSB.MetaAPIConsumer), null, (getMeta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            projectKey: containerData.project.key,
            projectName: containerData.project.name,
            projectId: containerData.project.id,
            isSimplifiedProject: true
        }, (0, $eIXz9.default)((0, $27ecaf74a39e2b82$export$296f840b5ae7056e), boardId, projectName, sourceAri, getMeta, tenantContext, prefetchData), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ohLM.default), {
            resource: roadmapDataResource
        })));
};
const $2fdfe2cefe086e3d$export$44c65390e6d85d61 = (routeContext)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [projectKey, boardId, sourceAri] = $2fdfe2cefe086e3d$var$getKeys(routeContext, tenantContext.cloudId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experienceId: projectKey,
        experience: "viewRoadmap",
        analyticsSource: "roadmap",
        edition: tenantContext.appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: (0, $hADNA.toRoadmapSpaAppId)((0, $27ecaf74a39e2b82$export$296f840b5ae7056e)),
        packageName: "jiraSpaAppsRoadmap",
        withExperienceTracker: true
    }, $2fdfe2cefe086e3d$export$a30ff54f42f5beca(projectKey, Number(boardId), sourceAri))));
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $2fdfe2cefe086e3d$var$RouterWrapper = (0, $lB25E.withRouter)((0, $fOHQR.withLicenseCheck)($2fdfe2cefe086e3d$export$44c65390e6d85d61)); // eslint-disable-line @typescript-eslint/no-explicit-any
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$2fdfe2cefe086e3d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2fdfe2cefe086e3d$var$RouterWrapper, props);

});
parcelRegister("ciulY", function(module, exports) {

$parcel$export(module.exports, "withSuspense", () => $47280a1aa92c9d77$export$a3bce93d4fb4eda6);
const $47280a1aa92c9d77$var$isDataEmpty = (data)=>data == null;
function $47280a1aa92c9d77$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $47280a1aa92c9d77$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});

parcelRegister("jkWSB", function(module, exports) {

$parcel$export(module.exports, "MetaAPIConsumer", () => $63ce08ffb5bc96ef$export$8b3f3b109d67f2a);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");
/**
 * Provide `getMeta(...)` via context.
 */ const $63ce08ffb5bc96ef$var$MetaAPIContext = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $6rW04.default));
const { Provider: $63ce08ffb5bc96ef$export$ab3e6458d0544c37, Consumer: $63ce08ffb5bc96ef$export$8b3f3b109d67f2a } = $63ce08ffb5bc96ef$var$MetaAPIContext;
const $63ce08ffb5bc96ef$export$42954e2090da65e = ()=>(0, $eUqFw.useContext)($63ce08ffb5bc96ef$var$MetaAPIContext);

});

parcelRegister("9ohLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c8dd705c55dbbc3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $78d1w = parcelRequire("78d1w");
/**
 * Refresh the resource on mount if it's not already loading or stale, resource from prefetch will have 10s expiry time.
 */ const $0c8dd705c55dbbc3$var$RefreshResourceOnMount = ({ resource: resource, refreshOnExpired: refreshOnExpired })=>{
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    // Store these values once, we don't want the useEffect proccing more than once after mount
    const [isFullRender] = (0, $eUqFw.useState)(isInitialRender);
    const [hasCache, setHasCache] = (0, $eUqFw.useState)(false);
    const [hasRefreshed, setHasRefreshed] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (resource === null || hasRefreshed) return;
        // If we started loading set the cache miss flag to true. React-resource-router procs this
        // on page load
        if (resource.loading || refreshOnExpired && resource.expiresAt && resource.expiresAt > Date.now()) {
            setHasCache(true);
            return;
        }
        // If this is not a full render (i.e. a SPA transition)
        // And this is a cache miss (our requested resource never got set to loading true)
        if (!isFullRender && !hasCache) {
            resource.refresh();
            setHasRefreshed(true);
        }
    }, [
        hasRefreshed,
        hasCache,
        isFullRender,
        resource,
        refreshOnExpired
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $0c8dd705c55dbbc3$var$RefreshResourceOnMountWithBoundaries = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "jira-software-resource-invalidator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c8dd705c55dbbc3$var$RefreshResourceOnMount, props));
var $0c8dd705c55dbbc3$export$2e2bcd8739ae039 = $0c8dd705c55dbbc3$var$RefreshResourceOnMountWithBoundaries;

});

const $27ecaf74a39e2b82$export$40f914e9a75ff65a = 'CLASSIC';
const $27ecaf74a39e2b82$export$296f840b5ae7056e = 'NEXTGEN';

parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("hADNA", function(module, exports) {

$parcel$export(module.exports, "toRoadmapSpaAppId", () => $63abec3298f57f4a$export$8a3bb66c7ed17f25);
const $63abec3298f57f4a$export$8a3bb66c7ed17f25 = (type)=>`spa-apps.roadmap.${type}`.toLowerCase();

});

parcelRegister("eIXz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $419af4366949ef36$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $iTvqy = parcelRequire("iTvqy");

var $jqvCZ = parcelRequire("jqvCZ");

var $jG2Eu = parcelRequire("jG2Eu");

var $3rlFA = parcelRequire("3rlFA");

var $kwMhr = parcelRequire("kwMhr");

var $lzvR2 = parcelRequire("lzvR2");

var $gUUjF = parcelRequire("gUUjF");

var $fee69 = parcelRequire("fee69");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5yh8X = parcelRequire("5yh8X");

var $7vf5z = parcelRequire("7vf5z");


var $841Zr = parcelRequire("841Zr");


var $eEvao = parcelRequire("eEvao");

var $1gs0D = parcelRequire("1gs0D");

var $fO5rB = parcelRequire("fO5rB");

var $iJHZm = parcelRequire("iJHZm");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $3iMaY = parcelRequire("3iMaY");

var $hADNA = parcelRequire("hADNA");

var $81WTV = parcelRequire("81WTV");
// permanent FF
const $419af4366949ef36$var$getIssueLimit = ()=>(0, $1ybV0.getFeatureFlagValue)('jsw.roadmap.issue-overall-limit', 3000);
const $419af4366949ef36$var$logError = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((type, error)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(type, 'Prefetch data error', error));
const $419af4366949ef36$var$getIsReleasesVisible = (criticalData)=>Boolean(criticalData?.configuration?.projectConfiguration?.isReleasesFeatureEnabled && criticalData?.settings?.isReleasesVisible);
const $419af4366949ef36$var$getCriticalDataTraceId = (criticalData)=>({
        criticalDataTraceId: (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(criticalData?.metadata?.traceIds || []) || ''
    });
const $419af4366949ef36$var$isNativeGraphQL = (criticalData)=>criticalData?.metadata?.extensions?.roadmaps?.isNativeGraphQL || false;
const $419af4366949ef36$export$aea546e78d89246e = (criticalData)=>{
    let issuesCount = 0;
    let epicsCount = 0;
    if (criticalData && criticalData.issues) {
        const { hash: hash, sequence: sequence } = criticalData.issues;
        sequence.forEach((id)=>{
            issuesCount += 1;
            if (!hash[id].parentId.value) epicsCount += 1;
        });
    }
    return {
        issuesCount: issuesCount,
        epicsCount: epicsCount
    };
};
const $419af4366949ef36$var$renderApp = (type, rapidViewId, containerName, sourceAri, metaConsumerData, { tenantContext: tenantContext }, { error: prefetchError, loading: loading, data: data })=>{
    if (prefetchError && !loading) {
        $419af4366949ef36$var$logError((0, $hADNA.toRoadmapSpaAppId)(type), prefetchError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
            location: (0, $1gs0D.ROADMAP_RESOURCE_DATA_FAILED)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: "roadmap",
            error: prefetchError
        }));
    }
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $841Zr.RoadmapSkeleton), null);
    /**
   *  Redirect users to projects page when project is not available.
   */ if (data.roadmapErrorContext) {
        const errorType = data.roadmapErrorContext.type;
        if (errorType === (0, $a04539576b54c5d8$export$50a1bc82cf68f557)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects?showFlag=jsw.project-not-found"
        });
        if (errorType === (0, $a04539576b54c5d8$export$e5e4b8c32e68dd0b)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
            location: (0, $1gs0D.ROADMAP_CRITICAL_DATA_SUCCEEDED)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: "roadmap",
            error: null
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
            location: (0, $1gs0D.ROADMAP_CRITICAL_DATA_FAILED),
            failureEventAttributes: data.roadmapErrorContext.context
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: "roadmap",
            error: null
        }));
    }
    // Custom data added to UFO and BM3 events.
    const analyticsCustomData = {
        ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
        ...$419af4366949ef36$export$aea546e78d89246e(data.roadmapData),
        ...$419af4366949ef36$var$getCriticalDataTraceId(data.roadmapData)
    };
    const { roadmapData: roadmapData, resourcesCacheSource: resourcesCacheSource } = data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "roadmap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3rlFA.ArchivedProjectRedirect), null), roadmapData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eEvao.default), {
        type: type,
        boardId: rapidViewId,
        containerName: containerName,
        sourceAri: sourceAri,
        locale: tenantContext.locale,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        loggedInAccountId: tenantContext.atlassianAccountId || '',
        cloudId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        criticalData: {
            ...roadmapData,
            resourcesCacheSource: resourcesCacheSource
        },
        isServer: false,
        isSiteAdmin: tenantContext.isSiteAdmin,
        onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "software-roadmap",
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $5yh8X.appBundleReadyMark),
            (0, $5yh8X.prefetchApiReadyMark)
        ],
        metric: (0, $81WTV.roadmapPageLoad),
        extra: {
            ...analyticsCustomData,
            isNativeGraphQL: $419af4366949ef36$var$isNativeGraphQL(data.roadmapData),
            isSimplified: type === (0, $27ecaf74a39e2b82$export$296f840b5ae7056e),
            isIssueDetailsOpen: window.location.href.includes('?selectedIssue='),
            hasAppliedJQLFilters: window.location.href.includes('customFilter=') || window.location.href.includes('quickFilter='),
            hasAppliedGoalFilters: window.location.href.includes('goal='),
            isIssueLimit5kEnabled: $419af4366949ef36$var$getIssueLimit() === 5000,
            isReleasesVisible: $419af4366949ef36$var$getIsReleasesVisible(data.roadmapData),
            isCustomScrollbarPdnd: (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_custom_scroll_pdnd')
        },
        ttrSlo: (0, $1gs0D.TTRSLO),
        ttiSlo: (0, $1gs0D.TTISLO),
        emitOnAnimationFrame: (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
        data: analyticsCustomData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$419af4366949ef36$export$2e2bcd8739ae039 = (type, rapidViewId, containerName, sourceAri, metaConsumerData, tenantContext, prefetchData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), $419af4366949ef36$var$renderApp(type, rapidViewId, containerName, sourceAri, metaConsumerData, {
        tenantContext: tenantContext
    }, prefetchData));

});
parcelRegister("3rlFA", function(module, exports) {

$parcel$export(module.exports, "ArchivedProjectRedirect", () => $c4611224216e7ea4$export$6e1a5929022745db);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");

var $eI64M = parcelRequire("eI64M");
const $c4611224216e7ea4$export$6e1a5929022745db = ()=>{
    const [{ data: data, error: error }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const projectData = data && data.project || {};
    const { key: projectKey } = projectData;
    if (error || !data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.default), {
        projectKey: projectKey || null
    });
};

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';



parcelRegister("lzvR2", function(module, exports) {

$parcel$export(module.exports, "getPerformanceFFsString", () => $eea190c0a66e0041$export$c983ad7dc5517558);
$parcel$export(module.exports, "getNormalisedPerformanceFFs", () => $eea190c0a66e0041$export$de03840ff3eb49a4);

var $hgFNe = parcelRequire("hgFNe");

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $aWbzA = parcelRequire("aWbzA");
const $eea190c0a66e0041$var$PERF_FF_PREFIX = 'jsw.perf.';
const $eea190c0a66e0041$var$EXTRA_FFS_WHITELIST = new Set([
    'fe.platform.error.tracking.enabled',
    'jsw.roadmap.remote-actions-rollout',
    'jsw-epic-panel-performance-async-epic-details'
]);
const $eea190c0a66e0041$var$getPerformanceFFs = (0, $5iWql.default)(()=>{
    const featureFlags = Object.entries((0, $aWbzA.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>key.startsWith($eea190c0a66e0041$var$PERF_FF_PREFIX)) // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key.substring($eea190c0a66e0041$var$PERF_FF_PREFIX.length),
            (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, [
                'value'
            ], null)
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hgFNe)))(featureFlags);
});
const $eea190c0a66e0041$var$isConsistencyCheckValue = (value)=>value === 'NEW' || value === 'OLD' || value === 'CHECK' || value === 'CHECK_RETURN_NEW';
const $eea190c0a66e0041$export$448575db1388a8e6 = (0, $5iWql.default)((whitelist = $eea190c0a66e0041$var$EXTRA_FFS_WHITELIST)=>{
    const featurePairs = Object.entries((0, $aWbzA.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>whitelist.has(key)) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key,
            (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, [
                'value'
            ], null)
        ]); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    // @ts-expect-error - TS2345 - Argument of type '([key, value]: [any, any]) => void' is not assignable to parameter of type '(value: any[], index: number, array: any[][]) => void'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featurePairs.forEach(([key, value])=>{
        result[key] = value;
        if ($eea190c0a66e0041$var$isConsistencyCheckValue(value)) {
            result[`${key}-new`] = value === 'NEW';
            result[`${key}-old`] = value === 'OLD';
            result[`${key}-check`] = value === 'CHECK';
            result[`${key}-check-return-new`] = value === 'CHECK_RETURN_NEW';
        }
    });
    return result;
});
const $eea190c0a66e0041$export$c983ad7dc5517558 = (0, $5iWql.default)(()=>JSON.stringify($eea190c0a66e0041$var$getPerformanceFFs()));
const $eea190c0a66e0041$export$de03840ff3eb49a4 = (0, $5iWql.default)(()=>{
    const featureEntries = Object.entries({
        ...$eea190c0a66e0041$var$getPerformanceFFs(),
        ...$eea190c0a66e0041$export$448575db1388a8e6()
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featureEntries.forEach(([key, value])=>{
        const normalisedKey = key.replace(/\./g, '-');
        map[normalisedKey] = value;
        return map;
    });
    return map;
});

});

parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


const $a04539576b54c5d8$export$50a1bc82cf68f557 = 'PROJECT_NOT_AVAILABLE_ERROR';
const $a04539576b54c5d8$export$e5e4b8c32e68dd0b = 'NETWORK_ERROR';
const $a04539576b54c5d8$export$f10b32dfda12e96e = 'UNKNOWN_ERROR';

parcelRegister("eEvao", function(module, exports) {

$parcel$export(module.exports, "default", () => $d45b1240b7acf722$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $4Bees = parcelRequire("4Bees");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $4B7EY = parcelRequire("4B7EY");

var $bQQi1 = parcelRequire("bQQi1");

var $64fil = parcelRequire("64fil");

var $aR8n6 = parcelRequire("aR8n6");

var $9m9bG = parcelRequire("9m9bG");

var $6FP8W = parcelRequire("6FP8W");


var $5cznK = parcelRequire("5cznK");

var $1JdUa = parcelRequire("1JdUa");


var $lB25E = parcelRequire("lB25E");

var $1gs0D = parcelRequire("1gs0D");

var $jgC5j = parcelRequire("jgC5j");

var $hoFgf = parcelRequire("hoFgf");

var $2XiKM = parcelRequire("2XiKM");

var $g8PwR = parcelRequire("g8PwR");

var $ecAMT = parcelRequire("ecAMT");

var $dFuRD = parcelRequire("dFuRD");

var $bIFjW = parcelRequire("bIFjW");

var $lKzXJ = parcelRequire("lKzXJ");
const $d45b1240b7acf722$var$isDevelopment = window.BUILD_KEY === 'JF-TEST';
// eslint-disable-next-line jira/react/no-class-components
class $d45b1240b7acf722$var$StandardRoadmap extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isServer: false,
            isReadOnly: false,
            cloudId: undefined,
            activationId: undefined,
            macroConfig: undefined,
            type: (0, $27ecaf74a39e2b82$export$296f840b5ae7056e),
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    constructor(props){
        super(props);
        const { criticalData: criticalData } = props;
        this.initialiseStore(criticalData);
    }
    componentDidMount() {
        const { criticalData: criticalData } = this.props;
        if (criticalData) this.initialiseUserPropertiesEngine();
    }
    componentDidUpdate(prevProps) {
        // Update stale data from cache with latest critical-data
        if (this.store && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevProps.criticalData, this.props.criticalData) && this.props.criticalData && // Ignore critical-data updates if it is from resources cache updater
        (!((0, $c22b1ee1fcd49c4a$export$889129cf7f70997b) in this.props.criticalData) || this.props.criticalData[0, $c22b1ee1fcd49c4a$export$889129cf7f70997b] !== (0, $c22b1ee1fcd49c4a$export$b7dfe28569b170a1))) {
            (0, $5cznK.triggerCacheRefreshAnalytics)((0, $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822));
            this.store.dispatch((0, $ecAMT.updateCriticalData)(this.props.criticalData));
        }
    }
    componentWillUnmount() {
        if (this.store && this.store.dispatch) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.store.dispatch((0, $4B7EY.DISPOSE_ACTION));
        this.props.onUnmount();
    }
    initialiseStore(criticalData) {
        const { push: push, location: location, type: type } = this.props;
        const rootEpic = (0, $hoFgf.default)(type);
        this.store = (0, $g8PwR.default)(type, (0, $bQQi1.disposableEpic)(rootEpic), {
            router: {
                push: push
            }
        });
        this.store.dispatch((0, $ecAMT.initializeAppProps)(this.getAppProps()));
        this.store.dispatch((0, $ecAMT.initializeCriticalData)(criticalData));
        this.store.dispatch((0, $dFuRD.routerLocationChange)(location));
    }
    initialiseUserPropertiesEngine() {
        const { criticalData: criticalData, boardId: boardId, sourceAri: sourceAri, loggedInAccountId: loggedInAccountId, macroConfig: macroConfig } = this.props;
        // hydration
        const settings = criticalData.settings || {};
        const userPropertyKey = `roadmap${macroConfig ? '-macro' : ''}`;
        if (this.store) (0, $64fil.attachToStore)(this.store, (0, $bIFjW.engine)(userPropertyKey, boardId, sourceAri, ()=>loggedInAccountId, settings), (0, $2XiKM.default)).subscribe();
    }
    getAppProps() {
        const { isReadOnly: isReadOnly, boardId: boardId, sourceAri: sourceAri, loggedInAccountId: loggedInAccountId, cloudId: cloudId, activationId: activationId, macroConfig: macroConfig, type: type, containerName: containerName } = this.props;
        return {
            isReadOnly: isReadOnly,
            boardId: boardId,
            sourceAri: sourceAri,
            loggedInAccountId: loggedInAccountId,
            cloudId: cloudId,
            activationId: activationId,
            macroConfig: macroConfig,
            containerName: containerName,
            type: type
        };
    }
    getRoadmapView() {
        const { macroConfig: macroConfig, type: type } = this.props;
        if (type === (0, $27ecaf74a39e2b82$export$40f914e9a75ff65a) && !macroConfig) return 0, $lKzXJ.ClassicStandardView;
        if (type === (0, $27ecaf74a39e2b82$export$40f914e9a75ff65a) && macroConfig) return 0, $lKzXJ.ClassicStandardMacro;
        if (macroConfig) return 0, $lKzXJ.StandardMacro;
        return 0, $lKzXJ.StandardView;
    }
    render() {
        const { isServer: isServer, macroConfig: macroConfig, type: type, criticalData: criticalData } = this.props;
        if (!criticalData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d45b1240b7acf722$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        }));
        const RoadmapView = this.getRoadmapView();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            id: (0, $1gs0D.toRoadmapAppId)(type),
            store: this.store,
            teamName: "chronos",
            packageName: "@atlassian/jira-software-roadmap-standard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            id: (0, $1gs0D.toRoadmapAppId)(type),
            packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
            attributes: {
                isDevelopment: $d45b1240b7acf722$var$isDevelopment
            }
        }, (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RoadmapView, {
            isServer: isServer,
            isMacroView: Boolean(macroConfig)
        }), type !== (0, $27ecaf74a39e2b82$export$40f914e9a75ff65a) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JdUa.default), {
            origin: (0, $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9m9bG.FlagsDispatcher), {
            mapper: (0, $jgC5j.flagsMapper)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RoadmapView, {
            isServer: isServer,
            isMacroView: Boolean(macroConfig)
        }), type !== (0, $27ecaf74a39e2b82$export$40f914e9a75ff65a) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JdUa.default), {
            origin: (0, $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9m9bG.FlagsDispatcher), {
            mapper: (0, $jgC5j.flagsMapper)
        }))));
    }
}
var $d45b1240b7acf722$export$2e2bcd8739ae039 = (0, $lB25E.withRouter)($d45b1240b7acf722$var$StandardRoadmap);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d45b1240b7acf722$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb13sl _4t3i1osq _kqswstnw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("4B7EY", function(module, exports) {

$parcel$export(module.exports, "DISPOSE_ACTION", () => $fcece09efe01c906$export$78be82e7e063a3fb);

const $fcece09efe01c906$export$78be82e7e063a3fb = {
    type: (0, $4f32d292c46e5882$export$58387e80544dbf03)
};

});
const $4f32d292c46e5882$export$58387e80544dbf03 = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION';


parcelRegister("bQQi1", function(module, exports) {

$parcel$export(module.exports, "disposableEpic", () => $669b2126028ef686$export$e6b812e492b046b8);
parcelRequire("5hZYM");

const $669b2126028ef686$export$e6b812e492b046b8 = (rootEpic)=>(action$, store, dependencies)=>rootEpic(action$, store, dependencies).takeUntil(action$.ofType((0, $4f32d292c46e5882$export$58387e80544dbf03)));

});

parcelRegister("64fil", function(module, exports) {

$parcel$export(module.exports, "attachToStore", () => $f9bfaaf88e54f4f9$export$646875c6afc27c8);
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("2rE4V");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");
const $f9bfaaf88e54f4f9$export$646875c6afc27c8 = (store, engine, rootStorage, // eslint-disable-next-line @typescript-eslint/no-explicit-any
waitUntil)=>{
    const trigger = waitUntil || (0, $3JafE.Observable).from([
        true
    ]);
    let initialized = false;
    return trigger.first().mergeMap(()=>{
        if (initialized) return (0, $3JafE.Observable).of(store);
        initialized = true;
        const hydrationActions = rootStorage.hydrate(store.getState(), engine);
        if (hydrationActions !== undefined) return hydrationActions.mergeMap((actions)=>{
            store.dispatch((0, $MYW4e.batchActions)(actions));
            store.subscribe(()=>{
                rootStorage.modify(store.getState(), engine);
            });
            return (0, $3JafE.Observable).of(store);
        });
        return (0, $3JafE.Observable).of(store);
    });
};

});

parcelRegister("9m9bG", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $002bf7125eab9f2d$export$9e60e3d40b6e758f);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $9IFOX = parcelRequire("9IFOX");
const $002bf7125eab9f2d$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9IFOX.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $k8Qyf.showFlag),
        dismissFlag: (0, $k8Qyf.dismissFlag)
    });

});
parcelRegister("9IFOX", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $d0a959626f60d440$export$ab054a1ef92eeb01);

var $eUqFw = parcelRequire("eUqFw");

var $6Yzg9 = parcelRequire("6Yzg9");
const $d0a959626f60d440$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $eUqFw.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $eUqFw.useMemo)(()=>(0, $6Yzg9.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("6Yzg9", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $4432f346a9cf5cd1$export$7b259d28468da15b);

var $eUqFw = parcelRequire("eUqFw");

var $3npQj = parcelRequire("3npQj");

var $k8Qyf = parcelRequire("k8Qyf");
const $4432f346a9cf5cd1$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $4432f346a9cf5cd1$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $k8Qyf.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $k8Qyf.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3npQj.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $4432f346a9cf5cd1$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $k8Qyf.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $4432f346a9cf5cd1$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $4432f346a9cf5cd1$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $4432f346a9cf5cd1$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $eUqFw.useMemo)(()=>$4432f346a9cf5cd1$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $4432f346a9cf5cd1$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $4432f346a9cf5cd1$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $3npQj.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4432f346a9cf5cd1$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $4432f346a9cf5cd1$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4432f346a9cf5cd1$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $4432f346a9cf5cd1$var$Dispatcher8DefaultStore;
};

});



const $c22b1ee1fcd49c4a$export$9b8283d5878d2491 = 'BOARD';
const $c22b1ee1fcd49c4a$export$dedbdcc35e955187 = 'BACKLOG';
const $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $c22b1ee1fcd49c4a$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $c22b1ee1fcd49c4a$export$b7dfe28569b170a1 = 'RESOURCES_CACHE_UPDATER_SOURCE';
const $c22b1ee1fcd49c4a$export$889129cf7f70997b = 'resourcesCacheSource';

parcelRegister("5cznK", function(module, exports) {

$parcel$export(module.exports, "default", () => $78426c31f217ab22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerCacheRefreshAnalytics", () => $78426c31f217ab22$export$e78b5ce2eed37743);

var $70s4u = parcelRequire("70s4u");
// Standard observer pattern, when the board/backlog/roadmap is mounted and loaded cache,
// but cache is stale and is updated by live data, this will be triggered
const $78426c31f217ab22$var$ResourcesCacheRefreshAnalytics = new (0, $70s4u.Subject)();
var $78426c31f217ab22$export$2e2bcd8739ae039 = $78426c31f217ab22$var$ResourcesCacheRefreshAnalytics;
const $78426c31f217ab22$export$e78b5ce2eed37743 = (origin)=>{
    $78426c31f217ab22$var$ResourcesCacheRefreshAnalytics.next(origin);
};

});

parcelRegister("1JdUa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48a5e529c3628da4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $eZThA = parcelRequire("eZThA");

var $4s0JT = parcelRequire("4s0JT");

var $2e3bR = parcelRequire("2e3bR");
const $48a5e529c3628da4$var$ResourcesCacheWrapper = ({ origin: origin })=>{
    (0, $eZThA.default)(origin);
    (0, $2e3bR.default)();
    (0, $4s0JT.default)(origin);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $48a5e529c3628da4$var$ResourcesCacheWrapperWithBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "jira-software-resource-invalidator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48a5e529c3628da4$var$ResourcesCacheWrapper, props));
var $48a5e529c3628da4$export$2e2bcd8739ae039 = $48a5e529c3628da4$var$ResourcesCacheWrapperWithBoundary;

});
parcelRegister("eZThA", function(module, exports) {

$parcel$export(module.exports, "default", () => $50d03910cf9c5012$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jnCPY");
parcelRequire("8OtG5");

var $iWLL0 = parcelRequire("iWLL0");

var $dWLk9 = parcelRequire("dWLk9");

var $lB25E = parcelRequire("lB25E");

var $ieUWD = parcelRequire("ieUWD");

var $iKyFB = parcelRequire("iKyFB");

var $l38jp = parcelRequire("l38jp");
/*
 * This hook is for handling when a change is performed that should invalidate the cache of another
 * resource. In the current case, the BOARD and BACKLOG caches are intertwined such that a major change
 * in the BOARD will invalidate the BACKLOG.
 */ const $50d03910cf9c5012$var$useResourcesCacheInvalidation = (origin)=>{
    const [resourcesRef] = (0, $iKyFB.default)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const boardId = match.params.boardId || '';
    (0, $eUqFw.useEffect)(()=>{
        // We don't want to refresh every time we have a change. Instead we only tell it to refresh its cache
        // AFTER we leave. The reason for doing this is we get a fresh cached version AFTER we've done all
        // our actions (and we minimise the number of API calls)
        let needToClearResourcesCacheOnExit = false;
        // We only need to proc this once and then we don't care about any further invalidation events
        const subscription = (0, $ieUWD.default).filter((val)=>val === origin).take(1).subscribe(()=>{
            // If we get an invalidation specific to this page, we flush out the caches of
            // all other pages we have cached that could be impacted
            Object.keys(resourcesRef.current).filter((key)=>key !== origin).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Resource>>'.
                resourcesRef.current[key].clear();
            });
            // Invalidate the boardScope resource in the Relay store
            (0, $l38jp.invalidateRelayStore)(environment, cloudId, boardId);
            // If we are allowed to refresh this cache on exit, set the flag for it
            if (origin in resourcesRef.current) needToClearResourcesCacheOnExit = true;
        });
        return ()=>{
            subscription.unsubscribe();
            if (needToClearResourcesCacheOnExit && origin in resourcesRef.current) {
                // Clear out this cache after we leave so when we come back we get a more up to date version.
                resourcesRef.current[origin].clear();
                // Invalidate the boardScope resource in the Relay store
                (0, $l38jp.invalidateRelayStore)(environment, cloudId, boardId);
            }
        };
    }, [
        origin,
        resourcesRef,
        environment,
        cloudId,
        boardId
    ]);
    return [
        (0, $ieUWD.default)
    ];
};
var $50d03910cf9c5012$export$2e2bcd8739ae039 = $50d03910cf9c5012$var$useResourcesCacheInvalidation;

});
parcelRegister("ieUWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $dce68b2aa6b68041$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerResourceCacheInvalidation", () => $dce68b2aa6b68041$export$76c3549b2288ab5d);
$parcel$export(module.exports, "addInvalidationReason", () => $dce68b2aa6b68041$export$77045c8772786aca);
$parcel$export(module.exports, "getAndClearInvalidationReasons", () => $dce68b2aa6b68041$export$c5ab3b0612bd31b4);

var $70s4u = parcelRequire("70s4u");


var $avsDR = parcelRequire("avsDR");
const $dce68b2aa6b68041$var$invalidationTracker = new (0, $avsDR.CacheInvalidationTracker)();
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be purged
const $dce68b2aa6b68041$var$ResourcesCacheInvalidationSubject = new (0, $70s4u.Subject)();
var $dce68b2aa6b68041$export$2e2bcd8739ae039 = $dce68b2aa6b68041$var$ResourcesCacheInvalidationSubject;
const $dce68b2aa6b68041$export$76c3549b2288ab5d = (origin, reason = (0, $c22b1ee1fcd49c4a$export$78244dbb77cfa6b6))=>{
    $dce68b2aa6b68041$var$ResourcesCacheInvalidationSubject.next(origin);
    $dce68b2aa6b68041$var$invalidationTracker.addReason(origin, reason);
};
const $dce68b2aa6b68041$export$77045c8772786aca = (origin, reason)=>{
    $dce68b2aa6b68041$var$invalidationTracker.addReason(origin, reason);
};
const $dce68b2aa6b68041$export$c5ab3b0612bd31b4 = (origin)=>$dce68b2aa6b68041$var$invalidationTracker.getAndClearReasons(origin);

});
parcelRegister("avsDR", function(module, exports) {

$parcel$export(module.exports, "CacheInvalidationTracker", () => $d2e1dd882832ab2e$export$71900622f425a7c3);

class $d2e1dd882832ab2e$export$71900622f425a7c3 {
    /**
	 * Pushes an invalidation reason to be tracked on the next cache-miss.
	 */ addReason(origin, reason = (0, $c22b1ee1fcd49c4a$export$78244dbb77cfa6b6)) {
        const reasonString = `${origin}:${reason}`;
        Object.keys(this.reasons).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            if (this.reasons[key].size >= 10) return;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            this.reasons[key].add(reasonString);
        });
    }
    /**
	 * Fetch invalidation reasons from the reasons set.
	 *
	 * If an experience does not read / clear reasons there's still only a bounded number of strings
	 * (10) that will be added into the Set; e.g. it's not a memory concern.
	 *
	 * The reasons are sorted.
	 */ getAndClearReasons(origin) {
        const reasonsSet = this.reasons[origin];
        const reasons = Array.from(reasonsSet);
        reasons.sort();
        reasonsSet.clear();
        return reasons;
    }
    constructor(){
        /**
	 * Holds reasons cache has been invalidated as a set of strings, for example:
	 *
	 * * BOARD:state.ISSUE_MOVE
	 * * BACKLOG:CREATE_SPRINT
	 *
	 * Reasons are kept separately for each page because they'll be cleared when the page is loaded.
	 *
	 * The reasoning can be exemplified by:
	 *
	 * * Visit board
	 * * Visit backlog
	 * * Visit roadmaps
	 * * Visit backlog - Load from cache
	 * * Make a BACKLOG:CARD_MOVE invalidation reason in backlog
	 *   * All 3 caches are now cleared
	 * * Visit board - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit roadmaps - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit backlog - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Make a BACKLOG:SPRINT_COMPLETE invalidation reason in backlog
	 * * Visit board - reason is BACKLOG:SPRINT_COMPLETE **only**
	 */ this.reasons = {
            [(0, $c22b1ee1fcd49c4a$export$9b8283d5878d2491)]: new Set(),
            [(0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187)]: new Set(),
            [(0, $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822)]: new Set(),
            [(0, $c22b1ee1fcd49c4a$export$78244dbb77cfa6b6)]: new Set()
        };
    }
}

});


parcelRegister("iKyFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfcdcca2f5502863$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $chAei = parcelRequire("chAei");

var $gmVN5 = parcelRequire("gmVN5");

var $bU6C3 = parcelRequire("bU6C3");

var $lB25E = parcelRequire("lB25E");

// We only ever want refresh and update in this component
// @ts-expect-error - TS7031 - Binding element 'update' implicitly has an 'any' type. | TS7031 - Binding element 'refresh' implicitly has an 'any' type. | TS7031 - Binding element 'clear' implicitly has an 'any' type.
const $dfcdcca2f5502863$var$buildResource = ({ update: update, refresh: refresh, clear: clear })=>({
        update: update,
        refresh: refresh,
        clear: clear
    });
/*
 * Simple hook that wraps the commonly used JSW resources in a dictionary and returns them
 */ const $dfcdcca2f5502863$var$useResourcesCacheTracker = ()=>{
    const boardResource = (0, $lB25E.useResource)((0, $chAei.boardResource));
    const backlogResource = (0, $lB25E.useResource)((0, $gmVN5.backlogResource));
    const roadmapResource = (0, $lB25E.useResource)((0, $bU6C3.nextGenRoadmapResource));
    // Store the retrieved objects in an internal state. The reason for doing this is because when our routes
    // change, the objects returned from useResource appear to change as well. We don't want/need that.
    const resourcesByOriginByRef = (0, $eUqFw.useRef)({});
    (0, $eUqFw.useEffect)(()=>{
        resourcesByOriginByRef.current = {
            [(0, $9d4e95f592d66664$export$9b8283d5878d2491)]: $dfcdcca2f5502863$var$buildResource(boardResource),
            [(0, $9d4e95f592d66664$export$dedbdcc35e955187)]: $dfcdcca2f5502863$var$buildResource(backlogResource),
            [(0, $9d4e95f592d66664$export$ffff0a2c60bf4822)]: $dfcdcca2f5502863$var$buildResource(roadmapResource)
        };
    }, [
        boardResource,
        backlogResource,
        roadmapResource
    ]);
    // @ts-expect-error - TS2322 - Type 'MutableRefObject<{}>' is not assignable to type 'ResourcesDictionary'.
    return [
        resourcesByOriginByRef
    ];
};
var $dfcdcca2f5502863$export$2e2bcd8739ae039 = $dfcdcca2f5502863$var$useResourcesCacheTracker;

});
const $9d4e95f592d66664$export$9b8283d5878d2491 = 'BOARD';
const $9d4e95f592d66664$export$dedbdcc35e955187 = 'BACKLOG';
const $9d4e95f592d66664$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $9d4e95f592d66664$export$78244dbb77cfa6b6 = 'UNKNOWN';


parcelRegister("l38jp", function(module, exports) {

$parcel$export(module.exports, "invalidateRelayStore", () => $3a7ab9bf04da86d8$export$fac5cf9145049c1c);

var $huI7r = parcelRequire("huI7r");
const $3a7ab9bf04da86d8$export$fac5cf9145049c1c = (environment, cloudId, boardId)=>{
    const boardAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: boardId
    });
    environment.commitUpdate((store)=>{
        const boardScopeRecord = store.getRoot().getLinkedRecord('boardScope', {
            boardId: boardAri
        });
        if (boardScopeRecord) boardScopeRecord.invalidateRecord();
    });
};

});


parcelRegister("4s0JT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c09bc7e8f5aeaea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("8OtG5");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5cznK = parcelRequire("5cznK");
/*
 * This hook is for firing an analytics event to track whether the cache is stale
 * It will be fired when we load a cache but the cache is stale and later gets updated
 */ const $7c09bc7e8f5aeaea$var$useCacheRefreshAnalytics = (origin)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const subscription = (0, $5cznK.default).filter((val)=>val === origin).subscribe(()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'resourcesCacheInvalidator updatedStaleData', {
                origin: origin
            });
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        createAnalyticsEvent,
        origin
    ]);
    return [
        (0, $5cznK.default)
    ];
};
var $7c09bc7e8f5aeaea$export$2e2bcd8739ae039 = $7c09bc7e8f5aeaea$var$useCacheRefreshAnalytics;

});

parcelRegister("2e3bR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41ae913878c87da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");
parcelRequire("8OtG5");


var $Tnz9v = parcelRequire("Tnz9v");

var $iKyFB = parcelRequire("iKyFB");
/*
 * Note this is only really used to handle real-time updates or any other methods of updating the cache
 */ const $e41ae913878c87da$var$useResourcesCacheUpdater = ()=>{
    // Use a local resources cache to track all the useResource instances for each key
    const [resourcesByRef] = (0, $iKyFB.default)();
    (0, $eUqFw.useEffect)(()=>{
        // We only need to proc this once and then we don't care about any further invalidation events
        const subscription = (0, $Tnz9v.default).filter((msg)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(msg.origin)).subscribe((msg)=>{
            // Only handle this update if we have the resources in our dictionary
            if (msg.origin in resourcesByRef.current) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(msg.payload)) resourcesByRef.current[msg.origin].clear();
                else // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2345 - Argument of type '(currentData: any) => any' is not assignable to parameter of type '() => null'. | TS7006 - Parameter 'currentData' implicitly has an 'any' type.
                resourcesByRef.current[msg.origin].update((currentData)=>({
                        ...currentData,
                        ...msg.payload,
                        // Metadata to tell us where this actually came from
                        [(0, $c22b1ee1fcd49c4a$export$889129cf7f70997b)]: (0, $c22b1ee1fcd49c4a$export$b7dfe28569b170a1)
                    }));
            }
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        resourcesByRef
    ]);
    return [
        (0, $Tnz9v.default)
    ];
};
var $e41ae913878c87da$export$2e2bcd8739ae039 = $e41ae913878c87da$var$useResourcesCacheUpdater;

});
parcelRegister("Tnz9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $188b2e5bea53760e$export$2e2bcd8739ae039);

var $70s4u = parcelRequire("70s4u");
var // Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
// eslint-disable-next-line jira/import/no-anonymous-default-export
$188b2e5bea53760e$export$2e2bcd8739ae039 = new (0, $70s4u.Subject)();

});



parcelRegister("1gs0D", function(module, exports) {

$parcel$export(module.exports, "ROADMAP_APP_ID", () => $0bbdb625f85b79b8$export$eb64d27edca3e703);
$parcel$export(module.exports, "toRoadmapAppId", () => $0bbdb625f85b79b8$export$ad60357d6714d43);
$parcel$export(module.exports, "ROADMAP_PACKAGE_NAME", () => $0bbdb625f85b79b8$export$8c14295980d51b03);
$parcel$export(module.exports, "ROADMAP_CRITICAL_DATA_SUCCEEDED", () => $0bbdb625f85b79b8$export$4fd29a5a4da01768);
$parcel$export(module.exports, "ROADMAP_CRITICAL_DATA_FAILED", () => $0bbdb625f85b79b8$export$f764daad80c436d4);
$parcel$export(module.exports, "ROADMAP_RESOURCE_DATA_FAILED", () => $0bbdb625f85b79b8$export$aa3a14ab8610ef4c);
$parcel$export(module.exports, "TTRSLO", () => $0bbdb625f85b79b8$export$747aad128920134d);
$parcel$export(module.exports, "TTISLO", () => $0bbdb625f85b79b8$export$e4f8d353742c04ac);
$parcel$export(module.exports, "PARENT_STARTS_AFTER_CHILD_MESSAGE_ID", () => $0bbdb625f85b79b8$export$a97149d40382503f);
$parcel$export(module.exports, "PARENT_ENDS_BEFORE_CHILD_MESSAGE_ID", () => $0bbdb625f85b79b8$export$d766993468a8fc97);
$parcel$export(module.exports, "PARENT_STARTS_AFTER_CHILD_AND_ENDS_BEFORE_CHILD_MESSAGE_ID", () => $0bbdb625f85b79b8$export$af6ac3ecd3a809a5);
$parcel$export(module.exports, "SPRINT_ENDS_BEFORE_CHILD_MESSAGE_ID", () => $0bbdb625f85b79b8$export$15c1cc5c30ec0dfc);
$parcel$export(module.exports, "START_DATE_LATER_DUE_DATE_MESSAGE_ID", () => $0bbdb625f85b79b8$export$92d02ff4a955dc9b);
$parcel$export(module.exports, "END_DATE_LATER_RELEASE_DATE_MESSAGE_ID", () => $0bbdb625f85b79b8$export$200248664fd9723f);
$parcel$export(module.exports, "PARENT_PLACEHOLDER_DAYS", () => $0bbdb625f85b79b8$export$6d703b8596a86779);
$parcel$export(module.exports, "CHILD_PLACEHOLDER_DAYS", () => $0bbdb625f85b79b8$export$92aea0f0203ecd42);
$parcel$export(module.exports, "INTERACTED_ITEMS_LIMIT", () => $0bbdb625f85b79b8$export$9272a348c522993d);
$parcel$export(module.exports, "SCHEDULING_SECTION", () => $0bbdb625f85b79b8$export$621948a1f95448a3);
$parcel$export(module.exports, "BULK_SECTION", () => $0bbdb625f85b79b8$export$b7607bb0b8643f2);
$parcel$export(module.exports, "REMOVE_DATES", () => $0bbdb625f85b79b8$export$7fdcec4cf891105d);
$parcel$export(module.exports, "EDIT_SPRINT", () => $0bbdb625f85b79b8$export$7e560fa5dffb36e);
$parcel$export(module.exports, "EDIT_DATES", () => $0bbdb625f85b79b8$export$cbfaa2b9201694be);
$parcel$export(module.exports, "BULK_EDIT_DATES", () => $0bbdb625f85b79b8$export$5e364e0a31ed0481);
$parcel$export(module.exports, "CHANGE_PARENT_ISSUE", () => $0bbdb625f85b79b8$export$5a0f05a726955e4b);
$parcel$export(module.exports, "CHANGE_ISSUE_COLOR", () => $0bbdb625f85b79b8$export$92ad4eabf7fea56c);
$parcel$export(module.exports, "EDIT_DEPENDENCY", () => $0bbdb625f85b79b8$export$1cdd104841f05601);
$parcel$export(module.exports, "REMOVE_START_DATE", () => $0bbdb625f85b79b8$export$8bfecf0f063625c9);
$parcel$export(module.exports, "REMOVE_DUE_DATE", () => $0bbdb625f85b79b8$export$3d55939abaccfa3a);
$parcel$export(module.exports, "REMOVE_START_DATE_AND_DUE_DATE", () => $0bbdb625f85b79b8$export$9a2eb0ee3249713e);
const $0bbdb625f85b79b8$export$eb64d27edca3e703 = 'standard-roadmap';
const $0bbdb625f85b79b8$export$ad60357d6714d43 = (type)=>type ? `${$0bbdb625f85b79b8$export$eb64d27edca3e703}.${type}`.toLowerCase() : $0bbdb625f85b79b8$export$eb64d27edca3e703;
const $0bbdb625f85b79b8$export$8c14295980d51b03 = 'jiraSoftwareRoadmapStandard';
const $0bbdb625f85b79b8$export$4fd29a5a4da01768 = 'roadmap-critical-data-succeeded';
const $0bbdb625f85b79b8$export$f764daad80c436d4 = 'roadmap-critical-data-failed';
const $0bbdb625f85b79b8$export$aa3a14ab8610ef4c = 'roadmap-resource-data-failed';
const $0bbdb625f85b79b8$export$747aad128920134d = 1000;
const $0bbdb625f85b79b8$export$e4f8d353742c04ac = 4000;
const $0bbdb625f85b79b8$export$5b7423264d48ab04 = 'not-enrolled';
const $0bbdb625f85b79b8$export$43f367b3e957f219 = 'control';
const $0bbdb625f85b79b8$export$9ba2bc3b1bdc1519 = 'experiment';
const $0bbdb625f85b79b8$export$a97149d40382503f = 'parentStartsAfterChild';
const $0bbdb625f85b79b8$export$d766993468a8fc97 = 'parentEndsBeforeChild';
const $0bbdb625f85b79b8$export$af6ac3ecd3a809a5 = 'parentStartsAfterChildAndEndsBeforeChild';
const $0bbdb625f85b79b8$export$15c1cc5c30ec0dfc = 'sprintEndsBeforeChild';
const $0bbdb625f85b79b8$export$92d02ff4a955dc9b = 'startDateLaterDueDate';
const $0bbdb625f85b79b8$export$200248664fd9723f = 'endDateLaterReleasesDate';
const $0bbdb625f85b79b8$export$6d703b8596a86779 = 30;
const $0bbdb625f85b79b8$export$92aea0f0203ecd42 = 14;
const $0bbdb625f85b79b8$export$9272a348c522993d = 50;
const $0bbdb625f85b79b8$export$621948a1f95448a3 = 'schedulingSection';
const $0bbdb625f85b79b8$export$b7607bb0b8643f2 = 'bulkSection';
const $0bbdb625f85b79b8$export$7fdcec4cf891105d = 'REMOVE_DATES';
const $0bbdb625f85b79b8$export$7e560fa5dffb36e = 'EDIT_SPRINT';
const $0bbdb625f85b79b8$export$cbfaa2b9201694be = 'EDIT_DATES';
const $0bbdb625f85b79b8$export$5e364e0a31ed0481 = 'BULK_EDIT_DATES';
const $0bbdb625f85b79b8$export$5a0f05a726955e4b = 'CHANGE_PARENT_ISSUE';
const $0bbdb625f85b79b8$export$92ad4eabf7fea56c = 'CHANGE_ISSUE_COLOR';
const $0bbdb625f85b79b8$export$1cdd104841f05601 = 'EDIT_DEPENDENCY';
const $0bbdb625f85b79b8$export$8bfecf0f063625c9 = 'REMOVE_START_DATE';
const $0bbdb625f85b79b8$export$3d55939abaccfa3a = 'REMOVE_DUE_DATE';
const $0bbdb625f85b79b8$export$9a2eb0ee3249713e = 'REMOVE_START_DATE_AND_DUE_DATE';

});

parcelRegister("jgC5j", function(module, exports) {

$parcel$export(module.exports, "flagsMapper", () => $199b5b59dab9d84d$export$4de5eb17326eea98);

var $eUqFw = parcelRequire("eUqFw");

var $9BmXV = parcelRequire("9BmXV");

var $6oEkZ = parcelRequire("6oEkZ");

var $ilsfc = parcelRequire("ilsfc");

var $9wcyk = parcelRequire("9wcyk");

var $aZu3P = parcelRequire("aZu3P");

var $3HDkE = parcelRequire("3HDkE");

var $5TbjN = parcelRequire("5TbjN");

var $3C54v = parcelRequire("3C54v");

var $3wyB9 = parcelRequire("3wyB9");

var $hRLaQ = parcelRequire("hRLaQ");

var $9sooW = parcelRequire("9sooW");

var $jQzPT = parcelRequire("jQzPT");

var $eZMrP = parcelRequire("eZMrP");

var $9NYwq = parcelRequire("9NYwq");

var $fJP86 = parcelRequire("fJP86");
const $199b5b59dab9d84d$export$4de5eb17326eea98 = (action)=>{
    switch(action.type){
        case 0, $9BmXV.GENERAL_ERROR:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3HDkE.default), props);
        case 0, $9BmXV.UPDATE_ITEM_PERMISSION:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQzPT.default), props);
        case 0, $9BmXV.AGG_ERROR:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oEkZ.default), {
                    ...props,
                    ...action.payload
                });
        case 0, $9BmXV.ISSUE_HIDDEN:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9sooW.default), {
                    ...props,
                    ...action.payload
                });
        case 0, $9BmXV.HIDDEN_DEPENDENCY_CREATED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5TbjN.default), props);
        case 0, $9BmXV.IRRELEVANT_ISSUES_CREATED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRLaQ.default), {
                    ...props,
                    issueKeys: action.payload.issueKeys
                });
        case 0, $9BmXV.DEPENDENCIES_UNAVAILABLE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZu3P.default), props);
        case 0, $9BmXV.ISSUE_DISAPPEARS_FROM_DISPLAY_RANGE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZMrP.default), {
                    ...props,
                    ...action.payload
                });
        case 0, $9BmXV.DEPENDENCIES_PERMISSION:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9wcyk.default), {
                    ...props,
                    ...action.payload
                });
        case 0, $9BmXV.UNABLE_TO_RANK_ISSUE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NYwq.default), {
                    ...props,
                    boardId: action.payload.boardId
                });
        case 0, $9BmXV.SPRINT_SCOPE_CHANGE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJP86.default), {
                    ...props,
                    ...action.payload
                });
        case 0, $9BmXV.INTERACTED_ITEMS_LIMIT_EXCEEDED:
            return (props)=>action.payload ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3wyB9.default), {
                    ...props,
                    ...action.payload
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3C54v.default), props);
        case 0, $9BmXV.DEPENDENCY_CYCLE_CREATION:
        case 0, $9BmXV.DEPENDENCY_DUPLICATION:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ilsfc.default), {
                    ...props,
                    ...action.payload,
                    isDependencyDuplicated: action.type === (0, $9BmXV.DEPENDENCY_DUPLICATION)
                });
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};

});
parcelRegister("9BmXV", function(module, exports) {

$parcel$export(module.exports, "GENERAL_ERROR", () => $772bb1d4a6370c2f$export$34c01b0a934c2cc3);
$parcel$export(module.exports, "generalError", () => $772bb1d4a6370c2f$export$92c1813bac9046d);
$parcel$export(module.exports, "AGG_ERROR", () => $772bb1d4a6370c2f$export$6ea4bc3af98cc26f);
$parcel$export(module.exports, "aggError", () => $772bb1d4a6370c2f$export$c9dde5743c9b0078);
$parcel$export(module.exports, "ISSUE_HIDDEN", () => $772bb1d4a6370c2f$export$56afcb57c54093ef);
$parcel$export(module.exports, "issueHidden", () => $772bb1d4a6370c2f$export$82dca12a93ca673f);
$parcel$export(module.exports, "IRRELEVANT_ISSUES_CREATED", () => $772bb1d4a6370c2f$export$88f828ea7faf6538);
$parcel$export(module.exports, "irrelevantIssuesCreated", () => $772bb1d4a6370c2f$export$943b8ae0debfb128);
$parcel$export(module.exports, "ISSUE_DISAPPEARS_FROM_DISPLAY_RANGE", () => $772bb1d4a6370c2f$export$57398f8dd536d3);
$parcel$export(module.exports, "issueDisappearsFromDisplayRange", () => $772bb1d4a6370c2f$export$57c6601b7de7174e);
$parcel$export(module.exports, "UNABLE_TO_RANK_ISSUE", () => $772bb1d4a6370c2f$export$9406ea723a962c47);
$parcel$export(module.exports, "unableToRankIssue", () => $772bb1d4a6370c2f$export$e3612e71b6b39da1);
$parcel$export(module.exports, "HIDDEN_DEPENDENCY_CREATED", () => $772bb1d4a6370c2f$export$88308e1b4abfd55e);
$parcel$export(module.exports, "hiddenDependencyCreated", () => $772bb1d4a6370c2f$export$a7f194f3b406f9e5);
$parcel$export(module.exports, "DEPENDENCIES_UNAVAILABLE", () => $772bb1d4a6370c2f$export$6c8916f000f0ecf3);
$parcel$export(module.exports, "dependenciesUnavailable", () => $772bb1d4a6370c2f$export$629f4726a19e166f);
$parcel$export(module.exports, "DEPENDENCIES_PERMISSION", () => $772bb1d4a6370c2f$export$bee605ca665bc47e);
$parcel$export(module.exports, "dependenciesPermission", () => $772bb1d4a6370c2f$export$7ae2a3c0890ea73c);
$parcel$export(module.exports, "UPDATE_ITEM_PERMISSION", () => $772bb1d4a6370c2f$export$d209d541a847828d);
$parcel$export(module.exports, "updateItemPermission", () => $772bb1d4a6370c2f$export$a7eada1968affd28);
$parcel$export(module.exports, "SPRINT_SCOPE_CHANGE", () => $772bb1d4a6370c2f$export$31b38b0222b12e4a);
$parcel$export(module.exports, "sprintScopeChanged", () => $772bb1d4a6370c2f$export$d580034b0a28e0db);
$parcel$export(module.exports, "INTERACTED_ITEMS_LIMIT_EXCEEDED", () => $772bb1d4a6370c2f$export$d574f859de528225);
$parcel$export(module.exports, "interactedItemsLimitExceeded", () => $772bb1d4a6370c2f$export$a7152d9c510f3783);
$parcel$export(module.exports, "DEPENDENCY_CYCLE_CREATION", () => $772bb1d4a6370c2f$export$84666f883c5c79a2);
$parcel$export(module.exports, "dependencyCycleCreation", () => $772bb1d4a6370c2f$export$b1275e1021a43355);
$parcel$export(module.exports, "DEPENDENCY_DUPLICATION", () => $772bb1d4a6370c2f$export$b7d53719119ed01a);
$parcel$export(module.exports, "dependencyDuplication", () => $772bb1d4a6370c2f$export$de85c6fa5ee537ca);
const $772bb1d4a6370c2f$export$34c01b0a934c2cc3 = 'state.flags.GENERAL_ERROR';
const $772bb1d4a6370c2f$export$92c1813bac9046d = ()=>({
        type: $772bb1d4a6370c2f$export$34c01b0a934c2cc3
    });
const $772bb1d4a6370c2f$export$6ea4bc3af98cc26f = 'state.flags.AGG_ERROR';
const $772bb1d4a6370c2f$export$c9dde5743c9b0078 = (payload = {
    description: undefined,
    errorType: undefined
})=>({
        type: $772bb1d4a6370c2f$export$6ea4bc3af98cc26f,
        payload: payload
    });
const $772bb1d4a6370c2f$export$56afcb57c54093ef = 'state.flags.ISSUE_HIDDEN';
const $772bb1d4a6370c2f$export$82dca12a93ca673f = (payload)=>({
        type: $772bb1d4a6370c2f$export$56afcb57c54093ef,
        payload: payload
    });
const $772bb1d4a6370c2f$export$88f828ea7faf6538 = 'state.flags.IRRELEVANT_ISSUES_CREATED';
const $772bb1d4a6370c2f$export$943b8ae0debfb128 = (payload)=>({
        type: $772bb1d4a6370c2f$export$88f828ea7faf6538,
        payload: payload
    });
const $772bb1d4a6370c2f$export$57398f8dd536d3 = 'state.flags.ISSUE_DISAPPEARS_FROM_DISPLAY_RANGE';
const $772bb1d4a6370c2f$export$57c6601b7de7174e = (payload)=>({
        type: $772bb1d4a6370c2f$export$57398f8dd536d3,
        payload: payload
    });
const $772bb1d4a6370c2f$export$23962d17d290f2c0 = 'state.flags.RANK_MISMATCH_ISSUE_CREATED';
const $772bb1d4a6370c2f$export$f1f725fa6b0c8a54 = (payload)=>({
        type: $772bb1d4a6370c2f$export$23962d17d290f2c0,
        payload: payload
    });
const $772bb1d4a6370c2f$export$9406ea723a962c47 = 'state.flags.UNABLE_TO_RANK_ISSUE';
const $772bb1d4a6370c2f$export$e3612e71b6b39da1 = (payload)=>({
        type: $772bb1d4a6370c2f$export$9406ea723a962c47,
        payload: payload
    });
const $772bb1d4a6370c2f$export$88308e1b4abfd55e = 'state.flags.HIDDEN_DEPENDENCY_CREATED';
const $772bb1d4a6370c2f$export$a7f194f3b406f9e5 = ()=>({
        type: $772bb1d4a6370c2f$export$88308e1b4abfd55e
    });
const $772bb1d4a6370c2f$export$6c8916f000f0ecf3 = 'state.flags.DEPENDENCIES_UNAVAILABLE';
const $772bb1d4a6370c2f$export$629f4726a19e166f = ()=>({
        type: $772bb1d4a6370c2f$export$6c8916f000f0ecf3
    });
const $772bb1d4a6370c2f$export$bee605ca665bc47e = 'state.flags.DEPENDENCIES_PERMISSION';
const $772bb1d4a6370c2f$export$7ae2a3c0890ea73c = (payload)=>({
        type: $772bb1d4a6370c2f$export$bee605ca665bc47e,
        payload: payload
    });
const $772bb1d4a6370c2f$export$d209d541a847828d = 'state.flags.UPDATE_ITEM_PERMISSION';
const $772bb1d4a6370c2f$export$a7eada1968affd28 = ()=>({
        type: $772bb1d4a6370c2f$export$d209d541a847828d
    });
const $772bb1d4a6370c2f$export$31b38b0222b12e4a = 'state.flags.SPRINT_SCOPE_CHANGE';
const $772bb1d4a6370c2f$export$d580034b0a28e0db = (payload)=>({
        type: $772bb1d4a6370c2f$export$31b38b0222b12e4a,
        payload: payload
    });
const $772bb1d4a6370c2f$export$d574f859de528225 = 'state.flags.INTERACTED_ITEMS_LIMIT_EXCEEDED';
const $772bb1d4a6370c2f$export$a7152d9c510f3783 = (payload)=>({
        type: $772bb1d4a6370c2f$export$d574f859de528225,
        payload: payload
    });
const $772bb1d4a6370c2f$export$84666f883c5c79a2 = 'state.flags.DEPENDENCY_CYCLE_CREATION';
const $772bb1d4a6370c2f$export$b1275e1021a43355 = (payload)=>({
        type: $772bb1d4a6370c2f$export$84666f883c5c79a2,
        payload: payload
    });
const $772bb1d4a6370c2f$export$b7d53719119ed01a = 'state.flags.DEPENDENCY_DUPLICATION';
const $772bb1d4a6370c2f$export$de85c6fa5ee537ca = (payload)=>({
        type: $772bb1d4a6370c2f$export$b7d53719119ed01a,
        payload: payload
    });

});

parcelRegister("6oEkZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c94bf213dad2bbe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $h46n2 = parcelRequire("h46n2");
const $7c94bf213dad2bbe$var$AggErrorFlag = ({ id: id, onDismissed: onDismissed, description: description, errorType: errorType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'roadmapErrorFlag'
        }), 'viewed roadmapErrorFlag', {
            cause: 'AGG'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onDismissedCallback = ()=>{
        onDismissed(id);
    };
    const getDescription = ()=>{
        if (errorType === (0, $cc11070e8f7c8919$export$d2fa25fc0fdc86b8)) return formatMessage((0, $h46n2.default).jqlValidationErrorDescription);
        return description !== undefined ? description : formatMessage((0, $h46n2.default).description);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
        onDismissed: onDismissedCallback,
        id: id,
        title: formatMessage((0, $h46n2.default).title),
        description: getDescription()
    });
};
$7c94bf213dad2bbe$var$AggErrorFlag.defaultProps = {
    description: undefined,
    onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $7c94bf213dad2bbe$export$2e2bcd8739ae039 = $7c94bf213dad2bbe$var$AggErrorFlag;

});
parcelRegister("3Y2Y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cb4ade2efc0679$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$23cb4ade2efc0679$export$2e2bcd8739ae039 = (0, $kQ0RL.ErrorFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5eqyk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});



const $cc11070e8f7c8919$export$d2fa25fc0fdc86b8 = 'JQL_VALIDATION_FAILED';

parcelRegister("h46n2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1a476d56dc52f6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3b1a476d56dc52f6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.agg-error.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "roadmap.standard-roadmap.flags.agg-error.description",
        "defaultMessage": "Please try again later."
    },
    jqlValidationErrorDescription: {
        "id": "roadmap.standard-roadmap.flags.agg-error.jql-validation-error-description",
        "defaultMessage": "One or more fields associated with your JQL query is no longer valid. Edit your query, or adjust your settings then try again."
    }
});

});


parcelRegister("ilsfc", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d8d1d0bbc95c0b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9ZLrP = parcelRequire("9ZLrP");

var $aSTh4 = parcelRequire("aSTh4");

var $7vazg = parcelRequire("7vazg");
var $97d8d1d0bbc95c0b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        isDependenciesVisible: (0, $9ZLrP.isDependenciesVisible)(state)
    }), {
    setShowDependencies: ()=>(0, $aSTh4.setDependenciesViewVisibility)(true)
})((0, $7vazg.default));

});
parcelRegister("9ZLrP", function(module, exports) {

$parcel$export(module.exports, "getFilteredAssignees", () => $589774b210201876$export$ead4f8ed70fc9285);
$parcel$export(module.exports, "getFilteredIssueTypes", () => $589774b210201876$export$f704001d88f4e8d2);
$parcel$export(module.exports, "getFilteredText", () => $589774b210201876$export$480513943813b51b);
$parcel$export(module.exports, "getFilteredLabels", () => $589774b210201876$export$1f2bd8f7634d2082);
$parcel$export(module.exports, "getFilteredVersions", () => $589774b210201876$export$e1963b8a944f3139);
$parcel$export(module.exports, "getFilteredComponents", () => $589774b210201876$export$5f2c47e8484746b9);
$parcel$export(module.exports, "getFilteredQuickFilters", () => $589774b210201876$export$6bf1855d9df1b383);
$parcel$export(module.exports, "getFilteredCustomFilters", () => $589774b210201876$export$4a8b3b1494c67db);
$parcel$export(module.exports, "getNumJQLFiltersApplied", () => $589774b210201876$export$bf3bd4b2a79eafca);
$parcel$export(module.exports, "getFilteredGoalIssueIds", () => $589774b210201876$export$d91b97590e8928e6);
$parcel$export(module.exports, "getIssuesFilter", () => $589774b210201876$export$8402447ccdc9e452);
$parcel$export(module.exports, "isFilterActive", () => $589774b210201876$export$71fbaed622c39d0f);
$parcel$export(module.exports, "getTimelineMode", () => $589774b210201876$export$c08af494d7047ac9);
$parcel$export(module.exports, "isDependenciesVisible", () => $589774b210201876$export$e6456cc1326d0539);
$parcel$export(module.exports, "isProgressVisible", () => $589774b210201876$export$879546fde72c4046);
$parcel$export(module.exports, "isWarningsVisible", () => $589774b210201876$export$14c823a13dc9b222);
$parcel$export(module.exports, "getLevelOneSetting", () => $589774b210201876$export$e748452c2646d46a);
$parcel$export(module.exports, "getChildIssueTypes", () => $589774b210201876$export$7d15cfb1065b114f);

var $df4Sl = parcelRequire("df4Sl");

var $gf0vG = parcelRequire("gf0vG");

var $jtx35 = parcelRequire("jtx35");

var $bwVWW = parcelRequire("bwVWW");

var $cUmMY = parcelRequire("cUmMY");

var $6FeJk = parcelRequire("6FeJk");

var $6489W = parcelRequire("6489W");

var $9N1AA = parcelRequire("9N1AA");

var $kz9g9 = parcelRequire("kz9g9");

var $lDe9P = parcelRequire("lDe9P");

var $iKKDu = parcelRequire("iKKDu");

var $hjI8T = parcelRequire("hjI8T");

var $9yupO = parcelRequire("9yupO");
const $589774b210201876$export$db9f6287b4948b1d = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getStatus), (statuses)=>statuses);
const $589774b210201876$export$ead4f8ed70fc9285 = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getAssignee), (assignees)=>assignees);
const $589774b210201876$export$f704001d88f4e8d2 = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getIssueType), (issueTypes)=>issueTypes);
const $589774b210201876$export$480513943813b51b = (0, $df4Sl.createSelector)((0, $6489W.getQuery), (query)=>query.text ?? '');
const $589774b210201876$export$1f2bd8f7634d2082 = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getLabels), (0, $iKKDu.getLabelsWithUnassignedOption), (0, $9yupO.createGetFilteredLabels));
const $589774b210201876$export$d95ca7dc26056ef4 = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getIssueParents), (0, $6FeJk.getIssueParentIds), (0, $9yupO.createGetFilteredIssueParents));
const $589774b210201876$export$e1963b8a944f3139 = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getVersions), (0, $hjI8T.getUniqueVersions), (0, $9yupO.createGetFilteredVersions));
const $589774b210201876$export$5f2c47e8484746b9 = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getComponents), (0, $lDe9P.getUniqueComponents), (0, $9yupO.createGetFilteredComponents));
const $589774b210201876$export$6bf1855d9df1b383 = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getQuickFilters), (quickFilters)=>quickFilters);
const $589774b210201876$export$4a8b3b1494c67db = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getCustomFilters), (customFilters)=>customFilters);
const $589774b210201876$export$bf3bd4b2a79eafca = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getQuickFilters), (0, $6489W.getCustomFilters), (quickFilters, customFilters)=>Math.max(quickFilters.length, customFilters.length));
const $589774b210201876$export$41f1c2d38e27d357 = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6489W.getGoalAris), (0, $cUmMY.getUniqueGoalIds), (0, $9yupO.createGetFilteredGoals));
const $589774b210201876$export$d91b97590e8928e6 = (0, $df4Sl.createSelector)($589774b210201876$export$41f1c2d38e27d357, (0, $cUmMY.getGoalsHash), (0, $6FeJk.getIssueChildrenHash), (0, $9yupO.createGetFilteredGoalIssueIds));
const $589774b210201876$export$8402447ccdc9e452 = (0, $df4Sl.createSelector)($589774b210201876$export$db9f6287b4948b1d, $589774b210201876$export$ead4f8ed70fc9285, $589774b210201876$export$f704001d88f4e8d2, $589774b210201876$export$480513943813b51b, $589774b210201876$export$1f2bd8f7634d2082, $589774b210201876$export$d95ca7dc26056ef4, $589774b210201876$export$e1963b8a944f3139, $589774b210201876$export$5f2c47e8484746b9, $589774b210201876$export$6bf1855d9df1b383, $589774b210201876$export$4a8b3b1494c67db, $589774b210201876$export$41f1c2d38e27d357, (statuses, assignees, issueTypes, text, labels, issueParents, versions, components, quickFilters, customFilters, goals)=>({
        statuses: statuses,
        assignees: assignees,
        issueTypes: issueTypes,
        text: text,
        labels: labels,
        issueParents: issueParents,
        versions: versions,
        components: components,
        quickFilters: quickFilters,
        customFilters: customFilters,
        goals: goals
    }));
const $589774b210201876$export$71fbaed622c39d0f = (0, $df4Sl.createSelector)($589774b210201876$export$8402447ccdc9e452, (filters)=>Object.values(filters).some((value)=>{
        if (Array.isArray(value) || typeof value === 'string') return value.length > 0;
        // should never reach here
        return false;
    }));
const $589774b210201876$export$c08af494d7047ac9 = (0, $df4Sl.createSelector)((0, $6489W.getQuery), (0, $9N1AA.getStoredTimelineFilter), (query, storedTimelineFilter)=>{
    switch(query.timeline){
        case 0, $gf0vG.WEEKS:
            return 0, $gf0vG.WEEKS;
        case 0, $gf0vG.MONTHS:
            return 0, $gf0vG.MONTHS;
        case 0, $gf0vG.QUARTERS:
            return 0, $gf0vG.QUARTERS;
        default:
            return storedTimelineFilter || (0, $gf0vG.MONTHS);
    }
});
const $589774b210201876$var$isViewVisible = (isVisibleInQuery, isVisibleInStore)=>!isVisibleInQuery ? false : isVisibleInStore;
const $589774b210201876$export$e6456cc1326d0539 = (0, $df4Sl.createSelector)((0, $6489W.isDependenciesVisibleInQuery), (0, $kz9g9.isDependenciesVisibleInView), $589774b210201876$var$isViewVisible);
const $589774b210201876$export$879546fde72c4046 = (0, $df4Sl.createSelector)((0, $6489W.isProgressVisibleInQuery), (0, $kz9g9.isProgressVisibleInView), $589774b210201876$var$isViewVisible);
const $589774b210201876$export$14c823a13dc9b222 = (0, $df4Sl.createSelector)((0, $6489W.isWarningsVisibleInQuery), (0, $kz9g9.isWarningsVisibleInView), $589774b210201876$var$isViewVisible);
const $589774b210201876$export$e748452c2646d46a = (0, $df4Sl.createSelector)((0, $6489W.getEpicSettingInQuery), (0, $kz9g9.getLevelOneSettingInView), (0, $9yupO.getLevelOneSettingPure));
const $589774b210201876$export$7d15cfb1065b114f = (0, $df4Sl.createSelector)((0, $bwVWW.getFullIssueTypeHash), (0, $bwVWW.getEpicIssueTypeIds), (0, $9yupO.getChildIssueTypesPure));

});
parcelRegister("gf0vG", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DEPTH", () => $007c33d2f693bd63$export$7f882bb969de14a3);
$parcel$export(module.exports, "DEFAULT_LEVEL", () => $007c33d2f693bd63$export$480df663967f228c);
$parcel$export(module.exports, "RESIZE_DEBOUNCE_MS", () => $007c33d2f693bd63$export$747901c4619ea19c);
$parcel$export(module.exports, "BASE_LEVEL", () => $007c33d2f693bd63$export$d5993e01b9439be4);
$parcel$export(module.exports, "BASE_HEADER_HEIGHT", () => $007c33d2f693bd63$export$bf0adf7b400249e1);
$parcel$export(module.exports, "HEADER_CONTENT_HEIGHT", () => $007c33d2f693bd63$export$46c78f5f070f677a);
$parcel$export(module.exports, "DEFAULT_SUBHEADER_HEIGHT", () => $007c33d2f693bd63$export$29ae8fa7fd1c9a2f);
$parcel$export(module.exports, "DEFAULT_ITEM_HEIGHT", () => $007c33d2f693bd63$export$f898a7479a35465b);
$parcel$export(module.exports, "BASE_LEVEL_ITEM_HEIGHT", () => $007c33d2f693bd63$export$c4ca1a8adb6a9f07);
$parcel$export(module.exports, "MINIMUM_LIST_WIDTH", () => $007c33d2f693bd63$export$6bb070ef26ec48d9);
$parcel$export(module.exports, "DEFAULT_LIST_WIDTH", () => $007c33d2f693bd63$export$58590494eb7f9f92);
$parcel$export(module.exports, "DEFAULT_HEADER_ROW_ID", () => $007c33d2f693bd63$export$b24bdd4190312b9);
$parcel$export(module.exports, "UP", () => $007c33d2f693bd63$export$b29f845fa4b57508);
$parcel$export(module.exports, "DOWN", () => $007c33d2f693bd63$export$c7c029a231f98d34);
$parcel$export(module.exports, "ROW_DRAG_AND_DROP_ID", () => $007c33d2f693bd63$export$ac3c20c079db2388);
$parcel$export(module.exports, "LIST_DRAG_AND_DROP", () => $007c33d2f693bd63$export$3c4f97ccd236019);
$parcel$export(module.exports, "CHILD_LIST_DRAG_AND_DROP", () => $007c33d2f693bd63$export$d3793ebc963c3515);
$parcel$export(module.exports, "LIST_RESIZE_DRAG_AND_DROP", () => $007c33d2f693bd63$export$ea4843d184267eb1);
$parcel$export(module.exports, "DELAY_EXPAND_TIME", () => $007c33d2f693bd63$export$d165800dfbec11d6);
$parcel$export(module.exports, "BEFORE", () => $007c33d2f693bd63$export$4cff6e48b6cc73b5);
$parcel$export(module.exports, "INSIDE", () => $007c33d2f693bd63$export$48ea0cac79c83ca8);
$parcel$export(module.exports, "LAST", () => $007c33d2f693bd63$export$5514f5adc70fa605);
$parcel$export(module.exports, "TIMELINE_ID", () => $007c33d2f693bd63$export$80a4040613c38228);
$parcel$export(module.exports, "WEEKS", () => $007c33d2f693bd63$export$ae0be2880fd1f23e);
$parcel$export(module.exports, "MONTHS", () => $007c33d2f693bd63$export$f9a766aa2475e8ba);
$parcel$export(module.exports, "QUARTERS", () => $007c33d2f693bd63$export$6bd120b531154c2a);
$parcel$export(module.exports, "HALF_INLINE_CREATE_ICON_WIDTH", () => $007c33d2f693bd63$export$6d29db963a7e29b9);
$parcel$export(module.exports, "zIndex", () => $007c33d2f693bd63$export$56446adcecbeec34);
$parcel$export(module.exports, "DEFAULT_CREATE_ID", () => $007c33d2f693bd63$export$420141f5c0e55c3e);
$parcel$export(module.exports, "ITEM_TYPE", () => $007c33d2f693bd63$export$e0a522cf395aec9b);
$parcel$export(module.exports, "CREATE_ITEM_TYPE", () => $007c33d2f693bd63$export$69cd3b48cdf4b6f0);
$parcel$export(module.exports, "SCROLLED", () => $007c33d2f693bd63$export$9402ce0d1e070b14);
$parcel$export(module.exports, "LIST_COLUMN_COORDINATE", () => $007c33d2f693bd63$export$4f0d26bf73633d25);
$parcel$export(module.exports, "CHART_COLUMN_COORDINATE", () => $007c33d2f693bd63$export$3a13d2b8bb5c5942);
$parcel$export(module.exports, "listItemMenu", () => $007c33d2f693bd63$export$ee28d791bd8e9db2);
$parcel$export(module.exports, "DEFAULT_MENU_MAX_HEIGHT", () => $007c33d2f693bd63$export$1412163b7495b138);

var $eI5EY = parcelRequire("eI5EY");
const $007c33d2f693bd63$export$7f882bb969de14a3 = 0;
const $007c33d2f693bd63$export$480df663967f228c = 1;
const $007c33d2f693bd63$export$747901c4619ea19c = 250;
const $007c33d2f693bd63$export$d5993e01b9439be4 = 0;
const $007c33d2f693bd63$export$6c5e715ac831956e = 1;
const $007c33d2f693bd63$export$bf0adf7b400249e1 = 48;
const $007c33d2f693bd63$export$46c78f5f070f677a = 16;
const $007c33d2f693bd63$export$29ae8fa7fd1c9a2f = 36;
const $007c33d2f693bd63$export$f898a7479a35465b = 40;
const $007c33d2f693bd63$export$c4ca1a8adb6a9f07 = 32;
const $007c33d2f693bd63$export$6bb070ef26ec48d9 = ()=>(0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? 360 : 320;
const $007c33d2f693bd63$export$58590494eb7f9f92 = ()=>(0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? 400 : 360;
const $007c33d2f693bd63$export$b24bdd4190312b9 = 'DEFAULT_HEADER_ROW';
const $007c33d2f693bd63$export$b29f845fa4b57508 = 'UP';
const $007c33d2f693bd63$export$c7c029a231f98d34 = 'DOWN';
const $007c33d2f693bd63$export$ac3c20c079db2388 = 'row-dnd-type-id';
const $007c33d2f693bd63$export$3c4f97ccd236019 = 'listDnd';
const $007c33d2f693bd63$export$d3793ebc963c3515 = 'childListDnd';
const $007c33d2f693bd63$export$ea4843d184267eb1 = 'listResizeDnd';
const $007c33d2f693bd63$export$d165800dfbec11d6 = 500;
const $007c33d2f693bd63$export$4cff6e48b6cc73b5 = 'BEFORE';
const $007c33d2f693bd63$export$48ea0cac79c83ca8 = 'INSIDE';
const $007c33d2f693bd63$export$5514f5adc70fa605 = 'LAST';
const $007c33d2f693bd63$export$80a4040613c38228 = 'sr-timeline';
const $007c33d2f693bd63$export$ae0be2880fd1f23e = 'WEEKS';
const $007c33d2f693bd63$export$f9a766aa2475e8ba = 'MONTHS';
const $007c33d2f693bd63$export$6bd120b531154c2a = 'QUARTERS';
const $007c33d2f693bd63$export$1041e95163fc373b = 20;
const $007c33d2f693bd63$export$6d29db963a7e29b9 = $007c33d2f693bd63$export$1041e95163fc373b / 2;
// =============== //
// === Z-INDEX === //
// =============== //
const $007c33d2f693bd63$var$CHART = 1;
const $007c33d2f693bd63$var$TODAY_MARKER = 6;
const $007c33d2f693bd63$var$HEADER = 7;
const $007c33d2f693bd63$var$LIST_COVER = 8;
const $007c33d2f693bd63$var$LIST = 9;
const $007c33d2f693bd63$var$LIST_CREATE_ITEM = 10;
const $007c33d2f693bd63$var$INLINE_INDICATOR = 11;
const $007c33d2f693bd63$var$SCROLLBAR = 11;
const $007c33d2f693bd63$var$ROW_HEADER = 12;
const $007c33d2f693bd63$var$BORDER = 12;
const $007c33d2f693bd63$var$LIST_RESIZER = 13;
const $007c33d2f693bd63$var$DRAGGABLE = 13;
const $007c33d2f693bd63$var$PORTAL = 13;
const $007c33d2f693bd63$var$HIGHEST = 14;
const $007c33d2f693bd63$export$56446adcecbeec34 = {
    CHART: $007c33d2f693bd63$var$CHART,
    BORDER: $007c33d2f693bd63$var$BORDER,
    TODAY_MARKER: $007c33d2f693bd63$var$TODAY_MARKER,
    LIST_COVER: $007c33d2f693bd63$var$LIST_COVER,
    HEADER: $007c33d2f693bd63$var$HEADER,
    LIST: $007c33d2f693bd63$var$LIST,
    LIST_CREATE_ITEM: $007c33d2f693bd63$var$LIST_CREATE_ITEM,
    INLINE_INDICATOR: $007c33d2f693bd63$var$INLINE_INDICATOR,
    SCROLLBAR: $007c33d2f693bd63$var$SCROLLBAR,
    ROW_HEADER: $007c33d2f693bd63$var$ROW_HEADER,
    LIST_RESIZER: $007c33d2f693bd63$var$LIST_RESIZER,
    DRAGGABLE: $007c33d2f693bd63$var$DRAGGABLE,
    PORTAL: $007c33d2f693bd63$var$PORTAL,
    HIGHEST: $007c33d2f693bd63$var$HIGHEST
};
const $007c33d2f693bd63$export$420141f5c0e55c3e = 'create-default';
const $007c33d2f693bd63$export$e0a522cf395aec9b = 'ITEM_TYPE';
const $007c33d2f693bd63$export$69cd3b48cdf4b6f0 = 'CREATE_ITEM_TYPE';
const $007c33d2f693bd63$export$9402ce0d1e070b14 = 'scrolled';
const $007c33d2f693bd63$export$4f0d26bf73633d25 = 0;
const $007c33d2f693bd63$export$3a13d2b8bb5c5942 = 1;
// ================================ //
// === LIST ITEM MENU OPTION IDS=== //
// ================================ //
const $007c33d2f693bd63$var$ITEMS_SECTION = 'itemsSection';
const $007c33d2f693bd63$var$CREATE_ITEM = 'createItem';
const $007c33d2f693bd63$var$MOVE_ITEM = 'moveItem';
const $007c33d2f693bd63$var$CREATE_CHILD_ITEM = 'createChildItem';
const $007c33d2f693bd63$var$CREATE_ITEM_ABOVE = 'createItemAbove';
const $007c33d2f693bd63$var$CREATE_ITEM_BELOW = 'createItemBelow';
const $007c33d2f693bd63$var$MOVE_ITEM_UP = 'moveItemUp';
const $007c33d2f693bd63$var$MOVE_ITEM_DOWN = 'moveItemDown';
const $007c33d2f693bd63$var$MOVE_ITEM_TO_TOP = 'moveItemToTop';
const $007c33d2f693bd63$var$MOVE_ITEM_TO_BOTTOM = 'moveItemToBottom';
const $007c33d2f693bd63$var$SELECTED_ITEM_COUNTER = 'selectedItemCounter';
const $007c33d2f693bd63$export$ee28d791bd8e9db2 = {
    SELECTED_ITEM_COUNTER: $007c33d2f693bd63$var$SELECTED_ITEM_COUNTER,
    ITEMS_SECTION: $007c33d2f693bd63$var$ITEMS_SECTION,
    CREATE_ITEM: $007c33d2f693bd63$var$CREATE_ITEM,
    MOVE_ITEM: $007c33d2f693bd63$var$MOVE_ITEM,
    CREATE_CHILD_ITEM: $007c33d2f693bd63$var$CREATE_CHILD_ITEM,
    CREATE_ITEM_ABOVE: $007c33d2f693bd63$var$CREATE_ITEM_ABOVE,
    CREATE_ITEM_BELOW: $007c33d2f693bd63$var$CREATE_ITEM_BELOW,
    MOVE_ITEM_UP: $007c33d2f693bd63$var$MOVE_ITEM_UP,
    MOVE_ITEM_DOWN: $007c33d2f693bd63$var$MOVE_ITEM_DOWN,
    MOVE_ITEM_TO_TOP: $007c33d2f693bd63$var$MOVE_ITEM_TO_TOP,
    MOVE_ITEM_TO_BOTTOM: $007c33d2f693bd63$var$MOVE_ITEM_TO_BOTTOM
};
const $007c33d2f693bd63$export$1412163b7495b138 = 480;

});

parcelRegister("jtx35", function(module, exports) {

$parcel$export(module.exports, "createSelectorWithDefaultEqual", () => $941eac65337be692$export$871506ce07a83fad);

var $df4Sl = parcelRequire("df4Sl");

var $hTLlD = parcelRequire("hTLlD");
const $941eac65337be692$export$871506ce07a83fad = (0, $df4Sl.createSelectorCreator)((0, $df4Sl.defaultMemoize), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));

});

parcelRegister("bwVWW", function(module, exports) {

$parcel$export(module.exports, "getProjectId", () => $1a6e73f78330e553$export$89040d072f281f85);
$parcel$export(module.exports, "getStartDateCustomFieldId", () => $1a6e73f78330e553$export$72a0c0eaa38c43af);
$parcel$export(module.exports, "getEpicIssueTypeIds", () => $1a6e73f78330e553$export$2757d772c10130c8);
$parcel$export(module.exports, "getColorCustomFieldId", () => $1a6e73f78330e553$export$46544f5f5c1828e1);
$parcel$export(module.exports, "getEpicLinkCustomFieldId", () => $1a6e73f78330e553$export$9b4fcf5b8538c861);
$parcel$export(module.exports, "getEpicNameCustomFieldId", () => $1a6e73f78330e553$export$8af40cc1df82ba43);
$parcel$export(module.exports, "getSprintCustomFieldId", () => $1a6e73f78330e553$export$c04a8f7b39c47d17);
$parcel$export(module.exports, "getFieldsNamesHash", () => $1a6e73f78330e553$export$905fbc05dc222193);
$parcel$export(module.exports, "hasCreateIssuesPermission", () => $1a6e73f78330e553$export$bc5899cabe5884a4);
$parcel$export(module.exports, "hasEditIssuesPermission", () => $1a6e73f78330e553$export$f26e62ade6542d00);
$parcel$export(module.exports, "hasScheduleIssuesPermission", () => $1a6e73f78330e553$export$96eae7feeb05906d);
$parcel$export(module.exports, "hasAdministerProjectPermission", () => $1a6e73f78330e553$export$fc2b3fef6cb69ee3);
$parcel$export(module.exports, "rankIssuesSupported", () => $1a6e73f78330e553$export$8bb7a2124eb8c9e5);
$parcel$export(module.exports, "getToday", () => $1a6e73f78330e553$export$883228a582a7567d);
$parcel$export(module.exports, "areDependenciesSupported", () => $1a6e73f78330e553$export$6cb87c93e2168baa);
$parcel$export(module.exports, "getInwardDependencyDescription", () => $1a6e73f78330e553$export$fc5e983135217133);
$parcel$export(module.exports, "getOutwardDependencyDescription", () => $1a6e73f78330e553$export$12df4b73c34b43df);
$parcel$export(module.exports, "getFullIssueTypeHash", () => $1a6e73f78330e553$export$960b0734990a1dd4);
$parcel$export(module.exports, "getIssueType", () => $1a6e73f78330e553$export$ed2455632bf977ef);
$parcel$export(module.exports, "getProjectKey", () => $1a6e73f78330e553$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectName", () => $1a6e73f78330e553$export$2cd058184eb75757);
$parcel$export(module.exports, "getProjectDefaultItemTypeId", () => $1a6e73f78330e553$export$6dfd97337d797ebe);
$parcel$export(module.exports, "getRequiredFieldsByIssueTypeId", () => $1a6e73f78330e553$export$a04cc75c31570bae);
$parcel$export(module.exports, "hasRequiredFields", () => $1a6e73f78330e553$export$9f3eb5b3e6860c0);
$parcel$export(module.exports, "getBoardJql", () => $1a6e73f78330e553$export$ba7a4ea5054ecd02);
$parcel$export(module.exports, "getIsUserBoardAdmin", () => $1a6e73f78330e553$export$77922deb356fe9ac);
$parcel$export(module.exports, "getActiveAndFutureSprints", () => $1a6e73f78330e553$export$531b49b68eed3b23);
$parcel$export(module.exports, "getSprints", () => $1a6e73f78330e553$export$1b132ed8629e9cb0);
$parcel$export(module.exports, "getFullVersionHash", () => $1a6e73f78330e553$export$28a38fc944590448);
$parcel$export(module.exports, "getFullComponentHash", () => $1a6e73f78330e553$export$254cbc79cefe4a73);
$parcel$export(module.exports, "getIsReleasesFeatureEnabled", () => $1a6e73f78330e553$export$486ac4364a6213c9);
$parcel$export(module.exports, "getChildIssuePlanningMode", () => $1a6e73f78330e553$export$97f5859d9b9ee574);
$parcel$export(module.exports, "getIsSprintsFeatureEnabled", () => $1a6e73f78330e553$export$236c77227e5ade46);
$parcel$export(module.exports, "getIsSprintsPlanningEnabled", () => $1a6e73f78330e553$export$ef0a9ade329ddbde);
$parcel$export(module.exports, "getIsChildIssuePlanningEnabled", () => $1a6e73f78330e553$export$1e1cd096ccca9b98);
$parcel$export(module.exports, "hasActiveOrFutureSprint", () => $1a6e73f78330e553$export$deba3717b0119a76);
$parcel$export(module.exports, "getLevelOneName", () => $1a6e73f78330e553$export$f361eea8c49edc41);
$parcel$export(module.exports, "getFullDerivedFields", () => $1a6e73f78330e553$export$28b082b8254a5fc3);
$parcel$export(module.exports, "getIsGoalsFeatureEnabled", () => $1a6e73f78330e553$export$d38f904d50b0a8af);
$parcel$export(module.exports, "getCanInviteOthersToProject", () => $1a6e73f78330e553$export$5124aa00ca92f2c0);

var $df4Sl = parcelRequire("df4Sl");


const $1a6e73f78330e553$var$getSingleProjectConfiguration = (state)=>state.configuration.projectConfiguration;
const $1a6e73f78330e553$export$89040d072f281f85 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getSingleProjectConfiguration, (projectConfig)=>projectConfig.id);
const $1a6e73f78330e553$var$getProjectConfiguration = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getSingleProjectConfiguration, (projectConfig)=>projectConfig);
const $1a6e73f78330e553$export$72a0c0eaa38c43af = (state)=>state.configuration.startDateCustomFieldId;
const $1a6e73f78330e553$export$2757d772c10130c8 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.epicIssueTypeIds);
const $1a6e73f78330e553$export$46544f5f5c1828e1 = (state)=>state.configuration.colorCustomFieldId;
const $1a6e73f78330e553$export$9b4fcf5b8538c861 = (state)=>state.configuration.epicLinkCustomFieldId;
const $1a6e73f78330e553$export$8af40cc1df82ba43 = (state)=>state.configuration.epicNameCustomFieldId;
const $1a6e73f78330e553$export$c04a8f7b39c47d17 = (state)=>state.configuration.sprintCustomFieldId;
const $1a6e73f78330e553$export$bee351d0af1cb8ad = (state)=>state.configuration.boardConfiguration;
const $1a6e73f78330e553$export$905fbc05dc222193 = (state)=>state.configuration.fields.reduce((acc, field)=>{
        acc[field.id] = field.name;
        return acc;
    }, {});
const $1a6e73f78330e553$export$bc5899cabe5884a4 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.permissions.canCreateIssues);
const $1a6e73f78330e553$export$f26e62ade6542d00 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.permissions.canEditIssues);
const $1a6e73f78330e553$export$96eae7feeb05906d = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.permissions.canScheduleIssues);
const $1a6e73f78330e553$export$fc2b3fef6cb69ee3 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.permissions.canAdministerProjects);
const $1a6e73f78330e553$export$8bb7a2124eb8c9e5 = (state)=>state.configuration.rankIssuesSupported;
const $1a6e73f78330e553$export$883228a582a7567d = (state)=>state.configuration.today;
const $1a6e73f78330e553$export$6cb87c93e2168baa = (state)=>state.configuration.dependenciesSupported;
const $1a6e73f78330e553$export$ac75fa8de98d4194 = (state)=>state.configuration;
const $1a6e73f78330e553$export$fc5e983135217133 = (state)=>state.configuration.inwardDependencyDescription;
const $1a6e73f78330e553$export$12df4b73c34b43df = (state)=>state.configuration.outwardDependencyDescription;
const $1a6e73f78330e553$export$960b0734990a1dd4 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.issueTypes.hash);
const $1a6e73f78330e553$export$ed2455632bf977ef = (state, issueTypeId)=>$1a6e73f78330e553$export$960b0734990a1dd4(state)[issueTypeId];
const $1a6e73f78330e553$export$667f2a0f99c75faa = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.key);
const $1a6e73f78330e553$export$2cd058184eb75757 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.name);
const $1a6e73f78330e553$export$6dfd97337d797ebe = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.defaultItemTypeId);
const $1a6e73f78330e553$export$71a2c3ba1c6ae580 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.requiredFields);
const $1a6e73f78330e553$export$a04cc75c31570bae = (state, issueTypeId)=>$1a6e73f78330e553$export$71a2c3ba1c6ae580(state)[issueTypeId];
const $1a6e73f78330e553$export$9f3eb5b3e6860c0 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$71a2c3ba1c6ae580, (requiredFieldsHash)=>Object.keys(requiredFieldsHash).some((itemTypeId)=>requiredFieldsHash[itemTypeId].length > 0));
const $1a6e73f78330e553$export$ba7a4ea5054ecd02 = (state)=>state.configuration.boardConfiguration.jql;
const $1a6e73f78330e553$export$77922deb356fe9ac = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.isUserBoardAdmin);
const $1a6e73f78330e553$export$9328442a7d4e1089 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.sprints.hash);
const $1a6e73f78330e553$var$EMPTY_ARRAY = [];
const $1a6e73f78330e553$export$531b49b68eed3b23 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$bee351d0af1cb8ad, (boardConfiguration)=>{
    const { sequence: sequence } = boardConfiguration.sprints;
    if (sequence !== undefined) {
        const sprintsHash = boardConfiguration.sprints.hash;
        const sprintsSequence = boardConfiguration.sprints.sequence;
        return sprintsSequence.filter((sprintId)=>sprintsHash[sprintId].state !== (0, $a7a73ddab4e749dd$export$19c4f83398a8dbce)).map((sprintId)=>sprintsHash[sprintId]);
    }
    return $1a6e73f78330e553$var$EMPTY_ARRAY;
});
const $1a6e73f78330e553$export$1b132ed8629e9cb0 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$9328442a7d4e1089, (sprintsHash)=>Object.keys(sprintsHash).map((sprintId)=>sprintsHash[sprintId]));
const $1a6e73f78330e553$export$28a38fc944590448 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.versions.hash);
const $1a6e73f78330e553$export$c506eb22e615ba4a = (state, versionId)=>$1a6e73f78330e553$export$28a38fc944590448(state)[versionId];
const $1a6e73f78330e553$export$254cbc79cefe4a73 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.components.hash);
const $1a6e73f78330e553$export$486ac4364a6213c9 = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>Boolean(projectConfiguration.isReleasesFeatureEnabled));
const $1a6e73f78330e553$export$21a8719ce41a1de2 = (state, componentId)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $1a6e73f78330e553$export$254cbc79cefe4a73(state)[componentId];
const $1a6e73f78330e553$export$97f5859d9b9ee574 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.childIssuePlanningMode);
const $1a6e73f78330e553$export$236c77227e5ade46 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.isSprintsFeatureEnabled);
const $1a6e73f78330e553$export$ef0a9ade329ddbde = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$236c77227e5ade46, $1a6e73f78330e553$export$97f5859d9b9ee574, (isSprintFeatureEnabled, mode)=>isSprintFeatureEnabled && mode === (0, $0237521e367b8052$export$a316570a0dbfd2b0));
const $1a6e73f78330e553$export$1e1cd096ccca9b98 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.isChildIssuePlanningEnabled);
const $1a6e73f78330e553$export$deba3717b0119a76 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$1b132ed8629e9cb0, (sprints)=>sprints.some((sprint)=>sprint.state === (0, $a7a73ddab4e749dd$export$2b35adb71b3f6143) || sprint.state === (0, $a7a73ddab4e749dd$export$47b7b82714c61a7c)));
const $1a6e73f78330e553$export$32752434cc32c671 = (state)=>state.configuration.hierarchyConfiguration;
const $1a6e73f78330e553$export$f361eea8c49edc41 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$32752434cc32c671, (hierarchyConfiguration)=>hierarchyConfiguration.levelOneName);
const $1a6e73f78330e553$export$28b082b8254a5fc3 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$ac75fa8de98d4194, (configuration)=>configuration.deriveFields ?? {});
const $1a6e73f78330e553$export$d38f904d50b0a8af = (0, $df4Sl.createSelector)($1a6e73f78330e553$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.isGoalsFeatureEnabled ?? false);
const $1a6e73f78330e553$export$5124aa00ca92f2c0 = (0, $df4Sl.createSelector)($1a6e73f78330e553$export$ac75fa8de98d4194, (configuration)=>configuration.canInviteOthersToProject);

});
const $0237521e367b8052$export$501a7fac1df67a49 = 'DATE';
const $0237521e367b8052$export$a316570a0dbfd2b0 = 'SPRINT';
const $0237521e367b8052$export$8cd212c10b4124d2 = 'DISABLED';

const $a7a73ddab4e749dd$export$19c4f83398a8dbce = 'CLOSED';
const $a7a73ddab4e749dd$export$2b35adb71b3f6143 = 'ACTIVE';
const $a7a73ddab4e749dd$export$47b7b82714c61a7c = 'FUTURE';


parcelRegister("cUmMY", function(module, exports) {

$parcel$export(module.exports, "getIsGoalsLoaded", () => $ace0274d81cd735c$export$e298bff40a30190e);
$parcel$export(module.exports, "getGoalsHash", () => $ace0274d81cd735c$export$697e9cd4661d73ca);
$parcel$export(module.exports, "getGoals", () => $ace0274d81cd735c$export$da2944c52ff0de62);
$parcel$export(module.exports, "getGoalsByKeyHash", () => $ace0274d81cd735c$export$e5a3a472ce119e30);
$parcel$export(module.exports, "getUniqueGoalIds", () => $ace0274d81cd735c$export$80b5fae50e4561f9);

var $df4Sl = parcelRequire("df4Sl");

var $3aUuh = parcelRequire("3aUuh");
const $ace0274d81cd735c$export$e298bff40a30190e = (state)=>state.entities.goals.isLoaded;
const $ace0274d81cd735c$export$697e9cd4661d73ca = (state)=>state.entities.goals.hash;
const $ace0274d81cd735c$export$da2944c52ff0de62 = (0, $df4Sl.createSelector)($ace0274d81cd735c$export$697e9cd4661d73ca, (goalHash)=>Object.values(goalHash).map(({ goal: goal })=>goal));
const $ace0274d81cd735c$export$e5a3a472ce119e30 = (0, $df4Sl.createSelector)($ace0274d81cd735c$export$697e9cd4661d73ca, (goals)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(Object.values(goals), (roadmapGoal)=>roadmapGoal.goal?.key));
const $ace0274d81cd735c$export$80b5fae50e4561f9 = (0, $df4Sl.createSelector)($ace0274d81cd735c$export$697e9cd4661d73ca, (goalHash)=>Object.keys(goalHash));

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});


parcelRegister("6FeJk", function(module, exports) {

$parcel$export(module.exports, "getFullIssueHash", () => $16a34ff4906d1cf5$export$509a628015f94404);
$parcel$export(module.exports, "getIssue", () => $16a34ff4906d1cf5$export$34403cb88b30d33b);
$parcel$export(module.exports, "isIssueExists", () => $16a34ff4906d1cf5$export$a987926fdc8259e3);
$parcel$export(module.exports, "getIssueIds", () => $16a34ff4906d1cf5$export$370b31b0927c0664);
$parcel$export(module.exports, "getIssueKeyHash", () => $16a34ff4906d1cf5$export$709dd7a2719b4d3c);
$parcel$export(module.exports, "getIssueSummaryHash", () => $16a34ff4906d1cf5$export$45178bf1f6b30a05);
$parcel$export(module.exports, "getIssueSummary", () => $16a34ff4906d1cf5$export$7bead7bb2ab962ba);
$parcel$export(module.exports, "getIssueLabelsHash", () => $16a34ff4906d1cf5$export$89a09562712dfef3);
$parcel$export(module.exports, "getIssueVersionIdsHash", () => $16a34ff4906d1cf5$export$8245af4324992ff2);
$parcel$export(module.exports, "getIssueComponentIdsHash", () => $16a34ff4906d1cf5$export$5e800c163de4eaa7);
$parcel$export(module.exports, "getIssueSprintIdsHash", () => $16a34ff4906d1cf5$export$a4ba5eda4ed95a38);
$parcel$export(module.exports, "getIssueStartDateHash", () => $16a34ff4906d1cf5$export$e70cd0960ca3186b);
$parcel$export(module.exports, "getIssueStartDate", () => $16a34ff4906d1cf5$export$a8ae12d1f205826a);
$parcel$export(module.exports, "getIssueDueDateHash", () => $16a34ff4906d1cf5$export$50e1c24a80dbb314);
$parcel$export(module.exports, "getIssueDueDate", () => $16a34ff4906d1cf5$export$f8ab4a7848083941);
$parcel$export(module.exports, "getIssueStatusHash", () => $16a34ff4906d1cf5$export$b01abdaac5dcf309);
$parcel$export(module.exports, "getIssueStatusCategoryIdHash", () => $16a34ff4906d1cf5$export$adccc555500c3bee);
$parcel$export(module.exports, "getIssueColorHash", () => $16a34ff4906d1cf5$export$da98615adc72ad52);
$parcel$export(module.exports, "getIssueColor", () => $16a34ff4906d1cf5$export$55c693e53af6bf58);
$parcel$export(module.exports, "getIssueDependenciesHash", () => $16a34ff4906d1cf5$export$d18473c39ab467b9);
$parcel$export(module.exports, "getIssueDependeesHash", () => $16a34ff4906d1cf5$export$a75f6e1b2d9a96e6);
$parcel$export(module.exports, "getIssueCreationTransitionHash", () => $16a34ff4906d1cf5$export$463be3da47228a17);
$parcel$export(module.exports, "getIssueTypeIdHash", () => $16a34ff4906d1cf5$export$9c2cc629815990f4);
$parcel$export(module.exports, "getIssueParentIdHash", () => $16a34ff4906d1cf5$export$bc636ecad39aefe7);
$parcel$export(module.exports, "getIssueParentIds", () => $16a34ff4906d1cf5$export$e2a1f4395caa152c);
$parcel$export(module.exports, "getIssueChildrenHash", () => $16a34ff4906d1cf5$export$42b9de7c695b23f4);
$parcel$export(module.exports, "getIssueAssigneeHash", () => $16a34ff4906d1cf5$export$ece74a09c40b283c);
$parcel$export(module.exports, "getIssueTypeIdForIssueId", () => $16a34ff4906d1cf5$export$627dd4a8a3148b34);
$parcel$export(module.exports, "getIssueRank", () => $16a34ff4906d1cf5$export$83043f999557592);
$parcel$export(module.exports, "getIssueKeyToIdHash", () => $16a34ff4906d1cf5$export$725bd639062ab891);
$parcel$export(module.exports, "getIssueKeyById", () => $16a34ff4906d1cf5$export$1ee789fc749b8122);
$parcel$export(module.exports, "getSafeId", () => $16a34ff4906d1cf5$export$d1aa29729505dfb6);
$parcel$export(module.exports, "getSafeIds", () => $16a34ff4906d1cf5$export$7a2a38248dcbd59d);
$parcel$export(module.exports, "getSafeIdResolve", () => $16a34ff4906d1cf5$export$1ecfe4cc5bb1d8e8);
$parcel$export(module.exports, "getIssueLevel", () => $16a34ff4906d1cf5$export$7c3556a5aaee2b0b);
$parcel$export(module.exports, "getIsIssueStartDateRequired", () => $16a34ff4906d1cf5$export$8772cf309cb8256d);
$parcel$export(module.exports, "getIsIssueDueDateRequired", () => $16a34ff4906d1cf5$export$cbfbf3928d1b6c17);
$parcel$export(module.exports, "getIsIssueResolved", () => $16a34ff4906d1cf5$export$bf068fa0555f7625);
$parcel$export(module.exports, "getIsIssueFlaggedHash", () => $16a34ff4906d1cf5$export$5b8c57fffaec5b6b);
parcelRequire("6og5C");
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("flmol");
parcelRequire("iects");

var $df4Sl = parcelRequire("df4Sl");

var $fUTZC = parcelRequire("fUTZC");

var $ccg3T = parcelRequire("ccg3T");

var $jG2Eu = parcelRequire("jG2Eu");

var $3JafE = parcelRequire("3JafE");

var $opsFH = parcelRequire("opsFH");

var $kbiEp = parcelRequire("kbiEp");

var $6ah8E = parcelRequire("6ah8E");

var $eIDUd = parcelRequire("eIDUd");

var $bwVWW = parcelRequire("bwVWW");

var $2ukAT = parcelRequire("2ukAT");
const $16a34ff4906d1cf5$var$get = (state)=>state.entities.issues;
const $16a34ff4906d1cf5$export$509a628015f94404 = (state)=>$16a34ff4906d1cf5$var$get(state).hash;
const $16a34ff4906d1cf5$export$34403cb88b30d33b = (state, issueId)=>$16a34ff4906d1cf5$export$509a628015f94404(state)[issueId];
const $16a34ff4906d1cf5$export$a987926fdc8259e3 = (state, issueId)=>Boolean($16a34ff4906d1cf5$export$34403cb88b30d33b(state, issueId)) || Boolean((0, $2ukAT.getSubtaskParentHash)(state)[issueId]);
const $16a34ff4906d1cf5$export$370b31b0927c0664 = (state)=>$16a34ff4906d1cf5$var$get(state).sequence;
// ============== //
// === HASHES === //
// ============== //
const $16a34ff4906d1cf5$var$entityUpdateSelector = (0, $6ah8E.createVersionedEntityHashDiffSelector)($16a34ff4906d1cf5$export$509a628015f94404);
const $16a34ff4906d1cf5$export$709dd7a2719b4d3c = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.key);
const $16a34ff4906d1cf5$export$45178bf1f6b30a05 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.summary.value);
const $16a34ff4906d1cf5$export$7bead7bb2ab962ba = (state, issueId)=>$16a34ff4906d1cf5$export$45178bf1f6b30a05(state)[issueId];
const $16a34ff4906d1cf5$export$89a09562712dfef3 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.labels);
const $16a34ff4906d1cf5$export$424a50dfd4d5b981 = (state, issueId)=>$16a34ff4906d1cf5$export$89a09562712dfef3(state)[issueId];
const $16a34ff4906d1cf5$export$8245af4324992ff2 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.versionIds);
const $16a34ff4906d1cf5$export$5e800c163de4eaa7 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.componentIds);
const $16a34ff4906d1cf5$export$a4ba5eda4ed95a38 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.sprintIds.value);
const $16a34ff4906d1cf5$export$e70cd0960ca3186b = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.startDate.value);
const $16a34ff4906d1cf5$export$a8ae12d1f205826a = (state, issueId)=>$16a34ff4906d1cf5$export$e70cd0960ca3186b(state)[issueId];
const $16a34ff4906d1cf5$export$50e1c24a80dbb314 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.dueDate.value);
const $16a34ff4906d1cf5$export$f8ab4a7848083941 = (state, issueId)=>$16a34ff4906d1cf5$export$50e1c24a80dbb314(state)[issueId];
const $16a34ff4906d1cf5$export$b01abdaac5dcf309 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.status);
const $16a34ff4906d1cf5$export$adccc555500c3bee = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.status ? issue.status.statusCategoryId : undefined);
const $16a34ff4906d1cf5$export$da98615adc72ad52 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue?.color.value || (0, $opsFH.PURPLE));
const $16a34ff4906d1cf5$export$55c693e53af6bf58 = (state, issueId)=>$16a34ff4906d1cf5$export$da98615adc72ad52(state)[issueId];
const $16a34ff4906d1cf5$export$d18473c39ab467b9 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.dependencies);
const $16a34ff4906d1cf5$export$ce469229d91e527c = (state, issueId)=>{
    const dependencies = $16a34ff4906d1cf5$export$d18473c39ab467b9(state)[issueId];
    return Boolean(dependencies && dependencies.length > 0);
};
const $16a34ff4906d1cf5$export$a75f6e1b2d9a96e6 = (0, $df4Sl.createSelector)($16a34ff4906d1cf5$export$d18473c39ab467b9, (dependenciesHash)=>{
    const result = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(dependenciesHash, (dependencies, issueId)=>{
        dependencies.forEach((dependencyId)=>{
            if (!result[dependencyId]) result[dependencyId] = [];
            result[dependencyId].push(issueId);
        });
    });
    return result;
});
const $16a34ff4906d1cf5$export$463be3da47228a17 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.inCreation);
const $16a34ff4906d1cf5$export$9c2cc629815990f4 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.issueTypeId);
const $16a34ff4906d1cf5$export$bc636ecad39aefe7 = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.parentId.value);
const $16a34ff4906d1cf5$export$e2a1f4395caa152c = (0, $df4Sl.createSelector)($16a34ff4906d1cf5$export$bc636ecad39aefe7, (issueParentIdHash)=>Object.keys(issueParentIdHash).filter((issueId)=>issueParentIdHash[issueId] === undefined));
const $16a34ff4906d1cf5$export$42b9de7c695b23f4 = (0, $df4Sl.createSelector)($16a34ff4906d1cf5$export$bc636ecad39aefe7, (0, (/*@__PURE__*/$parcel$interopDefault($ccg3T))));
const $16a34ff4906d1cf5$export$ece74a09c40b283c = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.assignee);
const $16a34ff4906d1cf5$export$d4f6e058473cfdbe = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.rank);
const $16a34ff4906d1cf5$export$627dd4a8a3148b34 = (state, issueId)=>$16a34ff4906d1cf5$export$9c2cc629815990f4(state)[issueId];
const $16a34ff4906d1cf5$export$83043f999557592 = (state, issueId)=>$16a34ff4906d1cf5$export$d4f6e058473cfdbe(state)[issueId];
const $16a34ff4906d1cf5$export$725bd639062ab891 = (0, $df4Sl.createSelector)($16a34ff4906d1cf5$export$709dd7a2719b4d3c, (keyHash)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(keyHash).forEach((id)=>{
        const issueKey = keyHash[id];
        if (issueKey !== undefined && typeof issueKey === 'string') result[issueKey] = id;
    });
    return result;
});
const $16a34ff4906d1cf5$export$1ee789fc749b8122 = (state, issueId)=>$16a34ff4906d1cf5$export$709dd7a2719b4d3c(state)[issueId];
const $16a34ff4906d1cf5$export$41017b23e16219ab = (state, issueId)=>$16a34ff4906d1cf5$export$463be3da47228a17(state)[issueId] === true;
// ================== //
// === TRANSITION === //
// ================== //
const $16a34ff4906d1cf5$var$getTransitionHandlers = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue, id)=>{
    if (issue.inCreation) {
        const resolve = {
            func: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
        const promise = new Promise((resolution)=>{
            resolve.func = resolution;
        });
        return {
            observable: (0, $3JafE.Observable).fromPromise(promise),
            resolve: resolve.func
        };
    }
    return {
        observable: (0, $3JafE.Observable).of(id),
        resolve: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
});
const $16a34ff4906d1cf5$var$getSafeTransitionId = (state, id)=>$16a34ff4906d1cf5$var$getTransitionHandlers(state)[id];
const $16a34ff4906d1cf5$export$d1aa29729505dfb6 = (state, id)=>{
    const transitionId = $16a34ff4906d1cf5$var$getSafeTransitionId(state, id);
    if (transitionId === undefined) return (0, $3JafE.Observable).of({}).mergeMap(()=>{
        throw Error(`no safe id can be retrieved for id ${id}`);
    });
    return transitionId.observable;
};
const $16a34ff4906d1cf5$export$7a2a38248dcbd59d = (state, ids)=>(0, $3JafE.Observable).forkJoin(ids.map((id)=>$16a34ff4906d1cf5$export$d1aa29729505dfb6(state, id))).map((safeIds)=>safeIds);
const $16a34ff4906d1cf5$export$1ecfe4cc5bb1d8e8 = (state, id)=>{
    const transitionId = $16a34ff4906d1cf5$var$getSafeTransitionId(state, id);
    if (transitionId === undefined) return ()=>{
        throw Error(`cannot resolve id ${id}`);
    };
    return transitionId.resolve;
};
const $16a34ff4906d1cf5$export$7c3556a5aaee2b0b = (state, issueId)=>{
    if ((0, $bwVWW.getEpicIssueTypeIds)(state).includes($16a34ff4906d1cf5$export$627dd4a8a3148b34(state, issueId))) return 0, $kbiEp.PARENT_LEVEL;
    return $16a34ff4906d1cf5$export$bc636ecad39aefe7(state)[issueId] === undefined ? (0, $kbiEp.PARENT_LEVEL) : (0, $kbiEp.BASE_LEVEL);
};
const $16a34ff4906d1cf5$export$8772cf309cb8256d = (state, issueId)=>(0, $bwVWW.getRequiredFieldsByIssueTypeId)(state, $16a34ff4906d1cf5$export$627dd4a8a3148b34(state, issueId)).includes('startdate');
const $16a34ff4906d1cf5$export$cbfbf3928d1b6c17 = (state, issueId)=>(0, $bwVWW.getRequiredFieldsByIssueTypeId)(state, $16a34ff4906d1cf5$export$627dd4a8a3148b34(state, issueId)).includes('duedate');
const $16a34ff4906d1cf5$export$d1de367978946dbc = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.resolved);
const $16a34ff4906d1cf5$export$bf068fa0555f7625 = (state, issueId)=>$16a34ff4906d1cf5$export$d1de367978946dbc(state)[issueId];
const $16a34ff4906d1cf5$export$5b8c57fffaec5b6b = (0, $eIDUd.createPropertyHashSelector)($16a34ff4906d1cf5$var$entityUpdateSelector, (issue)=>issue.flagged);

});
parcelRegister("ccg3T", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $eQ67w = parcelRequire("eQ67w");
/** Used for built-in method references. */ var $8e13109068bf5ca8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8e13109068bf5ca8$var$hasOwnProperty = $8e13109068bf5ca8$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8e13109068bf5ca8$var$nativeObjectToString = $8e13109068bf5ca8$var$objectProto.toString;
/**
 * This method is like `_.invert` except that the inverted object is generated
 * from the results of running each element of `object` thru `iteratee`. The
 * corresponding inverted value of each inverted key is an array of keys
 * responsible for generating the inverted value. The iteratee is invoked
 * with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Object
 * @param {Object} object The object to invert.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invertBy(object);
 * // => { '1': ['a', 'c'], '2': ['b'] }
 *
 * _.invertBy(object, function(value) {
 *   return 'group' + value;
 * });
 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
 */ var $8e13109068bf5ca8$var$invertBy = $eQ67w(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $8e13109068bf5ca8$var$nativeObjectToString.call(value);
    if ($8e13109068bf5ca8$var$hasOwnProperty.call(result, value)) result[value].push(key);
    else result[value] = [
        key
    ];
}, $7qARj);
module.exports = $8e13109068bf5ca8$var$invertBy;

});

parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});

parcelRegister("kbiEp", function(module, exports) {

$parcel$export(module.exports, "BASE_LEVEL", () => $88b3a53c4d7efea4$export$d5993e01b9439be4);
$parcel$export(module.exports, "PARENT_LEVEL", () => $88b3a53c4d7efea4$export$6c5e715ac831956e);
$parcel$export(module.exports, "isBaseLevel", () => $88b3a53c4d7efea4$export$3f3fbf12338c09a4);
$parcel$export(module.exports, "isParentLevel", () => $88b3a53c4d7efea4$export$dbfe1bb564ec5b98);
const $88b3a53c4d7efea4$export$7f882bb969de14a3 = 0;
const $88b3a53c4d7efea4$export$d5993e01b9439be4 = 0;
const $88b3a53c4d7efea4$export$6c5e715ac831956e = 1;
const $88b3a53c4d7efea4$export$e3140dc7d0c35e48 = (depth)=>depth === $88b3a53c4d7efea4$export$7f882bb969de14a3;
const $88b3a53c4d7efea4$export$3f3fbf12338c09a4 = (level)=>level === $88b3a53c4d7efea4$export$d5993e01b9439be4;
const $88b3a53c4d7efea4$export$dbfe1bb564ec5b98 = (level)=>level === $88b3a53c4d7efea4$export$6c5e715ac831956e;

});

parcelRegister("6ah8E", function(module, exports) {

$parcel$export(module.exports, "createVersionedEntityHashDiffSelector", () => $8d1afdfeb0a6e8b5$export$d8971c6f597927b5);

var $2jl6T = parcelRequire("2jl6T");
const $8d1afdfeb0a6e8b5$export$d8971c6f597927b5 = (hashSelector)=>{
    const weakHashPairsToDiffs = new WeakMap();
    const tryGetDiff = (previousHash, hash)=>{
        if (!previousHash) return undefined;
        const previousMap = weakHashPairsToDiffs.get(previousHash);
        if (!previousMap) return undefined;
        return previousMap.get(hash);
    };
    const createDiff = (previousHash, hash)=>{
        if (!previousHash) return (0, $2jl6T.createInitialized)(hash);
        if (previousHash === hash) return (0, $2jl6T.createUnchanged)(hash);
        const { added: added, changed: changed, removed: removed, unchanged: unchanged } = (0, $2jl6T.getHashDiff)(previousHash, hash);
        return {
            added: added,
            changed: changed,
            removed: removed,
            unchanged: unchanged,
            hash: hash
        };
    };
    const addDiff = (previousHash, hash, diff)=>{
        if (previousHash) {
            if (!weakHashPairsToDiffs.get(previousHash)) weakHashPairsToDiffs.set(previousHash, new WeakMap());
            const map = weakHashPairsToDiffs.get(previousHash);
            if (map && !map.get(hash)) map.set(hash, diff);
        }
    };
    return (state, previousHash)=>{
        const hash = hashSelector(state);
        const memoizedDiff = tryGetDiff(previousHash, hash);
        if (memoizedDiff) return memoizedDiff;
        const diff = createDiff(previousHash, hash);
        addDiff(previousHash, hash, diff);
        return diff;
    };
};

});
parcelRegister("2jl6T", function(module, exports) {

$parcel$export(module.exports, "createInitialized", () => $d7b2d5393cf766b5$export$c056a666e5fa43d9);
$parcel$export(module.exports, "createUnchanged", () => $d7b2d5393cf766b5$export$2c3deafddfc1bfd8);
$parcel$export(module.exports, "getHashDiff", () => $d7b2d5393cf766b5$export$5698c3adeade33cd);

var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d7b2d5393cf766b5$var$EMPTY = {};
const $d7b2d5393cf766b5$export$c056a666e5fa43d9 = (hash)=>({
        added: hash,
        removed: $d7b2d5393cf766b5$var$EMPTY,
        changed: $d7b2d5393cf766b5$var$EMPTY,
        unchanged: $d7b2d5393cf766b5$var$EMPTY,
        hash: hash
    });
const $d7b2d5393cf766b5$export$2c3deafddfc1bfd8 = (hash)=>({
        added: $d7b2d5393cf766b5$var$EMPTY,
        removed: $d7b2d5393cf766b5$var$EMPTY,
        changed: $d7b2d5393cf766b5$var$EMPTY,
        unchanged: hash,
        hash: hash
    });
const $d7b2d5393cf766b5$var$createHashDiff = (hash)=>({
        removed: {},
        added: {},
        changed: {},
        unchanged: {},
        hash: hash
    });
const $d7b2d5393cf766b5$export$5698c3adeade33cd = (prevItems, items)=>{
    const hashDiff = $d7b2d5393cf766b5$var$createHashDiff(items);
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(items, (value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prevItems, key)) hashDiff.added[key] = value;
        else if (prevItems[key] !== value) hashDiff.changed[key] = value;
        else hashDiff.unchanged[key] = value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(prevItems, (value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(items, key)) hashDiff.removed[key] = value;
    });
    return hashDiff;
};

});


parcelRegister("eIDUd", function(module, exports) {

$parcel$export(module.exports, "createPropertyHashSelector", () => $ac8512f1bdaa15c6$export$be7e3b3993889dcc);

var $fUTZC = parcelRequire("fUTZC");

var $8blac = parcelRequire("8blac");

var $lrL4o = parcelRequire("lrL4o");
const $ac8512f1bdaa15c6$export$be7e3b3993889dcc = (getVersionedEntityHash, propertyAccessor)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let previousPropertyHash = {};
    let previousEntityHash;
    return (state)=>{
        // get ids of entities differing in the entity hash
        // external O(#entities + #oldEntities) - but memoized
        const hashDiff = getVersionedEntityHash(state, previousEntityHash);
        previousEntityHash = hashDiff.hash;
        // if the content of the entity hash (or the hash itself) did not change - early exit
        // O(1)
        if (!(0, $lrL4o.isHashModified)(hashDiff)) return previousPropertyHash;
        // start building up the new property hash
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newPropertyHash = {};
        // first copy over properties from changed entities and remember if one changed
        // O(#updatedEntities * propertyAccess)
        let somePropertyModified = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(hashDiff.changed, (item, key)=>{
            newPropertyHash[key] = propertyAccessor(item, key);
            somePropertyModified = somePropertyModified || previousPropertyHash[key] !== newPropertyHash[key];
        });
        // if from the changed entities no relevant property got updated AND no entity has been added or removed - early exit
        // O(1)
        if (!somePropertyModified && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(hashDiff.added) && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(hashDiff.removed)) return previousPropertyHash;
        // copy over the properties from the added entities
        // O(#addedEntities * propertyAccess)
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(hashDiff.added, (entity, key)=>{
            newPropertyHash[key] = propertyAccessor(entity, key);
        });
        // copy over the properties from the unchanged items from the previous hash
        // O(#unchanged Entities)
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(hashDiff.unchanged, (entity, key)=>{
            newPropertyHash[key] = previousPropertyHash[key];
        });
        previousPropertyHash = newPropertyHash;
        return newPropertyHash;
    };
};

});
parcelRegister("lrL4o", function(module, exports) {

$parcel$export(module.exports, "isHashModified", () => $98acc9281574ea72$export$938a7d6ce11aef20);

var $8blac = parcelRequire("8blac");
const $98acc9281574ea72$export$938a7d6ce11aef20 = (hashDiff)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(hashDiff.added) || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(hashDiff.changed) || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(hashDiff.removed);

});


parcelRegister("2ukAT", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PROGRESS_META_DATA", () => $3d153d260b810af0$export$5effc9af7f3d5ab1);
$parcel$export(module.exports, "getIssueSubtaskProgress", () => $3d153d260b810af0$export$b11597e808a0695f);
$parcel$export(module.exports, "getSubtaskParentHash", () => $3d153d260b810af0$export$4815ade352754ab0);

var $df4Sl = parcelRequire("df4Sl");

var $5urmd = parcelRequire("5urmd");

var $11pvk = parcelRequire("11pvk");
const $3d153d260b810af0$export$5effc9af7f3d5ab1 = {
    total: 0,
    completed: 0
};
const $3d153d260b810af0$export$a4870c61873f9011 = (subtasksHash, doneStatusCategoryId)=>{
    const subtaskProgressHash = {};
    Object.keys(subtasksHash).forEach((issueId)=>{
        const subtasks = subtasksHash[issueId];
        subtaskProgressHash[issueId] = {
            total: subtasks.length,
            completed: subtasks.filter(({ statusCategoryId: statusCategoryId })=>statusCategoryId === doneStatusCategoryId).length
        };
    });
    return subtaskProgressHash;
};
const $3d153d260b810af0$export$dbe9e2254a5e78a5 = (0, $df4Sl.createSelector)((0, $11pvk.getFullSubtasksHash), (0, $5urmd.getDoneStatusCategoryId), $3d153d260b810af0$export$a4870c61873f9011);
const $3d153d260b810af0$export$b11597e808a0695f = (state, issueId)=>$3d153d260b810af0$export$dbe9e2254a5e78a5(state)[issueId] || $3d153d260b810af0$export$5effc9af7f3d5ab1;
const $3d153d260b810af0$export$4815ade352754ab0 = (0, $df4Sl.createSelector)((0, $11pvk.getFullSubtasksHash), (subtaskHash)=>{
    const parentHash = {};
    Object.keys(subtaskHash).forEach((issueId)=>{
        subtaskHash[issueId].forEach(({ id: subtaskId })=>{
            parentHash[subtaskId] = issueId;
        });
    });
    return parentHash;
});

});
parcelRegister("5urmd", function(module, exports) {

$parcel$export(module.exports, "getFullStatusCategoriesHash", () => $c8a98e8bac766c6e$export$4d3052942abf4419);
$parcel$export(module.exports, "getStatusCategoriesKeyHash", () => $c8a98e8bac766c6e$export$d54ec7912540cebb);
$parcel$export(module.exports, "getDoneStatusCategoryId", () => $c8a98e8bac766c6e$export$3580b58bfbfbc93d);

var $df4Sl = parcelRequire("df4Sl");

var $3aUuh = parcelRequire("3aUuh");

var $3cdA4 = parcelRequire("3cdA4");

var $5iA56 = parcelRequire("5iA56");
const $c8a98e8bac766c6e$export$4d3052942abf4419 = (state)=>state.entities.statusCategories.hash;
const $c8a98e8bac766c6e$export$d54ec7912540cebb = (0, $df4Sl.createSelector)($c8a98e8bac766c6e$export$4d3052942abf4419, (statusCategories)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))((0, (/*@__PURE__*/$parcel$interopDefault($3cdA4)))(statusCategories), 'key'));
const $c8a98e8bac766c6e$export$3580b58bfbfbc93d = (0, $df4Sl.createSelector)($c8a98e8bac766c6e$export$4d3052942abf4419, (statusCategoriesHash)=>Object.keys(statusCategoriesHash).find((id)=>statusCategoriesHash[id].key === (0, $5iA56.DONE)));

});
parcelRegister("3cdA4", function(module, exports) {

var $bQoXG = parcelRequire("bQoXG");

var $b69Sx = parcelRequire("b69Sx");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $hQ6NY = parcelRequire("hQ6NY");

var $c1eMI = parcelRequire("c1eMI");

var $bAWWz = parcelRequire("bAWWz");

var $aSldm = parcelRequire("aSldm");

var $hvbu2 = parcelRequire("hvbu2");
/** `Object#toString` result references. */ var $253d06f861bc4c67$var$mapTag = '[object Map]', $253d06f861bc4c67$var$setTag = '[object Set]';
/** Built-in value references. */ var $253d06f861bc4c67$var$symIterator = $bQoXG ? $bQoXG.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $253d06f861bc4c67$var$toArray(value) {
    if (!value) return [];
    if ($jxg5X(value)) return $4ZYEI(value) ? $aSldm(value) : $b69Sx(value);
    if ($253d06f861bc4c67$var$symIterator && value[$253d06f861bc4c67$var$symIterator]) return $hQ6NY(value[$253d06f861bc4c67$var$symIterator]());
    var tag = $fjnSB(value), func = tag == $253d06f861bc4c67$var$mapTag ? $c1eMI : tag == $253d06f861bc4c67$var$setTag ? $bAWWz : $hvbu2;
    return func(value);
}
module.exports = $253d06f861bc4c67$var$toArray;

});
parcelRegister("hQ6NY", function(module, exports) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $cfcc92505e25a5f1$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = $cfcc92505e25a5f1$var$iteratorToArray;

});


parcelRegister("5iA56", function(module, exports) {

$parcel$export(module.exports, "NO_CATEGORY", () => $cf76e765b7d2b8b6$export$485b1216c42d8d4);
$parcel$export(module.exports, "TODO", () => $cf76e765b7d2b8b6$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $cf76e765b7d2b8b6$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $cf76e765b7d2b8b6$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORY_APPEARENCE", () => $cf76e765b7d2b8b6$export$d30a79bc64f85b0a);
$parcel$export(module.exports, "TODO_STATUS_CATEGORY_ID", () => $cf76e765b7d2b8b6$export$d436f83626e1a290);

var $8Qd0L = parcelRequire("8Qd0L");
const $cf76e765b7d2b8b6$export$485b1216c42d8d4 = (0, $8Qd0L.StatusCategoryTypes).UNDEFINED;
const $cf76e765b7d2b8b6$export$aa456a5030160740 = (0, $8Qd0L.StatusCategoryTypes).NEW;
const $cf76e765b7d2b8b6$export$5a9ac66c2785cc13 = (0, $8Qd0L.StatusCategoryTypes).INDETERMINATE;
const { DONE: $cf76e765b7d2b8b6$export$71efb3495f6084f2 } = (0, $8Qd0L.StatusCategoryTypes);
const $cf76e765b7d2b8b6$export$d30a79bc64f85b0a = {
    '2': 'default',
    '3': 'success',
    '4': 'inprogress'
};
const $cf76e765b7d2b8b6$export$d436f83626e1a290 = (0, $8Qd0L.StatusCategoryIds)[$cf76e765b7d2b8b6$export$aa456a5030160740];

});


parcelRegister("11pvk", function(module, exports) {

$parcel$export(module.exports, "getFullSubtasksHash", () => $d25ef6303d67dbec$export$180d47c15a1bb3af);
const $d25ef6303d67dbec$export$180d47c15a1bb3af = (state)=>state.entities.subtasks.hash;

});



parcelRegister("6489W", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $6da12e838c25d541$export$e7fd20fad3cf4b5f);
$parcel$export(module.exports, "getLocationUrl", () => $6da12e838c25d541$export$c024dd91ea9ad904);
$parcel$export(module.exports, "getQuery", () => $6da12e838c25d541$export$71eec30d9db46a56);
$parcel$export(module.exports, "getStatus", () => $6da12e838c25d541$export$b70265791d2079d4);
$parcel$export(module.exports, "getAssignee", () => $6da12e838c25d541$export$faae7c2d4768067b);
$parcel$export(module.exports, "getIssueType", () => $6da12e838c25d541$export$ed2455632bf977ef);
$parcel$export(module.exports, "getLabels", () => $6da12e838c25d541$export$f81a3ec2bfb3f287);
$parcel$export(module.exports, "getIssueParents", () => $6da12e838c25d541$export$df9259146e40d32c);
$parcel$export(module.exports, "getVersions", () => $6da12e838c25d541$export$cbd9528a83fbffa1);
$parcel$export(module.exports, "getGoalAris", () => $6da12e838c25d541$export$d79b9fff2c89e8e9);
$parcel$export(module.exports, "isGoalFilterActive", () => $6da12e838c25d541$export$ab702c2371a7d5f8);
$parcel$export(module.exports, "getHighlightedVersionsInQuery", () => $6da12e838c25d541$export$5b6701495fa73553);
$parcel$export(module.exports, "getComponents", () => $6da12e838c25d541$export$4e811121b221213b);
$parcel$export(module.exports, "getQuickFilters", () => $6da12e838c25d541$export$59e2f55e44eccfa0);
$parcel$export(module.exports, "getCustomFilters", () => $6da12e838c25d541$export$ada7918f4af738ad);
$parcel$export(module.exports, "getQueryContainsJQLFilters", () => $6da12e838c25d541$export$dba384035ff81d88);
$parcel$export(module.exports, "getSelectedIssueKey", () => $6da12e838c25d541$export$f4f27837c656f0ef);
$parcel$export(module.exports, "isDependenciesVisibleInQuery", () => $6da12e838c25d541$export$4f0b76c30f0f3fd5);
$parcel$export(module.exports, "isProgressVisibleInQuery", () => $6da12e838c25d541$export$6768efe8b031989d);
$parcel$export(module.exports, "isWarningsVisibleInQuery", () => $6da12e838c25d541$export$bb252b79d23fc8f2);
$parcel$export(module.exports, "isReleasesVisibleInQuery", () => $6da12e838c25d541$export$751544b976770556);
$parcel$export(module.exports, "isShared", () => $6da12e838c25d541$export$973d2af2aea58feb);
$parcel$export(module.exports, "getEpicSettingInQuery", () => $6da12e838c25d541$export$5f19542fc055e77c);

var $df4Sl = parcelRequire("df4Sl");

var $aD3n2 = parcelRequire("aD3n2");

var $lgKTA = parcelRequire("lgKTA");

var $cUmMY = parcelRequire("cUmMY");
const $6da12e838c25d541$export$e7fd20fad3cf4b5f = (state)=>state.router.location;
const $6da12e838c25d541$export$c024dd91ea9ad904 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$e7fd20fad3cf4b5f, (location)=>`${location.pathname}${location.search}${location.hash}`);
const $6da12e838c25d541$export$71eec30d9db46a56 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$e7fd20fad3cf4b5f, (0, $lgKTA.getRoadmapType), (location, roadmapType)=>(0, $aD3n2.convertStringToQuery)(location.search.replace(/^\?/, ''), roadmapType));
const $6da12e838c25d541$export$b70265791d2079d4 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.statuses || []);
const $6da12e838c25d541$export$faae7c2d4768067b = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.assignee || []);
const $6da12e838c25d541$export$ed2455632bf977ef = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.issueType || []);
const $6da12e838c25d541$export$f81a3ec2bfb3f287 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.label || []);
const $6da12e838c25d541$export$df9259146e40d32c = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.issueParent || []);
const $6da12e838c25d541$export$cbd9528a83fbffa1 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.version || []);
const $6da12e838c25d541$export$d79b9fff2c89e8e9 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (0, $cUmMY.getGoalsByKeyHash), (query, goals)=>(query.goal || []).map((ari)=>goals[ari]?.goal?.id).filter((id)=>id !== undefined));
const $6da12e838c25d541$export$ab702c2371a7d5f8 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$d79b9fff2c89e8e9, (goals)=>goals.length > 0);
const $6da12e838c25d541$export$5b6701495fa73553 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.highlightedVersions || []);
const $6da12e838c25d541$export$4e811121b221213b = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.component || []);
const $6da12e838c25d541$export$59e2f55e44eccfa0 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.quickFilter || []);
const $6da12e838c25d541$export$ada7918f4af738ad = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.customFilter || []);
const $6da12e838c25d541$export$dba384035ff81d88 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$59e2f55e44eccfa0, $6da12e838c25d541$export$ada7918f4af738ad, (quickFilters, customFilters)=>customFilters.length > 0 || quickFilters.length > 0);
const $6da12e838c25d541$export$d5d5a91bd9ef0413 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.rapidView);
const $6da12e838c25d541$export$f4f27837c656f0ef = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.selectedIssue);
const $6da12e838c25d541$export$4f0b76c30f0f3fd5 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>!query.hideDependencies);
const $6da12e838c25d541$export$6768efe8b031989d = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>!query.hideProgress);
const $6da12e838c25d541$export$bb252b79d23fc8f2 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>!query.hideWarnings);
const $6da12e838c25d541$export$751544b976770556 = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>!query.hideVersionHeader);
const $6da12e838c25d541$export$973d2af2aea58feb = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.shared);
const $6da12e838c25d541$export$5f19542fc055e77c = (0, $df4Sl.createSelector)($6da12e838c25d541$export$71eec30d9db46a56, (query)=>query.epic);

});
parcelRegister("aD3n2", function(module, exports) {

$parcel$export(module.exports, "convertQueryToString", () => $8949093250332246$export$8883f4e93b9ac6a8);
$parcel$export(module.exports, "convertStringToQuery", () => $8949093250332246$export$2a2e058f3963d1fc);

var $8q0kU = parcelRequire("8q0kU");

var $53ciZ = parcelRequire("53ciZ");


var $2bSyC = parcelRequire("2bSyC");
const $8949093250332246$var$stringifyValuesList = (value)=>{
    if (Array.isArray(value)) return value.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($8q0kU)))(value, ',') : undefined;
    return value || undefined;
};
const $8949093250332246$export$8883f4e93b9ac6a8 = (query)=>{
    const modOverride = {
        statuses: $8949093250332246$var$stringifyValuesList(query.statuses),
        issueType: $8949093250332246$var$stringifyValuesList(query.issueType),
        assignee: $8949093250332246$var$stringifyValuesList(query.assignee),
        label: $8949093250332246$var$stringifyValuesList(query.label),
        issueParent: $8949093250332246$var$stringifyValuesList(query.issueParent),
        shared: query.shared ? null : undefined,
        version: $8949093250332246$var$stringifyValuesList(query.version),
        component: $8949093250332246$var$stringifyValuesList(query.component),
        quickFilter: $8949093250332246$var$stringifyValuesList(query.quickFilter),
        customFilter: $8949093250332246$var$stringifyValuesList(query.customFilter),
        highlightedVersions: $8949093250332246$var$stringifyValuesList(query.highlightedVersions),
        goal: $8949093250332246$var$stringifyValuesList(query.goal)
    };
    const mod = {
        ...query,
        ...modOverride
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(mod);
};
const $8949093250332246$export$2a2e058f3963d1fc = (query, roadmapType = (0, $27ecaf74a39e2b82$export$296f840b5ae7056e))=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(query);
    return (0, $2bSyC.getSanitizedQuery)(parsed, roadmapType);
};

});
parcelRegister("8q0kU", function(module, exports) {
/** Used for built-in method references. */ var $6211033229c314f4$var$arrayProto = Array.prototype;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6211033229c314f4$var$nativeJoin = $6211033229c314f4$var$arrayProto.join;
/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */ function $6211033229c314f4$var$join(array, separator) {
    return array == null ? '' : $6211033229c314f4$var$nativeJoin.call(array, separator);
}
module.exports = $6211033229c314f4$var$join;

});

parcelRegister("2bSyC", function(module, exports) {

$parcel$export(module.exports, "getSanitizedQuery", () => $0fbaefa62afb9b66$export$6e1abb516904ab3e);

var $8blac = parcelRequire("8blac");

var $4ZYEI = parcelRequire("4ZYEI");

const $0fbaefa62afb9b66$var$parseValuesList = (value)=>{
    if (value !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(value)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value.split(',');
    return [];
};
const $0fbaefa62afb9b66$var$parseValueBoolean = (value)=>value === 'true' || value === true ? true : undefined;
const $0fbaefa62afb9b66$export$6e1abb516904ab3e = (parsed, roadmapType)=>{
    const isCMP = roadmapType === (0, $27ecaf74a39e2b82$export$40f914e9a75ff65a);
    const sanitized = {
        // generic params
        projectKey: parsed.projectKey,
        rapidView: parsed.rapidView,
        timeline: parsed.timeline,
        selectedIssue: parsed.selectedIssue,
        text: parsed.text,
        hideDependencies: $0fbaefa62afb9b66$var$parseValueBoolean(parsed.hideDependencies),
        hideProgress: $0fbaefa62afb9b66$var$parseValueBoolean(parsed.hideProgress),
        hideWarnings: $0fbaefa62afb9b66$var$parseValueBoolean(parsed.hideWarnings),
        hideVersionHeader: $0fbaefa62afb9b66$var$parseValueBoolean(parsed.hideVersionHeader),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        epic: parsed.epic,
        statuses: $0fbaefa62afb9b66$var$parseValuesList(parsed.statuses),
        issueType: $0fbaefa62afb9b66$var$parseValuesList(parsed.issueType),
        assignee: $0fbaefa62afb9b66$var$parseValuesList(parsed.assignee),
        label: $0fbaefa62afb9b66$var$parseValuesList(parsed.label),
        issueParent: $0fbaefa62afb9b66$var$parseValuesList(parsed.issueParent),
        version: $0fbaefa62afb9b66$var$parseValuesList(parsed.version),
        component: $0fbaefa62afb9b66$var$parseValuesList(parsed.component),
        highlightedVersions: $0fbaefa62afb9b66$var$parseValuesList(parsed.highlightedVersions),
        shared: 'shared' in parsed,
        // CMP specific params
        quickFilter: isCMP ? $0fbaefa62afb9b66$var$parseValuesList(parsed.quickFilter) : undefined,
        customFilter: !isCMP ? $0fbaefa62afb9b66$var$parseValuesList(parsed.customFilter) : undefined,
        goal: $0fbaefa62afb9b66$var$parseValuesList(parsed.goal)
    };
    return sanitized;
};

});


parcelRegister("lgKTA", function(module, exports) {

$parcel$export(module.exports, "getLoggedInAccountId", () => $a8dc7c1437a30f93$export$846c7c52537933ac);
$parcel$export(module.exports, "getCloudId", () => $a8dc7c1437a30f93$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getActivationId", () => $a8dc7c1437a30f93$export$3ad4bb31a1816ff6);
$parcel$export(module.exports, "getIsReadOnly", () => $a8dc7c1437a30f93$export$1fc90e957d653067);
$parcel$export(module.exports, "getSourceARI", () => $a8dc7c1437a30f93$export$c0b7eb9c66c63628);
$parcel$export(module.exports, "getBoardId", () => $a8dc7c1437a30f93$export$557c2f222778cea6);
$parcel$export(module.exports, "hasMacroConfig", () => $a8dc7c1437a30f93$export$91384e8db69910af);
$parcel$export(module.exports, "getMacroHideHeader", () => $a8dc7c1437a30f93$export$f9526ccea455c4f4);
$parcel$export(module.exports, "getContainerName", () => $a8dc7c1437a30f93$export$d471dcb7d994b2a4);
$parcel$export(module.exports, "getRoadmapType", () => $a8dc7c1437a30f93$export$6bcd10888326ba19);
$parcel$export(module.exports, "isClassic", () => $a8dc7c1437a30f93$export$bb674e1910e1b216);
$parcel$export(module.exports, "shouldUseQuickFilters", () => $a8dc7c1437a30f93$export$88699d4b7a7a02a0);
$parcel$export(module.exports, "shouldUseCustomFilters", () => $a8dc7c1437a30f93$export$8019dd71e3c6ed2d);

var $df4Sl = parcelRequire("df4Sl");

const $a8dc7c1437a30f93$export$846c7c52537933ac = (state)=>state.app.loggedInAccountId;
const $a8dc7c1437a30f93$export$fdd2c0ba94025c3c = (state)=>state.app.cloudId;
const $a8dc7c1437a30f93$export$3ad4bb31a1816ff6 = (state)=>state.app.activationId;
const $a8dc7c1437a30f93$export$1fc90e957d653067 = (state)=>state.app.isReadOnly;
const $a8dc7c1437a30f93$export$c0b7eb9c66c63628 = (state)=>state.app.sourceAri;
const $a8dc7c1437a30f93$export$557c2f222778cea6 = (state)=>state.app.boardId;
const $a8dc7c1437a30f93$export$24be09ac26544799 = (state)=>state.app.macroConfig;
const $a8dc7c1437a30f93$export$91384e8db69910af = (0, $df4Sl.createSelector)($a8dc7c1437a30f93$export$24be09ac26544799, (macroConfig)=>Boolean(macroConfig));
const $a8dc7c1437a30f93$export$f9526ccea455c4f4 = (0, $df4Sl.createSelector)($a8dc7c1437a30f93$export$24be09ac26544799, (macroConfig)=>Boolean(macroConfig && macroConfig.hideHeader));
const $a8dc7c1437a30f93$export$d471dcb7d994b2a4 = (state)=>state.app.containerName;
const $a8dc7c1437a30f93$export$6bcd10888326ba19 = (state)=>state.app.type;
const $a8dc7c1437a30f93$export$bb674e1910e1b216 = (0, $df4Sl.createSelector)($a8dc7c1437a30f93$export$6bcd10888326ba19, (type)=>type === (0, $27ecaf74a39e2b82$export$40f914e9a75ff65a));
const $a8dc7c1437a30f93$export$88699d4b7a7a02a0 = (state)=>state.app.type === (0, $27ecaf74a39e2b82$export$40f914e9a75ff65a);
const $a8dc7c1437a30f93$export$8019dd71e3c6ed2d = (state)=>state.app.type === (0, $27ecaf74a39e2b82$export$296f840b5ae7056e);

});


parcelRegister("9N1AA", function(module, exports) {

$parcel$export(module.exports, "getStoredTimelineFilter", () => $cf80031e6fb65477$export$ed161c26e81cde84);
$parcel$export(module.exports, "getListWidth", () => $cf80031e6fb65477$export$546faffca0a891d);
$parcel$export(module.exports, "getCreationPreferences", () => $cf80031e6fb65477$export$d5ca17246c80d2c8);
$parcel$export(module.exports, "getHighlightedVersionsInSettings", () => $cf80031e6fb65477$export$b33d9f325ade8c9b);
$parcel$export(module.exports, "getIssuePanelRatio", () => $cf80031e6fb65477$export$aea41387f8aebc6f);
const $cf80031e6fb65477$export$ed161c26e81cde84 = (state)=>state.settings.timelineMode;
const $cf80031e6fb65477$export$546faffca0a891d = (state)=>state.settings.listWidth;
const $cf80031e6fb65477$export$d5ca17246c80d2c8 = (state)=>state.settings.creationPreferences;
const $cf80031e6fb65477$export$b33d9f325ade8c9b = (state)=>state.settings.highlightedVersions;
const $cf80031e6fb65477$export$aea41387f8aebc6f = (state)=>state.settings.issuePanelRatio;

});

parcelRegister("kz9g9", function(module, exports) {

$parcel$export(module.exports, "isDependenciesVisibleInView", () => $eaa6ab9844f193c4$export$962f58efc6e07e87);
$parcel$export(module.exports, "isProgressVisibleInView", () => $eaa6ab9844f193c4$export$75bdd64d01e19367);
$parcel$export(module.exports, "isWarningsVisibleInView", () => $eaa6ab9844f193c4$export$767253e2fd89204c);
$parcel$export(module.exports, "isReleasesVisibleInView", () => $eaa6ab9844f193c4$export$6e3f0e22409097be);
$parcel$export(module.exports, "getLevelOneSettingInView", () => $eaa6ab9844f193c4$export$d502ece6c0972ba1);
const $eaa6ab9844f193c4$export$962f58efc6e07e87 = (state)=>state.ui.views.isDependenciesVisible;
const $eaa6ab9844f193c4$export$75bdd64d01e19367 = (state)=>state.ui.views.isProgressVisible;
const $eaa6ab9844f193c4$export$767253e2fd89204c = (state)=>state.ui.views.isWarningsVisible;
const $eaa6ab9844f193c4$export$6e3f0e22409097be = (state)=>state.ui.views.isReleasesVisible;
const $eaa6ab9844f193c4$export$d502ece6c0972ba1 = (state)=>state.ui.views.levelOneViewSettings;

});

parcelRegister("lDe9P", function(module, exports) {

$parcel$export(module.exports, "getSanitisedIssueComponentIdsHash", () => $5ea652fcf9ce0476$export$3731ad97e9be4c92);
$parcel$export(module.exports, "getUniqueComponents", () => $5ea652fcf9ce0476$export$16a540615fa7c203);
$parcel$export(module.exports, "getComponents", () => $5ea652fcf9ce0476$export$4e811121b221213b);

var $df4Sl = parcelRequire("df4Sl");

var $jtx35 = parcelRequire("jtx35");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $18hMN = parcelRequire("18hMN");
const $5ea652fcf9ce0476$export$3731ad97e9be4c92 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueComponentIdsHash), (0, $bwVWW.getFullComponentHash), (0, $18hMN.createGetSanitisedIssueComponentIdsHash));
const $5ea652fcf9ce0476$export$16a540615fa7c203 = (0, $df4Sl.createSelector)($5ea652fcf9ce0476$export$3731ad97e9be4c92, (0, $18hMN.createGetUniqueComponents));
const $5ea652fcf9ce0476$export$4e811121b221213b = (0, $jtx35.createSelectorWithDefaultEqual)($5ea652fcf9ce0476$export$16a540615fa7c203, (0, $bwVWW.getFullComponentHash), (0, $18hMN.createGetComponents));

});
parcelRegister("18hMN", function(module, exports) {

$parcel$export(module.exports, "createGetSanitisedIssueComponentIdsHash", () => $9681eb86de99e38e$export$f42e04a8615077a5);
$parcel$export(module.exports, "createGetUniqueComponents", () => $9681eb86de99e38e$export$ab5c9aa3d05bf5d2);
$parcel$export(module.exports, "createGetComponents", () => $9681eb86de99e38e$export$9a82eb1ebd237ecc);

var $6ZDS2 = parcelRequire("6ZDS2");

var $MdoH4 = parcelRequire("MdoH4");

const $9681eb86de99e38e$export$f42e04a8615077a5 = (issueComponentIdsHash, allComponentsHash)=>Object.keys(issueComponentIdsHash).reduce((acc, key)=>{
        const componentIds = issueComponentIdsHash[key];
        acc[key] = componentIds.filter((componentId)=>Boolean(allComponentsHash[componentId]));
        return acc;
    }, {});
const $9681eb86de99e38e$export$ab5c9aa3d05bf5d2 = (issueComponentsHash)=>{
    const allComponents = (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(Object.keys(issueComponentsHash).map((key)=>{
        const issueComponents = issueComponentsHash[key] || [];
        return issueComponents;
    }));
    const uniqueComponents = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(allComponents);
    return uniqueComponents.length ? [
        (0, $44677eb502cfd308$export$4b7c755e61199a36),
        ...uniqueComponents
    ] : uniqueComponents;
};
const $9681eb86de99e38e$export$9a82eb1ebd237ecc = (uniqueComponents, componentsHash)=>{
    const components = [];
    uniqueComponents.forEach((componentId)=>{
        const component = componentsHash[componentId];
        // NOTE: Leave unassigned component case out as it's not a real component
        component && components.push(component);
    });
    return components.sort((componentA, componentB)=>componentA.name.toLowerCase() < componentB.name.toLowerCase() ? -1 : 1);
};

});
const $44677eb502cfd308$export$d597759d33be802e = 'TEXT';
const $44677eb502cfd308$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $44677eb502cfd308$export$37aee82a3cb1e8f7 = 'LABEL';
const $44677eb502cfd308$export$2a4f270075a033de = 'ISSUE_PARENT';
const $44677eb502cfd308$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $44677eb502cfd308$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $44677eb502cfd308$export$a4ad2735b021c132 = 'VERSION';
const $44677eb502cfd308$export$af1e30ebbae9df3b = 'COMPONENT';
const $44677eb502cfd308$export$f863b019d19144f4 = 'STATUS_CATEGORY';
const $44677eb502cfd308$export$a316570a0dbfd2b0 = 'SPRINT';
const $44677eb502cfd308$export$e50006273435e7d4 = 'STATUS';
const $44677eb502cfd308$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $44677eb502cfd308$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $44677eb502cfd308$export$1ea95b94fb0c51d9 = 'QUICK_FILTER';
const $44677eb502cfd308$export$871e58afc769b358 = 'GOAL';
const $44677eb502cfd308$export$6c4d37c7f376a1de = 'CLEAR';
const $44677eb502cfd308$export$db362e2d293fe52e = 'DEPENDENCIES';
const $44677eb502cfd308$export$12e572fd459c10dc = 'unassigned';
const $44677eb502cfd308$export$ac95b4b2317d4b33 = 'unassigned';
const $44677eb502cfd308$export$81ef49afbbead0a1 = 'label unassigned';
const $44677eb502cfd308$export$4b7c755e61199a36 = 'unassigned';
const $44677eb502cfd308$export$c9408e3fb31ddc71 = 'offline';
const $44677eb502cfd308$export$7a105aa475396c65 = 'online';



parcelRegister("iKKDu", function(module, exports) {

$parcel$export(module.exports, "getLabels", () => $76e5b2a3eaca9539$export$f81a3ec2bfb3f287);
$parcel$export(module.exports, "getLabelsWithUnassignedOption", () => $76e5b2a3eaca9539$export$849c9376495979c4);

var $df4Sl = parcelRequire("df4Sl");

var $6ZDS2 = parcelRequire("6ZDS2");

var $MdoH4 = parcelRequire("MdoH4");


var $jtx35 = parcelRequire("jtx35");

var $6FeJk = parcelRequire("6FeJk");
const $76e5b2a3eaca9539$var$getUniqueLabels = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueLabelsHash), (issueLabelsHash)=>{
    const allLabels = (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(Object.keys(issueLabelsHash).map((key)=>{
        const issueLabels = issueLabelsHash[key] || [];
        return issueLabels;
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(allLabels).sort();
});
const $76e5b2a3eaca9539$export$f81a3ec2bfb3f287 = (0, $jtx35.createSelectorWithDefaultEqual)($76e5b2a3eaca9539$var$getUniqueLabels, (labels)=>labels);
const $76e5b2a3eaca9539$export$849c9376495979c4 = (0, $jtx35.createSelectorWithDefaultEqual)($76e5b2a3eaca9539$var$getUniqueLabels, (labels)=>labels.length ? [
        (0, $44677eb502cfd308$export$81ef49afbbead0a1),
        ...labels
    ] : labels);

});

parcelRegister("hjI8T", function(module, exports) {

$parcel$export(module.exports, "getSanitisedIssueVersionIdsHash", () => $30dc258afd24abf2$export$c9041494b04fb60e);
$parcel$export(module.exports, "getUniqueVersions", () => $30dc258afd24abf2$export$f7cc858d2c3e2ed1);
$parcel$export(module.exports, "getVersionsForFilter", () => $30dc258afd24abf2$export$9cf24bc3913525f6);
$parcel$export(module.exports, "getVersionIdsForFilter", () => $30dc258afd24abf2$export$816050db139173ae);
$parcel$export(module.exports, "createGetVersionsForKeyDates", () => $30dc258afd24abf2$export$57b36ea5b0cba889);
$parcel$export(module.exports, "getIsReleasesVisible", () => $30dc258afd24abf2$export$1bd9547a6769d327);
$parcel$export(module.exports, "getHighlightedVersions", () => $30dc258afd24abf2$export$a46fe3951b75c931);
$parcel$export(module.exports, "getHighlightedKeyDates", () => $30dc258afd24abf2$export$fbd707cc0b3c1c08);

var $df4Sl = parcelRequire("df4Sl");

var $jtx35 = parcelRequire("jtx35");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $6489W = parcelRequire("6489W");

var $9N1AA = parcelRequire("9N1AA");

var $kz9g9 = parcelRequire("kz9g9");

var $cRNqv = parcelRequire("cRNqv");
const $30dc258afd24abf2$export$c9041494b04fb60e = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueVersionIdsHash), (0, $bwVWW.getFullVersionHash), (0, $cRNqv.createGetSanitisedIssueVersionIdsHash));
const $30dc258afd24abf2$export$f7cc858d2c3e2ed1 = (0, $df4Sl.createSelector)($30dc258afd24abf2$export$c9041494b04fb60e, (0, $cRNqv.createGetUniqueVersions));
const $30dc258afd24abf2$export$9cf24bc3913525f6 = (0, $jtx35.createSelectorWithDefaultEqual)($30dc258afd24abf2$export$f7cc858d2c3e2ed1, (0, $bwVWW.getFullVersionHash), (0, $cRNqv.createGetVersionsForFilter));
const $30dc258afd24abf2$export$816050db139173ae = (0, $df4Sl.createSelector)($30dc258afd24abf2$export$9cf24bc3913525f6, (versionsForFilter)=>versionsForFilter.map(({ id: id })=>id));
const $30dc258afd24abf2$export$57b36ea5b0cba889 = (0, $df4Sl.createSelector)((0, $bwVWW.getFullVersionHash), (0, $cRNqv.createGetVersionsForKeyDates));
const $30dc258afd24abf2$export$1bd9547a6769d327 = (0, $df4Sl.createSelector)((0, $bwVWW.getIsReleasesFeatureEnabled), (0, $6489W.isReleasesVisibleInQuery), (0, $kz9g9.isReleasesVisibleInView), (isReleaseFeatureEnable, isVisibleInQuery, isVisibleInView)=>!isReleaseFeatureEnable || !isVisibleInQuery ? false : isVisibleInView);
const $30dc258afd24abf2$var$EMPTY_ARRAY = [];
const $30dc258afd24abf2$export$a46fe3951b75c931 = (0, $df4Sl.createSelector)((0, $6489W.getHighlightedVersionsInQuery), (0, $9N1AA.getHighlightedVersionsInSettings), $30dc258afd24abf2$export$1bd9547a6769d327, (settingFromQuery, settingFromStore, isReleasesVisible)=>{
    if (!isReleasesVisible) return $30dc258afd24abf2$var$EMPTY_ARRAY;
    return settingFromQuery.length > 0 ? settingFromQuery : settingFromStore;
});
const $30dc258afd24abf2$export$fbd707cc0b3c1c08 = (0, $df4Sl.createSelector)($30dc258afd24abf2$export$a46fe3951b75c931, (highlightedVersions)=>highlightedVersions.map((version)=>version.toString()));

});
parcelRegister("cRNqv", function(module, exports) {

$parcel$export(module.exports, "createGetSanitisedIssueVersionIdsHash", () => $1154ef78e823a89c$export$7325f5903240ab1);
$parcel$export(module.exports, "createGetUniqueVersions", () => $1154ef78e823a89c$export$e9b6ecb0558048b);
$parcel$export(module.exports, "createGetVersionsForFilter", () => $1154ef78e823a89c$export$a928e57bd88fafd9);
$parcel$export(module.exports, "createGetVersionsForKeyDates", () => $1154ef78e823a89c$export$57b36ea5b0cba889);

var $6ZDS2 = parcelRequire("6ZDS2");

var $MdoH4 = parcelRequire("MdoH4");

var $5iWql = parcelRequire("5iWql");



var $fbLos = parcelRequire("fbLos");
const $1154ef78e823a89c$export$7325f5903240ab1 = (issueVersionIdsHash, allVersionsHash)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(issueVersionIdsHash).forEach((issueId)=>{
        const versionIds = issueVersionIdsHash[issueId];
        result[issueId] = versionIds.filter((versionId)=>Boolean(allVersionsHash[versionId]));
    });
    return result;
};
const $1154ef78e823a89c$export$e9b6ecb0558048b = (issueVersionsHash)=>{
    const allVersions = (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(Object.keys(issueVersionsHash).map((key)=>{
        const issueVersions = issueVersionsHash[key] || [];
        return issueVersions;
    }));
    const uniqueVersions = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(allVersions);
    return uniqueVersions.length ? [
        (0, $44677eb502cfd308$export$ac95b4b2317d4b33),
        ...uniqueVersions
    ] : uniqueVersions;
};
const $1154ef78e823a89c$export$a928e57bd88fafd9 = (uniqueVersions, versionsHash)=>{
    const versions = [];
    uniqueVersions.forEach((versionId)=>{
        const version = versionsHash[versionId];
        // NOTE: Leave unassigned version case out as it's not a real version
        if (version) versions.push({
            id: versionId,
            name: version.name
        });
    });
    return versions.sort((versionA, versionB)=>versionA.name.toLowerCase() < versionB.name.toLowerCase() ? -1 : 1);
};
const $1154ef78e823a89c$export$57b36ea5b0cba889 = (versionsHash)=>(0, $5iWql.default)((today)=>{
        const keyDates = [];
        const STATUS_MAP = {
            [(0, $8ee7c1d6e0383fbb$export$cb459d726a8530a5)]: (0, $fbLos.IN_PROGRESS),
            [(0, $8ee7c1d6e0383fbb$export$b983f2cb1f658a55)]: (0, $fbLos.COMPLETED)
        };
        Object.keys(versionsHash).forEach((versionId)=>{
            const version = versionsHash[versionId];
            if (version.releaseDate !== undefined) keyDates.push({
                id: versionId,
                name: version.name,
                date: version.releaseDate,
                status: version.status === (0, $8ee7c1d6e0383fbb$export$cb459d726a8530a5) && version.releaseDate < today ? (0, $fbLos.WARNING) : STATUS_MAP[version.status]
            });
        });
        return keyDates;
    });

});
const $8ee7c1d6e0383fbb$export$b983f2cb1f658a55 = 'RELEASED';
const $8ee7c1d6e0383fbb$export$cb459d726a8530a5 = 'UNRELEASED';

parcelRegister("fbLos", function(module, exports) {

$parcel$export(module.exports, "MARKER_WIDTH", () => $4aeafc4f5c417c61$export$4a6351d766d85076);
$parcel$export(module.exports, "MARKER_WIDTH_WITH_SPACE", () => $4aeafc4f5c417c61$export$95fcddab5858cd42);
$parcel$export(module.exports, "MARKER_BORDER_WIDTH", () => $4aeafc4f5c417c61$export$ff01cdc3aad1196);
$parcel$export(module.exports, "COMPLETED", () => $4aeafc4f5c417c61$export$fc332a617fd34192);
$parcel$export(module.exports, "IN_PROGRESS", () => $4aeafc4f5c417c61$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "WARNING", () => $4aeafc4f5c417c61$export$64fdd419ec8dbc36);
$parcel$export(module.exports, "MARKER_COLORS", () => $4aeafc4f5c417c61$export$d4060d4eb5ad0b29);
$parcel$export(module.exports, "STATUS_PRIORITY", () => $4aeafc4f5c417c61$export$dc65af84169ff7fb);


var $c9TLT = parcelRequire("c9TLT");
const $4aeafc4f5c417c61$export$4a6351d766d85076 = (0, $c9TLT.gridSize) * 2.5;
const $4aeafc4f5c417c61$export$95fcddab5858cd42 = $4aeafc4f5c417c61$export$4a6351d766d85076 + (0, $c9TLT.gridSize) * 2;
const $4aeafc4f5c417c61$export$ff01cdc3aad1196 = 2;
const $4aeafc4f5c417c61$export$fc332a617fd34192 = 'COMPLETED';
const $4aeafc4f5c417c61$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $4aeafc4f5c417c61$export$64fdd419ec8dbc36 = 'WARNING';
const $4aeafc4f5c417c61$export$d4060d4eb5ad0b29 = {
    [$4aeafc4f5c417c61$export$fc332a617fd34192]: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    [$4aeafc4f5c417c61$export$5a9ac66c2785cc13]: `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    [$4aeafc4f5c417c61$export$64fdd419ec8dbc36]: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
};
const $4aeafc4f5c417c61$export$dc65af84169ff7fb = {
    [$4aeafc4f5c417c61$export$fc332a617fd34192]: 0,
    [$4aeafc4f5c417c61$export$5a9ac66c2785cc13]: 1,
    [$4aeafc4f5c417c61$export$64fdd419ec8dbc36]: 2
};

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';




parcelRegister("9yupO", function(module, exports) {

$parcel$export(module.exports, "createGetFilteredLabels", () => $3d9f69755b5f0665$export$34da06a4ab395581);
$parcel$export(module.exports, "createGetFilteredIssueParents", () => $3d9f69755b5f0665$export$e5d358399bc5243b);
$parcel$export(module.exports, "createGetFilteredVersions", () => $3d9f69755b5f0665$export$33674feb2de63df5);
$parcel$export(module.exports, "createGetFilteredComponents", () => $3d9f69755b5f0665$export$1dc75016ff1b6891);
$parcel$export(module.exports, "getChildIssueTypesPure", () => $3d9f69755b5f0665$export$9edede936285e654);
$parcel$export(module.exports, "getLevelOneSettingPure", () => $3d9f69755b5f0665$export$4e27d35a1d765a6e);
$parcel$export(module.exports, "createGetFilteredGoals", () => $3d9f69755b5f0665$export$d8b78e7f68a52ee1);
$parcel$export(module.exports, "createGetFilteredGoalIssueIds", () => $3d9f69755b5f0665$export$7fca3aa3660623b6);

var $kG4jb = parcelRequire("kG4jb");

var $1urNG = parcelRequire("1urNG");

var $8vOu0 = parcelRequire("8vOu0");
const $3d9f69755b5f0665$export$34da06a4ab395581 = (labels, uniqueLabels)=>(0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(labels, uniqueLabels);
const $3d9f69755b5f0665$export$e5d358399bc5243b = (issueParents, uniqueIssueParents)=>(0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(issueParents, uniqueIssueParents);
const $3d9f69755b5f0665$export$33674feb2de63df5 = (versions, uniqueVersions)=>(0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(versions, uniqueVersions);
const $3d9f69755b5f0665$export$1dc75016ff1b6891 = (components, uniqueComponents)=>(0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(components, uniqueComponents);
const $3d9f69755b5f0665$export$9edede936285e654 = (issueTypesHash, epicIssueTypeIds)=>{
    const issueTypes = [];
    Object.keys(issueTypesHash).forEach((issueTypeId)=>{
        if (!epicIssueTypeIds.includes(issueTypeId)) {
            const issueType = issueTypesHash[issueTypeId];
            issueTypes.push({
                id: issueTypeId,
                name: issueType.name,
                iconUrl: issueType.iconUrl
            });
        }
    });
    return issueTypes;
};
const $3d9f69755b5f0665$export$4e27d35a1d765a6e = (settingFromQuery, settingFromStore)=>{
    if (settingFromQuery !== undefined && settingFromStore !== undefined) {
        const period = settingFromQuery === (0, $8vOu0.INCOMPLETE) ? settingFromStore.period : (0, $8vOu0.levelOneQuerySettingsToPeriodMap).get(settingFromQuery) || 12;
        return {
            period: period,
            showCompleted: settingFromQuery !== (0, $8vOu0.INCOMPLETE)
        };
    }
    return settingFromStore;
};
const $3d9f69755b5f0665$export$d8b78e7f68a52ee1 = (goals, uniqueGoals)=>(0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(goals, uniqueGoals);
const $3d9f69755b5f0665$export$7fca3aa3660623b6 = (filteredGoals, goals, childrenHash)=>{
    const parentIssues = (0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(...filteredGoals.map((goalId)=>goals[goalId].issueIds));
    return (0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(parentIssues, ...parentIssues.map((issueId)=>childrenHash[issueId] ?? []));
};

});
parcelRegister("kG4jb", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $kIBQX = parcelRequire("kIBQX");

var $9eFtX = parcelRequire("9eFtX");

var $arA63 = parcelRequire("arA63");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $f0db1270e02fec98$var$intersection = $9eFtX(function(arrays) {
    var mapped = $kJvGp(arrays, $arA63);
    return mapped.length && mapped[0] === arrays[0] ? $kIBQX(mapped) : [];
});
module.exports = $f0db1270e02fec98$var$intersection;

});
parcelRegister("kIBQX", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f155478e4676feef$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $f155478e4676feef$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $6v6uu : $lqZWH, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $kJvGp(array, $74vSq(iteratee));
        maxLength = $f155478e4676feef$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $lYFvJ(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $8AO5Q(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $8AO5Q(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $f155478e4676feef$var$baseIntersection;

});

parcelRegister("arA63", function(module, exports) {

var $cRpul = parcelRequire("cRpul");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $79a86d09190de0cd$var$castArrayLikeObject(value) {
    return $cRpul(value) ? value : [];
}
module.exports = $79a86d09190de0cd$var$castArrayLikeObject;

});


parcelRegister("1urNG", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $42tFs = parcelRequire("42tFs");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $115e28588d963fcd$var$union = $9eFtX(function(arrays) {
    return $42tFs($hKE3p(arrays, 1, $cRpul, true));
});
module.exports = $115e28588d963fcd$var$union;

});

parcelRegister("8vOu0", function(module, exports) {

$parcel$export(module.exports, "INCOMPLETE", () => $a2827ab4e9133c75$export$21a64a0a80457a5c);
$parcel$export(module.exports, "periodToLevelOneQuerySettingsMap", () => $a2827ab4e9133c75$export$ff5c9debc121d4e5);
$parcel$export(module.exports, "levelOneQuerySettingsToPeriodMap", () => $a2827ab4e9133c75$export$a820040c0626dd2d);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_VIEW_SETTINGS", () => $a2827ab4e9133c75$export$2aa5f7d521c704eb);
const $a2827ab4e9133c75$export$21a64a0a80457a5c = 'INCOMPLETE';
const $a2827ab4e9133c75$export$436621b04568a6f7 = 'COMPLETE1M';
const $a2827ab4e9133c75$export$9c18cd7ad055218c = 'COMPLETE3M';
const $a2827ab4e9133c75$export$fd408a62c645a1e5 = 'COMPLETE6M';
const $a2827ab4e9133c75$export$8ce4d04150556a2c = 'COMPLETE9M';
const $a2827ab4e9133c75$export$1f98274aa749e679 = 'COMPLETE12M';
const $a2827ab4e9133c75$export$ff5c9debc121d4e5 = new Map([
    [
        12,
        $a2827ab4e9133c75$export$1f98274aa749e679
    ],
    [
        9,
        $a2827ab4e9133c75$export$8ce4d04150556a2c
    ],
    [
        6,
        $a2827ab4e9133c75$export$fd408a62c645a1e5
    ],
    [
        3,
        $a2827ab4e9133c75$export$9c18cd7ad055218c
    ],
    [
        1,
        $a2827ab4e9133c75$export$436621b04568a6f7
    ]
]);
const $a2827ab4e9133c75$export$a820040c0626dd2d = new Map([
    [
        $a2827ab4e9133c75$export$1f98274aa749e679,
        12
    ],
    [
        $a2827ab4e9133c75$export$8ce4d04150556a2c,
        9
    ],
    [
        $a2827ab4e9133c75$export$fd408a62c645a1e5,
        6
    ],
    [
        $a2827ab4e9133c75$export$9c18cd7ad055218c,
        3
    ],
    [
        $a2827ab4e9133c75$export$436621b04568a6f7,
        1
    ]
]);
const $a2827ab4e9133c75$export$2aa5f7d521c704eb = {
    showCompleted: true,
    period: 12
};

});



parcelRegister("aSTh4", function(module, exports) {

$parcel$export(module.exports, "SET_DEPENDENCIES_VIEW_VISIBILITY", () => $08296887524c6ff5$export$1a16e905a7747be);
$parcel$export(module.exports, "setDependenciesViewVisibility", () => $08296887524c6ff5$export$d9343ff84626d4c8);
$parcel$export(module.exports, "SET_PROGRESS_VISIBILITY", () => $08296887524c6ff5$export$2e2e698a832d1a63);
$parcel$export(module.exports, "setProgressVisibility", () => $08296887524c6ff5$export$53320a7a4c26a8ad);
$parcel$export(module.exports, "SET_WARNINGS_VISIBILITY", () => $08296887524c6ff5$export$fc6caf89a567b8b1);
$parcel$export(module.exports, "setWarningsVisibility", () => $08296887524c6ff5$export$97d3304d96905fb0);
$parcel$export(module.exports, "SET_RELEASES_VISIBILITY", () => $08296887524c6ff5$export$44a92bc1a269f215);
$parcel$export(module.exports, "setReleasesVisibility", () => $08296887524c6ff5$export$fdec3e0865bc1066);
$parcel$export(module.exports, "SET_LEVEL_ONE_SETTING", () => $08296887524c6ff5$export$5847d71ec22dc665);
$parcel$export(module.exports, "setLevelOneSetting", () => $08296887524c6ff5$export$1542a36683289b9c);
$parcel$export(module.exports, "clearLevelOneSetting", () => $08296887524c6ff5$export$556a2127816d096d);

var $8vOu0 = parcelRequire("8vOu0");
const $08296887524c6ff5$export$1a16e905a7747be = 'state.ui.views.SET_DEPENDENCIES_VIEW_VISIBILITY';
const $08296887524c6ff5$export$d9343ff84626d4c8 = (payload)=>({
        type: $08296887524c6ff5$export$1a16e905a7747be,
        payload: payload
    });
const $08296887524c6ff5$export$2e2e698a832d1a63 = 'state.ui.views.SET_PROGRESS_VISIBILITY';
const $08296887524c6ff5$export$53320a7a4c26a8ad = (payload)=>({
        type: $08296887524c6ff5$export$2e2e698a832d1a63,
        payload: payload
    });
const $08296887524c6ff5$export$fc6caf89a567b8b1 = 'state.ui.views.SET_WARNINGS_VISIBILITY';
const $08296887524c6ff5$export$97d3304d96905fb0 = (payload)=>({
        type: $08296887524c6ff5$export$fc6caf89a567b8b1,
        payload: payload
    });
const $08296887524c6ff5$export$44a92bc1a269f215 = 'state.ui.views.SET_RELEASES_VISIBILITY';
const $08296887524c6ff5$export$fdec3e0865bc1066 = (payload)=>({
        type: $08296887524c6ff5$export$44a92bc1a269f215,
        payload: payload
    });
const $08296887524c6ff5$export$5847d71ec22dc665 = 'state.ui.views.SET_LEVEL_ONE_SETTING';
const $08296887524c6ff5$export$1542a36683289b9c = (payload)=>({
        type: $08296887524c6ff5$export$5847d71ec22dc665,
        payload: payload
    });
const $08296887524c6ff5$export$556a2127816d096d = ()=>({
        type: $08296887524c6ff5$export$5847d71ec22dc665,
        payload: (0, $8vOu0.DEFAULT_LEVEL_ONE_VIEW_SETTINGS)
    });

});

parcelRegister("7vazg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b35bb6de22197ffa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $eI5EY = parcelRequire("eI5EY");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hopaC = parcelRequire("hopaC");
const $b35bb6de22197ffa$export$36f7d6a88f12c6f1 = {
    DUPLICATED: 'DUPLICATED',
    DUPLICATED_HIDDEN: 'DUPLICATED_HIDDEN',
    CYCLE: 'CYCLE',
    CYCLE_HIDDEN: 'CYCLE_HIDDEN'
};
const $b35bb6de22197ffa$var$DependencyInvalidFlag = ({ id: id, onDismissed: onDismissed, setShowDependencies: setShowDependencies, dependee: dependee, dependency: dependency, isDependenciesVisible: isDependenciesVisible, isDependencyDuplicated: isDependencyDuplicated })=>{
    const onDismissedCallback = (0, $eUqFw.useCallback)(()=>{
        onDismissed(id);
    }, [
        id,
        onDismissed
    ]);
    const onShowDependencies = (0, $eUqFw.useCallback)(()=>{
        setShowDependencies();
        onDismissedCallback();
    }, [
        setShowDependencies,
        onDismissedCallback
    ]);
    let flagType;
    if (isDependenciesVisible) flagType = isDependencyDuplicated ? $b35bb6de22197ffa$export$36f7d6a88f12c6f1.DUPLICATED : $b35bb6de22197ffa$export$36f7d6a88f12c6f1.CYCLE;
    else flagType = isDependencyDuplicated ? $b35bb6de22197ffa$export$36f7d6a88f12c6f1.DUPLICATED_HIDDEN : $b35bb6de22197ffa$export$36f7d6a88f12c6f1.CYCLE_HIDDEN;
    const getDescription = ()=>{
        switch(flagType){
            case $b35bb6de22197ffa$export$36f7d6a88f12c6f1.DUPLICATED:
                return (0, $hopaC.default).duplicatedDescription;
            case $b35bb6de22197ffa$export$36f7d6a88f12c6f1.DUPLICATED_HIDDEN:
                return (0, $hopaC.default).duplicatedDescriptionHidden;
            case $b35bb6de22197ffa$export$36f7d6a88f12c6f1.CYCLE:
                return (0, $hopaC.default).cycleDescription;
            case $b35bb6de22197ffa$export$36f7d6a88f12c6f1.CYCLE_HIDDEN:
                return (0, $hopaC.default).cycleDescriptionHidden;
            default:
                return (0, $hopaC.default).duplicatedDescription;
        }
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!dependee || !dependency) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.WarningFlag), {
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-meatball-dependency-modal') ? {
            delayAnnouncement: 300
        } : {},
        id: id,
        onDismissed: onDismissedCallback,
        title: formatMessage(flagType === $b35bb6de22197ffa$export$36f7d6a88f12c6f1.DUPLICATED || flagType === $b35bb6de22197ffa$export$36f7d6a88f12c6f1.DUPLICATED_HIDDEN ? (0, $hopaC.default).duplicatedTitle : (0, $hopaC.default).cycleTitle),
        description: formatMessage(getDescription(), {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks),
            dependency: dependency,
            dependee: dependee
        }),
        ...flagType === $b35bb6de22197ffa$export$36f7d6a88f12c6f1.CYCLE_HIDDEN || flagType === $b35bb6de22197ffa$export$36f7d6a88f12c6f1.DUPLICATED_HIDDEN ? {
            actions: [
                {
                    content: formatMessage((0, $hopaC.default).showDependencies),
                    onClick: onShowDependencies
                },
                {
                    content: formatMessage((0, $hopaC.default).confirm),
                    onClick: onDismissedCallback
                }
            ]
        } : {}
    });
};
$b35bb6de22197ffa$var$DependencyInvalidFlag.defaultProps = {
    onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $b35bb6de22197ffa$export$2e2bcd8739ae039 = $b35bb6de22197ffa$var$DependencyInvalidFlag;

});
parcelRegister("hopaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba416d38d45d082$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5ba416d38d45d082$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    duplicatedTitle: {
        "id": "roadmap.standard-roadmap.flags.dependencies-invalid.duplicated-title",
        "defaultMessage": "Dependency already exists"
    },
    duplicatedDescription: {
        "id": "roadmap.standard-roadmap.flags.dependencies-invalid.duplicated-description",
        "defaultMessage": "<b>{dependency}</b> and <b>{dependee}</b> are already linked."
    },
    duplicatedDescriptionHidden: {
        "id": "roadmap.standard-roadmap.flags.dependencies-invalid.duplicated-description-hidden",
        "defaultMessage": "<b>{dependency}</b> and <b>{dependee}</b> are already linked, but dependencies are hidden on your timeline."
    },
    cycleTitle: {
        "id": "roadmap.standard-roadmap.flags.dependencies-invalid.cycle-title",
        "defaultMessage": "Couldn't create dependency"
    },
    cycleDescription: {
        "id": "roadmap.standard-roadmap.flags.dependencies-invalid.cycle-description",
        "defaultMessage": "Remove the existing dependency between <b>{dependency}</b> and <b>{dependee}</b>, and try again."
    },
    cycleDescriptionHidden: {
        "id": "roadmap.standard-roadmap.flags.dependencies-invalid.cycle-description-hidden",
        "defaultMessage": "Remove the existing dependency between <b>{dependency}</b> and <b>{dependee}</b> and try again. This dependency is currently hidden from your timeline."
    },
    showDependencies: {
        "id": "roadmap.standard-roadmap.flags.dependencies-invalid.show-dependencies",
        "defaultMessage": "Change Dependency settings"
    },
    confirm: {
        "id": "roadmap.standard-roadmap.flags.dependencies-invalid.confirm",
        "defaultMessage": "Got it"
    }
});

});



parcelRegister("9wcyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fccbfe1ae37a830b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $giAhk = parcelRequire("giAhk");


var $dGdwI = parcelRequire("dGdwI");

var $jvX9G = parcelRequire("jvX9G");
class $fccbfe1ae37a830b$export$3ac94ed2f6e2fad9 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            type: (0, $ca84cb21ba49b72e$export$706a65ec8b4360e1),
            onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { type: type, dependeeKey: dependeeKey, dependencyKey: dependencyKey, intl: { formatMessage: formatMessage }, ...props } = this.props;
        const title = type === (0, $ca84cb21ba49b72e$export$706a65ec8b4360e1) ? formatMessage((0, $jvX9G.default).titleAdd) : formatMessage((0, $jvX9G.default).titleRemove);
        const descriptionWithIssueKey = type === (0, $ca84cb21ba49b72e$export$706a65ec8b4360e1) ? formatMessage((0, $jvX9G.default).descriptionAdd, {
            dependee: dependeeKey,
            dependency: dependencyKey
        }) : formatMessage((0, $jvX9G.default).descriptionRemove, {
            dependee: dependeeKey,
            dependency: dependencyKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
            ...props,
            onDismissed: this.onDismissed,
            id: this.props.id,
            title: title,
            description: dependeeKey && dependencyKey ? descriptionWithIssueKey : formatMessage((0, $jvX9G.default).description),
            actions: [
                {
                    content: formatMessage((0, $jvX9G.default).learnMore),
                    href: (0, $dGdwI.docs).JIRA_PERMISSIONS_OVERVIEW
                }
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.onDismissed = ()=>{
            const { id: id, onDismissed: onDismissed } = this.props;
            onDismissed(id);
        };
    }
}
var $fccbfe1ae37a830b$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($fccbfe1ae37a830b$export$3ac94ed2f6e2fad9);

});
const $ca84cb21ba49b72e$export$706a65ec8b4360e1 = 'DEPENDENCY_ADD_ERROR';
const $ca84cb21ba49b72e$export$4e33c4fb4fd4616f = 'DEPENDENCY_DELETE_ERROR';

parcelRegister("dGdwI", function(module, exports) {

$parcel$export(module.exports, "docs", () => $f0833d728876dde0$export$257224358692d0e0);
// =========================== //
// SUPPORT DOCUMENTATION LINKS //
// =========================== //
const $f0833d728876dde0$var$SUPPORT_DOCUMENTATION_PREFIX = 'https://support.atlassian.com/jira-software-cloud/docs/';
const $f0833d728876dde0$var$TROUBLESHOOT_TIMELINES_NEXT_GEN = `${$f0833d728876dde0$var$SUPPORT_DOCUMENTATION_PREFIX}troubleshoot-the-timelines-for-team-managed-projects`;
const $f0833d728876dde0$var$DEPENDENCIES = `${$f0833d728876dde0$var$SUPPORT_DOCUMENTATION_PREFIX}manage-dependencies-between-epics-on-the-timeline`;
const $f0833d728876dde0$var$CUSTOMIZE_VIEW = `${$f0833d728876dde0$var$SUPPORT_DOCUMENTATION_PREFIX}customize-your-view-on-the-timeline`;
// =============================== //
// NON-ROADMAP DOCUMENTATION LINKS //
// =============================== //
const $f0833d728876dde0$var$JIRA_PERMISSIONS_OVERVIEW = 'https://support.atlassian.com/jira-service-desk-cloud/docs/overview-of-jira-cloud-permissions/';
const $f0833d728876dde0$var$CONTACT_SUPPORT = 'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues';
const $f0833d728876dde0$var$JIRA_SOFTWARE_PREMIUM_OVERVIEW = 'https://www.atlassian.com/software/jira/features/timelines?tab=advanced';
const $f0833d728876dde0$var$JIRA_SOFTWARE_PREMIUM_START_TRIAL = 'https://www.atlassian.com/try/cloud/signup?bundle=jira-software&edition=premium';
const $f0833d728876dde0$var$JIRA_WHAT_ARE_ADVANCED_ROADMAPS = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps';
const $f0833d728876dde0$export$257224358692d0e0 = {
    TROUBLESHOOT_TIMELINES_NEXT_GEN: $f0833d728876dde0$var$TROUBLESHOOT_TIMELINES_NEXT_GEN,
    DEPENDENCIES: $f0833d728876dde0$var$DEPENDENCIES,
    CUSTOMIZE_VIEW: $f0833d728876dde0$var$CUSTOMIZE_VIEW,
    JIRA_PERMISSIONS_OVERVIEW: $f0833d728876dde0$var$JIRA_PERMISSIONS_OVERVIEW,
    CONTACT_SUPPORT: $f0833d728876dde0$var$CONTACT_SUPPORT,
    JIRA_SOFTWARE_PREMIUM_OVERVIEW: $f0833d728876dde0$var$JIRA_SOFTWARE_PREMIUM_OVERVIEW,
    JIRA_SOFTWARE_PREMIUM_START_TRIAL: $f0833d728876dde0$var$JIRA_SOFTWARE_PREMIUM_START_TRIAL,
    JIRA_WHAT_ARE_ADVANCED_ROADMAPS: $f0833d728876dde0$var$JIRA_WHAT_ARE_ADVANCED_ROADMAPS
};

});

parcelRegister("jvX9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7f2df8598cfec0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7f7f2df8598cfec0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    titleAdd: {
        "id": "roadmap.standard-roadmap.flags.dependencies-permission.title-add",
        "defaultMessage": "Sorry we couldn't create a dependency"
    },
    titleRemove: {
        "id": "roadmap.standard-roadmap.flags.dependencies-permission.title-remove",
        "defaultMessage": "Sorry we couldn't delete a dependency"
    },
    description: {
        "id": "roadmap.standard-roadmap.flags.dependencies-permission.description",
        "defaultMessage": "You don't have link issues permission. Check your issue link Jira setting or contact your Jira administrator for help."
    },
    descriptionAdd: {
        "id": "roadmap.standard-roadmap.flags.dependencies-permission.description-add",
        "defaultMessage": "You don't have permission to link issue {dependency} to {dependee}. Check your issue link Jira setting or contact your Jira administrator for help."
    },
    descriptionRemove: {
        "id": "roadmap.standard-roadmap.flags.dependencies-permission.description-remove",
        "defaultMessage": "You don't have permission to unlink issue {dependency} and {dependee}. Check your issue link Jira setting or contact your Jira administrator for help."
    },
    learnMore: {
        "id": "roadmap.standard-roadmap.flags.dependencies-permission.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("aZu3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e3c18bdf2006a93$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $ahR90 = parcelRequire("ahR90");
const $0e3c18bdf2006a93$var$FlagWithAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "standardRoadmapFlags",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ahR90.default), props));
var $0e3c18bdf2006a93$export$2e2bcd8739ae039 = $0e3c18bdf2006a93$var$FlagWithAnalytics;

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("ahR90", function(module, exports) {

$parcel$export(module.exports, "default", () => $47bcad583c03413a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dGdwI = parcelRequire("dGdwI");

var $hkD0F = parcelRequire("hkD0F");
const $47bcad583c03413a$var$HiddenDependencyCreatedFlag = ({ id: id, onDismissed: onDismissed })=>{
    const onDismissedCallback = (0, $eUqFw.useCallback)(()=>{
        onDismissed(id);
    }, [
        id,
        onDismissed
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onLearnMoreCallback = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'learnMoreUnavailableDependenciesButton');
    }, [
        createAnalyticsEvent
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
        id: id,
        onDismissed: onDismissedCallback,
        title: formatMessage((0, $hkD0F.default).title),
        description: formatMessage((0, $hkD0F.default).description),
        actions: [
            {
                content: formatMessage((0, $hkD0F.default).learnMore),
                href: (0, $dGdwI.docs).DEPENDENCIES,
                onClick: onLearnMoreCallback
            }
        ]
    });
};
$47bcad583c03413a$var$HiddenDependencyCreatedFlag.defaultProps = {
    onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $47bcad583c03413a$export$2e2bcd8739ae039 = $47bcad583c03413a$var$HiddenDependencyCreatedFlag;

});
parcelRegister("hkD0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $50fda0a8411f252d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $50fda0a8411f252d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.dependencies-unavailable.title",
        "defaultMessage": "Sorry we couldn't create a dependency"
    },
    description: {
        "id": "roadmap.standard-roadmap.flags.dependencies-unavailable.description",
        "defaultMessage": "Check your issue link Jira setting or contact your Jira administrator for help."
    },
    learnMore: {
        "id": "roadmap.standard-roadmap.flags.dependencies-unavailable.learn-more",
        "defaultMessage": "Learn more"
    }
});

});



parcelRegister("3HDkE", function(module, exports) {

$parcel$export(module.exports, "default", () => $64249e43034cfd62$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6489W = parcelRequire("6489W");

var $8izRo = parcelRequire("8izRo");
var $64249e43034cfd62$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        href: (0, $6489W.getLocationUrl)(state)
    }), {})((0, $8izRo.default));

});
parcelRegister("8izRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $92a873239f29f813$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7whTz = parcelRequire("7whTz");
const $92a873239f29f813$var$RoadmapErrorFlag = ({ id: id, href: href, onDismissed: onDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onDismissedHandler = ()=>{
        onDismissed(id);
    };
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'roadmapErrorFlag'
        }), 'viewed roadmapErrorFlag', {
            cause: 'unknown'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
        onDismissed: onDismissedHandler,
        id: id,
        title: formatMessage((0, $7whTz.default).title),
        description: formatMessage((0, $7whTz.default).flagDescription),
        actions: [
            {
                content: formatMessage((0, $7whTz.default).reloadPageButton),
                href: href
            }
        ]
    });
};
var $92a873239f29f813$export$2e2bcd8739ae039 = $92a873239f29f813$var$RoadmapErrorFlag;

});
parcelRegister("7whTz", function(module, exports) {

$parcel$export(module.exports, "default", () => $37105d662a9f621b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37105d662a9f621b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.general-error.title",
        "defaultMessage": "Something went wrong"
    },
    flagDescription: {
        "id": "roadmap.standard-roadmap.flags.general-error.flag-description",
        "defaultMessage": "Reload the timeline to continue."
    },
    reloadPageButton: {
        "id": "roadmap.standard-roadmap.flags.general-error.reload-page-button",
        "defaultMessage": "Reload page"
    }
});

});



parcelRegister("5TbjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $73869247cdefad0b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $aSTh4 = parcelRequire("aSTh4");

var $GtSGi = parcelRequire("GtSGi");
const $73869247cdefad0b$var$onShowDependencies = ()=>(0, $aSTh4.setDependenciesViewVisibility)(true);
var $73869247cdefad0b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, {
    onShowDependencies: $73869247cdefad0b$var$onShowDependencies
})((0, $GtSGi.default));

});
parcelRegister("GtSGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b14512f46a0cf0d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $95RcH = parcelRequire("95RcH");

var $giAhk = parcelRequire("giAhk");

var $hcYpd = parcelRequire("hcYpd");
class $4b14512f46a0cf0d$export$e7de86f3a3a670e1 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, onShowDependencies: onShowDependencies, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95RcH.default), {
            ...props,
            onDismissed: this.onDismissed,
            id: this.props.id,
            title: formatMessage((0, $hcYpd.default).title),
            description: formatMessage((0, $hcYpd.default).description),
            actions: [
                {
                    content: formatMessage((0, $hcYpd.default).showDependencies),
                    onClick: this.onShowDependencies
                }
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.onDismissed = ()=>{
            const { id: id, onDismissed: onDismissed } = this.props;
            onDismissed(id);
        };
        this.onShowDependencies = ()=>{
            const { onShowDependencies: onShowDependencies } = this.props;
            onShowDependencies();
            this.onDismissed();
        };
    }
}
var $4b14512f46a0cf0d$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($4b14512f46a0cf0d$export$e7de86f3a3a670e1);

});
parcelRegister("95RcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eca080011a53a1f$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$6eca080011a53a1f$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessAutoDismissFlag);

});

parcelRegister("hcYpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $89eb78a86acd2687$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $89eb78a86acd2687$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.hidden-dependency-created.title",
        "defaultMessage": "New dependency created"
    },
    description: {
        "id": "roadmap.standard-roadmap.flags.hidden-dependency-created.description",
        "defaultMessage": "Your dependency was created, but it is hidden by your views configuration."
    },
    showDependencies: {
        "id": "roadmap.standard-roadmap.flags.hidden-dependency-created.show-dependencies",
        "defaultMessage": "Show dependencies"
    }
});

});



parcelRegister("3C54v", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c19cd62b05444f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");


var $95RcH = parcelRequire("95RcH");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1gs0D = parcelRequire("1gs0D");

var $20WCc = parcelRequire("20WCc");
const $07c19cd62b05444f$var$InteractedItemsLimitExceededFlag = ({ id: id, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95RcH.default), {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
            size: "medium",
            label: ""
        }),
        title: formatMessage((0, $20WCc.default).title, {
            limit: (0, $1gs0D.INTERACTED_ITEMS_LIMIT)
        }),
        onDismissed: onDismissed
    });
};
var $07c19cd62b05444f$export$2e2bcd8739ae039 = $07c19cd62b05444f$var$InteractedItemsLimitExceededFlag;

});
parcelRegister("20WCc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcb73f66fa43e211$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dcb73f66fa43e211$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded.title",
        "defaultMessage": "You can only select {limit} issues at a time."
    }
});

});


parcelRegister("3wyB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdcbd27ed090eb6c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $1pUKz = parcelRequire("1pUKz");
const $bdcbd27ed090eb6c$var$mapStateToProps = (state, { issueId: issueId })=>({
        issueKey: (0, $6FeJk.getIssueKeyById)(state, issueId)
    });
const $bdcbd27ed090eb6c$var$mapDispatchToProps = (dispatch, { transitionId: transitionId, issueId: issueId, hasOverdueReleaseDate: hasOverdueReleaseDate, properties: properties, sourceEvent: sourceEvent })=>({
        onPersist: ()=>{
            dispatch((0, $j45xj.updateAndPersistIssueWithoutSprintScopeCheck)(issueId, properties, sourceEvent, hasOverdueReleaseDate));
        },
        onUndo: ()=>{
            dispatch((0, $j45xj.resetTransitionState)({
                issueId: issueId,
                transitionId: transitionId
            }));
        }
    });
const $bdcbd27ed090eb6c$var$mergeProps = ({ issueKey: issueKey }, dispatchProps, { id: id, onDismissed: onDismissed })=>({
        ...dispatchProps,
        id: id,
        issueKey: issueKey,
        onDismissed: onDismissed
    });
var $bdcbd27ed090eb6c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($bdcbd27ed090eb6c$var$mapStateToProps, $bdcbd27ed090eb6c$var$mapDispatchToProps, $bdcbd27ed090eb6c$var$mergeProps)((0, $1pUKz.InteractedItemsLimitExceededWithActionsFlag));

});
parcelRegister("j45xj", function(module, exports) {

$parcel$export(module.exports, "RESET_TRANSITION_STATE", () => $658117860e846f30$export$8b2e719778c50595);
$parcel$export(module.exports, "resetTransitionState", () => $658117860e846f30$export$3e3a419ce534070d);
$parcel$export(module.exports, "CLEAR_TRANSITION_STATE", () => $658117860e846f30$export$fbef743040b68312);
$parcel$export(module.exports, "clearTransitionState", () => $658117860e846f30$export$5643948e01640c7);
$parcel$export(module.exports, "EXTEND_ISSUES", () => $658117860e846f30$export$acec6bb3a5a13008);
$parcel$export(module.exports, "extendIssues", () => $658117860e846f30$export$5c46d88adae7253a);
$parcel$export(module.exports, "REMOVE_ISSUE", () => $658117860e846f30$export$dfe0d1d38e6d3bc8);
$parcel$export(module.exports, "removeIssue", () => $658117860e846f30$export$ff1397fe6a062d34);
$parcel$export(module.exports, "REMOVE_ISSUES", () => $658117860e846f30$export$1311cc4749d2adfa);
$parcel$export(module.exports, "removeIssues", () => $658117860e846f30$export$d26ebabba061649);
$parcel$export(module.exports, "ATTEMPT_REMOVE_ISSUE", () => $658117860e846f30$export$56031d1f1d2d8da3);
$parcel$export(module.exports, "attemptRemoveIssue", () => $658117860e846f30$export$878526d4c3e30e41);
$parcel$export(module.exports, "INSERT_ISSUE", () => $658117860e846f30$export$6d969e379686bfb9);
$parcel$export(module.exports, "insertIssue", () => $658117860e846f30$export$e392a0a52e0da7ef);
$parcel$export(module.exports, "CREATE_ISSUE", () => $658117860e846f30$export$a84692caf5a334ea);
$parcel$export(module.exports, "createAndPersistIssue", () => $658117860e846f30$export$8f908b487df336a4);
$parcel$export(module.exports, "UPDATE_ISSUE", () => $658117860e846f30$export$d46fd8e9a2a59b28);
$parcel$export(module.exports, "updateAndPersistIssue", () => $658117860e846f30$export$1a1d5fb1c9f2f724);
$parcel$export(module.exports, "updateAndPersistIssueWithoutSprintScopeCheck", () => $658117860e846f30$export$d9b76e68436e3b0a);
$parcel$export(module.exports, "SCHEDULE_ISSUES", () => $658117860e846f30$export$2f2764f1900fe93f);
$parcel$export(module.exports, "scheduleIssues", () => $658117860e846f30$export$d94e003b0e92f34d);
$parcel$export(module.exports, "REPLACE_ISSUE", () => $658117860e846f30$export$cfc29e47c9ddc12f);
$parcel$export(module.exports, "replaceIssue", () => $658117860e846f30$export$d1422f3889d29bc7);
$parcel$export(module.exports, "RELOAD_ISSUE", () => $658117860e846f30$export$4b88b0c6284a01e1);
$parcel$export(module.exports, "reload", () => $658117860e846f30$export$32da5b5043dcd88c);
$parcel$export(module.exports, "RANK_ISSUE", () => $658117860e846f30$export$9bbbeac0bf5bf14);
$parcel$export(module.exports, "rankIssue", () => $658117860e846f30$export$dbff149eb80fd116);
$parcel$export(module.exports, "ATTEMPT_RANK_ISSUE", () => $658117860e846f30$export$3b83ef841bccf5d5);
$parcel$export(module.exports, "attemptRankIssue", () => $658117860e846f30$export$79c072ab6e632f2b);
$parcel$export(module.exports, "UPDATE_RANK_ISSUE", () => $658117860e846f30$export$621a7ebb8de5fe23);
$parcel$export(module.exports, "updateAndRankAndPersistIssue", () => $658117860e846f30$export$126321c7035ddbf1);
$parcel$export(module.exports, "CREATE_DEPENDENCY", () => $658117860e846f30$export$69ea00e5fa233007);
$parcel$export(module.exports, "createDependency", () => $658117860e846f30$export$952ad7810a0f4e91);
$parcel$export(module.exports, "ADD_DEPENDENCY", () => $658117860e846f30$export$9a7f264b868961c1);
$parcel$export(module.exports, "addDependency", () => $658117860e846f30$export$2ff5bfa5e70abb1);
$parcel$export(module.exports, "DELETE_DEPENDENCY", () => $658117860e846f30$export$ec9e6de72498e3ce);
$parcel$export(module.exports, "deleteDependency", () => $658117860e846f30$export$d68ff131ad0917e4);
$parcel$export(module.exports, "REMOVE_DEPENDENCY", () => $658117860e846f30$export$3b9bd127b2360780);
$parcel$export(module.exports, "removeDependency", () => $658117860e846f30$export$d532b99b7da25b72);
$parcel$export(module.exports, "UPDATE_ISSUES_SEQUENCE", () => $658117860e846f30$export$e9eeeb115921df74);
$parcel$export(module.exports, "updateIssuesSequence", () => $658117860e846f30$export$4fa10774905ad67c);
$parcel$export(module.exports, "UPDATE_ISSUES_HASH_AND_SEQUENCE", () => $658117860e846f30$export$606616912159e339);
$parcel$export(module.exports, "updateIssuesHashAndSequence", () => $658117860e846f30$export$80537863405b2ccf);
$parcel$export(module.exports, "GLOBAL_ISSUE_CREATE", () => $658117860e846f30$export$49d57bef9ac2550b);
$parcel$export(module.exports, "globalIssueCreate", () => $658117860e846f30$export$aa9ce723b504431);
const $658117860e846f30$export$8b2e719778c50595 = 'state.entities.issues.RESET_TRANSITION_STATE';
const $658117860e846f30$export$3e3a419ce534070d = (payload)=>({
        type: $658117860e846f30$export$8b2e719778c50595,
        payload: payload
    });
const $658117860e846f30$export$fbef743040b68312 = 'state.entities.issues.CLEAR_TRANSITION_STATE';
const $658117860e846f30$export$5643948e01640c7 = (payload, caller)=>({
        type: $658117860e846f30$export$fbef743040b68312,
        payload: payload,
        ...caller ? {
            meta: {
                caller: caller
            }
        } : {}
    });
const $658117860e846f30$export$acec6bb3a5a13008 = 'state.entities.issues.EXTEND_ISSUES';
const $658117860e846f30$export$5c46d88adae7253a = (payload, caller)=>({
        type: $658117860e846f30$export$acec6bb3a5a13008,
        payload: payload,
        ...caller ? {
            meta: {
                caller: caller
            }
        } : {}
    });
const $658117860e846f30$export$dfe0d1d38e6d3bc8 = 'state.entities.issues.REMOVE_ISSUE';
const $658117860e846f30$export$ff1397fe6a062d34 = (payload)=>({
        type: $658117860e846f30$export$dfe0d1d38e6d3bc8,
        payload: payload
    });
const $658117860e846f30$export$1311cc4749d2adfa = 'state.entities.issues.REMOVE_ISSUES';
const $658117860e846f30$export$d26ebabba061649 = (payload)=>({
        type: $658117860e846f30$export$1311cc4749d2adfa,
        payload: payload
    });
const $658117860e846f30$export$56031d1f1d2d8da3 = 'state.entities.issues.ATTEMPT_REMOVE_ISSUE';
const $658117860e846f30$export$878526d4c3e30e41 = (payload)=>({
        type: $658117860e846f30$export$56031d1f1d2d8da3,
        payload: payload
    });
const $658117860e846f30$export$6d969e379686bfb9 = 'state.entities.issues.INSERT_ISSUE';
const $658117860e846f30$export$e392a0a52e0da7ef = (payload)=>({
        type: $658117860e846f30$export$6d969e379686bfb9,
        payload: payload
    });
const $658117860e846f30$export$a84692caf5a334ea = 'state.entities.issues.CREATE_ISSUE';
const $658117860e846f30$export$8f908b487df336a4 = (payload, meta)=>({
        type: $658117860e846f30$export$a84692caf5a334ea,
        payload: payload,
        meta: {
            resetCreateItemAnchor: meta.resetCreateItemAnchor,
            analyticsEvent: meta.analyticsEvent
        }
    });
const $658117860e846f30$export$d46fd8e9a2a59b28 = 'state.entities.issues.UPDATE_ISSUE';
const $658117860e846f30$export$1a1d5fb1c9f2f724 = (id, properties, event, meta)=>({
        type: $658117860e846f30$export$d46fd8e9a2a59b28,
        payload: {
            id: id,
            properties: properties
        },
        meta: {
            analyticsEvent: event,
            bypassSprintScopeCheck: false,
            isDragged: !!meta?.isDragged,
            hasOverdueReleaseDate: meta?.hasOverdueReleaseDate
        }
    });
const $658117860e846f30$export$d9b76e68436e3b0a = (id, properties, event, hasOverdueReleaseDate)=>({
        type: $658117860e846f30$export$d46fd8e9a2a59b28,
        payload: {
            id: id,
            properties: properties
        },
        meta: {
            analyticsEvent: event,
            bypassSprintScopeCheck: true,
            hasOverdueReleaseDate: hasOverdueReleaseDate
        }
    });
const $658117860e846f30$export$2f2764f1900fe93f = 'state.entities.issues.SCHEDULE_ISSUES';
const $658117860e846f30$export$d94e003b0e92f34d = (issueScheduleFields, event, hasOverdueReleaseDate)=>({
        type: $658117860e846f30$export$2f2764f1900fe93f,
        payload: {
            issueScheduleFields: issueScheduleFields
        },
        meta: {
            analyticsEvent: event,
            hasOverdueReleaseDate: hasOverdueReleaseDate
        }
    });
const $658117860e846f30$export$cfc29e47c9ddc12f = 'state.entities.issues.REPLACE_ISSUE';
const $658117860e846f30$export$d1422f3889d29bc7 = (payload, caller)=>({
        type: $658117860e846f30$export$cfc29e47c9ddc12f,
        payload: payload,
        ...caller ? {
            meta: {
                caller: caller
            }
        } : {}
    });
const $658117860e846f30$export$4b88b0c6284a01e1 = 'state.entities.issues.RELOAD_ISSUE';
const $658117860e846f30$export$32da5b5043dcd88c = (event)=>({
        type: $658117860e846f30$export$4b88b0c6284a01e1,
        payload: event
    });
const $658117860e846f30$export$9bbbeac0bf5bf14 = 'state.entities.issues.RANK_ISSUE';
const $658117860e846f30$export$dbff149eb80fd116 = (payload, analyticsEvent)=>({
        type: $658117860e846f30$export$9bbbeac0bf5bf14,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $658117860e846f30$export$3b83ef841bccf5d5 = 'state.entities.issues.ATTEMPT_RANK_ISSUE';
const $658117860e846f30$export$79c072ab6e632f2b = (payload, analyticsEvent)=>({
        type: $658117860e846f30$export$3b83ef841bccf5d5,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $658117860e846f30$export$621a7ebb8de5fe23 = 'state.entities.issues.UPDATE_RANK_ISSUE';
const $658117860e846f30$export$126321c7035ddbf1 = (payload, event)=>({
        type: $658117860e846f30$export$621a7ebb8de5fe23,
        payload: payload,
        meta: {
            analyticsEvent: event
        }
    });
const $658117860e846f30$export$69ea00e5fa233007 = 'state.entities.issues.CREATE_DEPENDENCY';
const $658117860e846f30$export$952ad7810a0f4e91 = (payload, analyticsEvent)=>({
        type: $658117860e846f30$export$69ea00e5fa233007,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $658117860e846f30$export$9a7f264b868961c1 = 'state.entities.issues.ADD_DEPENDENCY';
const $658117860e846f30$export$2ff5bfa5e70abb1 = (payload)=>({
        type: $658117860e846f30$export$9a7f264b868961c1,
        payload: payload
    });
const $658117860e846f30$export$ec9e6de72498e3ce = 'state.entities.issues.DELETE_DEPENDENCY';
const $658117860e846f30$export$d68ff131ad0917e4 = (payload)=>({
        type: $658117860e846f30$export$ec9e6de72498e3ce,
        payload: payload
    });
const $658117860e846f30$export$3b9bd127b2360780 = 'state.entities.issues.REMOVE_DEPENDENCY';
const $658117860e846f30$export$d532b99b7da25b72 = (payload, analyticsEvent)=>({
        type: $658117860e846f30$export$3b9bd127b2360780,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $658117860e846f30$export$e9eeeb115921df74 = 'state.entities.issues.UPDATE_ISSUES_SEQUENCE';
const $658117860e846f30$export$4fa10774905ad67c = (payload)=>({
        type: $658117860e846f30$export$e9eeeb115921df74,
        payload: payload
    });
const $658117860e846f30$export$606616912159e339 = 'state.entities.issues.UPDATE_ISSUES_HASH_AND_SEQUENCE';
const $658117860e846f30$export$80537863405b2ccf = (payload)=>({
        type: $658117860e846f30$export$606616912159e339,
        payload: payload
    });
const $658117860e846f30$export$49d57bef9ac2550b = 'state.entities.issues.GLOBAL_ISSUE_CREATE';
const $658117860e846f30$export$aa9ce723b504431 = (payload)=>({
        type: $658117860e846f30$export$49d57bef9ac2550b,
        payload: payload
    });

});

parcelRegister("1pUKz", function(module, exports) {

$parcel$export(module.exports, "InteractedItemsLimitExceededWithActionsFlag", () => $6718f0defad96523$export$f2e195f794705af0);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");


var $95RcH = parcelRequire("95RcH");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1gs0D = parcelRequire("1gs0D");

var $bDszr = parcelRequire("bDszr");
const $6718f0defad96523$export$f2e195f794705af0 = ({ id: id, issueKey: issueKey, onUndo: onUndo, onPersist: onPersist, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isUndoing = (0, $eUqFw.useRef)(false);
    const handleDismissed = (0, $eUqFw.useCallback)((flagId, analyticsEvent)=>{
        isUndoing.current ? onDismissed?.(flagId, analyticsEvent) : onPersist(flagId, analyticsEvent);
    }, [
        onPersist,
        onDismissed
    ]);
    const handleUndo = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        isUndoing.current = true;
        onUndo(id, analyticsEvent);
        onDismissed?.(id, analyticsEvent);
    }, [
        id,
        onUndo,
        onDismissed
    ]);
    const handlePersist = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        isUndoing.current = false;
        onPersist(id, analyticsEvent);
        onDismissed?.(id, analyticsEvent);
    }, [
        id,
        onPersist,
        onDismissed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95RcH.default), {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
            size: "medium",
            label: ""
        }),
        title: formatMessage((0, $bDszr.default).title, {
            issueKey: issueKey
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $bDszr.default).description,
            values: {
                issueKey: issueKey,
                limit: (0, $1gs0D.INTERACTED_ITEMS_LIMIT),
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
            }
        }),
        onDismissed: handleDismissed,
        actions: [
            {
                content: formatMessage((0, $bDszr.default).undo),
                onClick: handleUndo
            },
            {
                content: formatMessage((0, $bDszr.default).persist),
                onClick: handlePersist
            }
        ]
    });
};

});
parcelRegister("bDszr", function(module, exports) {

$parcel$export(module.exports, "default", () => $387ed08f94b73c3f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $387ed08f94b73c3f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.title",
        "defaultMessage": "Only {issueKey} has been updated"
    },
    description: {
        "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.description",
        "defaultMessage": "<b>{issueKey}</b> has more than {limit} child issues which exceeds the amount that can be updated at one time. Select fewer issues and try again."
    },
    undo: {
        "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.undo",
        "defaultMessage": "Undo change"
    },
    persist: {
        "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.persist",
        "defaultMessage": "Got it"
    }
});

});



parcelRegister("hRLaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9cd612e6f6af2f4$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lgKTA = parcelRequire("lgKTA");

var $ety08 = parcelRequire("ety08");

var $6elnI = parcelRequire("6elnI");

var $kHrWA = parcelRequire("kHrWA");
var $b9cd612e6f6af2f4$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        Description: (0, $lgKTA.isClassic)(state) ? (0, $ety08.default) : (0, $6elnI.default)
    }), {})((0, $kHrWA.default));

});
parcelRegister("ety08", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b097e3dca83d87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caWTK = parcelRequire("caWTK");
const $f3b097e3dca83d87$var$BoardDescription = ({ issueCount: issueCount, issueUrls: issueUrls })=>{
    const messageDescriptor = issueCount === 1 ? (0, $caWTK.default).description : (0, $caWTK.default).descriptionMultipleIssues;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...messageDescriptor,
        values: {
            issueUrls: issueUrls
        }
    });
};
var $f3b097e3dca83d87$export$2e2bcd8739ae039 = $f3b097e3dca83d87$var$BoardDescription;

});
parcelRegister("caWTK", function(module, exports) {

$parcel$export(module.exports, "default", () => $888bea7101ec7602$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $888bea7101ec7602$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.board-description.description",
        "defaultMessage": "Your issue {issueUrls} has been created but is not currently visible because it does not match your board filter."
    },
    descriptionMultipleIssues: {
        "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.board-description.description-multiple-issues",
        "defaultMessage": "Your issues {issueUrls} have been created but are not currently visible because they do not match your board filter."
    }
});

});


parcelRegister("6elnI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd41e892604b88d0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $6ScBO = parcelRequire("6ScBO");
const $fd41e892604b88d0$var$ProjectDescription = ({ issueCount: issueCount, issueUrls: issueUrls })=>{
    const messageDescriptor = issueCount === 1 ? (0, $6ScBO.default).description : (0, $6ScBO.default).descriptionMultipleIssues;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...messageDescriptor,
        values: {
            issueUrls: issueUrls
        }
    });
};
var $fd41e892604b88d0$export$2e2bcd8739ae039 = $fd41e892604b88d0$var$ProjectDescription;

});
parcelRegister("6ScBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $561faabebb19ea04$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $561faabebb19ea04$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.project-description.description",
        "defaultMessage": "Your issue {issueUrls} has been created but is not currently visible because it does not match your project."
    },
    descriptionMultipleIssues: {
        "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.project-description.description-multiple-issues",
        "defaultMessage": "Your issues {issueUrls} have been created but are not currently visible because they do not match your project."
    }
});

});


parcelRegister("kHrWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $052eaf2bb85f1344$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4kMup = parcelRequire("4kMup");

var $95RcH = parcelRequire("95RcH");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $hPDrZ = parcelRequire("hPDrZ");
// eslint-disable-next-line jira/react/no-class-components
class $052eaf2bb85f1344$var$IrrelevantItemCreatedFlag extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    renderIssueUrls() {
        const { issueKeys: issueKeys } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issueKeys.map((issueKey, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: issueKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                href: `/browse/${issueKey}`
            }, issueKey), index < issueKeys.length - 1 && ', ')));
    }
    render() {
        const { id: id, issueKeys: issueKeys, Description: Description, intl: { formatMessage: formatMessage } } = this.props;
        const issueCount = issueKeys.length;
        const issueUrls = this.renderIssueUrls();
        const title = issueCount === 1 ? formatMessage((0, $hPDrZ.default).title) : formatMessage((0, $hPDrZ.default).titleMultipleIssues, {
            issueCount: issueCount
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "irrelevantItemCreated",
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95RcH.default), {
            id: id,
            onDismissed: this.onDismissed,
            title: title,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Description, {
                issueCount: issueCount,
                issueUrls: issueUrls
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
    }
    constructor(...args){
        super(...args);
        this.onDismissed = ()=>{
            const { id: id, onDismissed: onDismissed } = this.props;
            onDismissed(id);
        };
    }
}
var $052eaf2bb85f1344$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($052eaf2bb85f1344$var$IrrelevantItemCreatedFlag);

});
parcelRegister("hPDrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ee4a9706c458c49$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ee4a9706c458c49$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.title",
        "defaultMessage": "Issue created"
    },
    titleMultipleIssues: {
        "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.title-multiple-issues",
        "defaultMessage": "{issueCount} issues created"
    }
});

});



parcelRegister("9sooW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a000cb6084c4111a$export$2e2bcd8739ae039);

var $ldoFd = parcelRequire("ldoFd");

var $lNNXV = parcelRequire("lNNXV");

var $6FeJk = parcelRequire("6FeJk");

var $9ZLrP = parcelRequire("9ZLrP");

var $gdFA6 = parcelRequire("gdFA6");

var $7cApO = parcelRequire("7cApO");

var $7I6L8 = parcelRequire("7I6L8");
const $a000cb6084c4111a$var$mapStateToProps = (state, { ids: ids })=>({
        keys: ids.reduce((acc, id)=>{
            const key = (0, $6FeJk.getIssueKeyById)(state, id);
            !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(key) && acc.push(key);
            return acc;
        }, []),
        isFilterApplied: Object.values((0, $9ZLrP.getIssuesFilter)(state)).some((filter)=>filter.length)
    });
const $a000cb6084c4111a$var$mapDispatchToProps = {
    onViewIssue: (0, $7cApO.setSelectedIssue),
    onClearFilter: (0, $gdFA6.clearFilter)
};
const $a000cb6084c4111a$export$9d1611c77c2fe928 = (stateProps, dispatchProps, { id: id, onDismissed: onDismissed })=>({
        id: id,
        onDismissed: onDismissed,
        ...stateProps,
        ...dispatchProps
    });
var $a000cb6084c4111a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($a000cb6084c4111a$var$mapStateToProps, $a000cb6084c4111a$var$mapDispatchToProps, $a000cb6084c4111a$export$9d1611c77c2fe928)((0, $7I6L8.default));

});
parcelRegister("gdFA6", function(module, exports) {

$parcel$export(module.exports, "SET_TIMELINE_MODE", () => $aeb62b28e9b3d858$export$153dbe77ab644046);
$parcel$export(module.exports, "setTimelineMode", () => $aeb62b28e9b3d858$export$a3936c3a6c7236f0);
$parcel$export(module.exports, "SET_STATUS_CATEGORY_FILTER", () => $aeb62b28e9b3d858$export$3ce13c168d78b996);
$parcel$export(module.exports, "setStatusCategoryFilter", () => $aeb62b28e9b3d858$export$d2a82d7c3461581);
$parcel$export(module.exports, "SET_ISSUE_TYPE_FILTER", () => $aeb62b28e9b3d858$export$9ca69e0c20a04cec);
$parcel$export(module.exports, "setIssueTypeFilter", () => $aeb62b28e9b3d858$export$316476ada8a934d1);
$parcel$export(module.exports, "SET_ASSIGNEE_FILTER", () => $aeb62b28e9b3d858$export$6fe3d1b08c258323);
$parcel$export(module.exports, "setAssigneeFilter", () => $aeb62b28e9b3d858$export$4a2731aa5fc2b425);
$parcel$export(module.exports, "CLEAR_FILTER", () => $aeb62b28e9b3d858$export$80f6e3f69ac5bef4);
$parcel$export(module.exports, "clearFilter", () => $aeb62b28e9b3d858$export$77cedf2a856f1597);
$parcel$export(module.exports, "CLEAR_FILTER_AND_SETTING", () => $aeb62b28e9b3d858$export$af1441bab8ee3960);
$parcel$export(module.exports, "SET_TEXT_FILTER", () => $aeb62b28e9b3d858$export$3ff6c5ed0a39e295);
$parcel$export(module.exports, "setTextFilter", () => $aeb62b28e9b3d858$export$18ecd839459a178a);
$parcel$export(module.exports, "SET_LABEL_FILTER", () => $aeb62b28e9b3d858$export$4bf2768ab3ecfce5);
$parcel$export(module.exports, "setLabelFilter", () => $aeb62b28e9b3d858$export$ade76d88a88a3aed);
$parcel$export(module.exports, "SET_ISSUE_PARENT_FILTER", () => $aeb62b28e9b3d858$export$ddc1d16dbce4b006);
$parcel$export(module.exports, "setIssueParentFilter", () => $aeb62b28e9b3d858$export$e09ef35d0e5d72f3);
$parcel$export(module.exports, "SET_VERSION_FILTER", () => $aeb62b28e9b3d858$export$3e9fc12271dccc0b);
$parcel$export(module.exports, "setVersionFilter", () => $aeb62b28e9b3d858$export$4be540adb4b6f83b);
$parcel$export(module.exports, "SET_COMPONENT_FILTER", () => $aeb62b28e9b3d858$export$3ecce12a664b23bf);
$parcel$export(module.exports, "setComponentFilter", () => $aeb62b28e9b3d858$export$aa22dea8d756557b);
$parcel$export(module.exports, "SET_QUICK_FILTERS_FILTER", () => $aeb62b28e9b3d858$export$866796b9a25fc413);
$parcel$export(module.exports, "setQuickFiltersFilter", () => $aeb62b28e9b3d858$export$2bc4a51983d57990);
$parcel$export(module.exports, "SET_FILTER_CONFIGURATION", () => $aeb62b28e9b3d858$export$be94f667af3087fd);
$parcel$export(module.exports, "setFilterConfiguration", () => $aeb62b28e9b3d858$export$d17290d824a94b8);
$parcel$export(module.exports, "QUICK_FILTERS_REQUEST", () => $aeb62b28e9b3d858$export$6f89cb6c7d158240);
$parcel$export(module.exports, "quickFiltersRequest", () => $aeb62b28e9b3d858$export$638aaa01c7b2c997);
$parcel$export(module.exports, "JQL_FILTERS_SUCCESS", () => $aeb62b28e9b3d858$export$7eb1ce875b31f0be);
$parcel$export(module.exports, "jqlFiltersSuccess", () => $aeb62b28e9b3d858$export$c424cc8a00edb330);
$parcel$export(module.exports, "QUICK_FILTERS_CLEAR", () => $aeb62b28e9b3d858$export$6a0d76c2a8ab6957);
$parcel$export(module.exports, "clearQuickFilters", () => $aeb62b28e9b3d858$export$82a00f19fc766760);
$parcel$export(module.exports, "JQL_FILTERS_REAPPLY", () => $aeb62b28e9b3d858$export$a0d61e9ea4ad5a05);
$parcel$export(module.exports, "reapplyJQLFilters", () => $aeb62b28e9b3d858$export$6dc0831c960fc82c);
$parcel$export(module.exports, "SET_CUSTOM_FILTER", () => $aeb62b28e9b3d858$export$309288e527577ea2);
$parcel$export(module.exports, "setCustomFilter", () => $aeb62b28e9b3d858$export$d0e42db1dc9af930);
$parcel$export(module.exports, "CUSTOM_FILTERS_REQUEST", () => $aeb62b28e9b3d858$export$20195c741d1bb1b4);
$parcel$export(module.exports, "customFiltersRequest", () => $aeb62b28e9b3d858$export$3da18e7e501fd5f8);
$parcel$export(module.exports, "CUSTOM_FILTERS_CLEAR", () => $aeb62b28e9b3d858$export$67b962401e1755ad);
$parcel$export(module.exports, "clearCustomFilters", () => $aeb62b28e9b3d858$export$19fd00e898f244e9);
$parcel$export(module.exports, "SET_GOAL_FILTER", () => $aeb62b28e9b3d858$export$41f9712fbaf4d66b);
$parcel$export(module.exports, "setGoalFilter", () => $aeb62b28e9b3d858$export$70be1709162bf468);
const $aeb62b28e9b3d858$export$153dbe77ab644046 = 'state.ui.filters.SET_TIMELINE_MODE';
const $aeb62b28e9b3d858$export$a3936c3a6c7236f0 = (payload)=>({
        type: $aeb62b28e9b3d858$export$153dbe77ab644046,
        payload: payload
    });
const $aeb62b28e9b3d858$export$3ce13c168d78b996 = 'state.ui.filters.SET_STATUS_CATEGORY_FILTER';
const $aeb62b28e9b3d858$export$d2a82d7c3461581 = (payload)=>({
        type: $aeb62b28e9b3d858$export$3ce13c168d78b996,
        payload: payload
    });
const $aeb62b28e9b3d858$export$9ca69e0c20a04cec = 'state.ui.filters.SET_ISSUE_TYPE_FILTER';
const $aeb62b28e9b3d858$export$316476ada8a934d1 = (payload)=>({
        type: $aeb62b28e9b3d858$export$9ca69e0c20a04cec,
        payload: payload
    });
const $aeb62b28e9b3d858$export$6fe3d1b08c258323 = 'state.ui.filters.SET_ASSIGNEE_FILTER';
const $aeb62b28e9b3d858$export$4a2731aa5fc2b425 = (payload)=>({
        type: $aeb62b28e9b3d858$export$6fe3d1b08c258323,
        payload: payload
    });
const $aeb62b28e9b3d858$export$80f6e3f69ac5bef4 = 'state.ui.filters.CLEAR_FILTER';
const $aeb62b28e9b3d858$export$77cedf2a856f1597 = ()=>({
        type: $aeb62b28e9b3d858$export$80f6e3f69ac5bef4
    });
const $aeb62b28e9b3d858$export$af1441bab8ee3960 = 'state.ui.filters.CLEAR_FILTER_AND_SETTING';
const $aeb62b28e9b3d858$export$fb874fefdc9c2f15 = ()=>({
        type: $aeb62b28e9b3d858$export$af1441bab8ee3960
    });
const $aeb62b28e9b3d858$export$3ff6c5ed0a39e295 = 'state.ui.filters.SET_TEXT_FILTER';
const $aeb62b28e9b3d858$export$18ecd839459a178a = (payload)=>({
        type: $aeb62b28e9b3d858$export$3ff6c5ed0a39e295,
        payload: payload
    });
const $aeb62b28e9b3d858$export$4bf2768ab3ecfce5 = 'state.ui.filters.SET_LABEL_FILTER';
const $aeb62b28e9b3d858$export$ade76d88a88a3aed = (payload)=>({
        type: $aeb62b28e9b3d858$export$4bf2768ab3ecfce5,
        payload: payload
    });
const $aeb62b28e9b3d858$export$ddc1d16dbce4b006 = 'state.ui.filters.SET_ISSUE_PARENT_FILTER';
const $aeb62b28e9b3d858$export$e09ef35d0e5d72f3 = (payload)=>({
        type: $aeb62b28e9b3d858$export$ddc1d16dbce4b006,
        payload: payload
    });
const $aeb62b28e9b3d858$export$3e9fc12271dccc0b = 'state.ui.filters.SET_VERSION_FILTER';
const $aeb62b28e9b3d858$export$4be540adb4b6f83b = (payload)=>({
        type: $aeb62b28e9b3d858$export$3e9fc12271dccc0b,
        payload: payload
    });
const $aeb62b28e9b3d858$export$3ecce12a664b23bf = 'state.ui.filters.SET_COMPONENT_FILTER';
const $aeb62b28e9b3d858$export$aa22dea8d756557b = (payload)=>({
        type: $aeb62b28e9b3d858$export$3ecce12a664b23bf,
        payload: payload
    });
const $aeb62b28e9b3d858$export$866796b9a25fc413 = 'state.ui.filters.SET_QUICK_FILTERS_FILTER';
const $aeb62b28e9b3d858$export$2bc4a51983d57990 = (payload)=>({
        type: $aeb62b28e9b3d858$export$866796b9a25fc413,
        payload: payload
    });
const $aeb62b28e9b3d858$export$be94f667af3087fd = 'state.ui.filters.SET_FILTER_CONFIGURATION';
const $aeb62b28e9b3d858$export$d17290d824a94b8 = (payload)=>({
        type: $aeb62b28e9b3d858$export$be94f667af3087fd,
        payload: payload
    });
const $aeb62b28e9b3d858$export$6f89cb6c7d158240 = 'state.ui.filters.QUICK_FILTERS_REQUEST';
const $aeb62b28e9b3d858$export$638aaa01c7b2c997 = (payload)=>({
        type: $aeb62b28e9b3d858$export$6f89cb6c7d158240,
        payload: payload
    });
const $aeb62b28e9b3d858$export$7eb1ce875b31f0be = 'state.ui.filters.JQL_FILTERS_SUCCESS';
const $aeb62b28e9b3d858$export$c424cc8a00edb330 = (payload)=>({
        type: $aeb62b28e9b3d858$export$7eb1ce875b31f0be,
        payload: payload
    });
const $aeb62b28e9b3d858$export$6a0d76c2a8ab6957 = 'state.ui.filters.QUICK_FILTERS_CLEAR';
const $aeb62b28e9b3d858$export$82a00f19fc766760 = ()=>({
        type: $aeb62b28e9b3d858$export$6a0d76c2a8ab6957
    });
const $aeb62b28e9b3d858$export$a0d61e9ea4ad5a05 = 'state.ui.filters.JQL_FILTERS_REAPPLY';
const $aeb62b28e9b3d858$export$6dc0831c960fc82c = ()=>({
        type: $aeb62b28e9b3d858$export$a0d61e9ea4ad5a05
    });
const $aeb62b28e9b3d858$export$309288e527577ea2 = 'state.ui.filters.SET_CUSTOM_FILTER';
const $aeb62b28e9b3d858$export$d0e42db1dc9af930 = (payload)=>({
        type: $aeb62b28e9b3d858$export$309288e527577ea2,
        payload: payload
    });
const $aeb62b28e9b3d858$export$20195c741d1bb1b4 = 'state.ui.filters.CUSTOM_FILTERS_REQUEST';
const $aeb62b28e9b3d858$export$3da18e7e501fd5f8 = (payload)=>({
        type: $aeb62b28e9b3d858$export$20195c741d1bb1b4,
        payload: payload
    });
const $aeb62b28e9b3d858$export$67b962401e1755ad = 'state.ui.filters.CUSTOM_FILTERS_CLEAR';
const $aeb62b28e9b3d858$export$19fd00e898f244e9 = ()=>({
        type: $aeb62b28e9b3d858$export$67b962401e1755ad
    });
const $aeb62b28e9b3d858$export$41f9712fbaf4d66b = 'state.ui.filters.SET_GOAL_FILTER';
const $aeb62b28e9b3d858$export$70be1709162bf468 = (payload)=>({
        type: $aeb62b28e9b3d858$export$41f9712fbaf4d66b,
        payload: payload
    });

});

parcelRegister("7cApO", function(module, exports) {

$parcel$export(module.exports, "SHOW_PANEL", () => $c105dba1d78ca128$export$938bd55b420c1d30);
$parcel$export(module.exports, "showPanel", () => $c105dba1d78ca128$export$e89c3c9af31c1e3b);
$parcel$export(module.exports, "HIDE_PANEL", () => $c105dba1d78ca128$export$98671e345c4d9c82);
$parcel$export(module.exports, "hidePanel", () => $c105dba1d78ca128$export$3646905057a9ef29);
$parcel$export(module.exports, "SHOW_ISSUE_DETAILS", () => $c105dba1d78ca128$export$f925c7c8f6ccf4a5);
$parcel$export(module.exports, "SET_SELECTED_ISSUE", () => $c105dba1d78ca128$export$799a01fd5c3028a);
$parcel$export(module.exports, "setSelectedIssue", () => $c105dba1d78ca128$export$a7e96ee41f298462);
const $c105dba1d78ca128$export$938bd55b420c1d30 = 'state.ui.panel.SHOW_PANEL';
const $c105dba1d78ca128$export$e89c3c9af31c1e3b = (payload)=>({
        type: $c105dba1d78ca128$export$938bd55b420c1d30,
        payload: payload
    });
const $c105dba1d78ca128$export$98671e345c4d9c82 = 'state.ui.panel.HIDE_PANEL';
const $c105dba1d78ca128$export$3646905057a9ef29 = ()=>({
        type: $c105dba1d78ca128$export$98671e345c4d9c82
    });
const $c105dba1d78ca128$export$f925c7c8f6ccf4a5 = 'state.ui.panel.SHOW_ISSUE_DETAILS';
const $c105dba1d78ca128$export$b248d2709e43857 = (payload)=>({
        type: $c105dba1d78ca128$export$f925c7c8f6ccf4a5,
        payload: payload
    });
const $c105dba1d78ca128$export$799a01fd5c3028a = 'state.ui.panel.SET_SELECTED_ISSUE';
const $c105dba1d78ca128$export$a7e96ee41f298462 = (payload)=>({
        type: $c105dba1d78ca128$export$799a01fd5c3028a,
        payload: payload
    });

});

parcelRegister("7I6L8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2153056ae1e1add$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQ0RL = parcelRequire("kQ0RL");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cDvag = parcelRequire("cDvag");

var $6sl5W = parcelRequire("6sl5W");

var $lrNu5 = parcelRequire("lrNu5");
const $c2153056ae1e1add$var$IssueHiddenFlag = ({ id: id, keys: keys, isFilterApplied: isFilterApplied, onClearFilter: onClearFilter, onViewIssue: onViewIssue, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'issueHiddenFlag'
        }), 'viewed issueHiddenFlag', {
            isStateChangeBasedIssueHiddenFlagsEnabled: (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)()
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const numIssues = keys.length;
    const onClick = numIssues === 1 && onViewIssue ? (e)=>{
        const { ctrlKey: ctrlKey, metaKey: metaKey } = e.nativeEvent;
        if (ctrlKey || metaKey) return;
        e.preventDefault();
        onViewIssue(keys[0]);
    } : undefined;
    const description = numIssues === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        message: formatMessage((0, $6sl5W.default).flagDescriptionWithLink, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: (0, $lrNu5.getIssueUrl)([
                        keys[0]
                    ]),
                    onClick: onClick,
                    target: "_blank"
                }, keys[0])
        }
    }) : formatMessage((0, $6sl5W.default).flagDescription, {
        numIssues: numIssues
    });
    const viewIssueAction = {
        content: formatMessage((0, $6sl5W.default).issueLink, {
            numIssues: numIssues
        }),
        href: (0, $lrNu5.getIssueUrl)(keys),
        onClick: onClick,
        target: '_blank'
    };
    const clearFilterAction = {
        content: formatMessage((0, $6sl5W.default).clearFilter),
        onClick: onClearFilter
    };
    const actions = [];
    if (numIssues > 0) actions.push(viewIssueAction);
    if (isFilterApplied) actions.push(clearFilterAction);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6sl5W.default).title, {
            numIssues: numIssues
        }),
        description: description,
        actions: actions
    });
};
var $c2153056ae1e1add$export$2e2bcd8739ae039 = $c2153056ae1e1add$var$IssueHiddenFlag;

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("cDvag", function(module, exports) {

$parcel$export(module.exports, "isCustomerTemplatesMuseumEnabled", () => $a1aaeab9a2ef6b62$export$c1aca74e2b0051d3);
$parcel$export(module.exports, "isStateChangeBasedIssueHiddenFlagsEnabled", () => $a1aaeab9a2ef6b62$export$534ae8635224ab65);
$parcel$export(module.exports, "isEcClientEventListenerEnabled", () => $a1aaeab9a2ef6b62$export$f04c623593a78ee6);
// DEPRECATED: Add feature flags inline instead of in this file

var $1ybV0 = parcelRequire("1ybV0");
/* Add new FFs under your own "section" to minimise merge conflicts. */ /* Use the prefix "jsw.roadmap*" in your new FF key for it to be picked up in our techops dashboards. */ /* IF your new FF is a boolean type, then define your FF key as a const here. */ // ahuang
// cautexier
// dannesley
// hsu
// jtran
// nsudhir
// wloo
// mkilbane
const $a1aaeab9a2ef6b62$var$UNSUBSCRIBABLE_QUERY = 'jsw.roadmap.unsubscribable-query';
const $a1aaeab9a2ef6b62$var$UNSUBSCRIBABLE_MUTATION = 'jsw.roadmap.unsubscribable-mutation';
const $a1aaeab9a2ef6b62$var$STATE_CHANGE_BASED_ISSUE_HIDDEN_FLAGS = 'jsw.roadmap.state-change-based-issue-hidden-flags';
const $a1aaeab9a2ef6b62$export$341d6308cf969be9 = [
    // ahuang
    // cautexier
    // dannesley
    // hsu
    // jtran
    // kzhang
    // nsudhir
    // wloo
    // mkilbane
    $a1aaeab9a2ef6b62$var$UNSUBSCRIBABLE_QUERY,
    $a1aaeab9a2ef6b62$var$UNSUBSCRIBABLE_MUTATION,
    $a1aaeab9a2ef6b62$var$STATE_CHANGE_BASED_ISSUE_HIDDEN_FLAGS
];
const $a1aaeab9a2ef6b62$export$c1aca74e2b0051d3 = ()=>(0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-2250');
const $a1aaeab9a2ef6b62$export$534ae8635224ab65 = ()=>(0, $1ybV0.ff)('jsw.roadmap.state-change-based-issue-hidden-flags');
const $a1aaeab9a2ef6b62$export$f04c623593a78ee6 = ()=>(0, $1ybV0.ff)('odin.ec.client.integration');

});

parcelRegister("6sl5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c9847539f390eb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b3c9847539f390eb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.issue-hidden.title",
        "defaultMessage": "Changes are saved, but {numIssues, plural, one {issue isn't} other {issues aren't}} visible"
    },
    flagDescriptionWithLink: {
        "id": "roadmap.standard-roadmap.flags.issue-hidden.flag-description-with-link",
        "defaultMessage": "Changes were made to issue {linkStart}{linkEnd}, which is currently hidden on your timeline because of a filter or your view settings."
    },
    flagDescription: {
        "id": "roadmap.standard-roadmap.flags.issue-hidden.flag-description",
        "defaultMessage": "Changes were made to issues currently hidden on your timeline because of a filter or your view settings."
    },
    clearFilter: {
        "id": "roadmap.standard-roadmap.flags.issue-hidden.clear-filter",
        "defaultMessage": "Clear filter"
    },
    issueLink: {
        "id": "roadmap.standard-roadmap.flags.issue-hidden.issue-link",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    }
});

});

parcelRegister("lrNu5", function(module, exports) {

$parcel$export(module.exports, "getIssueUrl", () => $90bd1c1e71568081$export$dcf0cd5cf26c4b27);
const $90bd1c1e71568081$export$dcf0cd5cf26c4b27 = (cardKeys)=>{
    if (cardKeys.length > 1) {
        const issueKeys = cardKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${cardKeys[0]}`;
};

});



parcelRegister("jQzPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $76213847607e2254$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dGdwI = parcelRequire("dGdwI");

var $h6JeT = parcelRequire("h6JeT");
const $76213847607e2254$var$IssueUpdatePermissionFlag = ({ id: id, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const title = formatMessage((0, $h6JeT.default).titleUpdate);
    const description = formatMessage((0, $h6JeT.default).descriptionUpdate);
    const learnMore = formatMessage((0, $h6JeT.default).learnMore);
    const onDismissedCallback = ()=>{
        onDismissed?.(id);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
        onDismissed: onDismissedCallback,
        id: id,
        title: title,
        description: description,
        actions: [
            {
                content: learnMore,
                href: (0, $dGdwI.docs).JIRA_PERMISSIONS_OVERVIEW
            }
        ]
    });
};
$76213847607e2254$var$IssueUpdatePermissionFlag.defaultProps = {
    onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $76213847607e2254$export$2e2bcd8739ae039 = $76213847607e2254$var$IssueUpdatePermissionFlag;

});
parcelRegister("h6JeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b48c7facc18088ca$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b48c7facc18088ca$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    titleUpdate: {
        "id": "roadmap.standard-roadmap.flags.issue-update-permission.title-update",
        "defaultMessage": "We couldn't update your issue"
    },
    descriptionUpdate: {
        "id": "roadmap.standard-roadmap.flags.issue-update-permission.description-update",
        "defaultMessage": "You don't have permission to update this issue. Check your permissions settings or contact your Jira administrator for help."
    },
    learnMore: {
        "id": "roadmap.standard-roadmap.flags.issue-update-permission.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("eZMrP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a041f5eab92b6ac9$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6FeJk = parcelRequire("6FeJk");

var $aSTh4 = parcelRequire("aSTh4");

var $5WbRR = parcelRequire("5WbRR");
var $a041f5eab92b6ac9$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, ownProps)=>({
        issueKey: (0, $6FeJk.getIssueKeyById)(state, ownProps.issueId)
    }), {
    onClearDisplayOption: (0, $aSTh4.clearLevelOneSetting)
}, (stateProps, dispatchProps, ownProps)=>{
    const { issueKey: issueKey } = stateProps;
    const { id: id, onDismissed: onDismissed } = ownProps;
    return {
        ...dispatchProps,
        issueKey: issueKey,
        id: id,
        onDismissed: onDismissed
    };
})((0, $5WbRR.default));

});
parcelRegister("5WbRR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5576b2bfcf0e8115$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $95RcH = parcelRequire("95RcH");

var $8uD7Y = parcelRequire("8uD7Y");

var $4ksts = parcelRequire("4ksts");

var $6tBTL = parcelRequire("6tBTL");
const $5576b2bfcf0e8115$export$89ada5f647983029 = ({ issueKey: issueKey, onDismissed: onDismissed, id: id, onClearDisplayOption: onClearDisplayOption })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const onDismissedCallback = (0, $eUqFw.useCallback)((flagId)=>{
        onDismissed(flagId);
    }, [
        onDismissed
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        onDismissed(id);
        onClearDisplayOption();
    }, [
        onDismissed,
        id,
        onClearDisplayOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95RcH.default), {
        id: id,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $6tBTL.default).title,
            values: {
                issueKey: issueKey,
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
            }
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $6tBTL.default).description,
            values: {
                issueKey: issueKey,
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
            }
        }),
        onDismissed: onDismissedCallback,
        actions: [
            {
                content: formatMessage((0, $6tBTL.default).clearDisplayOption),
                onClick: onClick
            }
        ]
    });
};
$5576b2bfcf0e8115$export$89ada5f647983029.defaultProps = {
    onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $5576b2bfcf0e8115$export$2e2bcd8739ae039 = $5576b2bfcf0e8115$export$89ada5f647983029;

});
parcelRegister("6tBTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cbb836c972357bb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1cbb836c972357bb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.item-disappears-from-display-range.title",
        "defaultMessage": "<b>{issueKey}</b> is hidden from your plan"
    },
    description: {
        "id": "roadmap.standard-roadmap.flags.item-disappears-from-display-range.description",
        "defaultMessage": "<b>{issueKey}</b> is outside the visible date range of your plan. To view it, clear your issue display range settings."
    },
    clearDisplayOption: {
        "id": "roadmap.standard-roadmap.flags.item-disappears-from-display-range.clear-display-option",
        "defaultMessage": "Clear issue display range settings"
    }
});

});



parcelRegister("9NYwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $53632e447f7ec4e3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bwVWW = parcelRequire("bwVWW");

var $hsC0U = parcelRequire("hsC0U");
var $53632e447f7ec4e3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        isAdmin: (0, $bwVWW.hasAdministerProjectPermission)(state) || (0, $bwVWW.getIsUserBoardAdmin)(state)
    }), {})((0, $hsC0U.default));

});
parcelRegister("hsC0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $25bec64d5285973b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $82rJa = parcelRequire("82rJa");

var $giAhk = parcelRequire("giAhk");

var $7gXAj = parcelRequire("7gXAj");

var $eFTts = parcelRequire("eFTts");
class $25bec64d5285973b$export$321f8e7a5f776e25 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    getContent() {
        const { isAdmin: isAdmin, boardId: boardId, intl: { formatMessage: formatMessage } } = this.props;
        if (isAdmin) return {
            description: formatMessage((0, $eFTts.default).description),
            actions: [
                {
                    content: formatMessage((0, $eFTts.default).showJqlFilterForBoard),
                    href: (0, $7gXAj.getEditFilterUrl)(boardId)
                }
            ]
        };
        return {
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $eFTts.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), formatMessage((0, $eFTts.default).contactAdmin))
        };
    }
    render() {
        const { id: id, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
            id: id,
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            isAutoDismiss: true,
            onDismissed: this.onDismissed,
            title: formatMessage((0, $eFTts.default).title),
            ...this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.onDismissed = ()=>{
            const { id: id, onDismissed: onDismissed } = this.props;
            onDismissed(id);
        };
    }
}
var $25bec64d5285973b$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($25bec64d5285973b$export$321f8e7a5f776e25);

});
parcelRegister("82rJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8bd85b08cb5610$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$9c8bd85b08cb5610$export$2e2bcd8739ae039 = (0, $kQ0RL.WarningFlag);

});

parcelRegister("7gXAj", function(module, exports) {

$parcel$export(module.exports, "getEditFilterUrl", () => $ab4d0a9a293df00b$export$4a8805dc45e0d1a2);
const $ab4d0a9a293df00b$export$4a8805dc45e0d1a2 = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}&config=filter`;

});

parcelRegister("eFTts", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b068fc0bdce6d08$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5b068fc0bdce6d08$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.rank-disabled.title",
        "defaultMessage": "Ranking is disabled"
    },
    description: {
        "id": "roadmap.standard-roadmap.flags.rank-disabled.description",
        "defaultMessage": "Ranking is disabled, as the Filter Query for this board is not ordered by ascending Rank."
    },
    contactAdmin: {
        "id": "roadmap.standard-roadmap.flags.rank-disabled.contact-admin",
        "defaultMessage": "Contact your admin to adjust the board filter."
    },
    showJqlFilterForBoard: {
        "id": "roadmap.standard-roadmap.flags.rank-disabled.show-jql-filter-for-board",
        "defaultMessage": "Please check your filter configuration"
    }
});

});



parcelRegister("fJP86", function(module, exports) {

$parcel$export(module.exports, "default", () => $11af2381ea594663$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");


var $kbyLF = parcelRequire("kbyLF");

var $llb1k = parcelRequire("llb1k");
const $11af2381ea594663$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onPersist: ()=>{
            dispatch((0, $j45xj.updateAndPersistIssueWithoutSprintScopeCheck)(ownProps.issueId, ownProps.properties, ownProps.sourceEvent, ownProps.hasOverdueReleaseDate));
        },
        onUndo: ()=>{
            dispatch((0, $j45xj.resetTransitionState)({
                issueId: ownProps.issueId,
                transitionId: ownProps.transitionId
            }));
        }
    });
const $11af2381ea594663$var$ConnectedFlag = (0, $lNNXV.connect)((state, ownProps)=>({
        issueKey: (0, $6FeJk.getIssueKeyById)(state, ownProps.issueId),
        changedSprintName: (0, $kbyLF.getSprintName)(state)(ownProps.direction === (0, $34b1b2b25acc1092$export$11ee87f991dd6574) ? ownProps.targetSprintId : ownProps.sourceSprintId)
    }), $11af2381ea594663$var$mapDispatchToProps, (stateProps, dispatchProps, ownProps)=>{
    const { issueKey: issueKey, changedSprintName: changedSprintName } = stateProps;
    const { id: id, direction: direction, onDismissed: onDismissed } = ownProps;
    return {
        ...dispatchProps,
        issueKey: issueKey,
        id: id,
        changedSprintName: changedSprintName,
        direction: direction,
        onDismissed: onDismissed
    };
})((0, $llb1k.default));
var $11af2381ea594663$export$2e2bcd8739ae039 = $11af2381ea594663$var$ConnectedFlag;

});
const $34b1b2b25acc1092$export$11ee87f991dd6574 = 'ASSIGN';
const $34b1b2b25acc1092$export$be2c0bb3425b849c = 'UNASSIGN';

parcelRegister("kbyLF", function(module, exports) {

$parcel$export(module.exports, "createGetIntersectingSprintId", () => $f094bc48530775a5$export$31abdd665c32a9d3);
$parcel$export(module.exports, "getSprintState", () => $f094bc48530775a5$export$9cbf48c04feaac07);
$parcel$export(module.exports, "getSprintName", () => $f094bc48530775a5$export$3df6198cde5435f9);
$parcel$export(module.exports, "getSanitisedIssueSprintsHash", () => $f094bc48530775a5$export$7ace1dbeb1bd9b20);
$parcel$export(module.exports, "getCurrentlyAssignedSprints", () => $f094bc48530775a5$export$c1e6c915824951b6);
$parcel$export(module.exports, "getIsCurrentlyAssignedToSprints", () => $f094bc48530775a5$export$2f4a726669194a00);
$parcel$export(module.exports, "createGetIssueSprintDates", () => $f094bc48530775a5$export$ed6951d58e67f638);
$parcel$export(module.exports, "getSprintIntervals", () => $f094bc48530775a5$export$acb5f9893119b5b6);

var $df4Sl = parcelRequire("df4Sl");

var $jtx35 = parcelRequire("jtx35");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $dpcYO = parcelRequire("dpcYO");

var $KrzmK = parcelRequire("KrzmK");
const $f094bc48530775a5$export$4b81aebbd933400f = (0, $df4Sl.createSelector)((0, $bwVWW.getSprints), (0, $KrzmK.createGetSanitizedSprints));
const $f094bc48530775a5$export$9328442a7d4e1089 = (0, $df4Sl.createSelector)((0, $bwVWW.getSprints), (0, $KrzmK.getSprintsHash));
const $f094bc48530775a5$export$31abdd665c32a9d3 = (0, $df4Sl.createSelector)((0, $dpcYO.getTimelineDuration), $f094bc48530775a5$export$4b81aebbd933400f, (0, $KrzmK.createGetIntersectingSprintId));
const $f094bc48530775a5$export$9cbf48c04feaac07 = (0, $df4Sl.createSelector)($f094bc48530775a5$export$9328442a7d4e1089, (0, $KrzmK.getSprintState));
const $f094bc48530775a5$export$3df6198cde5435f9 = (0, $df4Sl.createSelector)($f094bc48530775a5$export$9328442a7d4e1089, (0, $KrzmK.getSprintName));
const $f094bc48530775a5$export$7ace1dbeb1bd9b20 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueSprintIdsHash), $f094bc48530775a5$export$9328442a7d4e1089, (0, $KrzmK.getSanitisedIssueSprintsHash));
const $f094bc48530775a5$export$c1e6c915824951b6 = (0, $df4Sl.createSelector)($f094bc48530775a5$export$7ace1dbeb1bd9b20, (0, $KrzmK.getCurrentlyAssignedSprints));
const $f094bc48530775a5$export$2f4a726669194a00 = (state, id)=>$f094bc48530775a5$export$c1e6c915824951b6(state)(id).length > 0;
const $f094bc48530775a5$export$4198a074ed17eba2 = (0, $df4Sl.createSelector)($f094bc48530775a5$export$7ace1dbeb1bd9b20, (issueIdToSprints)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(issueIdToSprints).reduce((acc, key)=>{
        const issueId = key;
        if (issueIdToSprints[issueId].length > 0) acc[`${issueId}`] = issueIdToSprints[issueId].map((sprint)=>sprint.id);
        return acc;
    }, {}));
const $f094bc48530775a5$export$abdb1a5f7673f188 = (0, $jtx35.createSelectorWithDefaultEqual)($f094bc48530775a5$export$4198a074ed17eba2, (0, $KrzmK.createGetMostRecentSprintId));
const $f094bc48530775a5$export$ed6951d58e67f638 = (0, $df4Sl.createSelector)($f094bc48530775a5$export$9328442a7d4e1089, $f094bc48530775a5$export$abdb1a5f7673f188, (sprintsHash, getMostRecentSprintId)=>(issueId)=>{
        const sprintId = getMostRecentSprintId(issueId);
        if (sprintId !== undefined) {
            const sprint = sprintsHash[sprintId];
            return {
                inferredStartDate: sprint.startDate,
                inferredEndDate: sprint.endDate
            };
        }
        return {
            inferredStartDate: undefined,
            inferredEndDate: undefined
        };
    });
const $f094bc48530775a5$export$acb5f9893119b5b6 = (0, $df4Sl.createSelector)((0, $bwVWW.getSprints), (0, $KrzmK.getSprintIntervals));

});
parcelRegister("dpcYO", function(module, exports) {

$parcel$export(module.exports, "getTimelineDuration", () => $a0e9863e9981b48b$export$815b68ba93fb8347);
$parcel$export(module.exports, "getTimelineOrigin", () => $a0e9863e9981b48b$export$173b9ad47017bbd3);
$parcel$export(module.exports, "getMinTimelineDateRange", () => $a0e9863e9981b48b$export$46a0793d67bcbd40);

var $df4Sl = parcelRequire("df4Sl");

var $c3IKH = parcelRequire("c3IKH");

var $1QJt8 = parcelRequire("1QJt8");

var $25Ymt = parcelRequire("25Ymt");

var $bwVWW = parcelRequire("bwVWW");

var $9ZLrP = parcelRequire("9ZLrP");
const $a0e9863e9981b48b$export$815b68ba93fb8347 = (0, $df4Sl.createSelector)((0, $bwVWW.getToday), (0, $9ZLrP.getTimelineMode), (today, timelineMode)=>(0, $25Ymt.getTimelineDurationFromDate)(timelineMode, today));
const $a0e9863e9981b48b$export$173b9ad47017bbd3 = (0, $df4Sl.createSelector)((0, $bwVWW.getToday), (0, $9ZLrP.getTimelineMode), (today, timelineMode)=>(0, $25Ymt.getTimelineOriginForToday)(today, timelineMode));
const $a0e9863e9981b48b$export$46a0793d67bcbd40 = (0, $df4Sl.createSelector)((0, $9ZLrP.getTimelineMode), $a0e9863e9981b48b$export$815b68ba93fb8347, (timelineMode, { totalMilliseconds: totalMilliseconds })=>{
    const timelineWidth = (0, $1QJt8.getTimelineWidth)(timelineMode, totalMilliseconds);
    return Math.ceil((0, $c3IKH.MINIMUM_BAR_LENGTH) / timelineWidth * totalMilliseconds);
});

});
parcelRegister("c3IKH", function(module, exports) {

$parcel$export(module.exports, "BAR_HEIGHT", () => $ce33e285ef462695$export$4f2f40eb3120c);
$parcel$export(module.exports, "BASE_BAR_HEIGHT", () => $ce33e285ef462695$export$c8c47b136dc7ac05);
$parcel$export(module.exports, "MINIMUM_BAR_LENGTH", () => $ce33e285ef462695$export$729e677ca5ac2f4f);
$parcel$export(module.exports, "DEFAULT_BORDER_RADIUS", () => $ce33e285ef462695$export$f2926bd20425bb0d);
$parcel$export(module.exports, "LEFT_PLACEHOLDER_BORDER_RADIUS", () => $ce33e285ef462695$export$df860cf23132dfbb);
$parcel$export(module.exports, "RIGHT_PLACEHOLDER_BORDER_RADIUS", () => $ce33e285ef462695$export$a822ec327ef716a4);
$parcel$export(module.exports, "LEFT_AND_RIGHT_PLACEHOLDER_BORDER_RADIUS", () => $ce33e285ef462695$export$5b9db862a15e1457);
$parcel$export(module.exports, "START_DATE_PLACEHOLDER", () => $ce33e285ef462695$export$cfcf3497a5711f2c);
$parcel$export(module.exports, "DUE_DATE_PLACEHOLDER", () => $ce33e285ef462695$export$42702a43f0325a0c);
$parcel$export(module.exports, "START_AND_DUE_DATE_PLACEHOLDER", () => $ce33e285ef462695$export$1b72784d953fe9b3);

var $c9TLT = parcelRequire("c9TLT");
const $ce33e285ef462695$export$4f2f40eb3120c = (0, $c9TLT.gridSize) * 3;
const $ce33e285ef462695$export$c8c47b136dc7ac05 = (0, $c9TLT.gridSize) * 2.5;
const $ce33e285ef462695$export$729e677ca5ac2f4f = 36;
const $ce33e285ef462695$export$f2926bd20425bb0d = `${(0, $c9TLT.borderRadius)}px`;
const $ce33e285ef462695$export$deb313264d4a6a20 = `${(0, $c9TLT.borderRadius) * 3}px`;
const $ce33e285ef462695$export$df860cf23132dfbb = `${$ce33e285ef462695$export$deb313264d4a6a20} ${$ce33e285ef462695$export$f2926bd20425bb0d} ${$ce33e285ef462695$export$f2926bd20425bb0d} ${$ce33e285ef462695$export$deb313264d4a6a20}`;
const $ce33e285ef462695$export$a822ec327ef716a4 = `${$ce33e285ef462695$export$f2926bd20425bb0d} ${$ce33e285ef462695$export$deb313264d4a6a20} ${$ce33e285ef462695$export$deb313264d4a6a20} ${$ce33e285ef462695$export$f2926bd20425bb0d}`;
const $ce33e285ef462695$export$5b9db862a15e1457 = `${$ce33e285ef462695$export$deb313264d4a6a20}`;
const $ce33e285ef462695$export$cfcf3497a5711f2c = 'START_DATE_PLACEHOLDER';
const $ce33e285ef462695$export$42702a43f0325a0c = 'DUE_DATE_PLACEHOLDER';
const $ce33e285ef462695$export$1b72784d953fe9b3 = 'START_AND_DUE_DATE_PLACEHOLDER';

});

parcelRegister("1QJt8", function(module, exports) {

$parcel$export(module.exports, "getTimelineWidth", () => $c56c41b2f09e0567$export$87113eddf3515c00);
$parcel$export(module.exports, "getTimelinePositionFromDate", () => $c56c41b2f09e0567$export$3d733aa4507a88f8);
$parcel$export(module.exports, "getDateFromTimelinePosition", () => $c56c41b2f09e0567$export$2dd9c7d371d81aa3);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

var $gf0vG = parcelRequire("gf0vG");
// Size in pixels a column should ideally represent for any timeline mode
const $c56c41b2f09e0567$var$COLUMN_BASELINE = 255;
const $c56c41b2f09e0567$export$893f7447303d5bc0 = {
    [(0, $gf0vG.WEEKS)]: $c56c41b2f09e0567$var$COLUMN_BASELINE / (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).duration(7, 'day').asMilliseconds(),
    [(0, $gf0vG.MONTHS)]: $c56c41b2f09e0567$var$COLUMN_BASELINE / (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).duration(30, 'day').asMilliseconds(),
    [(0, $gf0vG.QUARTERS)]: $c56c41b2f09e0567$var$COLUMN_BASELINE / (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).duration(91, 'day').asMilliseconds()
};
const $c56c41b2f09e0567$export$87113eddf3515c00 = (0, $5iWql.default)((timelineMode, totalDuration)=>Math.round(totalDuration * $c56c41b2f09e0567$export$893f7447303d5bc0[timelineMode]));
const $c56c41b2f09e0567$export$3d733aa4507a88f8 = ({ startMilliseconds: startMilliseconds, totalMilliseconds: totalMilliseconds }, timelineWidth, date)=>timelineWidth * ((date - startMilliseconds) / totalMilliseconds);
const $c56c41b2f09e0567$export$2dd9c7d371d81aa3 = ({ startMilliseconds: startMilliseconds, totalMilliseconds: totalMilliseconds }, timelineWidth, position)=>Math.round(startMilliseconds + position / timelineWidth * totalMilliseconds);

});
parcelRegister("jJwwt", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});


parcelRegister("25Ymt", function(module, exports) {

$parcel$export(module.exports, "getTimelineDurationFromDate", () => $a5219a4c66752b37$export$844e598264c96110);
$parcel$export(module.exports, "getTimelineOriginForToday", () => $a5219a4c66752b37$export$afef567e98d0d2bb);
$parcel$export(module.exports, "getDefaultTimelinePositionFromDate", () => $a5219a4c66752b37$export$96eeb91a52b83f6d);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

var $gf0vG = parcelRequire("gf0vG");

var $1QJt8 = parcelRequire("1QJt8");
const $a5219a4c66752b37$export$844e598264c96110 = (0, $5iWql.default)((timelineMode, date)=>{
    let startMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).subtract(1, 'year');
    let endMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).add(2, 'year');
    if (timelineMode === (0, $gf0vG.QUARTERS)) {
        startMoment = startMoment.startOf('quarter');
        endMoment = endMoment.endOf('quarter');
    } else if (timelineMode === (0, $gf0vG.MONTHS)) {
        startMoment = startMoment.startOf('month');
        endMoment = endMoment.endOf('month');
    } else {
        /* We are using ISO week to match column calculations.
			 * See getColumnDurations below for additional info.
			 */ startMoment = startMoment.startOf('isoWeek');
        endMoment = endMoment.endOf('isoWeek');
    }
    return {
        startMilliseconds: startMoment.valueOf(),
        endMilliseconds: endMoment.valueOf(),
        totalMilliseconds: endMoment.diff(startMoment, 'milliseconds')
    };
});
const $a5219a4c66752b37$export$afef567e98d0d2bb = (0, $5iWql.default)((today, timelineMode)=>{
    const todayMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today);
    if (timelineMode === (0, $gf0vG.QUARTERS)) return todayMoment.startOf('quarter').subtract(45, 'days').valueOf();
    if (timelineMode === (0, $gf0vG.MONTHS)) return todayMoment.startOf('month').subtract(15, 'days').valueOf();
    return todayMoment.startOf('isoWeek').subtract(4, 'days').valueOf();
});
const $a5219a4c66752b37$export$96eeb91a52b83f6d = (0, $5iWql.default)((date, timelineMode, timelineDuration)=>{
    const millisecondPosition = $a5219a4c66752b37$export$afef567e98d0d2bb(date, timelineMode);
    const relativePosition = (millisecondPosition - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds;
    return relativePosition * (0, $1QJt8.getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds);
});

});


parcelRegister("KrzmK", function(module, exports) {

$parcel$export(module.exports, "getSprintsHash", () => $f7b3979a2b953c6b$export$9328442a7d4e1089);
$parcel$export(module.exports, "getSprintIntervals", () => $f7b3979a2b953c6b$export$acb5f9893119b5b6);
$parcel$export(module.exports, "createGetSanitizedSprints", () => $f7b3979a2b953c6b$export$4b81aebbd933400f);
$parcel$export(module.exports, "createGetIntersectingSprintId", () => $f7b3979a2b953c6b$export$31abdd665c32a9d3);
$parcel$export(module.exports, "getSprintName", () => $f7b3979a2b953c6b$export$3df6198cde5435f9);
$parcel$export(module.exports, "getSprintState", () => $f7b3979a2b953c6b$export$9cbf48c04feaac07);
$parcel$export(module.exports, "createGetMostRecentSprintId", () => $f7b3979a2b953c6b$export$abdb1a5f7673f188);
$parcel$export(module.exports, "getSanitisedIssueSprintsHash", () => $f7b3979a2b953c6b$export$7ace1dbeb1bd9b20);
$parcel$export(module.exports, "getCurrentlyAssignedSprints", () => $f7b3979a2b953c6b$export$c1e6c915824951b6);

var $5iWql = parcelRequire("5iWql");


var $fHtBB = parcelRequire("fHtBB");

var $26s3n = parcelRequire("26s3n");

var $kkQUz = parcelRequire("kkQUz");
const $f7b3979a2b953c6b$var$withAdjustedSprintDates = (sprints)=>sprints.map((sprint)=>({
            id: sprint.id,
            name: sprint.name,
            state: sprint.state,
            startDate: Math.min(sprint.startDate, sprint.endDate),
            endDate: Math.max(sprint.startDate, sprint.endDate)
        }));
const $f7b3979a2b953c6b$export$9328442a7d4e1089 = (sprints)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $f7b3979a2b953c6b$var$withAdjustedSprintDates(sprints).reduce((acc, sprint)=>{
        acc[`${sprint.id}`] = sprint;
        return acc;
    }, {});
const $f7b3979a2b953c6b$export$acb5f9893119b5b6 = (sprints)=>sprints.map(({ id: id, name: name, state: state, startDate: startDate, endDate: endDate })=>({
            id: String(id),
            name: name,
            state: state,
            startDate: startDate,
            endDate: endDate
        }));
const $f7b3979a2b953c6b$export$4b81aebbd933400f = (sprints)=>(0, $5iWql.default)((timelineDuration)=>sprints.map((sprint)=>({
                id: sprint.id,
                name: sprint.name,
                state: sprint.state,
                startDate: Math.min(sprint.startDate, sprint.endDate),
                endDate: Math.max(sprint.startDate, sprint.endDate) + (0, $fHtBB.DUE_DATE_OFFSET)
            })).filter((sprint)=>sprint.startDate >= timelineDuration.startMilliseconds && sprint.startDate <= timelineDuration.endMilliseconds || sprint.endDate <= timelineDuration.endMilliseconds && sprint.endDate >= timelineDuration.startMilliseconds || sprint.startDate <= timelineDuration.startMilliseconds && sprint.endDate >= timelineDuration.endMilliseconds));
const $f7b3979a2b953c6b$var$asSprintIntervalType = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        state: sprint.state,
        start: sprint.startDate,
        end: sprint.endDate
    });
const $f7b3979a2b953c6b$export$31abdd665c32a9d3 = (timelineDuration, getSanitizedSprints)=>(startDate, currentSprintId)=>{
        const sprintGroups = (0, $kkQUz.groupOverlappingIntervals)(getSanitizedSprints(timelineDuration).filter((sprint)=>sprint.id !== currentSprintId).map($f7b3979a2b953c6b$var$asSprintIntervalType));
        // Filter out groups that don't overlap with start date and closed sprints
        const filteredSprintGroup = sprintGroups.find((sprintGroup)=>sprintGroup.start <= startDate && sprintGroup.end > startDate);
        return filteredSprintGroup ? (0, $26s3n.getFirstOpenSprint)(filteredSprintGroup.intervals) : undefined;
    };
const $f7b3979a2b953c6b$export$3df6198cde5435f9 = (sprintsHash)=>(sprintId)=>sprintId !== undefined ? sprintsHash[sprintId]?.name : undefined;
const $f7b3979a2b953c6b$export$9cbf48c04feaac07 = (sprintsHash)=>(sprintId)=>sprintId !== undefined ? sprintsHash[sprintId]?.state : undefined;
const $f7b3979a2b953c6b$export$abdb1a5f7673f188 = (issueIdToSprintIds)=>(0, $5iWql.default)((id)=>{
        const sprintIds = issueIdToSprintIds[id] || [];
        return sprintIds[0];
    });
const $f7b3979a2b953c6b$export$7ace1dbeb1bd9b20 = (issueSprintIdsHash, allSprintsHash)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(issueSprintIdsHash).forEach((issueId)=>{
        const sprintIds = issueSprintIdsHash[issueId];
        const filteredSprints = sprintIds.filter((sprintId)=>allSprintsHash[sprintId] !== undefined).map((sprintId)=>allSprintsHash[sprintId]);
        result[issueId] = filteredSprints;
    });
    return result;
};
const $f7b3979a2b953c6b$export$c1e6c915824951b6 = (issueSprintsHash)=>(issueId)=>(issueSprintsHash[issueId] ?? []).filter((sprint)=>sprint.state !== (0, $a7a73ddab4e749dd$export$19c4f83398a8dbce));

});
parcelRegister("fHtBB", function(module, exports) {

$parcel$export(module.exports, "DATE_FORMAT", () => $d61a398c89b7109c$export$45c85543ba71221d);
$parcel$export(module.exports, "DATE_FORMAT_MOMENT", () => $d61a398c89b7109c$export$98de7bb6e1f5105c);
$parcel$export(module.exports, "DUE_DATE_OFFSET", () => $d61a398c89b7109c$export$28c98c2c1f9d90de);
$parcel$export(module.exports, "INTERVAL", () => $d61a398c89b7109c$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "ROLLUP", () => $d61a398c89b7109c$export$e299765c2b7892c0);
$parcel$export(module.exports, "EXPLICIT", () => $d61a398c89b7109c$export$29c6b89b5966039e);

const $d61a398c89b7109c$export$45c85543ba71221d = 'yyyy/MM/dd';
const $d61a398c89b7109c$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
const $d61a398c89b7109c$export$28c98c2c1f9d90de = (0, $4975412c8fcbfa24$export$1f04624003d2da7d) - 1;
const $d61a398c89b7109c$export$7dea0e6e08f87a8a = 'INTERVAL';
const $d61a398c89b7109c$export$e299765c2b7892c0 = 'ROLLUP';
const $d61a398c89b7109c$export$29c6b89b5966039e = 'EXPLICIT';

});
const $4975412c8fcbfa24$export$e63e1e1c17a0e8b = 'YYYY-MM-DD';
const $4975412c8fcbfa24$export$45c85543ba71221d = 'YYYY/MM/DD';
const $4975412c8fcbfa24$export$1f04624003d2da7d = 86400000;


parcelRegister("26s3n", function(module, exports) {

$parcel$export(module.exports, "getFirstOpenSprint", () => $0b26e047273468de$export$d85846c0333cfbbb);

const $0b26e047273468de$export$d85846c0333cfbbb = (intervals)=>intervals.find((sprint)=>sprint.state !== (0, $a7a73ddab4e749dd$export$19c4f83398a8dbce))?.id;

});

parcelRegister("kkQUz", function(module, exports) {

$parcel$export(module.exports, "groupOverlappingIntervals", () => $44ee1b1ae8b45afa$export$1b45218c7b9e570f);
const $44ee1b1ae8b45afa$export$1b45218c7b9e570f = (intervals)=>{
    /* To read the diagram:
	 * - Each unique character represents an interval, where the start is the first character, and the end is the last character.
	 * - Intervals are ordered in the same way they appear in the input list.
	 * - Uppercase characters represent overlapping time, and lowercase characters represents overlapped time.
	 * - Each row, separated by (-), represents an interval grouping.
	 *
	 * |---------------------|
	 * |   A A A             |
	 * |---------------------|
	 * |   B B B B           |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 * |   D D               |
	 * |---------------------|
	 * | E E E               |
	 * |---------------------|
	 * |   F F               |
	 * |---------------------|
	 */ // remember original position in the list, because we'll need to sort again at the end
    const intervalsWithIndex = intervals.map((interval, index)=>({
            ...interval,
            index: index
        }));
    // First sort, as it will make the grouping logic a lot simpler.
    // Sprint with later end last; earlier sprint start last.
    const sortedIntervals = [
        ...intervalsWithIndex
    ].sort((interval, otherInterval)=>{
        const endComparison = interval.end - otherInterval.end;
        if (endComparison !== 0) return endComparison;
        return otherInterval.start - interval.start;
    });
    /* |---------------------|
	 * |   D D               |
	 * |---------------------|
	 * |   F F               |
	 * |---------------------|
	 * | E E E               |
	 * |---------------------|
	 * |   A A A             |
	 * |---------------------|
	 * |   B B B B           |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 */ let result = [];
    // Traverse through the list of sorted intervals in _reverse_ order.
    // Group together adjacent intervals that are _completely_ overlapped.
    let i = sortedIntervals.length - 1;
    while(i >= 0){
        const currentInterval = sortedIntervals[i];
        let groupedIntervals = [
            currentInterval
        ];
        let j = i - 1;
        while(j >= 0){
            const nextInterval = sortedIntervals[j];
            // Since intervals are sorted, then the currentInterval.end >= nextInterval.end
            const isNextIntervalCompletelyOverlapped = currentInterval.start <= nextInterval.start;
            if (isNextIntervalCompletelyOverlapped) groupedIntervals = [
                nextInterval
            ].concat(groupedIntervals);
            else break;
            j -= 1;
        }
        const groupedIntervalsInOriginalOrdering = groupedIntervals.sort((interval, otherInterval)=>interval.index - otherInterval.index).map(({ index: index, ...interval })=>interval);
        result = [
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                start: currentInterval.start,
                end: currentInterval.end,
                expandedEnd: currentInterval.end,
                intervals: groupedIntervalsInOriginalOrdering
            }
        ].concat(result);
        i = j;
    }
    /* |---------------------|
	 * |               C C   |
	 * |---------------------|
	 * |   B B B B           |
	 * |   a a a             |
	 * |---------------------|
	 * | E E E               |
	 * |   f f               |
	 * |   d d               |
	 * |---------------------|
	 */ // We now "collapse" adjacent interval groups that overlap.
    // Later interval groups take precedence over earlier interval groups.
    if (result.length >= 2) for(let k = 0; k < result.length - 1; k += 1){
        const currentIntervalGroup = result[k];
        const nextIntervalGroup = result[k + 1];
        if (currentIntervalGroup.end > nextIntervalGroup.start) currentIntervalGroup.end = nextIntervalGroup.start;
    }
    /* |---------------------|
	 * | E e e               |
	 * |   f f               |
	 * |   d d               |
	 * |---------------------|
	 * |   B B B B           |
	 * |   a a a             |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 */ return result;
};

});



parcelRegister("llb1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ade016cd85c24c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $95RcH = parcelRequire("95RcH");

var $8uD7Y = parcelRequire("8uD7Y");

var $4ksts = parcelRequire("4ksts");


var $81y0F = parcelRequire("81y0F");
const $2ade016cd85c24c7$export$bfc0b1314277ad8e = ({ id: id, changedSprintName: changedSprintName, direction: direction, issueKey: issueKey, onDismissed: onDismissed, onUndo: onUndo, onPersist: onPersist })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const isUndoing = (0, $eUqFw.useRef)(false);
    const onDismissedCallback = (0, $eUqFw.useCallback)((flagId, event)=>{
        if (!isUndoing.current) onPersist(flagId, event);
        onDismissed(flagId, event);
    }, [
        onDismissed,
        onPersist
    ]);
    const onClick = (0, $eUqFw.useCallback)((_, event)=>{
        isUndoing.current = true;
        onUndo(id, event);
        onDismissed(id, event);
    }, [
        onUndo,
        id,
        onDismissed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95RcH.default), {
        id: id,
        title: formatMessage((0, $81y0F.default).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...direction === (0, $34b1b2b25acc1092$export$11ee87f991dd6574) ? (0, $81y0F.default).descriptionAssign : (0, $81y0F.default).descriptionUnassign,
            values: {
                changedSprintName: changedSprintName,
                issueKey: issueKey,
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
            }
        }),
        onDismissed: onDismissedCallback,
        actions: [
            {
                content: formatMessage((0, $81y0F.default).undo),
                onClick: onClick
            }
        ]
    });
};
$2ade016cd85c24c7$export$bfc0b1314277ad8e.defaultProps = {
    onDismissed: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $2ade016cd85c24c7$export$2e2bcd8739ae039 = $2ade016cd85c24c7$export$bfc0b1314277ad8e;

});
parcelRegister("81y0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b69af85c6aaae74$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6b69af85c6aaae74$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "roadmap.standard-roadmap.flags.sprint-scope-change.title",
        "defaultMessage": "Active sprint scope has changed"
    },
    descriptionAssign: {
        "id": "roadmap.standard-roadmap.flags.sprint-scope-change.description-assign",
        "defaultMessage": "<b>{issueKey}</b> has been assigned to <b>{changedSprintName}</b>, which will affect its scope."
    },
    descriptionUnassign: {
        "id": "roadmap.standard-roadmap.flags.sprint-scope-change.description-unassign",
        "defaultMessage": "<b>{issueKey}</b> has been unassigned from <b>{changedSprintName}</b>, which will affect its scope."
    },
    undo: {
        "id": "roadmap.standard-roadmap.flags.sprint-scope-change.undo",
        "defaultMessage": "Undo"
    }
});

});




parcelRegister("hoFgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced22260e2cc64af$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");

var $dCCTr = parcelRequire("dCCTr");

var $8xmdY = parcelRequire("8xmdY");

var $1gs0D = parcelRequire("1gs0D");

var $9BmXV = parcelRequire("9BmXV");

var $5qjtC = parcelRequire("5qjtC");

var $6Syto = parcelRequire("6Syto");

var $1juxc = parcelRequire("1juxc");

var $hRJN0 = parcelRequire("hRJN0");

var $3Jg4R = parcelRequire("3Jg4R");

var $Pkh3j = parcelRequire("Pkh3j");

var $f2OcL = parcelRequire("f2OcL");

var $gZQty = parcelRequire("gZQty");

var $iwQNI = parcelRequire("iwQNI");

var $d2dJm = parcelRequire("d2dJm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ced22260e2cc64af$export$2e2bcd8739ae039 = (type)=>(0, $dCCTr.default)((0, $1gs0D.toRoadmapAppId)(type), 'root', (0, $bd1K7.combineEpics)((0, $5qjtC.default), (0, $6Syto.default), (0, $1juxc.default), (0, $hRJN0.default), (0, $Pkh3j.default), (0, $f2OcL.default), (0, $gZQty.default), (0, $d2dJm.default), (0, $3Jg4R.default), (0, $iwQNI.getCanUserInviteEpic)), (error)=>{
        if (error?.skipSentry === true) {
            // strip out skip sentry flag and make sure it's logged to sentry
            // we never expect unhandled errors, even 403s, so we need to log everything
            const errorWithoutSkipSentry = {
                ...error,
                skipSentry: false
            };
            (0, $8xmdY.captureException)(`common.epic-error.${(0, $1gs0D.toRoadmapAppId)(type)}.root`, errorWithoutSkipSentry);
        }
        return (0, $3JafE.Observable).of((0, $9BmXV.generalError)());
    });

});
parcelRegister("dCCTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c77def2ad7ce8cc2$export$2e2bcd8739ae039);
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $8xmdY = parcelRequire("8xmdY");
var /*
 * Catches errors within the epic middleware and makes them available to monitoring.
 *
 * Takes an optional handler as a parameter that can be executed when an error is encountered.
 * This handler returns an observable.
 * This could be used to show an error flag, for example, but will replace attempting to continue
 * the current observable stream.
 *
 * Example usage, which could be applied to the root epic:
 * errorHandlerEpicMiddleware('your-app-name', 'root', combineEpics(epicOne, epicTwo));
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$c77def2ad7ce8cc2$export$2e2bcd8739ae039 = (appId, location, epic, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorHandler)=>(action$, store, deps)=>epic(action$, store, deps).catch((error, stream)=>{
            const fullLocation = `common.epic-error.${appId}.${location}`;
            (0, $gUUjF.default).safeErrorWithoutCustomerData(fullLocation, 'Unhandled error in epic', error);
            (0, $8xmdY.captureException)(fullLocation, error);
            return errorHandler && errorHandler(error) || stream;
        });

});

parcelRegister("5qjtC", function(module, exports) {

$parcel$export(module.exports, "default", () => $81e85eef8c1b7f59$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $4fPVg = parcelRequire("4fPVg");

var $jOftK = parcelRequire("jOftK");

var $28nwG = parcelRequire("28nwG");

var $eZqh8 = parcelRequire("eZqh8");

var $5uaAI = parcelRequire("5uaAI");

var $39L2J = parcelRequire("39L2J");

var $eLcvs = parcelRequire("eLcvs");

var $30fUW = parcelRequire("30fUW");

var $eizPi = parcelRequire("eizPi");

var $fLwB4 = parcelRequire("fLwB4");

var $fwyOi = parcelRequire("fwyOi");

var $6pY0q = parcelRequire("6pY0q");

var $enZin = parcelRequire("enZin");

var $ckn21 = parcelRequire("ckn21");

var $1XQKS = parcelRequire("1XQKS");

var $7i2Xg = parcelRequire("7i2Xg");

var $162RE = parcelRequire("162RE");

var $jqxCh = parcelRequire("jqxCh");

var $cNjG8 = parcelRequire("cNjG8");

var $7pAws = parcelRequire("7pAws");

var $eT3kf = parcelRequire("eT3kf");

var $jeiZn = parcelRequire("jeiZn");

var $4tdkz = parcelRequire("4tdkz");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$81e85eef8c1b7f59$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $4fPVg.default), (0, $jOftK.default), (0, $jqxCh.default), (0, $cNjG8.default), (0, $6pY0q.default), (0, $fwyOi.default), (0, $eT3kf.default), (0, $eizPi.default), (0, $1XQKS.default), (0, $4tdkz.default), (0, $162RE.default), (0, $ckn21.default), (0, $7pAws.default), (0, $enZin.default), (0, $39L2J.default), (0, $jeiZn.default), (0, $eLcvs.default), (0, $7i2Xg.default), (0, $5uaAI.default), (0, $eZqh8.default), (0, $30fUW.default), (0, $28nwG.default), (0, $fLwB4.default));

});
parcelRegister("4fPVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa1fc3acfbd95993$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $gdFA6 = parcelRequire("gdFA6");

var $aSTh4 = parcelRequire("aSTh4");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$fa1fc3acfbd95993$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.CLEAR_FILTER_AND_SETTING)).mergeMap(()=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
            (0, $aSTh4.clearLevelOneSetting)(),
            (0, $hoVIs.default)(push, store.getState(), (query)=>({
                    ...query,
                    statuses: undefined,
                    assignee: undefined,
                    issueType: undefined,
                    text: undefined,
                    label: undefined,
                    issueParent: undefined,
                    epic: undefined,
                    version: undefined,
                    component: undefined,
                    quickFilter: undefined,
                    customFilter: undefined
                }))
        ])));

});
parcelRegister("hoVIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89542090b939557$export$2e2bcd8739ae039);

var $lgKTA = parcelRequire("lgKTA");

var $dFuRD = parcelRequire("dFuRD");

var $6489W = parcelRequire("6489W");

var $aD3n2 = parcelRequire("aD3n2");
const $c89542090b939557$var$updateQuery = (push, state, callback)=>{
    const location = (0, $6489W.getLocation)(state);
    const searchStr = (0, $aD3n2.convertQueryToString)(callback((0, $6489W.getQuery)(state)));
    // Roadmap macro doesn't need the url to be updated because it is in an iframe
    if (!(0, $lgKTA.hasMacroConfig)(state)) push({
        ...location,
        search: searchStr
    });
    return (0, $dFuRD.routerLocationChange)({
        ...location,
        search: `?${searchStr}`
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c89542090b939557$export$2e2bcd8739ae039 = (push, state, callback)=>$c89542090b939557$var$updateQuery(push, state, callback);

});
parcelRegister("dFuRD", function(module, exports) {

$parcel$export(module.exports, "ROUTER_LOCATION_CHANGE", () => $f9725a7a89c9118d$export$1c5e4d78bc961ac8);
$parcel$export(module.exports, "routerLocationChange", () => $f9725a7a89c9118d$export$989554cbc13fc377);
const $f9725a7a89c9118d$export$1c5e4d78bc961ac8 = 'ROUTER_LOCATION_CHANGE';
const $f9725a7a89c9118d$export$989554cbc13fc377 = (payload)=>({
        type: $f9725a7a89c9118d$export$1c5e4d78bc961ac8,
        payload: payload
    });

});



parcelRegister("jOftK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c05507fc7848bdd$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$9c05507fc7848bdd$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.CLEAR_FILTER)).map(()=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                statuses: undefined,
                assignee: undefined,
                issueType: undefined,
                text: undefined,
                label: undefined,
                issueParent: undefined,
                version: undefined,
                component: undefined,
                quickFilter: undefined,
                customFilter: undefined,
                goal: undefined
            })));

});

parcelRegister("28nwG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec0cfeea7b30616$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("b48pz");
parcelRequire("3wBUP");
parcelRequire("flmol");

var $3JafE = parcelRequire("3JafE");

var $jAy5L = parcelRequire("jAy5L");

var $eC0P8 = parcelRequire("eC0P8");

var $lgKTA = parcelRequire("lgKTA");

var $gdFA6 = parcelRequire("gdFA6");
const $4ec0cfeea7b30616$var$filter = (action, store)=>{
    const state = store.getState();
    const customFilterIds = action.payload;
    if (customFilterIds.length === 0) return (0, $3JafE.Observable).of((0, $gdFA6.clearCustomFilters)());
    return (0, $eC0P8.filterItemsByJQLFilters)((0, $lgKTA.getSourceARI)(state), [], customFilterIds).map((filteredIssueIds)=>(0, $gdFA6.jqlFiltersSuccess)(filteredIssueIds));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4ec0cfeea7b30616$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $gdFA6.CUSTOM_FILTERS_REQUEST)).throttleTime(500, (0, $jAy5L.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$4ec0cfeea7b30616$var$filter(action, store));

});
parcelRegister("eC0P8", function(module, exports) {

$parcel$export(module.exports, "filterItemsByJQLFilters", () => $6d7c960a5ce54479$export$ac2f1bddc6081e48);
parcelRequire("flmol");
parcelRequire("cpH8E");

var $7H2wA = parcelRequire("7H2wA");

var $hp0bJ = parcelRequire("hp0bJ");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");
const $6d7c960a5ce54479$var$analyticKey = 'jira.frontend.fe.software.roadmap.filter-roadmap-items';
const $6d7c960a5ce54479$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$d21f08c0570f92f7];
const $6d7c960a5ce54479$export$ac2f1bddc6081e48 = (sourceAri, quickFilterIds, customFilterIds)=>(0, $8sMwH.runQueryWithMetadata)((0, $7H2wA.default), (0, $hp0bJ.generateFilterRoadmapItemsQueryVariables)(sourceAri, quickFilterIds ?? [], customFilterIds ?? []), $6d7c960a5ce54479$var$analyticKey, $6d7c960a5ce54479$var$concurrentMetricDefinition).map(({ data: data })=>{
        const issueIds = data.roadmaps?.roadmapFilterItems ?? [];
        return issueIds.slice();
    });

});
parcelRegister("7H2wA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c298292629121e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d01bf4d7d86d5870e98ee63e1ddbd473>>
 * @relayHash 76fa5e70860be87b0aea6f6c5d2ab7f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 27d267d70916c4190d559166d5b624c365e56a06e45c7cd51a1a29372491ea76
const $6c298292629121e0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "customFilterIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "quickFilterIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v3 = [
        {
            "concreteType": "RoadmapsQuery",
            "kind": "LinkedField",
            "name": "roadmaps",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "customFilterIds",
                            "variableName": "customFilterIds"
                        },
                        {
                            "kind": "Variable",
                            "name": "quickFilterIds",
                            "variableName": "quickFilterIds"
                        },
                        {
                            "kind": "Variable",
                            "name": "sourceARI",
                            "variableName": "sourceAri"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "roadmapFilterItems"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "filterRoadmapItemsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "filterRoadmapItemsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "27d267d70916c4190d559166d5b624c365e56a06e45c7cd51a1a29372491ea76",
            "metadata": {},
            "name": "filterRoadmapItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c298292629121e0$var$node.hash = "19827cdd137051897ba5e27b5db7eeae";
var $6c298292629121e0$export$2e2bcd8739ae039 = $6c298292629121e0$var$node;

});

parcelRegister("hp0bJ", function(module, exports) {

$parcel$export(module.exports, "generateFilterRoadmapItemsQueryVariables", () => $4bb0147d33fb8373$export$3b5355050a9c05db);
const $4bb0147d33fb8373$export$3b5355050a9c05db = (sourceAri, quickFilterIds, customFilterIds)=>({
        sourceAri: sourceAri,
        quickFilterIds: quickFilterIds,
        customFilterIds: customFilterIds
    });

});

const $028d5637f56fe710$export$3ac90e7f239a7193 = 'dependencyDnd';
const $028d5637f56fe710$export$eedef6333f320132 = 'issueViewResizeDnd';
const $028d5637f56fe710$export$2475592765cae5b0 = 'chartBarResize';
const $028d5637f56fe710$export$2afae5ee414caffb = 'persistItem';
const $028d5637f56fe710$export$26d8759f6f1c8e13 = 'exportImageGenerated';
const $028d5637f56fe710$export$e04dc5133fcac555 = 'issueUpdated';
const $028d5637f56fe710$export$5913ec3a0f9505fe = 'dependencyAdded';
const $028d5637f56fe710$export$488a6fa9078615df = 'dependencyRemoved';
const $028d5637f56fe710$export$315e0cbd8c7bfbd4 = 'bulkIssuesScheduled';
const $028d5637f56fe710$export$f096bf13c1d89b91 = 'resolveHealthcheck';
const $028d5637f56fe710$export$12daf7ce2c179397 = 'criticalData';
const $028d5637f56fe710$export$ede40e627a0cbf14 = 'versionDetails';
const $028d5637f56fe710$export$1df1eb270f208354 = 'sprintDetails';
const $028d5637f56fe710$export$bd4cd00ee0750c9a = 'filterConfiguration';
const $028d5637f56fe710$export$9e57feecc7b4c365 = 'deriveFields';
const $028d5637f56fe710$export$d21f08c0570f92f7 = 'filterRoadmapItems';
const $028d5637f56fe710$export$72305db43681d1de = 'getIssueIds';
const $028d5637f56fe710$export$51617034fb6f2e3a = 'getItemsByIds';
const $028d5637f56fe710$export$d959a123e6ceb778 = 'getSubtasks';
const $028d5637f56fe710$export$2e07b3a26c033d37 = 'healthcheckIssueTypes';
const $028d5637f56fe710$export$a0d61e9ea4ad5a05 = 'jqlFiltersReapply';
const $028d5637f56fe710$export$57a4171901f1c15b = 'getGoals';

parcelRegister("8sMwH", function(module, exports) {

$parcel$export(module.exports, "runQueryWithMetadata", () => $366ecfb918a74623$export$24c7a6008914d023);
$parcel$export(module.exports, "runQueryWithMetadataAndSelector", () => $366ecfb918a74623$export$58a45f50aef158ce);

var $iWLL0 = parcelRequire("iWLL0");

var $3JafE = parcelRequire("3JafE");

var $df9H8 = parcelRequire("df9H8");
parcelRequire("1Lcr1");
parcelRequire("flmol");

var $dBQte = parcelRequire("dBQte");

var $hompL = parcelRequire("hompL");

var $amu7D = parcelRequire("amu7D");

var $15ZJO = parcelRequire("15ZJO");

var $2n6bs = parcelRequire("2n6bs");

var $5udmX = parcelRequire("5udmX");

var $aJyoc = parcelRequire("aJyoc");

var $dGP5L = parcelRequire("dGP5L");
parcelRequire("cpH8E");

var $b0VLP = parcelRequire("b0VLP");
const $366ecfb918a74623$var$runQueryWithMetadataInternal = (compiledQuery, variables, executionOptions = {})=>{
    const operationName = compiledQuery.params.name;
    (0, $5udmX.startCapturingTraceIds)(operationName);
    (0, $2n6bs.startCapturingExtensions)(operationName);
    const errorCollector = (0, $15ZJO.startCaptureGraphQlErrors)();
    if ((0, $aJyoc.isUnsubscribableQueryEnabled)()) return (0, $b0VLP.fetchQueryObservable)((0, $amu7D.default)(), compiledQuery, variables).catch((error)=>{
        const traceIds = (0, $5udmX.getTraceIds)(operationName);
        (0, $5udmX.stopCapturingTraceIds)(operationName);
        throw (0, $b0VLP.transformGenericError)(error, traceIds, operationName);
    }).map((data)=>{
        const traceIds = (0, $5udmX.getTraceIds)(operationName);
        (0, $5udmX.stopCapturingTraceIds)(operationName);
        const [extensions] = (0, $2n6bs.getExtensions)(operationName);
        (0, $2n6bs.stopCapturingExtensions)(operationName);
        const relevantErrors = (0, $b0VLP.getGraphQlErrorsForOperation)(errorCollector, operationName, executionOptions);
        if (relevantErrors.length > 0) throw new (0, $dGP5L.AggError)(`Query ${operationName} had graphql errors`, relevantErrors, traceIds, (0, $dGP5L.GRAPHQL_ERROR));
        return {
            metadata: {
                operationName: operationName,
                traceIds: traceIds,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                extensions: extensions
            },
            data: data
        };
    });
    return (0, $3JafE.Observable).fromPromise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Promise((resolve, reject)=>{
        (0, $iWLL0.fetchQuery)((0, $amu7D.default)(), compiledQuery, variables).subscribe({
            error: (error)=>{
                const traceIds = (0, $5udmX.getTraceIds)(operationName);
                (0, $5udmX.stopCapturingTraceIds)(operationName);
                (0, $2n6bs.stopCapturingExtensions)(operationName);
                const transformedError = (0, $b0VLP.transformGenericError)(error, traceIds, operationName);
                reject(transformedError);
            },
            next: (data)=>{
                const traceIds = (0, $5udmX.getTraceIds)(operationName);
                (0, $5udmX.stopCapturingTraceIds)(operationName);
                const [extensions] = (0, $2n6bs.getExtensions)(operationName);
                (0, $2n6bs.stopCapturingExtensions)(operationName);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const relevantErrors = (0, $b0VLP.getGraphQlErrorsForOperation)(errorCollector, operationName, executionOptions);
                if (relevantErrors.length > 0) {
                    reject(new (0, $dGP5L.AggError)(`Query ${operationName} had graphql errors`, relevantErrors, traceIds, (0, $dGP5L.GRAPHQL_ERROR)));
                    return;
                }
                resolve({
                    metadata: {
                        operationName: operationName,
                        traceIds: traceIds,
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        extensions: extensions
                    },
                    data: data
                });
            }
        });
    }));
};
const $366ecfb918a74623$export$24c7a6008914d023 = (compiledQuery, variables, analyticKey, concurrentMetricDefinition, executionOptions = {})=>{
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
    concurrentMetricDefinition(concurrentId).start();
    let isRetried = false;
    return $366ecfb918a74623$var$runQueryWithMetadataInternal(compiledQuery, variables, executionOptions).pipe((0, $df9H8.catchError)((error)=>{
        if (error instanceof (0, $dGP5L.AggError)) {
            if (error.errorType === (0, $dGP5L.INVALID_PAYLOAD_ERROR) || error.errorType === (0, $dGP5L.MISSING_DATA_ERROR) || (error.errorType === (0, $dGP5L.NETWORK_ERROR) || error.errorType === (0, $dGP5L.GRAPHQL_ERROR)) && (error.errors.length === 0 || error.errors[0].extensions != null && // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2365 - Operator '>=' cannot be applied to types 'number' and 'string'.
            error.errors[0].extensions.statusCode >= '500' && // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2365 - Operator '<=' cannot be applied to types 'number' and 'string'.
            error.errors[0].extensions.statusCode <= '600')) {
                isRetried = true;
                return $366ecfb918a74623$var$runQueryWithMetadataInternal(compiledQuery, variables, executionOptions);
            }
        }
        throw error;
    }), (0, $dBQte.tap)({
        next: ({ metadata: { traceIds: traceIds } })=>{
            (0, $b0VLP.sendOperationalEventV2)(analyticKey, '200', traceIds, isRetried);
            concurrentMetricDefinition(concurrentId).stop({
                customData: {
                    traceId: traceIds[0],
                    statusCode: '200',
                    isRetried: isRetried
                }
            });
        },
        error: (error)=>{
            const { traceIds: traceIds, statusCode: statusCode } = (0, $b0VLP.sendOperationalEventV2OnError)(error, analyticKey, isRetried);
            concurrentMetricDefinition(concurrentId).stop({
                customData: {
                    traceId: traceIds[0],
                    statusCode: statusCode,
                    isRetried: isRetried
                }
            });
        }
    }));
};
const $366ecfb918a74623$export$58a45f50aef158ce = (compiledQuery, variables, analyticKey, concurrentMetricDefinition, selector, executionOptions = {})=>$366ecfb918a74623$export$24c7a6008914d023(compiledQuery, variables, analyticKey, concurrentMetricDefinition, executionOptions).map(({ data: data, metadata: metadata })=>{
        const field = selector(data);
        if (field == null) throw new (0, $dGP5L.AggError)(`Failed to retrieve data via ${metadata.operationName}`, [], metadata.traceIds, (0, $dGP5L.MISSING_DATA_ERROR));
        return {
            data: field,
            metadata: metadata
        };
    });

});
parcelRegister("aJyoc", function(module, exports) {

$parcel$export(module.exports, "isUnsubscribableQueryEnabled", () => $5c86cb7f9da66e02$export$544b23c1154a6c3b);
$parcel$export(module.exports, "isUnsubscribableMutationEnabled", () => $5c86cb7f9da66e02$export$d8eb183d0f59beb1);
$parcel$export(module.exports, "isEcClientEventListenerEnabled", () => $5c86cb7f9da66e02$export$f04c623593a78ee6);

var $1ybV0 = parcelRequire("1ybV0");
const $5c86cb7f9da66e02$export$544b23c1154a6c3b = ()=>(0, $1ybV0.ff)('jsw.roadmap.unsubscribable-query');
const $5c86cb7f9da66e02$export$d8eb183d0f59beb1 = ()=>(0, $1ybV0.ff)('jsw.roadmap.unsubscribable-mutation');
const $5c86cb7f9da66e02$export$f04c623593a78ee6 = ()=>(0, $1ybV0.ff)('odin.ec.client.integration');

});

parcelRegister("dGP5L", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_ERROR", () => $18a7906127f286bb$export$2d06efb8146cd043);
$parcel$export(module.exports, "UNKNOWN_ERROR", () => $18a7906127f286bb$export$f10b32dfda12e96e);
$parcel$export(module.exports, "NETWORK_ERROR", () => $18a7906127f286bb$export$e5e4b8c32e68dd0b);
$parcel$export(module.exports, "MISSING_DATA_ERROR", () => $18a7906127f286bb$export$3ee0525ef4410691);
$parcel$export(module.exports, "INVALID_PAYLOAD_ERROR", () => $18a7906127f286bb$export$e264e80e8bb90041);
$parcel$export(module.exports, "AggError", () => $18a7906127f286bb$export$fb37d46cecef6785);

var $illlw = parcelRequire("illlw");

var $iTvqy = parcelRequire("iTvqy");

var $1Xtvv = parcelRequire("1Xtvv");
const $18a7906127f286bb$export$2d06efb8146cd043 = 'graphql';
const $18a7906127f286bb$export$f10b32dfda12e96e = 'unknown';
const $18a7906127f286bb$export$e5e4b8c32e68dd0b = 'network';
const $18a7906127f286bb$export$3ee0525ef4410691 = 'missingData';
const $18a7906127f286bb$export$e264e80e8bb90041 = 'invalidPayload';
const $18a7906127f286bb$var$errorSanitizationRegex = /\bNetwork\serror:|GraphQL\serror:/;
class $18a7906127f286bb$export$fb37d46cecef6785 extends Error {
    getCause() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return this.cause;
    }
    constructor(message, errors, traceIds, errorType, cause){
        // using the now widely support error cause mechanism https://github.com/tc39/proposal-error-cause. This is also supported by sentry.
        super(message, {
            cause: cause
        });
        this.affectsReliability = true;
        this.skipSentry = true;
        this.errors = errors;
        this.traceIds = traceIds;
        this.errorType = errorType;
        this.traceId = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(this.traceIds);
        this.statusCodes = errors.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
        this.userMessages = errors.map((graphQLError)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(graphQLError, 'extensions.userMessage', undefined) || graphQLError?.message || undefined).filter((x)=>x != null);
        this.computeAffectsReliability();
        this.skipSentry = !this.affectsReliability || this.statusCodes.some((statusCode)=>(0, $1Xtvv.statusCodesToSkipForSentry).includes(statusCode)) || this.userMessages.some((msg)=>(0, $1Xtvv.errorMessagesToSkipForSentry).includes(msg.replace($18a7906127f286bb$var$errorSanitizationRegex, '').trim()));
    }
    computeAffectsReliability() {
        const causeTrimmedMessage = this.getCause()?.message?.replace($18a7906127f286bb$var$errorSanitizationRegex, '').trim() || '';
        this.affectsReliability = this.affectsReliability && !this.statusCodes.some((code)=>(0, $1Xtvv.statusCodesNotImpactingReliability).includes(Number(code))) && !(0, $1Xtvv.errorMessagesNotImpactingReliability).includes(causeTrimmedMessage) && !this.userMessages.some((message)=>(0, $1Xtvv.errorMessagesNotImpactingReliability).includes(message.replace($18a7906127f286bb$var$errorSanitizationRegex, '').trim()));
    }
}

});
parcelRegister("1Xtvv", function(module, exports) {

$parcel$export(module.exports, "statusCodesNotImpactingReliability", () => $191a1b8002dd5b98$export$501df64f0fda1d63);
$parcel$export(module.exports, "statusCodesToSkipForSentry", () => $191a1b8002dd5b98$export$8cef49ed469b6cd2);
$parcel$export(module.exports, "errorMessagesToSkipForSentry", () => $191a1b8002dd5b98$export$a23281a65ac65f85);
$parcel$export(module.exports, "errorMessagesNotImpactingReliability", () => $191a1b8002dd5b98$export$4e68293cfa47ee01);
const $191a1b8002dd5b98$export$501df64f0fda1d63 = [
    400,
    404,
    401,
    403,
    408,
    426,
    429
];
const $191a1b8002dd5b98$export$8cef49ed469b6cd2 = [
    503
];
const $191a1b8002dd5b98$export$a23281a65ac65f85 = [
    'The underlying service call timed out'
];
const $191a1b8002dd5b98$export$4e68293cfa47ee01 = [
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'The operation was aborted.',
    'Auth category: UNAUTHENTICATED is not allowed in service roadmaps',
    'Failed to retrieve data via roadmapCriticalDataFromRoadmapService. Underlying error: Error: Failed to fetch'
];

});


parcelRegister("b0VLP", function(module, exports) {

$parcel$export(module.exports, "getGraphQlErrorsForOperation", () => $a44b9e0843f942ee$export$c1e5df311f2b29b2);
$parcel$export(module.exports, "sendOperationalEvent", () => $a44b9e0843f942ee$export$e5f89b51c6d4e36b);
$parcel$export(module.exports, "sendOperationalEventV2", () => $a44b9e0843f942ee$export$93d0b35b696044cb);
$parcel$export(module.exports, "fetchQueryObservable", () => $a44b9e0843f942ee$export$1b6907b181f00104);
$parcel$export(module.exports, "commitMutationObservable", () => $a44b9e0843f942ee$export$86078ec91637a7ad);
$parcel$export(module.exports, "transformGenericError", () => $a44b9e0843f942ee$export$7492c515d6da61a3);
$parcel$export(module.exports, "transformGraphQLErrors", () => $a44b9e0843f942ee$export$b032b8d1c2b46aae);
$parcel$export(module.exports, "sendOperationalEventV2OnError", () => $a44b9e0843f942ee$export$5434dcf2ed596c6e);
$parcel$export(module.exports, "sendOperationalEventV2OnSuccess", () => $a44b9e0843f942ee$export$3a2ff6315865acd7);

var $iWLL0 = parcelRequire("iWLL0");

var $3JafE = parcelRequire("3JafE");

var $7byHA = parcelRequire("7byHA");

var $3FyZ4 = parcelRequire("3FyZ4");

var $15ZJO = parcelRequire("15ZJO");

var $dGP5L = parcelRequire("dGP5L");
const $a44b9e0843f942ee$var$statusCodeRegex = /^[12345][0-9]{2}$/;
const $a44b9e0843f942ee$export$c1e5df311f2b29b2 = (errorCollector, operationName, executionOptions = {})=>{
    const errorsWithMeta = (0, $15ZJO.stopCaptureGraphQlErrors)(errorCollector);
    if (Array.isArray(errorsWithMeta)) {
        const operationErrors = errorsWithMeta.filter((errorWithMeta)=>errorWithMeta.meta.operationName === operationName).flatMap((errorWithMeta)=>errorWithMeta.errors);
        return executionOptions.graphqlErrorFilter ? executionOptions.graphqlErrorFilter(operationErrors) : operationErrors;
    }
    return [];
};
const $a44b9e0843f942ee$export$e5f89b51c6d4e36b = (analyticKey, statusCode, aggTraceIds, isRetried, cause)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'relay operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily,
                traceId: aggTraceIds[0],
                frontendVersion: window.BUILD_KEY,
                isRetried: isRetried,
                cause: cause
            },
            source: 'relayOperation'
        });
    });
};
const $a44b9e0843f942ee$export$93d0b35b696044cb = (analyticKey, statusCode, aggTraceIds, isRetried, errorDetails)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match($a44b9e0843f942ee$var$statusCodeRegex)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'relay operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily,
                traceId: aggTraceIds[0],
                frontendVersion: window.BUILD_KEY,
                affectsReliability: errorDetails?.affectsReliability || false,
                skipSentry: errorDetails?.skipSentry || false,
                isRetried: isRetried,
                cause: errorDetails?.cause
            },
            source: 'relayOperation'
        });
    });
};
const $a44b9e0843f942ee$export$b57c7b401625b0df = (create)=>(0, $3JafE.Observable).create((sink)=>{
        const subscription = create().subscribe(sink);
        return ()=>subscription.unsubscribe();
    });
const $a44b9e0843f942ee$export$1b6907b181f00104 = (environment, taggedNode, variables, cacheConfig)=>$a44b9e0843f942ee$export$b57c7b401625b0df(()=>(0, $iWLL0.fetchQuery)(environment, taggedNode, variables, cacheConfig));
const $a44b9e0843f942ee$export$86078ec91637a7ad = (environment, config)=>(0, $3JafE.Observable).create((subscriber)=>{
        const disposable = (0, $iWLL0.commitMutation)(environment, {
            ...config,
            onCompleted: (response)=>{
                subscriber.next(response);
                subscriber.complete();
            },
            onError: (err)=>subscriber.error(err),
            onUnsubscribe: ()=>subscriber.unsubscribe()
        });
        return ()=>disposable.dispose();
    });
const $a44b9e0843f942ee$export$7492c515d6da61a3 = (error, traceIds, operationName)=>{
    // default error if we could not interpret the error
    let transformedError = new (0, $dGP5L.AggError)(error.message ?? `An unknown error has occured from ${operationName}`, [], traceIds, (0, $dGP5L.UNKNOWN_ERROR), error);
    if (error instanceof (0, $7byHA.ValidationError)) {
        const newTraceId = error.traceId != null ? [
            error.traceId
        ] : traceIds;
        transformedError = new (0, $dGP5L.AggError)(`Query ${operationName} failed while fetching the data: HTTP ${error.statusCode}`, [
            {
                message: error.message,
                extensions: {
                    statusCode: error.statusCode,
                    errorType: (0, $dGP5L.NETWORK_ERROR)
                }
            }
        ], newTraceId, (0, $dGP5L.NETWORK_ERROR), error);
    }
    if (error instanceof DOMException && error.name === 'AbortError') // When abort() is called, the fetch() promise rejects with an Error of type DOMException, with name AbortError.
    // See https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort for more details
    transformedError = new (0, $dGP5L.AggError)(`Query ${operationName} was aborted.`, [], traceIds, (0, $dGP5L.NETWORK_ERROR), error);
    if (error instanceof SyntaxError) // SyntaxError will usually be thrown when the json format is invalid.
    // Currently no details are provided (traceId status code or content types).
    // Follow up task to improve this https://jdog.jira-dev.com/browse/ROAD-5547
    transformedError = new (0, $dGP5L.AggError)(`Query ${operationName} response payload was invalid and could not be parsed`, [], traceIds, (0, $dGP5L.INVALID_PAYLOAD_ERROR), error);
    if (error instanceof (0, $7byHA.default)) {
        const newTraceId = error.traceId != null ? [
            error.traceId
        ] : traceIds;
        transformedError = new (0, $dGP5L.AggError)(`Query ${operationName} failed while fetching the data: HTTP ${error.statusCode}`, [
            {
                message: error.message,
                extensions: {
                    statusCode: error.statusCode,
                    errorType: (0, $dGP5L.NETWORK_ERROR)
                }
            }
        ], newTraceId, (0, $dGP5L.NETWORK_ERROR), error);
    }
    return transformedError;
};
const $a44b9e0843f942ee$export$b032b8d1c2b46aae = (relevantErrors, operationName, traceIds)=>new (0, $dGP5L.AggError)(`Query ${operationName} had graphql errors`, relevantErrors, traceIds, (0, $dGP5L.GRAPHQL_ERROR));
const $a44b9e0843f942ee$export$5434dcf2ed596c6e = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, analyticKey, isRetried, statusCodeOveride)=>{
    let traceIds = [];
    let statusCode = 'unknown';
    let cause = '';
    let skipSentry = false;
    let affectsReliability = true;
    if (error instanceof (0, $dGP5L.AggError)) {
        traceIds = error.traceIds;
        affectsReliability = error.affectsReliability;
        skipSentry = error.skipSentry;
        statusCode = statusCodeOveride || String(error.statusCodes[0] || 'unknown');
        cause = String(error.getCause()?.message || '');
    }
    $a44b9e0843f942ee$export$93d0b35b696044cb(analyticKey, statusCode, traceIds, isRetried, {
        cause: cause,
        affectsReliability: affectsReliability,
        skipSentry: skipSentry
    });
    return {
        traceIds: traceIds,
        statusCode: statusCode
    };
};
const $a44b9e0843f942ee$export$3a2ff6315865acd7 = (analyticKey, traceId, isRetried = false)=>{
    $a44b9e0843f942ee$export$93d0b35b696044cb(analyticKey, '200', traceId, isRetried);
};

});


parcelRegister("9ouT3", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", () => $c45bfe021d1ff9c6$export$86db56030b57ba34);
$parcel$export(module.exports, "mutationMetrics", () => $c45bfe021d1ff9c6$export$bc11f2f91fc3aebe);
$parcel$export(module.exports, "queryMetrics", () => $c45bfe021d1ff9c6$export$d22c4382fb7221a0);

var $4vTMF = parcelRequire("4vTMF");

var $lNfG4 = parcelRequire("lNfG4");

var $gf0vG = parcelRequire("gf0vG");


var $3CcSr = parcelRequire("3CcSr");
const $c45bfe021d1ff9c6$var$STATE_CHANGE_BASED_ISSUE_HIDDEN_FLAGS = 'jsw.roadmap.state-change-based-issue-hidden-flags';
const $c45bfe021d1ff9c6$var$buildInteractionParameters = (type, featureFlags)=>{
    const slo = (0, $3CcSr.default)[type] || 0;
    return {
        key: `roadmap.${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(type)}`,
        featureFlags: featureFlags,
        ...slo ? {
            slo: {
                response: {
                    threshold: slo
                },
                result: {
                    threshold: slo
                }
            }
        } : undefined
    };
};
const $c45bfe021d1ff9c6$var$getInteractionMetrics = (type, featureFlags)=>(0, $lNfG4.metrics).interaction($c45bfe021d1ff9c6$var$buildInteractionParameters(type, featureFlags));
const $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics = (type)=>(0, $lNfG4.metrics).concurrent.interaction($c45bfe021d1ff9c6$var$buildInteractionParameters(type));
const $c45bfe021d1ff9c6$export$86db56030b57ba34 = {
    [(0, $gf0vG.LIST_DRAG_AND_DROP)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $gf0vG.LIST_DRAG_AND_DROP)),
    [(0, $gf0vG.CHILD_LIST_DRAG_AND_DROP)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $gf0vG.CHILD_LIST_DRAG_AND_DROP)),
    [(0, $gf0vG.LIST_RESIZE_DRAG_AND_DROP)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $gf0vG.LIST_RESIZE_DRAG_AND_DROP)),
    [(0, $028d5637f56fe710$export$3ac90e7f239a7193)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $028d5637f56fe710$export$3ac90e7f239a7193)),
    [(0, $028d5637f56fe710$export$2475592765cae5b0)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $028d5637f56fe710$export$2475592765cae5b0)),
    [(0, $028d5637f56fe710$export$26d8759f6f1c8e13)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $028d5637f56fe710$export$26d8759f6f1c8e13)),
    [(0, $gf0vG.SCROLLED)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $gf0vG.SCROLLED)),
    [(0, $028d5637f56fe710$export$a0d61e9ea4ad5a05)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $028d5637f56fe710$export$a0d61e9ea4ad5a05), [
        $c45bfe021d1ff9c6$var$STATE_CHANGE_BASED_ISSUE_HIDDEN_FLAGS
    ]),
    [(0, $028d5637f56fe710$export$eedef6333f320132)]: $c45bfe021d1ff9c6$var$getInteractionMetrics((0, $028d5637f56fe710$export$eedef6333f320132))
};
const $c45bfe021d1ff9c6$export$bc11f2f91fc3aebe = {
    [(0, $028d5637f56fe710$export$2afae5ee414caffb)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$2afae5ee414caffb)),
    [(0, $028d5637f56fe710$export$5913ec3a0f9505fe)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$5913ec3a0f9505fe)),
    [(0, $028d5637f56fe710$export$488a6fa9078615df)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$488a6fa9078615df)),
    [(0, $028d5637f56fe710$export$315e0cbd8c7bfbd4)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$315e0cbd8c7bfbd4)),
    [(0, $028d5637f56fe710$export$e04dc5133fcac555)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$e04dc5133fcac555)),
    [(0, $028d5637f56fe710$export$f096bf13c1d89b91)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$f096bf13c1d89b91))
};
const $c45bfe021d1ff9c6$export$d22c4382fb7221a0 = {
    [(0, $028d5637f56fe710$export$12daf7ce2c179397)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$12daf7ce2c179397)),
    [(0, $028d5637f56fe710$export$bd4cd00ee0750c9a)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$bd4cd00ee0750c9a)),
    [(0, $028d5637f56fe710$export$9e57feecc7b4c365)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$9e57feecc7b4c365)),
    [(0, $028d5637f56fe710$export$ede40e627a0cbf14)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$ede40e627a0cbf14)),
    [(0, $028d5637f56fe710$export$1df1eb270f208354)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$1df1eb270f208354)),
    [(0, $028d5637f56fe710$export$d21f08c0570f92f7)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$d21f08c0570f92f7)),
    [(0, $028d5637f56fe710$export$72305db43681d1de)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$72305db43681d1de)),
    [(0, $028d5637f56fe710$export$51617034fb6f2e3a)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$51617034fb6f2e3a)),
    [(0, $028d5637f56fe710$export$d959a123e6ceb778)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$d959a123e6ceb778)),
    [(0, $028d5637f56fe710$export$2e07b3a26c033d37)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$2e07b3a26c033d37)),
    [(0, $028d5637f56fe710$export$57a4171901f1c15b)]: $c45bfe021d1ff9c6$var$getConcurrentInteractionMetrics((0, $028d5637f56fe710$export$57a4171901f1c15b))
};

});
parcelRegister("3CcSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $888c1f9be1faeaf7$export$2e2bcd8739ae039);

const $888c1f9be1faeaf7$var$railTargets = {
    animation: 16,
    inline: 100,
    load: 1000
};
const $888c1f9be1faeaf7$var$serverResponseTargets = {
    fetch: 750,
    bulk: 2000,
    mutate: 2500,
    fastMutate: 1500,
    slowFetch: 1000
};
const $888c1f9be1faeaf7$var$interactionSLOs = {
    [(0, $028d5637f56fe710$export$2475592765cae5b0)]: $888c1f9be1faeaf7$var$railTargets.inline,
    [(0, $028d5637f56fe710$export$26d8759f6f1c8e13)]: $888c1f9be1faeaf7$var$railTargets.load,
    [(0, $028d5637f56fe710$export$2afae5ee414caffb)]: $888c1f9be1faeaf7$var$serverResponseTargets.mutate,
    [(0, $028d5637f56fe710$export$315e0cbd8c7bfbd4)]: $888c1f9be1faeaf7$var$serverResponseTargets.bulk,
    [(0, $028d5637f56fe710$export$e04dc5133fcac555)]: $888c1f9be1faeaf7$var$serverResponseTargets.fastMutate,
    [(0, $028d5637f56fe710$export$5913ec3a0f9505fe)]: $888c1f9be1faeaf7$var$serverResponseTargets.fetch,
    [(0, $028d5637f56fe710$export$12daf7ce2c179397)]: $888c1f9be1faeaf7$var$serverResponseTargets.fetch,
    [(0, $028d5637f56fe710$export$ede40e627a0cbf14)]: $888c1f9be1faeaf7$var$serverResponseTargets.fetch,
    [(0, $028d5637f56fe710$export$72305db43681d1de)]: $888c1f9be1faeaf7$var$serverResponseTargets.slowFetch,
    [(0, $028d5637f56fe710$export$51617034fb6f2e3a)]: $888c1f9be1faeaf7$var$serverResponseTargets.slowFetch,
    [(0, $028d5637f56fe710$export$2e07b3a26c033d37)]: $888c1f9be1faeaf7$var$serverResponseTargets.fetch,
    [(0, $028d5637f56fe710$export$bd4cd00ee0750c9a)]: $888c1f9be1faeaf7$var$serverResponseTargets.fetch,
    [(0, $028d5637f56fe710$export$9e57feecc7b4c365)]: $888c1f9be1faeaf7$var$serverResponseTargets.fetch,
    [(0, $028d5637f56fe710$export$57a4171901f1c15b)]: $888c1f9be1faeaf7$var$serverResponseTargets.fetch
};
var $888c1f9be1faeaf7$export$2e2bcd8739ae039 = $888c1f9be1faeaf7$var$interactionSLOs;

});




parcelRegister("eZqh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $84af175e40bb7ef6$export$2e2bcd8739ae039);
parcelRequire("kQbL4");
parcelRequire("kO85v");

var $3JafE = parcelRequire("3JafE");

var $eC0P8 = parcelRequire("eC0P8");

var $lgKTA = parcelRequire("lgKTA");

var $6489W = parcelRequire("6489W");

var $gdFA6 = parcelRequire("gdFA6");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$84af175e40bb7ef6$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $gdFA6.JQL_FILTERS_REAPPLY)).switchMap(()=>{
        const state = store.getState();
        // Only expecting either quick filters to exist or custom filters to exist, but never both.
        const quickFilterIds = (0, $6489W.getQuickFilters)(state);
        const customFilterIds = (0, $6489W.getCustomFilters)(state);
        const isJQLFilterApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
        const sourceARI = (0, $lgKTA.getSourceARI)(state);
        if (isJQLFilterApplied) // Deferred due to query automatically subscribing when filterItemsByJQLFilters is
        // called rather than subscribing when the outer observable is subscribed to.
        // Now when switchMap switches its inner observable, the previous request will be
        // cancelled.
        return (0, $3JafE.Observable).defer(()=>(0, $eC0P8.filterItemsByJQLFilters)(sourceARI, quickFilterIds, customFilterIds).map((issueIds)=>(0, $gdFA6.jqlFiltersSuccess)(issueIds)));
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("5uaAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $19fb2a9ccd5b7b12$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("b48pz");
parcelRequire("3wBUP");
parcelRequire("flmol");

var $3JafE = parcelRequire("3JafE");

var $jAy5L = parcelRequire("jAy5L");

var $eC0P8 = parcelRequire("eC0P8");

var $lgKTA = parcelRequire("lgKTA");

var $gdFA6 = parcelRequire("gdFA6");
const $19fb2a9ccd5b7b12$var$filter = (action, store)=>{
    const state = store.getState();
    const quickFilterIds = action.payload;
    if (!quickFilterIds || !quickFilterIds.length) return (0, $3JafE.Observable).of((0, $gdFA6.clearQuickFilters)());
    return (0, $eC0P8.filterItemsByJQLFilters)((0, $lgKTA.getSourceARI)(state), quickFilterIds).map((filteredIssueIds)=>(0, $gdFA6.jqlFiltersSuccess)(filteredIssueIds));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$19fb2a9ccd5b7b12$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $gdFA6.QUICK_FILTERS_REQUEST)).throttleTime(500, (0, $jAy5L.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$19fb2a9ccd5b7b12$var$filter(action, store));

});

parcelRegister("39L2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $f317e3f8539da730$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$f317e3f8539da730$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_ASSIGNEE_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                assignee: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("eLcvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a52e923e6fbd7ef$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$2a52e923e6fbd7ef$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_COMPONENT_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                component: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("30fUW", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b2bb2417276ded$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$58b2bb2417276ded$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_CUSTOM_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                customFilter: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("eizPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6745b66ed2fd5939$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $aSTh4 = parcelRequire("aSTh4");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$6745b66ed2fd5939$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $aSTh4.SET_DEPENDENCIES_VIEW_VISIBILITY)).map((action)=>{
        const hideDependencies = action.payload ? undefined : true;
        return (0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                hideDependencies: hideDependencies
            }));
    });

});

parcelRegister("fLwB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc81a42a4ae4fc18$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $cUmMY = parcelRequire("cUmMY");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$cc81a42a4ae4fc18$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_GOAL_FILTER)).map((action)=>{
        const state = store.getState();
        const goals = (0, $cUmMY.getGoalsHash)(state);
        return (0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                goal: action.payload.length > 0 ? action.payload.reduce((acc, id)=>{
                    const goal = goals[id];
                    if (goal) acc.push(goal.goal.key);
                    return acc;
                }, []) : undefined
            }));
    });

});

parcelRegister("fwyOi", function(module, exports) {

$parcel$export(module.exports, "default", () => $49bc7aec9cbca33e$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$49bc7aec9cbca33e$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_ISSUE_PARENT_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                issueParent: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("6pY0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95c2a9751477552$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$e95c2a9751477552$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_ISSUE_TYPE_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                issueType: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("enZin", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b88eaa87ef7432$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$57b88eaa87ef7432$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_LABEL_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                label: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("ckn21", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0b8531f6a3de59b$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $8vOu0 = parcelRequire("8vOu0");

var $aSTh4 = parcelRequire("aSTh4");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d0b8531f6a3de59b$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $aSTh4.SET_LEVEL_ONE_SETTING)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>{
            let levelOneView = (0, $8vOu0.INCOMPLETE);
            if (action.payload.showCompleted) levelOneView = (0, $8vOu0.periodToLevelOneQuerySettingsMap).get(action.payload.period);
            return {
                ...query,
                epic: levelOneView
            };
        }));

});

parcelRegister("1XQKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8d4078fa06edc6$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $aSTh4 = parcelRequire("aSTh4");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$1d8d4078fa06edc6$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $aSTh4.SET_PROGRESS_VISIBILITY)).map((action)=>{
        const hideProgress = action.payload ? undefined : true;
        return (0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                hideProgress: hideProgress
            }));
    });

});

parcelRegister("7i2Xg", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d43c9d7dab3d84$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$26d43c9d7dab3d84$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_QUICK_FILTERS_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                quickFilter: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("162RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f261dd3f9d726bc$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $aSTh4 = parcelRequire("aSTh4");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$0f261dd3f9d726bc$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $aSTh4.SET_RELEASES_VISIBILITY)).map((action)=>{
        const hideVersionHeader = action.payload ? undefined : true;
        return (0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                hideVersionHeader: hideVersionHeader
            }));
    });

});

parcelRegister("jqxCh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c12dceb195f4090e$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $56Mmd = parcelRequire("56Mmd");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$c12dceb195f4090e$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $56Mmd.SET_SHARED)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                shared: action.payload
            })));

});
parcelRegister("56Mmd", function(module, exports) {

$parcel$export(module.exports, "SET_SHARED", () => $70f01d7069f9a0c7$export$bf0c919e7ee37f3f);
$parcel$export(module.exports, "setShared", () => $70f01d7069f9a0c7$export$72030e9b32b3f1bb);
$parcel$export(module.exports, "EXPORT_CSV", () => $70f01d7069f9a0c7$export$8ecd527409aaf724);
$parcel$export(module.exports, "exportCsv", () => $70f01d7069f9a0c7$export$6a3b3e40f9ef1478);
const $70f01d7069f9a0c7$export$bf0c919e7ee37f3f = 'state.ui.share.SET_SHARED';
const $70f01d7069f9a0c7$export$72030e9b32b3f1bb = (payload)=>({
        type: $70f01d7069f9a0c7$export$bf0c919e7ee37f3f,
        payload: payload
    });
const $70f01d7069f9a0c7$export$8ecd527409aaf724 = 'state.ui.share.EXPORT_CSV';
const $70f01d7069f9a0c7$export$6a3b3e40f9ef1478 = (payload)=>({
        type: $70f01d7069f9a0c7$export$8ecd527409aaf724,
        payload: payload
    });

});


parcelRegister("cNjG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3d731d96dafee96$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d3d731d96dafee96$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_STATUS_CATEGORY_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                statuses: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("7pAws", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f27e585d93f234e$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$4f27e585d93f234e$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_TEXT_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                text: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("eT3kf", function(module, exports) {

$parcel$export(module.exports, "default", () => $56fc4fb215cb076c$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$56fc4fb215cb076c$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_TIMELINE_MODE)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                // reset timeline if it equals to default MONTHS
                timeline: action.payload
            })));

});

parcelRegister("jeiZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $630b3f3f7d7e2571$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $gdFA6 = parcelRequire("gdFA6");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$630b3f3f7d7e2571$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $gdFA6.SET_VERSION_FILTER)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                version: action.payload.length > 0 ? action.payload : undefined
            })));

});

parcelRegister("4tdkz", function(module, exports) {

$parcel$export(module.exports, "default", () => $55998b4b951ab8c3$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $aSTh4 = parcelRequire("aSTh4");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$55998b4b951ab8c3$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $aSTh4.SET_WARNINGS_VISIBILITY)).map((action)=>{
        const hideWarnings = action.payload ? undefined : true;
        return (0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                hideWarnings: hideWarnings
            }));
    });

});


parcelRegister("6Syto", function(module, exports) {

$parcel$export(module.exports, "default", () => $da69c65c2e0dda64$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $klf8N = parcelRequire("klf8N");

var $hkAC7 = parcelRequire("hkAC7");

var $aECmE = parcelRequire("aECmE");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$da69c65c2e0dda64$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $aECmE.default), (0, $hkAC7.default), (0, $klf8N.default));

});
parcelRegister("klf8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bb1216c8c43ad12$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $huI7r = parcelRequire("huI7r");

var $f8xAg = parcelRequire("f8xAg");

var $9BmXV = parcelRequire("9BmXV");

var $8ybWM = parcelRequire("8ybWM");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$9bb1216c8c43ad12$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $8ybWM.REQUEST_ISSUE_TYPES)).mergeMap((action)=>{
        const { cloudId: cloudId, projectId: projectId } = action.payload;
        return (0, $f8xAg.default)((0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(projectId)
        })).map((issueTypes)=>(0, $8ybWM.extendIssueTypes)(issueTypes)).catch(()=>(0, $3JafE.Observable).of((0, $9BmXV.aggError)()));
    });

});
parcelRegister("f8xAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9100001b0d4a225$export$2e2bcd8739ae039);

var $fGjzP = parcelRequire("fGjzP");

var $6vrw7 = parcelRequire("6vrw7");

var $55OQZ = parcelRequire("55OQZ");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");
const $d9100001b0d4a225$var$analyticKey = 'jira.frontend.fe.software.roadmap.filter-roadmap-items';
const $d9100001b0d4a225$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$2e07b3a26c033d37];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9100001b0d4a225$export$2e2bcd8739ae039 = (projectAri)=>(0, $8sMwH.runQueryWithMetadata)((0, $fGjzP.default), (0, $55OQZ.generateProjectIssueTypesQueryVariables)(projectAri), $d9100001b0d4a225$var$analyticKey, $d9100001b0d4a225$var$concurrentMetricDefinition).map(({ data: data })=>{
        const issueTypes = {};
        data.jira.jiraProject.issueTypes.edges.forEach((edge)=>{
            if (edge) {
                const { node: { issueTypeId: issueTypeId, avatar: avatar, name: name, description: description } } = edge;
                issueTypes[(0, $6vrw7.toIssueTypeId)(issueTypeId)] = {
                    name: name,
                    description: description || '',
                    iconUrl: avatar.medium || ''
                };
            }
        });
        return issueTypes;
    });

});
parcelRegister("fGjzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e381b7f54f1414$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<072b24458f8d9f4f3a915f15cac39ffe>>
 * @relayHash 6f4122f3aceda8ab3b15c7f0855270fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 936c169a1a3da60677b586f7416035e96cc19f2558c71ff347037e2d661f574f
const $74e381b7f54f1414$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "medium"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "cursor"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectIssueTypesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v2 /*: any*/ ,
                                                                            v3 /*: any*/ ,
                                                                            v4 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProject.issueTypes.edges.node.issueTypeId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v6 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProject.issueTypes.edges.node.avatar"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraProject.issueTypes.edges.node"
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jiraProject.issueTypes.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProject.issueTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectIssueTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "936c169a1a3da60677b586f7416035e96cc19f2558c71ff347037e2d661f574f",
            "metadata": {},
            "name": "projectIssueTypesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$74e381b7f54f1414$var$node.hash = "e1bde9923437b56592abdd2237c64176";
var $74e381b7f54f1414$export$2e2bcd8739ae039 = $74e381b7f54f1414$var$node;

});

parcelRegister("55OQZ", function(module, exports) {

$parcel$export(module.exports, "generateProjectIssueTypesQueryVariables", () => $5da02b69858ce15a$export$4053c97707dd7d85);
const $5da02b69858ce15a$export$4053c97707dd7d85 = (projectAri)=>({
        projectAri: projectAri
    });

});


parcelRegister("8ybWM", function(module, exports) {

$parcel$export(module.exports, "RETRIEVE_ISSUE_TYPE_COUNT", () => $1f2cf5efab19fa5d$export$6e62eb1ae117debe);
$parcel$export(module.exports, "retrieveIssueTypeCount", () => $1f2cf5efab19fa5d$export$d800abc79f7d0a4b);
$parcel$export(module.exports, "EXTEND_ISSUE_TYPE_COUNT", () => $1f2cf5efab19fa5d$export$7cea639a62ce64a2);
$parcel$export(module.exports, "extendIssueTypeCount", () => $1f2cf5efab19fa5d$export$388067634b61b046);
$parcel$export(module.exports, "RESOLVE", () => $1f2cf5efab19fa5d$export$4732ab3df087d9be);
$parcel$export(module.exports, "SET_RESOLVING", () => $1f2cf5efab19fa5d$export$bbea77d4819d05b3);
$parcel$export(module.exports, "setResolving", () => $1f2cf5efab19fa5d$export$d6f73a1d23a0f84c);
$parcel$export(module.exports, "UPDATE_HEALTHCHECK", () => $1f2cf5efab19fa5d$export$88295fbb4c70ff7b);
$parcel$export(module.exports, "updateHealthcheck", () => $1f2cf5efab19fa5d$export$a58491703ac419fb);
$parcel$export(module.exports, "RESOLVE_HEALTHCHECK", () => $1f2cf5efab19fa5d$export$f096bf13c1d89b91);
$parcel$export(module.exports, "resolveHealthcheck", () => $1f2cf5efab19fa5d$export$65c820cb5cc3a669);
$parcel$export(module.exports, "REQUEST_ISSUE_TYPES", () => $1f2cf5efab19fa5d$export$8c9d9e8eaa5b8c93);
$parcel$export(module.exports, "requestIssueTypes", () => $1f2cf5efab19fa5d$export$f615b4b60e70c65e);
$parcel$export(module.exports, "EXTEND_ISSUE_TYPES", () => $1f2cf5efab19fa5d$export$77b42279c05c291a);
$parcel$export(module.exports, "extendIssueTypes", () => $1f2cf5efab19fa5d$export$7f78f9436d5ef445);
const $1f2cf5efab19fa5d$export$6e62eb1ae117debe = 'state.ui.healthcheck.RETRIEVE_ISSUE_TYPE_COUNT';
const $1f2cf5efab19fa5d$export$d800abc79f7d0a4b = (payload)=>({
        type: $1f2cf5efab19fa5d$export$6e62eb1ae117debe,
        payload: payload
    });
const $1f2cf5efab19fa5d$export$7cea639a62ce64a2 = 'state.ui.healthcheck.EXTEND_ISSUE_TYPE_COUNT';
const $1f2cf5efab19fa5d$export$388067634b61b046 = (payload)=>({
        type: $1f2cf5efab19fa5d$export$7cea639a62ce64a2,
        payload: payload
    });
const $1f2cf5efab19fa5d$export$4732ab3df087d9be = 'state.ui.healthcheck.RESOLVE';
const $1f2cf5efab19fa5d$export$f7ad0328861e2f03 = (payload)=>({
        type: $1f2cf5efab19fa5d$export$4732ab3df087d9be,
        payload: payload
    });
const $1f2cf5efab19fa5d$export$bbea77d4819d05b3 = 'state.ui.healthcheck.SET_RESOLVING';
const $1f2cf5efab19fa5d$export$d6f73a1d23a0f84c = (payload)=>({
        type: $1f2cf5efab19fa5d$export$bbea77d4819d05b3,
        payload: payload
    });
const $1f2cf5efab19fa5d$export$88295fbb4c70ff7b = 'state.ui.healthcheck.UPDATE_HEALTHCHECK';
const $1f2cf5efab19fa5d$export$a58491703ac419fb = (payload)=>({
        type: $1f2cf5efab19fa5d$export$88295fbb4c70ff7b,
        payload: payload
    });
const $1f2cf5efab19fa5d$export$f096bf13c1d89b91 = 'state.ui.healthcheck.RESOLVE_HEALTHCHECK';
const $1f2cf5efab19fa5d$export$65c820cb5cc3a669 = (payload, analyticsEvent)=>({
        type: $1f2cf5efab19fa5d$export$f096bf13c1d89b91,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1f2cf5efab19fa5d$export$8c9d9e8eaa5b8c93 = 'state.ui.healthcheck.REQUEST_ISSUE_TYPES';
const $1f2cf5efab19fa5d$export$f615b4b60e70c65e = (payload)=>({
        type: $1f2cf5efab19fa5d$export$8c9d9e8eaa5b8c93,
        payload: payload
    });
const $1f2cf5efab19fa5d$export$77b42279c05c291a = 'state.ui.healthcheck.EXTEND_ISSUE_TYPES';
const $1f2cf5efab19fa5d$export$7f78f9436d5ef445 = (payload)=>({
        type: $1f2cf5efab19fa5d$export$77b42279c05c291a,
        payload: payload
    });

});


parcelRegister("hkAC7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a9af4d50dc9259$export$2e2bcd8739ae039);
parcelRequire("dM0Xt");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $jMP2a = parcelRequire("jMP2a");

var $2BAqi = parcelRequire("2BAqi");

var $6KDJ5 = parcelRequire("6KDJ5");

var $lgKTA = parcelRequire("lgKTA");

var $9BmXV = parcelRequire("9BmXV");

var $6489W = parcelRequire("6489W");

var $8ybWM = parcelRequire("8ybWM");

var $16ixF = parcelRequire("16ixF");

var $37nmJ = parcelRequire("37nmJ");
const $e8a9af4d50dc9259$var$transformLevelOneSelection = (levelOneIssueTypeSelection)=>{
    if (levelOneIssueTypeSelection) {
        if (levelOneIssueTypeSelection.issueTypeToPromote) return {
            promote: {
                promoteItemTypeId: String(levelOneIssueTypeSelection.issueTypeToPromote)
            }
        };
        if (levelOneIssueTypeSelection.epicName !== undefined && levelOneIssueTypeSelection.epicDescription !== undefined) return {
            create: {
                epicTypeName: levelOneIssueTypeSelection.epicName,
                epicTypeDescription: levelOneIssueTypeSelection.epicDescription
            }
        };
    }
    return undefined;
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$e8a9af4d50dc9259$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $8ybWM.RESOLVE_HEALTHCHECK)).mergeMap((action)=>{
        const state = store.getState();
        const sourceARI = (0, $lgKTA.getSourceARI)(state);
        const resolutionActionId = action.payload.actionId;
        const addLevelOneIssueType = $e8a9af4d50dc9259$var$transformLevelOneSelection(action.payload.levelOneIssueTypeSelection);
        const resolveHealthcheckObservable = (0, $2BAqi.resolveHealthcheckFromServer)(sourceARI, resolutionActionId, addLevelOneIssueType).mergeMap((response)=>{
            const resolveRoadmapHealthcheckData = response.roadmaps?.resolveRoadmapHealthcheck;
            const errors = resolveRoadmapHealthcheckData?.errors;
            const success = resolveRoadmapHealthcheckData?.success;
            if (success === false && errors?.length) return (0, $16ixF.onHandleAggErrors)(!!resolveRoadmapHealthcheckData, errors).map((aggErrors)=>(0, $MYW4e.batchActions)([
                    (0, $8ybWM.setResolving)(false),
                    aggErrors
                ]));
            (0, $jMP2a.fireTrackAnalytics)(action.meta.analyticsEvent, 'healthcheck resolved', 'roadmapHealthcheck', {
                projectType: 'software',
                resolutionActionId: resolutionActionId
            });
            action.payload.refreshNavigationData();
            const query = (0, $6489W.getQuery)(state);
            return (0, $6KDJ5.getCriticalDataObservable)((0, $lgKTA.getSourceARI)(state), query, undefined).mergeMap((criticalData)=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
                    ...(0, $37nmJ.getCriticalDataActions)(criticalData),
                    (0, $8ybWM.setResolving)(false)
                ])));
        }).catch(()=>(0, $3JafE.Observable).from([
                (0, $9BmXV.aggError)(),
                (0, $8ybWM.setResolving)(false)
            ]));
        return (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $8ybWM.setResolving)(true)), resolveHealthcheckObservable);
    });

});
parcelRegister("2BAqi", function(module, exports) {

$parcel$export(module.exports, "resolveHealthcheckFromServer", () => $ba470cf3d38fc865$export$1499faa3a2f25f61);

var $ctgLS = parcelRequire("ctgLS");


var $jie15 = parcelRequire("jie15");

var $9ouT3 = parcelRequire("9ouT3");
const $ba470cf3d38fc865$var$mutationName = 'resolveHealthcheck';
const $ba470cf3d38fc865$var$concurrentMetricDefinition = (0, $9ouT3.mutationMetrics)[0, $028d5637f56fe710$export$f096bf13c1d89b91];
const $ba470cf3d38fc865$var$analyticKey = 'jira.frontend.fe.software.roadmap.resolve-roadmap-healthcheck';
const $ba470cf3d38fc865$export$1499faa3a2f25f61 = (sourceARI, actionId, addLevelOneIssueType)=>{
    const variables = {
        sourceARI: sourceARI,
        input: {
            actionId: actionId,
            addLevelOneIssueType: addLevelOneIssueType
        }
    };
    return (0, $jie15.runMutation)($ba470cf3d38fc865$var$mutationName, (0, $ctgLS.default), variables, $ba470cf3d38fc865$var$analyticKey, $ba470cf3d38fc865$var$concurrentMetricDefinition);
};

});
parcelRegister("ctgLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a6791b0d31a8cd8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aaf856764ab7f6d3002ddce971058f8f>>
 * @relayHash 800f7f5d14028fe401831f044c0b82ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 33a869b2348eba3530cb6f638df8e5e0d286115c291912fded9f10e48df8e18a
const $3a6791b0d31a8cd8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceARI"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceARI"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            },
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ],
        "type": "RoadmapMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "resolveHealthcheckMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapResolveHealthcheckPayload",
                            "kind": "LinkedField",
                            "name": "resolveRoadmapHealthcheck",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "resolveHealthcheckMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapResolveHealthcheckPayload",
                            "kind": "LinkedField",
                            "name": "resolveRoadmapHealthcheck",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "33a869b2348eba3530cb6f638df8e5e0d286115c291912fded9f10e48df8e18a",
            "metadata": {},
            "name": "resolveHealthcheckMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3a6791b0d31a8cd8$var$node.hash = "7937429ceae92519546484200a3f3d14";
var $3a6791b0d31a8cd8$export$2e2bcd8739ae039 = $3a6791b0d31a8cd8$var$node;

});

parcelRegister("jie15", function(module, exports) {

$parcel$export(module.exports, "runMutation", () => $8e31dd82d4b80c0f$export$5484b58371dd1c3a);

var $illlw = parcelRequire("illlw");

var $iWLL0 = parcelRequire("iWLL0");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $amu7D = parcelRequire("amu7D");

var $15ZJO = parcelRequire("15ZJO");

var $5udmX = parcelRequire("5udmX");

var $aJyoc = parcelRequire("aJyoc");
parcelRequire("cpH8E");
parcelRequire("l5lul");
parcelRequire("1Lcr1");

var $b0VLP = parcelRequire("b0VLP");
const $8e31dd82d4b80c0f$export$5484b58371dd1c3a = (mutationName, mutation, variables, analyticKey, concurrentMetricDefinition)=>{
    const operationName = `${mutationName}Mutation`;
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
    (0, $5udmX.startCapturingTraceIds)(operationName);
    const errorCollector = (0, $15ZJO.startCaptureGraphQlErrors)();
    if ((0, $aJyoc.isUnsubscribableMutationEnabled)()) {
        concurrentMetricDefinition(concurrentId).start();
        return (0, $b0VLP.commitMutationObservable)((0, $amu7D.default)(), {
            mutation: mutation,
            variables: variables
        }).do((data)=>{
            concurrentMetricDefinition(concurrentId).stop();
            const mutationPayload = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, [
                'roadmaps',
                mutationName
            ]);
            if (!mutationPayload || mutationPayload.success !== true) {
                const statusCode = mutationPayload ? (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(mutationPayload, [
                    'errors',
                    0,
                    'extensions',
                    'statusCode'
                ], 'unknown') : 'unknown';
                const relevantErrors = (0, $b0VLP.getGraphQlErrorsForOperation)(errorCollector, operationName);
                const transformedError = (0, $b0VLP.transformGraphQLErrors)(relevantErrors, operationName, (0, $5udmX.getTraceIds)(operationName));
                (0, $b0VLP.sendOperationalEventV2OnError)(transformedError, analyticKey, false, String(statusCode));
            } else (0, $b0VLP.sendOperationalEvent)(analyticKey, '200', (0, $5udmX.getTraceIds)(operationName));
            (0, $5udmX.stopCapturingTraceIds)(operationName);
        }).catch((error)=>{
            concurrentMetricDefinition(concurrentId).stop();
            const transformedError = (0, $b0VLP.transformGenericError)(error, (0, $5udmX.getTraceIds)(operationName), operationName);
            (0, $b0VLP.sendOperationalEventV2OnError)(transformedError, analyticKey, false);
            (0, $5udmX.stopCapturingTraceIds)(operationName);
            throw error;
        });
    }
    return (0, $3JafE.Observable).fromPromise(new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reject)=>{
        concurrentMetricDefinition(concurrentId).start();
        (0, $iWLL0.commitMutation)((0, $amu7D.default)(), {
            mutation: mutation,
            variables: variables,
            onCompleted: (data)=>{
                concurrentMetricDefinition(concurrentId).stop();
                const mutationPayload = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, [
                    'roadmaps',
                    mutationName
                ]);
                if (!mutationPayload || mutationPayload.success !== true) {
                    const statusCode = mutationPayload ? (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(mutationPayload, [
                        'errors',
                        0,
                        'extensions',
                        'statusCode'
                    ], 'unknown') : 'unknown';
                    const relevantErrors = (0, $b0VLP.getGraphQlErrorsForOperation)(errorCollector, operationName);
                    const transformedError = (0, $b0VLP.transformGraphQLErrors)(relevantErrors, operationName, (0, $5udmX.getTraceIds)(operationName));
                    (0, $b0VLP.sendOperationalEventV2OnError)(transformedError, analyticKey, false, String(statusCode));
                } else (0, $b0VLP.sendOperationalEventV2OnSuccess)(analyticKey, (0, $5udmX.getTraceIds)(operationName));
                (0, $5udmX.stopCapturingTraceIds)(operationName);
                resolve(data);
            },
            onError: (error)=>{
                concurrentMetricDefinition(concurrentId).stop();
                const transformedError = (0, $b0VLP.transformGenericError)(error, (0, $5udmX.getTraceIds)(operationName), operationName);
                (0, $b0VLP.sendOperationalEventV2OnError)(transformedError, analyticKey, false);
                (0, $5udmX.stopCapturingTraceIds)(operationName);
                reject(error);
            }
        });
    }));
};

});


parcelRegister("6KDJ5", function(module, exports) {

$parcel$export(module.exports, "getCriticalDataObservable", () => $ed781dce82af9335$export$3e7267aae1bc4);
$parcel$export(module.exports, "getCriticalDataWithEagerLoading", () => $ed781dce82af9335$export$ac6421fe3567f604);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jAXdN");
parcelRequire("jyKN9");
parcelRequire("flmol");

var $exdf9 = parcelRequire("exdf9");

var $eC0P8 = parcelRequire("eC0P8");

var $668VM = parcelRequire("668VM");
const $ed781dce82af9335$var$mapResult = (configuration, issues, statusCategories, users, settings, metadata, healthcheck, filteredIssueIds, eagerLoadedData)=>({
        configuration: configuration,
        issues: issues,
        statusCategories: statusCategories,
        users: users,
        settings: settings,
        metadata: metadata,
        healthcheck: healthcheck,
        filteredIssueIds: filteredIssueIds,
        eagerLoadedData: eagerLoadedData
    });
const $ed781dce82af9335$export$3e7267aae1bc4 = (sourceAri, query, locationAri)=>{
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    let filteredIssuesObservable = (0, $3JafE.Observable).of(undefined);
    const customFilters = query?.customFilter ?? [];
    const quickFilters = query?.quickFilter ?? [];
    if (quickFilters.length > 0 || customFilters.length > 0) filteredIssuesObservable = (0, $eC0P8.filterItemsByJQLFilters)(sourceAri, quickFilters, customFilters);
    return (0, $3JafE.Observable).zip((0, $exdf9.default)(sourceAri, locationAri), filteredIssuesObservable, ({ currentUser: currentUser, configuration: configuration, statusCategories: statusCategories, issues: issues, users: users, metadata: metadata, settings: settings, healthcheck: healthcheck }, filteredIssueIds)=>{
        const mappedCriticalData = $ed781dce82af9335$var$mapResult(configuration, issues, statusCategories, {
            ...currentUser,
            ...users
        }, settings, metadata, healthcheck, filteredIssueIds);
        return mappedCriticalData;
    });
};
const $ed781dce82af9335$export$ac6421fe3567f604 = (sourceAri, routerDataContext, locationAri)=>(0, $3JafE.Observable).zip((0, $exdf9.default)(sourceAri, locationAri), (0, $668VM.fetchEagerLoadedData)(sourceAri, routerDataContext), ({ currentUser: currentUser, configuration: configuration, statusCategories: statusCategories, issues: issues, users: users, metadata: metadata, settings: settings, healthcheck: healthcheck }, eagerLoadedlData)=>{
        const mappedCriticalData = $ed781dce82af9335$var$mapResult(configuration, issues, statusCategories, {
            ...currentUser,
            ...users
        }, settings, metadata, healthcheck, undefined, eagerLoadedlData);
        return mappedCriticalData;
    });

});
parcelRegister("exdf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d8d7f9490ee9a2d$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $lAqFh = parcelRequire("lAqFh");

var $5mLzd = parcelRequire("5mLzd");


var $dGP5L = parcelRequire("dGP5L");

var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");

var $9I3mY = parcelRequire("9I3mY");
const $3d8d7f9490ee9a2d$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$12daf7ce2c179397];
const $3d8d7f9490ee9a2d$var$analyticKey = 'jira.frontend.fe.software.roadmap.critical-data';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d8d7f9490ee9a2d$export$2e2bcd8739ae039 = (sourceAri, locationAri)=>(0, $8sMwH.runQueryWithMetadata)((0, $lAqFh.default), (0, $5mLzd.generateCriticalDataQueryVariables)(sourceAri, locationAri), $3d8d7f9490ee9a2d$var$analyticKey, $3d8d7f9490ee9a2d$var$concurrentMetricDefinition).map(({ data: data, metadata: { traceIds: traceIds, operationName: operationName, extensions: extensions } })=>{
        if (!data?.roadmaps?.roadmapForSource || !data?.me?.user || data?.roadmaps?.roadmapForSource.healthcheck === null && data?.roadmaps?.roadmapForSource.content === null) throw new (0, $dGP5L.AggError)(`Failed to retrieve data via ${operationName}`, [], traceIds, (0, $dGP5L.MISSING_DATA_ERROR));
        const { content: content, healthcheck: healthcheck } = data.roadmaps.roadmapForSource;
        const items = content?.items?.edges || [];
        return {
            currentUser: (0, $9I3mY.transformCurrentUser)(data?.me?.user),
            roadmapConfiguration: content?.configuration ? (0, $9I3mY.transformRoadmapConfiguration)(content.configuration) : undefined,
            items: items.filter(Boolean) // TODO: "filter" to be removed after null/undefined is removed from edges in AGG schema
            .map(({ node: roadmapItem })=>roadmapItem),
            metadata: {
                traceIds: traceIds,
                extensions: extensions
            },
            healthcheck: (0, $9I3mY.transformHealthcheck)(healthcheck)
        };
    }).map((0, $9I3mY.transformCriticalData));

});
parcelRegister("lAqFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a21da87791504115$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<258e2579d0880422341fa205706415b5>>
 * @relayHash 5ba4a401d1ac4076883004f9bafe6d29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7faf0fcae69a16c1e634367363f5f232fda270030289124c5ef0cd9de019b126
const $a21da87791504115$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRoadmapsCriticalDataItemFlaggedEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "explanation"
    }, v11 = {
        "concreteType": "RoadmapHealthCheckLink",
        "kind": "LinkedField",
        "name": "learnMore",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v12 = {
        "concreteType": "RoadmapHealthCheckResolution",
        "kind": "LinkedField",
        "name": "resolution",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "label"
            },
            {
                "kind": "ScalarField",
                "name": "actionId"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "rankIssuesSupported"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isCrossProject"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isDependenciesEnabled"
    }, v16 = {
        "kind": "ScalarField",
        "name": "inwardDependencyDescription"
    }, v17 = {
        "kind": "ScalarField",
        "name": "outwardDependencyDescription"
    }, v18 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v19 = {
        "kind": "ScalarField",
        "name": "isUserBoardAdmin"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isBoardJqlFilteringOutEpics"
    }, v21 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    }, v22 = {
        "kind": "ScalarField",
        "name": "isChildIssuePlanningEnabled"
    }, v23 = {
        "kind": "ScalarField",
        "name": "state"
    }, v24 = {
        "kind": "ScalarField",
        "name": "startDateRFC3339"
    }, v25 = {
        "kind": "ScalarField",
        "name": "endDateRFC3339"
    }, v26 = {
        "kind": "ScalarField",
        "name": "childIssuePlanningMode"
    }, v27 = {
        "concreteType": "RoadmapField",
        "kind": "LinkedField",
        "name": "derivedFields",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "values"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "projectKey"
    }, v30 = {
        "kind": "ScalarField",
        "name": "projectName"
    }, v31 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v32 = {
        "kind": "ScalarField",
        "name": "requiredFieldIds"
    }, v33 = {
        "kind": "ScalarField",
        "name": "canEditIssues"
    }, v34 = {
        "kind": "ScalarField",
        "name": "canScheduleIssues"
    }, v35 = {
        "kind": "ScalarField",
        "name": "canCreateIssues"
    }, v36 = {
        "kind": "ScalarField",
        "name": "canAdministerProjects"
    }, v37 = {
        "kind": "ScalarField",
        "name": "status"
    }, v38 = {
        "kind": "ScalarField",
        "name": "releaseDate"
    }, v39 = {
        "kind": "ScalarField",
        "name": "isReleasesFeatureEnabled"
    }, v40 = {
        "kind": "ScalarField",
        "name": "defaultItemTypeId"
    }, v41 = {
        "kind": "ScalarField",
        "name": "isGoalsFeatureEnabled"
    }, v42 = {
        "kind": "ScalarField",
        "name": "startDateField"
    }, v43 = {
        "kind": "ScalarField",
        "name": "rankField"
    }, v44 = {
        "kind": "ScalarField",
        "name": "epicLinkField"
    }, v45 = {
        "kind": "ScalarField",
        "name": "epicNameField"
    }, v46 = {
        "kind": "ScalarField",
        "name": "sprintField"
    }, v47 = {
        "kind": "ScalarField",
        "name": "colorField"
    }, v48 = [
        v8 /*: any*/ ,
        v5 /*: any*/ 
    ], v49 = {
        "concreteType": "RoadmapFieldConfiguration",
        "kind": "LinkedField",
        "name": "fields",
        "plural": true,
        "selections": v48 /*: any*/ 
    }, v50 = {
        "kind": "ScalarField",
        "name": "key"
    }, v51 = {
        "kind": "ScalarField",
        "name": "itemTypes"
    }, v52 = {
        "kind": "ScalarField",
        "name": "isDependenciesVisible"
    }, v53 = {
        "kind": "ScalarField",
        "name": "isProgressVisible"
    }, v54 = {
        "kind": "ScalarField",
        "name": "isWarningsVisible"
    }, v55 = {
        "kind": "ScalarField",
        "name": "listWidth"
    }, v56 = {
        "kind": "ScalarField",
        "name": "timelineMode"
    }, v57 = {
        "kind": "ScalarField",
        "name": "period"
    }, v58 = {
        "kind": "ScalarField",
        "name": "showCompleted"
    }, v59 = {
        "kind": "ScalarField",
        "name": "isReleasesVisible"
    }, v60 = {
        "kind": "ScalarField",
        "name": "highlightedVersions"
    }, v61 = {
        "kind": "ScalarField",
        "name": "issuePanelRatio"
    }, v62 = {
        "kind": "ScalarField",
        "name": "levelOneName"
    }, v63 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v64 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v65 = {
        "kind": "ScalarField",
        "name": "dueDateRFC3339"
    }, v66 = {
        "kind": "ScalarField",
        "name": "color"
    }, v67 = {
        "kind": "ScalarField",
        "name": "dependencies"
    }, v68 = {
        "kind": "ScalarField",
        "name": "itemTypeId"
    }, v69 = {
        "kind": "ScalarField",
        "name": "rank"
    }, v70 = {
        "kind": "ScalarField",
        "name": "labels"
    }, v71 = {
        "kind": "ScalarField",
        "name": "sprintIds"
    }, v72 = {
        "kind": "ScalarField",
        "name": "versionIds"
    }, v73 = {
        "kind": "ScalarField",
        "name": "componentIds"
    }, v74 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v75 = {
        "kind": "ScalarField",
        "name": "flagged"
    }, v76 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ 
    ], v77 = [
        v8 /*: any*/ ,
        v31 /*: any*/ ,
        v5 /*: any*/ ,
        v32 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "roadmapCriticalDataQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "AuthenticationContext",
                        "kind": "LinkedField",
                        "name": "me",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v3 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "me.user.__typename"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v4 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "me.user.accountId"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v5 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "me.user.name"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "me.user.picture"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "me"
                },
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapHealthCheck",
                                    "kind": "LinkedField",
                                    "name": "healthcheck",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapForSource.healthcheck.id"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "RoadmapContent",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "RoadmapConfiguration",
                                                "kind": "LinkedField",
                                                "name": "configuration",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v13 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.rankIssuesSupported"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v14 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.isCrossProject"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapDependencyConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "dependencies",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v15 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.dependencies.isDependenciesEnabled"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v16 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.dependencies.inwardDependencyDescription"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v17 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.dependencies.outwardDependencyDescription"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.dependencies"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapBoardConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "boardConfiguration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v18 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.jql"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v19 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.isUserBoardAdmin"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v20 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.isBoardJqlFilteringOutEpics"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v21 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.isSprintsFeatureEnabled"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v22 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.isChildIssuePlanningEnabled"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "sprints",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v8 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v23 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.state"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v24 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.startDateRFC3339"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v25 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.endDateRFC3339"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v26 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.childIssuePlanningMode"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v27 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.derivedFields"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapProjectConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "projectConfiguration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v28 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.projectId"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v29 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.projectKey"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v30 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.projectName"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapItemType",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentItemTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v8 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v31 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes.iconUrl"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v32 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes.requiredFieldIds"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapItemType",
                                                                        "kind": "LinkedField",
                                                                        "name": "childItemTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v8 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v31 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes.iconUrl"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v32 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes.requiredFieldIds"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapProjectPermissions",
                                                                        "kind": "LinkedField",
                                                                        "name": "permissions",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v33 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions.canEditIssues"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v34 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions.canScheduleIssues"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v35 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions.canCreateIssues"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v36 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions.canAdministerProjects"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "versions",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v8 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.versions.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.versions.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v37 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.versions.status"
                                                                            },
                                                                            v38 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.versions"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapComponent",
                                                                        "kind": "LinkedField",
                                                                        "name": "components",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v8 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.components.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.components.name"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.components"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v39 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.isReleasesFeatureEnabled"
                                                                },
                                                                v40 /*: any*/ ,
                                                                v41 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapExternalConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "externalConfiguration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v42 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.startDateField"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v43 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.rankField"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v44 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.epicLinkField"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v45 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.epicNameField"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v46 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.sprintField"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v47 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.colorField"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v49 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.fields"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategories",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v8 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.statusCategories.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v50 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.statusCategories.key"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v5 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.statusCategories.name"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.statusCategories"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapUserConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "userConfiguration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapCreationPreferences",
                                                                        "kind": "LinkedField",
                                                                        "name": "creationPreferences",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v51 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.creationPreferences.itemTypes"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.creationPreferences"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v52 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.isDependenciesVisible"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v53 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.isProgressVisible"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v54 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.isWarningsVisible"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v55 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.listWidth"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v56 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.timelineMode"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapViewSettings",
                                                                        "kind": "LinkedField",
                                                                        "name": "levelOneViewSettings",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v57 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.levelOneViewSettings.period"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v58 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.levelOneViewSettings.showCompleted"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.levelOneViewSettings"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v59 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.isReleasesVisible"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v60 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.highlightedVersions"
                                                                },
                                                                v61 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapHierarchyConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchyConfiguration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v62 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.configuration.hierarchyConfiguration.levelOneName"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.configuration.hierarchyConfiguration"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapForSource.content.configuration"
                                        },
                                        {
                                            "concreteType": "RoadmapItemConnection",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "RoadmapItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "RoadmapItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v8 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v50 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.key"
                                                                        },
                                                                        v63 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v64 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.summary"
                                                                        },
                                                                        v24 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v66 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.color"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v67 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.dependencies"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v68 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.itemTypeId"
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "assignee",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v4 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node.assignee.accountId"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node.assignee.name"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v6 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node.assignee.picture"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "RoadmapItemStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v8 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node.status.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node.status.name"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": {
                                                                                        "concreteType": "RoadmapItemStatusCategory",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "statusCategory",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v8 /*: any*/ ,
                                                                                                "action": "THROW",
                                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.status.statusCategory.id"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node.status.statusCategory"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v69 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.rank"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v70 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.labels"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v71 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.sprintIds"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v72 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.versionIds"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v73 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.componentIds"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v74 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.resolved"
                                                                        },
                                                                        {
                                                                            "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v75 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node.flagged"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "roadmaps.roadmapForSource.content.items.edges"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "roadmapCriticalDataQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v76 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapHealthCheck",
                                    "kind": "LinkedField",
                                    "name": "healthcheck",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "RoadmapContent",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapConfiguration",
                                            "kind": "LinkedField",
                                            "name": "configuration",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "RoadmapDependencyConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "dependencies",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        {
                                                            "concreteType": "RoadmapSprint",
                                                            "kind": "LinkedField",
                                                            "name": "sprints",
                                                            "plural": true,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v23 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ 
                                                            ]
                                                        },
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "RoadmapProjectConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "projectConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        {
                                                            "concreteType": "RoadmapItemType",
                                                            "kind": "LinkedField",
                                                            "name": "parentItemTypes",
                                                            "plural": true,
                                                            "selections": v77 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "RoadmapItemType",
                                                            "kind": "LinkedField",
                                                            "name": "childItemTypes",
                                                            "plural": true,
                                                            "selections": v77 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "RoadmapProjectPermissions",
                                                            "kind": "LinkedField",
                                                            "name": "permissions",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                v34 /*: any*/ ,
                                                                v35 /*: any*/ ,
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "RoadmapVersion",
                                                            "kind": "LinkedField",
                                                            "name": "versions",
                                                            "plural": true,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v37 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "RoadmapComponent",
                                                            "kind": "LinkedField",
                                                            "name": "components",
                                                            "plural": true,
                                                            "selections": v48 /*: any*/ 
                                                        },
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v41 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "RoadmapExternalConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "externalConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v49 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "RoadmapStatusCategory",
                                                    "kind": "LinkedField",
                                                    "name": "statusCategories",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "RoadmapUserConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "userConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "RoadmapCreationPreferences",
                                                            "kind": "LinkedField",
                                                            "name": "creationPreferences",
                                                            "plural": false,
                                                            "selections": [
                                                                v51 /*: any*/ 
                                                            ]
                                                        },
                                                        v52 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        v54 /*: any*/ ,
                                                        v55 /*: any*/ ,
                                                        v56 /*: any*/ ,
                                                        {
                                                            "concreteType": "RoadmapViewSettings",
                                                            "kind": "LinkedField",
                                                            "name": "levelOneViewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v57 /*: any*/ ,
                                                                v58 /*: any*/ 
                                                            ]
                                                        },
                                                        v59 /*: any*/ ,
                                                        v60 /*: any*/ ,
                                                        v61 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "RoadmapHierarchyConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "hierarchyConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v62 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "RoadmapItemConnection",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "RoadmapItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "RoadmapItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v50 /*: any*/ ,
                                                                v63 /*: any*/ ,
                                                                v64 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v65 /*: any*/ ,
                                                                v66 /*: any*/ ,
                                                                v67 /*: any*/ ,
                                                                v68 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "assignee",
                                                                    "plural": false,
                                                                    "selections": v76 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "RoadmapItemStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "RoadmapItemStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v69 /*: any*/ ,
                                                                v70 /*: any*/ ,
                                                                v71 /*: any*/ ,
                                                                v72 /*: any*/ ,
                                                                v73 /*: any*/ ,
                                                                v74 /*: any*/ ,
                                                                {
                                                                    "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v75 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7faf0fcae69a16c1e634367363f5f232fda270030289124c5ef0cd9de019b126",
            "metadata": {},
            "name": "roadmapCriticalDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a21da87791504115$var$node.hash = "89db149db4d4f4d1b0c377d210f81bfb";
var $a21da87791504115$export$2e2bcd8739ae039 = $a21da87791504115$var$node;

});

parcelRegister("5mLzd", function(module, exports) {

$parcel$export(module.exports, "generateCriticalDataQueryVariables", () => $2ae15a933194cff9$export$9ffe3013471a2a01);

var $bKxX9 = parcelRequire("bKxX9");
const $2ae15a933194cff9$export$9ffe3013471a2a01 = (sourceAri, locationAri = null)=>({
        sourceAri: sourceAri,
        locationAri: locationAri,
        isRoadmapsCriticalDataItemFlaggedEnabled: (0, $bKxX9.ff)('jsw.timeline.return-flagged-attribute-fe')
    });

});

parcelRegister("9I3mY", function(module, exports) {

$parcel$export(module.exports, "transformHealthcheck", () => $338c6df4e1c0fea7$export$1bdeeafa873182c7);
$parcel$export(module.exports, "transformCurrentUser", () => $338c6df4e1c0fea7$export$6386c84a43c69c67);
$parcel$export(module.exports, "transformRoadmapConfiguration", () => $338c6df4e1c0fea7$export$89ded4c2b7361b2f);
$parcel$export(module.exports, "transformCriticalData", () => $338c6df4e1c0fea7$export$9bbdc053b14eb715);

var $iVIEg = parcelRequire("iVIEg");


var $8vOu0 = parcelRequire("8vOu0");


var $gf0vG = parcelRequire("gf0vG");

var $lfgcv = parcelRequire("lfgcv");

var $eUylY = parcelRequire("eUylY");

var $etZVu = parcelRequire("etZVu");

var $5LLIO = parcelRequire("5LLIO");

var $9doIl = parcelRequire("9doIl");

var $hmc1Z = parcelRequire("hmc1Z");
const $338c6df4e1c0fea7$export$1bdeeafa873182c7 = (healthcheck)=>{
    if (healthcheck) return healthcheck;
    return undefined;
};
const $338c6df4e1c0fea7$export$6386c84a43c69c67 = (currentUser)=>currentUser ? {
        [currentUser.accountId]: {
            displayName: currentUser.name,
            avatarUrls: {
                '16x16': currentUser.picture,
                '24x24': currentUser.picture,
                '32x32': currentUser.picture,
                '48x48': currentUser.picture
            }
        }
    } : undefined;
const $338c6df4e1c0fea7$export$89ded4c2b7361b2f = ({ dependencies: dependencies, externalConfiguration: externalConfiguration, ...rest })=>{
    const { isDependenciesEnabled: isDependenciesEnabled, ...dependenciesRest } = dependencies;
    return {
        ...rest,
        dependencies: {
            ...dependenciesRest,
            dependenciesEnabled: isDependenciesEnabled
        },
        externalConfiguration: externalConfiguration
    };
};
const $338c6df4e1c0fea7$var$transformItemTypes = (itemTypes)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    itemTypes.reduce((acc, itemType)=>{
        acc[itemType.id] = {
            iconUrl: itemType.iconUrl,
            name: itemType.name
        };
        return acc;
    }, {});
const $338c6df4e1c0fea7$var$transformVersions = (versions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    versions.reduce((acc, version)=>{
        acc[version.id] = {
            name: version.name,
            status: version.status,
            releaseDate: (0, $eUylY.optionalDateToUtcTimestamp)((0, $etZVu.nullableToOptional)(version.releaseDate))
        };
        return acc;
    }, {});
const $338c6df4e1c0fea7$var$transformComponents = (components)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    components.reduce((acc, component)=>{
        acc[component.id] = component;
        return acc;
    }, {});
const $338c6df4e1c0fea7$var$REQUIRED_FIELD_WHITELIST = [
    'reporter',
    'issuetype',
    'project',
    'summary'
];
const $338c6df4e1c0fea7$export$1b5f4e1a54578f29 = (itemTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requiredFieldsHash = {};
    itemTypes.forEach((itemType)=>{
        requiredFieldsHash[itemType.id] = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(itemType.requiredFieldIds, $338c6df4e1c0fea7$var$REQUIRED_FIELD_WHITELIST);
    });
    return requiredFieldsHash;
};
const $338c6df4e1c0fea7$var$transformProjectConfig = (projectConfig)=>{
    const itemTypes = [
        ...projectConfig.parentItemTypes,
        ...projectConfig.childItemTypes
    ];
    const defaultItemTypeId = projectConfig.defaultItemTypeId !== null && projectConfig.defaultItemTypeId !== undefined ? projectConfig.defaultItemTypeId : undefined;
    return {
        id: projectConfig.projectId,
        key: projectConfig.projectKey,
        name: projectConfig.projectName,
        permissions: {
            ...projectConfig.permissions
        },
        epicIssueTypeIds: projectConfig.parentItemTypes.map((epicItemType)=>epicItemType.id),
        requiredFields: $338c6df4e1c0fea7$export$1b5f4e1a54578f29(itemTypes),
        issueTypes: {
            hash: $338c6df4e1c0fea7$var$transformItemTypes(itemTypes)
        },
        versions: {
            hash: $338c6df4e1c0fea7$var$transformVersions(projectConfig.versions)
        },
        components: {
            hash: $338c6df4e1c0fea7$var$transformComponents(projectConfig.components)
        },
        defaultItemTypeId: defaultItemTypeId,
        isReleasesFeatureEnabled: projectConfig.isReleasesFeatureEnabled,
        isGoalsFeatureEnabled: projectConfig.isGoalsFeatureEnabled
    };
};
const $338c6df4e1c0fea7$var$transformSprintConfiguration = (sprintConfigs)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sprintConfigHash = {};
    sprintConfigs.forEach((sprintConfig)=>{
        const { id: id, name: name, state: state, startDateRFC3339: startDateRFC3339, endDateRFC3339: endDateRFC3339 } = sprintConfig;
        sprintConfigHash[id] = {
            id: id,
            name: name,
            state: state,
            startDate: (0, $eUylY.dateToUtcTimestamp)(startDateRFC3339),
            endDate: (0, $eUylY.dateToUtcTimestamp)(endDateRFC3339)
        };
    });
    return sprintConfigHash;
};
const $338c6df4e1c0fea7$var$transformChildIssuePlanningMode = (childIssuePlanningMode)=>{
    switch(childIssuePlanningMode){
        case 'DISABLED':
            return 0, $0237521e367b8052$export$8cd212c10b4124d2;
        case 'DATE':
            return 0, $0237521e367b8052$export$501a7fac1df67a49;
        case 'SPRINT':
        default:
            return 0, $0237521e367b8052$export$a316570a0dbfd2b0;
    }
};
const $338c6df4e1c0fea7$var$transformBoardConfiguration = (boardConfig)=>{
    const isSprintsFeatureEnabled = boardConfig.isSprintsFeatureEnabled === true;
    const isChildIssuePlanningEnabled = boardConfig.isChildIssuePlanningEnabled === true;
    const boardConfigTransformed = {
        ...boardConfig,
        isBoardJqlFilteringOutEpics: boardConfig.isBoardJqlFilteringOutEpics === true,
        isSprintsFeatureEnabled: isSprintsFeatureEnabled,
        isChildIssuePlanningEnabled: isChildIssuePlanningEnabled,
        childIssuePlanningMode: $338c6df4e1c0fea7$var$transformChildIssuePlanningMode(boardConfig.childIssuePlanningMode),
        sprints: {
            hash: boardConfig.sprints ? $338c6df4e1c0fea7$var$transformSprintConfiguration([
                ...boardConfig.sprints
            ]) : {},
            sequence: boardConfig.sprints.map((sprint)=>sprint.id)
        }
    };
    return boardConfigTransformed;
};
const $338c6df4e1c0fea7$var$transformConfiguration = (roadmapConfiguration)=>{
    const { dependencies: dependencies, externalConfiguration: externalConfiguration, rankIssuesSupported: rankIssuesSupported, isCrossProject: isCrossProject, boardConfiguration: boardConfiguration, projectConfiguration: projectConfiguration, hierarchyConfiguration: hierarchyConfiguration } = roadmapConfiguration;
    const { dependenciesEnabled: dependenciesEnabled, inwardDependencyDescription: inwardDependencyDescription, outwardDependencyDescription: outwardDependencyDescription } = dependencies;
    const { colorField: colorField, startDateField: startDateField, rankField: rankField, epicLinkField: epicLinkField, epicNameField: epicNameField, sprintField: sprintField } = externalConfiguration;
    return {
        today: (0, $lfgcv.getToday)(),
        rankIssuesSupported: rankIssuesSupported,
        isCrossProject: isCrossProject,
        startDateCustomFieldId: startDateField,
        lexoRankCustomFieldId: rankField,
        epicLinkCustomFieldId: epicLinkField,
        epicNameCustomFieldId: epicNameField,
        sprintCustomFieldId: sprintField,
        colorCustomFieldId: colorField,
        inwardDependencyDescription: (0, $etZVu.nullableToOptional)(inwardDependencyDescription),
        outwardDependencyDescription: (0, $etZVu.nullableToOptional)(outwardDependencyDescription),
        dependenciesSupported: dependenciesEnabled,
        projectConfiguration: $338c6df4e1c0fea7$var$transformProjectConfig(projectConfiguration),
        boardConfiguration: $338c6df4e1c0fea7$var$transformBoardConfiguration(boardConfiguration),
        hierarchyConfiguration: hierarchyConfiguration ?? {
            levelOneName: ''
        },
        deriveFields: (0, $9doIl.transformDerivedFieldsHash)(boardConfiguration.derivedFields),
        fields: [
            ...externalConfiguration.fields ?? []
        ],
        canInviteOthersToProject: false
    };
};
// NOTE: The only valuable bit of this transformer is to convert the itemTypeId from number to string, we should unify it between BE and FE to remove the transformation
const $338c6df4e1c0fea7$var$transformCreationPreference = (creationPreferences)=>{
    const itemTypes = {};
    if (creationPreferences && creationPreferences.itemTypes) Object.keys(creationPreferences.itemTypes).forEach((key)=>{
        const level = Number(key);
        const { itemTypeId: itemTypeId } = creationPreferences.itemTypes[level];
        itemTypes[level] = {
            itemTypeId: itemTypeId.toString()
        };
    });
    return {
        itemTypes: itemTypes
    };
};
const $338c6df4e1c0fea7$export$50644fb2a14d9591 = (setting)=>{
    const defaultSettings = {
        timelineMode: (0, $gf0vG.MONTHS),
        listWidth: (0, $gf0vG.DEFAULT_LIST_WIDTH)(),
        creationPreferences: {
            itemTypes: {}
        },
        isDependenciesVisible: true,
        isProgressVisible: true,
        isWarningsVisible: true,
        isReleasesVisible: true,
        highlightedVersions: [],
        levelOneViewSettings: (0, $8vOu0.DEFAULT_LEVEL_ONE_VIEW_SETTINGS),
        issuePanelRatio: (0, $1e509df9ee2402a3$export$75a24528ec4289ef)
    };
    if (setting) {
        defaultSettings.creationPreferences = $338c6df4e1c0fea7$var$transformCreationPreference(setting.creationPreferences);
        const { timelineMode: timelineMode = defaultSettings.timelineMode, listWidth: listWidth = defaultSettings.listWidth, isDependenciesVisible: isDependenciesVisible = defaultSettings.isDependenciesVisible, isProgressVisible: isProgressVisible = defaultSettings.isProgressVisible, isWarningsVisible: isWarningsVisible = defaultSettings.isWarningsVisible, isReleasesVisible: isReleasesVisible = defaultSettings.isReleasesVisible, highlightedVersions: highlightedVersions = defaultSettings.highlightedVersions, levelOneViewSettings: levelOneViewSettings = defaultSettings.levelOneViewSettings, issuePanelRatio: issuePanelRatio = defaultSettings.issuePanelRatio } = setting;
        return {
            ...defaultSettings,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timelineMode: timelineMode,
            listWidth: listWidth,
            isDependenciesVisible: isDependenciesVisible,
            isProgressVisible: isProgressVisible,
            isWarningsVisible: isWarningsVisible,
            isReleasesVisible: isReleasesVisible,
            highlightedVersions: [
                ...highlightedVersions
            ],
            levelOneViewSettings: levelOneViewSettings,
            issuePanelRatio: issuePanelRatio || defaultSettings.issuePanelRatio
        };
    }
    return defaultSettings;
};
const $338c6df4e1c0fea7$export$9bbdc053b14eb715 = ({ currentUser: currentUser, roadmapConfiguration: roadmapConfiguration, items: items, metadata: metadata, healthcheck: healthcheck })=>({
        currentUser: currentUser,
        configuration: roadmapConfiguration ? $338c6df4e1c0fea7$var$transformConfiguration(roadmapConfiguration) : undefined,
        statusCategories: roadmapConfiguration ? (0, $5LLIO.transformStatusCategories)([
            ...roadmapConfiguration.statusCategories
        ]) : undefined,
        settings: $338c6df4e1c0fea7$export$50644fb2a14d9591(roadmapConfiguration?.userConfiguration),
        ...(0, $hmc1Z.transformIssues)([
            ...items
        ]),
        metadata: {
            ...metadata
        },
        healthcheck: healthcheck
    });

});
const $1e509df9ee2402a3$export$75a24528ec4289ef = 0.35;

parcelRegister("lfgcv", function(module, exports) {

$parcel$export(module.exports, "getToday", () => $e3fa822dabb3902d$export$883228a582a7567d);
$parcel$export(module.exports, "getStartOfDay", () => $e3fa822dabb3902d$export$acfb4d8d6f22913c);
$parcel$export(module.exports, "getClosestStartOfDay", () => $e3fa822dabb3902d$export$3b10530a2652517a);
$parcel$export(module.exports, "getEndOfDay", () => $e3fa822dabb3902d$export$ba913d97bab95922);
$parcel$export(module.exports, "getClosestEndOfDay", () => $e3fa822dabb3902d$export$15bcb0122f94fe73);
$parcel$export(module.exports, "getDateFromTimestamp", () => $e3fa822dabb3902d$export$f268c901e7fab1f4);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

const $e3fa822dabb3902d$var$HALF_DAY_IN_MS = (0, $4975412c8fcbfa24$export$1f04624003d2da7d) / 2;
const $e3fa822dabb3902d$export$883228a582a7567d = (0, $5iWql.default)(()=>{
    const now = new Date();
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc().startOf('day');
    date.set({
        year: now.getFullYear(),
        month: now.getMonth(),
        date: now.getDate()
    });
    return date.valueOf();
});
const $e3fa822dabb3902d$export$acfb4d8d6f22913c = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).startOf('day').valueOf();
const $e3fa822dabb3902d$export$3b10530a2652517a = (date)=>{
    const newValue = $e3fa822dabb3902d$export$acfb4d8d6f22913c(date);
    if (date - newValue > $e3fa822dabb3902d$var$HALF_DAY_IN_MS) return newValue + $e3fa822dabb3902d$var$HALF_DAY_IN_MS * 2;
    return newValue;
};
const $e3fa822dabb3902d$export$ba913d97bab95922 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).endOf('day').valueOf();
const $e3fa822dabb3902d$export$15bcb0122f94fe73 = (date)=>{
    const newValue = $e3fa822dabb3902d$export$ba913d97bab95922(date);
    if (newValue - date > $e3fa822dabb3902d$var$HALF_DAY_IN_MS) return newValue - $e3fa822dabb3902d$var$HALF_DAY_IN_MS * 2;
    return newValue;
};
const $e3fa822dabb3902d$export$b6b0beaf88b31f31 = (date)=>Math.round(date / (0, $4975412c8fcbfa24$export$1f04624003d2da7d)) * (0, $4975412c8fcbfa24$export$1f04624003d2da7d);
const $e3fa822dabb3902d$export$f268c901e7fab1f4 = (timestamp, format = (0, $4975412c8fcbfa24$export$45c85543ba71221d))=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(timestamp).format(format);

});

parcelRegister("eUylY", function(module, exports) {

$parcel$export(module.exports, "dateToUtcTimestamp", () => $949bb8333b3ed8e1$export$c56f0b7c199d6cc4);
$parcel$export(module.exports, "optionalDateToUtcTimestamp", () => $949bb8333b3ed8e1$export$285bdc8a9ea7c1de);
$parcel$export(module.exports, "optionalUtcTimestampToDate", () => $949bb8333b3ed8e1$export$b2b962f648d391c4);
// eslint-disable-next-line jira/restricted/moment

var $jJwwt = parcelRequire("jJwwt");

const $949bb8333b3ed8e1$export$c56f0b7c199d6cc4 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date, (0, $4975412c8fcbfa24$export$e63e1e1c17a0e8b)).valueOf();
const $949bb8333b3ed8e1$export$285bdc8a9ea7c1de = (date)=>{
    if (date === undefined) return undefined;
    return $949bb8333b3ed8e1$export$c56f0b7c199d6cc4(date);
};
const $949bb8333b3ed8e1$export$b2b962f648d391c4 = (timestamp)=>{
    if (timestamp === undefined) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(timestamp).format((0, $4975412c8fcbfa24$export$e63e1e1c17a0e8b));
};

});

parcelRegister("etZVu", function(module, exports) {

$parcel$export(module.exports, "toModifiable", () => $1f32b2301b1509ac$export$b807868ed7c6dc2);
$parcel$export(module.exports, "nullableToModifiable", () => $1f32b2301b1509ac$export$1c3dc21bb7c157ad);
$parcel$export(module.exports, "nullableToModifiableWithConversion", () => $1f32b2301b1509ac$export$fb3253a5ab719486);
$parcel$export(module.exports, "nullableToOptional", () => $1f32b2301b1509ac$export$9d88f099d751247a);
$parcel$export(module.exports, "optionalToNullableWithConversion", () => $1f32b2301b1509ac$export$b347dfde75ec8151);
const $1f32b2301b1509ac$export$b807868ed7c6dc2 = (value)=>({
        value: value
    });
const $1f32b2301b1509ac$export$1c3dc21bb7c157ad = (nullable)=>{
    if (nullable === null) return {
        value: undefined
    };
    return {
        value: nullable
    };
};
const $1f32b2301b1509ac$export$fb3253a5ab719486 = (nullable, func)=>{
    if (nullable === null) return {
        value: undefined
    };
    return {
        value: func(nullable)
    };
};
const $1f32b2301b1509ac$export$9d88f099d751247a = (nullable)=>{
    if (nullable === null) return undefined;
    return nullable;
};
const $1f32b2301b1509ac$export$85aa01adeb0c4c1c = (nullable, func)=>{
    if (nullable === null) return undefined;
    return func(nullable);
};
const $1f32b2301b1509ac$export$b2ed551664a25599 = (optional)=>{
    if (optional === undefined) return null;
    return optional;
};
const $1f32b2301b1509ac$export$b347dfde75ec8151 = (optional, func)=>{
    if (optional === undefined) return null;
    return func(optional);
};

});

parcelRegister("5LLIO", function(module, exports) {

$parcel$export(module.exports, "transformStatusCategories", () => $86df649db73d4bda$export$847e60d12743ff1a);
const $86df649db73d4bda$export$847e60d12743ff1a = (statusCategories)=>{
    const getTransformedStatusCategories = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        statusCategories.forEach((statusCategory)=>{
            result[statusCategory.id] = {
                key: statusCategory.key,
                name: statusCategory.name
            };
        });
        return result;
    };
    return getTransformedStatusCategories();
};

});

parcelRegister("9doIl", function(module, exports) {

$parcel$export(module.exports, "transformDerivedFieldsHash", () => $d32f176593e3fd7c$export$90c58bddabb88fa1);
const $d32f176593e3fd7c$export$90c58bddabb88fa1 = (derivedFields)=>derivedFields.reduce((acc, deriveField)=>{
        acc[deriveField.id] = [
            ...deriveField.values
        ];
        return acc;
    }, {});

});

parcelRegister("hmc1Z", function(module, exports) {

$parcel$export(module.exports, "transformIssue", () => $1bb0fdec2e3ad7ce$export$2d1bde06ef9e2dcc);
$parcel$export(module.exports, "transformIssues", () => $1bb0fdec2e3ad7ce$export$a26a6de2e9ae64a0);
$parcel$export(module.exports, "transformIssuesFromGetItemsByIdsQueryResponse", () => $1bb0fdec2e3ad7ce$export$171bea9a74da27e6);
$parcel$export(module.exports, "transformScheduleItemsRequest", () => $1bb0fdec2e3ad7ce$export$c4dd18f037a8ccf9);
$parcel$export(module.exports, "transformSubtasksAndStatusCategoriesResponse", () => $1bb0fdec2e3ad7ce$export$29438f0dc3b07875);

var $6G5mG = parcelRequire("6G5mG");

var $eUylY = parcelRequire("eUylY");

var $etZVu = parcelRequire("etZVu");

var $5LLIO = parcelRequire("5LLIO");

var $24hOP = parcelRequire("24hOP");

var $lWbEj = parcelRequire("lWbEj");
const $1bb0fdec2e3ad7ce$export$2d1bde06ef9e2dcc = (issue)=>{
    const assignee = (0, $etZVu.nullableToOptional)(issue.assignee);
    const parentId = issue.parentId || null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const color = issue.color;
    const componentIds = issue.componentIds || [];
    return {
        key: issue.key,
        // @ts-expect-error(Suppressed for relay bump) - Type 'Modifiable<string | null | undefined>' is not assignable to type 'Modifiable<string>'.
        summary: (0, $etZVu.toModifiable)(issue.summary),
        startDate: (0, $etZVu.nullableToModifiableWithConversion)(issue.startDateRFC3339, (0, $eUylY.optionalDateToUtcTimestamp)),
        dueDate: (0, $etZVu.nullableToModifiableWithConversion)(issue.dueDateRFC3339, (0, $eUylY.optionalDateToUtcTimestamp)),
        color: (0, $etZVu.toModifiable)(color),
        inCreation: false,
        issueTypeId: `${issue.itemTypeId}`,
        // @ts-expect-error(Suppressed for relay bump) - Type 'string | null | undefined' is not assignable to type 'string'.
        rank: issue.rank,
        status: (0, $24hOP.transformStatus)(issue.status || null),
        assignee: assignee?.accountId,
        parentId: (0, $etZVu.nullableToModifiable)(parentId),
        // @ts-expect-error(Suppressed for relay bump) - Type 'readonly string[] | null | undefined' must have a '[Symbol.iterator]()' method that returns an iterator.
        dependencies: [
            ...issue.dependencies
        ],
        labels: Array.isArray(issue.labels) ? [
            ...issue.labels
        ] : [],
        sprintIds: (0, $etZVu.toModifiable)([
            ...issue.sprintIds
        ]),
        versionIds: [
            ...issue.versionIds
        ],
        componentIds: [
            ...componentIds
        ],
        // @ts-expect-error(Suppressed for relay bump) - Type 'boolean | null | undefined' is not assignable to type 'boolean'.
        resolved: issue.resolved,
        flagged: issue.flagged || false
    };
};
const $1bb0fdec2e3ad7ce$export$a26a6de2e9ae64a0 = (graphQLIssues)=>{
    const users = {};
    const issues = {
        hash: {},
        sequence: []
    };
    graphQLIssues.forEach((issue)=>{
        const assignee = (0, $etZVu.nullableToOptional)(issue.assignee);
        if (assignee !== undefined) users[assignee.accountId] = (0, $lWbEj.transformAssignee)(assignee);
        issues.sequence.push(issue.id);
        issues.hash[issue.id] = $1bb0fdec2e3ad7ce$export$2d1bde06ef9e2dcc(issue);
    });
    return {
        users: users,
        issues: issues
    };
};
const $1bb0fdec2e3ad7ce$export$171bea9a74da27e6 = (data)=>{
    const roadmapItems = data.roadmaps?.roadmapItemByIds;
    const users = {};
    const issues = {
        hash: {},
        sequence: []
    };
    if (roadmapItems) roadmapItems.forEach((issue)=>{
        if (issue) {
            const assignee = (0, $etZVu.nullableToOptional)(issue.assignee);
            if (assignee !== undefined) users[assignee.accountId] = (0, $lWbEj.transformAssignee)(assignee);
            issues.sequence.push(issue.id);
            issues.hash[issue.id] = $1bb0fdec2e3ad7ce$export$2d1bde06ef9e2dcc(issue);
        }
    });
    return {
        users: users,
        issues: issues
    };
};
const $1bb0fdec2e3ad7ce$export$c4dd18f037a8ccf9 = (issueScheduleFields)=>{
    const issues = [];
    issueScheduleFields.forEach((scheduledIssue)=>{
        const itemId = scheduledIssue.issueId;
        let startDate = null;
        let dueDate = null;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(scheduledIssue, 'startDate')) startDate = (0, $etZVu.optionalToNullableWithConversion)(scheduledIssue.startDate, (0, $eUylY.optionalUtcTimestampToDate));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(scheduledIssue, 'dueDate')) dueDate = (0, $etZVu.optionalToNullableWithConversion)(scheduledIssue.dueDate, (0, $eUylY.optionalUtcTimestampToDate));
        issues.push({
            itemId: itemId,
            startDate: startDate,
            dueDate: dueDate
        });
    });
    return issues;
};
const $1bb0fdec2e3ad7ce$export$29438f0dc3b07875 = (response)=>{
    const { subtasks: subtasks, statusCategories: statusCategories } = response;
    const subtasksHash = {};
    subtasks.forEach(({ parentId: parentId, id: id, key: key, statusCategoryId: statusCategoryId })=>{
        if (subtasksHash[parentId] === undefined) subtasksHash[parentId] = [];
        subtasksHash[parentId].push({
            id: id,
            key: key,
            statusCategoryId: statusCategoryId
        });
    });
    return {
        statusCategories: (0, $5LLIO.transformStatusCategories)([
            ...statusCategories
        ]),
        subtasks: subtasksHash
    };
};

});
parcelRegister("24hOP", function(module, exports) {

$parcel$export(module.exports, "transformStatus", () => $344b0f980b196d92$export$95f71e2e6b5bd102);
const $344b0f980b196d92$export$95f71e2e6b5bd102 = (status)=>{
    if (status != null) return {
        id: status.id,
        // @ts-expect-error(Suppressed for relay bump) - Type 'string | null | undefined' is not assignable to type 'string'.
        name: status.name,
        // @ts-expect-error(Suppressed for relay bump) - 'status.statusCategory' is possibly 'null' or 'undefined'.
        statusCategoryId: status.statusCategory.id
    };
    return undefined;
};

});

parcelRegister("lWbEj", function(module, exports) {

$parcel$export(module.exports, "transformAssignee", () => $4b22f696b5fa732b$export$32f35dc2efaf5893);
const $4b22f696b5fa732b$export$32f35dc2efaf5893 = (assignee)=>({
        avatarUrls: {
            '16x16': assignee.picture,
            '24x24': assignee.picture,
            '32x32': assignee.picture,
            '48x48': assignee.picture
        },
        displayName: assignee.name
    });

});




parcelRegister("668VM", function(module, exports) {

$parcel$export(module.exports, "fetchEagerLoadedData", () => $075c751385153eae$export$28cd71eb0ba7805a);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jAXdN");
parcelRequire("jyKN9");
parcelRequire("flmol");

var $d7vZw = parcelRequire("d7vZw");

var $aXwen = parcelRequire("aXwen");
const $075c751385153eae$var$eagerDataFetchers = [
    (0, $d7vZw.goalsFetcher),
    (0, $aXwen.filterItemsByJQLFetcher)
];
const $075c751385153eae$var$mergeAdditionalData = (dataFragments)=>{
    const result = {};
    dataFragments.forEach((object)=>{
        Object.assign(result, object);
    });
    return result;
};
const $075c751385153eae$export$28cd71eb0ba7805a = (sourceAri, context)=>{
    const matchingFetchers = $075c751385153eae$var$eagerDataFetchers.filter((fetcher)=>fetcher.match(context));
    if (matchingFetchers.length === 0) return (0, $3JafE.Observable).of({});
    return (0, $3JafE.Observable).zip(...matchingFetchers.map((fetcher)=>fetcher.fetch(sourceAri, context))) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map((dataFragments)=>$075c751385153eae$var$mergeAdditionalData(dataFragments));
};

});
parcelRegister("d7vZw", function(module, exports) {

$parcel$export(module.exports, "goalsFetcher", () => $4b43e6db4c3263a8$export$bff1d3ae1b2929bc);

var $eGb5T = parcelRequire("eGb5T");
const $4b43e6db4c3263a8$export$bff1d3ae1b2929bc = {
    match: ({ query: { goal: goal } })=>goal !== undefined,
    fetch: (sourceAri)=>(0, $eGb5T.getGoals)(sourceAri).map((goals)=>({
                goals: goals
            }))
};

});
parcelRegister("eGb5T", function(module, exports) {

$parcel$export(module.exports, "getGoals", () => $293fc834f200e7a1$export$da2944c52ff0de62);
parcelRequire("flmol");
parcelRequire("cpH8E");

var $jJpnQ = parcelRequire("jJpnQ");

var $k8EEO = parcelRequire("k8EEO");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");
const $293fc834f200e7a1$var$analyticKey = 'jira.frontend.fe.software.roadmap.goals';
const $293fc834f200e7a1$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$57a4171901f1c15b];
const $293fc834f200e7a1$export$c4b84c37e5420d49 = {
    graphqlErrorFilter: (errors)=>errors.filter((error)=>!(error.path && error.path[0] === 'townsquare' && error.extensions?.statusCode === 403))
};
const $293fc834f200e7a1$export$da2944c52ff0de62 = (sourceAri)=>(0, $8sMwH.runQueryWithMetadataAndSelector)((0, $jJpnQ.default), (0, $k8EEO.generateRoadmapGoalsQueryVariables)(sourceAri), $293fc834f200e7a1$var$analyticKey, $293fc834f200e7a1$var$concurrentMetricDefinition, (data)=>data.roadmaps?.roadmapAriGoals?.goals, $293fc834f200e7a1$export$c4b84c37e5420d49).map(({ data: data })=>data.reduce((acc, { goal: goal, issueIds: issueIds })=>{
            if (goal) acc[goal.id] = {
                goal: goal,
                issueIds: issueIds.map((id)=>String(id))
            };
            return acc;
        }, {}));

});
parcelRegister("jJpnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec85f5e2cb229c7a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e02ac3a151e2932b2331b39a1a93577d>>
 * @relayHash ed01c651c385a1754424ab87363cbba9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd0e4c566bd1af6d8a8352be7b22bfc085c63b835d01e5adfd2ca9f0007cb006
const $ec85f5e2cb229c7a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v3 = {
        "kind": "ScalarField",
        "name": "issueIds"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "label"
    }, v9 = {
        "kind": "ScalarField",
        "name": "score"
    }, v10 = {
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "roadmapGoalsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "RoadmapAriGoals",
                            "kind": "LinkedField",
                            "name": "roadmapAriGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapAriGoalDetails",
                                        "kind": "LinkedField",
                                        "name": "goals",
                                        "plural": true,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            {
                                                "concreteType": "TownsquareGoal",
                                                "kind": "LinkedField",
                                                "name": "goal",
                                                "plural": false,
                                                "selections": [
                                                    v4 /*: any*/ ,
                                                    v5 /*: any*/ ,
                                                    v6 /*: any*/ ,
                                                    v7 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "TownsquareGoalState",
                                                            "kind": "LinkedField",
                                                            "name": "state",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v8 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapAriGoals.goals.goal.state.label"
                                                                },
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v10 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapAriGoals.goals.goal.state.value"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapAriGoals.goals.goal.state"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapAriGoals.goals"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "roadmapGoalsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "RoadmapAriGoals",
                            "kind": "LinkedField",
                            "name": "roadmapAriGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapAriGoalDetails",
                                    "kind": "LinkedField",
                                    "name": "goals",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "goal",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "state",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cd0e4c566bd1af6d8a8352be7b22bfc085c63b835d01e5adfd2ca9f0007cb006",
            "metadata": {},
            "name": "roadmapGoalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ec85f5e2cb229c7a$var$node.hash = "2792b908e31158794969cc76ffa0f0f8";
var $ec85f5e2cb229c7a$export$2e2bcd8739ae039 = $ec85f5e2cb229c7a$var$node;

});

parcelRegister("k8EEO", function(module, exports) {

$parcel$export(module.exports, "generateRoadmapGoalsQueryVariables", () => $99b9062f13527218$export$232f8dfcaf45cea7);
const $99b9062f13527218$export$232f8dfcaf45cea7 = (sourceAri)=>({
        sourceAri: sourceAri
    });

});



parcelRegister("aXwen", function(module, exports) {

$parcel$export(module.exports, "filterItemsByJQLFetcher", () => $0ab4d88d4dc8f943$export$175e69da1a1f5ca2);

var $eC0P8 = parcelRequire("eC0P8");
const $0ab4d88d4dc8f943$export$175e69da1a1f5ca2 = {
    match: ({ query: { quickFilter: quickFilter, customFilter: customFilter } })=>quickFilter !== undefined || customFilter !== undefined,
    fetch: (sourceAri, { query: { quickFilter: quickFilter, customFilter: customFilter } })=>{
        const quickFilterIds = quickFilter ? quickFilter.split(',') : [];
        const customFilterIds = customFilter ? customFilter.split(',') : [];
        return (0, $eC0P8.filterItemsByJQLFilters)(sourceAri, quickFilterIds, customFilterIds).map((filteredIssueIds)=>({
                filteredIssueIds: filteredIssueIds
            }));
    }
};

});



parcelRegister("16ixF", function(module, exports) {

$parcel$export(module.exports, "onHandleAggErrors", () => $85d5d292a0248666$export$e0ee9ab1145d2d14);

var $3OXzs = parcelRequire("3OXzs");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");

var $9BmXV = parcelRequire("9BmXV");

const $85d5d292a0248666$export$e0ee9ab1145d2d14 = (isDataValid, errors)=>{
    if (!isDataValid) return (0, $3JafE.Observable).of((0, $9BmXV.aggError)());
    if (errors && errors.length) {
        const errorTypes = errors.reduce((allErrorTypes, error)=>error && error.extensions && error.extensions.errorType ? allErrorTypes.concat([
                error.extensions.errorType
            ]) : allErrorTypes, []);
        // Check if it's a JQL validation error
        if (errorTypes.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))(errorTypes, (0, $cc11070e8f7c8919$export$d2fa25fc0fdc86b8))) return (0, $3JafE.Observable).of((0, $9BmXV.aggError)({
            errorType: (0, $cc11070e8f7c8919$export$d2fa25fc0fdc86b8),
            description: undefined
        }));
        const errorMessage = `${errors.reduce((errorMsg, error)=>error && error.message !== undefined && error.message !== null ? `${errorMsg}${error.message} ` : '', '').trim()}`;
        if (errorMessage.length) {
            const formattedErrorMessage = errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1);
            return (0, $3JafE.Observable).of((0, $9BmXV.aggError)({
                description: formattedErrorMessage,
                errorType: undefined
            }));
        }
    }
    return (0, $3JafE.Observable).of((0, $9BmXV.aggError)());
};

});

parcelRegister("37nmJ", function(module, exports) {

$parcel$export(module.exports, "getCriticalDataActions", () => $b152924b5258f608$export$9557d78156c411f1);


var $xbB8r = parcelRequire("xbB8r");

var $jktkh = parcelRequire("jktkh");

var $j45xj = parcelRequire("j45xj");

var $a2ne3 = parcelRequire("a2ne3");

var $cerFH = parcelRequire("cerFH");

var $56PNW = parcelRequire("56PNW");

var $2DqCi = parcelRequire("2DqCi");

var $5MpXz = parcelRequire("5MpXz");

var $gdFA6 = parcelRequire("gdFA6");

var $8ybWM = parcelRequire("8ybWM");

var $aSTh4 = parcelRequire("aSTh4");
const $b152924b5258f608$export$9557d78156c411f1 = (criticalData)=>{
    const { configuration: configuration, users: users, issues: issues, statusCategories: statusCategories, settings: settings, metadata: metadata, healthcheck: healthcheck, filteredIssueIds: filteredIssueIds, eagerLoadedData: eagerLoadedData, resourcesCacheSource: resourcesCacheSource } = criticalData;
    const basicInitActions = [
        (0, $8ybWM.updateHealthcheck)(healthcheck),
        (0, $56PNW.setMetadata)(metadata)
    ];
    if (resourcesCacheSource !== (0, $c22b1ee1fcd49c4a$export$b7dfe28569b170a1)) basicInitActions.push((0, $2DqCi.updateResourceCache)(criticalData));
    if (configuration) basicInitActions.push((0, $xbB8r.setConfiguration)(configuration));
    if (settings) {
        basicInitActions.push((0, $5MpXz.setSettings)(settings));
        if (settings.isDependenciesVisible !== undefined) basicInitActions.push((0, $aSTh4.setDependenciesViewVisibility)(settings.isDependenciesVisible));
        if (settings.isProgressVisible !== undefined) basicInitActions.push((0, $aSTh4.setProgressVisibility)(settings.isProgressVisible));
        if (settings.isWarningsVisible !== undefined) basicInitActions.push((0, $aSTh4.setWarningsVisibility)(settings.isWarningsVisible));
        if (settings.isReleasesVisible !== undefined) basicInitActions.push((0, $aSTh4.setReleasesVisibility)(settings.isReleasesVisible));
        if (settings.levelOneViewSettings !== undefined && !(settings.levelOneViewSettings.showCompleted && settings.levelOneViewSettings.period === 12)) basicInitActions.push((0, $aSTh4.setLevelOneSetting)(settings.levelOneViewSettings));
        if (filteredIssueIds !== undefined) basicInitActions.push((0, $gdFA6.jqlFiltersSuccess)(filteredIssueIds));
    }
    if (healthcheck !== undefined) return basicInitActions;
    if (eagerLoadedData) {
        if (configuration?.projectConfiguration?.isGoalsFeatureEnabled === true && eagerLoadedData.goals) basicInitActions.push((0, $jktkh.setGoals)(eagerLoadedData.goals));
        if (eagerLoadedData.filteredIssueIds) basicInitActions.push((0, $gdFA6.jqlFiltersSuccess)(eagerLoadedData.filteredIssueIds));
    }
    basicInitActions.push((0, $cerFH.addUsers)(users), (0, $j45xj.updateIssuesHashAndSequence)(issues));
    if (statusCategories) basicInitActions.push((0, $a2ne3.mergeStatusCategories)(statusCategories));
    return basicInitActions;
};

});
parcelRegister("xbB8r", function(module, exports) {

$parcel$export(module.exports, "SET_CONFIGURATION", () => $0e3894c04b7f5f59$export$88d379a4ed7b960a);
$parcel$export(module.exports, "SET_TODAY", () => $0e3894c04b7f5f59$export$ea5cc78508d1a91f);
$parcel$export(module.exports, "SET_COMPONENTS", () => $0e3894c04b7f5f59$export$eb071a4d80c1cce1);
$parcel$export(module.exports, "SET_VERSION", () => $0e3894c04b7f5f59$export$33d1af9ce619539e);
$parcel$export(module.exports, "SET_SPRINT", () => $0e3894c04b7f5f59$export$26f77f93871b8908);
$parcel$export(module.exports, "setConfiguration", () => $0e3894c04b7f5f59$export$6a52175581b4d614);
$parcel$export(module.exports, "setComponents", () => $0e3894c04b7f5f59$export$41155fc643823ac5);
$parcel$export(module.exports, "setVersion", () => $0e3894c04b7f5f59$export$f99c3c9c04cda7ae);
$parcel$export(module.exports, "setSprint", () => $0e3894c04b7f5f59$export$cd32ff7d877f176c);
$parcel$export(module.exports, "DERIVE_FIELDS_REQUEST", () => $0e3894c04b7f5f59$export$9eaf0f2039b438c4);
$parcel$export(module.exports, "deriveFieldsRequest", () => $0e3894c04b7f5f59$export$75d1c1de4eb47530);
$parcel$export(module.exports, "SET_DERIVE_FIELDS", () => $0e3894c04b7f5f59$export$b386863aaed4e128);
$parcel$export(module.exports, "setDeriveFieldsHash", () => $0e3894c04b7f5f59$export$ecb601895f145781);
$parcel$export(module.exports, "SET_CAN_USER_INVITE", () => $0e3894c04b7f5f59$export$c09a6e8888fd28fa);
$parcel$export(module.exports, "setCanUserInvite", () => $0e3894c04b7f5f59$export$c07b821618e68774);
const $0e3894c04b7f5f59$export$88d379a4ed7b960a = 'state.configuration.SET_CONFIGURATION';
const $0e3894c04b7f5f59$export$ea5cc78508d1a91f = 'state.configuration.SET_TODAY';
const $0e3894c04b7f5f59$export$eb071a4d80c1cce1 = 'state.configuration.SET_COMPONENTS';
const $0e3894c04b7f5f59$export$33d1af9ce619539e = 'state.configuration.SET_VERSION';
const $0e3894c04b7f5f59$export$26f77f93871b8908 = 'state.configuration.SET_SPRINT';
const $0e3894c04b7f5f59$export$6a52175581b4d614 = (payload)=>({
        type: $0e3894c04b7f5f59$export$88d379a4ed7b960a,
        payload: payload
    });
const $0e3894c04b7f5f59$export$e4826d6ef31827eb = (payload)=>({
        type: $0e3894c04b7f5f59$export$ea5cc78508d1a91f,
        payload: payload
    });
const $0e3894c04b7f5f59$export$41155fc643823ac5 = (payload)=>({
        type: $0e3894c04b7f5f59$export$eb071a4d80c1cce1,
        payload: payload
    });
const $0e3894c04b7f5f59$export$f99c3c9c04cda7ae = (payload)=>({
        type: $0e3894c04b7f5f59$export$33d1af9ce619539e,
        payload: payload
    });
const $0e3894c04b7f5f59$export$cd32ff7d877f176c = (payload)=>({
        type: $0e3894c04b7f5f59$export$26f77f93871b8908,
        payload: payload
    });
const $0e3894c04b7f5f59$export$9eaf0f2039b438c4 = 'state.configuration.DERIVE_FIELDS_REQUEST';
const $0e3894c04b7f5f59$export$75d1c1de4eb47530 = ()=>({
        type: $0e3894c04b7f5f59$export$9eaf0f2039b438c4
    });
const $0e3894c04b7f5f59$export$b386863aaed4e128 = 'state.configuration.SET_DERIVE_FIELDS';
const $0e3894c04b7f5f59$export$ecb601895f145781 = (payload)=>({
        type: $0e3894c04b7f5f59$export$b386863aaed4e128,
        payload: payload
    });
const $0e3894c04b7f5f59$export$c09a6e8888fd28fa = 'state.actions.can-user-invite.SET_CAN_USER_INVITE';
const $0e3894c04b7f5f59$export$c07b821618e68774 = (payload)=>({
        type: $0e3894c04b7f5f59$export$c09a6e8888fd28fa,
        payload: payload
    });

});

parcelRegister("jktkh", function(module, exports) {

$parcel$export(module.exports, "SET_GOALS", () => $6528bacac2422e46$export$daa9b77b180e2d74);
$parcel$export(module.exports, "setGoals", () => $6528bacac2422e46$export$d76a439abd266c57);
const $6528bacac2422e46$export$daa9b77b180e2d74 = 'state.entities.goals.SET_GOALS';
const $6528bacac2422e46$export$d76a439abd266c57 = (payload)=>({
        type: $6528bacac2422e46$export$daa9b77b180e2d74,
        payload: payload
    });

});

parcelRegister("a2ne3", function(module, exports) {

$parcel$export(module.exports, "MERGE_STATUS_CATEGORIES", () => $34266e60055f0fb2$export$e1b89668a4ad1ca0);
$parcel$export(module.exports, "mergeStatusCategories", () => $34266e60055f0fb2$export$a7fa16a7a2a0c3c6);
const $34266e60055f0fb2$export$e1b89668a4ad1ca0 = 'state.entities.status-categories.MERGE_STATUS_CATEGORIES';
const $34266e60055f0fb2$export$a7fa16a7a2a0c3c6 = (payload)=>({
        type: $34266e60055f0fb2$export$e1b89668a4ad1ca0,
        payload: payload
    });

});

parcelRegister("cerFH", function(module, exports) {

$parcel$export(module.exports, "ADD_USERS", () => $7bccb5c830c5b45c$export$9f43e179ecfa3bdc);
$parcel$export(module.exports, "addUsers", () => $7bccb5c830c5b45c$export$8c4f477b62a4d628);
const $7bccb5c830c5b45c$export$9f43e179ecfa3bdc = 'state.entities.users.ADD_USERS';
const $7bccb5c830c5b45c$export$8c4f477b62a4d628 = (payload)=>({
        type: $7bccb5c830c5b45c$export$9f43e179ecfa3bdc,
        payload: payload
    });

});

parcelRegister("56PNW", function(module, exports) {

$parcel$export(module.exports, "SET_METADATA", () => $223ac748fb58a702$export$eb6efca4aaa03911);
$parcel$export(module.exports, "setMetadata", () => $223ac748fb58a702$export$f8685c902e685023);
const $223ac748fb58a702$export$eb6efca4aaa03911 = 'state.metadata.SET_METADATA';
const $223ac748fb58a702$export$f8685c902e685023 = (payload)=>({
        type: $223ac748fb58a702$export$eb6efca4aaa03911,
        payload: payload
    });

});

parcelRegister("2DqCi", function(module, exports) {

$parcel$export(module.exports, "UPDATE_RESOURCE_CACHE", () => $602e44054caf25ca$export$54870d50c480d83);
$parcel$export(module.exports, "updateResourceCache", () => $602e44054caf25ca$export$269d53138aef8ce1);
const $602e44054caf25ca$export$54870d50c480d83 = 'state.metadata.UPDATE_RESOURCE_CACHE';
const $602e44054caf25ca$export$269d53138aef8ce1 = (payload)=>({
        type: $602e44054caf25ca$export$54870d50c480d83,
        payload: payload
    });

});

parcelRegister("5MpXz", function(module, exports) {

$parcel$export(module.exports, "SET_SETTINGS", () => $7cb611743e127c5f$export$d0c4639253ab3ec7);
$parcel$export(module.exports, "setSettings", () => $7cb611743e127c5f$export$dc86d17a64679bc7);
$parcel$export(module.exports, "SET_LIST_WIDTH", () => $7cb611743e127c5f$export$39181e9b13b7b1a3);
$parcel$export(module.exports, "setListWidth", () => $7cb611743e127c5f$export$e9fd6c0c57a999a3);
$parcel$export(module.exports, "SET_CREATION_PREFERENCES", () => $7cb611743e127c5f$export$18e0a41e5d9d838e);
$parcel$export(module.exports, "setCreationPreferences", () => $7cb611743e127c5f$export$f2f0354403c25702);
$parcel$export(module.exports, "UPDATE_CREATION_PREFERENCES", () => $7cb611743e127c5f$export$1e29ef5ceeacfed9);
$parcel$export(module.exports, "updateCreationPreferences", () => $7cb611743e127c5f$export$9e8352969ee835d9);
$parcel$export(module.exports, "SET_HIGHLIGHTED_VERSIONS", () => $7cb611743e127c5f$export$9dfe09f4da54827);
$parcel$export(module.exports, "setHighlightedVersions", () => $7cb611743e127c5f$export$c4b191c3a49c947f);
$parcel$export(module.exports, "SET_ISSUE_PANEL_RATIO", () => $7cb611743e127c5f$export$972293701d976b1);
$parcel$export(module.exports, "setIssuePanelRatio", () => $7cb611743e127c5f$export$c51330ff34087218);
const $7cb611743e127c5f$export$d0c4639253ab3ec7 = 'state.settings.SET_SETTINGS';
const $7cb611743e127c5f$export$dc86d17a64679bc7 = (payload)=>({
        type: $7cb611743e127c5f$export$d0c4639253ab3ec7,
        payload: payload
    });
const $7cb611743e127c5f$export$39181e9b13b7b1a3 = 'state.settings.SET_LIST_WIDTH';
const $7cb611743e127c5f$export$e9fd6c0c57a999a3 = (payload)=>({
        type: $7cb611743e127c5f$export$39181e9b13b7b1a3,
        payload: payload
    });
const $7cb611743e127c5f$export$18e0a41e5d9d838e = 'state.settings.SET_CREATION_PREFERENCES';
const $7cb611743e127c5f$export$f2f0354403c25702 = (payload)=>({
        type: $7cb611743e127c5f$export$18e0a41e5d9d838e,
        payload: payload
    });
const $7cb611743e127c5f$export$1e29ef5ceeacfed9 = 'state.settings.UPDATE_CREATION_PREFERENCES';
const $7cb611743e127c5f$export$9e8352969ee835d9 = (payload)=>({
        type: $7cb611743e127c5f$export$1e29ef5ceeacfed9,
        payload: payload
    });
const $7cb611743e127c5f$export$9dfe09f4da54827 = 'state.settings.SET_HIGHLIGHTED_VERSIONS';
const $7cb611743e127c5f$export$c4b191c3a49c947f = (payload)=>({
        type: $7cb611743e127c5f$export$9dfe09f4da54827,
        payload: payload
    });
const $7cb611743e127c5f$export$972293701d976b1 = 'state.settings.SET_ISSUE_PANEL_RATIO';
const $7cb611743e127c5f$export$c51330ff34087218 = (payload)=>({
        type: $7cb611743e127c5f$export$972293701d976b1,
        payload: payload
    });

});



parcelRegister("aECmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cd251da7e39ec26$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("dM0Xt");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $84hEy = parcelRequire("84hEy");

var $6KDJ5 = parcelRequire("6KDJ5");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $9BmXV = parcelRequire("9BmXV");

var $6489W = parcelRequire("6489W");

var $8ybWM = parcelRequire("8ybWM");

var $37nmJ = parcelRequire("37nmJ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$2cd251da7e39ec26$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $8ybWM.RESOLVE)).mergeMap((action)=>(0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $8ybWM.setResolving)(true)), (0, $84hEy.default)((0, $bwVWW.getProjectId)(store.getState()), action.payload.epicName, action.payload.epicDescription, action.payload.issueTypeToPromote).mergeMap(()=>{
            const state = store.getState();
            const query = (0, $6489W.getQuery)(state);
            return (0, $6KDJ5.getCriticalDataObservable)((0, $lgKTA.getSourceARI)(state), query, undefined).mergeMap((criticalData)=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
                    ...(0, $37nmJ.getCriticalDataActions)(criticalData),
                    (0, $8ybWM.setResolving)(false)
                ]))).catch(()=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
                    (0, $9BmXV.aggError)()
                ])));
        })));

});
parcelRegister("84hEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d11cd211f7bda5$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e7d11cd211f7bda5$export$2e2bcd8739ae039 = (projectId, epicTypeName, epicTypeDescription, promoteIssueTypeId)=>{
    const options = {
        method: 'POST',
        body: JSON.stringify({
            projectId: projectId,
            epicTypeName: epicTypeName,
            epicTypeDescription: epicTypeDescription,
            promoteIssueTypeId: Number(promoteIssueTypeId)
        })
    };
    return (0, $aiRd8.default)('/rest/greenhopper/1.0/roadmap/setup', options);
};

});
parcelRegister("aiRd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6464cf3e92eca984$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("flmol");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $6iz4v = parcelRequire("6iz4v");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");
const $6464cf3e92eca984$var$noContentStatus = 204;
const $6464cf3e92eca984$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $6464cf3e92eca984$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$6464cf3e92eca984$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6iz4v.setMark)(`BEGIN_${key}`);
    }
    return (0, $3JafE.Observable).of(url).mergeMap(()=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), opts), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6iz4v.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, str, traceId);
                else throw new (0, $7byHA.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $6464cf3e92eca984$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        return response.json();
    });
}
var $6464cf3e92eca984$export$2e2bcd8739ae039 = $6464cf3e92eca984$var$fetchJson$;

});




parcelRegister("1juxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc3baa146fd33ac5$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");
parcelRequire("jyKN9");

var $5v4on = parcelRequire("5v4on");

var $89iLu = parcelRequire("89iLu");

var $l8It9 = parcelRequire("l8It9");

var $7Jriz = parcelRequire("7Jriz");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$bc3baa146fd33ac5$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $5v4on.default), (0, $l8It9.default), (0, $89iLu.default), (0, $7Jriz.default));

});
parcelRegister("5v4on", function(module, exports) {

$parcel$export(module.exports, "default", () => $d77f8dfe447d206e$export$2e2bcd8739ae039);

var $MYW4e = parcelRequire("MYW4e");
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $ecAMT = parcelRequire("ecAMT");

var $37nmJ = parcelRequire("37nmJ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d77f8dfe447d206e$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $ecAMT.INITIALIZE_CRITICAL_DATA)).mergeMap((action)=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)((0, $37nmJ.getCriticalDataActions)(action.payload))));

});
parcelRegister("ecAMT", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $61b4ede44965e3d7$export$84856e4ae7cd7538);
$parcel$export(module.exports, "initializeAppProps", () => $61b4ede44965e3d7$export$5f0e35553cecddfe);
$parcel$export(module.exports, "UPDATE_CRITICAL_DATA", () => $61b4ede44965e3d7$export$376502e6007b0f09);
$parcel$export(module.exports, "updateCriticalData", () => $61b4ede44965e3d7$export$4daba2868c495f34);
$parcel$export(module.exports, "INITIALIZE_CRITICAL_DATA", () => $61b4ede44965e3d7$export$2687fde7499d72c0);
$parcel$export(module.exports, "initializeCriticalData", () => $61b4ede44965e3d7$export$f93aa271c9412029);
$parcel$export(module.exports, "INITIALIZE_NON_CRITICAL_DATA", () => $61b4ede44965e3d7$export$2b57a52333b76c0a);
$parcel$export(module.exports, "initializeNonCriticalData", () => $61b4ede44965e3d7$export$ecba41fbc21bbd84);
const $61b4ede44965e3d7$export$84856e4ae7cd7538 = 'state.app.INITIALIZE_APP_PROPS';
const $61b4ede44965e3d7$export$5f0e35553cecddfe = (payload)=>({
        type: $61b4ede44965e3d7$export$84856e4ae7cd7538,
        payload: payload
    });
const $61b4ede44965e3d7$export$376502e6007b0f09 = 'state.app.UPDATE_CRITICAL_DATA';
const $61b4ede44965e3d7$export$4daba2868c495f34 = (payload)=>({
        type: $61b4ede44965e3d7$export$376502e6007b0f09,
        payload: payload
    });
const $61b4ede44965e3d7$export$2687fde7499d72c0 = 'state.app.INITIALIZE_CRITICAL_DATA';
const $61b4ede44965e3d7$export$f93aa271c9412029 = (payload)=>({
        type: $61b4ede44965e3d7$export$2687fde7499d72c0,
        payload: payload
    });
const $61b4ede44965e3d7$export$2b57a52333b76c0a = 'state.app.INITIALIZE_NON_CRITICAL_DATA';
const $61b4ede44965e3d7$export$ecba41fbc21bbd84 = ()=>({
        type: $61b4ede44965e3d7$export$2b57a52333b76c0a
    });

});


parcelRegister("89iLu", function(module, exports) {

$parcel$export(module.exports, "default", () => $56af4e0fd1d69365$export$2e2bcd8739ae039);

var $8blac = parcelRequire("8blac");
parcelRequire("8jBvP");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $lgKTA = parcelRequire("lgKTA");

var $xbB8r = parcelRequire("xbB8r");

var $bwVWW = parcelRequire("bwVWW");

var $6489W = parcelRequire("6489W");

var $hTAd9 = parcelRequire("hTAd9");

var $3KOvX = parcelRequire("3KOvX");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$56af4e0fd1d69365$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $xbB8r.DERIVE_FIELDS_REQUEST)).mergeMap(()=>{
        const state = store.getState();
        const sourceAri = (0, $lgKTA.getSourceARI)(state);
        if (sourceAri !== undefined) {
            const boardJQL = (0, $bwVWW.getBoardJql)(state);
            if ((0, $lgKTA.isClassic)(state)) {
                const quickFilters = (0, $hTAd9.getFullQuickFilterHash)(state);
                const validQuickFilterIds = Object.keys(quickFilters);
                const appliedQuickFilterJQLs = (0, $6489W.getQuickFilters)(state).reduce((acc, quickFilterId)=>{
                    if (validQuickFilterIds.indexOf(quickFilterId) > -1) {
                        const quickFilterJQL = quickFilters[quickFilterId]?.query;
                        if (quickFilterJQL !== undefined) acc.push(quickFilterJQL);
                    }
                    return acc;
                }, []);
                // skip derivedFields fetch if no filters applied
                return (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(appliedQuickFilterJQLs) ? (0, $3JafE.Observable).empty() : (0, $3KOvX.getInitializeDeriveFieldsAction)(sourceAri, [
                    ...boardJQL !== null ? [
                        boardJQL
                    ] : [],
                    ...appliedQuickFilterJQLs
                ], []);
            }
            const customFilters = (0, $hTAd9.getFullCustomFilterHash)(state);
            const validCustomFilterIds = Object.keys(customFilters);
            const appliedCustomFilterIds = (0, $6489W.getCustomFilters)(state).filter((customFilterId)=>validCustomFilterIds.indexOf(customFilterId) > -1);
            // skip derivedFields fetch if no filters applied
            return (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(appliedCustomFilterIds) ? (0, $3JafE.Observable).empty() : (0, $3KOvX.getInitializeDeriveFieldsAction)(sourceAri, boardJQL !== null ? [
                boardJQL
            ] : [], appliedCustomFilterIds);
        }
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("hTAd9", function(module, exports) {

$parcel$export(module.exports, "getFullQuickFilterHash", () => $921c2a915ca4094b$export$4a2a1c7b06b352b0);
$parcel$export(module.exports, "getFullCustomFilterHash", () => $921c2a915ca4094b$export$a9437088d460ded8);
$parcel$export(module.exports, "getJQLFilteredIssueIds", () => $921c2a915ca4094b$export$815231ddc49f7ee7);
$parcel$export(module.exports, "getIsJQLFiltersActive", () => $921c2a915ca4094b$export$f0aa49ab84110c86);
$parcel$export(module.exports, "getIsJQLFilterLoading", () => $921c2a915ca4094b$export$76eb8b481e5adc40);
$parcel$export(module.exports, "getFilteredQuickFilterQueries", () => $921c2a915ca4094b$export$c50ba17b114351dc);

var $df4Sl = parcelRequire("df4Sl");

var $9ZLrP = parcelRequire("9ZLrP");

var $egOws = parcelRequire("egOws");
const $921c2a915ca4094b$export$d01c426cf75c490 = (state)=>state.ui.filter.configuration;
const $921c2a915ca4094b$export$4a2a1c7b06b352b0 = (0, $df4Sl.createSelector)($921c2a915ca4094b$export$d01c426cf75c490, (filterConfiguration)=>{
    if (filterConfiguration !== undefined) return filterConfiguration.quickFilters;
    return {};
});
const $921c2a915ca4094b$export$a9437088d460ded8 = (0, $df4Sl.createSelector)($921c2a915ca4094b$export$d01c426cf75c490, (filterConfiguration)=>{
    if (filterConfiguration !== undefined) return filterConfiguration.customFilters;
    return {};
});
const $921c2a915ca4094b$export$1377c852f579d8c5 = (state, quickFilterId)=>$921c2a915ca4094b$export$4a2a1c7b06b352b0(state)[quickFilterId];
const $921c2a915ca4094b$export$9cfd924149019e5b = (state, customFilterId)=>$921c2a915ca4094b$export$a9437088d460ded8(state)[customFilterId];
const $921c2a915ca4094b$export$815231ddc49f7ee7 = (state)=>state.ui.filter.issueIds;
const $921c2a915ca4094b$export$f0aa49ab84110c86 = (state)=>state.ui.filter.isJQLFilterActive;
const $921c2a915ca4094b$export$76eb8b481e5adc40 = (state)=>state.ui.filter.isJQLFilterLoading;
const $921c2a915ca4094b$export$c50ba17b114351dc = (0, $df4Sl.createSelector)((0, $9ZLrP.getFilteredQuickFilters), $921c2a915ca4094b$export$4a2a1c7b06b352b0, (0, $egOws.getFilteredQuickFilterQueriesPure));

});
parcelRegister("egOws", function(module, exports) {

$parcel$export(module.exports, "getFilteredQuickFilterQueriesPure", () => $200716434e65472f$export$1a2dbbfdd0122f3f);
const $200716434e65472f$export$1a2dbbfdd0122f3f = (filteredQuickFilters, quickFilterHash)=>filteredQuickFilters.reduce((queries, quickFilterId)=>{
        const quickFilter = quickFilterHash[quickFilterId];
        if (quickFilter !== undefined) queries.push(quickFilter.query);
        return queries;
    }, []);

});


parcelRegister("3KOvX", function(module, exports) {

$parcel$export(module.exports, "getInitializeDeriveFieldsAction", () => $1210b60472af7bd4$export$4faeceaf3c6757a2);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("flmol");

var $kFSrE = parcelRequire("kFSrE");

var $9doIl = parcelRequire("9doIl");

var $xbB8r = parcelRequire("xbB8r");
const $1210b60472af7bd4$export$4faeceaf3c6757a2 = (sourceAri, jqlContexts, customFilterIds)=>jqlContexts.length === 0 && customFilterIds.length === 0 ? (0, $3JafE.Observable).empty() : (0, $kFSrE.getDeriveFields)(sourceAri, jqlContexts, customFilterIds).map((deriveFields)=>{
        const deriveFieldsHash = (0, $9doIl.transformDerivedFieldsHash)(deriveFields);
        return (0, $xbB8r.setDeriveFieldsHash)(deriveFieldsHash);
    });

});
parcelRegister("kFSrE", function(module, exports) {

$parcel$export(module.exports, "getDeriveFields", () => $bb25699685202b59$export$8677adeb17044443);
parcelRequire("flmol");
parcelRequire("cpH8E");

var $azuWM = parcelRequire("azuWM");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");
const $bb25699685202b59$var$analyticKey = 'jira.frontend.fe.software.roadmap.derive-fields';
const $bb25699685202b59$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$9e57feecc7b4c365];
const $bb25699685202b59$export$8677adeb17044443 = (sourceAri, jqlContexts, customFilterIds)=>(0, $8sMwH.runQueryWithMetadata)((0, $azuWM.default), {
        sourceAri: sourceAri,
        jqlContexts: jqlContexts,
        customFilterIds: customFilterIds
    }, $bb25699685202b59$var$analyticKey, $bb25699685202b59$var$concurrentMetricDefinition).map(({ data: data })=>data.roadmaps?.roadmapDeriveFields?.reduce((acc, deriveField)=>{
            if (deriveField != null) acc.push(deriveField);
            return acc;
        }, []) ?? [])// gracefully handle any errors
    .catch(()=>[]);

});
parcelRegister("azuWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c38a89214e6bc6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4636b2692d5ceff90b984c30654913bf>>
 * @relayHash ae19ed1ed7424eb78d30531d31c19de9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01c1afb1671bea65374e5122e7f6071bed18381cc77a55f2fdf2be94c6806bd5
const $e8c38a89214e6bc6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "customFilterIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlContexts"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v3 = [
        {
            "concreteType": "RoadmapsQuery",
            "kind": "LinkedField",
            "name": "roadmaps",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "customFilterIds",
                            "variableName": "customFilterIds"
                        },
                        {
                            "kind": "Variable",
                            "name": "jqlContexts",
                            "variableName": "jqlContexts"
                        },
                        {
                            "kind": "Variable",
                            "name": "sourceARI",
                            "variableName": "sourceAri"
                        }
                    ],
                    "concreteType": "RoadmapField",
                    "kind": "LinkedField",
                    "name": "roadmapDeriveFields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "values"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "roadmapDeriveFieldsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "roadmapDeriveFieldsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "01c1afb1671bea65374e5122e7f6071bed18381cc77a55f2fdf2be94c6806bd5",
            "metadata": {},
            "name": "roadmapDeriveFieldsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e8c38a89214e6bc6$var$node.hash = "5b8a766134f80f9e9cd3532c1bf9cfbd";
var $e8c38a89214e6bc6$export$2e2bcd8739ae039 = $e8c38a89214e6bc6$var$node;

});




parcelRegister("l8It9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d66d5b956cbfab$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("dM0Xt");
parcelRequire("YLEHo");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $dCCTr = parcelRequire("dCCTr");

var $8xmdY = parcelRequire("8xmdY");

var $9BmXV = parcelRequire("9BmXV");

var $2byGo = parcelRequire("2byGo");

var $lf3BM = parcelRequire("lf3BM");

var $5aiBq = parcelRequire("5aiBq");
const $f2d66d5b956cbfab$var$combineEpicsWithErrorHandling = (...epics)=>{
    const epicsWithErrorHandling = epics.map((epic)=>(0, $dCCTr.default)('nonCriticalRoadmap', 'initializeNonCritical', epic, (error)=>{
            if (error?.skipSentry === true) {
                // strip out skip sentry flag and make sure it's logged to sentry
                // we never expect unhandled errors, even 403s, so we need to log everything
                const errorWithoutSkipSentry = {
                    ...error,
                    skipSentry: false
                };
                (0, $8xmdY.captureException)('common.epic-error.nonCriticalRoadmap.initializeNonCritical', errorWithoutSkipSentry);
            }
            return (0, $3JafE.Observable).of((0, $9BmXV.generalError)());
        }));
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $bd1K7.combineEpics)(...epicsWithErrorHandling);
};
var $f2d66d5b956cbfab$export$2e2bcd8739ae039 = $f2d66d5b956cbfab$var$combineEpicsWithErrorHandling((0, $5aiBq.default), (0, $lf3BM.default), (0, $2byGo.default));

});
parcelRegister("2byGo", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b8da59d4a62555$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("dM0Xt");
parcelRequire("YLEHo");

var $3JafE = parcelRequire("3JafE");

var $ecAMT = parcelRequire("ecAMT");

var $xbB8r = parcelRequire("xbB8r");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$63b8da59d4a62555$export$2e2bcd8739ae039 = (action$, _)=>action$.ofType((0, $ecAMT.INITIALIZE_NON_CRITICAL_DATA)).mergeMap(()=>(0, $3JafE.Observable).of((0, $xbB8r.deriveFieldsRequest)()));

});

parcelRegister("lf3BM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d7bb5eb418e0450$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("dM0Xt");
parcelRequire("YLEHo");

var $3JafE = parcelRequire("3JafE");

var $eGb5T = parcelRequire("eGb5T");

var $ecAMT = parcelRequire("ecAMT");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $jktkh = parcelRequire("jktkh");

var $cUmMY = parcelRequire("cUmMY");
const $9d7bb5eb418e0450$var$getInitializeGoalsAction = (sourceAri)=>(0, $eGb5T.getGoals)(sourceAri).map((0, $jktkh.setGoals));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$9d7bb5eb418e0450$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $ecAMT.INITIALIZE_NON_CRITICAL_DATA)).mergeMap(()=>{
        const state = store.getState();
        const sourceAri = (0, $lgKTA.getSourceARI)(state);
        const isGoalsFeatureEnabled = (0, $bwVWW.getIsGoalsFeatureEnabled)(state);
        const isGoalsLoaded = (0, $cUmMY.getIsGoalsLoaded)(state);
        if (isGoalsFeatureEnabled && !isGoalsLoaded) return $9d7bb5eb418e0450$var$getInitializeGoalsAction(sourceAri);
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("5aiBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6186b118a9ed0fd8$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("dM0Xt");
parcelRequire("YLEHo");

var $3JafE = parcelRequire("3JafE");

var $ecAMT = parcelRequire("ecAMT");

var $lgKTA = parcelRequire("lgKTA");

var $5B8Dm = parcelRequire("5B8Dm");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$6186b118a9ed0fd8$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $ecAMT.INITIALIZE_NON_CRITICAL_DATA)).mergeMap(()=>{
        const state = store.getState();
        let filterConfigAction = (0, $3JafE.Observable).empty();
        const sourceAri = (0, $lgKTA.getSourceARI)(state);
        const useQuickFilters = (0, $lgKTA.shouldUseQuickFilters)(state);
        const useCustomFilters = (0, $lgKTA.shouldUseCustomFilters)(state);
        if (sourceAri !== undefined) filterConfigAction = (0, $5B8Dm.getInitializeFilterConfigurationAction)(sourceAri, useQuickFilters, useCustomFilters);
        return filterConfigAction;
    });

});
parcelRegister("5B8Dm", function(module, exports) {

$parcel$export(module.exports, "getInitializeFilterConfigurationAction", () => $94df22d8ab234b96$export$e34f5233e08f98c7);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("flmol");

var $goPGr = parcelRequire("goPGr");

var $gdFA6 = parcelRequire("gdFA6");
const $94df22d8ab234b96$var$getConfig = (sourceAri)=>(0, $goPGr.getFilterConfiguration)(sourceAri).map((filterConfiguration)=>(0, $gdFA6.setFilterConfiguration)(filterConfiguration));
const $94df22d8ab234b96$export$e34f5233e08f98c7 = (sourceAri, useQuickFilters, useCustomFilters)=>useQuickFilters || useCustomFilters ? $94df22d8ab234b96$var$getConfig(sourceAri) : (0, $3JafE.Observable).empty();

});
parcelRegister("goPGr", function(module, exports) {

$parcel$export(module.exports, "getFilterConfiguration", () => $89d67d60c7ebc4d2$export$d01c426cf75c490);
parcelRequire("flmol");
parcelRequire("cpH8E");

var $fVD3i = parcelRequire("fVD3i");

var $KGbuW = parcelRequire("KGbuW");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");

var $9Rge1 = parcelRequire("9Rge1");
const $89d67d60c7ebc4d2$var$analyticKey = 'jira.frontend.fe.software.roadmap.filter-configuration';
const $89d67d60c7ebc4d2$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$bd4cd00ee0750c9a];
const $89d67d60c7ebc4d2$export$d01c426cf75c490 = (sourceAri)=>(0, $8sMwH.runQueryWithMetadata)((0, $fVD3i.default), (0, $KGbuW.generateFilterConfigurationQueryVariables)(sourceAri), $89d67d60c7ebc4d2$var$analyticKey, $89d67d60c7ebc4d2$var$concurrentMetricDefinition).map(({ data: data })=>{
        const filterConfig = {
            quickFilters: data.roadmaps?.roadmapFilterConfiguration?.quickFilters ?? [],
            customFilters: data.roadmaps?.roadmapFilterConfiguration?.customFilters ?? []
        };
        return (0, $9Rge1.transformFilterConfiguration)(filterConfig);
    });

});
parcelRegister("fVD3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $1de8c8eca9f8fc71$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b9141802c93be24cb6175859e1f8c92>>
 * @relayHash dba922c431b7d82ea815adb75d8379d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc6e5f91caa4ea72ba0e0c1b6e9705b161b4143857be506725a8d16a51690270
const $1de8c8eca9f8fc71$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = [
        {
            "concreteType": "RoadmapsQuery",
            "kind": "LinkedField",
            "name": "roadmaps",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "sourceARI",
                            "variableName": "sourceAri"
                        }
                    ],
                    "concreteType": "RoadmapFilterConfiguration",
                    "kind": "LinkedField",
                    "name": "roadmapFilterConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RoadmapQuickFilter",
                            "kind": "LinkedField",
                            "name": "quickFilters",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "query"
                                }
                            ]
                        },
                        {
                            "concreteType": "RoadmapCustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "roadmapFilterConfigurationQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "roadmapFilterConfigurationQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "bc6e5f91caa4ea72ba0e0c1b6e9705b161b4143857be506725a8d16a51690270",
            "metadata": {},
            "name": "roadmapFilterConfigurationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1de8c8eca9f8fc71$var$node.hash = "83a8710482c6bfc95e5dd7f72a0b0f83";
var $1de8c8eca9f8fc71$export$2e2bcd8739ae039 = $1de8c8eca9f8fc71$var$node;

});

parcelRegister("KGbuW", function(module, exports) {

$parcel$export(module.exports, "generateFilterConfigurationQueryVariables", () => $39cdfd22d13252ea$export$b527eee0f75a4247);
const $39cdfd22d13252ea$export$b527eee0f75a4247 = (sourceAri)=>({
        sourceAri: sourceAri
    });

});

parcelRegister("9Rge1", function(module, exports) {

$parcel$export(module.exports, "transformFilterConfiguration", () => $2f723c5c22fc5a2f$export$c699535cb8d8f356);
const $2f723c5c22fc5a2f$var$transformQuickFilters = (quickFilters)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    quickFilters.reduce((acc, quickFilter, position)=>{
        acc[quickFilter.id] = {
            id: quickFilter.id,
            name: quickFilter.name,
            query: quickFilter.query,
            position: position
        };
        return acc;
    }, {});
const $2f723c5c22fc5a2f$var$transformCustomFilters = (customFilters)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    customFilters.reduce((acc, customFilter)=>{
        acc[customFilter.id] = {
            id: customFilter.id,
            name: customFilter.name
        };
        return acc;
    }, {});
const $2f723c5c22fc5a2f$export$c699535cb8d8f356 = (filterConfig)=>({
        quickFilters: $2f723c5c22fc5a2f$var$transformQuickFilters(filterConfig.quickFilters),
        customFilters: $2f723c5c22fc5a2f$var$transformCustomFilters(filterConfig.customFilters)
    });

});





parcelRegister("7Jriz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5891e26d87714cc4$export$2e2bcd8739ae039);

var $MYW4e = parcelRequire("MYW4e");
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $ecAMT = parcelRequire("ecAMT");

var $37nmJ = parcelRequire("37nmJ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$5891e26d87714cc4$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $ecAMT.UPDATE_CRITICAL_DATA)).mergeMap((action)=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)((0, $37nmJ.getCriticalDataActions)(action.payload))));

});


parcelRegister("hRJN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4d1ce4998d4f91b$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $cDvag = parcelRequire("cDvag");

var $8gZ8s = parcelRequire("8gZ8s");

var $1tGmM = parcelRequire("1tGmM");

var $arpN2 = parcelRequire("arpN2");

var $cyqEc = parcelRequire("cyqEc");

var $jjw0S = parcelRequire("jjw0S");

var $31knk = parcelRequire("31knk");

var $kcW7T = parcelRequire("kcW7T");

var $7NPsf = parcelRequire("7NPsf");

var $Dr1ld = parcelRequire("Dr1ld");

var $5hBC0 = parcelRequire("5hBC0");

var $6h5Tl = parcelRequire("6h5Tl");

var $68rOS = parcelRequire("68rOS");

var $2AxzI = parcelRequire("2AxzI");

var $dH9r1 = parcelRequire("dH9r1");

var $7Ov8F = parcelRequire("7Ov8F");

var $9kTfp = parcelRequire("9kTfp");

var $ecqkK = parcelRequire("ecqkK");

var $DEW9W = parcelRequire("DEW9W");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$f4d1ce4998d4f91b$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $cyqEc.default), (0, $jjw0S.default), (0, $kcW7T.default), (0, $Dr1ld.default), (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)() ? (0, $5hBC0.default) : (0, $8gZ8s.dummyEpic), (0, $9kTfp.select), (0, $9kTfp.multiselect), // Remove with project_timeline_multi-select_and_checkboxes
(0, $9kTfp.default), (0, $ecqkK.default), (0, $DEW9W.default), (0, $dH9r1.default), (0, $68rOS.default), (0, $1tGmM.default), (0, $31knk.default), (0, $2AxzI.default), (0, $6h5Tl.default), (0, $7Ov8F.default), (0, $arpN2.default), (0, $7NPsf.default));

});
parcelRegister("8gZ8s", function(module, exports) {

$parcel$export(module.exports, "dummyEpic", () => $7036f82881506c3d$export$552a9a4c1c6d3b51);

var $3JafE = parcelRequire("3JafE");
const $7036f82881506c3d$export$552a9a4c1c6d3b51 = ()=>(0, $3JafE.Observable).empty();

});

parcelRegister("1tGmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2794343c7f2cffd$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $9BmXV = parcelRequire("9BmXV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d2794343c7f2cffd$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.ATTEMPT_RANK_ISSUE)).mergeMap((action)=>{
        const state = store.getState();
        if ((0, $bwVWW.rankIssuesSupported)(state)) return (0, $3JafE.Observable).of((0, $j45xj.rankIssue)(action.payload, action.meta.analyticsEvent));
        return (0, $3JafE.Observable).of((0, $9BmXV.unableToRankIssue)({
            boardId: (0, $lgKTA.getBoardId)(state)
        }));
    });

});

parcelRegister("arpN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9da8cb3eba66663d$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $j45xj = parcelRequire("j45xj");

var $4bpn3 = parcelRequire("4bpn3");

var $2ukAT = parcelRequire("2ukAT");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9da8cb3eba66663d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.ATTEMPT_REMOVE_ISSUE)).mergeMap((action)=>{
        const state = store.getState();
        const issueId = action.payload;
        const subtaskParent = (0, $2ukAT.getSubtaskParentHash)(state)[issueId];
        if (subtaskParent !== undefined) return (0, $3JafE.Observable).of((0, $4bpn3.removeSubtasks)([
            {
                id: issueId,
                parentId: subtaskParent
            }
        ]));
        return (0, $3JafE.Observable).of((0, $j45xj.removeIssue)(issueId));
    });

});
parcelRegister("4bpn3", function(module, exports) {

$parcel$export(module.exports, "EXTEND_SUBTASKS", () => $2720cce3e9de2f0b$export$d3662084139e9a0d);
$parcel$export(module.exports, "extendSubtasks", () => $2720cce3e9de2f0b$export$816acc63178ce4a8);
$parcel$export(module.exports, "ADD_SUBTASK", () => $2720cce3e9de2f0b$export$b9900d3419a32a0c);
$parcel$export(module.exports, "addSubtask", () => $2720cce3e9de2f0b$export$bcf961302100908a);
$parcel$export(module.exports, "REMOVE_SUBTASKS", () => $2720cce3e9de2f0b$export$446c994baf375781);
$parcel$export(module.exports, "removeSubtasks", () => $2720cce3e9de2f0b$export$2ca9bbaf7e1f372c);
$parcel$export(module.exports, "UPDATE_SUBTASK_STATUS", () => $2720cce3e9de2f0b$export$cc155d4209942051);
$parcel$export(module.exports, "updateSubtaskStatus", () => $2720cce3e9de2f0b$export$1a29221067edde72);
$parcel$export(module.exports, "CHANGE_SUBTASK_PARENT", () => $2720cce3e9de2f0b$export$8f84542de7233e3f);
$parcel$export(module.exports, "changeSubtaskParent", () => $2720cce3e9de2f0b$export$6e9bf93d0d5ca735);
const $2720cce3e9de2f0b$export$d3662084139e9a0d = 'state.entities.subtasks.EXTEND_SUBTASKS';
const $2720cce3e9de2f0b$export$816acc63178ce4a8 = (payload)=>({
        type: $2720cce3e9de2f0b$export$d3662084139e9a0d,
        payload: payload
    });
const $2720cce3e9de2f0b$export$b9900d3419a32a0c = 'state.entities.subtasks.ADD_SUBTASK';
const $2720cce3e9de2f0b$export$bcf961302100908a = (payload)=>({
        type: $2720cce3e9de2f0b$export$b9900d3419a32a0c,
        payload: payload
    });
const $2720cce3e9de2f0b$export$446c994baf375781 = 'state.entities.subtasks.REMOVE_SUBTASKS';
const $2720cce3e9de2f0b$export$2ca9bbaf7e1f372c = (payload)=>({
        type: $2720cce3e9de2f0b$export$446c994baf375781,
        payload: payload
    });
const $2720cce3e9de2f0b$export$cc155d4209942051 = 'state.entities.subtasks.UPDATE_SUBTASK_STATUS';
const $2720cce3e9de2f0b$export$1a29221067edde72 = (payload)=>({
        type: $2720cce3e9de2f0b$export$cc155d4209942051,
        payload: payload
    });
const $2720cce3e9de2f0b$export$8f84542de7233e3f = 'state.entities.subtasks.CHANGE_SUBTASK_PARENT';
const $2720cce3e9de2f0b$export$6e9bf93d0d5ca735 = (payload)=>({
        type: $2720cce3e9de2f0b$export$8f84542de7233e3f,
        payload: payload
    });

});


parcelRegister("cyqEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ebedf8451df8863$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("iects");

var $jsz0X = parcelRequire("jsz0X");

var $8ybWM = parcelRequire("8ybWM");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$1ebedf8451df8863$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $8ybWM.RETRIEVE_ISSUE_TYPE_COUNT)).mergeMap((action)=>{
        const { issueTypeId: issueTypeId, projectId: projectId } = action.payload;
        return (0, $jsz0X.default)(projectId, issueTypeId).map((issueCount)=>{
            const newCounts = {};
            newCounts[issueTypeId] = issueCount;
            return (0, $8ybWM.extendIssueTypeCount)(newCounts);
        });
    });

});
parcelRegister("jsz0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae5518c9fd0d519$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $aiRd8 = parcelRequire("aiRd8");
const $bae5518c9fd0d519$var$getJqlForCount = (projectId, issueTypeId)=>`project = ${projectId} AND issuetype = ${issueTypeId}`;
var // This function returns the number of issues of a particular type
// eslint-disable-next-line jira/import/no-anonymous-default-export
$bae5518c9fd0d519$export$2e2bcd8739ae039 = (projectId, issueTypeId)=>{
    const options = {
        method: 'POST',
        body: JSON.stringify({
            jql: $bae5518c9fd0d519$var$getJqlForCount(projectId, issueTypeId),
            fields: [],
            expand: []
        })
    };
    return (0, $aiRd8.default)('/rest/api/2/search', options).map((result)=>result.total);
};

});


parcelRegister("jjw0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $c045de97315f169f$export$2e2bcd8739ae039);
parcelRequire("iects");

var $ldoFd = parcelRequire("ldoFd");


var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $9ZLrP = parcelRequire("9ZLrP");

var $11LHz = parcelRequire("11LHz");

var $6Mk6Q = parcelRequire("6Mk6Q");

var $2g8iV = parcelRequire("2g8iV");

var $adQBo = parcelRequire("adQBo");
const $c045de97315f169f$export$c70950e65a75fd8a = (field)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(field)) {
        if (Array.isArray(field) && field.length > 0) return true;
        const fieldType = typeof field;
        if (fieldType === 'boolean' || fieldType === 'number') return true;
        if (fieldType === 'string') return field.length > 0;
        if (typeof field === 'object') return $c045de97315f169f$export$c70950e65a75fd8a(field.value);
    }
    // unknown field type
    return false;
};
var /* This is the entry point for creating an issue on the server. The bulk of the work is
 * is delegated to the relevant utilities depending on whether an issue has required fields.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$c045de97315f169f$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.CREATE_ISSUE)).mergeMap((action)=>{
        const state = store.getState();
        const createItemAnchor = (0, $11LHz.getCreateItemAnchor)(state);
        if (createItemAnchor === undefined) throw new Error('Cannot create an issue without an anchor (anchor was undefined)');
        const { summary: summary, issueTypeId: issueTypeId } = action.payload;
        const parentId = 'parentId' in createItemAnchor && createItemAnchor.parentId ? createItemAnchor.parentId : undefined;
        const { assignees: assignees, labels: labels, versions: versions, components: components } = (0, $9ZLrP.getIssuesFilter)(state);
        const filteredAssignees = assignees.filter((assignee)=>assignee !== (0, $44677eb502cfd308$export$12e572fd459c10dc));
        const assignee = filteredAssignees[filteredAssignees.length - 1]; // retrieve last selected assignee
        const filteredVersions = versions.filter((version)=>version !== (0, $44677eb502cfd308$export$ac95b4b2317d4b33));
        const filteredLabels = labels.filter((label)=>label !== (0, $44677eb502cfd308$export$81ef49afbbead0a1));
        const filteredComponents = components.filter((component)=>component !== (0, $44677eb502cfd308$export$4b7c755e61199a36));
        const requiredFields = (0, $bwVWW.getRequiredFieldsByIssueTypeId)(state, issueTypeId);
        const derivedFieldsHash = (0, $bwVWW.getFullDerivedFields)(state);
        const sprintCFId = (0, $bwVWW.getSprintCustomFieldId)(state);
        const optimisticIssue = (0, $2g8iV.mergeIssueContexts)((0, $2g8iV.derivedFieldsToIssueContext)(derivedFieldsHash, sprintCFId), {
            summary: {
                value: summary
            },
            assignee: assignee,
            issueTypeId: issueTypeId,
            parentId: {
                value: parentId
            },
            labels: filteredLabels,
            versionIds: filteredVersions,
            componentIds: filteredComponents
        });
        if (requiredFields.some((requiredField)=>// @ts-expect-error - We are handling any type
            !$c045de97315f169f$export$c70950e65a75fd8a(optimisticIssue[requiredField]) && !$c045de97315f169f$export$c70950e65a75fd8a(derivedFieldsHash[requiredField]))) return (0, $adQBo.default)(store, action, optimisticIssue);
        return (0, $6Mk6Q.default)(store, action, optimisticIssue, createItemAnchor);
    });

});
parcelRegister("11LHz", function(module, exports) {

$parcel$export(module.exports, "getCreateItemAnchor", () => $01bd3ab4a4374e8e$export$136936d41252875f);
$parcel$export(module.exports, "getExpandedItems", () => $01bd3ab4a4374e8e$export$b38bc92ef8b87c5c);
$parcel$export(module.exports, "getSelectedItemIds", () => $01bd3ab4a4374e8e$export$e9f0552305c19203);
$parcel$export(module.exports, "getSelectionAnchors", () => $01bd3ab4a4374e8e$export$3c56d171cade2f38);
$parcel$export(module.exports, "getTooltipParams", () => $01bd3ab4a4374e8e$export$27834ee3c7180cde);
const $01bd3ab4a4374e8e$export$136936d41252875f = (state)=>state.ui.table.createItemAnchor;
const $01bd3ab4a4374e8e$export$b38bc92ef8b87c5c = (state)=>state.ui.table.expandedItems;
const $01bd3ab4a4374e8e$export$e9f0552305c19203 = (state)=>state.ui.table.selectedItemIds;
const $01bd3ab4a4374e8e$export$3c56d171cade2f38 = (state)=>state.ui.table.selectionAnchors;
const $01bd3ab4a4374e8e$export$27834ee3c7180cde = (state)=>state.ui.table.tooltip;

});

parcelRegister("6Mk6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9ee224d9e018b3b$export$2e2bcd8739ae039);
parcelRequire("dM0Xt");
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $kbiEp = parcelRequire("kbiEp");

var $iyGt9 = parcelRequire("iyGt9");

var $hmc1Z = parcelRequire("hmc1Z");

var $cDvag = parcelRequire("cDvag");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $cuKcG = parcelRequire("cuKcG");

var $j45xj = parcelRequire("j45xj");

var $9BmXV = parcelRequire("9BmXV");

var $6489W = parcelRequire("6489W");

var $9ZLrP = parcelRequire("9ZLrP");

var $5MpXz = parcelRequire("5MpXz");

var $gdFA6 = parcelRequire("gdFA6");

var $hTAd9 = parcelRequire("hTAd9");

var $htXdF = parcelRequire("htXdF");

var $16ixF = parcelRequire("16ixF");

var $7J2Ol = parcelRequire("7J2Ol");

var $g5l0l = parcelRequire("g5l0l");

var $66ncF = parcelRequire("66ncF");

var $7yIcx = parcelRequire("7yIcx");
const $e9ee224d9e018b3b$var$getPostCreateActions = (state, temporaryId, { id: id, key: key, issue: issue, matchesSource: matchesSource, matchesJqlFilters: matchesJqlFilters }, skipQuickFilters)=>{
    const actions = [];
    if (matchesSource && issue !== undefined) {
        actions.push((0, $j45xj.replaceIssue)({
            temporaryId: temporaryId,
            id: id,
            issue: issue
        }, (0, $j45xj.CREATE_ISSUE)));
        if (!(0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)()) {
            const { isHiddenByFilter: isHiddenByFilter } = (0, $7J2Ol.getIsIssueHiddenByFiltersOrSettings)(state, issue, id, skipQuickFilters);
            const isHidden = isHiddenByFilter || !matchesJqlFilters;
            if (isHidden) actions.push((0, $9BmXV.issueHidden)({
                ids: [
                    id
                ]
            }));
        }
        if (matchesJqlFilters) {
            const currentlyVisibleIssueIds = (0, $hTAd9.getJQLFilteredIssueIds)(state);
            if ((0, $6489W.getQueryContainsJQLFilters)(state)) actions.push((0, $gdFA6.jqlFiltersSuccess)([
                ...currentlyVisibleIssueIds,
                id
            ]));
        }
    } else {
        if (!key) throw new Error('Cannot remove issue without a key (key was undefined)');
        actions.push((0, $j45xj.removeIssue)(temporaryId), (0, $9BmXV.irrelevantIssuesCreated)({
            issueKeys: [
                key
            ]
        }));
    }
    return (0, $MYW4e.batchActions)(actions);
};
const $e9ee224d9e018b3b$var$getCreateErrorActions = (temporaryId, aggErrorAction)=>(0, $MYW4e.batchActions)([
        aggErrorAction ?? (0, $9BmXV.aggError)(),
        (0, $j45xj.removeIssue)(temporaryId),
        (0, $htXdF.resetCreateItemAnchor)()
    ]);
const $e9ee224d9e018b3b$var$createOnBackend = (store, temporaryId, optimisticIssue, createItemAnchor, analyticsEvent)=>{
    const state = store.getState();
    const { issueTypeId: issueTypeId } = optimisticIssue;
    const projectId = (0, $bwVWW.getProjectId)(state);
    const sourceARI = (0, $lgKTA.getSourceARI)(state);
    const jql = (0, $bwVWW.getBoardJql)(state);
    let jqlContexts = [];
    if ((0, $lgKTA.isClassic)(state)) jqlContexts = (0, $hTAd9.getFilteredQuickFilterQueries)(state);
    else if (!(0, $lgKTA.isClassic)(state)) jqlContexts = (0, $9ZLrP.getFilteredCustomFilters)(state);
    return (0, $g5l0l.getSafeRankBeforeRequest)(state, createItemAnchor !== undefined && 'beforeId' in createItemAnchor && createItemAnchor.beforeId !== undefined ? createItemAnchor.beforeId : undefined).mergeMap((rankRequest)=>(0, $iyGt9.create)({
            sourceARI: sourceARI,
            input: {
                projectId: projectId,
                itemTypeId: issueTypeId,
                parentId: optimisticIssue.parentId.value,
                summary: optimisticIssue.summary.value,
                dueDate: null,
                startDate: null,
                color: optimisticIssue.color.value,
                rank: rankRequest ? {
                    beforeId: String(rankRequest.beforeId)
                } : undefined,
                jql: jql,
                jqlContexts: jqlContexts,
                assignee: optimisticIssue.assignee,
                labels: optimisticIssue.labels.length > 0 ? optimisticIssue.labels : undefined,
                componentIds: optimisticIssue.componentIds.length > 0 ? optimisticIssue.componentIds : undefined,
                versionIds: optimisticIssue.versionIds.length > 0 ? optimisticIssue.versionIds : undefined
            }
        })).mergeMap((data)=>{
        const addRoadmapItemPayload = data?.roadmaps?.addRoadmapItem;
        const addRoadmapItemOutput = data?.roadmaps?.addRoadmapItem?.output;
        if (addRoadmapItemPayload?.success === true && addRoadmapItemOutput) {
            const { id: id, key: key, matchesSource: matchesSource, matchesJqlFilters: matchesJqlFilters, item: item } = addRoadmapItemOutput;
            // WARNING!!! We need to retrieve the state again here as a workaround to a race-condition #ROAD-3073
            const safeState = store.getState();
            const createIssue = {
                id: id,
                parentId: optimisticIssue.parentId.value,
                issueTypeId: issueTypeId,
                key: key,
                issue: item ? (0, $hmc1Z.transformIssue)(item) : undefined,
                matchesSource: matchesSource,
                matchesJqlFilters: matchesJqlFilters ?? true
            };
            (0, $66ncF.performPostCreateSideEffects)(safeState, temporaryId, createIssue, analyticsEvent);
            const skipQuickFilters = matchesJqlFilters ?? true;
            return (0, $3JafE.Observable).of($e9ee224d9e018b3b$var$getPostCreateActions(safeState, temporaryId, createIssue, skipQuickFilters));
        }
        const errorMessage = (0, $7yIcx.getGICReasonOnCreateError)(addRoadmapItemPayload?.errors);
        if (errorMessage) return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
            (0, $j45xj.removeIssue)(temporaryId),
            (0, $cuKcG.addPayloadGlobalIssueCreate)((0, $7yIcx.getFieldsForCreateDialogGIC)(state, optimisticIssue, errorMessage)),
            (0, $5MpXz.updateCreationPreferences)({
                itemTypeId: issueTypeId,
                level: optimisticIssue.parentId.value ? (0, $kbiEp.BASE_LEVEL) : (0, $kbiEp.PARENT_LEVEL),
                projectId: projectId
            }),
            (0, $htXdF.resetCreateItemAnchor)()
        ]));
        return (0, $16ixF.onHandleAggErrors)(!!addRoadmapItemPayload, addRoadmapItemPayload?.errors).map((aggErrorAction)=>$e9ee224d9e018b3b$var$getCreateErrorActions(temporaryId, aggErrorAction));
    }).catch(()=>(0, $3JafE.Observable).of($e9ee224d9e018b3b$var$getCreateErrorActions(temporaryId)));
};
/* When an issue has no required fields it can be created inline.
 * 1. Insert an optimistic issue.
 * 2. Create, or create and rank issue on the backend. Depends on the create anchor (sibling, parent, etc).
 * 3. Replace the optimistic issue with the real issue, or remove it. Depends on post-create visibility.
 */ const $e9ee224d9e018b3b$var$inlineCreate = (store, { payload: { level: level }, meta: meta }, optimisticIssue, createItemAnchor)=>{
    const projectId = (0, $bwVWW.getProjectId)(store.getState());
    const { issueTypeId: issueTypeId } = optimisticIssue;
    const temporaryId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
    const optimisticActions = [
        (0, $5MpXz.updateCreationPreferences)({
            itemTypeId: issueTypeId,
            level: level,
            projectId: projectId
        }),
        (0, $j45xj.insertIssue)({
            id: temporaryId,
            issue: optimisticIssue,
            anchor: createItemAnchor
        })
    ];
    if (meta.resetCreateItemAnchor) optimisticActions.push((0, $htXdF.resetCreateItemAnchor)());
    return (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $MYW4e.batchActions)(optimisticActions)), $e9ee224d9e018b3b$var$createOnBackend(store, temporaryId, optimisticIssue, createItemAnchor, meta.analyticsEvent));
};
var $e9ee224d9e018b3b$export$2e2bcd8739ae039 = $e9ee224d9e018b3b$var$inlineCreate;

});
parcelRegister("iyGt9", function(module, exports) {

$parcel$export(module.exports, "create", () => $223c7ab6a7952ab8$export$185802fd694ee1f5);

var $6kWJL = parcelRequire("6kWJL");
parcelRequire("jyKN9");
parcelRequire("iects");

var $bKxX9 = parcelRequire("bKxX9");


var $jie15 = parcelRequire("jie15");

var $9ouT3 = parcelRequire("9ouT3");
const $223c7ab6a7952ab8$var$concurrentMetricDefinition = (0, $9ouT3.mutationMetrics)[0, $028d5637f56fe710$export$2afae5ee414caffb];
const $223c7ab6a7952ab8$var$analyticKey = 'jira.frontend.fe.software.roadmap.persist-issue';
const $223c7ab6a7952ab8$var$mutationName = 'addRoadmapItem';
const $223c7ab6a7952ab8$export$185802fd694ee1f5 = ({ sourceARI: sourceARI, input: input })=>(0, $jie15.runMutation)($223c7ab6a7952ab8$var$mutationName, (0, $6kWJL.default), {
        sourceARI: sourceARI,
        input: input,
        isRoadmapsCriticalDataItemFlaggedEnabled: (0, $bKxX9.ff)('jsw.timeline.return-flagged-attribute-fe')
    }, $223c7ab6a7952ab8$var$analyticKey, $223c7ab6a7952ab8$var$concurrentMetricDefinition);

});
parcelRegister("6kWJL", function(module, exports) {

$parcel$export(module.exports, "default", () => $80977e4e3915b36d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<505aa4f805ebe71f3f28cccdd8184b4b>>
 * @relayHash 78dd425f98792f38e9f6e8424a58c087
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3758129448547311f08b77e2bed6324551c5cffddb448486c6a3fe20ba22e4cb
const $80977e4e3915b36d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRoadmapsCriticalDataItemFlaggedEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceARI"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceARI"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            },
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ],
        "type": "RoadmapMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "matchesSource"
    }, v10 = {
        "kind": "ScalarField",
        "name": "matchesJqlFilters"
    }, v11 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v13 = {
        "kind": "ScalarField",
        "name": "startDateRFC3339"
    }, v14 = {
        "kind": "ScalarField",
        "name": "dueDateRFC3339"
    }, v15 = {
        "kind": "ScalarField",
        "name": "color"
    }, v16 = {
        "kind": "ScalarField",
        "name": "dependencies"
    }, v17 = {
        "kind": "ScalarField",
        "name": "itemTypeId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v21 = [
        v7 /*: any*/ 
    ], v22 = {
        "concreteType": "RoadmapItemStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "RoadmapItemStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": v21 /*: any*/ 
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "rank"
    }, v24 = {
        "kind": "ScalarField",
        "name": "labels"
    }, v25 = {
        "kind": "ScalarField",
        "name": "sprintIds"
    }, v26 = {
        "kind": "ScalarField",
        "name": "versionIds"
    }, v27 = {
        "kind": "ScalarField",
        "name": "componentIds"
    }, v28 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v29 = {
        "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "flagged"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "addRoadmapItemMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "RoadmapAddItemPayload",
                            "kind": "LinkedField",
                            "name": "addRoadmapItem",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "RoadmapAddItemResponse",
                                    "kind": "LinkedField",
                                    "name": "output",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "RoadmapItem",
                                            "kind": "LinkedField",
                                            "name": "item",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v29 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "addRoadmapItemMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "RoadmapAddItemPayload",
                            "kind": "LinkedField",
                            "name": "addRoadmapItem",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v21 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "RoadmapAddItemResponse",
                                    "kind": "LinkedField",
                                    "name": "output",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "RoadmapItem",
                                            "kind": "LinkedField",
                                            "name": "item",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        v30 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v29 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3758129448547311f08b77e2bed6324551c5cffddb448486c6a3fe20ba22e4cb",
            "metadata": {},
            "name": "addRoadmapItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$80977e4e3915b36d$var$node.hash = "5d55eaa73059fae775c21e07aebd6bbe";
var $80977e4e3915b36d$export$2e2bcd8739ae039 = $80977e4e3915b36d$var$node;

});


parcelRegister("cuKcG", function(module, exports) {

$parcel$export(module.exports, "ADD_PAYLOAD_GLOBAL_ISSUE_CREATE", () => $623bd14796a7f4ff$export$675a960198823add);
$parcel$export(module.exports, "addPayloadGlobalIssueCreate", () => $623bd14796a7f4ff$export$e0ba284a1fc021b7);
$parcel$export(module.exports, "CLEAR_PAYLOAD_GLOBAL_ISSUE_CREATE", () => $623bd14796a7f4ff$export$91304df9531434d5);
$parcel$export(module.exports, "clearPayloadGlobalIssueCreate", () => $623bd14796a7f4ff$export$a32481b575495215);
const $623bd14796a7f4ff$export$675a960198823add = 'state.entities.global-issue-create.ADD_PAYLOAD_GLOBAL_ISSUE_CREATE';
const $623bd14796a7f4ff$export$e0ba284a1fc021b7 = (payload)=>({
        type: $623bd14796a7f4ff$export$675a960198823add,
        payload: payload
    });
const $623bd14796a7f4ff$export$91304df9531434d5 = 'state.entities.global-issue-create.CLEAR_PAYLOAD_GLOBAL_ISSUE_CREATE';
const $623bd14796a7f4ff$export$a32481b575495215 = ()=>({
        type: $623bd14796a7f4ff$export$91304df9531434d5
    });

});

parcelRegister("htXdF", function(module, exports) {

$parcel$export(module.exports, "SET_CREATE_ITEM_ANCHOR", () => $7c954c57bd3e0c7d$export$95f769ba297653c2);
$parcel$export(module.exports, "setCreateItemAnchor", () => $7c954c57bd3e0c7d$export$f1ba3db771e71820);
$parcel$export(module.exports, "RESET_CREATE_ITEM_ANCHOR", () => $7c954c57bd3e0c7d$export$a01718abc83595db);
$parcel$export(module.exports, "resetCreateItemAnchor", () => $7c954c57bd3e0c7d$export$40c3dbaf42b82dd3);
$parcel$export(module.exports, "CHANGE_EXPANSION_STATE", () => $7c954c57bd3e0c7d$export$ed5ea3119374e5c6);
$parcel$export(module.exports, "changeExpansionState", () => $7c954c57bd3e0c7d$export$51e4400863559e4f);
$parcel$export(module.exports, "BULK_CHANGE_EXPANSION_STATE", () => $7c954c57bd3e0c7d$export$db80068e23e4152b);
$parcel$export(module.exports, "bulkChangeExpansionState", () => $7c954c57bd3e0c7d$export$a8352c05f0f63574);
$parcel$export(module.exports, "EXPAND_ALL_ISSUES", () => $7c954c57bd3e0c7d$export$33c6058a7747823c);
$parcel$export(module.exports, "expandAllIssues", () => $7c954c57bd3e0c7d$export$10ac7c690c63aaee);
$parcel$export(module.exports, "COLLAPSE_ALL_ISSUES", () => $7c954c57bd3e0c7d$export$404716ca78e6b45b);
$parcel$export(module.exports, "collapseAllIssues", () => $7c954c57bd3e0c7d$export$4c55fb4cb44a67e0);
$parcel$export(module.exports, "SHOW_TOOLTIP", () => $7c954c57bd3e0c7d$export$7214ccce749e0556);
$parcel$export(module.exports, "showToolTip", () => $7c954c57bd3e0c7d$export$b5df56b714e320a5);
$parcel$export(module.exports, "HIDE_TOOLTIP", () => $7c954c57bd3e0c7d$export$ab59b5e1053acdd);
$parcel$export(module.exports, "hideToolTip", () => $7c954c57bd3e0c7d$export$fa43f0bcb12c5e1c);
$parcel$export(module.exports, "SELECT_ITEMS", () => $7c954c57bd3e0c7d$export$11e14d85d660d6b3);
$parcel$export(module.exports, "selectItems", () => $7c954c57bd3e0c7d$export$3978dea8a714b756);
$parcel$export(module.exports, "SELECT_MULTIPLE_ITEMS", () => $7c954c57bd3e0c7d$export$3366b046d25a8b48);
$parcel$export(module.exports, "selectMultipleItems", () => $7c954c57bd3e0c7d$export$d747c0060051d52c);
$parcel$export(module.exports, "ACTIVATE_ITEM", () => $7c954c57bd3e0c7d$export$62d5ab861bf71935);
$parcel$export(module.exports, "activateItem", () => $7c954c57bd3e0c7d$export$3031f509587c24cc);
$parcel$export(module.exports, "SET_SELECTED_ITEMS", () => $7c954c57bd3e0c7d$export$9aefe348679263b5);
$parcel$export(module.exports, "setSelectedItemIds", () => $7c954c57bd3e0c7d$export$541aa27b138a3895);
$parcel$export(module.exports, "SET_SELECTION_ANCHORS", () => $7c954c57bd3e0c7d$export$a12b0f6c746053e3);
$parcel$export(module.exports, "setSelectionAnchors", () => $7c954c57bd3e0c7d$export$b8f7c93739288e95);
const $7c954c57bd3e0c7d$export$95f769ba297653c2 = 'state.ui.table.SET_CREATE_ITEM_ANCHOR';
const $7c954c57bd3e0c7d$export$f1ba3db771e71820 = (payload)=>({
        type: $7c954c57bd3e0c7d$export$95f769ba297653c2,
        payload: payload
    });
const $7c954c57bd3e0c7d$export$a01718abc83595db = 'state.ui.table.RESET_CREATE_ITEM_ANCHOR';
const $7c954c57bd3e0c7d$export$40c3dbaf42b82dd3 = ()=>({
        type: $7c954c57bd3e0c7d$export$a01718abc83595db
    });
const $7c954c57bd3e0c7d$export$ed5ea3119374e5c6 = 'state.ui.table.CHANGE_EXPANSION_STATE';
const $7c954c57bd3e0c7d$export$51e4400863559e4f = (payload)=>({
        type: $7c954c57bd3e0c7d$export$ed5ea3119374e5c6,
        payload: payload
    });
const $7c954c57bd3e0c7d$export$db80068e23e4152b = 'state.ui.table.BULK_CHANGE_EXPANSION_STATE';
const $7c954c57bd3e0c7d$export$a8352c05f0f63574 = (payload)=>({
        type: $7c954c57bd3e0c7d$export$db80068e23e4152b,
        payload: payload
    });
const $7c954c57bd3e0c7d$export$33c6058a7747823c = 'state.ui.table.EXPAND_ALL_ISSUES';
const $7c954c57bd3e0c7d$export$10ac7c690c63aaee = ()=>({
        type: $7c954c57bd3e0c7d$export$33c6058a7747823c
    });
const $7c954c57bd3e0c7d$export$404716ca78e6b45b = 'state.ui.table.COLLAPSE_ALL_ISSUES';
const $7c954c57bd3e0c7d$export$4c55fb4cb44a67e0 = ()=>({
        type: $7c954c57bd3e0c7d$export$404716ca78e6b45b
    });
const $7c954c57bd3e0c7d$export$7214ccce749e0556 = 'state.ui.table.SHOW_TOOLTIP';
const $7c954c57bd3e0c7d$export$b5df56b714e320a5 = (payload)=>({
        type: $7c954c57bd3e0c7d$export$7214ccce749e0556,
        payload: payload
    });
const $7c954c57bd3e0c7d$export$ab59b5e1053acdd = 'state.ui.table.HIDE_TOOLTIP';
const $7c954c57bd3e0c7d$export$fa43f0bcb12c5e1c = ()=>({
        type: $7c954c57bd3e0c7d$export$ab59b5e1053acdd
    });
const $7c954c57bd3e0c7d$export$11e14d85d660d6b3 = 'state.ui.table.SELECT_ITEMS'; // Remove with project_timeline_multi-select_and_checkboxes
const $7c954c57bd3e0c7d$export$3978dea8a714b756 = (payload, analyticsEvent)=>({
        type: $7c954c57bd3e0c7d$export$11e14d85d660d6b3,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $7c954c57bd3e0c7d$export$3366b046d25a8b48 = 'state.ui.table.SELECT_MULTIPLE_ITEMS';
const $7c954c57bd3e0c7d$export$d747c0060051d52c = (analyticsEvent, itemIds)=>({
        type: $7c954c57bd3e0c7d$export$3366b046d25a8b48,
        payload: {
            itemIds: itemIds,
            analyticsEvent: analyticsEvent
        }
    });
const $7c954c57bd3e0c7d$export$62d5ab861bf71935 = 'state.ui.table.ACTIVATE_ITEM';
const $7c954c57bd3e0c7d$export$3031f509587c24cc = (itemId)=>({
        type: $7c954c57bd3e0c7d$export$62d5ab861bf71935,
        payload: {
            itemId: itemId
        }
    });
const $7c954c57bd3e0c7d$export$9aefe348679263b5 = 'state.ui.table.SET_SELECTED_ITEMS';
const $7c954c57bd3e0c7d$export$541aa27b138a3895 = (payload)=>({
        type: $7c954c57bd3e0c7d$export$9aefe348679263b5,
        payload: payload
    });
const $7c954c57bd3e0c7d$export$a12b0f6c746053e3 = 'state.ui.table.SET_SELECTION_ANCHORS';
const $7c954c57bd3e0c7d$export$b8f7c93739288e95 = (payload)=>({
        type: $7c954c57bd3e0c7d$export$a12b0f6c746053e3,
        payload: payload
    });

});

parcelRegister("7J2Ol", function(module, exports) {

$parcel$export(module.exports, "getFieldModForIssueUpdate", () => $58cff8b95a43ff3b$export$9bcd863363405f3a);
$parcel$export(module.exports, "getIsIssueHiddenByFiltersOrSettings", () => $58cff8b95a43ff3b$export$f7eb58b1156295bd);

var $6G5mG = parcelRequire("6G5mG");

var $3PMIz = parcelRequire("3PMIz");

var $3YMoa = parcelRequire("3YMoa");

var $9E22T = parcelRequire("9E22T");
const $58cff8b95a43ff3b$export$9bcd863363405f3a = (issue)=>{
    const fieldMod = {};
    const clearFields = [];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(issue.summary, 'old')) fieldMod.summary = issue.summary.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(issue.startDate, 'old')) {
        if (issue.startDate.value === undefined) clearFields.push((0, $3PMIz.START_DATE));
        else fieldMod.startDate = issue.startDate.value;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(issue.dueDate, 'old')) {
        if (issue.dueDate.value === undefined) clearFields.push((0, $3PMIz.DUE_DATE));
        else fieldMod.dueDate = issue.dueDate.value;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(issue.color, 'old')) fieldMod.color = issue.color.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(issue.parentId, 'old')) fieldMod.parentId = issue.parentId.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(issue.sprintIds, 'old')) {
        if (issue.sprintIds.value.length === 0) clearFields.push((0, $3PMIz.SPRINT_IDS));
        else {
            const sprintId = issue.sprintIds.value[0];
            fieldMod.sprintId = sprintId;
        }
    }
    if (clearFields.length > 0) fieldMod.clearFields = clearFields;
    return fieldMod;
};
const $58cff8b95a43ff3b$export$f7eb58b1156295bd = (state, issue, issueId, skipQuickFilters = false)=>{
    const { key: key, issueTypeId: issueTypeId, summary: summary, status: status, assignee: assigneeId, labels: labels, parentId: parentId, versionIds: versionIds, dueDate: dueDate, componentIds: componentIds } = issue;
    const filter = (0, $9E22T.getFilterFunction)(state, skipQuickFilters);
    const settingFilter = (0, $9E22T.getSettingFilterFunction)(state);
    const userDisplayNameHash = (0, $3YMoa.getUserDisplayNameHash)(state);
    const assignee = assigneeId !== undefined ? {
        id: assigneeId,
        displayName: userDisplayNameHash[assigneeId]
    } : undefined;
    const filterFields = {
        key: key,
        summary: summary.value,
        labels: labels,
        parentId: parentId.value,
        type: {
            id: issueTypeId
        },
        versionIds: versionIds,
        componentIds: componentIds,
        statusCategoryId: status?.statusCategoryId,
        children: [],
        assignee: assignee,
        dueDate: dueDate.value,
        id: issueId
    };
    const isHiddenByFilter = filter ? filter(filterFields) === false : false;
    const isHiddenBySetting = settingFilter ? settingFilter(filterFields) === false : false;
    return {
        isHiddenByFilter: isHiddenByFilter,
        isHiddenBySetting: isHiddenBySetting
    };
};

});
parcelRegister("3PMIz", function(module, exports) {

$parcel$export(module.exports, "SUMMARY", () => $7a4fee9c7d68c0f9$export$913055729e1380b2);
$parcel$export(module.exports, "START_DATE", () => $7a4fee9c7d68c0f9$export$99a467bcc22b8df9);
$parcel$export(module.exports, "DUE_DATE", () => $7a4fee9c7d68c0f9$export$cf7e173386d30cdd);
$parcel$export(module.exports, "COLOR", () => $7a4fee9c7d68c0f9$export$9b982809044276a6);
$parcel$export(module.exports, "STATUS", () => $7a4fee9c7d68c0f9$export$e50006273435e7d4);
$parcel$export(module.exports, "ASSIGNEE", () => $7a4fee9c7d68c0f9$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "LABELS", () => $7a4fee9c7d68c0f9$export$79b91d4669dcadcb);
$parcel$export(module.exports, "PARENT_ID", () => $7a4fee9c7d68c0f9$export$3af4d9a28905196d);
$parcel$export(module.exports, "SPRINT_IDS", () => $7a4fee9c7d68c0f9$export$fca7b6a230da6c2);
$parcel$export(module.exports, "VERSION_IDS", () => $7a4fee9c7d68c0f9$export$d47cf884beb9bf04);
$parcel$export(module.exports, "COMPONENT_IDS", () => $7a4fee9c7d68c0f9$export$38f111893f96104);
$parcel$export(module.exports, "ISSUE_TYPE", () => $7a4fee9c7d68c0f9$export$ebb48b08205007c5);

var $lO4Or = parcelRequire("lO4Or");
const $7a4fee9c7d68c0f9$export$913055729e1380b2 = (0, $lO4Or.SUMMARY_TYPE);
const $7a4fee9c7d68c0f9$export$99a467bcc22b8df9 = (0, $lO4Or.START_DATE_TYPE);
const $7a4fee9c7d68c0f9$export$cf7e173386d30cdd = 'dueDate';
const $7a4fee9c7d68c0f9$export$9b982809044276a6 = (0, $lO4Or.COLOR_TYPE);
const $7a4fee9c7d68c0f9$export$e50006273435e7d4 = (0, $lO4Or.STATUS_TYPE);
const $7a4fee9c7d68c0f9$export$f8f7545d2bb78afb = (0, $lO4Or.ASSIGNEE_TYPE);
const $7a4fee9c7d68c0f9$export$79b91d4669dcadcb = (0, $lO4Or.LABELS_TYPE);
const $7a4fee9c7d68c0f9$export$3af4d9a28905196d = 'parentId';
const $7a4fee9c7d68c0f9$export$fca7b6a230da6c2 = 'sprintIds';
const $7a4fee9c7d68c0f9$export$d47cf884beb9bf04 = 'versionIds';
const $7a4fee9c7d68c0f9$export$38f111893f96104 = 'componentIds';
const $7a4fee9c7d68c0f9$export$ebb48b08205007c5 = (0, $lO4Or.ISSUE_TYPE);

});

parcelRegister("3YMoa", function(module, exports) {

$parcel$export(module.exports, "getFullUserHash", () => $d302a38f292ec82f$export$9c65f1b2beec0059);
$parcel$export(module.exports, "getUser", () => $d302a38f292ec82f$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUserDisplayNameHash", () => $d302a38f292ec82f$export$160cfd792cba790f);
$parcel$export(module.exports, "getUserAvatar16x16Hash", () => $d302a38f292ec82f$export$275c56c7a00ae6ca);

var $6G5mG = parcelRequire("6G5mG");

var $6ah8E = parcelRequire("6ah8E");

var $eIDUd = parcelRequire("eIDUd");
const $d302a38f292ec82f$export$9c65f1b2beec0059 = (state)=>state.entities.users.hash;
const $d302a38f292ec82f$export$7cbf767827cd68ba = (state, accountId)=>$d302a38f292ec82f$export$9c65f1b2beec0059(state)[accountId];
// ============== //
// === HASHES === //
// ============== //
const $d302a38f292ec82f$var$entityUpdateSelector = (0, $6ah8E.createVersionedEntityHashDiffSelector)($d302a38f292ec82f$export$9c65f1b2beec0059);
const $d302a38f292ec82f$export$160cfd792cba790f = (0, $eIDUd.createPropertyHashSelector)($d302a38f292ec82f$var$entityUpdateSelector, (user)=>user.displayName);
const $d302a38f292ec82f$export$275c56c7a00ae6ca = (0, $eIDUd.createPropertyHashSelector)($d302a38f292ec82f$var$entityUpdateSelector, (user)=>user.avatarUrls && user.avatarUrls['16x16']);
const $d302a38f292ec82f$export$642cbbb15f6f21b = (state, accountId)=>(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))($d302a38f292ec82f$export$9c65f1b2beec0059(state), accountId);

});

parcelRegister("9E22T", function(module, exports) {

$parcel$export(module.exports, "getSelectedIssueId", () => $f762976025fb2b74$export$19cf1f433bb54516);
$parcel$export(module.exports, "getIssueTypeForIssueId", () => $f762976025fb2b74$export$6050f95a970355e3);
$parcel$export(module.exports, "getSettingFilterFunction", () => $f762976025fb2b74$export$ceddd1a6c19dead0);
$parcel$export(module.exports, "getFilterFunction", () => $f762976025fb2b74$export$4d2a5b62ef91607b);
$parcel$export(module.exports, "getFilteredIssueIds", () => $f762976025fb2b74$export$7a57a09bf274fce6);
$parcel$export(module.exports, "getFilteredIssueIdsHash", () => $f762976025fb2b74$export$f7ae446899657bda);
$parcel$export(module.exports, "getFilteredIssueCount", () => $f762976025fb2b74$export$589c122e94692c);
$parcel$export(module.exports, "getNonBaseLevelIssueIds", () => $f762976025fb2b74$export$9d3065a4935015a1);
$parcel$export(module.exports, "getFilteredNonBaseLevelIssueIds", () => $f762976025fb2b74$export$6b86533989c11346);
$parcel$export(module.exports, "getFilteredChildIssueIdsHash", () => $f762976025fb2b74$export$8e32946c3d3c8727);
$parcel$export(module.exports, "getFilteredBaseLevelIssueIds", () => $f762976025fb2b74$export$90b3596fc3773f68);
$parcel$export(module.exports, "getFilteredIssueDependenciesHash", () => $f762976025fb2b74$export$3c46a5657d663740);
$parcel$export(module.exports, "getFilteredIssueDependeesHash", () => $f762976025fb2b74$export$9c925993a3e4a4bc);
$parcel$export(module.exports, "getIssueDependencies", () => $f762976025fb2b74$export$fc4a6304669861ca);
$parcel$export(module.exports, "getIssueDependees", () => $f762976025fb2b74$export$cce99423082ae667);
$parcel$export(module.exports, "getProgress", () => $f762976025fb2b74$export$1947d5eba3dbedea);
$parcel$export(module.exports, "getIssueContextMenuSprints", () => $f762976025fb2b74$export$3289885d4f62b5a4);
$parcel$export(module.exports, "getIssueParentColor", () => $f762976025fb2b74$export$82d2b2062ab119f);
$parcel$export(module.exports, "getIssueEdgeReleaseDatesHash", () => $f762976025fb2b74$export$13633a9e6b348fb);

var $df4Sl = parcelRequire("df4Sl");

var $czx3b = parcelRequire("czx3b");

var $jqvCZ = parcelRequire("jqvCZ");

var $jJwwt = parcelRequire("jJwwt");


var $h0Fv2 = parcelRequire("h0Fv2");

var $5iA56 = parcelRequire("5iA56");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $5urmd = parcelRequire("5urmd");

var $3YMoa = parcelRequire("3YMoa");

var $6489W = parcelRequire("6489W");

var $hTAd9 = parcelRequire("hTAd9");

var $lDe9P = parcelRequire("lDe9P");

var $9ZLrP = parcelRequire("9ZLrP");

var $kbyLF = parcelRequire("kbyLF");

var $fTkuC = parcelRequire("fTkuC");

var $hjI8T = parcelRequire("hjI8T");

var $iadEd = parcelRequire("iadEd");
const $f762976025fb2b74$export$19cf1f433bb54516 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueKeyToIdHash), (0, $6489W.getSelectedIssueKey), (hash, key)=>{
    if (key === undefined) return undefined;
    return hash[key];
});
const $f762976025fb2b74$export$6050f95a970355e3 = (state, id)=>(0, $bwVWW.getIssueType)(state, (0, $6FeJk.getIssueTypeIdHash)(state)[id]);
const $f762976025fb2b74$export$fd02f1f08f5001a4 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueStatusCategoryIdHash), (0, $5urmd.getFullStatusCategoriesHash), (0, $iadEd.getIssueStatusCategoryHashPure));
/* Create a filter that can check against one or more values of an issue property at once.
 * E.g. You could filter for multiple assignees or statuses at once.
 */ const $f762976025fb2b74$var$createFilterFromProperties = (filterableProperties, checkProperties)=>{
    const filterablePropertiesSet = new Set(filterableProperties);
    return (issue)=>checkProperties(issue, filterablePropertiesSet);
};
const $f762976025fb2b74$var$statusCategoryChecker = (issue, statusCategories)=>issue.statusCategoryId !== undefined && statusCategories.has(issue.statusCategoryId);
const $f762976025fb2b74$export$ceddd1a6c19dead0 = (0, $df4Sl.createSelector)((0, $bwVWW.getEpicIssueTypeIds), (0, $5urmd.getFullStatusCategoriesHash), (0, $9ZLrP.getLevelOneSetting), (0, $bwVWW.getToday), (0, $5urmd.getDoneStatusCategoryId), (epicIssueTypeIds, statusCategoriesHash, levelOneSetting, today, doneStatusCategoryId)=>{
    const allStatusCategoryId = Object.keys(statusCategoriesHash);
    if (!levelOneSetting.showCompleted) {
        const incompleteStatusCategoryId = allStatusCategoryId.filter((id)=>statusCategoriesHash[id].key !== (0, $5iA56.DONE));
        const filterFunction = $f762976025fb2b74$var$createFilterFromProperties(incompleteStatusCategoryId, $f762976025fb2b74$var$statusCategoryChecker);
        return (issue)=>epicIssueTypeIds.includes(issue.type.id) ? filterFunction(issue) : true;
    }
    const filterFunction = (issue)=>{
        if (doneStatusCategoryId === issue.statusCategoryId && issue.dueDate !== undefined) {
            const { dueDate: dueDate } = issue;
            const { showCompleted: showCompleted, period: period } = levelOneSetting;
            const durationStart = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).subtract(showCompleted ? period : 0, 'months').startOf('day').valueOf();
            return dueDate >= durationStart;
        }
        return true;
    };
    return (issue)=>epicIssueTypeIds.includes(issue.type.id) ? filterFunction(issue) : true;
});
const $f762976025fb2b74$var$makeMatcherHierarchical = (matcher)=>{
    const recursiveMatcher = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((issue)=>matcher(issue) || issue.children.some(recursiveMatcher));
    return (issue)=>recursiveMatcher(issue);
};
const $f762976025fb2b74$var$getFilterFunctionWithIssueIdsFilters = (0, $df4Sl.createSelector)((0, $9ZLrP.getIssuesFilter), (0, $hTAd9.getJQLFilteredIssueIds), (0, $9ZLrP.getFilteredGoalIssueIds), ({ text: text, statuses: statuses, assignees: assignees, issueTypes: issueTypes, issueParents: issueParents, labels: labels, versions: versions, components: components, quickFilters: quickFilters, customFilters: customFilters, goals: goals }, jqlFilteredIssueIds, goalFilteredIssueIds)=>(0, $h0Fv2.createFilterFunction)({
        [(0, $44677eb502cfd308$export$d597759d33be802e)]: text,
        [(0, $44677eb502cfd308$export$f8f7545d2bb78afb)]: assignees,
        [(0, $44677eb502cfd308$export$37aee82a3cb1e8f7)]: labels,
        [(0, $44677eb502cfd308$export$2a4f270075a033de)]: issueParents,
        [(0, $44677eb502cfd308$export$ebb48b08205007c5)]: issueTypes,
        [(0, $44677eb502cfd308$export$a4ad2735b021c132)]: versions,
        [(0, $44677eb502cfd308$export$f863b019d19144f4)]: statuses,
        [(0, $44677eb502cfd308$export$af1e30ebbae9df3b)]: components,
        [(0, $44677eb502cfd308$export$1ea95b94fb0c51d9)]: quickFilters,
        [(0, $44677eb502cfd308$export$68d693c35a8d8866)]: customFilters,
        [(0, $44677eb502cfd308$export$871e58afc769b358)]: goals
    }, {
        filteredIssueIds: new Set((0, $iadEd.combineIssueIdsFilters)(jqlFilteredIssueIds, goalFilteredIssueIds))
    }));
const $f762976025fb2b74$var$getFilterFunctionWithoutJQLFilters = (0, $df4Sl.createSelector)((0, $9ZLrP.getIssuesFilter), ({ text: text, statuses: statuses, assignees: assignees, issueTypes: issueTypes, issueParents: issueParents, labels: labels, versions: versions, components: components })=>(0, $h0Fv2.createFilterFunction)({
        [(0, $44677eb502cfd308$export$d597759d33be802e)]: text,
        [(0, $44677eb502cfd308$export$f8f7545d2bb78afb)]: assignees,
        [(0, $44677eb502cfd308$export$37aee82a3cb1e8f7)]: labels,
        [(0, $44677eb502cfd308$export$2a4f270075a033de)]: issueParents,
        [(0, $44677eb502cfd308$export$ebb48b08205007c5)]: issueTypes,
        [(0, $44677eb502cfd308$export$a4ad2735b021c132)]: versions,
        [(0, $44677eb502cfd308$export$f863b019d19144f4)]: statuses,
        [(0, $44677eb502cfd308$export$af1e30ebbae9df3b)]: components
    }, {}));
const $f762976025fb2b74$export$4d2a5b62ef91607b = (state, skipQuickFilters = false)=>{
    if ((0, $hTAd9.getIsJQLFiltersActive)(state) && !skipQuickFilters || (0, $6489W.isGoalFilterActive)(state)) return $f762976025fb2b74$var$getFilterFunctionWithIssueIdsFilters(state);
    return $f762976025fb2b74$var$getFilterFunctionWithoutJQLFilters(state);
};
const $f762976025fb2b74$var$getIssuePropertyHashes = (0, $df4Sl.createStructuredSelector)({
    issueStatusCategoryIdHash: (0, $6FeJk.getIssueStatusCategoryIdHash),
    issueAssigneeHash: (0, $6FeJk.getIssueAssigneeHash),
    issueTypeIdHash: (0, $6FeJk.getIssueTypeIdHash),
    issueChildrenHash: (0, $6FeJk.getIssueChildrenHash),
    issueCreationTransitionHash: (0, $6FeJk.getIssueCreationTransitionHash),
    issueSummaryHash: (0, $6FeJk.getIssueSummaryHash),
    issueParentIdHash: (0, $6FeJk.getIssueParentIdHash),
    issueLabelsHash: (0, $6FeJk.getIssueLabelsHash),
    issueKeyHash: (0, $6FeJk.getIssueKeyHash),
    issueVersionsHash: (0, $hjI8T.getSanitisedIssueVersionIdsHash),
    issueComponentsHash: (0, $lDe9P.getSanitisedIssueComponentIdsHash),
    issueDueDateHash: (0, $6FeJk.getIssueDueDateHash)
});
const $f762976025fb2b74$export$7a57a09bf274fce6 = (0, $df4Sl.createSelector)($f762976025fb2b74$export$4d2a5b62ef91607b, $f762976025fb2b74$export$ceddd1a6c19dead0, (0, $6FeJk.getIssueIds), $f762976025fb2b74$var$getIssuePropertyHashes, (0, $3YMoa.getUserDisplayNameHash), (0, $fTkuC.getParentRolledUpDatesHash), (filterFunction, viewSettingFilterFunction, issueIds, { issueStatusCategoryIdHash: issueStatusCategoryIdHash, issueAssigneeHash: issueAssigneeHash, issueTypeIdHash: issueTypeIdHash, issueChildrenHash: issueChildrenHash, issueCreationTransitionHash: issueCreationTransitionHash, issueSummaryHash: issueSummaryHash, issueParentIdHash: issueParentIdHash, issueLabelsHash: issueLabelsHash, issueKeyHash: issueKeyHash, issueVersionsHash: issueVersionsHash, issueComponentsHash: issueComponentsHash, issueDueDateHash: issueDueDateHash }, userDisplayNameHash, parentRolledUpDatesHash)=>{
    if (filterFunction === undefined && viewSettingFilterFunction === undefined) return issueIds;
    const createFilterableIssue = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((issueId)=>{
        const children = issueChildrenHash[issueId] || [];
        const parentRolledUpDate = parentRolledUpDatesHash[issueId];
        const rolledUpDueDate = parentRolledUpDate === undefined || parentRolledUpDate.isDueDatePlaceholder ? undefined : parentRolledUpDate.dueDate;
        const dueDate = issueDueDateHash[issueId] !== undefined ? issueDueDateHash[issueId] : rolledUpDueDate;
        const assigneeId = issueAssigneeHash[issueId];
        const assignee = assigneeId !== undefined ? {
            id: assigneeId,
            displayName: userDisplayNameHash[assigneeId]
        } : undefined;
        return {
            id: issueId,
            key: issueKeyHash[issueId],
            summary: issueSummaryHash[issueId],
            labels: issueLabelsHash[issueId],
            parentId: issueParentIdHash[issueId],
            type: {
                id: issueTypeIdHash[issueId]
            },
            versionIds: issueVersionsHash[issueId],
            componentIds: issueComponentsHash[issueId],
            statusCategoryId: issueStatusCategoryIdHash[issueId],
            children: children.map(createFilterableIssue),
            assignee: assignee,
            dueDate: dueDate
        };
    });
    const recursiveFilterFunction = filterFunction !== undefined ? $f762976025fb2b74$var$makeMatcherHierarchical(filterFunction) : undefined;
    return issueIds.filter((issueId)=>{
        const issue = createFilterableIssue(issueId);
        // An issues visibility will be resolved on its "real" properties AFTER creation.
        if (issueCreationTransitionHash[issueId] === true) return true;
        if (recursiveFilterFunction !== undefined && viewSettingFilterFunction !== undefined) return recursiveFilterFunction(issue) && viewSettingFilterFunction(issue);
        if (recursiveFilterFunction !== undefined) return recursiveFilterFunction(issue);
        if (viewSettingFilterFunction !== undefined) return viewSettingFilterFunction(issue);
        return true;
    });
});
const $f762976025fb2b74$export$f7ae446899657bda = (0, $df4Sl.createSelector)($f762976025fb2b74$export$7a57a09bf274fce6, (filteredIssueIds)=>{
    const issueIdsHash = {};
    filteredIssueIds.forEach((issueId)=>{
        issueIdsHash[issueId] = true;
    });
    return issueIdsHash;
});
const $f762976025fb2b74$export$589c122e94692c = (state)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $f762976025fb2b74$export$7a57a09bf274fce6(state).length;
const $f762976025fb2b74$export$fc04e99ac3563a66 = (state, issueId)=>$f762976025fb2b74$export$f7ae446899657bda(state)[issueId] || false;
const $f762976025fb2b74$var$filterNonBaseLevelIssueIds = (issueIds, issueTypeIdHash, epicIssueTypeIds)=>issueIds.filter((issueId)=>epicIssueTypeIds.includes(issueTypeIdHash[issueId]));
const $f762976025fb2b74$export$9d3065a4935015a1 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueIds), (0, $6FeJk.getIssueTypeIdHash), (0, $bwVWW.getEpicIssueTypeIds), $f762976025fb2b74$var$filterNonBaseLevelIssueIds);
const $f762976025fb2b74$export$6b86533989c11346 = (0, $df4Sl.createSelector)($f762976025fb2b74$export$7a57a09bf274fce6, (0, $6FeJk.getIssueTypeIdHash), (0, $bwVWW.getEpicIssueTypeIds), $f762976025fb2b74$var$filterNonBaseLevelIssueIds);
const $f762976025fb2b74$export$8e32946c3d3c8727 = (0, $df4Sl.createSelector)($f762976025fb2b74$export$7a57a09bf274fce6, (0, $6FeJk.getIssueParentIdHash), (issueIds, parentIdHash)=>{
    const issueChildIdHash = {};
    issueIds.forEach((issueId)=>{
        const parentId = parentIdHash[issueId];
        // Can only be a child if it has a parent...
        if (parentId) {
            if (!issueChildIdHash[parentId]) issueChildIdHash[parentId] = [
                issueId
            ];
            else issueChildIdHash[parentId].push(issueId);
        }
    });
    return issueChildIdHash;
});
const $f762976025fb2b74$export$90b3596fc3773f68 = (0, $df4Sl.createSelector)($f762976025fb2b74$export$9d3065a4935015a1, $f762976025fb2b74$export$8e32946c3d3c8727, (issueParentIds, issueChildIdHash)=>{
    const filteredBaseLevelIssueIds = [];
    issueParentIds.forEach((id)=>{
        const ids = issueChildIdHash[id] || [];
        ids.length && filteredBaseLevelIssueIds.push(...ids);
    });
    return filteredBaseLevelIssueIds;
});
const $f762976025fb2b74$export$3c46a5657d663740 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueDependenciesHash), (0, $6FeJk.getIssueTypeIdHash), (0, $bwVWW.getEpicIssueTypeIds), (0, $bwVWW.getFullIssueTypeHash), (issueDependenciesHash, issueTypeIdHash, epicIssueTypeIds, issueTypeHash)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(issueDependenciesHash, (dependencies)=>dependencies.filter((issueId)=>issueTypeHash[issueTypeIdHash[issueId]])));
const $f762976025fb2b74$export$9c925993a3e4a4bc = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueDependeesHash), (0, $6FeJk.getIssueTypeIdHash), (0, $bwVWW.getEpicIssueTypeIds), (0, $bwVWW.getFullIssueTypeHash), (issueDependeesHash, issueTypeIdHash, epicIssueTypeIds, issueTypeHash)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(issueDependeesHash, (dependencies)=>dependencies.filter((issueId)=>issueTypeHash[issueTypeIdHash[issueId]])));
const $f762976025fb2b74$export$fc4a6304669861ca = (state, issueId)=>$f762976025fb2b74$export$3c46a5657d663740(state)[issueId];
const $f762976025fb2b74$export$cce99423082ae667 = (state, issueId)=>$f762976025fb2b74$export$9c925993a3e4a4bc(state)[issueId];
const $f762976025fb2b74$export$139880bd42541622 = (0, $df4Sl.createSelector)($f762976025fb2b74$export$9d3065a4935015a1, (0, $6FeJk.getIssueChildrenHash), $f762976025fb2b74$export$fd02f1f08f5001a4, (0, $5urmd.getStatusCategoriesKeyHash), (0, $iadEd.getProgressHashPure));
const $f762976025fb2b74$export$1947d5eba3dbedea = (state, issueId)=>$f762976025fb2b74$export$139880bd42541622(state)[issueId];
const $f762976025fb2b74$export$5ee2d25d02c7177 = (0, $df4Sl.createSelector)((0, $bwVWW.getActiveAndFutureSprints), (0, $kbyLF.getSanitisedIssueSprintsHash), (activeOrFutureSprints, issueSprintsHash)=>{
    const result = {};
    Object.keys(issueSprintsHash).forEach((issueId)=>{
        const sprintIds = issueSprintsHash[issueId].map((sprint)=>sprint.id);
        result[issueId] = activeOrFutureSprints.filter((sprint)=>!sprintIds.includes(sprint.id));
    });
    return result;
});
const $f762976025fb2b74$export$3289885d4f62b5a4 = (state, issueId)=>$f762976025fb2b74$export$5ee2d25d02c7177(state)[issueId];
// Returns the parent's color for base level issues
const $f762976025fb2b74$var$getIssueParentColorHash = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueIds), (0, $6FeJk.getIssueParentIdHash), (0, $6FeJk.getIssueColorHash), (ids, parentIdHash, issueColorHash)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueParentColorHash = {};
    ids.forEach((id)=>{
        const parentId = parentIdHash[id];
        const color = parentId !== undefined ? issueColorHash[parentId] : issueColorHash[id];
        issueParentColorHash[`${id}`] = color;
    });
    return issueParentColorHash;
});
const $f762976025fb2b74$export$82d2b2062ab119f = (state, issueId)=>$f762976025fb2b74$var$getIssueParentColorHash(state)[issueId];
const $f762976025fb2b74$export$13633a9e6b348fb = (0, $df4Sl.createSelector)((0, $bwVWW.getFullVersionHash), (0, $hjI8T.getSanitisedIssueVersionIdsHash), (0, $iadEd.getIssueEdgeReleaseDatesPure));

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});

parcelRegister("h0Fv2", function(module, exports) {

$parcel$export(module.exports, "createDefaultMatcherCreators", () => $d1d21cafc14323e5$export$551eb27bf5bd708);
$parcel$export(module.exports, "createFilterFunction", () => $d1d21cafc14323e5$export$5b4da3e2bd753e6);


var $ftKFx = parcelRequire("ftKFx");

var $7TAX0 = parcelRequire("7TAX0");

var $9sYsd = parcelRequire("9sYsd");

var $iwYAV = parcelRequire("iwYAV");

var $kaz6O = parcelRequire("kaz6O");

var $cPwAI = parcelRequire("cPwAI");

var $1js3v = parcelRequire("1js3v");

var $ft9WA = parcelRequire("ft9WA");

var $21p3u = parcelRequire("21p3u");

var $bKIUF = parcelRequire("bKIUF");

var $iJnBh = parcelRequire("iJnBh");

var $60yor = parcelRequire("60yor");

var $jHhlI = parcelRequire("jHhlI");

var $4gVwH = parcelRequire("4gVwH");
const $d1d21cafc14323e5$export$551eb27bf5bd708 = ()=>({
        [(0, $44677eb502cfd308$export$d597759d33be802e)]: (0, $jHhlI.textMatcherCreator),
        [(0, $44677eb502cfd308$export$f8f7545d2bb78afb)]: (0, $ftKFx.assigneeMatcherCreator),
        [(0, $44677eb502cfd308$export$37aee82a3cb1e8f7)]: (0, $ft9WA.labelMatcherCreator),
        [(0, $44677eb502cfd308$export$2a4f270075a033de)]: (0, $kaz6O.issueParentMatcherCreator),
        [(0, $44677eb502cfd308$export$401f4b6eda6a369c)]: (0, $cPwAI.issueProjectMatcherCreator),
        [(0, $44677eb502cfd308$export$ebb48b08205007c5)]: (0, $1js3v.issueTypeMatcherCreator),
        [(0, $44677eb502cfd308$export$a4ad2735b021c132)]: (0, $4gVwH.versionMatcherCreator),
        [(0, $44677eb502cfd308$export$68d693c35a8d8866)]: (0, $iwYAV.filteredIssueIdsMatcherCreator),
        [(0, $44677eb502cfd308$export$af1e30ebbae9df3b)]: (0, $7TAX0.componentMatcherCreator),
        [(0, $44677eb502cfd308$export$92ab80c1dc9baf44)]: (0, $21p3u.requestTypeMatcherCreator),
        [(0, $44677eb502cfd308$export$f863b019d19144f4)]: (0, $iJnBh.statusCategoryMatcherCreator),
        [(0, $44677eb502cfd308$export$e50006273435e7d4)]: (0, $60yor.statusMatcherCreator),
        [(0, $44677eb502cfd308$export$1ea95b94fb0c51d9)]: (0, $iwYAV.filteredIssueIdsMatcherCreator),
        [(0, $44677eb502cfd308$export$a316570a0dbfd2b0)]: (0, $bKIUF.sprintMatcherCreator),
        [(0, $44677eb502cfd308$export$871e58afc769b358)]: (0, $iwYAV.filteredIssueIdsMatcherCreator),
        [(0, $44677eb502cfd308$export$db362e2d293fe52e)]: (0, $9sYsd.dependenciesMatcherCreator)
    });
const $d1d21cafc14323e5$var$createMatchers = (filter, context, matcherCreators)=>Object.keys(filter).reduce((acc, key)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Filters'.
        const filterValue = filter[key];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'MatcherCreators<Issue>'.
        const matcherCreator = matcherCreators[key];
        if (filterValue === undefined || filterValue.length <= 0 || matcherCreator === undefined) return acc;
        acc.push(matcherCreator(filterValue, context));
        return acc;
    }, []);
const $d1d21cafc14323e5$export$5b4da3e2bd753e6 = (filter, context, matcherCreators, overrideMatchers)=>{
    const matchers = $d1d21cafc14323e5$var$createMatchers(filter, context, matcherCreators ?? $d1d21cafc14323e5$export$551eb27bf5bd708());
    return (issue)=>matchers.every((matcher)=>matcher(issue)) || overrideMatchers !== undefined && overrideMatchers.some((matcher)=>matcher(issue));
};

});
parcelRegister("ftKFx", function(module, exports) {

$parcel$export(module.exports, "assigneeMatcherCreator", () => $354afd9c9dee1cb7$export$5c453ff7d8a6957f);

var $6vrw7 = parcelRequire("6vrw7");

const $354afd9c9dee1cb7$export$5c453ff7d8a6957f = (assigneeFilter)=>{
    const assigneeSet = new Set(assigneeFilter);
    return ({ assignee: assignee })=>assignee !== undefined && assigneeSet.has(assignee.id) || assignee === undefined && assigneeSet.has((0, $6vrw7.toAccountId)((0, $44677eb502cfd308$export$12e572fd459c10dc)));
};

});

parcelRegister("7TAX0", function(module, exports) {

$parcel$export(module.exports, "componentMatcherCreator", () => $13808b3decc68df4$export$667cab6ac6c65512);

const $13808b3decc68df4$export$667cab6ac6c65512 = (componentFilter)=>{
    const componentSet = new Set(componentFilter);
    return ({ componentIds: componentIds })=>componentIds !== undefined && (componentIds.some((componentId)=>componentSet.has(componentId)) || componentIds.length === 0 && componentSet.has((0, $44677eb502cfd308$export$4b7c755e61199a36)));
};

});

parcelRegister("9sYsd", function(module, exports) {

$parcel$export(module.exports, "dependenciesMatcherCreator", () => $30a935975edc077c$export$18a8a0a9891403f1);

var $eI5EY = parcelRequire("eI5EY");

var $fY3YW = parcelRequire("fY3YW");
const $30a935975edc077c$export$18a8a0a9891403f1 = (dependenciesFilter)=>{
    if (dependenciesFilter && dependenciesFilter.includes((0, $fY3YW.DependencyFilterOption).OFF_TRACK) && (0, $eI5EY.fg)('dependency_visualisation_program_board_fe_and_be')) return (issue)=>!!issue.isDependencyOfftrack;
    return ()=>true;
};

});
parcelRegister("fY3YW", function(module, exports) {

$parcel$export(module.exports, "DependencyFilterOption", () => $182288e5c0b91665$export$499848eca2db01cf);
const $182288e5c0b91665$export$499848eca2db01cf = {
    OFF_TRACK: 'off-track'
};

});


parcelRegister("iwYAV", function(module, exports) {

$parcel$export(module.exports, "filteredIssueIdsMatcherCreator", () => $003ab2d78b2340e2$export$4493d922cd011b1a);
const $003ab2d78b2340e2$export$4493d922cd011b1a = (value, { filteredIssueIds: filteredIssueIds })=>({ id: id })=>filteredIssueIds !== undefined ? id !== undefined && filteredIssueIds.has(id) : true;

});

parcelRegister("kaz6O", function(module, exports) {

$parcel$export(module.exports, "issueParentMatcherCreator", () => $0b2241078d1b56df$export$4729465fe91e6864);

const $0b2241078d1b56df$export$4729465fe91e6864 = (issueParentFilter, { issues: issues })=>{
    const issueParentSet = new Set(issueParentFilter);
    const isAncestorInFilter = (id, checked = [])=>{
        if (id === undefined) return issueParentSet.has((0, $f2d11b1049867935$export$794f07be04aca3fe));
        if (issueParentSet.has(id)) return true;
        if (checked.includes(id)) return false;
        if (issues === undefined) return false;
        const issue = issues.hash[id];
        if (issue === undefined) return false;
        const { parentId: parentId } = issue;
        return isAncestorInFilter(parentId, checked.concat(id));
    };
    return ({ id: id, parentId: parentId })=>{
        if (id === undefined) return false;
        if (issueParentSet.has(id)) return true;
        if (id === parentId) return false;
        return isAncestorInFilter(parentId, [
            id
        ]);
    };
};

});
const $f2d11b1049867935$export$794f07be04aca3fe = '0';
const $f2d11b1049867935$export$cb17e3c17bc50301 = 'Epic';
const $f2d11b1049867935$export$7fbc739f2667a35e = 'Subtask';


parcelRegister("cPwAI", function(module, exports) {

$parcel$export(module.exports, "issueProjectMatcherCreator", () => $a372eb626e60d8ee$export$b10ee43342090204);

var $cV7Ha = parcelRequire("cV7Ha");
const $a372eb626e60d8ee$export$b10ee43342090204 = (projectFilter)=>{
    if (!(0, $cV7Ha.isIncrementPlanningBoardM1Enabled)()) return ()=>true;
    const projectSet = new Set(projectFilter);
    return ({ projectId: projectId })=>!!projectId && projectSet.has(projectId);
};

});
parcelRegister("cV7Ha", function(module, exports) {

$parcel$export(module.exports, "isIncrementPlanningBoardM1Enabled", () => $b9d7535b282cdc7b$export$3cf7abcb30f8ee4d);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $b9d7535b282cdc7b$export$40a610084ff0408 = 'com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1';
const $b9d7535b282cdc7b$export$3cf7abcb30f8ee4d = ()=>(0, $1ybV0.ff)($b9d7535b282cdc7b$export$40a610084ff0408); // </qfeyaerts>

});


parcelRegister("1js3v", function(module, exports) {

$parcel$export(module.exports, "issueTypeMatcherCreator", () => $584952870c30b05f$export$48b17418005f8b9b);
const $584952870c30b05f$export$48b17418005f8b9b = (issueTypeFilter)=>{
    const issueTypeSet = new Set(issueTypeFilter);
    return ({ type: type })=>issueTypeSet.has(type.id);
};

});

parcelRegister("ft9WA", function(module, exports) {

$parcel$export(module.exports, "labelMatcherCreator", () => $ab6a1cc6240f5e5d$export$71d90ee236f2e796);

const $ab6a1cc6240f5e5d$export$71d90ee236f2e796 = (labelFilter)=>{
    const labelSet = new Set(labelFilter);
    return ({ labels: labels })=>labels !== undefined && (labels.some((label)=>labelSet.has(label)) || labels.length === 0 && labelSet.has((0, $44677eb502cfd308$export$81ef49afbbead0a1)));
};

});

parcelRegister("21p3u", function(module, exports) {

$parcel$export(module.exports, "requestTypeMatcherCreator", () => $fd9886982e8311a4$export$d04e41d82fbfb8ba);
const $fd9886982e8311a4$export$d04e41d82fbfb8ba = (requestTypeFilter)=>{
    const requestTypeSet = new Set(requestTypeFilter);
    return ({ requestTypeId: requestTypeId })=>!!requestTypeId && requestTypeSet.has(requestTypeId);
};

});

parcelRegister("bKIUF", function(module, exports) {

$parcel$export(module.exports, "sprintMatcherCreator", () => $cd675abcb29605aa$export$4706275ba29d0c7);
const $cd675abcb29605aa$export$4706275ba29d0c7 = (sprintFilter)=>({ sprintId: sprintId })=>sprintFilter.includes(sprintId || '');

});

parcelRegister("iJnBh", function(module, exports) {

$parcel$export(module.exports, "statusCategoryMatcherCreator", () => $4a8647655f62da05$export$bb986e45707c6c33);
const $4a8647655f62da05$export$bb986e45707c6c33 = (statusCategoryFilter)=>{
    const statusCategorySet = new Set(statusCategoryFilter);
    return ({ statusCategoryId: statusCategoryId })=>statusCategoryId !== undefined && statusCategorySet.has(statusCategoryId);
};

});

parcelRegister("60yor", function(module, exports) {

$parcel$export(module.exports, "statusMatcherCreator", () => $d1771c65d5da4b4d$export$c61724a440d8ea1d);
const $d1771c65d5da4b4d$export$c61724a440d8ea1d = (statusFilter)=>{
    const statusSet = new Set(statusFilter);
    return ({ statusId: statusId })=>!!statusId && statusSet.has(statusId);
};

});

parcelRegister("jHhlI", function(module, exports) {

$parcel$export(module.exports, "textMatcherCreator", () => $1398123769c733e8$export$71a22d4a5d2891fc);

var $e1vfz = parcelRequire("e1vfz");

var $jqvCZ = parcelRequire("jqvCZ");
const $1398123769c733e8$export$f3f2882e8b11d731 = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $1398123769c733e8$var$doesSummaryContainText = (summary, lowercaseText)=>summary.toLowerCase().includes(lowercaseText) || $1398123769c733e8$export$f3f2882e8b11d731(summary).toLowerCase().includes(lowercaseText);
const $1398123769c733e8$var$doesIssueKeyMatchLoosely = (key, lowercaseText)=>key !== undefined && key?.toLowerCase().includes(lowercaseText);
const $1398123769c733e8$var$createDisplayNameChecker = (text)=>{
    // It transforms a text to a regular expression.
    // eg: text='mi ze', the transformed regexp would be 'mi.*\s+ze'
    // which searches for 'mi' followed by anything then 'ze'.
    const pattern = text.split(/\s+/).map((0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))).join('.*\\s+');
    const regExp = new RegExp(pattern, 'i');
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((displayName)=>regExp.test(displayName));
};
const $1398123769c733e8$export$71a22d4a5d2891fc = (textFilter)=>{
    const lowercaseText = textFilter.toLowerCase();
    const doesDisplayNameMatchRegExp = $1398123769c733e8$var$createDisplayNameChecker(textFilter);
    return ({ summary: summary, key: key, assignee: assignee })=>summary && $1398123769c733e8$var$doesSummaryContainText(summary, lowercaseText) || $1398123769c733e8$var$doesIssueKeyMatchLoosely(key, lowercaseText) || assignee !== undefined && doesDisplayNameMatchRegExp(assignee.displayName);
};

});
parcelRegister("e1vfz", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a359664a3c663e8b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $a359664a3c663e8b$var$reHasRegExpChar = RegExp($a359664a3c663e8b$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $a359664a3c663e8b$var$escapeRegExp(string) {
    string = $1uqnh(string);
    return string && $a359664a3c663e8b$var$reHasRegExpChar.test(string) ? string.replace($a359664a3c663e8b$var$reRegExpChar, '\\$&') : string;
}
module.exports = $a359664a3c663e8b$var$escapeRegExp;

});


parcelRegister("4gVwH", function(module, exports) {

$parcel$export(module.exports, "versionMatcherCreator", () => $85c08470c7208112$export$fb114a888e0e17b4);

const $85c08470c7208112$export$fb114a888e0e17b4 = (versionFilter)=>{
    const versionSet = new Set(versionFilter);
    return ({ versionIds: versionIds })=>versionIds !== undefined && (versionIds.some((versionId)=>versionSet.has(versionId)) || versionIds.length === 0 && versionSet.has((0, $44677eb502cfd308$export$ac95b4b2317d4b33)));
};

});


parcelRegister("fTkuC", function(module, exports) {

$parcel$export(module.exports, "getParentRolledUpDatesHash", () => $cb15f661078edb88$export$19344f1f730b9c22);
$parcel$export(module.exports, "getExplicitBoundaryDatesHash", () => $cb15f661078edb88$export$4f77368293516479);

var $df4Sl = parcelRequire("df4Sl");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $kbyLF = parcelRequire("kbyLF");

var $aJBDu = parcelRequire("aJBDu");
const $cb15f661078edb88$export$19344f1f730b9c22 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueChildrenHash), (0, $kbyLF.createGetIssueSprintDates), (0, $6FeJk.getIssueStartDateHash), (0, $6FeJk.getIssueDueDateHash), (0, $bwVWW.getIsSprintsPlanningEnabled), (0, $bwVWW.getIsChildIssuePlanningEnabled), (0, $aJBDu.getParentRolledUpDatesHash));
const $cb15f661078edb88$export$4f77368293516479 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueChildrenHash), (0, $6FeJk.getIssueStartDateHash), (0, $6FeJk.getIssueDueDateHash), (0, $kbyLF.createGetIssueSprintDates), (0, $bwVWW.getIsSprintsPlanningEnabled), (0, $aJBDu.getBoundaryDatesHash));

});
parcelRegister("aJBDu", function(module, exports) {

$parcel$export(module.exports, "getBoundaryDatesHash", () => $3c077887e9e6a935$export$18b28b3bf7ea66b1);
$parcel$export(module.exports, "getParentRolledUpDatesHash", () => $3c077887e9e6a935$export$19344f1f730b9c22);

var $cD8SO = parcelRequire("cD8SO");

var $aksMB = parcelRequire("aksMB");

var $jJwwt = parcelRequire("jJwwt");

var $1gs0D = parcelRequire("1gs0D");
const $3c077887e9e6a935$var$getChildInferredSprintDates = (childIssueId, getIssueSprintDates)=>{
    const { inferredStartDate: startDate, inferredEndDate: dueDate } = getIssueSprintDates(childIssueId);
    return {
        startDate: startDate,
        dueDate: dueDate
    };
};
const $3c077887e9e6a935$export$982f0c3b285f400e = ({ startDate: startDate, dueDate: dueDate })=>{
    if (startDate !== undefined && dueDate !== undefined) return {
        startDate: Math.min(startDate, dueDate),
        dueDate: Math.max(startDate, dueDate),
        isStartDatePlaceholder: false,
        isDueDatePlaceholder: false,
        areDatesFlipped: startDate > dueDate
    };
    if (startDate !== undefined) {
        // No due date - default to showing the due date one month after the start date
        const placeholderDueDate = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(startDate).add((0, $1gs0D.CHILD_PLACEHOLDER_DAYS), 'days').startOf('day').valueOf();
        return {
            startDate: startDate,
            dueDate: placeholderDueDate,
            isStartDatePlaceholder: false,
            isDueDatePlaceholder: true,
            areDatesFlipped: false
        };
    }
    if (dueDate !== undefined) {
        // No start date - default to showing the start date once month before the due date
        const placeholderStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(dueDate).subtract((0, $1gs0D.CHILD_PLACEHOLDER_DAYS), 'days').startOf('day').valueOf();
        return {
            startDate: placeholderStartDate,
            dueDate: dueDate,
            isStartDatePlaceholder: true,
            isDueDatePlaceholder: false,
            areDatesFlipped: false
        };
    }
    // No dates - default to showing a bar that has no dates
    return {
        startDate: undefined,
        dueDate: undefined,
        isStartDatePlaceholder: false,
        isDueDatePlaceholder: false,
        areDatesFlipped: false
    };
};
const $3c077887e9e6a935$var$getChildExplicitDates = (childIssueId, issueStartDateHash, issueDueDateHash)=>{
    const startDate = issueStartDateHash[childIssueId];
    const dueDate = issueDueDateHash[childIssueId];
    return {
        startDate: startDate,
        dueDate: dueDate
    };
};
const $3c077887e9e6a935$export$a54cf1eacbf962ce = (childIssueIds, getIssueSprintDates, issueStartDateHash, issueDueDateHash, isSprintsPlanning)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueDatesHash = {};
    childIssueIds.forEach((childIssueId)=>{
        const { startDate: startDate, dueDate: dueDate, isStartDatePlaceholder: isStartDatePlaceholder, isDueDatePlaceholder: isDueDatePlaceholder, areDatesFlipped: areDatesFlipped } = $3c077887e9e6a935$export$982f0c3b285f400e(isSprintsPlanning ? $3c077887e9e6a935$var$getChildInferredSprintDates(childIssueId, getIssueSprintDates) : $3c077887e9e6a935$var$getChildExplicitDates(childIssueId, issueStartDateHash, issueDueDateHash));
        // either both dates are defined, or both are undefined
        if (startDate !== undefined && dueDate !== undefined) issueDatesHash[`${childIssueId}`] = {
            startDate: startDate,
            dueDate: dueDate,
            isStartDateInferred: isSprintsPlanning,
            isStartDatePlaceholder: isStartDatePlaceholder,
            isDueDateInferred: isSprintsPlanning,
            isDueDatePlaceholder: isDueDatePlaceholder,
            areDatesFlipped: areDatesFlipped
        };
    });
    return issueDatesHash;
};
const $3c077887e9e6a935$var$startDateComparator = (first, second)=>first < second;
const $3c077887e9e6a935$var$dueDateComparator = (first, second)=>first > second;
const $3c077887e9e6a935$var$getRolledUpDate = (previousDate, date, isPreviousDatePlaceholder, isDatePlaceholder, shouldUseCurrentDateComparator)=>{
    if (previousDate === undefined) return {
        date: date,
        isDatePlaceholder: isDatePlaceholder
    };
    return {
        date: shouldUseCurrentDateComparator(date, previousDate) ? date : previousDate,
        isDatePlaceholder: isDatePlaceholder || isPreviousDatePlaceholder
    };
};
const $3c077887e9e6a935$var$getRolledUpChildDates = (childIssueIds, childIssueDatesHash)=>childIssueIds.reduce((rolledUpDatesAcc, childIssueId)=>{
        // will be undefined if child issue does not have any dates
        const dates = childIssueDatesHash[childIssueId];
        if (dates !== undefined) {
            const { date: startDate, isDatePlaceholder: isStartDatePlaceholder } = $3c077887e9e6a935$var$getRolledUpDate(rolledUpDatesAcc.startDate, dates.startDate, rolledUpDatesAcc.isStartDatePlaceholder, dates.isStartDatePlaceholder, $3c077887e9e6a935$var$startDateComparator);
            const { date: latestStartDate } = $3c077887e9e6a935$var$getRolledUpDate(rolledUpDatesAcc.latestStartDate, dates.startDate, rolledUpDatesAcc.isStartDatePlaceholder, dates.isStartDatePlaceholder, $3c077887e9e6a935$var$dueDateComparator);
            const { date: earliestDueDate } = $3c077887e9e6a935$var$getRolledUpDate(rolledUpDatesAcc.earliestDueDate, dates.dueDate, rolledUpDatesAcc.isDueDatePlaceholder, dates.isDueDatePlaceholder, $3c077887e9e6a935$var$startDateComparator);
            const { date: dueDate, isDatePlaceholder: isDueDatePlaceholder } = $3c077887e9e6a935$var$getRolledUpDate(rolledUpDatesAcc.dueDate, dates.dueDate, rolledUpDatesAcc.isDueDatePlaceholder, dates.isDueDatePlaceholder, $3c077887e9e6a935$var$dueDateComparator);
            return {
                startDate: startDate,
                dueDate: dueDate,
                isStartDatePlaceholder: isStartDatePlaceholder,
                isDueDatePlaceholder: isDueDatePlaceholder,
                latestStartDate: latestStartDate,
                earliestDueDate: earliestDueDate
            };
        }
        return rolledUpDatesAcc;
    }, // initialize placeholder to true in case there are no explicit dates to override the value
    {
        startDate: undefined,
        dueDate: undefined,
        latestStartDate: undefined,
        earliestDueDate: undefined,
        isStartDatePlaceholder: true,
        isDueDatePlaceholder: true
    });
const $3c077887e9e6a935$var$getParentRolledUpDatesHashOld = (childrenHash, getIssueSprintDates)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(childrenHash).reduce((acc, parentIssueId)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const childIssueIds = childrenHash[parentIssueId];
        const rolledUpDates = childIssueIds.reduce((rolledupAcc, childIssueId)=>{
            const { inferredStartDate: childInferredStartDate, inferredEndDate: childInferredDueDate } = getIssueSprintDates(childIssueId);
            return {
                startDate: (0, (/*@__PURE__*/$parcel$interopDefault($aksMB)))([
                    rolledupAcc.startDate,
                    childInferredStartDate
                ]),
                dueDate: (0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))([
                    rolledupAcc.dueDate,
                    childInferredDueDate
                ]),
                latestStartDate: undefined,
                earliestDueDate: undefined,
                isStartDatePlaceholder: false,
                isDueDatePlaceholder: false
            };
        }, {
            startDate: undefined,
            dueDate: undefined,
            earliestDueDate: undefined,
            latestStartDate: undefined,
            isStartDatePlaceholder: true,
            isDueDatePlaceholder: true
        });
        acc[parentIssueId] = rolledUpDates;
        return acc;
    }, {});
const $3c077887e9e6a935$export$18b28b3bf7ea66b1 = (childrenHash, issueStartDateHash, issueDueDateHash, getIssueSprintDates, isSprintsPlanning)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(childrenHash).forEach((parentIssueId)=>{
        const parentStartDate = issueStartDateHash[parentIssueId];
        const parentDueDate = issueDueDateHash[parentIssueId];
        let earliestStart = parentStartDate;
        let earliestEnd = parentDueDate;
        let latestStart = parentStartDate;
        let latestEnd = parentDueDate;
        childrenHash[parentIssueId].forEach((childIssueId)=>{
            const { inferredEndDate: inferredEndDate, inferredStartDate: inferredStartDate } = getIssueSprintDates(childIssueId);
            const startDate = isSprintsPlanning ? inferredStartDate : issueStartDateHash[childIssueId];
            const endDate = isSprintsPlanning ? inferredEndDate : issueDueDateHash[childIssueId];
            if (parentStartDate !== undefined) {
                earliestStart = (0, (/*@__PURE__*/$parcel$interopDefault($aksMB)))([
                    earliestStart,
                    startDate
                ]);
                latestStart = (0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))([
                    latestStart,
                    startDate
                ]);
            }
            if (parentDueDate !== undefined) {
                earliestEnd = (0, (/*@__PURE__*/$parcel$interopDefault($aksMB)))([
                    earliestEnd,
                    endDate
                ]);
                latestEnd = (0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))([
                    latestEnd,
                    endDate
                ]);
            }
        });
        result[parentIssueId] = {
            startDateBoundary: (0, (/*@__PURE__*/$parcel$interopDefault($aksMB)))([
                earliestStart,
                earliestEnd
            ]),
            dueDateBoundary: (0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))([
                latestStart,
                latestEnd
            ])
        };
    });
    return result;
};
const $3c077887e9e6a935$export$19344f1f730b9c22 = (childrenHash, getIssueSprintDates, issueStartDateHash, issueDueDateHash, isSprintsPlanning, isChildIssuePlanningEnabled)=>{
    if (!isChildIssuePlanningEnabled) return $3c077887e9e6a935$var$getParentRolledUpDatesHashOld(childrenHash, getIssueSprintDates);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(childrenHash).reduce((acc, parentIssueId)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const childIssueIds = childrenHash[parentIssueId];
        const childIssueDatesHash = $3c077887e9e6a935$export$a54cf1eacbf962ce(childIssueIds, getIssueSprintDates, issueStartDateHash, issueDueDateHash, isSprintsPlanning);
        const dueDate = issueDueDateHash[parentIssueId];
        const startDate = issueStartDateHash[parentIssueId];
        const { dueDate: rolledUpDueDate, isDueDatePlaceholder: isRolledUpDueDatePlaceholder, isStartDatePlaceholder: isRolledUpStartDatePlaceholder, startDate: rolledUpStartDate, latestStartDate: latestStartDate, earliestDueDate: earliestDueDate } = $3c077887e9e6a935$var$getRolledUpChildDates(childIssueIds, childIssueDatesHash);
        acc[parentIssueId] = {
            dueDate: rolledUpDueDate,
            isDueDatePlaceholder: dueDate === undefined && isRolledUpDueDatePlaceholder,
            isStartDatePlaceholder: startDate === undefined && isRolledUpStartDatePlaceholder,
            startDate: rolledUpStartDate,
            latestStartDate: latestStartDate,
            earliestDueDate: earliestDueDate
        };
        return acc;
    }, {});
};

});
parcelRegister("cD8SO", function(module, exports) {

var $77fbL = parcelRequire("77fbL");

var $bOiiU = parcelRequire("bOiiU");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $932004927d7c326a$var$max(array) {
    return array && array.length ? $77fbL(array, $3QMTK, $bOiiU) : undefined;
}
module.exports = $932004927d7c326a$var$max;

});
parcelRegister("77fbL", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $52e4f805c3622ecd$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8aco7(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $52e4f805c3622ecd$var$baseExtremum;

});

parcelRegister("bOiiU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $899290031a4184bf$var$baseGt(value, other) {
    return value > other;
}
module.exports = $899290031a4184bf$var$baseGt;

});


parcelRegister("aksMB", function(module, exports) {

var $77fbL = parcelRequire("77fbL");

var $iDjne = parcelRequire("iDjne");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $7852195066d5c66c$var$min(array) {
    return array && array.length ? $77fbL(array, $3QMTK, $iDjne) : undefined;
}
module.exports = $7852195066d5c66c$var$min;

});
parcelRegister("iDjne", function(module, exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $d90ae5b52ef23625$var$baseLt(value, other) {
    return value < other;
}
module.exports = $d90ae5b52ef23625$var$baseLt;

});




parcelRegister("iadEd", function(module, exports) {

$parcel$export(module.exports, "getProgressHashPure", () => $779138268c17416b$export$4679bf3e5c8b2fc8);
$parcel$export(module.exports, "getIssueStatusCategoryHashPure", () => $779138268c17416b$export$5de6d959ce8dde18);
$parcel$export(module.exports, "getIssueEdgeReleaseDatesPure", () => $779138268c17416b$export$f730c9142ca7307);
$parcel$export(module.exports, "combineIssueIdsFilters", () => $779138268c17416b$export$78fa515948420196);

var $kG4jb = parcelRequire("kG4jb");

var $czx3b = parcelRequire("czx3b");


var $5iA56 = parcelRequire("5iA56");
const $779138268c17416b$export$4679bf3e5c8b2fc8 = (parentIssueIds, childrenHash, issueStatusCategoryHash, statusCategoryKeyHash)=>{
    const progressHash = {};
    const createProgressFromCounts = (progressCounts)=>[
            {
                id: (0, $5iA56.DONE),
                name: statusCategoryKeyHash[0, $5iA56.DONE].name,
                count: progressCounts[0, $5iA56.DONE],
                color: `var(--ds-border-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
            },
            {
                id: (0, $5iA56.IN_PROGRESS),
                name: statusCategoryKeyHash[0, $5iA56.IN_PROGRESS].name,
                count: progressCounts[0, $5iA56.IN_PROGRESS],
                color: `var(--ds-border-information, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
            },
            {
                id: (0, $5iA56.TODO),
                name: statusCategoryKeyHash[0, $5iA56.TODO].name,
                count: progressCounts[0, $5iA56.TODO],
                color: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`
            }
        ];
    // For each issue, build up a count of what child is in what status category
    parentIssueIds.forEach((issueId)=>{
        const childIssues = childrenHash[issueId];
        if (childIssues && childIssues.length > 0) {
            const progressCounts = {
                [(0, $5iA56.TODO)]: 0,
                [(0, $5iA56.IN_PROGRESS)]: 0,
                [(0, $5iA56.DONE)]: 0
            };
            childIssues.forEach((childIssueId)=>{
                const statusCategory = issueStatusCategoryHash[childIssueId];
                const statusCategoryKey = statusCategory?.key;
                if (statusCategoryKey && statusCategoryKey !== (0, $5iA56.NO_CATEGORY)) progressCounts[statusCategoryKey] += 1;
            });
            progressHash[issueId] = createProgressFromCounts(progressCounts);
        }
    });
    return progressHash;
};
const $779138268c17416b$export$5de6d959ce8dde18 = (issueStatusCategoryIdHash, fullStatusCategoryHash)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(issueStatusCategoryIdHash, (statusCategoryId)=>statusCategoryId ? fullStatusCategoryHash[statusCategoryId] : undefined);
const $779138268c17416b$export$f730c9142ca7307 = (fullVersionHash, sanitisedIssueVersionIdsHash)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(sanitisedIssueVersionIdsHash, (versionIds)=>{
        let minVersionReleaseDate;
        let maxVersionReleaseDate;
        if (versionIds.length > 0) versionIds.forEach((versionId)=>{
            const versionReleaseDate = fullVersionHash[versionId]?.releaseDate;
            if (versionReleaseDate === undefined) return;
            if (minVersionReleaseDate === undefined || versionReleaseDate < minVersionReleaseDate) minVersionReleaseDate = versionReleaseDate;
            if (maxVersionReleaseDate === undefined || versionReleaseDate > maxVersionReleaseDate) maxVersionReleaseDate = versionReleaseDate;
        });
        return [
            minVersionReleaseDate,
            maxVersionReleaseDate
        ];
    });
const $779138268c17416b$export$78fa515948420196 = (...issueSets)=>(0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(...issueSets.filter((array)=>array.length > 0));

});



parcelRegister("g5l0l", function(module, exports) {

$parcel$export(module.exports, "getSafeRankRequest", () => $c84a97d8dd5289cc$export$4c2551ba746466f5);
$parcel$export(module.exports, "getSafeRankBeforeRequest", () => $c84a97d8dd5289cc$export$f66f8a46cc172ecd);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("flmol");

var $6FeJk = parcelRequire("6FeJk");
const $c84a97d8dd5289cc$export$4c2551ba746466f5 = (state, request)=>{
    if ('rankAfterId' in request) return (0, $6FeJk.getSafeId)(state, request.rankAfterId).map((safeIssueId)=>({
            rankAfterId: safeIssueId
        }));
    return (0, $6FeJk.getSafeId)(state, request.rankBeforeId).map((safeIssueId)=>({
            rankBeforeId: safeIssueId
        }));
};
const $c84a97d8dd5289cc$export$f66f8a46cc172ecd = (state, beforeId)=>{
    if (beforeId !== undefined) return (0, $6FeJk.getSafeId)(state, beforeId).map((safeIssueId)=>safeIssueId !== undefined ? {
            beforeId: safeIssueId
        } : null);
    return (0, $3JafE.Observable).of(null);
};

});

parcelRegister("66ncF", function(module, exports) {

$parcel$export(module.exports, "performPostCreateSideEffects", () => $0c5aa83587e2e3bd$export$d5c3aa31cb8a425e);

var $iVIEg = parcelRequire("iVIEg");

var $3bukT = parcelRequire("3bukT");

var $65uQX = parcelRequire("65uQX");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $jMP2a = parcelRequire("jMP2a");

var $cDvag = parcelRequire("cDvag");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $dUMAZ = parcelRequire("dUMAZ");

var $hTAd9 = parcelRequire("hTAd9");

var $4tOj7 = parcelRequire("4tOj7");
const $0c5aa83587e2e3bd$var$DERIVED_FIELD_WHITELIST = [
    'pid',
    'issuetype',
    'summary',
    'reporter'
];
const $0c5aa83587e2e3bd$export$d5c3aa31cb8a425e = (state, temporaryId, { id: id, issueTypeId: issueTypeId, parentId: parentId }, analyticsEvent)=>{
    // Notify listeners waiting on the issue to have been created on the backend
    const resolveSafeId = (0, $6FeJk.getSafeIdResolve)(state, temporaryId);
    resolveSafeId(id);
    // Update the issue view of the parent to reflect any new child issues.
    if (parentId) {
        const issueKey = (0, $6FeJk.getIssueKeyById)(state, parentId);
        (0, $4tOj7.default)(state, issueKey);
    }
    const issueTypeName = (0, $dUMAZ.getIssueTypeName)(state, issueTypeId);
    const safeIssueTypeName = issueTypeName !== undefined && (0, $3bukT.standardIssueTypes)[issueTypeName] ? issueTypeName : (0, $3bukT.CUSTOM);
    const clonedAnalyticsEvent = analyticsEvent.clone();
    if ((0, $cDvag.isEcClientEventListenerEnabled)()) (0, $65uQX.default).saveIssueMutationToCache(new (0, $48mPv.default)(id, (0, $d7Wfe.MutationSource).CREATE), {
        analyticsMetadata: {
            scenario: 'roadmap'
        },
        analyticsEventObj: clonedAnalyticsEvent || {}
    });
    if (clonedAnalyticsEvent) {
        const jqlFiltersActive = (0, $hTAd9.getIsJQLFiltersActive)(state);
        const derivedFields = (0, $bwVWW.getFullDerivedFields)(state);
        (0, $jMP2a.fireTrackAnalytics)(clonedAnalyticsEvent, 'issue created', `${id}`, {
            issueTypeId: issueTypeId,
            issueType: safeIssueTypeName,
            projectType: 'software',
            isJQLFiltersApplied: jqlFiltersActive,
            isDerivedFieldsApplied: (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(Object.keys(derivedFields), $0c5aa83587e2e3bd$var$DERIVED_FIELD_WHITELIST).length > 0
        });
    }
};

});
parcelRegister("3bukT", function(module, exports) {

$parcel$export(module.exports, "CUSTOM", () => $cc2fecf6996f211b$export$952581bc40160893);
$parcel$export(module.exports, "standardIssueTypes", () => $cc2fecf6996f211b$export$c5b8a33017b6146a);
$parcel$export(module.exports, "translatedTaskNames", () => $cc2fecf6996f211b$export$ae53d86e513cd6);
const $cc2fecf6996f211b$var$EPIC = 'Epic';
const $cc2fecf6996f211b$var$STORY = 'Story';
const $cc2fecf6996f211b$var$BUG = 'Bug';
const $cc2fecf6996f211b$var$TASK = 'Task';
const $cc2fecf6996f211b$export$952581bc40160893 = 'Custom';
const $cc2fecf6996f211b$export$c5b8a33017b6146a = {
    [$cc2fecf6996f211b$var$EPIC]: true,
    [$cc2fecf6996f211b$var$STORY]: true,
    [$cc2fecf6996f211b$var$BUG]: true,
    [$cc2fecf6996f211b$var$TASK]: true
};
const $cc2fecf6996f211b$export$ae53d86e513cd6 = [
    'Task',
    'Aufgabe',
    'Tarea',
    "T\xe2che",
    "\u30BF\u30B9\u30AF",
    "\uC791\uC5C5",
    'Tarefa',
    "\u0417\u0430\u0434\u0430\u0447\u0430",
    "\xdakol",
    "\xdclesanne",
    "Teht\xe4v\xe4",
    'Feladat',
    'Verk',
    'Taak',
    'Opgave',
    'Oppgave',
    'Zadanie',
    'Activitate',
    "\u0417\u0430\u0434\u0430\u0447\u0430",
    "\xdaloha",
    'Uppgift',
    "G\xf6rev",
    "Nhi\u1EC7m v\u1EE5",
    "\u4EFB\u52A1",
    "\u4EFB\u52D9",
    "Attivit\xe0"
];

});

parcelRegister("65uQX", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $9d182d4720e39d79$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $9d182d4720e39d79$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $9d182d4720e39d79$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $fqqil = parcelRequire("fqqil");

var $7S3WE = parcelRequire("7S3WE");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
class $9d182d4720e39d79$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $7S3WE.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $7S3WE.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $jMP2a.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutation);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutations);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $d7Wfe.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $fqqil.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $2OdyW.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $4qvSX.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $9d182d4720e39d79$var$ecClient = new $9d182d4720e39d79$export$a736992aaac2307a();
function $9d182d4720e39d79$export$c9342bd32f51406b(tenantContext = {}) {
    $9d182d4720e39d79$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $9d182d4720e39d79$var$ecClient;
}
var $9d182d4720e39d79$export$2e2bcd8739ae039 = $9d182d4720e39d79$var$ecClient;

});
parcelRegister("7S3WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed861ad8bfcfb81a$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $kBiqn = parcelRequire("kBiqn");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
const $ed861ad8bfcfb81a$var$MAX_AGE_MIN = 5;
const $ed861ad8bfcfb81a$var$MAX_AGE = $ed861ad8bfcfb81a$var$MAX_AGE_MIN * 60000;
const $ed861ad8bfcfb81a$var$CACHE_SIZE = 100;
const $ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX = '__storejs';
const $ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $ed861ad8bfcfb81a$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $ed861ad8bfcfb81a$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $ed861ad8bfcfb81a$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX}_${this.namespace}_${$ed861ad8bfcfb81a$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $48mPv.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $48mPv.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
            (0, $2OdyW.default)($ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $48mPv.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $48mPv.default)(issueId, (0, $d7Wfe.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $48mPv.default)) {
                    if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $48mPv.default)(key, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");

var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';


parcelRegister("48mPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce578c493ad96d9e$export$2e2bcd8739ae039);
class $ce578c493ad96d9e$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("d7Wfe", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $598bd411eca1df87$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $598bd411eca1df87$export$ba193b555633db78);
const $598bd411eca1df87$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $598bd411eca1df87$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("4qvSX", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $1b463beed4d472c8$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $1b463beed4d472c8$export$71923bad28063cb1);
$parcel$export(module.exports, "createAnalyticsMetadata", () => $1b463beed4d472c8$export$eeaad9fa1f02ef4a);

var $6rW04 = parcelRequire("6rW04");
function $1b463beed4d472c8$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $1b463beed4d472c8$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $1b463beed4d472c8$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $6rW04.default)('ajs-shard') || '',
        userId: (0, $6rW04.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $6rW04.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});



parcelRegister("dUMAZ", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeName", () => $5a2ae912e16aead9$export$7fbe5338a34739de);

var $bwVWW = parcelRequire("bwVWW");
const $5a2ae912e16aead9$export$7fbe5338a34739de = (state, issueTypeId)=>(0, $bwVWW.getIssueType)(state, issueTypeId).name;

});

parcelRegister("4tOj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc88d4d1bdd3793$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $5oStv = parcelRequire("5oStv");

var $6489W = parcelRequire("6489W");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcc88d4d1bdd3793$export$2e2bcd8739ae039 = (state, issueKey)=>{
    if (issueKey !== undefined && (0, $6489W.getSelectedIssueKey)(state) === issueKey) // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $5oStv.default).refreshIssuePage(issueKey);
};

});
parcelRegister("5oStv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdea36b35279d86d$export$2e2bcd8739ae039);

var $7eDnP = parcelRequire("7eDnP");
const $bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addEventListener = (event, callback)=>{
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeEventListener = (event, callback)=>{
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $bdea36b35279d86d$var$refreshIssuePageThrowable = (issueKey, reason = (0, $7eDnP.Reason).OnDemand)=>{
    try {
        document.dispatchEvent(new CustomEvent($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $bdea36b35279d86d$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $bdea36b35279d86d$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdea36b35279d86d$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $bdea36b35279d86d$var$addRefreshIssueListener,
    removeRefreshIssueListener: $bdea36b35279d86d$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $bdea36b35279d86d$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $bdea36b35279d86d$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $bdea36b35279d86d$var$refreshIssuePageThrowable,
    refreshIssuePage: $bdea36b35279d86d$var$refreshIssuePage
};

});
parcelRegister("7eDnP", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $501d104507444a18$export$fe867595c4640fb1);
const $501d104507444a18$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});




parcelRegister("7yIcx", function(module, exports) {

$parcel$export(module.exports, "getFieldsForCreateDialogGIC", () => $769cdf366ccc05cb$export$4542e58ddb5b2ec3);
$parcel$export(module.exports, "getGICReasonOnCreateError", () => $769cdf366ccc05cb$export$b1aafd89216b8b8f);

var $8blac = parcelRequire("8blac");

var $grmb7 = parcelRequire("grmb7");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");
const $769cdf366ccc05cb$var$asStringArray = (array)=>array;
const $769cdf366ccc05cb$export$eb18ffe6388f217a = (issue, projectId, parentIssueKey, epicLinkCustomFieldId, epicNameCustomFieldId)=>{
    const outputPayload = {};
    const { summary: summary, issueTypeId: issueTypeId, assignee: assignee, labels: labels, versionIds: versionIds, componentIds: componentIds, parentId: parentId } = issue;
    outputPayload.project = {
        projectId: projectId
    };
    outputPayload.issueType = {
        issueTypeId: issueTypeId
    };
    if (parentId?.value !== undefined) outputPayload.parentId = {
        parentId: parentId.value
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const otherFields = {
        summary: summary.value
    };
    if (parentIssueKey !== undefined && epicLinkCustomFieldId !== undefined) otherFields.epic = {
        fieldId: epicLinkCustomFieldId,
        fieldValue: `key:${parentIssueKey}`
    };
    if (parentIssueKey === undefined && epicNameCustomFieldId !== undefined) otherFields.epicName = {
        fieldId: epicNameCustomFieldId,
        fieldValue: summary.value
    };
    if (assignee !== undefined) otherFields.assignee = assignee;
    if (labels !== undefined) otherFields.labels = labels;
    if (versionIds !== undefined) otherFields.fixVersions = $769cdf366ccc05cb$var$asStringArray(versionIds);
    if (componentIds !== undefined) otherFields.components = $769cdf366ccc05cb$var$asStringArray(componentIds);
    if (Object.keys(otherFields).length > 0) {
        const { defaultValues: defaultValues, fieldIds: fieldIds } = (0, $grmb7.generateDefaultValues)(parentId?.value !== undefined ? {
            parent: parentId.value,
            ...otherFields
        } : otherFields);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(defaultValues)) outputPayload.defaultValues = defaultValues;
        outputPayload.customFieldsToPreserveOnFormRecreation = fieldIds;
    }
    return outputPayload;
};
const $769cdf366ccc05cb$export$4542e58ddb5b2ec3 = (state, issue, reason)=>{
    const { parentId: parentId } = issue;
    const projectId = (0, $bwVWW.getProjectId)(state);
    const parentKey = parentId.value ? (0, $6FeJk.getIssueKeyById)(state, parentId.value) : undefined;
    const epicLinkCustomFieldId = (0, $bwVWW.getEpicLinkCustomFieldId)(state);
    const epicNameCustomFieldId = (0, $bwVWW.getEpicNameCustomFieldId)(state);
    return {
        payload: $769cdf366ccc05cb$export$eb18ffe6388f217a(issue, projectId, parentKey, epicLinkCustomFieldId, epicNameCustomFieldId),
        submitErrorMessage: reason
    };
};
const $769cdf366ccc05cb$export$b1aafd89216b8b8f = (errors)=>{
    const createError = errors && errors.find((e)=>e && e.extensions && e.extensions.statusCode === 400);
    if (createError) return createError.message;
    return undefined;
};

});
parcelRegister("grmb7", function(module, exports) {

$parcel$export(module.exports, "generateDefaultValues", () => $ac2928cb7824ba77$export$300f392f5922240);
$parcel$export(module.exports, "extractEventAttributes", () => $ac2928cb7824ba77$export$1e69307ca1d0a0a);
$parcel$export(module.exports, "filterCustomFields", () => $ac2928cb7824ba77$export$3d0318b836ef9005);
$parcel$export(module.exports, "mergeDefaultValues", () => $ac2928cb7824ba77$export$2b461e4b4c8d36cf);
$parcel$export(module.exports, "transformGICPayload", () => $ac2928cb7824ba77$export$db3a4d24608ba186);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8blac = parcelRequire("8blac");

var $k4nIh = parcelRequire("k4nIh");

var $cOaQi = parcelRequire("cOaQi");

var $jOgEf = parcelRequire("jOgEf");
const $ac2928cb7824ba77$var$CUSTOM_FIELD_PREFIX = 'customfield';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $ac2928cb7824ba77$var$mergePrefilled = (oldPayload, newPayload)=>{
    if (newPayload !== null && newPayload !== undefined) // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
    return {
        ...oldPayload,
        ...newPayload
    };
    return oldPayload;
};
const $ac2928cb7824ba77$var$returnActualValue = (value)=>{
    if (Array.isArray(value)) return value[0].toString();
    return value.toString();
};
// @ts-expect-error - TS7023 - 'mergeFormat' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'format' implicitly has an 'any' type.
const $ac2928cb7824ba77$var$mergeFormat = (format, finalKey, finalValue)=>{
    // Ideally format can be object or string
    // Format will only contain 1 object having single key/value where value can be null or an object
    // go inside and wherever we find first null, replace the same with the value.
    // some of the mutation use fieldId whereas other uses like priorityId
    // so whichever key has value === ID will replace the same with the proper mutationKey
    if (typeof format === 'string') {
        if (format === 'ID') return finalKey;
        return format;
    }
    // recursively goes inside to find the null and key param and replace with the corresponding values
    // Also checks for array like labels
    return Object.keys(format).reduce((accumulator, currentKey)=>{
        const currentValue = format[currentKey];
        if (Array.isArray(currentValue)) {
            const mappedValue = Array.isArray(finalValue) ? finalValue : [
                finalValue
            ];
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...accumulator,
                [currentKey]: mappedValue.map((val)=>$ac2928cb7824ba77$var$mergeFormat(currentValue[0], finalKey, val))
            };
        }
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accumulator,
            [currentKey]: currentValue === null ? $ac2928cb7824ba77$var$returnActualValue(finalValue) : $ac2928cb7824ba77$var$mergeFormat(format[currentKey], finalKey, finalValue)
        };
    }, {});
};
const $ac2928cb7824ba77$var$generateDefaultValuesForEcosystemAPI = (otherFields)=>{
    const defaultValues = {};
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $jOgEf.ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $jOgEf.ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const formattedValue = (0, $jOgEf.ECOSYSTEM_API_FIELD_FORMATTER)[mutationGroup](mutationKey, mutationValue);
            if (formattedValue) {
                const { value: value, type: type } = formattedValue;
                fieldIds.push(mutationKey);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(value)) {
                    if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(value);
                    else if (type === 'object') defaultValues[mutationGroup] = value;
                }
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $ac2928cb7824ba77$var$generateDefaultValuesLegacy = (otherFields)=>{
    const defaultValues = {};
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $cOaQi.FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $cOaQi.FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly singleLineTextFields: { readonly value: { readonly fieldId: "ID"; readonly text: null; }; readonly type: "array"; }; readonly epicLinkField: { readonly value: { readonly fieldId: "ID"; readonly epicLink: { readonly issueKey: null; }; }; readonly type: "object"; }; ... 7 more ...; readonly components: { .....'.
            const { type: type = null, value: depth = null } = (0, $cOaQi.FORMATTER)[mutationGroup];
            let pattern = null;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(mutationValue) && depth && type) {
                if (!Array.isArray(mutationValue) && typeof mutationValue === 'object') {
                    const { fieldId: fieldId, fieldValue: fieldValue } = mutationValue;
                    // If fieldValue is different from the key like custom fields
                    pattern = $ac2928cb7824ba77$var$mergeFormat(depth, fieldId || mutationKey, fieldValue);
                    fieldIds.push(fieldId || mutationKey);
                } else {
                    // same as key like summary etc.
                    pattern = $ac2928cb7824ba77$var$mergeFormat(depth, mutationKey, mutationValue);
                    fieldIds.push(mutationKey);
                }
            }
            // merge mutations based on type as some mutations are object whereas others are arrays
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(pattern)) {
                if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(pattern);
                else if (type === 'object') defaultValues[mutationGroup] = pattern;
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $ac2928cb7824ba77$export$300f392f5922240 = (otherFields, isEcosystemAPI = false)=>{
    if (isEcosystemAPI) return $ac2928cb7824ba77$var$generateDefaultValuesForEcosystemAPI(otherFields);
    return $ac2928cb7824ba77$var$generateDefaultValuesLegacy(otherFields);
};
const $ac2928cb7824ba77$export$1e69307ca1d0a0a = (trigger)=>{
    const anchor = trigger.nodeName === 'A' ? trigger : trigger.querySelector('a');
    if (anchor) {
        const href = anchor.getAttribute('href');
        // @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'qs' implicitly has an 'any' type.
        const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(href, (qs)=>new URLSearchParams(qs));
        const returnData = {
            prefilledFields: {}
        };
        // If data attributes exist, we will prefer those over the query params.
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const pid = anchor.getAttribute('data-pid') || query.get('pid');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const issuetype = anchor.getAttribute('data-issue-type') || query.get('issuetype');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const requestype = anchor.getAttribute('data-itsm-category') || query.get('itsmCategory');
        if (pid) // @ts-expect-error - TS2339 - Property 'pid' does not exist on type '{}'.
        returnData.prefilledFields.pid = pid;
        if (issuetype) // @ts-expect-error - TS2339 - Property 'issuetype' does not exist on type '{}'.
        returnData.prefilledFields.issuetype = issuetype;
        if (requestype) // @ts-expect-error - TS2339 - Property 'requestype' does not exist on type '{}'.
        returnData.prefilledFields.requestype = requestype;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(returnData.prefilledFields)) // @ts-expect-error - TS2322 - Type '{ prefilledFields: {}; }' is not assignable to type 'OldGICPayload'.
        return returnData;
        return {};
    }
    return {};
};
const $ac2928cb7824ba77$export$70cb7a42e309786 = (payload = {}, isEcosystemAPI = false)=>{
    const { prefilledFields: gicPreFilledFields, target: target = null } = payload;
    let prefilledFields = gicPreFilledFields;
    if (target) {
        const newPayload = $ac2928cb7824ba77$export$1e69307ca1d0a0a(target);
        prefilledFields = $ac2928cb7824ba77$var$mergePrefilled(gicPreFilledFields, newPayload.prefilledFields);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(prefilledFields)) {
        const { fieldsToRetain: fieldsToRetain = [], pid: pid, issuetype: issuetype, requestype: requestype, additionalContext: additionalContext, statusId: statusId, ...otherFields } = prefilledFields;
        const outputPayload = {};
        if ((!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(pid) || typeof pid === 'number') && pid !== 'undefined') outputPayload.project = {
            projectId: $ac2928cb7824ba77$var$returnActualValue(pid)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issuetype) || typeof issuetype === 'number') outputPayload.issueType = {
            issueTypeId: $ac2928cb7824ba77$var$returnActualValue(issuetype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(requestype)) outputPayload.requestType = {
            key: $ac2928cb7824ba77$var$returnActualValue(requestype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(otherFields.parentId)) outputPayload.parentId = {
            parentId: $ac2928cb7824ba77$var$returnActualValue(otherFields.parentId)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(statusId)) outputPayload.status = {
            statusId: statusId
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(additionalContext)) outputPayload.additionalContext = additionalContext;
        // for other fields
        if (Object.keys(otherFields).length > 0) {
            const { parentId: parentId, ...otherFieldsWithoutParent } = otherFields;
            const { defaultValues: defaultValues, fieldIds: fieldIds } = $ac2928cb7824ba77$export$300f392f5922240(parentId !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(parentId) ? {
                parent: parentId,
                ...otherFieldsWithoutParent
            } : otherFieldsWithoutParent, isEcosystemAPI);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(defaultValues)) outputPayload.defaultValues = defaultValues;
            outputPayload.customFieldsToPreserveOnFormRecreation = [
                ...fieldsToRetain,
                ...fieldIds
            ];
        }
        return outputPayload;
    }
    return null;
};
const $ac2928cb7824ba77$export$3d0318b836ef9005 = (payload = {})=>{
    // customField's id's start with the name customfield https://confluence.atlassian.com/adminjiraserver/advanced-use-of-the-jira-issue-collector-938847349.html
    const fieldsToPrefill = payload?.prefilledFields;
    if (!fieldsToPrefill) return {};
    const prefilledCustomFields = {};
    const systemFieldsToBeIncluded = [
        'worklog_timeLogged',
        'worklog_startDate',
        'worklog_comment',
        'timetracking_remainingestimate',
        'description',
        'paragraph',
        'environment'
    ];
    Object.keys(fieldsToPrefill).forEach((key)=>{
        if (key.startsWith($ac2928cb7824ba77$var$CUSTOM_FIELD_PREFIX) || systemFieldsToBeIncluded.includes(key)) prefilledCustomFields[key] = fieldsToPrefill[key];
    });
    return prefilledCustomFields;
};
const $ac2928cb7824ba77$export$2b461e4b4c8d36cf = (defaultValuesFromAPI = {}, defaultValuesFromFE = {})=>{
    const mergedDefaultValues = JSON.parse(JSON.stringify(defaultValuesFromAPI));
    if (!defaultValuesFromFE) return mergedDefaultValues;
    Object.keys(defaultValuesFromFE).forEach((key)=>{
        if (mergedDefaultValues?.key) mergedDefaultValues[key] = {
            ...mergedDefaultValues[key],
            ...defaultValuesFromFE[key]
        };
        else mergedDefaultValues[key] = defaultValuesFromFE[key];
    });
    return mergedDefaultValues;
};
const $ac2928cb7824ba77$export$db3a4d24608ba186 = $ac2928cb7824ba77$export$70cb7a42e309786;

});
parcelRegister("cOaQi", function(module, exports) {

$parcel$export(module.exports, "FORMATTER", () => $5043ffa756a0131b$export$92cfe806f4f0ae2f);
$parcel$export(module.exports, "FIELD_MAPPER_MUTATION_GROUP", () => $5043ffa756a0131b$export$6669905e89f27d17);
const $5043ffa756a0131b$export$92cfe806f4f0ae2f = {
    singleLineTextFields: {
        value: {
            fieldId: 'ID',
            text: null
        },
        type: 'array'
    },
    epicLinkField: {
        value: {
            fieldId: 'ID',
            epicLink: {
                issueKey: null
            }
        },
        type: 'object'
    },
    sprintsField: {
        value: {
            fieldId: 'ID',
            sprints: [
                {
                    sprintId: null
                }
            ]
        },
        type: 'object'
    },
    priority: {
        value: {
            priorityId: 'ID'
        },
        type: 'object'
    },
    datePickerFields: {
        value: {
            fieldId: 'ID',
            date: {
                formattedDate: null
            }
        },
        type: 'array'
    },
    dateTimePickerFields: {
        value: {
            fieldId: 'ID',
            dateTime: {
                formattedDateTime: null
            }
        },
        type: 'array'
    },
    labelsFields: {
        value: {
            fieldId: 'ID',
            labels: [
                {
                    name: null
                }
            ]
        },
        type: 'array'
    },
    singleSelectUserPickerFields: {
        value: {
            fieldId: 'ID',
            user: {
                accountId: null
            }
        },
        type: 'array'
    },
    multipleVersionPickerFields: {
        value: {
            fieldId: 'ID',
            versions: [
                {
                    versionId: null
                }
            ]
        },
        type: 'array'
    },
    components: {
        value: {
            componentId: null
        },
        type: 'array'
    },
    parentField: {
        value: {
            issueId: null
        },
        type: 'object'
    }
};
const $5043ffa756a0131b$export$6669905e89f27d17 = {
    summary: 'singleLineTextFields',
    epic: 'epicLinkField',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    plannedStartDate: 'dateTimePickerFields',
    plannedEndDate: 'dateTimePickerFields',
    labels: 'labelsFields',
    sprint: 'sprintsField',
    assignee: 'singleSelectUserPickerFields',
    reporter: 'singleSelectUserPickerFields',
    fixVersions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField'
};

});

parcelRegister("jOgEf", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_API_FIELD_FORMATTER", () => $ee6ccb07902c2ba9$export$8ef3266ee07318b4);
$parcel$export(module.exports, "ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP", () => $ee6ccb07902c2ba9$export$343b44fa14f045e3);

var $htiJk = parcelRequire("htiJk");
const $ee6ccb07902c2ba9$export$8ef3266ee07318b4 = {
    security: (id, input)=>{
        if ((0, $htiJk.checkIfValidId)(input)) return {
            value: {
                securityLevelId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $htiJk.checkIfValidId)(input[0])) return {
            value: {
                securityLevelId: Number(input[0])
            },
            type: 'object'
        };
    },
    singleLineTextFields: (id, input)=>{
        if (typeof input === 'string' || typeof input === 'number') return {
            value: {
                fieldId: id,
                text: input.toString()
            },
            type: 'array'
        };
        if (Array.isArray(input) && input.length > 0) return {
            value: {
                fieldId: id,
                text: input[0].toString()
            },
            type: 'array'
        };
    },
    timeTrackingField: (id, input)=>{
        if (typeof input === 'string') return {
            value: {
                originalEstimate: input
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') return {
            value: {
                originalEstimate: input[0]
            },
            type: 'object'
        };
    },
    priority: (id, input)=>{
        if ((0, $htiJk.checkIfValidId)(input)) return {
            value: {
                priorityId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $htiJk.checkIfValidId)(input[0])) return {
            value: {
                priorityId: Number(input[0])
            },
            type: 'object'
        };
    },
    resolution: (id, input)=>{
        if ((0, $htiJk.checkIfValidId)(input)) return {
            value: {
                resolutionId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $htiJk.checkIfValidId)(input[0])) return {
            value: {
                resolutionId: Number(input[0])
            },
            type: 'object'
        };
        return {
            value: {
                resolutionId: 10000
            },
            type: 'object'
        };
    },
    datePickerFields: (id, input)=>{
        if (typeof input === 'string') {
            const dateInISO = (0, $htiJk.findADate)(input);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    date: {
                        formattedDate: dateInISO
                    }
                },
                type: 'array'
            };
        }
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
            const dateInISO = (0, $htiJk.findADate)(input[0]);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    date: {
                        formattedDate: dateInISO
                    }
                },
                type: 'array'
            };
        }
    },
    dateTimePickerFields: (id, input)=>{
        if (typeof input === 'string') {
            const dateInISO = (0, $htiJk.findADate)(input);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    dateTime: {
                        formattedDateTime: dateInISO
                    }
                },
                type: 'array'
            };
        }
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
            const dateInISO = (0, $htiJk.findADate)(input[0]);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    dateTime: {
                        formattedDateTime: dateInISO
                    }
                },
                type: 'array'
            };
        }
    },
    labelsFields: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const label of input)if (typeof label === 'string' || typeof label === 'number') transformedValue.push({
                name: label.toString()
            });
        } else if (typeof input === 'string' || typeof input === 'number') transformedValue = [
            {
                name: input.toString()
            }
        ];
        return {
            value: {
                fieldId: id,
                labels: transformedValue
            },
            type: 'array'
        };
    },
    multipleVersionPickerFields: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const version of input)if ((0, $htiJk.checkIfValidId)(version)) transformedValue.push({
                versionId: Number(version)
            });
        } else if ((0, $htiJk.checkIfValidId)(input)) transformedValue = [
            {
                versionId: Number(input)
            }
        ];
        return {
            value: {
                fieldId: id,
                versions: transformedValue
            },
            type: 'array'
        };
    },
    components: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const component of input)if ((0, $htiJk.checkIfValidId)(component)) transformedValue.push({
                componentId: Number(component)
            });
        } else if ((0, $htiJk.checkIfValidId)(input)) transformedValue = [
            {
                componentId: Number(input)
            }
        ];
        return {
            value: transformedValue,
            type: 'object'
        };
    },
    parentField: (id, input)=>{
        if ((0, $htiJk.checkIfValidId)(input)) return {
            value: {
                issueId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $htiJk.checkIfValidId)(input[0])) return {
            value: {
                issueId: Number(input[0])
            },
            type: 'object'
        };
    }
};
const $ee6ccb07902c2ba9$export$343b44fa14f045e3 = {
    security: 'security',
    resolution: 'resolution',
    summary: 'singleLineTextFields',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    labels: 'labelsFields',
    fixVersions: 'multipleVersionPickerFields',
    versions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField',
    priority: 'priority',
    timetracking_originalestimate: 'timeTrackingField'
};

});
parcelRegister("htiJk", function(module, exports) {

$parcel$export(module.exports, "findADate", () => $f016e5f6429ab5e0$export$3ce9cccf56f196eb);
$parcel$export(module.exports, "checkIfValidId", () => $f016e5f6429ab5e0$export$d65005e77da517bc);
const $f016e5f6429ab5e0$var$monthMap = {
    Jan: '01',
    January: '01',
    Feb: '02',
    February: '02',
    Mar: '03',
    March: '03',
    Apr: '04',
    April: '04',
    May: '05',
    Jun: '06',
    June: '06',
    Jul: '07',
    July: '07',
    Aug: '08',
    August: '08',
    Sep: '09',
    September: '09',
    Oct: '10',
    October: '10',
    Nov: '11',
    November: '11',
    Dec: '12',
    December: '12'
};
const $f016e5f6429ab5e0$var$formatDay = (day)=>{
    if (day.length === 1) return `0${day}`;
    return day;
};
const $f016e5f6429ab5e0$var$formatMonth = (month)=>{
    if ($f016e5f6429ab5e0$var$monthMap[month]) return $f016e5f6429ab5e0$var$monthMap[month];
    if (month.length === 1) return `0${month}`;
    return month;
};
const $f016e5f6429ab5e0$var$formatYear = (year)=>{
    const yearAsNumber = Number(year);
    if (yearAsNumber < 100) return yearAsNumber + 2000;
    return yearAsNumber;
};
const $f016e5f6429ab5e0$var$constructISOTime = (time)=>{
    const timeStr = time.trim();
    const time24HourPattern = /^T(\d{1,2}):(\d{2}):?(\d{2})?$/;
    const time12HourPattern = /^@?\s*(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
    const match24Hour = timeStr.match(time24HourPattern);
    if (match24Hour) {
        // eslint-disable-next-line prefer-const
        let [, hours, minutes, seconds] = match24Hour;
        seconds = seconds || '00';
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }
    const match12Hour = timeStr.match(time12HourPattern);
    if (match12Hour) {
        let hours;
        let minutes;
        let ampm;
        [, hours, minutes, ampm] = match12Hour;
        hours = parseInt(hours, 10);
        minutes = parseInt(minutes, 10);
        if (ampm) {
            ampm = ampm.toLowerCase();
            if (ampm === 'pm' && hours !== 12) hours += 12;
            else if (ampm === 'am' && hours === 12) hours = 0;
        }
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    }
    return '00:00:00';
};
const $f016e5f6429ab5e0$var$constructISODateTime = (date)=>{
    const regexForDay = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})(.*)/;
    const regexForDateWithYYYYFirst = /^(\d{2,4})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{1,2})(.*)/;
    const matchForDay = date.match(regexForDay);
    const matchForDayWithYYYYFirst = date.match(regexForDateWithYYYYFirst);
    if (matchForDay) {
        const [, day, month, year, time] = matchForDay;
        let formattedDay = $f016e5f6429ab5e0$var$formatDay(day);
        let formattedMonth = $f016e5f6429ab5e0$var$formatMonth(month);
        const formattedYear = $f016e5f6429ab5e0$var$formatYear(year);
        let skipMatchingDay = false;
        if (Number(day) < 13 && Number(month)) [formattedDay, formattedMonth] = [
            formattedMonth,
            formattedDay
        ];
        else if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else skipMatchingDay = true;
        }
        if (!skipMatchingDay) {
            const isoTime = $f016e5f6429ab5e0$var$constructISOTime(time);
            return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
        }
    }
    if (matchForDayWithYYYYFirst) {
        const [, year, month, day, time] = matchForDayWithYYYYFirst;
        let formattedDay = $f016e5f6429ab5e0$var$formatDay(day);
        let formattedMonth = $f016e5f6429ab5e0$var$formatMonth(month);
        const formattedYear = $f016e5f6429ab5e0$var$formatYear(year);
        if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else return null;
        }
        const isoTime = $f016e5f6429ab5e0$var$constructISOTime(time);
        return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
    }
    return null;
};
function $f016e5f6429ab5e0$var$convertUnixToISO(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    if (!date.getTime()) return null;
    return date.toISOString().slice(0, 19);
}
const $f016e5f6429ab5e0$export$3ce9cccf56f196eb = (defaultValue)=>{
    if (typeof defaultValue === 'number') return $f016e5f6429ab5e0$var$convertUnixToISO(defaultValue);
    if (typeof defaultValue === 'string') {
        if (Number(defaultValue)) return $f016e5f6429ab5e0$var$convertUnixToISO(Number(defaultValue));
        return $f016e5f6429ab5e0$var$constructISODateTime(defaultValue);
    }
    return null;
};
const $f016e5f6429ab5e0$export$d65005e77da517bc = (input)=>{
    if ((typeof input === 'string' || typeof input === 'number') && Number(input)) return true;
    return false;
};

});





parcelRegister("2g8iV", function(module, exports) {

$parcel$export(module.exports, "derivedFieldsToIssueContext", () => $7ce57b6b5a23caa2$export$783926c2768c855b);
$parcel$export(module.exports, "mergeIssueContexts", () => $7ce57b6b5a23caa2$export$212c66f230e8034);

var $2vzCR = parcelRequire("2vzCR");

var $opsFH = parcelRequire("opsFH");
const $7ce57b6b5a23caa2$var$LABELS_FIELD_ID = 'labels';
const $7ce57b6b5a23caa2$var$DUE_DATE_FIELD_ID = 'duedate';
const $7ce57b6b5a23caa2$var$VERSION_FIELD_ID = 'fixVersions';
const $7ce57b6b5a23caa2$var$COMPONENT_FIELD_ID = 'components';
const $7ce57b6b5a23caa2$export$783926c2768c855b = (derivedFieldsHash, sprintCustomFieldId)=>{
    const resultIssueContext = {};
    Object.keys(derivedFieldsHash).forEach((fieldName)=>{
        switch(fieldName){
            case $7ce57b6b5a23caa2$var$LABELS_FIELD_ID:
                resultIssueContext.labels = derivedFieldsHash[fieldName];
                break;
            case $7ce57b6b5a23caa2$var$DUE_DATE_FIELD_ID:
                resultIssueContext.dueDate = {
                    value: Number(derivedFieldsHash[fieldName][0]) || undefined
                };
                break;
            case $7ce57b6b5a23caa2$var$VERSION_FIELD_ID:
                break;
            case $7ce57b6b5a23caa2$var$COMPONENT_FIELD_ID:
                break;
            case sprintCustomFieldId:
                resultIssueContext.sprintIds = {
                    value: derivedFieldsHash[fieldName]
                };
                break;
            default:
                break;
        }
    });
    return resultIssueContext;
};
const $7ce57b6b5a23caa2$export$212c66f230e8034 = (...contexts)=>{
    const defaultContext = {
        inCreation: true,
        key: undefined,
        summary: {
            value: ''
        },
        startDate: {
            value: undefined
        },
        dueDate: {
            value: undefined
        },
        status: undefined,
        color: {
            value: (0, $opsFH.PURPLE)
        },
        assignee: undefined,
        issueTypeId: '',
        parentId: {
            value: ''
        },
        dependencies: [],
        rank: '1',
        labels: [],
        sprintIds: {
            value: []
        },
        versionIds: [],
        componentIds: [],
        resolved: false,
        flagged: false
    };
    // `merge` will overwrite previous value, but for multiple value fields, we want to concat instead
    // NOTE: ignore versions and components because these fields may not be uniquely referenced in the JQL,
    // and cause errors when doing a filtered create
    const contextsWithoutMultipleValueFields = contexts.map(({ labels: labels, ...remainingFields })=>({
            ...remainingFields
        }));
    const resultIssue = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(defaultContext, ...contextsWithoutMultipleValueFields);
    // concat multiple value fields
    contexts.forEach(({ labels: labels = [] })=>{
        resultIssue.labels.push(...labels);
    });
    return resultIssue;
};

});

parcelRegister("adQBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fbadb8bf06046a3$export$2e2bcd8739ae039);
parcelRequire("jyKN9");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $bwVWW = parcelRequire("bwVWW");

var $cuKcG = parcelRequire("cuKcG");

var $5MpXz = parcelRequire("5MpXz");

var $htXdF = parcelRequire("htXdF");

var $7yIcx = parcelRequire("7yIcx");
/* When an issue to be created has required fields, we defer to the global issue create dialog.
 * Handling the result of this dialog happens elsewhere (see global-issue-create.js), since it is
 * the same handling for when a user would open global issue create manually.
 */ const $9fbadb8bf06046a3$var$requiredFieldsCreate = (store, { payload: { level: level } }, optimisticIssue)=>{
    const state = store.getState();
    const projectId = (0, $bwVWW.getProjectId)(state);
    const { issueTypeId: issueTypeId } = optimisticIssue;
    return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
        (0, $cuKcG.addPayloadGlobalIssueCreate)((0, $7yIcx.getFieldsForCreateDialogGIC)(state, optimisticIssue)),
        (0, $5MpXz.updateCreationPreferences)({
            itemTypeId: issueTypeId,
            level: level,
            projectId: projectId
        }),
        (0, $htXdF.resetCreateItemAnchor)()
    ]));
};
var $9fbadb8bf06046a3$export$2e2bcd8739ae039 = $9fbadb8bf06046a3$var$requiredFieldsCreate;

});


parcelRegister("31knk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b3081e772e5e060$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $gwIV8 = parcelRequire("gwIV8");

var $lBt67 = parcelRequire("lBt67");
var $6b3081e772e5e060$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $gwIV8.default), (0, $lBt67.default));

});
parcelRegister("gwIV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $39dc6652ee91533a$export$2e2bcd8739ae039);
parcelRequire("dM0Xt");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("1Lcr1");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("b8V1i");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $7Urnu = parcelRequire("7Urnu");

var $cDvag = parcelRequire("cDvag");


var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $9BmXV = parcelRequire("9BmXV");

var $9ZLrP = parcelRequire("9ZLrP");

var $gdFA6 = parcelRequire("gdFA6");

var $eRn8i = parcelRequire("eRn8i");

var $aCPQO = parcelRequire("aCPQO");

var $16ixF = parcelRequire("16ixF");

var $4tOj7 = parcelRequire("4tOj7");

var $4tn5a = parcelRequire("4tn5a");
const $39dc6652ee91533a$export$1ca7cc4cb19d0dda = (state, action)=>{
    const existingDependencies = (0, $6FeJk.getIssueDependenciesHash)(state);
    const { dependency: dependency, dependee: dependee } = action.payload;
    return existingDependencies[dependee]?.includes(dependency);
};
const $39dc6652ee91533a$var$fireAnalytics = (state, action, analyticsAction)=>{
    const clonedEvent = action.meta.analyticsEvent.clone();
    const { dependency: dependency, dependee: dependee } = action.payload;
    if (clonedEvent) (0, $jMP2a.fireTrackAnalytics)(clonedEvent, `issueDependency ${analyticsAction}`, {
        dependeeLevel: (0, $6FeJk.getIssueLevel)(state, dependee),
        dependencyLevel: (0, $6FeJk.getIssueLevel)(state, dependency)
    });
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$39dc6652ee91533a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.CREATE_DEPENDENCY)).map((action)=>{
        const state = store.getState();
        const payload = {
            dependee: (0, $6FeJk.getIssueKeyById)(state, action.payload.dependee),
            dependency: (0, $6FeJk.getIssueKeyById)(state, action.payload.dependency)
        };
        if (!payload.dependency || !payload.dependee || payload.dependency === payload.dependee) return (0, $3JafE.Observable).empty();
        const isCyclic = (0, $eRn8i.isDependencyCyclic)({
            dependenciesHash: (0, $6FeJk.getIssueDependenciesHash)(state),
            dependency: action.payload.dependency,
            dependee: action.payload.dependee
        });
        if (isCyclic) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('roadmap.standard.issues-add-dependency', 'Dependency cycle exceeds supported depth.');
            return (0, $3JafE.Observable).of((0, $9BmXV.dependencyCycleCreation)(payload));
        }
        if ($39dc6652ee91533a$export$1ca7cc4cb19d0dda(state, action)) return (0, $3JafE.Observable).of((0, $9BmXV.dependencyDuplication)(payload));
        if (!(0, $bwVWW.areDependenciesSupported)(store.getState())) {
            $39dc6652ee91533a$var$fireAnalytics(store.getState(), action, 'addFailed');
            return (0, $3JafE.Observable).of((0, $9BmXV.dependenciesUnavailable)());
        }
        const sourceARI = (0, $lgKTA.getSourceARI)(state);
        const inputObservable = (0, $4tn5a.getSafeDependencyInput)(state, action.payload);
        const longRunning = inputObservable.mergeMap((input)=>{
            const { dependee: dependee, dependency: dependency } = input;
            const addDependencyOnBackendPromise = (0, $7Urnu.addDependencyOnServer)({
                sourceARI: sourceARI,
                input: {
                    dependee: dependee,
                    dependency: dependency
                }
            }).mergeMap((data)=>{
                const addRoadmapDependencyData = data?.roadmaps?.addRoadmapDependency;
                const errors = addRoadmapDependencyData?.errors;
                const success = addRoadmapDependencyData?.success;
                if (success === false && errors?.length) {
                    if ((0, $aCPQO.isPermissionError)(errors)) {
                        const actions = [
                            (0, $j45xj.deleteDependency)(action.payload),
                            (0, $9BmXV.dependenciesPermission)({
                                type: (0, $ca84cb21ba49b72e$export$706a65ec8b4360e1),
                                dependeeKey: (0, $6FeJk.getIssueKeyHash)(state)[action.payload.dependee],
                                dependencyKey: (0, $6FeJk.getIssueKeyHash)(state)[action.payload.dependency]
                            })
                        ];
                        return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)(actions));
                    }
                    return (0, $16ixF.onHandleAggErrors)(!!addRoadmapDependencyData, errors).map((aggErrorAction)=>(0, $MYW4e.batchActions)([
                            (0, $j45xj.deleteDependency)(action.payload),
                            aggErrorAction
                        ]));
                }
                (0, $4tOj7.default)(state, (0, $6FeJk.getIssueKeyById)(state, action.payload.dependee));
                (0, $4tOj7.default)(state, (0, $6FeJk.getIssueKeyById)(state, action.payload.dependency));
                $39dc6652ee91533a$var$fireAnalytics(store.getState(), action, 'added');
                if ((0, $9ZLrP.isDependenciesVisible)(store.getState())) return (0, $3JafE.Observable).empty();
                return (0, $3JafE.Observable).of((0, $9BmXV.hiddenDependencyCreated)());
            });
            return addDependencyOnBackendPromise.catch(()=>{
                const actions = [
                    (0, $j45xj.deleteDependency)(action.payload),
                    (0, $9BmXV.aggError)()
                ];
                return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)(actions));
            });
        });
        return (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $j45xj.addDependency)(action.payload)), longRunning, (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)() ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).of((0, $gdFA6.reapplyJQLFilters)()));
    }).mergeAll();

});
parcelRegister("7Urnu", function(module, exports) {

$parcel$export(module.exports, "addDependencyOnServer", () => $e3a5d55b6aeaef6c$export$aee09e3d42b0625e);

var $jyMfJ = parcelRequire("jyMfJ");


var $jie15 = parcelRequire("jie15");

var $9ouT3 = parcelRequire("9ouT3");
const $e3a5d55b6aeaef6c$var$mutationName = 'addRoadmapDependency';
const $e3a5d55b6aeaef6c$var$concurrentMetricDefinition = (0, $9ouT3.mutationMetrics)[0, $028d5637f56fe710$export$5913ec3a0f9505fe];
const $e3a5d55b6aeaef6c$var$analyticKey = 'jira.frontend.fe.software.roadmap.dependency-added';
const $e3a5d55b6aeaef6c$export$aee09e3d42b0625e = ({ sourceARI: sourceARI, input: input })=>(0, $jie15.runMutation)($e3a5d55b6aeaef6c$var$mutationName, (0, $jyMfJ.default), {
        sourceARI: sourceARI,
        input: input
    }, $e3a5d55b6aeaef6c$var$analyticKey, $e3a5d55b6aeaef6c$var$concurrentMetricDefinition);

});
parcelRegister("jyMfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d454f4992aacced$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f21e995a2eb1be71e4e3df94f3c81a7>>
 * @relayHash 255e226237216096e8a600bbdb20cfcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5128cd59d6a48d3cf837c81e4baf8846c37dc31eba1fd40ee0fb65591718c84b
const $3d454f4992aacced$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceARI"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceARI"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            },
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ],
        "type": "RoadmapMutationErrorExtension"
    }, v6 = {
        "concreteType": "RoadmapToggleDependencyResponse",
        "kind": "LinkedField",
        "name": "output",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dependee"
            },
            {
                "kind": "ScalarField",
                "name": "dependency"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "addRoadmapDependencyMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapToggleDependencyPayload",
                            "kind": "LinkedField",
                            "name": "addRoadmapDependency",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "addRoadmapDependencyMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapToggleDependencyPayload",
                            "kind": "LinkedField",
                            "name": "addRoadmapDependency",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5128cd59d6a48d3cf837c81e4baf8846c37dc31eba1fd40ee0fb65591718c84b",
            "metadata": {},
            "name": "addRoadmapDependencyMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3d454f4992aacced$var$node.hash = "32cf0e6cedae9ac26e7413c9b16a5074";
var $3d454f4992aacced$export$2e2bcd8739ae039 = $3d454f4992aacced$var$node;

});


parcelRegister("eRn8i", function(module, exports) {

$parcel$export(module.exports, "isDependencyCyclic", () => $d7b2ffdee24e8012$export$1ad746945d35a8c6);
/** Maximum runs that checks cyclic depth for optimisation */ const $d7b2ffdee24e8012$var$MAX_DEPTH = 10;
const $d7b2ffdee24e8012$export$1ad746945d35a8c6 = ({ dependenciesHash: dependenciesHash, dependency: dependency, dependee: dependee, maxDepth: maxDepth = $d7b2ffdee24e8012$var$MAX_DEPTH })=>{
    const visited = {};
    const findPath = (node, depth)=>{
        // if we find a previously visited node, we can stop because we have already traversed subsequent paths
        if (visited[node]) return false;
        visited[node] = true;
        // if we reach the max depth, we stop and assume there is no path
        if (depth >= maxDepth) return false;
        // if we reach the destination node, then we have found a path
        if (node === dependee) return true;
        const connectedNodes = dependenciesHash[node] ?? [];
        return connectedNodes.some((connectedNode)=>findPath(connectedNode, depth + 1));
    };
    return findPath(dependency, 0);
};

});

parcelRegister("aCPQO", function(module, exports) {

$parcel$export(module.exports, "isPermissionError", () => $37c0bb280f420ed8$export$e11674744930cd15);
const $37c0bb280f420ed8$export$e11674744930cd15 = (errors)=>errors.filter((error)=>error.extensions?.statusCode === 403).length > 0;

});

parcelRegister("4tn5a", function(module, exports) {

$parcel$export(module.exports, "getSafeDependencyInput", () => $6a91da13edbe14bc$export$f57851ce68faa479);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jAXdN");

var $6FeJk = parcelRequire("6FeJk");
const $6a91da13edbe14bc$export$f57851ce68faa479 = (state, payload)=>(0, $3JafE.Observable).zip((0, $6FeJk.getSafeId)(state, payload.dependee), (0, $6FeJk.getSafeId)(state, payload.dependency), (safeDependeeId, safeDependencyId)=>({
            dependee: safeDependeeId,
            dependency: safeDependencyId
        }));

});


parcelRegister("lBt67", function(module, exports) {

$parcel$export(module.exports, "default", () => $a588020c72ec5fb3$export$2e2bcd8739ae039);
parcelRequire("dM0Xt");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("flmol");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $jMP2a = parcelRequire("jMP2a");

var $ku2JA = parcelRequire("ku2JA");

var $cDvag = parcelRequire("cDvag");


var $lgKTA = parcelRequire("lgKTA");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $9BmXV = parcelRequire("9BmXV");

var $gdFA6 = parcelRequire("gdFA6");

var $aCPQO = parcelRequire("aCPQO");

var $16ixF = parcelRequire("16ixF");

var $4tOj7 = parcelRequire("4tOj7");

var $4tn5a = parcelRequire("4tn5a");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$a588020c72ec5fb3$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.REMOVE_DEPENDENCY)).mergeMap((action)=>{
        const { payload: payload, meta: { analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const inputObservable = (0, $4tn5a.getSafeDependencyInput)(state, action.payload);
        const sourceARI = (0, $lgKTA.getSourceARI)(state);
        const longRunning = inputObservable.mergeMap((input)=>{
            const { dependee: dependee, dependency: dependency } = input;
            const removeDependencyOnBackendPromise = (0, $ku2JA.removeDependencyOnServer)({
                sourceARI: sourceARI,
                input: {
                    dependee: dependee,
                    dependency: dependency
                }
            }).mergeMap((data)=>{
                const removeRoadmapDependencyData = data?.roadmaps?.removeRoadmapDependency;
                const errors = removeRoadmapDependencyData?.errors;
                const success = removeRoadmapDependencyData?.success;
                if (success === false && errors?.length) {
                    if ((0, $aCPQO.isPermissionError)(errors)) {
                        // permissions error
                        const actions = [
                            (0, $j45xj.addDependency)(payload),
                            (0, $9BmXV.dependenciesPermission)({
                                type: (0, $ca84cb21ba49b72e$export$4e33c4fb4fd4616f),
                                dependeeKey: (0, $6FeJk.getIssueKeyHash)(state)[payload.dependee],
                                dependencyKey: (0, $6FeJk.getIssueKeyHash)(state)[payload.dependency]
                            })
                        ];
                        return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)(actions));
                    }
                    return (0, $16ixF.onHandleAggErrors)(!!removeRoadmapDependencyData, errors).map((aggErrorAction)=>(0, $MYW4e.batchActions)([
                            (0, $j45xj.addDependency)(payload),
                            aggErrorAction
                        ]));
                }
                (0, $4tOj7.default)(state, (0, $6FeJk.getIssueKeyById)(state, payload.dependee));
                (0, $4tOj7.default)(state, (0, $6FeJk.getIssueKeyById)(state, payload.dependency));
                (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issueDependency deleted', {
                    dependeeLevel: (0, $6FeJk.getIssueLevel)(state, payload.dependee),
                    dependencyLevel: (0, $6FeJk.getIssueLevel)(state, payload.dependency)
                });
                return (0, $3JafE.Observable).empty();
            });
            return removeDependencyOnBackendPromise.catch(()=>{
                const actions = [
                    (0, $j45xj.addDependency)(payload),
                    (0, $9BmXV.aggError)()
                ];
                return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)(actions));
            });
        });
        return (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $j45xj.deleteDependency)(payload)), longRunning, (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)() ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).of((0, $gdFA6.reapplyJQLFilters)()));
    });

});
parcelRegister("ku2JA", function(module, exports) {

$parcel$export(module.exports, "removeDependencyOnServer", () => $84cb0ddf97d1a1eb$export$6177c0c69879770e);

var $8OEln = parcelRequire("8OEln");


var $jie15 = parcelRequire("jie15");

var $9ouT3 = parcelRequire("9ouT3");
const $84cb0ddf97d1a1eb$var$mutationName = 'removeRoadmapDependency';
const $84cb0ddf97d1a1eb$var$concurrentMetricDefinition = (0, $9ouT3.mutationMetrics)[0, $028d5637f56fe710$export$488a6fa9078615df];
const $84cb0ddf97d1a1eb$var$analyticKey = 'jira.frontend.fe.software.roadmap.dependency-removed';
const $84cb0ddf97d1a1eb$export$6177c0c69879770e = ({ sourceARI: sourceARI, input: input })=>(0, $jie15.runMutation)($84cb0ddf97d1a1eb$var$mutationName, (0, $8OEln.default), {
        sourceARI: sourceARI,
        input: input
    }, $84cb0ddf97d1a1eb$var$analyticKey, $84cb0ddf97d1a1eb$var$concurrentMetricDefinition);

});
parcelRegister("8OEln", function(module, exports) {

$parcel$export(module.exports, "default", () => $0accee6c5b70d0b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb3bdb5e717a094a5373a76f8e2ce1a3>>
 * @relayHash 546354d9795c58c7f4cec3571f3e6ae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 17bdaad9cdc6a0a9bdd038723300f6b082d5eedd61a018c8aa37141dc03e5645
const $0accee6c5b70d0b0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceARI"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceARI"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            },
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ],
        "type": "RoadmapMutationErrorExtension"
    }, v6 = {
        "concreteType": "RoadmapToggleDependencyResponse",
        "kind": "LinkedField",
        "name": "output",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dependee"
            },
            {
                "kind": "ScalarField",
                "name": "dependency"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "removeRoadmapDependencyMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapToggleDependencyPayload",
                            "kind": "LinkedField",
                            "name": "removeRoadmapDependency",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "removeRoadmapDependencyMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapToggleDependencyPayload",
                            "kind": "LinkedField",
                            "name": "removeRoadmapDependency",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "17bdaad9cdc6a0a9bdd038723300f6b082d5eedd61a018c8aa37141dc03e5645",
            "metadata": {},
            "name": "removeRoadmapDependencyMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0accee6c5b70d0b0$var$node.hash = "f2c55864aaec3b444aa411cc582decd9";
var $0accee6c5b70d0b0$export$2e2bcd8739ae039 = $0accee6c5b70d0b0$var$node;

});




parcelRegister("kcW7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e6e12662d86e332$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("8jBvP");

var $3JafE = parcelRequire("3JafE");

var $6FeJk = parcelRequire("6FeJk");

var $dFuRD = parcelRequire("dFuRD");

var $9E22T = parcelRequire("9E22T");

var $htXdF = parcelRequire("htXdF");

var $11LHz = parcelRequire("11LHz");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$1e6e12662d86e332$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $dFuRD.ROUTER_LOCATION_CHANGE)).mergeMap(()=>{
        const state = store.getState();
        const issueId = (0, $9E22T.getSelectedIssueId)(state);
        if (issueId) {
            const parentId = (0, $6FeJk.getIssueParentIdHash)(state)[issueId];
            if (parentId && !(0, $11LHz.getExpandedItems)(state)[parentId]) return (0, $3JafE.Observable).of((0, $htXdF.changeExpansionState)({
                id: parentId,
                isExpanded: true
            }));
        }
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("7NPsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $872bacea4fe3a3b0$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("8jBvP");

var $fG8Rc = parcelRequire("fG8Rc");

var $jJwwt = parcelRequire("jJwwt");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $34Aaz = parcelRequire("34Aaz");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $3YMoa = parcelRequire("3YMoa");

var $9BmXV = parcelRequire("9BmXV");

var $9E22T = parcelRequire("9E22T");

var $kbyLF = parcelRequire("kbyLF");

var $1SuDz = parcelRequire("1SuDz");

var $56Mmd = parcelRequire("56Mmd");

var $2CrgW = parcelRequire("2CrgW");
const $872bacea4fe3a3b0$var$BASE_LEVEL_PARENT = '[NO_PARENT]';
const $872bacea4fe3a3b0$var$generatePartialCsv = (columnTransformers, context, parentId)=>{
    const { chartDataHash: chartDataHash, issuesByParent: issuesByParent } = context;
    let csv = '';
    (issuesByParent[parentId] ?? []).forEach(({ issueId: issueId, issue: issue })=>{
        const chartData = chartDataHash[issueId];
        csv += `${columnTransformers.map((column)=>column.transform({
                issueId: issueId,
                issue: issue,
                chartData: chartData
            }, context)).join(',')}\r\n`;
        csv += $872bacea4fe3a3b0$var$generatePartialCsv(columnTransformers, context, issueId);
    });
    return csv;
};
const $872bacea4fe3a3b0$export$d4b63bab9e1886d8 = (columnTransformers, context)=>`${columnTransformers.map((column)=>(0, $2CrgW.escapeValue)(context.issueFields[column.fieldId ?? ''] ?? column.fieldId)).join(',')}\r\n`;
const $872bacea4fe3a3b0$export$bf12c6f7f076b36f = (columnTransformers, context)=>{
    let csv = '';
    csv += $872bacea4fe3a3b0$export$d4b63bab9e1886d8(columnTransformers, context);
    csv += $872bacea4fe3a3b0$var$generatePartialCsv(columnTransformers, context, $872bacea4fe3a3b0$var$BASE_LEVEL_PARENT);
    const safeFileName = context.projectName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
    const dateNow = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt)))().format('YYYY-MM-DD_hh.mma');
    const blob = new Blob([
        csv
    ], {
        type: 'text/plain;charset=utf-8'
    });
    (0, $fG8Rc.saveAs)(blob, `${safeFileName}_${dateNow}.csv`);
};
const $872bacea4fe3a3b0$export$80d376111cc09ad7 = ({ issueIds: issueIds, issuesHash: issuesHash, userDisplayNameHash: userDisplayNameHash, issueTypesHash: issueTypesHash, startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, issueFields: issueFields, issueSprintsHash: issueSprintsHash, isSprintsFeatureEnabled: isSprintsFeatureEnabled, chartDataHash: chartDataHash, projectName: projectName })=>{
    if ((0, $1ybV0.ff)('timeline-export-as-spreadsheet_1mdsg')) (0, $34Aaz.onGenerateCsv)({
        issueIds: issueIds,
        issuesHash: issuesHash,
        userDisplayNameHash: userDisplayNameHash,
        issueTypesHash: issueTypesHash,
        startDateCustomFieldId: startDateCustomFieldId,
        colorCustomFieldId: colorCustomFieldId,
        sprintCustomFieldId: sprintCustomFieldId,
        issueFields: issueFields,
        issueSprintsHash: issueSprintsHash,
        isSprintsFeatureEnabled: isSprintsFeatureEnabled,
        chartDataHash: chartDataHash,
        projectName: projectName
    });
    else {
        if (issueIds.length === 0) return (0, $3JafE.Observable).empty();
        const issuesByParent = {
            BASE_LEVEL_PARENT: []
        };
        issueIds.forEach((issueId)=>{
            const issue = issuesHash[issueId];
            const parentId = issue.parentId.value ?? $872bacea4fe3a3b0$var$BASE_LEVEL_PARENT;
            const issueList = issuesByParent[parentId] ?? [];
            issueList.push({
                issueId: issueId,
                issue: issue
            });
            issuesByParent[parentId] = issueList;
        });
        const customFields = {
            startDateCustomFieldId: startDateCustomFieldId,
            colorCustomFieldId: colorCustomFieldId,
            sprintCustomFieldId: sprintCustomFieldId,
            isSprintsFeatureEnabled: isSprintsFeatureEnabled
        };
        const columnTransformers = (0, $2CrgW.getColumnTransformers)(customFields);
        const transformationContext = {
            issueIds: issueIds,
            issuesByParent: issuesByParent,
            issuesHash: issuesHash,
            userDisplayNameHash: userDisplayNameHash,
            issueTypesHash: issueTypesHash,
            issueFields: issueFields,
            issueSprintsHash: issueSprintsHash,
            customFields: customFields,
            chartDataHash: chartDataHash,
            projectName: projectName
        };
        $872bacea4fe3a3b0$export$bf12c6f7f076b36f(columnTransformers, transformationContext);
    }
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$872bacea4fe3a3b0$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $56Mmd.EXPORT_CSV)).mergeMap(({ payload: { inferredDueDateHeader: inferredDueDateHeader, inferredStartDateHeader: inferredStartDateHeader } })=>{
        try {
            const state = store.getState();
            const issueIds = (0, $9E22T.getFilteredIssueIds)(state);
            const issuesHash = (0, $6FeJk.getFullIssueHash)(state);
            const userDisplayNameHash = (0, $3YMoa.getUserDisplayNameHash)(state);
            const issueTypesHash = (0, $bwVWW.getFullIssueTypeHash)(state);
            const startDateCustomFieldId = (0, $bwVWW.getStartDateCustomFieldId)(state);
            const colorCustomFieldId = (0, $bwVWW.getColorCustomFieldId)(state);
            const sprintCustomFieldId = (0, $bwVWW.getSprintCustomFieldId)(state);
            const issueFields = {
                inferredDueDate: inferredDueDateHeader,
                inferredStartDate: inferredStartDateHeader,
                ...(0, $bwVWW.getFieldsNamesHash)(state)
            };
            const issueSprintsHash = (0, $kbyLF.getSanitisedIssueSprintsHash)(state);
            const isSprintsFeatureEnabled = (0, $bwVWW.getIsSprintsFeatureEnabled)(state);
            const chartDataHash = (0, $1SuDz.getChartDataHash)(state);
            const projectName = (0, $bwVWW.getProjectName)(state);
            $872bacea4fe3a3b0$export$80d376111cc09ad7({
                issueIds: issueIds,
                issuesHash: issuesHash,
                userDisplayNameHash: userDisplayNameHash,
                issueTypesHash: issueTypesHash,
                startDateCustomFieldId: startDateCustomFieldId,
                colorCustomFieldId: colorCustomFieldId,
                sprintCustomFieldId: sprintCustomFieldId,
                issueFields: issueFields,
                issueSprintsHash: issueSprintsHash,
                isSprintsFeatureEnabled: isSprintsFeatureEnabled,
                chartDataHash: chartDataHash,
                projectName: projectName
            });
        } catch  {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsw.timeline.export-csv.failure', 'Failed to generate timeline CSV');
            return (0, $3JafE.Observable).of((0, $9BmXV.generalError)());
        }
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("fG8Rc", function(module, exports) {
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ var $b6a1a615ff478201$var$saveAs = $b6a1a615ff478201$var$saveAs || function(view) {
    "use strict";
    // IE <10 is explicitly unsupported
    if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var doc = view.document, get_URL = function() {
        return view.URL || view.webkitURL || view;
    }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
        var event = new MouseEvent("click");
        node.dispatchEvent(event);
    }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
        (view.setImmediate || view.setTimeout)(function() {
            throw ex;
        }, 0);
    }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000 // in ms
    , revoke = function(file) {
        var revoker = function() {
            if (typeof file === "string") get_URL().revokeObjectURL(file);
            else file.remove();
        };
        setTimeout(revoker, arbitrary_revoke_timeout);
    }, dispatch = function(filesaver, event_types, event) {
        event_types = [].concat(event_types);
        var i = event_types.length;
        while(i--){
            var listener = filesaver["on" + event_types[i]];
            if (typeof listener === "function") try {
                listener.call(filesaver, event || filesaver);
            } catch (ex) {
                throw_outside(ex);
            }
        }
    }, auto_bom = function(blob) {
        // prepend BOM for UTF-8 XML and text/* types (including HTML)
        // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
            String.fromCharCode(0xFEFF),
            blob
        ], {
            type: blob.type
        });
        return blob;
    }, FileSaver = function(blob, name, no_auto_bom) {
        if (!no_auto_bom) blob = auto_bom(blob);
        // First try a.download, then web filesystem, then object URLs
        var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
            dispatch(filesaver, "writestart progress write writeend".split(" "));
        }, fs_error = function() {
            if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                // Safari doesn't allow downloading of blob urls
                var reader = new FileReader();
                reader.onloadend = function() {
                    var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                    var popup = view.open(url, '_blank');
                    if (!popup) view.location.href = url;
                    url = undefined; // release reference before dispatching
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                };
                reader.readAsDataURL(blob);
                filesaver.readyState = filesaver.INIT;
                return;
            }
            // don't create more object URLs than needed
            if (!object_url) object_url = get_URL().createObjectURL(blob);
            if (force) view.location.href = object_url;
            else {
                var opened = view.open(object_url, "_blank");
                if (!opened) // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                view.location.href = object_url;
            }
            filesaver.readyState = filesaver.DONE;
            dispatch_all();
            revoke(object_url);
        };
        filesaver.readyState = filesaver.INIT;
        if (can_use_save_link) {
            object_url = get_URL().createObjectURL(blob);
            setTimeout(function() {
                save_link.href = object_url;
                save_link.download = name;
                click(save_link);
                dispatch_all();
                revoke(object_url);
                filesaver.readyState = filesaver.DONE;
            });
            return;
        }
        fs_error();
    }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
        return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
    };
    // IE 10+ (native saveAs)
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
        name = name || blob.name || "download";
        if (!no_auto_bom) blob = auto_bom(blob);
        return navigator.msSaveOrOpenBlob(blob, name);
    };
    FS_proto.abort = function() {};
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;
    FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
    return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window
if (0, module.exports) module.exports.saveAs = $b6a1a615ff478201$var$saveAs;
else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
    return $b6a1a615ff478201$var$saveAs;
});

});

parcelRegister("34Aaz", function(module, exports) {

$parcel$export(module.exports, "onGenerateCsv", () => $fbd9745c2294c69d$export$e8a9be234322a768);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("8jBvP");

var $fG8Rc = parcelRequire("fG8Rc");

var $jJwwt = parcelRequire("jJwwt");

var $3JafE = parcelRequire("3JafE");

var $cox6r = parcelRequire("cox6r");
const $fbd9745c2294c69d$var$BASE_LEVEL_PARENT = '[NO_PARENT]';
const $fbd9745c2294c69d$var$generatePartialCsv = (columnTransformers, context, parentId)=>{
    const { chartDataHash: chartDataHash, issuesByParent: issuesByParent } = context;
    let csv = '';
    (issuesByParent[parentId] ?? []).forEach(({ issueId: issueId, issue: issue })=>{
        const chartData = chartDataHash?.[issueId];
        csv += `${columnTransformers.map((column)=>column.transform({
                issueId: issueId,
                issue: issue,
                chartData: chartData
            }, context)).join(',')}\r\n`;
        csv += $fbd9745c2294c69d$var$generatePartialCsv(columnTransformers, context, issueId);
    });
    return csv;
};
const $fbd9745c2294c69d$export$d4b63bab9e1886d8 = (columnTransformers, context)=>`${columnTransformers.map((column)=>(0, $cox6r.escapeValue)(context.issueFields[column.fieldId ?? ''] ?? column.fieldId)).join(',')}\r\n`;
const $fbd9745c2294c69d$export$bf12c6f7f076b36f = (columnTransformers, context)=>{
    let csv = '';
    csv += $fbd9745c2294c69d$export$d4b63bab9e1886d8(columnTransformers, context);
    csv += $fbd9745c2294c69d$var$generatePartialCsv(columnTransformers, context, $fbd9745c2294c69d$var$BASE_LEVEL_PARENT);
    const safeFileName = context.projectName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
    const dateNow = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt)))().format('YYYY-MM-DD_hh.mma');
    const blob = new Blob([
        csv
    ], {
        type: 'text/plain;charset=utf-8'
    });
    (0, $fG8Rc.saveAs)(blob, `${safeFileName}_${dateNow}.csv`);
};
const $fbd9745c2294c69d$export$e8a9be234322a768 = ({ issueIds: issueIds, issuesHash: issuesHash, userDisplayNameHash: userDisplayNameHash, issueTypesHash: issueTypesHash, startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, issueFields: issueFields, issueSprintsHash: issueSprintsHash, chartDataHash: chartDataHash, projectName: projectName, isSprintsFeatureEnabled: isSprintsFeatureEnabled = false, hasInferredStartDueDateFields: hasInferredStartDueDateFields = true })=>{
    if (issueIds.length === 0) return (0, $3JafE.Observable).empty();
    const issuesByParent = {
        BASE_LEVEL_PARENT: []
    };
    issueIds.forEach((issueId)=>{
        const issue = issuesHash[issueId];
        const parentId = issue.parentId?.value ?? $fbd9745c2294c69d$var$BASE_LEVEL_PARENT;
        const issueList = issuesByParent[parentId] ?? [];
        issueList.push({
            issueId: issueId,
            issue: issue
        });
        issuesByParent[parentId] = issueList;
    });
    const customFields = {
        startDateCustomFieldId: startDateCustomFieldId,
        colorCustomFieldId: colorCustomFieldId,
        sprintCustomFieldId: sprintCustomFieldId,
        isSprintsFeatureEnabled: isSprintsFeatureEnabled,
        hasInferredStartDueDateFields: hasInferredStartDueDateFields
    };
    const columnTransformers = (0, $cox6r.getColumnTransformers)(customFields);
    const transformationContext = {
        issueIds: issueIds,
        issuesByParent: issuesByParent,
        issuesHash: issuesHash,
        userDisplayNameHash: userDisplayNameHash,
        issueTypesHash: issueTypesHash,
        issueFields: issueFields,
        issueSprintsHash: issueSprintsHash,
        customFields: customFields,
        chartDataHash: chartDataHash,
        projectName: projectName
    };
    $fbd9745c2294c69d$export$bf12c6f7f076b36f(columnTransformers, transformationContext);
};

});
parcelRegister("cox6r", function(module, exports) {

$parcel$export(module.exports, "escapeValue", () => $142f455e1307b0d5$export$ea39ee3092b88584);
$parcel$export(module.exports, "getColumnTransformers", () => $142f455e1307b0d5$export$8275ddb83241f041);
// eslint-disable-next-line jira/restricted/moment

var $jJwwt = parcelRequire("jJwwt");

var $bKxX9 = parcelRequire("bKxX9");

var $tgbCK = parcelRequire("tgbCK");

var $c3IKH = parcelRequire("c3IKH");
const $142f455e1307b0d5$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
const $142f455e1307b0d5$export$ea39ee3092b88584 = (value)=>{
    if (value === undefined) return '""';
    if (value.includes('"')) return `"${value.replace(/"/g, '""')}"`;
    return `"${value}"`;
};
const $142f455e1307b0d5$export$3ae94a2503e890a1 = (date)=>$142f455e1307b0d5$export$ea39ee3092b88584(date !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).format($142f455e1307b0d5$export$98de7bb6e1f5105c) : '');
const $142f455e1307b0d5$export$8275ddb83241f041 = ({ startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, isSprintsFeatureEnabled: isSprintsFeatureEnabled, hasInferredStartDueDateFields: hasInferredStartDueDateFields })=>[
        {
            fieldId: 'issuekey',
            transform: ({ issue: issue })=>$142f455e1307b0d5$export$ea39ee3092b88584(issue.key)
        },
        {
            fieldId: 'issuetype',
            transform: ({ issue: issue }, { issueTypesHash: issueTypesHash })=>$142f455e1307b0d5$export$ea39ee3092b88584(issueTypesHash[issue.issueTypeId]?.name)
        },
        {
            fieldId: 'parent',
            transform: ({ issue: issue }, { issuesHash: issuesHash })=>$142f455e1307b0d5$export$ea39ee3092b88584(issue.parentId?.value ? issuesHash[issue.parentId.value]?.key : undefined)
        },
        {
            fieldId: 'summary',
            transform: ({ issue: issue })=>$142f455e1307b0d5$export$ea39ee3092b88584(issue.summary.value)
        },
        ...(0, $bKxX9.ff)('jsw.timeline.return-flagged-attribute-fe') ? [
            {
                fieldId: 'flagged',
                transform: ({ issue: issue })=>$142f455e1307b0d5$export$ea39ee3092b88584(issue.flagged.toString().toLowerCase())
            }
        ] : [],
        {
            fieldId: 'status',
            transform: ({ issue: issue })=>$142f455e1307b0d5$export$ea39ee3092b88584(issue?.status?.name)
        },
        {
            fieldId: 'assignee',
            transform: ({ issue: issue }, { userDisplayNameHash: userDisplayNameHash })=>$142f455e1307b0d5$export$ea39ee3092b88584(issue.assignee ? userDisplayNameHash[issue.assignee] : undefined)
        },
        ...isSprintsFeatureEnabled ? [
            {
                fieldId: sprintCustomFieldId,
                transform: ({ issueId: issueId }, { issueSprintsHash: issueSprintsHash })=>$142f455e1307b0d5$export$ea39ee3092b88584(issueSprintsHash?.[issueId]?.at(0)?.name)
            }
        ] : [],
        {
            fieldId: startDateCustomFieldId,
            transform: ({ issue: issue })=>$142f455e1307b0d5$export$3ae94a2503e890a1(issue.startDate?.value)
        },
        // Inferred start due date fields are not used in JBusiness timeline
        ...hasInferredStartDueDateFields ? [
            {
                fieldId: 'inferredStartDate',
                transform: ({ chartData: chartData })=>$142f455e1307b0d5$export$3ae94a2503e890a1(chartData?.startDate && chartData.placeholder !== (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, $c3IKH.START_DATE_PLACEHOLDER) ? chartData.startDate : undefined)
            }
        ] : [],
        {
            fieldId: 'duedate',
            transform: ({ issue: issue })=>$142f455e1307b0d5$export$3ae94a2503e890a1(issue.dueDate.value)
        },
        // Inferred start due date fields are not used in JBusiness timeline
        ...hasInferredStartDueDateFields ? [
            {
                fieldId: 'inferredDueDate',
                transform: ({ chartData: chartData })=>$142f455e1307b0d5$export$3ae94a2503e890a1(chartData?.dueDate && chartData.placeholder !== (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, $c3IKH.DUE_DATE_PLACEHOLDER) ? chartData.dueDate : undefined)
            }
        ] : [],
        ...colorCustomFieldId ? [
            {
                fieldId: colorCustomFieldId,
                transform: ({ issue: issue })=>$142f455e1307b0d5$export$ea39ee3092b88584((0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[issue.color.value])
            }
        ] : []
    ];

});
parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");


var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $73a5c9d720aa66e1$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
    [(0, $73a5c9d720aa66e1$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    [(0, $73a5c9d720aa66e1$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    [(0, $73a5c9d720aa66e1$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
    [(0, $73a5c9d720aa66e1$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    [(0, $73a5c9d720aa66e1$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    [(0, $73a5c9d720aa66e1$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
    [(0, $73a5c9d720aa66e1$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
    [(0, $73a5c9d720aa66e1$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    [(0, $73a5c9d720aa66e1$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
    [(0, $73a5c9d720aa66e1$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
    [(0, $73a5c9d720aa66e1$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    [(0, $73a5c9d720aa66e1$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    [(0, $73a5c9d720aa66e1$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $73a5c9d720aa66e1$exports).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $73a5c9d720aa66e1$exports).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$exports).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$exports).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $73a5c9d720aa66e1$exports).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $73a5c9d720aa66e1$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N300})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});



parcelRegister("1SuDz", function(module, exports) {

$parcel$export(module.exports, "getFilteredCreateCount", () => $fba6cbd4f3eb0929$export$68429a8cbb9a8844);
$parcel$export(module.exports, "getItemTypesByLevel", () => $fba6cbd4f3eb0929$export$8e9c976d58d13d2c);
$parcel$export(module.exports, "getSecondaryFieldsHash", () => $fba6cbd4f3eb0929$export$510887f0429ab384);
$parcel$export(module.exports, "getChartDataHash", () => $fba6cbd4f3eb0929$export$f879d822e32ece35);
$parcel$export(module.exports, "getChartDataById", () => $fba6cbd4f3eb0929$export$28e002e6c2204a53);
$parcel$export(module.exports, "getItems", () => $fba6cbd4f3eb0929$export$d2f92acf417bbf5d);
$parcel$export(module.exports, "getTableHeaderItems", () => $fba6cbd4f3eb0929$export$15bc8f218c19ff18);
$parcel$export(module.exports, "getTableHeaderItemsHeight", () => $fba6cbd4f3eb0929$export$605bc738601d9d80);
$parcel$export(module.exports, "getItemHeight", () => $fba6cbd4f3eb0929$export$ddd834f23fa82fc4);
$parcel$export(module.exports, "getTableHeight", () => $fba6cbd4f3eb0929$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "getIsCreateSiblingEnabled", () => $fba6cbd4f3eb0929$export$6e34bc43d5f06c81);
$parcel$export(module.exports, "getIsCreateChildEnabled", () => $fba6cbd4f3eb0929$export$b4d24e43117efaf5);
$parcel$export(module.exports, "getIsDragEnabled", () => $fba6cbd4f3eb0929$export$71320b5c818a3427);
$parcel$export(module.exports, "getAriaReadOnly", () => $fba6cbd4f3eb0929$export$704c61f9a16bf8cc);

var $df4Sl = parcelRequire("df4Sl");

var $4P2VV = parcelRequire("4P2VV");

var $gf0vG = parcelRequire("gf0vG");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $5urmd = parcelRequire("5urmd");

var $3YMoa = parcelRequire("3YMoa");

var $9N1AA = parcelRequire("9N1AA");

var $11LHz = parcelRequire("11LHz");

var $9ZLrP = parcelRequire("9ZLrP");

var $9E22T = parcelRequire("9E22T");

var $bkuyl = parcelRequire("bkuyl");

var $9DoTe = parcelRequire("9DoTe");

var $kbyLF = parcelRequire("kbyLF");

var $hjI8T = parcelRequire("hjI8T");

var $363rs = parcelRequire("363rs");

var $59mqg = parcelRequire("59mqg");

var $fTkuC = parcelRequire("fTkuC");

var $hG3ro = parcelRequire("hG3ro");
const $fba6cbd4f3eb0929$export$68429a8cbb9a8844 = (0, $df4Sl.createSelector)((0, $9ZLrP.getIssuesFilter), (0, $hG3ro.getFilteredCreateCountPure));
const $fba6cbd4f3eb0929$export$8e9c976d58d13d2c = (0, $df4Sl.createSelector)((0, $bwVWW.getFullIssueTypeHash), (0, $bwVWW.getEpicIssueTypeIds), (0, $9N1AA.getCreationPreferences), (0, $bwVWW.getProjectDefaultItemTypeId), (0, $hG3ro.getItemTypesByLevelPure));
const $fba6cbd4f3eb0929$export$510887f0429ab384 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueIds), (0, $6FeJk.getIssueParentIdHash), (0, $6FeJk.getIssueStatusHash), (0, $6FeJk.getIssueAssigneeHash), (0, $3YMoa.getUserAvatar16x16Hash), (0, $3YMoa.getUserDisplayNameHash), (0, $5urmd.getDoneStatusCategoryId), (0, $6FeJk.getIsIssueFlaggedHash), (0, $hG3ro.getSecondaryFieldsHashPure));
const $fba6cbd4f3eb0929$export$f879d822e32ece35 = (0, $df4Sl.createSelector)((0, $9E22T.getFilteredNonBaseLevelIssueIds), (0, $9E22T.getFilteredChildIssueIdsHash), (0, $6FeJk.getIssueStartDateHash), (0, $6FeJk.getIssueDueDateHash), (0, $kbyLF.getSanitisedIssueSprintsHash), (0, $6FeJk.getIssueColorHash), (0, $363rs.getIssueDateErrorsHashWithDefaultEqual), (0, $fTkuC.getParentRolledUpDatesHash), (0, $6FeJk.getIssueParentIdHash), (0, $bwVWW.getIsSprintsPlanningEnabled), (0, $bwVWW.getIsChildIssuePlanningEnabled), (0, $59mqg.getChartDataHash));
const $fba6cbd4f3eb0929$export$28e002e6c2204a53 = (state, id)=>$fba6cbd4f3eb0929$export$f879d822e32ece35(state)[id];
const $fba6cbd4f3eb0929$export$d2f92acf417bbf5d = (0, $df4Sl.createSelector)((0, $9E22T.getFilteredNonBaseLevelIssueIds), (0, $9E22T.getFilteredChildIssueIdsHash), (0, $6FeJk.getIssueCreationTransitionHash), (nonBaseLevelIssueIds, issueChildIdsHash, issueCreationTransitionHash)=>{
    const items = [];
    const rootIssues = nonBaseLevelIssueIds;
    rootIssues.forEach((issueId)=>{
        const childIds = issueChildIdsHash[issueId];
        items.push({
            id: issueId,
            level: 1,
            isInTransition: Boolean(issueCreationTransitionHash[issueId]),
            childItems: childIds && childIds.map((childId)=>({
                    id: childId,
                    level: 0,
                    isInTransition: Boolean(issueCreationTransitionHash[childId]),
                    canCreateChildOverride: false
                })),
            canCreateChildOverride: true
        });
    });
    return items;
});
const $fba6cbd4f3eb0929$export$15bc8f218c19ff18 = (0, $df4Sl.createSelector)((0, $bwVWW.getIsSprintsFeatureEnabled), (0, $hjI8T.getIsReleasesVisible), (isSprintsFeatureEnabled, isReleasesHeaderVisible)=>{
    const headerItemConfigs = [];
    if (isSprintsFeatureEnabled) headerItemConfigs.push({
        id: (0, $4P2VV.SPRINTS_HEADER_ID),
        height: (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT)
    });
    if (isReleasesHeaderVisible) headerItemConfigs.push({
        id: (0, $4P2VV.RELEASES_HEADER_ID),
        height: (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT)
    });
    return headerItemConfigs;
});
const $fba6cbd4f3eb0929$export$605bc738601d9d80 = (0, $df4Sl.createSelector)($fba6cbd4f3eb0929$export$15bc8f218c19ff18, (headerItems)=>headerItems.reduce((acc, { height: height })=>acc + (height ?? (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT)), 0));
const $fba6cbd4f3eb0929$var$PROGRESS_ITEM_HEIGHT = 44;
const $fba6cbd4f3eb0929$export$ddd834f23fa82fc4 = (0, $df4Sl.createSelector)((0, $9ZLrP.isProgressVisible), (isVisible)=>isVisible ? $fba6cbd4f3eb0929$var$PROGRESS_ITEM_HEIGHT : (0, $gf0vG.DEFAULT_ITEM_HEIGHT));
const $fba6cbd4f3eb0929$export$81ff4c821ba5ba90 = (0, $df4Sl.createSelector)($fba6cbd4f3eb0929$export$605bc738601d9d80, $fba6cbd4f3eb0929$export$ddd834f23fa82fc4, (0, $9E22T.getFilteredNonBaseLevelIssueIds), (0, $9E22T.getFilteredChildIssueIdsHash), (0, $11LHz.getExpandedItems), (0, $11LHz.getCreateItemAnchor), (0, $bkuyl.getItemsHeight));
const $fba6cbd4f3eb0929$export$6e34bc43d5f06c81 = (0, $df4Sl.createSelector)((0, $9DoTe.getCanUserCreate), (0, $9DoTe.getCanUserRank), (0, $9DoTe.getCanUserEdit), (0, $bwVWW.hasRequiredFields), (canCreate, canRank, canEdit, hasRequiredField)=>!hasRequiredField && canCreate && canRank && canEdit);
const $fba6cbd4f3eb0929$export$b4d24e43117efaf5 = (0, $df4Sl.createSelector)((0, $9DoTe.getCanUserCreate), (0, $9ZLrP.getChildIssueTypes), (canCreate, childItemTypes)=>canCreate && childItemTypes.length > 0);
const $fba6cbd4f3eb0929$export$71320b5c818a3427 = (0, $df4Sl.createSelector)((0, $9DoTe.getCanUserRank), (0, $9DoTe.getCanUserEdit), (canRank, canEdit)=>canRank && canEdit);
const $fba6cbd4f3eb0929$export$704c61f9a16bf8cc = (0, $df4Sl.createSelector)((0, $9DoTe.getCanUserCreate), (0, $9DoTe.getCanUserRank), (0, $9DoTe.getCanUserEdit), (canCreate, canRank, canEdit)=>!canRank && !canCreate && !canEdit);

});
parcelRegister("4P2VV", function(module, exports) {

$parcel$export(module.exports, "TOP", () => $489ab04a62618e5c$export$793ed84f5e13fedc);
$parcel$export(module.exports, "BOTTOM", () => $489ab04a62618e5c$export$84e1549b474f1b93);
$parcel$export(module.exports, "LEFT", () => $489ab04a62618e5c$export$f981f70d61d1405a);
$parcel$export(module.exports, "RIGHT", () => $489ab04a62618e5c$export$1cac5500365a4eb4);
$parcel$export(module.exports, "LEFT_AND_RIGHT", () => $489ab04a62618e5c$export$15a640865ed23fd6);
$parcel$export(module.exports, "START_DATE_RELATIVE", () => $489ab04a62618e5c$export$9353e50b864bcf30);
$parcel$export(module.exports, "DUE_DATE_RELATIVE", () => $489ab04a62618e5c$export$37796aed858ea4df);
$parcel$export(module.exports, "START_DATE_AND_DUE_DATE_RELATIVE", () => $489ab04a62618e5c$export$a7d970936077567f);
$parcel$export(module.exports, "RELEASES_HEADER_ID", () => $489ab04a62618e5c$export$c44d80b675e16f76);
$parcel$export(module.exports, "SPRINTS_HEADER_ID", () => $489ab04a62618e5c$export$8b5a447b30b83d68);
$parcel$export(module.exports, "DEFAULT_RENDERER", () => $489ab04a62618e5c$export$8c50c502a6dae24);
// ============================================== //
// === Catch all - Generic constants go here! === //
// ============================================== //
const $489ab04a62618e5c$export$793ed84f5e13fedc = 'TOP';
const $489ab04a62618e5c$export$84e1549b474f1b93 = 'BOTTOM';
const $489ab04a62618e5c$export$f981f70d61d1405a = 'LEFT';
const $489ab04a62618e5c$export$1cac5500365a4eb4 = 'RIGHT';
const $489ab04a62618e5c$export$15a640865ed23fd6 = 'LEFT_AND_RIGHT';
const $489ab04a62618e5c$export$9353e50b864bcf30 = 'START_DATE_RELATIVE';
const $489ab04a62618e5c$export$37796aed858ea4df = 'DUE_DATE_RELATIVE';
const $489ab04a62618e5c$export$a7d970936077567f = 'START_DATE_AND_DUE_DATE_RELATIVE';
const $489ab04a62618e5c$export$c44d80b675e16f76 = 'RELEASES_HEADER_ID';
const $489ab04a62618e5c$export$8b5a447b30b83d68 = 'SPRINTS_HEADER_ID';
const $489ab04a62618e5c$export$8c50c502a6dae24 = ()=>null;

});

parcelRegister("bkuyl", function(module, exports) {

$parcel$export(module.exports, "getItemOffsetPositions", () => $7ab92e7ddf28889d$export$1c16f71ecb9378cb);
$parcel$export(module.exports, "getItemsHeight", () => $7ab92e7ddf28889d$export$28a0df7c3241d02);

var $df4Sl = parcelRequire("df4Sl");

var $gf0vG = parcelRequire("gf0vG");
const $7ab92e7ddf28889d$export$70dc67daffbef8af = (headerItemsHeight, itemHeight, itemIds, childIdsHash = {}, expandedItems = {}, createItemAnchor)=>{
    const result = [];
    let prevItemOffset = 0;
    itemIds.forEach((id)=>{
        const childIds = childIdsHash[id] || [];
        let childHeight = expandedItems[id] ? childIds.length * (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : 0;
        let currentOffset = prevItemOffset;
        /* Include offsets caused by the create item.
		 * The create item is always the same height (itemHeight) even when creating children.
		 */ if (createItemAnchor) {
            const createBeforeItem = createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === id;
            const createBeforeChildItem = createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === id && createItemAnchor.parentId !== undefined;
            const createInsideItem = createItemAnchor.position === (0, $gf0vG.INSIDE) && createItemAnchor.parentId === id;
            if (createBeforeItem) currentOffset += itemHeight;
            if (createInsideItem || createBeforeChildItem) childHeight += itemHeight;
        }
        const totalHeight = itemHeight + childHeight;
        result.push({
            id: String(id),
            position: currentOffset + itemHeight / 2,
            height: itemHeight
        });
        // if parent is expanded, include children in the list
        if (expandedItems[id]) {
            let childPrevItemOffset = currentOffset + itemHeight;
            childIds.forEach((childId)=>{
                if (createItemAnchor && typeof createItemAnchor === 'object' && 'parentId' in createItemAnchor && createItemAnchor.parentId && createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === childId) {
                    childPrevItemOffset += itemHeight;
                    currentOffset += itemHeight;
                }
                result.push({
                    id: String(childId),
                    position: childPrevItemOffset + (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) / 2,
                    height: (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT)
                });
                childPrevItemOffset += (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT);
            });
        }
        prevItemOffset = currentOffset + totalHeight;
    });
    return result;
};
const $7ab92e7ddf28889d$var$parsePositions = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, { id: id, position: position })=>{
        acc[id] = position;
        return acc;
    }, {});
const $7ab92e7ddf28889d$var$parseHeight = (items, headerItemsHeight)=>{
    let itemsHeight = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, { height: height })=>{
        itemsHeight += height;
        return acc;
    }, {});
    return itemsHeight + headerItemsHeight + (0, $gf0vG.BASE_HEADER_HEIGHT);
};
const $7ab92e7ddf28889d$export$1c16f71ecb9378cb = (0, $df4Sl.createSelector)($7ab92e7ddf28889d$export$70dc67daffbef8af, $7ab92e7ddf28889d$var$parsePositions);
const $7ab92e7ddf28889d$export$28a0df7c3241d02 = (0, $df4Sl.createSelector)($7ab92e7ddf28889d$export$70dc67daffbef8af, (headerItemsHeight)=>headerItemsHeight, $7ab92e7ddf28889d$var$parseHeight);

});

parcelRegister("9DoTe", function(module, exports) {

$parcel$export(module.exports, "getCanUserEdit", () => $603c08cb070c2663$export$b47d5e7b73592dfd);
$parcel$export(module.exports, "getCanUserCreate", () => $603c08cb070c2663$export$db23a83630667bd2);
$parcel$export(module.exports, "getCanUserRank", () => $603c08cb070c2663$export$a2798deca233c810);
$parcel$export(module.exports, "getCanUserViewDetails", () => $603c08cb070c2663$export$c4234881dfa9e672);

var $df4Sl = parcelRequire("df4Sl");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");
const $603c08cb070c2663$export$b47d5e7b73592dfd = (0, $df4Sl.createSelector)((0, $bwVWW.hasEditIssuesPermission), (0, $lgKTA.getIsReadOnly), (0, $lgKTA.hasMacroConfig), (canEditIssue, isReadyOnly, isMacroConfigExist)=>canEditIssue && !isReadyOnly && !isMacroConfigExist);
const $603c08cb070c2663$export$db23a83630667bd2 = (0, $df4Sl.createSelector)((0, $bwVWW.hasCreateIssuesPermission), (0, $lgKTA.getIsReadOnly), (0, $lgKTA.hasMacroConfig), (canCreateIssue, isReadyOnly, isMacroConfigExist)=>canCreateIssue && !isReadyOnly && !isMacroConfigExist);
const $603c08cb070c2663$export$a2798deca233c810 = (0, $df4Sl.createSelector)((0, $bwVWW.hasScheduleIssuesPermission), (0, $lgKTA.getIsReadOnly), (0, $lgKTA.hasMacroConfig), (canRankIssue, isReadyOnly, isMacroConfigExist)=>canRankIssue && !isReadyOnly && !isMacroConfigExist);
const $603c08cb070c2663$export$c4234881dfa9e672 = (0, $df4Sl.createSelector)((0, $lgKTA.hasMacroConfig), (isMacroConfigExist)=>!isMacroConfigExist);

});

parcelRegister("363rs", function(module, exports) {

$parcel$export(module.exports, "getIssueDateErrorsHashWithDefaultEqual", () => $8f000b6242175e28$export$3ab7cce0b33f8834);

var $df4Sl = parcelRequire("df4Sl");

var $jtx35 = parcelRequire("jtx35");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $5urmd = parcelRequire("5urmd");

var $9ZLrP = parcelRequire("9ZLrP");

var $9E22T = parcelRequire("9E22T");

var $kbyLF = parcelRequire("kbyLF");

var $fTkuC = parcelRequire("fTkuC");

var $ebT6q = parcelRequire("ebT6q");
const $8f000b6242175e28$export$56404af3856ae112 = (0, $df4Sl.createSelector)((0, $5urmd.getDoneStatusCategoryId), (0, $6FeJk.getIssueStatusHash), (0, $6FeJk.getIssueStartDateHash), (0, $6FeJk.getIssueDueDateHash), (0, $6FeJk.getIssueParentIdHash), (0, $fTkuC.getParentRolledUpDatesHash), (0, $fTkuC.getExplicitBoundaryDatesHash), (0, $bwVWW.getIsSprintsPlanningEnabled), (0, $bwVWW.getIsChildIssuePlanningEnabled), (0, $9E22T.getIssueEdgeReleaseDatesHash), (0, $kbyLF.getSanitisedIssueSprintsHash), (0, $bwVWW.getIsReleasesFeatureEnabled), (0, $ebT6q.createGetIssueDateWarningsHash));
const $8f000b6242175e28$export$36937d09d493b192 = (state)=>(0, $9ZLrP.isWarningsVisible)(state) ? $8f000b6242175e28$export$56404af3856ae112(state) : {};
const $8f000b6242175e28$export$3ab7cce0b33f8834 = (0, $jtx35.createSelectorWithDefaultEqual)($8f000b6242175e28$export$36937d09d493b192, (dateErrors)=>dateErrors);

});
parcelRegister("ebT6q", function(module, exports) {

$parcel$export(module.exports, "createGetIssueDateWarningsHash", () => $bccc623b64a0fdbc$export$3312d29c1b2c9e97);

var $c3IKH = parcelRequire("c3IKH");

var $1gs0D = parcelRequire("1gs0D");

var $hVoYF = parcelRequire("hVoYF");

var $l5hWP = parcelRequire("l5hWP");

var $dO54w = parcelRequire("dO54w");
const $bccc623b64a0fdbc$export$b263ee37617f73e = (startDate, dueDate, rolledUpBaseLevelStartDate, rolledUpBaseLevelDueDate, rolledUpLatestStartDate, rolledUpEarliestDueDate)=>{
    const rolledUpStartDate = rolledUpLatestStartDate !== undefined && dueDate !== undefined && rolledUpLatestStartDate > dueDate ? rolledUpLatestStartDate : rolledUpBaseLevelStartDate;
    const rolledUpDueDate = rolledUpEarliestDueDate !== undefined && startDate !== undefined && rolledUpEarliestDueDate < startDate ? rolledUpEarliestDueDate : rolledUpBaseLevelDueDate;
    const warningMapKey = (0, $dO54w.getErrorForDatesOutsideBoundary)(rolledUpStartDate, rolledUpDueDate, startDate, dueDate);
    const warningMessageIdMap = new Map([
        [
            (0, $dO54w.BOTH),
            (0, $1gs0D.PARENT_STARTS_AFTER_CHILD_AND_ENDS_BEFORE_CHILD_MESSAGE_ID)
        ],
        [
            (0, $dO54w.START),
            (0, $1gs0D.PARENT_STARTS_AFTER_CHILD_MESSAGE_ID)
        ],
        [
            (0, $dO54w.DUE),
            (0, $1gs0D.PARENT_ENDS_BEFORE_CHILD_MESSAGE_ID)
        ]
    ]);
    const warningMessageId = warningMapKey && warningMessageIdMap.get(warningMapKey);
    return warningMessageId !== undefined ? (0, $l5hWP.default)[warningMessageId] : undefined;
};
const $bccc623b64a0fdbc$export$3312d29c1b2c9e97 = (doneStatusCategoryId, issueStatusHash, issueStartDateHash, issueDueDateHash, parentIdHash, parentRolledUpDatesHash, boundaryDates, isSprintsPlanning, isChildIssuePlanningEnabled, issueEdgeReleaseDatesVersionHash, issueSprintIdsHash, isReleasesFeatureEnabled)=>{
    const result = {};
    Object.keys(issueStartDateHash).forEach((issueId)=>{
        result[issueId] = [];
        if (doneStatusCategoryId && issueStatusHash[issueId]?.statusCategoryId === doneStatusCategoryId) return;
        const explicitStartDate = issueStartDateHash[issueId];
        const explicitDueDate = issueDueDateHash[issueId];
        const sprints = issueSprintIdsHash[issueId] || [];
        const isParentIssue = parentIdHash[issueId] === undefined;
        let startDate;
        let dueDate;
        let placeholder;
        let childExceedsRolledUpParent;
        if (isParentIssue) {
            const rolledUpDates = parentRolledUpDatesHash[issueId] || {};
            const { startDate: parentLevelStartDate, dueDate: parentLevelDueDate, placeholder: parentLevelPlaceholder, childExceedsRolledUpParent: parentChildExceedsRolledUpParent } = (0, $hVoYF.getParentLevelDates)(explicitStartDate, explicitDueDate, rolledUpDates, isChildIssuePlanningEnabled);
            startDate = parentLevelStartDate;
            dueDate = parentLevelDueDate;
            placeholder = parentLevelPlaceholder;
            childExceedsRolledUpParent = parentChildExceedsRolledUpParent;
        } else {
            const { startDate: baseLevelStartDate, dueDate: baseLevelDueDate, placeholder: baseLevelPlaceholder } = (0, $hVoYF.getBaseLevelDates)(explicitStartDate, explicitDueDate, sprints, isSprintsPlanning, isChildIssuePlanningEnabled);
            startDate = baseLevelStartDate;
            dueDate = baseLevelDueDate;
            placeholder = baseLevelPlaceholder;
        }
        // start date after due date warning
        if ((0, $dO54w.isDateAfter)(explicitStartDate, explicitDueDate) || childExceedsRolledUpParent) result[issueId].push((0, $l5hWP.default)[0, $1gs0D.START_DATE_LATER_DUE_DATE_MESSAGE_ID]);
        // child outside of parent warning
        const shouldShowChildWarning = isParentIssue && isChildIssuePlanningEnabled;
        if (shouldShowChildWarning) {
            let parentDateError;
            const isStartDatePlaceholder = placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
            const isDueDatePlaceholder = placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
            const dateRangeBoundary = boundaryDates[issueId];
            const latestStartDate = parentRolledUpDatesHash[issueId]?.latestStartDate;
            const earliestDueDate = parentRolledUpDatesHash[issueId]?.earliestDueDate;
            if (dateRangeBoundary) parentDateError = $bccc623b64a0fdbc$export$b263ee37617f73e(!isStartDatePlaceholder ? startDate : undefined, !isDueDatePlaceholder ? dueDate : undefined, dateRangeBoundary.startDateBoundary, dateRangeBoundary.dueDateBoundary, latestStartDate, earliestDueDate);
            if (parentDateError !== undefined) result[issueId].push(parentDateError);
        }
        // child outside of sprint warning (check end date only as the issue may be carried over from previous sprints)
        const shouldShowChildSprintWarning = !isParentIssue && isChildIssuePlanningEnabled && sprints.length > 0;
        if (shouldShowChildSprintWarning) {
            const { endDate: maxSprintDate } = sprints[0];
            const shouldShowWarning = maxSprintDate !== undefined && dueDate !== undefined && (!placeholder || placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER)) && (0, $dO54w.isDateAfter)(dueDate, maxSprintDate);
            if (shouldShowWarning) {
                const sprintWarningMessage = (0, $l5hWP.default)[0, $1gs0D.SPRINT_ENDS_BEFORE_CHILD_MESSAGE_ID];
                result[issueId].push(sprintWarningMessage);
            }
        }
        // end date after release date warning
        if (isReleasesFeatureEnabled) {
            const [minReleaseDate, maxReleaseDate] = issueEdgeReleaseDatesVersionHash[issueId];
            const shouldShowWarning = isSprintsPlanning ? minReleaseDate !== undefined && startDate !== undefined && !placeholder && (0, $dO54w.isDateAfter)(startDate, minReleaseDate) : maxReleaseDate !== undefined && dueDate !== undefined && !placeholder && (0, $dO54w.isDateAfter)(dueDate, maxReleaseDate);
            if (shouldShowWarning) {
                const releasesWarningMessage = (0, $l5hWP.default)[0, $1gs0D.END_DATE_LATER_RELEASE_DATE_MESSAGE_ID];
                result[issueId].push(releasesWarningMessage);
            }
        }
    });
    return result;
};

});
parcelRegister("hVoYF", function(module, exports) {

$parcel$export(module.exports, "getParentLevelDates", () => $201f1d680188e4cf$export$bdde5ab43980faef);
$parcel$export(module.exports, "getBaseLevelDates", () => $201f1d680188e4cf$export$9d659d7f902f05ab);

var $fHtBB = parcelRequire("fHtBB");

var $cERyr = parcelRequire("cERyr");

var $h0EGs = parcelRequire("h0EGs");
const $201f1d680188e4cf$export$a79b06f135b87e1f = (issueStartDateHash, issueDueDateHash, parentRolledUpDatesHash, issueId)=>{
    const explicitStartDate = issueStartDateHash[issueId];
    const explicitDueDate = issueDueDateHash[issueId];
    const rolledUpDates = parentRolledUpDatesHash[issueId] || {
        inferredStartDate: undefined,
        inferredEndDate: undefined
    };
    const { startDate: startDate, dueDate: dueDate, isStartDatePlaceholder: isStartDatePlaceholder, isDueDatePlaceholder: isDueDatePlaceholder } = (0, $h0EGs.fallbackToInferredDate)({
        explicitStartDate: explicitStartDate,
        explicitDueDate: explicitDueDate
    }, rolledUpDates);
    return {
        startDate: startDate,
        dueDate: dueDate,
        isStartDateInferred: explicitStartDate === undefined && startDate !== undefined,
        isDueDateInferred: explicitDueDate === undefined && dueDate !== undefined,
        isStartDatePlaceholder: isStartDatePlaceholder,
        isDueDatePlaceholder: isDueDatePlaceholder
    };
};
const $201f1d680188e4cf$var$getChildExceedsRolledUpParent = (rolledUpDates, explicitStartDate, explicitDueDate, rollUpStartDate, rollUpDueDate)=>({
        childStartsAfterParent: explicitStartDate === undefined && explicitDueDate !== undefined && rolledUpDates.startDate !== undefined && rollUpDueDate !== undefined && rolledUpDates.startDate > rollUpDueDate && rolledUpDates.latestStartDate !== undefined && rolledUpDates.latestStartDate > explicitDueDate,
        childEndsBeforeParent: explicitStartDate !== undefined && explicitDueDate === undefined && rolledUpDates.dueDate !== undefined && rollUpStartDate !== undefined && rolledUpDates.dueDate < rollUpStartDate && rolledUpDates.earliestDueDate !== undefined && rolledUpDates.earliestDueDate < explicitStartDate
    });
const $201f1d680188e4cf$export$bdde5ab43980faef = (explicitStartDate, explicitDueDate, parentRolledUpDates, isChildIssuePlanningEnabled)=>{
    const rolledUpDates = isChildIssuePlanningEnabled && parentRolledUpDates ? parentRolledUpDates : {
        startDate: undefined,
        dueDate: undefined,
        latestStartDate: undefined,
        earliestDueDate: undefined,
        isStartDatePlaceholder: false,
        isDueDatePlaceholder: false
    };
    const { startDate: rollUpStartDate, dueDate: rollUpDueDate, isStartDatePlaceholder: isStartDatePlaceholder, isDueDatePlaceholder: isDueDatePlaceholder } = (0, $h0EGs.fallbackToInferredDate)({
        explicitStartDate: explicitStartDate,
        explicitDueDate: explicitDueDate
    }, rolledUpDates);
    const { childStartsAfterParent: childStartsAfterParent, childEndsBeforeParent: childEndsBeforeParent } = $201f1d680188e4cf$var$getChildExceedsRolledUpParent(rolledUpDates, explicitStartDate, explicitDueDate, rollUpStartDate, rollUpDueDate);
    const hasLeftPlaceholder = isChildIssuePlanningEnabled ? isStartDatePlaceholder || rollUpStartDate === undefined || childEndsBeforeParent : rollUpStartDate === undefined;
    const hasRightPlaceholder = isChildIssuePlanningEnabled ? isDueDatePlaceholder || rollUpDueDate === undefined || childStartsAfterParent : rollUpDueDate === undefined;
    return {
        startDate: rollUpStartDate,
        dueDate: rollUpDueDate,
        startDateType: explicitStartDate === undefined && rollUpStartDate !== undefined && !childStartsAfterParent ? (0, $fHtBB.ROLLUP) : (0, $fHtBB.EXPLICIT),
        dueDateType: explicitDueDate === undefined && rollUpDueDate !== undefined && !childEndsBeforeParent ? (0, $fHtBB.ROLLUP) : (0, $fHtBB.EXPLICIT),
        placeholder: (0, $cERyr.getPlaceholder)(hasLeftPlaceholder, hasRightPlaceholder),
        childExceedsRolledUpParent: childStartsAfterParent || childEndsBeforeParent
    };
};
const $201f1d680188e4cf$export$9d659d7f902f05ab = (explicitStartDate, explicitDueDate, sprints, isSprintsPlanning, isChildIssuePlanningEnabled)=>{
    if (!isSprintsPlanning) {
        const issueStartDate = isChildIssuePlanningEnabled ? explicitStartDate : undefined;
        const issueDueDate = isChildIssuePlanningEnabled ? explicitDueDate : undefined;
        return {
            startDateType: (0, $fHtBB.EXPLICIT),
            dueDateType: (0, $fHtBB.EXPLICIT),
            placeholder: (0, $cERyr.getPlaceholder)(issueStartDate === undefined, issueDueDate === undefined),
            startDate: issueStartDate,
            dueDate: issueDueDate
        };
    }
    const issueSprints = sprints || [];
    const inferredStartDate = isChildIssuePlanningEnabled ? issueSprints[0]?.startDate : undefined;
    const inferredDueDate = isChildIssuePlanningEnabled ? issueSprints[0]?.endDate : undefined;
    return {
        startDateType: (0, $fHtBB.INTERVAL),
        dueDateType: (0, $fHtBB.INTERVAL),
        placeholder: undefined,
        startDate: inferredStartDate,
        dueDate: inferredDueDate
    };
};

});
parcelRegister("cERyr", function(module, exports) {

$parcel$export(module.exports, "isStartDatePlaceholder", () => $19c0e4ccb73df2dd$export$1673e5e0e5ff398a);
$parcel$export(module.exports, "isDueDatePlaceholder", () => $19c0e4ccb73df2dd$export$bd9b44c69998322c);
$parcel$export(module.exports, "getPlaceholderWhileDragging", () => $19c0e4ccb73df2dd$export$97dae3d8f882d620);
$parcel$export(module.exports, "getPlaceholder", () => $19c0e4ccb73df2dd$export$d3f5c5e0a5023fa0);

var $4P2VV = parcelRequire("4P2VV");

var $c3IKH = parcelRequire("c3IKH");
const $19c0e4ccb73df2dd$export$1673e5e0e5ff398a = (placeholder)=>placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
const $19c0e4ccb73df2dd$export$bd9b44c69998322c = (placeholder)=>placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
const $19c0e4ccb73df2dd$export$97dae3d8f882d620 = (dragType, placeholder)=>{
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT)) return undefined;
    if (dragType === (0, $4P2VV.LEFT) && placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER)) return undefined;
    if (dragType === (0, $4P2VV.RIGHT) && placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER)) return undefined;
    if (dragType === (0, $4P2VV.RIGHT) && placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)) return 0, $c3IKH.START_DATE_PLACEHOLDER;
    if (dragType === (0, $4P2VV.LEFT) && placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)) return 0, $c3IKH.DUE_DATE_PLACEHOLDER;
    return placeholder;
};
const $19c0e4ccb73df2dd$export$d3f5c5e0a5023fa0 = (hasLeftPlaceholder, hasRightPlaceholder)=>{
    if (hasLeftPlaceholder && hasRightPlaceholder) return 0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER;
    if (hasLeftPlaceholder) return 0, $c3IKH.START_DATE_PLACEHOLDER;
    if (hasRightPlaceholder) return 0, $c3IKH.DUE_DATE_PLACEHOLDER;
    return undefined;
};

});

parcelRegister("h0EGs", function(module, exports) {

$parcel$export(module.exports, "fallbackToInferredDate", () => $788884472bce1bc5$export$43b61ec222c43ae6);
const $788884472bce1bc5$export$43b61ec222c43ae6 = (explicitDates, rolledUpDates)=>{
    const rollUpStartDate = rolledUpDates.startDate;
    const rollUpDueDate = rolledUpDates.dueDate;
    const { explicitStartDate: explicitStartDate, explicitDueDate: explicitDueDate } = explicitDates;
    const { isStartDatePlaceholder: isStartDatePlaceholder, isDueDatePlaceholder: isDueDatePlaceholder } = rolledUpDates;
    if (explicitStartDate === undefined && explicitDueDate === undefined) return {
        startDate: rollUpStartDate,
        dueDate: rollUpDueDate,
        isStartDatePlaceholder: isStartDatePlaceholder,
        isDueDatePlaceholder: isDueDatePlaceholder
    };
    if (rollUpStartDate !== undefined && rollUpDueDate !== undefined) {
        if (explicitStartDate !== undefined && explicitDueDate === undefined) return {
            startDate: explicitStartDate,
            dueDate: explicitStartDate >= rollUpDueDate ? rollUpStartDate : rollUpDueDate,
            isStartDatePlaceholder: isStartDatePlaceholder,
            isDueDatePlaceholder: isDueDatePlaceholder
        };
        if (explicitStartDate === undefined && explicitDueDate !== undefined) return {
            startDate: explicitDueDate <= rollUpStartDate ? rollUpDueDate : rollUpStartDate,
            dueDate: explicitDueDate,
            isStartDatePlaceholder: isStartDatePlaceholder,
            isDueDatePlaceholder: isDueDatePlaceholder
        };
    }
    return {
        startDate: explicitStartDate,
        dueDate: explicitDueDate,
        isStartDatePlaceholder: false,
        isDueDatePlaceholder: false
    };
};

});


parcelRegister("l5hWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f4eb61d5154edb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$59f4eb61d5154edb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    startDateLaterDueDate: {
        "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.start-date-later-due-date",
        "defaultMessage": "Start date must be before Due date."
    },
    endDateLaterReleasesDate: {
        "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.end-date-later-releases-date",
        "defaultMessage": "This issue is scheduled to end after the release to which it's been assigned."
    },
    parentStartsAfterChild: {
        "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.parent-starts-after-child",
        "defaultMessage": "This parent issue begins after the start date of a child issue."
    },
    parentEndsBeforeChild: {
        "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.parent-ends-before-child",
        "defaultMessage": "This parent issue ends before its child issues are scheduled to complete."
    },
    parentStartsAfterChildAndEndsBeforeChild: {
        "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.parent-starts-after-child-and-ends-before-child",
        "defaultMessage": "Child issues begin and end outside the dates set for this parent issue."
    },
    sprintEndsBeforeChild: {
        "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.sprint-ends-before-child",
        "defaultMessage": "This issue is scheduled to end after the sprint to which it's been assigned."
    }
});

});

parcelRegister("dO54w", function(module, exports) {

$parcel$export(module.exports, "START", () => $ed1d99f2434279ff$export$21c466265830bc3a);
$parcel$export(module.exports, "DUE", () => $ed1d99f2434279ff$export$ee74b0b7e193b0b0);
$parcel$export(module.exports, "BOTH", () => $ed1d99f2434279ff$export$1cb7e2af85daea7b);
$parcel$export(module.exports, "getErrorForDatesOutsideBoundary", () => $ed1d99f2434279ff$export$e261b272fabf99d);
$parcel$export(module.exports, "isDateAfter", () => $ed1d99f2434279ff$export$1c4ee043487b1d5e);
const $ed1d99f2434279ff$export$21c466265830bc3a = 'START';
const $ed1d99f2434279ff$export$ee74b0b7e193b0b0 = 'DUE';
const $ed1d99f2434279ff$export$1cb7e2af85daea7b = 'BOTH';
const $ed1d99f2434279ff$export$e261b272fabf99d = (startDate, dueDate, boundaryStartDate, boundaryDueDate)=>{
    // Short circuit when either both boundary dates or both explicit dates are not defined
    if (boundaryStartDate === undefined && boundaryDueDate === undefined || startDate === undefined && dueDate === undefined) return undefined;
    const validBoundaryStartDate = boundaryStartDate;
    const validBoundaryDueDate = boundaryDueDate;
    let validStartDate = startDate;
    let validDueDate = dueDate;
    if (startDate !== undefined && dueDate !== undefined && startDate > dueDate) {
        validStartDate = dueDate;
        validDueDate = startDate;
    }
    const isStartDateBeforeBoundaryStartDate = validBoundaryStartDate !== undefined && validStartDate !== undefined ? validStartDate < validBoundaryStartDate : false;
    const isDueDateLaterBoundaryDueDate = validBoundaryDueDate !== undefined && validDueDate !== undefined ? validDueDate > validBoundaryDueDate : false;
    const isStartDateLaterBoundaryDueDate = validBoundaryDueDate !== undefined && validStartDate !== undefined ? validStartDate > validBoundaryDueDate : false;
    const isDueDateBeforeBoundaryStartDate = validBoundaryStartDate !== undefined && validDueDate !== undefined ? validDueDate < validBoundaryStartDate : false;
    const isOutsideBoundaryDates = isStartDateBeforeBoundaryStartDate && isDueDateLaterBoundaryDueDate || isStartDateLaterBoundaryDueDate && isDueDateLaterBoundaryDueDate || isStartDateBeforeBoundaryStartDate && isDueDateBeforeBoundaryStartDate;
    if (isOutsideBoundaryDates) return $ed1d99f2434279ff$export$1cb7e2af85daea7b;
    if (isStartDateBeforeBoundaryStartDate) return $ed1d99f2434279ff$export$21c466265830bc3a;
    if (isDueDateLaterBoundaryDueDate) return $ed1d99f2434279ff$export$ee74b0b7e193b0b0;
    return undefined;
};
const $ed1d99f2434279ff$export$1c4ee043487b1d5e = (date, comparisonDate)=>date !== undefined && comparisonDate !== undefined ? date > comparisonDate : false;

});



parcelRegister("59mqg", function(module, exports) {

$parcel$export(module.exports, "getChartDataHash", () => $767deff2f486b94a$export$f879d822e32ece35);

var $iLBBI = parcelRequire("iLBBI");

var $5iuSS = parcelRequire("5iuSS");
const $767deff2f486b94a$export$f879d822e32ece35 = (parentIds, childIdsHash, issueStartDateHash, issueDueDateHash, issueSprintsHash, issueColorHash, issueDateErrorsHash, parentRolledUpDatesHash, issueParentIdHash, isSprintsPlanning, isChildIssuePlanningEnabled)=>{
    const chartDataHash = {};
    parentIds.forEach((parentId)=>{
        chartDataHash[parentId] = (0, $5iuSS.getParentLevelChartData)(issueColorHash, issueStartDateHash, issueDueDateHash, parentRolledUpDatesHash, issueDateErrorsHash, parentId, isChildIssuePlanningEnabled);
        const childIds = childIdsHash[parentId] || [];
        childIds.forEach((childId)=>{
            chartDataHash[childId] = (0, $iLBBI.getBaseLevelChartData)(isSprintsPlanning, isChildIssuePlanningEnabled, issueParentIdHash, issueColorHash, issueStartDateHash, issueDueDateHash, issueSprintsHash, issueDateErrorsHash, childId);
        });
    });
    return chartDataHash;
};

});
parcelRegister("iLBBI", function(module, exports) {

$parcel$export(module.exports, "getBaseLevelChartData", () => $c1b5dd54fcff83ea$export$81ce5c0846f33915);

var $opsFH = parcelRequire("opsFH");

var $kbiEp = parcelRequire("kbiEp");

var $hVoYF = parcelRequire("hVoYF");

var $crWmP = parcelRequire("crWmP");
const $c1b5dd54fcff83ea$var$getBaseLevelColor = (issueParentIdHash, issueColorHash, issueId)=>{
    const parentId = issueParentIdHash[issueId];
    if (parentId !== undefined) return issueColorHash[parentId];
    // This case should be impossible.
    return undefined;
};
const $c1b5dd54fcff83ea$export$81ce5c0846f33915 = (isSprintsPlanning, isChildIssuePlanningEnabled, issueParentIdHash, issueColorHash, issueStartDateHash, issueDueDateHash, issueSprintsHash, issueDateErrorsHash, issueId)=>{
    const explicitStartDate = issueStartDateHash[issueId];
    const explicitDueDate = issueDueDateHash[issueId];
    const sprints = issueSprintsHash[issueId];
    const { startDate: baseLevelStartDate, dueDate: baseLevelDueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder } = (0, $hVoYF.getBaseLevelDates)(explicitStartDate, explicitDueDate, sprints, isSprintsPlanning, isChildIssuePlanningEnabled);
    const color = $c1b5dd54fcff83ea$var$getBaseLevelColor(issueParentIdHash, issueColorHash, issueId) || (0, $opsFH.PURPLE);
    const { startDate: startDate, dueDate: dueDate } = (0, $crWmP.getChartDateData)(baseLevelStartDate, baseLevelDueDate, (0, $kbiEp.BASE_LEVEL), isChildIssuePlanningEnabled);
    return {
        startDate: startDate,
        dueDate: dueDate,
        startDateType: startDateType,
        dueDateType: dueDateType,
        placeholder: placeholder,
        color: color,
        warnings: isChildIssuePlanningEnabled ? issueDateErrorsHash[issueId] : [],
        level: (0, $kbiEp.BASE_LEVEL)
    };
};

});
parcelRegister("crWmP", function(module, exports) {

$parcel$export(module.exports, "getChartDateData", () => $96e502918b2160db$export$e05848039380116b);
// eslint-disable-next-line jira/restricted/moment

var $jJwwt = parcelRequire("jJwwt");

var $kbiEp = parcelRequire("kbiEp");

var $1gs0D = parcelRequire("1gs0D");
const $96e502918b2160db$export$e05848039380116b = (startDate, dueDate, level, isChildIssuePlanningEnabled)=>{
    const placeholderDays = isChildIssuePlanningEnabled && level === (0, $kbiEp.BASE_LEVEL) ? (0, $1gs0D.CHILD_PLACEHOLDER_DAYS) : (0, $1gs0D.PARENT_PLACEHOLDER_DAYS);
    // All dates are defined
    if (startDate !== undefined && dueDate !== undefined) {
        const isDateError = startDate > dueDate;
        // if the dates are flipped, flip them back!
        return {
            startDate: isDateError ? dueDate : startDate,
            dueDate: isDateError ? startDate : dueDate,
            isDateError: isDateError
        };
    }
    if (startDate !== undefined) {
        // No due date - default to showing the due date one month after the start date
        const monthAfterStart = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(startDate).add(placeholderDays, 'days').startOf('day').valueOf();
        return {
            startDate: startDate,
            dueDate: monthAfterStart
        };
    }
    if (dueDate !== undefined) {
        // No start date - default to showing the start date once month before the due date
        const monthBeforeDue = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(dueDate).subtract(placeholderDays, 'days').startOf('day').valueOf();
        return {
            startDate: monthBeforeDue,
            dueDate: dueDate
        };
    }
    // No dates - default to showing a bar that has no dates
    return {
        startDate: undefined,
        dueDate: undefined
    };
};

});


parcelRegister("5iuSS", function(module, exports) {

$parcel$export(module.exports, "getParentLevelChartData", () => $fe17b97681d55123$export$93810e1de67e20a1);

var $kbiEp = parcelRequire("kbiEp");

var $hVoYF = parcelRequire("hVoYF");

var $crWmP = parcelRequire("crWmP");
const $fe17b97681d55123$export$93810e1de67e20a1 = (issueColorHash, issueStartDateHash, issueDueDateHash, parentRolledUpDatesHash, issueDateErrorsHash, issueId, isChildIssuePlanningEnabled)=>{
    const explicitStartDate = issueStartDateHash[issueId];
    const explicitDueDate = issueDueDateHash[issueId];
    const { startDate: parentLevelStartDate, dueDate: parentLevelDueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder } = (0, $hVoYF.getParentLevelDates)(explicitStartDate, explicitDueDate, parentRolledUpDatesHash[issueId], isChildIssuePlanningEnabled);
    const color = issueColorHash[issueId];
    const { startDate: startDate, dueDate: dueDate } = (0, $crWmP.getChartDateData)(parentLevelStartDate, parentLevelDueDate, (0, $kbiEp.PARENT_LEVEL), isChildIssuePlanningEnabled);
    return {
        startDateType: startDateType,
        dueDateType: dueDateType,
        placeholder: placeholder,
        color: color,
        startDate: startDate,
        dueDate: dueDate,
        warnings: issueDateErrorsHash[issueId],
        level: (0, $kbiEp.PARENT_LEVEL)
    };
};

});


parcelRegister("hG3ro", function(module, exports) {

$parcel$export(module.exports, "getFilteredCreateCountPure", () => $718f914fad68adfc$export$300d851f748781ef);
$parcel$export(module.exports, "getItemTypesByLevelPure", () => $718f914fad68adfc$export$3f53768088038f28);
$parcel$export(module.exports, "getSecondaryFieldsHashPure", () => $718f914fad68adfc$export$73fd4330bbde09e8);

var $fUTZC = parcelRequire("fUTZC");

var $bKxX9 = parcelRequire("bKxX9");


var $kbiEp = parcelRequire("kbiEp");

var $5iA56 = parcelRequire("5iA56");
const $718f914fad68adfc$export$300d851f748781ef = ({ assignees: assignees, labels: labels, versions: versions, components: components })=>{
    const assigneesWithoutUnassigned = assignees.filter((assignee)=>assignee !== (0, $44677eb502cfd308$export$12e572fd459c10dc));
    // Any effective filter contributes at most once towards the count
    const filteredCreateCount = Math.min(assigneesWithoutUnassigned.length, 1) + Math.min(labels.length, 1) + Math.min(versions.length, 1) + Math.min(components.length, 1);
    return filteredCreateCount;
};
const $718f914fad68adfc$export$3f53768088038f28 = (issueTypeHash, epicIssueTypeIds, creationPreferences, defaultItemTypeId)=>{
    const itemTypes = {
        [(0, $kbiEp.BASE_LEVEL)]: [],
        [(0, $kbiEp.PARENT_LEVEL)]: []
    };
    // Construct a lookup of item types per level
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(issueTypeHash, (issueType, issueTypeId)=>{
        const level = epicIssueTypeIds.includes(issueTypeId) ? 1 : 0;
        itemTypes[level].push({
            id: issueTypeId,
            iconUrl: issueType.iconUrl,
            name: issueType.name
        });
    });
    // Sort the item types by alphabetical ascending, with the preferred item type to the top
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(itemTypes, (itemTypeForLevel, level)=>{
        itemTypeForLevel.sort((itemType1, itemType2)=>{
            const creationPreferenceForLevel = creationPreferences.itemTypes[Number(level)];
            const itemTypeName1 = itemType1.name.toUpperCase();
            const itemTypeName2 = itemType2.name.toUpperCase();
            // Check by creation preference
            if (creationPreferenceForLevel) {
                if (creationPreferenceForLevel.itemTypeId === itemType1.id) return -1;
                if (creationPreferenceForLevel.itemTypeId === itemType2.id) return 1;
            }
            // if no preference, then check by default item type
            if (defaultItemTypeId) {
                if (defaultItemTypeId === itemType1.id) return -1;
                if (defaultItemTypeId === itemType2.id) return 1;
            }
            // If no preference and default item type, then check by name
            if (itemTypeName1 < itemTypeName2) return -1;
            if (itemTypeName1 > itemTypeName2) return 1;
            return 0;
        });
    });
    return itemTypes;
};
const $718f914fad68adfc$export$73fd4330bbde09e8 = (issueIds, parentIdHash, issueStatusHash, issueAssigneeIdHash, userAvatarUrlHash, userDisplayNameHash, doneStatusCategoryId, issueFlaggedHash)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueSecondaryFieldHash = {};
    issueIds.forEach((id)=>{
        // Raw fields associated with the issue
        const issueStatus = issueStatusHash[id];
        const issueAssigneeId = issueAssigneeIdHash[id];
        const flagged = issueFlaggedHash[id];
        // Fields as to be displayed. Different for parent and child issues.
        let status;
        let assignee;
        let mapItem;
        if (issueStatus) {
            const { name: name, statusCategoryId: statusCategoryId } = issueStatus;
            const appearance = (0, $5iA56.STATUS_CATEGORY_APPEARENCE)[statusCategoryId];
            status = {
                name: name,
                appearance: appearance
            };
        }
        if (issueAssigneeId) {
            const name = userDisplayNameHash[issueAssigneeId];
            const avatarUrl = userAvatarUrlHash[issueAssigneeId];
            assignee = {
                name: name,
                avatarUrl: avatarUrl
            };
        }
        if (parentIdHash[id]) mapItem = {
            status: status,
            assignee: assignee
        };
        else if (issueStatus?.statusCategoryId === doneStatusCategoryId) mapItem = {
            status: status
        };
        issueSecondaryFieldHash[`${id}`] = {
            ...mapItem,
            flagged: (0, $bKxX9.ff)('jsw.timeline.return-flagged-attribute-fe') && !!flagged
        };
    });
    return issueSecondaryFieldHash;
};

});


parcelRegister("2CrgW", function(module, exports) {

$parcel$export(module.exports, "escapeValue", () => $e1543bf3c5125fac$export$ea39ee3092b88584);
$parcel$export(module.exports, "getColumnTransformers", () => $e1543bf3c5125fac$export$8275ddb83241f041);
// eslint-disable-next-line jira/restricted/moment

var $jJwwt = parcelRequire("jJwwt");

var $bKxX9 = parcelRequire("bKxX9");

var $tgbCK = parcelRequire("tgbCK");

var $c3IKH = parcelRequire("c3IKH");
const $e1543bf3c5125fac$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
const $e1543bf3c5125fac$export$ea39ee3092b88584 = (value)=>{
    if (value === undefined) return '""';
    if (value.includes('"')) return `"${value.replace(/"/g, '""')}"`;
    return `"${value}"`;
};
const $e1543bf3c5125fac$export$3ae94a2503e890a1 = (date)=>$e1543bf3c5125fac$export$ea39ee3092b88584(date !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).format($e1543bf3c5125fac$export$98de7bb6e1f5105c) : '');
const $e1543bf3c5125fac$export$8275ddb83241f041 = ({ startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, isSprintsFeatureEnabled: isSprintsFeatureEnabled })=>[
        {
            fieldId: 'issuekey',
            transform: ({ issue: issue })=>$e1543bf3c5125fac$export$ea39ee3092b88584(issue.key)
        },
        {
            fieldId: 'issuetype',
            transform: ({ issue: issue }, { issueTypesHash: issueTypesHash })=>$e1543bf3c5125fac$export$ea39ee3092b88584(issueTypesHash[issue.issueTypeId]?.name)
        },
        {
            fieldId: 'parent',
            transform: ({ issue: issue }, { issuesHash: issuesHash })=>$e1543bf3c5125fac$export$ea39ee3092b88584(issue.parentId.value ? issuesHash[issue.parentId.value]?.key : undefined)
        },
        {
            fieldId: 'summary',
            transform: ({ issue: issue })=>$e1543bf3c5125fac$export$ea39ee3092b88584(issue.summary.value)
        },
        ...(0, $bKxX9.ff)('jsw.timeline.return-flagged-attribute-fe') ? [
            {
                fieldId: 'flagged',
                transform: ({ issue: issue })=>$e1543bf3c5125fac$export$ea39ee3092b88584(issue.flagged.toString().toLowerCase())
            }
        ] : [],
        {
            fieldId: 'status',
            transform: ({ issue: issue })=>$e1543bf3c5125fac$export$ea39ee3092b88584(issue?.status?.name)
        },
        {
            fieldId: 'assignee',
            transform: ({ issue: issue }, { userDisplayNameHash: userDisplayNameHash })=>$e1543bf3c5125fac$export$ea39ee3092b88584(issue.assignee ? userDisplayNameHash[issue.assignee] : undefined)
        },
        ...isSprintsFeatureEnabled ? [
            {
                fieldId: sprintCustomFieldId,
                transform: ({ issueId: issueId }, { issueSprintsHash: issueSprintsHash })=>$e1543bf3c5125fac$export$ea39ee3092b88584(issueSprintsHash[issueId]?.at(0)?.name)
            }
        ] : [],
        {
            fieldId: startDateCustomFieldId,
            transform: ({ issue: issue })=>$e1543bf3c5125fac$export$3ae94a2503e890a1(issue.startDate.value)
        },
        {
            fieldId: 'inferredStartDate',
            transform: ({ chartData: chartData })=>$e1543bf3c5125fac$export$3ae94a2503e890a1(chartData?.startDate && chartData.placeholder !== (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, $c3IKH.START_DATE_PLACEHOLDER) ? chartData.startDate : undefined)
        },
        {
            fieldId: 'duedate',
            transform: ({ issue: issue })=>$e1543bf3c5125fac$export$3ae94a2503e890a1(issue.dueDate.value)
        },
        {
            fieldId: 'inferredDueDate',
            transform: ({ chartData: chartData })=>$e1543bf3c5125fac$export$3ae94a2503e890a1(chartData?.dueDate && chartData.placeholder !== (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, $c3IKH.DUE_DATE_PLACEHOLDER) ? chartData.dueDate : undefined)
        },
        {
            fieldId: colorCustomFieldId,
            transform: ({ issue: issue })=>$e1543bf3c5125fac$export$ea39ee3092b88584((0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[issue.color.value])
        }
    ];

});


parcelRegister("Dr1ld", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c88e629445d6a16$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("jyKN9");
parcelRequire("jAXdN");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $eC0P8 = parcelRequire("eC0P8");

var $85pXK = parcelRequire("85pXK");

var $cDvag = parcelRequire("cDvag");

var $lgKTA = parcelRequire("lgKTA");

var $j45xj = parcelRequire("j45xj");

var $cerFH = parcelRequire("cerFH");

var $9BmXV = parcelRequire("9BmXV");

var $6489W = parcelRequire("6489W");

var $gdFA6 = parcelRequire("gdFA6");
// Irrelevant issues are those that were created but do match the roadmaps issue source
const $4c88e629445d6a16$var$getIrrelevantIssueKeys = (globalIssues, roadmapIssues)=>{
    const irrelevantIssueKeys = [];
    globalIssues.forEach((globalIssue)=>{
        if (roadmapIssues[globalIssue.issueId] === undefined) irrelevantIssueKeys.push(globalIssue.issueKey);
    });
    return irrelevantIssueKeys;
};
var /* From the issues created in global create when on the roadmap:
 * 1. Check whether they are relevant to the roadmap (ie board filter, project)
 * 2. For all issues that are relevant, add them to the roadmap
 * 3. For all issues that are not relevant, do not add them to the roadmap, and notify the user
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$4c88e629445d6a16$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.GLOBAL_ISSUE_CREATE)).mergeMap((action)=>{
        const globalIssues = action.payload;
        const globalIssueIds = globalIssues.map((issue)=>issue.issueId);
        const quickFilterIds = (0, $6489W.getQuickFilters)(store.getState());
        const customFilterIds = (0, $6489W.getCustomFilters)(store.getState());
        if ((0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)()) return (0, $85pXK.getItems)((0, $lgKTA.getSourceARI)(store.getState()), globalIssueIds).map((roadmapIssuesAndUsers)=>{
            const { issues: roadmapIssues, users: roadmapUsers } = roadmapIssuesAndUsers;
            const irrelevantKeys = $4c88e629445d6a16$var$getIrrelevantIssueKeys(globalIssues, roadmapIssues.hash);
            const createActions = [];
            if (Object.keys(roadmapUsers).length > 0) createActions.push((0, $cerFH.addUsers)(roadmapUsers));
            if (roadmapIssues.sequence.length > 0) createActions.push((0, $j45xj.extendIssues)(roadmapIssues, (0, $j45xj.GLOBAL_ISSUE_CREATE)));
            if (irrelevantKeys.length > 0) createActions.push((0, $9BmXV.irrelevantIssuesCreated)({
                issueKeys: irrelevantKeys
            }));
            return (0, $MYW4e.batchActions)(createActions);
        });
        return (0, $3JafE.Observable).zip((0, $85pXK.getItems)((0, $lgKTA.getSourceARI)(store.getState()), globalIssueIds), quickFilterIds.length > 0 || customFilterIds.length > 0 ? (0, $eC0P8.filterItemsByJQLFilters)((0, $lgKTA.getSourceARI)(store.getState()), quickFilterIds, customFilterIds) : (0, $3JafE.Observable).of(null), (roadmapIssuesAndUsers, filterIssueIds)=>{
            const { issues: roadmapIssues, users: roadmapUsers } = roadmapIssuesAndUsers;
            const irrelevantKeys = $4c88e629445d6a16$var$getIrrelevantIssueKeys(globalIssues, roadmapIssues.hash);
            const createActions = [];
            if (filterIssueIds) {
                const issuesHiddenByQuickFilter = roadmapIssues.sequence.filter((roadmapIssueId)=>!filterIssueIds.includes(roadmapIssueId));
                createActions.push((0, $gdFA6.jqlFiltersSuccess)(filterIssueIds));
                if (issuesHiddenByQuickFilter.length > 0) createActions.push((0, $9BmXV.issueHidden)({
                    ids: issuesHiddenByQuickFilter
                }));
            }
            if (Object.keys(roadmapUsers).length > 0) createActions.push((0, $cerFH.addUsers)(roadmapUsers));
            if (roadmapIssues.sequence.length > 0) createActions.push((0, $j45xj.extendIssues)(roadmapIssues, (0, $j45xj.CREATE_ISSUE)));
            if (irrelevantKeys.length > 0) createActions.push((0, $9BmXV.irrelevantIssuesCreated)({
                issueKeys: irrelevantKeys
            }));
            return (0, $MYW4e.batchActions)(createActions);
        });
    });

});
parcelRegister("85pXK", function(module, exports) {

$parcel$export(module.exports, "getItems", () => $68b57d9f7b4b4e8b$export$d2f92acf417bbf5d);
parcelRequire("flmol");
parcelRequire("cpH8E");

var $iuGQK = parcelRequire("iuGQK");

var $lsWOB = parcelRequire("lsWOB");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");

var $hmc1Z = parcelRequire("hmc1Z");
const $68b57d9f7b4b4e8b$var$analyticKey = 'jira.frontend.fe.software.roadmap.get-items-by-ids';
const $68b57d9f7b4b4e8b$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$51617034fb6f2e3a];
const $68b57d9f7b4b4e8b$export$d2f92acf417bbf5d = (sourceAri, issueIds)=>(0, $8sMwH.runQueryWithMetadata)((0, $iuGQK.default), (0, $lsWOB.generateGetItemsByIdsQueryVariables)(sourceAri, issueIds), $68b57d9f7b4b4e8b$var$analyticKey, $68b57d9f7b4b4e8b$var$concurrentMetricDefinition).map(({ data: data })=>(0, $hmc1Z.transformIssuesFromGetItemsByIdsQueryResponse)(data));

});
parcelRegister("iuGQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67282ff1cedaab4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4bbe94915c9a58784e4d72bfe5e79419>>
 * @relayHash dce5379cadea1d78150457c03377ca0b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90c1860875ba5b16004b821f7b613eaa617bf47cc6b4cdff8568a42a6c8d5729
const $d67282ff1cedaab4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRoadmapsCriticalDataItemFlaggedEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "ids"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v8 = {
        "kind": "ScalarField",
        "name": "startDateRFC3339"
    }, v9 = {
        "kind": "ScalarField",
        "name": "dueDateRFC3339"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "dependencies"
    }, v12 = {
        "kind": "ScalarField",
        "name": "itemTypeId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v16 = {
        "kind": "ScalarField",
        "name": "rank"
    }, v17 = {
        "kind": "ScalarField",
        "name": "labels"
    }, v18 = {
        "kind": "ScalarField",
        "name": "sprintIds"
    }, v19 = {
        "kind": "ScalarField",
        "name": "versionIds"
    }, v20 = {
        "kind": "ScalarField",
        "name": "componentIds"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v22 = {
        "kind": "ScalarField",
        "name": "flagged"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getItemsByIdsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "RoadmapItem",
                            "kind": "LinkedField",
                            "name": "roadmapItemByIds",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v4 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.id"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v5 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.key"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "RequiredField",
                                    "field": v7 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.summary"
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "kind": "RequiredField",
                                    "field": v10 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.color"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v11 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.dependencies"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v12 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.itemTypeId"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "assignee",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v13 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapItemByIds.assignee.accountId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v14 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapItemByIds.assignee.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v15 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapItemByIds.assignee.picture"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "RoadmapItemStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapItemByIds.status.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v14 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapItemByIds.status.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "RoadmapItemStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v4 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapItemByIds.status.statusCategory.id"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapItemByIds.status.statusCategory"
                                        }
                                    ]
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v16 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.rank"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v17 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.labels"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v18 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.sprintIds"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v19 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.versionIds"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v20 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.componentIds"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v21 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapItemByIds.resolved"
                                },
                                {
                                    "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v22 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "roadmaps.roadmapItemByIds.flagged"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getItemsByIdsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "RoadmapItem",
                            "kind": "LinkedField",
                            "name": "roadmapItemByIds",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "assignee",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "RoadmapItemStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "RoadmapItemStatusCategory",
                                            "kind": "LinkedField",
                                            "name": "statusCategory",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                {
                                    "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "90c1860875ba5b16004b821f7b613eaa617bf47cc6b4cdff8568a42a6c8d5729",
            "metadata": {},
            "name": "getItemsByIdsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d67282ff1cedaab4$var$node.hash = "591daa91640ce28204a62d6e310a6911";
var $d67282ff1cedaab4$export$2e2bcd8739ae039 = $d67282ff1cedaab4$var$node;

});

parcelRegister("lsWOB", function(module, exports) {

$parcel$export(module.exports, "generateGetItemsByIdsQueryVariables", () => $f20dde936d339d8d$export$b1321c96886bcd30);

var $bKxX9 = parcelRequire("bKxX9");
const $f20dde936d339d8d$export$b1321c96886bcd30 = (sourceAri, ids)=>({
        sourceAri: sourceAri,
        ids: ids,
        isRoadmapsCriticalDataItemFlaggedEnabled: (0, $bKxX9.ff)('jsw.timeline.return-flagged-attribute-fe')
    });

});



parcelRegister("5hBC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f21278196b2c281$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("3X5NT");
parcelRequire("g2Yef");
parcelRequire("kn0sk");

var $ecAMT = parcelRequire("ecAMT");

var $j45xj = parcelRequire("j45xj");

var $6489W = parcelRequire("6489W");

var $9E22T = parcelRequire("9E22T");

var $bSfRQ = parcelRequire("bSfRQ");

var $fmIwx = parcelRequire("fmIwx");

var $eSvYH = parcelRequire("eSvYH");

var $lu0Fq = parcelRequire("lu0Fq");

var $72BLE = parcelRequire("72BLE");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$6f21278196b2c281$export$2e2bcd8739ae039 = (action$, store)=>{
    // Wait until the critical data has loaded.
    const afterCriticalDataLoad$ = action$.skipUntil(action$.ofType((0, $ecAMT.INITIALIZE_NON_CRITICAL_DATA)));
    // Create an observable which emits changes to the filtered issue IDs.
    const selectorResult$ = (0, $bSfRQ.observeSelector)(afterCriticalDataLoad$, store, (0, $9E22T.getFilteredIssueIds));
    // Create an observable of the before and after values of each change, and attach the action that caused it.
    const resultChangeWithAction$ = selectorResult$.pairwise().withLatestFrom(action$, (change, action)=>({
            change: change,
            action: action
        }));
    // Process the observable such that any batch actions are split up, with the underlying actions
    // grouped by their type.
    const groupedAction$ = (0, $72BLE.groupBatchedActionsObservable)(resultChangeWithAction$);
    return groupedAction$.filter(({ action: action })=>[
            (0, $j45xj.EXTEND_ISSUES),
            (0, $j45xj.REPLACE_ISSUE),
            (0, $j45xj.CLEAR_TRANSITION_STATE)
        ].includes(action.type)).mergeMap(({ change: change, action: action })=>{
        const state = store.getState();
        const { type: type, payload: payload } = action;
        const [before, after] = change;
        const quickFilterIds = (0, $6489W.getQuickFilters)(state);
        const customFilterIds = (0, $6489W.getCustomFilters)(state);
        const isJQLFilterApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
        // Assume all actions in a group come from the first caller.
        const caller = payload[0]?.meta?.caller;
        if (type === (0, $j45xj.REPLACE_ISSUE) && caller === (0, $j45xj.CREATE_ISSUE)) return (0, $fmIwx.handleHiddenIssueCreated)(store, before, after, payload);
        if (type === (0, $j45xj.EXTEND_ISSUES) && caller === (0, $j45xj.GLOBAL_ISSUE_CREATE)) return (0, $fmIwx.handleHiddenGlobalIssueCreated)(store, before, after, payload);
        if (type === (0, $j45xj.EXTEND_ISSUES) && caller === (0, $j45xj.UPDATE_ISSUE)) return (0, $lu0Fq.handleHiddenIssueUpdated)(action$, store, before, after, payload, isJQLFilterApplied);
        if (type === (0, $j45xj.EXTEND_ISSUES) && caller === (0, $j45xj.SCHEDULE_ISSUES)) return (0, $eSvYH.handleHiddenIssueRescheduled)(action$, store, before, after, payload, isJQLFilterApplied);
        return (0, $3JafE.Observable).empty();
    });
};

});
parcelRegister("kn0sk", function(module, exports) {
"use strict";

var $3JafE = parcelRequire("3JafE");

var $k25oO = parcelRequire("k25oO");
$3JafE.Observable.prototype.skipUntil = $k25oO.skipUntil;

});
parcelRegister("k25oO", function(module, exports) {

$parcel$export(module.exports, "skipUntil", () => $e9582eba8869d757$export$facc584867c26fde, (v) => $e9582eba8869d757$export$facc584867c26fde = v);
var $e9582eba8869d757$export$facc584867c26fde;
"use strict";

var $dMiA4 = parcelRequire("dMiA4");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $e9582eba8869d757$var$skipUntil(notifier) {
    return $dMiA4.skipUntil(notifier)(this);
}
$e9582eba8869d757$export$facc584867c26fde = $e9582eba8869d757$var$skipUntil;

});
parcelRegister("dMiA4", function(module, exports) {
"use strict";
var $a07e2bd4db1f8075$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $a07e2bd4db1f8075$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $a07e2bd4db1f8075$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $a07e2bd4db1f8075$var$skipUntil;
var $a07e2bd4db1f8075$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a07e2bd4db1f8075$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a07e2bd4db1f8075$var$SkipUntilSubscriber = function(_super) {
    $a07e2bd4db1f8075$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($87MtM.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($6UnJS.OuterSubscriber);

});



parcelRegister("bSfRQ", function(module, exports) {

$parcel$export(module.exports, "observeSelector", () => $a9efc6f5ba79f917$export$ccc0552649affc7d);
const $a9efc6f5ba79f917$export$ccc0552649affc7d = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store, // eslint-disable-next-line @typescript-eslint/no-explicit-any
selector)=>{
    let recomputations = selector.recomputations();
    return action$.filter(()=>selector.recomputations() !== recomputations).map(()=>{
        const state = store.getState();
        recomputations = selector.recomputations();
        return selector(state);
    });
};

});

parcelRegister("fmIwx", function(module, exports) {

$parcel$export(module.exports, "handleHiddenIssueCreated", () => $b42b18cd5a6cce94$export$d095245b0238bf2);
$parcel$export(module.exports, "handleHiddenGlobalIssueCreated", () => $b42b18cd5a6cce94$export$21f4857e44d73821);

var $iVIEg = parcelRequire("iVIEg");

var $1urNG = parcelRequire("1urNG");

var $7GXrf = parcelRequire("7GXrf");

var $3JafE = parcelRequire("3JafE");

var $9BmXV = parcelRequire("9BmXV");
const $b42b18cd5a6cce94$var$getHiddenCreatedIssueIds = (before, after, created, removed)=>{
    const expected = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))((0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(before, created), ...removed);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(expected, after);
};
const $b42b18cd5a6cce94$export$d095245b0238bf2 = (store, before, after, actions)=>{
    const created = actions.map((action)=>action.payload.id);
    const removed = actions.map((action)=>action.payload.temporaryId);
    const hidden = $b42b18cd5a6cce94$var$getHiddenCreatedIssueIds(before, after, created, removed);
    return hidden.length > 0 ? (0, $3JafE.Observable).of((0, $9BmXV.issueHidden)({
        ids: hidden
    })) : (0, $3JafE.Observable).empty();
};
const $b42b18cd5a6cce94$export$21f4857e44d73821 = (store, before, after, actions)=>{
    const created = actions.flatMap((action)=>Object.keys(action.payload.hash));
    const hidden = $b42b18cd5a6cce94$var$getHiddenCreatedIssueIds(before, after, created, []);
    return hidden.length > 0 ? (0, $3JafE.Observable).of((0, $9BmXV.issueHidden)({
        ids: hidden
    })) : (0, $3JafE.Observable).empty();
};

});
parcelRegister("7GXrf", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $599a8fe1eb632ef8$var$without = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, values) : [];
});
module.exports = $599a8fe1eb632ef8$var$without;

});


parcelRegister("eSvYH", function(module, exports) {

$parcel$export(module.exports, "handleHiddenIssueRescheduled", () => $008bc1a2d79e8503$export$3511d3b1489d5cf4);

var $iVIEg = parcelRequire("iVIEg");

var $fcWBJ = parcelRequire("fcWBJ");

var $kG4jb = parcelRequire("kG4jb");

var $3JafE = parcelRequire("3JafE");
parcelRequire("kO85v");

var $6FeJk = parcelRequire("6FeJk");

var $9BmXV = parcelRequire("9BmXV");

var $9E22T = parcelRequire("9E22T");

var $11LHz = parcelRequire("11LHz");

var $dkw7K = parcelRequire("dkw7K");
const $008bc1a2d79e8503$var$getHiddenScheduledIssueIds = (before, after, scheduled)=>{
    const hidden = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(before, after);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(hidden, scheduled);
};
const $008bc1a2d79e8503$var$getAlreadyHiddenScheduledIssueIds = (after, scheduled)=>(0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(scheduled, after);
const $008bc1a2d79e8503$var$getCollapsedScheduledIssueIds = (store, scheduled)=>{
    const state = store.getState();
    const issueParentIdHash = (0, $6FeJk.getIssueParentIdHash)(state);
    const issueIdsByParentIds = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(scheduled, (id)=>issueParentIdHash[id]);
    const issueParentIds = Object.keys(issueIdsByParentIds);
    const scheduledIssueParentIds = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(scheduled, issueParentIds);
    const expandedItems = (0, $11LHz.getExpandedItems)(state);
    const collapsedScheduledIssueParentIds = scheduledIssueParentIds.filter((id)=>!(expandedItems[id] ?? false));
    return collapsedScheduledIssueParentIds.flatMap((id)=>issueIdsByParentIds[id]);
};
const $008bc1a2d79e8503$export$3511d3b1489d5cf4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store, before, after, actions, isJQLFilterApplied)=>{
    const scheduled = actions.flatMap((action)=>Object.keys(action.payload.hash));
    const clientHiddenScheduled = $008bc1a2d79e8503$var$getHiddenScheduledIssueIds(before, after, scheduled);
    if (clientHiddenScheduled.length > 0) return (0, $3JafE.Observable).of((0, $9BmXV.issueDisappearsFromDisplayRange)({
        issueId: clientHiddenScheduled[0]
    }));
    const clientAlreadyHiddenScheduled = $008bc1a2d79e8503$var$getAlreadyHiddenScheduledIssueIds(after, scheduled);
    if (clientAlreadyHiddenScheduled.length > 0) return (0, $3JafE.Observable).of((0, $9BmXV.issueHidden)({
        ids: clientAlreadyHiddenScheduled
    }));
    const collapsedScheduledIssueIds = $008bc1a2d79e8503$var$getCollapsedScheduledIssueIds(store, scheduled);
    if (collapsedScheduledIssueIds.length > 0) return (0, $3JafE.Observable).of((0, $9BmXV.issueHidden)({
        ids: collapsedScheduledIssueIds
    }));
    const asyncCheck = ()=>{
        const state = store.getState();
        const final = (0, $9E22T.getFilteredIssueIds)(state);
        const serverHiddenScheduled = $008bc1a2d79e8503$var$getHiddenScheduledIssueIds(before, final, scheduled);
        if (serverHiddenScheduled.length > 0) return (0, $3JafE.Observable).of((0, $9BmXV.issueHidden)({
            ids: serverHiddenScheduled
        }));
        return (0, $3JafE.Observable).empty();
    };
    if (isJQLFilterApplied) return (0, $3JafE.Observable).concat((0, $dkw7K.awaitReapplyJQLFilters)(action$), (0, $3JafE.Observable).defer(asyncCheck));
    return (0, $3JafE.Observable).empty();
};

});
parcelRegister("dkw7K", function(module, exports) {

$parcel$export(module.exports, "awaitReapplyJQLFilters", () => $d00191206f901409$export$36ac0dbca5255db1);

var $3JafE = parcelRequire("3JafE");
parcelRequire("2rE4V");
parcelRequire("fiQ2m");

var $gdFA6 = parcelRequire("gdFA6");
const $d00191206f901409$export$36ac0dbca5255db1 = (action$)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $3JafE.Observable).concat(action$.ofType((0, $gdFA6.JQL_FILTERS_REAPPLY)).first().ignoreElements(), action$.ofType((0, $gdFA6.JQL_FILTERS_SUCCESS)).first().ignoreElements());

});


parcelRegister("lu0Fq", function(module, exports) {

$parcel$export(module.exports, "handleHiddenIssueUpdated", () => $b1fa95d606ef0f38$export$b98d9ae8804c9ef8);

var $iVIEg = parcelRequire("iVIEg");

var $kG4jb = parcelRequire("kG4jb");

var $3JafE = parcelRequire("3JafE");
parcelRequire("kO85v");
parcelRequire("2rE4V");

var $9BmXV = parcelRequire("9BmXV");

var $9E22T = parcelRequire("9E22T");

var $dkw7K = parcelRequire("dkw7K");
const $b1fa95d606ef0f38$var$getHiddenUpdatedIssueIds = (before, after, updated)=>{
    const hidden = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(before, after);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(hidden, updated);
};
const $b1fa95d606ef0f38$export$b98d9ae8804c9ef8 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store, before, after, actions, isJQLFilterApplied)=>{
    const updated = actions.flatMap((action)=>Object.keys(action.payload.hash));
    const clientHiddenUpdated = $b1fa95d606ef0f38$var$getHiddenUpdatedIssueIds(before, after, updated);
    if (clientHiddenUpdated.length > 0) return (0, $3JafE.Observable).of((0, $9BmXV.issueDisappearsFromDisplayRange)({
        issueId: clientHiddenUpdated[0]
    }));
    const asyncCheck = ()=>{
        const state = store.getState();
        const final = (0, $9E22T.getFilteredIssueIds)(state);
        const serverHiddenUpdated = $b1fa95d606ef0f38$var$getHiddenUpdatedIssueIds(before, final, updated);
        if (serverHiddenUpdated.length > 0) return (0, $3JafE.Observable).of((0, $9BmXV.issueHidden)({
            ids: serverHiddenUpdated
        }));
        return (0, $3JafE.Observable).empty();
    };
    if (isJQLFilterApplied) return (0, $3JafE.Observable).concat((0, $dkw7K.awaitReapplyJQLFilters)(action$), (0, $3JafE.Observable).defer(asyncCheck));
    return (0, $3JafE.Observable).empty();
};

});

parcelRegister("72BLE", function(module, exports) {

$parcel$export(module.exports, "groupBatchedActionsObservable", () => $62f61472df68889e$export$66441a0e10ffb390);

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");
parcelRequire("fiQ2m");
const $62f61472df68889e$export$a40b51388efb1169 = (action)=>action.type === (0, $MYW4e.BATCH);
const $62f61472df68889e$var$group = (values, extractKey)=>values.reduce((acc, curr)=>{
        const key = extractKey(curr);
        if (acc[key] === undefined) acc[key] = [];
        acc[key].push(curr);
        return acc;
    }, {});
const $62f61472df68889e$var$batchActionToGroupedActions = (action)=>{
    const actions = $62f61472df68889e$export$a40b51388efb1169(action) ? action.payload : [
        action
    ];
    const groupedActions = $62f61472df68889e$var$group(actions, ({ type: type })=>type);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.entries(groupedActions).map(([key, value])=>({
            type: key,
            payload: value,
            grouped: true
        }));
};
const $62f61472df68889e$export$66441a0e10ffb390 = (action$)=>action$.mergeMap(({ change: change, action: action })=>(0, $3JafE.Observable).from($62f61472df68889e$var$batchActionToGroupedActions(action).map((groupedAction)=>({
                change: change,
                action: groupedAction
            }))));

});


parcelRegister("6h5Tl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7240d5a4b1022f9$export$2e2bcd8739ae039);
parcelRequire("YLEHo");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");

var $MYW4e = parcelRequire("MYW4e");

var $kG4jb = parcelRequire("kG4jb");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $fE3Ua = parcelRequire("fE3Ua");

var $lO4Or = parcelRequire("lO4Or");

var $kbiEp = parcelRequire("kbiEp");

var $3PMIz = parcelRequire("3PMIz");

var $eC0P8 = parcelRequire("eC0P8");

var $cDvag = parcelRequire("cDvag");

var $l12G5 = parcelRequire("l12G5");

var $5iA56 = parcelRequire("5iA56");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $4bpn3 = parcelRequire("4bpn3");

var $11pvk = parcelRequire("11pvk");

var $3YMoa = parcelRequire("3YMoa");

var $9BmXV = parcelRequire("9BmXV");

var $6489W = parcelRequire("6489W");

var $2ukAT = parcelRequire("2ukAT");

var $gdFA6 = parcelRequire("gdFA6");

var $2f9uM = parcelRequire("2f9uM");

var $enHA1 = parcelRequire("enHA1");
const $c7240d5a4b1022f9$var$getRoadmapIssueFieldName = (state, fieldId)=>{
    const colorFieldId = (0, $bwVWW.getColorCustomFieldId)(state);
    const startDateCustomFieldId = (0, $bwVWW.getStartDateCustomFieldId)(state);
    const epicLinkCustomFieldId = (0, $bwVWW.getEpicLinkCustomFieldId)(state);
    const sprintCustomFieldId = (0, $bwVWW.getSprintCustomFieldId)(state);
    return (0, $l12G5.mapIssueViewFieldToRoadmapField)(fieldId, startDateCustomFieldId, colorFieldId, epicLinkCustomFieldId, sprintCustomFieldId);
};
const $c7240d5a4b1022f9$var$updateIssueSequenceOptimistically = (store, issueIds, isRankAfter, rankId)=>{
    const oldSequence = (0, $6FeJk.getIssueIds)(store.getState());
    const issueIdsExisted = issueIds.filter((id)=>(0, $6FeJk.isIssueExists)(store.getState(), id));
    if (issueIdsExisted.length > 0) {
        const newSequence = oldSequence.filter((id)=>!issueIdsExisted.includes(id));
        const rank = rankId.toString();
        const getInsertIndex = ()=>{
            if (!isRankAfter) return newSequence.indexOf(rank);
            return rank ? newSequence.indexOf(rank) + 1 : 0;
        };
        newSequence.splice(getInsertIndex(), 0, ...issueIdsExisted);
        return (0, $3JafE.Observable).of((0, $j45xj.updateIssuesSequence)((0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(newSequence, oldSequence)));
    }
    return (0, $3JafE.Observable).empty();
};
/**
 * Checks fields that might not be able to be updated optimistically. An example of
 * such a field is assignee as it might not be part of critical data.
 * Status isn't updated optimistically to fetch if the issue is resolved from the backend
 */ const $c7240d5a4b1022f9$var$canUpdateIssueOptimistically = (state, fieldName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
newValue)=>!((fieldName === (0, $3PMIz.ASSIGNEE) || fieldName === (0, $3PMIz.STATUS)) && newValue !== null && (0, $3YMoa.getUser)(state, newValue.accountId) === undefined);
/**
 * Checks if a field should be removed from the Roadmap. This function contains a
 * list of known field changes that can result in the issue being removed from the roadmap.
 *
 */ const $c7240d5a4b1022f9$var$shouldRemoveIssueFromRoadmap = (state, fieldName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
newValue)=>fieldName === (0, $3PMIz.PARENT_ID) && (newValue === null || !(0, $6FeJk.isIssueExists)(state, newValue.id));
const $c7240d5a4b1022f9$var$updateIssueOptimistically = (state, issueId, fieldName, issue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
newValue)=>fieldName ? (0, $3JafE.Observable).of((0, $j45xj.extendIssues)({
        sequence: [],
        hash: {
            [issueId]: {
                ...issue,
                [fieldName]: (0, $l12G5.convertIssueViewFieldValue)(fieldName, newValue)
            }
        }
    })) : (0, $3JafE.Observable).empty();
const $c7240d5a4b1022f9$var$updateIssueField = (store, fieldId, issueId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
newValue)=>{
    const state = store.getState();
    const fieldName = $c7240d5a4b1022f9$var$getRoadmapIssueFieldName(state, fieldId);
    const issue = (0, $6FeJk.getIssue)(state, issueId);
    // check, that the field is supported and updated values are primitives
    if (fieldName !== undefined && issue) {
        if (fieldName === (0, $3PMIz.PARENT_ID) && (0, $6FeJk.getIssueLevel)(state, issueId) === (0, $kbiEp.PARENT_LEVEL)) // do nothing when epic's parent was changed
        // we have selectors that assume issue is epic if it doesn't have parent, and we need to maintain that state
        return (0, $3JafE.Observable).empty();
        let issueAction;
        if ($c7240d5a4b1022f9$var$shouldRemoveIssueFromRoadmap(state, fieldName, newValue)) issueAction = (0, $3JafE.Observable).of((0, $j45xj.removeIssue)(issueId));
        else if ($c7240d5a4b1022f9$var$canUpdateIssueOptimistically(state, fieldName, newValue)) issueAction = $c7240d5a4b1022f9$var$updateIssueOptimistically(state, issueId, fieldName, issue, newValue);
        else issueAction = (0, $2f9uM.reloadIssues)(store, [
            issueId
        ]);
        const setUpdatedFilter = (0, $enHA1.createSetUpdatedFilter)(state, issueId, newValue, fieldName);
        const setUpdatedConfiguration = (0, $enHA1.createSetUpdatedConfiguration)(state, newValue, fieldName);
        return (0, $3JafE.Observable).merge(issueAction, setUpdatedFilter ? (0, $3JafE.Observable).of(setUpdatedFilter) : (0, $3JafE.Observable).empty(), setUpdatedConfiguration ? (0, $3JafE.Observable).of(setUpdatedConfiguration) : (0, $3JafE.Observable).empty());
    }
    return (0, $3JafE.Observable).empty();
};
const $c7240d5a4b1022f9$var$addChildIssue = (store, childIssue, quickFilterIds, customFilterIds)=>(0, $eC0P8.filterItemsByJQLFilters)((0, $lgKTA.getSourceARI)(store.getState()), quickFilterIds, customFilterIds).map((filterIssueIds)=>{
        const createActions = [];
        const childIssueId = childIssue.id;
        const isHiddenByQuickFilter = !filterIssueIds.includes(childIssueId);
        createActions.push((0, $gdFA6.jqlFiltersSuccess)(filterIssueIds));
        if (isHiddenByQuickFilter) createActions.push((0, $9BmXV.issueHidden)({
            ids: [
                childIssueId
            ]
        }));
        return (0, $MYW4e.batchActions)(createActions);
    });
const $c7240d5a4b1022f9$var$updateSubtaskParent = (store, issueId, newParentId)=>{
    const state = store.getState();
    const oldParentId = (0, $2ukAT.getSubtaskParentHash)(state)[issueId];
    if (oldParentId) {
        if ((0, $11pvk.getFullSubtasksHash)(state)[newParentId]) return (0, $3JafE.Observable).of((0, $4bpn3.changeSubtaskParent)({
            id: issueId,
            oldParentId: oldParentId,
            newParentId: newParentId
        }));
        // remove subtask if new parent does not exist in the hash
        return (0, $3JafE.Observable).of((0, $4bpn3.removeSubtasks)([
            {
                id: issueId,
                parentId: oldParentId
            }
        ]));
    }
    return (0, $3JafE.Observable).empty();
};
const $c7240d5a4b1022f9$var$isIssueSubtask = (state, issueId)=>Boolean((0, $2ukAT.getSubtaskParentHash)(state)[issueId]);
const $c7240d5a4b1022f9$var$isIssueSubtaskParent = (state, issueId)=>Boolean((0, $11pvk.getFullSubtasksHash)(state)[issueId]);
const $c7240d5a4b1022f9$var$addJQLFiltersRequest = (store, quickFilterIds, customFilterIds)=>(0, $eC0P8.filterItemsByJQLFilters)((0, $lgKTA.getSourceARI)(store.getState()), quickFilterIds, customFilterIds).map((filterIssueIds)=>(0, $gdFA6.jqlFiltersSuccess)(filterIssueIds));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$c7240d5a4b1022f9$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.RELOAD_ISSUE)).mergeMap((action)=>{
        const event = action.payload;
        const state = store.getState();
        const { issueId: issueId } = event;
        const quickFilterIds = (0, $6489W.getQuickFilters)(state);
        const customFilterIds = (0, $6489W.getCustomFilters)(state);
        const isJQLFiltersApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
        const isStateChangeBasedIssueHiddenFlagsEnabledValue = (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)();
        if (!(0, $6FeJk.isIssueExists)(state, issueId)) return (0, $3JafE.Observable).empty();
        switch(event.type){
            case (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED:
                {
                    const { meta: { childIssue: childIssue } } = event;
                    if ($c7240d5a4b1022f9$var$isIssueSubtaskParent(state, issueId)) return (0, $3JafE.Observable).of((0, $4bpn3.addSubtask)({
                        id: issueId,
                        subtask: {
                            id: childIssue.id,
                            key: childIssue.issueKey || '',
                            statusCategoryId: `${(0, $5iA56.TODO_STATUS_CATEGORY_ID)}`
                        }
                    }));
                    if (isJQLFiltersApplied) try {
                        return $c7240d5a4b1022f9$var$addChildIssue(store, childIssue, quickFilterIds, customFilterIds);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $gUUjF.default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', "Failed to handle optimistic update 'CHILD_ISSUE_ADDED' from the issue view", error);
                    }
                    break;
                }
            case (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED:
                {
                    const { meta: { fieldId: fieldId, fieldValue: fieldValue } } = event;
                    if ((0, $l12G5.isFieldUpdateWithoutRequestEvent)(fieldId)) {
                        if (fieldId === (0, $3PMIz.STATUS) && $c7240d5a4b1022f9$var$isIssueSubtask(state, issueId)) {
                            const { statusCategory: { id: statusCategoryId } } = fieldValue;
                            return (0, $3JafE.Observable).of((0, $4bpn3.updateSubtaskStatus)({
                                id: issueId,
                                parentId: (0, $2ukAT.getSubtaskParentHash)(state)[issueId],
                                statusCategoryId: statusCategoryId
                            }));
                        }
                        try {
                            if (!isStateChangeBasedIssueHiddenFlagsEnabledValue && isJQLFiltersApplied) return (0, $3JafE.Observable).merge($c7240d5a4b1022f9$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), $c7240d5a4b1022f9$var$updateIssueField(store, fieldId, issueId, fieldValue));
                            return $c7240d5a4b1022f9$var$updateIssueField(store, fieldId, issueId, fieldValue);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        } catch (error) {
                            (0, $gUUjF.default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', `Failed to handle optimistic update 'FIELD_CHANGED' from the issue view for field "${fieldId}"`, error);
                        }
                    }
                    break;
                }
            case (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_REQUESTED:
                {
                    const { meta: { fieldId: fieldId, fieldValue: fieldValue } } = event;
                    try {
                        // check for isFieldUpdateWithoutRequestEvent otherwise it will be called twice from ChangeEventTypes.FIELD_CHANGED
                        if (!isStateChangeBasedIssueHiddenFlagsEnabledValue && isJQLFiltersApplied) {
                            if (!(0, $l12G5.isFieldUpdateWithoutRequestEvent)(event.meta.fieldId)) return (0, $3JafE.Observable).merge($c7240d5a4b1022f9$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), $c7240d5a4b1022f9$var$updateIssueField(store, fieldId, issueId, fieldValue));
                            break;
                        }
                        return $c7240d5a4b1022f9$var$updateIssueField(store, fieldId, issueId, fieldValue);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $gUUjF.default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', `Failed to handle optimistic update 'FIELD_CHANGE_REQUESTED' from the issue view for field "${fieldId}"`, error);
                    }
                    break;
                }
            case (0, $fE3Ua.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED:
                {
                    const { meta: { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter } } = event;
                    try {
                        return $c7240d5a4b1022f9$var$updateIssueSequenceOptimistically(store, issueIds, isRankAfter, rankId);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $gUUjF.default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', `Failed to handle optimistic rank update from the issue view for child issue "${issueIds.join(',')}"`, error);
                    }
                    break;
                }
            case (0, $fE3Ua.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED:
                {
                    const { meta: { newParentIssueId: newParentIssueId } } = event;
                    if ($c7240d5a4b1022f9$var$isIssueSubtask(state, issueId) && newParentIssueId !== null) return $c7240d5a4b1022f9$var$updateSubtaskParent(store, issueId, newParentIssueId);
                    try {
                        if (!isStateChangeBasedIssueHiddenFlagsEnabledValue && isJQLFiltersApplied) return (0, $3JafE.Observable).merge($c7240d5a4b1022f9$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), $c7240d5a4b1022f9$var$updateIssueField(store, (0, $lO4Or.PARENT_TYPE), issueId, {
                            id: newParentIssueId
                        }));
                        return $c7240d5a4b1022f9$var$updateIssueField(store, (0, $lO4Or.PARENT_TYPE), issueId, {
                            id: newParentIssueId
                        });
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $gUUjF.default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', `Failed to handle optimistic update 'ISSUE_RELATIONSHIP_UPDATED' from the issue view for field ${(0, $lO4Or.PARENT_TYPE)}`, error);
                    }
                    break;
                }
            case (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_FAILED:
                {
                    // try to reload failed issue
                    const { meta: { fieldId: fieldId } } = event;
                    if ($c7240d5a4b1022f9$var$getRoadmapIssueFieldName(store.getState(), fieldId) === undefined) break;
                    if (!isStateChangeBasedIssueHiddenFlagsEnabledValue && isJQLFiltersApplied) return (0, $3JafE.Observable).merge($c7240d5a4b1022f9$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), (0, $2f9uM.reloadIssues)(store, [
                        issueId
                    ]));
                    return (0, $2f9uM.reloadIssues)(store, [
                        issueId
                    ]);
                }
            case (0, $fE3Ua.ChangeEventTypes).ISSUE_TYPE_CHANGED:
                {
                    const { fieldId: fieldId, meta: { typeName: typeName } } = event;
                    const setUpdatedFilter = (0, $enHA1.createSetUpdatedFilter)(state, issueId, typeName, fieldId);
                    if (setUpdatedFilter) {
                        if (!isStateChangeBasedIssueHiddenFlagsEnabledValue && isJQLFiltersApplied) return (0, $3JafE.Observable).merge($c7240d5a4b1022f9$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), (0, $3JafE.Observable).of(setUpdatedFilter));
                        return (0, $3JafE.Observable).of(setUpdatedFilter);
                    }
                    if (!isStateChangeBasedIssueHiddenFlagsEnabledValue && isJQLFiltersApplied) return $c7240d5a4b1022f9$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds);
                    break;
                }
            default:
                break;
        }
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("l12G5", function(module, exports) {

$parcel$export(module.exports, "isFieldUpdateWithoutRequestEvent", () => $ff63765d61861b44$export$8db3339834f8a8f5);
$parcel$export(module.exports, "mapIssueViewFieldToRoadmapField", () => $ff63765d61861b44$export$9d6d2e8f94e22e8f);
$parcel$export(module.exports, "convertIssueViewFieldValue", () => $ff63765d61861b44$export$962c330cdbeb1d25);
$parcel$export(module.exports, "convertIssueViewFieldValueToConfiguration", () => $ff63765d61861b44$export$25cd05ae94678477);

var $lzTt0 = parcelRequire("lzTt0");

var $jJwwt = parcelRequire("jJwwt");

var $tgbCK = parcelRequire("tgbCK");

var $lPQPn = parcelRequire("lPQPn");

var $lO4Or = parcelRequire("lO4Or");


var $3PMIz = parcelRequire("3PMIz");
const $ff63765d61861b44$export$8db3339834f8a8f5 = (fieldId)=>// NOTE: Since "assign to me" won't trigger 'FIELD_CHANGE_REQUESTED', we have to handle all assignee cases here
{
    const fields = [
        (0, $3PMIz.ASSIGNEE),
        (0, $3PMIz.STATUS),
        (0, $3PMIz.SUMMARY)
    ];
    return fieldId !== undefined && fields.includes(fieldId);
};
const $ff63765d61861b44$export$9d6d2e8f94e22e8f = (fieldId, startDateCustomFieldId, colorFieldId, epicLinkCustomField, sprintCustomFieldId)=>{
    if (!fieldId) return undefined;
    if (colorFieldId === fieldId) return 0, $3PMIz.COLOR;
    switch(fieldId){
        case 0, $lO4Or.SUMMARY_TYPE:
            return 0, $3PMIz.SUMMARY;
        case 0, $lO4Or.DUE_DATE_TYPE:
            return 0, $3PMIz.DUE_DATE;
        case startDateCustomFieldId:
            return 0, $3PMIz.START_DATE;
        case 0, $lO4Or.STATUS_TYPE:
            return 0, $3PMIz.STATUS;
        case 0, $lO4Or.ASSIGNEE_TYPE:
            return 0, $3PMIz.ASSIGNEE;
        case 0, $lO4Or.PARENT_TYPE:
        case epicLinkCustomField:
            return 0, $3PMIz.PARENT_ID;
        case 0, $lO4Or.LABELS_TYPE:
            return 0, $3PMIz.LABELS;
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
            return 0, $3PMIz.VERSION_IDS;
        case 0, $lO4Or.COMPONENTS_TYPE:
            return 0, $3PMIz.COMPONENT_IDS;
        case sprintCustomFieldId:
            return 0, $3PMIz.SPRINT_IDS;
        case 0, $lO4Or.ISSUE_TYPE:
            return 0, $3PMIz.ISSUE_TYPE;
        default:
            return undefined;
    }
};
const $ff63765d61861b44$var$convertDateFieldValue = (fieldName, value)=>{
    if (value === null || value === '') return undefined;
    if (typeof value !== 'string' && !(0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(value)) throw new Error(`Returned field value for field "${fieldName}" is not primitive: "${typeof value}"`);
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(value, (0, $4975412c8fcbfa24$export$e63e1e1c17a0e8b));
    if (date.isValid()) return date.valueOf();
    throw new Error(`Invalid date "${value}" was returned for field "${fieldName}"`);
};
const $ff63765d61861b44$var$convertColorFieldValue = (fieldName, value)=>{
    if (value in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) return (0, $lPQPn.toFrontendColor)(value);
    if (value in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) return (0, $lPQPn.classicToFrontendColor)(value);
    throw new Error(`Invalid color value "${value}" for "${fieldName}" field`);
};
const $ff63765d61861b44$var$convertSummaryFieldValue = (value)=>{
    if (value === null) throw new Error('Invalid summary value "null", should be string instead');
    if (typeof value !== 'string' && !(0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(value)) throw new Error(`Returned field value for field "summary" is not primitive: "${typeof value}"`);
    return value;
};
const $ff63765d61861b44$var$convertStatusFieldValue = (value)=>{
    if (value === null || !value.id || value.name === null || !value.statusCategory) throw new Error('Invalid status value "null", should be valid status value instead');
    return {
        id: value.id,
        name: value.name,
        statusCategoryId: value.statusCategory.id.toString()
    };
};
const $ff63765d61861b44$var$convertAssigneeFieldValue = (value)=>{
    if (value === null || value.accountId === null) return undefined;
    return value.accountId;
};
const $ff63765d61861b44$var$convertLabelsFieldValue = (value)=>{
    if (value === null) return undefined;
    return value;
};
const $ff63765d61861b44$var$convertVersionsFieldValue = (value)=>{
    if (value === null) return undefined;
    return value.map((version)=>version.id.toString());
};
const $ff63765d61861b44$var$convertComponentsFieldValue = (value)=>{
    if (value === null) return undefined;
    return value.map((component)=>component.id.toString());
};
const $ff63765d61861b44$var$convertComponentsFieldValueToConfiguration = (value)=>{
    if (value === null) return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return value.reduce((acc, curr)=>{
        const id = curr.id.toString();
        const { name: name } = curr;
        acc[`${id}`] = {
            id: id,
            name: name
        };
        return acc;
    }, {});
};
const $ff63765d61861b44$var$convertParentIdFieldValue = (value)=>{
    if (value === null || value.id === null) return undefined;
    return value.id;
};
const $ff63765d61861b44$var$convertSprintFieldValue = (value)=>{
    if (value === null) return undefined;
    return value.map((sprint)=>sprint.id.toString());
};
const $ff63765d61861b44$var$convertIssueTypeFieldValue = (value)=>value;
const $ff63765d61861b44$export$962c330cdbeb1d25 = (fieldName, value)=>{
    switch(fieldName){
        case 0, $3PMIz.COLOR:
            return {
                value: $ff63765d61861b44$var$convertColorFieldValue(fieldName, value)
            };
        case 0, $3PMIz.START_DATE:
        case 0, $3PMIz.DUE_DATE:
            return {
                value: $ff63765d61861b44$var$convertDateFieldValue(fieldName, value)
            };
        case 0, $3PMIz.SUMMARY:
            return {
                value: $ff63765d61861b44$var$convertSummaryFieldValue(value)
            };
        case 0, $3PMIz.STATUS:
            return $ff63765d61861b44$var$convertStatusFieldValue(value);
        case 0, $3PMIz.ASSIGNEE:
            return $ff63765d61861b44$var$convertAssigneeFieldValue(value);
        case 0, $3PMIz.LABELS:
            return $ff63765d61861b44$var$convertLabelsFieldValue(value);
        case 0, $3PMIz.PARENT_ID:
            return {
                value: $ff63765d61861b44$var$convertParentIdFieldValue(value)
            };
        case 0, $3PMIz.SPRINT_IDS:
            return {
                value: $ff63765d61861b44$var$convertSprintFieldValue(value)
            };
        case 0, $3PMIz.VERSION_IDS:
            return $ff63765d61861b44$var$convertVersionsFieldValue(value);
        case 0, $3PMIz.COMPONENT_IDS:
            return $ff63765d61861b44$var$convertComponentsFieldValue(value);
        case 0, $3PMIz.ISSUE_TYPE:
            return $ff63765d61861b44$var$convertIssueTypeFieldValue(value);
        default:
            throw new Error(`Unknow field name: "${fieldName}"`);
    }
};
const $ff63765d61861b44$export$25cd05ae94678477 = (fieldName, value)=>{
    switch(fieldName){
        case 0, $3PMIz.COMPONENT_IDS:
            return $ff63765d61861b44$var$convertComponentsFieldValueToConfiguration(value);
        default:
            throw new Error(`Unknow field name: "${fieldName}"`);
    }
};

});
parcelRegister("lzTt0", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $fb57e46e5749abd1$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $fb57e46e5749abd1$var$isNumber(value) {
    return typeof value == 'number' || $hYEMs(value) && $2OY5s(value) == $fb57e46e5749abd1$var$numberTag;
}
module.exports = $fb57e46e5749abd1$var$isNumber;

});

parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});



parcelRegister("2f9uM", function(module, exports) {

$parcel$export(module.exports, "tryGetIssueFromIssuesAndUsers", () => $b9f3d20cfa938bc8$export$b690423e2c8b5b34);
$parcel$export(module.exports, "issueTypesReloadRequired", () => $b9f3d20cfa938bc8$export$31e7869d01af42fd);
$parcel$export(module.exports, "criticalDataReload", () => $b9f3d20cfa938bc8$export$3b1fd433cebec571);
$parcel$export(module.exports, "reloadIssues", () => $b9f3d20cfa938bc8$export$ac45f1f94fef700c);
parcelRequire("iects");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("flmol");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $3FyZ4 = parcelRequire("3FyZ4");

var $6KDJ5 = parcelRequire("6KDJ5");

var $85pXK = parcelRequire("85pXK");

var $ecAMT = parcelRequire("ecAMT");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $91mgt = parcelRequire("91mgt");
const $b9f3d20cfa938bc8$export$b690423e2c8b5b34 = (issuesAndUsers, issueId)=>issuesAndUsers.issues.hash[issueId];
const $b9f3d20cfa938bc8$export$31e7869d01af42fd = (issuesAndUsers, currentIssueTypes)=>Object.entries(issuesAndUsers.issues.hash).some(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, issue])=>currentIssueTypes[issue.issueTypeId] === undefined);
const $b9f3d20cfa938bc8$export$3b1fd433cebec571 = (store)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'relay operation',
            attributes: {
                key: 'jira.frontend.fe.software.roadmap.critical-data.reload',
                reason: 'issue-types'
            },
            source: 'relayOperation'
        });
    });
    /**
	 * quickFilter request is not required in this getCriticalDataObservable, because it has already been handled independently in the upper layer
	 * i.e. reload-with-sequence and optimistic-updates. The reason is because not all updates require both quickFilter and critical-data reload.
	 */ return (0, $6KDJ5.getCriticalDataObservable)((0, $lgKTA.getSourceARI)(store.getState()), undefined, undefined).map((criticalData)=>(0, $MYW4e.batchActions)([
            (0, $ecAMT.updateCriticalData)(criticalData)
        ]));
};
const $b9f3d20cfa938bc8$export$ac45f1f94fef700c = (store, issueIds)=>{
    if (issueIds.length === 0) return (0, $3JafE.Observable).empty();
    return (0, $85pXK.getItems)((0, $lgKTA.getSourceARI)(store.getState()), issueIds).flatMap((issues)=>{
        const issueTypes = (0, $bwVWW.getFullIssueTypeHash)(store.getState());
        if ($b9f3d20cfa938bc8$export$31e7869d01af42fd(issues, issueTypes)) return $b9f3d20cfa938bc8$export$3b1fd433cebec571(store);
        const issueIdsForRemoval = issueIds.filter((issueId)=>!$b9f3d20cfa938bc8$export$b690423e2c8b5b34(issues, issueId));
        const hasDefinedIssues = issueIds.length !== issueIdsForRemoval.length;
        return hasDefinedIssues ? (0, $3JafE.Observable).of((0, $91mgt.updateIssuesAndUsers)(store, issues, issueIdsForRemoval)) : (0, $3JafE.Observable).of((0, $j45xj.removeIssues)(issueIdsForRemoval));
    });
};

});
parcelRegister("91mgt", function(module, exports) {

$parcel$export(module.exports, "updateIssuesAndUsers", () => $b6cdf661a0a4c9ea$export$ae9eb5a0ed39309b);
$parcel$export(module.exports, "createTransitionIssueWithUpdatedItems", () => $b6cdf661a0a4c9ea$export$69c12c168f550414);

var $MYW4e = parcelRequire("MYW4e");

var $iVIEg = parcelRequire("iVIEg");

var $fUTZC = parcelRequire("fUTZC");

var $kFGm5 = parcelRequire("kFGm5");

var $gKA5o = parcelRequire("gKA5o");

var $3PMIz = parcelRequire("3PMIz");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $cerFH = parcelRequire("cerFH");
const $b6cdf661a0a4c9ea$var$isInvalid = (issue, issueTypes)=>issueTypes[issue.issueTypeId] === undefined;
const $b6cdf661a0a4c9ea$export$ae9eb5a0ed39309b = (store, issues, invalidIssueIds = [])=>{
    const issueTypeHash = (0, $bwVWW.getFullIssueTypeHash)(store.getState());
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(issues.issues.hash, (issue, issueId)=>{
        if ($b6cdf661a0a4c9ea$var$isInvalid(issue, issueTypeHash)) invalidIssueIds.push(issueId);
    });
    const validIssues = {
        sequence: (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(issues.issues.sequence, invalidIssueIds),
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(issues.issues.hash, invalidIssueIds)
    };
    const actions = [
        (0, $cerFH.addUsers)(issues.users)
    ];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gKA5o)))(validIssues.hash) > 0) actions.push((0, $j45xj.extendIssues)(validIssues));
    if (invalidIssueIds.length > 0) actions.push((0, $j45xj.removeIssues)(invalidIssueIds));
    return (0, $MYW4e.batchActions)(actions);
};
const $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff = (oldProp, newProp, transitionId)=>{
    if ('old' in oldProp) return {
        value: newProp,
        old: oldProp.old,
        transitionId: transitionId
    };
    return {
        value: newProp,
        old: oldProp.value,
        transitionId: transitionId
    };
};
const $b6cdf661a0a4c9ea$export$69c12c168f550414 = (issue, updateProps, transitionId)=>{
    const transitionIssue = {
        ...issue
    };
    const updatedItems = [];
    // NOTE: `in` and `hasOwnProperty` syntax check won't remove the optional marker from IssueFieldModification type
    if (updateProps.summary !== undefined) {
        updatedItems.push({
            name: 'summary'
        });
        transitionIssue.summary = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.summary, updateProps.summary, transitionId);
    }
    if ('startDate' in updateProps) {
        updatedItems.push({
            name: 'startDate'
        });
        transitionIssue.startDate = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.startDate, updateProps.startDate, transitionId);
    }
    if ('dueDate' in updateProps) {
        updatedItems.push({
            name: 'dueDate'
        });
        transitionIssue.dueDate = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.dueDate, updateProps.dueDate, transitionId);
    }
    // NOTE: `in` and `hasOwnProperty` syntax check won't remove the optional marker from IssueFieldModification type
    if (updateProps.sprintId !== undefined) {
        updatedItems.push({
            name: 'sprintId'
        });
        transitionIssue.sprintIds = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.sprintIds, [
            updateProps.sprintId
        ], transitionId);
    }
    if ('clearFields' in updateProps && updateProps.clearFields && updateProps.clearFields.length > 0) {
        if (updateProps.clearFields.indexOf((0, $3PMIz.START_DATE)) > -1) {
            updatedItems.push({
                name: 'startDate'
            });
            transitionIssue.startDate = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.startDate, undefined, transitionId);
        }
        if (updateProps.clearFields.indexOf((0, $3PMIz.DUE_DATE)) > -1) {
            updatedItems.push({
                name: 'dueDate'
            });
            transitionIssue.dueDate = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.dueDate, undefined, transitionId);
        }
        if (updateProps.clearFields.indexOf((0, $3PMIz.SPRINT_IDS)) > -1) {
            updatedItems.push({
                name: 'sprintId'
            });
            transitionIssue.sprintIds = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.sprintIds, [], transitionId);
        }
    }
    if ('color' in updateProps) {
        updatedItems.push({
            name: 'color'
        });
        transitionIssue.color = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.color, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        updateProps.color, transitionId);
    }
    if ('parentId' in updateProps) {
        updatedItems.push({
            name: 'parentId'
        });
        transitionIssue.parentId = $b6cdf661a0a4c9ea$export$d33eced2e1ca66ff(issue.parentId, updateProps.parentId, transitionId);
    }
    return [
        transitionIssue,
        updatedItems
    ];
};

});
parcelRegister("gKA5o", function(module, exports) {

var $fCpZe = parcelRequire("fCpZe");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $eQiJU = parcelRequire("eQiJU");
/** `Object#toString` result references. */ var $c31cef206f882b8b$var$mapTag = '[object Map]', $c31cef206f882b8b$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $c31cef206f882b8b$var$size(collection) {
    if (collection == null) return 0;
    if ($jxg5X(collection)) return $4ZYEI(collection) ? $eQiJU(collection) : collection.length;
    var tag = $fjnSB(collection);
    if (tag == $c31cef206f882b8b$var$mapTag || tag == $c31cef206f882b8b$var$setTag) return collection.size;
    return $fCpZe(collection).length;
}
module.exports = $c31cef206f882b8b$var$size;

});
parcelRegister("eQiJU", function(module, exports) {

var $3K42x = parcelRequire("3K42x");

var $fFFC0 = parcelRequire("fFFC0");

var $CYLq5 = parcelRequire("CYLq5");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $ace4754dece6a484$var$stringSize(string) {
    return $fFFC0(string) ? $CYLq5(string) : $3K42x(string);
}
module.exports = $ace4754dece6a484$var$stringSize;

});
parcelRegister("3K42x", function(module, exports) {

var $pRnxj = parcelRequire("pRnxj");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $2b98cd398295eed4$var$asciiSize = $pRnxj('length');
module.exports = $2b98cd398295eed4$var$asciiSize;

});

parcelRegister("CYLq5", function(module, exports) {
/** Used to compose unicode character classes. */ var $0752af280e68c649$var$rsAstralRange = '\\ud800-\\udfff', $0752af280e68c649$var$rsComboMarksRange = '\\u0300-\\u036f', $0752af280e68c649$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0752af280e68c649$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0752af280e68c649$var$rsComboRange = $0752af280e68c649$var$rsComboMarksRange + $0752af280e68c649$var$reComboHalfMarksRange + $0752af280e68c649$var$rsComboSymbolsRange, $0752af280e68c649$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0752af280e68c649$var$rsAstral = '[' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsCombo = '[' + $0752af280e68c649$var$rsComboRange + ']', $0752af280e68c649$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0752af280e68c649$var$rsModifier = '(?:' + $0752af280e68c649$var$rsCombo + '|' + $0752af280e68c649$var$rsFitz + ')', $0752af280e68c649$var$rsNonAstral = '[^' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0752af280e68c649$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0752af280e68c649$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0752af280e68c649$var$reOptMod = $0752af280e68c649$var$rsModifier + '?', $0752af280e68c649$var$rsOptVar = '[' + $0752af280e68c649$var$rsVarRange + ']?', $0752af280e68c649$var$rsOptJoin = '(?:' + $0752af280e68c649$var$rsZWJ + '(?:' + [
    $0752af280e68c649$var$rsNonAstral,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair
].join('|') + ')' + $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + ')*', $0752af280e68c649$var$rsSeq = $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + $0752af280e68c649$var$rsOptJoin, $0752af280e68c649$var$rsSymbol = '(?:' + [
    $0752af280e68c649$var$rsNonAstral + $0752af280e68c649$var$rsCombo + '?',
    $0752af280e68c649$var$rsCombo,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair,
    $0752af280e68c649$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0752af280e68c649$var$reUnicode = RegExp($0752af280e68c649$var$rsFitz + '(?=' + $0752af280e68c649$var$rsFitz + ')|' + $0752af280e68c649$var$rsSymbol + $0752af280e68c649$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $0752af280e68c649$var$unicodeSize(string) {
    var result = $0752af280e68c649$var$reUnicode.lastIndex = 0;
    while($0752af280e68c649$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $0752af280e68c649$var$unicodeSize;

});





parcelRegister("enHA1", function(module, exports) {

$parcel$export(module.exports, "createSetUpdatedFilter", () => $c1dec3b90022e4c4$export$21444d00749e7c62);
$parcel$export(module.exports, "createSetUpdatedConfiguration", () => $c1dec3b90022e4c4$export$f0f24bd9eeb55cf7);

var $6ZDS2 = parcelRequire("6ZDS2");

var $kG4jb = parcelRequire("kG4jb");

var $MdoH4 = parcelRequire("MdoH4");


var $3PMIz = parcelRequire("3PMIz");

var $l12G5 = parcelRequire("l12G5");

var $lgKTA = parcelRequire("lgKTA");

var $xbB8r = parcelRequire("xbB8r");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $9ZLrP = parcelRequire("9ZLrP");

var $gdFA6 = parcelRequire("gdFA6");
const $c1dec3b90022e4c4$var$getValidFilter = (filteredOptions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
issueOptions, fieldValue, issueId, fieldName)=>{
    const issueOptionsHash = {
        ...issueOptions
    };
    issueOptionsHash[issueId] = (0, $l12G5.convertIssueViewFieldValue)(fieldName, fieldValue);
    const validOptions = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))((0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(Object.keys(issueOptionsHash).map((key)=>issueOptionsHash[key])));
    const intersectingOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(filteredOptions, validOptions);
    // check whether the filter and router filter doesn't match
    if (intersectingOptions.length !== filteredOptions.length) return intersectingOptions;
    return undefined;
};
const $c1dec3b90022e4c4$export$21444d00749e7c62 = (state, issueId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldValue, fieldName)=>{
    if (fieldName === (0, $3PMIz.LABELS)) {
        const filteredLabels = (0, $9ZLrP.getFilteredLabels)(state);
        const issueLabels = (0, $6FeJk.getIssueLabelsHash)(state);
        const newValue = fieldValue;
        const validFilter = $c1dec3b90022e4c4$var$getValidFilter(filteredLabels, issueLabels, newValue, issueId, fieldName);
        if (validFilter) return (0, $gdFA6.setLabelFilter)(validFilter);
    }
    if (fieldName === (0, $3PMIz.VERSION_IDS)) {
        const filteredVersions = (0, $9ZLrP.getFilteredVersions)(state);
        const issueVersions = (0, $6FeJk.getIssueVersionIdsHash)(state);
        const newValue = fieldValue;
        const validFilter = $c1dec3b90022e4c4$var$getValidFilter(filteredVersions, issueVersions, newValue, issueId, fieldName);
        if (validFilter) return (0, $gdFA6.setVersionFilter)(validFilter);
    }
    if (fieldName === (0, $3PMIz.COMPONENT_IDS)) {
        const filteredComponents = (0, $9ZLrP.getFilteredComponents)(state);
        const issueComponents = (0, $6FeJk.getIssueComponentIdsHash)(state);
        const newValue = fieldValue;
        const validFilter = $c1dec3b90022e4c4$var$getValidFilter(filteredComponents, issueComponents, newValue, issueId, fieldName);
        if (validFilter) return (0, $gdFA6.setComponentFilter)(validFilter);
    }
    if (fieldName === (0, $3PMIz.ASSIGNEE)) {
        const filteredAssignees = (0, $9ZLrP.getFilteredAssignees)(state);
        const issueAssignees = (0, $6FeJk.getIssueAssigneeHash)(state);
        const newValue = fieldValue;
        const loggedInAccountId = (0, $lgKTA.getLoggedInAccountId)(state);
        // logged in user is never removed from the assignee dropdown
        const issueAssigneeWithLoggedInUser = {
            ...issueAssignees,
            '-1': loggedInAccountId
        };
        const validFilter = $c1dec3b90022e4c4$var$getValidFilter(filteredAssignees.filter((filteredOption)=>filteredOption !== (0, $44677eb502cfd308$export$12e572fd459c10dc)), issueAssigneeWithLoggedInUser, newValue, issueId, fieldName);
        const unassignedFilter = filteredAssignees.includes((0, $44677eb502cfd308$export$12e572fd459c10dc)) ? [
            (0, $44677eb502cfd308$export$12e572fd459c10dc)
        ] : [];
        if (validFilter && !(filteredAssignees.length === 1 && unassignedFilter.length)) return (0, $gdFA6.setAssigneeFilter)([
            ...validFilter,
            ...unassignedFilter
        ]);
    }
    if (fieldName === (0, $3PMIz.ISSUE_TYPE)) {
        const filteredIssueTypes = (0, $9ZLrP.getFilteredIssueTypes)(state);
        const issueIssueTypes = (0, $6FeJk.getIssueTypeIdHash)(state);
        const issueTypes = (0, $bwVWW.getFullIssueTypeHash)(state);
        let issueTypeId;
        Object.keys(issueTypes).forEach((id)=>{
            if (issueTypes[id].name === fieldValue) issueTypeId = id;
        });
        if (issueTypeId) {
            const validFilter = $c1dec3b90022e4c4$var$getValidFilter(filteredIssueTypes, issueIssueTypes, issueTypeId, issueId, fieldName);
            if (validFilter) return (0, $gdFA6.setIssueTypeFilter)(validFilter);
        }
    }
    return undefined;
};
const $c1dec3b90022e4c4$export$f0f24bd9eeb55cf7 = (state, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldValue, fieldName)=>{
    if (fieldName === (0, $3PMIz.COMPONENT_IDS)) {
        const projectId = (0, $bwVWW.getProjectId)(state);
        const existingComponents = (0, $bwVWW.getFullComponentHash)(state);
        const issueComponents = (0, $l12G5.convertIssueViewFieldValueToConfiguration)(fieldName, fieldValue);
        if (issueComponents === undefined) return undefined;
        const hasNewComponents = Object.keys(issueComponents).some((key)=>!(key in existingComponents));
        if (hasNewComponents) {
            const components = Object.assign(existingComponents, issueComponents);
            return (0, $xbB8r.setComponents)({
                projectId: projectId,
                components: components
            });
        }
    }
    return undefined;
};

});


parcelRegister("68rOS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfeeafe48fb5f35f$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("8jBvP");
parcelRequire("1Lcr1");
parcelRequire("flmol");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $jMP2a = parcelRequire("jMP2a");

var $hYQyG = parcelRequire("hYQyG");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $9BmXV = parcelRequire("9BmXV");

var $16ixF = parcelRequire("16ixF");

var $g5l0l = parcelRequire("g5l0l");

var $4tOj7 = parcelRequire("4tOj7");
const $cfeeafe48fb5f35f$export$fbc8bcd33b574fbc = (unsafeIssueId, unsafeRankRequest, analyticsMetadata, sourceARI)=>unsafeIssueId.flatMap((issueId)=>unsafeRankRequest.mergeMap((request)=>{
            let aggRank;
            if ('rankBeforeId' in request) aggRank = {
                id: request.rankBeforeId,
                position: 'BEFORE'
            };
            else if ('rankAfterId' in request) aggRank = {
                id: request.rankAfterId,
                position: 'AFTER'
            };
            return (0, $hYQyG.updateItemGraphqlOnServer)({
                sourceARI: sourceARI,
                input: {
                    itemId: issueId,
                    projectId: analyticsMetadata.projectId,
                    rank: aggRank
                }
            }).map((data)=>{
                const updateRoadmapItemData = data?.roadmaps?.updateRoadmapItem;
                const errors = updateRoadmapItemData?.errors;
                const success = updateRoadmapItemData?.success;
                if (success === false && errors?.length) (0, $16ixF.onHandleAggErrors)(!!updateRoadmapItemData, errors);
                const clonedEvent = analyticsMetadata.event.clone();
                if (clonedEvent) {
                    const attributes = {
                        ...analyticsMetadata.attributes,
                        projectType: 'software',
                        updatedItems: [
                            {
                                name: 'rank'
                            }
                        ]
                    };
                    (0, $jMP2a.fireTrackAnalytics)(clonedEvent, 'issue updated', attributes);
                }
                return undefined;
            });
        }));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$cfeeafe48fb5f35f$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.RANK_ISSUE)).mergeMap((action)=>{
        const state = store.getState();
        const sourceARI = (0, $lgKTA.getSourceARI)(state);
        const { issueId: issueId, rankRequest: rankRequest } = action.payload;
        const safeId = (0, $6FeJk.getSafeId)(state, issueId);
        const safeRankRequest = (0, $g5l0l.getSafeRankRequest)(state, rankRequest);
        const projectId = (0, $bwVWW.getProjectId)(state);
        const issueTypeId = (0, $6FeJk.getIssueTypeIdForIssueId)(state, issueId);
        const level = (0, $bwVWW.getEpicIssueTypeIds)(state).includes(issueTypeId) ? 1 : 0;
        const parentId = (0, $6FeJk.getIssueParentIdHash)(state)[issueId];
        const parentIssueKey = parentId ? (0, $6FeJk.getIssueKeyById)(state, parentId) : undefined;
        return $cfeeafe48fb5f35f$export$fbc8bcd33b574fbc(safeId, safeRankRequest, {
            event: action.meta.analyticsEvent,
            projectId: projectId,
            attributes: {
                issueTypeId: issueTypeId,
                level: level
            }
        }, sourceARI).flatMap(()=>{
            (0, $4tOj7.default)(state, parentIssueKey);
            return (0, $3JafE.Observable).empty();
        }).catch(()=>(0, $3JafE.Observable).from([
                (0, $9BmXV.aggError)()
            ]));
    });

});
parcelRegister("hYQyG", function(module, exports) {

$parcel$export(module.exports, "updateItemGraphqlOnServer", () => $9a57f8561107889e$export$7fbe6f22690ea34c);

var $8GxYL = parcelRequire("8GxYL");

var $65uQX = parcelRequire("65uQX");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");


var $jie15 = parcelRequire("jie15");

var $aJyoc = parcelRequire("aJyoc");

var $9ouT3 = parcelRequire("9ouT3");
const $9a57f8561107889e$var$mutationName = 'updateRoadmapItem';
const $9a57f8561107889e$var$concurrentMetricDefinition = (0, $9ouT3.mutationMetrics)[0, $028d5637f56fe710$export$e04dc5133fcac555];
const $9a57f8561107889e$var$analyticKey = 'jira.frontend.fe.software.roadmap.issue-updated';
const $9a57f8561107889e$export$7fbe6f22690ea34c = ({ sourceARI: sourceARI, input: input })=>{
    if ((0, $aJyoc.isEcClientEventListenerEnabled)() && !Object.prototype.hasOwnProperty.call(input, 'rank')) (0, $65uQX.default).saveIssueMutationToCache(new (0, $48mPv.default)(input.itemId, (0, $d7Wfe.MutationSource).UPDATE));
    return (0, $jie15.runMutation)($9a57f8561107889e$var$mutationName, (0, $8GxYL.default), {
        sourceARI: sourceARI,
        input: input
    }, $9a57f8561107889e$var$analyticKey, $9a57f8561107889e$var$concurrentMetricDefinition);
};

});
parcelRegister("8GxYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $095a3d663b59f226$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<426591ebbdeb2a0e3ea13d19bcfb473c>>
 * @relayHash c8c1f6c9567e3fc623ee7998049dba24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac083b05f962f8d48e2193ea1422badaa7b089c2b0762e4e158e5e26b3d9238d
const $095a3d663b59f226$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceARI"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceARI"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            },
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ],
        "type": "RoadmapMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "updateRoadmapItemMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapUpdateItemPayload",
                            "kind": "LinkedField",
                            "name": "updateRoadmapItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "updateRoadmapItemMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapUpdateItemPayload",
                            "kind": "LinkedField",
                            "name": "updateRoadmapItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ac083b05f962f8d48e2193ea1422badaa7b089c2b0762e4e158e5e26b3d9238d",
            "metadata": {},
            "name": "updateRoadmapItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$095a3d663b59f226$var$node.hash = "7ffc6f5477ee6a7f1c9eef09097f8de8";
var $095a3d663b59f226$export$2e2bcd8739ae039 = $095a3d663b59f226$var$node;

});



parcelRegister("2AxzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9736bb071c40f8f9$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $cDvag = parcelRequire("cDvag");

var $8gZ8s = parcelRequire("8gZ8s");

var $d8uzh = parcelRequire("d8uzh");

var $ak8sM = parcelRequire("ak8sM");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$9736bb071c40f8f9$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $d8uzh.default), (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)() ? (0, $ak8sM.default) : (0, $8gZ8s.dummyEpic));

});
parcelRegister("d8uzh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b61a0644914f499$export$2e2bcd8739ae039);
parcelRequire("dM0Xt");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("kIwye");
parcelRequire("8OtG5");
parcelRequire("l5lul");
parcelRequire("dYXzn");
parcelRequire("iects");

var $7GXrf = parcelRequire("7GXrf");

var $3JafE = parcelRequire("3JafE");

var $3FyZ4 = parcelRequire("3FyZ4");


var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $4bpn3 = parcelRequire("4bpn3");

var $g1CaY = parcelRequire("g1CaY");

var $2ukAT = parcelRequire("2ukAT");

var $f2Jih = parcelRequire("f2Jih");

var $ifWeD = parcelRequire("ifWeD");

var $brZt9 = parcelRequire("brZt9");

var $jTiEZ = parcelRequire("jTiEZ");
const $8b61a0644914f499$var$sendAnalyticEvent = (batchEventCount)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'update',
            actionSubject: 'realtime',
            attributes: {
                batchEventCount: batchEventCount
            },
            source: 'roadmapRealtime'
        });
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b61a0644914f499$export$2e2bcd8739ae039 = (action$, store)=>{
    let bufferCounter = 0;
    return action$.ofType((0, $g1CaY.REALTIME_DISPATCH_EVENT)).filter(({ payload: { type: type, payload: payload } })=>{
        if (!(0, $f2Jih.isIssueEvent)(type, payload)) return false;
        const state = store.getState();
        const { atlassianId: atlassianId, issueId: issueId } = payload;
        if ((0, $f2Jih.isCurrentUser)(state, atlassianId)) return false;
        return (0, $6FeJk.isIssueExists)(state, String(issueId)) || type === (0, $1d129cd1c8b202ad$export$b22a14d5dac59664);
    }).do(()=>{
        bufferCounter += 1;
    }).bufferWhen(()=>(0, $3JafE.Observable).interval((0, $jTiEZ.getRealtimeBufferDuration)()).filter(()=>bufferCounter >= (0, $jTiEZ.getMaxBufferSize)() || (0, $jTiEZ.isBrowserTabVisible)())).mergeMap((actions)=>{
        bufferCounter = 0;
        if (actions.length === 0) return (0, $3JafE.Observable).empty();
        const subtaskParentHash = (0, $2ukAT.getSubtaskParentHash)(store.getState());
        const issueIdsToReload = [];
        const issueIdsToRemove = [];
        const subtaskParentIdsToReload = [];
        const subtaskIissueIdsToRemove = [];
        actions.forEach((action)=>{
            if (action) {
                const { payload: { payload: payload, type: type } } = action;
                if (!(0, $f2Jih.isIssueEvent)(type, payload)) return;
                const { issueId: issueId } = payload;
                if (type === (0, $1d129cd1c8b202ad$export$b22a14d5dac59664) || type === (0, $1d129cd1c8b202ad$export$d9bc8850eeef9f60) || type === (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee)) {
                    if (subtaskParentHash[issueId]) subtaskParentIdsToReload.push(subtaskParentHash[issueId]);
                    else issueIdsToReload.push(String(issueId));
                } else if (type === (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99)) {
                    if (subtaskParentHash[issueId]) subtaskIissueIdsToRemove.push({
                        id: `${issueId}`,
                        parentId: subtaskParentHash[issueId]
                    });
                    else issueIdsToRemove.push(String(issueId));
                }
            }
        });
        const observablesToZip = [];
        if (issueIdsToRemove.length > 0) observablesToZip.push((0, $3JafE.Observable).of((0, $j45xj.removeIssues)(issueIdsToRemove)));
        if (subtaskIissueIdsToRemove.length > 0) observablesToZip.push((0, $3JafE.Observable).of((0, $4bpn3.removeSubtasks)(subtaskIissueIdsToRemove)));
        // can disregard deleted issues
        // edge case when reload happens in one interval, and remove happens in another, need to handle errors when issue does not exist
        const remainingIssuesIdsToReload = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(issueIdsToReload, ...issueIdsToRemove);
        if (remainingIssuesIdsToReload.length > 0) {
            observablesToZip.push((0, $brZt9.reloadIssuesWithSequence)(store, remainingIssuesIdsToReload));
            $8b61a0644914f499$var$sendAnalyticEvent(remainingIssuesIdsToReload.length);
        }
        // disregard deleted subtasks
        const remainingSubtaskParentToReload = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(subtaskParentIdsToReload, ...subtaskIissueIdsToRemove.map(({ parentId: parentId })=>parentId));
        if (remainingSubtaskParentToReload.length > 0) observablesToZip.push((0, $ifWeD.reloadSubtaskProgress)(store, remainingSubtaskParentToReload));
        if (observablesToZip.length > 0) return (0, $3JafE.Observable).concat(...observablesToZip);
        return (0, $3JafE.Observable).empty();
    });
};

});
const $1d129cd1c8b202ad$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $1d129cd1c8b202ad$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $1d129cd1c8b202ad$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $1d129cd1c8b202ad$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $1d129cd1c8b202ad$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $1d129cd1c8b202ad$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $1d129cd1c8b202ad$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $1d129cd1c8b202ad$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';

parcelRegister("g1CaY", function(module, exports) {

$parcel$export(module.exports, "REALTIME_DISPATCH_EVENT", () => $94358036e2ab0d45$export$b5816ca887d8baac);
$parcel$export(module.exports, "dispatchRealtimeEvent", () => $94358036e2ab0d45$export$e0f58b7bfd5c1657);
const $94358036e2ab0d45$export$b5816ca887d8baac = 'state.realtime.REALTIME_DISPATCH_EVENT';
const $94358036e2ab0d45$export$e0f58b7bfd5c1657 = (event)=>({
        type: $94358036e2ab0d45$export$b5816ca887d8baac,
        payload: event
    });

});

parcelRegister("f2Jih", function(module, exports) {

$parcel$export(module.exports, "isCurrentUser", () => $f3be1b360f1a8cd6$export$863470530413e3e7);
$parcel$export(module.exports, "isIssueEvent", () => $f3be1b360f1a8cd6$export$734ba008b9d9e61c);


var $lgKTA = parcelRequire("lgKTA");
const $f3be1b360f1a8cd6$export$863470530413e3e7 = (state, accountId)=>(0, $lgKTA.getLoggedInAccountId)(state) === accountId;
const $f3be1b360f1a8cd6$var$issueEventTypes = [
    (0, $1d129cd1c8b202ad$export$b22a14d5dac59664),
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee),
    (0, $1d129cd1c8b202ad$export$d9bc8850eeef9f60),
    (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99)
];
const $f3be1b360f1a8cd6$export$734ba008b9d9e61c = (type, payload)=>$f3be1b360f1a8cd6$var$issueEventTypes.includes(type) && (payload === undefined || 'issueId' in payload && payload.issueId !== undefined);

});

parcelRegister("ifWeD", function(module, exports) {

$parcel$export(module.exports, "reloadSubtaskProgress", () => $bd750ee3e4840da2$export$9c75d597f17b4dd1);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("YLEHo");
parcelRequire("jAXdN");
parcelRequire("1Lcr1");

var $MYW4e = parcelRequire("MYW4e");

var $8blac = parcelRequire("8blac");

var $3JafE = parcelRequire("3JafE");

var $jHsyj = parcelRequire("jHsyj");

var $lgKTA = parcelRequire("lgKTA");

var $a2ne3 = parcelRequire("a2ne3");

var $5urmd = parcelRequire("5urmd");

var $4bpn3 = parcelRequire("4bpn3");
const $bd750ee3e4840da2$export$9c75d597f17b4dd1 = (store, issueIds)=>{
    if (issueIds.length === 0) return (0, $3JafE.Observable).empty();
    const state = store.getState();
    const fullStatusCategoriesHash = (0, $5urmd.getFullStatusCategoriesHash)(state);
    return (0, $jHsyj.getSubtasksForIssues)((0, $lgKTA.getSourceARI)(state), issueIds).mergeMap(({ subtasks: subtasks, statusCategories: statusCategories })=>{
        const subtaskHash = {};
        const actions = [];
        issueIds.forEach((id)=>{
            subtaskHash[id] = [];
        });
        actions.push((0, $4bpn3.extendSubtasks)({
            ...subtaskHash,
            ...subtasks
        }));
        const newStatusCategories = {};
        Object.keys(statusCategories).forEach((statusCategoryId)=>{
            if (fullStatusCategoriesHash[statusCategoryId] === undefined) newStatusCategories[statusCategoryId] = statusCategories[statusCategoryId];
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newStatusCategories)) actions.push((0, $a2ne3.mergeStatusCategories)(newStatusCategories));
        return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)(actions));
    }).catch(()=>(0, $3JafE.Observable).empty());
};

});
parcelRegister("jHsyj", function(module, exports) {

$parcel$export(module.exports, "getSubtasksForIssues", () => $581cd99a7607ae51$export$626d5c594c98bbce);
parcelRequire("cpH8E");
parcelRequire("flmol");

var $3FyZ4 = parcelRequire("3FyZ4");

var $bokAF = parcelRequire("bokAF");

var $9qKxX = parcelRequire("9qKxX");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");

var $hmc1Z = parcelRequire("hmc1Z");
const $581cd99a7607ae51$var$analyticKey = 'jira.frontend.fe.software.roadmap.get-subtasks';
const $581cd99a7607ae51$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$d959a123e6ceb778];
const $581cd99a7607ae51$var$DEFAULT_RESPONSE = {
    statusCategories: [],
    subtasks: []
};
const $581cd99a7607ae51$export$626d5c594c98bbce = (sourceAri, issueIds)=>(0, $8sMwH.runQueryWithMetadata)((0, $bokAF.default), (0, $9qKxX.generateGetSubtasksQueryVariables)(sourceAri, issueIds), $581cd99a7607ae51$var$analyticKey, $581cd99a7607ae51$var$concurrentMetricDefinition).map(({ data: data })=>{
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (analyticsClient) analyticsClient.sendOperationalEvent({
                action: 'fetched',
                actionSubject: 'roadmapSubtasks',
                attributes: {
                    total: data?.roadmaps?.roadmapSubtasksByIds?.subtasks.length ?? 0
                },
                source: 'relayOperation'
            });
        });
        const response = data?.roadmaps?.roadmapSubtasksByIds ?? $581cd99a7607ae51$var$DEFAULT_RESPONSE;
        return (0, $hmc1Z.transformSubtasksAndStatusCategoriesResponse)(response);
    });

});
parcelRegister("bokAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb84193d335f4b54$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5bc62a992ea19135d71697e9e7337015>>
 * @relayHash e768406b8e14cc741a9cab3c8f11b795
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eac03d37c54edb765ed82f90ebd26f88b6be8aec5a8d90e4095bccaefef13888
const $fb84193d335f4b54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "itemIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = [
        {
            "concreteType": "RoadmapsQuery",
            "kind": "LinkedField",
            "name": "roadmaps",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "itemIds",
                            "variableName": "itemIds"
                        },
                        {
                            "kind": "Variable",
                            "name": "sourceARI",
                            "variableName": "sourceAri"
                        }
                    ],
                    "concreteType": "RoadmapSubtasksWithStatusCategories",
                    "kind": "LinkedField",
                    "name": "roadmapSubtasksByIds",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RoadmapSubtasks",
                            "kind": "LinkedField",
                            "name": "subtasks",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "parentId"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCategoryId"
                                }
                            ]
                        },
                        {
                            "concreteType": "RoadmapStatusCategory",
                            "kind": "LinkedField",
                            "name": "statusCategories",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getSubtasksQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getSubtasksQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "eac03d37c54edb765ed82f90ebd26f88b6be8aec5a8d90e4095bccaefef13888",
            "metadata": {},
            "name": "getSubtasksQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fb84193d335f4b54$var$node.hash = "86a1203541c65452598c6eb81a645287";
var $fb84193d335f4b54$export$2e2bcd8739ae039 = $fb84193d335f4b54$var$node;

});

parcelRegister("9qKxX", function(module, exports) {

$parcel$export(module.exports, "generateGetSubtasksQueryVariables", () => $24a8204efe992f97$export$6d867358533d05b);
const $24a8204efe992f97$export$6d867358533d05b = (sourceAri, itemIds)=>({
        sourceAri: sourceAri,
        itemIds: itemIds
    });

});



parcelRegister("brZt9", function(module, exports) {

$parcel$export(module.exports, "reloadIssuesWithSequence", () => $5b60b6e897b3b8ad$export$6bc188af425a1762);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("YLEHo");
parcelRequire("jAXdN");

var $kG4jb = parcelRequire("kG4jb");

var $3JafE = parcelRequire("3JafE");

var $eC0P8 = parcelRequire("eC0P8");

var $hoQXP = parcelRequire("hoQXP");

var $85pXK = parcelRequire("85pXK");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $6489W = parcelRequire("6489W");

var $gdFA6 = parcelRequire("gdFA6");

var $2f9uM = parcelRequire("2f9uM");

var $91mgt = parcelRequire("91mgt");
const $5b60b6e897b3b8ad$export$6bc188af425a1762 = (store, issueIds)=>{
    if (issueIds.length === 0) return (0, $3JafE.Observable).empty();
    const state = store.getState();
    const sourceAri = (0, $lgKTA.getSourceARI)(state);
    const quickFilterIds = (0, $6489W.getQuickFilters)(store.getState());
    const customFilterIds = (0, $6489W.getCustomFilters)(store.getState());
    const isJQLFiltersApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
    return (0, $3JafE.Observable).zip((0, $85pXK.getItems)(sourceAri, issueIds), isJQLFiltersApplied ? (0, $eC0P8.filterItemsByJQLFilters)((0, $lgKTA.getSourceARI)(state), quickFilterIds, customFilterIds) : (0, $3JafE.Observable).of(null)).mergeMap(([issuesAndUsers, filterIssueIds])=>{
        const reloadWithSequenceObservables = [];
        if (filterIssueIds !== null) reloadWithSequenceObservables.push((0, $3JafE.Observable).of((0, $gdFA6.jqlFiltersSuccess)(filterIssueIds)));
        if (issueIds.length === 0 && issuesAndUsers.issues.sequence.length === 0) return (0, $3JafE.Observable).empty();
        const issueTypes = (0, $bwVWW.getFullIssueTypeHash)(store.getState());
        if ((0, $2f9uM.issueTypesReloadRequired)(issuesAndUsers, issueTypes)) {
            reloadWithSequenceObservables.push((0, $2f9uM.criticalDataReload)(store));
            return (0, $3JafE.Observable).merge(...reloadWithSequenceObservables);
        }
        // when creating issues in between, we also need to update the rank
        const isAnyRankNewOrDifferent = issueIds.some((issueId)=>{
            const oldRank = (0, $6FeJk.getIssueRank)(state, issueId);
            // it's possible that the issue was deleted by the time this realtime event reached the client
            // in this rare edge case, the fetch would not return the issue
            // and trying to search for it by id would result in undefined
            // the rank will be updated when handling the delete realtime event
            const newIssue = issuesAndUsers.issues.hash[issueId];
            return newIssue !== undefined && (oldRank === undefined || oldRank !== newIssue.rank);
        });
        if (isAnyRankNewOrDifferent) return (0, $hoQXP.getIssueIdsFromServer)(sourceAri).mergeMap((newSequence)=>{
            const oldSequence = (0, $6FeJk.getIssueIds)(state);
            const batched = (0, $91mgt.updateIssuesAndUsers)(store, {
                issues: {
                    hash: issuesAndUsers.issues.hash,
                    sequence: issuesAndUsers.issues.sequence
                },
                users: issuesAndUsers.users
            });
            batched.payload.unshift(// To prevent race condition, we ignore issues that do not exist in the store.
            (0, $j45xj.updateIssuesSequence)((0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(newSequence, oldSequence.concat(issuesAndUsers.issues.sequence))));
            reloadWithSequenceObservables.push((0, $3JafE.Observable).of(batched));
            return (0, $3JafE.Observable).merge(...reloadWithSequenceObservables);
        });
        let issueIdsForRemoval = [];
        if (issueIds.length !== issuesAndUsers.issues.sequence.length) issueIdsForRemoval = issueIds.filter((issueId)=>!(0, $2f9uM.tryGetIssueFromIssuesAndUsers)(issuesAndUsers, issueId));
        reloadWithSequenceObservables.push((0, $3JafE.Observable).of((0, $91mgt.updateIssuesAndUsers)(store, issuesAndUsers, issueIdsForRemoval)));
        return (0, $3JafE.Observable).merge(...reloadWithSequenceObservables);
    });
};

});
parcelRegister("hoQXP", function(module, exports) {

$parcel$export(module.exports, "getIssueIdsFromServer", () => $8d663764404ebfaf$export$1016d311ff24ce21);
parcelRequire("flmol");
parcelRequire("cpH8E");

var $1VKs9 = parcelRequire("1VKs9");

var $eObZ1 = parcelRequire("eObZ1");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");
const $8d663764404ebfaf$var$analyticKey = 'jira.frontend.fe.software.roadmap.get-issue-ids';
const $8d663764404ebfaf$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$72305db43681d1de];
const $8d663764404ebfaf$export$1016d311ff24ce21 = (sourceAri)=>(0, $8sMwH.runQueryWithMetadata)((0, $1VKs9.default), (0, $eObZ1.generateGetIssueIdsQueryVariables)(sourceAri), $8d663764404ebfaf$var$analyticKey, $8d663764404ebfaf$var$concurrentMetricDefinition).map(({ data: data })=>data.roadmaps?.roadmapForSource?.content?.items.edges.filter(Boolean) // TODO: "filter" to be removed after null/undefined is removed from edges in AGG schema
        .map(({ node: roadmapItem })=>roadmapItem.id) ?? []);

});
parcelRegister("1VKs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e021ec45b867690d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c810cae4890c69f4255fd4ce5926752>>
 * @relayHash a71a4c37e44c87ca3d5208d8e4f39467
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 86d3d5d0c58fd2a26d1fd2f392bc3902793bfe94272758d1f721f1b99392b72b
const $e021ec45b867690d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getIssueIdsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapContent",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapItemConnection",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "RoadmapItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "RoadmapItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v2 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "roadmaps.roadmapForSource.content.items.edges.node.id"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "roadmaps.roadmapForSource.content.items.edges"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getIssueIdsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapContent",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapItemConnection",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "RoadmapItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "RoadmapItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "86d3d5d0c58fd2a26d1fd2f392bc3902793bfe94272758d1f721f1b99392b72b",
            "metadata": {},
            "name": "getIssueIdsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e021ec45b867690d$var$node.hash = "ef97f4c0b11c66b5a686daf59be5fe4f";
var $e021ec45b867690d$export$2e2bcd8739ae039 = $e021ec45b867690d$var$node;

});

parcelRegister("eObZ1", function(module, exports) {

$parcel$export(module.exports, "generateGetIssueIdsQueryVariables", () => $2ac852021e1a44b5$export$7cd8da70683a208d);
const $2ac852021e1a44b5$export$7cd8da70683a208d = (sourceAri)=>({
        sourceAri: sourceAri
    });

});



parcelRegister("jTiEZ", function(module, exports) {

$parcel$export(module.exports, "getRealtimeBufferDuration", () => $2f354d305d586db6$export$d81b1507c0d48361);
$parcel$export(module.exports, "getMaxBufferSize", () => $2f354d305d586db6$export$364161aa43e3a835);
$parcel$export(module.exports, "isBrowserTabVisible", () => $2f354d305d586db6$export$ab764bf4fd8cc5f1);
const $2f354d305d586db6$export$d81b1507c0d48361 = ()=>5000;
const $2f354d305d586db6$export$364161aa43e3a835 = ()=>100;
const $2f354d305d586db6$export$ab764bf4fd8cc5f1 = ()=>!document.hidden;

});


parcelRegister("ak8sM", function(module, exports) {

$parcel$export(module.exports, "default", () => $468fee6962e99338$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");

var $g1CaY = parcelRequire("g1CaY");

var $6489W = parcelRequire("6489W");

var $gdFA6 = parcelRequire("gdFA6");

var $f2Jih = parcelRequire("f2Jih");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$468fee6962e99338$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $g1CaY.REALTIME_DISPATCH_EVENT)).filter(({ payload: { type: type, payload: payload } })=>{
        const state = store.getState();
        const { atlassianId: atlassianId } = payload;
        const quickFilterIds = (0, $6489W.getQuickFilters)(state);
        const customFilterIds = (0, $6489W.getCustomFilters)(state);
        const isJQLFilterApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
        return (0, $f2Jih.isIssueEvent)(type) && (0, $f2Jih.isCurrentUser)(state, atlassianId) && isJQLFilterApplied;
    }).mergeMap(()=>(0, $3JafE.Observable).of((0, $gdFA6.reapplyJQLFilters)()));

});


parcelRegister("dH9r1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e32fccee73a36c9a$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jAXdN");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $03XEB = parcelRequire("03XEB");

var $fE3Ua = parcelRequire("fE3Ua");

var $85pXK = parcelRequire("85pXK");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $2f9uM = parcelRequire("2f9uM");

var $91mgt = parcelRequire("91mgt");
const $e32fccee73a36c9a$var$updateDependencies = (store, issueId, links)=>{
    const state = store.getState();
    const issueIdsSet = new Set();
    links.forEach((link)=>{
        if (link.direction === (0, $03XEB.IssueLinkDirectionTypes).INWARD) issueIdsSet.add(issueId);
        else if (link.direction === (0, $03XEB.IssueLinkDirectionTypes).OUTWARD) issueIdsSet.add(link.linkedIssueId);
    });
    return (0, $3JafE.Observable).zip(...Array.from(issueIdsSet.values()).filter((targetIssueId)=>(0, $6FeJk.isIssueExists)(state, targetIssueId)).map((issueIdToFetch)=>(0, $85pXK.getItems)((0, $lgKTA.getSourceARI)(state), [
            issueIdToFetch
        ])), (...issuesData)=>{
        if (issuesData.length) {
            const getMergedIssues = ()=>{
                const result = {
                    issues: {
                        hash: {},
                        sequence: []
                    },
                    users: {}
                };
                issuesData.forEach((issuesDataItem)=>{
                    Object.assign(result.issues.hash, issuesDataItem.issues.hash);
                    Object.assign(result.users, issuesDataItem.users);
                });
                return result;
            };
            const mergedIssues = getMergedIssues();
            return (0, $91mgt.updateIssuesAndUsers)(store, mergedIssues);
        }
        return (0, $3JafE.Observable).empty();
    });
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$e32fccee73a36c9a$export$2e2bcd8739ae039 = (action$, store)=>// @ts-expect-error - Property 'type' is missing in type 'Observable<never>' but required in type 'Action'.
    action$.ofType((0, $j45xj.RELOAD_ISSUE)).mergeMap((action)=>{
        const event = action.payload;
        switch(event.type){
            case (0, $fE3Ua.ChangeEventTypes).ISSUE_TYPE_CHANGED:
                {
                    const { issueId: issueId } = event;
                    return (0, $2f9uM.reloadIssues)(store, [
                        issueId
                    ]);
                }
            case (0, $fE3Ua.ChangeEventTypes).ISSUE_LINKS_CREATED:
                {
                    const { issueId: issueId, meta: { links: links } } = event;
                    const state = store.getState();
                    const issueTypeId = (0, $6FeJk.getIssueTypeIdHash)(state)[issueId];
                    const issueTypeHash = (0, $bwVWW.getFullIssueTypeHash)(state);
                    // Check for issue types that exist on the roadmap
                    if (!issueTypeHash[issueTypeId]) break;
                    return $e32fccee73a36c9a$var$updateDependencies(store, issueId, links);
                }
            case (0, $fE3Ua.ChangeEventTypes).ISSUE_LINK_DELETED:
                {
                    const { issueId: issueId, meta: { direction: direction, linkedIssueId: linkedIssueId } } = event;
                    const state = store.getState();
                    const issueTypeIdHash = (0, $6FeJk.getIssueTypeIdHash)(state);
                    const issueTypeHash = (0, $bwVWW.getFullIssueTypeHash)(state);
                    // Check for issue types that exist on the roadmap
                    if (!issueTypeHash[issueTypeIdHash[issueId]] && !issueTypeHash[issueTypeIdHash[linkedIssueId]]) break;
                    if (direction === (0, $03XEB.IssueLinkDirectionTypes).INWARD) return (0, $2f9uM.reloadIssues)(store, [
                        issueId
                    ]);
                    if (direction === (0, $03XEB.IssueLinkDirectionTypes).OUTWARD) return (0, $2f9uM.reloadIssues)(store, [
                        linkedIssueId
                    ]);
                    break;
                }
            case (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED:
                {
                    const { issueId: issueId, meta: { childIssue: { id: childIssueId } } } = event;
                    if ((0, $6FeJk.isIssueExists)(store.getState(), issueId)) return (0, $2f9uM.reloadIssues)(store, [
                        childIssueId
                    ]);
                    break;
                }
            default:
                break;
        }
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("03XEB", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $dc38a98d5f20359c$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $dc38a98d5f20359c$export$4b7bcc27238c61b9);
const $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $dc38a98d5f20359c$export$5dec99d71ec794ba = 'OUTWARD';
const $dc38a98d5f20359c$export$6cdcf74878b11d34 = 'BOTH';
const $dc38a98d5f20359c$export$4b7bcc27238c61b9 = {
    [$dc38a98d5f20359c$export$b5e2b68b0fa7f1c8]: $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8,
    [$dc38a98d5f20359c$export$5dec99d71ec794ba]: $dc38a98d5f20359c$export$5dec99d71ec794ba,
    [$dc38a98d5f20359c$export$6cdcf74878b11d34]: $dc38a98d5f20359c$export$6cdcf74878b11d34
};

});


parcelRegister("7Ov8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9015d9d81b4af0f3$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("dM0Xt");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("flmol");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $jMP2a = parcelRequire("jMP2a");

var $kbiEp = parcelRequire("kbiEp");

var $k48Ch = parcelRequire("k48Ch");

var $cDvag = parcelRequire("cDvag");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $9BmXV = parcelRequire("9BmXV");

var $6489W = parcelRequire("6489W");

var $gdFA6 = parcelRequire("gdFA6");

var $11LHz = parcelRequire("11LHz");

var $7J2Ol = parcelRequire("7J2Ol");

var $91mgt = parcelRequire("91mgt");

var $4tOj7 = parcelRequire("4tOj7");
const $9015d9d81b4af0f3$var$getPostScheduleActions = (state, scheduledIssues)=>{
    const nonBaseLevelIssues = scheduledIssues[0, $kbiEp.PARENT_LEVEL];
    const baseLevelIssues = scheduledIssues[0, $kbiEp.BASE_LEVEL];
    const actions = [];
    const issueChildrenHash = (0, $6FeJk.getIssueChildrenHash)(state);
    let activeIssueLevel = (0, $kbiEp.PARENT_LEVEL);
    let isHiddenIssueRescheduledCalled = false;
    let hasIssueCollapsedWithScheduledChildIssue = false;
    nonBaseLevelIssues.concat(baseLevelIssues).some(({ issueId: issueId, level: level, issue: issue }, index)=>{
        if (index === 0) activeIssueLevel = level;
        // For bulk-scheduling epics, exit early when
        // - "Hidden Issue Rescheduled" flag is counted once + all epics have been checked since epic view settings is not applicable to base-level issues
        // NOTE: the check should continue when "Hidden Issue Rescheduled" hasn't been counted since "Disappears from Display Range" flag can still occur + "Hidden Issue Rescheduled" flag can still occur on filtered base-level issues
        // For bulk-scheduling base-level issues, exit early when
        // - "Hidden Issue Rescheduled" flag is counted once since epic view settings is not applicable to base-level issues
        const shouldExitEarly = activeIssueLevel === (0, $kbiEp.PARENT_LEVEL) ? isHiddenIssueRescheduledCalled && level === (0, $kbiEp.BASE_LEVEL) : isHiddenIssueRescheduledCalled;
        if (shouldExitEarly) return true;
        // NOTE: isHiddenByFilter can never be true for the active issue since it's the one interacted by users
        const { isHiddenByFilter: isHiddenByFilter, isHiddenBySetting: isHiddenBySetting } = (0, $7J2Ol.getIsIssueHiddenByFiltersOrSettings)(state, issue, issueId);
        // NOTE: For each issue, either "Disappears from Display Range" flag or "Hidden Issue Rescheduled" flag is applicable, but not both
        if (level === (0, $kbiEp.PARENT_LEVEL) && isHiddenBySetting) actions.push((0, $9BmXV.issueDisappearsFromDisplayRange)({
            issueId: issueId
        }));
        else if (!isHiddenIssueRescheduledCalled) {
            // NOTE: isHiddenBySetting can never be true for base-level issues since it's "epic" view settings
            if (isHiddenByFilter) {
                // Check if there are any issues from the same hierarchy level as the active issue that are hidden by filters
                actions.push((0, $9BmXV.issueHidden)({
                    ids: []
                }));
                isHiddenIssueRescheduledCalled = true;
                return false;
            }
            // If no child items are being scheduled, skip checking for parent items' child item state or collapse state
            if (level === (0, $kbiEp.PARENT_LEVEL) && baseLevelIssues.length) {
                // Check if the parent issue has any child issues that are being scheduled (required for bar-resizing cases)
                const hasChildIssueScheduled = (issueChildrenHash[issueId] ?? []).some((childIssueId)=>baseLevelIssues.some(({ issueId: baseLevelIssueId })=>baseLevelIssueId === childIssueId));
                // Check if the parent is collapsed
                const isCollapsed = !((0, $11LHz.getExpandedItems)(state)[issueId] ?? false);
                // The parent collapse state is only taken into account when it has child issues that are being scheduled
                hasIssueCollapsedWithScheduledChildIssue = hasChildIssueScheduled ? isCollapsed : false;
                if (hasIssueCollapsedWithScheduledChildIssue) {
                    actions.push((0, $9BmXV.issueHidden)({
                        ids: []
                    }));
                    isHiddenIssueRescheduledCalled = true;
                    return false;
                }
            }
        }
        return false;
    });
    return actions;
};
const $9015d9d81b4af0f3$var$persistScheduleIssues = (issueIdsObservable, safeIssueScheduleFields, transitionId, { scheduledIssues: scheduledIssues, attributes: issuesAttributes, event: event }, store)=>issueIdsObservable.mergeMap(()=>{
        const state = store.getState();
        return (0, $k48Ch.scheduleItems)((0, $lgKTA.getSourceARI)(state), safeIssueScheduleFields).map((data)=>{
            const scheduleRoadmapItemsData = data?.roadmaps?.scheduleRoadmapItems;
            const errors = scheduleRoadmapItemsData?.errors;
            const success = scheduleRoadmapItemsData?.success;
            if (success === false && errors && errors?.length) throw new Error(`ScheduleItems failed: ${errors[0]?.message || 'unknown'}, ${errors[0]?.extensions?.statusCode || 'statusCode unknown'}`);
            const clearTransitions = [];
            const clonedEvent = event.clone();
            const activeIssueAttributes = issuesAttributes[0];
            if (clonedEvent) {
                const { issueId: issueId, ...otherAttributes } = activeIssueAttributes;
                const numberOfSelectedIssuesShiftedTogether = (scheduledIssues[activeIssueAttributes.level] ?? []).length - 1;
                const numberOfChildIssuesShiftedTogether = (scheduledIssues[activeIssueAttributes.level - 1] ?? []).length;
                (0, $jMP2a.fireTrackAnalytics)(clonedEvent, 'issue updated', issueId, {
                    ...otherAttributes,
                    projectType: 'software',
                    numberOfSelectedIssuesShiftedTogether: numberOfSelectedIssuesShiftedTogether,
                    numberOfChildIssuesShiftedTogether: numberOfChildIssuesShiftedTogether
                });
            }
            safeIssueScheduleFields.forEach((scheduleField)=>{
                clearTransitions.push((0, $j45xj.clearTransitionState)({
                    issueId: scheduleField.issueId,
                    transitionId: transitionId
                }, (0, $j45xj.SCHEDULE_ISSUES)));
            });
            if ((0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)()) return clearTransitions;
            return [
                ...clearTransitions,
                ...$9015d9d81b4af0f3$var$getPostScheduleActions(state, scheduledIssues)
            ];
        });
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$9015d9d81b4af0f3$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.SCHEDULE_ISSUES)).mergeMap(({ payload: { issueScheduleFields: issueScheduleFields }, meta: { hasOverdueReleaseDate: hasOverdueReleaseDate, analyticsEvent: analyticsEvent } })=>{
        const state = store.getState();
        const transitionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        const issueKeys = [];
        const ids = [];
        const projectIds = [];
        const issueTransitions = new Map();
        const safeIssueScheduleFields = [];
        const issuesAttributes = [];
        const baseLevelIssues = [];
        const nonBaseLevelIssues = [];
        const extendHash = {};
        // Generate transition issues
        issueScheduleFields.forEach((issueScheduleField)=>{
            const { issueId: issueId, startDate: startDate, dueDate: dueDate } = issueScheduleField;
            const issue = (0, $6FeJk.getIssue)(state, issueId);
            if (!issue) return;
            const projectId = (0, $bwVWW.getProjectId)(state);
            if (!projectIds.includes(projectId)) projectIds.push(projectId);
            const issueTypeId = (0, $6FeJk.getIssueTypeIdForIssueId)(state, issueId);
            const level = (0, $bwVWW.getEpicIssueTypeIds)(state).includes(issueTypeId) ? (0, $kbiEp.PARENT_LEVEL) : (0, $kbiEp.BASE_LEVEL);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const updateProps = {};
            if (startDate !== issue.startDate.value) updateProps.startDate = startDate;
            if (dueDate !== issue.dueDate.value) updateProps.dueDate = dueDate;
            // create new issue object
            const [transitionIssue, updatedItems] = (0, $91mgt.createTransitionIssueWithUpdatedItems)(issue, updateProps, transitionId);
            if (transitionIssue) {
                extendHash[issueId] = transitionIssue;
                const issueKey = (0, $6FeJk.getIssueKeyById)(state, issueId);
                const isIssueBaseLevel = (0, $kbiEp.isBaseLevel)(level);
                ids.push(issueId);
                issueKey && issueKeys.push(issueKey);
                issueTransitions.set(issueId, transitionIssue);
                safeIssueScheduleFields.push(issueScheduleField);
                issuesAttributes.push({
                    issueId: issueId,
                    issueTypeId: issueTypeId,
                    level: level,
                    updatedItems: updatedItems,
                    ...isIssueBaseLevel ? undefined : {
                        hasOverdueReleaseDate: hasOverdueReleaseDate
                    }
                });
                (isIssueBaseLevel ? baseLevelIssues : nonBaseLevelIssues).push({
                    issueId: issueId,
                    level: level,
                    issue: transitionIssue
                });
            }
        });
        if (!safeIssueScheduleFields.length) return (0, $3JafE.Observable).empty();
        // Extend issues
        const transitionExtend = (0, $6FeJk.getSafeIds)(store.getState(), ids).mergeMap((issueIds)=>{
            const transitionExtendHash = {};
            issueIds.forEach((issueId)=>{
                if (issueId !== undefined) {
                    const transitionIssue = issueTransitions.get(issueId);
                    if (transitionIssue) transitionExtendHash[issueId] = transitionIssue;
                }
            });
            return (0, $3JafE.Observable).of((0, $j45xj.extendIssues)({
                sequence: [],
                hash: transitionExtendHash
            }));
        });
        const analyticsMetadata = {
            projectId: projectIds[0],
            scheduledIssues: {
                [(0, $kbiEp.BASE_LEVEL)]: baseLevelIssues,
                [(0, $kbiEp.PARENT_LEVEL)]: nonBaseLevelIssues
            },
            attributes: issuesAttributes,
            event: analyticsEvent
        };
        return (0, $3JafE.Observable).concat(// update `unsafe` issues first
        (0, $3JafE.Observable).of((0, $j45xj.extendIssues)({
            sequence: [],
            hash: extendHash
        }, (0, $j45xj.SCHEDULE_ISSUES))), // persist schedule issues
        transitionExtend, $9015d9d81b4af0f3$var$persistScheduleIssues((0, $6FeJk.getSafeIds)(store.getState(), ids), safeIssueScheduleFields, transitionId, analyticsMetadata, store).map((actions)=>{
            const selectedIssueKey = (0, $6489W.getSelectedIssueKey)(state);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueKeys.includes(selectedIssueKey) && (0, $4tOj7.default)(state, selectedIssueKey);
            return (0, $MYW4e.batchActions)(actions);
        }).catch(()=>(0, $3JafE.Observable).from([
                (0, $9BmXV.aggError)()
            ])), (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)() ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).of((0, $gdFA6.reapplyJQLFilters)()));
    });

});
parcelRegister("k48Ch", function(module, exports) {

$parcel$export(module.exports, "scheduleItems", () => $6cea7c78bb9429e1$export$7b362d3efe98c60d);

var $fmi13 = parcelRequire("fmi13");


var $jie15 = parcelRequire("jie15");

var $9ouT3 = parcelRequire("9ouT3");

var $hmc1Z = parcelRequire("hmc1Z");
const $6cea7c78bb9429e1$var$analyticKey = 'jira.frontend.fe.software.roadmap.bulk-issues-scheduled';
const $6cea7c78bb9429e1$var$scheduleItemsMetric = (0, $9ouT3.mutationMetrics)[0, $028d5637f56fe710$export$315e0cbd8c7bfbd4];
const $6cea7c78bb9429e1$var$mutationName = 'scheduleRoadmapItems';
const $6cea7c78bb9429e1$export$7b362d3efe98c60d = (sourceARI, issueScheduleFields)=>(0, $jie15.runMutation)($6cea7c78bb9429e1$var$mutationName, (0, $fmi13.default), {
        sourceARI: sourceARI,
        scheduleRequests: (0, $hmc1Z.transformScheduleItemsRequest)(issueScheduleFields)
    }, $6cea7c78bb9429e1$var$analyticKey, $6cea7c78bb9429e1$var$scheduleItemsMetric);

});
parcelRegister("fmi13", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9e3e6074856b6c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a4cdb38644fc652a84fbc59caf7af6c2>>
 * @relayHash 8984ea3b0bd52a4a879c387014bb9c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f71597ff5dc1e918db86f2c0ed3f92c5c95a21bda21e558fe23d5b71ced2c4b
const $de9e3e6074856b6c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scheduleRequests"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceARI"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "scheduleRequests",
                    "variableName": "scheduleRequests"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceARI"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            },
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ],
        "type": "RoadmapMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "scheduleRoadmapItemsMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapScheduleItemsPayload",
                            "kind": "LinkedField",
                            "name": "scheduleRoadmapItems",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "scheduleRoadmapItemsMutation",
            "selections": [
                {
                    "concreteType": "RoadmapsMutation",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapScheduleItemsPayload",
                            "kind": "LinkedField",
                            "name": "scheduleRoadmapItems",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4f71597ff5dc1e918db86f2c0ed3f92c5c95a21bda21e558fe23d5b71ced2c4b",
            "metadata": {},
            "name": "scheduleRoadmapItemsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$de9e3e6074856b6c$var$node.hash = "0dd026eff03519d70944542fa22dbd32";
var $de9e3e6074856b6c$export$2e2bcd8739ae039 = $de9e3e6074856b6c$var$node;

});



parcelRegister("9kTfp", function(module, exports) {

$parcel$export(module.exports, "multiselect", () => $e25d81579e69a981$export$afd90303e38e32b1);
$parcel$export(module.exports, "select", () => $e25d81579e69a981$export$2e6c959c16ff56b8);
$parcel$export(module.exports, "default", () => $e25d81579e69a981$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("dM0Xt");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $kbiEp = parcelRequire("kbiEp");


var $6FeJk = parcelRequire("6FeJk");

var $9BmXV = parcelRequire("9BmXV");

var $9E22T = parcelRequire("9E22T");

var $jxq2V = parcelRequire("jxq2V");

var $7cApO = parcelRequire("7cApO");

var $iJJay = parcelRequire("iJJay");

var $htXdF = parcelRequire("htXdF");

var $11LHz = parcelRequire("11LHz");

var $g3uMy = parcelRequire("g3uMy");
const $e25d81579e69a981$var$getIsInteractedItemsLimitExceeded = (state, isSelectedItemIdsBaseLevel, toBeSelectedItemIds, analyticsEvent)=>{
    const isInteractedItemsOverLimit = (0, $jxq2V.getIsInteractedItemsOverLimit)(state, isSelectedItemIdsBaseLevel, toBeSelectedItemIds);
    isInteractedItemsOverLimit && (0, $g3uMy.fireInteractedItemsLimitExceededAnalytics)(analyticsEvent);
    return isInteractedItemsOverLimit;
};
const $e25d81579e69a981$var$getMultiSelectItems = (state, id, anchorId, isSelectedItemIdsBaseLevel)=>{
    if (!anchorId) return [];
    const orderedFilteredItems = isSelectedItemIdsBaseLevel ? (0, $9E22T.getFilteredBaseLevelIssueIds)(state) : (0, $9E22T.getFilteredNonBaseLevelIssueIds)(state);
    const clickedItemIndex = orderedFilteredItems.indexOf(id);
    const anchorIndex = orderedFilteredItems.indexOf(anchorId);
    const itemList = orderedFilteredItems.slice(Math.min(clickedItemIndex, anchorIndex), Math.max(clickedItemIndex, anchorIndex) + 1);
    return clickedItemIndex < anchorIndex ? itemList.reverse() : itemList;
};
const $e25d81579e69a981$export$afd90303e38e32b1 = (action$, store)=>action$.ofType((0, $htXdF.SELECT_MULTIPLE_ITEMS)).mergeMap(({ payload: { analyticsEvent: analyticsEvent, itemIds: itemIds } })=>{
        const state = store.getState();
        const selectedItemLevel = itemIds.length ? (0, $6FeJk.getIssueLevel)(state, itemIds[0]) : undefined; /** When deselecting all. */ 
        if (selectedItemLevel === undefined) return (0, $3JafE.Observable).of((0, $htXdF.setSelectedItemIds)([]));
        const isSelectedItemIdsBaseLevel = (0, $kbiEp.isBaseLevel)(selectedItemLevel);
        const isInteractedItemsLimitExceeded = $e25d81579e69a981$var$getIsInteractedItemsLimitExceeded(state, isSelectedItemIdsBaseLevel, itemIds, analyticsEvent);
        if (isInteractedItemsLimitExceeded) return (0, $3JafE.Observable).of((0, $9BmXV.interactedItemsLimitExceeded)());
        return (0, $3JafE.Observable).of((0, $htXdF.setSelectedItemIds)(itemIds));
    });
const $e25d81579e69a981$export$2e6c959c16ff56b8 = (action$, store)=>action$.ofType((0, $htXdF.ACTIVATE_ITEM)).mergeMap(({ payload: { itemId: itemId } })=>{
        const state = store.getState();
        const key = (0, $6FeJk.getIssueKeyById)(state, itemId);
        return (0, $3JafE.Observable).of((0, $7cApO.setSelectedIssue)(key));
    });
var // Remove with project_timeline_multi-select_and_checkboxes
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$e25d81579e69a981$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $htXdF.SELECT_ITEMS)).mergeMap(({ payload: { id: id, level: level, withCmd: withCmd, withShift: withShift }, meta: { analyticsEvent: analyticsEvent } })=>{
        const state = store.getState();
        const key = (0, $6FeJk.getIssueKeyById)(state, id);
        if (!key) return (0, $3JafE.Observable).empty();
        const isIssueDetailsShown = (0, $iJJay.getPanelType)(state) === (0, $fa44db75711523b7$export$e90b483346a763db);
        if (!withCmd && !withShift) // Single-select resets selected items and anchors
        return (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
            (0, $htXdF.setSelectionAnchors)([
                id
            ]),
            (0, $htXdF.setSelectedItemIds)([
                id
            ])
        ])), (0, $3JafE.Observable).of((0, $7cApO.setSelectedIssue)(key)));
        const parentIds = (0, $6FeJk.getIssueParentIdHash)(state);
        const selectedItemIds = (0, $11LHz.getSelectedItemIds)(state);
        const selectedItemLevel = selectedItemIds.length ? (0, $6FeJk.getIssueLevel)(state, selectedItemIds[0]) : level;
        const isSelectedItemIdsBaseLevel = (0, $kbiEp.isBaseLevel)(selectedItemLevel);
        // Prevent selecting items from a different level or parent when multi-selecting
        if (selectedItemIds.length && parentIds[selectedItemIds[0]] !== parentIds[id]) return (0, $3JafE.Observable).empty();
        const selectionAnchors = (0, $11LHz.getSelectionAnchors)(state);
        if (withShift) {
            const actions = [];
            const [anchorId] = selectionAnchors.slice(-1);
            // Do nothing if nothing is selected via shift multi-select
            if (anchorId === id) return (0, $3JafE.Observable).empty();
            const multiSelectItems = $e25d81579e69a981$var$getMultiSelectItems(state, id, anchorId, isSelectedItemIdsBaseLevel);
            // Append and dedupe the multi-select items when selecting via cmd + shift multi-select
            const updatedMultiSelectItems = withCmd ? selectedItemIds.filter((item)=>!multiSelectItems.includes(item)).concat(multiSelectItems) : multiSelectItems;
            const isInteractedItemsLimitExceeded = $e25d81579e69a981$var$getIsInteractedItemsLimitExceeded(state, isSelectedItemIdsBaseLevel, updatedMultiSelectItems, analyticsEvent);
            if (isInteractedItemsLimitExceeded) return (0, $3JafE.Observable).of((0, $9BmXV.interactedItemsLimitExceeded)());
            // Only keep the most recent anchor to avoid conflicting with selected items when selecting via shift multi-select
            selectionAnchors.length > 1 && actions.push((0, $htXdF.setSelectionAnchors)([
                anchorId
            ]));
            // Treat multi-select as single-select when no items were selected previously
            selectedItemIds.length ? actions.push((0, $htXdF.setSelectedItemIds)(updatedMultiSelectItems)) : actions.push((0, $htXdF.setSelectionAnchors)([
                id
            ]), (0, $htXdF.setSelectedItemIds)([
                id
            ]));
            const batchedActionsObservable = (0, $3JafE.Observable).of(actions.length > 1 ? (0, $MYW4e.batchActions)(actions) : actions[0]);
            // Update the issue details (if it's already shown) when selecting via shift multi-select
            return isIssueDetailsShown ? (0, $3JafE.Observable).concat(batchedActionsObservable, (0, $3JafE.Observable).of((0, $7cApO.setSelectedIssue)(key))) : batchedActionsObservable;
        }
        const selectedItemIndex = selectedItemIds.indexOf(id);
        const updatedSelectedItemIds = selectedItemIds.slice();
        const selectionAnchorIndex = selectionAnchors.indexOf(id);
        const updatedSelectionAnchors = selectionAnchors.slice();
        if (withCmd) {
            const actions = [];
            let issueKeyShown;
            if (selectedItemIds.length === 1 && selectedItemIndex === 0) {
                // Hide the issue details when the only item is deselected via cmd multi-select
                updatedSelectionAnchors.pop();
                updatedSelectedItemIds.pop();
                isIssueDetailsShown && actions.push((0, $7cApO.hidePanel)());
            } else {
                issueKeyShown = key;
                // Toggle the item and update anchors when (de)selecting via cmd multi-select
                if (selectedItemIndex === -1) {
                    updatedSelectionAnchors.push(id);
                    updatedSelectedItemIds.push(id);
                    const isInteractedItemsLimitExceeded = $e25d81579e69a981$var$getIsInteractedItemsLimitExceeded(state, isSelectedItemIdsBaseLevel, updatedSelectedItemIds, analyticsEvent);
                    if (isInteractedItemsLimitExceeded) return (0, $3JafE.Observable).of((0, $9BmXV.interactedItemsLimitExceeded)());
                } else {
                    const isAnchor = selectionAnchorIndex > -1;
                    isAnchor && updatedSelectionAnchors.splice(selectionAnchorIndex, 1);
                    updatedSelectedItemIds.splice(selectedItemIndex, 1);
                    const [prevSelectedItem] = updatedSelectedItemIds.slice(-1);
                    // Use a previously selected item since the last anchor was deselected
                    !updatedSelectionAnchors.length && updatedSelectionAnchors.push(prevSelectedItem);
                    // Update the issue details with a previously selected item when deselecting
                    if (prevSelectedItem !== id) issueKeyShown = (0, $6FeJk.getIssueKeyById)(state, prevSelectedItem);
                }
                if (isIssueDetailsShown && !issueKeyShown) actions.push((0, $7cApO.hidePanel)());
            }
            // Ensure the selection anchors and selected items are updated
            actions.unshift((0, $htXdF.setSelectionAnchors)(updatedSelectionAnchors), (0, $htXdF.setSelectedItemIds)(updatedSelectedItemIds));
            const batchedActionsObservable = (0, $3JafE.Observable).of((0, $MYW4e.batchActions)(actions));
            // Update the issue details (if it's already shown) when selecting via cmd multi-select
            return isIssueDetailsShown && issueKeyShown ? (0, $3JafE.Observable).concat(batchedActionsObservable, (0, $3JafE.Observable).of((0, $7cApO.setSelectedIssue)(issueKeyShown))) : batchedActionsObservable;
        }
        return (0, $3JafE.Observable).empty();
    });

});
const $fa44db75711523b7$export$e90b483346a763db = 'ISSUE_DETAILS';

parcelRegister("jxq2V", function(module, exports) {

$parcel$export(module.exports, "getIsInteractedItemsOverLimit", () => $2dfe4135c5fb782f$export$4b0e940e4f6d33c5);

var $1gs0D = parcelRequire("1gs0D");

var $6FeJk = parcelRequire("6FeJk");
const $2dfe4135c5fb782f$export$4b0e940e4f6d33c5 = (state, isBaseLevel, toBeSelectedItemIds)=>{
    if (isBaseLevel) return toBeSelectedItemIds.length > (0, $1gs0D.INTERACTED_ITEMS_LIMIT);
    const issueChildrenHash = (0, $6FeJk.getIssueChildrenHash)(state);
    let childItemsNo = 0;
    toBeSelectedItemIds.forEach((issueId)=>{
        const childIds = issueChildrenHash[issueId] || [];
        childItemsNo += childIds.length;
    });
    return toBeSelectedItemIds.length + childItemsNo > (0, $1gs0D.INTERACTED_ITEMS_LIMIT);
};

});

parcelRegister("iJJay", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $258f941e3cf71f37$export$fa00fa3d6c22a747);
const $258f941e3cf71f37$export$fa00fa3d6c22a747 = (state)=>state.ui.panel.panelType;

});

parcelRegister("g3uMy", function(module, exports) {

$parcel$export(module.exports, "fireInteractedItemsLimitExceededAnalytics", () => $4e056aae49fa533e$export$a66211dbb1def336);

var $jMP2a = parcelRequire("jMP2a");
const $4e056aae49fa533e$export$a66211dbb1def336 = (analyticsEvent)=>{
    const { actionSubject: actionSubject, action: action } = analyticsEvent.payload;
    const clonedEvent = analyticsEvent.clone();
    clonedEvent && (0, $jMP2a.fireTrackAnalytics)(clonedEvent, 'interactedItemsLimit exceeded', {
        trigger: `${actionSubject} ${action}`
    });
};

});


parcelRegister("ecqkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd86a4cc77d1a47d$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("dM0Xt");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("flmol");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $jJwwt = parcelRequire("jJwwt");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $jMP2a = parcelRequire("jMP2a");

var $kbiEp = parcelRequire("kbiEp");

var $3PMIz = parcelRequire("3PMIz");


var $hYQyG = parcelRequire("hYQyG");

var $1gs0D = parcelRequire("1gs0D");

var $cDvag = parcelRequire("cDvag");


var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $9BmXV = parcelRequire("9BmXV");


var $kbyLF = parcelRequire("kbyLF");

var $gdFA6 = parcelRequire("gdFA6");

var $iJJay = parcelRequire("iJJay");

var $11LHz = parcelRequire("11LHz");

var $aCPQO = parcelRequire("aCPQO");

var $16ixF = parcelRequire("16ixF");

var $5Ovv9 = parcelRequire("5Ovv9");

var $7J2Ol = parcelRequire("7J2Ol");

var $g3uMy = parcelRequire("g3uMy");

var $dtl39 = parcelRequire("dtl39");

var $6yFCa = parcelRequire("6yFCa");

var $91mgt = parcelRequire("91mgt");

var $4tOj7 = parcelRequire("4tOj7");
const $fd86a4cc77d1a47d$export$4addbf2b693857b = (isHiddenBySetting, issueIdObservable, issue, transitionId, startDateCustomFieldId, analyticsMetadata, sourceARI, unsafeIssueId)=>issueIdObservable.mergeMap((issueId)=>{
        const fieldMod = (0, $7J2Ol.getFieldModForIssueUpdate)(issue);
        return (0, $hYQyG.updateItemGraphqlOnServer)({
            sourceARI: sourceARI,
            input: {
                itemId: issueId,
                projectId: analyticsMetadata.projectId,
                summary: fieldMod?.summary,
                dueDate: (0, $dtl39.formatDate)(fieldMod?.dueDate),
                startDate: (0, $dtl39.formatDate)(fieldMod?.startDate),
                color: fieldMod?.color,
                parentId: fieldMod?.parentId,
                sprintId: fieldMod?.sprintId,
                clearFields: fieldMod?.clearFields
            }
        }).mergeMap((data)=>{
            const updateRoadmapItemData = data?.roadmaps?.updateRoadmapItem;
            const errors = updateRoadmapItemData?.errors;
            const success = updateRoadmapItemData?.success;
            if (success === false && errors?.length) {
                if ((0, $aCPQO.isPermissionError)(errors)) // Display Schedule issue permission error
                return (0, $3JafE.Observable).of((0, $9BmXV.updateItemPermission)()).map((permissionErrorAction)=>[
                        permissionErrorAction,
                        (0, $j45xj.resetTransitionState)({
                            issueId: unsafeIssueId,
                            transitionId: transitionId
                        })
                    ]);
                return (0, $16ixF.onHandleAggErrors)(!!updateRoadmapItemData, errors).map((aggErrorAction)=>[
                        aggErrorAction,
                        (0, $j45xj.resetTransitionState)({
                            issueId: unsafeIssueId,
                            transitionId: transitionId
                        })
                    ]);
            }
            const clonedEvent = analyticsMetadata.event.clone();
            if (clonedEvent) {
                const { level: level, updatedItems: updatedItems, issueTypeId: issueTypeId, hasOverdueReleaseDate: hasOverdueReleaseDate } = analyticsMetadata.attributes;
                (0, $jMP2a.fireTrackAnalytics)(clonedEvent, 'issue updated', issueId, {
                    level: level,
                    updatedItems: updatedItems,
                    issueTypeId: issueTypeId,
                    projectType: 'software',
                    hasOverdueReleaseDate: hasOverdueReleaseDate
                });
            }
            const actions = [
                (0, $j45xj.clearTransitionState)({
                    issueId: issueId,
                    transitionId: transitionId
                }, (0, $j45xj.UPDATE_ISSUE))
            ];
            if (!(0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)() && isHiddenBySetting) actions.push((0, $9BmXV.issueDisappearsFromDisplayRange)({
                issueId: issueId
            }));
            return (0, $3JafE.Observable).of(actions);
        });
    });
const $fd86a4cc77d1a47d$export$8cf807211b294d82 = (bypassSprintScopeCheck, modifiedProperties, analyticsEvent, issueId, issue, state, transitionId, hasOverdueReleaseDate)=>{
    if (!bypassSprintScopeCheck && modifiedProperties.sprintId !== undefined || modifiedProperties.clearFields?.includes((0, $3PMIz.SPRINT_IDS))) {
        const sourceSprintId = issue !== undefined && issue.sprintIds.value !== undefined && issue.sprintIds.value.length > 0 ? issue.sprintIds.value[0] : undefined;
        const sprintStateSelector = (0, $kbyLF.getSprintState)(state);
        const targetSprintState = sprintStateSelector(modifiedProperties.sprintId);
        const sourceSprintState = sprintStateSelector(sourceSprintId);
        if (targetSprintState === (0, $a7a73ddab4e749dd$export$2b35adb71b3f6143) || sourceSprintState === (0, $a7a73ddab4e749dd$export$2b35adb71b3f6143)) return (0, $9BmXV.sprintScopeChanged)({
            direction: targetSprintState === (0, $a7a73ddab4e749dd$export$2b35adb71b3f6143) ? (0, $34b1b2b25acc1092$export$11ee87f991dd6574) : (0, $34b1b2b25acc1092$export$be2c0bb3425b849c),
            issueId: issueId,
            targetSprintId: modifiedProperties.sprintId,
            sourceSprintId: sourceSprintId,
            properties: modifiedProperties,
            sourceEvent: analyticsEvent,
            transitionId: transitionId,
            hasOverdueReleaseDate: hasOverdueReleaseDate
        });
    }
    return undefined;
};
const $fd86a4cc77d1a47d$export$5764cb619636eedb = (updatedStartDate, updatedDueDate, isDragged)=>isDragged === true ? (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc((updatedStartDate + updatedDueDate) / 2).add(12, 'hours').startOf('day').valueOf() : updatedStartDate;
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$fd86a4cc77d1a47d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.UPDATE_ISSUE)).mergeMap(({ payload: { id: unsafeIssueId, properties: properties }, meta: { isDragged: isDragged, hasOverdueReleaseDate: hasOverdueReleaseDate, bypassSprintScopeCheck: bypassSprintScopeCheck, analyticsEvent: analyticsEvent } })=>{
        const state = store.getState();
        const issue = (0, $6FeJk.getIssue)(state, unsafeIssueId);
        if (issue === undefined) return (0, $3JafE.Observable).empty();
        let modifiedProperties = {
            ...properties
        };
        const sourceARI = (0, $lgKTA.getSourceARI)(state);
        const isSprintsPlanning = (0, $bwVWW.getIsSprintsPlanningEnabled)(state);
        const isChildIssuePlannedEnabled = (0, $bwVWW.getIsChildIssuePlanningEnabled)(state);
        const issueKey = (0, $6FeJk.getIssueKeyById)(state, unsafeIssueId);
        const projectId = (0, $bwVWW.getProjectId)(state);
        const issueTypeId = (0, $6FeJk.getIssueTypeIdForIssueId)(state, unsafeIssueId);
        const level = (0, $bwVWW.getEpicIssueTypeIds)(state).includes(issueTypeId) ? (0, $kbiEp.PARENT_LEVEL) : (0, $kbiEp.BASE_LEVEL);
        const isIssueBaseLevel = (0, $kbiEp.isBaseLevel)(level);
        if (isIssueBaseLevel) {
            const updatedStartDate = properties.startDate;
            const updatedDueDate = properties.dueDate;
            const currentSprintIds = issue?.sprintIds?.value ?? [];
            if (isSprintsPlanning && modifiedProperties.sprintId === undefined) {
                const intersectingSprintId = updatedStartDate === undefined || updatedDueDate === undefined ? undefined : (0, $kbyLF.createGetIntersectingSprintId)(state)($fd86a4cc77d1a47d$export$5764cb619636eedb(updatedStartDate, updatedDueDate, isDragged), currentSprintIds[currentSprintIds.length - 1]);
                const { startDate: startDate, dueDate: dueDate, ...otherProperties } = modifiedProperties;
                if (intersectingSprintId === undefined) modifiedProperties = otherProperties;
                else modifiedProperties = {
                    ...otherProperties,
                    sprintId: intersectingSprintId
                };
            }
            if (Object.keys(modifiedProperties).length === 0) return (0, $3JafE.Observable).empty();
        }
        let scheduleFields = [];
        const transitionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        const selectedItemIds = (0, $11LHz.getSelectedItemIds)(state);
        const prevStartDate = (0, $6FeJk.getIssueStartDate)(state, unsafeIssueId);
        const prevDueDate = (0, $6FeJk.getIssueDueDate)(state, unsafeIssueId);
        if (modifiedProperties.startDate === prevStartDate) delete modifiedProperties.startDate;
        if (modifiedProperties.dueDate === prevDueDate) delete modifiedProperties.dueDate;
        const childIds = (0, $6FeJk.getIssueChildrenHash)(state)[unsafeIssueId] || [];
        const canBulkSchedule = (0, $6yFCa.shouldBulkSchedule)(unsafeIssueId, modifiedProperties, {
            startDate: prevStartDate,
            dueDate: prevDueDate
        }, selectedItemIds);
        const canScheduleChildren = (0, $6yFCa.shouldScheduleChildrenIssues)(level, modifiedProperties, {
            startDate: prevStartDate,
            dueDate: prevDueDate
        }, childIds.length, isSprintsPlanning, isChildIssuePlannedEnabled);
        const isIssueOutsideSelection = selectedItemIds.length > 0 && !selectedItemIds.includes(unsafeIssueId);
        const isInteractedItemsLimitExceeded = canScheduleChildren && childIds.length + 1 > (0, $1gs0D.INTERACTED_ITEMS_LIMIT);
        const isIssueDetailsShown = (0, $iJJay.getPanelType)(state) === (0, $fa44db75711523b7$export$e90b483346a763db);
        const resetActions = (0, $5Ovv9.getResetActions)(isIssueOutsideSelection, isIssueOutsideSelection && isIssueDetailsShown);
        const resetObservable = resetActions.length ? (0, $3JafE.Observable).of(resetActions.length > 1 ? (0, $MYW4e.batchActions)(resetActions) : resetActions[0]) : (0, $3JafE.Observable).empty();
        if (canBulkSchedule || canScheduleChildren) {
            const { startDate: startDate, dueDate: dueDate } = modifiedProperties;
            if (isInteractedItemsLimitExceeded) (0, $g3uMy.fireInteractedItemsLimitExceededAnalytics)(analyticsEvent);
            else scheduleFields = (0, $6yFCa.getScheduleFieldsForBulkDatesUpdate)(store, unsafeIssueId, {
                startDate: startDate,
                dueDate: dueDate
            }, isIssueBaseLevel, selectedItemIds);
        }
        if (scheduleFields.length) return (0, $3JafE.Observable).concat(resetObservable, (0, $3JafE.Observable).of((0, $j45xj.scheduleIssues)(scheduleFields, analyticsEvent, hasOverdueReleaseDate)));
        // create new issue object
        const [transitionIssue, updatedItems] = (0, $91mgt.createTransitionIssueWithUpdatedItems)(issue, modifiedProperties, transitionId);
        const transitionExtend = (0, $6FeJk.getSafeId)(state, unsafeIssueId).mergeMap((issueId)=>{
            if (issueId === undefined) return (0, $3JafE.Observable).empty();
            const extendHash = {};
            extendHash[issueId] = transitionIssue;
            return (0, $3JafE.Observable).of((0, $j45xj.extendIssues)({
                sequence: [],
                hash: extendHash
            }));
        });
        const extendHash = {};
        extendHash[unsafeIssueId] = transitionIssue;
        const handlePersistUpdate = ()=>{
            const sprintScopeChangedAction = $fd86a4cc77d1a47d$export$8cf807211b294d82(bypassSprintScopeCheck, modifiedProperties, analyticsEvent, unsafeIssueId, issue, state, transitionId, hasOverdueReleaseDate);
            if (sprintScopeChangedAction) return (0, $3JafE.Observable).of(sprintScopeChangedAction);
            if (isInteractedItemsLimitExceeded) return (0, $3JafE.Observable).of((0, $9BmXV.interactedItemsLimitExceeded)({
                transitionId: transitionId,
                issueId: unsafeIssueId,
                hasOverdueReleaseDate: hasOverdueReleaseDate,
                properties: modifiedProperties,
                sourceEvent: analyticsEvent
            }));
            const { isHiddenBySetting: isHiddenBySetting } = (0, $7J2Ol.getIsIssueHiddenByFiltersOrSettings)(state, transitionIssue, unsafeIssueId);
            const analyticsMetadata = {
                event: analyticsEvent,
                projectId: projectId,
                attributes: {
                    issueTypeId: issueTypeId,
                    updatedItems: updatedItems,
                    level: level,
                    hasOverdueReleaseDate: hasOverdueReleaseDate
                }
            };
            return $fd86a4cc77d1a47d$export$4addbf2b693857b(isHiddenBySetting, (0, $6FeJk.getSafeId)(state, unsafeIssueId), transitionIssue, transitionId, (0, $bwVWW.getStartDateCustomFieldId)(state), analyticsMetadata, sourceARI, unsafeIssueId).map((actions)=>{
                (0, $4tOj7.default)(state, issueKey);
                return (0, $MYW4e.batchActions)(actions);
            }).catch(()=>(0, $3JafE.Observable).from([
                    (0, $9BmXV.aggError)(),
                    (0, $j45xj.resetTransitionState)({
                        issueId: unsafeIssueId,
                        transitionId: transitionId
                    })
                ]));
        };
        return (0, $3JafE.Observable).concat(resetObservable, // update `unsafe` issue first
        (0, $3JafE.Observable).of((0, $j45xj.extendIssues)({
            sequence: [],
            hash: extendHash
        }, (0, $j45xj.UPDATE_ISSUE))), // schedule update of persisted issue
        transitionExtend, handlePersistUpdate(), (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)() ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).of((0, $gdFA6.reapplyJQLFilters)()));
    });

});
parcelRegister("5Ovv9", function(module, exports) {

$parcel$export(module.exports, "getResetActions", () => $8f86a251bb901a14$export$3bc4b4116025636f);
$parcel$export(module.exports, "getSyncActions", () => $8f86a251bb901a14$export$dcee6b662e166418);

var $eI5EY = parcelRequire("eI5EY");


var $6FeJk = parcelRequire("6FeJk");

var $7cApO = parcelRequire("7cApO");

var $iJJay = parcelRequire("iJJay");

var $htXdF = parcelRequire("htXdF");

var $11LHz = parcelRequire("11LHz");
const $8f86a251bb901a14$export$3bc4b4116025636f = (shouldResetSelection = true, shouldHidePanel = true)=>{
    const actions = shouldResetSelection ? [
        (0, $htXdF.setSelectionAnchors)([]),
        (0, $htXdF.setSelectedItemIds)([])
    ] : [];
    const panelActions = shouldHidePanel ? [
        (0, $7cApO.hidePanel)()
    ] : [];
    return actions.concat(panelActions);
};
const $8f86a251bb901a14$export$dcee6b662e166418 = (state, key)=>{
    const selectedItemIds = (0, $11LHz.getSelectedItemIds)(state);
    const isIssueDetailsShown = (0, $iJJay.getPanelType)(state) === (0, $fa44db75711523b7$export$e90b483346a763db);
    const id = (0, $6FeJk.getIssueKeyToIdHash)(state)[key ?? ''] ?? '';
    if (!key) return $8f86a251bb901a14$export$3bc4b4116025636f(selectedItemIds.length === 1, isIssueDetailsShown);
    const selectedItemIndex = selectedItemIds.indexOf(id);
    const actions = (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? [
        (0, $htXdF.setSelectionAnchors)([
            id
        ])
    ] : [
        (0, $htXdF.setSelectionAnchors)([
            id
        ]),
        (0, $htXdF.setSelectedItemIds)([
            id
        ])
    ];
    const panelActions = isIssueDetailsShown ? [] : [
        (0, $7cApO.showPanel)((0, $fa44db75711523b7$export$e90b483346a763db))
    ];
    return id && selectedItemIndex === -1 ? actions.concat(panelActions) : panelActions;
};

});

parcelRegister("dtl39", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $8c738578eeac9da8$export$3ae94a2503e890a1);
// eslint-disable-next-line jira/restricted/moment

var $jJwwt = parcelRequire("jJwwt");
const $8c738578eeac9da8$export$3ae94a2503e890a1 = (date)=>date !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).format('YYYY-MM-DD') : null;

});

parcelRegister("6yFCa", function(module, exports) {

$parcel$export(module.exports, "shouldScheduleChildrenIssues", () => $6e5e0fa3fcf68222$export$f98ee0b182e34597);
$parcel$export(module.exports, "shouldBulkSchedule", () => $6e5e0fa3fcf68222$export$5b71390452906e47);
$parcel$export(module.exports, "getScheduleFieldsForBulkDatesUpdate", () => $6e5e0fa3fcf68222$export$d9763154bd67b2b3);

var $kbiEp = parcelRequire("kbiEp");

var $fHtBB = parcelRequire("fHtBB");

var $4P2VV = parcelRequire("4P2VV");

var $lfgcv = parcelRequire("lfgcv");

var $6FeJk = parcelRequire("6FeJk");

var $crWmP = parcelRequire("crWmP");

var $fTkuC = parcelRequire("fTkuC");

var $dpcYO = parcelRequire("dpcYO");
const $6e5e0fa3fcf68222$export$f98ee0b182e34597 = (level, { startDate: startDate, dueDate: dueDate }, { startDate: prevStartDate, dueDate: prevDueDate }, numberOfChildren, isSprintsPlanning, isChildIssuePlanningEnabled)=>{
    /**
	 * When parent bar is dragged (i.e. both start and due dates are updated), then child bars also dragged together.
	 * When parent bar is resized (i.e. only one of start of due dates are updated), then child bars are unaffected.
	 */ const isParentWithChildren = !(0, $kbiEp.isBaseLevel)(level) && numberOfChildren > 0;
    const isBothDatesPopulated = startDate !== undefined && dueDate !== undefined;
    const isBothDatesUpdated = startDate !== prevStartDate && dueDate !== prevDueDate;
    return isChildIssuePlanningEnabled && !isSprintsPlanning && isParentWithChildren && isBothDatesPopulated && isBothDatesUpdated;
};
const $6e5e0fa3fcf68222$export$5b71390452906e47 = (targetItem, { startDate: startDate, dueDate: dueDate }, { startDate: prevStartDate, dueDate: prevDueDate }, selectedItemIds)=>{
    const isDraggingOrResizing = startDate !== undefined || dueDate !== undefined;
    const isDateUpdated = startDate !== prevStartDate || dueDate !== prevDueDate;
    return isDraggingOrResizing && isDateUpdated && selectedItemIds.length > 1 && selectedItemIds.includes(targetItem);
};
const $6e5e0fa3fcf68222$export$a43c8446bad60ee = (startDate, dueDate, timelineDuration, offset)=>{
    const direction = offset < 0 ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
    const { startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds } = timelineDuration;
    let newOffset = offset;
    if (direction === (0, $4P2VV.LEFT) && startDate !== undefined) {
        const maxLeftOffset = -Math.max(0, startDate - startMilliseconds);
        newOffset = Math.max(maxLeftOffset, offset);
    } else if (direction === (0, $4P2VV.RIGHT) && dueDate !== undefined) {
        const maxRightOffset = Math.max(0, endMilliseconds - dueDate - (0, $fHtBB.DUE_DATE_OFFSET));
        newOffset = Math.min(maxRightOffset, offset);
    }
    const newStartDate = startDate !== undefined ? startDate + newOffset : undefined;
    const newDueDate = dueDate !== undefined ? dueDate + newOffset : undefined;
    return {
        startDate: newStartDate,
        dueDate: newDueDate
    };
};
/**
 * Get issue ids and its properties for bulk-scheduling issues, which handles
 * - multiple bar-dragging (same issue hierarchy)
 * - multiple bar-resizing (same issue hierarchy)
 * - single bar-dragging BUT with child bars dragged along
 * It calculates the dates offset from the interacted issue (target issue) and apply it to all selected issues including hidden child issues.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6e5e0fa3fcf68222$var$EMPTY_HASH = {};
const $6e5e0fa3fcf68222$var$getFlippedDates = (startDate, dueDate)=>startDate !== undefined && dueDate !== undefined && startDate > dueDate ? [
        dueDate,
        startDate
    ] : [
        startDate,
        dueDate
    ];
const $6e5e0fa3fcf68222$export$d9763154bd67b2b3 = (store, targetIssueId, { startDate: startDate, dueDate: dueDate }, isIssueBaseLevel, selectedItemIds)=>{
    const state = store.getState();
    let prevExplicitStartDate = (0, $6FeJk.getIssueStartDate)(state, targetIssueId);
    let prevExplicitDueDate = (0, $6FeJk.getIssueDueDate)(state, targetIssueId);
    // If the dates were flipped previously, flip them back before scheduling
    [prevExplicitStartDate, prevExplicitDueDate] = $6e5e0fa3fcf68222$var$getFlippedDates(prevExplicitStartDate, prevExplicitDueDate);
    const { startDate: prevRolledUpStartDate, dueDate: prevRolledUpDueDate } = isIssueBaseLevel ? $6e5e0fa3fcf68222$var$EMPTY_HASH // base-level issues won't have rolled-up dates since bulk-scheduling is not applicable to interval derived dates
     : (0, $fTkuC.getParentRolledUpDatesHash)(state)[targetIssueId] ?? $6e5e0fa3fcf68222$var$EMPTY_HASH;
    const { startDate: prevInferredStartDate, dueDate: prevInferredDueDate } = (0, $crWmP.getChartDateData)(prevExplicitStartDate, prevExplicitDueDate, isIssueBaseLevel ? (0, $kbiEp.BASE_LEVEL) : (0, $kbiEp.PARENT_LEVEL), true);
    const scheduleFields = [];
    let offset = 0;
    if (startDate !== undefined && prevExplicitStartDate !== undefined) offset = startDate - prevExplicitStartDate;
    else if (dueDate !== undefined && prevExplicitDueDate !== undefined) offset = dueDate - prevExplicitDueDate;
    else if (startDate !== undefined && prevRolledUpStartDate !== undefined) offset = startDate - prevRolledUpStartDate;
    else if (dueDate !== undefined && prevRolledUpDueDate !== undefined) offset = dueDate - prevRolledUpDueDate;
    else if (startDate !== undefined && prevInferredStartDate !== undefined) offset = startDate - prevInferredStartDate;
    else if (dueDate !== undefined && prevInferredDueDate !== undefined) offset = dueDate - prevInferredDueDate;
    const timelineDuration = (0, $dpcYO.getTimelineDuration)(state);
    const issueChildrenHash = (0, $6FeJk.getIssueChildrenHash)(state);
    const minTimelineDateRange = (0, $dpcYO.getMinTimelineDateRange)(state);
    const isResizing = startDate === undefined || dueDate === undefined;
    const isBulkScheduling = selectedItemIds.length > 1 && selectedItemIds.includes(targetIssueId);
    const targetItems = isBulkScheduling ? selectedItemIds : [
        targetIssueId
    ];
    const targetItemsChidren = [];
    // Only consider handling child issues when
    // - the interacted issue is a parent issue AND
    // - the interaction is bar-dragging (both start and due dates are updated)
    if (!isIssueBaseLevel && !isResizing) targetItems.forEach((issueId)=>{
        const childIds = issueChildrenHash[issueId] || [];
        childIds.length && targetItemsChidren.push(...childIds);
    });
    // For the directly interacted item,
    // - [bar-dragging] use new dates as they are always defined
    // - [bar-dragging] turn placeholder dates (undefined) into set dates
    // - [bar-resizing] use previous dates as fallback (even it's undefined) since the new dates can be undefined for the side that's not resized
    // - [bar-resizing] turn placeholder dates (undefined) into set dates if it's the side that's resized
    scheduleFields.push({
        issueId: targetIssueId,
        startDate: startDate ?? prevExplicitStartDate,
        dueDate: dueDate ?? prevExplicitDueDate
    });
    // For bulk scheduled items with the same issue hierarchy,
    // - [bar-dragging] use new dates as they are always defined
    // - [bar-dragging] turn placeholder dates (undefined) into set dates (need to extrapolate from roll-up dates and offset)
    // - [bar-resizing] use previous dates as fallback (even it's undefined) since the new dates can be undefined for the side that's not resized
    // - [bar-resizing] turn placeholder dates (undefined) into set dates if it's the side that's resized (need to extrapolate from roll-up dates and offset)
    targetItems.forEach((issueId)=>{
        if (issueId === targetIssueId) return;
        const isStartDateResized = isResizing && dueDate === undefined;
        const isDueDateResized = isResizing && startDate === undefined;
        let issueExplicitStartDate = (0, $6FeJk.getIssueStartDate)(state, issueId);
        let issueExplicitDueDate = (0, $6FeJk.getIssueDueDate)(state, issueId);
        // If the dates of a bulk-scheduled issue were flipped previously, flip them back just like conventional scheduling
        [issueExplicitStartDate, issueExplicitDueDate] = $6e5e0fa3fcf68222$var$getFlippedDates(issueExplicitStartDate, issueExplicitDueDate);
        const { startDate: issueRolledUpStartDate, dueDate: issueRolledUpDueDate } = isIssueBaseLevel ? $6e5e0fa3fcf68222$var$EMPTY_HASH : (0, $fTkuC.getParentRolledUpDatesHash)(state)[issueId] ?? $6e5e0fa3fcf68222$var$EMPTY_HASH;
        const { startDate: issueInferredStartDate, dueDate: issueInferredDueDate } = (0, $crWmP.getChartDateData)(issueExplicitStartDate, issueExplicitDueDate, isIssueBaseLevel ? (0, $kbiEp.BASE_LEVEL) : (0, $kbiEp.PARENT_LEVEL), true);
        // Calculate all possible dates, so placeholder dates (undefined) can be turned into set dates where possible
        const { startDate: newStartDate, dueDate: newDueDate } = $6e5e0fa3fcf68222$export$a43c8446bad60ee(issueExplicitStartDate ?? issueRolledUpStartDate ?? issueInferredStartDate, issueExplicitDueDate ?? issueRolledUpDueDate ?? issueInferredDueDate, timelineDuration, offset);
        // Exclude issues without date changes
        if (issueExplicitStartDate !== newStartDate || issueExplicitDueDate !== newDueDate) {
            // [bar-dragging] Only turn placeholders dates (undefined) into a set date if the date is being scheduled
            let cappedStartDate = isDueDateResized ? issueExplicitStartDate : newStartDate;
            let cappedDueDate = isStartDateResized ? issueExplicitDueDate : newDueDate;
            // [bar-resizing] Cap the dates to form a bar with minimal lengh if the dates are about to be flipped after bulk scheduling
            if (isResizing && cappedStartDate !== undefined && cappedDueDate !== undefined && cappedDueDate - cappedStartDate < minTimelineDateRange) {
                if (isStartDateResized) cappedStartDate = (0, $lfgcv.getEndOfDay)(cappedDueDate - minTimelineDateRange);
                else cappedDueDate = (0, $lfgcv.getStartOfDay)(cappedStartDate + minTimelineDateRange);
            }
            scheduleFields.push({
                issueId: issueId,
                startDate: cappedStartDate,
                dueDate: cappedDueDate
            });
        }
    });
    // For bulk scheduled items with a sub issue hierarchy,
    // - [bar-dragging] use new dates as they are always defined
    // - [bar-dragging] keep placeholder dates (undefined) as they are
    // - [bar-resizing] invalid cases - child items will never get resized with their parents
    targetItemsChidren.forEach((issueId)=>{
        const issueExplicitStartDate = (0, $6FeJk.getIssueStartDate)(state, issueId);
        const issueExplicitDueDate = (0, $6FeJk.getIssueDueDate)(state, issueId);
        const { startDate: newStartDate, dueDate: newDueDate } = $6e5e0fa3fcf68222$export$a43c8446bad60ee(issueExplicitStartDate, issueExplicitDueDate, timelineDuration, offset);
        // Exclude child issues without date changes
        if (issueExplicitStartDate !== newStartDate || issueExplicitDueDate !== newDueDate) scheduleFields.push({
            issueId: issueId,
            startDate: newStartDate,
            dueDate: newDueDate
        });
    });
    return scheduleFields;
};

});


parcelRegister("DEW9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $0446877c09769e90$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("dM0Xt");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("flmol");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $65uQX = parcelRequire("65uQX");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $jMP2a = parcelRequire("jMP2a");

var $hYQyG = parcelRequire("hYQyG");

var $cDvag = parcelRequire("cDvag");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $9BmXV = parcelRequire("9BmXV");

var $gdFA6 = parcelRequire("gdFA6");

var $16ixF = parcelRequire("16ixF");

var $7J2Ol = parcelRequire("7J2Ol");

var $dtl39 = parcelRequire("dtl39");

var $g5l0l = parcelRequire("g5l0l");

var $91mgt = parcelRequire("91mgt");

var $4tOj7 = parcelRequire("4tOj7");
const $0446877c09769e90$export$6cafb1506b079115 = (issueIdObservable, issue, transitionId, unsafeRankRequest, analyticsMetadata, sourceARI)=>issueIdObservable.flatMap((issueId)=>unsafeRankRequest.flatMap((request)=>{
            let aggRank;
            if ('rankBeforeId' in request) aggRank = {
                id: request.rankBeforeId,
                position: 'BEFORE'
            };
            else if ('rankAfterId' in request) aggRank = {
                id: request.rankAfterId,
                position: 'AFTER'
            };
            const fields = {
                ...(0, $7J2Ol.getFieldModForIssueUpdate)(issue),
                rank: aggRank
            };
            return (0, $hYQyG.updateItemGraphqlOnServer)({
                sourceARI: sourceARI,
                input: {
                    itemId: issueId,
                    projectId: analyticsMetadata.projectId,
                    summary: fields.summary,
                    dueDate: (0, $dtl39.formatDate)(fields.dueDate),
                    startDate: (0, $dtl39.formatDate)(fields.startDate),
                    color: fields.color,
                    parentId: fields.parentId,
                    sprintId: fields.sprintId,
                    clearFields: fields.clearFields,
                    rank: fields.rank
                }
            }).flatMap((data)=>{
                const updateRoadmapItemData = data?.roadmaps?.updateRoadmapItem;
                const errors = updateRoadmapItemData?.errors;
                const success = updateRoadmapItemData?.success;
                if (success === false && errors?.length) return (0, $16ixF.onHandleAggErrors)(!!updateRoadmapItemData, errors).map((aggErrorAction)=>[
                        (0, $j45xj.clearTransitionState)({
                            issueId: issueId,
                            transitionId: transitionId
                        }),
                        aggErrorAction
                    ]);
                const clonedEvent = analyticsMetadata.event.clone();
                if (clonedEvent) {
                    const attributes = {
                        ...analyticsMetadata.attributes,
                        projectType: 'software'
                    };
                    (0, $jMP2a.fireTrackAnalytics)(clonedEvent, 'issue updated', attributes);
                }
                if ((0, $1ybV0.ff)('odin.ec.client.integration')) (0, $65uQX.default).saveIssueMutationToCache(new (0, $48mPv.default)(issueId.toString(), (0, $d7Wfe.MutationSource).UPDATE));
                return (0, $3JafE.Observable).of([
                    (0, $j45xj.clearTransitionState)({
                        issueId: issueId,
                        transitionId: transitionId
                    })
                ]);
            });
        }));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$0446877c09769e90$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.UPDATE_RANK_ISSUE)).flatMap((action)=>{
        const unsafeIssueId = action.payload.issueId;
        const { rankRequest: rankRequest } = action.payload;
        const state = store.getState();
        const sourceARI = (0, $lgKTA.getSourceARI)(state);
        const issue = (0, $6FeJk.getIssue)(state, unsafeIssueId);
        const issueKey = (0, $6FeJk.getIssueKeyById)(state, unsafeIssueId);
        const projectId = (0, $bwVWW.getProjectId)(state);
        const issueTypeId = (0, $6FeJk.getIssueTypeIdForIssueId)(state, unsafeIssueId);
        const level = (0, $bwVWW.getEpicIssueTypeIds)(state).includes(issueTypeId) ? 1 : 0;
        if (issue === undefined) return (0, $3JafE.Observable).empty();
        if (!(0, $bwVWW.rankIssuesSupported)(state)) {
            const { parentId: parentId } = action.payload.properties;
            const clonedEvent = action.meta.analyticsEvent.clone();
            if (clonedEvent) {
                const attributes = {
                    projectType: 'software',
                    parentIdUpdated: true
                };
                (0, $jMP2a.fireTrackAnalytics)(clonedEvent, 'issue disabledRankDrop', attributes);
            }
            return (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $9BmXV.unableToRankIssue)({
                boardId: (0, $lgKTA.getBoardId)(state)
            })), (0, $3JafE.Observable).of((0, $j45xj.updateAndPersistIssue)(unsafeIssueId, {
                parentId: parentId
            }, action.meta.analyticsEvent)));
        }
        // Find out new sequence
        const sequence = (0, $6FeJk.getIssueIds)(state);
        let anchorId;
        let isBefore = true;
        if ('rankBeforeId' in rankRequest) anchorId = rankRequest.rankBeforeId;
        else {
            isBefore = false;
            anchorId = rankRequest.rankAfterId;
        }
        const issueIndex = sequence.indexOf(unsafeIssueId);
        sequence.splice(issueIndex, 1);
        let anchorIndex = sequence.indexOf(anchorId);
        if (isBefore === false) anchorIndex += 1;
        sequence.splice(anchorIndex, 0, unsafeIssueId);
        const transitionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        // create new issue object
        const [transitionIssue, updatedItems] = (0, $91mgt.createTransitionIssueWithUpdatedItems)(issue, action.payload.properties, transitionId);
        const transitionExtend = (0, $6FeJk.getSafeId)(store.getState(), unsafeIssueId).flatMap((issueId)=>{
            if (issueId === undefined) return (0, $3JafE.Observable).empty();
            const extendHash = {};
            extendHash[issueId] = transitionIssue;
            return (0, $3JafE.Observable).of((0, $j45xj.extendIssues)({
                sequence: [
                    ...sequence
                ],
                hash: extendHash
            }));
        });
        const extendHash = {};
        extendHash[unsafeIssueId] = transitionIssue;
        const analyticsMetadata = {
            event: action.meta.analyticsEvent,
            projectId: projectId,
            attributes: {
                issueTypeId: issueTypeId,
                updatedItems: [
                    ...updatedItems,
                    {
                        name: 'rank'
                    }
                ],
                level: level
            }
        };
        const safeRankRequest = (0, $g5l0l.getSafeRankRequest)(state, rankRequest);
        return (0, $3JafE.Observable).concat(// update `unsafe` issue first
        (0, $3JafE.Observable).of((0, $j45xj.extendIssues)({
            sequence: [],
            hash: extendHash
        })), // schedule update of persisted issue
        transitionExtend, $0446877c09769e90$export$6cafb1506b079115((0, $6FeJk.getSafeId)(store.getState(), unsafeIssueId), transitionIssue, transitionId, safeRankRequest, analyticsMetadata, sourceARI).map((actions)=>{
            (0, $4tOj7.default)(state, issueKey);
            if ('old' in transitionIssue.parentId) {
                const { parentId: { old: prevParentId, value: nextParentId } } = transitionIssue;
                prevParentId && (0, $4tOj7.default)(state, (0, $6FeJk.getIssueKeyById)(state, prevParentId));
                nextParentId && (0, $4tOj7.default)(state, (0, $6FeJk.getIssueKeyById)(state, nextParentId));
            }
            return (0, $MYW4e.batchActions)(actions);
        }).catch(()=>(0, $3JafE.Observable).from([
                (0, $9BmXV.aggError)()
            ])), (0, $cDvag.isStateChangeBasedIssueHiddenFlagsEnabled)() ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).of((0, $gdFA6.reapplyJQLFilters)()));
    });

});


parcelRegister("3Jg4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b093c65129242f7$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $ko6Xw = parcelRequire("ko6Xw");

var $lc7wD = parcelRequire("lc7wD");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$5b093c65129242f7$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $ko6Xw.default), (0, $lc7wD.default));

});
parcelRegister("ko6Xw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b06b63d0b203942$export$2e2bcd8739ae039);
parcelRequire("3GQRI");
parcelRequire("8jBvP");
parcelRequire("fiQ2m");
parcelRequire("jnCPY");
parcelRequire("8OtG5");

var $3JafE = parcelRequire("3JafE");

var $3iMaY = parcelRequire("3iMaY");

var $j45xj = parcelRequire("j45xj");

var $61Xo4 = parcelRequire("61Xo4");

var $gdFA6 = parcelRequire("gdFA6");

var $7cApO = parcelRequire("7cApO");

var $htXdF = parcelRequire("htXdF");

var $aSTh4 = parcelRequire("aSTh4");
var /**
 * This ops adds the custom data attributes to the UFO events.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$4b06b63d0b203942$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j45xj.CREATE_ISSUE), (0, $gdFA6.SET_TIMELINE_MODE), (0, $gdFA6.SET_STATUS_CATEGORY_FILTER), (0, $gdFA6.SET_ISSUE_TYPE_FILTER), (0, $gdFA6.SET_ASSIGNEE_FILTER), (0, $gdFA6.SET_TEXT_FILTER), (0, $gdFA6.SET_LABEL_FILTER), (0, $gdFA6.SET_ISSUE_PARENT_FILTER), (0, $gdFA6.SET_VERSION_FILTER), (0, $gdFA6.SET_COMPONENT_FILTER), (0, $htXdF.CHANGE_EXPANSION_STATE), (0, $htXdF.SET_CREATE_ITEM_ANCHOR), (0, $aSTh4.SET_PROGRESS_VISIBILITY), (0, $aSTh4.SET_RELEASES_VISIBILITY), (0, $aSTh4.SET_LEVEL_ONE_SETTING), (0, $aSTh4.SET_DEPENDENCIES_VIEW_VISIBILITY), (0, $htXdF.SHOW_TOOLTIP), (0, $7cApO.SHOW_PANEL), (0, $7cApO.SET_SELECTED_ISSUE)).concatMap(()=>{
        const interactionPerformanceExtraData = (0, $61Xo4.getInteractionPerformanceExtraData)(store.getState());
        (0, $3iMaY.addUFOCustomData)(interactionPerformanceExtraData);
        return (0, $3JafE.Observable).empty();
    }).ignoreElements();

});
parcelRegister("61Xo4", function(module, exports) {

$parcel$export(module.exports, "getInteractionPerformanceExtraData", () => $ddd0f8d011276a5b$export$f44b2ebb2dd51306);

var $df4Sl = parcelRequire("df4Sl");

var $lgKTA = parcelRequire("lgKTA");

var $9ZLrP = parcelRequire("9ZLrP");

var $9E22T = parcelRequire("9E22T");

var $hjI8T = parcelRequire("hjI8T");
const $ddd0f8d011276a5b$export$f44b2ebb2dd51306 = (0, $df4Sl.createSelector)((0, $9ZLrP.getTimelineMode), (0, $9E22T.getFilteredIssueCount), (0, $9ZLrP.getNumJQLFiltersApplied), (0, $9ZLrP.isDependenciesVisible), (0, $9ZLrP.isProgressVisible), (0, $hjI8T.getIsReleasesVisible), (0, $lgKTA.hasMacroConfig), (timelineMode, filteredIssueCount, numJQLFiltersApplied, dependenciesVisible, progressVisible, releasesVisible, isMacro)=>({
        timelineMode: timelineMode,
        filteredIssueCount: filteredIssueCount,
        numJQLFiltersApplied: numJQLFiltersApplied,
        dependenciesVisible: dependenciesVisible,
        progressVisible: progressVisible,
        releasesVisible: releasesVisible,
        isMacro: isMacro
    }));

});


parcelRegister("lc7wD", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaca25aa0cb60e51$export$2e2bcd8739ae039);

var $dBQte = parcelRequire("dBQte");
parcelRequire("3wBUP");
parcelRequire("jnCPY");


var $lQHIu = parcelRequire("lQHIu");

var $j45xj = parcelRequire("j45xj");

var $gdFA6 = parcelRequire("gdFA6");
var /**
 * Listens for redux actions that may cause the JQL filters to be reapplied, and times how long it takes for them to be
 * reapplied. It will cancel the timer if another action is detected, since the reapply op cancels requests in a similar
 * way.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$eaca25aa0cb60e51$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $j45xj.CREATE_ISSUE), (0, $j45xj.UPDATE_ISSUE), (0, $j45xj.SCHEDULE_ISSUES)).switchMap(()=>{
        (0, $lQHIu.interactionPerformance).start((0, $028d5637f56fe710$export$a0d61e9ea4ad5a05));
        return action$.ofType((0, $gdFA6.JQL_FILTERS_SUCCESS)).take(1).pipe((0, $dBQte.tap)(()=>(0, $lQHIu.interactionPerformance).stop((0, $028d5637f56fe710$export$a0d61e9ea4ad5a05))));
    }).ignoreElements();

});
parcelRegister("lQHIu", function(module, exports) {

$parcel$export(module.exports, "interactionPerformance", () => $19af757e8783a193$export$5815a965e990dd4f);
$parcel$export(module.exports, "InteractionMetricsExtraData", () => $19af757e8783a193$export$45dbc3f8ac9dc78c);

var $lNNXV = parcelRequire("lNNXV");

var $61Xo4 = parcelRequire("61Xo4");

var $iyXW5 = parcelRequire("iyXW5");
const $19af757e8783a193$export$5815a965e990dd4f = (0, $iyXW5.default)();
const $19af757e8783a193$var$CaptureInteractionMetricsExtraData = ({ interactionPerformanceExtraData: interactionPerformanceExtraData })=>{
    $19af757e8783a193$export$5815a965e990dd4f.setExtraData(interactionPerformanceExtraData);
    return null;
};
const $19af757e8783a193$export$45dbc3f8ac9dc78c = (0, $lNNXV.connect)((state)=>({
        interactionPerformanceExtraData: (0, $61Xo4.getInteractionPerformanceExtraData)(state)
    }), {})($19af757e8783a193$var$CaptureInteractionMetricsExtraData);

});
parcelRegister("iyXW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c312d6484dad7d$export$2e2bcd8739ae039);

var $9ouT3 = parcelRequire("9ouT3");
const $a7c312d6484dad7d$var$interactionPerformanceMetricFactory = ()=>{
    let lastExtraData;
    return {
        setExtraData: (extraData)=>{
            lastExtraData = extraData;
        },
        start: (type)=>{
            const performanceMetrics = (0, $9ouT3.interactionMetrics)[type];
            performanceMetrics?.cancel();
            performanceMetrics?.start();
        },
        stop: (type)=>{
            const performanceMetrics = (0, $9ouT3.interactionMetrics)[type];
            performanceMetrics?.stop({
                customData: {
                    ...lastExtraData ?? undefined
                }
            });
        }
    };
};
var $a7c312d6484dad7d$export$2e2bcd8739ae039 = $a7c312d6484dad7d$var$interactionPerformanceMetricFactory;

});




parcelRegister("Pkh3j", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d2d069d6d2e9d72$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $kSyvy = parcelRequire("kSyvy");

var $aL8B6 = parcelRequire("aL8B6");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$8d2d069d6d2e9d72$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $aL8B6.default), (0, $kSyvy.default));

});
parcelRegister("kSyvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6df5de3b36c71e9$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $lgKTA = parcelRequire("lgKTA");

var $dFuRD = parcelRequire("dFuRD");

var $aD3n2 = parcelRequire("aD3n2");

var $5Ovv9 = parcelRequire("5Ovv9");
var /* This epic keeps the panel state synchronised with the url.
 * This is necessary because the url is the source of truth for the visibility of the issue details panel type.
 * E.g. Users may come to the page from a shared link or bookmark, or navigate history. This may affect the panel visibility in the UI.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$c6df5de3b36c71e9$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $dFuRD.ROUTER_LOCATION_CHANGE)).mergeMap(({ payload: location })=>{
        const state = store.getState();
        const { selectedIssue: selectedIssue } = (0, $aD3n2.convertStringToQuery)(location.search, (0, $lgKTA.getRoadmapType)(state));
        const actions = (0, $5Ovv9.getSyncActions)(state, selectedIssue);
        return actions.length ? (0, $3JafE.Observable).of(actions.length > 1 ? (0, $MYW4e.batchActions)(actions) : actions[0]) : (0, $3JafE.Observable).empty();
    });

});

parcelRegister("aL8B6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea33a70b3d6e268$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $7cApO = parcelRequire("7cApO");

var $hoVIs = parcelRequire("hoVIs");
var /* This epic sets the selected issue by updating the relevant url parameter.
 * You can pass undefined to effectively un-select the current issues.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$cea33a70b3d6e268$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $7cApO.SET_SELECTED_ISSUE)).map((action)=>{
        const state = store.getState();
        const issueKey = action.payload;
        return (0, $hoVIs.default)(push, state, (query)=>({
                ...query,
                selectedIssue: issueKey
            }));
    });

});


parcelRegister("f2OcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7f743a60564699a$export$2e2bcd8739ae039);

var $dBQte = parcelRequire("dBQte");


var $Tnz9v = parcelRequire("Tnz9v");

var $2DqCi = parcelRequire("2DqCi");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$b7f743a60564699a$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $2DqCi.UPDATE_RESOURCE_CACHE)).pipe((0, $dBQte.tap)(({ payload: payload })=>{
        (0, $Tnz9v.default).next({
            origin: (0, $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822),
            payload: {
                roadmapData: payload
            }
        });
    }));

});

parcelRegister("gZQty", function(module, exports) {

$parcel$export(module.exports, "default", () => $d608364cd748a65f$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $M0U6U = parcelRequire("M0U6U");

var $gxZCl = parcelRequire("gxZCl");

var $1epo2 = parcelRequire("1epo2");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d608364cd748a65f$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $1epo2.default), (0, $gxZCl.default), (0, $M0U6U.default));

});
parcelRegister("M0U6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bba2e62201b1018$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $6FeJk = parcelRequire("6FeJk");

var $htXdF = parcelRequire("htXdF");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$8bba2e62201b1018$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $htXdF.EXPAND_ALL_ISSUES), (0, $htXdF.COLLAPSE_ALL_ISSUES)).map((action)=>{
        const { type: type } = action;
        const state = store.getState();
        const issueParentIds = (0, $6FeJk.getIssueParentIds)(state);
        const isExpanded = type === (0, $htXdF.EXPAND_ALL_ISSUES);
        return (0, $htXdF.bulkChangeExpansionState)({
            ids: issueParentIds,
            isExpanded: isExpanded
        });
    });

});

parcelRegister("gxZCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6e1c496173775c2$export$2e2bcd8739ae039);
parcelRequire("iects");
parcelRequire("8jBvP");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $6FeJk = parcelRequire("6FeJk");

var $11pvk = parcelRequire("11pvk");

var $htXdF = parcelRequire("htXdF");

var $ifWeD = parcelRequire("ifWeD");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$c6e1c496173775c2$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $htXdF.CHANGE_EXPANSION_STATE), (0, $htXdF.BULK_CHANGE_EXPANSION_STATE)).mergeMap((action)=>{
        const { type: type, payload: payload } = action;
        const { isExpanded: isExpanded } = payload;
        if (!isExpanded) return (0, $3JafE.Observable).empty();
        const epicIds = type === (0, $htXdF.CHANGE_EXPANSION_STATE) ? [
            payload.id
        ] : payload.ids;
        const state = store.getState();
        const issueIds = epicIds.flatMap((epicId)=>(0, $6FeJk.getIssueChildrenHash)(state)[epicId] ?? []);
        const fullSubtaskHash = (0, $11pvk.getFullSubtasksHash)(state);
        const issuesWithoutSubtask = issueIds.filter((issueId)=>fullSubtaskHash[issueId] === undefined);
        if (issuesWithoutSubtask.length === 0) return (0, $3JafE.Observable).empty();
        return (0, $ifWeD.reloadSubtaskProgress)(store, issuesWithoutSubtask);
    });

});

parcelRegister("1epo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $af88becde1c7e275$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $5MpXz = parcelRequire("5MpXz");

var $hoVIs = parcelRequire("hoVIs");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$af88becde1c7e275$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, $5MpXz.SET_HIGHLIGHTED_VERSIONS)).map((action)=>(0, $hoVIs.default)(push, store.getState(), (query)=>({
                ...query,
                highlightedVersions: action.payload.length > 0 ? action.payload : undefined
            })));

});


parcelRegister("iwQNI", function(module, exports) {

$parcel$export(module.exports, "getCanUserInviteEpic", () => $a6cc2fabed0f6767$export$89828008460b535c);
parcelRequire("jyKN9");
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $JRB5w = parcelRequire("JRB5w");

var $2HjcN = parcelRequire("2HjcN");

var $ecAMT = parcelRequire("ecAMT");

var $lgKTA = parcelRequire("lgKTA");

var $xbB8r = parcelRequire("xbB8r");

var $bwVWW = parcelRequire("bwVWW");
const $a6cc2fabed0f6767$export$89828008460b535c = (action$, store)=>action$.ofType((0, $ecAMT.INITIALIZE_NON_CRITICAL_DATA)).switchMap(()=>{
        const state = store.getState();
        const isCMP = (0, $lgKTA.isClassic)(state);
        if (isCMP || !(0, $79xbN.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment')) return (0, $3JafE.Observable).of();
        const projectId = Number((0, $bwVWW.getProjectId)(state));
        return (0, $2HjcN.fetchCanUserInviteService)(projectId).mergeMap((canUserInviteResponse)=>(0, $3JafE.Observable).of((0, $xbB8r.setCanUserInvite)(canUserInviteResponse))).catch((error)=>{
            if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'timeline.can-user-invite.load.failure',
                    packageName: 'jiraSoftwareRoadmapStandard',
                    teamName: 'chronos'
                }
            });
            return (0, $3JafE.Observable).of();
        });
    });

});
parcelRegister("2HjcN", function(module, exports) {

$parcel$export(module.exports, "fetchCanUserInviteService", () => $aaa4d79326763685$export$583ef539d905855);
parcelRequire("bI4RP");

var $aiRd8 = parcelRequire("aiRd8");
const $aaa4d79326763685$var$getCanInviteOthersUrl = (projectId)=>`/rest/internal/latest/invite-user/project/${projectId}/can-invite-others`;
const $aaa4d79326763685$export$22c733f1adfb0925 = (projectId)=>(0, $aiRd8.default)($aaa4d79326763685$var$getCanInviteOthersUrl(projectId), {
        method: 'GET'
    });
const $aaa4d79326763685$export$583ef539d905855 = (projectId)=>$aaa4d79326763685$export$22c733f1adfb0925(projectId);

});


parcelRegister("d2dJm", function(module, exports) {

$parcel$export(module.exports, "default", () => $db5ea62cea42020a$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $3nJe9 = parcelRequire("3nJe9");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$db5ea62cea42020a$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $3nJe9.default));

});
parcelRegister("3nJe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c153b982a42ca1$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $huI7r = parcelRequire("huI7r");

var $a1Dvi = parcelRequire("a1Dvi");

var $lgKTA = parcelRequire("lgKTA");

var $xbB8r = parcelRequire("xbB8r");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$32c153b982a42ca1$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $xbB8r.SET_VERSION)).mergeMap(({ payload: { id: id } })=>{
        const state = store.getState();
        const cloudId = (0, $lgKTA.getCloudId)(state);
        const activationId = (0, $lgKTA.getActivationId)(state);
        const versionAri = (0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'version',
            activationId: activationId,
            resourceId: id
        });
        cloudId && activationId && (0, $a1Dvi.removeVersionDetailsCache)(versionAri);
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("a1Dvi", function(module, exports) {

$parcel$export(module.exports, "removeVersionDetailsCache", () => $ae9fb79872ca3b2d$export$b2c0b3575fda481c);
$parcel$export(module.exports, "getVersionDetailsFromServer", () => $ae9fb79872ca3b2d$export$6ad0cbfa40c89e6d);
parcelRequire("flmol");
parcelRequire("1Lcr1");


var $jhVpU = parcelRequire("jhVpU");

var $bWZzJ = parcelRequire("bWZzJ");

var $hA4Pc = parcelRequire("hA4Pc");
const $ae9fb79872ca3b2d$var$CACHE_SIZE = 50;
const $ae9fb79872ca3b2d$export$e29d82aabb0f64f = (0, $jhVpU.default)({
    size: $ae9fb79872ca3b2d$var$CACHE_SIZE,
    cacheKey: 'roadmap-version-details-cache',
    storageType: (0, $834cc2f16be60bc5$export$bf340b99118a1511)
});
const $ae9fb79872ca3b2d$export$b2c0b3575fda481c = (versionAri)=>{
    const cacheKey = versionAri.toString();
    return $ae9fb79872ca3b2d$export$e29d82aabb0f64f.remove(cacheKey);
};
const $ae9fb79872ca3b2d$export$6ad0cbfa40c89e6d = (versionAri, intl)=>{
    const cacheKey = versionAri.toString();
    return $ae9fb79872ca3b2d$export$e29d82aabb0f64f.get(cacheKey).then((data)=>{
        if (data !== undefined) return data;
        return (0, $bWZzJ.fetchVersionDetails)(versionAri).toPromise().then((response)=>{
            const versionDetails = (0, $hA4Pc.transformVersionDetails)(response, intl);
            $ae9fb79872ca3b2d$export$e29d82aabb0f64f.set(cacheKey, versionDetails);
            return versionDetails;
        });
    });
};

});
parcelRegister("jhVpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a98829846b4116$export$2e2bcd8739ae039);

var $kBiqn = parcelRequire("kBiqn");
const $47a98829846b4116$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47a98829846b4116$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $kBiqn.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $47a98829846b4116$var$pNothing,
        update: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $47a98829846b4116$var$pNothing
    };
};

});

parcelRegister("bWZzJ", function(module, exports) {

$parcel$export(module.exports, "fetchVersionDetails", () => $034b1fda4a79dbe5$export$7148f3bfb84532da);

var $gUUjF = parcelRequire("gUUjF");

var $4ghcx = parcelRequire("4ghcx");


var $8sMwH = parcelRequire("8sMwH");

var $9ouT3 = parcelRequire("9ouT3");
const $034b1fda4a79dbe5$var$concurrentMetricDefinition = (0, $9ouT3.queryMetrics)[0, $028d5637f56fe710$export$ede40e627a0cbf14];
const $034b1fda4a79dbe5$var$analyticKey = 'jira.frontend.fe.software.roadmap.version-details';
const $034b1fda4a79dbe5$export$7148f3bfb84532da = (versionAri)=>(0, $8sMwH.runQueryWithMetadataAndSelector)((0, $4ghcx.default), {
        versionAri: versionAri
    }, $034b1fda4a79dbe5$var$analyticKey, $034b1fda4a79dbe5$var$concurrentMetricDefinition, (data)=>data.jira.version).map(({ data: data })=>data).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('getVersionDetails', 'getVersionDetails failed', error);
        throw error;
    });

});
parcelRegister("4ghcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4728fb0b572e2c78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<29ef59f9daac427229ed7b906e39ccc2>>
 * @relayHash cde6a02fbb3e988a67f25278696a70bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16dbcd61c253daeede3a24c3baddf1a6ba9b5cc226a5184f833fdc8bbf4c31cf
const $4728fb0b572e2c78$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v6 = {
        "kind": "ScalarField",
        "name": "releaseDate"
    }, v7 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "TODO"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "IN_PROGRESS"
        }
    ], v10 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ], v11 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDetailsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v3 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.version.versionId"
                                            },
                                            v4 /*: any*/ ,
                                            v5 /*: any*/ ,
                                            v6 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "alias": "todoIssues",
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v8 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.version.todoIssues.totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "issues(filter:\"TODO\")"
                                                },
                                                "action": "THROW",
                                                "path": "jira.version.todoIssues"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "alias": "inProgressIssues",
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v8 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.version.inProgressIssues.totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                },
                                                "action": "THROW",
                                                "path": "jira.version.inProgressIssues"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "alias": "doneIssues",
                                                    "args": v10 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v8 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.version.doneIssues.totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "issues(filter:\"DONE\")"
                                                },
                                                "action": "THROW",
                                                "path": "jira.version.doneIssues"
                                            }
                                        ],
                                        "type": "JiraVersion"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDetailsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "alias": "todoIssues",
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v11 /*: any*/ ,
                                            "storageKey": "issues(filter:\"TODO\")"
                                        },
                                        {
                                            "alias": "inProgressIssues",
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v11 /*: any*/ ,
                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                        },
                                        {
                                            "alias": "doneIssues",
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v11 /*: any*/ ,
                                            "storageKey": "issues(filter:\"DONE\")"
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "16dbcd61c253daeede3a24c3baddf1a6ba9b5cc226a5184f833fdc8bbf4c31cf",
            "metadata": {},
            "name": "versionDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4728fb0b572e2c78$var$node.hash = "5d5e1bd006f223be75c2d70927a59808";
var $4728fb0b572e2c78$export$2e2bcd8739ae039 = $4728fb0b572e2c78$var$node;

});


parcelRegister("hA4Pc", function(module, exports) {

$parcel$export(module.exports, "transformVersionDetails", () => $b95b19b0f8e20480$export$40f792aaeb1b9eb9);

var $eNsvS = parcelRequire("eNsvS");

var $eUylY = parcelRequire("eUylY");

var $etZVu = parcelRequire("etZVu");

var $aRqha = parcelRequire("aRqha");
const $b95b19b0f8e20480$export$40f792aaeb1b9eb9 = (version, { formatMessage: formatMessage })=>{
    if (version.__typename === 'JiraVersion') {
        const { versionId: id, description: description, startDate: startDate, releaseDate: releaseDate, todoIssues: todoIssues, inProgressIssues: inProgressIssues, doneIssues: doneIssues } = version;
        const progress = [
            {
                id: `version-${id}-in-progress`,
                name: formatMessage((0, $aRqha.default).inProgress),
                count: inProgressIssues.totalCount,
                color: (0, $eNsvS.IN_PROGRESS_COLOR_HIGHER_CONTRAST)
            },
            {
                id: `version-${id}-done`,
                name: formatMessage((0, $aRqha.default).done),
                count: doneIssues.totalCount,
                color: (0, $eNsvS.DONE_COLOR_HIGHER_CONTRAST)
            },
            {
                id: `version-${id}-todo`,
                name: formatMessage((0, $aRqha.default).todo),
                count: todoIssues.totalCount,
                color: (0, $eNsvS.TODO_COLOR_HIGHER_CONTRAST)
            }
        ];
        return {
            id: id,
            description: description || '',
            startDate: (0, $eUylY.optionalDateToUtcTimestamp)((0, $etZVu.nullableToOptional)(startDate)),
            releaseDate: (0, $eUylY.optionalDateToUtcTimestamp)((0, $etZVu.nullableToOptional)(releaseDate)),
            progress: progress
        };
    }
    throw new Error(`Invalid version type: ${version.__typename}`);
};

});
parcelRegister("eNsvS", function(module, exports) {

$parcel$export(module.exports, "TODO_COLOR_HIGHER_CONTRAST", () => $0aa5c6d1540f1ad7$export$8a8f905ccf4b0050);
$parcel$export(module.exports, "IN_PROGRESS_COLOR_HIGHER_CONTRAST", () => $0aa5c6d1540f1ad7$export$15757ae585322101);
$parcel$export(module.exports, "DONE_COLOR_HIGHER_CONTRAST", () => $0aa5c6d1540f1ad7$export$b718e067b2a5f1e5);

const $0aa5c6d1540f1ad7$export$9a2ce699a8e88c00 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $0aa5c6d1540f1ad7$export$8a8f905ccf4b0050 = `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $0aa5c6d1540f1ad7$export$dc4e31a90347554e = `var(--ds-text-information, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`;
const $0aa5c6d1540f1ad7$export$15757ae585322101 = `var(--ds-border-information, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`;
const $0aa5c6d1540f1ad7$export$f2a648c26a91297f = `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`;
const $0aa5c6d1540f1ad7$export$b718e067b2a5f1e5 = `var(--ds-border-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`;

});

parcelRegister("aRqha", function(module, exports) {

$parcel$export(module.exports, "default", () => $572a49587bb8562b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $572a49587bb8562b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    todo: {
        "id": "software-roadmap-services.version.todo",
        "defaultMessage": "To Do"
    },
    inProgress: {
        "id": "software-roadmap-services.version.in-progress",
        "defaultMessage": "In Progress"
    },
    done: {
        "id": "software-roadmap-services.version.done",
        "defaultMessage": "Done"
    }
});

});






parcelRegister("2XiKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac00aba42461cace$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $dbcRM = parcelRequire("dbcRM");

var $9Cvv0 = parcelRequire("9Cvv0");

var $8skBf = parcelRequire("8skBf");
var $ac00aba42461cace$export$2e2bcd8739ae039 = (0, $fh5V5.combineStorage)((0, $dbcRM.default), (0, $8skBf.default), (0, $9Cvv0.default));

});
parcelRegister("fh5V5", function(module, exports) {

$parcel$export(module.exports, "defineSimpleStorage", () => $c9746cee77ef46b1$export$b3e4b068c8b91397);
$parcel$export(module.exports, "combineStorage", () => $c9746cee77ef46b1$export$2d3e45efc84ee30f);
parcelRequire("jAXdN");
parcelRequire("jyKN9");

var $9DhEq = parcelRequire("9DhEq");

var $fUTZC = parcelRequire("fUTZC");

var $hTLlD = parcelRequire("hTLlD");

var $lUFEu = parcelRequire("lUFEu");

var $3JafE = parcelRequire("3JafE");
const $c9746cee77ef46b1$export$94c6bb4af8700ddd = (requestedStorageKeys, hydrationActionCreator, stateConnector, transformer)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let memoizedProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isModified = (newProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(newProps, (val, key)=>!memoizedProps || !memoizedProps[key] || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(memoizedProps[key], val));
    return {
        hydrate: (state, engine)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const params = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(requestedStorageKeys(state), (storageKey)=>{
                params.push(engine.get(storageKey));
            });
            if (params.length === 0) return (0, $3JafE.Observable).of([]);
            return (0, $3JafE.Observable).zip(...params, (args)=>{
                const { value: currentValue } = stateConnector(state);
                if (args !== null && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(args, currentValue)) return (0, (/*@__PURE__*/$parcel$interopDefault($9DhEq)))([
                    hydrationActionCreator(args)
                ]);
                return [];
            });
        },
        modify: (state, engine)=>{
            const props = stateConnector(state);
            if (!engine.allowsModificationWithoutHydration && memoizedProps === undefined) // in hydration
            memoizedProps = props;
            else if (isModified(props)) {
                const transformed = transformer(props);
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(transformed, (prop, key)=>engine.set(key, prop));
                memoizedProps = props;
            }
        }
    };
};
const $c9746cee77ef46b1$export$b3e4b068c8b91397 = (key, hydrationActionCreator, stateConnector)=>$c9746cee77ef46b1$export$94c6bb4af8700ddd(()=>[
            key()
        ], hydrationActionCreator, (state)=>({
            value: stateConnector(state)
        }), (t)=>({
            [key()]: t.value
        }));
const $c9746cee77ef46b1$export$2d3e45efc84ee30f = (...storageConfigs)=>({
        hydrate: (state, engine)=>{
            const hydrations = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(storageConfigs, (def)=>{
                hydrations.push(def.hydrate(state, engine));
            });
            const flat = (0, (/*@__PURE__*/$parcel$interopDefault($9DhEq)))(hydrations);
            if (flat.length === 0) return (0, $3JafE.Observable).of([]);
            return (0, $3JafE.Observable).zip(...flat, (...hydrationActions)=>(0, (/*@__PURE__*/$parcel$interopDefault($9DhEq)))(hydrationActions));
        },
        modify: (state, engine)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(storageConfigs, (def)=>{
                def.modify(state, engine);
            });
        }
    });

});
parcelRegister("9DhEq", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");
/** Used as references for various `Number` constants. */ var $703572b8b756f789$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $703572b8b756f789$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? $hKE3p(array, $703572b8b756f789$var$INFINITY) : [];
}
module.exports = $703572b8b756f789$var$flattenDeep;

});

parcelRegister("lUFEu", function(module, exports) {

var $jqs7R = parcelRequire("jqs7R");

var $7qARj = parcelRequire("7qARj");

var $8v3yf = parcelRequire("8v3yf");

var $1c8hB = parcelRequire("1c8hB");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $ff3f232f92bb24aa$var$some(collection, predicate, guard) {
    var func = $1c8hB(collection) ? $jqs7R : $8v3yf;
    if (guard && $3P7i5(collection, predicate, guard)) predicate = undefined;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $ff3f232f92bb24aa$var$some;

});
parcelRegister("8v3yf", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6303f9332a27a1b4$var$baseSome(collection, predicate) {
    var result;
    $awetI(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $6303f9332a27a1b4$var$baseSome;

});



parcelRegister("dbcRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $24fa0109cbe073f0$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $gn9h7 = parcelRequire("gn9h7");

var $jBcAQ = parcelRequire("jBcAQ");

var $2zhqB = parcelRequire("2zhqB");

var $kPIWr = parcelRequire("kPIWr");

var $gnPSm = parcelRequire("gnPSm");

var $jR9Nd = parcelRequire("jR9Nd");
var $24fa0109cbe073f0$export$2e2bcd8739ae039 = (0, $fh5V5.combineStorage)((0, $gnPSm.default), (0, $gn9h7.default), (0, $2zhqB.default), (0, $jR9Nd.default), (0, $kPIWr.default), (0, $jBcAQ.default));

});
parcelRegister("gn9h7", function(module, exports) {

$parcel$export(module.exports, "default", () => $200861338080d892$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $9ZLrP = parcelRequire("9ZLrP");

var $aSTh4 = parcelRequire("aSTh4");
var $200861338080d892$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'isDependenciesVisible', (isVisible)=>isVisible === null ? [] : [
        (0, $aSTh4.setDependenciesViewVisibility)(isVisible)
    ], (state)=>(0, $9ZLrP.isDependenciesVisible)(state));

});

parcelRegister("jBcAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d812ade7104274$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $9ZLrP = parcelRequire("9ZLrP");

var $aSTh4 = parcelRequire("aSTh4");
var $f2d812ade7104274$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'levelOneViewSettings', (levelOneSetting)=>levelOneSetting === null ? [] : [
        (0, $aSTh4.setLevelOneSetting)(levelOneSetting)
    ], (state)=>(0, $9ZLrP.getLevelOneSetting)(state));

});

parcelRegister("2zhqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b9bc3606ecda1ac$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $aSTh4 = parcelRequire("aSTh4");

var $kz9g9 = parcelRequire("kz9g9");
var $6b9bc3606ecda1ac$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'isProgressVisible', (isVisible)=>isVisible === null ? [] : [
        (0, $aSTh4.setProgressVisibility)(isVisible)
    ], (state)=>(0, $kz9g9.isProgressVisibleInView)(state));

});

parcelRegister("kPIWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9bf1b6a4769c96$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $aSTh4 = parcelRequire("aSTh4");

var $kz9g9 = parcelRequire("kz9g9");
var $bc9bf1b6a4769c96$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'isReleasesVisible', (isVisible)=>isVisible === null ? [] : [
        (0, $aSTh4.setReleasesVisibility)(isVisible)
    ], (state)=>(0, $kz9g9.isReleasesVisibleInView)(state));

});

parcelRegister("gnPSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1ef60cea8badef$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $9ZLrP = parcelRequire("9ZLrP");

var $gdFA6 = parcelRequire("gdFA6");
var $9e1ef60cea8badef$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'timelineMode', (timelineMode)=>timelineMode === null ? [] : [
        (0, $gdFA6.setTimelineMode)(timelineMode)
    ], (state)=>(0, $9ZLrP.getTimelineMode)(state));

});

parcelRegister("jR9Nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $60fdf5d37720918b$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $aSTh4 = parcelRequire("aSTh4");

var $kz9g9 = parcelRequire("kz9g9");
var $60fdf5d37720918b$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'isWarningsVisible', (isVisible)=>isVisible === null ? [] : [
        (0, $aSTh4.setWarningsVisibility)(isVisible)
    ], (state)=>(0, $kz9g9.isWarningsVisibleInView)(state));

});


parcelRegister("9Cvv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa6b34c9add2fb8e$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $5LHSf = parcelRequire("5LHSf");
var $fa6b34c9add2fb8e$export$2e2bcd8739ae039 = (0, $fh5V5.combineStorage)((0, $5LHSf.default));

});
parcelRegister("5LHSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bee3b18f165310f4$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $5MpXz = parcelRequire("5MpXz");

var $9N1AA = parcelRequire("9N1AA");
var // @ts-expect-error - Type 'number | null | undefined' does not satisfy the constraint 'GenericStorageValue'.
$bee3b18f165310f4$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'issuePanelRatio', (issuePanelRatio)=>issuePanelRatio ? [
        (0, $5MpXz.setIssuePanelRatio)(issuePanelRatio)
    ] : [], (state)=>(0, $9N1AA.getIssuePanelRatio)(state) || null);

});


parcelRegister("8skBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c335674b1dce8d2$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $cMOYx = parcelRequire("cMOYx");

var $i44ZD = parcelRequire("i44ZD");

var $7qM9F = parcelRequire("7qM9F");
var $7c335674b1dce8d2$export$2e2bcd8739ae039 = (0, $fh5V5.combineStorage)((0, $cMOYx.default), (0, $7qM9F.default), (0, $i44ZD.default));

});
parcelRegister("cMOYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c97333244855d5$export$2e2bcd8739ae039);

var $df4Sl = parcelRequire("df4Sl");

var $fUTZC = parcelRequire("fUTZC");

var $fh5V5 = parcelRequire("fh5V5");

var $bwVWW = parcelRequire("bwVWW");

var $5MpXz = parcelRequire("5MpXz");

var $9N1AA = parcelRequire("9N1AA");
const $62c97333244855d5$var$STORAGE_KEY = 'creationPreferences';
// Make sure to exclude any types that may have been deleted from the project
const $62c97333244855d5$var$transformCreationPreferences = (creationPreferences, issueTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const itemTypes = {};
    const safeCreationPreferences = {
        itemTypes: itemTypes
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(creationPreferences.itemTypes, (preference, level)=>{
        // Can we still find the stored issueType in the retrieved issue types
        if (issueTypes[preference.itemTypeId]) itemTypes[level] = preference;
    });
    safeCreationPreferences.itemTypes = itemTypes;
    return safeCreationPreferences;
};
const $62c97333244855d5$var$mappedPreference = (0, $df4Sl.createSelector)((0, $9N1AA.getCreationPreferences), (0, $bwVWW.getFullIssueTypeHash), $62c97333244855d5$var$transformCreationPreferences);
var $62c97333244855d5$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>$62c97333244855d5$var$STORAGE_KEY, (creationPreferences)=>creationPreferences === null ? [] : [
        (0, $5MpXz.setCreationPreferences)(creationPreferences)
    ], (state)=>$62c97333244855d5$var$mappedPreference(state));

});

parcelRegister("i44ZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e74219d18f8dac6$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $hjI8T = parcelRequire("hjI8T");

var $5MpXz = parcelRequire("5MpXz");
var $4e74219d18f8dac6$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'highlightedVersions', (highlightedVersions)=>highlightedVersions === null ? [] : [
        (0, $5MpXz.setHighlightedVersions)(highlightedVersions)
    ], (state)=>(0, $hjI8T.getHighlightedVersions)(state));

});

parcelRegister("7qM9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a9bf4b5e172bbec$export$2e2bcd8739ae039);

var $fh5V5 = parcelRequire("fh5V5");

var $5MpXz = parcelRequire("5MpXz");

var $9N1AA = parcelRequire("9N1AA");
var $1a9bf4b5e172bbec$export$2e2bcd8739ae039 = (0, $fh5V5.defineSimpleStorage)(()=>'listWidth', (listWidth)=>listWidth === null ? [] : [
        (0, $5MpXz.setListWidth)(listWidth)
    ], (state)=>(0, $9N1AA.getListWidth)(state));

});



parcelRegister("g8PwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $80e82427e2d047e8$export$2e2bcd8739ae039);

var $8FRHo = parcelRequire("8FRHo");

var $hLwwF = parcelRequire("hLwwF");

var $1gs0D = parcelRequire("1gs0D");

var $9BmXV = parcelRequire("9BmXV");

var $hcRcR = parcelRequire("hcRcR");

var $a3fi2 = parcelRequire("a3fi2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80e82427e2d047e8$export$2e2bcd8739ae039 = (type, rootEpic, rootEpicDependencies)=>{
    const middlewares = [
        (0, $hLwwF.default)((0, $1gs0D.toRoadmapAppId)(type), (0, $9BmXV.generalError)),
        (0, $hcRcR.default)
    ];
    return (0, $8FRHo.default)({
        appName: (0, $1gs0D.toRoadmapAppId)(type),
        rootReducer: $a3fi2.default,
        rootEpic: rootEpic,
        rootEpicDependencies: rootEpicDependencies,
        middlewares: middlewares
    });
};

});
parcelRegister("hLwwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2862a2f270e4342c$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $8xmdY = parcelRequire("8xmdY");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $2862a2f270e4342c$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $gUUjF.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $8xmdY.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $2862a2f270e4342c$export$2e2bcd8739ae039 = $2862a2f270e4342c$var$errorHandling;

});

parcelRegister("hcRcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f3344180e6afd9f$export$2e2bcd8739ae039);


var $hdVXV = parcelRequire("hdVXV");

var $ecAMT = parcelRequire("ecAMT");

var $xbB8r = parcelRequire("xbB8r");

var $jktkh = parcelRequire("jktkh");

var $j45xj = parcelRequire("j45xj");

var $a2ne3 = parcelRequire("a2ne3");

var $g1CaY = parcelRequire("g1CaY");

var $5MpXz = parcelRequire("5MpXz");

var $gdFA6 = parcelRequire("gdFA6");

var $8ybWM = parcelRequire("8ybWM");

var $7cApO = parcelRequire("7cApO");

var $56Mmd = parcelRequire("56Mmd");

var $htXdF = parcelRequire("htXdF");
const $2f3344180e6afd9f$var$ELIGIBLE_FOR_INVALIDATION = /^(state\.).+$/;
// We ignore the flag actions
const $2f3344180e6afd9f$var$ROADMAP_IGNORE_REGEX = /^(state\.flags\.).+$/;
const $2f3344180e6afd9f$export$d4b7dead01a52ae = ({ type: type })=>{
    switch(type){
        case 0, $ecAMT.INITIALIZE_APP_PROPS:
        case 0, $ecAMT.INITIALIZE_CRITICAL_DATA:
        case 0, $ecAMT.INITIALIZE_NON_CRITICAL_DATA:
        case 0, $ecAMT.UPDATE_CRITICAL_DATA:
        case 0, $5MpXz.SET_SETTINGS:
        case 0, $xbB8r.SET_CONFIGURATION:
        case 0, $xbB8r.SET_TODAY:
        case 0, $xbB8r.SET_DERIVE_FIELDS:
        case 0, $xbB8r.DERIVE_FIELDS_REQUEST:
        case 0, $htXdF.SET_CREATE_ITEM_ANCHOR:
        case 0, $htXdF.RESET_CREATE_ITEM_ANCHOR:
        case 0, $j45xj.EXTEND_ISSUES:
        case 0, $a2ne3.MERGE_STATUS_CATEGORIES:
        case 0, $gdFA6.SET_TEXT_FILTER:
        case 0, $gdFA6.CLEAR_FILTER:
        case 0, $gdFA6.SET_ISSUE_TYPE_FILTER:
        case 0, $gdFA6.SET_LABEL_FILTER:
        case 0, $gdFA6.SET_ISSUE_PARENT_FILTER:
        case 0, $gdFA6.SET_VERSION_FILTER:
        case 0, $gdFA6.SET_COMPONENT_FILTER:
        case 0, $gdFA6.SET_QUICK_FILTERS_FILTER:
        case 0, $gdFA6.QUICK_FILTERS_REQUEST:
        case 0, $gdFA6.JQL_FILTERS_SUCCESS:
        case 0, $gdFA6.QUICK_FILTERS_CLEAR:
        case 0, $gdFA6.SET_CUSTOM_FILTER:
        case 0, $gdFA6.CUSTOM_FILTERS_CLEAR:
        case 0, $gdFA6.SET_ASSIGNEE_FILTER:
        case 0, $gdFA6.SET_STATUS_CATEGORY_FILTER:
        case 0, $gdFA6.SET_FILTER_CONFIGURATION:
        case 0, $56Mmd.SET_SHARED:
        case 0, $htXdF.CHANGE_EXPANSION_STATE:
        case 0, $htXdF.SHOW_TOOLTIP:
        case 0, $htXdF.HIDE_TOOLTIP:
        case 0, $7cApO.SHOW_ISSUE_DETAILS:
        case 0, $7cApO.HIDE_PANEL:
        case 0, $7cApO.SET_SELECTED_ISSUE:
        case 0, $g1CaY.REALTIME_DISPATCH_EVENT:
        case 0, $8ybWM.EXTEND_ISSUE_TYPE_COUNT:
        case 0, $8ybWM.RETRIEVE_ISSUE_TYPE_COUNT:
        case 0, $8ybWM.SET_RESOLVING:
        case 0, $8ybWM.RESOLVE:
        case 0, $jktkh.SET_GOALS:
        case 0, $gdFA6.SET_GOAL_FILTER:
            return false;
        default:
            break;
    }
    // Ignore stuff that isn't applicable (e.g. COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION)
    if (!$2f3344180e6afd9f$var$ELIGIBLE_FOR_INVALIDATION.exec(type) || $2f3344180e6afd9f$var$ROADMAP_IGNORE_REGEX.exec(type)) return false;
    // Just invalidate on anything. We'll roll out some exclusion logic in the next PR
    return true;
};
var $2f3344180e6afd9f$export$2e2bcd8739ae039 = (0, $hdVXV.default)((0, $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822), $2f3344180e6afd9f$export$d4b7dead01a52ae);

});
parcelRegister("hdVXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf16d328e2c4f433$export$2e2bcd8739ae039);

var $ieUWD = parcelRequire("ieUWD");
const $cf16d328e2c4f433$export$41c940a04807c68c = (subject)=>(origin, invalidationFunction)=>()=>(next)=>(action)=>{
                    // There is a potential that the action gets passed as undefined
                    if (action && invalidationFunction(action)) {
                        // Trigger cache invalidation. Let the listeners handle everything else
                        subject.next(origin);
                        (0, $ieUWD.addInvalidationReason)(origin, action.type ?? 'UNKNOWN');
                    }
                    return next(action);
                };
var $cf16d328e2c4f433$export$2e2bcd8739ae039 = $cf16d328e2c4f433$export$41c940a04807c68c((0, $ieUWD.default));

});


parcelRegister("a3fi2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d218d2df1fe1db0$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $hHm5E = parcelRequire("hHm5E");

var $hCoE6 = parcelRequire("hCoE6");

var $7BdYu = parcelRequire("7BdYu");

var $cJlXZ = parcelRequire("cJlXZ");

var $atMh2 = parcelRequire("atMh2");

var $4TiJy = parcelRequire("4TiJy");

var $e4GSN = parcelRequire("e4GSN");
var $1d218d2df1fe1db0$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    app: $hHm5E.default,
    configuration: $hCoE6.default,
    entities: $7BdYu.default,
    ui: $e4GSN.default,
    router: $atMh2.default,
    settings: $4TiJy.default,
    metadata: $cJlXZ.default
});

});
parcelRegister("hHm5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d86c08352f773a$export$2e2bcd8739ae039);

var $huI7r = parcelRequire("huI7r");


var $ecAMT = parcelRequire("ecAMT");
const $e7d86c08352f773a$var$sourceAri = (0, $huI7r.createAri)({
    resourceOwner: '',
    cloudId: '',
    resourceType: 'board',
    resourceId: ''
});
const $e7d86c08352f773a$var$defaultState = {
    boardId: 0,
    loggedInAccountId: '',
    cloudId: undefined,
    activationId: undefined,
    sourceAri: $e7d86c08352f773a$var$sourceAri,
    isReadOnly: false,
    macroConfig: undefined,
    type: (0, $27ecaf74a39e2b82$export$296f840b5ae7056e),
    containerName: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e7d86c08352f773a$export$2e2bcd8739ae039 = (state = $e7d86c08352f773a$var$defaultState, action)=>{
    switch(action.type){
        case 0, $ecAMT.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("hCoE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $24fa706bbe9c8f04$export$2e2bcd8739ae039);


var $xbB8r = parcelRequire("xbB8r");
// there is no valid initial state.
// this state will be set by the INITIALIZE op, after which it will be valid
// for the rest of the app lifetime. before INITIALIZE, the entire app is invalid
// and must only ever show a spinner or similar
const $24fa706bbe9c8f04$var$initialState = {
    today: 0,
    rankIssuesSupported: false,
    isCrossProject: false,
    startDateCustomFieldId: '',
    lexoRankCustomFieldId: '',
    colorCustomFieldId: '',
    epicLinkCustomFieldId: '',
    epicNameCustomFieldId: '',
    sprintCustomFieldId: '',
    inwardDependencyDescription: undefined,
    outwardDependencyDescription: undefined,
    dependenciesSupported: false,
    projectConfiguration: {
        id: '',
        key: '',
        name: '',
        permissions: {
            canEditIssues: false,
            canScheduleIssues: false,
            canCreateIssues: false,
            canAdministerProjects: false
        },
        epicIssueTypeIds: [],
        requiredFields: {},
        issueTypes: {
            hash: {}
        },
        versions: {
            hash: {}
        },
        components: {
            hash: {}
        },
        defaultItemTypeId: undefined,
        isReleasesFeatureEnabled: false,
        isGoalsFeatureEnabled: false
    },
    boardConfiguration: {
        isUserBoardAdmin: false,
        jql: null,
        isBoardJqlFilteringOutEpics: false,
        isSprintsFeatureEnabled: false,
        isChildIssuePlanningEnabled: false,
        sprints: {
            hash: {},
            sequence: []
        },
        childIssuePlanningMode: (0, $0237521e367b8052$export$8cd212c10b4124d2)
    },
    hierarchyConfiguration: {
        levelOneName: ''
    },
    deriveFields: {},
    fields: [],
    canInviteOthersToProject: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$24fa706bbe9c8f04$export$2e2bcd8739ae039 = (state = $24fa706bbe9c8f04$var$initialState, action)=>{
    switch(action.type){
        case 0, $xbB8r.SET_CONFIGURATION:
            return action.payload;
        case 0, $xbB8r.SET_TODAY:
            return {
                ...state,
                today: action.payload
            };
        case 0, $xbB8r.SET_COMPONENTS:
            {
                const { components: components } = action.payload;
                const project = state.projectConfiguration;
                return {
                    ...state,
                    projectConfiguration: {
                        ...project,
                        components: {
                            hash: components
                        }
                    }
                };
            }
        case 0, $xbB8r.SET_VERSION:
            {
                const { projectConfiguration: projectConfiguration } = state;
                const { hash: versionHash } = projectConfiguration?.versions ?? {};
                const { id: id, ...version } = action.payload;
                return {
                    ...state,
                    projectConfiguration: {
                        ...projectConfiguration,
                        versions: {
                            hash: {
                                ...versionHash,
                                [id]: version
                            }
                        }
                    }
                };
            }
        case 0, $xbB8r.SET_DERIVE_FIELDS:
            return {
                ...state,
                deriveFields: action.payload
            };
        case 0, $xbB8r.SET_SPRINT:
            {
                const { boardConfiguration: boardConfiguration } = state;
                const { hash: sprintHash, sequence: sprintSequence } = boardConfiguration?.sprints ?? {};
                const sprint = action.payload;
                return {
                    ...state,
                    boardConfiguration: {
                        ...boardConfiguration,
                        sprints: {
                            hash: {
                                ...sprintHash,
                                [sprint.id]: sprint
                            },
                            sequence: sprintSequence
                        }
                    }
                };
            }
        case 0, $xbB8r.SET_CAN_USER_INVITE:
            return {
                ...state,
                canInviteOthersToProject: action.payload.canInviteOthersToProject
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("7BdYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $039743c12c36ef64$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $j01Gj = parcelRequire("j01Gj");

var $hwqya = parcelRequire("hwqya");

var $dCXFR = parcelRequire("dCXFR");

var $lnO6V = parcelRequire("lnO6V");

var $74eOg = parcelRequire("74eOg");

var $bst0j = parcelRequire("bst0j");
var $039743c12c36ef64$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    issues: $dCXFR.default,
    statusCategories: $lnO6V.default,
    users: $bst0j.default,
    globalIssueCreate: $j01Gj.default,
    subtasks: $74eOg.default,
    goals: $hwqya.default
});

});
parcelRegister("j01Gj", function(module, exports) {

$parcel$export(module.exports, "default", () => $571bc1315343db51$export$2e2bcd8739ae039);

var $cuKcG = parcelRequire("cuKcG");
const $571bc1315343db51$var$initialState = {
    payloadGIC: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$571bc1315343db51$export$2e2bcd8739ae039 = (state = $571bc1315343db51$var$initialState, action)=>{
    switch(action.type){
        case 0, $cuKcG.ADD_PAYLOAD_GLOBAL_ISSUE_CREATE:
            return {
                ...state,
                payloadGIC: action.payload
            };
        case 0, $cuKcG.CLEAR_PAYLOAD_GLOBAL_ISSUE_CREATE:
            return {
                ...state,
                payloadGIC: undefined
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("hwqya", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d13f9bbf3308c8f$export$2e2bcd8739ae039);

var $jktkh = parcelRequire("jktkh");
const $3d13f9bbf3308c8f$var$NO_GOALS = {};
const $3d13f9bbf3308c8f$var$initialState = {
    isLoaded: false,
    hash: $3d13f9bbf3308c8f$var$NO_GOALS
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d13f9bbf3308c8f$export$2e2bcd8739ae039 = (state = $3d13f9bbf3308c8f$var$initialState, action)=>{
    switch(action.type){
        case 0, $jktkh.SET_GOALS:
            return {
                isLoaded: true,
                hash: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("dCXFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cc276f52283368b$export$2e2bcd8739ae039);

var $kFGm5 = parcelRequire("kFGm5");

var $3LiTJ = parcelRequire("3LiTJ");

var $1urNG = parcelRequire("1urNG");

var $MdoH4 = parcelRequire("MdoH4");

var $7GXrf = parcelRequire("7GXrf");

var $gf0vG = parcelRequire("gf0vG");

var $j45xj = parcelRequire("j45xj");
const $8cc276f52283368b$var$initialState = {
    sequence: [],
    hash: {}
};
const $8cc276f52283368b$var$clearTransitionForField = (field, transitionId)=>{
    if ('transitionId' in field && field.transitionId === transitionId) return {
        value: field.value
    };
    return field;
};
const $8cc276f52283368b$var$resetTransitionForField = (field, transitionId)=>{
    if ('transitionId' in field && field.transitionId === transitionId) return {
        value: field.old
    };
    return field;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8cc276f52283368b$export$2e2bcd8739ae039 = (state = $8cc276f52283368b$var$initialState, action)=>{
    switch(action.type){
        case 0, $j45xj.EXTEND_ISSUES:
            {
                const { payload: payload } = action;
                return {
                    sequence: (0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(state.sequence, payload.sequence),
                    hash: {
                        ...state.hash,
                        ...payload.hash
                    }
                };
            }
        case 0, $j45xj.UPDATE_ISSUES_SEQUENCE:
            {
                const { payload: payload } = action;
                return {
                    sequence: payload,
                    hash: state.hash
                };
            }
        case 0, $j45xj.UPDATE_ISSUES_HASH_AND_SEQUENCE:
            {
                const { payload: payload } = action;
                return {
                    sequence: payload.sequence,
                    hash: payload.hash
                };
            }
        case 0, $j45xj.REMOVE_ISSUE:
            return {
                sequence: (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(state.sequence, action.payload),
                hash: (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(state.hash, (item, key)=>key !== action.payload)
            };
        case 0, $j45xj.REMOVE_ISSUES:
            return {
                sequence: (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(state.sequence, ...action.payload),
                hash: (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(state.hash, (item, key)=>!action.payload.includes(key))
            };
        case 0, $j45xj.INSERT_ISSUE:
            {
                const { id: id, issue: issue, anchor: anchor } = action.payload;
                const sequence = [
                    ...state.sequence
                ];
                /* Children will always be added last inside their parent.
			 * For our purposes, this can be accomplished by inserting last into the whole sequence.
			 */ if (anchor.position === (0, $gf0vG.LAST) || anchor.position === (0, $gf0vG.INSIDE)) sequence.push(id);
                else sequence.splice(anchor?.beforeId ? sequence.indexOf(anchor.beforeId) : -1, 0, id);
                return {
                    sequence: sequence,
                    hash: {
                        ...state.hash,
                        [`${id}`]: issue
                    }
                };
            }
        case 0, $j45xj.REPLACE_ISSUE:
            {
                const { temporaryId: temporaryId, id: id, issue: issue } = action.payload;
                return {
                    sequence: state.sequence.map((existingId)=>existingId === temporaryId ? id : existingId),
                    hash: {
                        ...(0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.hash, [
                            temporaryId
                        ]),
                        [`${id}`]: issue
                    }
                };
            }
        case 0, $j45xj.RANK_ISSUE:
            {
                const { issueId: issueId, rankRequest: rankRequest } = action.payload;
                const { sequence: sequence } = state;
                let anchorId;
                let isBefore = true;
                if ('rankBeforeId' in rankRequest) anchorId = rankRequest.rankBeforeId;
                else {
                    isBefore = false;
                    anchorId = rankRequest.rankAfterId;
                }
                const issueIndex = sequence.indexOf(issueId);
                // remove issueId
                sequence.splice(issueIndex, 1);
                let anchorIndex = sequence.indexOf(anchorId);
                if (isBefore === false) anchorIndex += 1;
                // insert issueId at new position
                sequence.splice(anchorIndex, 0, issueId);
                return {
                    ...state,
                    sequence: [
                        ...sequence
                    ]
                };
            }
        case 0, $j45xj.ADD_DEPENDENCY:
            {
                const { dependee: dependee, dependency: dependency } = action.payload;
                const { hash: hash } = state;
                if (hash[dependee]) return {
                    ...state,
                    hash: {
                        ...hash,
                        [dependee]: {
                            ...hash[dependee],
                            dependencies: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                                ...hash[dependee].dependencies || [],
                                dependency
                            ])
                        }
                    }
                };
                // ignore if target issue does not exists
                return state;
            }
        case 0, $j45xj.DELETE_DEPENDENCY:
            {
                const { dependee: dependee, dependency: dependency } = action.payload;
                const { hash: hash } = state;
                if (hash[dependee]) return {
                    ...state,
                    hash: {
                        ...hash,
                        [dependee]: {
                            ...hash[dependee],
                            dependencies: hash[dependee].dependencies.filter((dependencyId)=>dependencyId !== dependency)
                        }
                    }
                };
                // ignore if target issue does not exists
                return state;
            }
        case 0, $j45xj.CLEAR_TRANSITION_STATE:
            {
                const { issueId: issueId, transitionId: transitionId } = action.payload;
                const { hash: hash } = state;
                const issue = hash[issueId];
                if (issue !== undefined) return {
                    ...state,
                    hash: {
                        ...hash,
                        [issueId]: {
                            ...issue,
                            summary: $8cc276f52283368b$var$clearTransitionForField(issue.summary, transitionId),
                            startDate: $8cc276f52283368b$var$clearTransitionForField(issue.startDate, transitionId),
                            dueDate: $8cc276f52283368b$var$clearTransitionForField(issue.dueDate, transitionId),
                            color: $8cc276f52283368b$var$clearTransitionForField(issue.color, transitionId),
                            parentId: $8cc276f52283368b$var$clearTransitionForField(issue.parentId, transitionId),
                            sprintIds: $8cc276f52283368b$var$clearTransitionForField(issue.sprintIds, transitionId)
                        }
                    }
                };
                return state;
            }
        case 0, $j45xj.RESET_TRANSITION_STATE:
            {
                const { issueId: issueId, transitionId: transitionId } = action.payload;
                const { hash: hash } = state;
                const issue = hash[issueId];
                if (issue !== undefined) return {
                    ...state,
                    hash: {
                        ...hash,
                        [issueId]: {
                            ...issue,
                            summary: $8cc276f52283368b$var$resetTransitionForField(issue.summary, transitionId),
                            startDate: $8cc276f52283368b$var$resetTransitionForField(issue.startDate, transitionId),
                            dueDate: $8cc276f52283368b$var$resetTransitionForField(issue.dueDate, transitionId),
                            color: $8cc276f52283368b$var$resetTransitionForField(issue.color, transitionId),
                            parentId: $8cc276f52283368b$var$resetTransitionForField(issue.parentId, transitionId),
                            sprintIds: $8cc276f52283368b$var$resetTransitionForField(issue.sprintIds, transitionId)
                        }
                    }
                };
                return state;
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("lnO6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b66baf3e71e82a$export$2e2bcd8739ae039);

var $a2ne3 = parcelRequire("a2ne3");
const $42b66baf3e71e82a$var$initialState = {
    hash: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42b66baf3e71e82a$export$2e2bcd8739ae039 = (state = $42b66baf3e71e82a$var$initialState, action)=>{
    switch(action.type){
        case 0, $a2ne3.MERGE_STATUS_CATEGORIES:
            return {
                hash: {
                    ...state.hash,
                    ...action.payload
                }
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("74eOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1541ea83fb9e8aa3$export$2e2bcd8739ae039);

var $4bpn3 = parcelRequire("4bpn3");
const $1541ea83fb9e8aa3$var$initialState = {
    hash: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1541ea83fb9e8aa3$export$2e2bcd8739ae039 = (state = $1541ea83fb9e8aa3$var$initialState, action)=>{
    switch(action.type){
        case 0, $4bpn3.EXTEND_SUBTASKS:
            return {
                hash: {
                    ...state.hash,
                    ...action.payload
                }
            };
        case 0, $4bpn3.UPDATE_SUBTASK_STATUS:
            {
                const { id: id, parentId: parentId, statusCategoryId: statusCategoryId } = action.payload;
                const subtaskIndex = state.hash[parentId].findIndex(({ id: subtaskId })=>id === subtaskId);
                if (subtaskIndex >= 0) {
                    const subtask = {
                        ...state.hash[parentId][subtaskIndex],
                        statusCategoryId: statusCategoryId
                    };
                    const subtaskList = [
                        ...state.hash[parentId]
                    ];
                    subtaskList.splice(subtaskIndex, 1, subtask);
                    return {
                        hash: {
                            ...state.hash,
                            [`${parentId}`]: subtaskList
                        }
                    };
                }
                // ignore if target subtask does not exists
                return state;
            }
        case 0, $4bpn3.ADD_SUBTASK:
            {
                const { id: id, subtask: subtask } = action.payload;
                const subtaskList = [
                    ...state.hash[id]
                ];
                subtaskList.push(subtask);
                return {
                    hash: {
                        ...state.hash,
                        [`${id}`]: subtaskList
                    }
                };
            }
        case 0, $4bpn3.REMOVE_SUBTASKS:
            {
                const items = action.payload;
                const updatedHash = {
                    ...state.hash
                };
                items.forEach(({ parentId: parentId, id: id })=>{
                    updatedHash[parentId] = updatedHash[parentId].filter((subtask)=>!id.includes(subtask.id));
                });
                return {
                    hash: updatedHash
                };
            }
        case 0, $4bpn3.CHANGE_SUBTASK_PARENT:
            {
                const { id: id, newParentId: newParentId, oldParentId: oldParentId } = action.payload;
                const subtask = state.hash[oldParentId].find(({ id: subtaskId })=>id === subtaskId);
                if (subtask !== undefined) {
                    const newParentList = [
                        ...state.hash[newParentId]
                    ];
                    newParentList.push(subtask);
                    return {
                        hash: {
                            ...state.hash,
                            [`${oldParentId}`]: state.hash[oldParentId].filter(({ id: subtaskId })=>id !== subtaskId),
                            [`${newParentId}`]: newParentList
                        }
                    };
                }
                // ignore if target subtask does not exists
                return state;
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("bst0j", function(module, exports) {

$parcel$export(module.exports, "default", () => $c144f23def0aaf2a$export$2e2bcd8739ae039);

var $cerFH = parcelRequire("cerFH");
const $c144f23def0aaf2a$var$initialState = {
    hash: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c144f23def0aaf2a$export$2e2bcd8739ae039 = (state = $c144f23def0aaf2a$var$initialState, action)=>{
    switch(action.type){
        case 0, $cerFH.ADD_USERS:
            return {
                hash: {
                    ...state.hash,
                    ...action.payload
                }
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});


parcelRegister("cJlXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5744179d73b9fd5f$export$2e2bcd8739ae039);

var $56PNW = parcelRequire("56PNW");
const $5744179d73b9fd5f$var$defaultState = {
    traceIds: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5744179d73b9fd5f$export$2e2bcd8739ae039 = (state = $5744179d73b9fd5f$var$defaultState, action)=>{
    switch(action.type){
        case 0, $56PNW.SET_METADATA:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("atMh2", function(module, exports) {

$parcel$export(module.exports, "default", () => $53c89e1a739035f3$export$2e2bcd8739ae039);

var $dFuRD = parcelRequire("dFuRD");
const $53c89e1a739035f3$var$initialState = {
    location: {
        search: '',
        pathname: '',
        hash: ''
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53c89e1a739035f3$export$2e2bcd8739ae039 = (state = $53c89e1a739035f3$var$initialState, action)=>{
    switch(action.type){
        case 0, $dFuRD.ROUTER_LOCATION_CHANGE:
            return {
                location: {
                    ...state.location,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};

});

parcelRegister("4TiJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a7be1c6733e326$export$2e2bcd8739ae039);

var $8vOu0 = parcelRequire("8vOu0");


var $gf0vG = parcelRequire("gf0vG");

var $gdFA6 = parcelRequire("gdFA6");

var $5MpXz = parcelRequire("5MpXz");
const $b0a7be1c6733e326$var$defaultState = {
    timelineMode: (0, $gf0vG.MONTHS),
    listWidth: (0, $gf0vG.DEFAULT_LIST_WIDTH)(),
    issuePanelRatio: (0, $1e509df9ee2402a3$export$75a24528ec4289ef),
    creationPreferences: {
        itemTypes: {}
    },
    isDependenciesVisible: false,
    isProgressVisible: false,
    isWarningsVisible: false,
    isReleasesVisible: false,
    highlightedVersions: [],
    levelOneViewSettings: (0, $8vOu0.DEFAULT_LEVEL_ONE_VIEW_SETTINGS)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b0a7be1c6733e326$export$2e2bcd8739ae039 = (state = $b0a7be1c6733e326$var$defaultState, action)=>{
    switch(action.type){
        case 0, $5MpXz.SET_SETTINGS:
            return {
                ...state,
                ...action.payload
            };
        case 0, $gdFA6.SET_TIMELINE_MODE:
            return {
                ...state,
                timelineMode: action.payload
            };
        case 0, $5MpXz.SET_LIST_WIDTH:
            return {
                ...state,
                listWidth: action.payload
            };
        case 0, $5MpXz.SET_CREATION_PREFERENCES:
            return {
                ...state,
                creationPreferences: action.payload
            };
        case 0, $5MpXz.UPDATE_CREATION_PREFERENCES:
            return {
                ...state,
                creationPreferences: {
                    ...state.creationPreferences,
                    itemTypes: {
                        ...state.creationPreferences.itemTypes,
                        [action.payload.level]: {
                            itemTypeId: action.payload.itemTypeId
                        }
                    }
                }
            };
        case 0, $5MpXz.SET_HIGHLIGHTED_VERSIONS:
            return {
                ...state,
                highlightedVersions: action.payload
            };
        case 0, $5MpXz.SET_ISSUE_PANEL_RATIO:
            return {
                ...state,
                issuePanelRatio: action.payload
            };
        default:
            return state;
    }
};

});

parcelRegister("e4GSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e662424fbea538d2$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $i6UL2 = parcelRequire("i6UL2");

var $c1osU = parcelRequire("c1osU");

var $lDsrE = parcelRequire("lDsrE");

var $1mimA = parcelRequire("1mimA");

var $j1r1M = parcelRequire("j1r1M");
var $e662424fbea538d2$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    healthcheck: $c1osU.default,
    table: $1mimA.default,
    views: $j1r1M.default,
    panel: $lDsrE.default,
    filter: $i6UL2.default
});

});
parcelRegister("i6UL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $549ee5075c07dc24$export$2e2bcd8739ae039);

var $gdFA6 = parcelRequire("gdFA6");
const $549ee5075c07dc24$var$initialState = {
    configuration: {
        quickFilters: {},
        customFilters: {}
    },
    issueIds: [],
    isJQLFilterActive: false,
    isJQLFilterLoading: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$549ee5075c07dc24$export$2e2bcd8739ae039 = (state = $549ee5075c07dc24$var$initialState, action)=>{
    switch(action.type){
        case 0, $gdFA6.SET_FILTER_CONFIGURATION:
            return {
                ...state,
                configuration: action.payload
            };
        case 0, $gdFA6.CUSTOM_FILTERS_REQUEST:
        case 0, $gdFA6.QUICK_FILTERS_REQUEST:
            return {
                ...state,
                isJQLFilterLoading: true
            };
        case 0, $gdFA6.JQL_FILTERS_SUCCESS:
            return {
                ...state,
                isJQLFilterActive: true,
                isJQLFilterLoading: false,
                issueIds: action.payload
            };
        case 0, $gdFA6.CUSTOM_FILTERS_CLEAR:
        case 0, $gdFA6.QUICK_FILTERS_CLEAR:
            return {
                ...state,
                isJQLFilterActive: $549ee5075c07dc24$var$initialState.isJQLFilterActive,
                isJQLFilterLoading: $549ee5075c07dc24$var$initialState.isJQLFilterLoading,
                issueIds: $549ee5075c07dc24$var$initialState.issueIds
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("c1osU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5db91e0f7b3295a$export$2e2bcd8739ae039);

var $8ybWM = parcelRequire("8ybWM");
const $e5db91e0f7b3295a$var$defaultState = {
    isResolving: false,
    issueTypeCounts: {},
    current: undefined,
    issueTypes: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e5db91e0f7b3295a$export$2e2bcd8739ae039 = (state = $e5db91e0f7b3295a$var$defaultState, action)=>{
    switch(action.type){
        case 0, $8ybWM.EXTEND_ISSUE_TYPE_COUNT:
            return {
                ...state,
                issueTypeCounts: {
                    ...state.issueTypeCounts,
                    ...action.payload
                }
            };
        case 0, $8ybWM.EXTEND_ISSUE_TYPES:
            return {
                ...state,
                issueTypes: action.payload
            };
        case 0, $8ybWM.SET_RESOLVING:
            return {
                ...state,
                isResolving: action.payload
            };
        case 0, $8ybWM.UPDATE_HEALTHCHECK:
            return {
                ...state,
                current: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("lDsrE", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bb1f83298b2f90$export$2e2bcd8739ae039);

var $7cApO = parcelRequire("7cApO");
const $82bb1f83298b2f90$var$defaultState = {
    panelType: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82bb1f83298b2f90$export$2e2bcd8739ae039 = (state = $82bb1f83298b2f90$var$defaultState, action)=>{
    switch(action.type){
        case 0, $7cApO.SHOW_PANEL:
            return {
                ...state,
                panelType: action.payload
            };
        case 0, $7cApO.HIDE_PANEL:
            return {
                ...state,
                panelType: undefined
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("1mimA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6d9c92c4f9dcd4$export$2e2bcd8739ae039);

var $htXdF = parcelRequire("htXdF");
const $5e6d9c92c4f9dcd4$var$defaultState = {
    createItemAnchor: undefined,
    expandedItems: {},
    selectedItemIds: [],
    selectionAnchors: [],
    tooltip: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5e6d9c92c4f9dcd4$export$2e2bcd8739ae039 = (state = $5e6d9c92c4f9dcd4$var$defaultState, action)=>{
    switch(action.type){
        case 0, $htXdF.SET_CREATE_ITEM_ANCHOR:
            return {
                ...state,
                expandedItems: {
                    ...state.expandedItems,
                    ...action.payload && 'parentId' in action.payload && action.payload.parentId ? {
                        [action.payload.parentId]: true
                    } : {}
                },
                createItemAnchor: action.payload
            };
        case 0, $htXdF.RESET_CREATE_ITEM_ANCHOR:
            return {
                ...state,
                createItemAnchor: undefined
            };
        case 0, $htXdF.CHANGE_EXPANSION_STATE:
            return {
                ...state,
                expandedItems: {
                    ...state.expandedItems,
                    [action.payload.id]: action.payload.isExpanded
                }
            };
        case 0, $htXdF.BULK_CHANGE_EXPANSION_STATE:
            return {
                ...state,
                expandedItems: {
                    ...state.expandedItems,
                    ...Object.fromEntries(action.payload.ids.map((id)=>[
                            id,
                            action.payload.isExpanded
                        ]))
                }
            };
        case 0, $htXdF.SHOW_TOOLTIP:
            return {
                ...state,
                tooltip: action.payload
            };
        case 0, $htXdF.HIDE_TOOLTIP:
            return {
                ...state,
                tooltip: undefined
            };
        case 0, $htXdF.SET_SELECTED_ITEMS:
            return {
                ...state,
                selectedItemIds: action.payload
            };
        case 0, $htXdF.SET_SELECTION_ANCHORS:
            return {
                ...state,
                selectionAnchors: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("j1r1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $1da82dc80da410c2$export$2e2bcd8739ae039);

var $8vOu0 = parcelRequire("8vOu0");

var $aSTh4 = parcelRequire("aSTh4");
const $1da82dc80da410c2$var$defaultState = {
    isDependenciesVisible: true,
    isProgressVisible: true,
    isWarningsVisible: true,
    isReleasesVisible: true,
    levelOneViewSettings: (0, $8vOu0.DEFAULT_LEVEL_ONE_VIEW_SETTINGS)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1da82dc80da410c2$export$2e2bcd8739ae039 = (state = $1da82dc80da410c2$var$defaultState, action)=>{
    switch(action.type){
        case 0, $aSTh4.SET_DEPENDENCIES_VIEW_VISIBILITY:
            return {
                ...state,
                isDependenciesVisible: action.payload
            };
        case 0, $aSTh4.SET_PROGRESS_VISIBILITY:
            return {
                ...state,
                isProgressVisible: action.payload
            };
        case 0, $aSTh4.SET_WARNINGS_VISIBILITY:
            return {
                ...state,
                isWarningsVisible: action.payload
            };
        case 0, $aSTh4.SET_RELEASES_VISIBILITY:
            return {
                ...state,
                isReleasesVisible: action.payload
            };
        case 0, $aSTh4.SET_LEVEL_ONE_SETTING:
            return {
                ...state,
                levelOneViewSettings: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("bIFjW", function(module, exports) {

$parcel$export(module.exports, "engine", () => $7045a68d1f58d2b8$export$d3c662a6136faebb);
parcelRequire("jyKN9");

var $hTLlD = parcelRequire("hTLlD");

var $3JafE = parcelRequire("3JafE");

var $jG31f = parcelRequire("jG31f");

var $huI7r = parcelRequire("huI7r");

var $aIi5h = parcelRequire("aIi5h");
const $7045a68d1f58d2b8$export$d3c662a6136faebb = (prefix, boardId, sourceAri, loggedInAccountIdSelector, // eslint-disable-next-line @typescript-eslint/no-explicit-any
prefetchedData)=>{
    const mod = (0, $jG31f.prefixer)(`standard-${prefix}`);
    const blob = prefetchedData || {};
    let propertyKey = mod(`board-${boardId}`);
    const ariConfig = (0, $huI7r.parseAri)(sourceAri);
    if (ariConfig) propertyKey = mod(`${ariConfig.resourceType}-${ariConfig.resourceId}`);
    return {
        get: (key)=>(0, $3JafE.Observable).of(blob[key]),
        set: (key, value)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(blob[key], value)) {
                blob[key] = value;
                (0, $aIi5h.default)(loggedInAccountIdSelector(), propertyKey, JSON.stringify(blob));
            }
        },
        allowsModificationWithoutHydration: false
    };
};

});
parcelRegister("jG31f", function(module, exports) {

$parcel$export(module.exports, "prefixer", () => $8f0feb090556e4a6$export$e08c7d021b829b7a);
const $8f0feb090556e4a6$export$e08c7d021b829b7a = (prefix)=>(key)=>`${prefix}.${key}`;

});

parcelRegister("aIi5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ecdbe94b9dfa5ef$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("cpH8E");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7ecdbe94b9dfa5ef$export$2e2bcd8739ae039 = (accountId, propertyKey, propertyValue)=>{
    const options = {
        method: 'PUT',
        body: propertyValue
    };
    return (0, $3JafE.Observable).fromPromise((0, $lRmyA.performPutRequest)(`/rest/api/2/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`, options)).mergeMap(()=>(0, $3JafE.Observable).empty());
};

});


parcelRegister("lKzXJ", function(module, exports) {

$parcel$export(module.exports, "StandardMacro", () => $7293dd91967468ed$export$447e142a7e4ffcb6);
$parcel$export(module.exports, "ClassicStandardMacro", () => $7293dd91967468ed$export$9dac407fe81bed96);
$parcel$export(module.exports, "StandardView", () => $7293dd91967468ed$export$18d5f6166a1f65de);
$parcel$export(module.exports, "ClassicStandardView", () => $7293dd91967468ed$export$2e9f3cb234df1140);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $5iWql = parcelRequire("5iWql");

var $8WuJm = parcelRequire("8WuJm");

var $lNNXV = parcelRequire("lNNXV");

var $ecAMT = parcelRequire("ecAMT");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $6489W = parcelRequire("6489W");

var $imwJF = parcelRequire("imwJF");

var $56Mmd = parcelRequire("56Mmd");

var $lSdOK = parcelRequire("lSdOK");

var $PugJB = parcelRequire("PugJB");

var $aF2Jr = parcelRequire("aF2Jr");

var $7TkUZ = parcelRequire("7TkUZ");

var $bwWcE = parcelRequire("bwWcE");

var $2fGx1 = parcelRequire("2fGx1");

var $dgEpl = parcelRequire("dgEpl");

var $5uNCa = parcelRequire("5uNCa");

var $kZoDo = parcelRequire("kZoDo");
const $7293dd91967468ed$var$mapStateToProps = (state, { isMacroView: isMacroView })=>{
    const projectId = (0, $bwVWW.getProjectId)(state) || '';
    const boardId = (0, $lgKTA.getBoardId)(state);
    return {
        boardId: (0, $lgKTA.getBoardId)(state),
        projectKey: (0, $bwVWW.getProjectKey)(state),
        isHealthy: !(0, $imwJF.getHasHealthcheck)(state),
        isShared: (0, $6489W.isShared)(state),
        isClassic: (0, $lgKTA.isClassic)(state),
        issueIds: (0, $6FeJk.getIssueIds)(state),
        Header: $aF2Jr.default,
        Table: $5uNCa.default,
        Healthcheck: $7TkUZ.default,
        DocumentTitle: $lSdOK.default,
        RealtimeProvider: $2fGx1.default,
        RouterUpdater: $dgEpl.default,
        MountAnalytic: $bwWcE.default,
        isHeaderHidden: (0, $lgKTA.getMacroHideHeader)(state),
        shouldMountKeyboardShortcuts: !isMacroView,
        objectId: String(boardId),
        projectId: projectId,
        boardType: (0, $bwVWW.getIsSprintsFeatureEnabled)(state) ? 'Scrum' : 'Kanban',
        childIssuePlanningMode: (0, $bwVWW.getChildIssuePlanningMode)(state)
    };
};
const $7293dd91967468ed$var$mapDispatchToProps = {
    onSetShared: (0, $56Mmd.setShared),
    initializeNonCriticalData: $ecAMT.initializeNonCriticalData
};
const $7293dd91967468ed$var$onLoadedFactory = (0, $5iWql.default)((dispatchPropsInitializeNonCriticalData, statePropsIsShared, onSetShared)=>()=>{
        dispatchPropsInitializeNonCriticalData();
        if (statePropsIsShared) onSetShared(false);
    });
const $7293dd91967468ed$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...stateProps,
        ...ownProps,
        onLoaded: $7293dd91967468ed$var$onLoadedFactory(dispatchProps.initializeNonCriticalData, stateProps.isShared, dispatchProps.onSetShared)
    });
const $7293dd91967468ed$var$View = (0, $PugJB.withViewExperienceTracker)((0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
    (0, $lNNXV.connect)($7293dd91967468ed$var$mapStateToProps, $7293dd91967468ed$var$mapDispatchToProps, $7293dd91967468ed$var$mergeProps)
])((0, $kZoDo.default)));
const $7293dd91967468ed$export$447e142a7e4ffcb6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "roadmapMacro",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7293dd91967468ed$var$View, props));
const $7293dd91967468ed$export$9dac407fe81bed96 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "classicRoadmapMacro",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7293dd91967468ed$var$View, props));
const $7293dd91967468ed$export$18d5f6166a1f65de = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "roadmap",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7293dd91967468ed$var$View, props));
const $7293dd91967468ed$export$2e9f3cb234df1140 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "classicRoadmap",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7293dd91967468ed$var$View, props));

});
parcelRegister("imwJF", function(module, exports) {

$parcel$export(module.exports, "getIssueCounts", () => $48da73d0604bbafd$export$bdfb218a19333daa);
$parcel$export(module.exports, "getHealthcheckIssueTypes", () => $48da73d0604bbafd$export$156194c028613748);
$parcel$export(module.exports, "isResolving", () => $48da73d0604bbafd$export$385897f863931845);
$parcel$export(module.exports, "getHealthcheck", () => $48da73d0604bbafd$export$47b0be97eea80dc5);
$parcel$export(module.exports, "getHasHealthcheck", () => $48da73d0604bbafd$export$330b0477c226ca52);
const $48da73d0604bbafd$export$bdfb218a19333daa = (state)=>state.ui.healthcheck.issueTypeCounts;
const $48da73d0604bbafd$export$156194c028613748 = (state)=>state.ui.healthcheck.issueTypes;
const $48da73d0604bbafd$export$385897f863931845 = (state)=>state.ui.healthcheck.isResolving;
const $48da73d0604bbafd$export$47b0be97eea80dc5 = (state)=>state.ui.healthcheck.current;
const $48da73d0604bbafd$export$330b0477c226ca52 = (state)=>state.ui.healthcheck.current !== undefined;

});

parcelRegister("lSdOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9504416a3dc6894e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lgKTA = parcelRequire("lgKTA");

var $jgiwv = parcelRequire("jgiwv");
var $9504416a3dc6894e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        projectName: (0, $lgKTA.getContainerName)(state)
    }), {})((0, $jgiwv.default));

});
parcelRegister("jgiwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b2d472b61c6943f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cuQMP = parcelRequire("cuQMP");
const $4b2d472b61c6943f$var$DocumentTitle = ({ projectName: projectName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $cuQMP.default).timelineDocumentTitle, {
            projectName: projectName
        })
    });
};
var $4b2d472b61c6943f$export$2e2bcd8739ae039 = $4b2d472b61c6943f$var$DocumentTitle;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("cuQMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e273143f67f3832b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e273143f67f3832b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timelineDocumentTitle: {
        "id": "roadmap.standard-roadmap.document-title.timeline-document-title",
        "defaultMessage": "{projectName} - Timeline"
    }
});

});



parcelRegister("PugJB", function(module, exports) {

$parcel$export(module.exports, "withViewExperienceTracker", () => $a876ec6668be2c9c$export$52092272c0483371);

var $eUqFw = parcelRequire("eUqFw");

var $8yne0 = parcelRequire("8yne0");
const $a876ec6668be2c9c$export$52092272c0483371 = (ComponentBeingTracked)=>{
    const WithViewExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
            location: "roadmap"
        }, ({ onExperienceSuccess: onExperienceSuccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentBeingTracked, {
                onExperienceSuccess: onExperienceSuccess,
                ...props
            }));
    return WithViewExperienceTracker;
};

});

parcelRegister("aF2Jr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abbc27c10b38f17$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $ddAn0 = parcelRequire("ddAn0");

var $dZX9R = parcelRequire("dZX9R");

var $jW7VM = parcelRequire("jW7VM");

var $daMD5 = parcelRequire("daMD5");

var $jX4Ux = parcelRequire("jX4Ux");

var $6P3e2 = parcelRequire("6P3e2");
var $6abbc27c10b38f17$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        isMacroView: (0, $lgKTA.hasMacroConfig)(state),
        Share: $daMD5.default,
        Filters: (0, $dZX9R.default),
        ViewSettings: $6P3e2.default,
        // clean up hasAdministerProjectPermission(state) || getIsUserBoardAdmin(state) conditions along with getWillShowNav4()
        MoreSettings: (0, $bwVWW.hasAdministerProjectPermission)(state) || (0, $bwVWW.getIsUserBoardAdmin)(state) ? (0, $jW7VM.default) : undefined,
        Feedback: // clean up Feedback prop along with getWillShowNav4()
        $ddAn0.default
    }), {})((0, $jX4Ux.default));

});
parcelRegister("ddAn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4626ba99a79313fd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4626ba99a79313fd$var$LazyFeedback = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("kEelR")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/header/feedback/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4626ba99a79313fd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-feedback",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-feedback",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4626ba99a79313fd$var$LazyFeedback, props)));

});
parcelRegister("kEelR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c6dtW").then(()=>parcelRequire('8lb2v'));

});


parcelRegister("dZX9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaaa65353e5d4b25$export$2e2bcd8739ae039);

var $79xbN = parcelRequire("79xbN");

var $lNNXV = parcelRequire("lNNXV");


var $lgKTA = parcelRequire("lgKTA");

var $xbB8r = parcelRequire("xbB8r");

var $bwVWW = parcelRequire("bwVWW");

var $cUmMY = parcelRequire("cUmMY");

var $lDe9P = parcelRequire("lDe9P");

var $iIU9b = parcelRequire("iIU9b");

var $i1cMJ = parcelRequire("i1cMJ");

var $iyp4D = parcelRequire("iyp4D");

var $1T0K9 = parcelRequire("1T0K9");

var $iKKDu = parcelRequire("iKKDu");

var $gJJHm = parcelRequire("gJJHm");

var $gN3NG = parcelRequire("gN3NG");

var $hjI8T = parcelRequire("hjI8T");

var $gdFA6 = parcelRequire("gdFA6");

var $hTAd9 = parcelRequire("hTAd9");

var $4kNMg = parcelRequire("4kNMg");

var $1a2Bl = parcelRequire("1a2Bl");

var $gtjVH = parcelRequire("gtjVH");
const $aaaa65353e5d4b25$var$EMPTY_ARRAY = [];
const $aaaa65353e5d4b25$var$shouldShowAddPeopleButton = (state)=>{
    const isCMP = (0, $lgKTA.isClassic)(state);
    const canAdministerProject = (0, $bwVWW.hasAdministerProjectPermission)(state);
    if (isCMP) return canAdministerProject;
    const canInviteOthersToProject = (0, $bwVWW.getCanInviteOthersToProject)(state);
    return canAdministerProject || canInviteOthersToProject;
};
const $aaaa65353e5d4b25$var$mapStateToProps = (state, { isMacroView: isMacroView })=>({
        issueTypes: (0, $1T0K9.getIssueTypes)(state),
        assignees: (0, $i1cMJ.getAssignees)(state),
        labels: (0, $iKKDu.getLabels)(state),
        issueParents: (0, $iyp4D.getIssueParents)(state),
        issueParentsLabel: (0, $bwVWW.getLevelOneName)(state),
        statusCategories: (0, $gJJHm.getStatusCategories)(state),
        AddPeopleModal: isMacroView ? undefined : (0, $4kNMg.default),
        filter: (0, $1a2Bl.getFilters)(state),
        boardId: (0, $lgKTA.getBoardId)(state),
        projectId: parseInt((0, $bwVWW.getProjectId)(state), 10),
        projectName: (0, $bwVWW.getProjectName)(state),
        projectKey: (0, $bwVWW.getProjectKey)(state),
        versions: (0, $hjI8T.getVersionsForFilter)(state),
        components: (0, $lDe9P.getComponents)(state),
        customFilters: (0, $iIU9b.getCustomFilters)(state),
        quickFilters: (0, $gN3NG.getQuickFilters)(state),
        goals: (0, $cUmMY.getGoals)(state),
        isAddPeopleButtonEnabled: !(0, $79xbN.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment') ? (0, $bwVWW.hasAdministerProjectPermission)(state) // Existing permission check
         : $aaaa65353e5d4b25$var$shouldShowAddPeopleButton(state),
        isCustomFilterManageLinkEnabled: (0, $bwVWW.hasAdministerProjectPermission)(state),
        isVersionFilterSpotlightEnabled: (0, $bwVWW.hasAdministerProjectPermission)(state),
        isCustomFiltersLoading: (0, $hTAd9.getIsJQLFilterLoading)(state),
        isCMP: (0, $lgKTA.isClassic)(state)
    });
const $aaaa65353e5d4b25$var$mapDispatchToProps = (dispatch)=>({
        onClearAllButtonClicked: ()=>{
            dispatch((0, $gdFA6.clearFilter)());
            dispatch((0, $gdFA6.clearQuickFilters)());
            dispatch((0, $xbB8r.deriveFieldsRequest)());
        },
        onChange: (filters, filterType)=>{
            if (filterType === (0, $44677eb502cfd308$export$d597759d33be802e)) {
                const textValue = filters[0, $44677eb502cfd308$export$d597759d33be802e] || '';
                dispatch((0, $gdFA6.setTextFilter)(textValue));
            } else if (filterType === (0, $44677eb502cfd308$export$f8f7545d2bb78afb)) {
                const assigneeValue = filters[0, $44677eb502cfd308$export$f8f7545d2bb78afb] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setAssigneeFilter)(assigneeValue));
            } else if (filterType === (0, $44677eb502cfd308$export$37aee82a3cb1e8f7)) {
                const labelValue = filters[0, $44677eb502cfd308$export$37aee82a3cb1e8f7] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setLabelFilter)(labelValue));
            } else if (filterType === (0, $44677eb502cfd308$export$2a4f270075a033de)) {
                const issueParentValue = filters[0, $44677eb502cfd308$export$2a4f270075a033de] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setIssueParentFilter)(issueParentValue));
            } else if (filterType === (0, $44677eb502cfd308$export$ebb48b08205007c5)) {
                const issueTypeValue = filters[0, $44677eb502cfd308$export$ebb48b08205007c5] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setIssueTypeFilter)(issueTypeValue));
            } else if (filterType === (0, $44677eb502cfd308$export$f863b019d19144f4)) {
                const statusValue = filters[0, $44677eb502cfd308$export$f863b019d19144f4] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setStatusCategoryFilter)(statusValue));
            } else if (filterType === (0, $44677eb502cfd308$export$a4ad2735b021c132)) {
                const versionValue = filters[0, $44677eb502cfd308$export$a4ad2735b021c132] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setVersionFilter)(versionValue));
            } else if (filterType === (0, $44677eb502cfd308$export$af1e30ebbae9df3b)) {
                const componentValue = filters[0, $44677eb502cfd308$export$af1e30ebbae9df3b] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setComponentFilter)(componentValue));
            } else if (filterType === (0, $44677eb502cfd308$export$871e58afc769b358)) {
                const goalValue = filters[0, $44677eb502cfd308$export$871e58afc769b358] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setGoalFilter)(goalValue));
            } else if (filterType === (0, $44677eb502cfd308$export$1ea95b94fb0c51d9)) {
                const quickFilterValue = filters[0, $44677eb502cfd308$export$1ea95b94fb0c51d9] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setQuickFiltersFilter)(quickFilterValue));
                dispatch((0, $gdFA6.quickFiltersRequest)(quickFilterValue));
                dispatch((0, $xbB8r.deriveFieldsRequest)());
            } else if (filterType === (0, $44677eb502cfd308$export$68d693c35a8d8866)) {
                const customFilterValue = filters[0, $44677eb502cfd308$export$68d693c35a8d8866] || $aaaa65353e5d4b25$var$EMPTY_ARRAY;
                dispatch((0, $gdFA6.setCustomFilter)(customFilterValue));
                dispatch((0, $gdFA6.customFiltersRequest)(customFilterValue));
                dispatch((0, $xbB8r.deriveFieldsRequest)());
            }
        }
    });
var $aaaa65353e5d4b25$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($aaaa65353e5d4b25$var$mapStateToProps, $aaaa65353e5d4b25$var$mapDispatchToProps)((0, $gtjVH.default));

});
parcelRegister("iIU9b", function(module, exports) {

$parcel$export(module.exports, "getCustomFilters", () => $edd6a02e7698844f$export$ada7918f4af738ad);

var $df4Sl = parcelRequire("df4Sl");

var $hTAd9 = parcelRequire("hTAd9");
const $edd6a02e7698844f$export$34d8969cbca362eb = (customFiltershash)=>Object.keys(customFiltershash).map((customFilterId)=>{
        const customFilter = customFiltershash[customFilterId];
        return {
            id: customFilter.id,
            name: customFilter.name
        };
    });
const $edd6a02e7698844f$export$ada7918f4af738ad = (0, $df4Sl.createSelector)((0, $hTAd9.getFullCustomFilterHash), $edd6a02e7698844f$export$34d8969cbca362eb);

});

parcelRegister("i1cMJ", function(module, exports) {

$parcel$export(module.exports, "getAssignees", () => $8358e6a31b11d25f$export$83f72e15d115a0e7);

var $df4Sl = parcelRequire("df4Sl");

var $jtx35 = parcelRequire("jtx35");

var $lgKTA = parcelRequire("lgKTA");

var $6FeJk = parcelRequire("6FeJk");

var $3YMoa = parcelRequire("3YMoa");
const $8358e6a31b11d25f$export$1b2f73c5cdda2111 = (0, $df4Sl.createSelector)((0, $lgKTA.getLoggedInAccountId), (0, $6FeJk.getIssueIds), (0, $6FeJk.getIssueAssigneeHash), (loggedInUserId, issueIds, assigneeHash)=>{
    const assigneeSet = new Set([
        loggedInUserId
    ]);
    // reverse mutates an original array, so it should be cloned first
    Array.from(issueIds).reverse().forEach((issueId)=>{
        const assignee = assigneeHash[issueId];
        if (assignee) assigneeSet.add(assignee);
    });
    return Array.from(assigneeSet.values());
});
const $8358e6a31b11d25f$export$83f72e15d115a0e7 = (0, $jtx35.createSelectorWithDefaultEqual)($8358e6a31b11d25f$export$1b2f73c5cdda2111, (0, $3YMoa.getFullUserHash), (assigneeIds, usersHash)=>{
    const assignees = [];
    assigneeIds.forEach((assigneeId)=>{
        const user = usersHash[assigneeId];
        if (assigneeId && user) assignees.push({
            id: assigneeId,
            displayName: user.displayName,
            avatarUrl: user.avatarUrls['48x48']
        });
    });
    return assignees;
});

});

parcelRegister("iyp4D", function(module, exports) {

$parcel$export(module.exports, "getIssueParents", () => $16d75148abb1555a$export$df9259146e40d32c);

var $jtx35 = parcelRequire("jtx35");

var $6FeJk = parcelRequire("6FeJk");
const $16d75148abb1555a$export$df9259146e40d32c = (0, $jtx35.createSelectorWithDefaultEqual)((0, $6FeJk.getIssueParentIds), (0, $6FeJk.getIssueSummaryHash), (uniqueIssueParentIds, issueSummaryHash)=>uniqueIssueParentIds.map((parentId)=>({
            id: parentId,
            name: issueSummaryHash[parentId]
        })));

});

parcelRegister("1T0K9", function(module, exports) {

$parcel$export(module.exports, "getIssueTypes", () => $b5820f2f0fce21ea$export$4cf4b24b88599615);

var $df4Sl = parcelRequire("df4Sl");

var $aXGkF = parcelRequire("aXGkF");

var $jtx35 = parcelRequire("jtx35");

var $6FeJk = parcelRequire("6FeJk");

var $9ZLrP = parcelRequire("9ZLrP");
const $b5820f2f0fce21ea$var$getIssueTypesUsageHash = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueTypeIdHash), (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF))));
const $b5820f2f0fce21ea$var$getSortedChildIssueTypes = (0, $df4Sl.createSelector)((0, $9ZLrP.getChildIssueTypes), $b5820f2f0fce21ea$var$getIssueTypesUsageHash, (childIssueTypes, issueTypesUsageHash)=>childIssueTypes.filter(({ id: id })=>issueTypesUsageHash[id]).sort((issueTypeA, issueTypeB)=>issueTypeA.name.toLowerCase() < issueTypeB.name.toLowerCase() ? -1 : 1));
const $b5820f2f0fce21ea$export$4cf4b24b88599615 = (0, $jtx35.createSelectorWithDefaultEqual)($b5820f2f0fce21ea$var$getSortedChildIssueTypes, (childIssueTypes)=>childIssueTypes);

});

parcelRegister("gJJHm", function(module, exports) {

$parcel$export(module.exports, "getStatusCategories", () => $6ea6c1119224db08$export$29350702a509e1b9);

var $df4Sl = parcelRequire("df4Sl");

var $3G3gn = parcelRequire("3G3gn");

var $5iA56 = parcelRequire("5iA56");

var $5urmd = parcelRequire("5urmd");
const $6ea6c1119224db08$var$STATUS_KEYS_ORDER_HASH = {
    [`${0, $5iA56.TODO}`]: 1,
    [`${0, $5iA56.IN_PROGRESS}`]: 2,
    [`${0, $5iA56.DONE}`]: 3
};
const $6ea6c1119224db08$export$29350702a509e1b9 = (0, $df4Sl.createSelector)((0, $5urmd.getFullStatusCategoriesHash), (statusCategoriesHash)=>{
    const statusCategoryIds = Object.keys(statusCategoriesHash).filter((id)=>statusCategoriesHash[id].key in $6ea6c1119224db08$var$STATUS_KEYS_ORDER_HASH);
    const orderedStatusCategoryIds = (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(statusCategoryIds, (id)=>$6ea6c1119224db08$var$STATUS_KEYS_ORDER_HASH[statusCategoriesHash[id].key]);
    return orderedStatusCategoryIds.map((id)=>({
            id: id,
            name: statusCategoriesHash[id].name
        }));
});

});

parcelRegister("gN3NG", function(module, exports) {

$parcel$export(module.exports, "getQuickFilters", () => $16135cc62179aa74$export$59e2f55e44eccfa0);

var $df4Sl = parcelRequire("df4Sl");

var $hTAd9 = parcelRequire("hTAd9");
const $16135cc62179aa74$var$getQuickFiltersOrderedBase = (quickFiltersHash)=>Object.values(quickFiltersHash).sort((a, b)=>a.position - b.position).map((quickFilter)=>({
            id: quickFilter.id,
            name: quickFilter.name
        }));
const $16135cc62179aa74$export$59e2f55e44eccfa0 = (0, $df4Sl.createSelector)((0, $hTAd9.getFullQuickFilterHash), $16135cc62179aa74$var$getQuickFiltersOrderedBase);

});

parcelRegister("4kNMg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3b65e438fc8ea9$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $7ZZxN = parcelRequire("7ZZxN");

var $3JuZY = parcelRequire("3JuZY");

var $lNNXV = parcelRequire("lNNXV");

var $bwVWW = parcelRequire("bwVWW");
const $ec3b65e438fc8ea9$var$mapStateToProps = (state, ownProps)=>({
        baseUrl: '',
        projectId: Number((0, $bwVWW.getProjectId)(state)),
        projectKey: (0, $bwVWW.getProjectKey)(state),
        isOpen: ownProps.isOpen,
        projectType: (0, $7ZZxN.SOFTWARE_PROJECT),
        isAdmin: true,
        analyticsPrefix: 'software.roadmap',
        allowFlags: true,
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onAddSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onStopPerfMetric: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        projectRoles: undefined,
        partiesInProject: undefined,
        defaultRoleId: undefined,
        adminRoleId: undefined,
        roleConfigurable: undefined
    });
var $ec3b65e438fc8ea9$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($ec3b65e438fc8ea9$var$mapStateToProps, {})((0, $3JuZY.default));

});
parcelRegister("3JuZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0622cdc3f1c5195e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AddPeopleModalBoundary", () => $0622cdc3f1c5195e$export$374b95de0cd72a02);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");


const $0622cdc3f1c5195e$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jIcF2")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $0622cdc3f1c5195e$export$c4cbbeec160c9988 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-add-people-dialog",
        packageName: "project-add-people"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-add-people-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $c53566c3ac758a18$export$b68a44ad9e8d6ce)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0622cdc3f1c5195e$var$LazyComponent, props)));
var $0622cdc3f1c5195e$export$2e2bcd8739ae039 = $0622cdc3f1c5195e$export$c4cbbeec160c9988;
const $0622cdc3f1c5195e$export$374b95de0cd72a02 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "add-people-modal",
        metricKey: (0, $c53566c3ac758a18$export$b68a44ad9e8d6ce),
        ...props
    }, children);

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $fee69 = parcelRequire("fee69");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

const $c53566c3ac758a18$export$8fcd8ea7ed6539b1 = 'project-settings-apps.add-people-dialog';
const $c53566c3ac758a18$export$b68a44ad9e8d6ce = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
const $c53566c3ac758a18$export$656613627a47a509 = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
const $c53566c3ac758a18$export$61762786d0849c64 = 'ADD_PEOPLE_READY_MARK_KEY';

parcelRegister("jIcF2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("6HI0g")
]).then(()=>parcelRequire('4urEy'));

});



parcelRegister("1a2Bl", function(module, exports) {

$parcel$export(module.exports, "getFilters", () => $141948c86789e52f$export$1933a9fe712fc1fd);

var $df4Sl = parcelRequire("df4Sl");

var $3LiTJ = parcelRequire("3LiTJ");


var $9ZLrP = parcelRequire("9ZLrP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $141948c86789e52f$var$isNotEmpty = (a)=>a.length !== 0;
const $141948c86789e52f$export$1933a9fe712fc1fd = (0, $df4Sl.createSelector)((0, $9ZLrP.getIssuesFilter), ({ assignees: assignees, issueTypes: issueTypes, statuses: statuses, text: text, labels: labels, issueParents: issueParents, versions: versions, components: components, quickFilters: quickFilters, customFilters: customFilters, goals: goals })=>{
    const filters = {
        [(0, $44677eb502cfd308$export$d597759d33be802e)]: text,
        [(0, $44677eb502cfd308$export$f8f7545d2bb78afb)]: assignees,
        [(0, $44677eb502cfd308$export$37aee82a3cb1e8f7)]: labels,
        [(0, $44677eb502cfd308$export$2a4f270075a033de)]: issueParents,
        [(0, $44677eb502cfd308$export$ebb48b08205007c5)]: issueTypes,
        [(0, $44677eb502cfd308$export$f863b019d19144f4)]: statuses,
        [(0, $44677eb502cfd308$export$a4ad2735b021c132)]: versions,
        [(0, $44677eb502cfd308$export$af1e30ebbae9df3b)]: components,
        [(0, $44677eb502cfd308$export$1ea95b94fb0c51d9)]: quickFilters,
        [(0, $44677eb502cfd308$export$68d693c35a8d8866)]: customFilters,
        [(0, $44677eb502cfd308$export$871e58afc769b358)]: goals
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(filters, $141948c86789e52f$var$isNotEmpty);
});

});

parcelRegister("gtjVH", function(module, exports) {

$parcel$export(module.exports, "default", () => $64456a3007204e2d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $k8Lle = parcelRequire("k8Lle");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $fmCcJ = parcelRequire("fmCcJ");

var $75e8i = parcelRequire("75e8i");

var $63ypL = parcelRequire("63ypL");

var $3z3DP = parcelRequire("3z3DP");
const $64456a3007204e2d$var$RoadmapCustomFilter = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8Lle.default), {
        filters: props.filters,
        ...props
    });
const $64456a3007204e2d$var$Filter = ({ isMacroView: isMacroView, isCMP: isCMP, goals: goals, ...filterProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { isCustomFiltersLoading: isCustomFiltersLoading, versions: versions, labels: labels, components: components, customFilters: customFilters, quickFilters: quickFilters, onChange: onChange, onClearAllButtonClicked: onClearAllButtonClicked } = filterProps;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const jqlFilters = isCMP ? quickFilters : customFilters;
    const { collator: collator } = (0, $63ypL.useCollator)();
    const onFilterChanged = (0, $eUqFw.useCallback)((filters, filterType, extraAttributes)=>{
        (0, $75e8i.default)('timeline-filter');
        onChange(filters, filterType);
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        const hasUnassignedAssignee = Boolean(filterType === (0, $44677eb502cfd308$export$f8f7545d2bb78afb) && filters[0, $44677eb502cfd308$export$f8f7545d2bb78afb]);
        let hasUnassignedOption = hasUnassignedAssignee;
        const isAssigneeUnassigned = filters[0, $44677eb502cfd308$export$f8f7545d2bb78afb]?.includes((0, $44677eb502cfd308$export$12e572fd459c10dc));
        let isUnassigned = isAssigneeUnassigned;
        const hasUnassignedVersion = Boolean(filterType === (0, $44677eb502cfd308$export$a4ad2735b021c132) && filters[0, $44677eb502cfd308$export$a4ad2735b021c132]);
        const hasUnassignedLabel = Boolean(filterType === (0, $44677eb502cfd308$export$37aee82a3cb1e8f7) && filters[0, $44677eb502cfd308$export$37aee82a3cb1e8f7]);
        const hasUnassignedComponent = Boolean(filterType === (0, $44677eb502cfd308$export$af1e30ebbae9df3b) && filters[0, $44677eb502cfd308$export$af1e30ebbae9df3b]);
        hasUnassignedOption = hasUnassignedAssignee || hasUnassignedVersion || hasUnassignedLabel || hasUnassignedComponent;
        const isVersionUnassigned = filters[0, $44677eb502cfd308$export$a4ad2735b021c132]?.includes((0, $44677eb502cfd308$export$ac95b4b2317d4b33));
        const isLabelUnassigned = filters[0, $44677eb502cfd308$export$37aee82a3cb1e8f7]?.includes((0, $44677eb502cfd308$export$81ef49afbbead0a1));
        const isComponentUnassigned = filters[0, $44677eb502cfd308$export$af1e30ebbae9df3b]?.includes((0, $44677eb502cfd308$export$4b7c755e61199a36));
        isUnassigned = isAssigneeUnassigned || isVersionUnassigned || isLabelUnassigned || isComponentUnassigned;
        const attributes = hasUnassignedOption ? {
            filterType: filterType,
            isUnassigned: isUnassigned,
            ...extraAttributes || {}
        } : {
            filterType: filterType,
            ...extraAttributes || {}
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'changeFilterBar', attributes);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const onClear = (0, $eUqFw.useCallback)(()=>{
        onClearAllButtonClicked();
        const clickedAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const clearedAnalyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        (0, $jMP2a.fireUIAnalytics)(clickedAnalyticsEvent, 'clearFiltersButton');
        (0, $jMP2a.fireUIAnalytics)(clearedAnalyticsEvent, 'changeFilterBar', {
            filterType: (0, $44677eb502cfd308$export$6c4d37c7f376a1de)
        });
    }, [
        createAnalyticsEvent,
        onClearAllButtonClicked
    ]);
    const FilterBar = (0, $fmCcJ.default);
    const sortedGoals = [
        ...goals
    ].sort((a, b)=>collator.compare(a.name, b.name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            isMacroView ? "_19bv1ejb" : "_19bvidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FilterBar, {
        ...filterProps,
        goals: sortedGoals,
        externalId: "software.roadmap",
        screenName: "roadmap",
        onChange: onFilterChanged,
        onClearAllButtonClicked: onClear,
        isVersionsFeatureEnabled: versions.length > 0,
        isLabelsFeatureEnabled: labels.length > 0,
        isComponentsFeatureEnabled: components.length > 0,
        isGoalsFeatureOptionEnabled: goals.length > 0,
        showPanelToggle: false,
        showSearchFilterChangeboarding: !isMacroView,
        hijackBrowserDefaultSearch: !isMacroView,
        isUnassignedAssigneeOptionEnabled: true,
        isUnassignedVersionOptionEnabled: true,
        isUnassignedLabelOptionEnabled: true,
        isUnassignedComponentOptionEnabled: true,
        jqlFilters: jqlFilters,
        CustomFilter: $64456a3007204e2d$var$RoadmapCustomFilter,
        showCustomFilters: !isCMP,
        placeholder: formatMessage((0, $3z3DP.default).filterPlaceholder),
        isCustomFiltersLoading: isCustomFiltersLoading
    }));
};
$64456a3007204e2d$var$Filter.whyDidYouRender = true;
var $64456a3007204e2d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($64456a3007204e2d$var$Filter);
const $64456a3007204e2d$var$macroViewStyles = null;
const $64456a3007204e2d$var$nonMacroViewStyles = null;

});
parcelRegister("k8Lle", function(module, exports) {

$parcel$export(module.exports, "default", () => $5108fb81e1ffdb4d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $idkBG = parcelRequire("idkBG");

var $azooe = parcelRequire("azooe");

var $9QFla = parcelRequire("9QFla");
const $5108fb81e1ffdb4d$var$MAX_SELECTION_ALLOWED = 10;
const $5108fb81e1ffdb4d$var$CustomFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], showLink: showLink = false, manageUrl: manageUrl = '', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false, isCompanyManaged: isCompanyManaged = false, isPanelToggleChecked: isPanelToggleChecked = false, onTogglePanel: onTogglePanel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), showPanelToggle: showPanelToggle = false, shouldReturnFocus: shouldReturnFocus })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $9QFla.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $5108fb81e1ffdb4d$var$MAX_SELECTION_ALLOWED
    });
    const onLinkItemClick = (0, $eUqFw.useCallback)(()=>{
        (0, $idkBG.setReturnToProjectUrl)();
    }, []);
    const filterLabel = isCompanyManaged ? (0, $9QFla.default).labelCmp : (0, $9QFla.default).label;
    const manageLinkTitle = isCompanyManaged ? (0, $9QFla.default).manageLinkTitleCmp : (0, $9QFla.default).manageLinkTitle;
    const toggleLabel = isCompanyManaged ? formatMessage((0, $9QFla.default).toggleLabelCmp) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        shouldReturnFocus: shouldReturnFocus,
        buttonType: "QuickFilters",
        "data-testid": "filters.ui.filters.custom.assignee-filter",
        label: formatMessage(filterLabel),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        showLink: showLink,
        url: manageUrl,
        useHrefForUrl: isCompanyManaged,
        linkTitle: formatMessage(manageLinkTitle),
        maxSelectionAllowed: isCompanyManaged ? undefined : $5108fb81e1ffdb4d$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested,
        onLinkItemClick: onLinkItemClick,
        showPanelToggle: showPanelToggle,
        onTogglePanel: onTogglePanel,
        isPanelToggleChecked: isPanelToggleChecked,
        toggleLabel: toggleLabel
    });
};
const $5108fb81e1ffdb4d$var$CustomFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($5108fb81e1ffdb4d$var$CustomFilter);
$5108fb81e1ffdb4d$var$CustomFilterComponent.displayName = 'CustomFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$5108fb81e1ffdb4d$var$CustomFilterComponent.whyDidYouRender = true;
var $5108fb81e1ffdb4d$export$2e2bcd8739ae039 = $5108fb81e1ffdb4d$var$CustomFilterComponent;

});
parcelRegister("idkBG", function(module, exports) {

$parcel$export(module.exports, "setReturnToProjectUrl", () => $fad8e4e0d6f4380e$export$127f7bd1c092fc8f);
$parcel$export(module.exports, "getReturnToProjectUrl", () => $fad8e4e0d6f4380e$export$575dc7c4a154874b);

var $89bO2 = parcelRequire("89bO2");
const $fad8e4e0d6f4380e$var$RETURN_TO_PROJECT_URL = 'returnToProjectUrl';
const $fad8e4e0d6f4380e$var$sessionStorage = (0, $89bO2.createSessionExpirableStorageProvider)('navigation');
const $fad8e4e0d6f4380e$export$127f7bd1c092fc8f = ()=>{
    $fad8e4e0d6f4380e$var$sessionStorage.set($fad8e4e0d6f4380e$var$RETURN_TO_PROJECT_URL, window.location.pathname + window.location.search);
};
const $fad8e4e0d6f4380e$export$575dc7c4a154874b = ()=>String($fad8e4e0d6f4380e$var$sessionStorage.get($fad8e4e0d6f4380e$var$RETURN_TO_PROJECT_URL) || '');

});

parcelRegister("azooe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e44aa39502f5b060$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $bVKeg = parcelRequire("bVKeg");
var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $bBKri = parcelRequire("bBKri");

var $iN7qj = parcelRequire("iN7qj");

var $4q4xB = parcelRequire("4q4xB");

var $o0yPF = parcelRequire("o0yPF");

var $iRoug = parcelRequire("iRoug");

var $kCSUv = parcelRequire("kCSUv");
const $e44aa39502f5b060$var$MenuListWrapper = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "filters.common.ui.list.menu-list-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, rest, children));
const $e44aa39502f5b060$export$fa71ab09534e6447 = ({ isOpen: defaultIsOpen, isTriggerDisabled: isTriggerDisabled, isNested: isNested, isLoading: isLoading, isAsyncSearch: isAsyncSearch, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, label: label, toggleLabel: toggleLabel, buttonType: buttonType, values: values, selectedValues: selectedValueIds, onChange: onChange, onInputChange: onInputChange, onOpenChange: onOpenChange, noOptionsMessage: noOptionsMessage, menuGroupTitle: menuGroupTitle, inputValue: inputValue, maxSelectionAllowed: maxSelectionAllowed, maxSelectionReachedTooltip: maxSelectionReachedTooltip, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, CustomOptionLabel: CustomOptionLabel, placeholder: placeholder, shouldReturnFocus: shouldReturnFocus, ...footerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const options = (0, $eUqFw.useMemo)(()=>(0, $kCSUv.getOptionsFromProps)({
            values: values,
            menuGroupTitle: menuGroupTitle
        }), [
        values,
        menuGroupTitle
    ]);
    const { selectedIdLookup: selectedIdLookup, selectedOptions: selectedOptions } = (0, $eUqFw.useMemo)(()=>(0, $kCSUv.getSelectedOptionsFromProps)({
            values: values,
            selectedValueIds: selectedValueIds
        }), [
        values,
        selectedValueIds
    ]);
    /* Cannot return null here for async search as this would cause the
   * filter to disappear completely when fetch returns no results.
   */ if (!showMenuIfValuesAreEmpty && !isAsyncSearch && values.length === 0) return null;
    // ================= //
    // === Callbacks === //
    // ================= //
    const onChangeHandler = (selected)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(selected);
    };
    const onOpenChangeHandler = (isOpen)=>{
        const analyticsEvent = createAnalyticsEvent((0, $bBKri.OPEN_CHANGE_PAYLOAD));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $bBKri.OPEN_CHANGE_SUBJECT_ID));
        onOpenChange(isOpen);
    };
    const isOptionDisabled = (option)=>selectedOptions.length >= maxSelectionAllowed && !selectedIdLookup.has(option.value.toString());
    // ============== //
    // === RENDER === //
    // ============== //
    // Select expects a function that returns a string, rather than a string primitive
    const getNoOptionsMessage = noOptionsMessage === undefined ? noOptionsMessage : ()=>noOptionsMessage;
    const renderTrigger = (popupProps)=>(0, $eI5EY.fg)('allow_jplat_filter_list_to_be_disabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRoug.default), {
            ...popupProps,
            isDisabled: isTriggerDisabled,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRoug.default), {
            ...popupProps,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        });
    const renderFooter = ()=>(footerProps.showLink || footerProps.showPanelToggle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iN7qj.default), {
            label: label,
            toggleLabel: toggleLabel,
            ...footerProps
        });
    const renderOption = (option)=>{
        const { label: optionLabel, iconUrl: iconUrl, subLabel: subLabel, value: value } = option;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $o0yPF.default), {
            label: optionLabel,
            subLabel: subLabel,
            iconUrl: iconUrl,
            value: String(value),
            isDisabled: isOptionDisabled(option),
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            CustomOptionLabel: CustomOptionLabel ?? (0, $o0yPF.DefaultOptionLabel)
        });
    };
    const onKeyDown = (event)=>{
        if (event.key === 'Escape') event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        "aria-label": `Select ${label} filters`,
        // testId="filters.common.ui.list.menu-list-wrapper"
        isMulti: true,
        isLoading: isLoading,
        backspaceRemovesValue: true,
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        defaultIsOpen: defaultIsOpen,
        options: options,
        value: selectedOptions,
        inputValue: inputValue,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: placeholder ?? formatMessage((0, $4q4xB.default).placeholder),
        target: renderTrigger,
        footer: renderFooter(),
        formatOptionLabel: renderOption,
        components: {
            Option: (0, $bVKeg.CheckboxOption),
            DropdownIndicator: null,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            MenuList: $e44aa39502f5b060$var$MenuListWrapper
        },
        popperProps: {
            placement: isNested ? 'right-start' : 'bottom-start',
            // to render popup next to the trigger element to achieve DOM order
            strategy: 'fixed'
        },
        onChange: onChangeHandler,
        onInputChange: onInputChange,
        isOptionDisabled: isOptionDisabled,
        onMenuOpen: ()=>onOpenChangeHandler(true),
        onMenuClose: ()=>onOpenChangeHandler(false),
        onKeyDown: onKeyDown,
        ...(0, $kCSUv.getSearchableProps)({
            isAsyncSearch: isAsyncSearch,
            optionsCount: values.length,
            isNested: isNested
        })
    });
};
$e44aa39502f5b060$export$fa71ab09534e6447.defaultProps = {
    isOpen: false,
    isNested: false,
    isTriggerDisabled: false,
    isLoading: false,
    isAsyncSearch: false,
    isPanelToggleChecked: false,
    showLink: false,
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    useHrefForUrl: false,
    values: [],
    selectedValues: [],
    menuGroupTitle: undefined,
    noOptionsMessage: undefined,
    maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
    url: undefined,
    linkTitle: undefined,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onMouseEnterToTriggerButton: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $e44aa39502f5b060$export$2e2bcd8739ae039 = $e44aa39502f5b060$export$fa71ab09534e6447;

});
parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hSJ9G = parcelRequire("hSJ9G");

var $c6Z6Z = parcelRequire("c6Z6Z");

function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "35x0q3",
    styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "16e0ede",
    styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});
parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d04a81b304c826a5$var$_checkboxChecked = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d04a81b304c826a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d04a81b304c826a5$var$_checkboxChecked.default
    }));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = module.exports.default = $d04a81b304c826a5$var$CheckboxIcon;

});
parcelRegister("ejTfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cdb252f5736633$var$_react = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6cdb252f5736633$var$_UNSAFE_baseNew = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a6cdb252f5736633$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cdb252f5736633$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $a6cdb252f5736633$var$_react.default.createElement($a6cdb252f5736633$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$a6cdb252f5736633$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $a6cdb252f5736633$var$_default = module.exports.default = $a6cdb252f5736633$var$CheckboxCheckedIcon;

});


parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $02468a1d390d1515$var$_radioChecked = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("a7ob3")));
function $02468a1d390d1515$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $02468a1d390d1515$var$_radioChecked.default
    }));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = module.exports.default = $02468a1d390d1515$var$RadioIcon;

});
parcelRegister("a7ob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa46e6d801ee3a3fb5cceaf32be49fab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75dd4fef0eed872c$var$_react = $75dd4fef0eed872c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75dd4fef0eed872c$var$_UNSAFE_baseNew = $75dd4fef0eed872c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75dd4fef0eed872c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75dd4fef0eed872c$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $75dd4fef0eed872c$var$_react.default.createElement($75dd4fef0eed872c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$75dd4fef0eed872c$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $75dd4fef0eed872c$var$_default = module.exports.default = $75dd4fef0eed872c$var$RadioCheckedIcon;

});



parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $lbDTY = parcelRequire("lbDTY");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $asNSH = parcelRequire("asNSH");

var $XHGTv = parcelRequire("XHGTv");


var $5wCDk = parcelRequire("5wCDk");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");

var $7ldaw = parcelRequire("7ldaw");
/**
 * Are we rendering on the client or server?
 */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$FocusLock = (0, $XHGTv.fg)('platform_dst_select-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            if ((0, $XHGTv.fg)('tab-event-should-close-popupSelect')) {
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            }
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $XHGTv.fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $XHGTv.fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $lT14u.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $lT14u.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $lT14u.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform_design_system_team_select_node_resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29cbcff993ea6c5$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId,
                    ref: !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29cbcff993ea6c5$var$FocusLock, {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $e29cbcff993ea6c5$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});


parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hcvt0 = parcelRequire("hcvt0");


var $lcnyw = parcelRequire("lcnyw");

var $lkPEe = parcelRequire("lkPEe");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hcvt0))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).IndicatorSeparator, props);
const $e208c4fdfb4dbbc3$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, props);
const $e208c4fdfb4dbbc3$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu,
    IndicatorSeparator: $e208c4fdfb4dbbc3$var$IndicatorSeparator,
    ClearIndicator: $e208c4fdfb4dbbc3$var$ClearIndicator,
    MultiValueRemove: $e208c4fdfb4dbbc3$var$MultiValueRemove
};

});
parcelRegister("hcvt0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c85bf750af932d50$var$_react = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c85bf750af932d50$var$_search = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("9IsWp")));

var $c85bf750af932d50$var$_search2 = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("bPZtE")));
function $c85bf750af932d50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c85bf750af932d50$var$SearchIcon = (props)=>/*#__PURE__*/ $c85bf750af932d50$var$_react.default.createElement($c85bf750af932d50$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c85bf750af932d50$var$_search2.default
    }, props));
$c85bf750af932d50$var$SearchIcon.Name = 'SearchIconMigration';
var $c85bf750af932d50$var$_default = module.exports.default = $c85bf750af932d50$var$SearchIcon;

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $89e4253a013a6022$var$_search = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $89e4253a013a6022$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $89e4253a013a6022$var$_search.default
    }));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = module.exports.default = $89e4253a013a6022$var$EditorSearchIcon;

});




parcelRegister("bBKri", function(module, exports) {

$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH", () => $b7c20e9c2dfb0c8d$export$84ae3fb9fdba8a12);
$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH_ON_NESTED", () => $b7c20e9c2dfb0c8d$export$920d89f17cd2fe3d);
$parcel$export(module.exports, "FILTER_MENU_MAX_WIDTH", () => $b7c20e9c2dfb0c8d$export$6ea791ab71b8fa00);
$parcel$export(module.exports, "FILTER_SEARCH_THRESHOLD", () => $b7c20e9c2dfb0c8d$export$1d287c6a8b81eb5b);
$parcel$export(module.exports, "OPEN_CHANGE_PAYLOAD", () => $b7c20e9c2dfb0c8d$export$2f5981b7dbafe3a4);
$parcel$export(module.exports, "OPEN_CHANGE_SUBJECT_ID", () => $b7c20e9c2dfb0c8d$export$b94e5dc1a8a1409);

var $c9TLT = parcelRequire("c9TLT");
const $b7c20e9c2dfb0c8d$export$84ae3fb9fdba8a12 = (0, $c9TLT.gridSize) * 21;
const $b7c20e9c2dfb0c8d$export$920d89f17cd2fe3d = (0, $c9TLT.gridSize) * 25;
const $b7c20e9c2dfb0c8d$export$6ea791ab71b8fa00 = (0, $c9TLT.gridSize) * 48;
const $b7c20e9c2dfb0c8d$export$1d287c6a8b81eb5b = 9;
const $b7c20e9c2dfb0c8d$export$2f5981b7dbafe3a4 = {
    action: 'clicked',
    actionSubject: 'dropdownMenu'
};
const $b7c20e9c2dfb0c8d$export$b94e5dc1a8a1409 = 'filterList';

});

parcelRegister("iN7qj", function(module, exports) {

$parcel$export(module.exports, "default", () => $11194a43908dcca2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $jMP2a = parcelRequire("jMP2a");

var $l61gw = parcelRequire("l61gw");

var $i3CUI = parcelRequire("i3CUI");
const $11194a43908dcca2$var$FilterListFooter = ({ isPanelToggleChecked: isPanelToggleChecked, showLink: showLink, showPanelToggle: showPanelToggle, useHrefForUrl: useHrefForUrl, url: url, label: label, toggleLabel: toggleLabel, linkTitle: linkTitle, toggleRef: toggleRef, onTogglePanel: onTogglePanel, onLinkItemClick: onLinkItemClick })=>{
    const onToggleHandler = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onTogglePanel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (showPanelToggle || showLink && url && linkTitle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11194a43908dcca2$var$HorizontalSeparator, null), showPanelToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11194a43908dcca2$var$PanelToggleContainer, {
        "data-testid": "filters.common.ui.list.footer.panel-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i3CUI.default), {
        label: toggleLabel || label,
        panelType: label,
        isChecked: isPanelToggleChecked,
        toggleRef: toggleRef,
        onToggle: onToggleHandler
    })), showLink && url && linkTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l61gw.default), {
        url: url,
        linkTitle: linkTitle,
        onClick: onLinkItemClick,
        useHref: useHrefForUrl
    }));
};
$11194a43908dcca2$var$FilterListFooter.defaultProps = {
    url: undefined,
    linkTitle: undefined,
    showPanel: false,
    showLink: false,
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $11194a43908dcca2$export$2e2bcd8739ae039 = $11194a43908dcca2$var$FilterListFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11194a43908dcca2$var$HorizontalSeparator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _4t3iv77o _bfhkyucn _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $11194a43908dcca2$var$PanelToggleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4wux3 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l61gw", function(module, exports) {

$parcel$export(module.exports, "default", () => $63861f575a33e906$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $eGI9v = parcelRequire("eGI9v");

var $jMP2a = parcelRequire("jMP2a");

var $lB25E = parcelRequire("lB25E");
const $63861f575a33e906$var$DropdownItem = (0, $eGI9v.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $63861f575a33e906$var$linkWrapperStyles = null;
const $63861f575a33e906$export$532cb6865ebe8946 = ({ url: url, linkTitle: linkTitle, onClick: onClick, useHref: useHref = false })=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const onDropdownClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'clickLinkFromFilters');
        onClick && onClick();
        if (!useHref) push(url);
    }, [
        useHref,
        onClick,
        push,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq _n3td1b66 _n3ag1osq _1i3qd8e8 _hjpp1osq _c24d81pi"
        ])
    }, useHref ? /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63861f575a33e906$var$DropdownItem, {
        href: url,
        onClick: onDropdownClick
    }, linkTitle) : /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63861f575a33e906$var$DropdownItem, {
        onClick: onDropdownClick
    }, linkTitle));
};
var $63861f575a33e906$export$2e2bcd8739ae039 = $63861f575a33e906$export$532cb6865ebe8946;

});
parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});
parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});
parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});






parcelRegister("i3CUI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb29b4841d4c7f6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $ffiyv = parcelRequire("ffiyv");

var $e270j = parcelRequire("e270j");

var $eGI9v = parcelRequire("eGI9v");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $5oqMG = parcelRequire("5oqMG");

var $2GBsX = parcelRequire("2GBsX");
const $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID = 'filters.common.ui.list.panel-toggle.toggle-checkbox';
const $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID = 'filters.common.ui.list.panel-toggle.toggle-hint';
const $cfb29b4841d4c7f6$var$PanelToggle = (props)=>{
    const { isChecked: isChecked, panelType: panelType, onToggle: onToggle, ariaLabel: ariaLabel, intl: { formatMessage: formatMessage }, toggleRef: toggleRef = null, label: label } = props;
    const panelToggleKeyboardShortcut = (0, $5oqMG.getKeyboardShortcutForPanel)(panelType);
    const toggleLabel = label || formatMessage((0, $2GBsX.default).toggleLabel, {
        panelType: panelType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        label: ariaLabel,
        id: $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID,
        ref: toggleRef,
        onChange: onToggle,
        isChecked: isChecked,
        testId: "filters.common.ui.list.panel-toggle.panel-toggle",
        descriptionId: $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleLabel, {
        htmlFor: $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID
    }, toggleLabel)), panelToggleKeyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleHint, {
        id: $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $2GBsX.default).toggleHint,
        values: {
            kbd: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, chunks),
            key: panelToggleKeyboardShortcut
        }
    })));
};
$cfb29b4841d4c7f6$var$PanelToggle.defaultProps = {
    isChecked: false,
    panelType: '',
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $cfb29b4841d4c7f6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $2qhQi.default), (0, $eUqFw.memo), (0, $eGI9v.default)('filterPanelToggle', {
    onToggle: 'toggled'
}))($cfb29b4841d4c7f6$var$PanelToggle);
const $cfb29b4841d4c7f6$var$PanelToggleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleControl = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0v77o _1reo15vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleHint = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _o5721q9c _11c8qk37 _19pkidpf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});



parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform-visual-refresh-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});



parcelRegister("5oqMG", function(module, exports) {

$parcel$export(module.exports, "getKeyboardShortcutForPanel", () => $4efb03f3225c562c$export$fa36ece4b5d88abc);

const $4efb03f3225c562c$var$panelShortcuts = {
    Epic: (0, $b9597ab46ec7cd93$export$9b094cdf6fd7589e),
    Version: (0, $b9597ab46ec7cd93$export$6f416a1fb11a53d9)
};
const $4efb03f3225c562c$export$fa36ece4b5d88abc = (panelType)=>$4efb03f3225c562c$var$panelShortcuts[panelType];

});
const $b9597ab46ec7cd93$export$a10c132b86ae798b = 'Epic';
const $b9597ab46ec7cd93$export$41073ac826c57195 = 'Version';
const $b9597ab46ec7cd93$export$9b094cdf6fd7589e = 'E';
const $b9597ab46ec7cd93$export$6f416a1fb11a53d9 = 'V';


parcelRegister("2GBsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $01d484359a982a7b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $01d484359a982a7b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    toggleAccessibilityLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-accessibility-label",
        "defaultMessage": "Toggle panel"
    },
    toggleLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-label",
        "defaultMessage": "{panelType} panel"
    },
    toggleHint: {
        "id": "software-filters.common.list.panel-toggle.toggle-hint",
        "defaultMessage": "Press <kbd>{key}</kbd> to open and close"
    }
});

});



parcelRegister("4q4xB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b803d9be02c7a9c9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b803d9be02c7a9c9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "software-filters.common.list.placeholder",
        "defaultMessage": "Search filters\u2026"
    },
    anounceMessage: {
        "id": "software-filters.common.list.anounce-message",
        "defaultMessage": "When selecting from the {field} filter, content in the backlog board will automatically update"
    }
});

});

parcelRegister("o0yPF", function(module, exports) {

$parcel$export(module.exports, "DefaultOptionLabel", () => $4e0754c0a543f63b$export$86f820b2f37564e5);
$parcel$export(module.exports, "default", () => $4e0754c0a543f63b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $2eG9N = parcelRequire("2eG9N");

var $c9TLT = parcelRequire("c9TLT");
const $4e0754c0a543f63b$export$86f820b2f37564e5 = ({ label: label, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, iconUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$Icon, {
        src: iconUrl,
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionLabel, null, label));
const $4e0754c0a543f63b$var$ListFilterOption = ({ label: label, subLabel: subLabel, iconUrl: iconUrl, value: value, maxSelectionReachedTooltip: maxSelectionReachedTooltip, isDisabled: isDisabled, CustomOptionLabel: CustomOptionLabel })=>{
    const content = isDisabled && maxSelectionReachedTooltip ? maxSelectionReachedTooltip : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionWrapper, {
        "data-testid": "filters.common.ui.list.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomOptionLabel, {
        label: label,
        value: value,
        iconUrl: iconUrl
    })), subLabel !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionSubLabel, null, subLabel));
};
$4e0754c0a543f63b$var$ListFilterOption.defaultProps = {
    iconUrl: undefined,
    isDisabled: false
};
var $4e0754c0a543f63b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4e0754c0a543f63b$var$ListFilterOption);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e0754c0a543f63b$var$SelectOptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$SelectOptionLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$SelectOptionSubLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syaz1e9r _1wyb1skh",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_zb0g5d": (0, $9t7rW.default)((0, $c9TLT.layout).issueIconSize, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsbwrp2 _4t3iwrp2 _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iRoug", function(module, exports) {

$parcel$export(module.exports, "default", () => $2627b6651f6d491e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $c6CvK = parcelRequire("c6CvK");

var $fCmfi = parcelRequire("fCmfi");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $eI5EY = parcelRequire("eI5EY");

var $2KzVh = parcelRequire("2KzVh");

var $8WuJm = parcelRequire("8WuJm");

var $8rQuz = parcelRequire("8rQuz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2627b6651f6d491e$var$FilterListTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isOpen: isOpen, isNested: isNested, isDisabled: isDisabled, label: label, buttonType: buttonType, selectedCount: selectedCount, onMouseEnter: onMouseEnter, shouldReturnFocus: shouldReturnFocus, ...popupProps }, ref)=>{
    const testId = `filters.common.ui.list.${label.toLowerCase().replace(/ /g, '-')}-filter`;
    const primaryColor = isOpen ? "var(--ds-icon-selected, #0052CC)" : "var(--ds-icon, #44546F)";
    const IconComponent = isNested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCmfi))), {
        label: "",
        color: primaryColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))),
        LEGACY_primaryColor: primaryColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))), {
        label: "",
        color: primaryColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
        LEGACY_primaryColor: primaryColor
    });
    const inputRef = (0, $eUqFw.useRef)();
    const isMounted = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldReturnFocus && buttonType === 'QuickFilters' && isMounted.current) inputRef?.current?.focus();
        else isMounted.current = true;
    }, [
        shouldReturnFocus,
        buttonType
    ]);
    const conditionalRef = buttonType === 'QuickFilters' ? (0, $2KzVh.mergeRefs)(ref, inputRef) : ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            !isNested && $2627b6651f6d491e$var$containerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "dropDownMenu",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$StyledButton, {
        ...popupProps,
        ref: conditionalRef,
        isNested: isNested,
        isSelected: isOpen || (0, $8rQuz.isVisualRefreshEnabled)() && selectedCount > 0,
        shouldFitContainer: isNested,
        appearance: (0, $8rQuz.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onMouseEnter: onMouseEnter,
        iconAfter: (0, $8rQuz.isVisualRefreshEnabled)() && selectedCount > 0 ? undefined : IconComponent,
        ...(0, $eI5EY.fg)('allow_jplat_filter_list_to_be_disabled') && {
            isDisabled: isDisabled || false
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label,
        hideTooltipOnClick: true,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$TriggerContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$TriggerLabel, null, label), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$CountWrapper, {
        isNested: isNested,
        "data-testid": `${testId}-badge`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: "primary"
    }, selectedCount)))))));
});
var $2627b6651f6d491e$export$2e2bcd8739ae039 = $2627b6651f6d491e$var$FilterListTrigger;
const $2627b6651f6d491e$var$containerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $2627b6651f6d491e$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isNested && "_2rkogrf3 _u5f3ns44 _1bg412gs",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$CountWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNested: isNested, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.isNested ? "_18u01wug _19bvftgi" : "_19bv1y44",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$TriggerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$TriggerLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f68cl _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("2KzVh", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $0be6a57b715845c4$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $0be6a57b715845c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0be6a57b715845c4$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $0be6a57b715845c4$export$2e2bcd8739ae039(...refs) {
    return (0, $eUqFw.useMemo)(()=>$0be6a57b715845c4$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("kCSUv", function(module, exports) {

$parcel$export(module.exports, "getOptionsFromProps", () => $d5275d028e90805a$export$ecd68164c475a713);
$parcel$export(module.exports, "getSelectedOptionsFromProps", () => $d5275d028e90805a$export$94d5b7a6f69b418);
$parcel$export(module.exports, "getSearchableProps", () => $d5275d028e90805a$export$62d9d395b3dd2ae8);

var $cEc3i = parcelRequire("cEc3i");

var $bBKri = parcelRequire("bBKri");
const $d5275d028e90805a$var$isValueGroupOption = (value)=>'options' in value;
const $d5275d028e90805a$var$containsOnlyOption = (values)=>values.every((value)=>!$d5275d028e90805a$var$isValueGroupOption(value));
const $d5275d028e90805a$export$ecd68164c475a713 = ({ values: values, menuGroupTitle: menuGroupTitle })=>{
    // menuGroupTitle should be deprecated
    if (menuGroupTitle && $d5275d028e90805a$var$containsOnlyOption(values)) return [
        {
            label: menuGroupTitle,
            options: values
        }
    ];
    return values;
};
const $d5275d028e90805a$export$94d5b7a6f69b418 = ({ values: values, selectedValueIds: selectedValueIds })=>{
    const selectedIdLookup = selectedValueIds.reduce((acc, cur)=>{
        acc.add(cur);
        return acc;
    }, new Set());
    const valuesToLook = values.flatMap((value)=>$d5275d028e90805a$var$isValueGroupOption(value) ? value.options : [
            value
        ]);
    const selectedOptions = valuesToLook.filter(({ value: value })=>selectedIdLookup.has(value));
    return {
        selectedIdLookup: selectedIdLookup,
        selectedOptions: selectedOptions
    };
};
const $d5275d028e90805a$export$62d9d395b3dd2ae8 = ({ optionsCount: optionsCount, isAsyncSearch: isAsyncSearch, defaultSearchThreshold: defaultSearchThreshold = (0, $bBKri.FILTER_SEARCH_THRESHOLD), isNested: isNested })=>{
    // Search input should always be visible for async selects
    const searchThreshold = isAsyncSearch ? -1 : defaultSearchThreshold;
    const isSearchable = optionsCount > searchThreshold;
    // Due to renderToParent the grid size will change so, incresing the min width for low resolutions
    const filterMenuMinWidth = isNested ? (0, $bBKri.FILTER_MENU_MIN_WIDTH_ON_NESTED) : (0, $bBKri.FILTER_MENU_MIN_WIDTH);
    const maxMenuWidth = (0, $bBKri.FILTER_MENU_MAX_WIDTH);
    // Set the min and max width to be the same so updated search results don't cause the menu to resize
    const minMenuWidth = isSearchable ? maxMenuWidth : filterMenuMinWidth;
    // Don't filter anything on the frontend for async selects
    const filter = (0, $cEc3i.c)({
        stringify: (option)=>option.label
    });
    const filterOption = isAsyncSearch ? undefined : filter;
    return {
        minMenuWidth: minMenuWidth,
        maxMenuWidth: maxMenuWidth,
        searchThreshold: searchThreshold,
        filterOption: filterOption
    };
};

});


parcelRegister("9QFla", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7be5eeb33252bd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5c7be5eeb33252bd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.custom.label",
        "defaultMessage": "Custom filters"
    },
    labelCmp: {
        "id": "software-filters.filters.custom.label-cmp",
        "defaultMessage": "Quick filters"
    },
    manageLinkTitle: {
        "id": "software-filters.filters.custom.manage-link-title",
        "defaultMessage": "Manage custom filters"
    },
    manageLinkTitleCmp: {
        "id": "software-filters.filters.custom.manage-link-title-cmp",
        "defaultMessage": "Manage quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.custom.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed} custom filters"
    },
    toggleLabelCmp: {
        "id": "software-filters.filters.custom.toggle-label-cmp",
        "defaultMessage": "Show quick filters"
    }
});

});


parcelRegister("fmCcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ea7329b75e4ee65$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $jG2Eu = parcelRequire("jG2Eu");

var $7GXrf = parcelRequire("7GXrf");

var $asu8X = parcelRequire("asu8X");

var $8CfG4 = parcelRequire("8CfG4");

var $dsroq = parcelRequire("dsroq");

var $b5IAe = parcelRequire("b5IAe");

var $4Bees = parcelRequire("4Bees");

var $cf2Y4 = parcelRequire("cf2Y4");

var $kjXsi = parcelRequire("kjXsi");

var $9zALC = parcelRequire("9zALC");

var $jmejm = parcelRequire("jmejm");

var $gfXKy = parcelRequire("gfXKy");

var $axKFq = parcelRequire("axKFq");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $8NoA2 = parcelRequire("8NoA2");

var $7xG8t = parcelRequire("7xG8t");

var $itGQN = parcelRequire("itGQN");

var $35WdX = parcelRequire("35WdX");

var $9U5Uu = parcelRequire("9U5Uu");

var $9D86p = parcelRequire("9D86p");

var $6syeh = parcelRequire("6syeh");

var $kpwtP = parcelRequire("kpwtP");

var $dNCGp = parcelRequire("dNCGp");

var $ifij9 = parcelRequire("ifij9");

var $37gdQ = parcelRequire("37gdQ");

var $8rjRz = parcelRequire("8rjRz");

var $9iyDY = parcelRequire("9iyDY");

var $hNl8a = parcelRequire("hNl8a");

var $7Xd92 = parcelRequire("7Xd92");

var $2ZPCT = parcelRequire("2ZPCT");

var $b9Y1q = parcelRequire("b9Y1q");

var $01UFf = parcelRequire("01UFf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $glQYN = parcelRequire("glQYN");

var $7uxUn = parcelRequire("7uxUn");

var $fqAlt = parcelRequire("fqAlt");

var $fmImn = parcelRequire("fmImn");

var $l4zCR = parcelRequire("l4zCR");

var $8Ui86 = parcelRequire("8Ui86");

var $6vrw7 = parcelRequire("6vrw7");

var $1Ksr6 = parcelRequire("1Ksr6");

var $dxcfv = parcelRequire("dxcfv");

var $8rQuz = parcelRequire("8rQuz");


var $cV7Ha = parcelRequire("cV7Ha");

var $8gxRf = parcelRequire("8gxRf");

var $8D53g = parcelRequire("8D53g");

var $hREiq = parcelRequire("hREiq");

var $iesgE = parcelRequire("iesgE");

var $gp3Fg = parcelRequire("gp3Fg");

var $84m3I = parcelRequire("84m3I");
const $2ea7329b75e4ee65$var$EMPTY_ARRAY = [];
const $2ea7329b75e4ee65$var$MIN_VISIBLE_USERS = 2;
const $2ea7329b75e4ee65$var$USER_AVATAR_WIDTH = 30;
const $2ea7329b75e4ee65$var$DEFAULT_VISIBLE_USERS = 7;
const $2ea7329b75e4ee65$var$MIN_FILTER_BAR_WIDTH = 510;
const $2ea7329b75e4ee65$var$LARGE_SEARCH_FILTER_BREAKPOINT = 1440;
const $2ea7329b75e4ee65$var$SoftwareFiltersStateless = (props)=>{
    (0, $asu8X.di)(requestAnimationFrame);
    const { filter: filter, issueParentsLabel: issueParentsLabel, assignees: assignees = [], issueParents: issueParents = [], versions: versions = [], components: components = [], labels: labels = [], issueProjects: issueProjects = {}, issueTypes: issueTypes = [], issueTypeGroups: issueTypeGroups = [], statuses: statuses = [], requestTypes: requestTypes = [], onChange: onChange, onSearchFieldFocus: onSearchFieldFocus = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onExtraAvatarMenuOpen: onExtraAvatarMenuOpen = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFilterPanelMounted: onFilterPanelMounted = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onClearAllButtonClicked: onClearAllButtonClicked = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onToggleParentPanel: onToggleParentPanel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onToggleVersionsPanel: onToggleVersionsPanel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isIssueParentPanelToggleChecked: isIssueParentPanelToggleChecked = false, isVersionPanelToggleChecked: isVersionPanelToggleChecked = false, isAnyModalOpen: isAnyModalOpen = false, AddPeopleModal: AddPeopleModal, showPanelToggle: /**
     * @deprecated `showPanelToggle` used to control visibility of all panel toggles. Use `panelToggleVisibility` instead to control each panel toggle visibility.
     */ showPanelToggle = false, panelToggleVisibility: panelToggleVisibility, showParentIssueMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty = false, showSearchFilterChangeboarding: showSearchFilterChangeboarding = false, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isVersionsFeatureEnabled: isVersionsFeatureEnabled = false, isComponentsFeatureEnabled: isComponentsFeatureEnabled = false, isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled = true, isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled = true, isLabelsFeatureEnabled: isLabelsFeatureEnabled = true, isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled = false, isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled = true, isSprintsFeatureEnabled: isSprintsFeatureEnabled = true, isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled = false, isStatusesFeatureEnabled: isStatusesFeatureEnabled = false, isGroupIssueTypesEnabled: isGroupIssueTypesEnabled = false, isDependenciesFeatureEnabled: isDependenciesFeatureEnabled = false, onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), projectId: projectId, projectName: projectName, projectKey: projectKey, boardId: boardId, statusCategories: statusCategories = [], customFiltersQueryRef: customFiltersQueryRef, CustomFilter: CustomFilter, showAssigneeFilter: showAssigneeFilter = true, showCustomFilters: showCustomFilters = false, showBoardSwitcher: showBoardSwitcher = false, isBoardSwitcherReadOnly: isBoardSwitcherReadOnly = true, versionFilterRelayQueryRef: versionFilterRelayQueryRef, VersionFilterRelay: VersionFilterRelay, isVersionFilterRelayEnabled: isVersionFilterRelayEnabled = false, isUnassignedAssigneeOptionEnabled: isUnassignedAssigneeOptionEnabled = false, isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled = false, isUnassignedLabelOptionEnabled: isUnassignedLabelOptionEnabled = false, isUnassignedComponentOptionEnabled: isUnassignedComponentOptionEnabled = false, isCustomFiltersLoading: isCustomFiltersLoading = false, placeholder: placeholder = '', screenReaderInstruction: screenReaderInstruction = '', sprints: sprints = [], isAddPeopleButtonEnabled: isAddPeopleButtonEnabled = false, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled = false, jqlFilters: jqlFilters = [], isCompanyManaged: isCompanyManaged = false, isJSMBoard: isJSMBoard = false, hasMultipleProjects: hasMultipleProjects = false, isGoalsFeatureOptionEnabled: isGoalsFeatureOptionEnabled = false, goals: goals = [] } = props;
    const accountId = (0, $dxcfv.useAccountId)();
    const isAsyncFilterLoading = isCustomFiltersLoading;
    const [screenReaderInstructionForFilters, setScreenReaderInstructionForFilters] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const allAssignees = (0, $eUqFw.useMemo)(()=>{
        if (!isUnassignedAssigneeOptionEnabled) return assignees;
        const unassignedUser = {
            id: (0, $6vrw7.toAccountId)((0, $44677eb502cfd308$export$12e572fd459c10dc)),
            displayName: formatMessage((0, $gp3Fg.default).unassignedAssigneeDisplayName),
            avatarUrl: undefined
        };
        if ((0, $eI5EY.fg)('jira-collab-unassigned-filter-cta-gate')) return [
            unassignedUser,
            ...assignees
        ];
        return [
            ...assignees,
            unassignedUser
        ];
    }, [
        assignees,
        isUnassignedAssigneeOptionEnabled,
        formatMessage
    ]);
    const allVersions = (0, $eUqFw.useMemo)(()=>isUnassignedVersionOptionEnabled && versions.length ? [
            {
                id: (0, $44677eb502cfd308$export$ac95b4b2317d4b33),
                name: formatMessage((0, $gp3Fg.default).unassignedVersionLabel)
            },
            ...versions
        ] : versions, [
        versions,
        isUnassignedVersionOptionEnabled,
        formatMessage
    ]);
    const unassignedOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $gp3Fg.default).unassignedLabelLabel),
            value: (0, $44677eb502cfd308$export$81ef49afbbead0a1)
        }), [
        formatMessage
    ]);
    const allComponents = (0, $eUqFw.useMemo)(()=>isUnassignedComponentOptionEnabled && components.length ? [
            {
                id: (0, $44677eb502cfd308$export$4b7c755e61199a36),
                name: formatMessage((0, $gp3Fg.default).unassignedComponentLabel)
            },
            ...components
        ] : components, [
        components,
        isUnassignedComponentOptionEnabled,
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onFilterPanelMounted();
    }, [
        onFilterPanelMounted
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSearchChange = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((newText)=>{
        onChangeInteractionStart();
        onChange({
            [(0, $44677eb502cfd308$export$d597759d33be802e)]: newText
        }, (0, $44677eb502cfd308$export$d597759d33be802e), undefined);
    }, 300), [
        onChange,
        onChangeInteractionStart
    ]);
    const assigneeValue = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filter, [
            (0, $44677eb502cfd308$export$f8f7545d2bb78afb)
        ], $2ea7329b75e4ee65$var$EMPTY_ARRAY), [
        filter
    ]);
    const onToggleAssignee = (0, $eUqFw.useCallback)((entryId)=>{
        setScreenReaderInstructionForFilters(true);
        setTimeout(()=>{
            setScreenReaderInstructionForFilters(false);
        });
        const withoutValue = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(assigneeValue, entryId);
        const newFilterValue = withoutValue.length === assigneeValue.length ? withoutValue.concat(entryId) : withoutValue;
        onChange({
            [(0, $44677eb502cfd308$export$f8f7545d2bb78afb)]: (0, $6vrw7.toAccountIdArray)(newFilterValue)
        }, (0, $44677eb502cfd308$export$f8f7545d2bb78afb), {
            isUnassignedFilterCta: false,
            // part of experiment jira-collab-unassigned-filter-cta
            isUnassignedSelected: newFilterValue.includes((0, $44677eb502cfd308$export$12e572fd459c10dc)),
            isOnlyCurrentUserSelected: accountId && newFilterValue.length === 1 && newFilterValue[0] === accountId
        });
    }, [
        assigneeValue,
        onChange,
        accountId
    ]);
    const onChangeParents = (0, $eUqFw.useCallback)((parentIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$2a4f270075a033de)]: parentIds
        }, (0, $44677eb502cfd308$export$2a4f270075a033de), attributes);
    }, [
        onChange
    ]);
    const onChangeVersions = (0, $eUqFw.useCallback)((versionIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$a4ad2735b021c132)]: (0, $6vrw7.toVersionIdArray)(versionIds)
        }, (0, $44677eb502cfd308$export$a4ad2735b021c132), attributes);
    }, [
        onChange
    ]);
    const onChangeComponents = (0, $eUqFw.useCallback)((componentIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$af1e30ebbae9df3b)]: (0, $6vrw7.toComponentIdArray)(componentIds)
        }, (0, $44677eb502cfd308$export$af1e30ebbae9df3b), attributes);
    }, [
        onChange
    ]);
    const onChangeLabels = (0, $eUqFw.useCallback)((newLabels, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$37aee82a3cb1e8f7)]: newLabels
        }, (0, $44677eb502cfd308$export$37aee82a3cb1e8f7), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueProjects = (0, $eUqFw.useCallback)((newProjects, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$401f4b6eda6a369c)]: newProjects
        }, (0, $44677eb502cfd308$export$401f4b6eda6a369c), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueTypes = (0, $eUqFw.useCallback)((issueTypeIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$ebb48b08205007c5)]: issueTypeIds
        }, (0, $44677eb502cfd308$export$ebb48b08205007c5), attributes);
    }, [
        onChange
    ]);
    const onChangeStatusCategories = (0, $eUqFw.useCallback)((newStatusCategories, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$f863b019d19144f4)]: newStatusCategories
        }, (0, $44677eb502cfd308$export$f863b019d19144f4), attributes);
    }, [
        onChange
    ]);
    const onChangeCustomFilters = (0, $eUqFw.useCallback)((newCustomFilters, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$68d693c35a8d8866)]: newCustomFilters
        }, (0, $44677eb502cfd308$export$68d693c35a8d8866), attributes);
    }, [
        onChange
    ]);
    const onChangeSprints = (0, $eUqFw.useCallback)((newSprintIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$a316570a0dbfd2b0)]: newSprintIds
        }, (0, $44677eb502cfd308$export$a316570a0dbfd2b0), attributes);
    }, [
        onChange
    ]);
    const onChangeStatuses = (0, $eUqFw.useCallback)((newStatuses, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$e50006273435e7d4)]: newStatuses
        }, (0, $44677eb502cfd308$export$e50006273435e7d4), attributes);
    }, [
        onChange
    ]);
    const onChangeRequestTypes = (0, $eUqFw.useCallback)((newRequestTypeIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$92ab80c1dc9baf44)]: newRequestTypeIds
        }, (0, $44677eb502cfd308$export$92ab80c1dc9baf44), attributes);
    }, [
        onChange
    ]);
    const onChangeQuickFilters = (0, $eUqFw.useCallback)((newQuickFilters, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$1ea95b94fb0c51d9)]: newQuickFilters
        }, (0, $44677eb502cfd308$export$1ea95b94fb0c51d9), attributes);
    }, [
        onChange
    ]);
    const onChangeGoals = (0, $eUqFw.useCallback)((goalIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$871e58afc769b358)]: goalIds
        }, (0, $44677eb502cfd308$export$871e58afc769b358), attributes);
    }, [
        onChange
    ]);
    const onChangeDependencies = (0, $eUqFw.useCallback)((dependencyOptions, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$db362e2d293fe52e)]: dependencyOptions
        }, (0, $44677eb502cfd308$export$db362e2d293fe52e), attributes);
    }, [
        onChange
    ]);
    const isClearButtonVisible = (0, $eUqFw.useMemo)(()=>filter && Object.keys(filter).length > 0, [
        filter
    ]);
    const searchInputRef = (0, $eUqFw.useRef)(null);
    const fireShortcutAnalytics = (0, $1Ksr6.useShortcutAnalytics)(screenName);
    const focusSearchInput = (0, $79xbN.expVal)('blu-3488_fix_jsw_filters_flickering', 'isEnabled', false) ? ()=>{
        if (!searchInputRef.current) return; // This is the same way the global search input prevents
        // the shortcut from being fed into the input
        // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
        requestAnimationFrame(()=>{
            searchInputRef.current && searchInputRef.current.focus();
        });
        const analyticsPayload = {
            id: 'focusSearchField',
            key: 'f',
            attributes: {}
        };
        fireShortcutAnalytics(analyticsPayload);
    } : ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(searchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(searchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                searchInputRef.current && searchInputRef.current.focus();
            });
            const analyticsPayload = {
                id: 'focusSearchField',
                key: 'f',
                attributes: {}
            };
            fireShortcutAnalytics(analyticsPayload);
        }
    };
    const screenReaderDescriptionId = 'search-issue-description';
    const isUserBoard = window.location.pathname.startsWith('/jira/people/');
    const customFilterManageUrl = (0, $84m3I.getManageCustomFiltersUrl)(projectKey, boardId.toString(), isCompanyManaged, isUserBoard, isJSMBoard);
    const showEpicPanelToggle = panelToggleVisibility ? panelToggleVisibility.showEpicPanelToggle : showPanelToggle;
    const isMounted = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (isMounted.current) {
            if (!isClearButtonVisible) {
                setScreenReaderInstructionForFilters(true);
                setTimeout(()=>{
                    setScreenReaderInstructionForFilters(false);
                }, 1000);
            }
        } else isMounted.current = true;
    }, [
        isClearButtonVisible
    ]);
    const parentFilter = {
        id: (0, $44677eb502cfd308$export$2a4f270075a033de),
        isStatic: false,
        isHidden: (0, $cV7Ha.isIncrementPlanningBoardM1Enabled)() ? !isIssueParentsFeatureEnabled : undefined,
        renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37gdQ.default), {
                key: "ParentFilter",
                isNested: isNested,
                label: issueParentsLabel,
                parents: issueParents,
                selectedParents: filter[0, $44677eb502cfd308$export$2a4f270075a033de],
                isToggleChecked: isIssueParentPanelToggleChecked,
                onChange: onChangeParents,
                onTogglePanel: onToggleParentPanel,
                showPanelToggle: showEpicPanelToggle,
                showMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty
            })
    };
    const showVersionsPanelToggle = panelToggleVisibility ? panelToggleVisibility.showVersionsPanelToggle : showPanelToggle;
    const versionFilter = {
        id: (0, $44677eb502cfd308$export$a4ad2735b021c132),
        isStatic: false,
        hidden: (0, $eI5EY.fg)('jsw-perf-backlog-versions-filter-load') ? !isVersionsFeatureEnabled : undefined,
        renderer: (isNested)=>isVersionFilterRelayEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iesgE.default), {
                key: "VersionFilterRelayBoundary",
                screenName: screenName,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b9Y1q.default), {
                    isNested: isNested,
                    versions: $2ea7329b75e4ee65$var$EMPTY_ARRAY,
                    isToggleChecked: isVersionPanelToggleChecked,
                    onChange: onChangeVersions,
                    onTogglePanel: onToggleVersionsPanel,
                    selectedVersions: filter[0, $44677eb502cfd308$export$a4ad2735b021c132] ?? $2ea7329b75e4ee65$var$EMPTY_ARRAY,
                    isSpotlightEnabled: false,
                    showPanelToggle: showVersionsPanelToggle,
                    isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                    hasMultipleProjects: hasMultipleProjects,
                    isLoading: true
                })
            }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(VersionFilterRelay, {
                isNested: isNested,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $44677eb502cfd308$export$a4ad2735b021c132] ?? $2ea7329b75e4ee65$var$EMPTY_ARRAY,
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                hasMultipleProjects: hasMultipleProjects
            }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b9Y1q.default), {
                key: "VersionFilter",
                isNested: isNested,
                versions: allVersions,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $44677eb502cfd308$export$a4ad2735b021c132] ?? $2ea7329b75e4ee65$var$EMPTY_ARRAY,
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled
            })
    };
    const overflowItemsBefore = [
        {
            id: (0, $44677eb502cfd308$export$f863b019d19144f4),
            isStatic: false,
            isHidden: !isStatusCategoriesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Xd92.default), {
                    key: "StatusCategoryFilter",
                    isNested: isNested,
                    statusCategories: statusCategories,
                    selectedStatusCategories: filter[0, $44677eb502cfd308$export$f863b019d19144f4],
                    onChange: onChangeStatusCategories
                })
        },
        /**
   * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
   * please refer to src/packages/software/board/src/services/filter/filter-url-bindings.tsx
   */ {
            id: (0, $44677eb502cfd308$export$401f4b6eda6a369c),
            isStatic: false,
            isHidden: (0, $cV7Ha.isIncrementPlanningBoardM1Enabled)() ? !isIssueProjectsFeatureEnabled : undefined,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6syeh.default), {
                    isNested: isNested,
                    issueProjects: issueProjects,
                    key: "IssueProjectFilter",
                    onChange: onChangeIssueProjects,
                    selectedProjects: filter[0, $44677eb502cfd308$export$401f4b6eda6a369c]
                })
        },
        versionFilter,
        parentFilter,
        {
            id: (0, $44677eb502cfd308$export$37aee82a3cb1e8f7),
            isStatic: false,
            isHidden: !isLabelsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifij9.default), {
                    key: "LabelFilter",
                    isNested: isNested,
                    ...isUnassignedLabelOptionEnabled && labels.length ? {
                        unassignedOption: unassignedOption
                    } : undefined,
                    labels: labels,
                    selectedLabels: filter[0, $44677eb502cfd308$export$37aee82a3cb1e8f7],
                    onChange: onChangeLabels
                })
        },
        {
            id: (0, $44677eb502cfd308$export$ebb48b08205007c5),
            isStatic: false,
            isHidden: !isIssueTypesFeatureEnabled,
            renderer: (isNested)=>isGroupIssueTypesEnabled ? // In the program board, we could have multiple issue types with the same hierarchy level and names coming from multiple TWP project. We group them so there's no visually duplicated items in the dropdown
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpwtP.default), {
                    key: "IssueTypeGroupFilter",
                    isNested: isNested,
                    issueTypeGroups: issueTypeGroups,
                    selectedIssueTypes: filter[0, $44677eb502cfd308$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNCGp.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    issueTypes: issueTypes,
                    selectedIssueTypes: filter[0, $44677eb502cfd308$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                })
        },
        {
            id: (0, $44677eb502cfd308$export$af1e30ebbae9df3b),
            isStatic: false,
            isHidden: !isComponentsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $35WdX.default), {
                    key: "ComponentFilter",
                    isNested: isNested,
                    components: allComponents,
                    onChange: onChangeComponents,
                    selectedComponents: filter[0, $44677eb502cfd308$export$af1e30ebbae9df3b]
                })
        },
        {
            id: (0, $44677eb502cfd308$export$a316570a0dbfd2b0),
            isStatic: false,
            isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hNl8a.default), {
                    key: "SprintFilter",
                    isNested: isNested,
                    sprints: sprints,
                    selectedSprints: filter[0, $44677eb502cfd308$export$a316570a0dbfd2b0],
                    onChange: onChangeSprints
                })
        },
        {
            id: (0, $44677eb502cfd308$export$e50006273435e7d4),
            isStatic: false,
            isHidden: !isStatusesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ZPCT.default), {
                    key: "StatusFilter",
                    isNested: isNested,
                    statuses: statuses,
                    selectedStatuses: filter[0, $44677eb502cfd308$export$e50006273435e7d4],
                    onChange: onChangeStatuses
                })
        },
        {
            id: (0, $44677eb502cfd308$export$92ab80c1dc9baf44),
            isStatic: false,
            isHidden: !isRequestTypesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iyDY.default), {
                    key: "RequestTypeFilter",
                    isNested: isNested,
                    requestTypes: requestTypes,
                    selectedRequestTypes: filter[0, $44677eb502cfd308$export$92ab80c1dc9baf44],
                    onChange: onChangeRequestTypes
                })
        },
        {
            id: (0, $44677eb502cfd308$export$68d693c35a8d8866),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8gxRf.default), {
                    key: "CustomFilterBoundary",
                    screenName: screenName,
                    customFiltersQueryRef: customFiltersQueryRef
                }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomFilter, {
                    shouldReturnFocus: (0, $eI5EY.fg)('jsw_remove_the_auto_focus_on_custom_filter') ? undefined : isClearButtonVisible === false,
                    isNested: isNested,
                    customFiltersQueryRef: customFiltersQueryRef,
                    selectedFilters: filter[0, $44677eb502cfd308$export$68d693c35a8d8866],
                    filters: jqlFilters,
                    onChange: onChangeCustomFilters,
                    showLink: isCustomFilterManageLinkEnabled,
                    manageUrl: customFilterManageUrl,
                    screenName: screenName
                }))
        },
        {
            id: (0, $44677eb502cfd308$export$1ea95b94fb0c51d9),
            isStatic: false,
            isHidden: showCustomFilters,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rjRz.default), {
                    key: "QuickFilter",
                    isNested: isNested,
                    filters: jqlFilters,
                    selectedFilters: filter[0, $44677eb502cfd308$export$1ea95b94fb0c51d9],
                    onChange: onChangeQuickFilters
                })
        },
        {
            id: (0, $44677eb502cfd308$export$871e58afc769b358),
            isStatic: false,
            isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9D86p.default), {
                    key: "GoalFilter",
                    isNested: isNested,
                    goals: goals,
                    selectedGoals: filter[0, $44677eb502cfd308$export$871e58afc769b358],
                    onChange: onChangeGoals
                })
        },
        {
            id: (0, $44677eb502cfd308$export$db362e2d293fe52e),
            isStatic: false,
            isHidden: (0, $eI5EY.fg)('dependency_visualisation_program_board_fe_and_be') ? !isDependenciesFeatureEnabled : true,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9U5Uu.default), {
                    key: "DependenciesFilter",
                    onChange: onChangeDependencies,
                    selectedValues: filter[0, $44677eb502cfd308$export$db362e2d293fe52e]
                })
        }
    ];
    const overflowItemsAfter = [
        {
            id: 'CLEAR_BUTTON',
            // The CLEAR_BUTTON should be non-static until a filter is added, else it causes the More button to appear
            // in the filter bar on small window sizes, due to overflow calculations in <OverflowHandler />
            isStatic: isClearButtonVisible,
            isHidden: !isClearButtonVisible,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $itGQN.default), {
                    key: "ClearButton",
                    onClick: onClearAllButtonClicked
                })
        }
    ];
    if (isAsyncFilterLoading) overflowItemsAfter.push({
        id: 'SPINNER',
        isStatic: true,
        isHidden: !isAsyncFilterLoading,
        renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ea7329b75e4ee65$var$SpinnerContainer, {
                key: "SpinnerContainer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            }))
    });
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const [maxVisibleUsers, setMaxVisibleUsers] = (0, $eUqFw.useState)($2ea7329b75e4ee65$var$DEFAULT_VISIBLE_USERS);
    const [showLargeSearchFilter, setShowLargeSearchFilter] = (0, $eUqFw.useState)(true);
    const filterBarRef = (0, $eUqFw.useRef)(null);
    const onResize = (0, $eUqFw.useCallback)(()=>{
        if (!filterBarRef.current || !searchInputRef.current) return;
        const completeFilterBarWidth = filterBarRef.current.offsetWidth; // complete bar with input + filter controls
        const searchInputWidth = searchInputRef.current.offsetWidth; // only the input
        const remainingWidth = completeFilterBarWidth - searchInputWidth; // remaining room for avatar, etc.
        // Handle avatar overflow
        if (remainingWidth < $2ea7329b75e4ee65$var$MIN_FILTER_BAR_WIDTH) {
            const usersToReduce = Math.ceil(($2ea7329b75e4ee65$var$MIN_FILTER_BAR_WIDTH - remainingWidth) / $2ea7329b75e4ee65$var$USER_AVATAR_WIDTH);
            const newMax = Math.max($2ea7329b75e4ee65$var$DEFAULT_VISIBLE_USERS - usersToReduce, $2ea7329b75e4ee65$var$MIN_VISIBLE_USERS);
            setMaxVisibleUsers(newMax);
        } else setMaxVisibleUsers($2ea7329b75e4ee65$var$DEFAULT_VISIBLE_USERS);
         // Handle search field width
        setShowLargeSearchFilter(window.innerWidth >= $2ea7329b75e4ee65$var$LARGE_SEARCH_FILTER_BREAKPOINT);
    }, []);
    (0, $7uxUn.useResizeObserver)({
        ref: filterBarRef,
        onResize: onResize
    });
    (0, $7uxUn.useResizeObserver)({
        ref: searchInputRef,
        onResize: onResize
    });
    const { experimentCohort: experimentCohort } = (0, $l4zCR.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = ()=>screenName === 'board' && experimentCohort === (0, $1Iui1.VARIATION);
    if (screenName === 'board' && experimentCohort !== (0, $1Iui1.NOT_ENROLLED)) {
        const [, fireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
        fireExposure();
    }
    const [{ participants: participants }] = (0, $fmImn.useCollabStore)();
    const allUsersWithPresence = isRealtimePresenceEnabled() ? (0, $84m3I.getAssigneesWithPresence)(allAssignees, participants) : allAssignees;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01UFf.FilterBar), {
        ref: filterBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axKFq.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'software-filters-stateless-focus-search-input',
                    name: formatMessage((0, $gp3Fg.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                                label: formatMessage((0, $gp3Fg.default).searchCurrentPage)
                            })
                    },
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        },
        location: "software.filters.keyboard-shortcuts"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        id: screenReaderDescriptionId
    }, screenReaderInstruction || formatMessage((0, $gp3Fg.default).screenReaderInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, screenReaderInstructionForFilters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status",
        "aria-relevant": "all"
    }, formatMessage((0, $gp3Fg.default).screenReaderInstructionForFilters)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status"
    })), hijackBrowserDefaultSearch === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8D53g.default), {
        onFocusSearch: focusSearchInput,
        isAnyModalOpen: isAnyModalOpen
    }), showSearchFilterChangeboarding === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hREiq.default), {
        hijackBrowserDefaultSearch: hijackBrowserDefaultSearch,
        screenName: screenName,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: screenReaderDescriptionId,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $2ea7329b75e4ee65$var$CustomSearchInput,
        value: filter[0, $44677eb502cfd308$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $gp3Fg.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: screenReaderDescriptionId,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $2ea7329b75e4ee65$var$CustomSearchInput,
        value: filter[0, $44677eb502cfd308$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $gp3Fg.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field"
    }), (0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && showBoardSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $glQYN.default), {
        boardId: boardId,
        isReadOnly: isBoardSwitcherReadOnly
    }), showAssigneeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xG8t.default), {
        maxUsers: maxVisibleUsers,
        users: allUsersWithPresence,
        screenName: screenName,
        selectedUsers: assigneeValue,
        onToggle: onToggleAssignee,
        onAssigneeMenuOpen: onExtraAvatarMenuOpen,
        AddPeopleModal: AddPeopleModal,
        projectId: projectId,
        projectName: projectName,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        projectKey: projectKey
    }), isRealtimePresenceEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fqAlt.CollabContainerAsync), {
        screenName: screenName,
        boardId: boardId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01UFf.ListFilterContainerNextGen // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        "data-testid": "software-filters.ui.list-filter-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NoA2.default), {
        itemsBefore: overflowItemsBefore,
        itemsAfter: overflowItemsAfter,
        selectedItems: filter
    })));
};
const $2ea7329b75e4ee65$var$customSearchInputStyles = null; // TODO: remove on visual-refresh cleanup
const $2ea7329b75e4ee65$var$customSearchInputStylesOld = null;
const $2ea7329b75e4ee65$var$CustomSearchInput = ({ textFieldProps: textFieldProps, searchIcon: searchIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        elemAfterInput: searchIcon,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingInlineStart: "space.100",
            paddingBlockStart: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            primaryColor: "var(--ds-icon, #44546F)",
            size: "small",
            label: ""
        })),
        autoComplete: "off",
        testId: "software-filters.ui.stateless.search-field",
        className: (0, $7JEyt.default)([
            (0, $8rQuz.isVisualRefreshEnabled)() ? "_1hxm12x7 _1twg1b66" : "_2rkoq1pp _1yt4ze3t _1rns1b66 _1srlxy5q"
        ])
    });
var $2ea7329b75e4ee65$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($2ea7329b75e4ee65$var$SoftwareFiltersStateless);
const $2ea7329b75e4ee65$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66 _4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $645e088e86b3f594$var$_page = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $645e088e86b3f594$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $645e088e86b3f594$var$_page.default
    }));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = module.exports.default = $645e088e86b3f594$var$PageIcon;

});
parcelRegister("20Mcc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c63ce0083f2e9a73a4c7c0a839641a58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});


parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("kjXsi", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $cfcbcec828cf2e62$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $cfcbcec828cf2e62$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $cfcbcec828cf2e62$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cfcbcec828cf2e62$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $cfcbcec828cf2e62$export$88fad6aa294f111c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9zALC", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $8bee8fa7684ab6e5$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $8bee8fa7684ab6e5$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $8bee8fa7684ab6e5$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $8bee8fa7684ab6e5$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $8bee8fa7684ab6e5$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $8bee8fa7684ab6e5$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $8bee8fa7684ab6e5$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $8bee8fa7684ab6e5$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $8bee8fa7684ab6e5$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($8bee8fa7684ab6e5$export$16b06d29ef8f802b || ($8bee8fa7684ab6e5$export$16b06d29ef8f802b = {}));
const $8bee8fa7684ab6e5$export$156ebd2354e25466 = 'issueActions';
const $8bee8fa7684ab6e5$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $8bee8fa7684ab6e5$export$9f646ab88e1d2b14 = 'commandPalette';
var $8bee8fa7684ab6e5$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 || ($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 = {}));
var $8bee8fa7684ab6e5$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($8bee8fa7684ab6e5$export$12514ca8899b0521 || ($8bee8fa7684ab6e5$export$12514ca8899b0521 = {}));
var $8bee8fa7684ab6e5$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 || ($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 = {}));
var $8bee8fa7684ab6e5$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($8bee8fa7684ab6e5$export$7d9743be0b7d862f || ($8bee8fa7684ab6e5$export$7d9743be0b7d862f = {}));
var $8bee8fa7684ab6e5$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($8bee8fa7684ab6e5$export$b4e1633c86db2b70 || ($8bee8fa7684ab6e5$export$b4e1633c86db2b70 = {}));
var $8bee8fa7684ab6e5$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($8bee8fa7684ab6e5$export$5e5a87aac5d9771f || ($8bee8fa7684ab6e5$export$5e5a87aac5d9771f = {}));

});

parcelRegister("jmejm", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $008cf4f8cce3a652$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $008cf4f8cce3a652$export$5ea2dca0a260365d;
(function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
})($008cf4f8cce3a652$export$5ea2dca0a260365d || ($008cf4f8cce3a652$export$5ea2dca0a260365d = {}));

});

parcelRegister("gfXKy", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $59897234799b31c8$export$4d8fe3ef6385358);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iBHM = parcelRequire("3iBHM");
const $59897234799b31c8$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getKeywords = (0, $eUqFw.useCallback)((keywordGroup)=>(0, $3iBHM.messages)[keywordGroup] ? formatMessage((0, $3iBHM.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("3iBHM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f74b9c3b50ad31d$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2f74b9c3b50ad31d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("axKFq", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a);

var $eUqFw = parcelRequire("eUqFw");

var $fmmnJ = parcelRequire("fmmnJ");

var $awzwr = parcelRequire("awzwr");

var $6jiFZ = parcelRequire("6jiFZ");

var $9aFSa = parcelRequire("9aFSa");
const $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eUqFw.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $6jiFZ.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eUqFw.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzwr.RegisterCommands), {
        registrationId: (0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});

parcelRegister("awzwr", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $42c02b036374b0c2$export$cd555833c78729f1);

var $eUqFw = parcelRequire("eUqFw");

var $7ElYg = parcelRequire("7ElYg");
const $42c02b036374b0c2$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ElYg.RegisterCommandsWithRegistry), props);

});
parcelRegister("7ElYg", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $f8fb4bce96babd2d$export$b8955a01360d2876);

var $fqCN8 = parcelRequire("fqCN8");
function $f8fb4bce96babd2d$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $fqCN8.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("fqCN8", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $f1b669646bbb8295$export$8a824ae164ff968d);

var $eUqFw = parcelRequire("eUqFw");

var $7Xm2s = parcelRequire("7Xm2s");
function $f1b669646bbb8295$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $7Xm2s.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eUqFw.useRef)(commands);
    (0, $eUqFw.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $9139bfe8dcd2ea64$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $WBLbN.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $WBLbN.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$a18633b655403b12 = (0, $WBLbN.createStateHook)($9139bfe8dcd2ea64$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $WBLbN.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $48b165edb54974f4$export$894e19fc96687503);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));
const $48b165edb54974f4$export$894e19fc96687503 = 250;

});

parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $8PVSz = parcelRequire("8PVSz");

var $75e8i = parcelRequire("75e8i");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $476b965ceb7c28b6$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $75e8i.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $8PVSz.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $75e8i.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $75e8i.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $8PVSz.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride,
    setHasPopupOverlay: $476b965ceb7c28b6$var$setHasPopupOverlay,
    forceSearchValue: $476b965ceb7c28b6$var$forceSearchValue,
    resetShouldForceSearchValue: $476b965ceb7c28b6$var$resetShouldForceSearchValue
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});







parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $WBLbN = parcelRequire("WBLbN");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $WBLbN.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("8NoA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87a122a4f8c098d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $9nkwJ = parcelRequire("9nkwJ");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $2eG9N = parcelRequire("2eG9N");

var $eWeL8 = parcelRequire("eWeL8");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7uxUn = parcelRequire("7uxUn");

var $8rQuz = parcelRequire("8rQuz");

var $iLKfm = parcelRequire("iLKfm");

var $fMKb3 = parcelRequire("fMKb3");

var $b9IeP = parcelRequire("b9IeP");
const $d87a122a4f8c098d$var$OverflowHandler = ({ itemsBefore: itemsBefore, itemsAfter: itemsAfter, selectedItems: selectedItems = {} })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const overflowContainerRef = (0, $eUqFw.useRef)(null);
    const moreFilterRef = (0, $eUqFw.useRef)(null);
    const elementsRef = (0, $eUqFw.useRef)({});
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    // There is a flickering bug switching to/from the "more" button https://jplat.atlassian.net/browse/BLU-3488
    // Additional information can also be found in https://jbusiness.atlassian.net/browse/JVRQ-426
    // But can't reproduce in Storybook + lot of pending changes, so won't fix for now.
    // I suspect this is related to this out-of-rerender memorization of data.
    // Next person actively working on this file is welcome to check. See also investigation notes in the ticket above.
    const prevOverflowContainerWidthRef = (0, $eUqFw.useRef)(0);
    const elementsWidthRef = (0, $eUqFw.useRef)({});
    const visibleElementsRef = (0, $eUqFw.useRef)({});
    const prevElementsWidthRef = (0, $eUqFw.useRef)({});
    const [{ overflowableHideState: overflowableHideState, isMoreDropdownHidden: isMoreDropdownHidden }, setOverflowState] = (0, $eUqFw.useState)({
        overflowableHideState: {},
        isMoreDropdownHidden: true
    });
    const { renderedOverflowableItems: renderedOverflowableItems, staticItems: staticItems, renderedItemsBefore: renderedItemsBefore, renderedItemsAfter: renderedItemsAfter } = (0, $eUqFw.useMemo)(()=>{
        const theOverflowable = [];
        const theStatic = [];
        const theRenderedBefore = [];
        const theRenderedAfter = [];
        const categoriseItems = ({ isRenderedBefore: isRenderedBefore })=>{
            (isRenderedBefore ? itemsBefore : itemsAfter).forEach((item)=>{
                const { isStatic: isStatic, isHidden: isHidden = false } = item;
                // Exclude hidden overflowable items from rendering
                if (!isStatic && isHidden) return;
                (isStatic ? theStatic : theOverflowable).push(item);
                (isRenderedBefore ? theRenderedBefore : theRenderedAfter).push(item);
            });
        };
        categoriseItems({
            isRenderedBefore: true
        });
        categoriseItems({
            isRenderedBefore: false
        });
        return {
            renderedOverflowableItems: theOverflowable,
            staticItems: theStatic,
            renderedItemsBefore: theRenderedBefore,
            renderedItemsAfter: theRenderedAfter
        };
    }, [
        itemsBefore,
        itemsAfter
    ]);
    /**
   * Calculate the count for "More" dropdown.
   * It excludes the selected items of the visible items.
   */ const selectedOverflowItemsCount = (0, $eUqFw.useMemo)(()=>(0, $b9IeP.getSelectedItemsCount)(overflowableHideState, selectedItems), [
        overflowableHideState,
        selectedItems
    ]);
    const onResize = (0, $eUqFw.useCallback)(()=>{
        const { current: overflowContainer } = overflowContainerRef;
        const { current: moreFilter } = moreFilterRef;
        const shouldRecomputeOverflow = (0, $b9IeP.getShouldRecomputeOverflow)(prevOverflowContainerWidthRef.current, overflowContainer?.offsetWidth ?? 0, prevElementsWidthRef.current, elementsWidthRef.current);
        if (!overflowContainer || !moreFilter || !renderedOverflowableItems.length || !shouldRecomputeOverflow) return;
        // Store the widths for comparison
        prevOverflowContainerWidthRef.current = overflowContainer.offsetWidth;
        prevElementsWidthRef.current = {
            ...elementsWidthRef.current
        };
        setOverflowState((0, $b9IeP.calcOverflow)(overflowContainer, moreFilter, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        renderedOverflowableItems, staticItems, elementsRef.current));
    }, [
        renderedOverflowableItems,
        staticItems
    ]);
    if ((0, $79xbN.expVal)('blu-3488_fix_jsw_filters_flickering', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7uxUn.useResizeObserver)({
        ref: overflowContainerRef,
        onResize: onResize
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fMKb3.useResizeObserver)(overflowContainerRef, onResize);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const triggerLabel = formatMessage((0, $iLKfm.default).more);
    const triggerTooltipText = formatMessage((0, $iLKfm.default).moreFiltersTooltip);
    const buttonToolTip = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: triggerTooltipText,
            hideTooltipOnClick: true,
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$TriggerContainer, {
            "data-testid": "filters.common.ui.overflow-handler.trigger-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$TriggerLabel, null, triggerLabel), selectedOverflowItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$BadgeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            appearance: "primary"
        }, selectedOverflowItemsCount)))), [
        selectedOverflowItemsCount,
        triggerTooltipText,
        triggerLabel
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$PopupContainer, null, renderedOverflowableItems.map(({ id: id, renderer: renderer })=>Boolean(overflowableHideState[id]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: id
            }, renderer(true)))), [
        renderedOverflowableItems,
        overflowableHideState
    ]);
    const renderItems = (items)=>items.map(({ id: id, isStatic: isStatic, isHidden: isHidden = false, renderer: renderer })=>{
            const isItemHidden = isStatic ? isHidden : Boolean(overflowableHideState[id]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$ItemWrapper, {
                key: id,
                innerRef: (element)=>{
                    elementsRef.current[id] = element;
                    if (element) {
                        elementsWidthRef.current[id] = element.offsetWidth;
                        if (!isHidden) visibleElementsRef.current[id] = {
                            width: element.offsetWidth,
                            height: element.offsetHeight
                        };
                    }
                },
                "aria-hidden": isItemHidden,
                isHidden: isItemHidden
            }, renderer(false));
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: overflowContainerRef,
        className: (0, $7JEyt.default)([
            (0, $8rQuz.isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _18s83l1n" : "_1e0c1txw _1ul9idpf"
        ])
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$ItemWrapper, {
        innerRef: moreFilterRef,
        "aria-hidden": isMoreDropdownHidden,
        isHidden: isMoreDropdownHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: (0, $8rQuz.isVisualRefreshEnabled)() ? 'default' : 'subtle',
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    primaryColor: "var(--ds-icon, #44546F)",
                    label: triggerLabel
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
};
var $d87a122a4f8c098d$export$2e2bcd8739ae039 = $d87a122a4f8c098d$var$OverflowHandler;
const $d87a122a4f8c098d$var$overflowContainerStylesOld = null;
const $d87a122a4f8c098d$var$overflowContainerStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$PopupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4swc3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$TriggerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$TriggerLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$BadgeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _19bv1b66",
            __cmplp.className
        ])
    });
});
const $d87a122a4f8c098d$var$ItemWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1krxkwp-0"
})((props)=>({
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        order: props.isHidden ? 2 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.isHidden ? 'hidden' : 'visible',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isHidden ? 'none' : 'auto'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$ItemWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.isHidden ? "_1f49cs5v" : "_1f49kb7n",
            __cmplp.isHidden ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isHidden ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $d87a122a4f8c098d$var$ItemWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $d87a122a4f8c098d$var$ItemWrapperExperiment, $d87a122a4f8c098d$var$ItemWrapperControl);

});
parcelRegister("eWeL8", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $e0c5c7e39a960e0c$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $e0c5c7e39a960e0c$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $e0c5c7e39a960e0c$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("7uxUn", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $dc839ec384d19a4a$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $dc839ec384d19a4a$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $dc839ec384d19a4a$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $dc839ec384d19a4a$export$e58143dc89297272);

var $eUqFw = parcelRequire("eUqFw");

var $gDQs6 = parcelRequire("gDQs6");
function $dc839ec384d19a4a$export$87a9d3e287304ae4(params) {
    const group = new (0, $gDQs6.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eUqFw.useRef)(onResize);
        (0, $eUqFw.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eUqFw.useCallback)(()=>onResizeRef.current(), []);
        (0, $eUqFw.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $dc839ec384d19a4a$export$683480f191c0e3ea, flushResizeObservers: $dc839ec384d19a4a$export$a181ef2a6d0a1bb6 } = $dc839ec384d19a4a$export$87a9d3e287304ae4();
function $dc839ec384d19a4a$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $dc839ec384d19a4a$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eUqFw.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("gDQs6", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $91e461fbc4ab66c0$export$607798bbe2869c0);

var $lEfVV = parcelRequire("lEfVV");

var $dxIU5 = parcelRequire("dxIU5");
class $91e461fbc4ab66c0$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("iLKfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a29a4590d069b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c5a29a4590d069b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    more: {
        "id": "software-filters.common.overflow-handler.more",
        "defaultMessage": "More"
    },
    moreFiltersTooltip: {
        "id": "software-filters.common.overflow-handler.more-filters-tooltip",
        "defaultMessage": "More filters"
    }
});

});

parcelRegister("fMKb3", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $21cd25eee961b6ff$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");
let $21cd25eee961b6ff$var$resizeObserver;
const $21cd25eee961b6ff$var$callbacks = new Map();
const $21cd25eee961b6ff$var$runCallbacks = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target } = entry;
        const callback = $21cd25eee961b6ff$var$callbacks.get(target);
        callback?.(entry);
    });
};
const $21cd25eee961b6ff$var$observeElement = (target, callback)=>{
    if (typeof ResizeObserver === 'undefined') return;
    if (!$21cd25eee961b6ff$var$resizeObserver) $21cd25eee961b6ff$var$resizeObserver = new ResizeObserver($21cd25eee961b6ff$var$runCallbacks);
    $21cd25eee961b6ff$var$callbacks.set(target, callback);
    $21cd25eee961b6ff$var$resizeObserver.observe(target);
};
const $21cd25eee961b6ff$var$unobserveElement = (target)=>{
    if (!$21cd25eee961b6ff$var$resizeObserver) return;
    $21cd25eee961b6ff$var$callbacks.delete(target);
    $21cd25eee961b6ff$var$resizeObserver.unobserve(target);
};
const $21cd25eee961b6ff$export$683480f191c0e3ea = (ref, callback)=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        const element = ref.current;
        element && $21cd25eee961b6ff$var$observeElement(element, callback);
        return ()=>{
            element && $21cd25eee961b6ff$var$unobserveElement(element);
        };
    }, [
        ref,
        callback
    ]);
};

});

parcelRegister("b9IeP", function(module, exports) {

$parcel$export(module.exports, "calcOverflow", () => $274da3a39e4318f2$export$7128ab9dfe00f62e);
$parcel$export(module.exports, "getShouldRecomputeOverflow", () => $274da3a39e4318f2$export$2544af09d06b9c65);
$parcel$export(module.exports, "getSelectedItemsCount", () => $274da3a39e4318f2$export$b0e31612dc0df344);

var $8blac = parcelRequire("8blac");
const $274da3a39e4318f2$export$1fed873882a661c5 = (items, itemElements, spaceLimit)=>{
    const hideState = {};
    let usedSpace = 0;
    let isOverflowingAssumed = false;
    items.forEach(({ id: id })=>{
        const element = itemElements[id];
        if (element) {
            const { offsetWidth: space } = element;
            if ((spaceLimit === undefined || usedSpace + space < spaceLimit) && !isOverflowingAssumed) usedSpace += space;
            else {
                if (!isOverflowingAssumed) isOverflowingAssumed = true;
                hideState[id] = true;
            }
        }
    });
    return {
        usedSpace: usedSpace,
        hideState: hideState
    };
};
const $274da3a39e4318f2$export$7128ab9dfe00f62e = ({ offsetWidth: availableSpace }, { offsetWidth: moreFilterSpace }, renderedOverflowableItems, staticItems, itemElements)=>{
    const { usedSpace: staticSpace } = $274da3a39e4318f2$export$1fed873882a661c5(staticItems, itemElements);
    const maxOverflowableSpace = renderedOverflowableItems.reduce((maxSpace, { id: id })=>maxSpace + (itemElements[id]?.offsetWidth ?? 0), 0);
    const isOverflowing = maxOverflowableSpace + staticSpace > availableSpace;
    let overflowableHideState = {};
    if (isOverflowing) {
        const spaceLimit = Math.max(availableSpace - moreFilterSpace - staticSpace, 0);
        const { hideState: hideState } = $274da3a39e4318f2$export$1fed873882a661c5(renderedOverflowableItems, itemElements, spaceLimit);
        overflowableHideState = hideState;
    }
    return {
        overflowableHideState: overflowableHideState,
        isMoreDropdownHidden: !isOverflowing
    };
};
const $274da3a39e4318f2$var$BADGE_WIDTH_THRESHOLD = 25; // Width of count badge
const $274da3a39e4318f2$export$2544af09d06b9c65 = (prevContainerWidth, currContainerWidth, prevElementsWidthRef, currElementsWidthRef)=>{
    const currItemIds = Object.keys(currElementsWidthRef);
    const prevItemIds = Object.keys(prevElementsWidthRef);
    if (prevItemIds.length !== currItemIds.length || prevContainerWidth !== currContainerWidth) return true;
    const hasItemsWidthChange = currItemIds.some((id)=>prevElementsWidthRef[id] === undefined || Math.abs(prevElementsWidthRef[id] - currElementsWidthRef[id]) > $274da3a39e4318f2$var$BADGE_WIDTH_THRESHOLD);
    return hasItemsWidthChange;
};
const $274da3a39e4318f2$export$b0e31612dc0df344 = (itemsHiddenState, selectedItems)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(selectedItems) || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(itemsHiddenState)) return 0;
    return Object.entries(selectedItems).reduce((acc, [key, value])=>{
        if (value === undefined || itemsHiddenState[key] !== true) return acc;
        // selectedItem could be "any" value, if the value is not an Array, it will be counted as 1
        return Array.isArray(value) ? acc + value.length : acc + 1;
    }, 0);
};

});


parcelRegister("7xG8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21c7a389f4c6f79$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $i528B = parcelRequire("i528B");

var $anpCp = parcelRequire("anpCp");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Ua7e = parcelRequire("6Ua7e");


var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $6UBeg = parcelRequire("6UBeg");

var $1Gl68 = parcelRequire("1Gl68");

var $7NnaN = parcelRequire("7NnaN");

var $kovzS = parcelRequire("kovzS");
const $d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('StatelessAssigneeFilterWithAnalytics', {
    onAddPeopleClick: 'clicked'
})((0, $kovzS.default));
$d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics.displayName = 'StatelessAssigneeFilterWithAnalytics';
const $d21c7a389f4c6f79$export$3ecb2c48b5973cac = ({ AddPeopleModal: AddPeopleModal, showAddPeopleModal: showAddPeopleModal, onAddPeopleModalClose: onAddPeopleModalClose, cloudId: cloudId, projectName: projectName, projectId: projectId, projectKey: projectKey, appEdition: appEdition, isSiteAdmin: isSiteAdmin, modalRef: modalRef })=>{
    if ((0, $anpCp.isCoreInvitesInJiraProjectsEnabled)(isSiteAdmin)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        inviteRef: modalRef,
        appEdition: appEdition,
        cloudId: cloudId,
        isOpen: (0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
        onClose: onAddPeopleModalClose,
        jiraProjectName: projectName,
        projectId: projectId,
        jiraProjectKey: projectKey,
        isSiteAdmin: isSiteAdmin
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddPeopleModal, {
        onClose: onAddPeopleModalClose,
        isOpen: (0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal
    });
};
const $d21c7a389f4c6f79$export$804bfdea59f89629 = (createAnalyticsEvent, baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, jswEdition, analyticsEvent, isSiteAdmin, screenName, fireTriggerClickEvent)=>{
    const openAddPeopleModal = ()=>{
        (0, $i528B.fireCoreInvitesInJiraProjectFeatureExposed)(createAnalyticsEvent, isSiteAdmin);
        setShowAddPeopleModal(!showAddPeopleModal);
    };
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (jswEdition === (0, $6WXNs.toEdition)((0, $6WXNs.FREE_EDITION))) (0, $1Gl68.getRemainingSeats)(baseUrl, (0, $2edfd53057852e41$export$1346c9aa3cbb477d)).then((remainingSeats)=>{
        if (remainingSeats === 0) {
            // When the JSW Free instance is at the user limit and
            // the user is enrolled in the auto-upgrade experiment, fire an exposure event
            if (expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled') {
                const [, fireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
                fireExposureEvent();
            }
            fireTriggerClickEvent();
            // If the user is in the auto-upgrade experiment variation cohort, show the invite modal.
            // Otherwise, show the upsell dialog.
            if (expConfig.get('cohort', 'not-enrolled') === 'variation') openAddPeopleModal();
            else {
                setShowUpSell(!showUpSell);
                if (!showUpSell) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `${screenName}AssigneeFilterAddPeople`);
            }
        } else {
            fireTriggerClickEvent();
            openAddPeopleModal();
        }
    }).catch((e)=>{
        fireTriggerClickEvent();
        openAddPeopleModal();
        throw e;
    });
    else {
        fireTriggerClickEvent();
        // If not on JSW Free, always show the invite modal
        openAddPeopleModal();
    }
};
const $d21c7a389f4c6f79$var$ConditionalUpsellDialogWrapper = (props)=>{
    const { children: children, showUpsellDialog: showUpsellDialog, setShowUpsellDialog: setShowUpsellDialog, screenName: screenName } = props;
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (expConfig.get('cohort', 'not-enrolled') === 'variation') // When the user is in the experiment variation cohort, we won't be showing the upsell dialog.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const onUpgradeDialogClose = ()=>{
        setShowUpsellDialog(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UBeg.default), {
        isOpen: showUpsellDialog,
        onClose: onUpgradeDialogClose,
        touchpointId: `${screenName || ''}${screenName ? 'A' : 'a'}ssigneeFilterAddPeople`,
        onUpFlowDismiss: onUpgradeDialogClose
    }, children);
};
const $d21c7a389f4c6f79$export$20e0939737a940df = (props)=>{
    const { users: users, maxUsers: maxUsers, AddPeopleModal: AddPeopleModal, screenName: screenName, selectedUsers: selectedUsers, onToggle: onToggle, projectId: projectId, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectName: projectName, projectKey: projectKey } = props;
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [showAddPeopleModal, setShowAddPeopleModal] = (0, $eUqFw.useState)(false);
    const [showUpSell, setShowUpSell] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const appEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), tenantContext.appEditions);
    const onAddPeopleClick = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        const fireAddPeopleClickEvent = ()=>{
            // If neither the upsell dialog nor the invite modal is currently open,
            // then the user is trying to open one of them. When this happens,
            // we fire an analytics event.
            if (!showAddPeopleModal && !showUpSell) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    source: screenName
                });
                (0, $jMP2a.fireUIAnalytics)(event, 'assigneeFilterAddPeople');
            }
        };
        $d21c7a389f4c6f79$export$804bfdea59f89629(createAnalyticsEvent, tenantContext.baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, appEdition, analyticsEvent, tenantContext.isSiteAdmin, screenName || '', fireAddPeopleClickEvent);
    }, [
        createAnalyticsEvent,
        tenantContext.baseUrl,
        tenantContext.isSiteAdmin,
        showUpSell,
        showAddPeopleModal,
        appEdition,
        screenName
    ]);
    const onAddPeopleModalClose = (0, $eUqFw.useCallback)(()=>{
        setShowAddPeopleModal(false);
    }, []);
    const showAddPeopleButton = AddPeopleModal !== undefined && isAddPeopleButtonEnabled;
    const addButtonRef = (0, $eUqFw.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$var$ConditionalUpsellDialogWrapper, {
        showUpsellDialog: showUpSell,
        setShowUpsellDialog: setShowUpSell,
        screenName: screenName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics, {
        peopleRef: addButtonRef,
        users: users,
        maxUsers: maxUsers,
        selectedUsers: selectedUsers,
        onToggle: onToggle,
        onAddPeopleClick: onAddPeopleClick,
        showAddPeopleButton: showAddPeopleButton,
        screenName: screenName || '',
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NnaN.Analytics), {
        baseUrl: tenantContext.baseUrl,
        projectId: projectId,
        screenName: screenName || '',
        showAddPeopleButton: showAddPeopleButton
    }), AddPeopleModal && ((0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleButton) && ((0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? showAddPeopleModal : true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$export$3ecb2c48b5973cac, {
        modalRef: addButtonRef,
        projectName: projectName,
        projectKey: projectKey,
        projectId: projectId,
        AddPeopleModal: AddPeopleModal,
        showAddPeopleModal: (0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
        onAddPeopleModalClose: onAddPeopleModalClose,
        cloudId: tenantContext.cloudId,
        appEdition: appEdition,
        isSiteAdmin: tenantContext.isSiteAdmin
    }));
};
$d21c7a389f4c6f79$export$20e0939737a940df.defaultProps = {
    users: [],
    selectedUsers: [],
    maxUsers: 5,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    AddPeopleModal: undefined,
    isAddPeopleButtonEnabled: false,
    projectId: -1
};
const $d21c7a389f4c6f79$var$AssigneeFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($d21c7a389f4c6f79$export$20e0939737a940df);
$d21c7a389f4c6f79$var$AssigneeFilterComponent.displayName = 'AssigneeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<{ isAddPeopleButtonEnabled: boolean; readonly projectId: number; } & CommonAssigneeFilterProps & { AddPeopleModal: ComponentType<{ onClose: () => void; isOpen: boolean; }> | undefined; }>'.
$d21c7a389f4c6f79$var$AssigneeFilterComponent.whyDidYouRender = true;
var $d21c7a389f4c6f79$export$2e2bcd8739ae039 = $d21c7a389f4c6f79$var$AssigneeFilterComponent;

});
parcelRegister("i528B", function(module, exports) {

$parcel$export(module.exports, "fireCoreInvitesInJiraProjectFeatureExposed", () => $0dbd3d296d3d0e11$export$2f2d4a4234531655);
$parcel$export(module.exports, "fireCoreInvitesInJsmProjectFeatureExposed", () => $0dbd3d296d3d0e11$export$4ae66d6e56a5cb11);

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");

var $anpCp = parcelRequire("anpCp");
const $0dbd3d296d3d0e11$var$getCoreInvitesInJiraProjects = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('core-invites-in-jira-projects', (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED, [
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).CONTROL,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY_NOT_ENROLLED,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA_NOT_ENROLLED
    ]);
const $0dbd3d296d3d0e11$export$2f2d4a4234531655 = (createAnalyticsEvent, isSiteAdmin)=>{
    const featureFlagValue = $0dbd3d296d3d0e11$var$getCoreInvitesInJiraProjects();
    const cohort = featureFlagValue;
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'core-invites-in-jira-projects',
        value: featureFlagValue,
        cohort: cohort,
        isSiteAdmin: isSiteAdmin,
        ineligibilityReasons: [],
        growthInitiative: 'virality'
    });
};
const $0dbd3d296d3d0e11$export$4ae66d6e56a5cb11 = (createAnalyticsEvent, coreInvitesJsmExpValue)=>{
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'jsm_core_invites_experiment',
        cohort: coreInvitesJsmExpValue
    });
};

});
parcelRegister("anpCp", function(module, exports) {

$parcel$export(module.exports, "CORE_INVITES_IN_JIRA_PROJECTS", () => $2d494c23fdb3d24c$export$3496ae3c3008d7e5);
$parcel$export(module.exports, "isCoreInvitesInJiraProjectsEnabled", () => $2d494c23fdb3d24c$export$78d85fc0e603743c);
$parcel$export(module.exports, "isElligibleProject", () => $2d494c23fdb3d24c$export$b0222359e25e154);
$parcel$export(module.exports, "isServiceProject", () => $2d494c23fdb3d24c$export$f52f6e19ac3c110);

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");
const $2d494c23fdb3d24c$export$3496ae3c3008d7e5 = {
    CONTROL: 'control',
    NOT_ENROLLED: 'not-enrolled',
    INVITE_ONLY: 'invite-only-variation',
    INVITE_ONLY_NOT_ENROLLED: 'invite-only-not-enrolled',
    INVITE_RA: 'invite-ra-variation',
    INVITE_RA_NOT_ENROLLED: 'invite-ra-variation'
};
const $2d494c23fdb3d24c$var$getCoreInvitesInJiraProjects = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('core-invites-in-jira-projects', $2d494c23fdb3d24c$export$3496ae3c3008d7e5.NOT_ENROLLED, [
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.NOT_ENROLLED,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.CONTROL,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY_NOT_ENROLLED,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA_NOT_ENROLLED
    ]);
const $2d494c23fdb3d24c$export$78d85fc0e603743c = (isSiteAdmin)=>{
    const flag = $2d494c23fdb3d24c$var$getCoreInvitesInJiraProjects();
    return isSiteAdmin && flag === $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY || flag === $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA;
};
const $2d494c23fdb3d24c$export$b0222359e25e154 = (projectType)=>projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
const $2d494c23fdb3d24c$export$f52f6e19ac3c110 = (projectType)=>projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);

});


parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cTVAu")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("cTVAu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e1vXm")
]).then(()=>parcelRequire('bagiu'));

});


const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("6UBeg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d6c2870ae2a9a87$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $29yDk = parcelRequire("29yDk");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDzFH = parcelRequire("kDzFH");

var $3svxt = parcelRequire("3svxt");

var $5oIBC = parcelRequire("5oIBC");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");


var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $3uAFr = parcelRequire("3uAFr");

var $9ekFy = parcelRequire("9ekFy");

var $3V6nz = parcelRequire("3V6nz");


var $1Y97h = parcelRequire("1Y97h");
const $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics = (analyticsEvent, actionSubjectId, touchpointId, currentEdition)=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, actionSubjectId, {
        currentEdition: currentEdition,
        touchpointId: touchpointId,
        targetEdition: (0, $3V6nz.applicationEditionToUpFlowEdition)((0, $6WXNs.STANDARD_EDITION)),
        isGrandfathered: false,
        isSiteAdmin: true,
        upFlowVariateFlag: 'experiment'
    });
};
const $3d6c2870ae2a9a87$var$showTryNowButton = (onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "primary",
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label);
const $3d6c2870ae2a9a87$var$showLearnMoreButton = (appearance, onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: appearance,
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label); // TODO split this file in to proper tangerine app structure, it's getting too big
const $3d6c2870ae2a9a87$var$UpgradeToAddUsersDialog = (props)=>{
    const { children: children, isOpen: isOpen, onClose: onClose, intl: intl, touchpointId: touchpointId, onUpFlowDismiss: onUpFlowDismiss } = props;
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const hasOnlyJSW = explicitlyLicensedProducts.length === 1 && explicitlyLicensedProducts[0] === (0, $2edfd53057852e41$export$1346c9aa3cbb477d);
    const [upFlowIframeState, setUpFlowIframeState] = (0, $eUqFw.useState)(null);
    const currentEdition = (0, $3V6nz.applicationEditionToUpFlowEdition)((0, $kDzFH.getProductEdition)(explicitlyLicensedProducts[0], tenantContext));
    const upgradeButtonOnClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $3uAFr.mapActionIdFromType)[0, $3uAFr.UPGRADE];
        $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $3uAFr.UPGRADE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const learnMoreButtonOnClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $3uAFr.mapActionIdFromType)[0, $3uAFr.LEARN_MORE];
        $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $3uAFr.LEARN_MORE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const onUpFlowIframeClose = (0, $eUqFw.useCallback)(()=>{
        setUpFlowIframeState(null);
        onUpFlowDismiss();
    }, [
        onUpFlowDismiss
    ]);
    const learnMoreButtonAppearance = tenantContext.isSiteAdmin ? 'link' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: touchpointId,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "changeEditionGateway",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                isSiteAdmin: tenantContext.isSiteAdmin,
                source: touchpointId
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, intl.formatMessage((0, $1Y97h.default).upgradeToAddUsersHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d6c2870ae2a9a87$var$MultiLineParagraph, null, intl.formatMessage((0, $1Y97h.default).upgradeToAddUsersContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $3d6c2870ae2a9a87$var$buttonBarStyles
        }, tenantContext.isSiteAdmin ? $3d6c2870ae2a9a87$var$showTryNowButton(// @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        upgradeButtonOnClick, intl.formatMessage((0, $1Y97h.default).upgradeButtonLabel), hasOnlyJSW ? undefined : (0, $584c6c5758c545fa$export$cfca87b5d4683694), hasOnlyJSW ? undefined : '_blank') : null, $3d6c2870ae2a9a87$var$showLearnMoreButton(learnMoreButtonAppearance, // @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        learnMoreButtonOnClick, intl.formatMessage((0, $1Y97h.default).learnMoreButtonLabel), hasOnlyJSW ? undefined : (0, $584c6c5758c545fa$export$997e23a0aec74966), hasOnlyJSW ? undefined : '_blank')), upFlowIframeState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ekFy.UpFlowIFrame), {
            targetEdition: (0, $6WXNs.STANDARD_EDITION),
            product: explicitlyLicensedProducts[0],
            flow: upFlowIframeState,
            touchpointId: touchpointId,
            experienceTrackingEnabled: true,
            onClose: onUpFlowIframeClose
        })),
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start"
    }, children));
};
var $3d6c2870ae2a9a87$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $5oIBC.default)($3d6c2870ae2a9a87$var$UpgradeToAddUsersDialog));
const $3d6c2870ae2a9a87$var$buttonBarStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3d6c2870ae2a9a87$var$MultiLineParagraph = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kDzFH", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $f3ca75df413b6183$export$53e066a63a960439);

const $f3ca75df413b6183$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $2edfd53057852e41$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});

parcelRegister("3svxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e55bb6ee669ca6d$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e55bb6ee669ca6d$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $2edfd53057852e41$export$db515c8cec1e6f79] && result.push((0, $2edfd53057852e41$export$db515c8cec1e6f79));
    licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61] && result.push((0, $2edfd53057852e41$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $2edfd53057852e41$export$1346c9aa3cbb477d] && result.push((0, $2edfd53057852e41$export$1346c9aa3cbb477d));
    licensedProducts[0, $2edfd53057852e41$export$202f50ee62667e32] && result.push((0, $2edfd53057852e41$export$202f50ee62667e32));
    return result;
};

});

parcelRegister("3uAFr", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE", () => $bc6bb1980bacdf08$export$1979295cc80a7ec1);
$parcel$export(module.exports, "READ_ABOUT_CONFIGURING_STATUSES", () => $bc6bb1980bacdf08$export$ec2640a84c44efca);
$parcel$export(module.exports, "UPGRADE", () => $bc6bb1980bacdf08$export$fe5b785cab515b6e);
$parcel$export(module.exports, "mapActionIdFromType", () => $bc6bb1980bacdf08$export$2bf527ee1645dc7d);
const $bc6bb1980bacdf08$export$9ba2bc3b1bdc1519 = 'experiment';
const $bc6bb1980bacdf08$export$5b7423264d48ab04 = 'not-enrolled';
const $bc6bb1980bacdf08$export$43f367b3e957f219 = 'control';
const $bc6bb1980bacdf08$export$1979295cc80a7ec1 = 'learn-more';
const $bc6bb1980bacdf08$export$ec2640a84c44efca = 'read-about-configuring-statuses';
const $bc6bb1980bacdf08$export$fe5b785cab515b6e = 'upgrade';
const $bc6bb1980bacdf08$export$2bf527ee1645dc7d = {
    [$bc6bb1980bacdf08$export$1979295cc80a7ec1]: 'freeLearnMore',
    [$bc6bb1980bacdf08$export$ec2640a84c44efca]: 'readAboutConfiguringStatuses',
    [$bc6bb1980bacdf08$export$fe5b785cab515b6e]: 'freeTryNow'
};

});

parcelRegister("9ekFy", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $1bd1da7075fc78d1$export$e9eafd8c579e773d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


var $3V6nz = parcelRequire("3V6nz");

var $lB1hx = parcelRequire("lB1hx");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1bd1da7075fc78d1$var$UpFlowIFrameLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("cRo6H")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $1bd1da7075fc78d1$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $784e146d081cab2a$export$c73007a11ea7e52),
        packageName: (0, $784e146d081cab2a$export$c73007a11ea7e52),
        teamName: "growth-tako",
        fallback: (0, $lB1hx.ChunkLoadErrorFlag),
        attributes: (0, $3V6nz.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bd1da7075fc78d1$var$UpFlowIFrameLazy, props)));

});
const $784e146d081cab2a$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $784e146d081cab2a$export$cb7e587097a78810 = 'upsell-edition';
const $784e146d081cab2a$export$fb320338324d1328 = 'upflowIFrame';
const $784e146d081cab2a$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $784e146d081cab2a$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $784e146d081cab2a$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $784e146d081cab2a$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $784e146d081cab2a$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $784e146d081cab2a$export$b6cceaecfde9dc91 = 'SPA_READY';

parcelRegister("3V6nz", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $4f19dd0acff36bb5$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $4f19dd0acff36bb5$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $4f19dd0acff36bb5$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $4f19dd0acff36bb5$export$d3da1ecaf1206c58);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $lNfG4 = parcelRequire("lNfG4");

var $guiFP = parcelRequire("guiFP");

var $6WXNs = parcelRequire("6WXNs");



var $fdxQj = parcelRequire("fdxQj");
const $4f19dd0acff36bb5$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $guiFP.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $784e146d081cab2a$export$c73007a11ea7e52),
            packageName: (0, $784e146d081cab2a$export$c73007a11ea7e52),
            teamName: 'growth-tako'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $4f19dd0acff36bb5$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $6WXNs.FREE_EDITION)) return 0, $0722a49a19fd82a0$export$e69af2c4378638a2;
    if (applicationEdition === (0, $6WXNs.STANDARD_EDITION)) return 0, $0722a49a19fd82a0$export$7bc7dd5faba7ad6b;
    return 0, $0722a49a19fd82a0$export$3fd0bbb8c68dc4c7;
};
const $4f19dd0acff36bb5$export$7d4045a899f62dfd = (0, $lNfG4.metrics).interaction({
    key: `${(0, $784e146d081cab2a$export$c73007a11ea7e52)}.upgrade.plan`
});
const $4f19dd0acff36bb5$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7rh0R.isLoaderError)(error)
    });
const $4f19dd0acff36bb5$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $4f19dd0acff36bb5$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $4f19dd0acff36bb5$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdxQj.CommerceApiErrorFlag), null);
};

});
const $0722a49a19fd82a0$export$e69af2c4378638a2 = 'free';
const $0722a49a19fd82a0$export$7bc7dd5faba7ad6b = 'standard';
const $0722a49a19fd82a0$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("fdxQj", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $f9cddb5329b8bde6$export$7ee77c445dd775b4);

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $7AaMe = parcelRequire("7AaMe");
const $f9cddb5329b8bde6$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $eo17r.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $7AaMe.default).title,
        description: (0, $7AaMe.default).description,
        isAutoDismiss: true
    });
    return null;
};

});
parcelRegister("7AaMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec87d75cc62a60c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec87d75cc62a60c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("lB1hx", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $fbcf8118023ec96d$export$7a9d9407b3a5f50e);

var $7rh0R = parcelRequire("7rh0R");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $d7NSa = parcelRequire("d7NSa");
const $fbcf8118023ec96d$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $eo17r.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    if ((0, $7rh0R.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $d7NSa.default).title,
        description: (0, $d7NSa.default).description,
        isAutoDismiss: true,
        actions: [
            {
                content: (0, $d7NSa.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("d7NSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf70fc34a5a9ee18$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cf70fc34a5a9ee18$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("cRo6H", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ipZXA")
]).then(()=>parcelRequire('9t7R1'));

});


const $584c6c5758c545fa$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';
const $584c6c5758c545fa$export$b31b7002b6bdcbe9 = 'https://support.atlassian.com/jira-cloud-administration/docs/configure-statuses-resolutions-and-priorities/';
const $584c6c5758c545fa$export$cfca87b5d4683694 = '/admin/billing/applications';

parcelRegister("1Y97h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a007549c91f619$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e5a007549c91f619$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    upgradeToAddUsersHeader: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-header",
        "defaultMessage": "Upgrade to add users"
    },
    upgradeToAddUsersContent: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-content",
        "defaultMessage": "You've reached the maximum number of users for your plan.\nRemove existing users or upgrade to grow your team."
    },
    upgradeButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-button-label",
        "defaultMessage": "Try it now"
    },
    learnMoreButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.learn-more-button-label",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("1Gl68", function(module, exports) {

$parcel$export(module.exports, "getRemainingSeats", () => $a8e8f70e71e008ee$export$6397e3bbf35b34e3);

var $lRmyA = parcelRequire("lRmyA");
const $a8e8f70e71e008ee$var$toRemainingSeats = (json)=>json.remainingSeat;
const $a8e8f70e71e008ee$export$6397e3bbf35b34e3 = (baseUrl, applicationKey)=>(0, $lRmyA.performGetRequest)(`/rest/internal/2/invite-user/application/remaining-seat?key=${applicationKey}`).then((json)=>$a8e8f70e71e008ee$var$toRemainingSeats(json));

});

parcelRegister("7NnaN", function(module, exports) {

$parcel$export(module.exports, "Analytics", () => $92267752c3276ed5$export$2b3af6baec22bd98);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $g1u9S = parcelRequire("g1u9S");

var $2DMQz = parcelRequire("2DMQz");

var $grFrv = parcelRequire("grFrv");
const $92267752c3276ed5$export$2b3af6baec22bd98 = (props)=>{
    const { projectId: projectId, baseUrl: baseUrl, showAddPeopleButton: showAddPeopleButton, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (projectId >= 0 && showAddPeopleButton) Promise.all([
            (0, $2DMQz.getUserProjectRoles)(baseUrl, projectId),
            (0, $g1u9S.getProjectAccessLevel)(baseUrl, projectId)
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([roleData, projectAccessLevel])=>{
            const projectRoleNames = roleData === null || roleData.projectRoleNames === null ? null : (0, $grFrv.reduceCustomRoles)(roleData.projectRoleNames);
            (0, $grFrv.fireAddPeopleRenderedEvent)(createAnalyticsEvent, screenName, projectId, projectRoleNames, projectAccessLevel);
        });
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectId,
        screenName,
        showAddPeopleButton
    ]);
    return null;
};

});
parcelRegister("g1u9S", function(module, exports) {

$parcel$export(module.exports, "getProjectAccessLevel", () => $cb03e98e1c54da65$export$f5f97c28ee230e06);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $cb03e98e1c54da65$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;
const $cb03e98e1c54da65$var$transform = (data)=>data.value;
const $cb03e98e1c54da65$export$f5f97c28ee230e06 = (baseUrl, projectId)=>{
    const request = ()=>(0, $lRmyA.performGetRequest)($cb03e98e1c54da65$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>$cb03e98e1c54da65$var$transform(data)).catch((error)=>{
        const attributes = error instanceof (0, $7byHA.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $guiFP.default)({
            meta: {
                id: 'fetchProjectAccessLevel',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("2DMQz", function(module, exports) {

$parcel$export(module.exports, "getUserProjectRoles", () => $5485a1e5a52a43c5$export$3b587d1e1fe73b9d);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME = 'Member';
const $5485a1e5a52a43c5$var$VIEWER_ROLE_NAME = 'Viewer';
const $5485a1e5a52a43c5$var$userProjectRoleNames = (data)=>data.map((projectRole)=>projectRole.name);
const $5485a1e5a52a43c5$export$5a1a2e9d57f47aee = (data)=>data.some((role)=>role.name === $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME);
const $5485a1e5a52a43c5$export$10eeb2d34050404e = (data)=>data.some((role)=>role.admin);
const $5485a1e5a52a43c5$export$a4d7f3415bee4b75 = (data)=>data.some((role)=>role.name !== $5485a1e5a52a43c5$var$VIEWER_ROLE_NAME && role.name !== $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME && !role.admin);
const $5485a1e5a52a43c5$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true&currentMember=true`;
const $5485a1e5a52a43c5$export$3b587d1e1fe73b9d = (baseUrl, projectId)=>{
    const request = ()=>(0, $lRmyA.performGetRequest)($5485a1e5a52a43c5$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>({
            isMember: $5485a1e5a52a43c5$export$5a1a2e9d57f47aee(data),
            isJiraAdmin: $5485a1e5a52a43c5$export$10eeb2d34050404e(data),
            hasCustomRole: $5485a1e5a52a43c5$export$a4d7f3415bee4b75(data),
            projectRoleNames: $5485a1e5a52a43c5$var$userProjectRoleNames(data)
        })).catch((error)=>{
        const attributes = error instanceof (0, $7byHA.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $guiFP.default)({
            meta: {
                id: 'fetchUserProjectRoles',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("grFrv", function(module, exports) {

$parcel$export(module.exports, "fireAddPeopleRenderedEvent", () => $c3f54e4ee61be276$export$8014b0c4810b7867);
$parcel$export(module.exports, "reduceCustomRoles", () => $c3f54e4ee61be276$export$7f2d1c0dab5190f9);

var $jMP2a = parcelRequire("jMP2a");
const $c3f54e4ee61be276$var$defaultProjectRoles = [
    'Administrator',
    'Member',
    'Viewer'
];
const $c3f54e4ee61be276$export$ecf9824f02c8a125 = 'Custom Role';
const $c3f54e4ee61be276$export$8014b0c4810b7867 = (createAnalyticsEvent, source, projectId, userProjectRoles, projectAccessLevel)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'rendered',
        actionSubject: 'addPeopleButton',
        source: source
    });
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
        projectId: projectId,
        userProjectRoles: userProjectRoles,
        projectAccessLevel: projectAccessLevel
    });
};
const $c3f54e4ee61be276$export$7f2d1c0dab5190f9 = (userProjectRoles)=>{
    let hasCustomRole = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const modifiedProjectRoles = userProjectRoles.reduce((acc, role)=>{
        const isDefaultRole = $c3f54e4ee61be276$var$defaultProjectRoles.includes(role);
        hasCustomRole = hasCustomRole || !isDefaultRole;
        if (isDefaultRole) acc.push(role);
        return acc;
    }, []);
    if (hasCustomRole) modifiedProjectRoles.push($c3f54e4ee61be276$export$ecf9824f02c8a125);
    return modifiedProjectRoles;
};

});


parcelRegister("kovzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46f6f245d939aef$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $giAhk = parcelRequire("giAhk");

var $8rQuz = parcelRequire("8rQuz");

var $9pw6N = parcelRequire("9pw6N");

var $ddnmK = parcelRequire("ddnmK");

var $1Y4Nh = parcelRequire("1Y4Nh");

var $l2Yeb = parcelRequire("l2Yeb");

var $fGrG2 = parcelRequire("fGrG2");
const $a46f6f245d939aef$var$AssigneeFilter = (props)=>{
    const { users: users, selectedUsers: selectedUsers, maxUsers: maxUsers, onAddPeopleClick: onAddPeopleClick, showAddPeopleButton: showAddPeopleButton, onToggle: onToggle, onAssigneeMenuOpen: onAssigneeMenuOpen, intl: { formatMessage: formatMessage }, peopleRef: peopleRef } = props;
    const mainList = (0, $eUqFw.useMemo)(()=>users.length > maxUsers ? users.slice(0, maxUsers - 1) : users.slice(0), [
        users,
        maxUsers
    ]);
    const moreList = (0, $eUqFw.useMemo)(()=>users.length > maxUsers ? users.slice(maxUsers - 1) : [], [
        users,
        maxUsers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "fieldset",
        xcss: [
            (0, $8rQuz.isVisualRefreshEnabled)() ? $a46f6f245d939aef$var$fieldsetStyles : $a46f6f245d939aef$var$fieldsetStylesOld
        ],
        "data-test-id": "filters.ui.filters.assignee.stateless.assignee-filter",
        testId: "filters.ui.filters.assignee.stateless.assignee-filter" // eslint-disable-next-line jira/react/no-style-attribute
        ,
        style: {
            // Ensure layering of avatars does not conflict with anything else in the DOM tree
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            zIndex: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a46f6f245d939aef$var$AvatarFilterLegend, {
        id: (0, $9pw6N.FILTER_PREFIX)
    }, formatMessage((0, $l2Yeb.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a46f6f245d939aef$var$AvatarsList, null, mainList.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Y4Nh.default), {
            key: user.id,
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        })), moreList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fGrG2.default), {
        users: moreList,
        selectedUsers: selectedUsers,
        onItemActivated: onToggle,
        onOpen: onAssigneeMenuOpen
    }), showAddPeopleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ddnmK.default), {
        peopleButtonRef: peopleRef,
        onClick: onAddPeopleClick
    })));
};
$a46f6f245d939aef$var$AssigneeFilter.defaultProps = {
    onAddPeopleClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showAddPeopleButton: false
};
var $a46f6f245d939aef$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($a46f6f245d939aef$var$AssigneeFilter);
const $a46f6f245d939aef$var$fieldsetStyles = (0, $1ZAYh.xcss)({
    flexShrink: 0,
    border: 0
});
const $a46f6f245d939aef$var$fieldsetStylesOld = (0, $1ZAYh.xcss)({
    flexShrink: 0,
    border: 0,
    marginLeft: 'space.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a46f6f245d939aef$var$AvatarsList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a46f6f245d939aef$var$AvatarFilterLegend = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3it94y _1bsbt94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogto7mnp _1reo15vq _18m915vq _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9pw6N", function(module, exports) {

$parcel$export(module.exports, "FILTER_PREFIX", () => $0967a5c8c840826d$export$d6acfe0d617669c3);
$parcel$export(module.exports, "Z_INDEX", () => $0967a5c8c840826d$export$42310dd57a41067);
const $0967a5c8c840826d$export$d6acfe0d617669c3 = 'assignee';
const $0967a5c8c840826d$export$42310dd57a41067 = {
    SELECTED: 1,
    ADD: 2,
    MENU: 3,
    HOVER: 4
};
const $0967a5c8c840826d$export$e70f7f4a08e4d8fb = 10;
const $0967a5c8c840826d$export$75297e3804621b0 = 36;

});

parcelRegister("ddnmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ddc227f3bf4696$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $eri7S = parcelRequire("eri7S");

var $iisnK = parcelRequire("iisnK");

var $eI5EY = parcelRequire("eI5EY");

var $2qhQi = parcelRequire("2qhQi");

var $5cLMB = parcelRequire("5cLMB");

var $kS8l2 = parcelRequire("kS8l2");

var $aked2 = parcelRequire("aked2");

var $8k8RR = parcelRequire("8k8RR");

var $9pw6N = parcelRequire("9pw6N");

var $9bwt3 = parcelRequire("9bwt3");

var $c6LJE = parcelRequire("c6LJE");

var $3zepQ = parcelRequire("3zepQ");
const $70ddc227f3bf4696$var$ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
const $70ddc227f3bf4696$var$AddUsersButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClickProp, peopleButtonRef: peopleButtonRef } = props;
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $9bwt3.onBlur)(event);
        onClickProp();
    }, [
        onClickProp
    ]);
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const onRef = (0, $eUqFw.useCallback)((ref)=>{
        register($70ddc227f3bf4696$var$ADD_PEOPLE_BUTTON_TARGET, ref);
    }, [
        register
    ]);
    const [isDismissed] = (0, $5cLMB.useIsDismissed)();
    const NudgeTooltip = !(0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') || !isDismissed ? (0, $aked2.AssigneeFilterAddPeopleButtonWrapperNudgeAsync) : (0, $eUqFw.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$AddButtonWrapper, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zepQ.AddPeopleTooltip), {
        content: formatMessage((0, $c6LJE.default).addPeople)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$ActionAvatarWrapper, {
        ref: peopleButtonRef,
        "data-test-id": "filters.ui.filters.assignee.stateless.add-button",
        "data-testid": "filters.ui.filters.assignee.stateless.add-button",
        "data-pollinator-filter-bar-add-people": true,
        id: `${(0, $9pw6N.FILTER_PREFIX)}-add-person`,
        "aria-label": formatMessage((0, $c6LJE.default).addPeople),
        onClick: onClick,
        "aria-describedby": (0, $9pw6N.FILTER_PREFIX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$AddButtonAvatarSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iisnK))), {
        size: "medium",
        label: formatMessage((0, $c6LJE.default).addPeople)
    }))))));
};
$70ddc227f3bf4696$var$AddUsersButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $70ddc227f3bf4696$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2qhQi.default)($70ddc227f3bf4696$var$AddUsersButton);
const $70ddc227f3bf4696$var$AddButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70ddc227f3bf4696$var$ActionAvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8k8RR.ActionAvatar), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70ddc227f3bf4696$var$AddButtonAvatarSpacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8k8RR.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $9t7rW.default)((0, $eri7S.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko12pq _1ul912pq _1bsb1wug _1yt4otz2 _vchhusvi _bfhk1s4m _1p9v18uv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $70ddc227f3bf4696$export$7ed12d2a5241e393 = {
    ActionAvatarWrapper: $70ddc227f3bf4696$var$ActionAvatarWrapper
};

});
parcelRegister("iisnK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d51fec82b4cf5254$var$_react = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d51fec82b4cf5254$var$_personAdd = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("kdBCz")));
function $d51fec82b4cf5254$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d51fec82b4cf5254$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d51fec82b4cf5254$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $d51fec82b4cf5254$var$_personAdd.default
    }));
$d51fec82b4cf5254$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d51fec82b4cf5254$var$_default = module.exports.default = $d51fec82b4cf5254$var$InviteTeamIcon;

});
parcelRegister("kdBCz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c71910615fcdf3419bf276c45a2048a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb823455dae27cb1$var$_react = $eb823455dae27cb1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $eb823455dae27cb1$var$_UNSAFE_baseNew = $eb823455dae27cb1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $eb823455dae27cb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb823455dae27cb1$var$PersonAddIcon = (props)=>/*#__PURE__*/ $eb823455dae27cb1$var$_react.default.createElement($eb823455dae27cb1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$eb823455dae27cb1$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $eb823455dae27cb1$var$_default = module.exports.default = $eb823455dae27cb1$var$PersonAddIcon;

});


parcelRegister("kS8l2", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $450c796f66462b96$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $450c796f66462b96$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $450c796f66462b96$export$6b4b878b04fd3017);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");
const $450c796f66462b96$var$store = (0, $WBLbN.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $450c796f66462b96$export$4beaa3baa53198e4 = (0, $WBLbN.createContainer)($450c796f66462b96$var$store);
const $450c796f66462b96$var$useGlobalRefStateSelector = (0, $WBLbN.createStateHook)($450c796f66462b96$var$store, {
    selector: (state, key)=>state[key]
});
const $450c796f66462b96$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $450c796f66462b96$var$useGlobalRefStateSelector(key)
    ];
const $450c796f66462b96$export$3c6c6911d09d7d8a = (0, $WBLbN.createHook)($450c796f66462b96$var$store, {
    selector: null
});
const $450c796f66462b96$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $450c796f66462b96$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("aked2", function(module, exports) {

$parcel$export(module.exports, "AssigneeFilterAddPeopleButtonWrapperNudgeAsync", () => $3995bf095383eb37$export$4e4097c2567f79b7);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3995bf095383eb37$var$AssigneeFilterAddPeopleButtonLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("dgobk")).then((exportedModule)=>exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/assignee-filter-add-people/index.tsx"
});
const $3995bf095383eb37$export$4e4097c2567f79b7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-assignee-filter-add-people-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3995bf095383eb37$var$AssigneeFilterAddPeopleButtonLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98)
    }, children)));

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $8379f5d78bf6fb5a$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $8379f5d78bf6fb5a$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("dgobk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("l5jGp")
]).then(()=>parcelRequire('htukB'));

});


parcelRegister("8k8RR", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $325bbcd3886753b0$export$f7513421c53ce141);
$parcel$export(module.exports, "ActionAvatar", () => $325bbcd3886753b0$export$1a5d4fdc8fa41cfb);
$parcel$export(module.exports, "ActionAvatarSpacer", () => $325bbcd3886753b0$export$d1aac2da5f30c370);
$parcel$export(module.exports, "AvatarBorder", () => $325bbcd3886753b0$export$398a7826f6fd570e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eri7S = parcelRequire("eri7S");

var $9zysr = parcelRequire("9zysr");

var $8rQuz = parcelRequire("8rQuz");

var $9pw6N = parcelRequire("9pw6N");
const $325bbcd3886753b0$export$483a2b43be170225 = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0,
    opacity: 0,
    overflow: 'hidden',
    'white-space': 'nowrap',
    cursor: 'pointer'
};
const $325bbcd3886753b0$export$a3e8c7acf36da4c1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, jiggle: jiggle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10xi207": (0, $9t7rW.default)(__cmplp.zIndex + (0, $9pw6N.Z_INDEX).SELECTED),
            "--_3qw8s9": (0, $9t7rW.default)(__cmplp.zIndex),
            "--_1rh09jt": (0, $9t7rW.default)(__cmplp.zIndex + (0, $9pw6N.Z_INDEX).HOVER)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _4t3i1ylp _kqswh2mm _18u014id _bfhk18uv _s7n4jp4b _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5644a6k _2rko1ssb _11cpidpf _rk8t1bgr _1dig1bgr _yt1x1bgr _qa15stnw _1tfxstnw _ixiwstnw _1wnsb3bt _h10pb3bt _1boqb3bt _328d1osq _cqfi1osq _rtz31osq _1mhnidpf _44x7idpf _l3jaidpf _1rky1n1a _1a071n1a _1wtq1n1a _1xpg1n1a _ti301n1a _1j2w1n1a _s1sf1mrw _1v981mrw _x2d61mrw _1pcqvab1 _1qb3vab1 _1b1bvab1 _vdzntlke _1virtlke _1y7ctlke",
            __cmplp.selected ? "_1pby1ho9" : "_1pby1hh6",
            __cmplp.jiggle ? "_1bvqr915 _66dkr915 _1llwr915" : "_1bvq1kli _66dk1kli _1llw1kli",
            __cmplp.jiggle ? "_n3lxmyb0 _gabdmyb0 _9di1myb0" : "_n3lxidpf _gabdidpf _9di1idpf",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$7d5adb020315f211 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $325bbcd3886753b0$export$a3e8c7acf36da4c1, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3in7od",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$f7513421c53ce141 = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $325bbcd3886753b0$export$7d5adb020315f211, $325bbcd3886753b0$export$a3e8c7acf36da4c1);
const $325bbcd3886753b0$export$1a5d4fdc8fa41cfb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _19it7zi8 _bfhk1s4m _v5644dm8 _80omtlke _7ehi12h7 _nt751r31 _49pcglyw _1hvw1o36 _irr3yucn",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$d1aac2da5f30c370 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $9t7rW.default)((0, $eri7S.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb12pq _4t3i12pq _bfhk18uv _syaz8a6j _vwz412pq",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$398a7826f6fd570e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _19itj1ic",
            __cmplp.selected ? "_1h6d1c86" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9bwt3", function(module, exports) {

$parcel$export(module.exports, "onBlur", () => $9033ffcb430e0776$export$5e446bc31724fca4);
$parcel$export(module.exports, "useOnKeyPress", () => $9033ffcb430e0776$export$49f6dd346c7dfb52);

var $eUqFw = parcelRequire("eUqFw");
const $9033ffcb430e0776$export$5e446bc31724fca4 = (event)=>{
    event.currentTarget.blur();
};
const $9033ffcb430e0776$export$49f6dd346c7dfb52 = (callback)=>(0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter') callback(event);
    }, [
        callback
    ]);

});

parcelRegister("c6LJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ba036c0ba7538c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ba036c0ba7538c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addPeople: {
        "id": "software-filters.filters.assignee.stateless.add-button.add-people",
        "defaultMessage": "Add people"
    }
});

});

parcelRegister("3zepQ", function(module, exports) {

$parcel$export(module.exports, "AddPeopleTooltip", () => $5da98676a909d737$export$7d4858372ded9f0e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2eG9N = parcelRequire("2eG9N");
const $5da98676a909d737$export$7d4858372ded9f0e = ({ content: content, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5da98676a909d737$var$TooltipWrapper, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5da98676a909d737$var$TooltipWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _4t3i14no",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1Y4Nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09bf05d0581ac1d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iJlfe = parcelRequire("iJlfe");

var $2eG9N = parcelRequire("2eG9N");

var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");

var $2qhQi = parcelRequire("2qhQi");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $l4zCR = parcelRequire("l4zCR");

var $8rQuz = parcelRequire("8rQuz");

var $8k8RR = parcelRequire("8k8RR");

var $9bwt3 = parcelRequire("9bwt3");

var $9lr32 = parcelRequire("9lr32");

var $43XZb = parcelRequire("43XZb");
const $a09bf05d0581ac1d$var$type = 'assignee';
const $a09bf05d0581ac1d$var$AvatarWithAnalytics = ({ isRealtimePresenceEnabled: isRealtimePresenceEnabled, intl: intl, ...user })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = intl;
    const onShow = ()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'tooltip viewed');
    };
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $43XZb.default).presenceOnlineLabel : (0, $43XZb.default).presenceOfflineLabel, {
        name: user.displayName
    });
    if (isRealtimePresenceEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
        content: user.label || user.displayName,
        onShow: onShow,
        tag: "span",
        presence: user.presence
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $8rQuz.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: user.label || user.displayName,
        onShow: onShow,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $8rQuz.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
};
const $a09bf05d0581ac1d$var$Avatar = (props)=>{
    const { user: user, isSelected: isSelected, zIndex: zIndex, intl: intl } = props;
    const { formatMessage: formatMessage } = intl;
    const userIdentifier = user.id;
    const checkboxId = `${$a09bf05d0581ac1d$var$type}-${userIdentifier}`;
    const onToggle = (0, $eUqFw.useCallback)(()=>{
        props.onToggle(user.id);
    }, [
        props,
        user.id
    ]);
    const onKeyPress = (0, $9bwt3.useOnKeyPress)(onToggle);
    const { experimentCohort: experimentCohort } = (0, $l4zCR.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $1Iui1.VARIATION);
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $43XZb.default).presenceOnlineLabel : (0, $43XZb.default).presenceOfflineLabel, {
        name: user.displayName
    });
    const avatarWithTooltip = isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
        content: user.displayName,
        presence: user.presence,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: "medium",
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: user.displayName,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: "medium",
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarWrapper), {
        selected: isSelected,
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarInputCheckbox, {
        "aria-label": formatMessage((0, $43XZb.default).avatarInputCheckboxLabel),
        type: "checkbox",
        id: checkboxId,
        name: $a09bf05d0581ac1d$var$type,
        value: userIdentifier,
        defaultChecked: isSelected,
        onChange: onToggle,
        onKeyPress: onKeyPress,
        onClick: (0, $9bwt3.onBlur)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarBorder), {
        selected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarLabel, {
        "data-test-id": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        "data-testid": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId
    }, (0, $1ybV0.ff)('jsw.enable.avatar.tooltip.label.and.analytic_hikl3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarWithAnalytics, {
        ...user,
        isRealtimePresenceEnabled: isRealtimePresenceEnabled,
        intl: intl
    }) : avatarWithTooltip)));
};
$a09bf05d0581ac1d$var$Avatar.defaultProps = {
    isSelected: false,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $a09bf05d0581ac1d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2qhQi.default)($a09bf05d0581ac1d$var$Avatar);
const $a09bf05d0581ac1d$var$AvatarLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4idpf _1e0c1ule _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a09bf05d0581ac1d$var$AvatarInputCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _1xp4rg51",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a09bf05d0581ac1d$export$7ed12d2a5241e393 = {
    AvatarInputCheckbox: $a09bf05d0581ac1d$var$AvatarInputCheckbox
};

});
parcelRegister("l4zCR", function(module, exports) {

$parcel$export(module.exports, "useRealtimePresenceExperiment", () => $fd97030f85875137$export$ba964695877b24);

var $d2wNG = parcelRequire("d2wNG");

var $79xbN = parcelRequire("79xbN");

var $21Sgb = parcelRequire("21Sgb");
const $fd97030f85875137$export$ba964695877b24 = ()=>{
    const firstActivationDateMs = (0, $21Sgb.useFirstActivationDateMs)();
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
    return {
        experimentCohort: !firstActivationDateMs || (0, $d2wNG.default)(new Date(), firstActivationDateMs) < 30 ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled')
    };
};

});
parcelRegister("21Sgb", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $080756a4d87be123$export$9df3a539e50a284b);

var $gd0Sp = parcelRequire("gd0Sp");
const $080756a4d87be123$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});


parcelRegister("9lr32", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4523828920fa75c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2MpRo = parcelRequire("2MpRo");
const $c4523828920fa75c$var$PresenceTooltip = ({ presence: presence, content: content, children: children, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const contentWithPresence = presence === 'online' ? formatMessage((0, $2MpRo.default).presenceToolTipOnline, {
        name: String(content)
    }) : formatMessage((0, $2MpRo.default).presenceToolTipOffline, {
        name: String(content)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: presence ? contentWithPresence : content,
        ...restProps
    }, children);
};
var $c4523828920fa75c$export$2e2bcd8739ae039 = $c4523828920fa75c$var$PresenceTooltip;

});
parcelRegister("2MpRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e99513c5816bd7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a9e99513c5816bd7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    presenceToolTipOnline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-online",
        "defaultMessage": "{name} is online"
    },
    presenceToolTipOffline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-offline",
        "defaultMessage": "{name} is offline"
    }
});

});


parcelRegister("43XZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $28562c6ddb0b4980$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28562c6ddb0b4980$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    presenceOnlineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-online-label",
        "defaultMessage": "{name} (online)"
    },
    presenceOfflineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-offline-label",
        "defaultMessage": "{name} (offline)"
    },
    avatarInputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label",
        "defaultMessage": "assignee filter avatar"
    }
});

});


parcelRegister("l2Yeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ec85272c96e5b8f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1ec85272c96e5b8f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.assignee.stateless.label",
        "defaultMessage": "Filter by assignee"
    }
});

});

parcelRegister("fGrG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f094d1bb53629df3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iJlfe = parcelRequire("iJlfe");

var $6OfWd = parcelRequire("6OfWd");
var $9mc6u = parcelRequire("9mc6u");

var $2eG9N = parcelRequire("2eG9N");

var $1Iui1 = parcelRequire("1Iui1");

var $l4zCR = parcelRequire("l4zCR");

var $6vrw7 = parcelRequire("6vrw7");

var $8k8RR = parcelRequire("8k8RR");

var $9pw6N = parcelRequire("9pw6N");

var $9bwt3 = parcelRequire("9bwt3");

var $9lr32 = parcelRequire("9lr32");
const $f094d1bb53629df3$var$ShowMoreButton = (props)=>{
    const { users: users, selectedUsers: selectedUsers, onOpen: onOpen, onItemActivated: onItemActivatedProps } = props;
    const [isOpen, setOpenState] = (0, $eUqFw.useState)(false);
    const _onOpenChange = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (attrs)=>{
        setOpenState(attrs.isOpen);
        if (attrs.isOpen) onOpen();
    }, [
        setOpenState,
        onOpen
    ]);
    const isSelected = (0, $eUqFw.useMemo)(()=>users.some((user)=>selectedUsers.includes(user.id)), [
        users,
        selectedUsers
    ]);
    const { experimentCohort: experimentCohort } = (0, $l4zCR.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $1Iui1.VARIATION);
    const dropdownItems = (0, $eUqFw.useMemo)(()=>users.map(({ id: id, displayName: displayName, avatarUrl: avatarUrl, presence: presence })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ItemWrapper, {
                key: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9mc6u.default), {
                id: id,
                isSelected: selectedUsers.includes(id),
                onClick: ()=>{
                    onItemActivatedProps((0, $6vrw7.toAccountId)(String(id)));
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ItemContent, null, isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
                content: displayName,
                presence: presence
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: displayName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$TextContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$TextContent, null, displayName)))))), [
        users,
        selectedUsers,
        onItemActivatedProps,
        isRealtimePresenceEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarWrapper), {
                ...triggerProps,
                ref: triggerRef,
                zIndex: (0, $9pw6N.Z_INDEX).MENU
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ActionInputCheckbox, {
                "data-test-id": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                "data-testid": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                type: "checkbox",
                id: `${(0, $9pw6N.FILTER_PREFIX)}-show-more`,
                name: (0, $9pw6N.FILTER_PREFIX),
                value: `${(0, $9pw6N.FILTER_PREFIX)}-show-more`,
                defaultChecked: isOpen,
                "aria-describedby": (0, $9pw6N.FILTER_PREFIX),
                onClick: (0, $9bwt3.onBlur)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarBorder), {
                selected: isSelected
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.ActionAvatar), {
                tabIndex: -1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.ActionAvatarSpacer), null, `+${users.length}`))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownItemsWrapper, null, dropdownItems)));
};
$f094d1bb53629df3$var$ShowMoreButton.defaultProps = {
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $f094d1bb53629df3$export$2e2bcd8739ae039 = $f094d1bb53629df3$var$ShowMoreButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f094d1bb53629df3$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _18u014id _1pbyidpf",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1mjv _1yt4swc3",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1t4ug9d8 _k907ze3t",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ItemContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$DropdownAvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$TextContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18s816r1 _1yt41w01 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$TextContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ActionInputCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1glwzk5k _5o9f194a",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});


parcelRegister("9mc6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd85e99771c9c60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $8jcoK = parcelRequire("8jcoK");

var $bULPy = parcelRequire("bULPy");

var $caOPr = parcelRequire("caOPr");

var $4lVNM = parcelRequire("4lVNM");

var $h1Q9j = parcelRequire("h1Q9j");

var $2fFJv = parcelRequire("2fFJv");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $bdd85e99771c9c60$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $5Q9wj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $2fFJv;
    const [selected, setSelected] = (0, $4lVNM.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $h1Q9j.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $caOPr.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        ...rest
    }, children));
};
var $bdd85e99771c9c60$export$2e2bcd8739ae039 = $bdd85e99771c9c60$var$DropdownItemCheckbox;

});
parcelRegister("caOPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70ae4045f17c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $0f70ae4045f17c28$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? `var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    })));
};
var $0f70ae4045f17c28$export$2e2bcd8739ae039 = $0f70ae4045f17c28$var$CheckboxIcon;

});

parcelRegister("4lVNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f55dd9044769050$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b9WHI = parcelRequire("b9WHI");

var $7mYCs = parcelRequire("7mYCs");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $4f55dd9044769050$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const groupId = (0, $eUqFw.useContext)((0, $b9WHI.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $4f55dd9044769050$export$2e2bcd8739ae039 = $4f55dd9044769050$var$useCheckboxState;

});
parcelRegister("b9WHI", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $7d37fbf6df8e3733$export$baf37c4be89255b8);

var $eUqFw = parcelRequire("eUqFw");
const $7d37fbf6df8e3733$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $eUqFw.createContext)('');

});






parcelRegister("itGQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $35bc1d42f552afea$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $hd6kM = parcelRequire("hd6kM");
const $35bc1d42f552afea$var$ClearFilterButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            !(0, $8rQuz.isVisualRefreshEnabled)() && $35bc1d42f552afea$var$styledClearFilterStyles
        ],
        "data-test-id": "filters.ui.filters.clear-button.ak-button",
        testId: "filters.ui.filters.clear-button.ak-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: (0, $8rQuz.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onClick: props.onClick
    }, props.label || formatMessage((0, $hd6kM.default).label)));
};
$35bc1d42f552afea$var$ClearFilterButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $35bc1d42f552afea$export$2e2bcd8739ae039 = $35bc1d42f552afea$var$ClearFilterButton;
const $35bc1d42f552afea$var$styledClearFilterStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("hd6kM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f91b0cf94f2a1046$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f91b0cf94f2a1046$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.clear-button.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("35WdX", function(module, exports) {

$parcel$export(module.exports, "default", () => $592abc4ed745ea19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $adsMt = parcelRequire("adsMt");
const $592abc4ed745ea19$var$ComponentFilter = ({ components: components = [], selectedComponents: selectedComponents = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>components.map((component)=>({
                label: component.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(component.id)
            })), [
        components
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
            label: formatMessage((0, $adsMt.default).label),
            values: values,
            selectedValues: (0, $6vrw7.toStringArray)(selectedComponents),
            onChange: onChangeCallback,
            isNested: isNested
        }), [
        formatMessage,
        onChangeCallback,
        selectedComponents,
        values,
        isNested
    ]);
};
var $592abc4ed745ea19$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($592abc4ed745ea19$var$ComponentFilter);

});
parcelRegister("adsMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ae72ac02ee48f1a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8ae72ac02ee48f1a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.component.label",
        "defaultMessage": "Components"
    }
});

});


parcelRegister("9U5Uu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10eca6451c38f91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $azooe = parcelRequire("azooe");

var $49Ecd = parcelRequire("49Ecd");

var $fY3YW = parcelRequire("fY3YW");
const $b10eca6451c38f91$var$DependenciesFilter = ({ isOpen: isOpen = false, onChange: // only used for VR testing purposes
onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), selectedValues: selectedValues = [] })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onChangeValue = (0, $eUqFw.useCallback)((entries)=>{
        onChange(entries.map(({ value: value })=>value));
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        isOpen: isOpen,
        label: formatMessage((0, $49Ecd.default).label),
        onChange: onChangeValue,
        values: [
            {
                label: formatMessage((0, $49Ecd.default).dependencyType),
                options: [
                    {
                        label: formatMessage((0, $49Ecd.default).offTrack),
                        value: (0, $fY3YW.DependencyFilterOption).OFF_TRACK
                    }
                ]
            }
        ],
        selectedValues: selectedValues
    });
};
$b10eca6451c38f91$var$DependenciesFilter.displayName = 'DependenciesFilter';
$b10eca6451c38f91$var$DependenciesFilter.whyDidYouRender = true;
var $b10eca6451c38f91$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b10eca6451c38f91$var$DependenciesFilter);

});
parcelRegister("49Ecd", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d74569191935e6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $86d74569191935e6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.dependencies.label",
        "defaultMessage": "Dependencies"
    },
    dependencyType: {
        "id": "software-filters.filters.dependencies.dependency-type",
        "defaultMessage": "Dependency type"
    },
    offTrack: {
        "id": "software-filters.filters.dependencies.off-track",
        "defaultMessage": "Off-track"
    }
});

});


parcelRegister("9D86p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab6568daa3b64d9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3aUuh = parcelRequire("3aUuh");

var $jG2Eu = parcelRequire("jG2Eu");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4dREb = parcelRequire("4dREb");

var $As52d = parcelRequire("As52d");

var $azooe = parcelRequire("azooe");

var $bfIfF = parcelRequire("bfIfF");

var $fDvZ4 = parcelRequire("fDvZ4");
const $ab6568daa3b64d9d$var$EMPTY_ARRAY = [];
const $ab6568daa3b64d9d$var$GoalCustomOptionLabel = ({ label: label, value: value })=>{
    const goalContext = (0, $eUqFw.useContext)((0, $bfIfF.GoalFilterContext));
    const goalState = goalContext.goals[value]?.state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        grow: "fill"
    }, goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4dREb.GoalIcon), {
        state: goalState.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $ab6568daa3b64d9d$var$goalLabelStyles
    }, label), goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $As52d.GoalTracker), {
        label: goalState.label,
        score: goalState.score,
        value: goalState.value
    }));
};
const $ab6568daa3b64d9d$var$GoalFilter = ({ goals: goals, selectedGoals: selectedGoals = $ab6568daa3b64d9d$var$EMPTY_ARRAY, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onOpenChange: onOpenChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onMouseEnterToTriggerButton: onMouseEnterToTriggerButton = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty = false, inputValue: inputValue, isLoading: isLoading = false, isNested: isNested = false, isOpen: isOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>goals.map((goal)=>({
                label: goal.name,
                value: goal.id,
                data: goal.state
            })), [
        goals
    ]);
    const goalsHash = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(goals, (goal)=>goal.id), [
        goals
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfIfF.GoalFilterContext).Provider, {
        value: {
            goals: goalsHash
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $fDvZ4.default).label),
        values: values,
        isOpen: isOpen,
        selectedValues: selectedGoals,
        isPanelToggleChecked: false,
        onChange: onChangeCallback,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $fDvZ4.default).noGoals),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: false,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
        placeholder: formatMessage((0, $fDvZ4.default).placeholder),
        CustomOptionLabel: $ab6568daa3b64d9d$var$GoalCustomOptionLabel,
        showPanelToggle: false,
        showLink: false,
        useHrefForUrl: false,
        maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
        onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }));
};
var $ab6568daa3b64d9d$export$2e2bcd8739ae039 = $ab6568daa3b64d9d$var$GoalFilter;
const $ab6568daa3b64d9d$var$goalLabelStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("4dREb", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $05f58ca73b129f56$export$134cbcd70c6693b8);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Deo8 = parcelRequire("4Deo8");

var $gKpeZ = parcelRequire("gKpeZ");
const $05f58ca73b129f56$var$GoalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $05f58ca73b129f56$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $05f58ca73b129f56$var$iconContainerStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4Deo8.mapStateToBgColor)(state)
        },
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $05f58ca73b129f56$var$GoalGlyph,
        label: formatMessage((0, $gKpeZ.default).goalIconLabel),
        primaryColor: (0, $4Deo8.mapStateToColor)(state)
    }));
};
const $05f58ca73b129f56$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    borderRadius: 'border.radius',
    marginRight: 'space.025'
});

});
parcelRegister("4Deo8", function(module, exports) {

$parcel$export(module.exports, "mapStateToBgColor", () => $02d4cc5f6bd3d325$export$931dac3fa53640b1);
$parcel$export(module.exports, "mapStateToColor", () => $02d4cc5f6bd3d325$export$163d1ee1b3b2aead);
$parcel$export(module.exports, "mapScoreToBgColor", () => $02d4cc5f6bd3d325$export$525ec0d5be9572a4);
$parcel$export(module.exports, "extractStatusLabelWithoutScore", () => $02d4cc5f6bd3d325$export$88bbcb3741dee92d);

const $02d4cc5f6bd3d325$export$931dac3fa53640b1 = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-background-accent-red-subtlest, ${(0, $73a5c9d720aa66e1$exports).R50})`;
        case 'at_risk':
            return `var(--ds-background-accent-yellow-subtlest, ${(0, $73a5c9d720aa66e1$exports).Y50})`;
        case 'on_track':
            return `var(--ds-background-accent-green-subtlest, ${(0, $73a5c9d720aa66e1$exports).G50})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-background-accent-gray-subtlest, ${(0, $73a5c9d720aa66e1$exports).N20})`;
    }
};
const $02d4cc5f6bd3d325$export$163d1ee1b3b2aead = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-text-accent-red, ${(0, $73a5c9d720aa66e1$exports).R500})`;
        case 'at_risk':
            return `var(--ds-text-accent-orange, ${(0, $73a5c9d720aa66e1$exports).Y500})`;
        case 'on_track':
            return `var(--ds-text-accent-green, ${(0, $73a5c9d720aa66e1$exports).G500})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-text-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`;
    }
};
const $02d4cc5f6bd3d325$export$525ec0d5be9572a4 = (score)=>{
    if (score < 0.4) return `var(--ds-background-danger-bold, ${(0, $73a5c9d720aa66e1$exports).R500})`;
    if (score < 0.7) return `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y500})`;
    return `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$exports).G500})`;
};
const $02d4cc5f6bd3d325$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];

});

parcelRegister("gKpeZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea671f73d186d15$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0ea671f73d186d15$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goalIconLabel: {
        "id": "software-goals.goal.icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("As52d", function(module, exports) {

$parcel$export(module.exports, "GoalTracker", () => $303e43f665e710f6$export$c0fdf469f92e8578);

var $eUqFw = parcelRequire("eUqFw");

var $4Deo8 = parcelRequire("4Deo8");

var $fKlXo = parcelRequire("fKlXo");

var $hT69m = parcelRequire("hT69m");
const $303e43f665e710f6$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hT69m.Tracker), {
        backgroundColor: (0, $4Deo8.mapStateToBgColor)(value),
        color: (0, $4Deo8.mapStateToColor)(value)
    }, (0, $4Deo8.extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fKlXo.Score), {
        score: score
    }));

});
parcelRegister("fKlXo", function(module, exports) {

$parcel$export(module.exports, "Score", () => $8652e2ebcc366b7f$export$6735cf84ecd2736);

var $eUqFw = parcelRequire("eUqFw");

var $4Deo8 = parcelRequire("4Deo8");

var $fdegN = parcelRequire("fdegN");
const $8652e2ebcc366b7f$export$6735cf84ecd2736 = ({ score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdegN.ScoreContainer), {
        backgroundColor: (0, $4Deo8.mapScoreToBgColor)(score)
    }, score);

});
parcelRegister("fdegN", function(module, exports) {

$parcel$export(module.exports, "ScoreContainer", () => $0423525836f3c2c9$export$32466e20de52fc97);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $0423525836f3c2c9$export$32466e20de52fc97 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _bfhk3qkl _syaz15cr _2rko1l7b _18u01b66 _1yt4otz2 _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hT69m", function(module, exports) {

$parcel$export(module.exports, "Tracker", () => $ef0bcdff719080e2$export$254d9747e34ddc90);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $ef0bcdff719080e2$export$254d9747e34ddc90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor),
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk3qkl _2rko1l7b _1yt41b66 _11c81vlj _k48pmoej _syaz1cj8 _1p1dangw _3fcw1q9c _1e0c1ule _4t3i7vkz _vwz47vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bfIfF", function(module, exports) {

$parcel$export(module.exports, "GoalFilterContext", () => $78a8184ec9e445f2$export$f656d92d95229cd2);

var $eUqFw = parcelRequire("eUqFw");
const $78a8184ec9e445f2$export$f656d92d95229cd2 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    goals: {}
});

});

parcelRegister("fDvZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9b6c41cb5dbc38$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3e9b6c41cb5dbc38$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noGoals: {
        "id": "software-filters.filters.goals.no-goals",
        "defaultMessage": "There are no matching goals"
    },
    placeholder: {
        "id": "software-filters.filters.goals.placeholder",
        "defaultMessage": "Choose goals"
    },
    label: {
        "id": "software-filters.filters.goals.label",
        "defaultMessage": "Goals"
    }
});

});


parcelRegister("6syeh", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b7489e946c438c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $9q65n = parcelRequire("9q65n");
const $87b7489e946c438c$var$IssueProjectFilter = ({ isOpen: isOpen = false, isNested: // only used for VR testing purposes
isNested = false, issueProjects: issueProjects = {}, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), selectedProjects: selectedProjects = [] })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>Object.values(issueProjects).map(({ avatar: avatar, id: id, name: name })=>({
                iconUrl: avatar,
                label: name,
                value: String(id)
            })).sort((a, b)=>a.label.localeCompare(b.label)), [
        issueProjects
    ]);
    const onChangeValue = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $6vrw7.toProjectId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        isOpen: isOpen,
        isNested: isNested,
        label: formatMessage((0, $9q65n.default).label),
        onChange: onChangeValue,
        selectedValues: selectedProjects.map(String),
        values: values
    });
};
$87b7489e946c438c$var$IssueProjectFilter.displayName = 'IssueProjectFilter';
$87b7489e946c438c$var$IssueProjectFilter.whyDidYouRender = true;
var $87b7489e946c438c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($87b7489e946c438c$var$IssueProjectFilter);

});
parcelRegister("9q65n", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c9b06265a5a95e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $15c9b06265a5a95e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-project.label",
        "defaultMessage": "Project"
    }
});

});


parcelRegister("kpwtP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b9961d32e52eac2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $azooe = parcelRequire("azooe");

var $lNrGM = parcelRequire("lNrGM");
const $6b9961d32e52eac2$var$IssueTypeGroupFilter = ({ isOpen: isOpen = false, issueTypeGroups: issueTypeGroups = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueTypeGroupByIssueType = (0, $eUqFw.useMemo)(()=>new Map(issueTypeGroups.flatMap((group)=>group.issueTypes.map((issueType)=>[
                    issueType,
                    group
                ]))), [
        issueTypeGroups
    ]);
    const issueTypeGroupByGroupKey = (0, $eUqFw.useMemo)(()=>new Map(issueTypeGroups.map((group)=>[
                group.key,
                group
            ])), [
        issueTypeGroups
    ]);
    const values = (0, $eUqFw.useMemo)(()=>issueTypeGroups.map((group)=>({
                label: group.name,
                value: group.key,
                iconUrl: group.iconUrl
            })), [
        issueTypeGroups
    ]);
    const selectGroupsByKeys = (0, $eUqFw.useCallback)((keys)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(keys.flatMap((key)=>issueTypeGroupByGroupKey.get(key)?.issueTypes).filter(Boolean), analyticAttributes);
    }, [
        onChange,
        issueTypeGroupByGroupKey,
        isNested
    ]);
    const selectedGroups = (0, $eUqFw.useMemo)(()=>Array.from(new Set(selectedIssueTypes.map((key)=>issueTypeGroupByIssueType.get(key)))), [
        issueTypeGroupByIssueType,
        selectedIssueTypes
    ]);
    const selectedGroupKeys = selectedGroups.map((group)=>group?.key).filter(Boolean);
    const selectedGroupsAllIssueTypes = selectedGroups.flatMap((group)=>group?.issueTypes).filter(Boolean);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const entryValues = entries.map(({ value: value })=>value);
        selectGroupsByKeys(entryValues);
    }, [
        selectGroupsByKeys
    ]);
    // early exit if we have only one issue type group
    if (issueTypeGroups.length <= 1) return null;
    // if there's mismatch between the filters in the url and the issue groups, e.g. when the url is manually edited or when an issue of a new type is created, we would apply the whole group
    if (selectedGroupsAllIssueTypes.length !== selectedIssueTypes.length) {
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(selectedGroupsAllIssueTypes, analyticAttributes);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        isOpen: isOpen,
        label: formatMessage((0, $lNrGM.default).label),
        values: values,
        selectedValues: selectedGroupKeys,
        onChange: onChangeCallback,
        isNested: isNested
    });
};
$6b9961d32e52eac2$var$IssueTypeGroupFilter.displayName = 'IssueTypeGroupFilter';
$6b9961d32e52eac2$var$IssueTypeGroupFilter.whyDidYouRender = true;
var $6b9961d32e52eac2$export$2e2bcd8739ae039 = $6b9961d32e52eac2$var$IssueTypeGroupFilter;

});
parcelRegister("lNrGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $92076df1efb7cd76$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $92076df1efb7cd76$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type-group.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("dNCGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb3e818e9802c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $7Wut4 = parcelRequire("7Wut4");
const $6bb3e818e9802c28$var$IssueTypeFilter = ({ issueTypes: issueTypes = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>issueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                iconUrl: issueType.iconUrl
            })), [
        issueTypes
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>(0, $6vrw7.toIssueTypeId)(entry.value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one issue type
    if (issueTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $7Wut4.default).label),
        values: values,
        selectedValues: selectedIssueTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $6bb3e818e9802c28$var$IssueTypeFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($6bb3e818e9802c28$var$IssueTypeFilter);
$6bb3e818e9802c28$var$IssueTypeFilterComponent.displayName = 'IssueTypeFilter';
// @ts-expect-error TS2339: Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$6bb3e818e9802c28$var$IssueTypeFilterComponent.whyDidYouRender = true;
var $6bb3e818e9802c28$export$2e2bcd8739ae039 = $6bb3e818e9802c28$var$IssueTypeFilterComponent;

});
parcelRegister("7Wut4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba2dd317ef60362$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6ba2dd317ef60362$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("ifij9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a428ff4a998e30ae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $azooe = parcelRequire("azooe");

var $2gCEP = parcelRequire("2gCEP");
const $a428ff4a998e30ae$var$LabelFilter = ({ labels: labels = [], selectedLabels: selectedLabels = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false, unassignedOption: unassignedOption })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>{
        const options = labels.map((label)=>({
                label: label,
                value: label
            }));
        unassignedOption && options.unshift(unassignedOption);
        return options;
    }, [
        labels,
        unassignedOption
    ]);
    const onChangeMapValues = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $2gCEP.default).label),
        values: values,
        selectedValues: selectedLabels,
        onChange: onChangeMapValues,
        isNested: isNested
    });
};
const $a428ff4a998e30ae$var$LabelFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($a428ff4a998e30ae$var$LabelFilter);
$a428ff4a998e30ae$var$LabelFilterComponent.displayName = 'LabelFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$a428ff4a998e30ae$var$LabelFilterComponent.whyDidYouRender = true;
var $a428ff4a998e30ae$export$2e2bcd8739ae039 = $a428ff4a998e30ae$var$LabelFilterComponent;

});
parcelRegister("2gCEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1276a32f4064ed01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1276a32f4064ed01$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.label.label",
        "defaultMessage": "Label"
    }
});

});


parcelRegister("37gdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $89b7bf9c6af5f6d4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");

var $6vrw7 = parcelRequire("6vrw7");

var $3kYjh = parcelRequire("3kYjh");

var $8MrYx = parcelRequire("8MrYx");

var $lB25E = parcelRequire("lB25E");

var $azooe = parcelRequire("azooe");

var $9kkzA = parcelRequire("9kkzA");
const $89b7bf9c6af5f6d4$var$ParentFilter = (props)=>{
    const { label: label, parents: parents, selectedParents: selectedParents, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, onInputChange: onInputChange, onOpenChange: onOpenChange, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, intl: { formatMessage: formatMessage }, showPanelToggle: showPanelToggle, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, inputValue: inputValue, isLoading: isLoading, isAsyncSearch: isAsyncSearch, isNested: isNested, isOpen: isOpen } = props;
    const [boardId] = (0, $lB25E.usePathParam)('boardId');
    const { toggleViewSetting: toggleViewSetting } = (0, $8MrYx.useViewSettingsActions)();
    const values = (0, $eUqFw.useMemo)(()=>parents.map((parent)=>({
                label: parent.name,
                value: parent.id,
                subLabel: parent.key
            })), [
        parents
    ]);
    const onChange = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map((entry)=>(0, $6vrw7.toIssueId)(entry.value)), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $eUqFw.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $3kYjh.ViewSetting).EPIC_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "epicPanelToggle",
        attributes: {
            isOpen: !isToggleChecked,
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: label,
        toggleLabel: formatMessage((0, $9kkzA.default).toggleLabel, {
            parentName: label?.toLowerCase()
        }),
        values: values,
        isOpen: isOpen,
        showPanelToggle: showPanelToggle,
        selectedValues: selectedParents.map(String),
        isPanelToggleChecked: isToggleChecked,
        onChange: onChange,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onTogglePanel: handleTogglePanel,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $9kkzA.default).noParentIssues, {
            parentName: label
        }),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: isAsyncSearch,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton
    }));
};
$89b7bf9c6af5f6d4$var$ParentFilter.defaultProps = {
    selectedParents: [],
    isToggleChecked: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    isLoading: false,
    isAsyncSearch: false,
    isNested: false
};
var $89b7bf9c6af5f6d4$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($89b7bf9c6af5f6d4$var$ParentFilter);

});
parcelRegister("3kYjh", function(module, exports) {

$parcel$export(module.exports, "ViewSetting", () => $c7ac9f0e85497714$export$b6da678b61e4982c);

var $c3qrZ = parcelRequire("c3qrZ");

var $kqmep = parcelRequire("kqmep");
const $c7ac9f0e85497714$export$b6da678b61e4982c = {
    ...(0, $c3qrZ.Panels),
    ...(0, $kqmep.CardDetails),
    ...(0, $c3qrZ.IncrementPlanningSettings),
    QUICK_FILTERS: $c3qrZ.QUICK_FILTERS,
    COMPACT_MODE: $c3qrZ.COMPACT_MODE
};

});
parcelRegister("c3qrZ", function(module, exports) {

$parcel$export(module.exports, "View", () => $8eb6b75af7e82572$export$27a5bd065ad55220);
$parcel$export(module.exports, "KeyboardShortcut", () => $8eb6b75af7e82572$export$47a1bf8d9994c680);
$parcel$export(module.exports, "ExpandableState", () => $8eb6b75af7e82572$export$d0f8c009a99b9c1b);
$parcel$export(module.exports, "ViewLocation", () => $8eb6b75af7e82572$export$7ee1cf745baadfcd);
$parcel$export(module.exports, "ViewAs", () => $8eb6b75af7e82572$export$70549c4aef7e1632);
$parcel$export(module.exports, "QUICK_FILTERS", () => $8eb6b75af7e82572$export$59191afd909777e0);
$parcel$export(module.exports, "COMPACT_MODE", () => $8eb6b75af7e82572$export$abd09d2531440e47);
$parcel$export(module.exports, "SHOW_EPICS", () => $8eb6b75af7e82572$export$f3d7917d25ca2d13);
$parcel$export(module.exports, "SHOW_STATUSES", () => $8eb6b75af7e82572$export$933792f2c41e7c51);
$parcel$export(module.exports, "SHOW_VERSIONS", () => $8eb6b75af7e82572$export$fe0a5eeac8bdee53);
$parcel$export(module.exports, "SHOW_ISSUE_LINKS_STATS", () => $8eb6b75af7e82572$export$889dbf130218e8b3);
$parcel$export(module.exports, "SHOW_ISSUE_KEY", () => $8eb6b75af7e82572$export$f199de710b228934);
$parcel$export(module.exports, "SHOW_ISSUE_TYPE", () => $8eb6b75af7e82572$export$e8f86e49139c6abb);
$parcel$export(module.exports, "SHOW_ESTIMATE", () => $8eb6b75af7e82572$export$e1f60d3e74825af0);
$parcel$export(module.exports, "SHOW_PRIORITY", () => $8eb6b75af7e82572$export$bcfd60da3302536e);
$parcel$export(module.exports, "SHOW_DEVELOPMENT", () => $8eb6b75af7e82572$export$e7b5d3d062c615d5);
$parcel$export(module.exports, "SHOW_ASSIGNEE", () => $8eb6b75af7e82572$export$3c14ba0cd46183b);
$parcel$export(module.exports, "SHOW_DAYS_IN_COLUMN", () => $8eb6b75af7e82572$export$8224ffeed837235e);
$parcel$export(module.exports, "SHOW_DUE_DATE", () => $8eb6b75af7e82572$export$770e28bfe2e0208d);
$parcel$export(module.exports, "SHOW_LABELS", () => $8eb6b75af7e82572$export$63993996bfd99919);
$parcel$export(module.exports, "SHOW_CARD_COVERS", () => $8eb6b75af7e82572$export$b811e8bce70dd7c2);
$parcel$export(module.exports, "Panels", () => $8eb6b75af7e82572$export$b94e9de8950563ef);
$parcel$export(module.exports, "IncrementPlanningSettings", () => $8eb6b75af7e82572$export$ad46e765f851721f);
const $8eb6b75af7e82572$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $8eb6b75af7e82572$export$47a1bf8d9994c680 = {
    ISSUE_PARENT_PANEL_SHORTCUT: 'E',
    VERSION_PANEL_SHORTCUT: 'V'
};
const $8eb6b75af7e82572$export$d0f8c009a99b9c1b = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed'
};
const $8eb6b75af7e82572$export$7ee1cf745baadfcd = {
    SIDEBAR: 'sidebar',
    MODAL: 'modal'
};
const $8eb6b75af7e82572$export$70549c4aef7e1632 = {
    PANEL: 'Panel',
    POPUP: 'Popup'
};
const $8eb6b75af7e82572$export$41073ac826c57195 = 'VERSION_PANEL';
const $8eb6b75af7e82572$export$86bfe5c9d2cf6b7c = 'EPIC_PANEL';
const $8eb6b75af7e82572$export$59191afd909777e0 = 'QUICK_FILTERS';
const $8eb6b75af7e82572$export$abd09d2531440e47 = 'COMPACT_MODE';
const $8eb6b75af7e82572$export$f3d7917d25ca2d13 = 'SHOW_EPICS';
const $8eb6b75af7e82572$export$933792f2c41e7c51 = 'SHOW_STATUSES';
const $8eb6b75af7e82572$export$fe0a5eeac8bdee53 = 'SHOW_VERSIONS';
const $8eb6b75af7e82572$export$889dbf130218e8b3 = 'SHOW_ISSUE_LINKS_STATS';
const $8eb6b75af7e82572$export$c3308fa11d994bc5 = 'SHOW_UNSCHEDULED_COLUMN';
const $8eb6b75af7e82572$export$f199de710b228934 = 'SHOW_ISSUE_KEY';
const $8eb6b75af7e82572$export$e8f86e49139c6abb = 'SHOW_ISSUE_TYPE';
const $8eb6b75af7e82572$export$e1f60d3e74825af0 = 'SHOW_ESTIMATE';
const $8eb6b75af7e82572$export$bcfd60da3302536e = 'SHOW_PRIORITY';
const $8eb6b75af7e82572$export$e7b5d3d062c615d5 = 'SHOW_DEVELOPMENT';
const $8eb6b75af7e82572$export$3c14ba0cd46183b = 'SHOW_ASSIGNEE';
const $8eb6b75af7e82572$export$8224ffeed837235e = 'SHOW_DAYS_IN_COLUMN';
const $8eb6b75af7e82572$export$770e28bfe2e0208d = 'SHOW_DUE_DATE';
const $8eb6b75af7e82572$export$63993996bfd99919 = 'SHOW_LABELS';
const $8eb6b75af7e82572$export$b811e8bce70dd7c2 = 'SHOW_CARD_COVERS';
const $8eb6b75af7e82572$export$ecec86e489253c13 = 'SHOW_OFFTRACK_DEPENDENCY_LINES';
const $8eb6b75af7e82572$export$79b3cada7e291288 = 'ISSUE_IDS_TO_SHOW_DEPENDENCIES';
const $8eb6b75af7e82572$export$b94e9de8950563ef = {
    VERSION_PANEL: $8eb6b75af7e82572$export$41073ac826c57195,
    EPIC_PANEL: $8eb6b75af7e82572$export$86bfe5c9d2cf6b7c
};
const $8eb6b75af7e82572$export$ad46e765f851721f = {
    SHOW_UNSCHEDULED_COLUMN: $8eb6b75af7e82572$export$c3308fa11d994bc5,
    SHOW_OFFTRACK_DEPENDENCY_LINES: $8eb6b75af7e82572$export$ecec86e489253c13,
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: $8eb6b75af7e82572$export$79b3cada7e291288
};

});

parcelRegister("kqmep", function(module, exports) {

$parcel$export(module.exports, "CardDetails", () => $17487e014d4eeb0c$export$741386389156bf07);

var $c3qrZ = parcelRequire("c3qrZ");
const $17487e014d4eeb0c$export$741386389156bf07 = {
    SHOW_ISSUE_KEY: $c3qrZ.SHOW_ISSUE_KEY,
    SHOW_ISSUE_TYPE: $c3qrZ.SHOW_ISSUE_TYPE,
    SHOW_EPICS: $c3qrZ.SHOW_EPICS,
    SHOW_STATUSES: $c3qrZ.SHOW_STATUSES,
    SHOW_VERSIONS: $c3qrZ.SHOW_VERSIONS,
    SHOW_ISSUE_LINKS_STATS: $c3qrZ.SHOW_ISSUE_LINKS_STATS,
    SHOW_PRIORITY: $c3qrZ.SHOW_PRIORITY,
    SHOW_DEVELOPMENT: $c3qrZ.SHOW_DEVELOPMENT,
    SHOW_ASSIGNEE: $c3qrZ.SHOW_ASSIGNEE,
    SHOW_ESTIMATE: $c3qrZ.SHOW_ESTIMATE,
    SHOW_DAYS_IN_COLUMN: $c3qrZ.SHOW_DAYS_IN_COLUMN,
    SHOW_DUE_DATE: $c3qrZ.SHOW_DUE_DATE,
    SHOW_LABELS: $c3qrZ.SHOW_LABELS,
    SHOW_CARD_COVERS: $c3qrZ.SHOW_CARD_COVERS
};

});


parcelRegister("8MrYx", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsContainer", () => $40a687938ce25904$export$920204d7413f6fe1);
$parcel$export(module.exports, "useViewSettings", () => $40a687938ce25904$export$704cffd05c51e2b6);
$parcel$export(module.exports, "useViewSettingsActions", () => $40a687938ce25904$export$d6a70239aff099b8);
$parcel$export(module.exports, "useIsFullscreen", () => $40a687938ce25904$export$d397eccea5f37b0a);
$parcel$export(module.exports, "useShowVersionPanel", () => $40a687938ce25904$export$459b400687bc0f20);
$parcel$export(module.exports, "useShowEpicPanel", () => $40a687938ce25904$export$203c9a05aebea04a);
$parcel$export(module.exports, "useShowQuickFilters", () => $40a687938ce25904$export$714ba21e90859f45);
$parcel$export(module.exports, "useShowCompactMode", () => $40a687938ce25904$export$8a591bb42a805814);
$parcel$export(module.exports, "useShowPanels", () => $40a687938ce25904$export$736bfa164a60e240);
$parcel$export(module.exports, "useShowEpics", () => $40a687938ce25904$export$ecaca052f9755b4e);
$parcel$export(module.exports, "useShowVersions", () => $40a687938ce25904$export$10178a1fc177e27a);
$parcel$export(module.exports, "useShowStatuses", () => $40a687938ce25904$export$7a14d92e68e42de1);
$parcel$export(module.exports, "useShowUnscheduledColumn", () => $40a687938ce25904$export$afb23457b0007ce7);
$parcel$export(module.exports, "useShowIssueLinksStats", () => $40a687938ce25904$export$1d584d816be8e0fd);
$parcel$export(module.exports, "useShowAssignee", () => $40a687938ce25904$export$be6bf1e24771efde);
$parcel$export(module.exports, "useShowCardCovers", () => $40a687938ce25904$export$77ff271d002b6f7e);
$parcel$export(module.exports, "useHasCardExtraFields", () => $40a687938ce25904$export$9e1ece2ef34a030);
$parcel$export(module.exports, "useCardFieldsSettings", () => $40a687938ce25904$export$e41d531469117029);
$parcel$export(module.exports, "useShowOfftrackDependencyLines", () => $40a687938ce25904$export$e709b26074f3a4a5);
$parcel$export(module.exports, "useIssueIdsToShowDependencies", () => $40a687938ce25904$export$b6fb171038a9e77e);

var $WBLbN = parcelRequire("WBLbN");

var $jyKDT = parcelRequire("jyKDT");

var $cMFHk = parcelRequire("cMFHk");

var $2R2bz = parcelRequire("2R2bz");
const $40a687938ce25904$var$Store = (0, $WBLbN.createStore)({
    name: 'ViewSettings',
    initialState: $jyKDT.initialState,
    actions: $cMFHk.actions
});
const $40a687938ce25904$export$920204d7413f6fe1 = (0, $WBLbN.createContainer)($40a687938ce25904$var$Store, {
    onInit: (0, $cMFHk.actions).initState
});
const $40a687938ce25904$export$704cffd05c51e2b6 = (0, $WBLbN.createHook)($40a687938ce25904$var$Store);
const $40a687938ce25904$export$d6a70239aff099b8 = (0, $WBLbN.createActionsHook)($40a687938ce25904$var$Store);
const $40a687938ce25904$export$d397eccea5f37b0a = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getIsFullscreen)
});
const $40a687938ce25904$export$459b400687bc0f20 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowVersionPanel)
});
const $40a687938ce25904$export$203c9a05aebea04a = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEpicPanel)
});
const $40a687938ce25904$export$714ba21e90859f45 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowQuickFilters)
});
const $40a687938ce25904$export$8a591bb42a805814 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCompactMode)
});
const $40a687938ce25904$export$736bfa164a60e240 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowPanels)
});
const $40a687938ce25904$export$ecaca052f9755b4e = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEpics)
});
const $40a687938ce25904$export$10178a1fc177e27a = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowVersions)
});
const $40a687938ce25904$export$7a14d92e68e42de1 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowStatuses)
});
const $40a687938ce25904$export$afb23457b0007ce7 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowUnscheduledColumn)
});
const $40a687938ce25904$export$1d584d816be8e0fd = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueLinksStats)
});
const $40a687938ce25904$export$c94c02788702c7e4 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueType)
});
const $40a687938ce25904$export$8007ae8b25a75629 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueKey)
});
const $40a687938ce25904$export$75223d65852dc3c0 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowPriority)
});
const $40a687938ce25904$export$eac20fb60c7f35ac = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowDevelopment)
});
const $40a687938ce25904$export$be6bf1e24771efde = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowAssignee)
});
const $40a687938ce25904$export$b5a76590347456cc = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEstimate)
});
const $40a687938ce25904$export$5e8e69c97a3cd45b = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCardExtraField)
});
const $40a687938ce25904$export$a53839ab3a916ce3 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowDaysInColumn)
});
const $40a687938ce25904$export$77ff271d002b6f7e = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCardCovers)
});
const $40a687938ce25904$export$9e1ece2ef34a030 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getHasCardExtraFields)
});
const $40a687938ce25904$export$e41d531469117029 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getCardFieldsSettings)
});
const $40a687938ce25904$export$e709b26074f3a4a5 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowOfftrackDependencyLines)
});
const $40a687938ce25904$export$b6fb171038a9e77e = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getIssueIdsToShowDependencies)
});

});
parcelRegister("jyKDT", function(module, exports) {

$parcel$export(module.exports, "VIEW_SETTINGS", () => $d03619c6ca5a0718$export$f900da9acbf1ac33);
$parcel$export(module.exports, "VIEW_SETTINGS_LOCAL_STORAGE", () => $d03619c6ca5a0718$export$752f3d44db2fbd2d);
$parcel$export(module.exports, "initialState", () => $d03619c6ca5a0718$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "boardViewTestIds", () => $d03619c6ca5a0718$export$9cf6a064d9c55597);
$parcel$export(module.exports, "backlogViewTestIds", () => $d03619c6ca5a0718$export$af828cca0407ed81);
$parcel$export(module.exports, "VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID", () => $d03619c6ca5a0718$export$b954e2c30216a1e9);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_LG", () => $d03619c6ca5a0718$export$20070c180403c06a);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_SM", () => $d03619c6ca5a0718$export$563c80e8ea5620c4);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_RESPONSIVE", () => $d03619c6ca5a0718$export$3895498dfef21366);
$parcel$export(module.exports, "QUERY_ENABLED_VALUE", () => $d03619c6ca5a0718$export$c0d46007b8549aca);
const $d03619c6ca5a0718$export$f900da9acbf1ac33 = 'view-settings';
const $d03619c6ca5a0718$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $d03619c6ca5a0718$export$d4c72bab9d6cc13a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDevelopment: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: false,
    showOfftrackDependencyLines: false,
    issueIdsToShowDependencies: [],
    cardExtraFields: {}
};
const $d03619c6ca5a0718$export$9cf6a064d9c55597 = {
    viewSettingsBoardMenu: 'software-view-settings.ui.view-settings-menu.menu-board',
    openIssuesInSidebarToggle: 'software-view-settings.ui.view-settings-menu.views.board.open-issues-in-sidebar',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-quick-filters-toggle',
    showWorkSuggestionsToggle: 'software-view-settings.ui.view-settings-menu.views.board.work-suggestions-toggle',
    swimlaneExpandAll: 'software-view-settings.ui.view-settings-menu.views.board.expand-all',
    swimlaneCollapseAll: 'software-view-settings.ui.view-settings-menu.views.board.collapse-all',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.board.card-details-board',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-type-toggle-board',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-key-toggle-board',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-epics-toggle-board',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.board.due-date-toggle-board',
    showLabelsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-labels-toggle-board',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-estimate-toggle-board',
    showDaysInColumnToggle: 'software-view-settings.ui.view-settings-menu.views.board.days-in-column-toggle-board',
    showLinkedIssueStatsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-linked-issue-stats-toggle-board',
    showCardCoversToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-card-covers-toggle-board',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-priority-toggle-board',
    showDevelopmentToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-development-toggle-board',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-assignee-toggle-board',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.board.custom-fields-board'
};
const $d03619c6ca5a0718$export$af828cca0407ed81 = {
    showVersionPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-version-panel-toggle',
    showEpicPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epic-panel-toggle',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-quick-filters-toggle',
    cardLayoutSection: 'software-view-settings.view-settings-menu.card-layout',
    cardLayoutRadioGroup: 'software-view-settings.ui.view-settings-menu.views.backlog.card-layout',
    showCompactModeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-compact-mode-toggle',
    subtaskSection: 'software-view-settings.view-settings-menu.subtasks',
    subtaskExpandAll: 'software-view-settings.ui.view-settings-menu.views.backlog.expand-all-subtasks',
    subtaskCollapseAll: 'software-view-settings.ui.view-settings-menu.views.backlog.collapse-all-subtasks',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.card-details-backlog',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-type-toggle-backlog',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-key-toggle-backlog',
    showVersionsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-versions-toggle-backlog',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epics-toggle-backlog',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.due-date-toggle-backlog',
    showStatusToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-statuses-toggle-backlog',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-estimate-toggle-backlog',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-priority-toggle-backlog',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-assignee-toggle-backlog',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.custom-fields-backlog'
};
const $d03619c6ca5a0718$export$b954e2c30216a1e9 = 'view-settings.ui.panel.header.close-button';
const $d03619c6ca5a0718$export$20070c180403c06a = 'view-settings-show-button.ui.view-settings-button-large';
const $d03619c6ca5a0718$export$563c80e8ea5620c4 = 'view-settings-show-button.ui.view-settings-button-small';
const $d03619c6ca5a0718$export$3895498dfef21366 = 'view-settings-show-button.ui.view-settings-button-responsive';
const $d03619c6ca5a0718$export$c0d46007b8549aca = 'on';
const $d03619c6ca5a0718$export$788a94e8107fb947 = 'off';

});

parcelRegister("cMFHk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $09be8f99c8e5e595$export$e324594224ef24da);

var $4E7nZ = parcelRequire("4E7nZ");
const $09be8f99c8e5e595$export$e324594224ef24da = {
    setViewSettings: $4E7nZ.setViewSettings,
    setIsFullscreen: $4E7nZ.setIsFullscreen,
    setViewSettingsPanels: $4E7nZ.setViewSettingsPanels,
    setViewSettingsQuickFilters: $4E7nZ.setViewSettingsQuickFilters,
    setViewSettingsCardDetails: $4E7nZ.setViewSettingsCardDetails,
    setViewSettingsCardExtraFields: $4E7nZ.setViewSettingsCardExtraFields,
    setViewSettingsCompactMode: $4E7nZ.setViewSettingsCompactMode,
    setShowUnscheduledColumn: $4E7nZ.setShowUnscheduledColumn,
    setShowOfftrackDependencyLines: $4E7nZ.setShowOfftrackDependencyLines,
    setIssueIdsToShowDependencies: $4E7nZ.setIssueIdsToShowDependencies,
    setViewSettingsShowCardCovers: $4E7nZ.setViewSettingsShowCardCovers,
    toggleViewSetting: $4E7nZ.toggleViewSetting,
    toggleShowEpics: $4E7nZ.toggleShowEpics,
    toggleShowVersions: $4E7nZ.toggleShowVersions,
    toggleShowStatuses: $4E7nZ.toggleShowStatuses,
    toggleShowLinkedIssuesStats: $4E7nZ.toggleShowLinkedIssuesStats,
    toggleExtraField: $4E7nZ.toggleExtraField,
    toggleShowDaysInColumn: $4E7nZ.toggleShowDaysInColumn,
    toggleShowDueDate: $4E7nZ.toggleShowDueDate,
    toggleShowLabels: $4E7nZ.toggleShowLabels,
    initState: $4E7nZ.initState
};

});
parcelRegister("4E7nZ", function(module, exports) {

$parcel$export(module.exports, "initState", () => $b676a0d483ac8166$export$f6196a6c6bb539b4);
$parcel$export(module.exports, "setViewSettings", () => $b676a0d483ac8166$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setIsFullscreen", () => $b676a0d483ac8166$export$9c73b2f282069160);
$parcel$export(module.exports, "setViewSettingsPanels", () => $b676a0d483ac8166$export$427f126b21640252);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $b676a0d483ac8166$export$60d0caf3b1c59159);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $b676a0d483ac8166$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $b676a0d483ac8166$export$af2e5a35023755b5);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $b676a0d483ac8166$export$b54537ba70def946);
$parcel$export(module.exports, "setViewSettingsShowCardCovers", () => $b676a0d483ac8166$export$d166622a8f3a93f0);
$parcel$export(module.exports, "toggleViewSetting", () => $b676a0d483ac8166$export$779d9a10b8826796);
$parcel$export(module.exports, "toggleShowEpics", () => $b676a0d483ac8166$export$c1bb93dcfa07c797);
$parcel$export(module.exports, "toggleShowVersions", () => $b676a0d483ac8166$export$582a65f6c8cb93ab);
$parcel$export(module.exports, "toggleShowStatuses", () => $b676a0d483ac8166$export$ac311ca7d5df1d03);
$parcel$export(module.exports, "toggleShowLinkedIssuesStats", () => $b676a0d483ac8166$export$580abda923c30dc5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $b676a0d483ac8166$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "toggleShowDaysInColumn", () => $b676a0d483ac8166$export$2849cc68d8e521b7);
$parcel$export(module.exports, "toggleShowDueDate", () => $b676a0d483ac8166$export$ef2b1a307fba6e8a);
$parcel$export(module.exports, "toggleShowLabels", () => $b676a0d483ac8166$export$229260fb852e61e0);
$parcel$export(module.exports, "toggleExtraField", () => $b676a0d483ac8166$export$6acb0c83c20a20);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $b676a0d483ac8166$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $b676a0d483ac8166$export$f7b68cb584e33d77);

var $3kYjh = parcelRequire("3kYjh");

var $cNacc = parcelRequire("cNacc");
const $b676a0d483ac8166$export$f6196a6c6bb539b4 = ()=>({ setState: setState }, { view: view })=>{
        setState({
            view: view
        });
    };
const $b676a0d483ac8166$export$99f2d9eb0b41b93 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $b676a0d483ac8166$export$9c73b2f282069160 = ({ boardId: boardId, view: view, isFullscreen: isFullscreen })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreen,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            isFullscreen: isFullscreen
        });
    };
const $b676a0d483ac8166$export$427f126b21640252 = ({ boardId: boardId, view: view, panelState: panelState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsPanels({
            boardId: boardId,
            panelState: panelState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpicPanel: panelState.EPIC_PANEL,
            showVersionPanel: panelState.VERSION_PANEL
        });
    };
const $b676a0d483ac8166$export$60d0caf3b1c59159 = ({ boardId: boardId, view: view, showQuickFilters: showQuickFilters })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsQuickFilters({
            boardId: boardId,
            showQuickFilters: showQuickFilters,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showQuickFilters: showQuickFilters
        });
    };
const $b676a0d483ac8166$export$9ca6e4490ca9b1fc = ({ boardId: boardId, view: view, showCompactMode: showCompactMode })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCompactMode({
            boardId: boardId,
            showCompactMode: showCompactMode,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showCompactMode: showCompactMode
        });
    };
const $b676a0d483ac8166$export$af2e5a35023755b5 = ({ boardId: boardId, view: view, cardDetailsState: cardDetailsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCardDetails({
            boardId: boardId,
            cardDetailsState: cardDetailsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: cardDetailsState.SHOW_EPICS,
            showVersions: cardDetailsState.SHOW_VERSIONS,
            showStatuses: cardDetailsState.SHOW_STATUSES,
            showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
            showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
            showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
            showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
            showEstimate: cardDetailsState.SHOW_ESTIMATE,
            showPriority: cardDetailsState.SHOW_PRIORITY,
            showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
            showAssignee: cardDetailsState.SHOW_ASSIGNEE,
            showDueDate: cardDetailsState.SHOW_DUE_DATE,
            showLabels: cardDetailsState.SHOW_LABELS,
            showCardCovers: cardDetailsState.SHOW_CARD_COVERS
        });
    };
const $b676a0d483ac8166$export$b54537ba70def946 = ({ boardId: boardId, view: view, cardExtraFieldsState: cardExtraFieldsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: cardExtraFieldsState
        });
    };
const $b676a0d483ac8166$export$d166622a8f3a93f0 = ({ boardId: boardId, view: view, showCardCovers: showCardCovers })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const newState = {
            ...currentSettings,
            showCardCovers: showCardCovers
        };
        $cNacc.setViewSettings({
            boardId: boardId,
            state: newState,
            view: view || currentSettings.view || undefined
        });
        setState(newState);
    };
const $b676a0d483ac8166$export$779d9a10b8826796 = ({ boardId: boardId, view: view, setting: setting })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const set = (newState)=>{
            setState(newState);
            $cNacc.setViewSettings({
                boardId: boardId,
                state: newState,
                view: view || currentSettings.view || undefined
            });
        };
        switch(setting){
            case (0, $3kYjh.ViewSetting).VERSION_PANEL:
                set({
                    ...currentSettings,
                    showVersionPanel: !currentSettings.showVersionPanel
                });
                break;
            case (0, $3kYjh.ViewSetting).EPIC_PANEL:
                set({
                    ...currentSettings,
                    showEpicPanel: !currentSettings.showEpicPanel
                });
                break;
            case (0, $3kYjh.ViewSetting).QUICK_FILTERS:
                set({
                    ...currentSettings,
                    showQuickFilters: !currentSettings.showQuickFilters
                });
                break;
            case (0, $3kYjh.ViewSetting).COMPACT_MODE:
                set({
                    ...currentSettings,
                    showCompactMode: !currentSettings.showCompactMode
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_EPICS:
                set({
                    ...currentSettings,
                    showEpics: !currentSettings.showEpics
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_STATUSES:
                set({
                    ...currentSettings,
                    showStatuses: !currentSettings.showStatuses
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_VERSIONS:
                set({
                    ...currentSettings,
                    showVersions: !currentSettings.showVersions
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_UNSCHEDULED_COLUMN:
                set({
                    ...currentSettings,
                    showUnscheduledColumn: !currentSettings.showUnscheduledColumn
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ISSUE_KEY:
                set({
                    ...currentSettings,
                    showIssueKey: !currentSettings.showIssueKey
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ISSUE_TYPE:
                set({
                    ...currentSettings,
                    showIssueType: !currentSettings.showIssueType
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_PRIORITY:
                set({
                    ...currentSettings,
                    showPriority: !currentSettings.showPriority
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_DEVELOPMENT:
                set({
                    ...currentSettings,
                    showDevelopment: !currentSettings.showDevelopment
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ASSIGNEE:
                set({
                    ...currentSettings,
                    showAssignee: !currentSettings.showAssignee
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ESTIMATE:
                set({
                    ...currentSettings,
                    showEstimate: !currentSettings.showEstimate
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_DAYS_IN_COLUMN:
                set({
                    ...currentSettings,
                    showDaysInColumn: !currentSettings.showDaysInColumn
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_DUE_DATE:
                set({
                    ...currentSettings,
                    showDueDate: !currentSettings.showDueDate
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_LABELS:
                set({
                    ...currentSettings,
                    showLabels: !currentSettings.showLabels
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_CARD_COVERS:
                set({
                    ...currentSettings,
                    showCardCovers: !currentSettings.showCardCovers
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_OFFTRACK_DEPENDENCY_LINES:
                set({
                    ...currentSettings,
                    showOfftrackDependencyLines: !currentSettings.showOfftrackDependencyLines
                });
                break;
            default:
                break;
        }
    };
const $b676a0d483ac8166$export$c1bb93dcfa07c797 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowEpics({
            boardId: boardId,
            showEpics: !currentSettings.showEpics,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: !currentSettings.showEpics
        });
    };
const $b676a0d483ac8166$export$582a65f6c8cb93ab = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowVersions({
            boardId: boardId,
            showVersions: !currentSettings.showVersions,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showVersions: !currentSettings.showVersions
        });
    };
const $b676a0d483ac8166$export$ac311ca7d5df1d03 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowStatuses({
            boardId: boardId,
            showStatuses: !currentSettings.showStatuses,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showStatuses: !currentSettings.showStatuses
        });
    };
const $b676a0d483ac8166$export$580abda923c30dc5 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowIssueLinksStats({
            boardId: boardId,
            showIssueLinksStats: !currentSettings.showIssueLinksStats,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showIssueLinksStats: !currentSettings.showIssueLinksStats
        });
    };
const $b676a0d483ac8166$export$6edce735c6eb4cb0 = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowUnscheduledColumn({
            boardId: boardId,
            showUnscheduledColumn: isVisible
        });
        setState({
            ...currentSettings,
            showUnscheduledColumn: isVisible
        });
    };
const $b676a0d483ac8166$export$2849cc68d8e521b7 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowDaysInColumn({
            boardId: boardId,
            showDaysInColumn: !currentSettings.showDaysInColumn,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDaysInColumn: !currentSettings.showDaysInColumn
        });
    };
const $b676a0d483ac8166$export$ef2b1a307fba6e8a = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowDueDate({
            boardId: boardId,
            showDueDate: !currentSettings.showDueDate,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDueDate: !currentSettings.showDueDate
        });
    };
const $b676a0d483ac8166$export$229260fb852e61e0 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowLabels({
            boardId: boardId,
            showLabels: !currentSettings.showLabels,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showLabels: !currentSettings.showLabels
        });
    };
const $b676a0d483ac8166$export$6acb0c83c20a20 = ({ boardId: boardId, view: view, fieldId: fieldId })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const currentExtraFields = currentSettings.cardExtraFields;
        $cNacc.setExtraFields({
            boardId: boardId,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            },
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            }
        });
    };
const $b676a0d483ac8166$export$2c48063cd4ef1ade = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowOfftrackDependencyLines({
            boardId: boardId,
            showOfftrackDependencyLines: isVisible
        });
        setState({
            ...currentSettings,
            showOfftrackDependencyLines: isVisible
        });
    };
const $b676a0d483ac8166$export$f7b68cb584e33d77 = (boardId, issueIds)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setIssueIdsToShowDependencies({
            boardId: boardId,
            issueIds: issueIds
        });
        setState({
            ...currentSettings,
            issueIdsToShowDependencies: issueIds
        });
    };

});
parcelRegister("cNacc", function(module, exports) {

$parcel$export(module.exports, "getViewSettings", () => $168332c15e8ca043$export$3ae70db4a97563c);
$parcel$export(module.exports, "setViewSettingsIsFullscreen", () => $168332c15e8ca043$export$322210075289ef56);
$parcel$export(module.exports, "getViewSettingsIsFullscreen", () => $168332c15e8ca043$export$d2c8042121049ae8);
$parcel$export(module.exports, "getViewSettingsPanels", () => $168332c15e8ca043$export$d6a5a0d616fcec93);
$parcel$export(module.exports, "setViewSettings", () => $168332c15e8ca043$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setViewSettingsPanels", () => $168332c15e8ca043$export$427f126b21640252);
$parcel$export(module.exports, "getViewSettingsQuickFilters", () => $168332c15e8ca043$export$18eb87e1feb49f18);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $168332c15e8ca043$export$60d0caf3b1c59159);
$parcel$export(module.exports, "getViewSettingsCompactMode", () => $168332c15e8ca043$export$658ed39e1ffe75b);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $168332c15e8ca043$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "getViewSettingsCardDetails", () => $168332c15e8ca043$export$a2a95ab43ea98277);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $168332c15e8ca043$export$af2e5a35023755b5);
$parcel$export(module.exports, "getViewSettingsCardExtraFields", () => $168332c15e8ca043$export$6a2173913af81755);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $168332c15e8ca043$export$b54537ba70def946);
$parcel$export(module.exports, "setShowEpics", () => $168332c15e8ca043$export$294c0e262bd1285a);
$parcel$export(module.exports, "setShowVersions", () => $168332c15e8ca043$export$a3ab3e2c6a6189bd);
$parcel$export(module.exports, "setShowStatuses", () => $168332c15e8ca043$export$e95c7c8d7cbf6350);
$parcel$export(module.exports, "setShowIssueLinksStats", () => $168332c15e8ca043$export$163e0dded7eda9d9);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $168332c15e8ca043$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $168332c15e8ca043$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "setShowDaysInColumn", () => $168332c15e8ca043$export$68382c1a767b0133);
$parcel$export(module.exports, "setShowDueDate", () => $168332c15e8ca043$export$13fed6c54275816a);
$parcel$export(module.exports, "setShowLabels", () => $168332c15e8ca043$export$43aa76b69739d220);
$parcel$export(module.exports, "setExtraFields", () => $168332c15e8ca043$export$b24e660e664a6bba);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $168332c15e8ca043$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $168332c15e8ca043$export$32c01395d25dfdcc);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $168332c15e8ca043$export$f7b68cb584e33d77);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $168332c15e8ca043$export$67e6bba1326e537a);

var $aZaPn = parcelRequire("aZaPn");

var $jyKDT = parcelRequire("jyKDT");

var $c3qrZ = parcelRequire("c3qrZ");

var $6eyW6 = parcelRequire("6eyW6");
const $168332c15e8ca043$var$browserLocalStorage = (0, $aZaPn.createLocalStorageProvider)((0, $jyKDT.VIEW_SETTINGS_LOCAL_STORAGE));
const $168332c15e8ca043$export$36e24695f02d4503 = (view)=>{
    if (view && view === (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD) return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).INCREMENT_PLANNING_BOARD}`;
    if ((0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD:
            return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).INCREMENT_PLANNING_BOARD}`;
        case (0, $c3qrZ.View).BACKLOG:
            return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).BACKLOG}`;
        case (0, $c3qrZ.View).BOARD:
            return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).BOARD}`;
        case (0, $c3qrZ.View).JSM_BOARD:
            return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).JSM_BOARD}`;
        default:
            return 0, $jyKDT.VIEW_SETTINGS;
    }
    return 0, $jyKDT.VIEW_SETTINGS;
};
const $168332c15e8ca043$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>$168332c15e8ca043$var$browserLocalStorage.get(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`) || $168332c15e8ca043$var$browserLocalStorage.get(`${(0, $jyKDT.VIEW_SETTINGS)}-${boardId}`); // return legacy view settings if prefixed storage doesn't exist
const $168332c15e8ca043$export$322210075289ef56 = ({ boardId: boardId, isFullscreen: isFullscreen, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        isFullscreen: isFullscreen
    });
};
const $168332c15e8ca043$export$d2c8042121049ae8 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.isFullscreen ?? (0, $jyKDT.initialState).isFullscreen;
};
const $168332c15e8ca043$export$d6a5a0d616fcec93 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        EPIC_PANEL: state?.showEpicPanel ?? (0, $jyKDT.initialState).showEpicPanel,
        VERSION_PANEL: state?.showVersionPanel ?? (0, $jyKDT.initialState).showVersionPanel
    };
};
const $168332c15e8ca043$export$99f2d9eb0b41b93 = ({ boardId: boardId, state: state, view: view })=>$168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, state);
const $168332c15e8ca043$export$427f126b21640252 = ({ boardId: boardId, panelState: panelState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: panelState.EPIC_PANEL,
        showVersionPanel: panelState.VERSION_PANEL
    });
};
const $168332c15e8ca043$export$7a001fa75693814b = ({ boardId: boardId, panel: panel, show: show, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    if (panel === (0, $c3qrZ.Panels).EPIC_PANEL) $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: show
    });
    if (panel === (0, $c3qrZ.Panels).VERSION_PANEL) $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersionPanel: show
    });
};
const $168332c15e8ca043$export$18eb87e1feb49f18 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showQuickFilters ?? (0, $jyKDT.initialState).showQuickFilters;
};
const $168332c15e8ca043$export$60d0caf3b1c59159 = ({ boardId: boardId, showQuickFilters: showQuickFilters, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showQuickFilters: showQuickFilters
    });
};
const $168332c15e8ca043$export$658ed39e1ffe75b = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showCompactMode ?? (0, $jyKDT.initialState).showCompactMode;
};
const $168332c15e8ca043$export$9ca6e4490ca9b1fc = ({ boardId: boardId, showCompactMode: showCompactMode, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCompactMode: showCompactMode
    });
};
const $168332c15e8ca043$export$a2a95ab43ea98277 = ({ boardId: boardId, view: view, isDaysInColumnEnabled: isDaysInColumnEnabled, isDueDateEnabled: isDueDateEnabled, isLabelsEnabled: isLabelsEnabled, isEstimateEnabled: isEstimateEnabled, isPriorityEnabled: isPriorityEnabled })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        SHOW_EPICS: state?.showEpics ?? (0, $jyKDT.initialState).showEpics,
        SHOW_STATUSES: state?.showStatuses ?? (0, $jyKDT.initialState).showStatuses,
        SHOW_VERSIONS: state?.showVersions ?? (0, $jyKDT.initialState).showVersions,
        SHOW_ISSUE_LINKS_STATS: state?.showIssueLinksStats ?? (0, $jyKDT.initialState).showIssueLinksStats,
        SHOW_ISSUE_KEY: state?.showIssueKey ?? (0, $jyKDT.initialState).showIssueKey,
        SHOW_ISSUE_TYPE: state?.showIssueType ?? (0, $jyKDT.initialState).showIssueType,
        SHOW_ASSIGNEE: state?.showAssignee ?? (0, $jyKDT.initialState).showAssignee,
        SHOW_PRIORITY: (isPriorityEnabled ? state?.showPriority : (0, $jyKDT.initialState).showPriority) ?? (0, $jyKDT.initialState).showPriority,
        SHOW_DEVELOPMENT: state?.showDevelopment ?? (0, $jyKDT.initialState).showDevelopment,
        SHOW_ESTIMATE: (isEstimateEnabled ? state?.showEstimate : (0, $jyKDT.initialState).showEstimate) ?? (0, $jyKDT.initialState).showEstimate,
        SHOW_DAYS_IN_COLUMN: (isDaysInColumnEnabled ? state?.showDaysInColumn : (0, $jyKDT.initialState).showDaysInColumn) ?? (0, $jyKDT.initialState).showDaysInColumn,
        SHOW_DUE_DATE: (isDueDateEnabled ? state?.showDueDate : (0, $jyKDT.initialState).showDueDate) ?? (0, $jyKDT.initialState).showDueDate,
        SHOW_LABELS: (isLabelsEnabled ? state?.showLabels : (0, $jyKDT.initialState).showLabels) ?? (0, $jyKDT.initialState).showLabels,
        SHOW_CARD_COVERS: state?.showCardCovers ?? (0, $jyKDT.initialState).showCardCovers
    };
};
const $168332c15e8ca043$export$af2e5a35023755b5 = ({ boardId: boardId, cardDetailsState: cardDetailsState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: cardDetailsState.SHOW_EPICS,
        showStatuses: cardDetailsState.SHOW_STATUSES,
        showVersions: cardDetailsState.SHOW_VERSIONS,
        showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
        showEstimate: cardDetailsState.SHOW_ESTIMATE,
        showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
        showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
        showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
        showAssignee: cardDetailsState.SHOW_ASSIGNEE,
        showPriority: cardDetailsState.SHOW_PRIORITY,
        showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
        showDueDate: cardDetailsState.SHOW_DUE_DATE,
        showLabels: cardDetailsState.SHOW_LABELS,
        showCardCovers: cardDetailsState.SHOW_CARD_COVERS
    });
};
const $168332c15e8ca043$export$6a2173913af81755 = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return cardExtraFields.reduce((acc, field)=>{
        acc[field.id] = state?.cardExtraFields?.[field.id] ?? true;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $168332c15e8ca043$export$b54537ba70def946 = ({ boardId: boardId, cardExtraFieldsState: cardExtraFieldsState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFieldsState
    });
};
const $168332c15e8ca043$export$294c0e262bd1285a = ({ boardId: boardId, showEpics: showEpics, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: showEpics
    });
};
const $168332c15e8ca043$export$a3ab3e2c6a6189bd = ({ boardId: boardId, showVersions: showVersions, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersions: showVersions
    });
};
const $168332c15e8ca043$export$e95c7c8d7cbf6350 = ({ boardId: boardId, showStatuses: showStatuses, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showStatuses: showStatuses
    });
};
const $168332c15e8ca043$export$163e0dded7eda9d9 = ({ boardId: boardId, showIssueLinksStats: showIssueLinksStats, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showIssueLinksStats: showIssueLinksStats
    });
};
const $168332c15e8ca043$export$6edce735c6eb4cb0 = ({ boardId: boardId, showUnscheduledColumn: showUnscheduledColumn })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503((0, $c3qrZ.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showUnscheduledColumn: showUnscheduledColumn
    });
};
const $168332c15e8ca043$export$bf31a7b99f7bc62f = (boardId)=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showUnscheduledColumn ?? (0, $jyKDT.initialState).showUnscheduledColumn;
};
const $168332c15e8ca043$export$68382c1a767b0133 = ({ boardId: boardId, showDaysInColumn: showDaysInColumn, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDaysInColumn: showDaysInColumn
    });
};
const $168332c15e8ca043$export$13fed6c54275816a = ({ boardId: boardId, showDueDate: showDueDate, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDueDate: showDueDate
    });
};
const $168332c15e8ca043$export$43aa76b69739d220 = ({ boardId: boardId, showLabels: showLabels, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showLabels: showLabels
    });
};
const $168332c15e8ca043$export$b24e660e664a6bba = ({ boardId: boardId, cardExtraFields: cardExtraFields, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFields
    });
};
const $168332c15e8ca043$export$90df0703e41f9b = ({ boardId: boardId, showCardCovers: showCardCovers, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCardCovers: showCardCovers
    });
};
const $168332c15e8ca043$export$2c48063cd4ef1ade = ({ boardId: boardId, showOfftrackDependencyLines: showOfftrackDependencyLines })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503((0, $c3qrZ.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showOfftrackDependencyLines: showOfftrackDependencyLines
    });
};
const $168332c15e8ca043$export$32c01395d25dfdcc = (boardId)=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showOfftrackDependencyLines ?? (0, $jyKDT.initialState).showOfftrackDependencyLines;
};
const $168332c15e8ca043$export$f7b68cb584e33d77 = ({ boardId: boardId, issueIds: issueIds })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503((0, $c3qrZ.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        issueIdsToShowDependencies: issueIds
    });
};
const $168332c15e8ca043$export$67e6bba1326e537a = (boardId)=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    return state?.issueIdsToShowDependencies ?? (0, $jyKDT.initialState).issueIdsToShowDependencies;
};

});
parcelRegister("6eyW6", function(module, exports) {

$parcel$export(module.exports, "parseSearchQuery", () => $e52899f32986aa87$export$6298490de4ddc3eb);
$parcel$export(module.exports, "setPanels", () => $e52899f32986aa87$export$d89c07c704083e54);
$parcel$export(module.exports, "parseSearchQueryForIPBoard", () => $e52899f32986aa87$export$442a6f7c9ee1c18a);
$parcel$export(module.exports, "setIncrementPlanningSettingsQuery", () => $e52899f32986aa87$export$8bc567645273ba46);
$parcel$export(module.exports, "isViewSettingsPanelAndTailoredViewExperimentEnabled", () => $e52899f32986aa87$export$eed360eb853808ee);

var $6HC1D = parcelRequire("6HC1D");

var $53ciZ = parcelRequire("53ciZ");

var $eI5EY = parcelRequire("eI5EY");

const $e52899f32986aa87$export$6298490de4ddc3eb = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
    return {
        EPIC_PANEL: searchParams[0, $737beaccda042ec2$export$ec3c43b997309252] === 'visible',
        VERSION_PANEL: searchParams[0, $737beaccda042ec2$export$a86c1a6dde9da34f] === 'visible'
    };
};
const $e52899f32986aa87$export$d89c07c704083e54 = (panels, location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    search.unset((0, $737beaccda042ec2$export$ec3c43b997309252));
    search.unset((0, $737beaccda042ec2$export$a86c1a6dde9da34f));
    if (panels.EPIC_PANEL) search.set((0, $737beaccda042ec2$export$ec3c43b997309252), 'visible');
    if (panels.VERSION_PANEL) search.set((0, $737beaccda042ec2$export$a86c1a6dde9da34f), 'visible');
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};
const $e52899f32986aa87$export$442a6f7c9ee1c18a = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
    if (!(0, $eI5EY.fg)('dependency_visualisation_program_board_fe_and_be')) return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $737beaccda042ec2$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: false,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: []
    };
    const issuesQuery = searchParams[0, $737beaccda042ec2$export$1692762d83d78f09] ? decodeURIComponent(searchParams[0, $737beaccda042ec2$export$1692762d83d78f09]) : undefined;
    const issuesSplit = issuesQuery ? issuesQuery.split(',') : [];
    const issueIdsToShowDependencies = [];
    issuesSplit.forEach((issueId)=>{
        const trimmedIssueId = issueId.trim();
        if (trimmedIssueId.length) issueIdsToShowDependencies.push(trimmedIssueId);
    });
    return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $737beaccda042ec2$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: searchParams[0, $737beaccda042ec2$export$8b0819c4fa234ad] === 'visible' ? true : undefined,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
    };
};
const $e52899f32986aa87$export$8bc567645273ba46 = (incrementPlanningSettings, location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    search.unset((0, $737beaccda042ec2$export$bfa26a3d2f080ac5));
    if (!incrementPlanningSettings.SHOW_UNSCHEDULED_COLUMN) search.set((0, $737beaccda042ec2$export$bfa26a3d2f080ac5), 'hidden');
    if ((0, $eI5EY.fg)('dependency_visualisation_program_board_fe_and_be')) {
        search.unset((0, $737beaccda042ec2$export$8b0819c4fa234ad));
        search.unset((0, $737beaccda042ec2$export$1692762d83d78f09));
        if (incrementPlanningSettings.SHOW_OFFTRACK_DEPENDENCY_LINES) search.set((0, $737beaccda042ec2$export$8b0819c4fa234ad), 'visible');
        if (incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES && incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length) search.set((0, $737beaccda042ec2$export$1692762d83d78f09), encodeURIComponent(incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.toString()));
    }
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};
const $e52899f32986aa87$export$eed360eb853808ee = ()=>(0, $eI5EY.fg)('jira_view_settings_additional_fields');

});
const $737beaccda042ec2$export$ec3c43b997309252 = 'epics';
const $737beaccda042ec2$export$a86c1a6dde9da34f = 'versions';
const $737beaccda042ec2$export$bfa26a3d2f080ac5 = 'unscheduledWork';
const $737beaccda042ec2$export$8b0819c4fa234ad = 'showOfftrackDependencyLines';
const $737beaccda042ec2$export$1692762d83d78f09 = 'issueIdsToShowDependencies';





parcelRegister("2R2bz", function(module, exports) {

$parcel$export(module.exports, "getIsFullscreen", () => $0824ef21329004e5$export$b061161f83abaf15);
$parcel$export(module.exports, "getShowVersionPanel", () => $0824ef21329004e5$export$cdf1158c8123d31c);
$parcel$export(module.exports, "getShowEpicPanel", () => $0824ef21329004e5$export$fc9a39e5c1906367);
$parcel$export(module.exports, "getShowQuickFilters", () => $0824ef21329004e5$export$732caa9fcae1c5ff);
$parcel$export(module.exports, "getShowCompactMode", () => $0824ef21329004e5$export$72bae49530cc02bb);
$parcel$export(module.exports, "getShowPanels", () => $0824ef21329004e5$export$e2483fb3e0d0ff4b);
$parcel$export(module.exports, "getShowEpics", () => $0824ef21329004e5$export$b631ebb4887e6060);
$parcel$export(module.exports, "getShowVersions", () => $0824ef21329004e5$export$2cb6de520195dbf5);
$parcel$export(module.exports, "getShowStatuses", () => $0824ef21329004e5$export$b5f1c34af9498ea);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $0824ef21329004e5$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "getShowIssueLinksStats", () => $0824ef21329004e5$export$266785c43d094472);
$parcel$export(module.exports, "getShowIssueType", () => $0824ef21329004e5$export$a079b5f709c4d237);
$parcel$export(module.exports, "getShowIssueKey", () => $0824ef21329004e5$export$cb710ef8b1ccd94b);
$parcel$export(module.exports, "getShowPriority", () => $0824ef21329004e5$export$5abfbf16fb2cec7b);
$parcel$export(module.exports, "getShowDevelopment", () => $0824ef21329004e5$export$d89a1b3e54af627e);
$parcel$export(module.exports, "getShowAssignee", () => $0824ef21329004e5$export$ad1a6d247a05049d);
$parcel$export(module.exports, "getShowEstimate", () => $0824ef21329004e5$export$d21c0b83591460c9);
$parcel$export(module.exports, "getShowCardExtraField", () => $0824ef21329004e5$export$7549550e839e6e0c);
$parcel$export(module.exports, "getShowDaysInColumn", () => $0824ef21329004e5$export$9a608cd91e68c95c);
$parcel$export(module.exports, "getShowCardCovers", () => $0824ef21329004e5$export$983376245b8547dc);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $0824ef21329004e5$export$32c01395d25dfdcc);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $0824ef21329004e5$export$67e6bba1326e537a);
$parcel$export(module.exports, "getCardFieldsSettings", () => $0824ef21329004e5$export$e9dfc10bd434fabb);
$parcel$export(module.exports, "getHasCardExtraFields", () => $0824ef21329004e5$export$1e24fae4497ff7e0);
const $0824ef21329004e5$export$b061161f83abaf15 = (state)=>state.isFullscreen;
const $0824ef21329004e5$export$cdf1158c8123d31c = (state)=>state.showVersionPanel;
const $0824ef21329004e5$export$fc9a39e5c1906367 = (state)=>state.showEpicPanel;
const $0824ef21329004e5$export$732caa9fcae1c5ff = (state)=>state.showQuickFilters;
const $0824ef21329004e5$export$72bae49530cc02bb = (state)=>state.showCompactMode;
const $0824ef21329004e5$export$e2483fb3e0d0ff4b = (state)=>({
        EPIC_PANEL: state.showEpicPanel,
        VERSION_PANEL: state.showVersionPanel
    });
const $0824ef21329004e5$export$b631ebb4887e6060 = (state)=>state.showEpics;
const $0824ef21329004e5$export$2cb6de520195dbf5 = (state)=>state.showVersions;
const $0824ef21329004e5$export$b5f1c34af9498ea = (state)=>state.showStatuses;
const $0824ef21329004e5$export$bf31a7b99f7bc62f = (state)=>state.showUnscheduledColumn;
const $0824ef21329004e5$export$266785c43d094472 = (state)=>state.showIssueLinksStats;
const $0824ef21329004e5$export$a079b5f709c4d237 = (state)=>state.showIssueType;
const $0824ef21329004e5$export$cb710ef8b1ccd94b = (state)=>state.showIssueKey;
const $0824ef21329004e5$export$5abfbf16fb2cec7b = (state)=>state.showPriority;
const $0824ef21329004e5$export$d89a1b3e54af627e = (state)=>state.showDevelopment;
const $0824ef21329004e5$export$ad1a6d247a05049d = (state)=>state.showAssignee;
const $0824ef21329004e5$export$d21c0b83591460c9 = (state)=>state.showEstimate;
const $0824ef21329004e5$export$7549550e839e6e0c = (state)=>state.cardExtraFields;
const $0824ef21329004e5$export$9a608cd91e68c95c = (state)=>state.showDaysInColumn;
const $0824ef21329004e5$export$983376245b8547dc = (state)=>state.showCardCovers;
const $0824ef21329004e5$export$32c01395d25dfdcc = (state)=>state.showOfftrackDependencyLines;
const $0824ef21329004e5$export$67e6bba1326e537a = (state)=>state.issueIdsToShowDependencies;
const $0824ef21329004e5$export$e9dfc10bd434fabb = (state)=>({
        showIssueType: state.showIssueType,
        showIssueKey: state.showIssueKey,
        showPriority: state.showPriority,
        showDevelopment: state.showDevelopment,
        showAssignee: state.showAssignee,
        showEstimate: state.showEstimate,
        cardExtraFields: state.cardExtraFields,
        showDaysInColumn: state.showDaysInColumn,
        showDueDate: state.showDueDate,
        showLabels: state.showLabels,
        showCardCovers: state.showCardCovers
    });
const $0824ef21329004e5$export$1e24fae4497ff7e0 = (state)=>Object.values(state.cardExtraFields).length > 0 && Object.values(state.cardExtraFields).some((value)=>value === true);

});


parcelRegister("9kkzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2065d18bd5dbf1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f2065d18bd5dbf1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noParentIssues: {
        "id": "software-filters.filters.parent.no-parent-issues",
        "defaultMessage": "Your project has no {parentName}"
    },
    toggleLabel: {
        "id": "software-filters.filters.parent.toggle-label",
        "defaultMessage": "Show {parentName} panel"
    }
});

});


parcelRegister("8rjRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a5d5a3c7bae2f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4ksts = parcelRequire("4ksts");

var $azooe = parcelRequire("azooe");

var $6wq34 = parcelRequire("6wq34");
const $20a5d5a3c7bae2f6$var$MAX_SELECTION_ALLOWED = 10;
const $20a5d5a3c7bae2f6$var$QuickFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const values = (0, $eUqFw.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $6wq34.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $20a5d5a3c7bae2f6$var$MAX_SELECTION_ALLOWED
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $6wq34.default).label),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        maxSelectionAllowed: $20a5d5a3c7bae2f6$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested
    });
};
const $20a5d5a3c7bae2f6$var$QuickFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($20a5d5a3c7bae2f6$var$QuickFilter);
$20a5d5a3c7bae2f6$var$QuickFilterComponent.displayName = 'QuickFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$20a5d5a3c7bae2f6$var$QuickFilterComponent.whyDidYouRender = true;
var $20a5d5a3c7bae2f6$export$2e2bcd8739ae039 = $20a5d5a3c7bae2f6$var$QuickFilterComponent;

});
parcelRegister("6wq34", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e68abd7d345f0f5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6e68abd7d345f0f5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.quick.label",
        "defaultMessage": "Quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.quick.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed, plural, one {# quick filter} other {# quick filters}}"
    }
});

});


parcelRegister("9iyDY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb1e777f4ed1038$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $azooe = parcelRequire("azooe");

var $bQpgz = parcelRequire("bQpgz");
const $cfb1e777f4ed1038$var$RequestTypeFilter = ({ requestTypes: requestTypes = [], selectedRequestTypes: selectedRequestTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>requestTypes.map((requestType)=>({
                label: requestType.name,
                value: requestType.id,
                iconUrl: requestType.iconUrl
            })), [
        requestTypes
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (requestTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $bQpgz.default).label),
        values: values,
        selectedValues: selectedRequestTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $cfb1e777f4ed1038$var$RequestTypeFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($cfb1e777f4ed1038$var$RequestTypeFilter);
$cfb1e777f4ed1038$var$RequestTypeFilterComponent.displayName = 'RequestTypeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$cfb1e777f4ed1038$var$RequestTypeFilterComponent.whyDidYouRender = true;
var $cfb1e777f4ed1038$export$2e2bcd8739ae039 = $cfb1e777f4ed1038$var$RequestTypeFilterComponent;

});
parcelRegister("bQpgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $60177fa6ca6183ec$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $60177fa6ca6183ec$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.request-type.label",
        "defaultMessage": "Request type"
    }
});

});


parcelRegister("hNl8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $69e04c62d6057d97$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $azooe = parcelRequire("azooe");

var $btVqx = parcelRequire("btVqx");
const $69e04c62d6057d97$var$SprintFilter = ({ sprints: sprints = [], selectedSprints: selectedSprints = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'sprintFilter rendered', {
            numberOfSprints: sprints.length
        });
    }, [
        createAnalyticsEvent,
        sprints
    ]);
    const values = (0, $eUqFw.useMemo)(()=>sprints.map((sprint)=>({
                label: sprint.name,
                value: sprint.id.toString()
            })), [
        sprints
    ]);
    const onChangeMapValues = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $btVqx.default).label),
        values: values,
        selectedValues: selectedSprints,
        onChange: onChangeMapValues,
        isNested: isNested
    });
};
const $69e04c62d6057d97$var$SprintFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($69e04c62d6057d97$var$SprintFilter);
$69e04c62d6057d97$var$SprintFilterComponent.displayName = 'SprintFilter';
var $69e04c62d6057d97$export$2e2bcd8739ae039 = $69e04c62d6057d97$var$SprintFilterComponent;

});
parcelRegister("btVqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9beb08ea05e17663$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9beb08ea05e17663$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.sprint.label",
        "defaultMessage": "Sprint"
    }
});

});


parcelRegister("7Xd92", function(module, exports) {

$parcel$export(module.exports, "default", () => $8db35472b726a302$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4ksts = parcelRequire("4ksts");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $csSOW = parcelRequire("csSOW");
const $8db35472b726a302$var$StatusCategoryFilter = ({ statusCategories: statusCategories = [], selectedStatusCategories: selectedStatusCategories = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const values = (0, $eUqFw.useMemo)(()=>statusCategories.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statusCategories
    ]);
    const onChangeValue = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $6vrw7.toIssueStatusCategoryId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $csSOW.default).label),
        values: values,
        selectedValues: selectedStatusCategories.map(String),
        onChange: onChangeValue,
        isNested: isNested
    });
};
const $8db35472b726a302$var$StatusCategoryFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($8db35472b726a302$var$StatusCategoryFilter);
$8db35472b726a302$var$StatusCategoryFilterComponent.displayName = 'StatusCategoryFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$8db35472b726a302$var$StatusCategoryFilterComponent.whyDidYouRender = true;
var $8db35472b726a302$export$2e2bcd8739ae039 = $8db35472b726a302$var$StatusCategoryFilterComponent;

});
parcelRegister("csSOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8849ca65a85d2f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8f8849ca65a85d2f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.status-category.label",
        "defaultMessage": "Status category"
    }
});

});


parcelRegister("2ZPCT", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c4f6cbe6b6fd36$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $fjYiT = parcelRequire("fjYiT");
const $03c4f6cbe6b6fd36$var$StatusFilter = ({ statuses: statuses = [], selectedStatuses: selectedStatuses = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>statuses.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statuses
    ]);
    const onChangeValue = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $6vrw7.toIssueStatusId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $fjYiT.default).label),
        values: values,
        selectedValues: selectedStatuses.map(String),
        onChange: onChangeValue,
        isNested: isNested
    });
};
const $03c4f6cbe6b6fd36$var$StatusFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($03c4f6cbe6b6fd36$var$StatusFilter);
$03c4f6cbe6b6fd36$var$StatusFilterComponent.displayName = 'StatusFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$03c4f6cbe6b6fd36$var$StatusFilterComponent.whyDidYouRender = true;
var $03c4f6cbe6b6fd36$export$2e2bcd8739ae039 = $03c4f6cbe6b6fd36$var$StatusFilterComponent;

});
parcelRegister("fjYiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3751963510c6878$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f3751963510c6878$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.status.label",
        "defaultMessage": "Status"
    }
});

});


parcelRegister("b9Y1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab251137c38af3a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $55pTl = parcelRequire("55pTl");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");

var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $6vrw7 = parcelRequire("6vrw7");

var $3kYjh = parcelRequire("3kYjh");

var $8MrYx = parcelRequire("8MrYx");

var $lB25E = parcelRequire("lB25E");

var $azooe = parcelRequire("azooe");

var $e7MSa = parcelRequire("e7MSa");
const $eab251137c38af3a$var$VersionFilter = (props)=>{
    const { versions: versions, selectedVersions: selectedVersions, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, isSpotlightEnabled: isSpotlightEnabled, showPanelToggle: showPanelToggle, isNested: isNested, toggleRef: toggleRef, hasMultipleProjects: hasMultipleProjects, isLoading: isLoading } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { toggleViewSetting: toggleViewSetting } = (0, $8MrYx.useViewSettingsActions)();
    const [boardId] = (0, $lB25E.usePathParam)('boardId');
    const values = (0, $eUqFw.useMemo)(()=>versions.map((version)=>({
                label: version.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(version.id),
                subLabel: hasMultipleProjects ? version.projectKey : undefined
            })), [
        versions,
        hasMultipleProjects
    ]);
    const onChange = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $eUqFw.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $3kYjh.ViewSetting).VERSION_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    const renderContent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
            label: formatMessage((0, $e7MSa.default).label),
            toggleLabel: formatMessage((0, $e7MSa.default).toggleLabel),
            values: values,
            showPanelToggle: showPanelToggle,
            selectedValues: (0, $6vrw7.toStringArray)(selectedVersions),
            isPanelToggleChecked: isToggleChecked,
            onChange: onChange,
            onTogglePanel: handleTogglePanel,
            noOptionsMessage: formatMessage(values.length === 0 ? (0, $e7MSa.default).noUnreleasedVersions : (0, $e7MSa.default).noMatchingVersions),
            showMenuIfValuesAreEmpty: true,
            isNested: isNested,
            toggleRef: toggleRef,
            isLoading: isLoading
        }), [
        formatMessage,
        values,
        showPanelToggle,
        selectedVersions,
        isToggleChecked,
        onChange,
        isNested,
        toggleRef,
        handleTogglePanel,
        isLoading
    ]);
    if (isSpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "fusionBacklogVersionsPanel"
    }, renderContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: "fusionBacklogVersionsPanel"
    })));
    return renderContent;
};
$eab251137c38af3a$var$VersionFilter.displayName = 'VersionFilter';
$eab251137c38af3a$var$VersionFilter.whyDidYouRender = true;
const $eab251137c38af3a$var$ErrorWrapper = (props)=>{
    if (!props.isVersionsFeatureEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "versionFilter",
        attributes: {
            isVersionPanelOpen: props.isToggleChecked
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eab251137c38af3a$var$VersionFilter, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))));
};
$eab251137c38af3a$var$ErrorWrapper.defaultProps = {
    versions: [],
    selectedVersions: [],
    isToggleChecked: false,
    isSpotlightEnabled: false,
    showPanelToggle: true,
    isVersionsFeatureEnabled: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isNested: false
};
var $eab251137c38af3a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($eab251137c38af3a$var$ErrorWrapper);

});
parcelRegister("e7MSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b1075579499f24$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $54b1075579499f24$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noUnreleasedVersions: {
        "id": "software-filters.filters.version.no-unreleased-versions",
        "defaultMessage": "No unreleased versions in this project"
    },
    noMatchingVersions: {
        "id": "software-filters.filters.version.no-matching-versions",
        "defaultMessage": "No matching versions"
    },
    label: {
        "id": "software-filters.filters.version.label",
        "defaultMessage": "Version"
    },
    toggleLabel: {
        "id": "software-filters.filters.version.toggle-label",
        "defaultMessage": "Show version panel"
    }
});

});


parcelRegister("01UFf", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $ce41b001519ffea0$export$56a20ec2552ffba2);
$parcel$export(module.exports, "ListFilterContainerNextGen", () => $ce41b001519ffea0$export$4a72bd88f9845459);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9zysr = parcelRequire("9zysr");

var $8rQuz = parcelRequire("8rQuz");
const $ce41b001519ffea0$export$9ea8cdcfa806101a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $ce41b001519ffea0$export$35dfe29d505ceb8f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $ce41b001519ffea0$export$56a20ec2552ffba2 = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $ce41b001519ffea0$export$35dfe29d505ceb8f, $ce41b001519ffea0$export$9ea8cdcfa806101a);
const $ce41b001519ffea0$export$847557029097218a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jx1txw _1hftutpp _1uf81b66 _1o94h2mm _79vbb3bt _lpsrstnw _9uwn1ssb _41sd7vkz _be5h1i34 _4amot94y _1omzidpf _1sn01d4u",
            __cmplp.className
        ])
    });
});
const $ce41b001519ffea0$export$6fe98dc7be67e1c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jx1txw _1hftv77o _1uf81b66 _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $ce41b001519ffea0$export$595be9b8d0603674 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jx1txw _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $ce41b001519ffea0$export$4a72bd88f9845459 = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $ce41b001519ffea0$export$595be9b8d0603674, $ce41b001519ffea0$export$6fe98dc7be67e1c2);

});

parcelRegister("glQYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $679a38503f8c6462$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $15Xup = parcelRequire("15Xup");

var $klbwP = parcelRequire("klbwP");
const $679a38503f8c6462$var$AsyncBoardSwitcher = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $klbwP.syncBoardSwitcher), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "plan-increment-board-switcher",
        packageName: (0, $15Xup.PACKAGE_NAME),
        teamName: (0, $15Xup.ERROR_REPORTING_TEAM),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $679a38503f8c6462$export$2e2bcd8739ae039 = $679a38503f8c6462$var$AsyncBoardSwitcher;

});
parcelRegister("15Xup", function(module, exports) {

$parcel$export(module.exports, "SCRUM_TEAM", () => $5c98b78e1862f2d4$export$103a728db4a941f8);
$parcel$export(module.exports, "KANBAN_TEAM", () => $5c98b78e1862f2d4$export$f43662b315e78f32);
$parcel$export(module.exports, "BOARD_ISSUE_SOURCE", () => $5c98b78e1862f2d4$export$4c4602fa98384024);
$parcel$export(module.exports, "SINGLE_CUSTOM_FIELD_TYPE_KEY", () => $5c98b78e1862f2d4$export$7a7b05cceb7cc8a9);
$parcel$export(module.exports, "MULTI_CUSTOM_FIELD_TYPE_KEY", () => $5c98b78e1862f2d4$export$2afd90c3608e7105);
$parcel$export(module.exports, "SYSTEM_LABEL_FIELD_ID", () => $5c98b78e1862f2d4$export$84bf4e4e31fe4475);
$parcel$export(module.exports, "CUSTOM_FIELD_OPTION_MISSED_ERROR", () => $5c98b78e1862f2d4$export$aa4bdec93afa2924);
$parcel$export(module.exports, "FILTER_FIELD_ERROR", () => $5c98b78e1862f2d4$export$a497a01fd14a64af);
$parcel$export(module.exports, "MAX_ACTIVE_BOARDS", () => $5c98b78e1862f2d4$export$70493a18b15fa2cc);
$parcel$export(module.exports, "IP_BOARD_STORY_POINTS_PLANNING_UNIT", () => $5c98b78e1862f2d4$export$e2ffaae341a16c5e);
$parcel$export(module.exports, "IP_BOARD_HOURS_PLANNING_UNIT", () => $5c98b78e1862f2d4$export$9a6e823d5b9e62be);
$parcel$export(module.exports, "IP_BOARD_DAYS_PLANNING_UNIT", () => $5c98b78e1862f2d4$export$ad92792f1d38ffba);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $5c98b78e1862f2d4$export$cfeee2ee86ead336);
$parcel$export(module.exports, "PACKAGE_NAME", () => $5c98b78e1862f2d4$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DOC_LINKS", () => $5c98b78e1862f2d4$export$f8975d2c25cd8c82);
$parcel$export(module.exports, "IPH_IDS", () => $5c98b78e1862f2d4$export$253194752488840a);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_PREFIX", () => $5c98b78e1862f2d4$export$c78721cd39b97424);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_START", () => $5c98b78e1862f2d4$export$1bb2633f6c6f66d1);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_END", () => $5c98b78e1862f2d4$export$9583c6ba8c6caee3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_NONE", () => $5c98b78e1862f2d4$export$f2ee1113933b4540);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_LABEL", () => $5c98b78e1862f2d4$export$3212503575d06ffd);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_SINGLE_SELECT", () => $5c98b78e1862f2d4$export$ba991b7dc2732ca3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_MULTI_SELECT", () => $5c98b78e1862f2d4$export$df2129225b939441);
$parcel$export(module.exports, "DEFAULT_ITERATION_LENGTH", () => $5c98b78e1862f2d4$export$8400d4ac050fc755);
$parcel$export(module.exports, "DEFAULT_ITERATIONS_COUNT", () => $5c98b78e1862f2d4$export$b83f977709573647);
$parcel$export(module.exports, "ITERATIONS_COUNT_OPTIONS", () => $5c98b78e1862f2d4$export$f16a2b8db5d397c);
$parcel$export(module.exports, "SWIMLANE_TEAMLESS", () => $5c98b78e1862f2d4$export$b5d1b5cc4a0cc53c);
const $5c98b78e1862f2d4$export$103a728db4a941f8 = 'Scrum';
const $5c98b78e1862f2d4$export$f43662b315e78f32 = 'Kanban';
const $5c98b78e1862f2d4$export$4c4602fa98384024 = 'Board';
const $5c98b78e1862f2d4$export$ab08f53e1080ee4f = 'Project';
const $5c98b78e1862f2d4$export$e5b9ed989e245a1a = 'Filter';
const $5c98b78e1862f2d4$export$7a7b05cceb7cc8a9 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $5c98b78e1862f2d4$export$2afd90c3608e7105 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $5c98b78e1862f2d4$export$84bf4e4e31fe4475 = 'labels';
const $5c98b78e1862f2d4$export$aa4bdec93afa2924 = 'CUSTOM_FIELD_OPTION_MISSED';
const $5c98b78e1862f2d4$export$a497a01fd14a64af = {
    NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND',
    TRASHED: 'CUSTOM_FIELD_TRASHED',
    NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN',
    OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND'
};
const $5c98b78e1862f2d4$export$70493a18b15fa2cc = 2;
const $5c98b78e1862f2d4$export$e2ffaae341a16c5e = 'StoryPoints';
const $5c98b78e1862f2d4$export$9a6e823d5b9e62be = 'Hours';
const $5c98b78e1862f2d4$export$ad92792f1d38ffba = 'Days';
const $5c98b78e1862f2d4$export$cfeee2ee86ead336 = 'axolotl';
const $5c98b78e1862f2d4$export$b8b9d90f9e5bd72b = 'jiraPortfolio3PlanIncrementCommon';
const $5c98b78e1862f2d4$export$f8975d2c25cd8c82 = {
    PROGRAM_BOARD: 'https://support.atlassian.com/jira-software-cloud/docs/what-is-the-program-board-in-my-plan/',
    LINK_SPRINTS: 'https://support.atlassian.com/jira-software-cloud/docs/add-and-change-sprints-on-the-program-board-in-your-plan/',
    CREATION: 'https://support.atlassian.com/jira-software-cloud/docs/what-does-the-program-board-show/',
    CAPACITY_PLANNING: 'https://support.atlassian.com/jira-software-cloud/docs/enable-capacity-planning-in-advanced-roadmaps/',
    OFFTRACK_DEPENDENCIES: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-dependencies-in-advanced-roadmaps/'
};
const $5c98b78e1862f2d4$export$253194752488840a = {
    PROGRAM_BOARDS_CREATE: '6gJCMknYvLjnUgKrm4BKIj',
    PROGRAM_BOARDS_SETTINGS: '1pdnvDJUBHtLdAcH6F03rm',
    CAPACITY_PLANNING: '4kDm3TUQ7LwIEubH72m3Gk',
    OFFTRACK_DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF'
};
const $5c98b78e1862f2d4$export$c78721cd39b97424 = 'plan-increment.sync-sprints:';
const $5c98b78e1862f2d4$export$1bb2633f6c6f66d1 = `${$5c98b78e1862f2d4$export$c78721cd39b97424}start`;
const $5c98b78e1862f2d4$export$9583c6ba8c6caee3 = `${$5c98b78e1862f2d4$export$c78721cd39b97424}end`;
const $5c98b78e1862f2d4$export$f2ee1113933b4540 = 'none';
const $5c98b78e1862f2d4$export$3212503575d06ffd = 'label';
const $5c98b78e1862f2d4$export$ba991b7dc2732ca3 = 'select';
const $5c98b78e1862f2d4$export$df2129225b939441 = 'multiselect';
const $5c98b78e1862f2d4$export$8400d4ac050fc755 = 2;
const $5c98b78e1862f2d4$export$b83f977709573647 = 6;
const $5c98b78e1862f2d4$export$f16a2b8db5d397c = [
    {
        label: '3',
        value: 3
    },
    {
        label: '4',
        value: 4
    },
    {
        label: '5',
        value: 5
    },
    {
        label: '6',
        value: 6
    },
    {
        label: '7',
        value: 7
    },
    {
        label: '8',
        value: 8
    },
    {
        label: '9',
        value: 9
    },
    {
        label: '10',
        value: 10
    },
    {
        label: '11',
        value: 11
    },
    {
        label: '12',
        value: 12
    },
    {
        label: '13',
        value: 13
    }
];
const $5c98b78e1862f2d4$export$b5d1b5cc4a0cc53c = '$teamless$';

});

parcelRegister("klbwP", function(module, exports) {

$parcel$export(module.exports, "syncBoardSwitcher", () => $24b2ce6661175299$export$e13b401cdb60e3ed);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $24b2ce6661175299$export$e13b401cdb60e3ed = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hB8TG")).then((module)=>module.AsyncBoardSwitcher), {
        moduleId: "2623f17b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hB8TG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("4k68Q")
]).then(()=>parcelRequire('5pr6u'));

});



parcelRegister("fqAlt", function(module, exports) {

$parcel$export(module.exports, "CollabContainerAsync", () => $4b716fbe5fc1d02e$export$69b83fdf5027068d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4b716fbe5fc1d02e$var$LazyCollabContainer = (0, $7rh0R.lazy)(()=>(parcelRequire("bfRkT")).then(({ CollabContainer: CollabContainer })=>CollabContainer), {
    moduleId: "./src/packages/software/real-time-presence/src/controllers/collab/index.tsx"
});
const $4b716fbe5fc1d02e$export$69b83fdf5027068d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-jira-software-real-time-presence",
        packageName: "jiraSoftwareRealtimePresence",
        teamName: "jira-werewolves",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-real-time-presence",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4b716fbe5fc1d02e$var$LazyCollabContainer, props)));

});
parcelRegister("bfRkT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eSMGv")
]).then(()=>parcelRequire('65xSr'));

});


parcelRegister("fmImn", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $bcb2c318ace1641e$export$4159ae80cfa2156);

var $lyOYo = parcelRequire("lyOYo");

var $WBLbN = parcelRequire("WBLbN");

const $bcb2c318ace1641e$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $bcb2c318ace1641e$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $356df1c77d24a703$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $bcb2c318ace1641e$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $bcb2c318ace1641e$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $bcb2c318ace1641e$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $bcb2c318ace1641e$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $bcb2c318ace1641e$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const newSelection = {
            nodeId: nodeId,
            user: user,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $bcb2c318ace1641e$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection,
            dragAnimation: dropParams && userId != null ? [
                ...state.dragAnimation,
                {
                    ...dropParams,
                    userId: userId
                }
            ] : state.dragAnimation
        });
    };
const $bcb2c318ace1641e$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
        });
    };
const $bcb2c318ace1641e$var$actions = {
    setProvider: $bcb2c318ace1641e$var$setProvider,
    participantsLeft: $bcb2c318ace1641e$var$participantsLeft,
    participantsJoined: $bcb2c318ace1641e$var$participantsJoined,
    updateUserInParticipants: $bcb2c318ace1641e$var$updateUserInParticipants,
    sendNodeSelected: $bcb2c318ace1641e$var$sendNodeSelected,
    sendClearNodeSelection: $bcb2c318ace1641e$var$sendClearNodeSelection,
    setNodeSelection: $bcb2c318ace1641e$var$setNodeSelection,
    clearNodeSelection: $bcb2c318ace1641e$var$clearNodeSelection,
    stopDragAnimation: $bcb2c318ace1641e$var$stopDragAnimation
};
const $bcb2c318ace1641e$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {},
        dragAnimation: []
    },
    actions: $bcb2c318ace1641e$var$actions,
    name: 'JSWCollabStore'
});
const $bcb2c318ace1641e$export$4159ae80cfa2156 = (0, $WBLbN.createHook)($bcb2c318ace1641e$var$Store);

});
const $356df1c77d24a703$export$3debf01bbfa135e5 = 80;


parcelRegister("8Ui86", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $02c3e5e2cebd6ff7$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $babBw = parcelRequire("babBw");

var $kq9HD = parcelRequire("kq9HD");

var $dAreR = parcelRequire("dAreR");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $02c3e5e2cebd6ff7$var$className = 'ajs-dirty-warning-exempt';
const $02c3e5e2cebd6ff7$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [value, setValue] = (0, $eUqFw.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const textInput = (0, $eUqFw.useRef)(null);
    const previousValueRef = (0, $eUqFw.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eUqFw.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $babBw.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $02c3e5e2cebd6ff7$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $babBw.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $8rQuz.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kq9HD.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $babBw.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        testId: testId,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.displayName = 'Search';
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $02c3e5e2cebd6ff7$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eUqFw.memo)($02c3e5e2cebd6ff7$var$SearchFieldUnmemoized);
$02c3e5e2cebd6ff7$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c3e5e2cebd6ff7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02c3e5e2cebd6ff7$var$InputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $9t7rW.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $9t7rW.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $9t7rW.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("babBw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1db92d5b4c5e946f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1db92d5b4c5e946f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("kq9HD", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $c70659cfee4e098d$export$84038b503874befa);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $02Sz7 = parcelRequire("02Sz7");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $c70659cfee4e098d$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $c70659cfee4e098d$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($02Sz7)))
    }));
const $c70659cfee4e098d$var$wrapperStylesCloseIcon = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("dAreR", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $81537fc79b34b1c4$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $81537fc79b34b1c4$export$8a82bff895521bd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8xkEh = parcelRequire("8xkEh");

var $aB51E = parcelRequire("aB51E");

var $9IsWp = parcelRequire("9IsWp");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $81537fc79b34b1c4$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aB51E))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStyles,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8xkEh))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $81537fc79b34b1c4$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStylesBefore,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null));
const $81537fc79b34b1c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $81537fc79b34b1c4$var$spacingStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $81537fc79b34b1c4$var$wrapperStylesBefore = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $81537fc79b34b1c4$var$spacingStylesBefore = (0, $1ZAYh.xcss)({
    marginLeft: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});


parcelRegister("1Ksr6", function(module, exports) {

$parcel$export(module.exports, "useShortcutAnalytics", () => $6f08a6f9a81f758c$export$cd482f0b72849b2c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");
const $6f08a6f9a81f758c$export$56c266726b07692d = (createAnalyticsEvent, { id: id, key: key, attributes: attributes }, shortcutSource)=>{
    const attrs = {
        ...attributes,
        key: key,
        shortcutSource: shortcutSource,
        nextGenProject: true
    };
    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    }), id, attrs);
};
const $6f08a6f9a81f758c$export$cd482f0b72849b2c = (shortcutSource)=>{
    // Will fix on FF cleanup
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        $6f08a6f9a81f758c$export$56c266726b07692d(createAnalyticsEvent, payload, shortcutSource);
    }, [
        createAnalyticsEvent,
        shortcutSource
    ]);
    return fireAnalytics;
};

});

parcelRegister("8gxRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5960339ce2b9bc1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $fee69 = parcelRequire("fee69");

var $iH6c1 = parcelRequire("iH6c1");

var $JRB5w = parcelRequire("JRB5w");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $15ZJO = parcelRequire("15ZJO");

var $J3y23 = parcelRequire("J3y23");
class $b5960339ce2b9bc1$export$876b3e4acf4df22c extends (0, $eUqFw.Component) {
    static{
        this.getDerivedStateFromError = (error)=>({
                error: error,
                isRelayValidationError: (0, $J3y23.isRelayValidationError)(error)
            });
    }
    static getDerivedStateFromProps({ customFiltersQueryRef: customFiltersQueryRef }, state) {
        if (state.error && !state.aggErrors && customFiltersQueryRef) {
            const capturedGQLErrorsInfo = (0, $15ZJO.stopCaptureGraphQlErrors)(customFiltersQueryRef.fetchKey.toString());
            const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === customFiltersQueryRef.name);
            if (validGQLErrorsInfo?.errors.length) return {
                ...state,
                aggErrors: validGQLErrorsInfo.errors,
                aggErrorsMeta: validGQLErrorsInfo.meta
            };
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            aggErrors: null,
            aggErrorsMeta: null,
            isRelayValidationError: false
        };
    }
    getCommonErrorAttributes(error) {
        return {
            task: 'loadCustomFilters',
            screenName: this.props.screenName,
            isNetworkError: false,
            isRelayValidationError: this.state.isRelayValidationError,
            hash: (0, $iH6c1.getErrorHash)(error) ?? '',
            errorMessage: error.message,
            stack: error.stack
        };
    }
    render() {
        const { error: error, aggErrors: aggErrors, aggErrorsMeta: aggErrorsMeta, isRelayValidationError: isRelayValidationError } = this.state;
        const { children: children } = this.props;
        if (!error) return children;
        if (aggErrors?.length) {
            const aggError = new (0, $J3y23.AGGErrors)(aggErrors, aggErrorsMeta?.requestId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
                eventName: "ui taskFail",
                attributes: {
                    traceId: aggError.traceId,
                    statusCode: aggError.statusCode,
                    ...this.getCommonErrorAttributes(aggError)
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
                id: "custom-filter-dropdown",
                error: aggError
            }));
        }
        if (isRelayValidationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
            eventName: "ui taskFail",
            attributes: {
                ...this.getCommonErrorAttributes(error)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: "custom-filter-dropdown",
            error: error
        }));
        // If this isn't an AGG or Relay error, let the upper error boundary handle it
        throw error;
    }
}
const $b5960339ce2b9bc1$var$CustomFilterBoundary = (props)=>{
    const { children: children, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onError = (_, error)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            screenName: screenName,
            task: 'loadCustomFilters',
            isNetworkError: (0, $JRB5w.isClientFetchError)(error),
            hash: (0, $iH6c1.getErrorHash)(error) ?? '',
            errorMessage: error.message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "custom-filter-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        },
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5960339ce2b9bc1$export$876b3e4acf4df22c, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-filter-boundary",
        fallback: null
    }, children)));
};
var $b5960339ce2b9bc1$export$2e2bcd8739ae039 = $b5960339ce2b9bc1$var$CustomFilterBoundary;

});
parcelRegister("J3y23", function(module, exports) {

$parcel$export(module.exports, "isRelayValidationError", () => $91e455f3f7b68213$export$f450dbe0abffdade);
$parcel$export(module.exports, "AGGErrors", () => $91e455f3f7b68213$export$60d8267243755b9c);

var $lgAsZ = parcelRequire("lgAsZ");
const $91e455f3f7b68213$export$321834dc4377cb7 = 'Relay: Missing @required value at path';
const $91e455f3f7b68213$export$f450dbe0abffdade = (error)=>error.message.includes($91e455f3f7b68213$export$321834dc4377cb7);
class $91e455f3f7b68213$export$60d8267243755b9c extends (0, $lgAsZ.default) {
    constructor(errors, traceId){
        // this is used to generate same 'hash' for error flag and sla event attribute
        super(errors[0].message, {
            cause: errors[0]
        });
        this.name = 'AGGError';
        this.graphQLErrors = errors;
        this.traceId = traceId;
        this.statusCode = errors[0].extensions?.statusCode ?? undefined;
    }
}

});


parcelRegister("8D53g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4937c963117aaed6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cmc0m = parcelRequire("cmc0m");
const $4937c963117aaed6$var$HijackBrowserDefaultSearch = ({ onFocusSearch: onFocusSearch, isAnyModalOpen: isAnyModalOpen = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onGlobalSearch = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'event' implicitly has an 'any' type.
    ({ event: event })=>{
        // Do not hijack browser default search when any modal is open
        if (isAnyModalOpen) return;
        // Hijacks default browser search and directs user to search in filter bar
        event.preventDefault();
        onFocusSearch();
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'hijackBrowserDefaultSearch triggered');
    }, [
        createAnalyticsEvent,
        isAnyModalOpen,
        onFocusSearch
    ]);
    (0, $cmc0m.useGlobalSearch)(onGlobalSearch);
    return null;
};
var $4937c963117aaed6$export$2e2bcd8739ae039 = $4937c963117aaed6$var$HijackBrowserDefaultSearch;

});
parcelRegister("cmc0m", function(module, exports) {

$parcel$export(module.exports, "isMacOS", () => $cda4b48a66b8cbd6$export$6159e43e50a41987);
$parcel$export(module.exports, "useGlobalSearch", () => $cda4b48a66b8cbd6$export$1df85516f1b3e335);
$parcel$export(module.exports, "default", () => $cda4b48a66b8cbd6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gtzuR = parcelRequire("gtzuR");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $cda4b48a66b8cbd6$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
const $cda4b48a66b8cbd6$export$1df85516f1b3e335 = (/** Callback to be fired when global search is used */ callback, getGlobalDocument = ()=>document)=>{
    (0, $eUqFw.useEffect)(()=>{
        const trackGlobalSearch = (event)=>{
            const isMacOs = $cda4b48a66b8cbd6$export$6159e43e50a41987();
            if (isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('f') && event.ctrlKey) callback({
                isMacOs: isMacOs,
                event: event
            });
        };
        getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
        return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
    }, [
        callback,
        getGlobalDocument
    ]);
};
const $cda4b48a66b8cbd6$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, $jMP2a.fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onGlobalSearch = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'isMacOs' implicitly has an 'any' type.
    ({ isMacOs: isMacOs })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'triggered',
            actionSubject: 'globalSearch'
        });
        const attributes = {
            ...analyticsAttributes,
            isMacOs: isMacOs
        };
        fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        fireAnalytics
    ]);
    $cda4b48a66b8cbd6$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
    return null;
};
var $cda4b48a66b8cbd6$export$2e2bcd8739ae039 = $cda4b48a66b8cbd6$var$GlobalSearchTracker;

});


parcelRegister("hREiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $888e8c9db9ec5c9b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $g9Oms = parcelRequire("g9Oms");
var $8Wt6T = parcelRequire("8Wt6T");

var $b5IAe = parcelRequire("b5IAe");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cmc0m = parcelRequire("cmc0m");

var $kQqwL = parcelRequire("kQqwL");

var $aX4h4 = parcelRequire("aX4h4");
const $888e8c9db9ec5c9b$var$SearchFilterChangeboarding = ({ children: children, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isCompanyManaged: isCompanyManaged = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)(false);
    const hasShown = (0, $eUqFw.useRef)(false);
    const onGlobalSearch = (0, $eUqFw.useCallback)(()=>{
        if (!hasShown.current) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding shown', {
                isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
            });
            setIsVisible(true);
            hasShown.current = true;
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') (0, $kQqwL.setUserSeenSearchFieldChangeboarding)(screenName);
        }
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const onDismiss = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding dismissed', {
            isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
        });
        setIsVisible(false);
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>[
            {
                text: formatMessage((0, $aX4h4.default).changeboardingConfirmButton),
                onClick: onDismiss
            }
        ], [
        formatMessage,
        onDismiss
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const getUserSeenSearchFieldChangeboarding = async ()=>{
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') {
                const seen = await (0, $kQqwL.hasUserSeenSearchFieldChangeboarding)(createAnalyticsEvent({}), screenName);
                if (seen) hasShown.current = true;
            }
        };
        getUserSeenSearchFieldChangeboarding();
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const changeBoardingMessage = ()=>{
        const ctrlKey = (0, $cmc0m.isMacOS)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Code, null, "Cmnd") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Code, null, "Ctrl");
        return hijackBrowserDefaultSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $aX4h4.default).hijackingDefaultSearchMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Code, null, "F"),
                ctrlKey: ctrlKey
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $aX4h4.default).changeboardingMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Code, null, "f")
            }
        });
    };
    let spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Oms.default), {
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, changeBoardingMessage()));
    if (isCompanyManaged) spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Oms.default), {
        heading: formatMessage((0, $aX4h4.default).changeboardingUifMessageHeading),
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $aX4h4.default).changeboardingUifMessage)));
    (0, $cmc0m.useGlobalSearch)(onGlobalSearch);
    if (isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$ChangeboardingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Pulse, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$SpolightCardContainer, null, spotlightCard));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
var $888e8c9db9ec5c9b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $888e8c9db9ec5c9b$var$SearchFilterChangeboarding;
const $888e8c9db9ec5c9b$var$Pulse = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8Wt6T.Pulse), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbyowjs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $888e8c9db9ec5c9b$var$ChangeboardingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $888e8c9db9ec5c9b$var$spotlightAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $888e8c9db9ec5c9b$var$SpolightCardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1pbyowjs _19pku2gc _tzy4idpf _y44v18t4 _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $888e8c9db9ec5c9b$var$Code = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _11q7exu1 _syaz1fxt _2rko1l7b _1e0c1nu9 _1reo1wug _o5721jtm _1yt4u49m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kQqwL", function(module, exports) {

$parcel$export(module.exports, "hasUserSeenSearchFieldChangeboarding", () => $e4f443dd945506e2$export$b5010e3edd313ae1);
$parcel$export(module.exports, "setUserSeenSearchFieldChangeboarding", () => $e4f443dd945506e2$export$fba51361338c8f18);

var $jBAQz = parcelRequire("jBAQz");

var $jMP2a = parcelRequire("jMP2a");
const $e4f443dd945506e2$var$changeboardingFlags = {
    board: 'jsw.filters.board.search-field-changeboarding.shown',
    backlog: 'jsw.filters.backlog.search-field-changeboarding.shown'
};
const $e4f443dd945506e2$var$CHANGEBOARDING_TTL_SEEN = 31536000000; // ~ 365 days
const $e4f443dd945506e2$export$b5010e3edd313ae1 = (analyticsEvent, screenName)=>(0, $jBAQz.getFlags)({
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
        [$e4f443dd945506e2$var$changeboardingFlags[screenName]]: {}
    })// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
    .then((res)=>res[$e4f443dd945506e2$var$changeboardingFlags[screenName]].status).catch(()=>{
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'searchFilterChangeboarding checkSeenFailed');
        return false;
    });
const $e4f443dd945506e2$export$fba51361338c8f18 = (screenName)=>(0, $jBAQz.setFlag)($e4f443dd945506e2$var$changeboardingFlags[screenName], $e4f443dd945506e2$var$CHANGEBOARDING_TTL_SEEN);

});
parcelRegister("jBAQz", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $1749c1c9732fa517$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $1749c1c9732fa517$export$5e165df1e30a1331);

var $czx3b = parcelRequire("czx3b");

var $hwbh0 = parcelRequire("hwbh0");

var $e91YZ = parcelRequire("e91YZ");

var $1Cw1V = parcelRequire("1Cw1V");

var $gYp0l = parcelRequire("gYp0l");
const $1749c1c9732fa517$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $1749c1c9732fa517$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $1749c1c9732fa517$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $gYp0l.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $gYp0l.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1Cw1V.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $gYp0l.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $1749c1c9732fa517$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $1749c1c9732fa517$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $gYp0l.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $1749c1c9732fa517$export$5e165df1e30a1331 = async (flagKey, ttl = $1749c1c9732fa517$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $gYp0l.default) {
        const value = (0, $gYp0l.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $gYp0l.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1Cw1V.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("hwbh0", function(module, exports) {

var $jDLwO = parcelRequire("jDLwO");

var $7hlYT = parcelRequire("7hlYT");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $cc0e2b7b9a1e48d7$var$zipObject(props, values) {
    return $7hlYT(props || [], values || [], $jDLwO);
}
module.exports = $cc0e2b7b9a1e48d7$var$zipObject;

});
parcelRegister("7hlYT", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $54cb2be8ad88e749$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $54cb2be8ad88e749$var$baseZipObject;

});


parcelRegister("1Cw1V", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $27a69f89da9f41d0$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $27a69f89da9f41d0$export$d5815430bcc75df0);

var $czx3b = parcelRequire("czx3b");

var $7byHA = parcelRequire("7byHA");
const $27a69f89da9f41d0$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $27a69f89da9f41d0$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $7byHA.default)(response.status, response.statusText);
        return undefined;
    });
};
const $27a69f89da9f41d0$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $27a69f89da9f41d0$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $7byHA.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$27a69f89da9f41d0$var$convertToDates(response));
};

});

parcelRegister("gYp0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $16304c7221461599$export$2e2bcd8739ae039);

var $89bO2 = parcelRequire("89bO2");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $16304c7221461599$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $89bO2.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $16304c7221461599$export$2e2bcd8739ae039 = $16304c7221461599$var$createStorage();

});



parcelRegister("aX4h4", function(module, exports) {

$parcel$export(module.exports, "default", () => $befdb0d42b23f1e0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $befdb0d42b23f1e0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changeboardingMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-message",
        "defaultMessage": "For quick access to search, use {key} on your keyboard anywhere in Jira. It takes you directly to the search field."
    },
    changeboardingUifMessageHeading: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading",
        "defaultMessage": "Search for an issue"
    },
    changeboardingUifMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message",
        "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    },
    hijackingDefaultSearchMessage: {
        "id": "software-filters.search-filter-changeboarding.hijacking-default-search-message",
        "defaultMessage": "{ ctrlKey } + { key } takes you directly to the search field, just like keyboard shortcut { key }. Both shortcuts give you quick access to our optimized search."
    },
    changeboardingConfirmButton: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-confirm-button",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("iesgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69c6cadd163f00$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");
const $cd69c6cadd163f00$var$VersionFilterRelayBoundary = ({ fallback: fallback = null, children: children, screenName: screenName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "version-filter-relay-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "version-filter-relay-boundary",
        fallback: fallback
    }, children));
var $cd69c6cadd163f00$export$2e2bcd8739ae039 = $cd69c6cadd163f00$var$VersionFilterRelayBoundary;

});

parcelRegister("gp3Fg", function(module, exports) {

$parcel$export(module.exports, "default", () => $58e8b1a5a510d996$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $58e8b1a5a510d996$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    textFilter: {
        "id": "software-filters.stateless.text-filter",
        "defaultMessage": "Filter issues"
    },
    screenReaderInstruction: {
        "id": "software-filters.stateless.screen-reader-instruction",
        "defaultMessage": "Results will be filtered below as you type to search or apply filters."
    },
    screenReaderInstructionForFilters: {
        "id": "software-filters.stateless.screen-reader-instruction-for-filters",
        "defaultMessage": "Content below has been updated"
    },
    searchCurrentPage: {
        "id": "software-filters.stateless.search-current-page",
        "defaultMessage": "Search on current page"
    },
    goToSection: {
        "id": "software-filters.stateless.go-to-section",
        "defaultMessage": "Go to"
    },
    unassignedAssigneeDisplayName: {
        "id": "software-filters.stateless.unassigned-assignee-display-name",
        "defaultMessage": "Unassigned"
    },
    unassignedVersionLabel: {
        "id": "software-filters.stateless.unassigned-version-label",
        "defaultMessage": "Issues without version"
    },
    unassignedLabelLabel: {
        "id": "software-filters.stateless.unassigned-label-label",
        "defaultMessage": "Issues without label"
    },
    unassignedComponentLabel: {
        "id": "software-filters.stateless.unassigned-component-label",
        "defaultMessage": "Issues without component"
    }
});

});

parcelRegister("84m3I", function(module, exports) {

$parcel$export(module.exports, "getManageCustomFiltersUrl", () => $71ff8d7d00a86ae0$export$84a62bf03b005a81);
$parcel$export(module.exports, "getAssigneesWithPresence", () => $71ff8d7d00a86ae0$export$cd7b2f0d4c426239);

var $1ybV0 = parcelRequire("1ybV0");

const $71ff8d7d00a86ae0$export$84a62bf03b005a81 = (projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, // For testing purposes
pathname = window.location.pathname)=>{
    if ((0, $1ybV0.ff)('jsm-fix-board-quick-filter-link-bug_xp1ia')) {
        if (isJSMBoard) return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
        if (isCompanyManaged) {
            if (isUserBoard) return `${pathname}?config=quickFilters`;
            return `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}?config=quickFilters`;
        }
        return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
    }
    return isCompanyManaged ? `${isUserBoard ? pathname : `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}`}?config=quickFilters` : `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
};
const $71ff8d7d00a86ae0$export$cd7b2f0d4c426239 = (allAssignees, participants)=>allAssignees.map((assignee)=>{
        if (assignee.id === (0, $44677eb502cfd308$export$12e572fd459c10dc)) return assignee;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            ...assignee,
            presence: participants.some((participant)=>participant.clientId === assignee.id) ? (0, $44677eb502cfd308$export$7a105aa475396c65) : (0, $44677eb502cfd308$export$c9408e3fb31ddc71)
        };
    }).sort((a, b)=>{
        // sort by presence & keep current user as the first
        if (a.id === allAssignees[0].id) return -1;
        if (b.id === allAssignees[0].id) return 1;
        if (a.presence === (0, $44677eb502cfd308$export$7a105aa475396c65)) return -1;
        if (b.presence === (0, $44677eb502cfd308$export$7a105aa475396c65)) return 1;
        return 0;
    });

});


parcelRegister("63ypL", function(module, exports) {

$parcel$export(module.exports, "useCollator", () => $38184ae03e67a75a$export$a16aca283550c30d);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $38184ae03e67a75a$export$a16aca283550c30d = ()=>{
    const { locale: locale } = (0, $gd0Sp.useTenantContext)();
    const { current: collator } = (0, $eUqFw.useRef)(new Intl.Collator((0, $ao0hp.standardizeLocale)(locale)));
    return {
        collator: collator
    };
};

});

parcelRegister("3z3DP", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a07c7f87860909$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $50a07c7f87860909$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "roadmap.standard-roadmap.header.filter-bar.filter-placeholder",
        "defaultMessage": "Search timeline"
    }
});

});



parcelRegister("jW7VM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe8ab0958382d15$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $9QJ8r = parcelRequire("9QJ8r");
var $3fe8ab0958382d15$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        isCMP: (0, $lgKTA.isClassic)(state),
        boardId: (0, $lgKTA.getBoardId)(state),
        projectKey: (0, $bwVWW.getProjectKey)(state),
        cloudId: (0, $lgKTA.getCloudId)(state) ?? '',
        boardType: (0, $bwVWW.getIsSprintsFeatureEnabled)(state) ? 'Scrum' : 'Kanban',
        canConfigureTimeline: (0, $bwVWW.hasAdministerProjectPermission)(state) || (0, $bwVWW.getIsUserBoardAdmin)(state)
    }), {})((0, $9QJ8r.default));

});
parcelRegister("9QJ8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a1c8dc50131f51b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $c5IEJ = parcelRequire("c5IEJ");

var $1kKog = parcelRequire("1kKog");

var $34Io4 = parcelRequire("34Io4");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FP8W = parcelRequire("6FP8W");

var $idkBG = parcelRequire("idkBG");

var $9Anw5 = parcelRequire("9Anw5");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eDgaT = parcelRequire("eDgaT");

var $ab6rA = parcelRequire("ab6rA");

var $c7H0g = parcelRequire("c7H0g");

var $gd0Sp = parcelRequire("gd0Sp");

var $8rQuz = parcelRequire("8rQuz");

var $lB25E = parcelRequire("lB25E");

var $kxVL6 = parcelRequire("kxVL6");

var $c9l8s = parcelRequire("c9l8s");
const $7a1c8dc50131f51b$var$licensedProductsToString = (products)=>Object.keys(products).map((productKey)=>products[productKey] ? productKey : '').join(', ');
const $7a1c8dc50131f51b$var$MoreSettings = ({ isCMP: isCMP, boardId: boardId, projectKey: projectKey, cloudId: cloudId, boardType: boardType, canConfigureTimeline: canConfigureTimeline, defaultOpen: defaultOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)();
    const { software: softwareEdition } = (0, $ab6rA.useAppEditions)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const configureRoadmapAnalyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'configureRoadmapButtonClicked'
    });
    const navigateToRoadmapSettingsPage = ()=>{
        (0, $jMP2a.fireUIAnalytics)(configureRoadmapAnalyticsEvent);
        if (!isCMP) (0, $idkBG.setReturnToProjectUrl)();
        const url = (0, $kxVL6.getRoadmapSettingsUrl)(isCMP, projectKey, boardId);
        push(url);
    };
    const feedbackButtonRef = (0, $eUqFw.useRef)(null);
    const additionalFeedbackEntries = (0, $eUqFw.useMemo)(()=>[
            {
                id: (0, $1c02D.EntryKeys).OPT_OUT,
                value: 'No'
            },
            {
                id: (0, $1c02D.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                value: 'jsw.roadmap'
            },
            {
                id: (0, $1c02D.EntryKeys).CLOUD_ID,
                value: cloudId
            },
            {
                id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: !isCMP.toString()
            },
            {
                id: (0, $1c02D.EntryKeys).BOARD_TYPE,
                value: boardType
            },
            {
                id: (0, $1c02D.EntryKeys).LOCATION,
                value: (0, $9Anw5.default)(window?.location?.href ?? '')
            },
            {
                id: (0, $1c02D.EntryKeys).REFERER,
                value: document.referrer ? (0, $9Anw5.default)(document.referrer) : ''
            },
            {
                id: (0, $1c02D.EntryKeys).USER_AGENT,
                value: navigator.userAgent
            },
            {
                id: (0, $1c02D.EntryKeys).SCREEN_RESOLUTION,
                value: `${window.screen.width} x ${window.screen.height}`
            },
            {
                id: (0, $1c02D.EntryKeys).IS_ADMIN,
                value: isAdmin.toString()
            },
            {
                id: (0, $1c02D.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: $7a1c8dc50131f51b$var$licensedProductsToString(licensedProducts)
            },
            {
                id: (0, $1c02D.EntryKeys).PROJECT_TYPE,
                value: 'software'
            },
            {
                id: (0, $1c02D.EntryKeys).EDITION,
                value: softwareEdition
            }
        ], [
        boardType,
        cloudId,
        isCMP,
        isAdmin,
        licensedProducts,
        softwareEdition
    ]);
    const onOpenFeedbackCollector = (0, $eUqFw.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackTitle: formatMessage((0, $c9l8s.default).feedbackCollectorTitle),
            feedbackTitleDetails: formatMessage((0, $c9l8s.default).feedbackCollectorDescription),
            triggerRef: feedbackButtonRef,
            feedbackContext: additionalFeedbackEntries
        });
    }, [
        openFeedbackCollector,
        formatMessage,
        additionalFeedbackEntries
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: "roadmap.standard-roadmap.header.more-settings",
        // eslint-disable-next-line jira/react-no-inline-function-prop
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>// eslint-disable-next-line no-nested-ternary
            (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Io4))),
                label: formatMessage((0, $c9l8s.default).moreSettingsMenuLabel),
                ref: triggerRef,
                isTooltipDisabled: false
            }) : (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
                label: formatMessage((0, $c9l8s.default).moreSettingsMenuLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Io4))),
                ref: triggerRef,
                ...triggerProps
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                ref: triggerRef,
                appearance: "subtle",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }),
        placement: "bottom-end",
        defaultOpen: defaultOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, canConfigureTimeline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: navigateToRoadmapSettingsPage,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kKog))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "roadmap.standard-roadmap.header.more-settings.configure-timeline"
    }, formatMessage((0, $c9l8s.default).moreSettingsButtonLabel)), (0, $6FP8W.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c5IEJ))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        onClick: onOpenFeedbackCollector,
        ref: feedbackButtonRef,
        testId: "roadmap.standard-roadmap.header.more-settings.feedback"
    }, formatMessage((0, $c9l8s.default).feedbackButtonLabel))));
};
var $7a1c8dc50131f51b$export$2e2bcd8739ae039 = $7a1c8dc50131f51b$var$MoreSettings;

});
parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("c5IEJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06b2b9eec310f6566d6d86916ad7e234>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cd8976d9d4f34ae$var$_react = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8cd8976d9d4f34ae$var$_feedback = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("3kIcQ")));

var $8cd8976d9d4f34ae$var$_feedback2 = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("l2ZYW")));
function $8cd8976d9d4f34ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cd8976d9d4f34ae$var$FeedbackIcon = (props)=>/*#__PURE__*/ $8cd8976d9d4f34ae$var$_react.default.createElement($8cd8976d9d4f34ae$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $8cd8976d9d4f34ae$var$_feedback2.default
    }, props));
$8cd8976d9d4f34ae$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $8cd8976d9d4f34ae$var$_default = module.exports.default = $8cd8976d9d4f34ae$var$FeedbackIcon;

});
parcelRegister("3kIcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8f50fdbec38c602b5aa9320deba7858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26d587cb75b7e288$var$_react = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26d587cb75b7e288$var$_UNSAFE_baseNew = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $26d587cb75b7e288$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26d587cb75b7e288$var$FeedbackIcon = (props)=>/*#__PURE__*/ $26d587cb75b7e288$var$_react.default.createElement($26d587cb75b7e288$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$26d587cb75b7e288$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $26d587cb75b7e288$var$_default = module.exports.default = $26d587cb75b7e288$var$FeedbackIcon;

});

parcelRegister("l2ZYW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f529dd351378d429$var$_react = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f529dd351378d429$var$_feedback = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("3kIcQ")));
function $f529dd351378d429$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f529dd351378d429$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f529dd351378d429$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $f529dd351378d429$var$_feedback.default
    }));
$f529dd351378d429$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $f529dd351378d429$var$_default = module.exports.default = $f529dd351378d429$var$FeedbackIcon;

});


parcelRegister("1kKog", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c63ca7bcdfd3dd8998b55e184532198>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f8ba4e21b20f23e$var$_react = $0f8ba4e21b20f23e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0f8ba4e21b20f23e$var$_settings = $0f8ba4e21b20f23e$var$_interopRequireDefault((parcelRequire("dW1OX")));

var $0f8ba4e21b20f23e$var$_settings2 = $0f8ba4e21b20f23e$var$_interopRequireDefault((parcelRequire("iw0Y6")));
function $0f8ba4e21b20f23e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SettingsIcon.
 * This component is SettingsIcon, with `UNSAFE_fallbackIcon` set to "SettingsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f8ba4e21b20f23e$var$SettingsIcon = (props)=>/*#__PURE__*/ $0f8ba4e21b20f23e$var$_react.default.createElement($0f8ba4e21b20f23e$var$_settings.default, Object.assign({
        LEGACY_fallbackIcon: $0f8ba4e21b20f23e$var$_settings2.default
    }, props));
$0f8ba4e21b20f23e$var$SettingsIcon.Name = 'SettingsIconMigration';
var $0f8ba4e21b20f23e$var$_default = module.exports.default = $0f8ba4e21b20f23e$var$SettingsIcon;

});

parcelRegister("34Io4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384f31b6891d11603b1a7b84cc388cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d42d3583f8fd73$var$_react = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $23d42d3583f8fd73$var$_showMoreHorizontal = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("7JXZ0")));

var $23d42d3583f8fd73$var$_more = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("jG1wZ")));
function $23d42d3583f8fd73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d42d3583f8fd73$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $23d42d3583f8fd73$var$_react.default.createElement($23d42d3583f8fd73$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $23d42d3583f8fd73$var$_more.default
    }, props));
$23d42d3583f8fd73$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $23d42d3583f8fd73$var$_default = module.exports.default = $23d42d3583f8fd73$var$ShowMoreHorizontalIcon;

});

parcelRegister("eDgaT", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $ad0d3127c7a37420$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $ad0d3127c7a37420$export$50fd17babcd996ef);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");
var $fI650 = parcelRequire("fI650");
var $8GeQ6 = parcelRequire("8GeQ6");

var $9Amv1 = parcelRequire("9Amv1");

var $5ARvW = parcelRequire("5ARvW");
var $eT0WN = parcelRequire("eT0WN");

var $2eG9N = parcelRequire("2eG9N");

const $ad0d3127c7a37420$export$47e82d861696e68c = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $eT0WN.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $eUqFw.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $ad0d3127c7a37420$export$50fd17babcd996ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $eT0WN.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $eUqFw.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GeQ6.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
parcelRegister("fI650", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b28527f26e4865$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4kMup = parcelRequire("4kMup");

var $3Ucf8 = parcelRequire("3Ucf8");
const $f7b28527f26e4865$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $3Ucf8.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $f7b28527f26e4865$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($f7b28527f26e4865$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $f7b28527f26e4865$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.memo)($f7b28527f26e4865$var$WithRef);
var $f7b28527f26e4865$export$2e2bcd8739ae039 = $f7b28527f26e4865$var$LinkButton;

});

parcelRegister("5ARvW", function(module, exports) {

$parcel$export(module.exports, "Show", () => $c749d80f6b8dab23$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $9SiaN = parcelRequire("9SiaN");
function $c749d80f6b8dab23$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c749d80f6b8dab23$var$showAboveQueries = (0, $9SiaN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$showBelowQueries = (0, $9SiaN.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $c749d80f6b8dab23$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $c749d80f6b8dab23$var$defaultHiddenStyles,
            above && $c749d80f6b8dab23$var$showAboveQueries[above],
            below && $c749d80f6b8dab23$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("9SiaN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $gnQiH = parcelRequire("gnQiH");

var $4Ywu9 = parcelRequire("4Ywu9");
const $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("gnQiH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $8ce21554f3c8bfb7$export$2d293d9871c38e91);
const $8ce21554f3c8bfb7$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $8ce21554f3c8bfb7$export$2d293d9871c38e91 = Object.keys($8ce21554f3c8bfb7$export$e5ee4fe8b989fd09);
const $8ce21554f3c8bfb7$export$b7ed752a57b4177b = $8ce21554f3c8bfb7$export$2d293d9871c38e91[0];

});



const $d189205948d5eb28$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("kxVL6", function(module, exports) {

$parcel$export(module.exports, "getRoadmapSettingsUrl", () => $ca5ea108710e570b$export$5466ff98ef58e78a);
const $ca5ea108710e570b$export$5466ff98ef58e78a = (isCMP, projectKey, boardId)=>{
    const cmpRoadmapConfigUrl = `/jira/software/c/projects/${projectKey}/boards/${boardId}?config=timelineConfig`;
    const tmpRoadmapConfigUrl = `/jira/software/projects/${projectKey}/settings/boards/${boardId}/timeline`;
    return isCMP ? cmpRoadmapConfigUrl : tmpRoadmapConfigUrl;
};

});

parcelRegister("c9l8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e29f81924c7bba$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $41e29f81924c7bba$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreSettingsMenuLabel: {
        "id": "roadmap.standard-roadmap.header.more-settings.more-settings-menu-label",
        "defaultMessage": "More"
    },
    moreSettingsButtonLabel: {
        "id": "roadmap.standard-roadmap.header.more-settings.more-settings-button-label",
        "defaultMessage": "Configure Timeline"
    },
    feedbackButtonLabel: {
        "id": "roadmap.standard-roadmap.header.more-settings.feedback-button-label",
        "defaultMessage": "Give feedback"
    },
    feedbackCollectorTitle: {
        "id": "roadmap.standard-roadmap.header.more-settings.feedback-collector-title",
        "defaultMessage": "Give feedback to Atlassian"
    },
    feedbackCollectorDescription: {
        "id": "roadmap.standard-roadmap.header.more-settings.feedback-collector-description",
        "defaultMessage": "Select Jira Timeline feedback type"
    }
});

});



parcelRegister("daMD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f25ca57fff7bfc9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $lNNXV = parcelRequire("lNNXV");

var $lgKTA = parcelRequire("lgKTA");

var $f5J4J = parcelRequire("f5J4J");

var $56Mmd = parcelRequire("56Mmd");

var $7ITak = parcelRequire("7ITak");

var $bf3e6 = parcelRequire("bf3e6");
var $6f25ca57fff7bfc9$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        ShareModalWithAnalytics: $7ITak.default,
        roadmapAri: (0, $lgKTA.getSourceARI)(state) || (0, $f5J4J.getRoadmapAri)(state)
    }), {
    onExportCsv: (0, $56Mmd.exportCsv)
})((0, $bf3e6.default));

});
parcelRegister("f5J4J", function(module, exports) {

$parcel$export(module.exports, "getShareTableProps", () => $e84b7b5431d34c14$export$377240b7d7caf8d3);
$parcel$export(module.exports, "getRoadmapAri", () => $e84b7b5431d34c14$export$ad07c153802f7136);

var $eoER9 = parcelRequire("eoER9");

var $5wu2M = parcelRequire("5wu2M");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $9N1AA = parcelRequire("9N1AA");

var $11LHz = parcelRequire("11LHz");

var $1SuDz = parcelRequire("1SuDz");
const $e84b7b5431d34c14$var$additionalSpaceForAssigneeLozenge = (0, $5wu2M.MAX_LOZENGE_WIDTH);
const $e84b7b5431d34c14$export$377240b7d7caf8d3 = (0, $eoER9.createSelector)((0, $1SuDz.getItems), (0, $11LHz.getExpandedItems), (0, $bwVWW.getToday), (0, $9N1AA.getListWidth), (0, $1SuDz.getTableHeight), (0, $1SuDz.getItemHeight), (0, $1SuDz.getTableHeaderItems), (items, expandedItems, today, listWidth, listHeight, itemHeight, headerItems)=>({
        items: items,
        expandedItems: expandedItems,
        today: today,
        listWidth: listWidth + $e84b7b5431d34c14$var$additionalSpaceForAssigneeLozenge,
        listHeight: listHeight,
        itemHeight: itemHeight,
        headerItems: headerItems
    }));
const $e84b7b5431d34c14$export$9cd9650c80504278 = (0, $eoER9.createSelector)((0, $lgKTA.getCloudId), (cloudId)=>cloudId != null && cloudId !== '' ? `ari:cloud:jira:${cloudId}` : null);
const $e84b7b5431d34c14$export$ad07c153802f7136 = (0, $eoER9.createSelector)($e84b7b5431d34c14$export$9cd9650c80504278, (0, $bwVWW.getProjectId), (baseAri, projectId)=>{
    if (baseAri == null || baseAri === '' || projectId == null) return '';
    return `${baseAri}:project/${projectId}`;
});

});
parcelRegister("eoER9", function(module, exports) {

$parcel$export(module.exports, "createWeakMapSelector", () => $83d259675c776220$export$3a90d1d234e724b5);
$parcel$export(module.exports, "createSelector", () => $83d259675c776220$export$595d22ed68ca2841);
// @ts-expect-error - TS2305 - Module '"reselect"' has no exported member 'SelectorCreator'.

var $df4Sl = parcelRequire("df4Sl");

var $3X7pb = parcelRequire("3X7pb");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $83d259675c776220$var$weakMapMemoize = (func)=>{
    const memorizer = (0, $3X7pb.createMemorizer)();
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    return (...args)=>{
        const cached = memorizer.read(args);
        if (cached !== undefined) return (0, $3X7pb.toReturnValue)(cached);
        const result = func.apply(func, args);
        memorizer.store(args, result);
        return result;
    };
};
const $83d259675c776220$export$3a90d1d234e724b5 = (0, $df4Sl.createSelectorCreator)($83d259675c776220$var$weakMapMemoize);
const $83d259675c776220$export$595d22ed68ca2841 = (0, $df4Sl.createSelectorCreator)((0, $df4Sl.defaultMemoize));

});
parcelRegister("3X7pb", function(module, exports) {

$parcel$export(module.exports, "toReturnValue", () => $24f64c7d1be5459a$export$9f3707bed4fc53c8);
$parcel$export(module.exports, "createMemorizer", () => $24f64c7d1be5459a$export$9db09f4ba21f9d2a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$UNDEFINED = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$NULL = {};
const $24f64c7d1be5459a$export$7abc386bcfed62e1 = (key)=>{
    if (key === undefined) return $24f64c7d1be5459a$var$UNDEFINED;
    if (key === null) return $24f64c7d1be5459a$var$NULL;
    return key;
};
const $24f64c7d1be5459a$export$9f3707bed4fc53c8 = (x)=>{
    if (x === $24f64c7d1be5459a$var$UNDEFINED) return undefined;
    if (x === $24f64c7d1be5459a$var$NULL) return null;
    return x;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$getFromWeakMapChain = (args, index, map)=>{
    const element = map.get($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]));
    if (index < args.length - 1) {
        if (element) return $24f64c7d1be5459a$var$getFromWeakMapChain(args, index + 1, element);
        return undefined;
    }
    return element;
};
const $24f64c7d1be5459a$var$storeToEmptyWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const subMap = new WeakMap();
        map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), subMap);
        $24f64c7d1be5459a$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
    } else map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), result);
};
const $24f64c7d1be5459a$var$storeToWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const element = map.get($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]));
        if (element) $24f64c7d1be5459a$var$storeToWeakMapChain(args, index + 1, element, result);
        else {
            const subMap = new WeakMap();
            map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), subMap);
            // we know that from now on, all chain elements need to be new maps,
            // so we move to a slightly more performent recursion
            $24f64c7d1be5459a$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
        }
    } else map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), result);
};
const $24f64c7d1be5459a$export$9db09f4ba21f9d2a = ()=>{
    const weakMap = new WeakMap();
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store: (args, result)=>result !== undefined ? $24f64c7d1be5459a$var$storeToWeakMapChain(args, 0, weakMap, result) : $24f64c7d1be5459a$var$storeToWeakMapChain(args, 0, weakMap, $24f64c7d1be5459a$var$UNDEFINED),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        read: (args)=>$24f64c7d1be5459a$var$getFromWeakMapChain(args, 0, weakMap)
    };
};

});


parcelRegister("5wu2M", function(module, exports) {

$parcel$export(module.exports, "DATE_RANGE_LIMIT", () => $bffbd70dd59e43c0$export$3f8939c9b1d3b1e3);
$parcel$export(module.exports, "MAX_LOZENGE_WIDTH", () => $bffbd70dd59e43c0$export$c13c0c5385d46707);

var $gf0vG = parcelRequire("gf0vG");
const $bffbd70dd59e43c0$export$3f8939c9b1d3b1e3 = {
    [(0, $gf0vG.QUARTERS)]: 18,
    [(0, $gf0vG.MONTHS)]: 12,
    [(0, $gf0vG.WEEKS)]: 12
};
const $bffbd70dd59e43c0$export$c13c0c5385d46707 = 72;

});


parcelRegister("7ITak", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7997478021d123$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6489W = parcelRequire("6489W");

var $9TSrj = parcelRequire("9TSrj");

var $kz4bw = parcelRequire("kz4bw");

var $d2XCa = parcelRequire("d2XCa");
var $8e7997478021d123$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        ShareModal: $kz4bw.default,
        isDependenciesVisible: (0, $6489W.isDependenciesVisibleInQuery)(state),
        isProgressVisible: (0, $6489W.isProgressVisibleInQuery)(state),
        isWarningsVisible: (0, $6489W.isWarningsVisibleInQuery)(state),
        isReleasesVisible: (0, $6489W.isReleasesVisibleInQuery)(state),
        imageExportMetrics: (0, $9TSrj.getRoadmapImageExportMetrics)(state)
    }), {})((0, $d2XCa.default));

});
parcelRegister("9TSrj", function(module, exports) {

$parcel$export(module.exports, "getRoadmapImageExportMetrics", () => $8c260cd539502b6c$export$92ac8d7608dcdf31);
$parcel$export(module.exports, "getRoadmapLoadedAnalyticsData", () => $8c260cd539502b6c$export$e68fb6340167d9bb);

var $df4Sl = parcelRequire("df4Sl");

var $lgKTA = parcelRequire("lgKTA");

var $6FeJk = parcelRequire("6FeJk");

var $6489W = parcelRequire("6489W");

var $9ZLrP = parcelRequire("9ZLrP");

var $9E22T = parcelRequire("9E22T");

var $f5J4J = parcelRequire("f5J4J");

var $hjI8T = parcelRequire("hjI8T");

var $dAvSa = parcelRequire("dAvSa");
const $8c260cd539502b6c$export$8b3528166f5efd8a = (0, $df4Sl.createSelector)((0, $9ZLrP.getIssuesFilter), (0, $lgKTA.isClassic), ({ assignees: assignees, issueTypes: issueTypes, statuses: statuses, text: text, labels: labels, versions: versions, quickFilters: quickFilters, customFilters: customFilters, goals: goals }, isClassic)=>({
        assignees: assignees.length > 0,
        issueTypes: issueTypes.length > 0,
        statuses: statuses.length > 0,
        text: text.length > 0,
        labels: labels.length > 0,
        versions: versions.length > 0,
        quickFilters: quickFilters.length > 0,
        customFilters: customFilters.length > 0,
        isClassic: isClassic,
        goals: goals.length > 0
    }));
const $8c260cd539502b6c$export$92ac8d7608dcdf31 = (0, $df4Sl.createSelector)((0, $f5J4J.getShareTableProps), (0, $6FeJk.getIssueIds), $8c260cd539502b6c$export$8b3528166f5efd8a, (0, $dAvSa.getRoadmapImageExportMetrics));
const $8c260cd539502b6c$export$e68fb6340167d9bb = (0, $df4Sl.createSelector)([
    (0, $9ZLrP.getTimelineMode),
    $8c260cd539502b6c$export$8b3528166f5efd8a,
    (0, $6489W.isShared),
    (0, $9ZLrP.getLevelOneSetting),
    (0, $hjI8T.getHighlightedVersions),
    (0, $9E22T.getFilteredIssueCount)
], (timelineMode, filters, shared, levelOneSetting, highlightedVersions, filteredIssueCount)=>({
        shared: shared,
        timelineMode: timelineMode,
        filters: filters,
        levelOneSetting: levelOneSetting,
        highlightedVersionCount: highlightedVersions.length,
        filteredIssueCount: filteredIssueCount
    }));

});
parcelRegister("dAvSa", function(module, exports) {

$parcel$export(module.exports, "getRoadmapImageExportMetrics", () => $948277d23ba2e921$export$92ac8d7608dcdf31);
const $948277d23ba2e921$export$92ac8d7608dcdf31 = (shareTableProps, issueIds, filtersAnalyticsData)=>{
    let visibleStoriesCount = 0;
    const { items: items, expandedItems: expandedItems } = shareTableProps;
    items.forEach((item)=>{
        if (expandedItems[item.id]) visibleStoriesCount += item.childItems?.length ?? 0;
    });
    const visibleEpicsCount = items.length;
    return {
        filters: filtersAnalyticsData,
        visibleEpicsCount: visibleEpicsCount,
        visibleStoriesCount: visibleStoriesCount,
        issuesCount: issueIds.length
    };
};

});


parcelRegister("kz4bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed36f9619464973a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ed36f9619464973a$var$ShareModal = (0, $7rh0R.lazy)(()=>(parcelRequire("faY76")), {
    moduleId: "./src/packages/software/roadmap/standard/src/view/header/share/share-modal-with-analytics/share-modal/index.tsx"
});
const $ed36f9619464973a$var$AsyncShareModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-share-modal",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-share-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ed36f9619464973a$var$ShareModal, props)));
var $ed36f9619464973a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ed36f9619464973a$var$AsyncShareModal);

});
parcelRegister("faY76", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ifoZw")
]).then(()=>parcelRequire('5v52C'));

});


parcelRegister("d2XCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc47218d89a9d3a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
const $0bc47218d89a9d3a$var$ShareModalWithAnalytics = ({ isDependenciesVisible: isDependenciesVisible, isProgressVisible: isProgressVisible, isWarningsVisible: isWarningsVisible, isReleasesVisible: isReleasesVisible, imageExportMetrics: imageExportMetrics, ShareModal: ShareModal, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "share",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        attributes: {
            isDependenciesVisible: isDependenciesVisible,
            isProgressVisible: isProgressVisible,
            isWarningsVisible: isWarningsVisible,
            isReleasesVisible: isReleasesVisible,
            ...imageExportMetrics
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ShareModal, props));
var $0bc47218d89a9d3a$export$2e2bcd8739ae039 = $0bc47218d89a9d3a$var$ShareModalWithAnalytics;

});


parcelRegister("bf3e6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ab22f1be4c938fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $5oEc8 = parcelRequire("5oEc8");

var $eAa4t = parcelRequire("eAa4t");

var $dxopF = parcelRequire("dxopF");

var $9Amv1 = parcelRequire("9Amv1");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FP8W = parcelRequire("6FP8W");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eDgaT = parcelRequire("eDgaT");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $iSNkS = parcelRequire("iSNkS");

var $e40AO = parcelRequire("e40AO");

var $8rQuz = parcelRequire("8rQuz");

var $lB25E = parcelRequire("lB25E");

var $fm2hn = parcelRequire("fm2hn");

var $jmsCP = parcelRequire("jmsCP");
const $1ab22f1be4c938fc$var$ShareCustomTriggerButton = ({ isDisabled: isDisabled, isSelected: isSelected, onClick: onClick }, triggerProps)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
        label: formatMessage((0, $fm2hn.default).share),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5oEc8))),
        onClick: onClick,
        isDisabled: isDisabled,
        isSelected: isSelected,
        ...triggerProps
    });
};
const $1ab22f1be4c938fc$var$Share = ({ ShareModalWithAnalytics: ShareModalWithAnalytics, roadmapAri: roadmapAri, onExportCsv: onExportCsv })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [routerState] = (0, $lB25E.useRouter)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onModalOpen = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'exportImage clicked');
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
    }, []);
    const onExportCsvCallback = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'exportCsv clicked');
        onExportCsv({
            inferredStartDateHeader: formatMessage((0, $fm2hn.default).exportSpreadsheetInferredStartDate),
            inferredDueDateHeader: formatMessage((0, $fm2hn.default).exportSpreadsheetInferredDueDate)
        });
    }, [
        createAnalyticsEvent,
        onExportCsv,
        formatMessage
    ]);
    const exportButton = (0, $6FP8W.getWillShowNav4)() && (0, $1ybV0.ff)('timeline-export-as-spreadsheet_1mdsg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e40AO.ExportButton), {
        onExportCsv: onExportCsv,
        onExportAsImageClick: onModalOpen
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        // eslint-disable-next-line jira/react-no-inline-function-prop
        trigger: ({ triggerRef: triggerRef, ...props })=>// eslint-disable-next-line no-nested-ternary
            (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                label: formatMessage((0, $fm2hn.default).exportButton),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eAa4t))),
                ref: triggerRef,
                isTooltipDisabled: false,
                ...props
            }) : (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
                label: formatMessage((0, $fm2hn.default).exportButton),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eAa4t))),
                ref: triggerRef,
                ...props
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eAa4t))), {
                    label: formatMessage((0, $fm2hn.default).exportButtonIcon),
                    color: "currentColor",
                    spacing: "spacious"
                }),
                ref: triggerRef
            }, formatMessage((0, $fm2hn.default).exportButton))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onModalOpen
    }, formatMessage((0, $fm2hn.default).exportImagePng)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onExportCsvCallback
    }, formatMessage((0, $fm2hn.default).exportSpreadsheetCsv))));
    const shareButton = !(0, $eI5EY.fg)('common_project_actions_menu') && !(0, $8rQuz.isVisualRefreshEnabled)() && ((0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        integrationType: (0, $iSNkS.integrationTypes).ROADMAP,
        productId: "jira",
        subProductId: "jira-software",
        shareLink: (0, $jmsCP.getShareUrl)(routerState.location.pathname, routerState.location.search),
        shareTitle: formatMessage((0, $fm2hn.default).timeline),
        shareContentType: "roadmap",
        objectAri: roadmapAri,
        renderCustomTriggerButton: $1ab22f1be4c938fc$var$ShareCustomTriggerButton
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        integrationType: (0, $iSNkS.integrationTypes).ROADMAP,
        triggerButtonAppearance: "subtle",
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-software",
        shareLink: (0, $jmsCP.getShareUrl)(routerState.location.pathname, routerState.location.search),
        shareTitle: formatMessage((0, $fm2hn.default).timeline),
        shareContentType: "roadmap",
        objectAri: roadmapAri
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100"
    }, shareButton, exportButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ShareModalWithAnalytics, {
        onClose: onModalClose
    })));
};
var $1ab22f1be4c938fc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1ab22f1be4c938fc$var$Share);

});
parcelRegister("5oEc8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::238da1d3f1c6691c40bb15e631a6cdbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ede5f7f6efda26a$var$_react = $3ede5f7f6efda26a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3ede5f7f6efda26a$var$_share = $3ede5f7f6efda26a$var$_interopRequireDefault((parcelRequire("ec2xp")));

var $3ede5f7f6efda26a$var$_share2 = $3ede5f7f6efda26a$var$_interopRequireDefault((parcelRequire("dFWNP")));
function $3ede5f7f6efda26a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ede5f7f6efda26a$var$ShareIcon = (props)=>/*#__PURE__*/ $3ede5f7f6efda26a$var$_react.default.createElement($3ede5f7f6efda26a$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $3ede5f7f6efda26a$var$_share2.default
    }, props));
$3ede5f7f6efda26a$var$ShareIcon.Name = 'ShareIconMigration';
var $3ede5f7f6efda26a$var$_default = module.exports.default = $3ede5f7f6efda26a$var$ShareIcon;

});
parcelRegister("ec2xp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a55427aa389adc57$var$_react = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a55427aa389adc57$var$_UNSAFE_baseNew = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a55427aa389adc57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a55427aa389adc57$var$ShareIcon = (props)=>/*#__PURE__*/ $a55427aa389adc57$var$_react.default.createElement($a55427aa389adc57$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a55427aa389adc57$var$ShareIcon.displayName = 'ShareIcon';
var $a55427aa389adc57$var$_default = module.exports.default = $a55427aa389adc57$var$ShareIcon;

});

parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f4cb7ac67043f68$var$_share = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("ec2xp")));
function $9f4cb7ac67043f68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $9f4cb7ac67043f68$var$_share.default
    }));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = module.exports.default = $9f4cb7ac67043f68$var$ShareIcon;

});


parcelRegister("eAa4t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dee6396e12806214e5fd6f6b74ec1829>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9dc3d64ee8756d8$var$_react = $a9dc3d64ee8756d8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9dc3d64ee8756d8$var$_upload = $a9dc3d64ee8756d8$var$_interopRequireDefault((parcelRequire("3Mygk")));

var $a9dc3d64ee8756d8$var$_export = $a9dc3d64ee8756d8$var$_interopRequireDefault((parcelRequire("5oiKm")));
function $a9dc3d64ee8756d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for UploadIcon.
 * This component is UploadIcon, with `UNSAFE_fallbackIcon` set to "ExportIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9dc3d64ee8756d8$var$UploadIcon = (props)=>/*#__PURE__*/ $a9dc3d64ee8756d8$var$_react.default.createElement($a9dc3d64ee8756d8$var$_upload.default, Object.assign({
        LEGACY_fallbackIcon: $a9dc3d64ee8756d8$var$_export.default
    }, props));
$a9dc3d64ee8756d8$var$UploadIcon.Name = 'UploadIconMigration';
var $a9dc3d64ee8756d8$var$_default = module.exports.default = $a9dc3d64ee8756d8$var$UploadIcon;

});
parcelRegister("3Mygk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc22958da752d07e6dcf81116f518ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c106e989d1556d4$var$_react = $2c106e989d1556d4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2c106e989d1556d4$var$_UNSAFE_baseNew = $2c106e989d1556d4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $2c106e989d1556d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c106e989d1556d4$var$UploadIcon = (props)=>/*#__PURE__*/ $2c106e989d1556d4$var$_react.default.createElement($2c106e989d1556d4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
    }, props));
$2c106e989d1556d4$var$UploadIcon.displayName = 'UploadIcon';
var $2c106e989d1556d4$var$_default = module.exports.default = $2c106e989d1556d4$var$UploadIcon;

});

parcelRegister("5oiKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0103517d4ae70c89$var$_react = $0103517d4ae70c89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $0103517d4ae70c89$var$_upload = $0103517d4ae70c89$var$_interopRequireDefault((parcelRequire("3Mygk")));
function $0103517d4ae70c89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0103517d4ae70c89$var$ExportIcon = (props)=>/*#__PURE__*/ $0103517d4ae70c89$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $0103517d4ae70c89$var$_upload.default
    }));
$0103517d4ae70c89$var$ExportIcon.displayName = 'ExportIcon';
var $0103517d4ae70c89$var$_default = module.exports.default = $0103517d4ae70c89$var$ExportIcon;

});


parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8nUKh = parcelRequire("8nUKh");
const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lUmmJ")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("lUmmJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2xQrm")
]).then(()=>parcelRequire('iHQJU'));

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("e40AO", function(module, exports) {

$parcel$export(module.exports, "ExportButton", () => $2376c8730777df77$export$bec7fd3dce2f28c0);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $eAa4t = parcelRequire("eAa4t");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eDgaT = parcelRequire("eDgaT");

var $8rQuz = parcelRequire("8rQuz");

var $fEo0B = parcelRequire("fEo0B");
const $2376c8730777df77$export$bec7fd3dce2f28c0 = ({ onExportCsv: onExportCsv, onExportAsImageClick: onExportAsImageClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onExportCsvCallback = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'exportCsv clicked');
        onExportCsv({
            inferredStartDateHeader: formatMessage((0, $fEo0B.default).exportSpreadsheetInferredStartDate),
            inferredDueDateHeader: formatMessage((0, $fEo0B.default).exportSpreadsheetInferredDueDate)
        });
    }, [
        createAnalyticsEvent,
        onExportCsv,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                label: formatMessage((0, $fEo0B.default).exportButton),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eAa4t))),
                ref: triggerRef,
                isTooltipDisabled: false,
                ...props,
                testId: "roadmap.timeline-table-kit.ui.header.export.export-button"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
                label: formatMessage((0, $fEo0B.default).exportButton),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eAa4t))),
                ref: triggerRef,
                ...props
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onExportAsImageClick
    }, formatMessage((0, $fEo0B.default).exportImagePng)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onExportCsvCallback
    }, formatMessage((0, $fEo0B.default).exportSpreadsheetCsv))));
};

});
parcelRegister("fEo0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $57102765edd89b24$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $57102765edd89b24$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    exportButton: {
        "id": "roadmap.timeline-table-kit.header.export.export-button",
        "defaultMessage": "Export"
    },
    exportImagePng: {
        "id": "roadmap.timeline-table-kit.header.export.export-image-png",
        "defaultMessage": "Image (.png)"
    },
    exportSpreadsheetCsv: {
        "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-csv",
        "defaultMessage": "Spreadsheet (.csv)"
    },
    exportSpreadsheetInferredStartDate: {
        "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-inferred-start-date",
        "defaultMessage": "Inferred start date"
    },
    exportSpreadsheetInferredDueDate: {
        "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-inferred-due-date",
        "defaultMessage": "Inferred due date"
    }
});

});


parcelRegister("fm2hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4def194c7b35c9a5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4def194c7b35c9a5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    share: {
        "id": "roadmap.standard-roadmap.header.share.share",
        "defaultMessage": "Share"
    },
    export: {
        "id": "roadmap.standard-roadmap.header.share.export",
        "defaultMessage": "Export image"
    },
    exportButton: {
        "id": "roadmap.standard-roadmap.header.share.export-button",
        "defaultMessage": "Export"
    },
    exportImagePng: {
        "id": "roadmap.standard-roadmap.header.share.export-image-png",
        "defaultMessage": "Image (.png)"
    },
    exportSpreadsheetCsv: {
        "id": "roadmap.standard-roadmap.header.share.export-spreadsheet-csv",
        "defaultMessage": "Spreadsheet (.csv)"
    },
    exportButtonIcon: {
        "id": "roadmap.standard-roadmap.header.share.export-button-icon",
        "defaultMessage": "Export icon"
    },
    timeline: {
        "id": "roadmap.standard-roadmap.header.share.timeline",
        "defaultMessage": "Timeline"
    },
    exportSpreadsheetInferredStartDate: {
        "id": "roadmap.standard-roadmap.header.share.export-spreadsheet-inferred-start-date",
        "defaultMessage": "Inferred start date"
    },
    exportSpreadsheetInferredDueDate: {
        "id": "roadmap.standard-roadmap.header.share.export-spreadsheet-inferred-due-date",
        "defaultMessage": "Inferred due date"
    }
});

});

parcelRegister("jmsCP", function(module, exports) {

$parcel$export(module.exports, "getShareUrl", () => $aa0e1b2060d48452$export$3a81dd9bbf5c2322);
const $aa0e1b2060d48452$export$3a81dd9bbf5c2322 = (path, search)=>{
    const { hostname: hostname, protocol: protocol } = window.location;
    return `${protocol}//${hostname}${path}${search}${search !== '' && search !== undefined ? '&' : '?'}shared`;
};

});



parcelRegister("jX4Ux", function(module, exports) {

$parcel$export(module.exports, "default", () => $f683afc5357f4997$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");

var $c76ap = parcelRequire("c76ap");

var $3a8wJ = parcelRequire("3a8wJ");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kIY50 = parcelRequire("kIY50");

var $6FP8W = parcelRequire("6FP8W");

var $jK1pm = parcelRequire("jK1pm");

var $dfoAl = parcelRequire("dfoAl");

var $3PpXB = parcelRequire("3PpXB");

var $et9OO = parcelRequire("et9OO");
const $f683afc5357f4997$var$containerStylesOldNavigation = null;
const $f683afc5357f4997$var$containerStylesNewNavigation = null;
const $f683afc5357f4997$var$headerRowContainerStyles = null;
const $f683afc5357f4997$var$breadcrumbRowContainerStyles = null;
const $f683afc5357f4997$var$spacedHeaderRowContainerStyles = null;
const $f683afc5357f4997$var$RoadmapHeader = ({ Feedback: Feedback, Share: Share, Filters: Filters, isMacroView: isMacroView, ViewSettings: ViewSettings, MoreSettings: MoreSettings })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const ref = (0, $eUqFw.useRef)(null);
    (0, $dfoAl.useBreakpointCSSVariables)(ref, (0, $3PpXB.headerBreakpointOptions));
    const marginBottom = ()=>{
        if ((0, $6FP8W.getWillShowNav4)()) return `${(0, $c9TLT.gridSize) * 2}px`;
        return isMacroView ? `${(0, $c9TLT.gridSize) * 2}px` : `${(0, $c9TLT.gridSize) * 4}px`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-fullscreen-id": (0, $6FP8W.getWillShowNav4)() ? undefined : 'roadmap-header-container',
        className: (0, $7JEyt.default)([
            (0, $6FP8W.getWillShowNav4)() ? "_16jlidpf _1o9zidpf _i0dl1wug _u5f31ejb" : "_16jlidpf _1o9zidpf _i0dl1wug _u5f31ejb _11w3glyw"
        ])
    }, (0, $kIY50.getWillShowNav3)() && !isMacroView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        truncateTitle: true,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Feedback, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Share, null), MoreSettings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MoreSettings, null) : null),
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null))
    }, formatMessage((0, $et9OO.default).timeline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            marginBottom: marginBottom()
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            "_19pkpxbi _eedjidpf _1v0eidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "roadmap-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Filters, {
        isMacroView: isMacroView
    })), (0, $6FP8W.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100"
    }, !isMacroView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Share, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewSettings, null), MoreSettings && !isMacroView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MoreSettings, null) : null), (0, $kIY50.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewSettings, null)));
};
$f683afc5357f4997$var$RoadmapHeader.defaultProps = {
    isMacroView: false
};
var $f683afc5357f4997$export$2e2bcd8739ae039 = $f683afc5357f4997$var$RoadmapHeader;

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("dfoAl", function(module, exports) {

$parcel$export(module.exports, "useBreakpointCSSVariables", () => $826eaba3d76b9953$export$695e30b23e1ef1ba);

var $eUqFw = parcelRequire("eUqFw");

var $4vTMF = parcelRequire("4vTMF");

var $lxTPV = parcelRequire("lxTPV");
const $826eaba3d76b9953$var$toPropertyName = (name)=>`--${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(name)}`;
const $826eaba3d76b9953$var$setVariables = (element, variables)=>{
    Object.keys(variables).forEach((key)=>{
        const property = $826eaba3d76b9953$var$toPropertyName(key);
        const value = variables[key];
        element.style.setProperty(property, value);
    });
};
const $826eaba3d76b9953$export$695e30b23e1ef1ba = (ref, options)=>{
    const { breakpoint: breakpoint, above: above, below: below } = options;
    const flag = (0, $eUqFw.useRef)(null);
    const evalWidth = (0, $eUqFw.useCallback)((width)=>{
        const element = ref.current;
        if (!element) return;
        const isAbove = width > breakpoint;
        if (flag.current !== null && isAbove === flag.current) return;
        flag.current = isAbove;
        const variables = isAbove ? above : below;
        $826eaba3d76b9953$var$setVariables(element, variables);
    }, [
        above,
        below,
        breakpoint,
        ref
    ]);
    (0, $lxTPV.useResizeObserver)(ref, (entry)=>{
        const { width: width } = entry.contentRect;
        evalWidth(width);
    });
};

});
parcelRegister("lxTPV", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $da56429240398c07$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");
let $da56429240398c07$var$resizeObserver;
const $da56429240398c07$var$callbacks = new Map();
const $da56429240398c07$var$runCallbacks = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target } = entry;
        const callback = $da56429240398c07$var$callbacks.get(target);
        callback?.(entry);
    });
};
const $da56429240398c07$export$9137ee61fe58d50e = (target, callback)=>{
    if (typeof ResizeObserver === 'undefined') return;
    if (!$da56429240398c07$var$resizeObserver) $da56429240398c07$var$resizeObserver = new ResizeObserver($da56429240398c07$var$runCallbacks);
    $da56429240398c07$var$callbacks.set(target, callback);
    $da56429240398c07$var$resizeObserver.observe(target);
};
const $da56429240398c07$export$4d125402ac99f1b = (target)=>{
    if (!$da56429240398c07$var$resizeObserver) return;
    $da56429240398c07$var$callbacks.delete(target);
    $da56429240398c07$var$resizeObserver.unobserve(target);
};
const $da56429240398c07$export$683480f191c0e3ea = (ref, callback)=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        const element = ref.current;
        element && $da56429240398c07$export$9137ee61fe58d50e(element, callback);
        return ()=>{
            element && $da56429240398c07$export$4d125402ac99f1b(element);
        };
    }, [
        ref,
        callback
    ]);
};

});


parcelRegister("3PpXB", function(module, exports) {

$parcel$export(module.exports, "headerBreakpointOptions", () => $84128903087a85c8$export$289323b1807e3857);
const $84128903087a85c8$export$289323b1807e3857 = {
    breakpoint: 1140,
    above: {
        largeButtonVisibility: 'block',
        smallButtonVisibility: 'none'
    },
    below: {
        largeButtonVisibility: 'none',
        smallButtonVisibility: 'block'
    }
};

});

parcelRegister("et9OO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ad6ddb362105009$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3ad6ddb362105009$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeline: {
        "id": "roadmap.standard-roadmap.header.timeline",
        "defaultMessage": "Timeline"
    }
});

});


parcelRegister("6P3e2", function(module, exports) {

$parcel$export(module.exports, "default", () => $04dafc6059006ba7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $hm0MI = parcelRequire("hm0MI");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FP8W = parcelRequire("6FP8W");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eDgaT = parcelRequire("eDgaT");

var $8rQuz = parcelRequire("8rQuz");

var $41Run = parcelRequire("41Run");

var $5Evw7 = parcelRequire("5Evw7");

var $2avND = parcelRequire("2avND");
const $04dafc6059006ba7$var$ViewSettings = ()=>{
    const [viewSettingsOpen, setViewSettingsOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const toggleViewSettings = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `viewSettings ${viewSettingsOpen ? 'closed' : 'opened'}`);
        setViewSettingsOpen(!viewSettingsOpen);
    }, [
        createAnalyticsEvent,
        viewSettingsOpen
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'viewSettings closed');
        setViewSettingsOpen(false);
    }, [
        createAnalyticsEvent
    ]);
    const renderTrigger = (0, $eUqFw.useCallback)((triggerProps)=>// eslint-disable-next-line no-nested-ternary
        (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            isSelected: viewSettingsOpen,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hm0MI))),
            onClick: toggleViewSettings,
            label: formatMessage((0, $5Evw7.default).viewSettings),
            ...triggerProps
        }) : (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
            isSelected: viewSettingsOpen,
            onClick: toggleViewSettings,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hm0MI))),
            label: formatMessage((0, $5Evw7.default).viewSettings),
            ...triggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $41Run.default), {
            isSelected: viewSettingsOpen,
            onClick: toggleViewSettings
        })), [
        viewSettingsOpen,
        toggleViewSettings,
        formatMessage
    ]);
    const renderContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2avND.default), {
            onClose: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        placement: "bottom-end",
        isOpen: viewSettingsOpen,
        onClose: onClose,
        trigger: renderTrigger,
        content: renderContent,
        shouldUseCaptureOnOutsideClick: true
    });
};
var $04dafc6059006ba7$export$2e2bcd8739ae039 = $04dafc6059006ba7$var$ViewSettings;

});
parcelRegister("hm0MI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0471165b1411c9e3d53c4e3bf136cbc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca251996f2fd3c65$var$_react = $ca251996f2fd3c65$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca251996f2fd3c65$var$_customize = $ca251996f2fd3c65$var$_interopRequireDefault((parcelRequire("hmbTp")));

var $ca251996f2fd3c65$var$_preferences = $ca251996f2fd3c65$var$_interopRequireDefault((parcelRequire("fUQgT")));
function $ca251996f2fd3c65$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca251996f2fd3c65$var$CustomizeIcon = (props)=>/*#__PURE__*/ $ca251996f2fd3c65$var$_react.default.createElement($ca251996f2fd3c65$var$_customize.default, Object.assign({
        LEGACY_fallbackIcon: $ca251996f2fd3c65$var$_preferences.default
    }, props));
$ca251996f2fd3c65$var$CustomizeIcon.Name = 'CustomizeIconMigration';
var $ca251996f2fd3c65$var$_default = module.exports.default = $ca251996f2fd3c65$var$CustomizeIcon;

});
parcelRegister("hmbTp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78335b71c0abb01e55fd286b4fa17edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca2db75d20af6d54$var$_react = $ca2db75d20af6d54$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca2db75d20af6d54$var$_UNSAFE_baseNew = $ca2db75d20af6d54$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $ca2db75d20af6d54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca2db75d20af6d54$var$CustomizeIcon = (props)=>/*#__PURE__*/ $ca2db75d20af6d54$var$_react.default.createElement($ca2db75d20af6d54$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
    }, props));
$ca2db75d20af6d54$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $ca2db75d20af6d54$var$_default = module.exports.default = $ca2db75d20af6d54$var$CustomizeIcon;

});

parcelRegister("fUQgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b964a2018cb4a0d7$var$_react = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b964a2018cb4a0d7$var$_customize = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("hmbTp")));
function $b964a2018cb4a0d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b964a2018cb4a0d7$var$PreferencesIcon = (props)=>/*#__PURE__*/ $b964a2018cb4a0d7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $b964a2018cb4a0d7$var$_customize.default
    }));
$b964a2018cb4a0d7$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $b964a2018cb4a0d7$var$_default = module.exports.default = $b964a2018cb4a0d7$var$PreferencesIcon;

});


parcelRegister("41Run", function(module, exports) {

$parcel$export(module.exports, "default", () => $b39f27ab17587fbd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $fUQgT = parcelRequire("fUQgT");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $75e8i = parcelRequire("75e8i");

var $5Evw7 = parcelRequire("5Evw7");
const $b39f27ab17587fbd$export$805802ea39f3d804 = ({ isSelected: isSelected, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $75e8i.default)('timeline-view-settings-clicked', event.timeStamp);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewSettingsButton');
        onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b39f27ab17587fbd$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b39f27ab17587fbd$var$largeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "roadmap.standard-roadmap.header.view-settings.button.large",
        "aria-label": formatMessage((0, $5Evw7.default).viewSettings),
        appearance: "default",
        isSelected: isSelected,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: ""
        })
    }, formatMessage((0, $5Evw7.default).viewSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b39f27ab17587fbd$var$smallButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $5Evw7.default).viewSettings)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "roadmap.standard-roadmap.header.view-settings.button.small",
        "aria-label": formatMessage((0, $5Evw7.default).viewSettings),
        appearance: "default",
        isSelected: isSelected,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: ""
        })
    }))));
};
var $b39f27ab17587fbd$export$2e2bcd8739ae039 = $b39f27ab17587fbd$export$805802ea39f3d804;
const $b39f27ab17587fbd$var$largeButtonStyles = (0, $1ZAYh.xcss)({
    display: 'var(--large-button-visibility, none)',
    [(0, $4Ywu9.media).above.md]: {
        display: 'var(--large-button-visibility, block)'
    }
});
const $b39f27ab17587fbd$var$smallButtonStyles = (0, $1ZAYh.xcss)({
    display: 'var(--small-button-visibility, block)',
    [(0, $4Ywu9.media).above.md]: {
        display: 'var(--small-button-visibility, none)'
    }
});
const $b39f27ab17587fbd$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("5Evw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3763aabf33ca3371$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3763aabf33ca3371$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewSettings: {
        "id": "roadmap.standard-roadmap.header.view-settings.button.view-settings",
        "defaultMessage": "View settings"
    }
});

});


parcelRegister("2avND", function(module, exports) {

$parcel$export(module.exports, "default", () => $475ffde5946a0667$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

var $jcgv1 = parcelRequire("jcgv1");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $475ffde5946a0667$var$LazyViewSettingsMenu = (0, $7rh0R.lazy)(()=>(parcelRequire("cRBN8")), {
    moduleId: "./src/packages/software/roadmap/standard/src/view/header/view-settings/menu/view.tsx"
});
const $475ffde5946a0667$var$ViewSettingsMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-view-settings-menu",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-view-settings-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcgv1.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($475ffde5946a0667$var$LazyViewSettingsMenu, props)));
var $475ffde5946a0667$export$2e2bcd8739ae039 = $475ffde5946a0667$var$ViewSettingsMenu;

});
parcelRegister("jcgv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a487c34418972d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bwVWW = parcelRequire("bwVWW");

var $jG0OB = parcelRequire("jG0OB");
var $a9a487c34418972d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        isReleasesFeatureEnabled: (0, $bwVWW.getIsReleasesFeatureEnabled)(state)
    }), {})((0, $jG0OB.default));

});
parcelRegister("jG0OB", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe26175bd61c289$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9VPEO = parcelRequire("9VPEO");
const $abe26175bd61c289$var$Toggle = ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$ToggleItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: width,
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$ToggleButton, {
        width: "32px",
        height: "16px"
    }));
const $abe26175bd61c289$var$ViewSettingsMenuSkeleton = ({ isReleasesFeatureEnabled: isReleasesFeatureEnabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$SectionTitle, {
        width: "85px",
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Toggle, {
        width: "130px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Item, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "240px",
        height: "32px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$WrapTextItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "350px",
        height: "14.5px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "120px",
        height: "14.5px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$ButtonItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "100px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$ButtonItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "110px",
        height: "16px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$SectionTitle, {
        width: "80px",
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Toggle, {
        width: "80px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Toggle, {
        width: "70px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Toggle, {
        width: "75px"
    }), isReleasesFeatureEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$Toggle, {
        width: "70px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abe26175bd61c289$var$LearnMoreItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "240px",
        height: "16px"
    })));
var $abe26175bd61c289$export$2e2bcd8739ae039 = $abe26175bd61c289$var$ViewSettingsMenuSkeleton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abe26175bd61c289$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1kdj",
            __cmplp.className
        ])
    });
});
const $abe26175bd61c289$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt437zh _1pnm1uzb",
            __cmplp.className
        ])
    });
});
const $abe26175bd61c289$var$Item = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _vchhusvi _1tke1ejb _18s81bpf",
            __cmplp.className
        ])
    });
});
const $abe26175bd61c289$var$ToggleItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $abe26175bd61c289$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1f4h _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $abe26175bd61c289$var$WrapTextItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $abe26175bd61c289$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _zulp1b66",
            __cmplp.className
        ])
    });
});
const $abe26175bd61c289$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $abe26175bd61c289$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _4cvr1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41bpf",
            __cmplp.className
        ])
    });
});
const $abe26175bd61c289$var$LearnMoreItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $abe26175bd61c289$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41hrj",
            __cmplp.className
        ])
    });
});
const $abe26175bd61c289$var$SectionTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkdlk8 _2hwxidpf _otyri2wt _18u0idpf",
            __cmplp.className
        ])
    });
});
const $abe26175bd61c289$var$ToggleButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81b66 _2rko7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $73a5c9d720aa66e1$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});



parcelRegister("cRBN8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("2NVMR")
]).then(()=>parcelRequire('cyy5E'));

});




parcelRegister("7TkUZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6990412e08d02521$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $jewDJ = parcelRequire("jewDJ");

var $2r8PJ = parcelRequire("2r8PJ");
const $6990412e08d02521$var$HealthcheckWithContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "healthcheck",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r8PJ.default), {
        Indicator: (0, $jewDJ.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
var $6990412e08d02521$export$2e2bcd8739ae039 = $6990412e08d02521$var$HealthcheckWithContext;

});
parcelRegister("jewDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1503ed529b2106d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

var $1w1jd = parcelRequire("1w1jd");

const $d1503ed529b2106d$var$ResolveHealthcheck = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("iUSx5")), {
    moduleId: "./src/packages/software/roadmap/standard/src/view/healthcheck/unified-healthcheck/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1503ed529b2106d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-unified-healthcheck",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-unified-healthcheck",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1w1jd.default), {
            imageSize: "default",
            paragraphHeight: 65
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d1503ed529b2106d$var$ResolveHealthcheck, null)));

});
parcelRegister("1w1jd", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea839fb0f44451f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");

var $iHXjC = parcelRequire("iHXjC");

var $jxYQF = parcelRequire("jxYQF");
const $dea839fb0f44451f$var$DEFAULT_IMAGE_SIZE = 'default';
const $dea839fb0f44451f$var$LARGE_IMAGE_SIZE = 'large';
const $dea839fb0f44451f$var$headerStyles = null;
const $dea839fb0f44451f$var$paragraphSkeletonStyles = null;
const $dea839fb0f44451f$var$HealthcheckSkeleton = ({ imageSize: imageSize, paragraphHeight: paragraphHeight })=>{
    const imgWidth = imageSize === $dea839fb0f44451f$var$DEFAULT_IMAGE_SIZE ? (0, $jxYQF.DEFAULT_IMAGE_WIDTH) : (0, $jxYQF.LARGE_IMAGE_WIDTH);
    const imgHeight = imageSize === $dea839fb0f44451f$var$DEFAULT_IMAGE_SIZE ? (0, $jxYQF.DEFAULT_IMAGE_HEIGHT) : (0, $jxYQF.LARGE_IMAGE_HEIGHT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxYQF.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        style: {
            width: `${imgWidth}px`,
            height: `${imgHeight}px`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsb1w8u"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHXjC.H700MCompiled), {
        className: (0, $7JEyt.default)([
            "_1bsb1w8u"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        style: {
            height: `${paragraphHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_1bsb1lk2 _19pkv47k"
        ])
    }));
};
var $dea839fb0f44451f$export$2e2bcd8739ae039 = $dea839fb0f44451f$var$HealthcheckSkeleton;

});
parcelRegister("iHXjC", function(module, exports) {

$parcel$export(module.exports, "PlainText", () => $feeb9bf8217ab604$export$f6d32c6d49be0014);
$parcel$export(module.exports, "Paragraph", () => $feeb9bf8217ab604$export$358a232cca1ab2ac);
$parcel$export(module.exports, "H300", () => $feeb9bf8217ab604$export$f36868a89c031e58);
$parcel$export(module.exports, "H500", () => $feeb9bf8217ab604$export$377ef4361b3db48f);
$parcel$export(module.exports, "PlainTextCompiled", () => $feeb9bf8217ab604$export$e6dbad138f5bdf17);
$parcel$export(module.exports, "H400Compiled", () => $feeb9bf8217ab604$export$892b8de9d7e14f37);
$parcel$export(module.exports, "H700MCompiled", () => $feeb9bf8217ab604$export$53b7b049cff342cb);
/* text.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $9VPEO = parcelRequire("9VPEO");
const $feeb9bf8217ab604$export$e2253033e6e1df16 = /*#__PURE__*/ (0, $kwce8.default)((0, $9VPEO.Skeleton)).withConfig({
    componentId: "p93our-0"
})({
    width: '100%'
});
const $feeb9bf8217ab604$export$f6d32c6d49be0014 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-1"
})({
    height: '14px',
    marginBottom: "var(--ds-space-075, 6px)"
});
const $feeb9bf8217ab604$export$358a232cca1ab2ac = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "p93our-2"
})`width:100%;margin-top:${"var(--ds-space-150, 12px)"};& > ${$feeb9bf8217ab604$export$f6d32c6d49be0014}{margin:0;}& > ${$feeb9bf8217ab604$export$f6d32c6d49be0014} + ${$feeb9bf8217ab604$export$f6d32c6d49be0014}{margin-top:3px;}`;
const $feeb9bf8217ab604$export$7465ee154025f712 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-3"
})({
    height: '11px',
    marginTop: "var(--ds-space-025, 2px)",
    marginBottom: '3px'
});
const $feeb9bf8217ab604$export$a5fc4a344b34831f = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$7465ee154025f712).withConfig({
    componentId: "p93our-4"
})({
    marginTop: '18px'
});
const $feeb9bf8217ab604$export$cf375857a047f134 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-5"
})({
    height: '12px',
    marginTop: "var(--ds-space-025, 2px)",
    marginBottom: "var(--ds-space-025, 2px)"
});
const $feeb9bf8217ab604$export$234850447241d4be = $feeb9bf8217ab604$export$a5fc4a344b34831f;
const $feeb9bf8217ab604$export$d65da85d43adf958 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$cf375857a047f134).withConfig({
    componentId: "p93our-6"
})({
    marginTop: '18px'
});
const $feeb9bf8217ab604$export$f36868a89c031e58 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-7"
})({
    height: '12px',
    marginTop: "var(--ds-space-025, 2px)",
    marginBottom: "var(--ds-space-025, 2px)"
});
const $feeb9bf8217ab604$export$5863115a55e7a278 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$f36868a89c031e58).withConfig({
    componentId: "p93our-8"
})({
    marginTop: '22px'
});
const $feeb9bf8217ab604$export$6c2738d775286d02 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-9"
})({
    height: '14px',
    marginTop: '1px',
    marginBottom: '1px'
});
const $feeb9bf8217ab604$export$4b8e008fe165f543 = $feeb9bf8217ab604$export$d65da85d43adf958;
const $feeb9bf8217ab604$export$a46c8598b69fa9c9 = $feeb9bf8217ab604$export$5863115a55e7a278;
const $feeb9bf8217ab604$export$655c11a59e0fb8b7 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$6c2738d775286d02).withConfig({
    componentId: "p93our-10"
})({
    marginTop: '17px'
});
const $feeb9bf8217ab604$export$225af344711a2ee8 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$655c11a59e0fb8b7).withConfig({
    componentId: "p93our-11"
})({
    marginTop: '27px',
    marginBottom: '3px'
});
const $feeb9bf8217ab604$export$377ef4361b3db48f = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-12"
})({
    height: '20px'
});
const $feeb9bf8217ab604$export$9af2972d81bc22d4 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$377ef4361b3db48f).withConfig({
    componentId: "p93our-13"
})({
    marginTop: '26px'
});
const $feeb9bf8217ab604$export$d5a20b614606407a = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$9af2972d81bc22d4).withConfig({
    componentId: "p93our-14"
})({
    marginTop: '36px',
    marginBottom: "var(--ds-space-050, 4px)"
});
const $feeb9bf8217ab604$export$1fb177267a8ebba2 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-15"
})({
    height: '20px',
    marginTop: "var(--ds-space-025, 2px)",
    marginBottom: "var(--ds-space-025, 2px)"
});
const $feeb9bf8217ab604$export$5ad8b93a781ab376 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$1fb177267a8ebba2).withConfig({
    componentId: "p93our-16"
})({
    marginTop: '30px'
});
const $feeb9bf8217ab604$export$8fca2a02d1129baa = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$5ad8b93a781ab376).withConfig({
    componentId: "p93our-17"
})({
    marginTop: '38px'
});
const $feeb9bf8217ab604$export$47d8e8f28b07dbe6 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-18"
})({
    height: '24px',
    marginTop: "var(--ds-space-025, 2px)",
    marginBottom: "var(--ds-space-025, 2px)"
});
const $feeb9bf8217ab604$export$8cf550a6494f0a95 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$47d8e8f28b07dbe6).withConfig({
    componentId: "p93our-19"
})({
    marginTop: '42px'
});
const $feeb9bf8217ab604$export$11421df4b306eac5 = $feeb9bf8217ab604$export$8cf550a6494f0a95;
const $feeb9bf8217ab604$export$f79dd616b4b7940 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-20"
})({
    height: '29px',
    marginTop: '1px',
    marginBottom: "var(--ds-space-025, 2px)"
});
const $feeb9bf8217ab604$export$1673bc4956a0d574 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$f79dd616b4b7940).withConfig({
    componentId: "p93our-21"
})({
    marginTop: '41px'
});
const $feeb9bf8217ab604$export$23912bec87db0a67 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$1673bc4956a0d574).withConfig({
    componentId: "p93our-22"
})({
    marginTop: '49px'
});
const $feeb9bf8217ab604$export$4f15f48a88de4246 = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$e2253033e6e1df16).withConfig({
    componentId: "p93our-23"
})({
    height: '35px',
    marginTop: "var(--ds-space-025, 2px)",
    marginBottom: '3px'
});
const $feeb9bf8217ab604$export$7d09a8e3c995666f = /*#__PURE__*/ (0, $kwce8.default)($feeb9bf8217ab604$export$4f15f48a88de4246).withConfig({
    componentId: "p93our-24"
})({
    marginTop: '54px'
});
const $feeb9bf8217ab604$export$7e32c7deacf14279 = $feeb9bf8217ab604$export$7d09a8e3c995666f;
const $feeb9bf8217ab604$export$b0895c0bfbd1ffb8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$e6dbad138f5bdf17 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3idlk8 _otyr12x7",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$7c050ac4f729d35 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkutpp",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$33ebdec21c095f6e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1skh _19pkv77o _otyr1l7b",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$82a6f7cce44c254 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$33ebdec21c095f6e, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkf6fq",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$e61e2190cb48676b = $feeb9bf8217ab604$export$82a6f7cce44c254;
const $feeb9bf8217ab604$export$8c60685913d30500 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1crf _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$f82bfe67e6a089e6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$8c60685913d30500, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkf6fq",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$350917bb6067b798 = $feeb9bf8217ab604$export$f82bfe67e6a089e6;
const $feeb9bf8217ab604$export$eb27f46149e3e85a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1crf _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$fd72e0c4b34be76a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$eb27f46149e3e85a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkqslr",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$bfaabc8568c580b1 = $feeb9bf8217ab604$export$fd72e0c4b34be76a;
const $feeb9bf8217ab604$export$892b8de9d7e14f37 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3idlk8 _19pkt94y _otyrt94y",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$9f435470752d8e4b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$892b8de9d7e14f37, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkl52n",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$f9230dd2e3259be0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$9f435470752d8e4b, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkd4y9 _otyr1l7b",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$ef0a9f1262ddb059 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3igktf",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$3306f1638a65aa25 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$ef0a9f1262ddb059, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ou6",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$8fbd282ac52a8998 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$3306f1638a65aa25, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk14no _otyr1b66",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$7966954511c1edb6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3igktf _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$576c433bd0b626fd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$7966954511c1edb6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ul9",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$594a18f5d65c77d1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$576c433bd0b626fd, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk10mc",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$bd4f20a0c6dc0659 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$53b7b049cff342cb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$bd4f20a0c6dc0659, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkor1b",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$957ddfeb34e9bf68 = $feeb9bf8217ab604$export$53b7b049cff342cb;
const $feeb9bf8217ab604$export$675af1e83e93897e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1pa9 _19pkt94y _otyrv77o",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$19ab514bc0674f75 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$675af1e83e93897e, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpzf8",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$8293db07860f297 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$19ab514bc0674f75, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk189y",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$a3699bd2412e4867 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ildb6 _19pkv77o _otyr1l7b",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$e3181bb29e80b5f3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $feeb9bf8217ab604$export$a3699bd2412e4867, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1l27",
            __cmplp.className
        ])
    });
});
const $feeb9bf8217ab604$export$1b6e300f10774868 = $feeb9bf8217ab604$export$e3181bb29e80b5f3;

});

parcelRegister("jxYQF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $458a593077591f93$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $458a593077591f93$export$da894f7669b4e67c);
$parcel$export(module.exports, "LARGE_IMAGE_WIDTH", () => $458a593077591f93$export$9069cbcb36903e62);
$parcel$export(module.exports, "LARGE_IMAGE_HEIGHT", () => $458a593077591f93$export$66157be652bb2e88);
$parcel$export(module.exports, "Content", () => $458a593077591f93$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Messages", () => $458a593077591f93$export$ceaacf8b390a3600);
$parcel$export(module.exports, "Title", () => $458a593077591f93$export$f99233281efd08a0);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");
const $458a593077591f93$export$6cccba5fae1d609d = 500;
const $458a593077591f93$export$a38d4ef0bccda3ff = 221;
const $458a593077591f93$export$d722b7527b1834a8 = 235;
const $458a593077591f93$export$da894f7669b4e67c = 138;
const $458a593077591f93$export$9069cbcb36903e62 = 344;
const $458a593077591f93$export$66157be652bb2e88 = 167;
const $458a593077591f93$export$7c6e2c02157bb7d2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        justifyContent: "start",
        alignItems: "center",
        xcss: $458a593077591f93$var$ContentStyles
    }, children);
const $458a593077591f93$export$ceaacf8b390a3600 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $458a593077591f93$var$MessagesStyles
    }, children);
const $458a593077591f93$export$f99233281efd08a0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $458a593077591f93$var$TitleComponentStyle
    }, children));
const $458a593077591f93$var$ContentStyles = (0, $1ZAYh.xcss)({
    width: `${$458a593077591f93$export$6cccba5fae1d609d}px`
});
const $458a593077591f93$var$MessagesStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    textAlign: 'center',
    marginTop: 'space.250',
    marginBottom: 'space.250'
});
const $458a593077591f93$var$TitleComponentStyle = (0, $1ZAYh.xcss)({
    marginTop: 'space.500',
    textAlign: 'center'
});

});


parcelRegister("iUSx5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ilLIF")
]).then(()=>parcelRequire('8yap0'));

});


parcelRegister("2r8PJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f67015eea1dd04b7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c76ap = parcelRequire("c76ap");

var $3a8wJ = parcelRequire("3a8wJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cuMSH = parcelRequire("cuMSH");
const $f67015eea1dd04b7$var$Healthcheck = ({ Indicator: Indicator })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        truncateTitle: true,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f67015eea1dd04b7$var$PageHeaderContainer, null, formatMessage((0, $cuMSH.default).timeline))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f67015eea1dd04b7$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Indicator, null)));
};
var $f67015eea1dd04b7$export$2e2bcd8739ae039 = $f67015eea1dd04b7$var$Healthcheck;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f67015eea1dd04b7$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _2lx21bp4 _1bah1y6m _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f67015eea1dd04b7$var$PageHeaderContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cuMSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40d774b12d5b04c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f40d774b12d5b04c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeline: {
        "id": "roadmap.standard-roadmap.healthcheck.timeline",
        "defaultMessage": "Timeline"
    }
});

});



parcelRegister("bwWcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc4a214e8fa9b316$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9TSrj = parcelRequire("9TSrj");

var $jCRwX = parcelRequire("jCRwX");
var $dc4a214e8fa9b316$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        attributes: (0, $9TSrj.getRoadmapLoadedAnalyticsData)(state)
    }), {})((0, $jCRwX.default));

});
parcelRegister("jCRwX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bcc6662f7b48c19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $gd0Sp = parcelRequire("gd0Sp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5bcc6662f7b48c19$export$2e2bcd8739ae039 = ({ attributes: attributes })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const fireRoadmapViewedAnalytic = (analyticsEvent)=>(0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'roadmap viewed', {
            ...attributes,
            theme: colorMode,
            isSiteAdmin: isSiteAdmin
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireRoadmapViewedAnalytic
    });
};

});


parcelRegister("2fGx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $769d93bcefcff65c$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $5iWql = parcelRequire("5iWql");

var $lNNXV = parcelRequire("lNNXV");

var $6heO3 = parcelRequire("6heO3");

var $1gs0D = parcelRequire("1gs0D");

var $iTFZo = parcelRequire("iTFZo");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");

var $g1CaY = parcelRequire("g1CaY");

var $8Igdg = parcelRequire("8Igdg");
const $769d93bcefcff65c$var$mapStateToProps = (state)=>({
        cloudId: (0, $lgKTA.getCloudId)(state) || '',
        projectId: (0, $bwVWW.getProjectId)(state),
        channels: (0, $8Igdg.getRealtimeChannels)(state)
    });
const $769d93bcefcff65c$var$mapDispatchToProps = {
    dispatchRealtimeEvent: $g1CaY.dispatchRealtimeEvent
};
const $769d93bcefcff65c$var$onReceiveFactory = (0, $5iWql.default)((dispatchPropsDispatchRealtimeEvent)=>(event)=>{
        if (event) dispatchPropsDispatchRealtimeEvent(event);
    });
const $769d93bcefcff65c$export$9d1611c77c2fe928 = (stateProps, dispatchProps)=>({
        appId: (0, $1gs0D.ROADMAP_APP_ID),
        channels: stateProps.channels,
        events: (0, $iTFZo.REALTIME_EVENTS),
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onReceive: $769d93bcefcff65c$var$onReceiveFactory(dispatchProps.dispatchRealtimeEvent),
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });
var $769d93bcefcff65c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($769d93bcefcff65c$var$mapStateToProps, $769d93bcefcff65c$var$mapDispatchToProps, $769d93bcefcff65c$export$9d1611c77c2fe928)((0, $6heO3.default));

});
parcelRegister("6heO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb89aa8c6039d680$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fLHAD = parcelRequire("fLHAD");

var $2W6nG = parcelRequire("2W6nG");
class $eb89aa8c6039d680$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2W6nG.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLHAD.RealtimeClient), {
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args);
        this.onEventReceive = (eventType, payload)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event);
        };
    }
}

});
parcelRegister("fLHAD", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $42b77c4aa56216fa$export$e680ceb7b9fcc184);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $g8JvH = parcelRequire("g8JvH");

var $efKIh = parcelRequire("efKIh");

var $6yVT4 = parcelRequire("6yVT4");
// eslint-disable-next-line jira/react/no-class-components
class $42b77c4aa56216fa$var$RealtimeClientView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.onReceiveEvent = (event, payload)=>{
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        };
        this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        };
        this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        };
        this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        };
        this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $42b77c4aa56216fa$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $42b77c4aa56216fa$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($42b77c4aa56216fa$var$withAnalytics, (0, $6yVT4.withPubSubClient), (0, $efKIh.asClientOnly))($42b77c4aa56216fa$var$RealtimeClientView);
var $42b77c4aa56216fa$export$2e2bcd8739ae039 = $42b77c4aa56216fa$export$e680ceb7b9fcc184;

});
parcelRegister("efKIh", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $4874a35f2e3af873$export$95cd02374de3431);

var $eUqFw = parcelRequire("eUqFw");
function $4874a35f2e3af873$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $4874a35f2e3af873$export$2e2bcd8739ae039 = $4874a35f2e3af873$export$95cd02374de3431;

});

parcelRegister("6yVT4", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $4857e418d88b13dd$export$32d968d4900ae3cd);

var $eUqFw = parcelRequire("eUqFw");

var $e97Bh = parcelRequire("e97Bh");
function $4857e418d88b13dd$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $4857e418d88b13dd$export$2e2bcd8739ae039 = $4857e418d88b13dd$export$32d968d4900ae3cd;

});
parcelRegister("e97Bh", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $4f1fb1ba24fc84ec$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f);

var $eUqFw = parcelRequire("eUqFw");
const $4f1fb1ba24fc84ec$var$defaultContext = {
    client: null
};
const { Provider: $4f1fb1ba24fc84ec$export$2881499e37b75b9a, Consumer: $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $eUqFw.createContext)($4f1fb1ba24fc84ec$var$defaultContext);

});



parcelRegister("2W6nG", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $ba1d3670c80098a4$export$64d242981d970821);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

var $g8JvH = parcelRequire("g8JvH");

var $3FyZ4 = parcelRequire("3FyZ4");


var $e97Bh = parcelRequire("e97Bh");

var $eBLah = parcelRequire("eBLah");

var $eDbRL = parcelRequire("eDbRL");

const $ba1d3670c80098a4$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("1jy1r")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $b0799f8f855a2fe4$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $ba1d3670c80098a4$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
    });
const $ba1d3670c80098a4$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $ba1d3670c80098a4$var$RealtimeProviderView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            host: (0, $b0799f8f855a2fe4$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels } = this.props;
        this.isComponentMounted = true;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((analyticsClient)=>$ba1d3670c80098a4$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$ba1d3670c80098a4$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
            $ba1d3670c80098a4$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            client: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result.currentChannels));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result.currentChannels));
        };
        this.isComponentMounted = false;
    }
}
const $ba1d3670c80098a4$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $ba1d3670c80098a4$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($ba1d3670c80098a4$var$withAnalytics, (0, $eBLah.withHost), (0, $eDbRL.withRuntimeProvider))($ba1d3670c80098a4$var$RealtimeProviderView);
var $ba1d3670c80098a4$export$2e2bcd8739ae039 = $ba1d3670c80098a4$export$64d242981d970821;

});
const $b0799f8f855a2fe4$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $b0799f8f855a2fe4$export$13ac40d1a5475532 = 'JIRA';

parcelRegister("eBLah", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $bd78fcaaefe05a83$export$b2d89aaea1461cd9);

var $eUqFw = parcelRequire("eUqFw");

var $giZl9 = parcelRequire("giZl9");
function $bd78fcaaefe05a83$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            host: (0, $giZl9.getDefaultPubSubHost)()
        });
}
var $bd78fcaaefe05a83$export$2e2bcd8739ae039 = $bd78fcaaefe05a83$export$b2d89aaea1461cd9;

});
parcelRegister("giZl9", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $5615d21da29bd94b$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $5615d21da29bd94b$export$354e43de513ff5);

var $6rW04 = parcelRequire("6rW04");

const $5615d21da29bd94b$export$f795b2d9ba365882 = ()=>(0, $6rW04.default)('ajs-fabric-realtime-url') || (0, $b0799f8f855a2fe4$export$92ffb25149c24a33);
const $5615d21da29bd94b$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});


parcelRegister("eDbRL", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $e49daff82a9a2253$export$4b38d0b01368c3f4);

var $eUqFw = parcelRequire("eUqFw");
function $e49daff82a9a2253$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $e49daff82a9a2253$export$2e2bcd8739ae039 = $e49daff82a9a2253$export$4b38d0b01368c3f4;

});

parcelRegister("1jy1r", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("acEmi")
]).then(()=>parcelRequire('3S62s'));

});



parcelRegister("iTFZo", function(module, exports) {

$parcel$export(module.exports, "REALTIME_EVENTS", () => $2fb4fe01e7fe6d3f$export$a45e758f2a5806e6);

const $2fb4fe01e7fe6d3f$export$a45e758f2a5806e6 = [
    (0, $1d129cd1c8b202ad$export$b22a14d5dac59664),
    (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99),
    (0, $1d129cd1c8b202ad$export$d9bc8850eeef9f60),
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee)
];

});

parcelRegister("8Igdg", function(module, exports) {

$parcel$export(module.exports, "getRealtimeChannels", () => $dfb8e43c9ab72e9a$export$2aa0d60688620de7);

var $df4Sl = parcelRequire("df4Sl");

var $giZl9 = parcelRequire("giZl9");

var $lgKTA = parcelRequire("lgKTA");

var $bwVWW = parcelRequire("bwVWW");
const $dfb8e43c9ab72e9a$var$EMPTY_CHANNELS = [];
const $dfb8e43c9ab72e9a$export$2aa0d60688620de7 = (0, $df4Sl.createSelector)((0, $lgKTA.getCloudId), (0, $bwVWW.getProjectId), (cloudId, projectId)=>{
    if (cloudId !== undefined) return [
        (0, $giZl9.buildChannelString)(cloudId, projectId)
    ];
    return $dfb8e43c9ab72e9a$var$EMPTY_CHANNELS;
});

});


parcelRegister("dgEpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4eae4dcea1cb46$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lB25E = parcelRequire("lB25E");

var $dFuRD = parcelRequire("dFuRD");

var $6489W = parcelRequire("6489W");

var $5tdw5 = parcelRequire("5tdw5");
var $4f4eae4dcea1cb46$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        locationFromStore: (0, $6489W.getLocation)(state)
    }), {
    onLocationChanged: (0, $dFuRD.routerLocationChange)
})((0, $lB25E.withRouter)((0, $5tdw5.default)));

});
parcelRegister("5tdw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $83ffcf9058d063c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $83ffcf9058d063c3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidUpdate(prevProps) {
        const { location: spaRouterlocation, onLocationChanged: onLocationChanged, locationFromStore: locationFromStore } = this.props;
        const { location: prevSpaRouterlocation } = prevProps;
        if (prevSpaRouterlocation.search !== spaRouterlocation.search && locationFromStore.search !== spaRouterlocation.search) // Update `router` if spa-router's location is not the same as router location from redux store
        onLocationChanged(spaRouterlocation);
    }
    render() {
        return null;
    }
}

});


parcelRegister("5uNCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e8cbe77d30372c$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");

var $lNNXV = parcelRequire("lNNXV");

var $hT84n = parcelRequire("hT84n");

var $bwVWW = parcelRequire("bwVWW");

var $j45xj = parcelRequire("j45xj");

var $6FeJk = parcelRequire("6FeJk");

var $9ZLrP = parcelRequire("9ZLrP");

var $9E22T = parcelRequire("9E22T");

var $eRVKI = parcelRequire("eRVKI");

var $9DoTe = parcelRequire("9DoTe");

var $1SuDz = parcelRequire("1SuDz");

var $dpcYO = parcelRequire("dpcYO");

var $5MpXz = parcelRequire("5MpXz");

var $9N1AA = parcelRequire("9N1AA");

var $htXdF = parcelRequire("htXdF");

var $11LHz = parcelRequire("11LHz");

var $1tL3w = parcelRequire("1tL3w");
const $d0e8cbe77d30372c$var$onItemDrop = (id, { parentId: parentId, rankRequest: rankRequest }, analyticsEvent)=>{
    if (parentId !== undefined && rankRequest !== undefined) return (0, $j45xj.updateAndRankAndPersistIssue)({
        issueId: id,
        rankRequest: rankRequest,
        properties: {
            parentId: parentId
        }
    }, analyticsEvent);
    if (rankRequest !== undefined) return (0, $j45xj.attemptRankIssue)({
        issueId: id,
        rankRequest: rankRequest
    }, analyticsEvent);
    return (0, $j45xj.updateAndPersistIssue)(id, {
        parentId: parentId
    }, analyticsEvent);
};
const $d0e8cbe77d30372c$var$onItemExpandChanged = (id, isExpanded)=>(0, $htXdF.changeExpansionState)({
        id: id,
        isExpanded: !isExpanded
    });
const $d0e8cbe77d30372c$var$onCreateClick = (anchor)=>(0, $htXdF.setCreateItemAnchor)(anchor);
const $d0e8cbe77d30372c$var$onItemSelect = (id, { level: level, withCmd: withCmd, withShift: withShift }, analyticsEvent)=>(0, $htXdF.selectItems)({
        id: id,
        level: level,
        withCmd: withCmd,
        withShift: withShift
    }, analyticsEvent);
const $d0e8cbe77d30372c$var$mapStateToProps = (state, ownProps)=>{
    const isSelectEnabled = (0, $9DoTe.getCanUserViewDetails)(state);
    const canUserCreate = (0, $9DoTe.getCanUserCreate)(state);
    const canUserEdit = (0, $9DoTe.getCanUserEdit)(state);
    return {
        isHighlightToday: !ownProps.isServer,
        isMeatballsButtonEnabled: canUserEdit || canUserCreate,
        isCreateLastEnabled: canUserCreate,
        isCreateSiblingEnabled: (0, $1SuDz.getIsCreateSiblingEnabled)(state),
        isCreateChildEnabled: (0, $1SuDz.getIsCreateChildEnabled)(state),
        isDragEnabled: (0, $1SuDz.getIsDragEnabled)(state),
        isSelectEnabled: isSelectEnabled,
        isMultiSelectEnabled: (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? isSelectEnabled : isSelectEnabled || undefined,
        hasSprints: (0, $bwVWW.getSprints)(state).length !== 0,
        items: (0, $1SuDz.getItems)(state),
        expandedItems: (0, $11LHz.getExpandedItems)(state),
        createItemAnchor: (0, $11LHz.getCreateItemAnchor)(state),
        selectedItemIds: (0, $11LHz.getSelectedItemIds)(state),
        activeItemId: (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? (0, $9E22T.getSelectedIssueId)(state) : undefined,
        timelineMode: (0, $9ZLrP.getTimelineMode)(state),
        timelineDuration: (0, $dpcYO.getTimelineDuration)(state),
        timelineOrigin: (0, $dpcYO.getTimelineOrigin)(state),
        today: (0, $bwVWW.getToday)(state),
        listWidth: (0, $9N1AA.getListWidth)(state),
        itemHeight: (0, $1SuDz.getItemHeight)(state),
        DndLongTaskMetric: (0, $hT84n.DragAndDropLongTaskMetric),
        isVirtualiseEnabled: true,
        headerItems: (0, $1SuDz.getTableHeaderItems)(state),
        ariaReadOnly: (0, $1SuDz.getAriaReadOnly)(state),
        flaggedItemsHash: (0, $6FeJk.getIsIssueFlaggedHash)(state),
        listItemMenuOptions: (0, $eRVKI.getListItemMenuOptions)(state)
    };
};
var $d0e8cbe77d30372c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($d0e8cbe77d30372c$var$mapStateToProps, {
    onItemDrop: $d0e8cbe77d30372c$var$onItemDrop,
    onItemSelect: // Remove this with project_timeline_multi-select_and_checkboxes
    $d0e8cbe77d30372c$var$onItemSelect,
    onItemExpandChanged: $d0e8cbe77d30372c$var$onItemExpandChanged,
    onCreateClick: $d0e8cbe77d30372c$var$onCreateClick,
    onSetListWidth: (0, $5MpXz.setListWidth),
    onItemActivate: (0, $htXdF.activateItem),
    onItemMultiSelect: (0, $htXdF.selectMultipleItems)
})((0, $1tL3w.default));

});
parcelRegister("hT84n", function(module, exports) {

$parcel$export(module.exports, "DragAndDropLongTaskMetric", () => $5a8bde4bddd9d8df$export$5b46e4151f98a6d5);
$parcel$export(module.exports, "useDragAndDropLongTaskMetric", () => $5a8bde4bddd9d8df$export$50ec904529fc184c);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $hg0u4 = parcelRequire("hg0u4");
const $5a8bde4bddd9d8df$var$onDragStart = (metricType)=>(0, $hg0u4.default).start(metricType);
const $5a8bde4bddd9d8df$var$onDragEnd = (metricType, extraProps)=>(0, $hg0u4.default).stop(metricType, extraProps);
class $5a8bde4bddd9d8df$export$5b46e4151f98a6d5 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            extraProps: {}
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isDragging && this.props.isDragging) $5a8bde4bddd9d8df$var$onDragStart(this.props.metricType);
        else if (prevProps.isDragging && !this.props.isDragging) {
            const extraProps = {
                ...this.props.extraProps
            };
            $5a8bde4bddd9d8df$var$onDragEnd(this.props.metricType, extraProps);
        }
    // do nothing when isDragging did not change
    }
    componentWillUnmount() {
        /**
		 * Stop the metric when the component has been unmounted when it is still dragging.
		 * e.g. issue-deleted JIRT event or child reparenting
		 * Child issue will be unmounted when it is dragged-moved to another epic.
		 */ if (this.props.isDragging) {
            const extraProps = {
                ...this.props.extraProps
            };
            $5a8bde4bddd9d8df$var$onDragEnd(this.props.metricType, extraProps);
        }
    }
    render() {
        return null;
    }
}
const $5a8bde4bddd9d8df$export$50ec904529fc184c = ({ metricType: metricType, extraProps: extraProps })=>{
    const isDragging = (0, $eUqFw.useRef)(false);
    const start = ()=>{
        if (!isDragging.current) {
            $5a8bde4bddd9d8df$var$onDragStart(metricType);
            isDragging.current = true;
        }
    };
    const stop = (0, $eUqFw.useCallback)(()=>{
        if (isDragging.current) {
            const extraData = {
                ...extraProps
            };
            $5a8bde4bddd9d8df$var$onDragEnd(metricType, extraData);
            isDragging.current = false;
        }
    }, [
        metricType,
        extraProps
    ]);
    (0, $eUqFw.useEffect)(()=>stop, [
        stop
    ]);
    return {
        start: start,
        stop: stop
    };
};
var $5a8bde4bddd9d8df$export$2e2bcd8739ae039 = $5a8bde4bddd9d8df$export$5b46e4151f98a6d5;

});
parcelRegister("hg0u4", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcc4684ef5c99739$export$2e2bcd8739ae039);

var $e5nQt = parcelRequire("e5nQt");

var $1gs0D = parcelRequire("1gs0D");
var $dcc4684ef5c99739$export$2e2bcd8739ae039 = (0, $e5nQt.default)((0, $1gs0D.ROADMAP_APP_ID));

});
parcelRegister("e5nQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b6eb4a4b6e830$export$2e2bcd8739ae039);

var $511uv = parcelRequire("511uv");

var $1MJR2 = parcelRequire("1MJR2");

var $oVkDS = parcelRequire("oVkDS");

var $62mlw = parcelRequire("62mlw");

var $gf0vG = parcelRequire("gf0vG");

const $136b6eb4a4b6e830$var$dndReporterWithSloAndExtraProps = (props)=>(observationData, extraProps, stopTimestamp)=>(0, $1MJR2.dndReporterWithSlo)({
            framerateThreshold: 20,
            blocktimeThreshold: 100
        })(observationData, {
            ...extraProps,
            ...props
        }, stopTimestamp);
const $136b6eb4a4b6e830$var$slowDndReporterWithSloAndExtraProps = (props)=>(observationData, extraProps, stopTimestamp)=>(0, $1MJR2.dndReporterWithSlo)({
            framerateThreshold: 16,
            blocktimeThreshold: 100
        })(observationData, {
            ...extraProps,
            ...props
        }, stopTimestamp);
const $136b6eb4a4b6e830$var$scrollReporterWithSloAndExtraProps = (props)=>(observationData, extraProps)=>(0, $62mlw.scrollReporterWithSlo)({
            framerateThreshold: 20,
            blocktimeThreshold: 100
        })(observationData, {
            ...extraProps,
            ...props
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$136b6eb4a4b6e830$export$2e2bcd8739ae039 = (appId)=>({
        start: (type)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $511uv.getLongTasksMetrics)(type).start(appId);
        },
        stop: (type, extraProps = {})=>{
            let reporter = (0, $oVkDS.genericReporter);
            switch(type){
                case 0, $028d5637f56fe710$export$2475592765cae5b0:
                case 0, $gf0vG.LIST_DRAG_AND_DROP:
                case 0, $gf0vG.CHILD_LIST_DRAG_AND_DROP:
                case 0, $gf0vG.LIST_RESIZE_DRAG_AND_DROP:
                case 0, $028d5637f56fe710$export$3ac90e7f239a7193:
                    reporter = $136b6eb4a4b6e830$var$dndReporterWithSloAndExtraProps(extraProps);
                    break;
                case 0, $028d5637f56fe710$export$eedef6333f320132:
                    reporter = $136b6eb4a4b6e830$var$slowDndReporterWithSloAndExtraProps(extraProps);
                    break;
                case 0, $gf0vG.SCROLLED:
                    reporter = $136b6eb4a4b6e830$var$scrollReporterWithSloAndExtraProps(extraProps);
                    break;
                default:
                    reporter = (0, $oVkDS.genericReporter);
                    break;
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $511uv.getLongTasksMetrics)(type).stop(reporter);
        }
    });

});
parcelRegister("511uv", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $6e4a680496b7cbbf$export$b092a8653a66aa5e);

var $jqvCZ = parcelRequire("jqvCZ");

var $6iz4v = parcelRequire("6iz4v");

var $hgcvd = parcelRequire("hgcvd");

var $7tZw9 = parcelRequire("7tZw9");
let $6e4a680496b7cbbf$var$observer = null;
const $6e4a680496b7cbbf$var$stopObserver = ()=>{
    if ($6e4a680496b7cbbf$var$observer) {
        $6e4a680496b7cbbf$var$observer.disconnect();
        $6e4a680496b7cbbf$var$observer = null;
    }
};
const $6e4a680496b7cbbf$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $hgcvd.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $6e4a680496b7cbbf$var$stopObserver();
                $6e4a680496b7cbbf$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $7tZw9.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $hgcvd.default).now && isStarted) {
                const stopTimestamp = (0, $hgcvd.default).now();
                setTimeout(()=>{
                    $6e4a680496b7cbbf$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($6e4a680496b7cbbf$var$observer && performanceMark) {
                const perfMark = (0, $6iz4v.getMark)(performanceMark);
                if (!perfMark) {
                    $6e4a680496b7cbbf$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("7tZw9", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $e45a8242e5c0159d$export$3d38a87309e205a4);
const $e45a8242e5c0159d$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("1MJR2", function(module, exports) {

$parcel$export(module.exports, "dndReporterWithSlo", () => $bf2b48326ab708ed$export$e5a00a4133cb3d76);
$parcel$export(module.exports, "dndReporter", () => $bf2b48326ab708ed$export$62f293b5c9d6890c);

var $ICvxP = parcelRequire("ICvxP");

var $3FyZ4 = parcelRequire("3FyZ4");

var $lzvR2 = parcelRequire("lzvR2");

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
const $bf2b48326ab708ed$export$e5a00a4133cb3d76 = (sloSettings)=>(observationData, extraProps, stopTimestamp)=>{
        if ((0, $7tZw9.isExpandedObservationData)(observationData)) {
            const { eventStartPerformanceMark: eventStartPerformanceMark } = observationData;
            if (eventStartPerformanceMark) (0, $ICvxP.default)(eventStartPerformanceMark);
            const startTimes = observationData.events.map((event)=>event.timestamp);
            const startLongTaskEndTimestamp = observationData.dragStartEndTimestamp;
            const startLongTasks = observationData.events.filter((event)=>event.timestamp < startLongTaskEndTimestamp);
            const movingLongTasks = observationData.events.filter((event)=>event.timestamp >= startLongTaskEndTimestamp && event.timestamp < stopTimestamp);
            const dropLongTasks = observationData.events.filter((event)=>event.timestamp >= stopTimestamp);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const analyticsData = {
                ...extraProps,
                ...(0, $fPUXl.generateLongTaskAnalyticsSummaryWithSlo)('start', startLongTasks, sloSettings),
                ...(0, $fPUXl.generateLongTaskAnalyticsSummaryWithSlo)('moving', movingLongTasks, sloSettings),
                ...(0, $fPUXl.generateLongTaskAnalyticsSummaryWithSlo)('drop', dropLongTasks, sloSettings),
                type: observationData.type || 'unknown',
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTimes),
                performanceFFs: (0, $lzvR2.getPerformanceFFsString)()
            };
            const triggerSoftwareAnalytics = (0, $fPUXl.triggerAnalytics)(`software.${observationData.appName}`);
            triggerSoftwareAnalytics(`long-tasks-${observationData.type || 'dnd'}`, analyticsData);
            if (sloSettings) {
                const attributes = {
                    ...extraProps,
                    type: observationData.type || 'unknown',
                    startLongTaskSloIsSuccess: analyticsData.startLongTaskSloIsSuccess,
                    movingLongTaskSloIsSuccess: analyticsData.movingLongTaskSloIsSuccess,
                    dropLongTaskSloIsSuccess: analyticsData.dropLongTaskSloIsSuccess,
                    ...sloSettings
                };
                (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                    const payload = {
                        source: observationData.appName,
                        action: 'complete',
                        actionSubject: 'dnd operation',
                        attributes: attributes
                    };
                    client.getInstance().sendOperationalEvent(payload);
                });
            }
        }
    };
const $bf2b48326ab708ed$export$62f293b5c9d6890c = $bf2b48326ab708ed$export$e5a00a4133cb3d76();

});
parcelRegister("fPUXl", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $9e8129e894f8b784$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $9e8129e894f8b784$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $9e8129e894f8b784$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $9e8129e894f8b784$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $9e8129e894f8b784$export$7e5f2df95eca342a);

var $x71UL = parcelRequire("x71UL");

var $4YjDD = parcelRequire("4YjDD");

var $9HwDQ = parcelRequire("9HwDQ");
const $9e8129e894f8b784$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $9e8129e894f8b784$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $9e8129e894f8b784$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $9e8129e894f8b784$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $9e8129e894f8b784$export$c36fdc326d0c207c = (prefix, data)=>({
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($4YjDD)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
        [`${prefix}Count`]: data.length
    });
const $9e8129e894f8b784$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("x71UL", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $6P7TZ = parcelRequire("6P7TZ");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $0638892b8ae22890$var$meanBy(array, iteratee) {
    return $6P7TZ(array, $7qARj(iteratee, 2));
}
module.exports = $0638892b8ae22890$var$meanBy;

});
parcelRegister("6P7TZ", function(module, exports) {

var $835ZM = parcelRequire("835ZM");
/** Used as references for various `Number` constants. */ var $4f7da2b12e23c1f3$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $4f7da2b12e23c1f3$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $835ZM(array, iteratee) / length : $4f7da2b12e23c1f3$var$NAN;
}
module.exports = $4f7da2b12e23c1f3$var$baseMean;

});
parcelRegister("835ZM", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $5dc3411db180ba2c$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $5dc3411db180ba2c$var$baseSum;

});



parcelRegister("4YjDD", function(module, exports) {

var $835ZM = parcelRequire("835ZM");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $39ebffc448745d7b$var$sum(array) {
    return array && array.length ? $835ZM(array, $3QMTK) : 0;
}
module.exports = $39ebffc448745d7b$var$sum;

});

parcelRegister("9HwDQ", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $835ZM = parcelRequire("835ZM");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $7101732f00f14013$var$sumBy(array, iteratee) {
    return array && array.length ? $835ZM(array, $7qARj(iteratee, 2)) : 0;
}
module.exports = $7101732f00f14013$var$sumBy;

});



parcelRegister("oVkDS", function(module, exports) {

$parcel$export(module.exports, "genericReporter", () => $11a01d8fc8c2c9e1$export$bf7963bc28dd02c2);

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
const $11a01d8fc8c2c9e1$export$bf7963bc28dd02c2 = (observationData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
featureFlags = {})=>{
    if ((0, $7tZw9.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $fPUXl.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $fPUXl.generateLongTaskAnalyticsSummary)(`${observationData.type}`, observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            ...featureFlags
        };
        triggerSoftwareAnalytics(`long-tasks-${observationData.type}`, analyticsData);
    }
};

});

parcelRegister("62mlw", function(module, exports) {

$parcel$export(module.exports, "scrollReporterWithSlo", () => $e70267f7a45c6c80$export$4cfca7ce0b67bede);

var $3FyZ4 = parcelRequire("3FyZ4");

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
const $e70267f7a45c6c80$export$4cfca7ce0b67bede = (sloSettings)=>(observationData, extraProps)=>{
        if (!(0, $7tZw9.isExpandedObservationData)(observationData) || sloSettings === undefined) return;
        const startTime = observationData.events.map((event)=>event.timestamp);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const analyticsData = {
            ...extraProps,
            ...(0, $fPUXl.generateLongTaskAnalyticsSummaryWithSlo)('scroll', observationData.events, sloSettings),
            type: observationData.type || 'unknown',
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
        };
        const attributes = {
            ...extraProps,
            type: observationData.type || 'unknown',
            isSuccess: analyticsData.scrollLongTaskSloIsSuccess,
            ...sloSettings
        };
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: observationData.appName,
                action: 'complete',
                actionSubject: 'scroll operation',
                attributes: attributes
            };
            client.getInstance().sendOperationalEvent(payload);
        });
    };

});




parcelRegister("eRVKI", function(module, exports) {

$parcel$export(module.exports, "getListItemMenuOptions", () => $1784cf235ba93442$export$2d38f26d6331442e);
$parcel$export(module.exports, "getEditDatesOptionParams", () => $1784cf235ba93442$export$596b38721828a359);
$parcel$export(module.exports, "getBulkEditDatesOptionParams", () => $1784cf235ba93442$export$15791ea194fd6f13);
$parcel$export(module.exports, "getChangeColorOptionParams", () => $1784cf235ba93442$export$b97c2dc8a4fa25d1);
$parcel$export(module.exports, "getEditSprintOptionParams", () => $1784cf235ba93442$export$50e3c22b2ee601e);
$parcel$export(module.exports, "getParentOptions", () => $1784cf235ba93442$export$ac3b26300904305a);
$parcel$export(module.exports, "getDependencyOptions", () => $1784cf235ba93442$export$e9fe09f7c25f0d68);
$parcel$export(module.exports, "getDependenciesById", () => $1784cf235ba93442$export$960ad1bb9ab003b5);

var $df4Sl = parcelRequire("df4Sl");

var $03XEB = parcelRequire("03XEB");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $11LHz = parcelRequire("11LHz");

var $9E22T = parcelRequire("9E22T");

var $9DoTe = parcelRequire("9DoTe");

var $kbyLF = parcelRequire("kbyLF");

var $1SuDz = parcelRequire("1SuDz");

var $gC6yb = parcelRequire("gC6yb");

var $3g5EA = parcelRequire("3g5EA");

var $JC89V = parcelRequire("JC89V");

var $bFVgd = parcelRequire("bFVgd");

var $fkOtA = parcelRequire("fkOtA");

var $376eX = parcelRequire("376eX");

var $hrcJx = parcelRequire("hrcJx");
const $1784cf235ba93442$export$2d38f26d6331442e = (0, $df4Sl.createSelector)((0, $9DoTe.getCanUserEdit), (0, $bwVWW.getIsSprintsFeatureEnabled), (0, $bwVWW.getIsChildIssuePlanningEnabled), (0, $gC6yb.getListItemMenuOptionsPure));
const $1784cf235ba93442$export$596b38721828a359 = (0, $df4Sl.createSelector)((0, $bwVWW.getIsChildIssuePlanningEnabled), (0, $bwVWW.getIsSprintsPlanningEnabled), (0, $6FeJk.getIsIssueStartDateRequired), (0, $6FeJk.getIsIssueDueDateRequired), (0, $6FeJk.getIssue), (0, $9E22T.getIssueTypeForIssueId), (0, $1SuDz.getChartDataById), (0, $bFVgd.getEditDatesOptionParamsPure));
const $1784cf235ba93442$export$15791ea194fd6f13 = (0, $df4Sl.createSelector)((0, $11LHz.getSelectedItemIds), $1784cf235ba93442$export$596b38721828a359, (0, $3g5EA.getBulkEditDatesOptionParamsPure));
const $1784cf235ba93442$export$b97c2dc8a4fa25d1 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueLevel), (0, $6FeJk.getIssueColor), (0, $JC89V.getChangeColorOptionParamsPure));
const $1784cf235ba93442$export$50e3c22b2ee601e = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueLevel), (0, $kbyLF.getIsCurrentlyAssignedToSprints), (0, $9E22T.getIssueContextMenuSprints), (0, $376eX.getEditSprintOptionParamsPure));
const $1784cf235ba93442$export$ac3b26300904305a = (0, $df4Sl.createSelector)((0, $9E22T.getNonBaseLevelIssueIds), (0, $6FeJk.getIssueTypeIdHash), (0, $bwVWW.getFullIssueTypeHash), (0, $6FeJk.getIssueKeyHash), (0, $6FeJk.getIssueSummaryHash), (0, $hrcJx.getParentOptionsPure));
const $1784cf235ba93442$export$e9fe09f7c25f0d68 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueIds), (0, $6FeJk.getIssueTypeIdHash), (0, $bwVWW.getFullIssueTypeHash), (0, $6FeJk.getIssueKeyHash), (0, $6FeJk.getIssueSummaryHash), (0, $fkOtA.getDependencyOptionsPure));
const $1784cf235ba93442$export$960ad1bb9ab003b5 = (0, $df4Sl.createSelector)((state, issueId)=>{
    const dependencyIds = (0, $9E22T.getIssueDependencies)(state, issueId);
    const dependeeIds = (0, $9E22T.getIssueDependees)(state, issueId);
    const dependencies = [];
    const mapDependencies = (link)=>(dependencyId)=>{
            const dependencyIssueType = (0, $9E22T.getIssueTypeForIssueId)(state, dependencyId);
            const dependencyIssueKey = (0, $6FeJk.getIssueKeyById)(state, dependencyId);
            if (dependencyIssueKey) dependencies.push({
                id: dependencyId,
                issueKey: dependencyIssueKey,
                issueSummary: (0, $6FeJk.getIssueSummary)(state, dependencyId),
                issueType: dependencyIssueType.name,
                iconUrl: dependencyIssueType.iconUrl,
                link: link
            });
        };
    dependencyIds?.forEach(mapDependencies((0, $03XEB.INWARD_LINK_DIRECTION)));
    dependeeIds?.forEach(mapDependencies((0, $03XEB.OUTWARD_LINK_DIRECTION)));
    return dependencies;
}, (dependencies)=>dependencies);

});
parcelRegister("gC6yb", function(module, exports) {

$parcel$export(module.exports, "getListItemMenuOptionsPure", () => $5d333737963f2762$export$359bb0efbdc4166b);

var $eI5EY = parcelRequire("eI5EY");

var $gf0vG = parcelRequire("gf0vG");

var $1gs0D = parcelRequire("1gs0D");

var $hlVlk = parcelRequire("hlVlk");
const $5d333737963f2762$export$359bb0efbdc4166b = (canUserEdit, isSprintsFeatureEnabled, isChildIssuePlanningEnabled)=>{
    const { ITEMS_SECTION: ITEMS_SECTION, MOVE_ITEM: MOVE_ITEM, CREATE_ITEM: CREATE_ITEM, CREATE_CHILD_ITEM: CREATE_CHILD_ITEM, CREATE_ITEM_ABOVE: CREATE_ITEM_ABOVE, CREATE_ITEM_BELOW: CREATE_ITEM_BELOW, MOVE_ITEM_UP: MOVE_ITEM_UP, MOVE_ITEM_DOWN: MOVE_ITEM_DOWN, MOVE_ITEM_TO_TOP: MOVE_ITEM_TO_TOP, MOVE_ITEM_TO_BOTTOM: MOVE_ITEM_TO_BOTTOM, SELECTED_ITEM_COUNTER: SELECTED_ITEM_COUNTER } = (0, $gf0vG.listItemMenu);
    const overrideLabels = {
        [ITEMS_SECTION]: (0, $hlVlk.default)[ITEMS_SECTION],
        [CREATE_ITEM]: (0, $hlVlk.default)[CREATE_ITEM],
        [MOVE_ITEM]: (0, $hlVlk.default)[MOVE_ITEM],
        [CREATE_CHILD_ITEM]: (0, $hlVlk.default)[CREATE_CHILD_ITEM],
        [CREATE_ITEM_ABOVE]: (0, $hlVlk.default)[CREATE_ITEM_ABOVE],
        [CREATE_ITEM_BELOW]: (0, $hlVlk.default)[CREATE_ITEM_BELOW],
        [MOVE_ITEM_UP]: (0, $hlVlk.default)[MOVE_ITEM_UP],
        [MOVE_ITEM_DOWN]: (0, $hlVlk.default)[MOVE_ITEM_DOWN],
        [MOVE_ITEM_TO_TOP]: (0, $hlVlk.default)[MOVE_ITEM_TO_TOP],
        [MOVE_ITEM_TO_BOTTOM]: (0, $hlVlk.default)[MOVE_ITEM_TO_BOTTOM],
        [SELECTED_ITEM_COUNTER]: (0, $hlVlk.default)[SELECTED_ITEM_COUNTER]
    };
    if ((0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) {
        if (canUserEdit) {
            const schedulingOptions = [
                ...isSprintsFeatureEnabled && isChildIssuePlanningEnabled && (0, $eI5EY.fg)('jsw_roadmaps_timeline_sprint_scheduling_a11y') ? [
                    {
                        id: (0, $1gs0D.EDIT_SPRINT)
                    }
                ] : [],
                ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-meatballs-date-update-modal') ? [
                    {
                        id: (0, $1gs0D.EDIT_DATES)
                    },
                    {
                        id: (0, $1gs0D.REMOVE_DATES)
                    }
                ] : [],
                ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-meatball-dependency-modal') ? [
                    {
                        id: (0, $1gs0D.EDIT_DEPENDENCY)
                    }
                ] : []
            ];
            return {
                overrideLabels: overrideLabels,
                customSections: [
                    {
                        id: ITEMS_SECTION,
                        title: (0, $hlVlk.default)[ITEMS_SECTION],
                        options: [
                            ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-meatball-reparent-menu') ? [
                                {
                                    id: (0, $1gs0D.CHANGE_PARENT_ISSUE)
                                }
                            ] : [],
                            ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-meatballs-change-issue-color') ? [
                                {
                                    id: (0, $1gs0D.CHANGE_ISSUE_COLOR)
                                }
                            ] : []
                        ]
                    },
                    {
                        id: (0, $1gs0D.SCHEDULING_SECTION),
                        title: (0, $hlVlk.default)[0, $1gs0D.SCHEDULING_SECTION],
                        options: schedulingOptions
                    }
                ],
                customSectionsBulk: [
                    {
                        id: (0, $1gs0D.BULK_SECTION),
                        options: [
                            ...(0, $eI5EY.fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? [
                                {
                                    id: (0, $1gs0D.BULK_EDIT_DATES)
                                }
                            ] : []
                        ]
                    }
                ]
            };
        }
    }
    return {
        overrideLabels: overrideLabels,
        customSections: [],
        customSectionsBulk: []
    };
};

});
parcelRegister("hlVlk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a02dd2a01d28197$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6a02dd2a01d28197$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    schedulingSection: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.scheduling-section",
        "defaultMessage": "Scheduling"
    },
    itemsSection: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.items-section",
        "defaultMessage": "Issues"
    },
    createItem: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.create-item",
        "defaultMessage": "Create issue"
    },
    createChildItem: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.create-child-item",
        "defaultMessage": "Create child issue"
    },
    createItemAbove: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.create-item-above",
        "defaultMessage": "Create issue above"
    },
    createItemBelow: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.create-item-below",
        "defaultMessage": "Create issue below"
    },
    moveItem: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item",
        "defaultMessage": "Move issue"
    },
    moveItemUp: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item-up",
        "defaultMessage": "Move issue up"
    },
    moveItemDown: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item-down",
        "defaultMessage": "Move issue down"
    },
    moveItemToTop: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item-to-top",
        "defaultMessage": "Move issue to top"
    },
    moveItemToBottom: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item-to-bottom",
        "defaultMessage": "Move issue to bottom"
    },
    selectedItemCounter: {
        "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.selected-item-counter",
        "defaultMessage": "<badge>{count}</badge> {count, plural, one {issue selected} other {issues selected}}"
    }
});

});


parcelRegister("3g5EA", function(module, exports) {

$parcel$export(module.exports, "getBulkEditDatesOptionParamsPure", () => $716877cd580790cb$export$721a3dbd7ea05586);
const $716877cd580790cb$export$721a3dbd7ea05586 = (selectedIssueIds, { isDateEditable: isDateEditable, startDate: startDate, dueDate: dueDate, editDatesModalParams: { issueKey: issueKey, issueSummary: issueSummary, level: level, warnings: warnings } })=>({
        isDateEditable: isDateEditable,
        issueKey: issueKey,
        issueSummary: issueSummary,
        startDate: startDate,
        dueDate: dueDate,
        level: level,
        selectedIssueCount: selectedIssueIds.length,
        warnings: warnings
    });

});

parcelRegister("JC89V", function(module, exports) {

$parcel$export(module.exports, "getChangeColorOptionParamsPure", () => $5f93c39062f59c88$export$1aaf4071a599968a);

var $kbiEp = parcelRequire("kbiEp");
const $5f93c39062f59c88$export$1aaf4071a599968a = (level, color)=>({
        isColorEditable: (0, $kbiEp.isParentLevel)(level),
        color: color
    });

});

parcelRegister("bFVgd", function(module, exports) {

$parcel$export(module.exports, "getEditDatesOptionParamsPure", () => $a25e666b65d12d5c$export$e537892b44c7a67f);

var $kbiEp = parcelRequire("kbiEp");

var $c3IKH = parcelRequire("c3IKH");

var $fHtBB = parcelRequire("fHtBB");
const $a25e666b65d12d5c$export$e537892b44c7a67f = (isChildIssuePlanningEnabled, isSprintsPlanningEnabled, isStartDateRequired, isDueDateRequired, issue, issueTypeData, chartData)=>{
    const { key: issueKey = '', summary: summary, startDate: startDateRaw, dueDate: dueDateRaw } = issue ?? {};
    const { name: issueType, iconUrl: iconUrl } = issueTypeData ?? {};
    const { level: level = 0, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, warnings: warnings } = chartData ?? {};
    const isParent = (0, $kbiEp.isParentLevel)(level);
    const isDateEditable = isChildIssuePlanningEnabled && !isSprintsPlanningEnabled || isParent;
    const isStartDatePlaceholder = placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
    const isDueDatePlaceholder = placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
    const isStartDateInferred = startDateType === (0, $fHtBB.ROLLUP) || startDateType === (0, $fHtBB.INTERVAL);
    const isDueDateInferred = dueDateType === (0, $fHtBB.ROLLUP) || dueDateType === (0, $fHtBB.INTERVAL);
    const isStartDateEmpty = startDate === undefined || isStartDatePlaceholder || isStartDateInferred;
    const isDueDateEmpty = dueDate === undefined || isDueDatePlaceholder || isDueDateInferred;
    const isStartDateClearable = !isStartDateRequired && !isStartDateEmpty;
    const isDueDateClearable = !isDueDateRequired && !isDueDateEmpty;
    const isDateFlipped = startDate !== undefined && dueDate !== undefined && startDate < dueDate && (startDate === dueDateRaw?.value || dueDate === startDateRaw?.value);
    const canHaveChildRollup = isChildIssuePlanningEnabled && !isSprintsPlanningEnabled && isParent;
    const canHaveSprintRollup = isChildIssuePlanningEnabled && isSprintsPlanningEnabled && isParent;
    const currentStartDate = isStartDateEmpty ? undefined : new Date(startDate);
    const currentDueDate = isDueDateEmpty ? undefined : new Date(dueDate);
    return {
        isDateEditable: isDateEditable,
        isStartDateRequired: isStartDateRequired,
        isDueDateRequired: isDueDateRequired,
        startDate: startDate,
        dueDate: dueDate,
        editDatesModalParams: {
            isStartDateInferred: isStartDateInferred,
            isDueDateInferred: isDueDateInferred,
            canHaveChildRollup: canHaveChildRollup,
            canHaveSprintRollup: canHaveSprintRollup,
            issueKey: issueKey,
            issueSummary: summary?.value ?? '',
            issueType: issueType,
            iconUrl: iconUrl,
            level: level,
            currentStartDate: currentStartDate,
            currentDueDate: currentDueDate,
            warnings: warnings ?? []
        },
        // NOTE: Dates removal check should be based on original dates instead of chart dates (flipped dates included)
        removeDatesOptionParams: {
            isStartDateClearable: isDateFlipped ? isDueDateClearable : isStartDateClearable,
            isDueDateClearable: isDateFlipped ? isStartDateClearable : isDueDateClearable,
            isStartDateRolledUp: isDateFlipped ? isDueDateInferred : isStartDateInferred,
            isDueDateRolledUp: isDateFlipped ? isStartDateInferred : isDueDateInferred
        }
    };
};

});

parcelRegister("fkOtA", function(module, exports) {

$parcel$export(module.exports, "getDependencyOptionsPure", () => $cf482b80c97cf983$export$95e663b22b28d36);
const $cf482b80c97cf983$export$95e663b22b28d36 = (issueIds, issueTypeIdHash, issueTypesHash, issueKeyHash, issueSummaryHash)=>issueIds.reduce((dependencyOptions, id)=>{
        const issueKey = issueKeyHash[id];
        const issueType = issueTypesHash[issueTypeIdHash[id]];
        if (issueKey) dependencyOptions.push({
            id: id,
            issueKey: issueKey,
            issueSummary: issueSummaryHash[id],
            issueType: issueType.name,
            iconUrl: issueType.iconUrl
        });
        return dependencyOptions;
    }, []);

});

parcelRegister("376eX", function(module, exports) {

$parcel$export(module.exports, "getEditSprintOptionParamsPure", () => $d462126c970ab719$export$71756d0ea1deed1f);

var $kbiEp = parcelRequire("kbiEp");
const $d462126c970ab719$export$71756d0ea1deed1f = (level, isCurrentlyAssignedToSprints, sprintsAssignable)=>({
        isSprintEditable: (0, $kbiEp.isBaseLevel)(level) && (isCurrentlyAssignedToSprints || sprintsAssignable.length > 0),
        isSprintClearable: isCurrentlyAssignedToSprints,
        sprints: sprintsAssignable
    });

});

parcelRegister("hrcJx", function(module, exports) {

$parcel$export(module.exports, "getParentOptionsPure", () => $e755e6a91992ff78$export$f53bc4fef5dddefe);
const $e755e6a91992ff78$export$f53bc4fef5dddefe = (parentIds, issueTypeIdHash, issueTypesHash, issueKeyHash, issueSummaryHash)=>parentIds.reduce((parentOptions, id)=>{
        const issueKey = issueKeyHash[id];
        const issueSummary = issueSummaryHash[id];
        const issueTypeId = issueTypeIdHash[id];
        const issueType = issueTypesHash[issueTypeId];
        if (issueKey) parentOptions.push({
            id: id,
            key: issueKey,
            summary: issueSummary,
            issueType: issueType.name,
            iconUrl: issueType.iconUrl
        });
        return parentOptions;
    }, []);

});


parcelRegister("1tL3w", function(module, exports) {

$parcel$export(module.exports, "renderers", () => $6f2437b8c20413d8$export$161aa799a4b9b9d7);
$parcel$export(module.exports, "default", () => $6f2437b8c20413d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2lQYS = parcelRequire("2lQYS");

var $3ExHl = parcelRequire("3ExHl");

var $83k2g = parcelRequire("83k2g");

var $jOFEQ = parcelRequire("jOFEQ");

var $jVmly = parcelRequire("jVmly");

var $7DfOL = parcelRequire("7DfOL");

var $igRS7 = parcelRequire("igRS7");

var $cy6z6 = parcelRequire("cy6z6");

var $6wDSA = parcelRequire("6wDSA");

var $8xVyM = parcelRequire("8xVyM");

var $imbpB = parcelRequire("imbpB");

var $jq8Ep = parcelRequire("jq8Ep");

var $1pFjT = parcelRequire("1pFjT");

var $bDb7U = parcelRequire("bDb7U");

var $kQxvx = parcelRequire("kQxvx");

var $asuJa = parcelRequire("asuJa");
const $6f2437b8c20413d8$var$renderListItemContent = (props, { isVirtual: isVirtual, ...state })=>{
    if (isVirtual) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xVyM.default), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6wDSA.default), {
        ...props,
        ...state
    });
};
const $6f2437b8c20413d8$var$renderListItemSecondaryContent = (props, { isVirtual: isVirtual })=>isVirtual ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDb7U.default), props);
const $6f2437b8c20413d8$var$renderListItemMenuOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jq8Ep.default), props);
const $6f2437b8c20413d8$var$renderListItemModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1pFjT.default), props);
const $6f2437b8c20413d8$var$renderChartItemContent = (props, { isVirtual: isVirtual, ...state })=>{
    if (isVirtual) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOFEQ.default), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83k2g.default), {
        ...props,
        ...state
    });
};
const $6f2437b8c20413d8$export$161aa799a4b9b9d7 = {
    renderListEmptyContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $igRS7.default), null),
    renderListItemContent: $6f2437b8c20413d8$var$renderListItemContent,
    renderListItemSecondaryContent: $6f2437b8c20413d8$var$renderListItemSecondaryContent,
    renderListItemCreate: (props, state)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imbpB.default), {
            ...props,
            ...state
        }),
    renderChartOverlay: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVmly.default), null),
    renderChartTimelineOverlay: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7DfOL.default), null),
    renderListItemMenuOption: $6f2437b8c20413d8$var$renderListItemMenuOption,
    renderListItemModal: $6f2437b8c20413d8$var$renderListItemModal,
    renderChartItemContent: $6f2437b8c20413d8$var$renderChartItemContent,
    renderProvider: $asuJa.renderProvider,
    renderListHeaderItem: $cy6z6.renderListHeaderItem,
    renderChartHeaderItem: $3ExHl.renderChartHeaderItem
};
const $6f2437b8c20413d8$var$RoadmapsTable = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2lQYS.default), {
        ...props,
        scope: "roadmap",
        renderers: $6f2437b8c20413d8$export$161aa799a4b9b9d7,
        marshalOptions: (0, $kQxvx.marshalOptions)
    });
var $6f2437b8c20413d8$export$2e2bcd8739ae039 = $6f2437b8c20413d8$var$RoadmapsTable;

});
parcelRegister("2lQYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e162de3b3bb687$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");

var $VrUCp = parcelRequire("VrUCp");

var $lSR7G = parcelRequire("lSR7G");

var $nH3p1 = parcelRequire("nH3p1");

var $lvr5h = parcelRequire("lvr5h");

var $bwj1b = parcelRequire("bwj1b");

var $cZkk1 = parcelRequire("cZkk1");

var $3XwA1 = parcelRequire("3XwA1");

var $kzPj3 = parcelRequire("kzPj3");
const $e3e162de3b3bb687$var$EMPTY_ARRAY = [];
function $e3e162de3b3bb687$export$2e2bcd8739ae039(props) {
    const { marshalOptions: marshalOptions, isCreateLastEnabled: isCreateLastEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isDragEnabled: isDragEnabled, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isHighlightToday: isHighlightToday, listWidth: listWidth, items: items, headerItems: headerItems, itemHeight: itemHeight, activeItemId: activeItemId, onItemActivate: onItemActivate, selectedItemIds: selectedItemIds, onItemMultiSelect: onItemMultiSelect, expandedItems: expandedItems, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin, createItemAnchor: createItemAnchor, ariaRowCount: ariaRowCount, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, isTreeDrag: isTreeDrag = false, listItemMenuOptions: listItemMenuOptions, isMeatballsButtonEnabled: isMeatballsButtonEnabled = false, ...mainProps } = props;
    const safeSelectedItemIds = isSelectEnabled ? selectedItemIds : $e3e162de3b3bb687$var$EMPTY_ARRAY;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvr5h.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZkk1.TimelineViewportProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WNLk.EnablementProvider), {
        isDragEnabled: isDragEnabled,
        isSelectEnabled: isSelectEnabled,
        isMultiSelectEnabled: isSelectEnabled && isMultiSelectEnabled,
        isCreateLastEnabled: isCreateLastEnabled,
        isCreateSiblingEnabled: isCreateSiblingEnabled,
        isCreateChildEnabled: isCreateChildEnabled,
        isMeatballsButtonEnabled: isMeatballsButtonEnabled,
        isHighlightToday: isHighlightToday,
        isTreeDrag: isTreeDrag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $VrUCp.default), {
        headerItems: headerItems,
        isRowCountKnown: ariaRowCount !== -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSR7G.ItemsProvider), {
        items: items,
        createItemAnchor: createItemAnchor,
        isCreateLastEnabled: isCreateLastEnabled,
        isCreateSiblingEnabled: isCreateSiblingEnabled,
        isCreateChildEnabled: isCreateChildEnabled,
        expandedItems: expandedItems,
        // Change to selectedItemIds={selectedItemIds} when cleaning up project_timeline_multi-select_and_checkboxes
        selectedItemIdsWithPermission: isSelectEnabled ? selectedItemIds : undefined,
        onItemMultiSelect: onItemMultiSelect,
        activeItemId: activeItemId,
        onItemActivate: onItemActivate,
        itemHeight: itemHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XwA1.TimelineProviderSweetState), {
        timelineMode: timelineMode,
        timelineDuration: timelineDuration,
        timelineOrigin: timelineOrigin,
        today: today
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nH3p1.default), {
        listWidth: listWidth,
        listItemMenuOptions: listItemMenuOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwj1b.default), {
        scope: mainProps.scope,
        ariaLabel: ariaLabel,
        ariaReadOnly: ariaReadOnly,
        ariaMultiselectable: isSelectEnabled ? isMultiSelectEnabled : undefined,
        ...marshalOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzPj3.default), {
        ...mainProps,
        selectedItemIds: safeSelectedItemIds
    })))))))));
}
$e3e162de3b3bb687$export$2e2bcd8739ae039.defaultProps = {
    isVirtualiseEnabled: false,
    isCreateLastEnabled: true,
    isCreateSiblingEnabled: true,
    isCreateChildEnabled: true,
    isDragEnabled: true,
    isSelectEnabled: true,
    isMultiSelectEnabled: false,
    isResizeEnabled: true,
    isHighlightToday: true,
    isHideScrollbar: false,
    items: [],
    headerItems: [],
    expandedItems: {},
    renderers: {},
    marshalOptions: {},
    createItemAnchor: undefined,
    activeItemId: undefined,
    selectedItemIds: [],
    itemHeight: (0, $gf0vG.DEFAULT_ITEM_HEIGHT),
    listWidth: (0, $gf0vG.DEFAULT_LIST_WIDTH)(),
    DndLongTaskMetric: undefined,
    onItemSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemMultiSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemActivate: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemDrop: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCreateClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemExpandChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onSetListWidth: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    ariaRowCount: undefined,
    ariaLabel: undefined,
    ariaReadOnly: undefined,
    listItemMenuOptions: {
        overrideLabels: {},
        customSections: []
    }
};

});
parcelRegister("9WNLk", function(module, exports) {

$parcel$export(module.exports, "useEnablements", () => $bc1114de86d96336$export$f6bfb0ec6efae17b);
$parcel$export(module.exports, "EnablementProvider", () => $bc1114de86d96336$export$221a50e4a5e2cf12);

var $WBLbN = parcelRequire("WBLbN");

var $jlV0M = parcelRequire("jlV0M");
const $bc1114de86d96336$var$initialState = {
    isDragEnabled: false,
    isSelectEnabled: false,
    isMultiSelectEnabled: false,
    isCreateLastEnabled: false,
    isCreateSiblingEnabled: false,
    isCreateChildEnabled: false,
    isHighlightToday: true,
    isTreeDrag: false,
    isMeatballsButtonEnabled: false
};
const $bc1114de86d96336$export$faca84be7efd165 = (0, $WBLbN.createStore)({
    initialState: $bc1114de86d96336$var$initialState,
    actions: $jlV0M.actions,
    name: 'timeline-table.enablements'
});
const $bc1114de86d96336$export$f6bfb0ec6efae17b = (0, $WBLbN.createHook)($bc1114de86d96336$export$faca84be7efd165);
const $bc1114de86d96336$export$221a50e4a5e2cf12 = (0, $WBLbN.createContainer)($bc1114de86d96336$export$faca84be7efd165, {
    onInit: ()=>({ setState: setState }, enablements)=>{
            setState({
                ...enablements
            });
        },
    onUpdate: ()=>({ setState: setState }, enablements)=>{
            setState({
                ...enablements
            });
        }
});

});
parcelRegister("jlV0M", function(module, exports) {

$parcel$export(module.exports, "actions", () => $00517908b6a93b84$export$e324594224ef24da);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $00517908b6a93b84$export$e324594224ef24da = {};

});


parcelRegister("VrUCp", function(module, exports) {

$parcel$export(module.exports, "useHeaderState", () => $8886d03b4d1abdd7$export$704ca874967743c3);
$parcel$export(module.exports, "useAriaRowOffset", () => $8886d03b4d1abdd7$export$21de272f1555a588);
$parcel$export(module.exports, "useHeaderItemIndexes", () => $8886d03b4d1abdd7$export$665cd3c10cd5eb7);
$parcel$export(module.exports, "default", () => $8886d03b4d1abdd7$export$2e2bcd8739ae039);

var $WBLbN = parcelRequire("WBLbN");

var $gf0vG = parcelRequire("gf0vG");

var $eubl3 = parcelRequire("eubl3");

var $gwTvV = parcelRequire("gwTvV");
const $8886d03b4d1abdd7$var$initialState = {
    headerItems: [],
    headerHeight: (0, $gf0vG.BASE_HEADER_HEIGHT),
    headerItemsOffsetTop: {},
    isRowCountKnown: true
};
const $8886d03b4d1abdd7$export$52342bdf89fb39e7 = (0, $WBLbN.createStore)({
    initialState: $8886d03b4d1abdd7$var$initialState,
    actions: $eubl3.actions,
    name: 'timeline-table.header'
});
const $8886d03b4d1abdd7$export$704ca874967743c3 = (0, $WBLbN.createHook)($8886d03b4d1abdd7$export$52342bdf89fb39e7);
const $8886d03b4d1abdd7$export$21de272f1555a588 = (0, $WBLbN.createHook)($8886d03b4d1abdd7$export$52342bdf89fb39e7, {
    selector: ({ isRowCountKnown: isRowCountKnown, headerItems: headerItems })=>isRowCountKnown ? headerItems.length : undefined
});
const $8886d03b4d1abdd7$export$665cd3c10cd5eb7 = (0, $WBLbN.createHook)($8886d03b4d1abdd7$export$52342bdf89fb39e7, {
    selector: ({ headerItems: headerItems })=>headerItems.reduce((acc, item, index)=>{
            acc[item.id] = index;
            return acc;
        }, {})
});
const $8886d03b4d1abdd7$var$handleState = ()=>({ setState: setState }, { headerItems: headerItems, isRowCountKnown: isRowCountKnown })=>{
        const derivedHeaderState = (0, $gwTvV.getDerivedHeaderState)(headerItems);
        setState({
            ...derivedHeaderState,
            isRowCountKnown: isRowCountKnown
        });
    };
const $8886d03b4d1abdd7$var$HeaderProvider = (0, $WBLbN.createContainer)($8886d03b4d1abdd7$export$52342bdf89fb39e7, {
    onInit: $8886d03b4d1abdd7$var$handleState,
    onUpdate: $8886d03b4d1abdd7$var$handleState
});
var $8886d03b4d1abdd7$export$2e2bcd8739ae039 = $8886d03b4d1abdd7$var$HeaderProvider;

});
parcelRegister("eubl3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ba9887bf83781838$export$e324594224ef24da);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ba9887bf83781838$export$e324594224ef24da = {};

});

parcelRegister("gwTvV", function(module, exports) {

$parcel$export(module.exports, "getDerivedHeaderState", () => $66a76eed592e3b88$export$cde087a6551ccf85);

var $gf0vG = parcelRequire("gf0vG");
const $66a76eed592e3b88$export$cde087a6551ccf85 = (customHeaderItems)=>{
    // There will always be a default header which we should still include in the header state
    const combinedHeaderItems = [
        {
            id: (0, $gf0vG.DEFAULT_HEADER_ROW_ID),
            height: (0, $gf0vG.BASE_HEADER_HEIGHT)
        },
        ...customHeaderItems
    ];
    // Make it so we don't require cascading fallback checks
    const sanitizedHeaderItems = combinedHeaderItems.map(({ id: id, height: height })=>({
            id: id,
            height: height ?? (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT)
        }));
    const headerItemsOffsetTop = {};
    const headerHeight = sanitizedHeaderItems.reduce((total, { id: id, height: height })=>{
        headerItemsOffsetTop[id] = total;
        return total + height;
    }, 0);
    return {
        headerItems: sanitizedHeaderItems,
        headerHeight: headerHeight,
        headerItemsOffsetTop: headerItemsOffsetTop
    };
};

});


parcelRegister("lSR7G", function(module, exports) {

$parcel$export(module.exports, "useItems", () => $bde75a318eddaba8$export$7bfdd97581ca93c);
$parcel$export(module.exports, "useItemIndexes", () => $bde75a318eddaba8$export$bd1eaa5808f71a42);
$parcel$export(module.exports, "useIsItemSelected", () => $bde75a318eddaba8$export$3d9fe48014f19d8a);
$parcel$export(module.exports, "useIsItemMultiSelected", () => $bde75a318eddaba8$export$e452b1d46f765b84);
$parcel$export(module.exports, "useItemsSelectionCount", () => $bde75a318eddaba8$export$fd6d33cbb99af134);
$parcel$export(module.exports, "useIsTableEmpty", () => $bde75a318eddaba8$export$ad9c09bad4bdddda);
$parcel$export(module.exports, "useItemsCount", () => $bde75a318eddaba8$export$29409325c4d1aa3a);
$parcel$export(module.exports, "useAriaRowCount", () => $bde75a318eddaba8$export$35cd36afbcd5e208);
$parcel$export(module.exports, "useItemHeight", () => $bde75a318eddaba8$export$1d47b041c6ce1962);
$parcel$export(module.exports, "useItemsContainerStyles", () => $bde75a318eddaba8$export$4d54f7a51148a517);
$parcel$export(module.exports, "useCreateItemAnchor", () => $bde75a318eddaba8$export$79c0b16424e10cdb);
$parcel$export(module.exports, "useCreateItemAnchorIndex", () => $bde75a318eddaba8$export$97b98339b446b4f4);
$parcel$export(module.exports, "useSelectedItemIds", () => $bde75a318eddaba8$export$c9fc8524b88d56df);
$parcel$export(module.exports, "useActiveItemId", () => $bde75a318eddaba8$export$6962c376bd636b65);
$parcel$export(module.exports, "useIsItemActive", () => $bde75a318eddaba8$export$22302ddf52c3b4c2);
$parcel$export(module.exports, "useIsItemSelectable", () => $bde75a318eddaba8$export$a431ef15e96621e9);
$parcel$export(module.exports, "ItemsProvider", () => $bde75a318eddaba8$export$dab1678cbe62d3ff);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $WBLbN = parcelRequire("WBLbN");

var $gf0vG = parcelRequire("gf0vG");

var $1sAbG = parcelRequire("1sAbG");

var $8zane = parcelRequire("8zane");

var $kTIHV = parcelRequire("kTIHV");

var $VrUCp = parcelRequire("VrUCp");

var $2qMqD = parcelRequire("2qMqD");

var $dHiyA = parcelRequire("dHiyA");
const $bde75a318eddaba8$var$DEFAULT_STATE = {
    items: [],
    itemIndexes: {},
    selectedItemIds: [],
    rangeAnchorItemId: undefined,
    onItemMultiSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    activeItemId: undefined,
    onItemActivate: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    // Remove this with project_timeline_multi-select_and_checkboxes
    itemsSelectionState: {},
    // Remove this with project_timeline_multi-select_and_checkboxes
    itemsSelectionCount: 0,
    ariaRowCount: 0,
    isTableEmpty: false,
    itemsBackground: 'none',
    totalHeight: 0,
    itemHeight: (0, $gf0vG.DEFAULT_ITEM_HEIGHT),
    createItemAnchor: undefined
};
const $bde75a318eddaba8$var$store = (0, $WBLbN.createStore)({
    initialState: $bde75a318eddaba8$var$DEFAULT_STATE,
    actions: $2qMqD.actions,
    name: 'timeline-table.items'
});
const $bde75a318eddaba8$export$fbd09c28377f1868 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store);
const $bde75a318eddaba8$export$7bfdd97581ca93c = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItems)
});
const $bde75a318eddaba8$export$bd1eaa5808f71a42 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItemIndexes)
});
const $bde75a318eddaba8$export$3d9fe48014f19d8a = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getIsItemSelected)
});
const $bde75a318eddaba8$export$e452b1d46f765b84 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getIsItemMultiSelected)
});
const $bde75a318eddaba8$export$fd6d33cbb99af134 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItemsSelectionCount)
});
const $bde75a318eddaba8$export$ad9c09bad4bdddda = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getIsTableEmpty)
});
const $bde75a318eddaba8$export$29409325c4d1aa3a = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItemsCount)
});
const $bde75a318eddaba8$export$35cd36afbcd5e208 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getAriaRowCount)
});
const $bde75a318eddaba8$export$1d47b041c6ce1962 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItemHeight)
});
const $bde75a318eddaba8$export$4d54f7a51148a517 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItemsContainerStyles)
});
const $bde75a318eddaba8$export$79c0b16424e10cdb = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getCreateItemAnchor)
});
const $bde75a318eddaba8$export$97b98339b446b4f4 = (0, $WBLbN.createStateHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getCreateItemAnchorIndex)
});
const $bde75a318eddaba8$export$51a276b6d0945af7 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getHasActiveCreate)
});
const $bde75a318eddaba8$export$c9fc8524b88d56df = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getSelectedItemIds)
});
const $bde75a318eddaba8$export$6962c376bd636b65 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getActiveItemId)
});
const $bde75a318eddaba8$export$22302ddf52c3b4c2 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getIsItemActive)
});
const $bde75a318eddaba8$export$a431ef15e96621e9 = (0, $WBLbN.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getIsItemSelectable)
});
const $bde75a318eddaba8$var$updateState = ()=>({ setState: setState }, { items: items, createItemAnchor: createItemAnchor, expandedItems: expandedItems, activeItemId: activeItemId, onItemActivate: onItemActivate, selectedItemIdsWithPermission: selectedItemIdsWithPermission, onItemMultiSelect: onItemMultiSelect, isCreateLastEnabled: isCreateLastEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isCreateChildEnabled: isCreateChildEnabled, itemHeight: itemHeight, ariaRowOffset: ariaRowOffset })=>{
        const { flatItems: flatItems, itemIndexes: itemIndexes, ariaRowCount: ariaRowCount } = (0, $1sAbG.getHierarchyEnrichedItems)(items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, itemHeight, ariaRowOffset);
        const itemsSelectionState = (0, $kTIHV.getSelectedItemIdsHash)(selectedItemIdsWithPermission);
        const { itemsBackground: itemsBackground, totalHeight: totalHeight } = (0, $8zane.getItemsContainerStyle)(flatItems, itemHeight);
        setState({
            items: flatItems,
            itemIndexes: itemIndexes,
            itemsSelectionState: itemsSelectionState,
            itemsSelectionCount: selectedItemIdsWithPermission?.length,
            activeItemId: activeItemId,
            onItemActivate: onItemActivate,
            selectedItemIds: selectedItemIdsWithPermission ?? [],
            onItemMultiSelect: onItemMultiSelect,
            ariaRowCount: ariaRowCount,
            isTableEmpty: items.length === 0,
            itemsBackground: itemsBackground,
            totalHeight: totalHeight,
            itemHeight: itemHeight,
            createItemAnchor: createItemAnchor
        });
    };
const $bde75a318eddaba8$var$ItemsProviderContainer = (0, $WBLbN.createContainer)($bde75a318eddaba8$var$store, {
    onInit: $bde75a318eddaba8$var$updateState,
    onUpdate: $bde75a318eddaba8$var$updateState
});
const $bde75a318eddaba8$export$dab1678cbe62d3ff = (props)=>{
    const [ariaRowOffset] = (0, $VrUCp.useAriaRowOffset)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bde75a318eddaba8$var$ItemsProviderContainer, {
        ...props,
        ariaRowOffset: ariaRowOffset
    });
};

});
parcelRegister("1sAbG", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $f8b6334e2bcb5845$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "isBaseLevel", () => $f8b6334e2bcb5845$export$3f3fbf12338c09a4);
$parcel$export(module.exports, "getItemLevel", () => $f8b6334e2bcb5845$export$aabd95853648484e);
$parcel$export(module.exports, "getHierarchyEnrichedItems", () => $f8b6334e2bcb5845$export$29090c866cb2cf07);

var $5iWql = parcelRequire("5iWql");


var $gf0vG = parcelRequire("gf0vG");
const $f8b6334e2bcb5845$export$e3140dc7d0c35e48 = (depth)=>depth === (0, $gf0vG.DEFAULT_DEPTH);
const $f8b6334e2bcb5845$export$3f3fbf12338c09a4 = (level)=>level === (0, $gf0vG.BASE_LEVEL);
const $f8b6334e2bcb5845$var$shouldCreateBeforeItem = (createItemAnchor, id)=>createItemAnchor !== undefined && createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === id;
const $f8b6334e2bcb5845$var$shouldCreateInsideItem = (createItemAnchor, id)=>{
    if (createItemAnchor === undefined) return false;
    const createChildLast = createItemAnchor.position === (0, $gf0vG.INSIDE) && createItemAnchor.parentId === id;
    const createChildSibling = createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.parentId === id;
    return createChildLast || createChildSibling;
};
const $f8b6334e2bcb5845$var$shouldCreateLast = (createItemAnchor)=>createItemAnchor === undefined || createItemAnchor.position === (0, $gf0vG.LAST);
/* The rootIndex is the position of the item at depth 0.
 * For parent items this will be its position, excluding any children.
 * For child items, this will be its parents position, as defined by the above.
 */ const $f8b6334e2bcb5845$var$getItemBackgroundColor = (rootIndex)=>rootIndex % 2 === 0 ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-surface-sunken, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
// To make sure the create item can be properly reconciled, we need a stable key.
const $f8b6334e2bcb5845$var$getStableCreateId = (createItemAnchor)=>{
    if (createItemAnchor === undefined) return 0, $gf0vG.DEFAULT_CREATE_ID;
    /**
   * We want to keep default key for the item at the end of the list
   * otherwise new key generation will unmount and then mount component again
   * which breaks empty list lifecycle
   */ if (!('beforeId' in createItemAnchor) && createItemAnchor.position === (0, $gf0vG.LAST)) return 0, $gf0vG.DEFAULT_CREATE_ID;
    if (createItemAnchor.position === (0, $gf0vG.INSIDE) && createItemAnchor.parentId) return `create-${createItemAnchor.position}${createItemAnchor.parentId}`;
    return `create-${createItemAnchor.position}${'beforeId' in createItemAnchor && createItemAnchor.beforeId ? createItemAnchor.beforeId : ''}`;
};
/* When creating last, it was always be on the same level as the root items.
 * When creating before, it will be on the same level as its anchor item.
 * When creating inside, it will be one level lower than its anchor item.
 */ const $f8b6334e2bcb5845$var$getCreateLevel = (createItemAnchor, anchorItem)=>{
    if (anchorItem === undefined) return 0, $gf0vG.DEFAULT_LEVEL;
    // If not a create before, it will be a create inside
    const { id: id, level: level } = anchorItem;
    return $f8b6334e2bcb5845$var$shouldCreateBeforeItem(createItemAnchor, id) ? level : level - 1;
};
const $f8b6334e2bcb5845$var$getCreateDepth = (createItemAnchor, anchorItem)=>{
    if (anchorItem === undefined) return 0, $gf0vG.DEFAULT_DEPTH;
    // If not a create before, it will be a create inside
    const { id: id, depth: depth = 0 } = anchorItem;
    return $f8b6334e2bcb5845$var$shouldCreateBeforeItem(createItemAnchor, id) ? depth : depth + 1;
};
const $f8b6334e2bcb5845$var$enrichCreateItem = ({ anchorItem: anchorItem, parentId: parentId, createItemAnchor: createItemAnchor, rootIndex: rootIndex, ariaRowIndex: ariaRowIndex, startOffset: startOffset, topOffset: topOffset, flatIndex: flatIndex })=>({
        id: $f8b6334e2bcb5845$var$getStableCreateId(createItemAnchor),
        type: (0, $gf0vG.CREATE_ITEM_TYPE),
        anchorItem: anchorItem,
        meta: {
            level: $f8b6334e2bcb5845$var$getCreateLevel(createItemAnchor, anchorItem),
            isActive: createItemAnchor !== undefined,
            backgroundColor: $f8b6334e2bcb5845$var$getItemBackgroundColor(rootIndex),
            parentId: parentId,
            ariaRowIndex: ariaRowIndex,
            topOffset: topOffset + startOffset,
            depth: $f8b6334e2bcb5845$var$getCreateDepth(createItemAnchor, anchorItem)
        },
        flatIndex: flatIndex
    });
const $f8b6334e2bcb5845$var$countDescendants = (item)=>{
    const { childItems: childItems = [] } = item;
    return childItems.length + childItems.reduce((acc, child)=>acc + $f8b6334e2bcb5845$var$countDescendants(child), 0);
};
const $f8b6334e2bcb5845$var$enrichItem = ({ item: item, expandedItems: expandedItems, rootIndex: rootIndex, flatIndex: flatIndex, ariaRowIndex: ariaRowIndex, isParent: isParent, numChildren: numChildren, startOffset: startOffset, childItemsHeight: childItemsHeight, parentItem: parentItem, ariaControls: ariaControls })=>({
        type: (0, $gf0vG.ITEM_TYPE),
        item: item,
        meta: {
            parentId: parentItem?.item.id,
            backgroundColor: $f8b6334e2bcb5845$var$getItemBackgroundColor(rootIndex),
            isParent: isParent,
            isExpanded: Boolean(expandedItems[item.id]),
            ariaRowIndex: ariaRowIndex,
            numChildren: numChildren,
            childItemsHeight: childItemsHeight,
            rootIndex: rootIndex,
            topOffset: (parentItem?.meta.topOffset ?? 0) + startOffset,
            ariaControls: ariaControls
        },
        flatIndex: flatIndex
    });
const $f8b6334e2bcb5845$export$aabd95853648484e = (enrichedItem)=>{
    switch(enrichedItem.type){
        case 0, $gf0vG.CREATE_ITEM_TYPE:
            return enrichedItem.meta.level;
        case 0, $gf0vG.ITEM_TYPE:
            return enrichedItem.item.level;
        default:
            {
                const _exhaustiveCheck = enrichedItem;
                return -1;
            }
    }
};
const $f8b6334e2bcb5845$export$29090c866cb2cf07 = (0, $5iWql.default)((items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, rootItemHeight, ariaRowOffset, lastFlatIndex = 0, parentItem)=>{
    // the height of any item is set depending on its depth
    // - root items have a height of rootItemHeight
    // - nested items have a height of nestedItemHeight
    const depth = parentItem ? (parentItem.item.depth ?? 0) + 1 : 0;
    // if the parent item is root (has no parent), then the offset should be 0 otherwise it should be the parent's height
    // as the item is positioned relative to its parent's container
    let offset = 0;
    if (depth > 0) // add the parent's height to the offset
    offset += depth > 1 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : rootItemHeight;
    let flatIndex = lastFlatIndex;
    const isRowCountKnown = ariaRowOffset !== undefined;
    let ariaRowIndex = (ariaRowOffset ?? 0) + 1; // NOTE: aria-rowindex starts from 1 instead of 0
    const flattenedItems = [];
    const itemIndexes = {};
    items.forEach((item, index)=>{
        const rootIndex = parentItem?.meta.rootIndex ?? index;
        const itemHeight = depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : rootItemHeight;
        const { id: id, level: level = (0, $gf0vG.DEFAULT_LEVEL), isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, childItems: childItems = [] } = item;
        const itemProps = {
            id: id,
            level: level,
            depth: depth,
            isInTransition: isInTransition,
            canCreateChildOverride: canCreateChildOverride
        };
        if (isCreateSiblingEnabled && $f8b6334e2bcb5845$var$shouldCreateBeforeItem(createItemAnchor, id)) {
            const createItem = $f8b6334e2bcb5845$var$enrichCreateItem({
                anchorItem: itemProps,
                parentId: parentItem?.item.id,
                createItemAnchor: createItemAnchor,
                rootIndex: rootIndex,
                ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                startOffset: offset,
                topOffset: parentItem?.meta?.topOffset ?? 0,
                flatIndex: flatIndex
            });
            flattenedItems.push(createItem);
            itemIndexes[createItem.id] = flatIndex;
            ariaRowIndex += 1;
            // create item has always height of the root level
            offset += rootItemHeight;
            // we need to increase the flat index to account for the create item
            flatIndex += 1;
        }
        // this is to find out if there is a create item inside the item to count it in the children count
        const isChildCreate = isCreateChildEnabled && canCreateChildOverride && $f8b6334e2bcb5845$var$shouldCreateInsideItem(createItemAnchor, id);
        // this is to create child is being created using the plus button next to the item
        const isChildCreateInside = Boolean(isChildCreate && createItemAnchor && createItemAnchor.position === (0, $gf0vG.INSIDE));
        // ItemsRenderer uses this count to find the child items in the flattened items
        const numChildren = childItems.length + (isChildCreate ? 1 : 0);
        const flattenedItem = $f8b6334e2bcb5845$var$enrichItem({
            item: itemProps,
            expandedItems: expandedItems,
            rootIndex: rootIndex,
            flatIndex: flatIndex,
            ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
            isParent: childItems.length > 0,
            numChildren: numChildren,
            // will be calculated after recursively created child items
            startOffset: offset,
            childItemsHeight: 0,
            parentItem: // will be calculated after recursively created child items
            parentItem,
            ...childItems.length > 0 && {
                ariaControls: childItems.map((child)=>child.id).join(' ')
            }
        });
        // Increase the index to account for the parent item, which will be inserted first
        flatIndex += 1;
        ariaRowIndex += 1;
        // consider the item itself is added to calculate the offset
        offset += itemHeight;
        let innerHierarchyEnrichedItems;
        let itemsHeight = 0;
        let childEnrichedItems = [];
        if (expandedItems[id]) {
            // for the children the offset is relative the parent
            // so we should reset the offset to parentsHeight
            innerHierarchyEnrichedItems = $f8b6334e2bcb5845$export$29090c866cb2cf07(childItems, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, rootItemHeight, isRowCountKnown ? ariaRowIndex - 1 : -1, flatIndex, flattenedItem);
            ariaRowIndex = innerHierarchyEnrichedItems?.ariaRowIndex ?? 0;
            // the height of the parent shouldn't be included in the children height
            itemsHeight = (innerHierarchyEnrichedItems?.offset ?? itemHeight) - itemHeight;
            childEnrichedItems = innerHierarchyEnrichedItems?.flatItems ?? [];
            flatIndex = innerHierarchyEnrichedItems?.flatIndex ?? flatIndex;
            // Creating an item inside a parent will always be in last position
            if (isChildCreateInside) {
                const createChildItem = $f8b6334e2bcb5845$var$enrichCreateItem({
                    anchorItem: itemProps,
                    parentId: id,
                    createItemAnchor: createItemAnchor,
                    rootIndex: rootIndex,
                    ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                    // offset of the create item would be the height of prior children plus the parent height,
                    startOffset: itemsHeight + itemHeight,
                    topOffset: flattenedItem?.meta?.topOffset ?? 0,
                    flatIndex: flatIndex
                });
                childEnrichedItems.push(createChildItem);
                // offset will be calculated based on the itemsHeight so we don't need to increase it here
                itemsHeight += rootItemHeight;
                ariaRowIndex += 1;
                flatIndex += 1;
            }
        } else ariaRowIndex += $f8b6334e2bcb5845$var$countDescendants(item);
        flattenedItems.push({
            ...flattenedItem,
            meta: {
                ...flattenedItem.meta,
                childItemsHeight: itemsHeight
            }
        });
        itemIndexes[flattenedItem.item.id] = flattenedItem.flatIndex;
        childEnrichedItems.forEach((enrichedChildItem)=>{
            flattenedItems.push(enrichedChildItem);
            const key = 'id' in enrichedChildItem ? enrichedChildItem.id : enrichedChildItem.item.id;
            itemIndexes[key] = enrichedChildItem.flatIndex;
        });
        offset += itemsHeight;
    });
    if (depth === (0, $gf0vG.DEFAULT_DEPTH) && isCreateLastEnabled && $f8b6334e2bcb5845$var$shouldCreateLast(createItemAnchor)) {
        const createItem = $f8b6334e2bcb5845$var$enrichCreateItem({
            anchorItem: undefined,
            parentId: undefined,
            createItemAnchor: createItemAnchor,
            rootIndex: items.length,
            ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
            startOffset: offset,
            topOffset: parentItem?.meta?.topOffset ?? 0,
            flatIndex: flatIndex
        });
        flattenedItems.push(createItem);
        itemIndexes[createItem.id] = flatIndex;
        ariaRowIndex += 1;
        offset += rootItemHeight;
        flatIndex += 1;
    }
    return {
        flatItems: flattenedItems,
        itemIndexes: itemIndexes,
        ariaRowCount: isRowCountKnown ? ariaRowIndex - 1 : -1,
        offset: offset,
        flatIndex: flatIndex,
        ariaRowIndex: ariaRowIndex
    };
});

});

parcelRegister("8zane", function(module, exports) {

$parcel$export(module.exports, "getItemsContainerStyle", () => $8aefd92011664154$export$30f72c856f253ec5);

var $5iWql = parcelRequire("5iWql");


var $gf0vG = parcelRequire("gf0vG");
const $8aefd92011664154$export$38a59fc64a33c476 = (0, $5iWql.default)((items, itemHeight)=>{
    if (!items.length) return [];
    const rows = [];
    // we should only iterate on the top level items (depth === 0)
    // Only the root items alternate the bg color ¯\_(ツ)_/¯
    let createItemIndex = -1;
    items.filter(({ meta: meta })=>meta?.parentId === undefined).forEach((item, index)=>{
        // Row height includes child items' height which is already calculated,
        // and the item's height itself in meta
        // Only the last create-item row alternates bg color ¯\_(ツ)_/¯
        if (item.type === (0, $gf0vG.CREATE_ITEM_TYPE)) {
            if (index === items.length - 1) rows.push(itemHeight);
            else // save the create index, so we could add it up to the previous (or next) row after calculation
            createItemIndex = index;
        } else // This is an ITEM_TYPE,
        // childItemsHeight would be zero if the item is not expanded
        rows.push((item.meta?.childItemsHeight || 0) + itemHeight);
    });
    // if there is a create item at the top level but not last item, add it to the previous row
    // if the create item is the first item, it'll add it to the first ITEM_TYPE
    if (createItemIndex !== -1) rows[Math.max(0, createItemIndex - 1)] += itemHeight;
    return rows;
});
const $8aefd92011664154$export$115273ef5e87cd0c = (0, $5iWql.default)((rows)=>{
    if (!rows.length) return {
        itemsBackground: `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5})`,
        totalHeight: 0
    };
    const prefix = 'linear-gradient(to bottom,';
    let position = 0;
    /**
   * Split rows background into smaller chunks due to a bug in Chrome browser
   * Chrome renders blurry edges when there are more than ~6 entries
   * https://bugs.chromium.org/p/chromium/issues/detail?id=1103863
   */ let count = 0;
    const chunkSize = 4;
    const rowsBackground = rows.reduce((accum, curr, index)=>{
        const bgColor = index % 2 === 0 ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-surface-sunken, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
        let rowStyle = `${bgColor} ${position}px ${position + curr}px`;
        if (count === chunkSize || index === rows.length - 1) {
            count = 0;
            rowStyle += `,transparent ${position + curr}px)`;
            rowStyle += index !== rows.length - 1 ? `,${prefix}` : '';
        } else {
            count += 1;
            rowStyle += ',';
        }
        position += curr;
        return accum + rowStyle;
    }, prefix);
    return {
        itemsBackground: rowsBackground,
        totalHeight: position
    };
});
const $8aefd92011664154$export$30f72c856f253ec5 = (0, $5iWql.default)((items, itemHeight)=>{
    const rows = $8aefd92011664154$export$38a59fc64a33c476(items, itemHeight);
    return $8aefd92011664154$export$115273ef5e87cd0c(rows);
});

});

parcelRegister("kTIHV", function(module, exports) {

$parcel$export(module.exports, "getSelectedItemIdsHash", () => $86097d83f4a1cde3$export$6147ec740e92f913);

var $5iWql = parcelRequire("5iWql");
const $86097d83f4a1cde3$export$6147ec740e92f913 = (0, $5iWql.default)((selectedItemIdsWithPermission)=>selectedItemIdsWithPermission ? selectedItemIdsWithPermission.reduce((itemsSelectionState, selectedItemId)=>{
        Object.assign(itemsSelectionState, {
            [selectedItemId]: true
        });
        return itemsSelectionState;
    }, {}) : undefined);

});

parcelRegister("2qMqD", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e6389b14b83cdc8f$export$e324594224ef24da);

var $6aCS7 = parcelRequire("6aCS7");

var $1sAbG = parcelRequire("1sAbG");
const $e6389b14b83cdc8f$export$e324594224ef24da = {
    toggleItem: (id, { analyticsEvent: analyticsEvent, deselectOthers: deselectOthers, withRange: withRange })=>({ setState: setState, getState: getState })=>{
            const { items: items, selectedItemIds: selectedItemIds, activeItemId: activeItemId, rangeAnchorItemId: rangeAnchorItemId = activeItemId, itemIndexes: itemIndexes, onItemMultiSelect: onItemMultiSelect } = getState();
            const current = new Set(selectedItemIds);
            const next = deselectOthers ? new Set() : current;
            /** Resets when any of selected items no longer available. */ if (selectedItemIds.some((itemId)=>itemIndexes[itemId] === undefined)) next.clear();
            const selected = !current.has(id);
            const anchorIndex = withRange && rangeAnchorItemId ? itemIndexes[rangeAnchorItemId] : undefined;
            const targetIndex = withRange ? itemIndexes[id] : undefined;
            if (anchorIndex !== undefined && targetIndex !== undefined) {
                const anchorItem = items[anchorIndex];
                let itemIdsInRange = [];
                /** Indicates whether the range-select is cancelled due to cross parent selecting. */ let isRangeCancelled = false;
                const indexRange = [
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($6aCS7)))(anchorIndex, targetIndex),
                    targetIndex
                ];
                for (const index of indexRange){
                    const item = items[index];
                    if ('item' in item && (0, $1sAbG.getItemLevel)(item) === (0, $1sAbG.getItemLevel)(anchorItem)) itemIdsInRange.push(item.item.id);
                    /** Cancels if multi-select across the a higher-level issue. */ if ((0, $1sAbG.getItemLevel)(item) > (0, $1sAbG.getItemLevel)(anchorItem)) {
                        isRangeCancelled = true;
                        break;
                    }
                }
                if (isRangeCancelled) itemIdsInRange = [
                    id
                ];
                itemIdsInRange.forEach((itemIdInRange)=>{
                    selected ? next.add(itemIdInRange) : next.delete(itemIdInRange);
                });
            } else selected ? next.add(id) : next.delete(id);
            setState({
                rangeAnchorItemId: id
            });
            onItemMultiSelect(analyticsEvent, [
                ...next
            ]);
        },
    activateItem: (id)=>({ getState: getState, setState: setState })=>{
            getState().onItemActivate(id);
            setState({
                rangeAnchorItemId: id
            });
        }
};

});
parcelRegister("6aCS7", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $47e1d465ca3ee8c1$var$func = $jFIrw('range', (parcelRequire("iqjbc")));

$47e1d465ca3ee8c1$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $47e1d465ca3ee8c1$var$func;

});
parcelRegister("jFIrw", function(module, exports) {

var $imppR = parcelRequire("imppR");

var $a02m0 = parcelRequire("a02m0");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $e524521dc9be9d0c$var$convert(name, func, options) {
    return $imppR($a02m0, name, func, options);
}
module.exports = $e524521dc9be9d0c$var$convert;

});
parcelRegister("imppR", function(module, exports) {

var $89eBv = parcelRequire("89eBv");

var $l6Yg9 = parcelRequire("l6Yg9");
/** Built-in value reference. */ var $d5ddff315914c7cb$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d5ddff315914c7cb$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d5ddff315914c7cb$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d5ddff315914c7cb$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d5ddff315914c7cb$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d5ddff315914c7cb$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d5ddff315914c7cb$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $l6Yg9, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($89eBv.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d5ddff315914c7cb$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d5ddff315914c7cb$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d5ddff315914c7cb$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $89eBv.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $89eBv.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$89eBv.skipFixed[name])) {
            var data = $89eBv.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d5ddff315914c7cb$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$89eBv.skipRearg[name]) ? rearg(func, $89eBv.methodRearg[name] || $89eBv.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $89eBv.aliasToReal[name] || name, methodName = $89eBv.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d5ddff315914c7cb$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d5ddff315914c7cb$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d5ddff315914c7cb$var$baseArity(rearg($d5ddff315914c7cb$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $89eBv.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($89eBv.mutate.array[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$cloneArray);
            else if ($89eBv.mutate.object[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$createCloner(func));
            else if ($89eBv.mutate.set[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($89eBv.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $89eBv.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($89eBv.aryMethod[aryKey], function(key) {
            var func = _[$89eBv.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($89eBv.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d5ddff315914c7cb$var$baseConvert;

});
parcelRegister("89eBv", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, (v) => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $5eea7e08a1db1590$export$85c665b4d7da9cb4, (v) => $5eea7e08a1db1590$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $5eea7e08a1db1590$export$42564e045b285e32, (v) => $5eea7e08a1db1590$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $5eea7e08a1db1590$export$81e17196e6a22b07, (v) => $5eea7e08a1db1590$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $5eea7e08a1db1590$export$30975ceb42167ebd, (v) => $5eea7e08a1db1590$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $5eea7e08a1db1590$export$8ceb0ad7e94d3801, (v) => $5eea7e08a1db1590$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $5eea7e08a1db1590$export$fbaeb3f87df3cf26, (v) => $5eea7e08a1db1590$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $5eea7e08a1db1590$export$57e795267c26e600, (v) => $5eea7e08a1db1590$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $5eea7e08a1db1590$export$1eb71a7e27943e71, (v) => $5eea7e08a1db1590$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $5eea7e08a1db1590$export$aee1dbae5de2db9d, (v) => $5eea7e08a1db1590$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $5eea7e08a1db1590$export$87ffbe4821a5d5e0, (v) => $5eea7e08a1db1590$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $5eea7e08a1db1590$export$b4d07413ce528c90, (v) => $5eea7e08a1db1590$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $5eea7e08a1db1590$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $5eea7e08a1db1590$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $5eea7e08a1db1590$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $5eea7e08a1db1590$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $5eea7e08a1db1590$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $5eea7e08a1db1590$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $5eea7e08a1db1590$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $5eea7e08a1db1590$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $5eea7e08a1db1590$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $5eea7e08a1db1590$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $5eea7e08a1db1590$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $5eea7e08a1db1590$export$b4d07413ce528c90;
$5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$5eea7e08a1db1590$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$5eea7e08a1db1590$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$5eea7e08a1db1590$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$5eea7e08a1db1590$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$5eea7e08a1db1590$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$5eea7e08a1db1590$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$5eea7e08a1db1590$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$5eea7e08a1db1590$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$5eea7e08a1db1590$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$5eea7e08a1db1590$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$5eea7e08a1db1590$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("l6Yg9", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("a02m0", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("iX5mF")),
    'assign': (parcelRequire("k1JQY")),
    'clone': (parcelRequire("E0NNP")),
    'curry': (parcelRequire("cleLA")),
    'forEach': (parcelRequire("9Kzih")),
    'isArray': (parcelRequire("1c8hB")),
    'isError': (parcelRequire("dbogu")),
    'isFunction': (parcelRequire("eoCgY")),
    'isWeakMap': (parcelRequire("a1CHL")),
    'iteratee': (parcelRequire("akHxB")),
    'keys': (parcelRequire("fCpZe")),
    'rearg': (parcelRequire("k5dRT")),
    'toInteger': (parcelRequire("hNahz")),
    'toPath': (parcelRequire("d0KBl"))
};

});
parcelRegister("iX5mF", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $dcc1e600da485164$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $dcc1e600da485164$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $xQ3hV(func, $dcc1e600da485164$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $dcc1e600da485164$var$ary;

});
parcelRegister("xQ3hV", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $ajgvA = parcelRequire("ajgvA");

var $4sFI9 = parcelRequire("4sFI9");

var $dJxZV = parcelRequire("dJxZV");

var $3slGh = parcelRequire("3slGh");

var $6bTTb = parcelRequire("6bTTb");

var $fHM5F = parcelRequire("fHM5F");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");

var $hNahz = parcelRequire("hNahz");
/** Error message constants. */ var $065b75a1a2ef24b3$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $065b75a1a2ef24b3$var$WRAP_BIND_FLAG = 1, $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG = 2, $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG = 8, $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG = 16, $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG = 32, $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065b75a1a2ef24b3$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $065b75a1a2ef24b3$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($065b75a1a2ef24b3$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $065b75a1a2ef24b3$var$nativeMax($hNahz(ary), 0);
    arity = arity === undefined ? arity : $hNahz(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $6bTTb(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $fHM5F(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $065b75a1a2ef24b3$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $065b75a1a2ef24b3$var$WRAP_BIND_FLAG) var result = $ajgvA(func, bitmask, thisArg);
    else if (bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG || bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG) result = $4sFI9(func, bitmask, arity);
    else if ((bitmask == $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG || bitmask == ($065b75a1a2ef24b3$var$WRAP_BIND_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $3slGh(func, bitmask, thisArg, partials);
    else result = $dJxZV.apply(undefined, newData);
    var setter = data ? $2n5KA : $bV9co;
    return $3mXyn(setter(result, newData), func, bitmask);
}
module.exports = $065b75a1a2ef24b3$var$createWrap;

});
parcelRegister("2n5KA", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");

var $beYtW = parcelRequire("beYtW");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $1ba230a38b363991$var$baseSetData = !$beYtW ? $3QMTK : function(func, data) {
    $beYtW.set(func, data);
    return func;
};
module.exports = $1ba230a38b363991$var$baseSetData;

});

parcelRegister("ajgvA", function(module, exports) {

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $78187bf3ce07aa33$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $78187bf3ce07aa33$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $78187bf3ce07aa33$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $78187bf3ce07aa33$var$createBind;

});
parcelRegister("4ptXN", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $feGjZ = parcelRequire("feGjZ");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $3360bd57e2c33b86$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $9F9XB(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $feGjZ(result) ? result : thisBinding;
    };
}
module.exports = $3360bd57e2c33b86$var$createCtor;

});


parcelRegister("4sFI9", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $dJxZV = parcelRequire("dJxZV");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $33fa21eee8bcca6f$var$createCurry(func, bitmask, arity) {
    var Ctor = $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $9xQzO(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBgrU(args, placeholder);
        length -= holders.length;
        if (length < arity) return $lOKcz(func, bitmask, $dJxZV, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return $5VdlS(fn, this, args);
    }
    return wrapper;
}
module.exports = $33fa21eee8bcca6f$var$createCurry;

});
parcelRegister("dJxZV", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $24kQN = parcelRequire("24kQN");

var $4ptXN = parcelRequire("4ptXN");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $jtjhF = parcelRequire("jtjhF");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG = 1, $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG = 2, $9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG = 8, $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG = 16, $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG = 128, $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $9ff9d999ee3e5b26$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG, isBind = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG, isBindKey = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG | $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $9xQzO(wrapper), holdersCount = $24kQN(args, placeholder);
        if (partials) args = $98OfC(args, partials, holders, isCurried);
        if (partialsRight) args = $aoNSM(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBgrU(args, placeholder);
            return $lOKcz(func, bitmask, $9ff9d999ee3e5b26$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $jtjhF(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $c1MCs && this instanceof wrapper) fn = Ctor || $4ptXN(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $9ff9d999ee3e5b26$var$createHybrid;

});
parcelRegister("98OfC", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a7bd72e71453dbc$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $6a7bd72e71453dbc$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $6a7bd72e71453dbc$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $6a7bd72e71453dbc$var$composeArgs;

});

parcelRegister("aoNSM", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7922d6e81726c41f$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $7922d6e81726c41f$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $7922d6e81726c41f$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $7922d6e81726c41f$var$composeArgsRight;

});

parcelRegister("24kQN", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $181c20ffe0a73f5e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $181c20ffe0a73f5e$var$countHolders;

});

parcelRegister("lOKcz", function(module, exports) {

var $cp9gS = parcelRequire("cp9gS");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");
/** Used to compose bitmasks for function metadata. */ var $fe221b32db6745a2$var$WRAP_BIND_FLAG = 1, $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG = 2, $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG = 4, $fe221b32db6745a2$var$WRAP_CURRY_FLAG = 8, $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG = 32, $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $fe221b32db6745a2$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $fe221b32db6745a2$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($fe221b32db6745a2$var$WRAP_BIND_FLAG | $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($cp9gS(func)) $bV9co(result, newData);
    result.placeholder = placeholder;
    return $3mXyn(result, func, bitmask);
}
module.exports = $fe221b32db6745a2$var$createRecurry;

});
parcelRegister("bV9co", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $d1V3m = parcelRequire("d1V3m");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8adc2746a2aa5eeb$var$setData = $d1V3m($2n5KA);
module.exports = $8adc2746a2aa5eeb$var$setData;

});

parcelRegister("3mXyn", function(module, exports) {

var $4pgZb = parcelRequire("4pgZb");

var $1k0ou = parcelRequire("1k0ou");

var $ly0Gc = parcelRequire("ly0Gc");

var $7YePn = parcelRequire("7YePn");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $27419f3ed4dc5d4c$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $ly0Gc(wrapper, $1k0ou(source, $7YePn($4pgZb(source), bitmask)));
}
module.exports = $27419f3ed4dc5d4c$var$setWrapToString;

});
parcelRegister("4pgZb", function(module, exports) {
/** Used to match wrap detail comments. */ var $3356ac43c54e635f$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $3356ac43c54e635f$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $3356ac43c54e635f$var$getWrapDetails(source) {
    var match = source.match($3356ac43c54e635f$var$reWrapDetails);
    return match ? match[1].split($3356ac43c54e635f$var$reSplitDetails) : [];
}
module.exports = $3356ac43c54e635f$var$getWrapDetails;

});

parcelRegister("1k0ou", function(module, exports) {
/** Used to match wrap detail comments. */ var $0f67f6f702bebdca$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $0f67f6f702bebdca$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($0f67f6f702bebdca$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $0f67f6f702bebdca$var$insertWrapDetails;

});

parcelRegister("7YePn", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $lqZWH = parcelRequire("lqZWH");
/** Used to compose bitmasks for function metadata. */ var $5cd9a37742eb8774$var$WRAP_BIND_FLAG = 1, $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG = 2, $5cd9a37742eb8774$var$WRAP_CURRY_FLAG = 8, $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG = 16, $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG = 32, $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $5cd9a37742eb8774$var$WRAP_ARY_FLAG = 128, $5cd9a37742eb8774$var$WRAP_REARG_FLAG = 256, $5cd9a37742eb8774$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $5cd9a37742eb8774$var$wrapFlags = [
    [
        'ary',
        $5cd9a37742eb8774$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $5cd9a37742eb8774$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $5cd9a37742eb8774$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $5cd9a37742eb8774$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $5cd9a37742eb8774$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $5cd9a37742eb8774$var$updateWrapDetails(details, bitmask) {
    $9Kzih($5cd9a37742eb8774$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$lqZWH(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $5cd9a37742eb8774$var$updateWrapDetails;

});



parcelRegister("9xQzO", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $6f2ffabf17208972$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $6f2ffabf17208972$var$getHolder;

});

parcelRegister("jtjhF", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3hFfZ = parcelRequire("3hFfZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e2cfaf2379d6eef4$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $e2cfaf2379d6eef4$var$reorder(array, indexes) {
    var arrLength = array.length, length = $e2cfaf2379d6eef4$var$nativeMin(indexes.length, arrLength), oldArray = $b69Sx(array);
    while(length--){
        var index = indexes[length];
        array[length] = $3hFfZ(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $e2cfaf2379d6eef4$var$reorder;

});

parcelRegister("kBgrU", function(module, exports) {
/** Used as the internal argument placeholder. */ var $eff405cccdf3a041$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $eff405cccdf3a041$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $eff405cccdf3a041$var$PLACEHOLDER) {
            array[index] = $eff405cccdf3a041$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $eff405cccdf3a041$var$replaceHolders;

});



parcelRegister("3slGh", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $2844ce06b6725f7d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $2844ce06b6725f7d$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $2844ce06b6725f7d$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $5VdlS(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $2844ce06b6725f7d$var$createPartial;

});

parcelRegister("fHM5F", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $kBgrU = parcelRequire("kBgrU");
/** Used as the internal argument placeholder. */ var $b6f02cf0a655a19e$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $b6f02cf0a655a19e$var$WRAP_BIND_FLAG = 1, $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG = 2, $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG = 4, $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG = 8, $b6f02cf0a655a19e$var$WRAP_ARY_FLAG = 128, $b6f02cf0a655a19e$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b6f02cf0a655a19e$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $b6f02cf0a655a19e$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($b6f02cf0a655a19e$var$WRAP_BIND_FLAG | $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG | $b6f02cf0a655a19e$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG || srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($b6f02cf0a655a19e$var$WRAP_ARY_FLAG | $b6f02cf0a655a19e$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG ? 0 : $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $98OfC(partials, value, source[4]) : value;
        data[4] = partials ? $kBgrU(data[3], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $aoNSM(partials, value, source[6]) : value;
        data[6] = partials ? $kBgrU(data[5], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $b6f02cf0a655a19e$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $b6f02cf0a655a19e$var$mergeData;

});



parcelRegister("E0NNP", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");
/** Used to compose bitmasks for cloning. */ var $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $07845bdb18fff27f$var$clone(value) {
    return $ee7Ev(value, $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $07845bdb18fff27f$var$clone;

});

parcelRegister("cleLA", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $8fc2e687045586ce$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $8fc2e687045586ce$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $xQ3hV(func, $8fc2e687045586ce$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $8fc2e687045586ce$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$8fc2e687045586ce$var$curry.placeholder = {};
module.exports = $8fc2e687045586ce$var$curry;

});

parcelRegister("dbogu", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");

var $jtsd5 = parcelRequire("jtsd5");
/** `Object#toString` result references. */ var $998f1ff604abccc1$var$domExcTag = '[object DOMException]', $998f1ff604abccc1$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $998f1ff604abccc1$var$isError(value) {
    if (!$hYEMs(value)) return false;
    var tag = $2OY5s(value);
    return tag == $998f1ff604abccc1$var$errorTag || tag == $998f1ff604abccc1$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$jtsd5(value);
}
module.exports = $998f1ff604abccc1$var$isError;

});

parcelRegister("a1CHL", function(module, exports) {

var $fjnSB = parcelRequire("fjnSB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $74c80559f18c75f2$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $74c80559f18c75f2$var$isWeakMap(value) {
    return $hYEMs(value) && $fjnSB(value) == $74c80559f18c75f2$var$weakMapTag;
}
module.exports = $74c80559f18c75f2$var$isWeakMap;

});

parcelRegister("akHxB", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");

var $7qARj = parcelRequire("7qARj");
/** Used to compose bitmasks for cloning. */ var $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $785d8bf9eb54b1a7$var$iteratee(func) {
    return $7qARj(typeof func == 'function' ? func : $ee7Ev(func, $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG));
}
module.exports = $785d8bf9eb54b1a7$var$iteratee;

});

parcelRegister("k5dRT", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");

var $224h2 = parcelRequire("224h2");
/** Used to compose bitmasks for function metadata. */ var $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $e9ef0836fe6d24f1$var$rearg = $224h2(function(func, indexes) {
    return $xQ3hV(func, $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $e9ef0836fe6d24f1$var$rearg;

});

parcelRegister("d0KBl", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $b69Sx = parcelRequire("b69Sx");

var $1c8hB = parcelRequire("1c8hB");

var $8aco7 = parcelRequire("8aco7");

var $1xzs7 = parcelRequire("1xzs7");

var $cNyDu = parcelRequire("cNyDu");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $978f6c7ba8ca5ebf$var$toPath(value) {
    if ($1c8hB(value)) return $kJvGp(value, $cNyDu);
    return $8aco7(value) ? [
        value
    ] : $b69Sx($1xzs7($1uqnh(value)));
}
module.exports = $978f6c7ba8ca5ebf$var$toPath;

});



parcelRegister("iqjbc", function(module, exports) {

var $doiuZ = parcelRequire("doiuZ");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d699885de2b5454c$var$range = $doiuZ();
module.exports = $d699885de2b5454c$var$range;

});
parcelRegister("doiuZ", function(module, exports) {

var $iVCWR = parcelRequire("iVCWR");

var $3P7i5 = parcelRequire("3P7i5");

var $d0d5X = parcelRequire("d0d5X");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9bfbddb9d5847b3e$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $3P7i5(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $d0d5X(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $d0d5X(end);
        step = step === undefined ? start < end ? 1 : -1 : $d0d5X(step);
        return $iVCWR(start, end, step, fromRight);
    };
}
module.exports = $9bfbddb9d5847b3e$var$createRange;

});
parcelRegister("iVCWR", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dc7bc3319622b4d0$var$nativeCeil = Math.ceil, $dc7bc3319622b4d0$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $dc7bc3319622b4d0$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $dc7bc3319622b4d0$var$nativeMax($dc7bc3319622b4d0$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $dc7bc3319622b4d0$var$baseRange;

});





parcelRegister("dHiyA", function(module, exports) {

$parcel$export(module.exports, "getIsTableEmpty", () => $5aeacb85a3bf5ed2$export$b8347bf00a122737);
$parcel$export(module.exports, "getItemsSelectionCount", () => $5aeacb85a3bf5ed2$export$a3c7ec1348b0395b);
$parcel$export(module.exports, "getItems", () => $5aeacb85a3bf5ed2$export$d2f92acf417bbf5d);
$parcel$export(module.exports, "getItemIndexes", () => $5aeacb85a3bf5ed2$export$b3e7f67495a21c55);
$parcel$export(module.exports, "getItemsContainerStyles", () => $5aeacb85a3bf5ed2$export$cc1469a0793758e9);
$parcel$export(module.exports, "getItemHeight", () => $5aeacb85a3bf5ed2$export$ddd834f23fa82fc4);
$parcel$export(module.exports, "getItemsCount", () => $5aeacb85a3bf5ed2$export$dd01a43948d7de86);
$parcel$export(module.exports, "getAriaRowCount", () => $5aeacb85a3bf5ed2$export$3d62f784b6f09127);
$parcel$export(module.exports, "getHasActiveCreate", () => $5aeacb85a3bf5ed2$export$37a764c3aa026241);
$parcel$export(module.exports, "getCreateItemAnchor", () => $5aeacb85a3bf5ed2$export$136936d41252875f);
$parcel$export(module.exports, "getCreateItemAnchorIndex", () => $5aeacb85a3bf5ed2$export$32b1b971ba5fa108);
$parcel$export(module.exports, "getSelectedItemIds", () => $5aeacb85a3bf5ed2$export$e9f0552305c19203);
$parcel$export(module.exports, "getActiveItemId", () => $5aeacb85a3bf5ed2$export$b40482e3ca743b81);
$parcel$export(module.exports, "getIsItemActive", () => $5aeacb85a3bf5ed2$export$4b209aa328dc6c69);
$parcel$export(module.exports, "getIsItemSelected", () => $5aeacb85a3bf5ed2$export$eacf042ab4fde4a7);
$parcel$export(module.exports, "getIsItemMultiSelected", () => $5aeacb85a3bf5ed2$export$1c36f8ddcf135195);
$parcel$export(module.exports, "getIsItemSelectable", () => $5aeacb85a3bf5ed2$export$b3fb6474950e2ea0);

var $eI5EY = parcelRequire("eI5EY");

var $WBLbN = parcelRequire("WBLbN");

var $gf0vG = parcelRequire("gf0vG");

var $1sAbG = parcelRequire("1sAbG");
const $5aeacb85a3bf5ed2$export$b8347bf00a122737 = (state)=>state.isTableEmpty;
const $5aeacb85a3bf5ed2$export$71297f0abe09788f = ({ itemsSelectionState: itemsSelectionState }, id)=>itemsSelectionState ? itemsSelectionState[id] ?? false : undefined;
const $5aeacb85a3bf5ed2$export$42fccc645f404e95 = ({ itemsSelectionState: itemsSelectionState, itemsSelectionCount: itemsSelectionCount }, id)=>{
    if (!itemsSelectionState || itemsSelectionCount === undefined) return undefined;
    return itemsSelectionCount > 1 && itemsSelectionState[id] || false;
};
const $5aeacb85a3bf5ed2$export$a3c7ec1348b0395b = (state)=>state.selectedItemIds.length;
const $5aeacb85a3bf5ed2$export$d2f92acf417bbf5d = (state)=>state.items;
const $5aeacb85a3bf5ed2$export$b3e7f67495a21c55 = (state)=>state.itemIndexes;
const $5aeacb85a3bf5ed2$export$cc1469a0793758e9 = (state)=>({
        itemsBackground: state.itemsBackground,
        totalHeight: state.totalHeight
    });
const $5aeacb85a3bf5ed2$export$ddd834f23fa82fc4 = (state)=>state.itemHeight;
const $5aeacb85a3bf5ed2$export$dd01a43948d7de86 = (state)=>state.items.length;
const $5aeacb85a3bf5ed2$export$3d62f784b6f09127 = (state)=>state.ariaRowCount;
const $5aeacb85a3bf5ed2$export$37a764c3aa026241 = (state)=>state.createItemAnchor !== undefined;
const $5aeacb85a3bf5ed2$export$136936d41252875f = (state)=>state.createItemAnchor;
const $5aeacb85a3bf5ed2$export$32b1b971ba5fa108 = ({ createItemAnchor: createItemAnchor, itemIndexes: itemIndexes })=>{
    if (!createItemAnchor || createItemAnchor.position === (0, $gf0vG.LAST)) return undefined;
    if (createItemAnchor.beforeId) return itemIndexes[createItemAnchor.beforeId];
    if (createItemAnchor.parentId) return itemIndexes[createItemAnchor.parentId];
};
const $5aeacb85a3bf5ed2$export$e9f0552305c19203 = (state)=>state.selectedItemIds;
const $5aeacb85a3bf5ed2$export$b40482e3ca743b81 = (state)=>state.activeItemId;
const $5aeacb85a3bf5ed2$export$4b209aa328dc6c69 = (state, id)=>state.activeItemId === id;
const $5aeacb85a3bf5ed2$export$6c44f432f7ffa367 = (0, $WBLbN.createSelector)([
    $5aeacb85a3bf5ed2$export$e9f0552305c19203
], (selectedItemIds)=>new Set(selectedItemIds));
const $5aeacb85a3bf5ed2$export$eacf042ab4fde4a7 = (state, id)=>{
    if (!(0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) return $5aeacb85a3bf5ed2$export$71297f0abe09788f(state, id);
    return $5aeacb85a3bf5ed2$export$6c44f432f7ffa367(state).has(id);
};
const $5aeacb85a3bf5ed2$export$1c36f8ddcf135195 = (state, id)=>{
    if (!(0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) return $5aeacb85a3bf5ed2$export$42fccc645f404e95(state, id);
    const selection = $5aeacb85a3bf5ed2$export$6c44f432f7ffa367(state);
    return selection.size > 1 && selection.has(id);
};
const $5aeacb85a3bf5ed2$var$getFirstSelectedItem = ({ items: items, itemIndexes: itemIndexes, selectedItemIds: selectedItemIds })=>selectedItemIds.length > 0 ? items[itemIndexes[selectedItemIds[0]]] : undefined;
const $5aeacb85a3bf5ed2$export$b3fb6474950e2ea0 = (0, $WBLbN.createSelector)([
    $5aeacb85a3bf5ed2$export$d2f92acf417bbf5d,
    $5aeacb85a3bf5ed2$export$b3e7f67495a21c55,
    $5aeacb85a3bf5ed2$var$getFirstSelectedItem,
    (_, itemId)=>itemId
], (items, itemIndexes, firstSelectedItem, itemId)=>{
    if (!firstSelectedItem) return true;
    const item = items[itemIndexes[itemId]];
    if (!item) return false;
    return (0, $1sAbG.getItemLevel)(firstSelectedItem) === (0, $1sAbG.getItemLevel)(item) && firstSelectedItem.meta.parentId === item.meta.parentId;
});

});


parcelRegister("nH3p1", function(module, exports) {

$parcel$export(module.exports, "useListWidth", () => $2277c74ed4fc72bd$export$55c090d16aa0f75d);
$parcel$export(module.exports, "useListItemMenuOptions", () => $2277c74ed4fc72bd$export$1951ac3cbf4049a0);
$parcel$export(module.exports, "default", () => $2277c74ed4fc72bd$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");

var $WBLbN = parcelRequire("WBLbN");

var $gf0vG = parcelRequire("gf0vG");

var $3bfJ7 = parcelRequire("3bfJ7");

var $6Tyrm = parcelRequire("6Tyrm");
const $2277c74ed4fc72bd$var$initialState = {
    listWidth: 0,
    listItemMenuOptions: {
        overrideLabels: {},
        customSections: [],
        customSectionsBulk: []
    }
};
const $2277c74ed4fc72bd$export$3e2081a696ef1795 = (0, $WBLbN.createStore)({
    initialState: $2277c74ed4fc72bd$var$initialState,
    actions: $3bfJ7.actions,
    name: 'timeline-table.list'
});
const $2277c74ed4fc72bd$export$469df0dd4929d037 = (0, $WBLbN.createActionsHook)($2277c74ed4fc72bd$export$3e2081a696ef1795);
const $2277c74ed4fc72bd$export$55c090d16aa0f75d = (0, $WBLbN.createHook)($2277c74ed4fc72bd$export$3e2081a696ef1795, {
    selector: (0, $6Tyrm.getListWidth)
});
const $2277c74ed4fc72bd$export$1951ac3cbf4049a0 = (0, $WBLbN.createHook)($2277c74ed4fc72bd$export$3e2081a696ef1795, {
    selector: (0, $6Tyrm.getListItemMenuOptions)
});
const $2277c74ed4fc72bd$export$2f645645f7bca764 = (0, $WBLbN.createHook)($2277c74ed4fc72bd$export$3e2081a696ef1795);
const $2277c74ed4fc72bd$export$9b0a72e5d41d62ec = (0, $WBLbN.createContainer)($2277c74ed4fc72bd$export$3e2081a696ef1795, {
    onInit: ()=>({ setState: setState }, listState)=>{
            setState({
                ...listState,
                ...(0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') && {
                    listWidth: Math.max((0, $gf0vG.MINIMUM_LIST_WIDTH)(), listState.listWidth)
                }
            });
        },
    onUpdate: ()=>({ setState: setState }, listState)=>{
            setState({
                ...listState,
                ...(0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') && {
                    listWidth: Math.max((0, $gf0vG.MINIMUM_LIST_WIDTH)(), listState.listWidth)
                }
            });
        }
});
var $2277c74ed4fc72bd$export$2e2bcd8739ae039 = $2277c74ed4fc72bd$export$9b0a72e5d41d62ec;

});
parcelRegister("3bfJ7", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e783548ea8558ac8$export$e324594224ef24da);

var $03mdU = parcelRequire("03mdU");
const $e783548ea8558ac8$export$e324594224ef24da = {
    setListWidth: $03mdU.setListWidth
};

});
parcelRegister("03mdU", function(module, exports) {

$parcel$export(module.exports, "setListWidth", () => $fcfdb1ed0089906c$export$e9fd6c0c57a999a3);
const $fcfdb1ed0089906c$export$e9fd6c0c57a999a3 = (listWidth)=>({ setState: setState })=>{
        setState({
            listWidth: listWidth
        });
    };

});


parcelRegister("6Tyrm", function(module, exports) {

$parcel$export(module.exports, "getListWidth", () => $93450cad8350d7e0$export$546faffca0a891d);
$parcel$export(module.exports, "getListItemMenuOptions", () => $93450cad8350d7e0$export$2d38f26d6331442e);
const $93450cad8350d7e0$export$546faffca0a891d = (state)=>state.listWidth;
const $93450cad8350d7e0$export$2d38f26d6331442e = (state)=>state.listItemMenuOptions;

});


parcelRegister("lvr5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $2edc8d12ea3b81e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $h829Y = parcelRequire("h829Y");
const $2edc8d12ea3b81e2$var$TablePortalProvider = (props)=>{
    const [portalContainerElement, setPortalContainerElement] = (0, $eUqFw.useState)(null);
    const portalState = (0, $eUqFw.useMemo)(()=>({
            setPortalContainerElement: setPortalContainerElement,
            portalContainerElement: portalContainerElement
        }), [
        portalContainerElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h829Y.PortalScopeContext).Provider, {
        value: portalState
    }, props.children);
};
var $2edc8d12ea3b81e2$export$2e2bcd8739ae039 = $2edc8d12ea3b81e2$var$TablePortalProvider;

});
parcelRegister("h829Y", function(module, exports) {

$parcel$export(module.exports, "PortalScopeContext", () => $36a2c3edf9c222be$export$c9ecc14d092a6ed0);
$parcel$export(module.exports, "usePortalScope", () => $36a2c3edf9c222be$export$ed9db44bbd000055);

var $eUqFw = parcelRequire("eUqFw");
const $36a2c3edf9c222be$export$c9ecc14d092a6ed0 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setPortalContainerElement: ()=>undefined,
    portalContainerElement: null
});
const $36a2c3edf9c222be$export$ed9db44bbd000055 = ()=>(0, $eUqFw.useContext)($36a2c3edf9c222be$export$c9ecc14d092a6ed0);

});


parcelRegister("bwj1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $738cfeea76ad64b7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useSideEffectMarshal", () => $738cfeea76ad64b7$export$b2476fd3df1b06b6);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eI5EY = parcelRequire("eI5EY");

var $8iXXr = parcelRequire("8iXXr");

var $8hFGR = parcelRequire("8hFGR");

var $azagy = parcelRequire("azagy");

var $1rnzH = parcelRequire("1rnzH");

var $2PgrC = parcelRequire("2PgrC");

var $jPGXT = parcelRequire("jPGXT");

var $fhdOI = parcelRequire("fhdOI");

var $1UVbw = parcelRequire("1UVbw");
const $738cfeea76ad64b7$var$SideEffectMarshal = ({ scope: scope, customActions: customActions, overrideActions: overrideActions, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, ariaMultiselectable: ariaMultiselectable, children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const styleAPI = (0, $fhdOI.useStyleMarshal)(scope);
    const rowState = (0, $2PgrC.useRowState)();
    /* Rather than wrap every function in useCallback, we can encapsulate everything into one useMemo.
	 * Subjectively, this ended up being the more readable approach given the number of functions.
	 */ const defaultActions = (0, $eUqFw.useMemo)(()=>{
        const onRowMouseEnter = (id)=>{
            if (rowState.get(id) || rowState.isAnyRowDragging()) return;
            styleAPI.hoverRow(id);
        };
        const onRowMouseLeave = (id)=>{
            if (rowState.get(id) || rowState.isAnyRowDragging()) return;
            styleAPI.leaveRow(id);
        };
        const onRowFocus = (id)=>{
            if (!(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) return;
            if (rowState.get(id) || rowState.isAnyRowDragging()) return;
            rowState.set(id, (0, $jPGXT.ROW_STATES).FOCUSED);
            styleAPI.hoverRow(id);
        };
        const onRowBlur = (id)=>{
            if (!(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) return;
            if (rowState.get(id) !== (0, $jPGXT.ROW_STATES).FOCUSED || rowState.isAnyRowDragging()) return;
            rowState.clear(id);
            styleAPI.leaveRow(id);
        };
        const onRowSelect = (ids)=>{
            ids.forEach((id)=>rowState.set(id, (0, $jPGXT.ROW_STATES).SELECTED));
            styleAPI.selectRow(ids);
        };
        const onRowDeselect = (ids)=>{
            ids.forEach((id)=>rowState.clear(id));
            styleAPI.deselectRow();
        };
        const onRowGenerateDragPreview = ()=>{
            styleAPI.hideChildCreate();
        };
        const onRowDragStart = (id)=>{
            rowState.set(id, (0, $jPGXT.ROW_STATES).DRAGGED);
            styleAPI.dragRow(id);
        };
        const onRowDragEnd = (id)=>{
            const wasRowSelected = rowState.wasRowSelected(id);
            wasRowSelected ? rowState.set(id, (0, $jPGXT.ROW_STATES).SELECTED) : rowState.clear(id);
            styleAPI.dropRow(id, wasRowSelected);
        };
        /**
		 *
		 * @param id
		 * @param top
		 * @param left: Left offset when dragging at nested levels
		 */ const onRowDragOver = (id, top, left)=>{
            rowState.set(id, (0, $jPGXT.ROW_STATES).DRAGGED_OVER);
            styleAPI.showDragIndicator(top, left);
        };
        const onRowDragChildOverParent = (id, parentId)=>{
            rowState.set(id, (0, $jPGXT.ROW_STATES).DRAGGED_OVER);
            styleAPI.dragOverParent(parentId, rowState.get(parentId) === (0, $jPGXT.ROW_STATES).SELECTED);
        };
        /**
		 * Clear the background color of the parent row when dragging child over parent ends
		 * @param parentId
		 */ const onRowDragChildOverParentEnd = (parentId)=>{
            styleAPI.leaveRow(parentId);
        };
        const onRowDragOutOfBounds = (id)=>{
            rowState.set(id, (0, $jPGXT.ROW_STATES).DRAGGED_OUT);
            styleAPI.dragOutOfBounds();
        };
        const onAddButtonMouseEnter = (top, tabFocused)=>{
            if (rowState.isAnyRowDragging()) return;
            if ((0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally')) styleAPI.showInlineCreate(top, tabFocused);
            else styleAPI.showInlineCreate(top);
        };
        const onAddButtonMouseLeave = ()=>{
            if (rowState.isAnyRowDragging()) return;
            styleAPI.hideInlineCreate();
        };
        const onScrollStateChanged = (isScrolling)=>{
            if (rowState.isAnyRowDragging()) return;
            isScrolling ? styleAPI.blockPointerEvents() : styleAPI.allowPointerEvents();
        };
        return {
            onRowMouseEnter: onRowMouseEnter,
            onRowMouseLeave: onRowMouseLeave,
            onRowSelect: onRowSelect,
            onRowDeselect: onRowDeselect,
            onRowFocus: onRowFocus,
            onRowBlur: onRowBlur,
            onRowGenerateDragPreview: onRowGenerateDragPreview,
            onRowDragStart: onRowDragStart,
            onRowDragEnd: onRowDragEnd,
            onRowDragOver: onRowDragOver,
            onRowDragChildOverParent: onRowDragChildOverParent,
            onRowDragChildOverParentEnd: onRowDragChildOverParentEnd,
            onRowDragOutOfBounds: onRowDragOutOfBounds,
            onAddButtonMouseEnter: onAddButtonMouseEnter,
            onAddButtonMouseLeave: onAddButtonMouseLeave,
            onScrollStateChanged: onScrollStateChanged
        };
    }, [
        rowState,
        styleAPI
    ]);
    const combinedActions = (0, $eUqFw.useMemo)(()=>({
            ...(0, $1UVbw.bindOverrideActions)(defaultActions, overrideActions, styleAPI),
            custom: (0, $1UVbw.bindCustomActions)(customActions, styleAPI)
        }), [
        defaultActions,
        customActions,
        overrideActions,
        styleAPI
    ]);
    const GridComponent = (0, $eI5EY.fg)('timeline_grid_navigation_m2') ? (0, $azagy.Grid) : (0, $azagy.GridOld);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8iXXr.SideEffectContext).Provider, {
        value: combinedActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8hFGR.FocusMarshalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GridComponent, {
        scope: scope,
        ariaReadOnly: ariaReadOnly,
        ariaMultiselectable: ariaMultiselectable,
        ariaLabel: ariaLabel ?? formatMessage((0, $1rnzH.default).defaultLabel)
    }, children)));
};
$738cfeea76ad64b7$var$SideEffectMarshal.defaultProps = {
    customActions: {},
    overrideActions: {},
    ariaLabel: undefined,
    ariaReadOnly: undefined,
    ariaMultiselectable: undefined
};
var $738cfeea76ad64b7$export$2e2bcd8739ae039 = $738cfeea76ad64b7$var$SideEffectMarshal;
const $738cfeea76ad64b7$export$b2476fd3df1b06b6 = ()=>(0, $eUqFw.useContext)((0, $8iXXr.SideEffectContext));

});
parcelRegister("8iXXr", function(module, exports) {

$parcel$export(module.exports, "SideEffectContext", () => $72c565eee22cabad$export$f87600ce6f9a1288);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $72c565eee22cabad$export$f87600ce6f9a1288 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    custom: {},
    onRowMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDeselect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowFocus: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowBlur: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowGenerateDragPreview: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragChildOverParent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragChildOverParentEnd: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragOutOfBounds: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAddButtonMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAddButtonMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onScrollStateChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});

});

parcelRegister("8hFGR", function(module, exports) {

$parcel$export(module.exports, "useFocusMarshal", () => $cc8900200a559c09$export$c8db889fd790e2d0);
$parcel$export(module.exports, "useIsNavigationEnabled", () => $cc8900200a559c09$export$197de480eb3dcfb5);
$parcel$export(module.exports, "useIsNavigationPrevented", () => $cc8900200a559c09$export$f0f577624c158cba);
$parcel$export(module.exports, "useIsCreateTriggerActive", () => $cc8900200a559c09$export$1d8ad99a41e9aa75);
$parcel$export(module.exports, "FocusMarshalProvider", () => $cc8900200a559c09$export$835dc2bb3cd0a80a);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $WBLbN = parcelRequire("WBLbN");

var $VrUCp = parcelRequire("VrUCp");

var $lSR7G = parcelRequire("lSR7G");

var $17drr = parcelRequire("17drr");

var $gZPes = parcelRequire("gZPes");

var $Ixemf = parcelRequire("Ixemf");
const $cc8900200a559c09$var$initialState = {
    gridCells: new (0, $gZPes.CellMap)(),
    focusedCell: undefined,
    activeCreateTrigger: undefined,
    rovingCell: undefined,
    isNavigationEnabled: true,
    isNavigationPrevented: false
};
const $cc8900200a559c09$var$FocusContainer = (0, $WBLbN.createContainer)();
const $cc8900200a559c09$var$focusStore = (0, $WBLbN.createStore)({
    containedBy: $cc8900200a559c09$var$FocusContainer,
    initialState: $cc8900200a559c09$var$initialState,
    actions: $17drr.actions,
    name: 'timeline-table.focus',
    handlers: {
        onContainerUpdate: (nextProps, prevProps)=>({ getState: getState })=>{
                if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) {
                    if (nextProps.headerIndexes !== prevProps.headerIndexes || nextProps.itemIndexes !== prevProps.itemIndexes) {
                        const cellMap = getState().gridCells;
                        cellMap.setIsDirty(true);
                    }
                }
            }
    }
});
const $cc8900200a559c09$export$c8db889fd790e2d0 = (0, $WBLbN.createActionsHook)($cc8900200a559c09$var$focusStore);
const $cc8900200a559c09$export$ae79915617215704 = (0, $WBLbN.createStateHook)($cc8900200a559c09$var$focusStore);
const $cc8900200a559c09$export$197de480eb3dcfb5 = (0, $WBLbN.createStateHook)($cc8900200a559c09$var$focusStore, {
    selector: (0, $Ixemf.isNavigationEnabled)
});
const $cc8900200a559c09$export$f0f577624c158cba = (0, $WBLbN.createStateHook)($cc8900200a559c09$var$focusStore, {
    selector: (0, $Ixemf.isNavigationPrevented)
});
const $cc8900200a559c09$export$1d8ad99a41e9aa75 = (0, $WBLbN.createHook)($cc8900200a559c09$var$focusStore, {
    selector: (0, $Ixemf.isCreateTriggerActiveForItem)
});
const $cc8900200a559c09$export$835dc2bb3cd0a80a = ({ children: children })=>{
    const [headerIndexesUnstable] = (0, $VrUCp.useHeaderItemIndexes)();
    const [itemIndexesUnstable] = (0, $lSR7G.useItemIndexes)();
    /* This follows the "useEventCallback" pattern. We want the callback reference to remain stable,
	 * but the internal values to also remain up-to-date. In doing so we can lazily evaluate coordinates
	 * using the action thunk and not have to hold a copy of the indexes elsewhere that is kept in sync.
	 */ const headerIndexes = (0, $eUqFw.useRef)(headerIndexesUnstable);
    const itemIndexes = (0, $eUqFw.useRef)(itemIndexesUnstable);
    (0, $eUqFw.useEffect)(()=>{
        headerIndexes.current = headerIndexesUnstable;
        itemIndexes.current = itemIndexesUnstable;
    });
    const getCoordinates = (0, $eUqFw.useCallback)((getRowData)=>{
        const { column: column, rowId: rowId } = getRowData();
        const itemIndexOffset = Object.keys(headerIndexes.current).length;
        const row = headerIndexes.current[rowId] ?? itemIndexes.current[rowId] + itemIndexOffset;
        return [
            column,
            row
        ];
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc8900200a559c09$var$FocusContainer, {
        getCoordinates: getCoordinates,
        ...(0, $eI5EY.fg)('timeline_grid_navigation_m2') ? {
            headerIndexes: headerIndexes.current,
            itemIndexes: itemIndexes.current
        } : {}
    }, children);
};

});
parcelRegister("17drr", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e01284d38ae01405$export$e324594224ef24da);

var $eI5EY = parcelRequire("eI5EY");

// ======================= //
// === PRIVATE ACTIONS === //
// ======================= //
// Moves the roving tab index, updating the DOM and relevant state
const $e01284d38ae01405$var$rove = (current, next)=>({ setState: setState })=>{
        current?.setAttribute('tabindex', '-1');
        next.setAttribute('tabindex', '0');
        setState({
            rovingCell: next
        });
    };
/* The grid must have a focusable cell to navigate. So when a cell is removed, we check
 * whether doing so would invalidate this requirement and find a suitable replacement.
 */ const $e01284d38ae01405$var$reconcile = (previous)=>({ getState: getState, dispatch: dispatch })=>{
        const { gridCells: gridCells, rovingCell: rovingCell, focusedCell: focusedCell } = getState();
        // Does the cell we're removing contain the current roving tab index
        if (previous === rovingCell) {
            const nextCell = gridCells.getStart(rovingCell, true);
            if (nextCell) {
                // Make the new roving point the origin for simplicity
                dispatch($e01284d38ae01405$var$rove(undefined, nextCell));
                // Only focus new cell if the previous was focused too
                previous === focusedCell && nextCell.focus();
            }
        }
    };
// Optionally sets focus to the cell or its content depending on the change in navigation state
const $e01284d38ae01405$var$toggleNavigation = (cell, shouldEnable, autofocus)=>({ getState: getState, setState: setState })=>{
        const { gridCells: gridCells } = getState();
        const cellContent = gridCells.get(cell)?.getContent();
        if (!cellContent) return;
        if (shouldEnable) {
            setState({
                isNavigationEnabled: true
            });
            autofocus && cell.focus();
        } else if (!shouldEnable && cellContent.length > 0) {
            setState({
                isNavigationEnabled: false
            });
            autofocus && cellContent[0].focus();
        }
    };
// ====================== //
// === PUBLIC ACTIONS === //
// ====================== //
const $e01284d38ae01405$var$enableNavigation = ({ autofocus: autofocus } = {
    autofocus: true
})=>({ getState: getState, dispatch: dispatch })=>{
        const { rovingCell: rovingCell, isNavigationEnabled: isNavigationEnabled } = getState();
        if (!isNavigationEnabled && rovingCell) dispatch($e01284d38ae01405$var$toggleNavigation(rovingCell, true, autofocus));
    };
const $e01284d38ae01405$var$disableNavigation = ({ autofocus: autofocus } = {
    autofocus: true
})=>({ getState: getState, dispatch: dispatch })=>{
        const { focusedCell: focusedCell, isNavigationEnabled: isNavigationEnabled } = getState();
        if (isNavigationEnabled && focusedCell) dispatch($e01284d38ae01405$var$toggleNavigation(focusedCell, false, autofocus));
    };
const $e01284d38ae01405$var$initialiseRovingCell = (elem)=>({ getState: getState, setState: setState })=>{
        if (!getState().rovingCell) setState({
            rovingCell: elem
        });
    };
const $e01284d38ae01405$var$createGetCoordinates = (getData, { getCoordinates: getCoordinates })=>()=>getCoordinates(getData);
const $e01284d38ae01405$var$trackCell = (elem, getData, getContent)=>({ getState: getState }, containerProps)=>{
        const getCoordinates = $e01284d38ae01405$var$createGetCoordinates(getData, containerProps);
        getState().gridCells.set(elem, {
            getCoordinates: getCoordinates,
            getContent: getContent
        });
    };
const $e01284d38ae01405$var$untrackCell = (elem)=>({ getState: getState, dispatch: dispatch })=>{
        const { gridCells: gridCells } = getState();
        gridCells.delete(elem);
        dispatch($e01284d38ae01405$var$reconcile(elem));
    };
const $e01284d38ae01405$var$focusCellOld = (elem)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { gridCells: gridCells, rovingCell: rovingCell } = getState();
        if (gridCells.has(elem)) {
            setState({
                focusedCell: elem
            });
            /* Cell can be focused for reasons outside our direct control
			 * which means we have to be resilient to moving the roving tab index
			 */ if (elem !== rovingCell) dispatch($e01284d38ae01405$var$rove(rovingCell, elem));
        }
    };
/* Cells can be focused outside our action controlled navigation, such as
 * with a mouse click or tabbing, so we have to be resilient to migrating the cell state
 */ const $e01284d38ae01405$var$focusCell = (cell, focusing)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { gridCells: gridCells, rovingCell: rovingCell, isNavigationEnabled: isNavigationEnabled } = getState();
        // We're in cell navigation mode and element being focused is a cell
        if (isNavigationEnabled && gridCells.has(focusing)) {
            setState({
                focusedCell: focusing
            });
            if (focusing !== rovingCell) dispatch($e01284d38ae01405$var$rove(rovingCell, focusing));
        } else if (isNavigationEnabled && cell.contains(focusing)) {
            /* We're in cell navigation mode, but the cell content is being focused.
			 * But, DON'T disable cell navigation here because it will create a focus trap
			 * for mouse users. We will check this elsewhere based on keyboard input.
			 */ setState({
                focusedCell: cell
            });
            if (cell !== rovingCell) dispatch($e01284d38ae01405$var$rove(rovingCell, cell));
        } else if (!isNavigationEnabled && rovingCell) {
            // We're in content navigation mode and we need to trap the focus
            const cellContent = gridCells.get(rovingCell)?.getContent();
            if (cellContent && focusing === rovingCell) cellContent[cellContent.length - 1].focus();
            else if (cellContent && !rovingCell.contains(focusing)) cellContent[0].focus();
        }
    };
const $e01284d38ae01405$var$blurCell = (blurring)=>({ getState: getState, setState: setState })=>{
        const { gridCells: gridCells, focusedCell: focusedCell } = getState();
        if (gridCells.has(blurring) && focusedCell === blurring) setState({
            focusedCell: undefined
        });
    };
const $e01284d38ae01405$var$navigateCell = (type, { ctrlKey: ctrlKey })=>({ getState: getState, dispatch: dispatch })=>{
        const { isNavigationEnabled: isNavigationEnabled, gridCells: gridCells, focusedCell: focusedCell } = getState();
        // Merge boolean logic after cleaning up fg
        if (!isNavigationEnabled && (0, $eI5EY.fg)('timeline_grid_navigation_m2')) return;
        if (!focusedCell) return;
        let nextCell;
        switch(type){
            case 'ArrowLeft':
                nextCell = gridCells.getBefore(focusedCell);
                break;
            case 'ArrowRight':
                nextCell = gridCells.getAfter(focusedCell);
                break;
            case 'ArrowUp':
                nextCell = gridCells.getAbove(focusedCell);
                break;
            case 'ArrowDown':
                nextCell = gridCells.getBelow(focusedCell);
                break;
            case 'PageUp':
                nextCell = gridCells.getAbove(focusedCell, (0, $ac62585be1e0fbab$export$25f3022e3913e948));
                break;
            case 'PageDown':
                nextCell = gridCells.getBelow(focusedCell, (0, $ac62585be1e0fbab$export$25f3022e3913e948));
                break;
            case 'Home':
                nextCell = gridCells.getStart(focusedCell, ctrlKey);
                break;
            case 'End':
                nextCell = gridCells.getEnd(focusedCell, ctrlKey);
                break;
            default:
                break;
        }
        if (nextCell && nextCell !== focusedCell) {
            dispatch($e01284d38ae01405$var$rove(focusedCell, nextCell));
            nextCell.focus();
        }
    };
const $e01284d38ae01405$var$setActiveCreateTrigger = (rowId, type, element)=>({ setState: setState })=>{
        if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) setState({
            // Make sure there are no focus traps for when the create input appears
            isNavigationEnabled: true,
            activeCreateTrigger: {
                rowId: rowId,
                type: type,
                element: element
            }
        });
        else setState({
            activeCreateTrigger: {
                rowId: rowId,
                type: type,
                element: element
            }
        });
    };
const $e01284d38ae01405$var$resetRovingCell = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { gridCells: gridCells, rovingCell: rovingCell } = getState();
        if (rovingCell) {
            const origin = gridCells.getClosestStartOrEnd(rovingCell);
            if (origin) {
                setState({
                    isNavigationEnabled: true
                });
                dispatch($e01284d38ae01405$var$rove(rovingCell, origin));
            }
        }
    };
// ======================== //
// === CONSUMER ACTIONS === //
// ======================== //
const $e01284d38ae01405$var$removeActiveCreateTrigger = ()=>({ setState: setState })=>{
        setState({
            activeCreateTrigger: undefined
        });
    };
const $e01284d38ae01405$var$focusCreateTrigger = ()=>({ getState: getState, setState: setState })=>{
        const activeCreateTrigger = getState().activeCreateTrigger;
        if (activeCreateTrigger && !(0, $eI5EY.fg)('timeline_grid_navigation_m2')) {
            setState({
                activeCreateTrigger: undefined
            });
            activeCreateTrigger.element?.focus();
        } else if (activeCreateTrigger && (0, $eI5EY.fg)('timeline_grid_navigation_m2')) {
            // Update the DOM first, otherwise the focus event will be treated as content navigation
            activeCreateTrigger.element?.focus();
            // Make sure to re-enable the focus trap when focus returns to a cell via its create trigger
            setState({
                isNavigationEnabled: false,
                activeCreateTrigger: undefined
            });
        }
    };
const $e01284d38ae01405$var$shouldPreventNavigation = (isNavigationPrevented)=>({ setState: setState })=>{
        setState({
            isNavigationPrevented: isNavigationPrevented
        });
    };
const $e01284d38ae01405$export$e324594224ef24da = {
    enableNavigation: $e01284d38ae01405$var$enableNavigation,
    disableNavigation: $e01284d38ae01405$var$disableNavigation,
    shouldPreventNavigation: $e01284d38ae01405$var$shouldPreventNavigation,
    initialiseRovingCell: $e01284d38ae01405$var$initialiseRovingCell,
    resetRovingCell: $e01284d38ae01405$var$resetRovingCell,
    trackCell: $e01284d38ae01405$var$trackCell,
    untrackCell: $e01284d38ae01405$var$untrackCell,
    focusCellOld: $e01284d38ae01405$var$focusCellOld,
    focusCell: $e01284d38ae01405$var$focusCell,
    blurCell: $e01284d38ae01405$var$blurCell,
    navigateCell: $e01284d38ae01405$var$navigateCell,
    setActiveCreateTrigger: $e01284d38ae01405$var$setActiveCreateTrigger,
    focusCreateTrigger: $e01284d38ae01405$var$focusCreateTrigger,
    removeActiveCreateTrigger: $e01284d38ae01405$var$removeActiveCreateTrigger
};

});
// The step size for navigating the grid cells when a user provides the relevant keyboard input
const $ac62585be1e0fbab$export$25f3022e3913e948 = 5;


parcelRegister("gZPes", function(module, exports) {

$parcel$export(module.exports, "CellMap", () => $733472d6e4fd934c$export$8c5f03eb5739ef16);

var $eI5EY = parcelRequire("eI5EY");

var $9rKEx = parcelRequire("9rKEx");
class $733472d6e4fd934c$export$8c5f03eb5739ef16 extends Map {
    // ================= //
    // === Mutations === //
    // ================= //
    set(key, value) {
        this.isDirty = true;
        return super.set(key, value);
    }
    delete(key) {
        this.isDirty = true;
        return super.delete(key);
    }
    clear() {
        this.isDirty = true;
        return super.clear();
    }
    setIsDirty(value) {
        this.isDirty = value;
    }
    // ============= //
    // === Reads === //
    // ============= //
    getBefore(key) {
        const cell = this.get(key);
        if (!cell) return;
        this.prepareCoordinates();
        const [column, row] = cell.getCoordinates();
        return this.getClosestByColumn(column - 1, row);
    }
    getAfter(key) {
        const cell = this.get(key);
        if (!cell) return;
        this.prepareCoordinates();
        const [column, row] = cell.getCoordinates();
        return this.getClosestByColumn(column + 1, row);
    }
    getAbove(key, offset = 1) {
        const cell = this.get(key);
        if (!cell) return;
        this.prepareCoordinates();
        const [column, row] = cell.getCoordinates();
        return this.getClosestByRow(column, row - offset);
    }
    getBelow(key, offset = 1) {
        const cell = this.get(key);
        if (!cell) return;
        this.prepareCoordinates();
        const [column, row] = cell.getCoordinates();
        return this.getClosestByRow(column, row + offset);
    }
    getStart(key, isGlobal = false) {
        this.prepareCoordinates();
        const cell = this.get(key);
        if (isGlobal || !cell) return this.elementLookup.get((0, $9rKEx.coordToString)(...this.globalMin));
        const [, row] = cell.getCoordinates();
        const columnBoundary = this.columnBoundaries.get(row);
        if (columnBoundary) return this.getClosestByColumn(columnBoundary.min, row);
    }
    getEnd(key, isGlobal = false) {
        this.prepareCoordinates();
        const cell = this.get(key);
        if (isGlobal || !cell) return this.elementLookup.get((0, $9rKEx.coordToString)(...this.globalMax));
        const [, row] = cell.getCoordinates();
        const columnBoundary = this.columnBoundaries.get(row);
        if (columnBoundary) return this.getClosestByColumn(columnBoundary.max, row);
    }
    getClosestStartOrEnd(key) {
        const cell = this.get(key);
        if (!cell) return;
        this.prepareCoordinates();
        const [column, row] = cell.getCoordinates();
        const rowBoundary = this.rowBoundaries.get(column);
        if (rowBoundary) {
            const isClosestToStart = Math.abs(row - rowBoundary.min) <= Math.abs(row - rowBoundary.max);
            return isClosestToStart ? this.getStart(key, true) : this.getEnd(key, true);
        }
    }
    // ================= //
    // === Utilities === //
    // ================= //
    clean() {
        this.elementLookup.clear();
        this.rowBoundaries.clear();
        this.columnBoundaries.clear();
        this.globalMin = [
            0,
            0
        ];
        this.globalMax = [
            0,
            0
        ];
        this.isDirty = false;
    }
    /* We only want to evaluate the co-ordinates just-in-time for a cell operation. This reduces
	 * the need to reconcile our "data state" and the DOM state, which can get spooky real fast.
	 * Here we also prepare some data structures to improve time complexity of successive operations.
	 */ prepareCoordinates() {
        if (!this.isDirty) return;
        this.clean();
        for (const [key, value] of this){
            const [column, row] = value.getCoordinates();
            // Store reverse lookup internally for easier retrieval of cell element
            this.elementLookup.set((0, $9rKEx.coordToString)(column, row), key);
            const rowBoundary = this.rowBoundaries.get(column);
            const columnBoundary = this.columnBoundaries.get(row);
            if (rowBoundary === undefined) this.rowBoundaries.set(column, {
                min: row,
                max: row
            });
            else {
                const min = Math.min(rowBoundary.min, row);
                const max = Math.max(rowBoundary.max, row);
                this.rowBoundaries.set(column, {
                    min: min,
                    max: max
                });
            }
            if (columnBoundary === undefined) this.columnBoundaries.set(row, {
                min: column,
                max: column
            });
            else {
                const min = Math.min(columnBoundary.min, column);
                const max = Math.max(columnBoundary.max, column);
                this.columnBoundaries.set(row, {
                    min: min,
                    max: max
                });
            }
            if (row <= this.globalMin[1]) {
                // Grab fresh value in case it was set above in this iteration of the loop
                const updatedColumnBoundary = this.columnBoundaries.get(row);
                const minColumn = updatedColumnBoundary?.min ?? this.globalMin[0];
                this.globalMin = [
                    minColumn,
                    row
                ];
            }
            if (row >= this.globalMax[1]) {
                // Grab fresh value in case it was set above in this iteration of the loop
                const updatedColumnBoundary = this.columnBoundaries.get(row);
                const maxColumn = updatedColumnBoundary?.max ?? this.globalMax[0];
                this.globalMax = [
                    maxColumn,
                    row
                ];
            }
        }
    }
    /* Used to get the cell before or after another cell in the horizontal axis.
	 * !! NOTE: We cannot assume that rows are contiguous for the same column without greatly degrading the user experience.
	 * This is because there are gaps in row navigation, e.g. going down from [3,0] might actually result in [2,1] and not [3,1]
	 */ getClosestByRow(column, row) {
        // Happy path - the closest coordinates are just those passed in
        const happyCell = this.elementLookup.get((0, $9rKEx.coordToString)(column, row));
        if (happyCell) return happyCell;
        const columnBoundary = this.columnBoundaries.get(row);
        const rowBoundary = this.rowBoundaries.get(column);
        // Can't find the cell, so check whether...
        // 1. The row exists, it's just not within the column boundaries of that row. Constrain the column to the boundaries.
        if (columnBoundary) {
            const clampedColumn = columnBoundary.max;
            return this.elementLookup.get((0, $9rKEx.coordToString)(clampedColumn, row));
        }
        // 2. The row does not exist, due to being outside the row boundaries for that column
        if (rowBoundary && (row > rowBoundary.max || row < rowBoundary.min)) {
            const isClosestToStart = Math.abs(row - rowBoundary.min) <= Math.abs(row - rowBoundary.max);
            const closestRow = isClosestToStart ? rowBoundary.min : rowBoundary.max;
            return this.elementLookup.get((0, $9rKEx.coordToString)(column, closestRow));
        }
        // 3. The row does not exist, but its within the row boundaries for that column. Get the next closest row.
        if (rowBoundary && row <= rowBoundary.max && row >= rowBoundary.min && (0, $eI5EY.fg)('timeline_grid_navigation_m2')) {
            const possibleRows = [];
            for (const [, value] of this){
                const coordinates = value.getCoordinates();
                if (coordinates[0] === column && coordinates[1] > row) possibleRows.push(coordinates[1]);
            }
            // Only works for integers, but is faster than Array.prototype.sort even with the need to clone
            const fastSortArray = Uint32Array.from(possibleRows).sort();
            return this.elementLookup.get((0, $9rKEx.coordToString)(column, fastSortArray[0]));
        }
        return undefined;
    }
    /* Used to get the cell before or after another cell in the horizontal axis.
	 * 1. Happy path - the closest coordinates are just those passed in.
	 * 2. However the column could exceed or precede the boundaries for that row, in which case we do nothing.
	 * !! NOTE: This assumes that the columns are contiguous for the same row
	 */ getClosestByColumn(column, row) {
        return this.elementLookup.get((0, $9rKEx.coordToString)(column, row));
    }
    constructor(...args){
        super(...args);
        this.isDirty = false;
        this.elementLookup = new Map();
        this.rowBoundaries = new Map();
        this.columnBoundaries = new Map();
        this.globalMin = [
            0,
            0
        ];
        this.globalMax = [
            0,
            0
        ];
    }
}

});
parcelRegister("9rKEx", function(module, exports) {

$parcel$export(module.exports, "coordToString", () => $af4e1669eacd567d$export$ad1ba9454d886ee3);
const $af4e1669eacd567d$export$ad1ba9454d886ee3 = (column, row)=>String([
        column,
        row
    ]);

});


parcelRegister("Ixemf", function(module, exports) {

$parcel$export(module.exports, "isCreateTriggerActiveForItem", () => $6cacf5a38bdbe004$export$e90c69d47d50701f);
$parcel$export(module.exports, "isNavigationEnabled", () => $6cacf5a38bdbe004$export$146dfdd989f678b);
$parcel$export(module.exports, "isNavigationPrevented", () => $6cacf5a38bdbe004$export$627dcd18967df965);
const $6cacf5a38bdbe004$export$e90c69d47d50701f = (state, { id: id, type: type })=>{
    const activeCreateTrigger = state.activeCreateTrigger;
    if (activeCreateTrigger) return activeCreateTrigger.rowId === id && activeCreateTrigger.type === type;
};
const $6cacf5a38bdbe004$export$146dfdd989f678b = (state)=>state.isNavigationEnabled;
const $6cacf5a38bdbe004$export$627dcd18967df965 = (state)=>state.isNavigationPrevented;

});


parcelRegister("azagy", function(module, exports) {

$parcel$export(module.exports, "GridOld", () => $7463a695e2284040$export$9e141a01a3e47f8e);
$parcel$export(module.exports, "Grid", () => $7463a695e2284040$export$ef2184bd89960b14);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $9WNLk = parcelRequire("9WNLk");

var $lSR7G = parcelRequire("lSR7G");

var $7mdB5 = parcelRequire("7mdB5");
const $7463a695e2284040$export$9e141a01a3e47f8e = ({ scope: scope, ariaMultiselectable: ariaMultiselectable, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, children: children })=>{
    const [ariaRowCount] = (0, $lSR7G.useAriaRowCount)();
    const eventHandlers = (0, $7mdB5.useGridContainerOld)();
    const [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, $9WNLk.useEnablements)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "grid",
        "aria-rowcount": ariaRowCount,
        "aria-multiselectable": (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? isMultiSelectEnabled || undefined : ariaMultiselectable,
        "aria-label": ariaLabel,
        "aria-readonly": ariaReadOnly,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: scope,
        ...eventHandlers
    }, children);
};
const $7463a695e2284040$export$ef2184bd89960b14 = ({ scope: scope, ariaMultiselectable: ariaMultiselectable, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, children: children })=>{
    const [ariaRowCount] = (0, $lSR7G.useAriaRowCount)();
    const containerProps = (0, $7mdB5.useGridContainer)();
    const [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, $9WNLk.useEnablements)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "grid",
        "aria-rowcount": ariaRowCount,
        "aria-multiselectable": (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? isMultiSelectEnabled || undefined : ariaMultiselectable,
        "aria-label": ariaLabel,
        "aria-readonly": ariaReadOnly,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: scope,
        ...containerProps
    }, children);
};

});
parcelRegister("7mdB5", function(module, exports) {

$parcel$export(module.exports, "useGridContainer", () => $bc9bba8bc32ded52$export$89cacf57f4ae1143);
$parcel$export(module.exports, "useGridContainerOld", () => $bc9bba8bc32ded52$export$ed776ebfb0fadaa3);

var $eUqFw = parcelRequire("eUqFw");

var $8hFGR = parcelRequire("8hFGR");
const $bc9bba8bc32ded52$var$isElementInGrid = (grid, target)=>{
    let current = target;
    while(current){
        if (current === grid) return true;
        current = current.parentElement;
    }
    return false;
};
const $bc9bba8bc32ded52$export$89cacf57f4ae1143 = ()=>{
    const element = (0, $eUqFw.useRef)(null);
    const { enableNavigation: enableNavigation, disableNavigation: disableNavigation, navigateCell: navigateCell, resetRovingCell: resetRovingCell } = (0, $8hFGR.useFocusMarshal)();
    const isNavigationEnabled = (0, $8hFGR.useIsNavigationEnabled)();
    const isNavigationPrevented = (0, $8hFGR.useIsNavigationPrevented)();
    const setGridRef = (0, $eUqFw.useCallback)((ref)=>{
        element.current = ref;
    }, []);
    // Keyboard interactions from https://www.w3.org/WAI/ARIA/apg/patterns/grid
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const { key: key, ctrlKey: ctrlKey } = event;
        if (isNavigationPrevented) return;
        switch(key){
            case 'Enter':
                if (isNavigationEnabled) {
                    event.preventDefault();
                    disableNavigation();
                }
                break;
            case 'Escape':
                if (!isNavigationEnabled) {
                    event.preventDefault();
                    enableNavigation();
                }
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'ArrowUp':
            case 'ArrowDown':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
            case 'End':
                if (isNavigationEnabled) {
                    event.preventDefault();
                    navigateCell(key, {
                        ctrlKey: ctrlKey
                    });
                }
                break;
            default:
                break;
        }
    }, [
        isNavigationPrevented,
        isNavigationEnabled,
        disableNavigation,
        enableNavigation,
        navigateCell
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(({ key: key })=>{
        if (isNavigationPrevented) return;
        switch(key){
            /* We don't stop keyboard users from tabbing, but we want to promote the semantic
				 * behaviour by automatically entering edit mode. This should NOT be done on key
				 * down, or the focus trap will be activated too early.
				 */ case 'Tab':
                if (isNavigationEnabled) disableNavigation({
                    autofocus: false
                });
                break;
            default:
                break;
        }
    }, [
        isNavigationEnabled,
        isNavigationPrevented,
        disableNavigation
    ]);
    const onBlur = (0, $eUqFw.useCallback)(({ relatedTarget: relatedTarget })=>{
        if (isNavigationPrevented) return;
        if (element.current && relatedTarget instanceof HTMLElement && !$bc9bba8bc32ded52$var$isElementInGrid(element.current, relatedTarget)) resetRovingCell();
    }, [
        isNavigationPrevented,
        resetRovingCell
    ]);
    return {
        ref: setGridRef,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onBlur: onBlur
    };
};
const $bc9bba8bc32ded52$export$ed776ebfb0fadaa3 = ()=>{
    const { focusCellOld: focusCellOld, blurCell: blurCell, navigateCell: navigateCell } = (0, $8hFGR.useFocusMarshal)();
    const onFocus = (0, $eUqFw.useCallback)((event)=>{
        if (event.target instanceof HTMLElement) focusCellOld(event.target);
    }, [
        focusCellOld
    ]);
    const onBlur = (0, $eUqFw.useCallback)((event)=>{
        if (event.target instanceof HTMLElement) blurCell(event.target);
    }, [
        blurCell
    ]);
    // Keyboard interactions from https://www.w3.org/WAI/ARIA/apg/patterns/grid
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const { key: key, ctrlKey: ctrlKey } = event;
        switch(key){
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'ArrowUp':
            case 'ArrowDown':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
            case 'End':
                event.preventDefault();
                navigateCell(key, {
                    ctrlKey: ctrlKey
                });
                break;
            default:
                break;
        }
    }, [
        navigateCell
    ]);
    return {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur
    };
};

});


parcelRegister("1rnzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $661a9b5df5329cff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $661a9b5df5329cff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultLabel: {
        id: 'roadmap.timeline-table.common.context.side-effect-marshal.default-label',
        defaultMessage: 'Timeline',
        description: "Default label for assistive technology. Describes in short the purpose of the Timeline's table component"
    }
});

});

parcelRegister("2PgrC", function(module, exports) {

$parcel$export(module.exports, "useRowState", () => $2c1d650abeae86aa$export$b2440517e54eabc);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $eKKjG = parcelRequire("eKKjG");

var $jPGXT = parcelRequire("jPGXT");
const $2c1d650abeae86aa$export$b2440517e54eabc = ()=>{
    const rowState = (0, $eUqFw.useRef)({});
    const stateCount = (0, $eUqFw.useRef)({
        ...(0, $jPGXT.DEFAULT_COUNTS)
    });
    const previouslySelected = (0, $eUqFw.useRef)({});
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // ================ //
    // === ANALYTICS === //
    // ================ //
    const fireInvalidRowTransitionEvent = (0, $eUqFw.useCallback)((message)=>{
        const event = createAnalyticsEvent({
            action: 'invalidRowTransition',
            actionSubject: 'timelineTable.sideEffectMarshall',
            attributes: {
                message: message
            }
        });
        (0, $eKKjG.fireOperationalAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent
    ]);
    const fireEmptyRowEntryEvent = (0, $eUqFw.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'emptyRowEntry',
            actionSubject: 'timelineTable.sideEffectMarshall'
        });
        (0, $eKKjG.fireOperationalAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent
    ]);
    // ================ //
    // === METADATA === //
    // ================ //
    // Doing this for each `set` and `clear` operation stops this from becoming an O(N) problem
    const updateStateCount = (0, $eUqFw.useCallback)((currentState, nextState)=>{
        if (currentState) stateCount.current[currentState] -= 1;
        if (nextState) stateCount.current[nextState] += 1;
    }, []);
    const isAnyRowDragging = (0, $eUqFw.useCallback)(()=>stateCount.current[(0, $jPGXT.ROW_STATES).DRAGGED] > 0 || stateCount.current[(0, $jPGXT.ROW_STATES).DRAGGED_OVER] > 0 || stateCount.current[(0, $jPGXT.ROW_STATES).DRAGGED_OUT] > 0, []);
    // Helps with interactions that rely on restoring the selection state
    const updatePreviouslySelected = (0, $eUqFw.useCallback)((id, currentState, nextState)=>{
        if (nextState && currentState === (0, $jPGXT.ROW_STATES).SELECTED) previouslySelected.current[id] = true;
        if (!nextState || nextState === (0, $jPGXT.ROW_STATES).SELECTED) delete previouslySelected.current[id];
    }, []);
    const wasRowSelected = (0, $eUqFw.useCallback)((id)=>previouslySelected.current[id] ?? false, []);
    // ================= //
    // === GET / SET === //
    // ================= //
    const get = (0, $eUqFw.useCallback)((id)=>rowState.current[id], []);
    const set = (0, $eUqFw.useCallback)((id, nextState)=>{
        const currentState = get(id);
        if (!currentState && (0, $jPGXT.VALID_INITIAL_STATES)[nextState] || currentState && (0, $jPGXT.VALID_TRANSITIONS)[currentState][nextState]) {
            updateStateCount(currentState, nextState);
            updatePreviouslySelected(id, currentState, nextState);
            rowState.current[id] = nextState;
        } else if (currentState !== nextState) fireInvalidRowTransitionEvent(`Invalid transition from ${currentState} to ${nextState}`);
    }, [
        get,
        updateStateCount,
        updatePreviouslySelected,
        fireInvalidRowTransitionEvent
    ]);
    const clear = (0, $eUqFw.useCallback)((id)=>{
        const currentState = get(id);
        if (currentState) {
            updateStateCount(currentState);
            updatePreviouslySelected(id, currentState);
            delete rowState.current[id];
        } else // This is a warning as it could be a sign of a bug in the table marshal
        fireEmptyRowEntryEvent();
    }, [
        get,
        updateStateCount,
        updatePreviouslySelected,
        fireEmptyRowEntryEvent
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            get: get,
            set: set,
            clear: clear,
            isAnyRowDragging: isAnyRowDragging,
            wasRowSelected: wasRowSelected
        }), [
        get,
        set,
        clear,
        isAnyRowDragging,
        wasRowSelected
    ]);
};

});
parcelRegister("eKKjG", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalyticsEvent", () => $0710cfdcb3c68937$export$4e7937b444ac21e8);
$parcel$export(module.exports, "fireUIAnalyticsEvent", () => $0710cfdcb3c68937$export$47e016b53a5f0465);
const $0710cfdcb3c68937$var$EVENT_TYPES = {
    UI: 'UI',
    TRACK: 'TRACK',
    SCREEN: 'SCREEN',
    OPERATIONAL: 'OPERATIONAL'
};
const $0710cfdcb3c68937$var$createFireAnalytics = (analyticsType)=>(event)=>{
        const clonedEvent = event.clone();
        if (clonedEvent) clonedEvent.update({
            ...event.payload,
            analyticsType: analyticsType
        }).fire('productAnalytics');
    };
const $0710cfdcb3c68937$export$4e7937b444ac21e8 = $0710cfdcb3c68937$var$createFireAnalytics($0710cfdcb3c68937$var$EVENT_TYPES.OPERATIONAL);
const $0710cfdcb3c68937$export$47e016b53a5f0465 = $0710cfdcb3c68937$var$createFireAnalytics($0710cfdcb3c68937$var$EVENT_TYPES.UI);

});

parcelRegister("jPGXT", function(module, exports) {

$parcel$export(module.exports, "ROW_STATES", () => $7a092798de03dbbf$export$d17c451ccb229dcb);
$parcel$export(module.exports, "VALID_INITIAL_STATES", () => $7a092798de03dbbf$export$43acf26460204930);
$parcel$export(module.exports, "VALID_TRANSITIONS", () => $7a092798de03dbbf$export$682b071fc4ac4b0c);
$parcel$export(module.exports, "DEFAULT_COUNTS", () => $7a092798de03dbbf$export$ccc216ff57ae82b9);
const $7a092798de03dbbf$export$d17c451ccb229dcb = {
    FOCUSED: 'FOCUSED',
    SELECTED: 'SELECTED',
    DRAGGED: 'DRAGGED',
    DRAGGED_OUT: 'DRAGGED_OUT',
    DRAGGED_OVER: 'DRAGGED_OVER'
};
const $7a092798de03dbbf$export$43acf26460204930 = {
    FOCUSED: true,
    SELECTED: true,
    DRAGGED: true,
    DRAGGED_OUT: false,
    DRAGGED_OVER: false
};
const $7a092798de03dbbf$export$682b071fc4ac4b0c = {
    FOCUSED: {
        SELECTED: true,
        DRAGGED: true
    },
    SELECTED: {
        DRAGGED: true
    },
    DRAGGED: {
        SELECTED: true,
        DRAGGED_OUT: true,
        DRAGGED_OVER: true
    },
    DRAGGED_OUT: {
        SELECTED: true,
        DRAGGED_OVER: true
    },
    DRAGGED_OVER: {
        SELECTED: true,
        DRAGGED_OUT: true
    }
};
const $7a092798de03dbbf$export$ccc216ff57ae82b9 = {
    FOCUSED: 0,
    SELECTED: 0,
    DRAGGED: 0,
    DRAGGED_OUT: 0,
    DRAGGED_OVER: 0
};

});


parcelRegister("fhdOI", function(module, exports) {

$parcel$export(module.exports, "useStyleMarshal", () => $10bb96204b760a96$export$984a1617ce4cc44b);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $fTs8H = parcelRequire("fTs8H");
/* This hook can be used to style components outside the React lifecycle, and without the aid
 * of libraries like compiled. It is achieved by inserting styles directly into a `<style>` tag
 * in the `<head>` of the document (similar to popular CSS-in-JS frameworks).
 *
 * This is necessary to provide a performant experience for high-frequency interactions that need
 * to be synchronised across the table. E.g. setting the hover state across the same row in all columns
 * is not be viable with prop drilling, since reconciliation is too expensive.
 */ const $10bb96204b760a96$export$984a1617ce4cc44b = (scope)=>{
    const styleEl = (0, $eUqFw.useRef)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (typeof document !== 'undefined') {
            styleEl.current = document.createElement('style');
            styleEl.current.id = 'roadmap-data-styles';
            const head = document.querySelector('head');
            head && head.appendChild(styleEl.current);
        }
        return ()=>{
            styleEl.current?.parentNode?.removeChild(styleEl.current);
        };
    }, []);
    // The primitive utils to manipulate our custom style element
    const styleUtils = (0, $eUqFw.useMemo)(()=>{
        const insertStyle = (className, rule)=>{
            removeStyle(className);
            addToStylesheet((0, $fTs8H.toSelector)(className), rule);
        };
        const removeStyle = (className)=>{
            if (!styleEl.current || !styleEl.current.sheet) return;
            const ruleIndex = (0, $fTs8H.getIndexBySelector)(scope, styleEl.current.sheet.cssRules, (0, $fTs8H.toSelector)(className));
            if (ruleIndex !== -1) styleEl.current.sheet.deleteRule(ruleIndex);
        };
        const updateStyle = (targetClassNames, style)=>{
            if (!styleEl.current || !styleEl.current.sheet) return;
            const ruleIndex = (0, $fTs8H.getIndexByRule)(styleEl.current.sheet.cssRules, style);
            const selectors = (0, $fTs8H.toSelectors)(targetClassNames, scope);
            ruleIndex !== -1 && styleEl.current.sheet.deleteRule(ruleIndex);
            if (selectors.length > 0) styleEl.current.sheet.insertRule(`${selectors.join(', ')} {${(0, $fTs8H.toRule)(style)}}`, styleEl.current.sheet.cssRules.length);
        };
        const addToStylesheet = (selector, rule)=>{
            styleEl.current?.sheet?.insertRule(`.${scope} ${String(selector)} {${rule.replace('\n', ' ')}}`, styleEl.current.sheet.cssRules.length);
        };
        return {
            insertStyle: insertStyle,
            removeStyle: removeStyle,
            updateStyle: updateStyle
        };
    }, [
        scope
    ]);
    // The view specific utils to manipulate our marshalled elements
    const styleAPI = (0, $eUqFw.useMemo)(()=>{
        const hoverRow = (id)=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).row(id), (0, $fTs8H.styles).itemHover);
        };
        const leaveRow = (id)=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).row(id));
        };
        const selectRow = (ids)=>{
            const selectedClasses = ids.map((id)=>(0, $fTs8H.classNames).row(id));
            styleUtils.updateStyle([], (0, $fTs8H.styles).itemHover);
            styleUtils.updateStyle(selectedClasses, (0, $fTs8H.styles).itemSelected);
        };
        const deselectRow = ()=>{
            styleUtils.updateStyle([], (0, $fTs8H.styles).itemSelected);
        };
        const dragRow = (id)=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).inlineCreate);
            styleUtils.insertStyle((0, $fTs8H.classNames).row(id), (0, $fTs8H.styles).itemDragging);
            styleUtils.insertStyle((0, $fTs8H.classNames).rowChild(id), (0, $fTs8H.styles).itemDragging);
            styleUtils.insertStyle((0, $fTs8H.classNames).itemsContainer, (0, $fTs8H.styles).itemsContainerDragging);
        };
        const dropRow = (id, wasSelected)=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).createChild);
            styleUtils.removeStyle((0, $fTs8H.classNames).row(id));
            styleUtils.removeStyle((0, $fTs8H.classNames).rowChild(id));
            styleUtils.removeStyle((0, $fTs8H.classNames).dragIndicator);
            styleUtils.removeStyle((0, $fTs8H.classNames).itemsContainer);
            wasSelected && styleUtils.insertStyle((0, $fTs8H.classNames).row(id), (0, $fTs8H.styles).itemSelected);
        };
        const showDragIndicator = (top, left)=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).dragIndicator, (0, $fTs8H.styles).getDragIndicator(top, left));
        };
        const dragOverParent = (parentId, isSelected)=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).dragIndicator);
            const style = isSelected ? (0, $fTs8H.styles).selectedItemCanBeCombined : (0, $fTs8H.styles).itemCanBeCombined;
            styleUtils.updateStyle([
                (0, $fTs8H.classNames).row(parentId)
            ], style);
        };
        const dragOutOfBounds = ()=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).dragIndicator);
        };
        const showInlineCreate = (top, tabFocused)=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).inlineCreate, (0, $fTs8H.styles).getInlineCreateButton(top));
            if (tabFocused && (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally')) styleUtils.insertStyle((0, $fTs8H.classNames).inlineCreateIcon, (0, $fTs8H.styles).getInlineCreateIcon());
            if (!tabFocused && (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) styleUtils.removeStyle((0, $fTs8H.classNames).inlineCreateIcon);
        };
        const hideInlineCreate = ()=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).inlineCreate);
            if ((0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally')) styleUtils.removeStyle((0, $fTs8H.classNames).inlineCreateIcon);
        };
        const hideChildCreate = ()=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).createChild, (0, $fTs8H.styles).itemDragging);
        };
        const blockPointerEvents = ()=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).itemsContainer, (0, $fTs8H.styles).itemsContainerScrolling);
        };
        const allowPointerEvents = ()=>{
            styleAPI.removeStyle((0, $fTs8H.classNames).itemsContainer);
        };
        return {
            ...styleUtils,
            hoverRow: hoverRow,
            leaveRow: leaveRow,
            selectRow: selectRow,
            deselectRow: deselectRow,
            dragRow: dragRow,
            dropRow: dropRow,
            showDragIndicator: showDragIndicator,
            dragOverParent: dragOverParent,
            dragOutOfBounds: dragOutOfBounds,
            showInlineCreate: showInlineCreate,
            hideInlineCreate: hideInlineCreate,
            hideChildCreate: hideChildCreate,
            blockPointerEvents: blockPointerEvents,
            allowPointerEvents: allowPointerEvents
        };
    }, [
        styleUtils
    ]);
    return styleAPI;
};

});
parcelRegister("fTs8H", function(module, exports) {

$parcel$export(module.exports, "getIndexBySelector", () => $94099e6ff79fd880$export$531566c459a9453);
$parcel$export(module.exports, "getIndexByRule", () => $94099e6ff79fd880$export$5e88903c48b9b53);
$parcel$export(module.exports, "toRule", () => $94099e6ff79fd880$export$f9a10e11cef4ed80);
$parcel$export(module.exports, "toSelector", () => $94099e6ff79fd880$export$fef48429545ba792);
$parcel$export(module.exports, "toSelectors", () => $94099e6ff79fd880$export$fea3972019a1b6b0);
$parcel$export(module.exports, "classNames", () => $94099e6ff79fd880$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "styles", () => $94099e6ff79fd880$export$9dd6ff9ea0189349);
$parcel$export(module.exports, "getDragIndicatorClassName", () => $94099e6ff79fd880$export$5295be4f68791c03);
$parcel$export(module.exports, "getInlineCreateButtonClassName", () => $94099e6ff79fd880$export$c6b1c9f0aaabd326);
$parcel$export(module.exports, "getInlineCreateIconClassName", () => $94099e6ff79fd880$export$36993ff9ff59e588);
$parcel$export(module.exports, "getItemsBackgroundClassName", () => $94099e6ff79fd880$export$db96af0fdcbdbc30);
$parcel$export(module.exports, "getCreateChildButtonClassName", () => $94099e6ff79fd880$export$30e1e4b30ec4d53);
$parcel$export(module.exports, "getRowClassName", () => $94099e6ff79fd880$export$d435f2dd2e4838a0);

const $94099e6ff79fd880$export$5a544e13ad4e1fa5 = (hexColor, alpha = 1)=>{
    const parsed = hexColor.match(/[a-f0-9]{2}/gi);
    if (!parsed || parsed && parsed.length !== 3 || hexColor.indexOf('#') < 0) return hexColor;
    const rgb = parsed.map((hex)=>parseInt(hex, 16));
    if (alpha < 1 && alpha >= 0) return `rgba(${rgb.concat(alpha).join(',')})`;
    return `rgb(${rgb.join()})`;
};
const $94099e6ff79fd880$export$307b18b61172f7ed = (className)=>({
        className: Array.isArray(className) ? className.join(' ') : className
    });
const $94099e6ff79fd880$export$531566c459a9453 = (scope, cssRules, target)=>Array.from(cssRules || []).findIndex((cssRule)=>'selectorText' in cssRule && cssRule.selectorText === `.${scope} ${target}`);
const $94099e6ff79fd880$export$5e88903c48b9b53 = (cssRules, target)=>Array.from(cssRules || []).findIndex(({ cssText: cssText })=>$94099e6ff79fd880$export$f9a10e11cef4ed80(cssText).endsWith(`{${$94099e6ff79fd880$export$f9a10e11cef4ed80(target)}}`));
const $94099e6ff79fd880$export$fef48429545ba792 = (className)=>`.${className}`;
const $94099e6ff79fd880$export$fea3972019a1b6b0 = (targetClassNames, scope)=>targetClassNames.map((className)=>`.${scope} .${className}`);
const $94099e6ff79fd880$export$f9a10e11cef4ed80 = (style)=>style.replace(/#\w+/g, (hexColor)=>$94099e6ff79fd880$export$5a544e13ad4e1fa5(hexColor)).replace(/[\r\n\s]/g, '');
// =============== //
// === CLASSES === //
// =============== //
const $94099e6ff79fd880$var$row = (id)=>`row-${id}`;
const $94099e6ff79fd880$var$rowChild = (id)=>`row-child-${id}`;
const $94099e6ff79fd880$var$inlineCreate = 'inline-create-button';
const $94099e6ff79fd880$var$inlineCreateIcon = 'inline-create-button-icon';
const $94099e6ff79fd880$var$dragIndicator = 'inline-drag-indicator';
const $94099e6ff79fd880$var$dragIndicatorTop = 'inline-drag-indicator-top';
const $94099e6ff79fd880$var$itemsContainer = 'items-container';
const $94099e6ff79fd880$var$createChild = 'create-child-button';
const $94099e6ff79fd880$export$ce4ab0c55987d1ff = {
    row: $94099e6ff79fd880$var$row,
    rowChild: $94099e6ff79fd880$var$rowChild,
    inlineCreate: $94099e6ff79fd880$var$inlineCreate,
    inlineCreateIcon: $94099e6ff79fd880$var$inlineCreateIcon,
    dragIndicator: $94099e6ff79fd880$var$dragIndicator,
    dragIndicatorTop: $94099e6ff79fd880$var$dragIndicatorTop,
    itemsContainer: $94099e6ff79fd880$var$itemsContainer,
    createChild: $94099e6ff79fd880$var$createChild
};
// =============== //
// === STYLES ==== //
// =============== //
const $94099e6ff79fd880$var$itemHover = `
    background-color: ${`var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`} !important;
`;
const $94099e6ff79fd880$var$itemSelected = `
    background-color: ${`var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`} !important;
`;
const $94099e6ff79fd880$var$itemDragging = `
    opacity: 0;
`;
const $94099e6ff79fd880$var$itemsContainerDragging = `
    background: ${`var(--ds-surface-pressed, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`} !important;
`;
const $94099e6ff79fd880$var$itemsContainerScrolling = `
    pointer-events: none;
`;
const $94099e6ff79fd880$var$itemCanBeCombined = `
    background-color: ${`var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`} !important;
`;
const $94099e6ff79fd880$var$selectedItemCanBeCombined = `
    background-color: ${`var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`} !important;
`;
const $94099e6ff79fd880$var$getDragIndicator = (top, left)=>`
    display: block;
    position: fixed;
    right: 0;
    transform: ${left ? `translate(${left}px, ${top}px)` : `translateY(${top}px)`};
    pointer-events: none;
`;
const $94099e6ff79fd880$var$getInlineCreateButton = (top)=>`
    display: block;
    position: fixed;
    right: 0;
    transform: translateY(${top}px);
    pointer-events: none;
`;
const $94099e6ff79fd880$var$getInlineCreateIcon = ()=>`
	outline: 2px solid ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`};
	outline-offset: 2px;
`;
const $94099e6ff79fd880$export$9dd6ff9ea0189349 = {
    itemHover: $94099e6ff79fd880$var$itemHover,
    itemSelected: $94099e6ff79fd880$var$itemSelected,
    itemDragging: $94099e6ff79fd880$var$itemDragging,
    itemsContainerDragging: $94099e6ff79fd880$var$itemsContainerDragging,
    itemsContainerScrolling: $94099e6ff79fd880$var$itemsContainerScrolling,
    itemCanBeCombined: $94099e6ff79fd880$var$itemCanBeCombined,
    selectedItemCanBeCombined: $94099e6ff79fd880$var$selectedItemCanBeCombined,
    getDragIndicator: $94099e6ff79fd880$var$getDragIndicator,
    getInlineCreateButton: $94099e6ff79fd880$var$getInlineCreateButton,
    getInlineCreateIcon: $94099e6ff79fd880$var$getInlineCreateIcon
};
const $94099e6ff79fd880$export$5295be4f68791c03 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed([
        $94099e6ff79fd880$var$dragIndicator,
        $94099e6ff79fd880$var$dragIndicatorTop
    ]);
const $94099e6ff79fd880$export$c6b1c9f0aaabd326 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed($94099e6ff79fd880$var$inlineCreate);
const $94099e6ff79fd880$export$36993ff9ff59e588 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed($94099e6ff79fd880$var$inlineCreateIcon);
const $94099e6ff79fd880$export$db96af0fdcbdbc30 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed($94099e6ff79fd880$var$itemsContainer);
const $94099e6ff79fd880$export$30e1e4b30ec4d53 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed($94099e6ff79fd880$var$createChild);
const $94099e6ff79fd880$export$d435f2dd2e4838a0 = (id, parentId)=>{
    const classes = parentId !== undefined ? [
        $94099e6ff79fd880$var$row(id),
        $94099e6ff79fd880$var$rowChild(parentId)
    ] : $94099e6ff79fd880$var$row(id);
    return $94099e6ff79fd880$export$307b18b61172f7ed(classes);
};

});


parcelRegister("1UVbw", function(module, exports) {

$parcel$export(module.exports, "bindCustomActions", () => $dba1bdcc37b5dc97$export$85d352c410f2eb84);
$parcel$export(module.exports, "bindOverrideActions", () => $dba1bdcc37b5dc97$export$d27110202ae8442b);
/* We only want to expose the primitive style utils for consumers.
 * Everything else is an internal abstraction, which should remain private.
 */ const $dba1bdcc37b5dc97$var$getPublicStyleAPI = (styleAPI)=>({
        insertStyle: styleAPI.insertStyle,
        removeStyle: styleAPI.removeStyle,
        updateStyle: styleAPI.updateStyle
    });
const $dba1bdcc37b5dc97$export$85d352c410f2eb84 = (customActions, styleAPI)=>Object.keys(customActions).reduce((acc, key)=>{
        acc[key] = customActions[key].bind(null, {
            styleAPI: $dba1bdcc37b5dc97$var$getPublicStyleAPI(styleAPI)
        });
        return acc;
    }, {});
/* Takes two action functions and combines them into a single function.
 * The aforementioned actions will be called in order, with the parameters of the first.
 *
 * Getting stricter generic types was impractical, but we ultimately still have good type
 * safety due to the calling function being strictly typed.
 */ const $dba1bdcc37b5dc97$var$combineActions = (actionOne, actionTwo, styleAPI)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        actionOne(...args);
        actionTwo?.bind(null, {
            styleAPI: $dba1bdcc37b5dc97$var$getPublicStyleAPI(styleAPI)
        })(...args);
    };
const $dba1bdcc37b5dc97$export$d27110202ae8442b = (defaultActions, overrideActions, styleAPI)=>Object.keys(defaultActions).reduce((acc, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const defaults = defaultActions[key];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrides = overrideActions[key];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        acc[key] = $dba1bdcc37b5dc97$var$combineActions(defaults, overrides, styleAPI);
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});

});


parcelRegister("cZkk1", function(module, exports) {

$parcel$export(module.exports, "useTimelineViewportActions", () => $5caed9027b519818$export$93c2697e07ec9389);
$parcel$export(module.exports, "useTimelineViewport", () => $5caed9027b519818$export$408aa890bc70d3dc);
$parcel$export(module.exports, "TimelineViewportProvider", () => $5caed9027b519818$export$f521cde558624422);

var $WBLbN = parcelRequire("WBLbN");

var $ggROF = parcelRequire("ggROF");
const $5caed9027b519818$var$initialState = {
    left: 0,
    clientWidth: 0,
    indicatorLineOffset: 0
};
const $5caed9027b519818$export$d474af741f65a5d3 = (0, $WBLbN.createStore)({
    initialState: $5caed9027b519818$var$initialState,
    actions: $ggROF.actions,
    name: 'timeline-table.timeline-viewport'
});
const $5caed9027b519818$export$93c2697e07ec9389 = (0, $WBLbN.createActionsHook)($5caed9027b519818$export$d474af741f65a5d3);
const $5caed9027b519818$export$408aa890bc70d3dc = (0, $WBLbN.createHook)($5caed9027b519818$export$d474af741f65a5d3);
const $5caed9027b519818$export$f521cde558624422 = (0, $WBLbN.createContainer)($5caed9027b519818$export$d474af741f65a5d3);

});
parcelRegister("ggROF", function(module, exports) {

$parcel$export(module.exports, "actions", () => $53e68ca006939e1d$export$e324594224ef24da);

var $dBS6z = parcelRequire("dBS6z");
const $53e68ca006939e1d$export$e324594224ef24da = {
    onResize: $dBS6z.onResize
};

});
parcelRegister("dBS6z", function(module, exports) {

$parcel$export(module.exports, "onResize", () => $22d5f79b2e1b025c$export$45b39e67d4ce4921);
const $22d5f79b2e1b025c$export$45b39e67d4ce4921 = (params)=>({ setState: setState })=>{
        setState({
            ...params
        });
    };

});



parcelRegister("3XwA1", function(module, exports) {

$parcel$export(module.exports, "useTimelineState", () => $7f456431cfda2d7a$export$f92f0bc83b35c17b);
$parcel$export(module.exports, "TimelineProviderSweetState", () => $7f456431cfda2d7a$export$4f33ace85fd289c5);

var $WBLbN = parcelRequire("WBLbN");

var $gf0vG = parcelRequire("gf0vG");

var $l2CBN = parcelRequire("l2CBN");

var $1QJt8 = parcelRequire("1QJt8");

var $7ymwE = parcelRequire("7ymwE");
const $7f456431cfda2d7a$var$initialState = {
    /* Raw data */ today: 0,
    timelineMode: (0, $gf0vG.MONTHS),
    timelineDuration: {
        startMilliseconds: 0,
        endMilliseconds: 0,
        totalMilliseconds: 0
    },
    timelineOrigin: 0,
    /* Derived data */ timelineWidth: 0,
    timelineOriginPosition: 0,
    columnDurations: [],
    columnPositions: []
};
const $7f456431cfda2d7a$export$2ce7f0e10391f4 = (0, $WBLbN.createStore)({
    initialState: $7f456431cfda2d7a$var$initialState,
    actions: $7ymwE.actions,
    name: 'timeline-table.timeline'
});
const $7f456431cfda2d7a$export$f92f0bc83b35c17b = (0, $WBLbN.createHook)($7f456431cfda2d7a$export$2ce7f0e10391f4);
const $7f456431cfda2d7a$var$handleState = ()=>({ setState: setState }, timelineData)=>{
        const { timelineMode: timelineMode, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin } = timelineData;
        const timelineWidth = (0, $1QJt8.getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds);
        const columnDurations = (0, $l2CBN.getColumnDurations)(timelineMode, timelineDuration);
        const columnPositions = (0, $l2CBN.getColumnPositions)(timelineDuration, columnDurations);
        const timelineOriginPosition = (0, $1QJt8.getTimelinePositionFromDate)(timelineDuration, timelineWidth, timelineOrigin);
        setState({
            ...timelineData,
            timelineWidth: timelineWidth,
            timelineOriginPosition: timelineOriginPosition,
            columnDurations: columnDurations,
            columnPositions: columnPositions
        });
    };
const $7f456431cfda2d7a$export$4f33ace85fd289c5 = (0, $WBLbN.createContainer)($7f456431cfda2d7a$export$2ce7f0e10391f4, {
    onInit: $7f456431cfda2d7a$var$handleState,
    onUpdate: $7f456431cfda2d7a$var$handleState
});

});
parcelRegister("l2CBN", function(module, exports) {

$parcel$export(module.exports, "getColumnDurations", () => $c923ac3e953c0bb6$export$97c232fe861416fb);
$parcel$export(module.exports, "getColumnPositions", () => $c923ac3e953c0bb6$export$1f04562dc761554b);
$parcel$export(module.exports, "getTodayColumnIndex", () => $c923ac3e953c0bb6$export$ce237023318dfe05);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

var $gf0vG = parcelRequire("gf0vG");
const $c923ac3e953c0bb6$var$getColumnDurationsForMode = (timelineDuration, momentIdentifier)=>{
    const columnDurations = [];
    const { startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds } = timelineDuration;
    // Sanitize. We still want to *round* to an ISO week, but you can't *add* an ISO week (it fails silently).
    const momentAddIdentifier = momentIdentifier === 'isoWeek' ? 'week' : momentIdentifier;
    const startMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(startMilliseconds).startOf(momentIdentifier);
    while(startMoment.valueOf() < endMilliseconds){
        const endMoment = startMoment.clone().endOf(momentIdentifier);
        columnDurations.push({
            startMilliseconds: startMoment.valueOf(),
            endMilliseconds: endMoment.valueOf(),
            totalMilliseconds: endMoment.diff(startMoment, 'milliseconds')
        });
        startMoment.add(1, momentAddIdentifier);
    }
    return columnDurations;
};
const $c923ac3e953c0bb6$export$97c232fe861416fb = (0, $5iWql.default)((timelineMode, timelineDuration)=>{
    if (timelineMode === (0, $gf0vG.QUARTERS)) return $c923ac3e953c0bb6$var$getColumnDurationsForMode(timelineDuration, 'quarter');
    if (timelineMode === (0, $gf0vG.MONTHS)) return $c923ac3e953c0bb6$var$getColumnDurationsForMode(timelineDuration, 'month');
    /* We always want a week column to start on Monday. The 'week' parameter is locale aware which could start on Sunday.
		 * An ISO week on the other hand always starts on the Monday.
		 */ return $c923ac3e953c0bb6$var$getColumnDurationsForMode(timelineDuration, 'isoWeek');
});
const $c923ac3e953c0bb6$export$1f04562dc761554b = (0, $5iWql.default)((timelineDuration, columnDurations)=>{
    let left = 0;
    if (columnDurations.length > 0) // Column start can be earlier than the timeline start. This means the first column left can be a negative value.
    // Example where this can happen is in the export table where the timeline duration is clamped to the selected date range.
    left = (columnDurations[0].startMilliseconds - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds * 100;
    return columnDurations.map((columnDuration)=>{
        const width = columnDuration.totalMilliseconds / timelineDuration.totalMilliseconds * 100;
        left += width;
        return [
            left - width,
            100 - left
        ];
    });
});
const $c923ac3e953c0bb6$export$ce237023318dfe05 = (0, $5iWql.default)((today, columnDurations)=>{
    let todayColumnIndex = 0;
    columnDurations.some(({ startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds })=>{
        if (today >= startMilliseconds && today <= endMilliseconds) return true;
        todayColumnIndex += 1;
        return false;
    });
    return todayColumnIndex;
});

});

parcelRegister("7ymwE", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a4619ff803e39c87$export$e324594224ef24da);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a4619ff803e39c87$export$e324594224ef24da = {};

});


parcelRegister("kzPj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7578ed892fee29bc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $apXyS = parcelRequire("apXyS");

var $9NRea = parcelRequire("9NRea");

var $8ftWh = parcelRequire("8ftWh");

var $gPBP5 = parcelRequire("gPBP5");

var $jV7n9 = parcelRequire("jV7n9");

var $76ouJ = parcelRequire("76ouJ");

var $ir2Y2 = parcelRequire("ir2Y2");

var $dqHZ6 = parcelRequire("dqHZ6");

var $ibHnm = parcelRequire("ibHnm");

var $4d1OI = parcelRequire("4d1OI");

var $4YDQS = parcelRequire("4YDQS");
const $7578ed892fee29bc$var$containerStyles = null;
const $7578ed892fee29bc$var$TableMain = ({ isVirtualiseEnabled: isVirtualiseEnabled, isResizeEnabled: isResizeEnabled, isHideScrollbar: isHideScrollbar, scope: scope, selectedItemIds: selectedItemIds, onItemDrop: onItemDrop, onItemSelect: onItemSelect, onItemExpandChanged: onItemExpandChanged, onCreateClick: onCreateClick, onSetListWidth: onSetListWidth, DndLongTaskMetric: DndLongTaskMetric, renderers: renderers })=>{
    const { listRenderers: listRenderers, chartRenderers: chartRenderers, renderProvider: renderProvider } = (0, $4YDQS.getRenderersWithDefaults)(renderers);
    const { renderListEmptyContent: renderListEmptyContent, renderListHeaderItem: renderListHeaderItem, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemCreate: renderListItemCreate, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal } = listRenderers;
    const { renderChartHeaderItem: renderChartHeaderItem, renderChartItemContent: renderChartItemContent, renderChartOverlay: renderChartOverlay, renderChartTimelineOverlay: renderChartTimelineOverlay } = chartRenderers;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gPBP5.default), {
        isHideScrollbar: isHideScrollbar
    }, ({ scrollElement: scrollElement, onContentResize: onContentResize })=>{
        const containerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1ns9 _4t3i1ns9 _1tke1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $76ouJ.default), {
            renderListHeaderItem: renderListHeaderItem,
            renderChartHeaderItem: renderChartHeaderItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ftWh.default), {
            isResizeEnabled: isResizeEnabled,
            DndLongTaskMetric: DndLongTaskMetric,
            onItemDrop: onItemDrop,
            // TODO: remove this
            onItemSelect: onItemSelect,
            onItemExpandChanged: onItemExpandChanged,
            onCreateClick: onCreateClick,
            onSetListWidth: onSetListWidth,
            onContentResize: onContentResize,
            renderListEmptyContent: renderListEmptyContent,
            renderListItemContent: renderListItemContent,
            renderListItemSecondaryContent: renderListItemSecondaryContent,
            renderListItemCreate: renderListItemCreate,
            renderChartItemContent: renderChartItemContent,
            renderChartTimelineOverlay: renderChartTimelineOverlay,
            renderListItemMenuOption: renderListItemMenuOption,
            renderListItemModal: renderListItemModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4d1OI.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jV7n9.default), {
            DndLongTaskMetric: DndLongTaskMetric
        }), (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ir2Y2.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dqHZ6.default), {
            selectedItemIds: selectedItemIds
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apXyS.default), {
            scope: scope,
            scrollElement: scrollElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NRea.default), {
            scrollElement: scrollElement,
            isEnabled: isVirtualiseEnabled
        }, renderProvider({
            children: containerContent
        })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ibHnm.default), {
        renderChartOverlay: renderChartOverlay
    }));
};
$7578ed892fee29bc$var$TableMain.displayName = 'TableMain';
$7578ed892fee29bc$var$TableMain.whyDidYouRender = true;
var $7578ed892fee29bc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7578ed892fee29bc$var$TableMain);

});
parcelRegister("apXyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ebfbe13a12bdc2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $511uv = parcelRequire("511uv");

var $oVkDS = parcelRequire("oVkDS");

var $62mlw = parcelRequire("62mlw");

var $gf0vG = parcelRequire("gf0vG");

var $VrUCp = parcelRequire("VrUCp");

var $lSR7G = parcelRequire("lSR7G");

var $hxnNZ = parcelRequire("hxnNZ");

var $bwj1b = parcelRequire("bwj1b");

var $ccgw3 = parcelRequire("ccgw3");

var $gCa9e = parcelRequire("gCa9e");

var $kqGqd = parcelRequire("kqGqd");
const $b2ebfbe13a12bdc2$var$start = (scope)=>{
    (0, $511uv.getLongTasksMetrics)((0, $gf0vG.SCROLLED)).start(scope);
};
const $b2ebfbe13a12bdc2$var$stop = (scope)=>{
    let reporter = (0, $oVkDS.genericReporter);
    reporter = (0, $62mlw.scrollReporterWithSlo)();
    (0, $511uv.getLongTasksMetrics)(scope).stop(reporter);
};
/**
 * SCROLL LONG TASK SLO METRIC
 */ const $b2ebfbe13a12bdc2$var$SCROLL_COUNT_THRESHOLD = 5;
const $b2ebfbe13a12bdc2$var$Container = ({ scope: scope, scrollElement: scrollElement })=>{
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const { onScrollStateChanged: onScrollStateChanged } = (0, $bwj1b.useSideEffectMarshal)();
    const [, { updateScrollMeta: updateScrollMeta, updateScrollPosition: updateScrollPosition }] = (0, $hxnNZ.useScrollMetaActions)();
    const [{ totalHeight: totalHeight }] = (0, $lSR7G.useItemsContainerStyles)();
    const isScrolling = (0, $eUqFw.useRef)(false);
    const scrollCount = (0, $eUqFw.useRef)(0);
    const getAndUpdateScrollPosition = (0, $eUqFw.useCallback)(()=>{
        const { scrollTop: scrollTop, clientHeight: clientHeight } = scrollElement;
        const tableHeight = totalHeight + headerHeight;
        const scrollBottom = Math.max(0, tableHeight - (scrollTop + clientHeight));
        updateScrollPosition({
            scrollTop: scrollTop,
            scrollBottom: scrollBottom
        });
    }, [
        scrollElement,
        totalHeight,
        updateScrollPosition,
        headerHeight
    ]);
    const onScrollChange = (0, $eUqFw.useCallback)((scrollingState)=>{
        if (isScrolling.current !== scrollingState.isScrollingY) {
            if (// Send metric on every Nth scroll interaction
            scrollCount.current === $b2ebfbe13a12bdc2$var$SCROLL_COUNT_THRESHOLD) {
                if (scrollingState.isScrollingY) $b2ebfbe13a12bdc2$var$start(scope);
                else {
                    $b2ebfbe13a12bdc2$var$stop(scope);
                    scrollCount.current = 0;
                }
                isScrolling.current = scrollingState.isScrollingY;
            } else scrollCount.current += 1;
        }
        updateScrollMeta(scrollingState);
        if (!scrollingState.isScrollingY) getAndUpdateScrollPosition();
        onScrollStateChanged(scrollingState.isScrollingY);
    }, [
        updateScrollMeta,
        getAndUpdateScrollPosition,
        onScrollStateChanged,
        scope
    ]);
    (0, $kqGqd.useIsScrolling)(scrollElement, onScrollChange);
    (0, $ccgw3.useResizeObserver)(scrollElement, getAndUpdateScrollPosition);
    return null;
};
const $b2ebfbe13a12bdc2$var$ScrollMetaContainer = ({ scope: scope, scrollElement: scrollElement, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hxnNZ.ScrollMetaProviderSweetState), null, scrollElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2ebfbe13a12bdc2$var$Container, {
        scope: scope,
        scrollElement: scrollElement
    }), scrollElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCa9e.default), {
        scope: scope,
        scrollElement: scrollElement
    }), children);
var $b2ebfbe13a12bdc2$export$2e2bcd8739ae039 = $b2ebfbe13a12bdc2$var$ScrollMetaContainer;

});
parcelRegister("hxnNZ", function(module, exports) {

$parcel$export(module.exports, "useScrollMetaActions", () => $df3dd5163f10b99b$export$ad4800a08d9776a3);
$parcel$export(module.exports, "ScrollMetaProviderSweetState", () => $df3dd5163f10b99b$export$e0f28de8d4016f86);
$parcel$export(module.exports, "isScrollToTop", () => $df3dd5163f10b99b$export$5a36b1e9643b5cf2);
$parcel$export(module.exports, "useIsScrollingY", () => $df3dd5163f10b99b$export$b4e5a0824bff5bca);
$parcel$export(module.exports, "useIsScrollingX", () => $df3dd5163f10b99b$export$b8a077e56392e785);

var $WBLbN = parcelRequire("WBLbN");

var $amX2C = parcelRequire("amX2C");

var $2qEZ6 = parcelRequire("2qEZ6");
const $df3dd5163f10b99b$var$DEFAULT_STATE = {
    isScrollingX: false,
    isScrollingY: false,
    positions: {
        top: 0,
        bottom: 0
    }
};
const $df3dd5163f10b99b$var$store = (0, $WBLbN.createStore)({
    initialState: $df3dd5163f10b99b$var$DEFAULT_STATE,
    actions: (0, $amX2C.scrollMetaActions),
    name: 'timeline-table.scroll-meta'
});
const $df3dd5163f10b99b$export$ad4800a08d9776a3 = (0, $WBLbN.createHook)($df3dd5163f10b99b$var$store, {
    selector: null
});
const $df3dd5163f10b99b$export$e0f28de8d4016f86 = (0, $WBLbN.createContainer)($df3dd5163f10b99b$var$store);
const $df3dd5163f10b99b$export$5a36b1e9643b5cf2 = (0, $WBLbN.createHook)($df3dd5163f10b99b$var$store, {
    selector: (0, $2qEZ6.getIsScrollToTop)
});
const $df3dd5163f10b99b$export$b4e5a0824bff5bca = (0, $WBLbN.createHook)($df3dd5163f10b99b$var$store, {
    selector: (0, $2qEZ6.getIsScrollingY)
});
const $df3dd5163f10b99b$export$b8a077e56392e785 = (0, $WBLbN.createHook)($df3dd5163f10b99b$var$store, {
    selector: (0, $2qEZ6.getIsScrollingX)
});

});
parcelRegister("amX2C", function(module, exports) {

$parcel$export(module.exports, "scrollMetaActions", () => $0fc5c6f60818c9eb$export$a0445084aaf6bbad);
const $0fc5c6f60818c9eb$var$updateScrollMeta = ({ isScrollingX: isScrollingX, isScrollingY: isScrollingY })=>({ setState: setState })=>{
        setState({
            isScrollingX: isScrollingX,
            isScrollingY: isScrollingY
        });
    };
const $0fc5c6f60818c9eb$var$updateScrollPosition = ({ scrollTop: scrollTop, scrollBottom: scrollBottom })=>({ setState: setState })=>{
        const positions = {
            top: scrollTop,
            bottom: scrollBottom
        };
        setState({
            positions: positions
        });
    };
const $0fc5c6f60818c9eb$export$a0445084aaf6bbad = {
    updateScrollMeta: $0fc5c6f60818c9eb$var$updateScrollMeta,
    updateScrollPosition: $0fc5c6f60818c9eb$var$updateScrollPosition
};

});

parcelRegister("2qEZ6", function(module, exports) {

$parcel$export(module.exports, "getIsScrollingX", () => $4bbf8949d8c46326$export$1b889f4869aca117);
$parcel$export(module.exports, "getIsScrollingY", () => $4bbf8949d8c46326$export$ca3dc64117d091c8);
$parcel$export(module.exports, "getIsScrollToTop", () => $4bbf8949d8c46326$export$2119597e6872810a);
const $4bbf8949d8c46326$export$1b889f4869aca117 = (state)=>state.isScrollingX;
const $4bbf8949d8c46326$export$ca3dc64117d091c8 = (state)=>state.isScrollingY;
const $4bbf8949d8c46326$export$2119597e6872810a = (state)=>state.positions.top === 0;

});


parcelRegister("ccgw3", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $d09aad1c949941e8$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");

var $1DUdw = parcelRequire("1DUdw");
let $d09aad1c949941e8$var$resizeObserver;
const $d09aad1c949941e8$export$683480f191c0e3ea = (element, // !! Important - The callback parameter must be referentially stable to avoid an infinite render loop !!
callback)=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (typeof ResizeObserver !== 'undefined') {
            if (!$d09aad1c949941e8$var$resizeObserver) $d09aad1c949941e8$var$resizeObserver = new ResizeObserver((0, $1DUdw.runCallbacks));
            element && (0, $1DUdw.observeElement)($d09aad1c949941e8$var$resizeObserver, element, callback);
        }
        return ()=>{
            if (element && $d09aad1c949941e8$var$resizeObserver) (0, $1DUdw.unobserveElement)($d09aad1c949941e8$var$resizeObserver, element, callback);
        };
    }, [
        element,
        callback
    ]);
};

});
parcelRegister("1DUdw", function(module, exports) {

$parcel$export(module.exports, "runCallbacks", () => $9f6a3ce1a557e93b$export$4219acf616175acb);
$parcel$export(module.exports, "observeElement", () => $9f6a3ce1a557e93b$export$9137ee61fe58d50e);
$parcel$export(module.exports, "unobserveElement", () => $9f6a3ce1a557e93b$export$4d125402ac99f1b);
const $9f6a3ce1a557e93b$var$elementsForCallback = new Map();
const $9f6a3ce1a557e93b$export$4219acf616175acb = (entries)=>{
    $9f6a3ce1a557e93b$var$elementsForCallback.forEach((elements, callback)=>{
        const relevantEntries = [];
        entries.forEach((entry)=>{
            if (elements.includes(entry.target)) relevantEntries.push(entry);
        });
        if (relevantEntries.length > 0) callback(relevantEntries);
    });
};
const $9f6a3ce1a557e93b$export$9137ee61fe58d50e = (resizeObserver, element, callback)=>{
    const existingElements = $9f6a3ce1a557e93b$var$elementsForCallback.get(callback);
    if (existingElements) $9f6a3ce1a557e93b$var$elementsForCallback.set(callback, [
        ...existingElements,
        element
    ]);
    else $9f6a3ce1a557e93b$var$elementsForCallback.set(callback, [
        element
    ]);
    resizeObserver.observe(element);
};
const $9f6a3ce1a557e93b$export$4d125402ac99f1b = (resizeObserver, element, callback)=>{
    $9f6a3ce1a557e93b$var$elementsForCallback.delete(callback);
    resizeObserver.unobserve(element);
};

});


parcelRegister("gCa9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4fa5f2557ea2e5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $axxSm = parcelRequire("axxSm");

var $lSR7G = parcelRequire("lSR7G");
const $1c4fa5f2557ea2e5$var$TimelineTableScrollFPSMetric = ({ scope: scope, scrollElement: scrollElement })=>{
    const [itemsCount] = (0, $lSR7G.useItemsCount)();
    const attributes = {
        isCustomScrollbarPdnd: (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_custom_scroll_pdnd')
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axxSm.default), {
        viewId: scope,
        itemsCount: itemsCount,
        scrollElement: scrollElement,
        attributes: attributes
    });
};
var $1c4fa5f2557ea2e5$export$2e2bcd8739ae039 = $1c4fa5f2557ea2e5$var$TimelineTableScrollFPSMetric;

});
parcelRegister("axxSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed3b6e522e859da6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

const $ed3b6e522e859da6$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $083bae7fff0f430d$export$9d3e6d8a99023567));
const $ed3b6e522e859da6$export$46962be62755f053 = /*#__PURE__*/ (0, $eUqFw.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $083bae7fff0f430d$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const samplingCount = (0, $eUqFw.useRef)(0);
    const frames = (0, $eUqFw.useRef)(0);
    const rafId = (0, $eUqFw.useRef)(null);
    const start = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const container = scrollElement ?? document;
        const hasScrollCapture = true;
        const tick = ()=>{
            if (frames.current < (0, $083bae7fff0f430d$export$299249b1dad3b14a)) {
                frames.current += 1;
                rafId.current = requestAnimationFrame(tick);
            } else {
                const stopTime = performance.now();
                const elapsedMs = stopTime - start.current;
                const fps = $ed3b6e522e859da6$export$df7175b69b5630dd(frames.current, elapsedMs);
                const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                frames.current = 0;
                const attr = {
                    ...attributes || {},
                    itemsCount: itemsCount,
                    avgFrameDuration: avgFrameDuration,
                    fps: fps
                };
                (0, $jMP2a.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
            }
        };
        const handleOnScroll = ()=>{
            samplingCount.current += 1;
            if (samplingCount.current !== samplingRate) return;
            samplingCount.current = 0;
            // start counting frames
            start.current = performance.now();
            tick();
        };
        container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        scrollElement,
        createAnalyticsEvent,
        itemsCount,
        samplingRate,
        viewId,
        attributes
    ]);
    return null;
});
var $ed3b6e522e859da6$export$2e2bcd8739ae039 = $ed3b6e522e859da6$export$46962be62755f053;

});
// how often do we measure, e.g. every 100th scroll
const $083bae7fff0f430d$export$71d024136796e395 = 100;
const $083bae7fff0f430d$export$299249b1dad3b14a = 20;
const $083bae7fff0f430d$export$9d3e6d8a99023567 = 60;



parcelRegister("kqGqd", function(module, exports) {

$parcel$export(module.exports, "useIsScrolling", () => $8d0556823ad10214$export$fde36fcfab14caba);

var $eUqFw = parcelRequire("eUqFw");

var $iH5dw = parcelRequire("iH5dw");

var $kTNWN = parcelRequire("kTNWN");
/* This hook is used to notify when either horizontal or vertical scrolling is in progress.
 * The notification will only fire for *changes* to this state, and not for every scroll event.
 */ const $8d0556823ad10214$export$fde36fcfab14caba = (scrollElement, onScrollChange)=>{
    const rafId = (0, $eUqFw.useRef)(null);
    const startTime = (0, $eUqFw.useRef)(-1);
    const isScrolling = (0, $eUqFw.useRef)(false);
    const lastPosition = (0, $eUqFw.useRef)({
        x: 0,
        y: 0
    });
    const lastScrollState = (0, $eUqFw.useRef)((0, $iH5dw.DEFAULT_STATE));
    const scrollEnd = (0, $eUqFw.useCallback)(()=>{
        if (isScrolling.current) {
            startTime.current = -1;
            isScrolling.current = false;
            lastScrollState.current = (0, $iH5dw.DEFAULT_STATE);
            onScrollChange((0, $iH5dw.DEFAULT_STATE));
        }
        if (rafId.current !== null) {
            cancelAnimationFrame(rafId.current);
            rafId.current = null;
        }
    }, [
        onScrollChange
    ]);
    /* Update the state and recursively schedule animation frames until the user
	 * stops scrolling (indicated by no scroll events over a small time period).
	 * -
	 * To determine which axis is scrolling, we compare the previous scroll offset with the
	 * the current offset. This is imperfect, since it's possible to get identical offsets
	 * even while scrolling. To minimise the number of updates, which also cause UI flickering,
	 * we assert that the scrolling state can only be fully reset on scroll end.
	 */ const tick = (0, $eUqFw.useCallback)(()=>{
        if (isScrolling.current) {
            const stopTime = performance.now();
            const time = stopTime - startTime.current;
            const { scrollTop: scrollTop, scrollLeft: scrollLeft } = scrollElement;
            const scrollState = {
                ...lastScrollState.current
            };
            if (scrollTop !== lastPosition.current.y) scrollState.isScrollingY = true;
            if (scrollLeft !== lastPosition.current.x) scrollState.isScrollingX = true;
            lastPosition.current = {
                x: scrollLeft,
                y: scrollTop
            };
            if (time >= (0, $iH5dw.IDLE_THRESHOLD)) scrollEnd();
            else {
                if ((0, $kTNWN.hasStateChanged)(lastScrollState.current, scrollState)) {
                    lastScrollState.current = {
                        ...scrollState
                    };
                    onScrollChange(scrollState);
                }
                rafId.current = requestAnimationFrame(tick);
            }
        }
    }, [
        scrollElement,
        scrollEnd,
        onScrollChange
    ]);
    const onScroll = (0, $eUqFw.useCallback)(()=>{
        isScrolling.current = true;
        startTime.current = performance.now();
        if (!rafId.current) rafId.current = requestAnimationFrame(tick);
    }, [
        tick
    ]);
    (0, $eUqFw.useEffect)(()=>{
        scrollElement.addEventListener('scroll', onScroll);
        return ()=>{
            scrollElement.removeEventListener('scroll', onScroll);
            if (rafId.current !== null) {
                cancelAnimationFrame(rafId.current);
                rafId.current = null;
            }
        };
    }, [
        scrollElement,
        onScroll
    ]);
};

});
parcelRegister("iH5dw", function(module, exports) {

$parcel$export(module.exports, "IDLE_THRESHOLD", () => $3f5b655fccdcb829$export$a9b912713512229e);
$parcel$export(module.exports, "DEFAULT_STATE", () => $3f5b655fccdcb829$export$a3a6a28ae8823b06);
const $3f5b655fccdcb829$export$a9b912713512229e = 150;
const $3f5b655fccdcb829$export$a3a6a28ae8823b06 = {
    isScrollingX: false,
    isScrollingY: false
};

});

parcelRegister("kTNWN", function(module, exports) {

$parcel$export(module.exports, "hasStateChanged", () => $8df4e4326a8e391c$export$ba6070bd39de76e0);
const $8df4e4326a8e391c$export$ba6070bd39de76e0 = (oldState, newState)=>!oldState.isScrollingX && newState.isScrollingX || !oldState.isScrollingY && newState.isScrollingY;

});



parcelRegister("9NRea", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dc571431d1c2120$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6ki0E = parcelRequire("6ki0E");

var $gf0vG = parcelRequire("gf0vG");

var $VrUCp = parcelRequire("VrUCp");

var $lSR7G = parcelRequire("lSR7G");

var $bmsPo = parcelRequire("bmsPo");

var $2eorI = parcelRequire("2eorI");
const $7dc571431d1c2120$var$useVirtualItems = ({ scrollElement: scrollElement, itemHeights: itemHeights })=>{
    const [, { generateVirtualMeta: generateVirtualMeta }] = (0, $bmsPo.useVirtualisedActions)();
    const parentRef = (0, $eUqFw.useRef)(scrollElement);
    const getRowHeight = (0, $eUqFw.useCallback)((index)=>itemHeights[index], [
        itemHeights
    ]);
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const virtualizer = (0, $6ki0E.useVirtualizer)({
        count: itemHeights.length,
        getScrollElement: ()=>parentRef.current,
        estimateSize: getRowHeight,
        overscan: 0,
        paddingStart: headerHeight
    });
    (0, $eUqFw.useLayoutEffect)(()=>{
        const virtualItems = virtualizer.getVirtualItems();
        if (virtualizer.getVirtualItems().length > 0) {
            const { index: startIndex } = virtualItems[0];
            const { index: endIndex } = virtualItems[virtualItems.length - 1];
            const visibleItemCount = endIndex - startIndex;
            const roundedStart = Math.round(startIndex / 5) * 5;
            generateVirtualMeta(roundedStart, Math.min(roundedStart + visibleItemCount, endIndex));
        } else // Unset start and end index to disable virtualisation
        generateVirtualMeta(0, itemHeights.length - 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        generateVirtualMeta,
        virtualizer.getVirtualItems(),
        itemHeights
    ]);
};
const $7dc571431d1c2120$var$Container = ({ itemHeights: itemHeights, scrollElement: scrollElement })=>{
    $7dc571431d1c2120$var$useVirtualItems({
        itemHeights: itemHeights,
        scrollElement: scrollElement
    });
    return null;
};
const $7dc571431d1c2120$var$VirtualiseContainer = ({ isEnabled: isEnabled, children: children, scrollElement: scrollElement })=>{
    const [items] = (0, $lSR7G.useItems)();
    const [itemHeight] = (0, $lSR7G.useItemHeight)();
    const itemHeights = (0, $eUqFw.useMemo)(()=>(0, $2eorI.getItemHeights)(items, itemHeight), [
        items,
        itemHeight
    ]);
    const createItemIndex = (0, $eUqFw.useMemo)(()=>items.findIndex((item)=>item.type === (0, $gf0vG.CREATE_ITEM_TYPE)), [
        items
    ]);
    if (// react-virtual uses ResizeObserver to get parentRef's dimension
    typeof ResizeObserver === 'undefined') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmsPo.VirtualiseProviderSweetState), {
        itemHeights: itemHeights,
        createItemIndex: createItemIndex,
        isEnabled: isEnabled,
        items: items
    }, scrollElement && isEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dc571431d1c2120$var$Container, {
        itemHeights: itemHeights,
        scrollElement: scrollElement
    }), children);
};
var $7dc571431d1c2120$export$2e2bcd8739ae039 = $7dc571431d1c2120$var$VirtualiseContainer;

});
parcelRegister("6ki0E", function(module, exports) {
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("2N9zU")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("5oCQ9")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("2N9zU")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("2N9zU")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("2N9zU")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("2N9zU")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("2N9zU")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("2N9zU")).windowScroll);

$parcel$export(module.exports, "useVirtualizer", () => $49b294a7a914c493$export$dd6d526d88b5a137);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2N9zU = parcelRequire("2N9zU");
const $49b294a7a914c493$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;
function $49b294a7a914c493$var$useVirtualizerBase(options) {
    const rerender = $eUqFw.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $lEfVV.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $eUqFw.useState(()=>new (0, $2N9zU.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $eUqFw.useEffect(()=>{
        return instance._didMount();
    }, []);
    $49b294a7a914c493$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $49b294a7a914c493$export$dd6d526d88b5a137(options) {
    return $49b294a7a914c493$var$useVirtualizerBase({
        observeElementRect: $2N9zU.observeElementRect,
        observeElementOffset: $2N9zU.observeElementOffset,
        scrollToFn: (0, $2N9zU.elementScroll),
        ...options
    });
}
function $49b294a7a914c493$export$645722dcac657cb9(options) {
    return $49b294a7a914c493$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $2N9zU.observeWindowRect),
        observeElementOffset: (0, $2N9zU.observeWindowOffset),
        scrollToFn: (0, $2N9zU.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("2N9zU", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $20879669f8b1eab4$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $20879669f8b1eab4$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $20879669f8b1eab4$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $20879669f8b1eab4$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $20879669f8b1eab4$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $20879669f8b1eab4$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $20879669f8b1eab4$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("5oCQ9")).notUndefined);

var $5oCQ9 = parcelRequire("5oCQ9");
const $20879669f8b1eab4$export$76974b428a49f15b = (index)=>index;
const $20879669f8b1eab4$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $20879669f8b1eab4$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $20879669f8b1eab4$var$addEventListenerOptions = {
    passive: true
};
const $20879669f8b1eab4$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $20879669f8b1eab4$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $20879669f8b1eab4$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $20879669f8b1eab4$var$supportsScrollend ? ()=>void 0 : (0, $5oCQ9.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $20879669f8b1eab4$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $20879669f8b1eab4$var$supportsScrollend ? ()=>void 0 : (0, $5oCQ9.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $20879669f8b1eab4$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $20879669f8b1eab4$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $20879669f8b1eab4$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $20879669f8b1eab4$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $20879669f8b1eab4$export$76974b428a49f15b,
                rangeExtractor: $20879669f8b1eab4$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $20879669f8b1eab4$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $5oCQ9.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $5oCQ9.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $5oCQ9.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $5oCQ9.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $20879669f8b1eab4$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $5oCQ9.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $5oCQ9.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $5oCQ9.notUndefined)(measurements[$20879669f8b1eab4$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $5oCQ9.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $5oCQ9.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $5oCQ9.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $20879669f8b1eab4$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $20879669f8b1eab4$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $20879669f8b1eab4$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("5oCQ9", function(module, exports) {

$parcel$export(module.exports, "memo", () => $3edd5277c0f8707b$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $3edd5277c0f8707b$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $3edd5277c0f8707b$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $3edd5277c0f8707b$export$61fc7d43ac8f84b0);
function $3edd5277c0f8707b$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $3edd5277c0f8707b$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $3edd5277c0f8707b$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $3edd5277c0f8707b$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("bmsPo", function(module, exports) {

$parcel$export(module.exports, "useVirtualisedActions", () => $333854ad01b5b46b$export$affb102126dcde2a);
$parcel$export(module.exports, "useVirtualisedItems", () => $333854ad01b5b46b$export$a4da365e237701e3);
$parcel$export(module.exports, "VirtualiseProviderSweetState", () => $333854ad01b5b46b$export$6754b86f75c8ce1a);

var $WBLbN = parcelRequire("WBLbN");

var $gf0vG = parcelRequire("gf0vG");

var $gXVpd = parcelRequire("gXVpd");

var $5spST = parcelRequire("5spST");

var $02RQg = parcelRequire("02RQg");
const $333854ad01b5b46b$var$store = (0, $WBLbN.createStore)({
    initialState: (0, $5spST.DEFAULT_VALUE),
    actions: (0, $gXVpd.virtualiserActions),
    name: 'timeline-table.virtualise'
});
const $333854ad01b5b46b$export$affb102126dcde2a = (0, $WBLbN.createHook)($333854ad01b5b46b$var$store, {
    selector: null
});
const $333854ad01b5b46b$export$a4da365e237701e3 = (0, $WBLbN.createHook)($333854ad01b5b46b$var$store, {
    selector: (0, $02RQg.getVirtualisedItems)
});
const $333854ad01b5b46b$export$34f4621b58d3fbc8 = ()=>({ dispatch: dispatch }, { itemHeights: itemHeights, isEnabled: isEnabled })=>{
        if (isEnabled) {
            // Set a reasonable default value for items components before useVirtual hook produces meta data
            const fallbackItemsCount = Math.round(window.innerHeight / (0, $gf0vG.DEFAULT_ITEM_HEIGHT));
            const fallbackEnd = Math.min(itemHeights.length - 1, fallbackItemsCount);
            dispatch((0, $gXVpd.virtualiserActions).generateVirtualMeta(0, fallbackEnd));
        } else dispatch((0, $gXVpd.virtualiserActions).generateVirtualMeta(0, itemHeights.length - 1));
    };
const $333854ad01b5b46b$export$ab8f0de40a3a2d2d = ()=>({ dispatch: dispatch }, { itemHeights: itemHeights, isEnabled: isEnabled })=>{
        /**
		 * Update the virtualised meta data When the items are updated when virtualisation is disabled.
		 * This step is not required when virtualisation is enabled because useVirtual handles that.
		 */ if (!isEnabled) dispatch((0, $gXVpd.virtualiserActions).generateVirtualMeta(0, itemHeights.length - 1));
    };
const $333854ad01b5b46b$export$6754b86f75c8ce1a = (0, $WBLbN.createContainer)($333854ad01b5b46b$var$store, {
    onInit: $333854ad01b5b46b$export$34f4621b58d3fbc8,
    onUpdate: $333854ad01b5b46b$export$ab8f0de40a3a2d2d
});

});
parcelRegister("gXVpd", function(module, exports) {

$parcel$export(module.exports, "virtualiserActions", () => $2fcc15370fc6853a$export$e8a8e63a5a7f1929);

var $5spST = parcelRequire("5spST");
const $2fcc15370fc6853a$export$e8a8e63a5a7f1929 = {
    generateVirtualMeta: $5spST.generateVirtualMeta
};

});
parcelRegister("5spST", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VALUE", () => $285b02195cb12660$export$66a151256d4631f5);
$parcel$export(module.exports, "generateVirtualMeta", () => $285b02195cb12660$export$ac5dd8f3ecc3f3f9);


var $iulwX = parcelRequire("iulwX");
const $285b02195cb12660$export$66a151256d4631f5 = {
    overscan: (0, $2cdd987d900949d8$export$def0e365218ffa1e),
    requiredItems: [],
    overscanRange: {
        start: 0,
        end: 0
    }
};
const $285b02195cb12660$export$ac5dd8f3ecc3f3f9 = (startIndex, endIndex)=>({ setState: setState }, { createItemIndex: createItemIndex, itemHeights: itemHeights, items: items })=>{
        if (startIndex !== undefined && endIndex !== undefined) {
            const virtualMeta = (0, $iulwX.getVisibleItemsFromIndexes)({
                createItemIndex: createItemIndex,
                itemHeights: itemHeights,
                startIndex: startIndex,
                endIndex: endIndex,
                items: items
            });
            setState(virtualMeta);
        } else setState($285b02195cb12660$export$66a151256d4631f5);
    };

});
const $2cdd987d900949d8$export$793ed84f5e13fedc = 'TOP';
const $2cdd987d900949d8$export$84e1549b474f1b93 = 'BOTTOM';
const $2cdd987d900949d8$export$def0e365218ffa1e = 5;

parcelRegister("iulwX", function(module, exports) {

$parcel$export(module.exports, "getVisibleItemsFromIndexes", () => $61003e8553e9916f$export$aefb967ef9d43391);

var $5iWql = parcelRequire("5iWql");

var $gf0vG = parcelRequire("gf0vG");

const $61003e8553e9916f$var$getAccumulateHeight = (0, $5iWql.default)((itemHeights)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    itemHeights.reduce((acc, current, index)=>{
        acc.push(current + (index > 0 ? acc[index - 1] : 0));
        return acc;
    }, []));
const $61003e8553e9916f$export$b55fce277fa0884f = (startIndex, endIndex, itemHeights)=>{
    if (endIndex <= startIndex) return 0;
    const accumHeight = $61003e8553e9916f$var$getAccumulateHeight(itemHeights);
    return accumHeight[endIndex - 1] - (startIndex === 0 ? 0 : accumHeight[startIndex - 1]);
};
const $61003e8553e9916f$export$1101758ce03ba6b1 = (index, itemHeights, start, end)=>{
    // Get row height for the items before index
    const before = $61003e8553e9916f$export$b55fce277fa0884f(start, index, itemHeights);
    const after = $61003e8553e9916f$export$b55fce277fa0884f(index + 1, end, itemHeights);
    return {
        before: before,
        after: after
    };
};
const $61003e8553e9916f$export$c6fd3ab3f44300d0 = (items, item)=>{
    const ancestors = [];
    if (item) {
        let currentParentId = item.meta.parentId;
        const startingIndex = item.flatIndex - 1;
        // we can iterate through the earlier objects to find all the ancestors
        for(let i = startingIndex; i >= 0 && currentParentId; i--){
            // had to introduce this 'currentItem' variable here to overcome typescript error
            const currentItem = items[i];
            if (currentItem.type === (0, $gf0vG.ITEM_TYPE) && currentItem.item.id === currentParentId) {
                ancestors.push(currentItem);
                currentParentId = items[i].meta.parentId;
            }
        }
    }
    return ancestors.reverse();
};
const $61003e8553e9916f$export$7adcff1c9f66e792 = (items, createItemIndex)=>{
    const createItem = items[createItemIndex];
    if (createItem === undefined || createItem.type !== (0, $gf0vG.CREATE_ITEM_TYPE)) return undefined;
    return createItem;
};
const $61003e8553e9916f$export$aefb967ef9d43391 = ({ startIndex: startIndex, endIndex: endIndex, itemHeights: itemHeights, createItemIndex: createItemIndex, items: items, overscan: overscan = (0, $2cdd987d900949d8$export$def0e365218ffa1e) })=>{
    // Overscan indexes
    const totalCount = itemHeights.length;
    const overscanStart = Math.max(startIndex - overscan, 0);
    const overscanEnd = Math.min(endIndex + overscan, totalCount - 1);
    let createPosition;
    // Check if create-item is rendered before visible items
    if (createItemIndex > -1 && createItemIndex < overscanStart) createPosition = (0, $2cdd987d900949d8$export$793ed84f5e13fedc);
    else if (createItemIndex > overscanEnd) createPosition = (0, $2cdd987d900949d8$export$84e1549b474f1b93);
    const createItem = $61003e8553e9916f$export$7adcff1c9f66e792(items, createItemIndex);
    // the ancestors of the first visible item are invisible.
    // this is needed to make sure all the children of the invisible ancestors are rendered
    const invisibleAncestors = $61003e8553e9916f$export$c6fd3ab3f44300d0(items, items[overscanStart]);
    // we need to keep the createItem and its ancestors always in the rendered list
    // this is to prevent the createItem from being rendered when it enters in the visible range
    // If we render the createItem everytime by scrolling,
    // it will cause a scroll jump to the createItem input fields which is a bad user xp
    // so, we keep it always rendered to stop this scroll jump
    // if the createItem is in the visible range, its parents are included in invisibleAncestors,
    // otherwise we should double-check the createItemAncestors
    const createItemAncestors = createPosition && createItem ? $61003e8553e9916f$export$c6fd3ab3f44300d0(items, createItem) : [];
    const requiredItems = items.filter((item, index)=>index >= overscanStart && index <= overscanEnd || // we need to keep the createItem always in the rendered list
        index === createItemIndex || // to fix type error
        item.type === (0, $gf0vG.ITEM_TYPE) && // we need to render the create item if it is active, even it is beyond the visible items
        (createItemAncestors?.includes(item) || // the invisible ancestors are needed for their children to get rendered
        invisibleAncestors?.includes(item)));
    return {
        requiredItems: requiredItems,
        overscanRange: {
            start: overscanStart,
            end: overscanEnd
        },
        overscan: overscan
    };
};

});



parcelRegister("02RQg", function(module, exports) {

$parcel$export(module.exports, "getVirtualisedItems", () => $4c8db53a14d64a4f$export$fab83018e0db4fa8);
const $4c8db53a14d64a4f$export$fab83018e0db4fa8 = (state)=>state;

});


parcelRegister("2eorI", function(module, exports) {

$parcel$export(module.exports, "getItemHeights", () => $80e5679b4cb84d23$export$b0c1b33ea0acf206);

var $gf0vG = parcelRequire("gf0vG");
const $80e5679b4cb84d23$export$b0c1b33ea0acf206 = (items, itemHeight)=>items.map((item)=>{
        const depth = item.type === (0, $gf0vG.ITEM_TYPE) && item?.item?.depth;
        // depth shouldn't be undefined
        if (item.type === (0, $gf0vG.ITEM_TYPE) && depth === 0) return itemHeight;
        if (item.type === (0, $gf0vG.CREATE_ITEM_TYPE)) return itemHeight;
        return 0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT;
    });

});


parcelRegister("8ftWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0367e82596afd4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $eI5EY = parcelRequire("eI5EY");

var $jK1pm = parcelRequire("jK1pm");

var $lnM6x = parcelRequire("lnM6x");

var $9WNLk = parcelRequire("9WNLk");

var $lSR7G = parcelRequire("lSR7G");

var $eKKjG = parcelRequire("eKKjG");

var $ccgw3 = parcelRequire("ccgw3");

var $agwqh = parcelRequire("agwqh");

var $6N43q = parcelRequire("6N43q");

var $lSZKO = parcelRequire("lSZKO");

var $f3dMv = parcelRequire("f3dMv");

var $hkIxH = parcelRequire("hkIxH");

var $dG2Eg = parcelRequire("dG2Eg");

var $l4yFR = parcelRequire("l4yFR");

var $8uivF = parcelRequire("8uivF");

var $a3v1C = parcelRequire("a3v1C");

var $dAVGZ = parcelRequire("dAVGZ");

var $htzwR = parcelRequire("htzwR");
const $6d0367e82596afd4$var$contentContainerStyles = null;
const $6d0367e82596afd4$var$Content = ({ isResizeEnabled: isResizeEnabled, DndLongTaskMetric: DndLongTaskMetric, onItemDrop: onItemDrop, onItemSelect: onItemSelect, onItemExpandChanged: onItemExpandChanged, onCreateClick: onCreateClick, onSetListWidth: onSetListWidth, onContentResize: onContentResize, renderListEmptyContent: renderListEmptyContent, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemCreate: renderListItemCreate, renderChartItemContent: renderChartItemContent, renderChartTimelineOverlay: renderChartTimelineOverlay, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal })=>{
    const contentContainerRef = (0, $eUqFw.useRef)(null);
    const [{ isDragEnabled: isDragEnabled, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isCreateChildEnabled: isCreateChildEnabled, isMeatballsButtonEnabled: isMeatballsButtonEnabled }] = (0, $9WNLk.useEnablements)();
    const [createItemAnchor] = (0, $lSR7G.useCreateItemAnchor)();
    const [itemHeight] = (0, $lSR7G.useItemHeight)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Remove this with project_timeline_multi-select_and_checkboxes
    const onSelect = (0, $eUqFw.useCallback)((id, payload)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'listItem',
            actionSubjectId: 'issueListItem',
            attributes: payload
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        onItemSelect(id, payload, analyticsEvent);
    }, [
        onItemSelect,
        createAnalyticsEvent
    ]);
    const onExpandChanged = (0, $eUqFw.useCallback)((id, isItemExpanded)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'expansionStateChanged',
            actionSubject: 'listItem',
            actionSubjectId: 'issueListItem',
            attributes: {
                type: isItemExpanded ? 'collapsed' : 'expanded'
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        onItemExpandChanged(id, isItemExpanded);
    }, [
        onItemExpandChanged,
        createAnalyticsEvent
    ]);
    const onDrop = (0, $eUqFw.useCallback)((id, payload)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragEnded',
            actionSubject: 'listItem',
            actionSubjectId: 'issueListItem',
            attributes: {
                level: payload.level,
                isReparent: Boolean(payload.parentId),
                ...(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? {
                    isMeatballsAction: payload.isMeatballsAction
                } : {}
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        onItemDrop(id, payload, analyticsEvent);
    }, [
        onItemDrop,
        createAnalyticsEvent
    ]);
    const renderCreateItem = (id, anchorItem, { level: level, depth: depth = 0, backgroundColor: backgroundColor, isActive: isActive, ariaRowIndex: ariaRowIndex, topOffset: topOffset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hkIxH.default), {
            key: id,
            id: id,
            level: level,
            canCreateChildOverride: Boolean(anchorItem?.canCreateChildOverride),
            depth: depth,
            anchorId: anchorItem?.id,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            isActive: isActive,
            ariaRowIndex: ariaRowIndex,
            topOffset: topOffset,
            onCreateClick: onCreateClick,
            renderListItemCreate: renderListItemCreate
        });
    const renderItem = ({ id: id, level: level, isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, depth: depth = 0 }, { parentId: parentId, backgroundColor: backgroundColor, isParent: isParent, isExpanded: isExpanded, ariaControls: ariaControls }, index, isVirtual = false)=>{
        if (isVirtual) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uivF.default), {
            key: `list-item-lite-${id}`,
            id: id,
            depth: depth,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            renderListItemContent: renderListItemContent,
            renderListItemSecondaryContent: renderListItemSecondaryContent
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6N43q.default), {
            id: id,
            key: `chart-item-lite-${id}`,
            depth: depth,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            renderChartItemContent: renderChartItemContent
        }));
        const canCreateChild = (0, $htzwR.canItemCreateChild)({
            id: id,
            createItemAnchor: createItemAnchor,
            isInTransition: isInTransition,
            isCreateChildEnabled: isCreateChildEnabled,
            canCreateChildOverride: canCreateChildOverride
        });
        const canCreateSibling = (0, $htzwR.canItemCreateSibling)({
            id: id,
            index: index,
            depth: depth,
            createItemAnchor: createItemAnchor,
            isInTransition: isInTransition,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3v1C.default), {
            ariaControls: ariaControls,
            key: `list-item-${id}`,
            id: id,
            parentId: parentId,
            level: level,
            depth: depth,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            isParent: isParent,
            isExpanded: isExpanded,
            isDragEnabled: isDragEnabled,
            isInTransition: isInTransition,
            isSelectEnabled: isSelectEnabled,
            isMultiSelectEnabled: isMultiSelectEnabled,
            isCreateChildEnabled: canCreateChild,
            isCreateSiblingEnabled: canCreateSibling,
            isMeatballsButtonEnabled: isMeatballsButtonEnabled,
            onSelect: onSelect,
            onDrop: onDrop,
            onExpandChanged: onExpandChanged,
            onInlineCreateClicked: onCreateClick,
            renderListItemContent: renderListItemContent,
            renderListItemSecondaryContent: renderListItemSecondaryContent,
            renderListItemMenuOption: renderListItemMenuOption,
            renderListItemModal: renderListItemModal
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSZKO.default), {
            id: id,
            key: `chart-item-${id}`,
            depth: depth,
            parentId: parentId,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            renderChartItemContent: renderChartItemContent
        }));
    };
    const renderItemContainer = ({ parentId: parentId, isExpanded: isExpanded, isParent: isParent, id: id, level: level, depth: depth = 0, topOffset: topOffset, ariaRowIndex: ariaRowIndex, childItemsHeight: childItemsHeight, isInTransition: isInTransition }, _, children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dG2Eg.default), {
            id: id,
            key: `drop-target-${id}`,
            ariaRowIndex: ariaRowIndex,
            topOffset: topOffset,
            level: level,
            depth: depth,
            parentId: parentId,
            isExpanded: isExpanded,
            isParent: isParent,
            itemHeight: itemHeight,
            childItemsHeight: childItemsHeight,
            isInTransition: isInTransition,
            onDrop: onDrop,
            onExpandChanged: onExpandChanged
        }, children);
    (0, $ccgw3.useResizeObserver)(contentContainerRef.current, onContentResize);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "timeline-table-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "rowgroup",
        ref: contentContainerRef,
        className: (0, $7JEyt.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f3dMv.ItemsBackground), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lnM6x.default), {
        renderItem: renderItem,
        renderItemContainer: renderItemContainer,
        renderCreateItem: renderCreateItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4yFR.default), {
        renderListEmptyContent: renderListEmptyContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agwqh.default), {
        renderChartTimelineOverlay: renderChartTimelineOverlay
    }), isResizeEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAVGZ.default), {
        DndLongTaskMetric: DndLongTaskMetric,
        onSetListWidth: onSetListWidth
    }));
};
$6d0367e82596afd4$var$Content.defaultProps = {
    isResizeEnabled: true,
    onItemDrop: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemExpandChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCreateClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onSetListWidth: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onContentResize: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
$6d0367e82596afd4$var$Content.displayName = 'Content';
$6d0367e82596afd4$var$Content.whyDidYouRender = true;
var $6d0367e82596afd4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6d0367e82596afd4$var$Content);

});
parcelRegister("lnM6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d6d314a1e882138$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $gf0vG = parcelRequire("gf0vG");

var $lSR7G = parcelRequire("lSR7G");

var $bmsPo = parcelRequire("bmsPo");
const $3d6d314a1e882138$var$ItemsRenderer = ({ renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
    const [virtualisedData] = (0, $bmsPo.useVirtualisedItems)();
    const createItemAnchorIndex = (0, $lSR7G.useCreateItemAnchorIndex)();
    const { requiredItems: requiredItems = [], overscanRange: overscanRange } = virtualisedData;
    /* If the item is beyond the visible and overscan range, then it's not visible.
	 * Unless it's the anchor for a create item, we need the "full" version to refocus for a11y
	 */ const getIsVirtual = (flatIndex)=>(flatIndex < overscanRange.start || flatIndex > overscanRange.end) && flatIndex !== createItemAnchorIndex;
    // if the item is beyond the visible and overscan range, then it's not visible
    const getIsVirtualOld = (flatIndex)=>flatIndex < overscanRange.start || flatIndex > overscanRange.end;
    const renderedItems = $3d6d314a1e882138$var$renderList({
        items: requiredItems,
        getIsVirtual: (0, $eI5EY.fg)('timeline_grid_navigation_m2') ? getIsVirtual : getIsVirtualOld,
        parentItem: undefined,
        renderItem: renderItem,
        renderItemContainer: renderItemContainer,
        renderCreateItem: renderCreateItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderedItems);
};
const $3d6d314a1e882138$var$renderList = ({ items: items, getIsVirtual: getIsVirtual, parentItem: parentItem, renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
    // Start iterate flat items
    const flatItemElements = [];
    const getItemsToRender = (parentFlatItem, flatItems)=>{
        if (parentFlatItem === undefined) return flatItems.filter(({ meta: meta })=>!meta.parentId);
        return flatItems.filter(({ meta: meta })=>meta.parentId === parentFlatItem.item.id);
    };
    const itemsToRender = getItemsToRender(parentItem, items);
    // Generate items
    itemsToRender?.forEach((enrichedItem)=>{
        if (enrichedItem.type === (0, $gf0vG.ITEM_TYPE)) {
            const itemContainerChildren = [];
            const { item: item, meta: meta, flatIndex: flatIndex } = enrichedItem;
            // If it is an invisible sibling or ancestor we render it as virtual,
            itemContainerChildren.push(renderItem(item, meta, flatIndex, getIsVirtual(flatIndex)));
            const { isExpanded: isExpanded, isParent: isParent, numChildren: numChildren = 0, ariaRowIndex: ariaRowIndex, topOffset: topOffset, childItemsHeight: childItemsHeight } = meta;
            const parentItemContainerMeta = {
                parentId: parentItem?.item.id,
                isExpanded: isExpanded,
                isParent: isParent,
                id: item.id,
                level: item.level,
                depth: item.depth,
                ariaRowIndex: ariaRowIndex,
                topOffset: topOffset,
                childItemsHeight: childItemsHeight,
                isInTransition: item.isInTransition
            };
            flatItemElements.push(renderItemContainer(parentItemContainerMeta, 0, itemContainerChildren));
            if (isExpanded && numChildren > 0) {
                const renderedChildItems = $3d6d314a1e882138$var$renderList({
                    items: items,
                    getIsVirtual: getIsVirtual,
                    parentItem: enrichedItem,
                    renderItem: renderItem,
                    renderItemContainer: renderItemContainer,
                    renderCreateItem: renderCreateItem
                });
                flatItemElements.push(...renderedChildItems);
            }
        } else if (enrichedItem.type === (0, $gf0vG.CREATE_ITEM_TYPE)) // Render visible create item
        flatItemElements.push(renderCreateItem(enrichedItem.id, enrichedItem.anchorItem, enrichedItem.meta));
    });
    return flatItemElements;
};
var $3d6d314a1e882138$export$2e2bcd8739ae039 = $3d6d314a1e882138$var$ItemsRenderer;

});

parcelRegister("agwqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d439ece8f8255508$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9WNLk = parcelRequire("9WNLk");

var $VrUCp = parcelRequire("VrUCp");

var $3XwA1 = parcelRequire("3XwA1");

var $dm0Lt = parcelRequire("dm0Lt");

var $daOnD = parcelRequire("daOnD");

var $hajSy = parcelRequire("hajSy");
const $d439ece8f8255508$var$containerStyles = null;
const $d439ece8f8255508$var$chartContainerStyles = null;
const $d439ece8f8255508$var$ScrollableOverlay = ({ isOverlayInHeader: isOverlayInHeader, renderChartTimelineOverlay: renderChartTimelineOverlay })=>{
    const columnsOverlayElementsRef = (0, $eUqFw.useRef)({});
    const [{ today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const [{ isHighlightToday: isHighlightToday }] = (0, $9WNLk.useEnablements)();
    // NOTE: Optimisation! There are enough columns that caching the generated elements is worth it.
    if (!columnsOverlayElementsRef.current[timelineMode]) columnsOverlayElementsRef.current[timelineMode] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dm0Lt.default), {
        isHighlightToday: isHighlightToday,
        today: today,
        timelineDuration: timelineDuration,
        columnDurations: columnDurations
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daOnD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...isOverlayInHeader ? {
                position: 'sticky',
                top: 0
            } : {
                position: 'relative',
                top: `${headerHeight}px`,
                height: `calc(100% - ${headerHeight}px)`
            },
            width: `${timelineWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug"
        ])
    }, columnsOverlayElementsRef.current[timelineMode], !isOverlayInHeader && renderChartTimelineOverlay(), !isOverlayInHeader && isHighlightToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hajSy.default), {
        today: today,
        timelineMode: timelineMode,
        timelineDuration: timelineDuration
    })));
};
var $d439ece8f8255508$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d439ece8f8255508$var$ScrollableOverlay);

});
parcelRegister("dm0Lt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b8503552a2b5515$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l2CBN = parcelRequire("l2CBN");

var $b1n3v = parcelRequire("b1n3v");
const $5b8503552a2b5515$var$ColumnsOverlay = ({ isHighlightToday: isHighlightToday, today: today, timelineDuration: timelineDuration, columnDurations: columnDurations })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1n3v.default), {
        isHighlightToday: isHighlightToday,
        columnPositions: (0, $l2CBN.getColumnPositions)(timelineDuration, columnDurations),
        todayColumnIndex: (0, $l2CBN.getTodayColumnIndex)(today, columnDurations)
    });
var $5b8503552a2b5515$export$2e2bcd8739ae039 = $5b8503552a2b5515$var$ColumnsOverlay;

});
parcelRegister("b1n3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f2d4f3b5e63737$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $dWSuJ = parcelRequire("dWSuJ");
const $47f2d4f3b5e63737$var$containerStyles = null;
const $47f2d4f3b5e63737$var$columnStyles = null;
const $47f2d4f3b5e63737$var$todayColumnStyles = null;
const $47f2d4f3b5e63737$var$Columns = ({ isHighlightToday: isHighlightToday, todayColumnIndex: todayColumnIndex, columnPositions: columnPositions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _154iidpf _1bsb1osq _4t3i1osq _lcxvglyw"
        ])
    }, columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: `column-position-${index}`,
            className: (0, $7JEyt.default)([
                "_kqswstnw _vchhusvi _16jlidpf _1o9zidpf _i0dl1wug _154iidpf _94n5idpf _1s7z1hum"
            ]),
            style: {
                left: `${left}%`,
                right: `${right}%`,
                "--_1p5ufam": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorder))
            }
        }, todayColumnIndex === index && isHighlightToday ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_kqswstnw _vchhusvi _154iidpf _1xi21n1a _1ltv1n1a _4t3i1osq _bfhkiw92 _1kl71xde _1s7z1xde"
            ])
        }) : null)));
var $47f2d4f3b5e63737$export$2e2bcd8739ae039 = $47f2d4f3b5e63737$var$Columns;

});
parcelRegister("dWSuJ", function(module, exports) {

$parcel$export(module.exports, "secondaryBorderColor", () => $6d8ea27a206d991f$export$95d9e829dbec7e8b);
$parcel$export(module.exports, "secondaryBorder", () => $6d8ea27a206d991f$export$a84a730095edc78);

const $6d8ea27a206d991f$export$12879c7697ed953d = 1;
const $6d8ea27a206d991f$export$95d9e829dbec7e8b = `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`;
const $6d8ea27a206d991f$export$a84a730095edc78 = `${$6d8ea27a206d991f$export$12879c7697ed953d}px solid ${$6d8ea27a206d991f$export$95d9e829dbec7e8b}`;
const $6d8ea27a206d991f$export$d1cf5418fbd2830d = 'background-color 100ms linear';

});



parcelRegister("daOnD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c52642cbcc28bb6d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $nH3p1 = parcelRequire("nH3p1");
// NOTE: The scrollable overlay for content will extend to be outside the content container when items are filtered
// The styling here covers the scrollable overlay (e.g. columns overlay, today marker, etc.) when it goes beneath the list part (e.g. scrolling or virtualisation)
const $c52642cbcc28bb6d$var$containerStyles = null;
const $c52642cbcc28bb6d$var$ListCover = ()=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${listWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _11q7vuon _1pby37uc"
        ])
    });
};
var $c52642cbcc28bb6d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c52642cbcc28bb6d$var$ListCover);

});

parcelRegister("hajSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $92c8d18545bff169$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1QJt8 = parcelRequire("1QJt8");

var $6Bu0e = parcelRequire("6Bu0e");

var $lmTNg = parcelRequire("lmTNg");
const $92c8d18545bff169$var$TodayMarker = ({ today: today, timelineMode: timelineMode, timelineDuration: timelineDuration })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmTNg.default), {
        todayPosition: (0, $6Bu0e.getTodayPosition)(today, timelineDuration, (0, $1QJt8.getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds))
    });
var $92c8d18545bff169$export$2e2bcd8739ae039 = $92c8d18545bff169$var$TodayMarker;

});
parcelRegister("6Bu0e", function(module, exports) {

$parcel$export(module.exports, "getTodayPosition", () => $b56fa76d5d9318b3$export$1c4a20ec05eb2ad0);
// eslint-disable-next-line jira/restricted/moment

var $jJwwt = parcelRequire("jJwwt");
const $b56fa76d5d9318b3$export$1c4a20ec05eb2ad0 = (today, timelineDuration, timelineWidth)=>{
    // We want to present "today" as the middle of the day.
    const middleOfToday = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).add(12, 'hour').valueOf();
    const relativePosition = (middleOfToday - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds;
    /* Some number magic.
	 * -1 to offset for the width of the today marker.
	 * -1 to offset for the visual weight of the column right border
	 */ return relativePosition * timelineWidth - 2;
};

});

parcelRegister("lmTNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b567ebaf80764d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $VrUCp = parcelRequire("VrUCp");
const $75b567ebaf80764d$var$MARKER_LINE_WIDTH = 2;
const $75b567ebaf80764d$var$POINTER_WIDTH = 4;
const $75b567ebaf80764d$var$containerStyles = null;
const $75b567ebaf80764d$var$markerStyles = null;
const $75b567ebaf80764d$var$pointerStyles = null;
const $75b567ebaf80764d$var$TodayMarkerLine = ({ todayPosition: todayPosition })=>{
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.scrollable-overlay.today-marker.container",
        style: {
            left: `${todayPosition}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1pbyouyt _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsbyh40 _4t3i1osq _bfhk1sn9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            top: `${headerHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1bsbidpf _4t3iidpf _18u0j39m _x3dom65w _1s7z12me _1kl712me"
        ])
    })));
};
var $75b567ebaf80764d$export$2e2bcd8739ae039 = $75b567ebaf80764d$var$TodayMarkerLine;

});



parcelRegister("6N43q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee99853e2a8e5c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $3XwA1 = parcelRequire("3XwA1");

var $22Yy6 = parcelRequire("22Yy6");
/* A non interactive version of the chart-item with lightweight styles.
 * Leveraged during virtualisation to improve scroll performance.
 */ const $2ee99853e2a8e5c7$var$ChartItemLite = ({ id: id, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderChartItemContent: renderChartItemContent })=>{
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: true,
        isHovered: false
    };
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const height = (0, $22Yy6.getContainerHeight)({
        itemHeight: itemHeight,
        depth: depth
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "gridcell",
        tabIndex: -1,
        xcss: $2ee99853e2a8e5c7$var$chartItemLiteContainerStyles,
        style: {
            width: `${timelineWidth}px`,
            height: height,
            backgroundColor: backgroundColor
        }
    }, renderChartItemContent(rendererProps, rendererState));
};
const $2ee99853e2a8e5c7$var$chartItemLiteContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden'
});
var $2ee99853e2a8e5c7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2ee99853e2a8e5c7$var$ChartItemLite);

});
parcelRegister("22Yy6", function(module, exports) {

$parcel$export(module.exports, "getContainerHeight", () => $3cf25319336ca480$export$cf6292b4985d86a5);
const $3cf25319336ca480$export$cf6292b4985d86a5 = ({ itemHeight: itemHeight, depth: depth })=>{
    const height = depth > 0 ? "var(--ds-space-400, 32px)" : `${itemHeight}px`;
    return height;
};

});


parcelRegister("lSZKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdf41337f165301$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $eI5EY = parcelRequire("eI5EY");

var $gf0vG = parcelRequire("gf0vG");

var $bwj1b = parcelRequire("bwj1b");

var $cUFbE = parcelRequire("cUFbE");

var $fTs8H = parcelRequire("fTs8H");

var $3XwA1 = parcelRequire("3XwA1");

var $kadaD = parcelRequire("kadaD");

var $22Yy6 = parcelRequire("22Yy6");
const $0bdf41337f165301$var$itemBaseStyles = null;
const $0bdf41337f165301$var$chartItemContainer = null;
const $0bdf41337f165301$var$ChartItem = ({ id: id, parentId: parentId, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderChartItemContent: renderChartItemContent })=>{
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave } = (0, $bwj1b.useSideEffectMarshal)();
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const cellRef = (0, $cUFbE.useGridCell)(id, (0, $gf0vG.CHART_COLUMN_COORDINATE));
    let onCellKeyDown;
    if ((0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) {
        /* eslint-disable react-hooks/rules-of-hooks */ const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
        const { handleKeyDown: handleKeyDown } = (0, $kadaD.useItemSelect)(id);
        onCellKeyDown = (0, $eUqFw.useCallback)((event)=>{
            // Handle key events on the container only (not bubbled ones)
            if (event.target === event.currentTarget) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'keydown',
                    actionSubject: 'chartItem',
                    actionSubjectId: 'issueChartItem'
                });
                handleKeyDown(event, analyticsEvent);
            }
        }, [
            createAnalyticsEvent,
            handleKeyDown
        ]);
    /* eslint-enable react-hooks/rules-of-hooks */ }
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        onRowMouseEnter(id);
        setIsHovered(true);
    }, [
        id,
        onRowMouseEnter
    ]);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>{
        onRowMouseLeave(id);
        setIsHovered(false);
    }, [
        id,
        onRowMouseLeave
    ]);
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: false,
        isHovered: isHovered
    };
    const height = (0, $22Yy6.getContainerHeight)({
        itemHeight: itemHeight,
        depth: depth
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: cellRef,
        role: "gridcell",
        tabIndex: -1,
        "data-testid": `roadmap.timeline-table.components.chart-item.container-${id}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _v564lfip _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b",
            "_kqswh2mm _1reo15vq _18m915vq",
            (0, $fTs8H.getRowClassName)(id, parentId).className
        ]),
        style: {
            width: `${timelineWidth}px`,
            height: `${height}`,
            backgroundColor: backgroundColor
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onKeyDown: onCellKeyDown,
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-row-highlight-bar-focus') ? {
            onFocus: onMouseEnter,
            onBlur: onMouseLeave
        } : {}
    }, renderChartItemContent(rendererProps, rendererState));
};
$0bdf41337f165301$var$ChartItem.displayName = 'ChartItem';
$0bdf41337f165301$var$ChartItem.whyDidYouRender = true;
var $0bdf41337f165301$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0bdf41337f165301$var$ChartItem);

});
parcelRegister("cUFbE", function(module, exports) {

$parcel$export(module.exports, "useGridCell", () => $0040ae340f12076b$export$c7e10bfc0c59f67c);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $8hFGR = parcelRequire("8hFGR");
const $0040ae340f12076b$export$c7e10bfc0c59f67c = (rowId, column, isOriginCell = false)=>{
    const element = (0, $eUqFw.useRef)(null);
    const { trackCell: trackCell, untrackCell: untrackCell, focusCell: focusCell, blurCell: blurCell, initialiseRovingCell: initialiseRovingCell } = (0, $8hFGR.useFocusMarshal)();
    // Ref callback is more robust for consumers than ref object
    const setCellRef = (0, $eUqFw.useCallback)((ref)=>{
        element.current = ref;
    }, []);
    /* Lazily evaluating the cell co-ordinates helps prevent a series of edge-cases.
	 * Even for the same cell, their coordinates are not static, and depend on user interactions.
	 */ const getData = (0, $eUqFw.useCallback)(()=>({
            rowId: rowId,
            column: column
        }), [
        rowId,
        column
    ]);
    /* Lazily evaluating the interactive cell widgets helps prevent a series of edge-cases.
	 * For example, content being added or removed due to user interactions.
	 */ const getContent = (0, $eUqFw.useCallback)(()=>{
        if (!element.current) return [];
        const keyboardFocusable = element.current.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
        return Array.from(keyboardFocusable).filter((e)=>e instanceof HTMLElement && !e.hasAttribute('disabled'));
    }, []);
    const onFocus = (0, $eUqFw.useCallback)((event)=>{
        if (element.current && event.target instanceof HTMLElement) focusCell(element.current, event.target);
    }, [
        focusCell
    ]);
    const onBlur = (0, $eUqFw.useCallback)((event)=>{
        if (event.target instanceof HTMLElement) blurCell(event.target);
    }, [
        blurCell
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!element.current || !(0, $eI5EY.fg)('timeline_grid_navigation_m2')) return;
        /* useEffect's own cleanup will be called after element.current is already null
		 * This closure provides us access to a valid reference to update the Map
		 */ const setup = (safeElement)=>{
            trackCell(safeElement, getData, getContent);
            isOriginCell && initialiseRovingCell(safeElement);
            safeElement.addEventListener('focusin', onFocus);
            safeElement.addEventListener('focusout', onBlur);
            return ()=>{
                untrackCell(safeElement);
                safeElement.removeEventListener('focusin', onFocus);
                safeElement.removeEventListener('focusout', onBlur);
            };
        };
        const cleanup = setup(element.current);
        return ()=>{
            cleanup();
        };
    }, [
        rowId,
        column,
        isOriginCell,
        getData,
        getContent,
        trackCell,
        untrackCell,
        initialiseRovingCell,
        onFocus,
        onBlur
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!element.current || (0, $eI5EY.fg)('timeline_grid_navigation_m2')) return;
        /* useEffect's own cleanup will be called after element.current is already null
		 * This closure provides us access to a valid reference to update the Map
		 */ const setup = (safeElement)=>{
            trackCell(safeElement, getData, ()=>[]);
            isOriginCell && initialiseRovingCell(safeElement);
            return ()=>untrackCell(safeElement);
        };
        const cleanup = setup(element.current);
        return ()=>{
            cleanup();
        };
    }, [
        rowId,
        column,
        isOriginCell,
        getData,
        trackCell,
        untrackCell,
        initialiseRovingCell
    ]);
    return setCellRef;
};

});

parcelRegister("kadaD", function(module, exports) {

$parcel$export(module.exports, "useItemSelect", () => $c0dc2905f0215c82$export$a7ddc5029ca778e1);

var $eUqFw = parcelRequire("eUqFw");

var $9WNLk = parcelRequire("9WNLk");

var $lSR7G = parcelRequire("lSR7G");
const $c0dc2905f0215c82$export$a7ddc5029ca778e1 = (id)=>{
    const [{ isMultiSelectEnabled: isMultiSelectEnabled, isSelectEnabled: isSelectEnabled }] = (0, $9WNLk.useEnablements)();
    const [selected = false, { toggleItem: toggleItem, activateItem: activateItem }] = (0, $lSR7G.useIsItemSelected)(id);
    const [isItemSelectable = false] = (0, $lSR7G.useIsItemSelectable)(id);
    const handleClick = (0, $eUqFw.useCallback)(({ ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey, currentTarget: currentTarget }, analyticsEvent)=>{
        const isCheckbox = currentTarget instanceof HTMLInputElement && currentTarget.type === 'checkbox';
        // User intention is to toggle the item when it's a checkbox or user using key modifiers
        const shouldOnlyToggleItem = isMultiSelectEnabled && (isCheckbox || ctrlKey || metaKey || shiftKey);
        if (shouldOnlyToggleItem && isItemSelectable) return toggleItem(id, {
            analyticsEvent: analyticsEvent,
            withRange: shiftKey
        });
        if (isSelectEnabled && !shouldOnlyToggleItem) return activateItem(id);
    }, [
        isSelectEnabled,
        isMultiSelectEnabled,
        activateItem,
        id,
        isItemSelectable,
        toggleItem
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)(({ shiftKey: shiftKey, ctrlKey: ctrlKey, metaKey: metaKey, altKey: altKey, key: key }, analyticsEvent)=>{
        if (isMultiSelectEnabled && isItemSelectable && shiftKey && key === ' ' && !/* User may have intension other than toggling the item with these modifiers - we only handle Shift + Space */ (ctrlKey || metaKey || altKey)) toggleItem(id, {
            analyticsEvent: analyticsEvent
        });
    }, [
        id,
        isItemSelectable,
        isMultiSelectEnabled,
        toggleItem
    ]);
    return {
        selectable: isItemSelectable,
        selected: selected,
        handleClick: handleClick,
        handleKeyDown: handleKeyDown
    };
};

});


parcelRegister("f3dMv", function(module, exports) {

$parcel$export(module.exports, "ItemsBackground", () => $6fae78434b3aa5c8$export$2473dc1b5c75a4f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $lSR7G = parcelRequire("lSR7G");

var $nH3p1 = parcelRequire("nH3p1");

var $fTs8H = parcelRequire("fTs8H");
const $6fae78434b3aa5c8$var$container = null;
const $6fae78434b3aa5c8$var$sticky = null;
/**
 * Use "100vw" as the width of the background rather than using the viewport dimension.
 * The accurate dimension does not matter here, as long as it covers the viewport.
 */ const $6fae78434b3aa5c8$var$widthApproximation = null;
/* Generates a complex background that imitates the row structure.
 * This means that when scrolling through the virtual list, a user won't see just
 * empty space even when the browser is struggling to keep up row rendering.
 *
 * WARNING: When the area (w x h) of this background gets too large, it can cause
 * awful bottlenecks in the browser rendering. For that reason, we don't use the
 * full table width, but rather a width just large enough to cover the viewport.
 */ const $6fae78434b3aa5c8$export$2473dc1b5c75a4f = ()=>{
    const [{ itemsBackground: itemsBackground, totalHeight: totalHeight }] = (0, $lSR7G.useItemsContainerStyles)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "presentation",
        style: {
            height: `${totalHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _lcxvglyw",
            (0, $fTs8H.getItemsBackgroundClassName)().className
        ]),
        style: {
            background: itemsBackground,
            width: listWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: (0, $gf0vG.zIndex).LIST
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _lcxvglyw",
            "_1bsbauwl",
            (0, $fTs8H.getItemsBackgroundClassName)().className
        ]),
        style: {
            background: itemsBackground
        }
    }));
};

});

parcelRegister("hkIxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7bf03b0a8ad75d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");


var $3XwA1 = parcelRequire("3XwA1");

var $1sAbG = parcelRequire("1sAbG");

var $8uT0K = parcelRequire("8uT0K");
const $b7bf03b0a8ad75d1$var$itemBaseStyles = null;
const $b7bf03b0a8ad75d1$var$containerStyles = null;
const $b7bf03b0a8ad75d1$var$chartCreateItemStyles = null;
const $b7bf03b0a8ad75d1$var$CreateItem = ({ id: id, level: level, depth: depth, anchorId: anchorId, canCreateChildOverride: canCreateChildOverride, itemHeight: itemHeight, topOffset: topOffset, ariaRowIndex: ariaRowIndex, backgroundColor: backgroundColor, isActive: isActive, onCreateClick: onCreateClick, renderListItemCreate: renderListItemCreate })=>{
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const createItemBackgroundColor = isActive && (0, $1sAbG.isRoot)(depth) ? `var(--ds-surface-pressed, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})` : backgroundColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.content.list.create-item.button",
        role: "row",
        "aria-rowindex": ariaRowIndex,
        style: {
            top: `${topOffset}px`,
            height: `${itemHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _v564lfip",
            "_kqswstnw _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uT0K.default), {
        id: id,
        isActive: isActive,
        anchorId: anchorId,
        canCreateChildOverride: canCreateChildOverride,
        level: level,
        depth: depth,
        itemHeight: itemHeight,
        backgroundColor: backgroundColor,
        onCreateClick: onCreateClick,
        renderListItemCreate: renderListItemCreate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${timelineWidth}px`,
            height: `${itemHeight}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: createItemBackgroundColor
        },
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlidpf _1o9zidpf _i0dl1wug"
        ])
    }));
};
var $b7bf03b0a8ad75d1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b7bf03b0a8ad75d1$var$CreateItem);

});
parcelRegister("8uT0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $2743d2c7621dfa9d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");


var $eI5EY = parcelRequire("eI5EY");

var $75e8i = parcelRequire("75e8i");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");

var $lSR7G = parcelRequire("lSR7G");

var $nH3p1 = parcelRequire("nH3p1");

var $cUFbE = parcelRequire("cUFbE");

var $kmplh = parcelRequire("kmplh");

var $eKKjG = parcelRequire("eKKjG");

var $1sAbG = parcelRequire("1sAbG");
const $2743d2c7621dfa9d$var$listCreateItemCellStyles = null;
const $2743d2c7621dfa9d$var$ListCreateItem = ({ id: id, isActive: isActive, anchorId: anchorId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, onCreateClick: onCreateClick, renderListItemCreate: renderListItemCreate, canCreateChildOverride: canCreateChildOverride })=>{
    let isMultiSelectEnabled;
    if ((0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, $9WNLk.useEnablements)();
    const [isListEmpty] = (0, $lSR7G.useIsTableEmpty)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cellRef = (0, $cUFbE.useGridCell)(id, (0, $gf0vG.LIST_COLUMN_COORDINATE));
    // If there are no items, we want to promote users to create one.
    (0, $eUqFw.useEffect)(()=>{
        if (isListEmpty) onCreateClick({
            position: (0, $gf0vG.LAST)
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const onClick = (0, $eUqFw.useCallback)(()=>{
        (0, $75e8i.default)('timeline-add-item-clicked');
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'issueCreateButton',
            attributes: {
                position: (0, $gf0vG.LAST)
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        onCreateClick({
            position: (0, $gf0vG.LAST)
        });
    }, [
        onCreateClick,
        createAnalyticsEvent
    ]);
    const createItemBackgroundColor = isActive && (0, $1sAbG.isRoot)(depth) ? `var(--ds-surface-pressed, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})` : backgroundColor;
    const paddingLeftStyle = !(0, $1sAbG.isRoot)(depth) ? {
        paddingLeft: `${(0, $kmplh.getListContentPaddingLeft)({
            depth: depth,
            ...(0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') && {
                hasCheckbox: isMultiSelectEnabled
            },
            isCreate: true,
            isParent: false
        })}px`
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: cellRef,
        role: "gridcell",
        tabIndex: -1,
        style: {
            width: `${listWidth}px`,
            height: `${itemHeight}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...paddingLeftStyle,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: createItemBackgroundColor
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _1ltvidpf _1yt4s8vo _1pbyzo7u _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
        ])
    }, renderListItemCreate({
        anchorId: anchorId,
        level: level,
        onClick: onClick,
        canCreateChildOverride: canCreateChildOverride
    }, {
        isActive: isActive
    }));
};
var $2743d2c7621dfa9d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2743d2c7621dfa9d$var$ListCreateItem);

});
parcelRegister("kmplh", function(module, exports) {

$parcel$export(module.exports, "getListContentPaddingLeft", () => $96940d50fa50b6d9$export$ca5712918dfd7d6b);

var $8rQuz = parcelRequire("8rQuz");
const $96940d50fa50b6d9$var$GRID_SIZE = 8;
const $96940d50fa50b6d9$var$DEFAULT_LIST_CONTENT_PADDING = $96940d50fa50b6d9$var$GRID_SIZE * 3;
const $96940d50fa50b6d9$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING = 0;
const $96940d50fa50b6d9$var$DEFAULT_LIST_CREATE_OFFSET = -12;
const $96940d50fa50b6d9$var$CHECKBOX_SPACE = 32;
const $96940d50fa50b6d9$export$ca5712918dfd7d6b = ({ isCreate: isCreate = false, hasCheckbox: hasCheckbox = false, depth: depth, isParent: isParent, offset: offset })=>{
    let result = depth * $96940d50fa50b6d9$var$DEFAULT_LIST_CONTENT_PADDING;
    if (hasCheckbox) result += $96940d50fa50b6d9$var$CHECKBOX_SPACE;
    if ((0, $8rQuz.isVisualRefreshEnabled)()) result += offset || 0;
    if (isParent) result += $96940d50fa50b6d9$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING;
    else result += $96940d50fa50b6d9$var$DEFAULT_LIST_CONTENT_PADDING;
    if (isCreate) result += $96940d50fa50b6d9$var$DEFAULT_LIST_CREATE_OFFSET;
    return result;
};

});



parcelRegister("dG2Eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e710ae2f70d253d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");

var $lSR7G = parcelRequire("lSR7G");

var $8cMB7 = parcelRequire("8cMB7");
const $9e710ae2f70d253d$var$containerStyles = null;
const $9e710ae2f70d253d$var$DropTarget = ({ id: id, parentId: parentId, level: level, depth: depth, ariaRowIndex: ariaRowIndex, topOffset: topOffset, children: children, itemHeight: itemHeight, childItemsHeight: childItemsHeight, isParent: isParent, isExpanded: isExpanded, isInTransition: isInTransition, onDrop: onDrop, onExpandChanged: onExpandChanged })=>{
    const [{ isTreeDrag: isTreeDrag }] = (0, $9WNLk.useEnablements)();
    const [setDropRef, clearDropRef] = (0, $8cMB7.useListDropTarget)({
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        isParent: isParent,
        isExpanded: isExpanded,
        isInTransition: isInTransition,
        isTreeDrag: isTreeDrag,
        childItemsHeight: childItemsHeight,
        onDrop: onDrop,
        onExpandChanged: onExpandChanged
    });
    const [isItemSelected] = (0, $lSR7G.useIsItemSelected)(id);
    // Effects //
    (0, $eUqFw.useEffect)(()=>()=>{
            // drop connections will be unsubscribed if NULL was passed to drop handler.
            clearDropRef();
        }, [
        clearDropRef
    ]);
    const height = depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "row",
        "aria-rowindex": ariaRowIndex,
        "aria-selected": isItemSelected,
        ref: setDropRef,
        style: {
            top: `${topOffset}px`,
            height: `${height}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _1bsb1osq"
        ])
    }, children);
};
var $9e710ae2f70d253d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($9e710ae2f70d253d$var$DropTarget);

});
parcelRegister("8cMB7", function(module, exports) {

$parcel$export(module.exports, "useListDropTarget", () => $051429adcc0ba945$export$4aeed369644ffdbb);

var $eUqFw = parcelRequire("eUqFw");

var $dLGEC = parcelRequire("dLGEC");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");

var $gf0vG = parcelRequire("gf0vG");

var $bwj1b = parcelRequire("bwj1b");

var $cZkk1 = parcelRequire("cZkk1");

var $kmplh = parcelRequire("kmplh");

var $jTR63 = parcelRequire("jTR63");
const $051429adcc0ba945$export$4aeed369644ffdbb = ({ id: id, level: level, depth: depth, parentId: parentId, isParent: isParent, isExpanded: isExpanded, isInTransition: isInTransition, isTreeDrag: isTreeDrag, childItemsHeight: childItemsHeight = 0, onDrop: onDrop, onExpandChanged: onExpandChanged })=>{
    const directionRef = (0, $eUqFw.useRef)((0, $gf0vG.DOWN));
    const cleanupDragAndDrop = (0, $eUqFw.useRef)(null);
    const isDraggedOver = (0, $eUqFw.useRef)(false);
    const timerRef = (0, $eUqFw.useRef)(undefined);
    const instructionRef = (0, $eUqFw.useRef)(null);
    const { onResize: onResize } = (0, $cZkk1.useTimelineViewportActions)();
    const isDragChildOverParent = (0, $eUqFw.useRef)(false);
    const { onRowDragOver: onRowDragOver, onRowDragChildOverParent: onRowDragChildOverParent, onRowDragChildOverParentEnd: onRowDragChildOverParentEnd } = (0, $bwj1b.useSideEffectMarshal)();
    const makeDroppable = (0, $eUqFw.useCallback)((dragElement)=>{
        const el = dragElement;
        if (el === null) return;
        const getData = ()=>({
                id: id,
                level: level,
                isInTransition: isInTransition
            });
        const canDrop = ({ source: source })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            return item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && !(0, $jTR63.getIsDragParentOverChild)(item.level, level) && isInTransition !== true;
        };
        const onDragEnter = ({ source: source })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && item.id !== id) {
                isDraggedOver.current = true;
                // expand parent
                if ((0, $jTR63.getIsDragChildOverParent)(item.level, level)) {
                    // set the drag over parent styles
                    onRowDragChildOverParent(item.id, id);
                    if (isParent && !isExpanded) {
                        // expand if it is a collapsed parent
                        timerRef.current && clearTimeout(timerRef.current);
                        timerRef.current = setTimeout(()=>{
                            onExpandChanged(id, false);
                            clearTimeout(timerRef.current);
                            timerRef.current = undefined;
                        }, (0, $gf0vG.DELAY_EXPAND_TIME));
                    }
                }
            }
        };
        const onDrag = ({ source: source, location: location })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            const { current: { input: current } } = location;
            if (isDraggedOver.current && // not dragging child over parent
            !(0, $jTR63.getIsDragChildOverParent)(item.level, level)) {
                // calculate drop position
                const { top: top, bottom: bottom } = el.getBoundingClientRect();
                const midpoint = top + (bottom - top) / 2;
                directionRef.current = current.pageY <= midpoint ? (0, $gf0vG.UP) : (0, $gf0vG.DOWN);
                const bottomWithOffset = bottom + childItemsHeight;
                const relativeTop = directionRef.current === (0, $gf0vG.DOWN) ? bottomWithOffset : top;
                onRowDragOver(item.id, relativeTop);
            }
        };
        const onItemDrop = ({ source: source, location: { current: { dropTargets: dropTargets } } })=>{
            /**
				 * Check whether the drop happens over only the current target,
				 * or over a nested one.
				 * The first item in dropTargets is always the inner most dropTarget.
				 */ const isShallowDrop = dropTargets.length > 0 && dropTargets[0].data.id === id;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            if (item.id !== id && isShallowDrop) {
                const rankRequest = directionRef.current === (0, $gf0vG.DOWN) ? {
                    rankAfterId: id
                } : {
                    rankBeforeId: id
                };
                const updateType = (0, $jTR63.getUpdateType)({
                    level: item.level,
                    parentId: item.parentId,
                    id: item.id,
                    depth: item.depth
                }, {
                    level: level,
                    parentId: parentId,
                    id: id,
                    depth: depth
                });
                switch(updateType){
                    case 0, $jTR63.UPDATE_RANK:
                        onDrop(item.id, {
                            level: item.level,
                            rankRequest: rankRequest
                        });
                        break;
                    case 0, $jTR63.UPDATE_PARENT:
                        onDrop(item.id, {
                            level: item.level,
                            parentId: id
                        });
                        break;
                    case 0, $jTR63.UPDATE_RANK_AND_PARENT:
                        onDrop(item.id, {
                            level: item.level,
                            parentId: parentId,
                            rankRequest: rankRequest
                        });
                        break;
                    default:
                        break;
                }
            }
        };
        const treeGetData = ({ source: source, input: input, element: element })=>{
            const data = {
                id: id,
                level: level,
                isInTransition: isInTransition
            };
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const draggedItem = source.data;
            const dropTarget = {
                id: id,
                parentId: parentId,
                level: level,
                depth: depth
            };
            const blockedInstructions = (0, $jTR63.getBlockedInstructions)({
                dropTarget: dropTarget,
                draggedItem: draggedItem
            });
            return (0, $dLGEC.attachInstruction)(data, {
                input: input,
                element: element,
                indentPerLevel: (0, $jTR63.INDENT_PER_LEVEL),
                currentLevel: depth || 0,
                mode: isParent && isExpanded ? 'expanded' : 'standard',
                block: blockedInstructions
            });
        };
        const treeCanDrop = ({ source: source })=>source.data.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && isInTransition !== true;
        const onTreeDrag = ({ source: source, self: self, location: location })=>{
            const { dropTargets: dropTargets } = location.current;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            const dropTarget = dropTargets[0];
            if (dropTarget.data.id === id) {
                const extractedInstruction = (0, $dLGEC.extractInstruction)(self.data);
                if (extractedInstruction?.type !== 'instruction-blocked') {
                    // show indicator line only when rerank issue
                    if (extractedInstruction?.type === 'reorder-above' || extractedInstruction?.type === 'reorder-below') {
                        const { top: top, bottom: bottom } = el.getBoundingClientRect();
                        const relativeTop = extractedInstruction?.type === 'reorder-below' ? bottom : top;
                        const paddingLeft = (0, $kmplh.getListContentPaddingLeft)({
                            isParent: true,
                            depth: depth
                        });
                        onResize({
                            indicatorLineOffset: paddingLeft
                        });
                        onRowDragOver(item.id, relativeTop, paddingLeft);
                        // Clear the background when a child is dragged over a parent and transitions to the state of reordering above or below.
                        if (isDragChildOverParent.current) {
                            onRowDragChildOverParentEnd(parentId ?? id);
                            isDragChildOverParent.current = false;
                        }
                    }
                    // show indicator background
                    if (extractedInstruction?.type === 'make-child') {
                        onRowDragChildOverParent(item.id, id);
                        isDragChildOverParent.current = true;
                    }
                    instructionRef.current = extractedInstruction;
                }
            }
        };
        const onTreeDrop = ({ source: source, location: { current: { dropTargets: dropTargets } } })=>{
            const isShallowDrop = dropTargets.length > 0 && dropTargets[0].data.id === id;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            if (instructionRef.current && item.id !== id && isShallowDrop) {
                // const isUnlinkParent = item.parentId && !parentId;
                const isReparent = item.parentId !== parentId;
                switch(instructionRef.current.type){
                    case 'make-child':
                        onDrop(item.id, {
                            level: item.level,
                            parentId: id
                        });
                        // Clear the parent's background after a child is dragged over the parent and dropped onto it
                        if (isDragChildOverParent.current) {
                            onRowDragChildOverParentEnd(id);
                            isDragChildOverParent.current = false;
                        }
                        break;
                    case 'reorder-above':
                    case 'reorder-below':
                        onDrop(item.id, {
                            level: item.level,
                            rankRequest: instructionRef.current.type === 'reorder-above' ? {
                                rankBeforeId: id
                            } : {
                                rankAfterId: id
                            },
                            ...isReparent ? {
                                parentId: parentId
                            } : {}
                        });
                        break;
                    default:
                        break;
                }
            }
            instructionRef.current = null;
        };
        const onTreeDragEnter = ({ source: source })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && item.id !== id) {
                isDraggedOver.current = true;
                // expand parent
                if ((0, $jTR63.getTreeItemIsDragChildOverParent)(item.level, level)) {
                    if (isParent && !isExpanded) {
                        // expand if it is a collapsed parent
                        timerRef.current && clearTimeout(timerRef.current);
                        timerRef.current = setTimeout(()=>{
                            onExpandChanged(id, false);
                            clearTimeout(timerRef.current);
                            timerRef.current = undefined;
                        }, (0, $gf0vG.DELAY_EXPAND_TIME));
                    }
                }
            }
        };
        const onTreeDropTargetChange = ({ location: location })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const previousDropTargetId = location.previous?.dropTargets[0]?.data.id;
            if (isDragChildOverParent.current && previousDropTargetId) {
                onRowDragChildOverParentEnd(previousDropTargetId);
                isDragChildOverParent.current = false;
            }
        };
        cleanupDragAndDrop.current = (0, $3f2za.combine)((0, $eo9PV.dropTargetForElements)({
            element: el,
            getData: isTreeDrag ? treeGetData : getData,
            canDrop: isTreeDrag ? treeCanDrop : canDrop,
            onDragEnter: isTreeDrag ? onTreeDragEnter : onDragEnter,
            onDrag: isTreeDrag ? onTreeDrag : onDrag,
            onDrop: isTreeDrag ? onTreeDrop : onItemDrop,
            onDragLeave: ()=>{
                if (isDraggedOver.current || timerRef.current) {
                    isDraggedOver.current = false;
                    clearTimeout(timerRef.current);
                    timerRef.current = undefined;
                }
            },
            ...isTreeDrag ? {
                onDropTargetChange: onTreeDropTargetChange
            } : {}
        }));
    }, [
        id,
        level,
        isParent,
        isExpanded,
        isInTransition,
        isTreeDrag,
        parentId,
        depth,
        childItemsHeight,
        onExpandChanged,
        onRowDragOver,
        onRowDragChildOverParent,
        onDrop,
        onResize,
        onRowDragChildOverParentEnd
    ]);
    const cleanupDroppable = (0, $eUqFw.useCallback)(()=>{
        cleanupDragAndDrop.current?.();
    }, []);
    return [
        makeDroppable,
        cleanupDroppable
    ];
};

});
parcelRegister("dLGEC", function(module, exports) {

$parcel$export(module.exports, "attachInstruction", () => $f50fe4e2820f93ae$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $f50fe4e2820f93ae$export$c8ffecbe249dc8f8);
// using a symbol so we can guarantee a key with a unique value
const $f50fe4e2820f93ae$var$uniqueKey = Symbol('tree-item-instruction');
function $f50fe4e2820f93ae$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $f50fe4e2820f93ae$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $f50fe4e2820f93ae$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $f50fe4e2820f93ae$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $f50fe4e2820f93ae$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $f50fe4e2820f93ae$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $f50fe4e2820f93ae$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $f50fe4e2820f93ae$var$isShallowEqual(a, b) {
    const aKeys = Object.keys(a).sort();
    const bKeys = Object.keys(b).sort();
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>a[key] === b[key]);
}
function $f50fe4e2820f93ae$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $f50fe4e2820f93ae$var$areInstructionsEqual(a.desired, b.desired);
    return $f50fe4e2820f93ae$var$isShallowEqual(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $f50fe4e2820f93ae$var$memoizeInstruction = (()=>{
    let last = null;
    return (instruction)=>{
        if (last && $f50fe4e2820f93ae$var$areInstructionsEqual(last, instruction)) return last;
        last = instruction;
        return instruction;
    };
})();
function $f50fe4e2820f93ae$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $f50fe4e2820f93ae$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $f50fe4e2820f93ae$var$getInstruction(rest);
    const withBlock = $f50fe4e2820f93ae$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $f50fe4e2820f93ae$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$f50fe4e2820f93ae$var$uniqueKey]: memoized
    };
}
function $f50fe4e2820f93ae$export$c8ffecbe249dc8f8(userData) {
    return userData[$f50fe4e2820f93ae$var$uniqueKey] ?? null;
}

});

parcelRegister("jTR63", function(module, exports) {

$parcel$export(module.exports, "UPDATE_RANK", () => $3f3ccce096253b63$export$576ea426c903d7e1);
$parcel$export(module.exports, "UPDATE_PARENT", () => $3f3ccce096253b63$export$44bc1fe1c2a61c81);
$parcel$export(module.exports, "UPDATE_RANK_AND_PARENT", () => $3f3ccce096253b63$export$14628ae53fe631c7);
$parcel$export(module.exports, "INDENT_PER_LEVEL", () => $3f3ccce096253b63$export$130b26c73bb9d040);
$parcel$export(module.exports, "getUpdateType", () => $3f3ccce096253b63$export$df2aa842dc5172b0);
$parcel$export(module.exports, "getIsDragChildOverParent", () => $3f3ccce096253b63$export$64e82cf96e63ddf2);
$parcel$export(module.exports, "getIsDragParentOverChild", () => $3f3ccce096253b63$export$fa3830d8bd814624);
$parcel$export(module.exports, "getTreeItemIsDragChildOverParent", () => $3f3ccce096253b63$export$466f5fb38504576b);
$parcel$export(module.exports, "getBlockedInstructions", () => $3f3ccce096253b63$export$44539271c2e3abc8);

var $1sAbG = parcelRequire("1sAbG");
const $3f3ccce096253b63$export$576ea426c903d7e1 = 'UPDATE_RANK';
const $3f3ccce096253b63$export$44bc1fe1c2a61c81 = 'UPDATE_PARENT';
const $3f3ccce096253b63$export$14628ae53fe631c7 = 'UPDATE_RANK_AND_PARENT';
const $3f3ccce096253b63$export$5b388ccfa29be01 = -1;
const $3f3ccce096253b63$export$130b26c73bb9d040 = 25;
const $3f3ccce096253b63$export$df2aa842dc5172b0 = (draggedItem, dropTarget)=>{
    if (draggedItem.level === dropTarget.level) {
        if ((0, $1sAbG.isBaseLevel)(draggedItem.level) && dropTarget.parentId !== draggedItem.parentId) // Update parent and rank if drop child to another expanded epic
        return $3f3ccce096253b63$export$14628ae53fe631c7;
        // Update rank if drop issue in the same level
        return $3f3ccce096253b63$export$576ea426c903d7e1;
    }
    if ((0, $1sAbG.isBaseLevel)(draggedItem.level) && !(0, $1sAbG.isBaseLevel)(dropTarget.level) && dropTarget.id !== draggedItem.parentId) // Update parentId when drop child issue to epic directly
    return $3f3ccce096253b63$export$44bc1fe1c2a61c81;
    return undefined;
};
const $3f3ccce096253b63$export$64e82cf96e63ddf2 = (itemLevel, overItemLevel)=>(0, $1sAbG.isBaseLevel)(itemLevel) && !(0, $1sAbG.isBaseLevel)(overItemLevel);
const $3f3ccce096253b63$export$fa3830d8bd814624 = (itemLevel, overItemLevel)=>!(0, $1sAbG.isBaseLevel)(itemLevel) && (0, $1sAbG.isBaseLevel)(overItemLevel);
const $3f3ccce096253b63$export$466f5fb38504576b = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 1;
const $3f3ccce096253b63$export$244c1f40d1decdb6 = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 0 || dropTargetLevel - draggedItemLevel === 1;
const $3f3ccce096253b63$export$98df7fcf26a10604 = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel === draggedItemLevel;
const $3f3ccce096253b63$export$df097d1d7a83adbb = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 1;
const $3f3ccce096253b63$export$44539271c2e3abc8 = ({ dropTarget: dropTarget, draggedItem: draggedItem })=>{
    const { level: dropTargetLevel, parentId: dropTargetParentId } = dropTarget;
    const { level: draggedItemLevel } = draggedItem;
    const isOnSameLevel = $3f3ccce096253b63$export$98df7fcf26a10604(draggedItemLevel, dropTargetLevel);
    const isWithinOneLevel = $3f3ccce096253b63$export$244c1f40d1decdb6(draggedItemLevel, dropTargetLevel);
    const isOneLevelBelow = $3f3ccce096253b63$export$df097d1d7a83adbb(draggedItemLevel, dropTargetLevel);
    const isSubTask = draggedItemLevel === $3f3ccce096253b63$export$5b388ccfa29be01;
    // Should not reparent when drop on same level
    if (isOnSameLevel) return [
        'make-child'
    ];
    // When dropTargetLevel -  draggedItemLevel > 1 or dropTargetLevel < draggedItemLevel
    if (!isWithinOneLevel) {
        if (dropTargetParentId || isSubTask) // Should block all instructions when dropTarget has parent
        return [
            'make-child',
            'reorder-below',
            'reorder-above'
        ];
        // Should allow re-rank when dropTarget is root level
        return [
            'make-child'
        ];
    }
    // When drag item to one level below
    if (isOneLevelBelow) {
        if (isSubTask) // Should allow reparent when drop one level below
        return [
            'reorder-below',
            'reorder-above'
        ];
        if (dropTargetParentId) // Should allow re-parent when dropTarget has parent
        return [
            'reorder-below',
            'reorder-above'
        ];
    }
    return [];
};

});



parcelRegister("l4yFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21706d0a7e65258$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $lSR7G = parcelRequire("lSR7G");

var $nH3p1 = parcelRequire("nH3p1");

var $3XwA1 = parcelRequire("3XwA1");

var $dWSuJ = parcelRequire("dWSuJ");
const $d21706d0a7e65258$var$listEmptyContentStyles = null;
const $d21706d0a7e65258$var$bottomBorderContainerStyles = null;
const $d21706d0a7e65258$var$listBottomBorderStyles = null;
const $d21706d0a7e65258$var$chartBottomBorderStyles = null;
const $d21706d0a7e65258$var$Footer = ({ renderListEmptyContent: renderListEmptyContent })=>{
    const [isTableEmpty] = (0, $lSR7G.useIsTableEmpty)();
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return isTableEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${listWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _1pby1406"
        ])
    }, renderListEmptyContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _1bsb1osq _4t3it94y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _4t3it94y _bfhk14l7 _1pby1406"
        ]),
        style: {
            width: `${listWidth}px`,
            "--_drom5x": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorderColor))
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlidpf _1o9zidpf _i0dl1wug _4t3it94y _bfhk14l7"
        ]),
        style: {
            width: `${timelineWidth}px`,
            "--_drom5x": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorderColor))
        }
    }));
};
var $d21706d0a7e65258$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d21706d0a7e65258$var$Footer);

});

parcelRegister("8uivF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e44c4abc3631a0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $nH3p1 = parcelRequire("nH3p1");

var $kmplh = parcelRequire("kmplh");
const $7e44c4abc3631a0b$var$listItemLiteCellStyles = null;
/* A non interactive version of the list-item with lightweight styles.
 * Leveraged during virtualisation to improve scroll performance.
 */ const $7e44c4abc3631a0b$var$ListItemLite = ({ id: id, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent })=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: true,
        isHoveredOrFocused: false
    };
    const height = depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "gridcell",
        tabIndex: -1,
        style: {
            width: `${listWidth}px`,
            height: `${height}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingLeft: `${(0, $kmplh.getListContentPaddingLeft)({
                isParent: false,
                depth: depth
            })}px`,
            backgroundColor: backgroundColor
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _vchhusvi _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _u5f3u2gc _1reo15vq _18m915vq _1pby1406"
        ])
    }, renderListItemContent(rendererProps, rendererState), renderListItemSecondaryContent(rendererProps, rendererState));
};
var $7e44c4abc3631a0b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7e44c4abc3631a0b$var$ListItemLite);

});

parcelRegister("a3v1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf19009c34dbb8d6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $eI5EY = parcelRequire("eI5EY");

var $8rQuz = parcelRequire("8rQuz");

var $75e8i = parcelRequire("75e8i");

var $gf0vG = parcelRequire("gf0vG");

var $lSR7G = parcelRequire("lSR7G");

var $nH3p1 = parcelRequire("nH3p1");

var $8hFGR = parcelRequire("8hFGR");

var $cUFbE = parcelRequire("cUFbE");

var $bwj1b = parcelRequire("bwj1b");

var $fTs8H = parcelRequire("fTs8H");

var $kmplh = parcelRequire("kmplh");

var $eKKjG = parcelRequire("eKKjG");

var $lqJW5 = parcelRequire("lqJW5");

var $kadaD = parcelRequire("kadaD");

var $3UUug = parcelRequire("3UUug");

var $4nEH9 = parcelRequire("4nEH9");

var $hQQ6H = parcelRequire("hQQ6H");

var $KAROR = parcelRequire("KAROR");

var $lqIGA = parcelRequire("lqIGA");

var $bt6fG = parcelRequire("bt6fG");

var $b0Luy = parcelRequire("b0Luy");

var $cLle4 = parcelRequire("cLle4");
const $bf19009c34dbb8d6$var$secondaryContentStyles = null;
const $bf19009c34dbb8d6$var$listItemContainerStyles = null;
const $bf19009c34dbb8d6$var$getCursor = (isInTransition, isSelectEnabled)=>{
    if (isInTransition) return 'not-allowed';
    if (isSelectEnabled) return 'pointer';
    return 'default';
};
const $bf19009c34dbb8d6$var$PADDING_LEFT_INCREMENT = 12;
const $bf19009c34dbb8d6$var$ListItem = ({ id: id, parentId: parentId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, ariaControls: ariaControls, isParent: isParent, isExpanded: isExpanded, isDragEnabled: isDragEnabled, isInTransition: isInTransition, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isMeatballsButtonEnabled: isMeatballsButtonEnabled, onSelect: onSelect, onDrop: onDrop, onExpandChanged: onExpandChanged, onInlineCreateClicked: onInlineCreateClicked, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sideEffectMarshal = (0, $bwj1b.useSideEffectMarshal)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const [isHoveredOrFocused, setIsHoveredOrFocused] = (0, $eUqFw.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $eUqFw.useState)(false);
    const isContainerInFocus = (0, $eUqFw.useRef)(false);
    const element = (0, $eUqFw.useRef)(null);
    const cellRef = (0, $cUFbE.useGridCell)(id, (0, $gf0vG.LIST_COLUMN_COORDINATE));
    const isFocused = (0, $eUqFw.useRef)(false);
    const [isActive] = (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $lSR7G.useIsItemActive)(id) : [
        false
    ];
    /* eslint-disable react-hooks/rules-of-hooks */ const { selectable: selectable, selected: selected, handleClick: handleClick, handleKeyDown: handleKeyDown } = (()=>{
        if ((0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) return (0, $kadaD.useItemSelect)(id);
        const [isItemSelected = false] = (0, $lSR7G.useIsItemSelected)(id);
        return {
            selectable: false,
            selected: isItemSelected,
            handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            handleKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    })();
    /* eslint-enable react-hooks/rules-of-hooks */ const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave, onRowFocus: onRowFocus, onRowBlur: onRowBlur } = sideEffectMarshal;
    const [isActiveCreateChildTrigger] = (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? // Safe to add this in as hook will either always be run, or never be run based on FG.
    // Do not want to introduce a massive fork to this component.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8hFGR.useIsCreateTriggerActive)({
        id: id,
        type: 'CHILD'
    }) : [
        false
    ];
    const canDrag = isDragEnabled && !isInTransition;
    const [makeDraggable, cleanupDraggable] = (0, $cLle4.default)({
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        canDrag: canDrag,
        sideEffectMarshal: sideEffectMarshal
    });
    // Effects //
    (0, $eUqFw.useEffect)(()=>{
        makeDraggable(element.current);
        return ()=>{
            // drag connections will be unsubscribed if NULL was passed to drag handler.
            cleanupDraggable();
        };
    }, [
        makeDraggable,
        cleanupDraggable
    ]);
    // Callbacks //
    const onHoverOrFocus = (0, $eUqFw.useCallback)(()=>{
        onRowMouseEnter(id);
        setIsHoveredOrFocused(true);
    }, [
        id,
        onRowMouseEnter
    ]);
    const onStopHoverOrFocus = (0, $eUqFw.useCallback)(()=>{
        if (isFocused.current && (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) {
            onRowBlur(id);
            isFocused.current = false;
        }
        onRowMouseLeave(id);
        setIsMenuOpen(false);
        setIsHoveredOrFocused(false);
    }, [
        id,
        onRowMouseLeave,
        onRowBlur
    ]);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        onRowFocus(id);
        onHoverOrFocus();
        isFocused.current = true;
    }, [
        id,
        onHoverOrFocus,
        onRowFocus
    ]);
    const onContainerBlurOld = (0, $eUqFw.useCallback)(({ relatedTarget: relatedTarget })=>{
        if (!element.current?.contains(relatedTarget) && !isContainerInFocus.current) onStopHoverOrFocus();
        isContainerInFocus.current = false;
    }, [
        onStopHoverOrFocus
    ]);
    const onContainerBlur = (0, $eUqFw.useCallback)(({ relatedTarget: relatedTarget })=>{
        if (!element.current?.contains(relatedTarget)) onStopHoverOrFocus();
    }, [
        onStopHoverOrFocus
    ]);
    const onContainerClickOld = (0, $eUqFw.useCallback)((event)=>{
        const { timeStamp: timeStamp, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
        (0, $75e8i.default)('timeline-item-clicked', timeStamp);
        const withCmd = ctrlKey || metaKey;
        const withShift = shiftKey;
        onSelect(id, {
            level: level,
            withCmd: withCmd,
            withShift: withShift,
            depth: depth
        });
    }, [
        id,
        level,
        depth,
        onSelect
    ]);
    const onContainerClickNew = (0, $eUqFw.useCallback)((event)=>{
        const { timeStamp: timeStamp, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
        (0, $75e8i.default)('timeline-item-clicked', timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'listItem',
            actionSubjectId: 'issueListItem',
            attributes: {
                level: level,
                depth: depth,
                withCmd: ctrlKey || metaKey,
                withShift: shiftKey
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        handleClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        level,
        depth,
        handleClick
    ]);
    const onContainerClick = (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? onContainerClickNew : onContainerClickOld;
    const onSelectCheckboxToggle = (0, $eUqFw.useCallback)((event)=>{
        const { timeStamp: timeStamp, shiftKey: shiftKey } = event;
        (0, $75e8i.default)('timeline-item-select-checkbox-toggled', timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'checkbox',
            actionSubjectId: 'issueListItemSelect',
            attributes: {
                level: level,
                depth: depth,
                withShift: shiftKey
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        handleClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        depth,
        handleClick,
        level
    ]);
    const onContainerMouseLeave = (0, $eUqFw.useCallback)(()=>{
        if (!element.current?.contains(document.activeElement)) onStopHoverOrFocus();
    }, [
        onStopHoverOrFocus
    ]);
    const onContainerMouseDown = (0, $eUqFw.useCallback)(()=>{
        isContainerInFocus.current = true;
    }, []);
    let onContainerKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $lqJW5.isEnterOrSpaceKey)(event) && !(0, $lqJW5.isBubbledEvent)(event)) {
            // Stops default behaviour of scrolling the parent container
            event.preventDefault();
            onContainerClick(event);
        }
    }, [
        onContainerClick
    ]);
    if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) onContainerKeyDown = undefined;
    if ((0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    onContainerKeyDown = (0, $eUqFw.useCallback)((event)=>{
        // Handle key events on the container only (not bubbled ones)
        if (event.target === event.currentTarget) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'keydown',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem'
            });
            handleKeyDown(event, analyticsEvent);
        }
    }, [
        createAnalyticsEvent,
        handleKeyDown
    ]);
    const setItemRef = (0, $eUqFw.useCallback)((ref)=>{
        element.current = ref;
        cellRef(ref);
    }, [
        cellRef
    ]);
    // Render //
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: false,
        isHoveredOrFocused: isHoveredOrFocused
    };
    const renderSecondaryContent = ()=>{
        if (isInTransition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1e0c116y _4cvr1h6o _18u01b66"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small",
            testId: `roadmap.timeline-table.components.list-item.spinner.${id}`
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1e0c116y _4cvr1h6o _18u01b66"
            ])
        }, renderListItemSecondaryContent(rendererProps, rendererState), renderListItemMenuOption && isMeatballsButtonEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (isCreateChildEnabled && isHoveredOrFocused || isActiveCreateChildTrigger) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3UUug.default), {
            parentId: id,
            label: formatMessage((0, $bt6fG.default).createChild),
            onInlineCreateClicked: onInlineCreateClicked,
            isVisible: !isActiveCreateChildTrigger
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lqIGA.default), {
            isTriggerVisible: isHoveredOrFocused,
            isMenuOpen: isMenuOpen,
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            renderListItemMenuOption: renderListItemMenuOption,
            renderListItemModal: renderListItemModal,
            onStopHoverOrFocus: onStopHoverOrFocus,
            onInlineCreateClicked: onInlineCreateClicked,
            onDrop: onDrop,
            setIsMenuOpen: setIsMenuOpen,
            cellRef: element
        })));
    };
    const renderSecondaryContentOld = ()=>{
        let innerElement;
        if (isInTransition) innerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small",
            testId: `roadmap.timeline-table.components.list-item.spinner.${id}`
        });
        else if (isCreateChildEnabled) innerElement = isHoveredOrFocused ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3UUug.default), {
            parentId: id,
            label: formatMessage((0, $bt6fG.default).createChild),
            onInlineCreateClicked: onInlineCreateClicked
        }) : null;
        // Consumer secondary content should only be visible when internal secondary content is not
        if (innerElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1e0c116y _4cvr1h6o _18u01b66"
            ])
        }, innerElement);
        return renderListItemSecondaryContent(rendererProps, rendererState);
    };
    const height = depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    const listContentPaddingLeft = (0, $kmplh.getListContentPaddingLeft)({
        isParent: isParent,
        depth: depth,
        ...(0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') && {
            hasCheckbox: isMultiSelectEnabled
        },
        offset: !isMultiSelectEnabled && (0, $8rQuz.isVisualRefreshEnabled)() ? $bf19009c34dbb8d6$var$PADDING_LEFT_INCREMENT : undefined
    });
    const ExpandComponent = (0, $eI5EY.fg)('timeline_grid_navigation_m2') ? (0, $hQQ6H.default) : (0, $KAROR.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: id,
        "data-testid": `roadmap.timeline-table.components.list-item.container-${id}`,
        role: "gridcell",
        tabIndex: -1,
        ref: setItemRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _1e0c1txw _4cvr1h6o _vchhusvi _u5f3u2gc _v564lfip _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b",
            (0, $fTs8H.getRowClassName)(id, parentId).className
        ]),
        style: {
            width: `${listWidth}px`,
            height: `${height}px`,
            backgroundColor: backgroundColor,
            paddingLeft: `${listContentPaddingLeft}px`,
            zIndex: isMenuOpen && (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, $gf0vG.zIndex).PORTAL // eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
             : (0, $gf0vG.zIndex).LIST,
            // eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            cursor: $bf19009c34dbb8d6$var$getCursor(isInTransition, isSelectEnabled)
        },
        onClick: isSelectEnabled && !isInTransition ? onContainerClick : undefined,
        onKeyDown: onContainerKeyDown,
        onMouseEnter: onHoverOrFocus,
        onMouseLeave: (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onContainerMouseLeave : onStopHoverOrFocus,
        ...!(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') && {
            onMouseDown: onContainerMouseDown
        },
        onFocus: (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onFocus : onHoverOrFocus,
        onBlur: (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onContainerBlur : onContainerBlurOld
    }, isSelectEnabled && (selected || isActive) && isMenuOpen && (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? // Applies a border overlay to the currently selected item if the meatballs menu is open.
    // This is required as we increase the z-index of this list item to the PORTAL layer to
    // fix overlapping issues in the timeline.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bf19009c34dbb8d6$var$borderOverlayStyles
    }) : null, isMultiSelectEnabled && (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bf19009c34dbb8d6$var$checkboxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b0Luy.default), {
        id: id,
        isChecked: selected,
        isDisabled: !selectable,
        onToggle: onSelectCheckboxToggle
    })), isCreateSiblingEnabled && !(0, $eI5EY.fg)('timeline_grid_navigation_m2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nEH9.default), {
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        label: formatMessage((0, $bt6fG.default).createSibling),
        onInlineCreateClicked: onInlineCreateClicked
    }), isParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ExpandComponent, {
        id: id,
        label: isExpanded ? formatMessage((0, $bt6fG.default).collapse) : formatMessage((0, $bt6fG.default).expand),
        isExpanded: isExpanded,
        isRichContentEnabled: isHoveredOrFocused,
        onExpandChanged: onExpandChanged,
        ariaControls: ariaControls
    }), renderListItemContent(rendererProps, rendererState), (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? renderSecondaryContent() : renderSecondaryContentOld(), isCreateSiblingEnabled && (0, $eI5EY.fg)('timeline_grid_navigation_m2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nEH9.default), {
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        label: formatMessage((0, $bt6fG.default).createSibling),
        onInlineCreateClicked: onInlineCreateClicked
    }));
};
const $bf19009c34dbb8d6$var$borderOverlayStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    pointerEvents: 'none',
    borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRight: `2px solid ${"var(--ds-border, #091E4224)"}`
});
$bf19009c34dbb8d6$var$ListItem.defaultProps = {
    isInTransition: false
};
$bf19009c34dbb8d6$var$ListItem.displayName = 'ListItem';
$bf19009c34dbb8d6$var$ListItem.whyDidYouRender = true;
var $bf19009c34dbb8d6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bf19009c34dbb8d6$var$ListItem);
const $bf19009c34dbb8d6$var$checkboxWrapperStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    left: 'space.0',
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});
parcelRegister("lqJW5", function(module, exports) {

$parcel$export(module.exports, "isEnterOrSpaceKey", () => $1bb1d72f44e9530b$export$f6deda1cc2672a2e);
$parcel$export(module.exports, "isBubbledEvent", () => $1bb1d72f44e9530b$export$6cc56ae238ebd443);
const $1bb1d72f44e9530b$export$f6deda1cc2672a2e = (event)=>event.keyCode === 13 || event.keyCode === 32;
const $1bb1d72f44e9530b$export$a6587fe901c3baf7 = (event)=>event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
const $1bb1d72f44e9530b$export$6cc56ae238ebd443 = (event)=>event.currentTarget !== event.target;
const $1bb1d72f44e9530b$export$9c580eee50acd9e2 = (e)=>{
    const event = e || window.event;
    if ('buttons' in event) return event.buttons === 1;
    if (event) {
        const { button: button } = event;
        return button === 1;
    }
    return false;
};

});

parcelRegister("3UUug", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f7e6411b398368$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jaTu3 = parcelRequire("jaTu3");

var $bFzGY = parcelRequire("bFzGY");

var $bkIGg = parcelRequire("bkIGg");

var $2eG9N = parcelRequire("2eG9N");

var $dnJL9 = parcelRequire("dnJL9");

var $eI5EY = parcelRequire("eI5EY");

var $75e8i = parcelRequire("75e8i");

var $gf0vG = parcelRequire("gf0vG");

var $ikmG7 = parcelRequire("ikmG7");

var $fTs8H = parcelRequire("fTs8H");

var $eKKjG = parcelRequire("eKKjG");
const $e1f7e6411b398368$var$buttonStyles = null;
const $e1f7e6411b398368$var$hideButtonStyles = null;
const $e1f7e6411b398368$var$CreateChildButtonNew = ({ parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked, isVisible: isVisible })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, $ikmG7.useCreateTrigger)(parentId, 'CHILD');
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        event.stopPropagation();
        onCreateTriggerClick();
        (0, $75e8i.default)('timeline-add-item-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'childIssueCreateButton',
            attributes: {
                position: (0, $gf0vG.INSIDE)
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        onInlineCreateClicked({
            parentId: parentId,
            position: (0, $gf0vG.INSIDE)
        });
    }, [
        onCreateTriggerClick,
        createAnalyticsEvent,
        onInlineCreateClicked,
        parentId
    ]);
    const stopPropagation = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Escape') e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label
    }, (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? ({ ref: tooltipRef, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ...tooltipProps,
            ref: (0, $jaTu3.mergeRefs)([
                tooltipRef,
                createTriggerRef
            ]),
            "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
            "aria-label": label,
            onClick: onClick,
            onKeyUp: stopPropagation,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7JEyt.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
                !isVisible && "_tzy4idpf _lcxvglyw",
                (0, $fTs8H.getCreateChildButtonClassName)().className
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: "",
            size: "medium"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
        "aria-label": label,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
            (0, $fTs8H.getCreateChildButtonClassName)().className
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: "",
        size: "medium"
    })));
};
const $e1f7e6411b398368$var$CreateChildButtonOld = ({ parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        event.stopPropagation();
        (0, $75e8i.default)('timeline-add-item-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'childIssueCreateButton',
            attributes: {
                position: (0, $gf0vG.INSIDE)
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        onInlineCreateClicked({
            parentId: parentId,
            position: (0, $gf0vG.INSIDE)
        });
    }, [
        createAnalyticsEvent,
        parentId,
        onInlineCreateClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label
    }, (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ...tooltipProps,
            "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
            "aria-label": label,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7JEyt.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
                (0, $fTs8H.getCreateChildButtonClassName)().className
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: "",
            size: "medium"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
        "aria-label": label,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
            (0, $fTs8H.getCreateChildButtonClassName)().className
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: "",
        size: "medium"
    })));
};
const $e1f7e6411b398368$var$CreateChildButton = (0, $dnJL9.componentWithFG)('jsw_roadmaps_timeline_table_meatballs_menu_a11y', $e1f7e6411b398368$var$CreateChildButtonNew, $e1f7e6411b398368$var$CreateChildButtonOld);
var $e1f7e6411b398368$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e1f7e6411b398368$var$CreateChildButton);

});
parcelRegister("jaTu3", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $df59fd64c73fe87e$export$c9058316764c140e);

var $iYh9J = parcelRequire("iYh9J");

var $37WxO = parcelRequire("37WxO");
function $df59fd64c73fe87e$export$c9058316764c140e(refs) {
    return (0, $37WxO.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $iYh9J.assignRef)(ref, newValue)));
}

});
parcelRegister("37WxO", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $246f7040b169dc51$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $246f7040b169dc51$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("ikmG7", function(module, exports) {

$parcel$export(module.exports, "useCreateTrigger", () => $a8bef7953da64a5c$export$91c6835e1a79c0e7);

var $eUqFw = parcelRequire("eUqFw");

var $8hFGR = parcelRequire("8hFGR");
const $a8bef7953da64a5c$export$91c6835e1a79c0e7 = (rowId, type)=>{
    const element = (0, $eUqFw.useRef)(null);
    const { setActiveCreateTrigger: setActiveCreateTrigger } = (0, $8hFGR.useFocusMarshal)();
    const setCreateTriggerRef = (0, $eUqFw.useCallback)((ref)=>{
        element.current = ref;
    }, []);
    const onCreateTriggerClick = (0, $eUqFw.useCallback)(()=>{
        if (element.current) setActiveCreateTrigger(rowId, type, element.current);
    }, [
        rowId,
        setActiveCreateTrigger,
        type
    ]);
    return {
        createTriggerRef: setCreateTriggerRef,
        onCreateTriggerClick: onCreateTriggerClick
    };
};

});


parcelRegister("4nEH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfebf2624394b8c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jaTu3 = parcelRequire("jaTu3");

var $bFzGY = parcelRequire("bFzGY");

var $2eG9N = parcelRequire("2eG9N");

var $dnJL9 = parcelRequire("dnJL9");

var $eI5EY = parcelRequire("eI5EY");

var $75e8i = parcelRequire("75e8i");

var $gf0vG = parcelRequire("gf0vG");

var $ikmG7 = parcelRequire("ikmG7");

var $bwj1b = parcelRequire("bwj1b");

var $eKKjG = parcelRequire("eKKjG");
const $cfebf2624394b8c9$var$buttonStyles = null;
const $cfebf2624394b8c9$var$buttonStylesOld = null;
const $cfebf2624394b8c9$var$zIndexStyle = null;
const $cfebf2624394b8c9$var$CreateSiblingButton = ({ id: id, level: level, depth: depth, parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
    const element = (0, $eUqFw.useRef)(null);
    const { onAddButtonMouseEnter: onAddButtonMouseEnter, onAddButtonMouseLeave: onAddButtonMouseLeave } = (0, $bwj1b.useSideEffectMarshal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, $ikmG7.useCreateTrigger)(id, 'SIBLING');
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        event.stopPropagation();
        onCreateTriggerClick();
        (0, $75e8i.default)('timeline-add-item-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'issueCreateButton',
            attributes: {
                position: (0, $gf0vG.BEFORE),
                level: level,
                depth: depth
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        // Hide the button after activating the input
        onAddButtonMouseLeave();
        onInlineCreateClicked({
            beforeId: id,
            parentId: parentId,
            position: (0, $gf0vG.BEFORE)
        });
    }, [
        onCreateTriggerClick,
        createAnalyticsEvent,
        level,
        depth,
        onAddButtonMouseLeave,
        onInlineCreateClicked,
        id,
        parentId
    ]);
    const onActiveOld = (0, $eUqFw.useCallback)(()=>{
        if (element.current) {
            const { top: top } = element.current.getBoundingClientRect();
            onAddButtonMouseEnter(top);
        }
    }, [
        onAddButtonMouseEnter
    ]);
    const updateVisualIndicator = (0, $eUqFw.useCallback)((tabFocused)=>{
        if (element.current) {
            const { top: top } = element.current.getBoundingClientRect();
            onAddButtonMouseEnter(top, tabFocused);
        }
    }, [
        onAddButtonMouseEnter
    ]);
    const onActiveHandler = (0, $eUqFw.useCallback)((tabFocused)=>{
        if (tabFocused) // When ICC is cancelled, there is a race condition between updating the issue list
        // and updating the top position of the visual indicator. This causes the visual indicator
        // to be positioned as if the ICC is still open. This setTimeout ensures the position of
        // the visual indicator is updated with the correct position after the issue list has updated.
        setTimeout(()=>updateVisualIndicator(true), 10);
        else updateVisualIndicator(false);
    }, [
        updateVisualIndicator
    ]);
    const onActive = (0, $eUqFw.useCallback)(()=>{
        onActiveHandler(false);
    }, [
        onActiveHandler
    ]);
    const onActiveFocus = (0, $eUqFw.useCallback)(()=>{
        onActiveHandler(true);
    }, [
        onActiveHandler
    ]);
    const onInactive = (0, $eUqFw.useCallback)(()=>{
        onAddButtonMouseLeave();
    }, [
        onAddButtonMouseLeave
    ]);
    const createOnFocus = (tooltipCallback)=>(e)=>{
            onActiveFocus();
            tooltipCallback(e);
        };
    const createOnBlur = (tooltipCallback)=>(e)=>{
            onInactive();
            tooltipCallback(e);
        };
    return (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label,
        position: "left"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ...tooltipProps,
            ref: (0, $jaTu3.mergeRefs)([
                tooltipProps.ref,
                element,
                createTriggerRef
            ]),
            "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
            "aria-label": label,
            onMouseEnter: onActive,
            onMouseLeave: onInactive,
            onClick: onClick,
            onFocus: createOnFocus(tooltipProps.onFocus),
            onBlur: createOnBlur(tooltipProps.onBlur),
            className: (0, $7JEyt.default)([
                "_kqswstnw _154i1lpd _1ltv14id _1bsb1r7l _4t3i19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
                "_1pbyibnn"
            ])
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        ref: (0, $jaTu3.mergeRefs)([
            element,
            createTriggerRef
        ]),
        "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: onActiveOld,
        onMouseLeave: onInactive,
        onFocus: onActiveOld,
        onBlur: onInactive,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154i196n _1ltvx0bf _1bsb1r7l _4t3iutpp _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
            "_1pbyibnn"
        ])
    });
};
const $cfebf2624394b8c9$var$CreateSiblingButtonOld = ({ id: id, level: level, depth: depth, parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
    const element = (0, $eUqFw.useRef)(null);
    const { onAddButtonMouseEnter: onAddButtonMouseEnter, onAddButtonMouseLeave: onAddButtonMouseLeave } = (0, $bwj1b.useSideEffectMarshal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        event.stopPropagation();
        (0, $75e8i.default)('timeline-add-item-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'issueCreateButton',
            attributes: {
                position: (0, $gf0vG.BEFORE),
                level: level,
                depth: depth
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        // Hide the button after activating the input
        onAddButtonMouseLeave();
        onInlineCreateClicked({
            beforeId: id,
            parentId: parentId,
            position: (0, $gf0vG.BEFORE)
        });
    }, [
        createAnalyticsEvent,
        level,
        depth,
        onAddButtonMouseLeave,
        onInlineCreateClicked,
        id,
        parentId
    ]);
    const onActiveOld = (0, $eUqFw.useCallback)(()=>{
        if (element.current) {
            const { top: top } = element.current.getBoundingClientRect();
            onAddButtonMouseEnter(top);
        }
    }, [
        onAddButtonMouseEnter
    ]);
    const onActiveHandler = (0, $eUqFw.useCallback)((tabFocused)=>{
        if (element.current) {
            const { top: top } = element.current.getBoundingClientRect();
            onAddButtonMouseEnter(top, tabFocused);
        }
    }, [
        onAddButtonMouseEnter
    ]);
    const onActive = (0, $eUqFw.useCallback)(()=>{
        onActiveHandler(false);
    }, [
        onActiveHandler
    ]);
    const onActiveFocus = (0, $eUqFw.useCallback)(()=>{
        onActiveHandler(true);
    }, [
        onActiveHandler
    ]);
    const onInactive = (0, $eUqFw.useCallback)(()=>{
        onAddButtonMouseLeave();
    }, [
        onAddButtonMouseLeave
    ]);
    const createOnFocus = (tooltipCallback)=>(e)=>{
            onActiveFocus();
            tooltipCallback(e);
        };
    const createOnBlur = (tooltipCallback)=>(e)=>{
            onInactive();
            tooltipCallback(e);
        };
    return (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label,
        position: "left"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ...tooltipProps,
            ref: (0, $jaTu3.mergeRefs)([
                tooltipProps.ref,
                element
            ]),
            "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
            "aria-label": label,
            onMouseEnter: onActive,
            onMouseLeave: onInactive,
            onClick: onClick,
            onFocus: createOnFocus(tooltipProps.onFocus),
            onBlur: createOnBlur(tooltipProps.onBlur),
            className: (0, $7JEyt.default)([
                "_kqswstnw _154i1lpd _1ltv14id _1bsb1r7l _4t3i19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
                "_1pbyibnn"
            ])
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        ref: element,
        "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: onActiveOld,
        onMouseLeave: onInactive,
        onFocus: onActiveOld,
        onBlur: onInactive,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154i196n _1ltvx0bf _1bsb1r7l _4t3iutpp _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
            "_1pbyibnn"
        ])
    });
};
var $cfebf2624394b8c9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((0, $dnJL9.componentWithFG)('jsw_roadmaps_timeline_table_meatballs_menu_a11y', $cfebf2624394b8c9$var$CreateSiblingButton, $cfebf2624394b8c9$var$CreateSiblingButtonOld));

});

parcelRegister("hQQ6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7211de5e63c01c6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $c6CvK = parcelRequire("c6CvK");

var $fCmfi = parcelRequire("fCmfi");

var $75e8i = parcelRequire("75e8i");
const $a7211de5e63c01c6$var$buttonStyles = null;
const $a7211de5e63c01c6$var$ExpandButton = ({ id: id, label: label, isExpanded: isExpanded, ariaControls: ariaControls, onExpandChanged: onExpandChanged })=>{
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        event.stopPropagation();
        (0, $75e8i.default)('timeline-expand-changed', event.timeStamp);
        onExpandChanged(id, isExpanded);
    }, [
        id,
        isExpanded,
        onExpandChanged
    ]);
    const Chevron = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))) : (0, (/*@__PURE__*/$parcel$interopDefault($fCmfi)));
    const chevronElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        testId: `roadmap.timeline-table.components.list-item.expand-button.container-${id}`,
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        onClick: onClick,
        "aria-expanded": isExpanded,
        "aria-label": label,
        ...isExpanded && ariaControls && {
            'aria-controls': ariaControls
        },
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
        ])
    }, chevronElement);
};
var $a7211de5e63c01c6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a7211de5e63c01c6$var$ExpandButton);

});

parcelRegister("KAROR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bedbe9cdb96e970c$export$2e2bcd8739ae039);
/* index-old.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $e9T6i = parcelRequire("e9T6i");

var $gIpo4 = parcelRequire("gIpo4");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");


var $8rQuz = parcelRequire("8rQuz");

var $75e8i = parcelRequire("75e8i");
const $bedbe9cdb96e970c$var$buttonStyles = null;
const $bedbe9cdb96e970c$var$ChevronWrapper = ({ children: children })=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        testId: "roadmap.timeline-table.main.content.list.list-item.expand-button.wrapper",
        justifyContent: "center",
        alignItems: "center",
        xcss: $bedbe9cdb96e970c$var$containerStyles
    }, children) : children;
const $bedbe9cdb96e970c$var$ExpandButton = ({ id: id, label: label, isRichContentEnabled: isRichContentEnabled, isExpanded: isExpanded, ariaControls: ariaControls, onExpandChanged: onExpandChanged })=>{
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        event.stopPropagation();
        (0, $75e8i.default)('timeline-expand-changed', event.timeStamp);
        onExpandChanged(id, isExpanded);
    }, [
        id,
        isExpanded,
        onExpandChanged
    ]);
    const Chevron = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))) : (0, (/*@__PURE__*/$parcel$interopDefault($gIpo4)));
    const chevronElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bedbe9cdb96e970c$var$ChevronWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        testId: `roadmap.timeline-table.components.list-item.expand-button.container-${id}`,
        color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        label: label
    }));
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isRichContentEnabled) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        onClick: onClick,
        "aria-expanded": isExpanded,
        "aria-label": label,
        ...isExpanded && ariaControls && {
            'aria-controls': ariaControls
        },
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
        ])
    }, chevronElement);
};
var $bedbe9cdb96e970c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bedbe9cdb96e970c$var$ExpandButton);
const $bedbe9cdb96e970c$var$containerStyles = (0, $1ZAYh.xcss)({
    width: '24px',
    height: '24px'
});

});

parcelRegister("lqIGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e6dcfb02fe3d9a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $fWMFg = parcelRequire("fWMFg");
const $18e6dcfb02fe3d9a$var$ListItemMeatBallsButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "timeline-table-list-item-meatballs-button",
        packageName: "timelineTable",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWMFg.default), props));
var $18e6dcfb02fe3d9a$export$2e2bcd8739ae039 = $18e6dcfb02fe3d9a$var$ListItemMeatBallsButton;

});
parcelRegister("fWMFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e10ec2fac48462$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");

var $nH3p1 = parcelRequire("nH3p1");

var $8hFGR = parcelRequire("8hFGR");

var $1TXmn = parcelRequire("1TXmn");

var $eldR2 = parcelRequire("eldR2");
const $91e10ec2fac48462$var$MeatBallsButton = ({ isTriggerVisible: isTriggerVisible = true, isMenuOpen: isMenuOpen, id: id, level: level, depth: depth, parentId: parentId, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal, onStopHoverOrFocus: onStopHoverOrFocus, onInlineCreateClicked: onInlineCreateClicked, onDrop: onDrop, setIsMenuOpen: setIsMenuOpen, cellRef: cellRef })=>{
    const [activeOptionId, setActiveOptionId] = (0, $eUqFw.useState)('');
    const [{ customSections: customSections }] = (0, $nH3p1.useListItemMenuOptions)();
    const [{ isDragEnabled: isDragEnabled }] = (0, $9WNLk.useEnablements)();
    const [isActiveMeatballTrigger] = (0, $8hFGR.useIsCreateTriggerActive)({
        id: id,
        type: 'MEATBALLS'
    });
    const { shouldPreventNavigation: shouldPreventNavigation } = (0, $8hFGR.useFocusMarshal)();
    const returnFocus = (0, $eUqFw.useRef)(false);
    const ref = (0, $eUqFw.useRef)(null);
    const menuRef = (0, $eUqFw.useRef)(null);
    const closeMenu = (0, $eUqFw.useCallback)(()=>{
        setIsMenuOpen(false);
    }, [
        setIsMenuOpen
    ]);
    // Manages the refocusing of the meatballs trigger when the menu is closed
    (0, $eUqFw.useEffect)(()=>{
        if (!isMenuOpen && returnFocus.current) {
            returnFocus.current = false;
            // Timeout is added here to ensure refocusing works correctly in cypress tests.
            setTimeout(()=>{
                ref.current?.focus();
            }, 0);
        }
    }, [
        isMenuOpen
    ]);
    (0, $1TXmn.useOnClickOutside)({
        cellRef: cellRef,
        menuRef: menuRef,
        triggerRef: ref,
        closeMenu: closeMenu,
        isMenuOpen: isMenuOpen,
        onStopHoverOrFocus: onStopHoverOrFocus
    });
    const [customItemsSections, customOtherSections] = (0, $eUqFw.useMemo)(()=>{
        const itemsSections = [];
        const otherSections = [];
        customSections.forEach((section)=>{
            if (section.id === (0, $gf0vG.listItemMenu).ITEMS_SECTION) itemsSections.push(section);
            else otherSections.push(section);
        });
        return [
            itemsSections,
            otherSections
        ];
    }, [
        customSections
    ]);
    const setCloseMenu = (0, $eUqFw.useCallback)((event, { shouldReturnFocus: shouldReturnFocus, shouldEnableNavigation: shouldEnableNavigation } = {
        shouldReturnFocus: true,
        shouldEnableNavigation: true
    })=>{
        const isMouseClick = event?.detail && event.detail > 0;
        const shouldStopFocus = isMouseClick || shouldReturnFocus === false;
        returnFocus.current = !shouldStopFocus;
        setIsMenuOpen(false);
        if (shouldStopFocus) onStopHoverOrFocus();
        if (shouldEnableNavigation && (0, $eI5EY.fg)('timeline_grid_navigation_m2')) shouldPreventNavigation(false);
    }, [
        shouldPreventNavigation,
        onStopHoverOrFocus,
        setIsMenuOpen
    ]);
    const onMenuToggle = (0, $eUqFw.useCallback)(()=>{
        setIsMenuOpen((currentState)=>!currentState);
    }, [
        setIsMenuOpen
    ]);
    const setOpenModal = (0, $eUqFw.useCallback)((event, optionId)=>{
        (0, $eI5EY.fg)('timeline_grid_navigation_m2') ? setCloseMenu(event, {
            shouldEnableNavigation: false
        }) : setCloseMenu(event);
        setActiveOptionId(optionId);
    }, [
        setCloseMenu
    ]);
    const setCloseModal = (0, $eUqFw.useCallback)(()=>{
        setActiveOptionId('');
        if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) shouldPreventNavigation(false);
    }, [
        shouldPreventNavigation
    ]);
    const onStopPropagation = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    const onStopDragging = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    const prebuiltOptions = (0, $eUqFw.useMemo)(()=>{
        const options = [];
        if (isCreateChildEnabled || isCreateSiblingEnabled) options.push({
            id: (0, $gf0vG.listItemMenu).CREATE_ITEM
        });
        if ((0, $eI5EY.fg)('jsw_roadmap_timeline_meatball_move_menu')) {
            if (isDragEnabled) options.push({
                id: (0, $gf0vG.listItemMenu).MOVE_ITEM
            });
        }
        return options;
    }, [
        isCreateChildEnabled,
        isCreateSiblingEnabled,
        isDragEnabled
    ]);
    const issuesSectionOptions = (0, $eUqFw.useMemo)(()=>{
        const issuesSectionCustomOptions = customItemsSections.reduce((acc, { options: options })=>{
            acc.push(...options);
            return acc;
        }, []);
        return [
            ...prebuiltOptions,
            ...issuesSectionCustomOptions
        ];
    }, [
        customItemsSections,
        prebuiltOptions
    ]);
    if (issuesSectionOptions.length > 0 || customSections.length > 0) // NOTE: Neither wrappers below are interactive (and should be invisible to assistive technology)
    // They are event suppressors to stop any interactions seeping into the gridcell which will have unexpected behavior like triggering the issue view panel
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "presentation",
        onClick: onStopPropagation,
        draggable: true,
        onDragStart: onStopDragging
    }, isTriggerVisible || isActiveMeatballTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eldR2.default), {
        id: id,
        isOpen: isMenuOpen,
        onMenuToggle: onMenuToggle,
        setCloseMenu: setCloseMenu,
        setOpenModal: setOpenModal,
        issuesSectionOptions: issuesSectionOptions,
        customOtherSections: customOtherSections,
        parentId: parentId,
        level: level,
        depth: depth,
        isCreateChildEnabled: isCreateChildEnabled,
        isCreateSiblingEnabled: isCreateSiblingEnabled,
        onInlineCreateClicked: onInlineCreateClicked,
        renderListItemMenuOption: renderListItemMenuOption,
        onDrop: onDrop,
        ref: ref,
        menuRef: menuRef
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "presentation",
        onClick: onStopPropagation,
        onKeyUp: onStopPropagation
    }, renderListItemModal?.({
        id: id,
        optionId: activeOptionId,
        setCloseModal: setCloseModal,
        triggerRef: ref
    })));
    return null;
};
var $91e10ec2fac48462$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($91e10ec2fac48462$var$MeatBallsButton);

});
parcelRegister("1TXmn", function(module, exports) {

$parcel$export(module.exports, "useOnClickOutside", () => $339360155a288188$export$9afc64c180e82dc4);

var $eUqFw = parcelRequire("eUqFw");
const $339360155a288188$export$9afc64c180e82dc4 = ({ menuRef: menuRef, cellRef: cellRef, triggerRef: triggerRef, closeMenu: closeMenu, isMenuOpen: isMenuOpen, onStopHoverOrFocus: onStopHoverOrFocus })=>{
    (0, $eUqFw.useEffect)(()=>{
        const handleOnClickOutsideMenu = ({ target: target })=>{
            if (target instanceof Node) {
                // If the click is outside the item cell clear the cell focus and close the menu
                if (isMenuOpen && cellRef && !cellRef.current?.contains(target)) onStopHoverOrFocus?.();
                else if (isMenuOpen && !triggerRef.current?.contains(target) && !menuRef.current?.contains(target)) closeMenu();
            }
        };
        if (typeof document !== 'undefined') document.addEventListener('mousedown', handleOnClickOutsideMenu);
        return ()=>{
            if (typeof document !== 'undefined') document.removeEventListener('mousedown', handleOnClickOutsideMenu);
        };
    }, [
        cellRef,
        closeMenu,
        isMenuOpen,
        menuRef,
        onStopHoverOrFocus,
        triggerRef
    ]);
};

});

parcelRegister("eldR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $987dda7c731b9780$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jaTu3 = parcelRequire("jaTu3");

var $j9fWg = parcelRequire("j9fWg");

var $34Io4 = parcelRequire("34Io4");

var $8PFhw = parcelRequire("8PFhw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eI5EY = parcelRequire("eI5EY");

var $8rQuz = parcelRequire("8rQuz");

var $gf0vG = parcelRequire("gf0vG");

var $lSR7G = parcelRequire("lSR7G");

var $hxnNZ = parcelRequire("hxnNZ");

var $8hFGR = parcelRequire("8hFGR");

var $ikmG7 = parcelRequire("ikmG7");

var $2WYjl = parcelRequire("2WYjl");

var $3D3LC = parcelRequire("3D3LC");

var $7vI5o = parcelRequire("7vI5o");
const $987dda7c731b9780$var$MeatballPopup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ id: id, isOpen: isOpen, issuesSectionOptions: issuesSectionOptions, customOtherSections: customOtherSections, parentId: parentId, level: level, depth: depth, onDrop: onDrop, menuRef: menuRef, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, renderListItemMenuOption: renderListItemMenuOption, onMenuToggle: onMenuToggle, setCloseMenu: setCloseMenu, setOpenModal: setOpenModal }, ref)=>{
    const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, $ikmG7.useCreateTrigger)(id, 'MEATBALLS');
    const [isMultiSelected] = (0, $lSR7G.useIsItemMultiSelected)(id);
    const [isScrollingY] = (0, $hxnNZ.useIsScrollingY)();
    const [itemsSelectionCount] = (0, $lSR7G.useItemsSelectionCount)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let itemsSelectionAriaLabel = '';
    if (isMultiSelected) itemsSelectionAriaLabel = formatMessage((0, $2WYjl.default).itemsSelectionCount, {
        count: itemsSelectionCount
    });
    const { shouldPreventNavigation: shouldPreventNavigation } = (0, $8hFGR.useFocusMarshal)();
    // Manages closing the meatballs menu when the timeline is scrolled.
    (0, $eUqFw.useEffect)(()=>{
        if (isScrollingY && isOpen) setCloseMenu();
    }, [
        isOpen,
        isScrollingY,
        setCloseMenu
    ]);
    const renderMenu = (0, $eUqFw.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            ref: menuRef,
            xcss: $987dda7c731b9780$var$menuWrapStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), {
            testId: `roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.menu-${id}`,
            maxHeight: (0, $gf0vG.DEFAULT_MENU_MAX_HEIGHT)
        }, isMultiSelected && (0, $eI5EY.fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3D3LC.default), {
            id: id,
            renderListItemMenuOption: renderListItemMenuOption,
            setOpenModal: setOpenModal,
            onCreateTriggerClick: onCreateTriggerClick,
            setInitialFocusRef: setInitialFocusRef,
            setCloseMenu: setCloseMenu
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vI5o.default), {
            issuesSectionOptions: issuesSectionOptions,
            customOtherSections: customOtherSections,
            id: id,
            parentId: parentId,
            level: level,
            depth: depth,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            onInlineCreateClicked: onInlineCreateClicked,
            setInitialFocusRef: setInitialFocusRef,
            onDrop: onDrop,
            renderListItemMenuOption: renderListItemMenuOption,
            setCloseMenu: setCloseMenu,
            setOpenModal: setOpenModal,
            onCreateTriggerClick: onCreateTriggerClick
        }))), [
        customOtherSections,
        depth,
        id,
        isCreateChildEnabled,
        isCreateSiblingEnabled,
        isMultiSelected,
        issuesSectionOptions,
        level,
        menuRef,
        onCreateTriggerClick,
        onDrop,
        onInlineCreateClicked,
        parentId,
        renderListItemMenuOption,
        setCloseMenu,
        setOpenModal
    ]);
    const onClick = (0, $eUqFw.useCallback)((e)=>{
        shouldPreventNavigation(true);
        onMenuToggle(e);
    }, [
        shouldPreventNavigation,
        onMenuToggle
    ]);
    const trigger = (0, $eUqFw.useCallback)(({ ref: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $987dda7c731b9780$var$buttonWrapStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            ...triggerProps,
            ref: (0, $jaTu3.mergeRefs)([
                ref,
                createTriggerRef,
                triggerRef
            ]),
            onClick: (0, $eI5EY.fg)('timeline_grid_navigation_m2') ? onClick : onMenuToggle,
            spacing: "compact",
            testId: `roadmap.timeline-table.main.content.list.list-item.more-options-button.meatballs-menu-${id}`,
            label: itemsSelectionAriaLabel && (0, $eI5EY.fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? `${formatMessage((0, $2WYjl.default).meatballsButtonLabel)} ${itemsSelectionAriaLabel}` : formatMessage((0, $2WYjl.default).meatballsButtonLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Io4))),
            interactionName: "timeline-meatballs-trigger-clicked",
            appearance: (0, $8rQuz.isVisualRefreshEnabled)() ? 'subtle' : 'default'
        })), [
        createTriggerRef,
        formatMessage,
        id,
        itemsSelectionAriaLabel,
        onClick,
        onMenuToggle,
        ref
    ]);
    const onPopupClose = (0, $eUqFw.useCallback)((event)=>setCloseMenu(event), [
        setCloseMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        role: "dialog",
        shouldFlip: false,
        shouldRenderToParent: true,
        shouldReturnFocus: false,
        shouldUseCaptureOnOutsideClick: true,
        onClose: onPopupClose,
        placement: "right-start",
        isOpen: isOpen,
        content: renderMenu,
        trigger: trigger
    });
});
const $987dda7c731b9780$var$buttonWrapStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050'
});
const $987dda7c731b9780$var$menuWrapStyles = (0, $1ZAYh.xcss)({
    cursor: 'default'
});
var $987dda7c731b9780$export$2e2bcd8739ae039 = $987dda7c731b9780$var$MeatballPopup;

});
parcelRegister("2WYjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aea454e3cf0f18d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $1aea454e3cf0f18d$var$messages = (0, $90IgZ.defineMessages)({
    meatballsButtonLabel: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.meatballs-button-label',
        defaultMessage: 'More actions',
        description: 'Label for the more options button in the list item'
    },
    itemsSectionHeader: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.items-section-header',
        defaultMessage: 'Items',
        description: 'Header for the item section in the list item'
    },
    itemsSelectionCount: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.items-selection-count',
        defaultMessage: '{count} {count, plural, one {item selected} other {items selected}}',
        description: 'Label to indicate the count of selected items on a meatballs button'
    }
});
var $1aea454e3cf0f18d$export$2e2bcd8739ae039 = $1aea454e3cf0f18d$var$messages;

});

parcelRegister("3D3LC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d073bc3cf3f0b745$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $9nkwJ = parcelRequire("9nkwJ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $gf0vG = parcelRequire("gf0vG");

var $lSR7G = parcelRequire("lSR7G");

var $nH3p1 = parcelRequire("nH3p1");

var $lAWH7 = parcelRequire("lAWH7");

var $hqxYn = parcelRequire("hqxYn");
const $d073bc3cf3f0b745$var$MultiSelectOptions = ({ id: id, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, renderListItemMenuOption: renderListItemMenuOption })=>{
    const [{ overrideLabels: overrideLabels, customSectionsBulk: customSectionsBulk }] = (0, $nH3p1.useListItemMenuOptions)();
    const [itemsSelectionCount] = (0, $lSR7G.useItemsSelectionCount)();
    const isLabelOverridden = Boolean(overrideLabels[(0, $gf0vG.listItemMenu).SELECTED_ITEM_COUNTER]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.multi-select-options.section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d073bc3cf3f0b745$var$bulkIndicatorContainer,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...isLabelOverridden ? overrideLabels[(0, $gf0vG.listItemMenu).SELECTED_ITEM_COUNTER] : (0, $hqxYn.default).selected,
        values: {
            count: itemsSelectionCount,
            badge: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                    appearance: "primary"
                }, chunks)
        }
    }))), customSectionsBulk.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lAWH7.default), {
        id: id,
        customOtherSections: customSectionsBulk,
        onCreateTriggerClick: onCreateTriggerClick,
        setCloseMenu: setCloseMenu,
        setInitialFocusRef: setInitialFocusRef,
        setOpenModal: setOpenModal,
        renderListItemMenuOption: renderListItemMenuOption
    }));
};
const $d073bc3cf3f0b745$var$bulkIndicatorContainer = (0, $1ZAYh.xcss)({
    display: 'flex',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    textTransform: 'uppercase',
    alignItems: 'center',
    height: "var(--ds-space-400, 32px)",
    color: 'color.text.subtle',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    gap: 'space.100'
});
var $d073bc3cf3f0b745$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d073bc3cf3f0b745$var$MultiSelectOptions);

});
parcelRegister("lAWH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $156d0abc6753c925$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $6t2Uj = parcelRequire("6t2Uj");

var $8NB6b = parcelRequire("8NB6b");
const $156d0abc6753c925$var$CustomOptions = ({ id: id, customOtherSections: customOtherSections, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, renderListItemMenuOption: renderListItemMenuOption })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, customOtherSections.map(({ id: sectionId, title: title, options: options })=>{
        if (!options || options.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $156d0abc6753c925$var$sectionWrap,
            key: sectionId,
            testId: `roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.custom-options.${sectionId}`
        }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $156d0abc6753c925$var$headingWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "xxsmall",
            as: "div"
        }, (0, $8NB6b.renderOverrideLabel)(formatMessage, title))), options.map(({ id: optionId }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                key: optionId
            }, renderListItemMenuOption({
                id: id,
                optionId: optionId,
                setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                setOpenModal: (event)=>{
                    setOpenModal(event, optionId);
                },
                Option: (0, $6t2Uj.ListItemMenuOption),
                onCreateTriggerClick: onCreateTriggerClick,
                setCloseMenu: setCloseMenu
            }))));
    }));
};
const $156d0abc6753c925$var$headingWrap = (0, $1ZAYh.xcss)({
    marginTop: 'space.250',
    marginBottom: 'space.075',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $156d0abc6753c925$var$sectionWrap = (0, $1ZAYh.xcss)({
    borderTop: '1px solid',
    borderColor: 'color.border',
    marginTop: 'space.075'
});
var $156d0abc6753c925$export$2e2bcd8739ae039 = $156d0abc6753c925$var$CustomOptions;

});
parcelRegister("6t2Uj", function(module, exports) {

$parcel$export(module.exports, "ListItemMenuOption", () => $b23b4ff91ced8a39$export$6c14ffa7379dfa2e);

var $eUqFw = parcelRequire("eUqFw");

var $jaTu3 = parcelRequire("jaTu3");

var $bULPy = parcelRequire("bULPy");

var $2eG9N = parcelRequire("2eG9N");

var $5QYdT = parcelRequire("5QYdT");
const $b23b4ff91ced8a39$export$6c14ffa7379dfa2e = ({ isDisabled: isDisabled, label: label, disabledTooltip: disabledTooltip, triggerRef: triggerRef, onClick: onClick, setInitialFocusRef: setInitialFocusRef, children: children })=>{
    const renderButtonItem = (0, $eUqFw.useCallback)((triggerProps)=>{
        const refs = [];
        if (setInitialFocusRef) refs.push(setInitialFocusRef);
        if (triggerProps?.ref) refs.push(triggerProps.ref);
        if (triggerRef) refs.push(triggerRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
            ...triggerProps,
            isDisabled: isDisabled,
            onClick: onClick,
            ref: (0, $jaTu3.mergeRefs)(refs)
        }, label);
    }, [
        isDisabled,
        label,
        onClick,
        triggerRef,
        setInitialFocusRef
    ]);
    if (children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QYdT.default), {
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        label: label,
        setInitialFocusRef: setInitialFocusRef,
        triggerRef: triggerRef
    }, children);
    return isDisabled && disabledTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: disabledTooltip
    }, renderButtonItem) : renderButtonItem();
};

});
parcelRegister("5QYdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c693afc99c90605$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jaTu3 = parcelRequire("jaTu3");

var $gIpo4 = parcelRequire("gIpo4");

var $bULPy = parcelRequire("bULPy");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");

var $2eG9N = parcelRequire("2eG9N");

var $1TXmn = parcelRequire("1TXmn");
const $2c693afc99c90605$var$PopupButton = ({ label: label, isDisabled: isDisabled, disabledTooltip: disabledTooltip, triggerRef: triggerRef, setInitialFocusRef: setInitialFocusRef, children: children })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const menuRef = (0, $eUqFw.useRef)(null);
    const ref = (0, $eUqFw.useRef)(null);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const onMenuToggle = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        setIsOpen((currentState)=>!currentState);
    }, []);
    (0, $1TXmn.useOnClickOutside)({
        menuRef: menuRef,
        closeMenu: onClose,
        isMenuOpen: isOpen,
        triggerRef: ref
    });
    const renderContent = (0, $eUqFw.useCallback)(({ setInitialFocusRef: setFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            ref: menuRef,
            testId: "roadmap.timeline-table.main.content.list.list-item.list-item-menu-option.popup-button.content"
        }, children({
            setInitialFocusRef: setFocusRef
        })), [
        children
    ]);
    const renderButtonItem = (0, $eUqFw.useCallback)((popupTriggerProps, tooltipTriggerProps)=>{
        const refs = [
            popupTriggerProps.ref
        ];
        if (tooltipTriggerProps?.ref) refs.push(tooltipTriggerProps.ref);
        if (setInitialFocusRef) refs.push(setInitialFocusRef);
        if (triggerRef) refs.push(triggerRef);
        refs.push(ref);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
            ...tooltipTriggerProps,
            ...popupTriggerProps,
            onClick: onMenuToggle,
            isDisabled: isDisabled,
            iconAfter: !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIpo4))), {
                color: "var(--ds-icon-subtle)",
                label: "",
                testId: "roadmap.timeline-table.main.content.list.list-item.list-item-menu-option.popup-button.chevron-right-icon"
            }) : undefined,
            ref: (0, $jaTu3.mergeRefs)(refs)
        }, label);
    }, [
        isDisabled,
        label,
        onMenuToggle,
        setInitialFocusRef,
        triggerRef
    ]);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>isDisabled && disabledTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: disabledTooltip
        }, (tooltipProps)=>renderButtonItem(triggerProps, tooltipProps)) : renderButtonItem(triggerProps), [
        isDisabled,
        disabledTooltip,
        renderButtonItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        role: "dialog",
        shouldRenderToParent: true,
        shouldUseCaptureOnOutsideClick: true,
        isOpen: isOpen,
        placement: "right-start",
        onClose: onClose,
        content: renderContent,
        trigger: trigger
    });
};
var $2c693afc99c90605$export$2e2bcd8739ae039 = $2c693afc99c90605$var$PopupButton;

});


parcelRegister("8NB6b", function(module, exports) {

$parcel$export(module.exports, "renderOverrideLabel", () => $20e3be7392b73da7$export$9f99feb062b3eb64);
const $20e3be7392b73da7$export$9f99feb062b3eb64 = (formatMessage, descriptor, values)=>{
    if (descriptor) return formatMessage(descriptor, values);
};

});


parcelRegister("hqxYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $91d92c77c5a176ff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $91d92c77c5a176ff$var$messages = (0, $90IgZ.defineMessages)({
    selected: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.multi-select-options.selected',
        description: 'Label to indicate the number of selected item on a meatballs menu',
        defaultMessage: '<badge>{count}</badge> selected'
    }
});
var $91d92c77c5a176ff$export$2e2bcd8739ae039 = $91d92c77c5a176ff$var$messages;

});


parcelRegister("7vI5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e263b7dccb974c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $gf0vG = parcelRequire("gf0vG");

var $nH3p1 = parcelRequire("nH3p1");

var $8NB6b = parcelRequire("8NB6b");

var $lAWH7 = parcelRequire("lAWH7");

var $kHKNT = parcelRequire("kHKNT");

var $2WYjl = parcelRequire("2WYjl");
const $c9e263b7dccb974c$var$SingleSelectOptions = ({ issuesSectionOptions: issuesSectionOptions, customOtherSections: customOtherSections, id: id, parentId: parentId, level: level, depth: depth, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, renderListItemMenuOption: renderListItemMenuOption, onInlineCreateClicked: onInlineCreateClicked, onDrop: onDrop, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, onCreateTriggerClick: onCreateTriggerClick })=>{
    const [{ overrideLabels: overrideLabels }] = (0, $nH3p1.useListItemMenuOptions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const headingLabel = (0, $8NB6b.renderOverrideLabel)(formatMessage, overrideLabels[(0, $gf0vG.listItemMenu).ITEMS_SECTION]) || formatMessage((0, $2WYjl.default).itemsSectionHeader);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issuesSectionOptions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.single-select-options.items-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c9e263b7dccb974c$var$headingWrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xxsmall",
        as: "div",
        testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.single-select-options.heading"
    }, headingLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHKNT.default), {
        issuesSectionOptions: issuesSectionOptions,
        id: id,
        parentId: parentId,
        level: level,
        depth: depth,
        isCreateChildEnabled: isCreateChildEnabled,
        isCreateSiblingEnabled: isCreateSiblingEnabled,
        onInlineCreateClicked: onInlineCreateClicked,
        setInitialFocusRef: setInitialFocusRef,
        onDrop: onDrop,
        renderListItemMenuOption: renderListItemMenuOption,
        onCreateTriggerClick: onCreateTriggerClick,
        setCloseMenu: setCloseMenu,
        setOpenModal: setOpenModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lAWH7.default), {
        id: id,
        customOtherSections: customOtherSections,
        onCreateTriggerClick: onCreateTriggerClick,
        setCloseMenu: setCloseMenu,
        setInitialFocusRef: issuesSectionOptions.length === 0 ? setInitialFocusRef : undefined,
        setOpenModal: setOpenModal,
        renderListItemMenuOption: renderListItemMenuOption
    }));
};
const $c9e263b7dccb974c$var$headingWrap = (0, $1ZAYh.xcss)({
    marginTop: 'space.250',
    marginBottom: 'space.075',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
var $c9e263b7dccb974c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c9e263b7dccb974c$var$SingleSelectOptions);

});
parcelRegister("kHKNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $be17140062ffdf46$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $6t2Uj = parcelRequire("6t2Uj");

var $8Rppc = parcelRequire("8Rppc");

var $kV8iI = parcelRequire("kV8iI");
const $be17140062ffdf46$var$ItemSectionOptions = ({ id: id, parentId: parentId, level: level, depth: depth, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, issuesSectionOptions: issuesSectionOptions, setInitialFocusRef: setInitialFocusRef, renderListItemMenuOption: renderListItemMenuOption, setCloseMenu: setCloseMenu, setOpenModal: setOpenModal, onDrop: onDrop, onCreateTriggerClick: onCreateTriggerClick })=>issuesSectionOptions.map(({ id: optionId }, index)=>{
        switch(optionId){
            case (0, $gf0vG.listItemMenu).CREATE_ITEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Rppc.default), {
                    key: optionId,
                    id: id,
                    parentId: parentId,
                    level: level,
                    depth: depth,
                    isCreateChildEnabled: isCreateChildEnabled,
                    isCreateSiblingEnabled: isCreateSiblingEnabled,
                    onInlineCreateClicked: onInlineCreateClicked,
                    setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                    onCreateTriggerClick: onCreateTriggerClick,
                    setCloseMenu: setCloseMenu
                });
            case (0, $gf0vG.listItemMenu).MOVE_ITEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kV8iI.default), {
                    id: id,
                    key: optionId,
                    level: level,
                    parentId: parentId,
                    setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                    onDrop: onDrop,
                    setCloseMenu: setCloseMenu
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                    key: optionId
                }, renderListItemMenuOption({
                    id: id,
                    optionId: optionId,
                    setOpenModal: (event)=>setOpenModal(event, optionId),
                    setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                    Option: (0, $6t2Uj.ListItemMenuOption),
                    onCreateTriggerClick: onCreateTriggerClick,
                    setCloseMenu: setCloseMenu
                }));
        }
    });
var $be17140062ffdf46$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($be17140062ffdf46$var$ItemSectionOptions);

});
parcelRegister("8Rppc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d9c27a7e2d7897e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $75e8i = parcelRequire("75e8i");

var $gf0vG = parcelRequire("gf0vG");

var $nH3p1 = parcelRequire("nH3p1");

var $eKKjG = parcelRequire("eKKjG");

var $6t2Uj = parcelRequire("6t2Uj");

var $8NB6b = parcelRequire("8NB6b");

var $j5MGQ = parcelRequire("j5MGQ");
const $1d9c27a7e2d7897e$var$CreateItemMenu = ({ id: id, level: level, depth: depth, parentId: parentId, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, setInitialFocusRef: setInitialFocusRef, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ overrideLabels: overrideLabels }] = (0, $nH3p1.useListItemMenuOptions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickCreateChildOption = (0, $eUqFw.useCallback)((event)=>{
        onCreateTriggerClick();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createChildMenuOption',
            attributes: {
                position: (0, $gf0vG.INSIDE)
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        (0, $75e8i.default)('timeline-create-child-option-clicked', event.timeStamp);
        onInlineCreateClicked({
            parentId: id,
            position: (0, $gf0vG.INSIDE)
        });
        setCloseMenu(event, {
            shouldReturnFocus: false
        });
    }, [
        createAnalyticsEvent,
        id,
        onCreateTriggerClick,
        onInlineCreateClicked,
        setCloseMenu
    ]);
    const onClickCreateSiblingAboveOption = (0, $eUqFw.useCallback)((event)=>{
        onCreateTriggerClick();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createAboveMenuOption',
            attributes: {
                position: (0, $gf0vG.BEFORE),
                level: level,
                depth: depth
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        (0, $75e8i.default)('timeline-create-above-option-clicked', event.timeStamp);
        onInlineCreateClicked({
            beforeId: id,
            parentId: parentId,
            position: (0, $gf0vG.BEFORE)
        });
        setCloseMenu(event, {
            shouldReturnFocus: false
        });
    }, [
        createAnalyticsEvent,
        depth,
        id,
        level,
        onCreateTriggerClick,
        onInlineCreateClicked,
        parentId,
        setCloseMenu
    ]);
    const createItemChildOptions = (0, $eUqFw.useMemo)(()=>{
        const options = [];
        if (isCreateChildEnabled) options.push({
            id: (0, $gf0vG.listItemMenu).CREATE_CHILD_ITEM,
            onClick: onClickCreateChildOption
        });
        if (isCreateSiblingEnabled) options.push({
            id: (0, $gf0vG.listItemMenu).CREATE_ITEM_ABOVE,
            onClick: onClickCreateSiblingAboveOption
        });
        return options;
    }, [
        isCreateChildEnabled,
        isCreateSiblingEnabled,
        onClickCreateChildOption,
        onClickCreateSiblingAboveOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6t2Uj.ListItemMenuOption), {
        setInitialFocusRef: setInitialFocusRef,
        label: (0, $8NB6b.renderOverrideLabel)(formatMessage, overrideLabels[(0, $gf0vG.listItemMenu).CREATE_ITEM]) || formatMessage((0, $j5MGQ.default).createItem)
    }, ({ setInitialFocusRef: setChildFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, createItemChildOptions.map(({ id: optionId, onClick: onClick }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6t2Uj.ListItemMenuOption), {
                key: optionId,
                label: (0, $8NB6b.renderOverrideLabel)(formatMessage, overrideLabels[optionId]) || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                formatMessage((0, $j5MGQ.default)[optionId]),
                setInitialFocusRef: index === 0 ? setChildFocusRef : undefined,
                onClick: onClick
            }))));
};
var $1d9c27a7e2d7897e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1d9c27a7e2d7897e$var$CreateItemMenu);

});
parcelRegister("j5MGQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a99bfadf3235c70f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $a99bfadf3235c70f$var$messages = (0, $90IgZ.defineMessages)({
    createItem: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item',
        defaultMessage: 'Create',
        description: 'Label for the create option in the list item menu'
    },
    createChildItem: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-child-item',
        defaultMessage: 'Create child',
        description: 'Label for the create child option in the list item menu'
    },
    createItemAbove: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item-above',
        defaultMessage: 'Create above',
        description: 'Label for the create above option in the list item menu'
    },
    createItemBelow: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item-below',
        defaultMessage: 'Create below',
        description: 'Label for the create below option in the list item menu'
    }
});
var $a99bfadf3235c70f$export$2e2bcd8739ae039 = $a99bfadf3235c70f$var$messages;

});


parcelRegister("kV8iI", function(module, exports) {

$parcel$export(module.exports, "default", () => $65d0b97bbed1ea0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $75e8i = parcelRequire("75e8i");

var $gf0vG = parcelRequire("gf0vG");

var $lSR7G = parcelRequire("lSR7G");

var $nH3p1 = parcelRequire("nH3p1");

var $6t2Uj = parcelRequire("6t2Uj");

var $8NB6b = parcelRequire("8NB6b");

var $keDqz = parcelRequire("keDqz");
const $65d0b97bbed1ea0e$var$MoveItemMenu = ({ id: id, level: level, parentId: parentId, onDrop: onDrop, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef })=>{
    const [items] = (0, $lSR7G.useItems)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ overrideLabels: overrideLabels }] = (0, $nH3p1.useListItemMenuOptions)();
    const siblingItemIds = (0, $eUqFw.useMemo)(()=>{
        const siblingIds = [];
        items.forEach((item)=>{
            const { type: type, meta: meta } = item;
            if (type === (0, $gf0vG.ITEM_TYPE)) {
                if (meta.parentId === parentId) siblingIds.push(item.item.id);
            }
        });
        return siblingIds;
    }, [
        items,
        parentId
    ]);
    const siblingItemsLength = siblingItemIds.length;
    const onMoveUp = (0, $eUqFw.useCallback)((event)=>{
        const currentIndex = siblingItemIds.findIndex((itemId)=>itemId === id);
        if (currentIndex > 0) {
            (0, $75e8i.default)('timeline-move-up-option-clicked', event.timeStamp);
            onDrop(id, {
                level: level,
                rankRequest: {
                    rankBeforeId: siblingItemIds[currentIndex - 1]
                },
                isMeatballsAction: true
            });
        }
    }, [
        id,
        level,
        siblingItemIds,
        onDrop
    ]);
    const onMoveDown = (0, $eUqFw.useCallback)((event)=>{
        const currentIndex = siblingItemIds.findIndex((itemId)=>itemId === id);
        if (currentIndex < siblingItemsLength - 1) {
            (0, $75e8i.default)('timeline-move-down-option-clicked', event.timeStamp);
            onDrop(id, {
                level: level,
                rankRequest: {
                    rankAfterId: siblingItemIds[currentIndex + 1]
                },
                isMeatballsAction: true
            });
        }
    }, [
        siblingItemIds,
        siblingItemsLength,
        id,
        onDrop,
        level
    ]);
    const onMoveToTop = (0, $eUqFw.useCallback)((event)=>{
        if (siblingItemsLength > 0) {
            (0, $75e8i.default)('timeline-move-to-top-option-clicked', event.timeStamp);
            onDrop(id, {
                level: level,
                rankRequest: {
                    rankBeforeId: siblingItemIds[0]
                },
                isMeatballsAction: true
            });
        }
    }, [
        siblingItemsLength,
        onDrop,
        id,
        level,
        siblingItemIds
    ]);
    const onMoveToBottom = (0, $eUqFw.useCallback)((event)=>{
        if (siblingItemsLength > 0) {
            (0, $75e8i.default)('timeline-move-to-bottom-option-clicked', event.timeStamp);
            onDrop(id, {
                level: level,
                rankRequest: {
                    rankAfterId: siblingItemIds[siblingItemsLength - 1]
                },
                isMeatballsAction: true
            });
        }
    }, [
        onDrop,
        id,
        level,
        siblingItemIds,
        siblingItemsLength
    ]);
    const moveItemChildOptions = (0, $eUqFw.useMemo)(()=>{
        const isMoveUpDisabled = !siblingItemsLength || id === siblingItemIds?.[0];
        const isMoveDownDisabled = !siblingItemsLength || id === siblingItemIds[siblingItemsLength - 1];
        const options = [
            {
                id: (0, $gf0vG.listItemMenu).MOVE_ITEM_UP,
                onClick: onMoveUp,
                isDisabled: isMoveUpDisabled
            },
            {
                id: (0, $gf0vG.listItemMenu).MOVE_ITEM_DOWN,
                onClick: onMoveDown,
                isDisabled: isMoveDownDisabled
            },
            {
                id: (0, $gf0vG.listItemMenu).MOVE_ITEM_TO_TOP,
                onClick: onMoveToTop,
                isDisabled: isMoveUpDisabled
            },
            {
                id: (0, $gf0vG.listItemMenu).MOVE_ITEM_TO_BOTTOM,
                onClick: onMoveToBottom,
                isDisabled: isMoveDownDisabled
            }
        ];
        return options;
    }, [
        id,
        onMoveDown,
        onMoveToBottom,
        onMoveToTop,
        onMoveUp,
        siblingItemIds,
        siblingItemsLength
    ]);
    const firstEnabledOptionIndex = moveItemChildOptions.findIndex((option)=>!option.isDisabled);
    const renderMoveItemChildOptions = (0, $eUqFw.useCallback)(({ id: optionId, onClick: onClick, isDisabled: isDisabled }, index, setChildFocusRef)=>{
        const handleClick = (e)=>{
            onClick(e);
            setCloseMenu(e);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6t2Uj.ListItemMenuOption), {
            key: optionId,
            label: (0, $8NB6b.renderOverrideLabel)(formatMessage, overrideLabels[optionId]) || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            formatMessage((0, $keDqz.default)[optionId]),
            setInitialFocusRef: firstEnabledOptionIndex === index ? setChildFocusRef : undefined,
            isDisabled: isDisabled,
            onClick: handleClick
        });
    }, [
        firstEnabledOptionIndex,
        formatMessage,
        overrideLabels,
        setCloseMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6t2Uj.ListItemMenuOption), {
        setInitialFocusRef: setInitialFocusRef,
        isDisabled: siblingItemsLength <= 1,
        label: (0, $8NB6b.renderOverrideLabel)(formatMessage, overrideLabels[(0, $gf0vG.listItemMenu).MOVE_ITEM]) || formatMessage((0, $keDqz.default).moveItem)
    }, ({ setInitialFocusRef: setChildFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, moveItemChildOptions.map((option, index)=>renderMoveItemChildOptions(option, index, setChildFocusRef))));
};
var $65d0b97bbed1ea0e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($65d0b97bbed1ea0e$var$MoveItemMenu);

});
parcelRegister("keDqz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a47f6cb60503968$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $0a47f6cb60503968$var$messages = (0, $90IgZ.defineMessages)({
    moveItem: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item',
        defaultMessage: 'Move',
        description: 'Label for the move option in the list item menu'
    },
    moveItemUp: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-up',
        defaultMessage: 'Move up',
        description: 'Label for the move up option in the list item menu'
    },
    moveItemDown: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-down',
        defaultMessage: 'Move down',
        description: 'Label for the move down option in the list item menu'
    },
    moveItemToTop: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-to-top',
        defaultMessage: 'Move to top',
        description: 'Label for the move to top option in the list item menu'
    },
    moveItemToBottom: {
        id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-to-bottom',
        defaultMessage: 'Move to bottom',
        description: 'Label for the move to bottom option in the list item menu'
    }
});
var $0a47f6cb60503968$export$2e2bcd8739ae039 = $0a47f6cb60503968$var$messages;

});







parcelRegister("bt6fG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86f8e9d8cd16bb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c86f8e9d8cd16bb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    expand: {
        id: 'roadmap.timeline-table.main.content.list.list-item.expand',
        defaultMessage: 'Show child issues',
        description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
    },
    collapse: {
        id: 'roadmap.timeline-table.main.content.list.list-item.collapse',
        defaultMessage: 'Hide child issues',
        description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
    },
    createSibling: {
        id: 'roadmap.timeline-table.main.content.list.list-item.create-sibling',
        defaultMessage: 'Create issue',
        description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
    },
    createChild: {
        id: 'roadmap.timeline-table.main.content.list.list-item.create-child',
        defaultMessage: 'Create child issue',
        description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
    },
    done: {
        id: 'roadmap.timeline-table.main.content.list.list-item.done',
        defaultMessage: 'Done',
        description: 'Icon label. Icon appears when issue is in the done status category.'
    }
});

});

parcelRegister("b0Luy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee035afa777d631b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bT7k5 = parcelRequire("bT7k5");

var $3KfMp = parcelRequire("3KfMp");
const $ee035afa777d631b$var$ListItemSelectCheckbox = ({ id: id, onToggle: onToggle, isChecked: isChecked, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        onToggle(e);
    }, [
        onToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        value: `${id} selected`,
        "aria-label": formatMessage((0, $3KfMp.default).label),
        isChecked: isChecked,
        isDisabled: isDisabled,
        onClick: handleClick
    });
};
var $ee035afa777d631b$export$2e2bcd8739ae039 = $ee035afa777d631b$var$ListItemSelectCheckbox;

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("3KfMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $748d966b0e3bb539$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $748d966b0e3bb539$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        id: 'roadmap.timeline-table.main.content.list.list-item.select-checkbox.label',
        defaultMessage: 'Row selection',
        description: 'Label for the select checkbox on each of the rows.'
    }
});

});


parcelRegister("cLle4", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ac22c8e1e4ed5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");

var $gf0vG = parcelRequire("gf0vG");
const $91ac22c8e1e4ed5f$var$useListItemDrag = ({ id: id, level: level, depth: depth, parentId: parentId, canDrag: canDrag, sideEffectMarshal: sideEffectMarshal })=>{
    const cleanupDragAndDrop = (0, $eUqFw.useRef)(null);
    const { onRowGenerateDragPreview: onRowGenerateDragPreview } = sideEffectMarshal;
    const makeDraggable = (0, $eUqFw.useCallback)((dragElement)=>{
        const el = dragElement;
        if (el === null) return;
        cleanupDragAndDrop.current = (0, $3f2za.combine)((0, $eo9PV.draggable)({
            element: el,
            canDrag: ()=>canDrag,
            getInitialData: ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    type: (0, $gf0vG.ROW_DRAG_AND_DROP_ID),
                    id: id,
                    level: level,
                    depth: depth,
                    parentId: parentId
                }),
            onGenerateDragPreview: ()=>{
                onRowGenerateDragPreview();
            }
        }));
    }, [
        canDrag,
        id,
        level,
        depth,
        parentId,
        onRowGenerateDragPreview
    ]);
    const cleanupDraggable = (0, $eUqFw.useCallback)(()=>{
        cleanupDragAndDrop.current?.();
    }, []);
    return [
        makeDraggable,
        cleanupDraggable
    ];
};
var $91ac22c8e1e4ed5f$export$2e2bcd8739ae039 = $91ac22c8e1e4ed5f$var$useListItemDrag;

});


parcelRegister("dAVGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab7d89e241a016e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dnJL9 = parcelRequire("dnJL9");

var $nH3p1 = parcelRequire("nH3p1");

var $7K2X3 = parcelRequire("7K2X3");

var $aiCod = parcelRequire("aiCod");
/* ===========================================================================
 * === @atlaskit/pragmatic-drag-and-drop === //
 *
 * Once the jsw_roadmaps_timeline_table_custom_scroll_pdnd feature gate is
 * removed, this comment and the following feature gated ResizerComponent
 * can be removed. The legacy-resizer component module can also be
 * deleted in its entirety.
 *
 * TODO(FG-REMOVE): jsw_roadmaps_timeline_table_custom_scroll_pdnd
 *
 * https://switcheroo.atlassian.com/ui/gates/49cac7b3-a5f8-45d9-9533-08d52c4f3345
 *
 * =========================================================================== */ const $0ab7d89e241a016e$var$ResizerComponent = (0, $dnJL9.componentWithFG)('jsw_roadmaps_timeline_table_custom_scroll_pdnd', (0, $7K2X3.default), (0, $aiCod.default));
const $0ab7d89e241a016e$var$containerStyles = null;
const $0ab7d89e241a016e$var$listResizerContainerStyles = null;
const $0ab7d89e241a016e$var$ListResizer = ({ DndLongTaskMetric: DndLongTaskMetric, onSetListWidth: onSetListWidth })=>{
    const [listWidth, { setListWidth: setListWidth }] = (0, $nH3p1.useListWidth)();
    const onResize = (0, $eUqFw.useCallback)((width)=>{
        setListWidth(width);
    }, [
        setListWidth
    ]);
    const onResizeEnd = (0, $eUqFw.useCallback)(()=>{
        onSetListWidth(listWidth);
    }, [
        listWidth,
        onSetListWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${listWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _1pbyilow"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ab7d89e241a016e$var$ResizerComponent, {
        width: listWidth,
        DndLongTaskMetric: DndLongTaskMetric,
        onResize: onResize,
        onResizeEnd: onResizeEnd
    })));
};
var $0ab7d89e241a016e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0ab7d89e241a016e$var$ListResizer);

});
parcelRegister("7K2X3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d185fce0fa3f9b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ynlC = parcelRequire("8ynlC");

var $bFzGY = parcelRequire("bFzGY");

var $eo9PV = parcelRequire("eo9PV");

var $cbxSN = parcelRequire("cbxSN");

var $jTs7k = parcelRequire("jTs7k");

var $gf0vG = parcelRequire("gf0vG");

var $eKKjG = parcelRequire("eKKjG");

var $b6Urp = parcelRequire("b6Urp");
const $b4d185fce0fa3f9b$var$getProposedWidth = ({ initialWidth: initialWidth, maxWidth: maxWidth, location: location })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    const proposedWidth = initialWidth + diffX;
    // ensure we don't go below the min or above the max allowed widths
    return Math.min(Math.max((0, $gf0vG.MINIMUM_LIST_WIDTH)(), proposedWidth), maxWidth);
};
const $b4d185fce0fa3f9b$var$Resizer = ({ width: width, DndLongTaskMetric: DndLongTaskMetric, onResize: onResize, onResizeEnd: onResizeEnd })=>{
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const dividerRef = (0, $eUqFw.useRef)(null);
    const initialWidth = (0, $eUqFw.useRef)(width);
    const maxWidth = (0, $b6Urp.useMaxWidth)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onDragStart = (0, $eUqFw.useCallback)(()=>{
        initialWidth.current = width;
        setIsDragging(true);
    }, [
        width
    ]);
    const onDrag = (0, $eUqFw.useCallback)(({ location: location })=>{
        onResize($b4d185fce0fa3f9b$var$getProposedWidth({
            initialWidth: initialWidth.current,
            maxWidth: maxWidth,
            location: location
        }));
    }, [
        onResize,
        maxWidth
    ]);
    const onDrop = (0, $eUqFw.useCallback)(({ location: location })=>{
        (0, $jTs7k.preventUnhandled).stop();
        setIsDragging(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'list',
            actionSubjectId: 'resizedList',
            attributes: {
                didExpand: location.current.input.clientX > location.initial.input.clientX
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        onResizeEnd(initialWidth.current);
    }, [
        createAnalyticsEvent,
        onResizeEnd
    ]);
    // The following effect makes sure the width of the list never exceeds the
    // width of the viewport causing users to not have access to the chart
    // component.
    (0, $eUqFw.useEffect)(()=>{
        width > maxWidth && onResize(maxWidth);
    }, [
        width,
        maxWidth,
        onResize
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const divider = dividerRef.current;
        (0, $8ynlC.default)(divider);
        return (0, $eo9PV.draggable)({
            element: divider,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $cbxSN.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $jTs7k.preventUnhandled).start();
            },
            onDragStart: onDragStart,
            onDrag: onDrag,
            onDrop: onDrop
        });
    }, [
        onDragStart,
        onDrag,
        onDrop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: dividerRef,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi21i6y _1bsbu2gc _4t3i1osq _1pbyilow _v564ryu7 _lcxv1rj4 _80omuf7j _18postnw _1ywu1ule _aetrb3bt _15l2idpf _32rxv77o _z0aiv77o _1qdg1osq _16r21can _11fnglyw",
            isDragging ? "_tzy4kb7n" : "_tzy4idpf _16l4kb7n"
        ])
    }), DndLongTaskMetric !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: isDragging,
        metricType: (0, $gf0vG.LIST_RESIZE_DRAG_AND_DROP)
    }));
};
const $b4d185fce0fa3f9b$var$resizeHandlerStyles = null;
const $b4d185fce0fa3f9b$var$staticStyles = null;
const $b4d185fce0fa3f9b$var$draggingStyles = null;
var $b4d185fce0fa3f9b$export$2e2bcd8739ae039 = $b4d185fce0fa3f9b$var$Resizer;

});
parcelRegister("b6Urp", function(module, exports) {

$parcel$export(module.exports, "useMaxWidth", () => $ec797c92d78f585a$export$f8d842793af60bfe);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $gf0vG = parcelRequire("gf0vG");

var $6TBpb = parcelRequire("6TBpb");

var $72o82 = parcelRequire("72o82");
/** The list's maximum width is relative to the table width. Since the table width is dynamic,
 * and influenced by external factors (e.g. screen resolution), it cannot be known ahead of render.
 * Thus, the value returned here is used constrain the current list width, either retroactively,
 * or during a resize operation.
 */ const $ec797c92d78f585a$export$f8d842793af60bfe = ()=>{
    const [maxWidth, setMaxWidth] = (0, $eUqFw.useState)(Infinity);
    const { requestViewportBoundingClient: requestViewportBoundingClient } = (0, $6TBpb.useViewport)();
    const setMaxWidthFromViewport = (0, $eUqFw.useCallback)(()=>{
        const viewportBoundingClient = requestViewportBoundingClient({
            withTimelineOffset: false
        });
        if (viewportBoundingClient) {
            const newMaxWidth = (0, $72o82.getMaxListWidth)(viewportBoundingClient.width);
            setMaxWidth(newMaxWidth);
        }
    }, [
        requestViewportBoundingClient
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setMaxWidthFromViewport();
    }, [
        setMaxWidthFromViewport
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            setMaxWidthFromViewport();
        }, (0, $gf0vG.RESIZE_DEBOUNCE_MS));
        window.addEventListener('resize', onWindowResize);
        return ()=>{
            window.removeEventListener('resize', onWindowResize);
            onWindowResize.cancel();
        };
    }, [
        setMaxWidthFromViewport
    ]);
    return maxWidth;
};

});
parcelRegister("6TBpb", function(module, exports) {

$parcel$export(module.exports, "useViewport", () => $e467fe7c3b8a4e47$export$297ec8eb77d6211d);
$parcel$export(module.exports, "default", () => $e467fe7c3b8a4e47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3defo = parcelRequire("3defo");
const $e467fe7c3b8a4e47$var$ViewportContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    requestViewportBoundingClient: ()=>(0, $3defo.DEFAULT_BOUNDING_CLIENT),
    requestViewportScrollBounding: ()=>(0, $3defo.DEFAULT_SCROLL_BOUNDING),
    listenToViewportScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    stopListeningToViewportScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    setViewportScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $e467fe7c3b8a4e47$export$297ec8eb77d6211d = ()=>(0, $eUqFw.useContext)($e467fe7c3b8a4e47$var$ViewportContext);
var $e467fe7c3b8a4e47$export$2e2bcd8739ae039 = $e467fe7c3b8a4e47$var$ViewportContext;

});
parcelRegister("3defo", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_BOUNDING_CLIENT", () => $534c582ade2276d4$export$2b0ecbff0a0d633b);
$parcel$export(module.exports, "DEFAULT_SCROLL_BOUNDING", () => $534c582ade2276d4$export$2f9f19f71eef1ceb);
const $534c582ade2276d4$export$2b0ecbff0a0d633b = {
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
const $534c582ade2276d4$export$2f9f19f71eef1ceb = {
    scrollTop: 0,
    scrollLeft: 0,
    scrollRight: 0,
    scrollBottom: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    isOverflowY: false
};

});


parcelRegister("72o82", function(module, exports) {

$parcel$export(module.exports, "getMaxListWidth", () => $d74088e260cdc398$export$5db3ad0238a5a9b3);

var $gf0vG = parcelRequire("gf0vG");
const $d74088e260cdc398$var$MAX_WIDTH_RATIO = 0.9;
const $d74088e260cdc398$export$5db3ad0238a5a9b3 = (viewportWidth)=>{
    const tableLimitedWidth = Math.round(viewportWidth * $d74088e260cdc398$var$MAX_WIDTH_RATIO);
    return Math.max((0, $gf0vG.MINIMUM_LIST_WIDTH)(), tableLimitedWidth);
};

});



parcelRegister("aiCod", function(module, exports) {

$parcel$export(module.exports, "default", () => $3861819d389b7ea9$export$2e2bcd8739ae039);
/* ===========================================================================
 * === LEGACY @atlassian/jira-drag-observer implementation ===
 *
 *
 * This entire `legacy-resizer` module can be deleted once the new
 * `resizer` implementation with @atlaskit/pragmatic-drag-and-drop has been
 * soaked in production and the feature gate is deprecated.
 *
 * TODO(FG-REMOVE): jsw_roadmaps_timeline_table_custom_scroll_pdnd
 *
 * https://switcheroo.atlassian.com/ui/gates/49cac7b3-a5f8-45d9-9533-08d52c4f3345
 *
 * =========================================================================== */ 
var $eUqFw = parcelRequire("eUqFw");

var $kn6GU = parcelRequire("kn6GU");

var $bFzGY = parcelRequire("bFzGY");

var $gf0vG = parcelRequire("gf0vG");

var $eKKjG = parcelRequire("eKKjG");

var $2XRKY = parcelRequire("2XRKY");

var $b6Urp = parcelRequire("b6Urp");
const $3861819d389b7ea9$var$Resizer = ({ width: width, DndLongTaskMetric: DndLongTaskMetric, onResize: onResize, onResizeEnd: onResizeEnd })=>{
    const initialWidth = (0, $eUqFw.useRef)(width);
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const maxWidth = (0, $b6Urp.useMaxWidth)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        width > maxWidth && onResize(maxWidth);
    }, [
        width,
        maxWidth,
        onResize
    ]);
    const onDragStart = (0, $eUqFw.useCallback)(()=>{
        initialWidth.current = width;
        setIsDragging(true);
    }, [
        width
    ]);
    const onDrag = (0, $eUqFw.useCallback)((_from, to, start)=>{
        const newWidth = Math.round(initialWidth.current + to.x - start.x);
        const saneWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kn6GU)))(newWidth, (0, $gf0vG.MINIMUM_LIST_WIDTH)(), maxWidth);
        onResize(saneWidth);
    }, [
        maxWidth,
        onResize
    ]);
    const onDragEnd = (0, $eUqFw.useCallback)((from, to)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'list',
            actionSubjectId: 'resizedList',
            attributes: {
                didExpand: to.x > from.x
            }
        });
        (0, $eKKjG.fireUIAnalyticsEvent)(analyticsEvent);
        setIsDragging(false);
        onResizeEnd(initialWidth.current);
    }, [
        createAnalyticsEvent,
        onResizeEnd
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XRKY.default), {
        onDragStart: onDragStart,
        onDrag: onDrag,
        onDragEnd: onDragEnd
    }), DndLongTaskMetric !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: isDragging,
        metricType: (0, $gf0vG.LIST_RESIZE_DRAG_AND_DROP)
    }));
};
var $3861819d389b7ea9$export$2e2bcd8739ae039 = $3861819d389b7ea9$var$Resizer;

});
parcelRegister("kn6GU", function(module, exports) {

var $1ImyS = parcelRequire("1ImyS");

var $7kP6w = parcelRequire("7kP6w");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $ed4b255301b8301f$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $7kP6w(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $7kP6w(lower);
        lower = lower === lower ? lower : 0;
    }
    return $1ImyS($7kP6w(number), lower, upper);
}
module.exports = $ed4b255301b8301f$var$clamp;

});
parcelRegister("1ImyS", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $13fb66c0c405b8c7$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $13fb66c0c405b8c7$var$baseClamp;

});


parcelRegister("2XRKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb761b5c173f7074$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3R70n = parcelRequire("3R70n");
const $fb761b5c173f7074$var$ResizeHandler = ({ isDragging: isDragging, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...props,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi21i6y _1bsbu2gc _4t3i1osq _1pbyilow _v564ryu7 _lcxv1rj4 _80omuf7j _18postnw _1ywu1ule _aetrb3bt _15l2idpf _32rxv77o _z0aiv77o _1qdg1osq _16r21can _11fnglyw",
            isDragging ? "_tzy4kb7n" : "_tzy4idpf _16l4kb7n"
        ])
    }, children);
var $fb761b5c173f7074$export$2e2bcd8739ae039 = (0, $3R70n.withDragObserver)($fb761b5c173f7074$var$ResizeHandler);
const $fb761b5c173f7074$var$resizeHandlerStyles = null;
const $fb761b5c173f7074$var$staticStyles = null;
const $fb761b5c173f7074$var$draggingStyles = null;

});
parcelRegister("3R70n", function(module, exports) {

$parcel$export(module.exports, "withDragObserver", () => $e0abf553c8271478$export$a0ae95ab2800c7f2);
// Allow PureComponent
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kFGm5 = parcelRequire("kFGm5");

var $jRGmr = parcelRequire("jRGmr");
const $e0abf553c8271478$export$13171b62aaa278f9 = 3;
const $e0abf553c8271478$var$DISABLED_DRAG_PROPS = [
    'onMouseDown',
    'onDragStart',
    'onDrag',
    'onDragEnd'
];
const $e0abf553c8271478$var$ENABLED_DRAG_PROPS = [
    'onMouseDown',
    'onClick',
    'onDragStart',
    'onDrag',
    'onDragEnd'
];
const $e0abf553c8271478$var$getMousePosition = (event)=>({
        x: event.pageX,
        y: event.pageY
    });
const $e0abf553c8271478$var$requestAnimationFrame = (0, $jRGmr.createRaf)();
const $e0abf553c8271478$export$a0ae95ab2800c7f2 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
WrappedComponent, threshold = $e0abf553c8271478$export$13171b62aaa278f9)=>{
    // eslint-disable-next-line jira/react/no-class-components
    class DragObserver extends (0, $eUqFw.PureComponent) {
        static{
            this.defaultProps = {
                isDisabled: false,
                onMouseDown: undefined,
                onDragStart: undefined,
                onDrag: undefined,
                onDragEnd: undefined,
                onClick: undefined
            };
        }
        constructor(props){
            super(props);
            this.onChildMouseDown = (event)=>{
                // Do not start dragging if mouse down with right click
                if (this.props.isDisabled || event.button !== 0) return;
                event.preventDefault();
                event.stopPropagation();
                this.addWindowEventListeners();
                const dragStart = $e0abf553c8271478$var$getMousePosition(event);
                this.setState({
                    isDragging: false,
                    dragStart: dragStart,
                    previousDragPosition: dragStart
                }, ()=>this.onMouseDown(event));
            };
            this.onWindowMouseMove = (event)=>{
                event.preventDefault();
                const mouse = $e0abf553c8271478$var$getMousePosition(event);
                const { isDragging: isDragging, dragStart: dragStart, previousDragPosition: previousDragPosition } = this.state;
                if (!isDragging) {
                    if (Math.abs(mouse.x - dragStart.x) > threshold || Math.abs(mouse.y - dragStart.y) > threshold) {
                        this.setState({
                            isDragging: true
                        });
                        this.onDragStart(dragStart);
                    }
                } else {
                    const from = previousDragPosition;
                    const to = mouse;
                    this.setState({
                        previousDragPosition: mouse
                    });
                    this.onDrag(from, to, dragStart);
                }
            };
            this.onWindowMouseUp = (event)=>{
                const { isDragging: isDragging, dragStart: dragStart } = this.state;
                if (isDragging) {
                    const mouse = $e0abf553c8271478$var$getMousePosition(event);
                    const start = dragStart;
                    const end = mouse;
                    if (this.mounted) this.setState({
                        isDragging: false
                    });
                    this.onDragEnd(start, end);
                } else if (event.button === 0 && ((navigator?.userAgent ?? '').includes('Mac') ? !event.ctrlKey : true)) // Trigger onClick on left clicks only. Checking ctrlKey as ctrl + click could emulate right-click on Mac
                this.onClick(event);
                this.removeWindowEventListeners();
            };
            this.animationId = undefined;
            this.mounted = false;
            this.state = {
                isDragging: false,
                dragStart: {
                    x: 0,
                    y: 0
                },
                previousDragPosition: {
                    x: 0,
                    y: 0
                }
            };
        }
        componentDidMount() {
            this.mounted = true;
            // eslint-disable-next-line react/no-find-dom-node
            this.ref = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this);
            if (this.ref) // @ts-expect-error - TS2345 - Argument of type '(event: MouseEvent) => void' is not assignable to parameter of type 'EventListenerOrEventListenerObject'.
            this.ref.addEventListener('mousedown', this.onChildMouseDown);
        }
        componentWillUnmount() {
            if (this.ref) // @ts-expect-error - TS2345 - Argument of type '(event: MouseEvent) => void' is not assignable to parameter of type 'EventListenerOrEventListenerObject'.
            this.ref.removeEventListener('mousedown', this.onChildMouseDown);
            this.removeWindowEventListeners();
            if (this.animationId !== undefined) {
                cancelAnimationFrame(this.animationId);
                this.animationId = undefined;
            }
            this.mounted = false;
        }
        addWindowEventListeners() {
            window.addEventListener('mousemove', this.onWindowMouseMove);
            window.addEventListener('mouseup', this.onWindowMouseUp);
        }
        removeWindowEventListeners() {
            window.removeEventListener('mousemove', this.onWindowMouseMove);
            window.removeEventListener('mouseup', this.onWindowMouseUp);
        }
        onMouseDown(event) {
            if (this.props.onMouseDown) this.props.onMouseDown(event);
        }
        onDragStart(from) {
            if (this.props.onDragStart) this.props.onDragStart(from);
        }
        onDrag(from, to, start) {
            if (this.props.onDrag) this.animationId = $e0abf553c8271478$var$requestAnimationFrame(()=>{
                if (this.props.onDrag && this.state.isDragging) this.props.onDrag(from, to, start);
            });
        }
        onDragEnd(from, to) {
            if (this.props.onDragEnd) this.props.onDragEnd(from, to);
        }
        onClick(event) {
            if (this.props.onClick) this.props.onClick(event);
        }
        render() {
            const { isDisabled: isDisabled } = this.props;
            const { isDragging: isDragging } = this.state;
            /* When dragging is disabled, clicking should still be enabled.
			 * Rather than try handle onClick in this HOC, we instead just allow
			 * the onClick passed in to make it to the underlying component.
			 */ const safeProps = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(this.props, isDisabled ? $e0abf553c8271478$var$DISABLED_DRAG_PROPS : $e0abf553c8271478$var$ENABLED_DRAG_PROPS);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                isDragging: isDragging,
                ...safeProps
            });
        }
    }
    return DragObserver;
};

});
parcelRegister("jRGmr", function(module, exports) {

$parcel$export(module.exports, "createRaf", () => $bfe88abdc2d8eafe$export$adfe8e38eaee509d);
/* The browser can attempt to schedule more than one animation frame on the same tick of the event loop.
 * In this case, we should cancel the already scheduled one to avoid redundant work.
 * The createRaf utility encapsulates this behaviour.
 */ const $bfe88abdc2d8eafe$export$adfe8e38eaee509d = ()=>{
    let frameId = null;
    return (callback)=>{
        if (frameId) cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(callback);
        return frameId;
    };
};

});





parcelRegister("htzwR", function(module, exports) {

$parcel$export(module.exports, "canItemCreateSibling", () => $3568a10fcb9b3083$export$a638fd397c012b84);
$parcel$export(module.exports, "canItemCreateChild", () => $3568a10fcb9b3083$export$8d944d58a048c0d4);

var $eI5EY = parcelRequire("eI5EY");

var $gf0vG = parcelRequire("gf0vG");

var $1sAbG = parcelRequire("1sAbG");
// Remove on FG cleanup jsw_roadmaps_timeline_table_meatballs_menu_a11y
const $3568a10fcb9b3083$var$isItemAlreadyInCreate = (id, createItemAnchor)=>createItemAnchor && (createItemAnchor.position === (0, $gf0vG.BEFORE) || createItemAnchor.position === (0, $gf0vG.INSIDE)) && (createItemAnchor.beforeId === id || createItemAnchor.parentId === id);
// Remove on FG cleanup jsw_roadmaps_timeline_table_meatballs_menu_a11y
const $3568a10fcb9b3083$var$canItemCreate = ({ id: id, createItemAnchor: createItemAnchor, isInTransition: isInTransition })=>!isInTransition && !$3568a10fcb9b3083$var$isItemAlreadyInCreate(id, createItemAnchor);
const $3568a10fcb9b3083$export$a638fd397c012b84 = ({ index: index, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, depth: depth, ...createCheckParams })=>isCreateSiblingEnabled && // !isInTransition is checked within canItemCreate, set this check to just !isInTransition on FG cleanup
    // The button must be rendered while the item is in create in order to refocus it once ICC is cancelled
    ($3568a10fcb9b3083$var$canItemCreate(createCheckParams) || !createCheckParams.isInTransition && (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) && ((0, $1sAbG.isRoot)(depth) && index !== 0 || !(0, $1sAbG.isRoot)(depth) && isCreateChildEnabled);
const $3568a10fcb9b3083$export$8d944d58a048c0d4 = ({ isCreateChildEnabled: isCreateChildEnabled, canCreateChildOverride: canCreateChildOverride, ...createCheckParams })=>isCreateChildEnabled && canCreateChildOverride && // !isInTransition is checked within canItemCreate, set this check to just !isInTransition on FG cleanup
    // The button must be rendered while the item is in create in order to refocus it once ICC is cancelled
    ($3568a10fcb9b3083$var$canItemCreate(createCheckParams) || !createCheckParams.isInTransition && (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y'));

});


parcelRegister("gPBP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9dafa7dc650fca8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $dnJL9 = parcelRequire("dnJL9");

var $gf0vG = parcelRequire("gf0vG");

var $VrUCp = parcelRequire("VrUCp");

var $nH3p1 = parcelRequire("nH3p1");

var $cZkk1 = parcelRequire("cZkk1");

var $3XwA1 = parcelRequire("3XwA1");

var $ldtYx = parcelRequire("ldtYx");

var $9uHe2 = parcelRequire("9uHe2");

var $ccgw3 = parcelRequire("ccgw3");

var $srCMJ = parcelRequire("srCMJ");

var $7KPyi = parcelRequire("7KPyi");

var $k1DV2 = parcelRequire("k1DV2");

var $4RNyl = parcelRequire("4RNyl");
/* ===========================================================================
 * === @atlaskit/pragmatic-drag-and-drop === //
 *
 * Once the jsw_roadmaps_timeline_table_custom_scroll_pdnd feature gate is
 * removed, this comment and the following feature gated ThumbTrackComponent
 * can be removed. The legacy-thumb-tracks component module can also be
 * deleted in its entirety.
 *
 * TODO(FG-REMOVE): jsw_roadmaps_timeline_table_custom_scroll_pdnd
 *
 * https://switcheroo.atlassian.com/ui/gates/49cac7b3-a5f8-45d9-9533-08d52c4f3345
 *
 * =========================================================================== */ const $a9dafa7dc650fca8$var$ThumbTrackComponent = (0, $dnJL9.componentWithFG)('jsw_roadmaps_timeline_table_custom_scroll_pdnd', (0, $7KPyi.default), (0, $k1DV2.default));
const $a9dafa7dc650fca8$var$containerStyles = null;
const $a9dafa7dc650fca8$var$hiddenScrollbarPanelStyles = null;
const $a9dafa7dc650fca8$var$HiddenScrollbarPanel = ({ scrollbarSize: scrollbarSize, innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: scrollbarSize > 0 ? {
            right: `-${scrollbarSize}px`,
            bottom: `-${scrollbarSize}px`
        } : undefined,
        ...rest,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1reo15zi _18m915zi"
        ])
    }, children);
const $a9dafa7dc650fca8$var$requestAnimationFrame = (0, $9uHe2.createRaf)();
const $a9dafa7dc650fca8$var$Viewport = (0, $ldtYx.default)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$a9dafa7dc650fca8$var$HiddenScrollbarPanel);
/*
 * !! Changes here should be made with extreme caution !!
 * This component exists to create scrollbars that have a browser/OS agnostic look and feel, while still respecting user settings.
 * The context this component provides is used by dozens of leaf nodes and is accessible to external consumers. Additionally, performance
 * optimisations here are nuanced, which if regressed can easily cause bottlenecks to our virtual scrolling and TTI.
 * ---
 * Some points of interest:
 * - We rely heavily on accessing the DOM directly, skipping as much work as possible in the React lifecycle.
 * - In the local system (we cannot guarantee this globally), we look to minimise layout thrashing by batching DOM reads and writes.
 * - We translate measurements between two coordinate systems to decouple the scrollbar ref from our custom element refs (see ./thumb-tracks).
 */ const $a9dafa7dc650fca8$var$CustomScrollbars = ({ isHideScrollbar: isHideScrollbar, children: children })=>{
    const [{ timelineOriginPosition: timelineOriginPosition }] = (0, $3XwA1.useTimelineState)();
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const [scrollbarSize, setScrollbarSize] = (0, $eUqFw.useState)(-1);
    const viewportRef = (0, $eUqFw.useRef)(null);
    const thumbTracksRef = (0, $eUqFw.useRef)(null);
    const lastScrollY = (0, $eUqFw.useRef)(0);
    const lastScrollX = (0, $eUqFw.useRef)(0);
    const frameId = (0, $eUqFw.useRef)();
    const [setupDragScroller, teardownDragScroller] = (0, $srCMJ.useDragScroller)(headerHeight);
    const { onResize: onResize } = (0, $cZkk1.useTimelineViewportActions)();
    // ====================== //
    // === EVENT HANDLING === //
    // ====================== //
    const onSetViewportRef = (elem)=>{
        viewportRef.current = elem;
        setupDragScroller(elem);
    };
    // Set the scroll left on the real scrollbar based on a position from clicking/dragging the track
    const onSetScrollLeft = (0, $eUqFw.useCallback)((relativePosition)=>{
        if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the scroll left position was null');
        const { scrollWidth: scrollWidth } = viewportRef.current;
        viewportRef.current.scrollLeft = relativePosition * scrollWidth;
    }, []);
    // Set the scroll top on the real scrollbar based on a position from from clicking/dragging the track
    const onSetScrollTop = (0, $eUqFw.useCallback)((relativePosition)=>{
        if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the scroll top position was null');
        const { scrollHeight: scrollHeight } = viewportRef.current;
        viewportRef.current.scrollTop = relativePosition * scrollHeight;
    }, []);
    /* Update the custom thumb positions to reflect the "real" ones that we've hidden.
   * To minimise the number of updates, we check whether the scroll position has changed
   * before mutating the DOM, e.g. don't change vertical position when only scrolling horizontally.
   */ const onScroll = ({ currentTarget: currentTarget })=>{
        frameId.current = $a9dafa7dc650fca8$var$requestAnimationFrame(()=>{
            // DOM reads //
            const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, scrollHeight: scrollHeight, clientWidth: clientWidth, clientHeight: clientHeight } = currentTarget;
            let horizontalScrollRatio = -1;
            let verticalScrollRatio = -1;
            if (lastScrollX.current !== scrollLeft) {
                lastScrollX.current = scrollLeft;
                horizontalScrollRatio = (0, $4RNyl.getScrollOffsetRatio)(scrollLeft, scrollWidth, clientWidth);
            }
            if (lastScrollY.current !== scrollTop) {
                lastScrollY.current = scrollTop;
                verticalScrollRatio = (0, $4RNyl.getScrollOffsetRatio)(scrollTop, scrollHeight, clientHeight);
            }
            // DOM reads then writes //
            thumbTracksRef.current?.setThumbPositions({
                horizontalScrollRatio: horizontalScrollRatio,
                verticalScrollRatio: verticalScrollRatio
            });
        });
    };
    /* This should be called in response to anything that would affect the dimensions of the viewport
   * or its content. As a result, the relevant custom properties are updated, e.g. thumb position and size.
   */ const updateScrollbars = (0, $eUqFw.useCallback)(()=>{
        if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the custom scroll parameters was null');
        // DOM reads //
        const { scrollWidth: scrollWidth, scrollHeight: scrollHeight, clientWidth: clientWidth, clientHeight: clientHeight, scrollLeft: scrollLeft, scrollTop: scrollTop } = viewportRef.current;
        const { left: left } = viewportRef.current.getBoundingClientRect();
        onResize({
            left: left,
            clientWidth: clientWidth
        });
        const horizontalScrollRatio = (0, $4RNyl.getScrollOffsetRatio)(scrollLeft, scrollWidth, clientWidth);
        const verticalScrollRatio = (0, $4RNyl.getScrollOffsetRatio)(scrollTop, scrollHeight, clientHeight);
        const horizontalContentRatio = (0, $4RNyl.getContentToViewportRatio)(scrollWidth, clientWidth);
        const verticalContentRatio = (0, $4RNyl.getContentToViewportRatio)(scrollHeight, clientHeight);
        // DOM reads then writes //
        thumbTracksRef.current?.update({
            horizontalScrollRatio: horizontalScrollRatio,
            verticalScrollRatio: verticalScrollRatio
        }, {
            horizontalContentRatio: horizontalContentRatio,
            verticalContentRatio: verticalContentRatio
        });
    }, [
        onResize
    ]);
    // If a scrollbar is not measured, we don't need to handle updating the custom parameters.
    const onContentResize = scrollbarSize > 0 ? updateScrollbars : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    // =============== //
    // === EFFECTS === //
    // =============== //
    /* Step 1: Initialize the fundamental custom scrollbar properties.
   *
   * Some OS settings hide scrollbars or display them as overlays. In these cases the
   * scrollbar size will be measured as 0, and we will fallback to using the browser built-ins.
   * Regardless, given how often these settings change, we only ever set the scrollbar size once.
   */ (0, $eUqFw.useLayoutEffect)(()=>{
        if (!viewportRef.current) throw new Error('An element required to initialise the custom scrollbars was null');
        const initialScrollbarSize = (0, $4RNyl.getScrollbarSize)(viewportRef.current);
        // Browsers will convert scrollLeft to an integer, and we want to compare these two values later
        const integerTimelineDefaultPosition = Math.round(timelineOriginPosition);
        viewportRef.current.scrollLeft = integerTimelineDefaultPosition;
        lastScrollX.current = integerTimelineDefaultPosition;
        setScrollbarSize(initialScrollbarSize);
    }, [
        timelineOriginPosition
    ]);
    /* Step 2: Construct the resize observer *after* initialization so DOM is stable.
   *
   * This handles updating the scrollbar properties whenever the *viewport* changes size,
   * e.g. resizing the window or collapsing a sidebar. As we have no direct way to observe
   * content changes, this will be handled by a callback (see the render).
   */ (0, $ccgw3.useResizeObserver)(viewportRef.current, onContentResize);
    // Step 3: Don't forget to cleanup!!
    (0, $eUqFw.useEffect)(()=>()=>{
            frameId.current && cancelAnimationFrame(frameId.current);
            teardownDragScroller(null);
        }, [
        teardownDragScroller
    ]);
    // ============== //
    // === RENDER === //
    // ============== //
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1reo15vq _18m915vq _2rkoo8o8"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9dafa7dc650fca8$var$Viewport, {
        id: (0, $gf0vG.TIMELINE_ID),
        "data-testid": (0, $gf0vG.TIMELINE_ID),
        innerRef: onSetViewportRef,
        scrollbarSize: scrollbarSize,
        offsets: (0, $4RNyl.getViewportOffsets)(scrollbarSize, listWidth, headerHeight),
        onScroll: scrollbarSize > 0 ? onScroll : undefined
    }, children({
        scrollElement: viewportRef.current,
        onContentResize: onContentResize
    })), scrollbarSize > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9dafa7dc650fca8$var$ThumbTrackComponent, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: thumbTracksRef,
        listWidth: listWidth,
        timelineTop: headerHeight,
        isHideScrollbar: isHideScrollbar,
        onSetScrollLeft: onSetScrollLeft,
        onSetScrollTop: onSetScrollTop
    }));
};
var $a9dafa7dc650fca8$export$2e2bcd8739ae039 = $a9dafa7dc650fca8$var$CustomScrollbars;

});
parcelRegister("ldtYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dab9cb41199266e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $6TBpb = parcelRequire("6TBpb");

var $a5UGF = parcelRequire("a5UGF");

var $iukCv = parcelRequire("iukCv");
const $3dab9cb41199266e$var$withViewportProvider = (WrappedComponent)=>{
    /* eslint-disable jira/react-arrow-function-property-naming */ // eslint-disable-next-line jira/react/no-class-components
    class WithViewportProvider extends (0, $eUqFw.Component) {
        static{
            this.defaultProps = {
                offsets: (0, $a5UGF.DEFAULT_OFFSETS),
                innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
            };
        }
        constructor(props){
            super(props);
            this.requestBoundingClient = ({ withTimelineOffset: withTimelineOffset } = (0, $a5UGF.DEFAULT_BOUNDING_OPTIONS))=>{
                if (!this.ref) throw new Error((0, $a5UGF.MISSING_REF_ERROR_MESSAGE));
                return (0, $iukCv.calculateClientBounding)({
                    element: this.ref,
                    offsets: this.props.offsets,
                    withTimelineOffset: withTimelineOffset
                });
            };
            this.requestScrollBounding = ({ withTimelineOffset: withTimelineOffset } = (0, $a5UGF.DEFAULT_BOUNDING_OPTIONS))=>{
                if (!this.ref) throw new Error((0, $a5UGF.MISSING_REF_ERROR_MESSAGE));
                return (0, $iukCv.calculateScrollBounding)({
                    element: this.ref,
                    offsets: this.props.offsets,
                    withTimelineOffset: withTimelineOffset
                });
            };
            this.listenToScroll = (callback)=>{
                if (!this.ref) throw new Error((0, $a5UGF.MISSING_REF_ERROR_MESSAGE));
                this.ref.addEventListener('scroll', callback);
            };
            this.stopListeningToScroll = (callback)=>{
                if (this.ref) this.ref.removeEventListener('scroll', callback);
            };
            this.setScroll = ({ scrollLeft: scrollLeft, scrollTop: scrollTop })=>{
                if (!this.ref) throw new Error((0, $a5UGF.MISSING_REF_ERROR_MESSAGE));
                if (scrollLeft !== undefined) this.ref.scrollLeft = scrollLeft;
                if (scrollTop !== undefined) this.ref.scrollTop = scrollTop;
            };
            this.onSetRef = (elem)=>{
                const { innerRef: innerRef } = this.props;
                this.ref = elem;
                innerRef(elem);
            };
            this.ref = null;
            // It is being used, but only as a whole state object and the linter does not recognize that
            /* eslint-disable react/no-unused-state */ this.state = {
                requestViewportBoundingClient: this.requestBoundingClient,
                requestViewportScrollBounding: this.requestScrollBounding,
                listenToViewportScroll: this.listenToScroll,
                stopListeningToViewportScroll: this.stopListeningToScroll,
                setViewportScroll: this.setScroll
            };
        /* eslint-enable react/no-unused-state */ }
        render() {
            const { children: children, ...props } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6TBpb.default).Provider, {
                value: this.state
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                innerRef: this.onSetRef
            }, children));
        }
    }
    /* eslint-enable jira/react-arrow-function-property-naming */ return WithViewportProvider;
};
var $3dab9cb41199266e$export$2e2bcd8739ae039 = $3dab9cb41199266e$var$withViewportProvider;

});
parcelRegister("a5UGF", function(module, exports) {

$parcel$export(module.exports, "MISSING_REF_ERROR_MESSAGE", () => $ecb8126a31f8e57d$export$a374b3d597cc8a2f);
$parcel$export(module.exports, "DEFAULT_BOUNDING_OPTIONS", () => $ecb8126a31f8e57d$export$411ca18ef48ec0a9);
$parcel$export(module.exports, "DEFAULT_OFFSETS", () => $ecb8126a31f8e57d$export$86c907556a515793);
const $ecb8126a31f8e57d$export$a374b3d597cc8a2f = 'Viewport element was null. Only make this request when it is certain to be available (e.g. not in componentDidMount)';
const $ecb8126a31f8e57d$export$411ca18ef48ec0a9 = {
    withTimelineOffset: true
};
const $ecb8126a31f8e57d$export$86c907556a515793 = {
    scrollbar: 0,
    timelineTop: 0,
    timelineLeft: 0
};

});

parcelRegister("iukCv", function(module, exports) {

$parcel$export(module.exports, "calculateClientBounding", () => $6abb6d96f4886613$export$787a1f452b87b38);
$parcel$export(module.exports, "calculateScrollBounding", () => $6abb6d96f4886613$export$7bc284cde09cb25);
/* Transforms the viewport's raw bounding client rectangle.
 * At a minimum, we need to manually exclude the offsets used to hide the native scrollbars.
 * Without it, logic that relies on the viewport boundaries would be slightly off.
 */ const $6abb6d96f4886613$export$787a1f452b87b38 = ({ element: element, offsets: offsets, withTimelineOffset: withTimelineOffset })=>{
    const { width: width, height: height, right: right, bottom: bottom, left: left, top: top } = element.getBoundingClientRect();
    const { timelineTop: timelineTop, timelineLeft: timelineLeft, scrollbar: scrollbar } = offsets;
    const effectiveTimelineTop = withTimelineOffset ? timelineTop : 0;
    const effectiveTimelineLeft = withTimelineOffset ? timelineLeft : 0;
    return {
        width: width - scrollbar - effectiveTimelineLeft,
        height: height - scrollbar - effectiveTimelineTop,
        right: right - scrollbar,
        bottom: bottom - scrollbar,
        left: left + effectiveTimelineLeft,
        top: top + effectiveTimelineTop
    };
};
/* Transforms the viewport's raw scroll attributes.
 * Unlike the bounding client rectangle, these attributes are not affected by the scrollbar offsets.
 * This is because they effectively measure the viewport's content (e.g. scrollWidth, scrollHeight).
 */ const $6abb6d96f4886613$export$7bc284cde09cb25 = ({ element: element, offsets: offsets, withTimelineOffset: withTimelineOffset })=>{
    const { scrollTop: scrollTop, scrollLeft: scrollLeft, scrollHeight: scrollHeight, scrollWidth: scrollWidth, clientWidth: clientWidth, clientHeight: clientHeight } = element;
    const { timelineTop: timelineTop, timelineLeft: timelineLeft } = offsets;
    const effectiveTimelineTop = withTimelineOffset ? timelineTop : 0;
    const effectiveTimelineLeft = withTimelineOffset ? timelineLeft : 0;
    return {
        scrollTop: scrollTop,
        scrollLeft: scrollLeft,
        scrollRight: Math.max(scrollWidth - clientWidth - scrollLeft, 0),
        scrollBottom: Math.max(scrollHeight - clientHeight - scrollTop, 0),
        scrollHeight: scrollHeight - effectiveTimelineTop,
        scrollWidth: scrollWidth - effectiveTimelineLeft,
        isOverflowY: scrollHeight > clientHeight
    };
};

});


parcelRegister("9uHe2", function(module, exports) {

$parcel$export(module.exports, "createRaf", () => $812c3705f52197ec$export$adfe8e38eaee509d);
/* The browser can attempt to schedule more than one animation frame on the same tick of the event loop.
 * In this case, we should cancel the already scheduled one to avoid redundant work.
 * The createRaf utility encapsulates this behaviour.
 */ const $812c3705f52197ec$export$adfe8e38eaee509d = ()=>{
    let frameId = null;
    return (callback)=>{
        if (frameId) cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(callback);
        return frameId;
    };
};

});

parcelRegister("srCMJ", function(module, exports) {

$parcel$export(module.exports, "useDragScroller", () => $9b3cff6912a4c4da$export$ef7372695b4ed2f3);

var $eUqFw = parcelRequire("eUqFw");

var $5Pwiq = parcelRequire("5Pwiq");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");

var $gf0vG = parcelRequire("gf0vG");
const $9b3cff6912a4c4da$export$ef7372695b4ed2f3 = (timelineTop)=>{
    const cleanupDragAndDrop = (0, $eUqFw.useRef)(null);
    const clientXPos = (0, $eUqFw.useRef)(0);
    const thresholdTop = (0, $eUqFw.useRef)(0);
    const setupDragScroller = (0, $eUqFw.useCallback)((viewportElement)=>{
        cleanupDragAndDrop.current = (0, $3f2za.combine)((0, $eo9PV.monitorForElements)({
            onDragStart: ({ source: source, location: location })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && viewportElement !== null) {
                    const viewportBoundingRect = viewportElement?.getBoundingClientRect();
                    const offsetTop = viewportBoundingRect?.top ?? 0;
                    clientXPos.current = (viewportBoundingRect?.left ?? 0) + (viewportBoundingRect?.width ?? 0) / 2;
                    thresholdTop.current = offsetTop / 2 + timelineTop + offsetTop;
                    (0, $5Pwiq.autoScroller).start({
                        input: {
                            ...location.current.input,
                            // lock the x axis
                            pageX: clientXPos.current,
                            clientX: clientXPos.current
                        }
                    });
                }
            },
            onDrop: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && viewportElement !== null) (0, $5Pwiq.autoScroller).stop();
            },
            onDrag: ({ source: source, location: location })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && viewportElement !== null) {
                    const { clientY: clientY, pageX: pageX, clientX: clientX, pageY: pageY, ...restInputs } = location.current.input;
                    const newClientY = clientY < thresholdTop.current ? clientY - timelineTop : clientY;
                    const input = {
                        ...restInputs,
                        // lock the x axis
                        pageX: clientXPos.current,
                        clientX: clientXPos.current,
                        pageY: newClientY,
                        clientY: newClientY
                    };
                    (0, $5Pwiq.autoScroller).updateInput({
                        input: input
                    });
                }
            }
        }));
    }, [
        timelineTop
    ]);
    const teardownDragScroller = (0, $eUqFw.useCallback)(()=>{
        cleanupDragAndDrop.current?.();
    }, []);
    return [
        setupDragScroller,
        teardownDragScroller
    ];
};

});
parcelRegister("5Pwiq", function(module, exports) {

$parcel$export(module.exports, "createAutoScroller", () => $bde649c1e39b5c8c$export$fbda4b72e803ec38);
$parcel$export(module.exports, "autoScroller", () => $bde649c1e39b5c8c$export$d19940cfc7560cd8);

var $dEKnA = parcelRequire("dEKnA");
const $bde649c1e39b5c8c$var$scrollElement = (element, change)=>{
    element.scrollBy(change.x, change.y);
};
const $bde649c1e39b5c8c$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $bde649c1e39b5c8c$export$fbda4b72e803ec38 = ()=>{
    let dragging = null;
    function tryScroll(fakeScrollCallback) {
        if (dragging == null) return;
        (0, $dEKnA.scroll)({
            input: dragging.latestInput,
            dragStartTime: dragging.dragStartTime,
            shouldUseTimeDampening: dragging.shouldUseTimeDampening,
            behavior: dragging.behavior,
            scrollElement: fakeScrollCallback ?? $bde649c1e39b5c8c$var$scrollElement,
            scrollWindow: fakeScrollCallback ?? $bde649c1e39b5c8c$var$scrollWindow
        });
    }
    // Every animation frame use the latest user input to scroll
    // We do this loop manually rather than in response to `onDrag`
    // events as `onDrag` can drop to 50-100ms between events when
    // the user is not actively moving their pointer
    function loop() {
        if (!dragging) return;
        dragging.loopFrameId = requestAnimationFrame(()=>{
            tryScroll();
            loop();
        });
    }
    const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
        const dragStartTime = Date.now();
        dragging = {
            dragStartTime: dragStartTime,
            latestInput: input,
            loopFrameId: null,
            shouldUseTimeDampening: false,
            behavior: behavior
        };
        // we only use time dampening when auto scrolling starts on lift.
        const fakeScrollCallback = ()=>{
            if (dragging) dragging.shouldUseTimeDampening = true;
        };
        tryScroll(fakeScrollCallback);
        loop();
    };
    function updateInput({ input: input }) {
        if (!dragging) return;
        dragging.latestInput = input;
    }
    const stop = ()=>{
        // can be called defensively
        if (!dragging) return;
        if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
        dragging = null;
    };
    return {
        start: start,
        updateInput: updateInput,
        stop: stop
    };
};
const $bde649c1e39b5c8c$export$d19940cfc7560cd8 = $bde649c1e39b5c8c$export$fbda4b72e803ec38();

});
parcelRegister("dEKnA", function(module, exports) {

$parcel$export(module.exports, "scroll", () => $704cec92194d31d8$export$209876d7b1ac8f3);
parcelRequire("5K1lL");
var $cHW1B = parcelRequire("cHW1B");

var $7E9sF = parcelRequire("7E9sF");

var $1s8mQ = parcelRequire("1s8mQ");

var $cmR18 = parcelRequire("cmR18");

var $91kec = parcelRequire("91kec");

var $2kKFy = parcelRequire("2kKFy");
const $704cec92194d31d8$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
    const tryScrollWindow = ()=>{
        const viewport = (0, $2kKFy.default)();
        const windowScrollChange = (0, $91kec.default)({
            dragStartTime: dragStartTime,
            viewport: viewport,
            center: {
                x: input.clientX + viewport.scroll.current.x,
                y: input.clientY + viewport.scroll.current.y
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (windowScrollChange) {
            scrollWindow(windowScrollChange);
            return true;
        }
        return false;
    };
    const tryScrollContainer = ()=>{
        const over = (0, $cHW1B.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        });
        const closestScrollable = (0, $7E9sF.getClosestScrollableElement)(over);
        if (!closestScrollable) return false;
        const scrollable = (0, $1s8mQ.getScrollable)({
            closestScrollable: closestScrollable
        });
        const scrollableScrollChange = (0, $cmR18.default)({
            dragStartTime: dragStartTime,
            scrollable: scrollable,
            center: {
                x: input.clientX,
                y: input.clientY
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (scrollableScrollChange) {
            scrollElement(closestScrollable, scrollableScrollChange);
            return true;
        }
        return false;
    };
    if (behavior === 'container-only') tryScrollContainer();
    if (behavior === 'window-only') tryScrollWindow();
    if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
    if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
};

});
parcelRegister("5K1lL", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("cHW1B")).getElementFromPointWithoutHoneypot);

var $cHW1B = parcelRequire("cHW1B");

});

parcelRegister("7E9sF", function(module, exports) {

$parcel$export(module.exports, "getClosestScrollableElement", () => $f466e08163ab9741$export$f39f407dd5a0ebdb);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $f466e08163ab9741$var$isEqual = (base)=>(value)=>base === value;
const $f466e08163ab9741$var$isScroll = $f466e08163ab9741$var$isEqual('scroll');
const $f466e08163ab9741$var$isAuto = $f466e08163ab9741$var$isEqual('auto');
const $f466e08163ab9741$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $f466e08163ab9741$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $f466e08163ab9741$var$isEither(overflow, $f466e08163ab9741$var$isScroll) || $f466e08163ab9741$var$isEither(overflow, $f466e08163ab9741$var$isAuto);
};
const $f466e08163ab9741$export$f39f407dd5a0ebdb = (el)=>{
    // cannot do anything else!
    if (!el) return null;
    // not allowing us to go higher then body
    if (el === document.body || el === document.documentElement) return null;
    if (!$f466e08163ab9741$var$isElementScrollable(el)) // keep recursing
    return $f466e08163ab9741$export$f39f407dd5a0ebdb(el.parentElement);
    // success!
    return el;
};

});

parcelRegister("1s8mQ", function(module, exports) {

$parcel$export(module.exports, "getScrollable", () => $6652de0133f228e0$export$9b7238c949d126e9);

var $bn5nT = parcelRequire("bn5nT");
const $6652de0133f228e0$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
    const rect = closestScrollable.getBoundingClientRect();
    const scrollPosition = {
        x: closestScrollable.scrollLeft,
        y: closestScrollable.scrollTop
    };
    return {
        container: (0, $bn5nT.getRect)(rect),
        scroll: {
            current: scrollPosition,
            max: {
                x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                y: closestScrollable.scrollHeight - closestScrollable.clientHeight
            }
        }
    };
};

});
parcelRegister("bn5nT", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $847604ea52819b67$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $847604ea52819b67$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $847604ea52819b67$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $847604ea52819b67$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $847604ea52819b67$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $847604ea52819b67$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $847604ea52819b67$export$34928e660d2a8702);

var $8ynlC = parcelRequire("8ynlC");
var $847604ea52819b67$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $847604ea52819b67$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $847604ea52819b67$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $847604ea52819b67$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $847604ea52819b67$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $847604ea52819b67$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$padding;
    var marginBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $847604ea52819b67$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $847604ea52819b67$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8ynlC.default)(false);
    return result;
};
var $847604ea52819b67$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $847604ea52819b67$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $847604ea52819b67$var$shift(borderBox, change);
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $847604ea52819b67$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $847604ea52819b67$var$getWindowScroll();
    return $847604ea52819b67$export$cc800923e997bb8(original, scroll);
};
var $847604ea52819b67$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $847604ea52819b67$var$parse(styles.marginTop),
        right: $847604ea52819b67$var$parse(styles.marginRight),
        bottom: $847604ea52819b67$var$parse(styles.marginBottom),
        left: $847604ea52819b67$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $847604ea52819b67$var$parse(styles.paddingTop),
        right: $847604ea52819b67$var$parse(styles.paddingRight),
        bottom: $847604ea52819b67$var$parse(styles.paddingBottom),
        left: $847604ea52819b67$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $847604ea52819b67$var$parse(styles.borderTopWidth),
        right: $847604ea52819b67$var$parse(styles.borderRightWidth),
        bottom: $847604ea52819b67$var$parse(styles.borderBottomWidth),
        left: $847604ea52819b67$var$parse(styles.borderLeftWidth)
    };
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $847604ea52819b67$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $847604ea52819b67$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});


parcelRegister("cmR18", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31ebcd079c503fc$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $kuXkS = parcelRequire("kuXkS");

var $h3yff = parcelRequire("h3yff");
var $f31ebcd079c503fc$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $h3yff.default)({
        dragStartTime: dragStartTime,
        container: scrollable.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $kuXkS.canScrollScrollable)(scrollable, scroll) ? scroll : null;
};

});
parcelRegister("kuXkS", function(module, exports) {

$parcel$export(module.exports, "canScrollWindow", () => $ed7d2bc081cd70a2$export$cbd1e6fd5e887f10);
$parcel$export(module.exports, "canScrollScrollable", () => $ed7d2bc081cd70a2$export$57c21b61d76c9819);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $6cABY = parcelRequire("6cABY");
const $ed7d2bc081cd70a2$var$smallestSigned = (0, $6cABY.apply)((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $ed7d2bc081cd70a2$export$6b13012b06f8f95b = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = (0, $6cABY.add)(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ((0, $6cABY.isEqual)(overlap, (0, $6cABY.origin))) return null;
        return overlap;
    };
})();
const $ed7d2bc081cd70a2$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
    // It is possible for the max scroll to be greater than the current scroll
    // when there are scrollbars on the cross axis. We adjust for this by
    // increasing the max scroll point if needed
    // This will allow movements backwards even if the current scroll is greater than the max scroll
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    // Only need to be able to move the smallest amount in the desired direction
    const smallestChange = $ed7d2bc081cd70a2$var$smallestSigned(change);
    const overlap = $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        max: max,
        current: current,
        change: smallestChange
    });
    // no overlap at all - we can move there!
    if (!overlap) return true;
    // if there was an x value, but there is no x overlap - then we can scroll on the x!
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    // if there was an y value, but there is no y overlap - then we can scroll on the y!
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $ed7d2bc081cd70a2$export$cbd1e6fd5e887f10 = (viewport, change)=>$ed7d2bc081cd70a2$export$dbc3ad6130556cf6({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $ed7d2bc081cd70a2$export$2f1f3b9e315c6096 = (viewport, change)=>{
    if (!$ed7d2bc081cd70a2$export$cbd1e6fd5e887f10(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        current: current,
        max: max,
        change: change
    });
};
const $ed7d2bc081cd70a2$export$57c21b61d76c9819 = (scrollable, change)=>{
    return $ed7d2bc081cd70a2$export$dbc3ad6130556cf6({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};
const $ed7d2bc081cd70a2$export$d88a6b2979421049 = (scrollable, change)=>{
    if (!$ed7d2bc081cd70a2$export$57c21b61d76c9819(scrollable, change)) return null;
    return $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};

});
parcelRegister("6cABY", function(module, exports) {

$parcel$export(module.exports, "origin", () => $bbb11b5c60935496$export$f710a83a91838a36);
$parcel$export(module.exports, "apply", () => $bbb11b5c60935496$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "isEqual", () => $bbb11b5c60935496$export$248d38f6296296c5);
$parcel$export(module.exports, "add", () => $bbb11b5c60935496$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $bbb11b5c60935496$export$4e2d2ead65e5f7e3);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $bbb11b5c60935496$export$f710a83a91838a36 = {
    x: 0,
    y: 0
};
const $bbb11b5c60935496$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
const $bbb11b5c60935496$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $bbb11b5c60935496$export$e16d8520af44a096 = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $bbb11b5c60935496$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });

});


parcelRegister("h3yff", function(module, exports) {

$parcel$export(module.exports, "default", () => $04403a563aa15b3f$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $1FJBN = parcelRequire("1FJBN");

var $6cABY = parcelRequire("6cABY");

var $gaAYU = parcelRequire("gaAYU");
// will replace -0 and replace with +0
const $04403a563aa15b3f$var$clean = (0, $6cABY.apply)((value)=>value === 0 ? 0 : value);
var $04403a563aa15b3f$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    // get distance to each edge
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    // 1. Figure out which x,y values are the best target
    // 2. Can the container scroll in that direction at all?
    // If no for both directions, then return null
    // 3. Is the center close enough to a edge to start a drag?
    // 4. Based on the distance, calculate the speed at which a scroll should occur
    // The lower distance value the faster the scroll should be.
    // Maximum speed value should be hit before the distance is 0
    // Negative values to not continue to increase the speed
    const y = (0, $gaAYU.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $1FJBN.vertical),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const x = (0, $gaAYU.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $1FJBN.horizontal),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const required = $04403a563aa15b3f$var$clean({
        x: x,
        y: y
    });
    // nothing required
    if ((0, $6cABY.isEqual)(required, (0, $6cABY.origin))) return null;
    return required;
};

});
parcelRegister("1FJBN", function(module, exports) {

$parcel$export(module.exports, "minScroll", () => $68996f5601ae722f$export$67e2de1e1e796844);
$parcel$export(module.exports, "vertical", () => $68996f5601ae722f$export$32f8a6eb41d46820);
$parcel$export(module.exports, "horizontal", () => $68996f5601ae722f$export$641ecd0b2bc39508);
const $68996f5601ae722f$export$67e2de1e1e796844 = 1;
const $68996f5601ae722f$export$32f8a6eb41d46820 = {
    direction: 'vertical',
    start: 'top',
    end: 'bottom',
    size: 'height',
    scrollAxis: 'scrollTop'
};
const $68996f5601ae722f$export$641ecd0b2bc39508 = {
    direction: 'horizontal',
    start: 'left',
    end: 'right',
    size: 'width',
    scrollAxis: 'scrollLeft'
};
const $68996f5601ae722f$export$1a8fc111f6979e7a = [
    $68996f5601ae722f$export$641ecd0b2bc39508.direction,
    $68996f5601ae722f$export$32f8a6eb41d46820.direction
];

});

parcelRegister("gaAYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9042b92424eff0cb$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8Yq8R = parcelRequire("8Yq8R");

var $j3mW5 = parcelRequire("j3mW5");
var $9042b92424eff0cb$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const thresholds = (0, $8Yq8R.default)(container, axis);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return (0, $j3mW5.default)({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * (0, $j3mW5.default)({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};

});
parcelRegister("8Yq8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $6206878988e06aa9$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");
const $6206878988e06aa9$export$79446fee27934459 = (container, axis)=>{
    const startScrollingFrom = container[axis.size] * (0, $CBqIn.default).startFromPercentage;
    const maxScrollValueAt = container[axis.size] * (0, $CBqIn.default).maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $6206878988e06aa9$export$2e2bcd8739ae039 = $6206878988e06aa9$export$79446fee27934459;

});
parcelRegister("CBqIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e1c26e7adafc61$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd
// Values used to control how the fluid auto scroll feels
const $22e1c26e7adafc61$var$config = {
    // percentage distance from edge of container:
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    // pixels per frame
    maxPixelScroll: 28,
    // A function used to ease a percentage value
    // A simple linear function would be: (percentage) => percentage;
    // percentage is between 0 and 1
    // result must be between 0 and 1
    ease: (percentage)=>Math.pow(percentage, 2),
    durationDampening: {
        // ms: how long to dampen the speed of an auto scroll from the start of a drag
        stopDampeningAt: 1200,
        // ms: when to start accelerating the reduction of duration dampening
        accelerateAt: 360
    }
};
var $22e1c26e7adafc61$export$2e2bcd8739ae039 = $22e1c26e7adafc61$var$config;

});


parcelRegister("j3mW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4138cfd10b8d6cb6$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $1FJBN = parcelRequire("1FJBN");

var $GGnA2 = parcelRequire("GGnA2");

var $i7kxC = parcelRequire("i7kxC");
const $4138cfd10b8d6cb6$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $i7kxC.getValueFromDistance)(distanceToEdge, thresholds);
    // not enough distance to trigger a minimum scroll
    // we can bail here
    if (scroll === 0) return 0;
    // Dampen an auto scroll speed based on duration of drag
    if (!shouldUseTimeDampening) return scroll;
    // Once we know an auto scroll should occur based on distance,
    // we must let at least 1px through to trigger a scroll event an
    // another auto scroll call
    return Math.max((0, $GGnA2.dampenValueByTime)(scroll, dragStartTime), (0, $1FJBN.minScroll));
};
var $4138cfd10b8d6cb6$export$2e2bcd8739ae039 = $4138cfd10b8d6cb6$export$bf7199a9ebcb84a9;

});
parcelRegister("GGnA2", function(module, exports) {

$parcel$export(module.exports, "dampenValueByTime", () => $09e5877382e55f91$export$2fe468ff7a999ed6);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");

var $1FJBN = parcelRequire("1FJBN");

var $gYLmt = parcelRequire("gYLmt");
const $09e5877382e55f91$var$accelerateAt = (0, $CBqIn.default).durationDampening.accelerateAt;
const $09e5877382e55f91$var$stopAt = (0, $CBqIn.default).durationDampening.stopDampeningAt;
const $09e5877382e55f91$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
    const startOfRange = dragStartTime;
    const endOfRange = $09e5877382e55f91$var$stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    // we have finished the time dampening period
    if (runTime >= $09e5877382e55f91$var$stopAt) return proposedScroll;
    // Up to this point we know there is a proposed scroll
    // but we have not reached our accelerate point
    // Return the minimum amount of scroll
    if (runTime < $09e5877382e55f91$var$accelerateAt) return 0, $1FJBN.minScroll;
    const betweenAccelerateAtAndStopAtPercentage = (0, $gYLmt.getPercentage)({
        startOfRange: $09e5877382e55f91$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * (0, $CBqIn.default).ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};

});
parcelRegister("gYLmt", function(module, exports) {

$parcel$export(module.exports, "getPercentage", () => $ee56cf2a5b618f47$export$6712e0f6cd0ea03);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $ee56cf2a5b618f47$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) /**
		 * Detected distance range of 0 in the auto scroller
		 * This is unexpected and would cause a divide by 0 issue.
		 * Not allowing an auto scroll
		 */ return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};

});


parcelRegister("i7kxC", function(module, exports) {

$parcel$export(module.exports, "getValueFromDistance", () => $6739aefbd53be9fe$export$f3e495573a199c91);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");

var $1FJBN = parcelRequire("1FJBN");

var $gYLmt = parcelRequire("gYLmt");
const $6739aefbd53be9fe$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
    /*
  // This function only looks at the distance to one edge
  // Example: looking at bottom edge
  |----------------------------------|
  |                                  |
  |                                  |
  |                                  |
  |                                  |
  |                                  | => no scroll in this range
  |                                  |
  |                                  |
  |  startScrollingFrom (eg 100px)   |
  |                                  |
  |                                  | => increased scroll value the closer to maxScrollValueAt
  |  maxScrollValueAt (eg 10px)      |
  |                                  | => max scroll value in this range
  |----------------------------------|
  */ // too far away to auto scroll
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    // use max speed when on or over boundary
    if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, $CBqIn.default).maxPixelScroll;
    // when just going on the boundary return the minimum integer
    if (distanceToEdge === thresholds.startScrollingFrom) return 0, $1FJBN.minScroll;
    // to get the % past startScrollingFrom we will calculate
    // the % the value is from maxScrollValueAt and then invert it
    const percentageFromMaxScrollValueAt = (0, $gYLmt.getPercentage)({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = (0, $CBqIn.default).maxPixelScroll * (0, $CBqIn.default).ease(percentageFromStartScrollingFrom);
    // scroll will always be a positive integer
    return Math.ceil(scroll);
};

});





parcelRegister("91kec", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb7d3871adca53b5$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $kuXkS = parcelRequire("kuXkS");

var $h3yff = parcelRequire("h3yff");
var $eb7d3871adca53b5$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $h3yff.default)({
        dragStartTime: dragStartTime,
        container: viewport.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $kuXkS.canScrollWindow)(viewport, scroll) ? scroll : null;
};

});

parcelRegister("2kKFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $02749ab18659f739$export$2e2bcd8739ae039);

var $bn5nT = parcelRequire("bn5nT");

var $iWYOC = parcelRequire("iWYOC");

var $bRP67 = parcelRequire("bRP67");
var $02749ab18659f739$export$2e2bcd8739ae039 = ()=>{
    const scroll = (0, $bRP67.default)();
    const maxScroll = (0, $iWYOC.default)();
    const top = scroll.y;
    const left = scroll.x;
    // window.innerHeight: includes scrollbars (not what we want)
    // document.clientHeight gives us the correct value when using the html5 doctype
    const doc = document.documentElement;
    // Using these values as they do not consider scrollbars
    // padding box, without scrollbar
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    // Computed
    const right = left + width;
    const bottom = top + height;
    const container = (0, $bn5nT.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        container: container,
        scroll: {
            current: scroll,
            max: maxScroll
        }
    };
    return viewport;
};

});
parcelRegister("iWYOC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb903add7ce77d90$export$2e2bcd8739ae039);

var $geSJi = parcelRequire("geSJi");
var $bb903add7ce77d90$export$2e2bcd8739ae039 = ()=>{
    const doc = document.documentElement;
    const maxScroll = (0, $geSJi.default)({
        // unclipped padding box, with scrollbar
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        // clipped padding box, without scrollbar
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};

});
parcelRegister("geSJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c38d3b19198398$export$2e2bcd8739ae039);

var $6cABY = parcelRequire("6cABY");
var $b6c38d3b19198398$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = (0, $6cABY.subtract)(// full size
    {
        x: scrollWidth,
        y: scrollHeight
    }, // viewport size
    {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};

});


parcelRegister("bRP67", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8599f91bb8874$export$2e2bcd8739ae039);
var // The browsers update document.documentElement.scrollTop and window.pageYOffset
// differently as the window scrolls.
// Webkit
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
// Chrome
// documentElement.scrollTop: update with fractional value
// window.pageYOffset: update with fractional value
// FireFox
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// IE11 (same as firefox)
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// Edge (same as webkit)
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
$a7d8599f91bb8874$export$2e2bcd8739ae039 = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });

});





parcelRegister("7KPyi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4944521059702c22$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ynlC = parcelRequire("8ynlC");

var $eo9PV = parcelRequire("eo9PV");

var $cbxSN = parcelRequire("cbxSN");

var $jTs7k = parcelRequire("jTs7k");

var $7Wjpo = parcelRequire("7Wjpo");

var $5ZQjJ = parcelRequire("5ZQjJ");
const $4944521059702c22$var$baseTrackStyles = null;
const $4944521059702c22$var$baseThumbStyles = null;
const $4944521059702c22$var$visibleStyles = null;
const $4944521059702c22$var$notVisibleStyles = null;
const $4944521059702c22$var$verticalTrackStyles = null;
const $4944521059702c22$var$horizontalTrackStyles = null;
const $4944521059702c22$var$verticalThumbStyles = null;
const $4944521059702c22$var$horizontalThumbStyles = null;
const $4944521059702c22$var$useImperativeTracksAndThumbs = ({ mainComponentRef: mainComponentRef })=>{
    const horizontalTrackRef = (0, $eUqFw.useRef)(null);
    const horizontalThumbRef = (0, $eUqFw.useRef)(null);
    const verticalTrackRef = (0, $eUqFw.useRef)(null);
    const verticalThumbRef = (0, $eUqFw.useRef)(null);
    // State updates are not batched outside React synthetic events so we consolidate the data here
    const [{ horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize }, setThumbSizes] = (0, $eUqFw.useState)({
        horizontalThumbSize: 0,
        verticalThumbSize: 0
    });
    const setHorizontalThumbPosition = (0, $eUqFw.useCallback)((trackSize, scrollRatio, thumbSize)=>{
        if (scrollRatio >= 0) {
            const position = (0, $5ZQjJ.getThumbPosition)(scrollRatio, trackSize, thumbSize);
            if (horizontalThumbRef.current) horizontalThumbRef.current.style.transform = `translateX(${position}px)`;
        }
    }, []);
    const setVerticalThumbPosition = (0, $eUqFw.useCallback)((trackSize, scrollRatio, thumbSize)=>{
        if (scrollRatio >= 0) {
            const position = (0, $5ZQjJ.getThumbPosition)(scrollRatio, trackSize, thumbSize);
            if (verticalThumbRef.current) verticalThumbRef.current.style.transform = `translateY(${position}px)`;
        }
    }, []);
    (0, $eUqFw.useImperativeHandle)(mainComponentRef, ()=>({
            setThumbPositions: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio })=>{
                if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to set the thumb positions were null');
                // DOM reads //
                const { clientWidth: clientWidth } = horizontalTrackRef.current;
                const { clientHeight: clientHeight } = verticalTrackRef.current;
                // DOM writes //
                setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, horizontalThumbSize);
                setVerticalThumbPosition(clientHeight, verticalScrollRatio, verticalThumbSize);
            },
            update: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio }, { horizontalContentRatio: horizontalContentRatio, verticalContentRatio: verticalContentRatio })=>{
                if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to update the thumb tracks were null');
                // DOM reads //
                const { clientWidth: clientWidth } = horizontalTrackRef.current;
                const { clientHeight: clientHeight } = verticalTrackRef.current;
                let hThumbSize = 0;
                let vThumbSize = 0;
                // DOM writes //
                if (horizontalContentRatio < 1) {
                    hThumbSize = (0, $5ZQjJ.getThumbSize)(horizontalContentRatio, clientWidth);
                    setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, hThumbSize);
                }
                if (verticalContentRatio < 1) {
                    vThumbSize = (0, $5ZQjJ.getThumbSize)(verticalContentRatio, clientHeight);
                    setVerticalThumbPosition(clientHeight, verticalScrollRatio, vThumbSize);
                }
                setThumbSizes((0, $5ZQjJ.getMemoisedThumbState)(hThumbSize, vThumbSize));
            }
        }), [
        horizontalThumbSize,
        verticalThumbSize,
        setHorizontalThumbPosition,
        setVerticalThumbPosition
    ]);
    return {
        horizontalThumbRef: horizontalThumbRef,
        horizontalTrackRef: horizontalTrackRef,
        verticalTrackRef: verticalTrackRef,
        verticalThumbRef: verticalThumbRef,
        horizontalThumbSize: horizontalThumbSize,
        verticalThumbSize: verticalThumbSize
    };
};
// Stop propogation of mouse down event from thumb to track in order to
// prevent jumping of thumb to click point of track "beneath" the thumb.
const $4944521059702c22$var$handleThumbMouseDown = (event)=>{
    event.stopPropagation();
};
/* This component is responsible for displaying the custom track and thumb.
 *
 * Responding to user actions (e.g. clicking or dragging) are handled internally, while syncing with changes from external
 * sources (e.g. window resizes) are managed by the parent component via a custom ref. The track dimensions are not a 1:1
 * recreation of the real track, since it is only displayed over the timeline, and so all parameters from the parent are
 * "viewport relative" and translated internally to "track relative" coordinate system.
 */ const $4944521059702c22$var$CustomScrollbarThumbTracks = ({ listWidth: listWidth, isHideScrollbar: isHideScrollbar, timelineTop: timelineTop, onSetScrollLeft: onSetScrollLeft, onSetScrollTop: onSetScrollTop }, ref)=>{
    const dragCache = (0, $eUqFw.useRef)((0, $7Wjpo.DEFAULT_DRAG_CACHE));
    // ========================= //
    // === IMPERATIVE EFFECT === //
    // ========================= //
    const { horizontalThumbRef: horizontalThumbRef, horizontalTrackRef: horizontalTrackRef, verticalTrackRef: verticalTrackRef, verticalThumbRef: verticalThumbRef, horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize } = $4944521059702c22$var$useImperativeTracksAndThumbs({
        mainComponentRef: ref
    });
    // ===================================== //
    // ==== EVENT HANDLING - HORIZONTAL ==== //
    // ===================================== //
    const onStartDragHorizontalThumb = (0, $eUqFw.useCallback)(({ location: location })=>{
        if (!horizontalTrackRef.current || !horizontalThumbRef.current) throw new Error('An element required to drag the horizontal scroll thumb was null');
        const { left: left, width: width } = horizontalTrackRef.current.getBoundingClientRect();
        const thumbClientRect = horizontalThumbRef.current.getBoundingClientRect();
        const relativeMousePosition = location.initial.input.clientX - thumbClientRect.left;
        dragCache.current = {
            thumbOrigin: Math.round(horizontalThumbSize / 2 - relativeMousePosition),
            trackPosition: left,
            trackSize: width
        };
    }, [
        horizontalThumbRef,
        horizontalThumbSize,
        horizontalTrackRef
    ]);
    const onDragHorizontalThumb = (0, $eUqFw.useCallback)(({ location: location })=>{
        const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: thumbOrigin + location.current.input.clientX,
            thumbSize: horizontalThumbSize,
            trackPosition: trackPosition,
            trackSize: trackSize
        });
        onSetScrollLeft(relativeScrollPosition);
    }, [
        horizontalThumbSize,
        onSetScrollLeft
    ]);
    const onMouseDownHorizontalTrack = (event)=>{
        const { left: left, width: width } = event.currentTarget.getBoundingClientRect();
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: event.pageX,
            thumbSize: horizontalThumbSize,
            trackPosition: left,
            trackSize: width
        });
        onSetScrollLeft(relativeScrollPosition);
    };
    // =================================== //
    // ==== EVENT HANDLING - VERTICAL ==== //
    // =================================== //
    const onMouseDownVerticalTrack = (event)=>{
        const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: event.pageY,
            thumbSize: verticalThumbSize,
            trackPosition: top,
            trackSize: height
        });
        onSetScrollTop(relativeScrollPosition);
    };
    const onStartDragVerticalThumb = (0, $eUqFw.useCallback)(({ location: location })=>{
        if (!verticalTrackRef.current || !verticalThumbRef.current) throw new Error('An element required to drag the vertical scroll thumb was null');
        const { top: top, height: height } = verticalTrackRef.current.getBoundingClientRect();
        const thumbClientRect = verticalThumbRef.current.getBoundingClientRect();
        const relativeMousePosition = location.initial.input.clientY - thumbClientRect.top;
        dragCache.current = {
            thumbOrigin: Math.round(verticalThumbSize / 2 - relativeMousePosition),
            trackPosition: top,
            trackSize: height
        };
    }, [
        verticalThumbRef,
        verticalThumbSize,
        verticalTrackRef
    ]);
    const onDragVerticalThumb = (0, $eUqFw.useCallback)(({ location: location })=>{
        const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: thumbOrigin + location.current.input.clientY,
            thumbSize: verticalThumbSize,
            trackPosition: trackPosition,
            trackSize: trackSize
        });
        onSetScrollTop(relativeScrollPosition);
    }, [
        verticalThumbSize,
        onSetScrollTop
    ]);
    // ================ //
    // ==== EFFECTS ==== //
    // ================ //
    (0, $eUqFw.useEffect)(()=>{
        const horizontalThumb = horizontalThumbRef.current;
        (0, $8ynlC.default)(horizontalThumb);
        return (0, $eo9PV.draggable)({
            element: horizontalThumb,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $cbxSN.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $jTs7k.preventUnhandled).start();
            },
            onDragStart: onStartDragHorizontalThumb,
            onDrag: onDragHorizontalThumb
        });
    }, [
        onStartDragHorizontalThumb,
        onDragHorizontalThumb,
        horizontalThumbRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const verticalThumb = verticalThumbRef.current;
        (0, $8ynlC.default)(verticalThumb);
        return (0, $eo9PV.draggable)({
            element: verticalThumb,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $cbxSN.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $jTs7k.preventUnhandled).start();
            },
            onDragStart: onStartDragVerticalThumb,
            onDrag: onDragVerticalThumb
        });
    }, [
        onStartDragVerticalThumb,
        onDragVerticalThumb,
        verticalThumbRef
    ]);
    // ================ //
    // ==== RENDER ==== //
    // ================ //
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: horizontalTrackRef,
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-track",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            left: `${listWidth + (0, $7Wjpo.SCROLLBAR_OFFSET)}px`
        },
        onMouseDown: onMouseDownHorizontalTrack,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
            horizontalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
            "_1xi21v6z _4t3i19bv _94n5idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-thumb",
        ref: horizontalThumbRef,
        onMouseDown: $4944521059702c22$var$handleThumbMouseDown,
        style: {
            width: `${horizontalThumbSize}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko19bv _bfhkvrk4",
            "_4t3i1osq"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: verticalTrackRef,
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-track",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `${timelineTop + (0, $7Wjpo.SCROLLBAR_OFFSET)}px`
        },
        onMouseDown: onMouseDownVerticalTrack,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
            verticalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
            "_94n51v6z _1bsb19bv _1xi2idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-thumb",
        ref: verticalThumbRef,
        onMouseDown: $4944521059702c22$var$handleThumbMouseDown,
        style: {
            height: `${verticalThumbSize}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko19bv _bfhkvrk4",
            "_1bsb1osq"
        ])
    })));
};
var $4944521059702c22$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($4944521059702c22$var$CustomScrollbarThumbTracks);

});
parcelRegister("7Wjpo", function(module, exports) {

$parcel$export(module.exports, "THUMB_DRAG_THRESHOLD", () => $aff5bb37216db935$export$e42a8c8f5541f7b0);
$parcel$export(module.exports, "THUMB_MINIMUM_SIZE", () => $aff5bb37216db935$export$e68be48bcc227668);
$parcel$export(module.exports, "SCROLLBAR_OFFSET", () => $aff5bb37216db935$export$b902a3a0053e40b);
$parcel$export(module.exports, "DEFAULT_DRAG_CACHE", () => $aff5bb37216db935$export$1580f12b2bee9a05);
const $aff5bb37216db935$export$e42a8c8f5541f7b0 = 0.1;
const $aff5bb37216db935$export$e68be48bcc227668 = 20;
const $aff5bb37216db935$export$d83d7e5e215aa7f9 = 10;
const $aff5bb37216db935$export$b902a3a0053e40b = 7;
const $aff5bb37216db935$export$1580f12b2bee9a05 = {
    thumbOrigin: 0,
    trackPosition: 0,
    trackSize: 0
};

});

parcelRegister("5ZQjJ", function(module, exports) {

$parcel$export(module.exports, "getRelativeScrollPosition", () => $f982f1b365577dba$export$2bc8e9ae2ef96ba4);
$parcel$export(module.exports, "getThumbPosition", () => $f982f1b365577dba$export$1bcd41904c090870);
$parcel$export(module.exports, "getThumbSize", () => $f982f1b365577dba$export$7b14c3f3cc4d1eca);
$parcel$export(module.exports, "getMemoisedThumbState", () => $f982f1b365577dba$export$1c021ba4dc4fcf31);

var $5iWql = parcelRequire("5iWql");

var $7Wjpo = parcelRequire("7Wjpo");
const $f982f1b365577dba$export$2bc8e9ae2ef96ba4 = ({ thumbPosition: thumbPosition, thumbSize: thumbSize, trackPosition: trackPosition, trackSize: trackSize })=>{
    const relativePosition = thumbPosition - trackPosition;
    const newThumbOffset = relativePosition - thumbSize / 2;
    return newThumbOffset / trackSize;
};
const $f982f1b365577dba$export$1bcd41904c090870 = (scrollOffsetRatio, trackSize, thumbSize)=>scrollOffsetRatio * (trackSize - thumbSize);
const $f982f1b365577dba$export$7b14c3f3cc4d1eca = (contentToViewportRatio, trackSize)=>{
    const size = Math.round(contentToViewportRatio * trackSize);
    return Math.max((0, $7Wjpo.THUMB_MINIMUM_SIZE), size);
};
const $f982f1b365577dba$export$1c021ba4dc4fcf31 = (0, $5iWql.default)((horizontalThumbSize, verticalThumbSize)=>({
        horizontalThumbSize: horizontalThumbSize,
        verticalThumbSize: verticalThumbSize
    }));

});


parcelRegister("k1DV2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fdbd44980992f3$export$2e2bcd8739ae039);
/* index-old.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* ===========================================================================
 * === LEGACY @atlassian/jira-drag-observer implementation ===
 *
 *
 * This entire .thumb-tracks` module can be deleted once the new
 * `thumb-tracks` implementation with @atlaskit/pragmatic-drag-and-drop has been
 * soaked in production and the feature gate is deprecated.
 *
 * TODO(FG-REMOVE): jsw_roadmaps_timeline_table_custom_scroll_pdnd
 *
 * https://switcheroo.atlassian.com/ui/gates/49cac7b3-a5f8-45d9-9533-08d52c4f3345
 *
 * =========================================================================== */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3R70n = parcelRequire("3R70n");

var $7Wjpo = parcelRequire("7Wjpo");

var $5ZQjJ = parcelRequire("5ZQjJ");
const $a4fdbd44980992f3$var$baseTrackStyles = null;
const $a4fdbd44980992f3$var$baseThumbStyles = null;
const $a4fdbd44980992f3$var$visibleStyles = null;
const $a4fdbd44980992f3$var$notVisibleStyles = null;
const $a4fdbd44980992f3$var$verticalTrackStyles = null;
const $a4fdbd44980992f3$var$horizontalTrackStyles = null;
const $a4fdbd44980992f3$var$verticalThumbStyles = null;
const $a4fdbd44980992f3$var$horizontalThumbStyles = null;
const $a4fdbd44980992f3$var$HorizontalThumb = ({ size: size, innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-thumb",
        ref: innerRef,
        style: {
            width: `${size}px`
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko19bv _bfhkvrk4",
            "_4t3i1osq"
        ])
    }, children);
const $a4fdbd44980992f3$var$VerticalThumb = ({ size: size, innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-thumb",
        ref: innerRef,
        style: {
            height: `${size}px`
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko19bv _bfhkvrk4",
            "_1bsb1osq"
        ])
    }, children);
const $a4fdbd44980992f3$var$DraggableHorizontalThumb = (0, $3R70n.withDragObserver)($a4fdbd44980992f3$var$HorizontalThumb, (0, $7Wjpo.THUMB_DRAG_THRESHOLD));
const $a4fdbd44980992f3$var$DraggableVerticalThumb = (0, $3R70n.withDragObserver)($a4fdbd44980992f3$var$VerticalThumb, (0, $7Wjpo.THUMB_DRAG_THRESHOLD));
/* This component is responsible for displaying the custom track and thumb.
 *
 * Responding to user actions (e.g. clicking or dragging) are handled internally, while syncing with changes from external
 * sources (e.g. window resizes) are managed by the parent component via a custom ref. The track dimensions are not a 1:1
 * recreation of the real track, since it is only displayed over the timeline, and so all parameters from the parent are
 * "viewport relative" and translated internally to "track relative" coordinate system.

 */ const $a4fdbd44980992f3$var$ScrollbarThumbTracks = ({ listWidth: listWidth, isHideScrollbar: isHideScrollbar, timelineTop: timelineTop, onSetScrollLeft: onSetScrollLeft, onSetScrollTop: onSetScrollTop }, ref)=>{
    const horizontalTrackRef = (0, $eUqFw.useRef)(null);
    const horizontalThumbRef = (0, $eUqFw.useRef)(null);
    const verticalTrackRef = (0, $eUqFw.useRef)(null);
    const verticalThumbRef = (0, $eUqFw.useRef)(null);
    const dragCache = (0, $eUqFw.useRef)((0, $7Wjpo.DEFAULT_DRAG_CACHE));
    // State updates are not batched outside React synthetic events so we consolidate the data here
    const [{ horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize }, setThumbSizes] = (0, $eUqFw.useState)({
        horizontalThumbSize: 0,
        verticalThumbSize: 0
    });
    // ========================= //
    // === IMPERATIVE EFFECT === //
    // ========================= //
    const setHorizontalThumbPosition = (0, $eUqFw.useCallback)((trackSize, scrollRatio, thumbSize)=>{
        if (scrollRatio >= 0) {
            const position = (0, $5ZQjJ.getThumbPosition)(scrollRatio, trackSize, thumbSize);
            if (horizontalThumbRef.current) horizontalThumbRef.current.style.transform = `translateX(${position}px)`;
        }
    }, []);
    const setVerticalThumbPosition = (0, $eUqFw.useCallback)((trackSize, scrollRatio, thumbSize)=>{
        if (scrollRatio >= 0) {
            const position = (0, $5ZQjJ.getThumbPosition)(scrollRatio, trackSize, thumbSize);
            if (verticalThumbRef.current) verticalThumbRef.current.style.transform = `translateY(${position}px)`;
        }
    }, []);
    (0, $eUqFw.useImperativeHandle)(ref, ()=>({
            setThumbPositions: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio })=>{
                if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to set the thumb positions were null');
                // DOM reads //
                const { clientWidth: clientWidth } = horizontalTrackRef.current;
                const { clientHeight: clientHeight } = verticalTrackRef.current;
                // DOM writes //
                setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, horizontalThumbSize);
                setVerticalThumbPosition(clientHeight, verticalScrollRatio, verticalThumbSize);
            },
            update: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio }, { horizontalContentRatio: horizontalContentRatio, verticalContentRatio: verticalContentRatio })=>{
                if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to update the thumb tracks were null');
                // DOM reads //
                const { clientWidth: clientWidth } = horizontalTrackRef.current;
                const { clientHeight: clientHeight } = verticalTrackRef.current;
                let hThumbSize = 0;
                let vThumbSize = 0;
                // DOM writes //
                if (horizontalContentRatio < 1) {
                    hThumbSize = (0, $5ZQjJ.getThumbSize)(horizontalContentRatio, clientWidth);
                    setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, hThumbSize);
                }
                if (verticalContentRatio < 1) {
                    vThumbSize = (0, $5ZQjJ.getThumbSize)(verticalContentRatio, clientHeight);
                    setVerticalThumbPosition(clientHeight, verticalScrollRatio, vThumbSize);
                }
                setThumbSizes((0, $5ZQjJ.getMemoisedThumbState)(hThumbSize, vThumbSize));
            }
        }), [
        horizontalThumbSize,
        verticalThumbSize,
        setHorizontalThumbPosition,
        setVerticalThumbPosition
    ]);
    // ===================================== //
    // ==== EVENT HANDLING - HORIZONTAL ==== //
    // ===================================== //
    const onStartDragHorizontalThumb = ({ x: x })=>{
        if (!horizontalTrackRef.current || !horizontalThumbRef.current) throw new Error('An element required to drag the horizontal scroll thumb was null');
        const { left: left, width: width } = horizontalTrackRef.current.getBoundingClientRect();
        const thumbClientRect = horizontalThumbRef.current.getBoundingClientRect();
        const relativeMousePosition = x - thumbClientRect.left;
        dragCache.current = {
            thumbOrigin: Math.round(horizontalThumbSize / 2 - relativeMousePosition),
            trackPosition: left,
            trackSize: width
        };
    };
    const onDragHorizontalThumb = (from, to)=>{
        const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: thumbOrigin + to.x,
            thumbSize: horizontalThumbSize,
            trackPosition: trackPosition,
            trackSize: trackSize
        });
        onSetScrollLeft(relativeScrollPosition);
    };
    const onMouseDownHorizontalTrack = (event)=>{
        const { left: left, width: width } = event.currentTarget.getBoundingClientRect();
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: event.pageX,
            thumbSize: horizontalThumbSize,
            trackPosition: left,
            trackSize: width
        });
        onSetScrollLeft(relativeScrollPosition);
    };
    // =================================== //
    // ==== EVENT HANDLING - VERTICAL ==== //
    // =================================== //
    const onStartDragVerticalThumb = ({ y: y })=>{
        if (!verticalTrackRef.current || !verticalThumbRef.current) throw new Error('An element required to drag the vertical scroll thumb was null');
        const { top: top, height: height } = verticalTrackRef.current.getBoundingClientRect();
        const thumbClientRect = verticalThumbRef.current.getBoundingClientRect();
        const relativeMousePosition = y - thumbClientRect.top;
        dragCache.current = {
            thumbOrigin: Math.round(verticalThumbSize / 2 - relativeMousePosition),
            trackPosition: top,
            trackSize: height
        };
    };
    const onDragVerticalThumb = (from, to)=>{
        const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: thumbOrigin + to.y,
            thumbSize: verticalThumbSize,
            trackPosition: trackPosition,
            trackSize: trackSize
        });
        onSetScrollTop(relativeScrollPosition);
    };
    const onMouseDownVerticalTrack = (event)=>{
        const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: event.pageY,
            thumbSize: verticalThumbSize,
            trackPosition: top,
            trackSize: height
        });
        onSetScrollTop(relativeScrollPosition);
    };
    // ================ //
    // ==== RENDER ==== //
    // ================ //
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: horizontalTrackRef,
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-track",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            left: `${listWidth + (0, $7Wjpo.SCROLLBAR_OFFSET)}px`
        },
        onMouseDown: onMouseDownHorizontalTrack,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
            horizontalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
            "_1xi21v6z _4t3i19bv _94n5idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a4fdbd44980992f3$var$DraggableHorizontalThumb, {
        // TODO: Not sure how to type innerRef when it's not an styled component. Is it due to DraggableHorizontalThumb being a class component?
        // @ts-expect-error - TS2322 - Type '{ innerRef: MutableRefObject<unknown>; size: number; onDrag: OnDrag; onDragStart: OnDragStart; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props> & Readonly<...>, "children"> & Partial<...> & Partial<...>'.
        innerRef: horizontalThumbRef,
        size: horizontalThumbSize,
        onDrag: onDragHorizontalThumb,
        onDragStart: onStartDragHorizontalThumb
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: verticalTrackRef,
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-track",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `${timelineTop + (0, $7Wjpo.SCROLLBAR_OFFSET)}px`
        },
        onMouseDown: onMouseDownVerticalTrack,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
            verticalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
            "_94n51v6z _1bsb19bv _1xi2idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a4fdbd44980992f3$var$DraggableVerticalThumb, {
        // TODO: Not sure how to type innerRef when it's not an styled component. Is it due to DraggableHorizontalThumb being a class component?
        // @ts-expect-error - TS2322 - Type '{ innerRef: MutableRefObject<unknown>; size: number; onDrag: OnDrag; onDragStart: OnDragStart; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props> & Readonly<...>, "children"> & Partial<...> & Partial<...>'.
        innerRef: verticalThumbRef,
        size: verticalThumbSize,
        onDrag: onDragVerticalThumb,
        onDragStart: onStartDragVerticalThumb
    })));
};
var $a4fdbd44980992f3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($a4fdbd44980992f3$var$ScrollbarThumbTracks);

});

parcelRegister("4RNyl", function(module, exports) {

$parcel$export(module.exports, "getScrollbarSize", () => $4d5d7e886d05d40e$export$728dbf35b325565b);
$parcel$export(module.exports, "getScrollOffsetRatio", () => $4d5d7e886d05d40e$export$1fb2953abd799768);
$parcel$export(module.exports, "getContentToViewportRatio", () => $4d5d7e886d05d40e$export$e27ceda66fe97870);
$parcel$export(module.exports, "getViewportOffsets", () => $4d5d7e886d05d40e$export$af20ae2261e1a891);

var $5iWql = parcelRequire("5iWql");
const $4d5d7e886d05d40e$export$728dbf35b325565b = (scrollElement)=>scrollElement.offsetWidth - scrollElement.clientWidth;
const $4d5d7e886d05d40e$export$1fb2953abd799768 = (scrollOffset, scrollSize, clientSize)=>scrollOffset / (scrollSize - clientSize);
const $4d5d7e886d05d40e$export$e27ceda66fe97870 = (scrollSize, clientSize)=>clientSize / scrollSize;
const $4d5d7e886d05d40e$export$af20ae2261e1a891 = (0, $5iWql.default)((scrollbarSize, listWidth, timelineTop)=>({
        scrollbar: scrollbarSize,
        timelineLeft: listWidth,
        timelineTop: timelineTop
    }));

});


parcelRegister("jV7n9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2c727e6f00ceb62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");

var $bwj1b = parcelRequire("bwj1b");

var $cZkk1 = parcelRequire("cZkk1");

var $1sAbG = parcelRequire("1sAbG");
const $a2c727e6f00ceb62$var$DragMonitor = ({ DndLongTaskMetric: DndLongTaskMetric })=>{
    const [{ isTreeDrag: isTreeDrag }] = (0, $9WNLk.useEnablements)();
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        level: (0, $gf0vG.DEFAULT_LEVEL),
        isDragging: false
    });
    const { onRowDragStart: onRowDragStart, onRowDragEnd: onRowDragEnd, onRowDragOutOfBounds: onRowDragOutOfBounds } = (0, $bwj1b.useSideEffectMarshal)();
    const { onResize: onResize } = (0, $cZkk1.useTimelineViewportActions)();
    // Effects //
    (0, $eUqFw.useEffect)(()=>(0, $3f2za.combine)((0, $eo9PV.monitorForElements)({
            onDragStart: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID)) {
                    onRowDragStart(item.id);
                    setDragState({
                        level: item.level,
                        isDragging: true
                    });
                }
            },
            onDropTargetChange: ({ source: source, location: location })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID)) {
                    const { dropTargets: dropTargets } = location.current;
                    if (dropTargets.length === 0) onRowDragOutOfBounds(item.id);
                }
            },
            onDrop: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID)) {
                    onRowDragEnd(item.id);
                    setDragState({
                        level: item.level,
                        isDragging: false
                    });
                    if (isTreeDrag) onResize({
                        indicatorLineOffset: 0
                    });
                }
            }
        })), [
        onRowDragStart,
        onRowDragEnd,
        onRowDragOutOfBounds,
        onResize,
        isTreeDrag
    ]);
    return DndLongTaskMetric ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: dragState.isDragging,
        metricType: (0, $1sAbG.isBaseLevel)(dragState.level) ? (0, $gf0vG.CHILD_LIST_DRAG_AND_DROP) : (0, $gf0vG.LIST_DRAG_AND_DROP)
    }) : null;
};
const $a2c727e6f00ceb62$var$DragMonitorEnabler = (props)=>{
    const [{ isDragEnabled: isDragEnabled }] = (0, $9WNLk.useEnablements)();
    return isDragEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2c727e6f00ceb62$var$DragMonitor, props) : null;
};
var $a2c727e6f00ceb62$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a2c727e6f00ceb62$var$DragMonitorEnabler);

});

parcelRegister("76ouJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0304c9169ced0897$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jK1pm = parcelRequire("jK1pm");

var $gf0vG = parcelRequire("gf0vG");

var $VrUCp = parcelRequire("VrUCp");

var $hxnNZ = parcelRequire("hxnNZ");

var $agwqh = parcelRequire("agwqh");

var $gl0d6 = parcelRequire("gl0d6");

var $kbEZf = parcelRequire("kbEZf");
const $0304c9169ced0897$var$headerContainerStyles = null;
const $0304c9169ced0897$var$headerRowStyles = null;
const $0304c9169ced0897$var$headerShadow = null;
const $0304c9169ced0897$var$defaultBackground = null;
const $0304c9169ced0897$var$Header = ({ renderListHeaderItem: renderListHeaderItem, renderChartHeaderItem: renderChartHeaderItem })=>{
    const [{ headerItems: headerItems, headerHeight: headerHeight, isRowCountKnown: isRowCountKnown }] = (0, $VrUCp.useHeaderState)();
    const [isAtTop] = (0, $hxnNZ.isScrollToTop)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "timeline-table-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "rowgroup",
        style: {
            height: headerHeight
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _vchhusvi _1bsb1osq _154iidpf _11q7vuon _2rkoo8o8 _1pby1ial",
            !isAtTop && "_16qs157p"
        ])
    }, headerItems.map(({ height: height = (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT), id: id }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: id,
            "data-testid": `roadmap.timeline-table.main.header.sub-header-${id.toLowerCase()}`,
            role: "row",
            "aria-rowindex": isRowCountKnown ? index + 1 : undefined,
            style: {
                height: height
            },
            className: (0, $7JEyt.default)([
                "_kqswh2mm _1e0c1txw",
                id === (0, $gf0vG.DEFAULT_HEADER_ROW_ID) && "_bfhk1s4m"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbEZf.default), {
            id: id,
            itemHeight: height,
            renderListHeaderItem: renderListHeaderItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gl0d6.ChartHeaderCell), {
            id: id,
            itemHeight: height,
            renderChartHeaderItem: renderChartHeaderItem
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agwqh.default), {
        isOverlayInHeader: true
    })));
};
$0304c9169ced0897$var$Header.displayName = 'Header';
$0304c9169ced0897$var$Header.whyDidYouRender = true;
var $0304c9169ced0897$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0304c9169ced0897$var$Header);

});
parcelRegister("gl0d6", function(module, exports) {

$parcel$export(module.exports, "ChartHeaderCell", () => $0232b4fcdb767b8f$export$da889e50c82c0962);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");

var $cUFbE = parcelRequire("cUFbE");

var $3XwA1 = parcelRequire("3XwA1");

var $ffuBS = parcelRequire("ffuBS");
const $0232b4fcdb767b8f$var$defaultHeaderCellsContainer = null;
const $0232b4fcdb767b8f$var$subHeaderCellsContainer = null;
const $0232b4fcdb767b8f$export$da889e50c82c0962 = ({ id: id, itemHeight: itemHeight, renderChartHeaderItem: renderChartHeaderItem })=>{
    const [{ timelineWidth: timelineWidth, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, today: today }] = (0, $3XwA1.useTimelineState)();
    const [{ isHighlightToday: isHighlightToday }] = (0, $9WNLk.useEnablements)();
    const cellRef = (0, $cUFbE.useGridCell)(id, (0, $gf0vG.CHART_COLUMN_COORDINATE));
    if (id === (0, $gf0vG.DEFAULT_HEADER_ROW_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: timelineWidth,
            height: itemHeight
        },
        className: (0, $7JEyt.default)([
            "_kqswh2mm _vchhusvi _x3doh6cr _n7zlh6cr _1pby1ohn"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffuBS.default), {
        today: today,
        timelineMode: timelineMode,
        timelineDuration: timelineDuration,
        columnDurations: columnDurations,
        isHighlightToday: isHighlightToday
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: cellRef,
        role: "gridcell",
        tabIndex: -1,
        style: {
            width: timelineWidth,
            height: itemHeight
        },
        className: (0, $7JEyt.default)([
            "_kqswh2mm _vchhusvi _1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _n7zlh6cr _1pby1ohn _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
        ])
    }, renderChartHeaderItem({
        id: id
    }));
};

});
parcelRegister("ffuBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb06481ff45031bb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dnJL9 = parcelRequire("dnJL9");

var $gf0vG = parcelRequire("gf0vG");

var $l2CBN = parcelRequire("l2CBN");

var $dIvdb = parcelRequire("dIvdb");

var $4zJTp = parcelRequire("4zJTp");

var $83EWE = parcelRequire("83EWE");

var $7cCTq = parcelRequire("7cCTq");

var $ha3hq = parcelRequire("ha3hq");
const $fb06481ff45031bb$var$containerStyles = null;
const $fb06481ff45031bb$var$ChartCalendarCellsNew = ({ isHighlightToday: isHighlightToday, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations })=>{
    const todayColumnIndex = (0, $l2CBN.getTodayColumnIndex)(today, columnDurations);
    const getIsHighlighted = (0, $eUqFw.useCallback)((index)=>isHighlightToday && todayColumnIndex === index, [
        isHighlightToday,
        todayColumnIndex
    ]);
    const renderWeekCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const todayCoordinates = isHighlightToday ? (0, $dIvdb.getTodayCoordinates)(today, columnDurations) : undefined;
        const columnWeekNumbers = (0, $dIvdb.getColumnWeekNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zJTp.CalendarCellWrapper), {
                key: index,
                left: left,
                right: right,
                column: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ha3hq.default), {
                columnIndex: index,
                isHighlightToday: isHighlightToday,
                todayCoordinates: todayCoordinates,
                weekNumbers: columnWeekNumbers[index],
                yearCaption: yearCaptions[index],
                isHighlighted: getIsHighlighted(index)
            })));
    }, [
        isHighlightToday,
        today,
        columnDurations,
        getIsHighlighted
    ]);
    const renderMonthCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const columnMonthNumbers = (0, $dIvdb.getColumnMonthNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zJTp.CalendarCellWrapper), {
                key: index,
                left: left,
                right: right,
                column: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83EWE.default), {
                monthNumber: columnMonthNumbers[index],
                yearCaption: yearCaptions[index],
                isHighlighted: getIsHighlighted(index)
            })));
    }, [
        columnDurations,
        today,
        getIsHighlighted
    ]);
    const renderQuarterCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const columnQuarterNumbers = (0, $dIvdb.getColumnQuarterNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zJTp.CalendarCellWrapper), {
                key: index,
                left: left,
                right: right,
                column: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cCTq.default), {
                quarterNumber: columnQuarterNumbers[index],
                yearCaption: yearCaptions[index],
                isHighlighted: getIsHighlighted(index)
            })));
    }, [
        columnDurations,
        today,
        getIsHighlighted
    ]);
    const renderColumnsForMode = (0, $eUqFw.useCallback)(()=>{
        const columnPositions = (0, $l2CBN.getColumnPositions)(timelineDuration, columnDurations);
        if (timelineMode === (0, $gf0vG.WEEKS)) return renderWeekCells(columnPositions);
        if (timelineMode === (0, $gf0vG.MONTHS)) return renderMonthCells(columnPositions);
        return renderQuarterCells(columnPositions);
    }, [
        timelineMode,
        columnDurations,
        timelineDuration,
        renderWeekCells,
        renderMonthCells,
        renderQuarterCells
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq _4t3i1osq"
        ])
    }, renderColumnsForMode());
};
const $fb06481ff45031bb$var$ChartCalendarCellsOld = ({ isHighlightToday: isHighlightToday, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations })=>{
    const renderWeekCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const todayCoordinates = isHighlightToday ? (0, $dIvdb.getTodayCoordinates)(today, columnDurations) : undefined;
        const columnWeekNumbers = (0, $dIvdb.getColumnWeekNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zJTp.CalendarCellWrapper), {
                key: index,
                left: left,
                right: right,
                column: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ha3hq.default), {
                columnIndex: index,
                isHighlightToday: isHighlightToday,
                todayCoordinates: todayCoordinates,
                weekNumbers: columnWeekNumbers[index],
                yearCaption: yearCaptions[index]
            })));
    }, [
        isHighlightToday,
        today,
        columnDurations
    ]);
    const renderMonthCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const columnMonthNumbers = (0, $dIvdb.getColumnMonthNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zJTp.CalendarCellWrapper), {
                key: index,
                left: left,
                right: right,
                column: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83EWE.default), {
                monthNumber: columnMonthNumbers[index],
                yearCaption: yearCaptions[index]
            })));
    }, [
        today,
        columnDurations
    ]);
    const renderQuarterCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const columnQuarterNumbers = (0, $dIvdb.getColumnQuarterNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zJTp.CalendarCellWrapper), {
                key: index,
                left: left,
                right: right,
                column: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cCTq.default), {
                quarterNumber: columnQuarterNumbers[index],
                yearCaption: yearCaptions[index]
            })));
    }, [
        today,
        columnDurations
    ]);
    const renderColumnsForMode = (0, $eUqFw.useCallback)(()=>{
        const columnPositions = (0, $l2CBN.getColumnPositions)(timelineDuration, columnDurations);
        if (timelineMode === (0, $gf0vG.WEEKS)) return renderWeekCells(columnPositions);
        if (timelineMode === (0, $gf0vG.MONTHS)) return renderMonthCells(columnPositions);
        return renderQuarterCells(columnPositions);
    }, [
        timelineMode,
        columnDurations,
        timelineDuration,
        renderWeekCells,
        renderMonthCells,
        renderQuarterCells
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq _4t3i1osq"
        ])
    }, renderColumnsForMode());
};
$fb06481ff45031bb$var$ChartCalendarCellsNew.whyDidYouRender = true;
$fb06481ff45031bb$var$ChartCalendarCellsOld.whyDidYouRender = true;
const $fb06481ff45031bb$var$ChartCalendarCells = (0, $dnJL9.componentWithFG)('jsw_roadmaps_timeline-gridcell-header-contrast', $fb06481ff45031bb$var$ChartCalendarCellsNew, $fb06481ff45031bb$var$ChartCalendarCellsOld);
$fb06481ff45031bb$var$ChartCalendarCells.displayName = 'ChartCalendarCells';
var $fb06481ff45031bb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($fb06481ff45031bb$var$ChartCalendarCells);

});
parcelRegister("dIvdb", function(module, exports) {

$parcel$export(module.exports, "getColumnMonthNumbers", () => $fc19ef0a671248fd$export$2db9691736ad99a0);
$parcel$export(module.exports, "getColumnQuarterNumbers", () => $fc19ef0a671248fd$export$f8f2585f7189f116);
$parcel$export(module.exports, "getColumnYearCaptions", () => $fc19ef0a671248fd$export$318e116da7ff1363);
$parcel$export(module.exports, "getColumnWeekNumbers", () => $fc19ef0a671248fd$export$a1fb8a69eea17cba);
$parcel$export(module.exports, "getTodayCoordinates", () => $fc19ef0a671248fd$export$1c186d1bc45d38b7);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

var $l2CBN = parcelRequire("l2CBN");
const $fc19ef0a671248fd$export$2db9691736ad99a0 = (0, $5iWql.default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(columnDuration.startMilliseconds).month()));
const $fc19ef0a671248fd$export$f8f2585f7189f116 = (0, $5iWql.default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(columnDuration.startMilliseconds).quarter() - 1));
const $fc19ef0a671248fd$export$318e116da7ff1363 = (0, $5iWql.default)((today, columnDurations)=>{
    const startOfCurrentYear = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).startOf('year').valueOf();
    const endOfCurrentYear = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).endOf('year').valueOf();
    let cachedYear;
    let nextYear;
    /* Optimisation! Only calculate a caption when the year changes and interpolate the remaining values.
		 * This makes a substantial difference for granular timeline modes (e.g. weeks). */ return columnDurations.map(({ startMilliseconds: startMilliseconds })=>{
        if (startMilliseconds < startOfCurrentYear || startMilliseconds > endOfCurrentYear) {
            if (!cachedYear || startMilliseconds >= nextYear) {
                const columnMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(startMilliseconds);
                cachedYear = `'${columnMoment.year().toString().slice(2)}`;
                nextYear = columnMoment.add(1, 'year').startOf('year').valueOf();
            }
            return cachedYear;
        }
        return undefined;
    });
});
const $fc19ef0a671248fd$export$a1fb8a69eea17cba = (0, $5iWql.default)((columnDurations)=>{
    const daysArray = [
        ...new Array(7)
    ];
    /* Optimisation! By leveraging moment's mutative paradigm we can avoid creating an
	 * expensive moment object for every inner loop - or O(N) vs O(N^2) work. */ return columnDurations.map(({ startMilliseconds: startMilliseconds })=>{
        const columnMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(startMilliseconds);
        const weekNumbers = daysArray.map(()=>{
            const data = {
                day: columnMoment.date(),
                month: columnMoment.month()
            };
            columnMoment.add(1, 'day');
            return data;
        });
        return weekNumbers;
    });
});
const $fc19ef0a671248fd$export$1c186d1bc45d38b7 = (0, $5iWql.default)((today, columnDurations)=>{
    let todayDayIndex = 0;
    const todayNumber = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).date();
    const todayColumnIndex = (0, $l2CBN.getTodayColumnIndex)(today, columnDurations);
    const weekNumbers = $fc19ef0a671248fd$export$a1fb8a69eea17cba(columnDurations);
    const weekOfToday = weekNumbers[todayColumnIndex];
    weekOfToday.forEach((weekNumber, index)=>{
        if (weekNumber.day === todayNumber) todayDayIndex = index;
    });
    return [
        todayColumnIndex,
        todayDayIndex
    ];
});

});

parcelRegister("4zJTp", function(module, exports) {

$parcel$export(module.exports, "CalendarCellWrapper", () => $3e62d16761b2fdc1$export$68256deaaec8dcee);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $cUFbE = parcelRequire("cUFbE");
const $3e62d16761b2fdc1$var$wrapperStyles = null;
const $3e62d16761b2fdc1$export$68256deaaec8dcee = ({ left: left, right: right, column: column, children: children })=>{
    const cellRef = (0, $cUFbE.useGridCell)((0, $gf0vG.DEFAULT_HEADER_ROW_ID), (0, $gf0vG.CHART_COLUMN_COORDINATE) + column);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: cellRef,
        role: "columnheader",
        tabIndex: -1,
        style: {
            left: `${left}%`,
            right: `${right}%`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ize3t _94n5ze3t _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _vchhusvi _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
        ])
    }, children);
};

});

parcelRegister("83EWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d1318684ce6754$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eI5EY = parcelRequire("eI5EY");

var $8rQuz = parcelRequire("8rQuz");

var $b3wt4 = parcelRequire("b3wt4");
const $88d1318684ce6754$var$headerStyles = null;
const $88d1318684ce6754$var$headerTextTransformStyles = null;
const $88d1318684ce6754$var$contrastStyles = null;
const $88d1318684ce6754$var$MonthCell = ({ monthNumber: monthNumber, yearCaption: yearCaption, isHighlighted: isHighlighted })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
        className: (0, $7JEyt.default)([
            "_11c8qk37 _k48p1wq8 _syaz1rc1 _19pkidpf",
            !(0, $8rQuz.isVisualRefreshEnabled)() && "_1p1dangw",
            isHighlighted && (0, $eI5EY.fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_syaz1x9z"
        ])
    }, formatMessage((0, $8rQuz.isVisualRefreshEnabled)() ? (0, $b3wt4.inMonthOrder)[monthNumber] : (0, $b3wt4.inMonthOrderOld)[monthNumber]), ' ', yearCaption);
};
$88d1318684ce6754$var$MonthCell.defaultProps = {
    yearCaption: null
};
var $88d1318684ce6754$export$2e2bcd8739ae039 = $88d1318684ce6754$var$MonthCell;

});
parcelRegister("b3wt4", function(module, exports) {

$parcel$export(module.exports, "inMonthOrder", () => $b9974530de653741$export$12c2656d1700ed6e);
$parcel$export(module.exports, "inMonthOrderOld", () => $b9974530de653741$export$21620c71d33a251c);
$parcel$export(module.exports, "inQuarterOrder", () => $b9974530de653741$export$62f5e462247f69c8);
$parcel$export(module.exports, "inQuarterOrderOld", () => $b9974530de653741$export$51eb1b094826ff0c);

var $90IgZ = parcelRequire("90IgZ");
const $b9974530de653741$var$messages = (0, $90IgZ.defineMessages)({
    january: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.january',
        defaultMessage: 'January',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of January'
    },
    february: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.february',
        defaultMessage: 'February',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of February'
    },
    march: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.march',
        defaultMessage: 'March',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of March'
    },
    april: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.april',
        defaultMessage: 'April',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of April'
    },
    may: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.may',
        defaultMessage: 'May',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of May'
    },
    june: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.june',
        defaultMessage: 'June',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of June'
    },
    july: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.july',
        defaultMessage: 'July',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of July'
    },
    august: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.august',
        defaultMessage: 'August',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of August'
    },
    september: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.september',
        defaultMessage: 'September',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of September'
    },
    october: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.october',
        defaultMessage: 'October',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of October'
    },
    november: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.november',
        defaultMessage: 'November',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of November'
    },
    december: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.december',
        defaultMessage: 'December',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of December'
    },
    januaryOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.january-old',
        defaultMessage: 'Jan',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of January'
    },
    februaryOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.february-old',
        defaultMessage: 'Feb',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of February'
    },
    marchOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.march-old',
        defaultMessage: 'Mar',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of March'
    },
    aprilOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.april-old',
        defaultMessage: 'Apr',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of April'
    },
    mayOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.may-old',
        defaultMessage: 'May',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of May'
    },
    juneOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.june-old',
        defaultMessage: 'Jun',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of June'
    },
    julyOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.july-old',
        defaultMessage: 'Jul',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of July'
    },
    augustOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.august-old',
        defaultMessage: 'Aug',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of August'
    },
    septemberOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.september-old',
        defaultMessage: 'Sep',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of September'
    },
    octoberOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.october-old',
        defaultMessage: 'Oct',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of October'
    },
    novemberOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.november-old',
        defaultMessage: 'Nov',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of November'
    },
    decemberOld: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.december-old',
        defaultMessage: 'Dec',
        description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of December'
    },
    monday: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.monday',
        defaultMessage: 'M',
        description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Monday'
    },
    tuesday: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.tuesday',
        defaultMessage: 'T',
        description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Tuesday'
    },
    wednesday: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.wednesday',
        defaultMessage: 'W',
        description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Wednesday'
    },
    thursday: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.thursday',
        defaultMessage: 'T',
        description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Thursday'
    },
    friday: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.friday',
        defaultMessage: 'F',
        description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Friday'
    },
    saturday: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.saturday',
        defaultMessage: 'S',
        description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Saturday'
    },
    sunday: {
        id: 'roadmap.timeline-table.main.header.chart.calendar-cells.sunday',
        defaultMessage: 'S',
        description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Sunday'
    }
});
const $b9974530de653741$export$b7dd7c64470aa506 = [
    $b9974530de653741$var$messages.monday,
    $b9974530de653741$var$messages.tuesday,
    $b9974530de653741$var$messages.wednesday,
    $b9974530de653741$var$messages.thursday,
    $b9974530de653741$var$messages.friday,
    $b9974530de653741$var$messages.saturday,
    $b9974530de653741$var$messages.sunday
];
const $b9974530de653741$export$12c2656d1700ed6e = [
    $b9974530de653741$var$messages.january,
    $b9974530de653741$var$messages.february,
    $b9974530de653741$var$messages.march,
    $b9974530de653741$var$messages.april,
    $b9974530de653741$var$messages.may,
    $b9974530de653741$var$messages.june,
    $b9974530de653741$var$messages.july,
    $b9974530de653741$var$messages.august,
    $b9974530de653741$var$messages.september,
    $b9974530de653741$var$messages.october,
    $b9974530de653741$var$messages.november,
    $b9974530de653741$var$messages.december
];
const $b9974530de653741$export$21620c71d33a251c = [
    $b9974530de653741$var$messages.januaryOld,
    $b9974530de653741$var$messages.februaryOld,
    $b9974530de653741$var$messages.marchOld,
    $b9974530de653741$var$messages.aprilOld,
    $b9974530de653741$var$messages.mayOld,
    $b9974530de653741$var$messages.juneOld,
    $b9974530de653741$var$messages.julyOld,
    $b9974530de653741$var$messages.augustOld,
    $b9974530de653741$var$messages.septemberOld,
    $b9974530de653741$var$messages.octoberOld,
    $b9974530de653741$var$messages.novemberOld,
    $b9974530de653741$var$messages.decemberOld
];
const $b9974530de653741$export$62f5e462247f69c8 = [
    {
        startMonth: $b9974530de653741$var$messages.january,
        endMonth: $b9974530de653741$var$messages.march
    },
    {
        startMonth: $b9974530de653741$var$messages.april,
        endMonth: $b9974530de653741$var$messages.june
    },
    {
        startMonth: $b9974530de653741$var$messages.july,
        endMonth: $b9974530de653741$var$messages.september
    },
    {
        startMonth: $b9974530de653741$var$messages.october,
        endMonth: $b9974530de653741$var$messages.december
    }
];
const $b9974530de653741$export$51eb1b094826ff0c = [
    {
        startMonth: $b9974530de653741$var$messages.januaryOld,
        endMonth: $b9974530de653741$var$messages.marchOld
    },
    {
        startMonth: $b9974530de653741$var$messages.aprilOld,
        endMonth: $b9974530de653741$var$messages.juneOld
    },
    {
        startMonth: $b9974530de653741$var$messages.julyOld,
        endMonth: $b9974530de653741$var$messages.septemberOld
    },
    {
        startMonth: $b9974530de653741$var$messages.octoberOld,
        endMonth: $b9974530de653741$var$messages.decemberOld
    }
];
var $b9974530de653741$export$2e2bcd8739ae039 = $b9974530de653741$var$messages;

});


parcelRegister("7cCTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bb700532c8612db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eI5EY = parcelRequire("eI5EY");

var $8rQuz = parcelRequire("8rQuz");

var $b3wt4 = parcelRequire("b3wt4");
const $4bb700532c8612db$var$headerStyles = null;
const $4bb700532c8612db$var$headerTextTransformStyles = null;
const $4bb700532c8612db$var$contrastStyles = null;
const $4bb700532c8612db$var$QuarterCell = ({ quarterNumber: quarterNumber, yearCaption: yearCaption, isHighlighted: isHighlighted })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { startMonth: startMonth, endMonth: endMonth } = (0, $8rQuz.isVisualRefreshEnabled)() ? (0, $b3wt4.inQuarterOrder)[quarterNumber] : (0, $b3wt4.inQuarterOrderOld)[quarterNumber];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
        className: (0, $7JEyt.default)([
            "_11c8qk37 _syaz1rc1 _19pkidpf",
            !(0, $8rQuz.isVisualRefreshEnabled)() && "_1p1dangw",
            isHighlighted && (0, $eI5EY.fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_syaz1x9z"
        ])
    }, `${formatMessage(startMonth)} \u{2013} ${formatMessage(endMonth)}`, " ", yearCaption);
};
$4bb700532c8612db$var$QuarterCell.defaultProps = {
    yearCaption: null
};
var $4bb700532c8612db$export$2e2bcd8739ae039 = $4bb700532c8612db$var$QuarterCell;

});

parcelRegister("ha3hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bedf6d784f14c050$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eI5EY = parcelRequire("eI5EY");

var $8rQuz = parcelRequire("8rQuz");

var $b3wt4 = parcelRequire("b3wt4");
// Each day is 1/7th of a Week Cell in width
const $bedf6d784f14c050$var$dayWidth = 1 / 7 * 100;
const $bedf6d784f14c050$var$headerStyles = null;
const $bedf6d784f14c050$var$headerTextTransformStyles = null;
const $bedf6d784f14c050$var$dayContainerStylesOld = null;
const $bedf6d784f14c050$var$dayChildTodayStylesOld = null;
const $bedf6d784f14c050$var$dayContainerStyles = null;
const $bedf6d784f14c050$var$dayChildWeekendStyles = null;
const $bedf6d784f14c050$var$dayChildTodayStyles = null;
const $bedf6d784f14c050$var$dayChildStyles = null;
const $bedf6d784f14c050$var$dayChildHighlightedStyles = null;
const $bedf6d784f14c050$var$WeekCell = ({ columnIndex: columnIndex, weekNumbers: weekNumbers, todayCoordinates: todayCoordinates, yearCaption: yearCaption, isHighlightToday: isHighlightToday, isHighlighted: isHighlighted })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // For the weeks granularity, the 4th day of the week determines the month that week falls in
    const monthNumber = weekNumbers[3].month;
    const todayIndex = weekNumbers.findIndex((element, i)=>isHighlightToday && todayCoordinates && todayCoordinates[0] === columnIndex && todayCoordinates[1] === i);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
        className: (0, $7JEyt.default)([
            "_19pk1b66 _11c81vlj _syaz1rc1",
            !(0, $8rQuz.isVisualRefreshEnabled)() && "_1p1dangw"
        ])
    }, (0, $eI5EY.fg)('jsw_roadmaps_timeline-gridcell-header-contrast') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            isHighlighted && (0, $eI5EY.fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && $bedf6d784f14c050$var$contrastStyles
        ]
    }, formatMessage((0, $8rQuz.isVisualRefreshEnabled)() ? (0, $b3wt4.inMonthOrder)[monthNumber] : (0, $b3wt4.inMonthOrderOld)[monthNumber]), ' ', yearCaption) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $8rQuz.isVisualRefreshEnabled)() ? (0, $b3wt4.inMonthOrder)[monthNumber] : (0, $b3wt4.inMonthOrderOld)[monthNumber]), ' ', yearCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            !(0, $eI5EY.fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _1bsb1osq _4t3i1y7b _e2oo14zn _1sc11vlj _13t319ii _15ai1h6o _c8i51hna _k907c5fp _kgm11nxw _1tjq1rc1 _1e85hkel _1pzyhkel _1fl41sit _u2op1sit",
            (0, $eI5EY.fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _1bsb1osq _4t3i1y7b"
        ])
    }, weekNumbers.map(({ day: day }, dayIndex)=>(0, $eI5EY.fg)('jsw_roadmaps_timeline-gridcell-header-contrast') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: `week-number-${dayIndex}`,
            className: (0, $7JEyt.default)([
                "_1bsb14zn _11c81vlj _y3gn1h6o _1i4q1hna _18s8c5fp _1yt41nxw _syaz1rc1",
                (dayIndex === 5 || dayIndex === 6) && "_bfhkhkel _2rko1sit",
                isHighlighted && "_syaz16ez",
                todayIndex === dayIndex && "_2rko1sit _bfhk1hdx _syaz1pqp"
            ])
        }, day) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: `week-number-${dayIndex}`,
            className: (0, $7JEyt.default)([
                todayIndex === dayIndex && "_2rko1sit _bfhk1hdx _syazkmhu"
            ])
        }, day))));
};
const $bedf6d784f14c050$var$contrastStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray.bolder'
});
$bedf6d784f14c050$var$WeekCell.defaultProps = {
    yearCaption: null
};
var $bedf6d784f14c050$export$2e2bcd8739ae039 = $bedf6d784f14c050$var$WeekCell;

});



parcelRegister("kbEZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b6403bd5b4e1a95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $nH3p1 = parcelRequire("nH3p1");

var $cUFbE = parcelRequire("cUFbE");
const $1b6403bd5b4e1a95$var$rowHeaderCellStyles = null;
const $1b6403bd5b4e1a95$var$dateRowHeaderContainerStyles = null;
const $1b6403bd5b4e1a95$var$subRowHeaderContainerStyles = null;
const $1b6403bd5b4e1a95$var$ListHeaderCell = ({ id: id, itemHeight: itemHeight, renderListHeaderItem: renderListHeaderItem })=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const isDefaultHeader = id === (0, $gf0vG.DEFAULT_HEADER_ROW_ID);
    const cellRef = (0, $cUFbE.useGridCell)(id, (0, $gf0vG.LIST_COLUMN_COORDINATE), isDefaultHeader);
    /* We need to pick a sensible grid entry point for the roving tab index. The simplest solution is to pick the upper-left most cell.
   * While non-interactive headers do not need to be focusable, this is the most resilient to our various edge cases.
   * For example, virtualisation, filtering, and expand states mean that table body row elements are not guaranteed to be in the DOM.
   */ const tabIndex = isDefaultHeader ? 0 : -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: cellRef,
        role: "rowheader",
        tabIndex: tabIndex,
        style: {
            width: `${listWidth}px`,
            height: `${itemHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhkvuon _2rkoo8o8 _1pby1ial _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
        ])
    }, id === (0, $gf0vG.DEFAULT_HEADER_ROW_ID) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _vchhusvi _1bsb1osq _4t3i1osq _bfhk1s4m _x3doh6cr _n7zlh6cr _2rkoo8o8"
        ])
    }, renderListHeaderItem({
        id: id
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _4cvr1h6o _vchhusvi _1bsb1osq _4t3i1osq _1yt4pn94 _n7zlh6cr"
        ])
    }, renderListHeaderItem({
        id: id
    })));
};
var $1b6403bd5b4e1a95$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1b6403bd5b4e1a95$var$ListHeaderCell);

});


parcelRegister("ir2Y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ce7746370a5d4dd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $3HqQe = parcelRequire("3HqQe");

var $hTLlD = parcelRequire("hTLlD");

var $lSR7G = parcelRequire("lSR7G");

var $bwj1b = parcelRequire("bwj1b");
const $2ce7746370a5d4dd$export$130b459525f81fe1 = ()=>{
    const [selectedItemIds] = (0, $lSR7G.useSelectedItemIds)();
    const [activeItemId] = (0, $lSR7G.useActiveItemId)();
    const { onRowSelect: onRowSelect, onRowDeselect: onRowDeselect } = (0, $bwj1b.useSideEffectMarshal)();
    const highlighted = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3HqQe)))(selectedItemIds.concat(activeItemId ? [
            activeItemId
        ] : [])), [
        selectedItemIds,
        activeItemId
    ]);
    const prevHighlighted = (0, $eUqFw.useRef)(highlighted);
    (0, $eUqFw.useEffect)(()=>{
        const toBeDehighlighted = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(prevHighlighted.current, highlighted);
        onRowDeselect(toBeDehighlighted);
        onRowSelect(highlighted);
    }, [
        selectedItemIds,
        onRowSelect,
        onRowDeselect,
        highlighted
    ]);
    (0, $eUqFw.useEffect)(()=>{
        prevHighlighted.current = highlighted;
    }, [
        highlighted
    ]);
    return null;
};
var /* Having this update unnecessarily contributes to an unexpected lifecycle in the side-effect-marshal.
 * The simplest remedy for now is to deep compare the selected item ids. In future, we may want to integrate
 * the selection into the side-effect-marshal itself.
 */ $2ce7746370a5d4dd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2ce7746370a5d4dd$export$130b459525f81fe1, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));

});
parcelRegister("3HqQe", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");


var $2b1a356672d01117$var$func = $jFIrw('uniq', (parcelRequire("MdoH4")), (parcelRequire("jKGa6")));

$2b1a356672d01117$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $2b1a356672d01117$var$func;

});
parcelRegister("jKGa6", function(module, exports) {
module.exports = {
    'cap': false,
    'curry': false,
    'fixed': false,
    'immutable': false,
    'rearg': false
};

});



parcelRegister("dqHZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $08d889c63df7e66d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $hTLlD = parcelRequire("hTLlD");

var $bwj1b = parcelRequire("bwj1b");
/* Item selection styles are orchestrated via the style marshal since it has to
 * be synchronised across a row. As such, there is no need for an item component
 * to even know about whether it is selected, allowing us to maintain the selection
 * state without going deep into the tree. This also has performance benefits.
 */ const $08d889c63df7e66d$var$ItemsSelector = ({ selectedItemIds: selectedItemIds })=>{
    const { onRowSelect: onRowSelect, onRowDeselect: onRowDeselect } = (0, $bwj1b.useSideEffectMarshal)();
    const previousSelectedItemIds = (0, $eUqFw.useRef)(selectedItemIds);
    (0, $eUqFw.useEffect)(()=>{
        const unselectedItemIds = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(previousSelectedItemIds.current, selectedItemIds);
        onRowDeselect(unselectedItemIds);
        onRowSelect(selectedItemIds);
    }, [
        previousSelectedItemIds,
        selectedItemIds,
        onRowSelect,
        onRowDeselect
    ]);
    (0, $eUqFw.useEffect)(()=>{
        previousSelectedItemIds.current = selectedItemIds;
    }, [
        selectedItemIds
    ]);
    return null;
};
var /* Having this update unnecessarily contributes to an unexpected lifecycle in the side-effect-marshal.
 * The simplest remedy for now is to deep compare the selected item ids. In future, we may want to integrate
 * the selection into the side-effect-marshal itself.
 */ $08d889c63df7e66d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($08d889c63df7e66d$var$ItemsSelector, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));

});

parcelRegister("ibHnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8098b08c293182fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $nH3p1 = parcelRequire("nH3p1");

var $bPBuf = parcelRequire("bPBuf");

var $jSCla = parcelRequire("jSCla");
const $8098b08c293182fb$var$StaticOverlay = ({ renderChartOverlay: renderChartOverlay })=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSCla.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPBuf.default), {
        listWidth: listWidth,
        renderChartOverlay: renderChartOverlay
    }));
};
$8098b08c293182fb$var$StaticOverlay.displayName = 'StaticOverlay';
$8098b08c293182fb$var$StaticOverlay.whyDidYouRender = true;
var $8098b08c293182fb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8098b08c293182fb$var$StaticOverlay);

});
parcelRegister("bPBuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f437bae228570065$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iS6tD = parcelRequire("iS6tD");
const $f437bae228570065$var$containerStyles = null;
const $f437bae228570065$var$ChartOverlay = ({ listWidth: listWidth, renderChartOverlay: renderChartOverlay })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            left: `${listWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1pby1o8a _lcxvglyw"
        ])
    }, renderChartOverlay(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS6tD.default), null));
var $f437bae228570065$export$2e2bcd8739ae039 = $f437bae228570065$var$ChartOverlay;

});
parcelRegister("iS6tD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba381a29a5fe79a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $h829Y = parcelRequire("h829Y");
const $7ba381a29a5fe79a$var$containerStyles = null;
const $7ba381a29a5fe79a$var$PortalContainer = ()=>{
    const { setPortalContainerElement: setPortalContainerElement } = (0, $h829Y.usePortalScope)();
    const containerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        setPortalContainerElement(containerRef.current);
        return ()=>{
            setPortalContainerElement(null);
        };
    }, [
        setPortalContainerElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: containerRef,
        className: (0, $7JEyt.default)([
            "_kqswstnw _lcxvglyw _1ltvidpf _154iidpf _94n5idpf _1xi2idpf _1pbyilow _ogto1994 _mkrz1fck"
        ])
    });
};
var $7ba381a29a5fe79a$export$2e2bcd8739ae039 = $7ba381a29a5fe79a$var$PortalContainer;

});


parcelRegister("jSCla", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d43c05cb6501952$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9WNLk = parcelRequire("9WNLk");

var $hxnNZ = parcelRequire("hxnNZ");

var $i0fOp = parcelRequire("i0fOp");

var $kvIXk = parcelRequire("kvIXk");

var $kQRc0 = parcelRequire("kQRc0");
const $2d43c05cb6501952$var$InlineIndicators = ()=>{
    const [{ isCreateSiblingEnabled: isCreateSiblingEnabled, isDragEnabled: isDragEnabled }] = (0, $9WNLk.useEnablements)();
    const [isScrollingY] = (0, $hxnNZ.useIsScrollingY)();
    const inlineIndicatorParams = (0, $kQRc0.useInlineIndicator)();
    if (isScrollingY) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isCreateSiblingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0fOp.default), inlineIndicatorParams), isDragEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kvIXk.default), inlineIndicatorParams));
};
var $2d43c05cb6501952$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2d43c05cb6501952$var$InlineIndicators);

});
parcelRegister("i0fOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d8009549d23840$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bkIGg = parcelRequire("bkIGg");

var $eI5EY = parcelRequire("eI5EY");

var $gf0vG = parcelRequire("gf0vG");

var $fTs8H = parcelRequire("fTs8H");

var $fQIE0 = parcelRequire("fQIE0");
const $d6d8009549d23840$var$appear = null;
const $d6d8009549d23840$var$opacityTransitionStyles = null;
const $d6d8009549d23840$var$appearStyles = null;
const $d6d8009549d23840$var$opacityTransitionStylesOld = null;
const $d6d8009549d23840$var$iconWrapperStyles = null;
const $d6d8009549d23840$var$iconWrapperStylesOld = null;
const $d6d8009549d23840$var$iconContainerStyles = null;
const $d6d8009549d23840$var$lineStyles = null;
const $d6d8009549d23840$var$containerStyles = null;
const $d6d8009549d23840$var$outerButtonStyles = null;
const $d6d8009549d23840$var$InlineCreateIndicator = ({ left: left, width: width })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyibnn",
            (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "",
            (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "_j7hq1wwu _tzy4idpf _5sagfnf5 _ju25188d _1o51q7pw",
            (0, $fTs8H.getInlineCreateButtonClassName)().className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            left: `${(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? left : left - (0, $gf0vG.HALF_INLINE_CREATE_ICON_WIDTH)}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1lpd _1ltvidpf _4t3igktf _1bsb1r7l _80omtlke _7momkb7n _b59ukb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": "line",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? width : width + (0, $gf0vG.HALF_INLINE_CREATE_ICON_WIDTH)}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154irdoj _4t3iyh40 _bfhki2p0",
            !(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "_tzy4idpf _5sagfnf5 _ju25188d _1o51q7pw",
            !(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "",
            !(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "_j7hq1wwu"
        ])
    }), (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3igktf _1bsbgktf _154iidpf _1ltv14id _bfhk1ffm _syaz15cr _2rko1sit",
            (0, $fTs8H.getInlineCreateIconClassName)().className
        ]),
        "data-component-selector": "icon-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _kqswh2mm _18u01i6y _19pk1i6y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: formatMessage((0, $fQIE0.default).label)
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": "icon-wrapper",
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3igktf _1bsbgktf _154iidpf _1ltvidpf _bfhk1ffm _syaz15cr _2rko1sit",
            "_tzy4idpf _5sagfnf5 _ju25188d _1o51q7pw",
            "_j7hq1wwu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _kqswh2mm _18u01i6y _19pk1i6y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: formatMessage((0, $fQIE0.default).label)
    })))));
};
var $d6d8009549d23840$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d6d8009549d23840$var$InlineCreateIndicator);

});
parcelRegister("fQIE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $491c28f451895164$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $491c28f451895164$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        id: 'roadmap.timeline-table.main.static-overlay.inline-indicators.create.label',
        defaultMessage: 'What needs to be done?',
        description: 'Icon label. Appears when the epics list is too long. Activates epic creation input at the bottom of the list'
    }
});

});


parcelRegister("kvIXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29ef442f38b9d95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $fTs8H = parcelRequire("fTs8H");
const $e29ef442f38b9d95$var$containerStyles = null;
const $e29ef442f38b9d95$var$lineStyles = null;
const $e29ef442f38b9d95$var$InlineDragIndicator = ({ left: left, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.static-overlay.inline-indicators.drag.inline-drag-indicator",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyibnn",
            (0, $fTs8H.getDragIndicatorClassName)().className
        ]),
        style: {
            left: `${left}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${width}px`
        },
        className: (0, $7JEyt.default)([
            "_4t3iyh40 _bfhk1r2e _1kt9b3bt _1cs8stnw _kfgtidpf _1mp4idpf _1aukj39m _qnec1lpd _1pq812me _4k1c12me _1n1j18is"
        ])
    }));
var $e29ef442f38b9d95$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e29ef442f38b9d95$var$InlineDragIndicator);

});

parcelRegister("kQRc0", function(module, exports) {

$parcel$export(module.exports, "useInlineIndicator", () => $f5c7298f96de85d5$export$27583fc2bcba0ca1);

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $cZkk1 = parcelRequire("cZkk1");

var $ccgw3 = parcelRequire("ccgw3");
const $f5c7298f96de85d5$export$27583fc2bcba0ca1 = ()=>{
    const [{ left: left, clientWidth: clientWidth, indicatorLineOffset: indicatorLineOffset }] = (0, $cZkk1.useTimelineViewport)();
    const [params, setParams] = (0, $eUqFw.useState)({
        left: 0,
        width: 0
    });
    const viewportRef = (0, $eUqFw.useRef)(null);
    const setInlineIndicatorParams = (viewport)=>{
        if (viewport) setParams({
            left: viewport.getBoundingClientRect().left,
            width: viewport.clientWidth
        });
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!clientWidth) {
            const viewport = document.getElementById((0, $gf0vG.TIMELINE_ID));
            viewportRef.current = viewport;
            setInlineIndicatorParams(viewport);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const onContentResize = (0, $eUqFw.useCallback)(()=>{
        setInlineIndicatorParams(viewportRef.current);
    }, []);
    (0, $ccgw3.useResizeObserver)(viewportRef.current, onContentResize);
    const inlineIndicatorParams = (0, $eUqFw.useMemo)(()=>({
            left: viewportRef.current ? params.left : left,
            width: viewportRef.current ? params.width - indicatorLineOffset : clientWidth - indicatorLineOffset
        }), [
        params.left,
        params.width,
        left,
        indicatorLineOffset,
        clientWidth
    ]);
    return inlineIndicatorParams;
};

});



parcelRegister("4d1OI", function(module, exports) {

$parcel$export(module.exports, "default", () => $acec9e8136ed9a63$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $nH3p1 = parcelRequire("nH3p1");

var $dWSuJ = parcelRequire("dWSuJ");
const $acec9e8136ed9a63$var$containerStyles = null;
const $acec9e8136ed9a63$var$listContainerStyles = null;
// NOTE: The borders here by nature are static overlay as they do not scroll with the Timeline
// However in Firefox / Safari, the elastic over-scroll feature needs the scrolling context to produce the bounce-back effect
// As a result, this component needs to be rendered inside the custom scrollbar instead of being rendered together with other static overlays
const $acec9e8136ed9a63$var$Borders = ()=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _1pby1ial _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _vchhusvi _1ltvidpf _4t3i1osq _1s7z9fei _1kl71hum _2rkoo8o8"
        ]),
        style: {
            width: `${listWidth}px`,
            "--_drom5x": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorderColor)),
            "--_1p5ufam": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorder))
        }
    }));
};
var $acec9e8136ed9a63$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($acec9e8136ed9a63$var$Borders);

});

parcelRegister("4YDQS", function(module, exports) {

$parcel$export(module.exports, "getRenderersWithDefaults", () => $c832d37b3500f29e$export$59f24ad0cf4048d7);

var $5iWql = parcelRequire("5iWql");

var $dnP9l = parcelRequire("dnP9l");
const $c832d37b3500f29e$export$59f24ad0cf4048d7 = (0, $5iWql.default)((customRenderers)=>{
    const safeRenderers = {
        ...(0, $dnP9l.defaultRenderers),
        ...customRenderers
    };
    return {
        listRenderers: {
            renderListEmptyContent: safeRenderers.renderListEmptyContent,
            renderListItemContent: safeRenderers.renderListItemContent,
            renderListItemSecondaryContent: safeRenderers.renderListItemSecondaryContent,
            renderListItemCreate: safeRenderers.renderListItemCreate,
            renderListHeaderItem: safeRenderers.renderListHeaderItem,
            /**
			 * TODO: This is a temporary change until the create button is deprecated.
			 * If the consumer doesn’t provide renderListItemMenu, it will render the create child button instead of the meatballs button.
			 * Revert this to the safeRenderers after the create button is deprecated.
			 */ renderListItemMenuOption: customRenderers?.renderListItemMenuOption,
            renderListItemModal: customRenderers?.renderListItemModal
        },
        chartRenderers: {
            renderChartOverlay: safeRenderers.renderChartOverlay,
            renderChartItemContent: safeRenderers.renderChartItemContent,
            renderChartTimelineOverlay: safeRenderers.renderChartTimelineOverlay,
            renderChartHeaderItem: safeRenderers.renderChartHeaderItem
        },
        renderProvider: safeRenderers.renderProvider
    };
});

});
parcelRegister("dnP9l", function(module, exports) {

$parcel$export(module.exports, "defaultRenderers", () => $2c1666ebf6271bd8$export$2d95bc3f1f7b3d23);
// A renderer is effectively a no-op until it gets overridden
const $2c1666ebf6271bd8$var$DEFAULT_RENDERER = ()=>null;
const $2c1666ebf6271bd8$export$2d95bc3f1f7b3d23 = {
    renderListItemMenuOption: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListItemModal: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListHeaderItem: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListEmptyContent: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListItemContent: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListItemSecondaryContent: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListItemCreate: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderChartHeaderItem: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderChartOverlay: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderChartItemContent: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderChartTimelineOverlay: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderProvider: ({ children: children })=>children
};

});




parcelRegister("3ExHl", function(module, exports) {

$parcel$export(module.exports, "renderChartHeaderItem", () => $0be7059ddd9a49a4$export$c4c87c526c6346ef);

var $eUqFw = parcelRequire("eUqFw");

var $4P2VV = parcelRequire("4P2VV");

var $i0A3C = parcelRequire("i0A3C");

var $d6dd7 = parcelRequire("d6dd7");
const $0be7059ddd9a49a4$export$c4c87c526c6346ef = ({ id: id })=>{
    switch(id){
        case 0, $4P2VV.RELEASES_HEADER_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0A3C.default), null);
        case 0, $4P2VV.SPRINTS_HEADER_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6dd7.default), null);
        default:
            return null;
    }
};

});
parcelRegister("i0A3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7924914b60de6493$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hjI8T = parcelRequire("hjI8T");

var $3UgQn = parcelRequire("3UgQn");
const $7924914b60de6493$var$mapStateToProps = (state)=>({
        getVersionsForKeyDate: (0, $hjI8T.createGetVersionsForKeyDates)(state),
        highlightedKeyDates: (0, $hjI8T.getHighlightedKeyDates)(state)
    });
var $7924914b60de6493$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($7924914b60de6493$var$mapStateToProps, {})((0, $3UgQn.default));

});
parcelRegister("3UgQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3baad60dacfd4fdc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $d4evd = parcelRequire("d4evd");

var $3XwA1 = parcelRequire("3XwA1");

var $3SfLA = parcelRequire("3SfLA");
const $3baad60dacfd4fdc$var$ReleasesHeader = ({ getVersionsForKeyDate: getVersionsForKeyDate, highlightedKeyDates: highlightedKeyDates })=>{
    const [{ today: today }] = (0, $3XwA1.useTimelineState)();
    const keyDates = getVersionsForKeyDate(today);
    const renderPopupContent = (0, $eUqFw.useCallback)((selectedKeyDates, setInitialFocusRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3SfLA.default), {
            keyDates: selectedKeyDates,
            ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-release-lozenge') ? {
                setInitialFocusRef: setInitialFocusRef
            } : {}
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d4evd.RoadmapKeyDates), {
        keyDates: keyDates,
        highlightedKeyDates: highlightedKeyDates,
        renderPopupContent: renderPopupContent
    });
};
var $3baad60dacfd4fdc$export$2e2bcd8739ae039 = $3baad60dacfd4fdc$var$ReleasesHeader;

});
parcelRegister("d4evd", function(module, exports) {

$parcel$export(module.exports, "RoadmapKeyDates", () => $eda08c9d3b0be9c5$export$c2d959f07ed56d48);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gf0vG = parcelRequire("gf0vG");

var $VrUCp = parcelRequire("VrUCp");

var $3XwA1 = parcelRequire("3XwA1");

var $4P2VV = parcelRequire("4P2VV");

var $fbLos = parcelRequire("fbLos");

var $lXsQo = parcelRequire("lXsQo");

var $aL4jn = parcelRequire("aL4jn");

var $fWP9f = parcelRequire("fWP9f");

var $bnCp8 = parcelRequire("bnCp8");

var $8d58c = parcelRequire("8d58c");
const $eda08c9d3b0be9c5$export$123b0ad6149c0886 = (headerItems, headerItemsOffsetTop, headerHeight)=>{
    const releasesRow = headerItems.find((headerItem)=>headerItem.id === (0, $4P2VV.RELEASES_HEADER_ID));
    const releasesRowHeight = releasesRow && releasesRow.height !== undefined ? releasesRow.height : (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT);
    return headerHeight - headerItemsOffsetTop[0, $4P2VV.RELEASES_HEADER_ID] - releasesRowHeight / 2 - (0, $fbLos.MARKER_WIDTH) / 2 + (0, $fbLos.MARKER_BORDER_WIDTH);
};
const $eda08c9d3b0be9c5$var$RoadmapKeyDates = ({ keyDates: keyDatesProp, highlightedKeyDates: highlightedKeyDates, renderPopupContent: renderPopupContent })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth, timelineMode: timelineMode }] = (0, $3XwA1.useTimelineState)();
    const [{ headerItems: headerItems, headerItemsOffsetTop: headerItemsOffsetTop, headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const highlightLineHeight = $eda08c9d3b0be9c5$export$123b0ad6149c0886(headerItems, headerItemsOffsetTop, headerHeight);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const keyDateGroups = (0, $lXsQo.getKeyDatesGroups)({
        keyDates: keyDatesProp,
        timelineMode: timelineMode,
        timelineDuration: timelineDuration,
        timelineWidth: timelineWidth
    });
    let highlightLines;
    if (highlightedKeyDates.length > 0) highlightLines = (0, $aL4jn.getHighlightLines)({
        keyDateGroups: keyDateGroups,
        highlightedKeyDates: highlightedKeyDates
    });
    const getMarkerContent = (count, status)=>{
        if (count > 1) return count > 9 ? '9+' : count;
        if (status === (0, $fbLos.WARNING)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnCp8.FailedIcon), null);
        if (status === (0, $fbLos.COMPLETED)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWP9f.CompletedIcon), null);
        return null;
    };
    (0, $eUqFw.useEffect)(()=>{
        const numberOfKeyDatesPerGroup = keyDateGroups.map(({ keyDates: keyDates })=>keyDates.length);
        const maxNumberOfKeyDatesInAGroup = Math.max(...numberOfKeyDatesPerGroup);
        const numberOfWarning = keyDateGroups.filter(({ status: status })=>status === (0, $fbLos.WARNING)).length;
        const analyticsEvent = createAnalyticsEvent({
            action: 'mounted',
            actionSubject: 'keyDatesHeader'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyDates', {
            maxNumberOfKeyDatesInAGroup: maxNumberOfKeyDatesInAGroup,
            numberOfWarning: numberOfWarning,
            numberOfMarker: keyDateGroups.length,
            timelineMode: timelineMode
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        timelineMode
    ]);
    /**
   * Callback to render the user selected key dates flyout popup content
   */ const renderSelectedKeyDatePopupContent = (0, $eUqFw.useCallback)((selectedKeyDates)=>({ setInitialFocusRef: setInitialFocusRef })=>(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-release-lozenge') ? renderPopupContent(selectedKeyDates, setInitialFocusRef) : renderPopupContent(selectedKeyDates), [
        renderPopupContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, keyDateGroups.map(({ keyDates: keyDates, status: status, maxWidth: maxWidth, leftPosition: leftPosition, id: id }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8d58c.MarkerWithTooltip), {
            key: index,
            leftPosition: leftPosition,
            keyDates: keyDates,
            status: status,
            id: id,
            renderPopupContent: renderSelectedKeyDatePopupContent(keyDates)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            style: {
                backgroundColor: (0, $fbLos.MARKER_COLORS)[status]
            },
            className: (0, $7JEyt.default)([
                "_eaap5w2r _11c81vlj _k48p8n31 _syaz15cr _1bsbgktf _4t3igktf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _19it1byb _1reo15vq _18m915vq"
            ])
        }, getMarkerContent(keyDates.length, status)), keyDates.length === 1 && maxWidth > (0, $fbLos.MARKER_WIDTH_WITH_SPACE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `${maxWidth - (0, $fbLos.MARKER_WIDTH_WITH_SPACE)}px`
            },
            className: (0, $7JEyt.default)([
                "_o5721q9c _1bto1l2s _1e0c1o8l _s7n4nkob _1yt4otz2 _1reo15vq _18m915vq _11c8qk37 _k48pbfng _19pkidpf _syaz1fxt"
            ])
        }, keyDates[0].name))), highlightLines && highlightLines.map(({ left: left, id: id, status: status })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: id,
            style: {
                height: `${highlightLineHeight}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                backgroundColor: (0, $fbLos.MARKER_COLORS)[status],
                left: `${left}px`
            },
            className: (0, $7JEyt.default)([
                "_kqswstnw _1e0c1ule _1bsbv77o _154i8rdq"
            ])
        })));
};
$eda08c9d3b0be9c5$var$RoadmapKeyDates.whyDidYouRender = true;
$eda08c9d3b0be9c5$var$RoadmapKeyDates.defaultProps = {
    highlightedKeyDates: []
};
const $eda08c9d3b0be9c5$export$c2d959f07ed56d48 = /*#__PURE__*/ (0, $eUqFw.memo)($eda08c9d3b0be9c5$var$RoadmapKeyDates);
$eda08c9d3b0be9c5$export$c2d959f07ed56d48.displayName = 'RoadmapKeyDates';
const $eda08c9d3b0be9c5$var$markerStyles = null;
const $eda08c9d3b0be9c5$var$highlightLineStyles = null;
const $eda08c9d3b0be9c5$var$labelStyles = null;

});
parcelRegister("lXsQo", function(module, exports) {

$parcel$export(module.exports, "getKeyDatesGroups", () => $9d21ef9019d1bc7e$export$efd6cb53cfb8bfc2);

var $hTLlD = parcelRequire("hTLlD");

var $5iWql = parcelRequire("5iWql");


var $gf0vG = parcelRequire("gf0vG");

var $1QJt8 = parcelRequire("1QJt8");

var $fHtBB = parcelRequire("fHtBB");

var $fbLos = parcelRequire("fbLos");
const $9d21ef9019d1bc7e$var$NUMBER_OF_DAYS_OFFSET = {
    [(0, $gf0vG.QUARTERS)]: 3,
    [(0, $gf0vG.MONTHS)]: 1,
    [(0, $gf0vG.WEEKS)]: 1
};
const $9d21ef9019d1bc7e$var$MAX_WIDTH = 300;
const $9d21ef9019d1bc7e$export$efd6cb53cfb8bfc2 = (0, $5iWql.default)(({ keyDates: keyDates, timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth })=>{
    const dayOffset = $9d21ef9019d1bc7e$var$NUMBER_OF_DAYS_OFFSET[timelineMode];
    const groups = [];
    let lastStart;
    let lastEnd;
    // Sort the data by date DESC for max width calculation
    const keyDatesInDescOrder = keyDates.slice().sort((keyDate, nextKeyDate)=>nextKeyDate.date - keyDate.date);
    keyDatesInDescOrder.forEach((keydate)=>{
        const { date: date, status: status } = keydate;
        if (date >= timelineDuration.startMilliseconds && date <= timelineDuration.endMilliseconds) {
            if (lastStart && lastEnd && date > lastStart && date <= lastEnd) {
                // Add to existing group if the date is within the range (1 day or 3 days for Quarter)
                const lastGroup = groups[0];
                lastGroup.keyDates.unshift(keydate);
                // Update group's state if the new status is a higher priority
                if ((0, $fbLos.STATUS_PRIORITY)[status] > (0, $fbLos.STATUS_PRIORITY)[lastGroup.status]) lastGroup.status = status;
            } else {
                // Get the min date of the group
                lastStart = Math.max(date - dayOffset * (0, $4975412c8fcbfa24$export$1f04624003d2da7d), timelineDuration.startMilliseconds);
                lastEnd = date;
                const newLeft = (0, $1QJt8.getTimelinePositionFromDate)(timelineDuration, timelineWidth, /**
						 * If markers are group by more than 1 day, take the middle position
						 * otherwise, use end of day ms for marker's position
						 */ dayOffset > 1 ? (lastEnd + lastStart) / 2 : lastEnd + (0, $fHtBB.DUE_DATE_OFFSET));
                // Assume full timeline width as previous left position if there is no prior group
                const lastLeft = groups.length > 0 ? groups[0].leftPosition : timelineWidth;
                // Add the entry to the first of the array so the markers of earlier date will be overlapped on top of the latter
                groups.unshift({
                    id: keydate.id,
                    keyDates: [
                        keydate
                    ],
                    status: status,
                    leftPosition: newLeft,
                    maxWidth: Math.min(Math.round(lastLeft - newLeft), $9d21ef9019d1bc7e$var$MAX_WIDTH)
                });
            }
        }
    });
    return groups;
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});

});

parcelRegister("aL4jn", function(module, exports) {

$parcel$export(module.exports, "getHighlightLines", () => $011531d0eb170309$export$dfb1168c62133e0d);

var $hTLlD = parcelRequire("hTLlD");

var $5iWql = parcelRequire("5iWql");

var $fbLos = parcelRequire("fbLos");
const $011531d0eb170309$export$1cce90b57e2c2286 = (0, $5iWql.default)((keyDateGroups)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const keyDatesAttributesHash = {};
    keyDateGroups.forEach((keyDateGroup)=>{
        const { leftPosition: leftPosition, keyDates: keyDatesWithinGroup, id: groupId } = keyDateGroup;
        keyDatesWithinGroup.forEach(({ id: id, status: status })=>{
            keyDatesAttributesHash[`${id}`] = {
                groupId: groupId,
                left: leftPosition,
                status: status
            };
        });
    });
    return keyDatesAttributesHash;
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $011531d0eb170309$export$dfb1168c62133e0d = (0, $5iWql.default)(({ keyDateGroups: keyDateGroups, highlightedKeyDates: highlightedKeyDates })=>{
    const highlightGroups = {};
    const keyDatesAttributesHash = $011531d0eb170309$export$1cce90b57e2c2286(keyDateGroups);
    highlightedKeyDates.forEach((id)=>{
        const keyDateAttributes = keyDatesAttributesHash[id];
        if (keyDateAttributes) {
            const { left: left, groupId: groupId, status: status } = keyDateAttributes;
            // if multiple lines from the same group, show only one with the highest status priority
            const highlightedGroup = highlightGroups[groupId];
            if (!highlightedGroup || (0, $fbLos.STATUS_PRIORITY)[status] > (0, $fbLos.STATUS_PRIORITY)[highlightedGroup.status]) highlightGroups[groupId] = {
                left: left,
                status: status,
                id: groupId
            };
        }
    });
    return Object.keys(highlightGroups).map((key)=>highlightGroups[key]);
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});

});

parcelRegister("fWP9f", function(module, exports) {

$parcel$export(module.exports, "CompletedIcon", () => $f537895d3e6cb737$export$78a23b7901d2dcd);

var $eUqFw = parcelRequire("eUqFw");

var $fbLos = parcelRequire("fbLos");
const $f537895d3e6cb737$export$78a23b7901d2dcd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16",
        /**
		 * AK inline-dialog's handleClickOutside does not recognise svg elements
		 * https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/design-system/inline-dialog/src/InlineDialog/index.tsx#lines-60
		 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            pointerEvents: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: (0, $fbLos.MARKER_COLORS)[0, $fbLos.COMPLETED],
        fillRule: "evenodd",
        d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));

});

parcelRegister("bnCp8", function(module, exports) {

$parcel$export(module.exports, "FailedIcon", () => $bbe4a54284ba694b$export$47b17d91c8e9a146);

var $eUqFw = parcelRequire("eUqFw");

var $fbLos = parcelRequire("fbLos");
const $bbe4a54284ba694b$export$47b17d91c8e9a146 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16",
        /**
		 * AK inline-dialog's handleClickOutside does not recognise svg elements
		 * https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/design-system/inline-dialog/src/InlineDialog/index.tsx#lines-60
		 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            pointerEvents: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "6",
        cx: "8",
        cy: "8",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: (0, $fbLos.MARKER_COLORS)[0, $fbLos.WARNING],
        fillRule: "evenodd",
        d: "M.768 9.768a2.5 2.5 0 010-3.536L6.232.768a2.5 2.5 0 013.536 0l5.464 5.464a2.5 2.5 0 010 3.536l-5.464 5.464a2.5 2.5 0 01-3.536 0L.768 9.768zM7 4a1 1 0 112 0v4a1 1 0 01-2 0V4zm1 8a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));

});

parcelRegister("8d58c", function(module, exports) {

$parcel$export(module.exports, "MarkerWithTooltip", () => $b991102e686e09fb$export$c2965f235e376059);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $2eG9N = parcelRequire("2eG9N");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2KzVh = parcelRequire("2KzVh");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8hFGR = parcelRequire("8hFGR");

var $6TBpb = parcelRequire("6TBpb");

var $lqJW5 = parcelRequire("lqJW5");

var $lfgcv = parcelRequire("lfgcv");

var $75e8i = parcelRequire("75e8i");

var $ksGD2 = parcelRequire("ksGD2");

var $fkfMB = parcelRequire("fkfMB");

var $bMb4i = parcelRequire("bMb4i");

var $hevaQ = parcelRequire("hevaQ");

var $90DIu = parcelRequire("90DIu");

var $dJeqi = parcelRequire("dJeqi");
const $b991102e686e09fb$var$tooltipStyles = null;
const $b991102e686e09fb$var$markerStyles = null;
const $b991102e686e09fb$export$c2965f235e376059 = ({ id: id, keyDates: keyDates, leftPosition: leftPosition, children: children, status: status, renderPopupContent: renderPopupContent })=>{
    const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, $6TBpb.useViewport)(); // Read the Timeline-table-kit context provider for any indication if the edit version details modal dialog was triggered (so Popup will stay open and not closed)
    const [{ isHeaderModalActive: isHeaderModalActive }, { onToggleHeaderModal: onToggleHeaderModal }] = (0, $hevaQ.useIsHeaderModalActive)();
    const [isPopupActive, setIsPopupActive] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shouldPreventNavigation: shouldPreventNavigation } = (0, $8hFGR.useFocusMarshal)();
    const openPopup = (0, $eUqFw.useCallback)(()=>{
        shouldPreventNavigation(true);
        setIsPopupActive(true);
    }, [
        shouldPreventNavigation
    ]);
    const closePopup = (0, $eUqFw.useCallback)(()=>{
        shouldPreventNavigation(false);
        setIsPopupActive(false);
    }, [
        shouldPreventNavigation
    ]);
    const tooltipContent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, keyDates.map(({ name: name, date: date }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkfMB.TooltipInterval), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMb4i.ReleaseIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkfMB.ContentName), null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkfMB.ContentDateLabel), null, `(${(0, $lfgcv.getDateFromTimestamp)(date)})`)))), [
        keyDates
    ]); // Listen to user event scrolling the timeline table => Hide the popup on each time its been scrolled
    (0, $eUqFw.useEffect)(()=>{
        const onViewPortScrollHandler = ()=>{
            if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) closePopup();
            else setIsPopupActive(false);
        };
        listenToViewportScroll(onViewPortScrollHandler);
        return function cleanup() {
            stopListeningToViewportScroll(onViewPortScrollHandler);
        };
    }, [
        closePopup,
        listenToViewportScroll,
        stopListeningToViewportScroll
    ]);
    const onClickMarkerLabelHandler = (0, $eUqFw.useCallback)((event)=>{
        (0, $75e8i.default)('timeline-keydate-marker-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyDatesMarker', {
            status: status
        });
        if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) openPopup();
        else setIsPopupActive(true);
    }, [
        createAnalyticsEvent,
        status,
        openPopup
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $lqJW5.isEnterOrSpaceKey)(event)) {
            event.preventDefault();
            (0, $75e8i.default)('timeline-keydate-marker-clicked', event.timeStamp);
            if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) openPopup();
            else setIsPopupActive(true);
        }
    }, [
        openPopup
    ]);
    const onClosePopup = (0, $eUqFw.useCallback)(()=>{
        if (!isHeaderModalActive) {
            if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) // This is needed due to usecase where the `<Popup />' component triggers the onClose event due to "Edit Version Details" dialog is opened which breaks the workflow
            closePopup();
            else // This is needed due to usecase where the `<Popup />' component triggers the onClose event due to "Edit Version Details" dialog is opened which breaks the workflow
            setIsPopupActive(false);
            onToggleHeaderModal(false);
        }
    }, [
        closePopup,
        isHeaderModalActive,
        onToggleHeaderModal
    ]);
    const renderPopupTrigger = ({ ref: ref, ...restTriggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default // @ts-expect-error Property 'css' does not exist on type 'IntrinsicAttributes & TooltipProps'.ts(2322)
        ), {
            content: tooltipContent,
            position: "bottom-end",
            hideTooltipOnClick: true,
            className: (0, $7JEyt.default)([
                "_2rko1l7b _vchhusvi _1yt41ppf _p12f1ogm _bfhkgkf6 _syaz15cr _vwz4nqt0"
            ])
        }, ({ 'aria-describedby': ariaDescribedBy, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ...restTriggerProps,
                ...tooltipProps,
                style: {
                    left: `${leftPosition}px`,
                    // THIS WAS NEEDED SINCE OLD IMPLEMENATION DOES NOT WRAP THE CONTENT OF TOOLTIP INSIDE A <div role="presentation" /> which causes the shift of the label to go down
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    top: '7.5px'
                },
                ref: (0, $2KzVh.mergeRefs)(ref, tooltipProps.ref),
                tabIndex: 0,
                role: "button",
                "data-testid": `roadmap.timeline-table-kit.ui.chart-header-item.key-dates.marker-${id}`,
                onClick: onClickMarkerLabelHandler,
                onKeyDown: onKeyDown,
                "aria-label": formatMessage((0, $90DIu.default).releases, {
                    noOfReleases: keyDates.length,
                    releaseNamesAndDates: (0, $dJeqi.getReleaseNamesAndDatesAlly)(keyDates)
                }),
                className: (0, $7JEyt.default)([
                    "_kqswstnw _4t3igktf _t9ec1ah0 _1e0c1txw _4cvr1h6o _80omtlke _yt1xcs5v"
                ])
            }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        isOpen: isPopupActive,
        onClose: onClosePopup,
        placement: "bottom-start",
        content: renderPopupContent,
        trigger: renderPopupTrigger,
        zIndex: (0, $ksGD2.OVERLAY_FLYOUT_Z_INDEX),
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-release-lozenge') ? {
            role: 'dialog',
            autoFocus: false,
            label: formatMessage((0, $90DIu.default).popupLabel)
        } : {}
    });
};

});
parcelRegister("ksGD2", function(module, exports) {

$parcel$export(module.exports, "CHART_BAR_Z_INDEX", () => $9d21b0c8cbcd8930$export$b769e19d85a0dd1f);
$parcel$export(module.exports, "OVERLAY_FLYOUT_Z_INDEX", () => $9d21b0c8cbcd8930$export$607b7b6549bb844a);

var $c9TLT = parcelRequire("c9TLT");
const $9d21b0c8cbcd8930$export$b8c38275349a321a = 2;
const $9d21b0c8cbcd8930$export$bf7c4b09e1259e0c = 2;
const $9d21b0c8cbcd8930$export$b769e19d85a0dd1f = 3;
const $9d21b0c8cbcd8930$export$e3452b0e8cf45d94 = 3;
const $9d21b0c8cbcd8930$export$fd0eb84f1cc64bd1 = 4;
const $9d21b0c8cbcd8930$export$ccfab360c3bec41f = 5;
const $9d21b0c8cbcd8930$export$d0b62675e5ca73fd = 6;
const $9d21b0c8cbcd8930$export$952b9e656bb22739 = 6;
const $9d21b0c8cbcd8930$export$bf33c90eb728615a = 8;
const $9d21b0c8cbcd8930$export$d2c2571c3482d99f = 15;
const $9d21b0c8cbcd8930$export$607b7b6549bb844a = (0, $c9TLT.layers).navigation;

});

parcelRegister("fkfMB", function(module, exports) {

$parcel$export(module.exports, "TooltipInterval", () => $470201a16f8a3528$export$dccd89ac2f47033e);
$parcel$export(module.exports, "ContentName", () => $470201a16f8a3528$export$6e99a112608b0053);
$parcel$export(module.exports, "ContentDateLabel", () => $470201a16f8a3528$export$3f3c4d01a01294ab);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");
const $470201a16f8a3528$export$dccd89ac2f47033e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "row",
        alignItems: "center",
        xcss: $470201a16f8a3528$var$tooltipStyles
    }, children);
const $470201a16f8a3528$export$6e99a112608b0053 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s"
        ])
    }, children);
const $470201a16f8a3528$export$3f3c4d01a01294ab = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_18u01b66 _syazafn2"
        ])
    }, children);
const $470201a16f8a3528$var$tooltipStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'nowrap'
});

});

parcelRegister("bMb4i", function(module, exports) {

$parcel$export(module.exports, "ReleaseIcon", () => $29c6d53bbb7229f5$export$8417cbec3ac6c318);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $aiDMO = parcelRequire("aiDMO");

var $c9TLT = parcelRequire("c9TLT");
const $29c6d53bbb7229f5$export$8417cbec3ac6c318 = ({ size: size })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29c6d53bbb7229f5$var$Wrapper, {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aiDMO))), {
        label: "",
        spacing: size === 'medium' ? 'spacious' : 'none',
        color: "currentColor",
        LEGACY_size: size
    }));
$29c6d53bbb7229f5$export$8417cbec3ac6c318.defaultProps = {
    size: 'small'
};
const $29c6d53bbb7229f5$var$SMALL_ICON_SIZE = (0, $c9TLT.gridSize) * 2;
const $29c6d53bbb7229f5$var$MEDIUM_ICON_SIZE = (0, $c9TLT.gridSize) * 3;
const $29c6d53bbb7229f5$var$getIconSize = ({ size: size })=>size === 'small' ? $29c6d53bbb7229f5$var$SMALL_ICON_SIZE : $29c6d53bbb7229f5$var$MEDIUM_ICON_SIZE;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $29c6d53bbb7229f5$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_2ylchh": (0, $9t7rW.default)($29c6d53bbb7229f5$var$getIconSize, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbktuk _4t3iktuk _2hwx1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aiDMO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::553e71e438a60de37e6f93988cb1bfa5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77fa728fc501b276$var$_react = $77fa728fc501b276$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $77fa728fc501b276$var$_release = $77fa728fc501b276$var$_interopRequireDefault((parcelRequire("1rDQJ")));

var $77fa728fc501b276$var$_ship = $77fa728fc501b276$var$_interopRequireDefault((parcelRequire("14lY4")));
function $77fa728fc501b276$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77fa728fc501b276$var$ReleaseIcon = (props)=>/*#__PURE__*/ $77fa728fc501b276$var$_react.default.createElement($77fa728fc501b276$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $77fa728fc501b276$var$_ship.default
    }, props));
$77fa728fc501b276$var$ReleaseIcon.Name = 'ReleaseIconMigration';
var $77fa728fc501b276$var$_default = module.exports.default = $77fa728fc501b276$var$ReleaseIcon;

});


parcelRegister("hevaQ", function(module, exports) {

$parcel$export(module.exports, "useResetChartInteractionState", () => $25c20dd0ba0dc6e6$export$fc4108d49b02ba94);
$parcel$export(module.exports, "useInteractionData", () => $25c20dd0ba0dc6e6$export$2f4e7606a05110d7);
$parcel$export(module.exports, "useTargetIntervalId", () => $25c20dd0ba0dc6e6$export$a93e57268029ba2d);
$parcel$export(module.exports, "useIntervalDropZoneData", () => $25c20dd0ba0dc6e6$export$6814590c602b8a2a);
$parcel$export(module.exports, "useIsHeaderModalActive", () => $25c20dd0ba0dc6e6$export$5eb5fe0fd641b668);
$parcel$export(module.exports, "useHeaderItemActions", () => $25c20dd0ba0dc6e6$export$fad9cd2384b134e0);
$parcel$export(module.exports, "RoadmapChartItemInteractionProvider", () => $25c20dd0ba0dc6e6$export$9d4771cc037ac267);

var $eUqFw = parcelRequire("eUqFw");

var $bwj1b = parcelRequire("bwj1b");

var $3XwA1 = parcelRequire("3XwA1");

var $WBLbN = parcelRequire("WBLbN");

var $94kLM = parcelRequire("94kLM");

var $97CZA = parcelRequire("97CZA");

var $bYbPQ = parcelRequire("bYbPQ");

var $ei022 = parcelRequire("ei022");

var $623w8 = parcelRequire("623w8");
const $25c20dd0ba0dc6e6$export$c830a1fa415103b0 = (0, $WBLbN.createStore)({
    initialState: (0, $bYbPQ.DEFAULT_STATE),
    actions: $97CZA.actions,
    name: 'timeline-table-kit.table-providers.chart-item-interactions'
});
const $25c20dd0ba0dc6e6$var$useChartInteractionActions = (0, $WBLbN.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: null
});
const $25c20dd0ba0dc6e6$export$fc4108d49b02ba94 = ()=>{
    const [, chartInteractionActions] = $25c20dd0ba0dc6e6$var$useChartInteractionActions();
    return {
        resetChartInteractionState: chartInteractionActions.onLingerEnd
    };
};
const $25c20dd0ba0dc6e6$export$2f4e7606a05110d7 = (0, $WBLbN.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: (0, $ei022.getInteractionDataById)
});
const $25c20dd0ba0dc6e6$export$a93e57268029ba2d = (0, $WBLbN.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: (0, $ei022.getTargetIntervalId)
});
const $25c20dd0ba0dc6e6$export$6814590c602b8a2a = (0, $WBLbN.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: (0, $ei022.getIntervalDropZoneDataById)
});
const $25c20dd0ba0dc6e6$export$5eb5fe0fd641b668 = (0, $WBLbN.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: (0, $ei022.getIsHeaderModalActive)
});
const $25c20dd0ba0dc6e6$export$fad9cd2384b134e0 = (0, $WBLbN.createActionsHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0);
const $25c20dd0ba0dc6e6$var$Container = (0, $WBLbN.createContainer)($25c20dd0ba0dc6e6$export$c830a1fa415103b0);
const $25c20dd0ba0dc6e6$export$9d4771cc037ac267 = ({ items: items, selectedItemIds: selectedItemIds, isDragAlongEnabled: isDragAlongEnabled, intervals: intervals, children: children })=>{
    const sideEffectMarshal = (0, $bwj1b.useSideEffectMarshal)();
    const [{ timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const { updateViewportCache: updateViewportCache, adjustScrollPositionAndGetOffset: adjustScrollPositionAndGetOffset } = (0, $94kLM.useAdjustScrollPosition)();
    const simpleIntervals = (0, $623w8.getSimpleIntervals)(intervals, timelineDuration, timelineWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25c20dd0ba0dc6e6$var$Container, {
        items: items,
        selectedItemIds: selectedItemIds,
        sideEffectMarshal: sideEffectMarshal,
        timelineMode: timelineMode,
        timelineWidth: timelineWidth,
        timelineDuration: timelineDuration,
        setViewportCache: updateViewportCache,
        getScrollOffset: adjustScrollPositionAndGetOffset,
        isDragAlongEnabled: isDragAlongEnabled,
        simpleIntervals: simpleIntervals
    }, children);
};
$25c20dd0ba0dc6e6$export$9d4771cc037ac267.defaultProps = {
    selectedItemIds: []
};

});
parcelRegister("94kLM", function(module, exports) {

$parcel$export(module.exports, "adjustScrollPosition", () => $f3def37c59f5822f$export$9b07bbd51c0d1d84);
$parcel$export(module.exports, "useAdjustScrollPosition", () => $f3def37c59f5822f$export$6853243092b02409);

var $eUqFw = parcelRequire("eUqFw");

var $6TBpb = parcelRequire("6TBpb");

var $ix5qZ = parcelRequire("ix5qZ");
const $f3def37c59f5822f$var$calculateScrollOnDragLeft = (0, $ix5qZ.createCalculateScrollOnDragWithOffset)(120);
const $f3def37c59f5822f$var$calculateScrollOnDragTop = (0, $ix5qZ.createCalculateScrollOnDragWithOffset)(40);
const $f3def37c59f5822f$var$DEFAULT_VIEWPORT_CACHE = {
    scrollBoundingRect: undefined,
    viewportBoundingRect: undefined
};
const $f3def37c59f5822f$export$9b07bbd51c0d1d84 = (from, to, setViewportScroll, initialScrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect, // Use current viewport scrollbounding if this is not defined
newScrollLeft, // Use current viewport scrollbounding if this is not defined
newScrollTop)=>{
    const initialScrollLeft = initialScrollBoundingRect ? initialScrollBoundingRect.scrollLeft : 0;
    const initialScrollTop = initialScrollBoundingRect ? initialScrollBoundingRect.scrollTop : 0;
    const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, scrollTop: scrollTop, scrollHeight: scrollHeight } = requestViewportScrollBounding();
    let topScroll;
    let leftScroll;
    if (viewportBoundingRect) {
        const { width: width, left: left, right: right, top: top, height: height, bottom: bottom } = viewportBoundingRect;
        const newScrollTopValue = $f3def37c59f5822f$var$calculateScrollOnDragTop(height, top, bottom, to.y, to.y - from.y, scrollTop, scrollHeight - height);
        if (newScrollTopValue !== scrollTop && newScrollTopValue > 0) {
            setViewportScroll({
                scrollTop: newScrollTopValue
            });
            topScroll = newScrollTopValue;
        }
        const newScrollLeftValue = $f3def37c59f5822f$var$calculateScrollOnDragLeft(width, left, right, to.x, to.x - from.x, scrollLeft, scrollWidth - width);
        if (newScrollLeftValue !== scrollLeft && newScrollLeftValue > 0) {
            setViewportScroll({
                scrollLeft: newScrollLeftValue
            });
            leftScroll = newScrollLeftValue;
        }
    }
    return {
        scrollLeft: initialScrollLeft - (newScrollLeft !== undefined ? newScrollLeft : scrollLeft),
        scrollTop: initialScrollTop - (newScrollTop !== undefined ? newScrollTop : scrollTop),
        updatedScrollLeft: leftScroll,
        updatedScrollTop: topScroll
    };
};
const $f3def37c59f5822f$export$6853243092b02409 = ()=>{
    const viewportContext = (0, $6TBpb.useViewport)();
    const viewportCache = (0, $eUqFw.useRef)($f3def37c59f5822f$var$DEFAULT_VIEWPORT_CACHE);
    const baselineScrollLeft = (0, $eUqFw.useRef)(0);
    const baselineScrollTop = (0, $eUqFw.useRef)(0);
    const { requestViewportBoundingClient: requestViewportBoundingClient, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = viewportContext;
    const updateViewportCache = (0, $eUqFw.useCallback)(()=>{
        const scrollBoundingRect = requestViewportScrollBounding();
        const viewportBoundingRect = requestViewportBoundingClient();
        viewportCache.current = {
            viewportBoundingRect: viewportBoundingRect,
            scrollBoundingRect: scrollBoundingRect
        };
        baselineScrollLeft.current = scrollBoundingRect.scrollLeft;
        baselineScrollTop.current = scrollBoundingRect.scrollTop;
    }, [
        requestViewportBoundingClient,
        requestViewportScrollBounding
    ]);
    // The offset between the old and new scroll positions is returned.
    // This can be used to help keep a drag element up to date with the mouse position.
    const adjustScrollPositionAndGetOffset = (0, $eUqFw.useCallback)((from, to)=>{
        const { scrollBoundingRect: scrollBoundingRect, viewportBoundingRect: viewportBoundingRect } = viewportCache.current;
        const { scrollLeft: scrollLeft, updatedScrollLeft: updatedScrollLeft } = $f3def37c59f5822f$export$9b07bbd51c0d1d84(from, to, setViewportScroll, scrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect, baselineScrollLeft.current, baselineScrollTop.current);
        if (updatedScrollLeft !== undefined) baselineScrollLeft.current = updatedScrollLeft;
        return scrollLeft;
    }, [
        setViewportScroll,
        requestViewportScrollBounding
    ]);
    return {
        updateViewportCache: updateViewportCache,
        adjustScrollPositionAndGetOffset: adjustScrollPositionAndGetOffset
    };
};

});
parcelRegister("ix5qZ", function(module, exports) {

$parcel$export(module.exports, "createCalculateScrollOnDragWithOffset", () => $c40412c71cf2dbf1$export$62b7f59ff4b39d81);
const $c40412c71cf2dbf1$var$SCROLL_SCALE_WITH_OFFSET = 2;
const $c40412c71cf2dbf1$var$getWeightedScrollAmountWithOffset = (scrollAmount)=>Math.round(scrollAmount ** $c40412c71cf2dbf1$var$SCROLL_SCALE_WITH_OFFSET);
const $c40412c71cf2dbf1$var$SCROLL_MAX = 150;
const $c40412c71cf2dbf1$var$getThrottledScrollAmount = (scrollAmount)=>Math.min($c40412c71cf2dbf1$var$SCROLL_MAX, scrollAmount);
const $c40412c71cf2dbf1$export$62b7f59ff4b39d81 = (scrollThreshold)=>(height, top, bottom, cursorOffset, cursorOffsetDiff, scrollPosition, scrollSize)=>{
        // Fallback to current scrollPosition
        let newScrollPosition = scrollPosition;
        // small tables need a fallback threshold derived from its' size
        const threshold = Math.min(height / 2, scrollThreshold);
        if (cursorOffset > top && cursorOffset <= top + threshold && cursorOffsetDiff < 0) {
            // inversely relative to distance to list top
            const scrollAmount = $c40412c71cf2dbf1$var$getWeightedScrollAmountWithOffset(1 / ((cursorOffset - top) / threshold));
            const throttledScrollAmount = $c40412c71cf2dbf1$var$getThrottledScrollAmount(scrollAmount);
            // don't scroll beyond the list start
            newScrollPosition = Math.max(0, scrollPosition - throttledScrollAmount);
        } else if (cursorOffset < bottom && cursorOffset >= bottom - threshold && cursorOffset > 0) {
            // inversely relative to distance to list bottom
            const scrollAmount = $c40412c71cf2dbf1$var$getWeightedScrollAmountWithOffset(1 / ((bottom - cursorOffset) / threshold));
            const throttledScrollAmount = $c40412c71cf2dbf1$var$getThrottledScrollAmount(scrollAmount);
            // don't scroll beyond the list end
            newScrollPosition = Math.min(scrollSize, scrollPosition + throttledScrollAmount);
        }
        return newScrollPosition;
    };

});


parcelRegister("97CZA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $831fef74b7670418$export$e324594224ef24da);

var $d7OQi = parcelRequire("d7OQi");

var $dJqdT = parcelRequire("dJqdT");

var $53tmg = parcelRequire("53tmg");

var $aadAS = parcelRequire("aadAS");

var $jfM9p = parcelRequire("jfM9p");

var $gLLn4 = parcelRequire("gLLn4");

var $eqZIm = parcelRequire("eqZIm");

var $dF5k3 = parcelRequire("dF5k3");
const $831fef74b7670418$export$e324594224ef24da = {
    onDrag: $d7OQi.onDrag,
    onDragEnd: $dJqdT.onDragEnd,
    onDragStart: $53tmg.onDragStart,
    onLinger: $aadAS.onLinger,
    onLingerEnd: $jfM9p.onLingerEnd,
    onLingerStart: $gLLn4.onLingerStart,
    onPreview: $eqZIm.onPreview,
    onToggleHeaderModal: $dF5k3.onToggleHeaderModal
};

});
parcelRegister("d7OQi", function(module, exports) {

$parcel$export(module.exports, "onDrag", () => $a0580fae0e3e9274$export$11a07b18d6f8f6d2);

var $1RX3i = parcelRequire("1RX3i");

var $4m3tp = parcelRequire("4m3tp");
const $a0580fae0e3e9274$export$11a07b18d6f8f6d2 = (from, to, start)=>({ setState: setState, getState: getState }, containerProps)=>{
        const { activeItem: activeItem, dragType: dragType, itemPositions: itemPositions, previewBaselinePosition: previewBaselinePosition } = getState();
        if (!activeItem || !dragType) return;
        let dragResult;
        const { startDate: startDate, dueDate: dueDate } = activeItem;
        if (startDate === undefined && dueDate === undefined && previewBaselinePosition) {
            // Refine types to prove to flow that both dates are always absent
            const noDateActiveItem = {
                ...activeItem,
                startDate: startDate,
                dueDate: dueDate
            };
            dragResult = (0, $4m3tp.onNoDateDrag)({
                from: from,
                to: to,
                start: start
            }, {
                activeItem: noDateActiveItem,
                dragType: dragType,
                previewBaselinePosition: previewBaselinePosition
            }, containerProps);
        } else if (startDate !== undefined && dueDate !== undefined) {
            // Refine types to prove to flow that both dates are always present
            const dateActiveItem = {
                ...activeItem,
                startDate: startDate,
                dueDate: dueDate
            };
            dragResult = (0, $1RX3i.onDateDrag)({
                from: from,
                to: to,
                start: start
            }, {
                activeItem: dateActiveItem,
                dragType: dragType,
                itemPositions: itemPositions
            }, containerProps);
        }
        // In case of an invalid drag (e.g. out of bounds) there will be no drag result
        dragResult && setState(dragResult);
    };

});
parcelRegister("1RX3i", function(module, exports) {

$parcel$export(module.exports, "onDateDrag", () => $e264ad6ddb4ca35f$export$6abaacf95e615b18);

var $8blac = parcelRequire("8blac");

var $4P2VV = parcelRequire("4P2VV");

var $fHtBB = parcelRequire("fHtBB");

var $81Dhf = parcelRequire("81Dhf");

var $5WPbd = parcelRequire("5WPbd");
const $e264ad6ddb4ca35f$export$6abaacf95e615b18 = (dragPosition, { activeItem: activeItem, dragType: dragType, itemPositions: itemPositions }, { items: items, selectedItemIds: selectedItemIds, timelineDuration: timelineDuration, timelineWidth: timelineWidth, isDragAlongEnabled: isDragAlongEnabled, getScrollOffset: getScrollOffset, simpleIntervals: simpleIntervals })=>{
    const gridSize = (0, $81Dhf.getGridSize)(timelineDuration, timelineWidth);
    const scrollOffset = getScrollOffset(dragPosition.from, dragPosition.to);
    const { selectedItems: selectedItems, childItemsHash: childItemsHash } = (0, $5WPbd.getItemsCollection)(items, selectedItemIds);
    const newItemPositions = {};
    const handleDrag = (targetItem)=>{
        const { leftPosition: leftPosition, rightPosition: rightPosition } = (0, $5WPbd.getDragPosition)(dragType, targetItem, timelineDuration, timelineWidth, dragPosition, gridSize, scrollOffset);
        // In case of an invalid drag (e.g. out of bounds) neither positions will be defined
        if (leftPosition === undefined && rightPosition === undefined) return;
        newItemPositions[targetItem.id] = {
            leftPosition: leftPosition,
            rightPosition: rightPosition
        };
        // Depending on the interaction, an item with children can result in updating their positions also
        if (isDragAlongEnabled && dragType === (0, $4P2VV.LEFT_AND_RIGHT)) {
            const childItems = childItemsHash[targetItem.id] || [];
            // Move the parent item along with its children
            childItems.forEach((childItem)=>{
                const { leftPosition: childLeftPosition, rightPosition: childRightPosition } = (0, $5WPbd.getDragPosition)(dragType, childItem, timelineDuration, timelineWidth, dragPosition, gridSize, scrollOffset);
                if (childLeftPosition !== undefined || childRightPosition !== undefined) newItemPositions[childItem.id] = {
                    leftPosition: childLeftPosition,
                    rightPosition: childRightPosition
                };
            });
        }
    };
    let targetIntervalId;
    const { id: id, intervalId: intervalId, startDateType: startDateType, dueDateType: dueDateType } = activeItem;
    // bulk-scheduling (bar-dragging and bar-resizing) is only available when
    // - there is more than one item selected
    // - the active item is part of the selection
    // - the items selected are schedulable (i.e. their dates are not derived from intervals. Currently only base-level issues in scrum fit)
    if (selectedItemIds.length > 1 && selectedItemIds.includes(id) && startDateType !== (0, $fHtBB.INTERVAL) && dueDateType !== (0, $fHtBB.INTERVAL)) {
        selectedItems.forEach((item)=>{
            handleDrag(item);
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newItemPositions)) return undefined;
    } else {
        handleDrag(activeItem);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newItemPositions)) return undefined;
        const { leftPosition: leftPosition, rightPosition: rightPosition } = newItemPositions[id];
        if (intervalId !== undefined && dragType === (0, $4P2VV.LEFT_AND_RIGHT) && leftPosition !== undefined && rightPosition !== undefined) {
            const midPosition = (timelineWidth - rightPosition - leftPosition) / 2 + leftPosition;
            const unsafeTargetIntervalId = (0, $81Dhf.getTargetIntervalId)(simpleIntervals, timelineWidth, midPosition);
            // Skip setting to an items existing assigned intervals
            if (unsafeTargetIntervalId !== intervalId) targetIntervalId = unsafeTargetIntervalId;
        }
    }
    return {
        itemPositions: {
            ...itemPositions,
            ...newItemPositions
        },
        targetIntervalId: targetIntervalId
    };
};

});
parcelRegister("81Dhf", function(module, exports) {

$parcel$export(module.exports, "to1DP", () => $ef4f0afa86695ff4$export$6c9c23d367dcea0f);
$parcel$export(module.exports, "getTargetIntervalId", () => $ef4f0afa86695ff4$export$fd188f2e31f7a51c);
$parcel$export(module.exports, "getGridSize", () => $ef4f0afa86695ff4$export$3a0507da8b146ff1);
$parcel$export(module.exports, "snapToGrid", () => $ef4f0afa86695ff4$export$195604d042fd3f87);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");
const $ef4f0afa86695ff4$export$6c9c23d367dcea0f = (value)=>Math.round((value + Number.EPSILON) * 10) / 10;
const $ef4f0afa86695ff4$export$fd188f2e31f7a51c = (simpleIntervals, timelineWidth, posX)=>{
    const overlappingIntervals = simpleIntervals.filter(({ leftPosition: leftPosition, rightPosition: rightPosition })=>{
        const isItemStartEqualToOrGreaterThanIntervalStart = $ef4f0afa86695ff4$export$6c9c23d367dcea0f(posX) >= $ef4f0afa86695ff4$export$6c9c23d367dcea0f(leftPosition);
        const isItemStartLessThanIntervalEnd = $ef4f0afa86695ff4$export$6c9c23d367dcea0f(posX) < $ef4f0afa86695ff4$export$6c9c23d367dcea0f(timelineWidth - rightPosition);
        return isItemStartEqualToOrGreaterThanIntervalStart && isItemStartLessThanIntervalEnd;
    });
    return overlappingIntervals.length > 0 ? overlappingIntervals[0].targetId : undefined;
};
const $ef4f0afa86695ff4$export$3a0507da8b146ff1 = (0, $5iWql.default)(({ endMilliseconds: endMilliseconds, startMilliseconds: startMilliseconds }, timelineWidth)=>{
    const numberOfDaysInTimeline = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt)))(endMilliseconds).diff(startMilliseconds, 'days') + 1;
    return timelineWidth / numberOfDaysInTimeline;
});
const $ef4f0afa86695ff4$export$195604d042fd3f87 = (position, gridSize, offset = 0)=>{
    const roundedOffset = Math.round(offset / gridSize) * gridSize;
    return position + roundedOffset;
};

});

parcelRegister("5WPbd", function(module, exports) {

$parcel$export(module.exports, "getDragPosition", () => $6bdbb0ab06e4e356$export$43fc86aa4efa07b0);
$parcel$export(module.exports, "getItemsCollection", () => $6bdbb0ab06e4e356$export$68a20f16cafe8131);

var $5iWql = parcelRequire("5iWql");

var $4P2VV = parcelRequire("4P2VV");

var $c3IKH = parcelRequire("c3IKH");

var $fHtBB = parcelRequire("fHtBB");

var $cww1R = parcelRequire("cww1R");

var $81Dhf = parcelRequire("81Dhf");
const $6bdbb0ab06e4e356$export$38e26b36381469ee = (dragType, hasLeftPlaceholder, dateType)=>dragType === (0, $4P2VV.LEFT_AND_RIGHT) || dragType === (0, $4P2VV.LEFT) || dragType === (0, $4P2VV.RIGHT) && hasLeftPlaceholder && dateType !== (0, $fHtBB.ROLLUP);
const $6bdbb0ab06e4e356$export$40ce9920ffc376d2 = (dragType, hasRightPlaceholder, dateType)=>dragType === (0, $4P2VV.LEFT_AND_RIGHT) || dragType === (0, $4P2VV.RIGHT) || dragType === (0, $4P2VV.LEFT) && hasRightPlaceholder && dateType !== (0, $fHtBB.ROLLUP);
const $6bdbb0ab06e4e356$export$94ff4f58995a561 = (dragType, leftPosition, rightPosition, timelineWidth, direction)=>{
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT) && leftPosition < 0 && direction === (0, $4P2VV.LEFT)) return false;
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT) && rightPosition < 0 && direction === (0, $4P2VV.RIGHT)) return false;
    if (dragType === (0, $4P2VV.LEFT) && (leftPosition < 0 || leftPosition > timelineWidth)) return false;
    if (dragType === (0, $4P2VV.RIGHT) && (rightPosition < 0 || rightPosition > timelineWidth)) return false;
    if (dragType === (0, $4P2VV.LEFT) || dragType === (0, $4P2VV.RIGHT)) // Cannot be smaller than the minimum width
    return timelineWidth - rightPosition - leftPosition > (0, $c3IKH.MINIMUM_BAR_LENGTH);
    return true;
};
const $6bdbb0ab06e4e356$var$getDragDirection = (dragType, leftPosition, baselineLeftPosition)=>{
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT)) return leftPosition !== undefined && leftPosition < baselineLeftPosition ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
    if (dragType === (0, $4P2VV.LEFT)) return 0, $4P2VV.LEFT;
    return 0, $4P2VV.RIGHT;
};
const $6bdbb0ab06e4e356$export$43fc86aa4efa07b0 = (dragType, item, timelineDuration, timelineWidth, { to: to, start: start }, gridSize, scrollOffset)=>{
    let leftPosition;
    let rightPosition;
    const { startDate: startDate, dueDate: dueDate, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType } = item;
    const baselineLeftPosition = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const baselineRightPosition = (0, $cww1R.getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
    const hasLeftPlaceholder = placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
    const hasRightPlaceholder = placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
    if ($6bdbb0ab06e4e356$export$38e26b36381469ee(dragType, hasLeftPlaceholder, startDateType)) {
        const offset = to.x - start.x - scrollOffset;
        leftPosition = (0, $81Dhf.snapToGrid)(baselineLeftPosition, gridSize, offset);
    }
    if ($6bdbb0ab06e4e356$export$40ce9920ffc376d2(dragType, hasRightPlaceholder, dueDateType)) {
        const offset = start.x - to.x + scrollOffset;
        rightPosition = (0, $81Dhf.snapToGrid)(baselineRightPosition, gridSize, offset);
    }
    const actualLeftPosition = leftPosition ?? baselineLeftPosition;
    const actualRightPosition = rightPosition ?? baselineRightPosition;
    const direction = $6bdbb0ab06e4e356$var$getDragDirection(dragType, leftPosition, baselineLeftPosition);
    if ($6bdbb0ab06e4e356$export$94ff4f58995a561(dragType, actualLeftPosition, actualRightPosition, timelineWidth, direction)) return {
        leftPosition: leftPosition,
        rightPosition: rightPosition
    };
    return {
        leftPosition: undefined,
        rightPosition: undefined
    };
};
const $6bdbb0ab06e4e356$var$isDateInteractiveChartItem = (item)=>item.startDate !== undefined && item.dueDate !== undefined;
const $6bdbb0ab06e4e356$export$68a20f16cafe8131 = (0, $5iWql.default)((items, selectedItemIds)=>{
    const itemsTree = items.reduce((acc, item)=>{
        if (item.parentId && $6bdbb0ab06e4e356$var$isDateInteractiveChartItem(item)) {
            const childItems = acc[item.parentId] ?? [];
            childItems.push(item);
            acc[item.parentId] = childItems;
        }
        return acc;
    }, {});
    const descendantItemsHash = {};
    const findDescendants = (parentId)=>{
        if (descendantItemsHash[parentId]) return descendantItemsHash[parentId];
        const children = itemsTree[parentId] ?? [];
        const descendants = children.flatMap((child)=>[
                child,
                ...findDescendants(child.id)
            ]);
        descendantItemsHash[parentId] = descendants;
        return descendants;
    };
    return items.reduce((acc, item)=>{
        if (!$6bdbb0ab06e4e356$var$isDateInteractiveChartItem(item)) return acc;
        if (selectedItemIds.includes(item.id)) acc.selectedItems.push(item);
        if (item.parentId) acc.childItemsHash[item.parentId] = findDescendants(item.parentId);
        return acc;
    }, {
        selectedItems: [],
        childItemsHash: {}
    });
});

});
parcelRegister("cww1R", function(module, exports) {

$parcel$export(module.exports, "getBarLeftPosition", () => $5eb2dfac86109cf2$export$7515da295c144459);
$parcel$export(module.exports, "getBarRightPosition", () => $5eb2dfac86109cf2$export$6d1b18b85e7cc7aa);
$parcel$export(module.exports, "getStartDate", () => $5eb2dfac86109cf2$export$3ee8fbdbeceaef0e);
$parcel$export(module.exports, "getDueDate", () => $5eb2dfac86109cf2$export$813ac50a60a492f2);
$parcel$export(module.exports, "getIsBarVisible", () => $5eb2dfac86109cf2$export$4a4fadfd0dbb59d8);


var $1QJt8 = parcelRequire("1QJt8");

var $fHtBB = parcelRequire("fHtBB");
const $5eb2dfac86109cf2$export$7515da295c144459 = (startDate, timelineDuration, timelineWidth)=>(0, $1QJt8.getTimelinePositionFromDate)(timelineDuration, timelineWidth, startDate);
const $5eb2dfac86109cf2$export$6d1b18b85e7cc7aa = (dueDate, timelineDuration, timelineWidth)=>{
    const endOfDueDate = dueDate + (0, $fHtBB.DUE_DATE_OFFSET);
    const leftPosition = (0, $1QJt8.getTimelinePositionFromDate)(timelineDuration, timelineWidth, endOfDueDate);
    return timelineWidth - leftPosition;
};
const $5eb2dfac86109cf2$export$b6b0beaf88b31f31 = (date)=>Math.round(date / (0, $4975412c8fcbfa24$export$1f04624003d2da7d)) * (0, $4975412c8fcbfa24$export$1f04624003d2da7d);
const $5eb2dfac86109cf2$export$3ee8fbdbeceaef0e = (leftPosition, timelineDuration, timelineWidth)=>{
    const startDate = (0, $1QJt8.getDateFromTimelinePosition)(timelineDuration, timelineWidth, leftPosition);
    return $5eb2dfac86109cf2$export$b6b0beaf88b31f31(startDate);
};
const $5eb2dfac86109cf2$export$813ac50a60a492f2 = (rightPosition, timelineDuration, timelineWidth)=>{
    const dueDate = (0, $1QJt8.getDateFromTimelinePosition)(timelineDuration, timelineWidth, timelineWidth - rightPosition) - (0, $fHtBB.DUE_DATE_OFFSET);
    return $5eb2dfac86109cf2$export$b6b0beaf88b31f31(dueDate);
};
const $5eb2dfac86109cf2$export$4a4fadfd0dbb59d8 = (barLeftPosition, barRightPosition, timelineWidth)=>{
    const isBeforeTimeline = barLeftPosition < 0 && barRightPosition >= timelineWidth;
    const isAfterTimeline = barLeftPosition >= timelineWidth && barRightPosition < 0;
    return !isBeforeTimeline && !isAfterTimeline;
};

});



parcelRegister("4m3tp", function(module, exports) {

$parcel$export(module.exports, "onNoDateDrag", () => $3e1025a76856b3d8$export$30770ba27cbf606f);

var $4P2VV = parcelRequire("4P2VV");

var $81Dhf = parcelRequire("81Dhf");

var $6cmG2 = parcelRequire("6cmG2");
const $3e1025a76856b3d8$export$30770ba27cbf606f = ({ from: from, to: to, start: start }, { activeItem: activeItem, dragType: dragType, previewBaselinePosition: previewBaselinePosition }, { timelineDuration: timelineDuration, timelineWidth: timelineWidth, getScrollOffset: getScrollOffset, simpleIntervals: simpleIntervals })=>{
    const gridSize = (0, $81Dhf.getGridSize)(timelineDuration, timelineWidth);
    const scrollOffset = getScrollOffset(from, to);
    const startPosition = previewBaselinePosition.leftPosition;
    let leftPosition;
    let rightPosition;
    let nextDragType;
    if (dragType === (0, $4P2VV.LEFT)) {
        const offset = to.x - start.x - scrollOffset;
        rightPosition = timelineWidth - startPosition;
        leftPosition = (0, $81Dhf.snapToGrid)(startPosition, gridSize, offset);
        nextDragType = leftPosition < startPosition ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
    } else {
        const offset = to.x - start.x - scrollOffset;
        leftPosition = startPosition;
        rightPosition = timelineWidth - (0, $81Dhf.snapToGrid)(startPosition, gridSize, offset);
        nextDragType = timelineWidth - rightPosition < startPosition ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
    }
    if (!(0, $6cmG2.isValidDrag)(leftPosition, rightPosition, gridSize, timelineWidth)) return undefined;
    const targetIntervalId = (0, $81Dhf.getTargetIntervalId)(simpleIntervals, timelineWidth, leftPosition);
    return {
        itemPositions: {
            [`${activeItem.id}`]: {
                leftPosition: leftPosition,
                rightPosition: rightPosition
            }
        },
        targetIntervalId: targetIntervalId,
        dragType: nextDragType
    };
};

});
parcelRegister("6cmG2", function(module, exports) {

$parcel$export(module.exports, "isValidDrag", () => $9b739c155524713e$export$94ff4f58995a561);

var $81Dhf = parcelRequire("81Dhf");
const $9b739c155524713e$export$94ff4f58995a561 = (leftPosition, rightPosition, gridSize, timelineWidth)=>{
    const distance = Math.abs(timelineWidth - rightPosition - leftPosition);
    return (0, $81Dhf.to1DP)(distance) >= (0, $81Dhf.to1DP)(gridSize);
};

});



parcelRegister("dJqdT", function(module, exports) {

$parcel$export(module.exports, "onDragEnd", () => $d5e7f1bb3a9c4b50$export$8566066e92caa8a);

var $bYbPQ = parcelRequire("bYbPQ");
const $d5e7f1bb3a9c4b50$export$8566066e92caa8a = ()=>({ setState: setState }, { sideEffectMarshal: sideEffectMarshal })=>{
        sideEffectMarshal.custom.onBarInteractionEnd();
        /* Don't reset activeItem, the mouse remains on the item after drag finishes so it is still "active".
		 * Don't reset hasLingered, the user may still intend to interact again. Without it, we won't show any target intervals.
		 */ const { activeItem: activeItem, hasLingered: hasLingered, ...defaultState } = (0, $bYbPQ.DEFAULT_STATE);
        setState(defaultState);
    };

});
parcelRegister("bYbPQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_STATE", () => $e648e84a85a5c3db$export$a3a6a28ae8823b06);
const $e648e84a85a5c3db$export$a3a6a28ae8823b06 = {
    activeItem: undefined,
    hasLingered: false,
    dragType: undefined,
    itemPositions: {},
    targetIntervalId: undefined,
    isHeaderModalActive: false,
    previewBaselinePosition: undefined
};

});


parcelRegister("53tmg", function(module, exports) {

$parcel$export(module.exports, "onDragStart", () => $04a7943594562b62$export$b00174fdb6a6ab8f);

var $fHtBB = parcelRequire("fHtBB");

var $5Hx5H = parcelRequire("5Hx5H");
const $04a7943594562b62$export$b00174fdb6a6ab8f = (id, dragType)=>({ getState: getState, setState: setState }, { items: items, sideEffectMarshal: sideEffectMarshal, setViewportCache: setViewportCache })=>{
        const activeItem = items.find((item)=>item.id === id);
        if (activeItem) {
            const { itemPositions: itemPositions, hasLingered: hasLingeredFromState } = getState();
            const previewBaselinePosition = (0, $5Hx5H.getPreviewBaselinePosition)(activeItem, itemPositions);
            /* Reset hasLingered for non-INTERVAL type, we don't highlight target interval while dragging.
			 */ const hasLingered = activeItem.startDateType === (0, $fHtBB.INTERVAL) && activeItem.dueDateType === (0, $fHtBB.INTERVAL) ? hasLingeredFromState : false;
            setViewportCache();
            sideEffectMarshal.custom.onBarInteractionStart();
            setState({
                activeItem: activeItem,
                dragType: dragType,
                previewBaselinePosition: previewBaselinePosition,
                hasLingered: hasLingered
            });
        }
    };

});
parcelRegister("5Hx5H", function(module, exports) {

$parcel$export(module.exports, "getPreviewBaselinePosition", () => $c695995dbeb4f280$export$6e65532e85c8e991);
const $c695995dbeb4f280$export$6e65532e85c8e991 = (activeItem, itemPositions)=>{
    let previewBaselinePosition;
    const { id: id, startDate: startDate, dueDate: dueDate } = activeItem;
    if (startDate === undefined && dueDate === undefined && itemPositions[id]) {
        const { leftPosition: leftPosition, rightPosition: rightPosition } = itemPositions[id];
        if (leftPosition !== undefined && rightPosition !== undefined) previewBaselinePosition = {
            leftPosition: leftPosition,
            rightPosition: rightPosition
        };
    }
    return previewBaselinePosition;
};

});


parcelRegister("aadAS", function(module, exports) {

$parcel$export(module.exports, "onLinger", () => $1e4f1410163d8f3a$export$c9ef8a8ee2b7f513);

var $fHtBB = parcelRequire("fHtBB");

var $81Dhf = parcelRequire("81Dhf");
const $1e4f1410163d8f3a$export$c9ef8a8ee2b7f513 = ()=>({ getState: getState, setState: setState }, { timelineWidth: timelineWidth, simpleIntervals: simpleIntervals })=>{
        const { activeItem: activeItem, itemPositions: itemPositions } = getState();
        if (activeItem?.startDateType === (0, $fHtBB.INTERVAL) && activeItem?.dueDateType === (0, $fHtBB.INTERVAL) || activeItem?.intervalId !== undefined) {
            let targetIntervalId;
            const { id: id, startDate: startDate, dueDate: dueDate, intervalId: intervalId } = activeItem;
            const leftPosition = itemPositions[id]?.leftPosition;
            /* For existing items, we can directly compare their pre-existing interval.
			 * Otherwise, for previews that don't have an interval yet, we can compare interval positions.
			 */ if (startDate !== undefined && dueDate !== undefined) {
                const isIntervalExists = simpleIntervals.find(({ intervalIds: intervalIds })=>intervalId && intervalIds.includes(intervalId));
                if (isIntervalExists) targetIntervalId = intervalId;
            } else if (/* Don't highlight target interval id if a date-based item has no dates
				 */ leftPosition !== undefined && activeItem.startDateType === (0, $fHtBB.INTERVAL) && activeItem.dueDateType === (0, $fHtBB.INTERVAL)) targetIntervalId = (0, $81Dhf.getTargetIntervalId)(simpleIntervals, timelineWidth, leftPosition);
            setState({
                hasLingered: true,
                targetIntervalId: targetIntervalId
            });
        }
    };

});

parcelRegister("jfM9p", function(module, exports) {

$parcel$export(module.exports, "onLingerEnd", () => $0501fab761d3150a$export$5066f5e6e6738857);

var $bYbPQ = parcelRequire("bYbPQ");
const $0501fab761d3150a$export$5066f5e6e6738857 = ()=>({ getState: getState, setState: setState })=>{
        const { dragType: dragType } = getState();
        /* The current affordance allows users to continue dragging an item even if
		 * their cursor moves to an adjacent row. Do *not* reset the state in this
		 * circumstance or it will cancel the drag interaction.
		 */ if (dragType === undefined) setState((0, $bYbPQ.DEFAULT_STATE));
    };

});

parcelRegister("gLLn4", function(module, exports) {

$parcel$export(module.exports, "onLingerStart", () => $7c3de49c7a130000$export$bb211627ff50e51b);
const $7c3de49c7a130000$export$bb211627ff50e51b = (id)=>({ getState: getState, setState: setState }, { items: items })=>{
        const { dragType: dragType } = getState();
        const activeItem = items.find((item)=>item.id === id);
        /* The current affordance allows users to continue dragging an item even if
		 * their cursor moves to an adjacent row. Do *not* override the active item
		 * in this circumstance or it will cancel the drag interaction.
		 */ if (activeItem !== undefined && dragType === undefined) setState({
            activeItem: activeItem
        });
    };

});

parcelRegister("eqZIm", function(module, exports) {

$parcel$export(module.exports, "onPreview", () => $acc1b9163d3f4bad$export$9d4a8aef590e6b33);

var $gf0vG = parcelRequire("gf0vG");

var $fHtBB = parcelRequire("fHtBB");

var $81Dhf = parcelRequire("81Dhf");
const $acc1b9163d3f4bad$var$TIMELINE_MODE_OFFSET = {
    [(0, $gf0vG.WEEKS)]: 7,
    [(0, $gf0vG.MONTHS)]: 14,
    [(0, $gf0vG.QUARTERS)]: 30
};
const $acc1b9163d3f4bad$export$9d4a8aef590e6b33 = (previewX)=>({ getState: getState, setState: setState }, { timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth, simpleIntervals: simpleIntervals })=>{
        const { activeItem: activeItem, dragType: dragType } = getState();
        // Dragging interactions have precedence (interactions should be mutually exclusive)
        if (!activeItem || activeItem && dragType) return;
        const isInterval = activeItem.startDateType === (0, $fHtBB.INTERVAL) && activeItem.dueDateType === (0, $fHtBB.INTERVAL);
        let leftPosition;
        let rightPosition;
        let targetIntervalId;
        const gridSize = (0, $81Dhf.getGridSize)(timelineDuration, timelineWidth);
        const leftPositionSnapToGrid = (0, $81Dhf.snapToGrid)(0, gridSize, previewX);
        if (!isInterval) {
            const rightOffset = $acc1b9163d3f4bad$var$TIMELINE_MODE_OFFSET[timelineMode] * gridSize;
            leftPosition = leftPositionSnapToGrid;
            rightPosition = timelineWidth - (leftPosition + rightOffset);
        } else /**
			 * An item will not have mixed date types when one side is INTERVAL.
			 * When startDateType is INTERVAL, it's dueDateType will be INTERVAL, too.
			 */ targetIntervalId = (0, $81Dhf.getTargetIntervalId)(simpleIntervals, timelineWidth, previewX);
        setState({
            itemPositions: {
                [`${activeItem.id}`]: {
                    leftPosition: leftPosition,
                    rightPosition: rightPosition
                }
            },
            targetIntervalId: targetIntervalId
        });
    };

});

parcelRegister("dF5k3", function(module, exports) {

$parcel$export(module.exports, "onToggleHeaderModal", () => $24570f01504beb05$export$8560de0545726746);
const $24570f01504beb05$export$8560de0545726746 = (isActive)=>({ setState: setState })=>{
        setState({
            isHeaderModalActive: isActive
        });
    };

});


parcelRegister("ei022", function(module, exports) {

$parcel$export(module.exports, "getTargetIntervalId", () => $25f3660e38a08887$export$fd188f2e31f7a51c);
$parcel$export(module.exports, "getInteractionDataById", () => $25f3660e38a08887$export$56ac7aa92dc17fde);
$parcel$export(module.exports, "getIsHeaderModalActive", () => $25f3660e38a08887$export$1c272fb440996072);
$parcel$export(module.exports, "getIntervalDropZoneDataById", () => $25f3660e38a08887$export$416f05e681eaec5b);

var $fHtBB = parcelRequire("fHtBB");
const $25f3660e38a08887$export$fd188f2e31f7a51c = ({ targetIntervalId: targetIntervalId, hasLingered: hasLingered }, intervals)=>{
    if (hasLingered) {
        const targetInterval = intervals.find(({ id: id })=>id === targetIntervalId);
        return targetInterval?.id;
    }
    return undefined;
};
const $25f3660e38a08887$export$56ac7aa92dc17fde = ({ activeItem: activeItem, dragType: dragType, itemPositions: itemPositions }, id)=>{
    const leftPosition = itemPositions[id]?.leftPosition;
    const rightPosition = itemPositions[id]?.rightPosition;
    const hasAnyPosition = leftPosition !== undefined || rightPosition !== undefined;
    return {
        isActive: activeItem?.id === id,
        leftPosition: leftPosition,
        rightPosition: rightPosition,
        dragType: hasAnyPosition ? dragType : undefined
    };
};
const $25f3660e38a08887$export$1c272fb440996072 = ({ isHeaderModalActive: isHeaderModalActive })=>({
        isHeaderModalActive: isHeaderModalActive
    });
const $25f3660e38a08887$export$416f05e681eaec5b = ({ activeItem: activeItem, dragType: dragType, hasLingered: hasLingered }, id)=>{
    if (!activeItem || activeItem.id !== id || activeItem.startDateType !== (0, $fHtBB.INTERVAL) && activeItem.dueDateType !== (0, $fHtBB.INTERVAL)) return {
        isVisible: false,
        currentIntervalId: undefined
    };
    if (activeItem.startDate !== undefined && activeItem.dueDate !== undefined) return {
        isVisible: dragType !== undefined,
        currentIntervalId: activeItem.intervalId
    };
    return {
        isVisible: hasLingered,
        currentIntervalId: activeItem.intervalId
    };
};

});

parcelRegister("623w8", function(module, exports) {

$parcel$export(module.exports, "getSimpleIntervals", () => $bf42115b0ccbec92$export$ba37947e5e9cffea);

var $5iWql = parcelRequire("5iWql");


var $9j4Ay = parcelRequire("9j4Ay");
const $bf42115b0ccbec92$export$ba37947e5e9cffea = (0, $5iWql.default)((intervals, timelineDuration, timelineWidth)=>{
    const intervalGroups = (0, $9j4Ay.getIntervalGroupPositions)(intervals, timelineDuration, timelineWidth);
    const simpleIntervals = [];
    intervalGroups.forEach((intervalGroup)=>{
        const leftPosition = Math.max(intervalGroup.left, intervalGroup.targetIntervalLeft);
        const rightPosition = Math.max(intervalGroup.right, intervalGroup.targetIntervalRight);
        const targetInterval = intervalGroup.intervals.find((interval)=>interval.state !== (0, $4a21b57a573cad8c$export$19c4f83398a8dbce));
        const intervalIds = intervals.map((interval)=>interval.id);
        if (targetInterval) simpleIntervals.push({
            targetId: targetInterval.id,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            intervalIds: intervalIds
        });
    });
    return simpleIntervals;
});

});
const $4a21b57a573cad8c$export$19c4f83398a8dbce = 'CLOSED';
const $4a21b57a573cad8c$export$2b35adb71b3f6143 = 'ACTIVE';
const $4a21b57a573cad8c$export$47b7b82714c61a7c = 'FUTURE';

parcelRegister("9j4Ay", function(module, exports) {

$parcel$export(module.exports, "getIntervalGroupPositions", () => $d04bc95426bb71dd$export$209e346bf640604);

var $fHtBB = parcelRequire("fHtBB");


var $cww1R = parcelRequire("cww1R");

var $ch4pj = parcelRequire("ch4pj");
const $d04bc95426bb71dd$export$cd3d993a5aa1490e = (intervals, timelineDuration)=>{
    const saneIntervals = [];
    intervals.forEach((interval)=>{
        const saneStartDate = Math.min(interval.startDate, interval.endDate);
        const saneEndDate = Math.max(interval.startDate, interval.endDate) + (0, $fHtBB.DUE_DATE_OFFSET);
        const isStartInTimeline = saneStartDate >= timelineDuration.startMilliseconds && saneStartDate <= timelineDuration.endMilliseconds;
        const isEndInTimeline = saneEndDate >= timelineDuration.startMilliseconds && saneEndDate <= timelineDuration.endMilliseconds;
        const isLongerThanTimeline = saneStartDate <= timelineDuration.startMilliseconds && saneEndDate >= timelineDuration.endMilliseconds;
        if (isStartInTimeline || isEndInTimeline || isLongerThanTimeline) saneIntervals.push({
            id: interval.id,
            name: interval.name,
            state: interval.state,
            startDate: saneStartDate,
            endDate: saneEndDate
        });
    });
    return saneIntervals;
};
const $d04bc95426bb71dd$export$487a26b15ffb2465 = (intervalGroup, timelineDuration, timelineWidth)=>{
    const { startDate: startDate, endDate: endDate, expandedEndDate: expandedEndDate, intervals: intervals } = intervalGroup;
    // === Calculate sub-interval positions === //
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const intervalsPositions = {};
    intervals.forEach((interval)=>{
        const left = (0, $cww1R.getBarLeftPosition)(interval.startDate, timelineDuration, timelineWidth);
        const right = (0, $cww1R.getBarRightPosition)(interval.endDate - (0, $fHtBB.DUE_DATE_OFFSET), timelineDuration, timelineWidth);
        intervalsPositions[interval.id] = {
            left: Math.max(0, left),
            right: Math.max(0, right)
        };
    });
    // === Calculate group level positions === //
    const left = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const right = (0, $cww1R.getBarRightPosition)(endDate - (0, $fHtBB.DUE_DATE_OFFSET), timelineDuration, timelineWidth);
    const rightExpanded = (0, $cww1R.getBarRightPosition)(expandedEndDate - (0, $fHtBB.DUE_DATE_OFFSET), timelineDuration, timelineWidth);
    let targetIntervalLeft = left;
    let targetIntervalRight = right;
    const targetInterval = intervals.find((interval)=>interval.state !== (0, $4a21b57a573cad8c$export$19c4f83398a8dbce));
    if (targetInterval !== undefined && intervalsPositions[targetInterval.id]) {
        targetIntervalLeft = intervalsPositions[targetInterval.id].left;
        targetIntervalRight = intervalsPositions[targetInterval.id].right;
    }
    // === Sanitise group level positions === //
    const clippedLeft = Math.max(0, left);
    const clippedRight = Math.max(0, right);
    const clippedTargetLeft = Math.max(0, targetIntervalLeft);
    const clippedTargetRight = Math.max(0, targetIntervalRight);
    const clippedRightExpanded = Math.max(0, rightExpanded);
    const width = timelineWidth - clippedLeft - clippedRight;
    const widthExpanded = timelineWidth - clippedLeft - clippedRightExpanded;
    return {
        isLeftClipped: left !== clippedLeft,
        isRightClipped: right !== clippedRight,
        isRightExpandedClipped: rightExpanded !== clippedRightExpanded,
        left: clippedLeft,
        right: clippedRight,
        targetIntervalLeft: clippedTargetLeft,
        targetIntervalRight: clippedTargetRight,
        rightExpanded: clippedRightExpanded,
        width: width,
        widthExpanded: widthExpanded,
        intervalsPositions: intervalsPositions,
        intervals: intervals
    };
};
const $d04bc95426bb71dd$export$209e346bf640604 = (intervals, timelineDuration, timelineWidth)=>{
    const saneIntervals = $d04bc95426bb71dd$export$cd3d993a5aa1490e(intervals, timelineDuration);
    const intervalGroups = (0, $ch4pj.groupOverlappingIntervals)(saneIntervals);
    return intervalGroups.map((intervalGroup)=>$d04bc95426bb71dd$export$487a26b15ffb2465(intervalGroup, timelineDuration, timelineWidth));
};

});
parcelRegister("ch4pj", function(module, exports) {

$parcel$export(module.exports, "groupOverlappingIntervals", () => $7b2b723999ef6d54$export$1b45218c7b9e570f);
const $7b2b723999ef6d54$export$1b45218c7b9e570f = (intervals)=>{
    /* To read the diagram:
	 * - Each unique character represents an interval, where the start is the first character, and the end is the last character.
	 * - Intervals are ordered in the same way they appear in the input list.
	 * - Uppercase characters represent overlapping time, and lowercase characters represents overlapped time.
	 * - Each row, separated by (-), represents an interval grouping.
	 *
	 * |---------------------|
	 * |   A A A             |
	 * |---------------------|
	 * |   B B B B           |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 * |   D D               |
	 * |---------------------|
	 * | E E E               |
	 * |---------------------|
	 * |   F F               |
	 * |---------------------|
	 */ // remember original position in the list, because we'll need to sort again at the end
    const intervalsWithIndex = intervals.map((interval, index)=>({
            ...interval,
            index: index
        }));
    // First sort, as it will make the grouping logic a lot simpler.
    // Sprint with later end last; earlier sprint start last.
    const sortedIntervals = [
        ...intervalsWithIndex
    ].sort((interval, otherInterval)=>{
        const endComparison = interval.endDate - otherInterval.endDate;
        if (endComparison !== 0) return endComparison;
        return otherInterval.startDate - interval.startDate;
    });
    /* |---------------------|
	 * |   D D               |
	 * |---------------------|
	 * |   F F               |
	 * |---------------------|
	 * | E E E               |
	 * |---------------------|
	 * |   A A A             |
	 * |---------------------|
	 * |   B B B B           |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 */ let result = [];
    // Traverse through the list of sorted intervals in _reverse_ order.
    // Group together adjacent intervals that are _completely_ overlapped.
    let i = sortedIntervals.length - 1;
    while(i >= 0){
        const currentInterval = sortedIntervals[i];
        let groupedIntervals = [
            currentInterval
        ];
        let j = i - 1;
        while(j >= 0){
            const nextInterval = sortedIntervals[j];
            // Since intervals are sorted, then the currentInterval.end >= nextInterval.end
            const isNextIntervalCompletelyOverlapped = currentInterval.startDate <= nextInterval.startDate;
            if (isNextIntervalCompletelyOverlapped) groupedIntervals = [
                nextInterval
            ].concat(groupedIntervals);
            else break;
            j -= 1;
        }
        const groupedIntervalsInOriginalOrdering = groupedIntervals.sort((interval, otherInterval)=>interval.index - otherInterval.index).map(({ index: index, ...interval })=>interval);
        result = [
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                startDate: currentInterval.startDate,
                endDate: currentInterval.endDate,
                expandedEndDate: currentInterval.endDate,
                intervals: groupedIntervalsInOriginalOrdering
            }
        ].concat(result);
        i = j;
    }
    /* |---------------------|
	 * |               C C   |
	 * |---------------------|
	 * |   B B B B           |
	 * |   a a a             |
	 * |---------------------|
	 * | E E E               |
	 * |   f f               |
	 * |   d d               |
	 * |---------------------|
	 */ // We now "collapse" adjacent interval groups that overlap.
    // Later interval groups take precedence over earlier interval groups.
    if (result.length >= 2) for(let k = 0; k < result.length - 1; k += 1){
        const currentIntervalGroup = result[k];
        const nextIntervalGroup = result[k + 1];
        if (currentIntervalGroup.endDate > nextIntervalGroup.startDate) currentIntervalGroup.endDate = nextIntervalGroup.startDate;
    }
    /* |---------------------|
	 * | E e e               |
	 * |   f f               |
	 * |   d d               |
	 * |---------------------|
	 * |   B B B B           |
	 * |   a a a             |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 */ return result;
};

});




parcelRegister("90DIu", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b5f7de049459ce$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $16b5f7de049459ce$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    releases: {
        "id": "roadmap.timeline-table-kit.chart-header-item.key-dates.tooltip.releases",
        "defaultMessage": "{noOfReleases} {noOfReleases, plural, one {release} other {releases}}: {releaseNamesAndDates}"
    },
    popupLabel: {
        "id": "roadmap.timeline-table-kit.chart-header-item.key-dates.tooltip.popup-label",
        "defaultMessage": "Release info"
    }
});

});

parcelRegister("dJeqi", function(module, exports) {

$parcel$export(module.exports, "getReleaseNamesAndDatesAlly", () => $dcabeb91bc9e8407$export$e07503727219f77b);

var $lfgcv = parcelRequire("lfgcv");
const $dcabeb91bc9e8407$export$e07503727219f77b = (keyDates)=>keyDates.map(({ name: name, date: date })=>`${name} ${(0, $lfgcv.getDateFromTimestamp)(date)}`).join(', ');

});



parcelRegister("3SfLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbc8a0707c6d96aa$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cbc8a0707c6d96aa$var$VersionFlyout = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("1m2RA")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/chart-header-item/releases/flyout/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbc8a0707c6d96aa$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-version-flyout",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-standard-roadmap-version-flyout",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbc8a0707c6d96aa$var$VersionFlyout, props)));

});
parcelRegister("1m2RA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hUkdO").then(()=>parcelRequire('auxLX'));

});




parcelRegister("d6dd7", function(module, exports) {

$parcel$export(module.exports, "default", () => $df35b6a95bd00194$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kbyLF = parcelRequire("kbyLF");

var $h4d3O = parcelRequire("h4d3O");
const $df35b6a95bd00194$var$mapStateToProps = (state)=>({
        intervals: (0, $kbyLF.getSprintIntervals)(state)
    });
var $df35b6a95bd00194$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($df35b6a95bd00194$var$mapStateToProps, {})((0, $h4d3O.default));

});
parcelRegister("h4d3O", function(module, exports) {

$parcel$export(module.exports, "default", () => $67658a3e68cbb108$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dWgfm = parcelRequire("dWgfm");

var $7ZWzX = parcelRequire("7ZWzX");
const $67658a3e68cbb108$var$RoadmapIntervalsHeader = ({ intervals: intervals })=>{
    const renderPopupContent = (0, $eUqFw.useCallback)((selectedIntervals, setInitialFocusRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZWzX.default), {
            intervals: selectedIntervals,
            setInitialFocusRef: setInitialFocusRef
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWgfm.RoadmapIntervals), {
        intervals: intervals,
        renderPopupContent: renderPopupContent
    });
};
var $67658a3e68cbb108$export$2e2bcd8739ae039 = $67658a3e68cbb108$var$RoadmapIntervalsHeader;

});
parcelRegister("dWgfm", function(module, exports) {

$parcel$export(module.exports, "RoadmapIntervals", () => $c92d76740ab34ff8$export$daf5887cbbb59c3e);

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");


var $9j4Ay = parcelRequire("9j4Ay");

var $ZKzRT = parcelRequire("ZKzRT");

var $gkLWS = parcelRequire("gkLWS");
const $c92d76740ab34ff8$var$RoadmapIntervals = ({ intervals: intervals, renderPopupContent: renderPopupContent })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const intervalGroups = (0, $9j4Ay.getIntervalGroupPositions)(intervals, timelineDuration, timelineWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, intervalGroups.map((intervalGroup, index)=>{
        const hasOpenInterval = intervalGroup.intervals.some(({ state: state })=>state !== (0, $4a21b57a573cad8c$export$19c4f83398a8dbce));
        const Marker = hasOpenInterval ? (0, $ZKzRT.IntervalMarker) : (0, $gkLWS.IntervalBaseMarker);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Marker, {
            key: index,
            intervalGroup: intervalGroup,
            renderPopupContent: renderPopupContent
        });
    }));
};
$c92d76740ab34ff8$var$RoadmapIntervals.whyDidYouRender = true;
const $c92d76740ab34ff8$export$daf5887cbbb59c3e = /*#__PURE__*/ (0, $eUqFw.memo)($c92d76740ab34ff8$var$RoadmapIntervals);
$c92d76740ab34ff8$export$daf5887cbbb59c3e.displayName = 'RoadmapIntervals';

});
parcelRegister("ZKzRT", function(module, exports) {

$parcel$export(module.exports, "IntervalMarker", () => $f9777dd9635db4d9$export$2b396c8a14ed518e);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $hevaQ = parcelRequire("hevaQ");

var $gkLWS = parcelRequire("gkLWS");
/* This component wraps the base marker component.
 * It controls whether the marker should react to contextual state changes.
 * Closed intervals will never be highlighted. Thus, it doesn't need to react to contextual state changes.
 */ const $f9777dd9635db4d9$var$Marker = (props)=>{
    const { intervals: intervals } = props.intervalGroup;
    const [targetIntervalId] = (0, $hevaQ.useTargetIntervalId)(intervals);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gkLWS.IntervalBaseMarker), {
        targetIntervalId: targetIntervalId,
        ...props
    });
};
$f9777dd9635db4d9$var$Marker.whyDidYouRender = true;
const $f9777dd9635db4d9$export$2b396c8a14ed518e = /*#__PURE__*/ (0, $eUqFw.memo)($f9777dd9635db4d9$var$Marker);
$f9777dd9635db4d9$export$2b396c8a14ed518e.displayName = 'IntervalMarker';

});
parcelRegister("gkLWS", function(module, exports) {

$parcel$export(module.exports, "IntervalBaseMarker", () => $d2360af5f0d90697$export$11d6002c52c98162);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2KzVh = parcelRequire("2KzVh");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8hFGR = parcelRequire("8hFGR");

var $6TBpb = parcelRequire("6TBpb");

var $lqJW5 = parcelRequire("lqJW5");

var $75e8i = parcelRequire("75e8i");


var $8OTV8 = parcelRequire("8OTV8");

var $ksGD2 = parcelRequire("ksGD2");

var $hevaQ = parcelRequire("hevaQ");

var $gnAUm = parcelRequire("gnAUm");

var $3tlTx = parcelRequire("3tlTx");

var $lQ591 = parcelRequire("lQ591");

var $7TtsG = parcelRequire("7TtsG");

var $jaqYt = parcelRequire("jaqYt");
const $d2360af5f0d90697$var$EXPANDED_Z_INDEX = 1;
const $d2360af5f0d90697$var$expandStyles = (right, rightExpanded, isExpanded)=>null;
const $d2360af5f0d90697$var$expandableContentStyles = null;
const $d2360af5f0d90697$var$expandableContentStylesOld = null;
const $d2360af5f0d90697$var$BaseMarker = ({ targetIntervalId: targetIntervalId, intervalGroup: intervalGroup, renderPopupContent: renderPopupContent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, $6TBpb.useViewport)();
    const [isMouseEntered, setIsMouseEntered] = (0, $eUqFw.useState)(false);
    const [isPopupActive, setIsPopupActive] = (0, $eUqFw.useState)(false);
    const [{ isHeaderModalActive: isHeaderModalActive }] = (0, $hevaQ.useIsHeaderModalActive)();
    const { shouldPreventNavigation: shouldPreventNavigation } = (0, $8hFGR.useFocusMarshal)();
    const openPopup = (0, $eUqFw.useCallback)(()=>{
        shouldPreventNavigation(true);
        setIsPopupActive(true);
    }, [
        shouldPreventNavigation
    ]);
    const closePopup = (0, $eUqFw.useCallback)(()=>{
        shouldPreventNavigation(false);
        setIsPopupActive(false);
    }, [
        shouldPreventNavigation
    ]); // Listen to user event scrolling the timeline table => Hide the popup on each time its been scrolled
    (0, $eUqFw.useEffect)(()=>{
        const onViewPortScrollHandler = ()=>{
            if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) closePopup();
            else setIsPopupActive(false);
        };
        listenToViewportScroll(onViewPortScrollHandler);
        return function cleanup() {
            stopListeningToViewportScroll(onViewPortScrollHandler);
        };
    }, [
        closePopup,
        listenToViewportScroll,
        stopListeningToViewportScroll
    ]);
    const { left: left, right: right, rightExpanded: rightExpanded, intervals: intervals } = intervalGroup;
    const isExpandable = right !== rightExpanded;
    const isHighlighted = targetIntervalId !== undefined;
    const isExpanded = isExpandable && (isMouseEntered || isHighlighted);
    const { colors: colors, borders: borders, spacing: spacing, childVisibility: childVisibility } = (0, $jaqYt.getDynamicMarkerStyles)({
        intervalGroup: intervalGroup,
        isExpanded: isExpanded,
        isExpandable: isExpandable,
        isHighlighted: isHighlighted
    });
    const { isLabelVisible: isLabelVisible, isExpandIndicatorVisible: isExpandIndicatorVisible } = childVisibility;
    const label = (0, $7TtsG.getLabel)({
        intervals: intervals,
        targetIntervalId: targetIntervalId,
        isLabelVisible: isLabelVisible
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)(); // ================= //
    // === CALLBACKS === //
    // ================= //
    const onMouseEnter = ()=>{
        if (!isPopupActive) setIsMouseEntered(true);
    };
    const onMouseLeave = ()=>{
        if (!isPopupActive) setIsMouseEntered(false);
    };
    const onClickContainer = (0, $eUqFw.useCallback)((event)=>{
        (0, $75e8i.default)('timeline-interval-marker-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'intervalsMarker', {
            numberOfMarker: intervals.length
        });
        if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) openPopup();
        else setIsPopupActive(true);
    }, [
        createAnalyticsEvent,
        intervals.length,
        openPopup
    ]);
    const handleKeyDown = (event)=>{
        if ((0, $lqJW5.isEnterOrSpaceKey)(event)) {
            event.preventDefault();
            if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) openPopup();
            else setIsPopupActive(true);
        }
    }; // ============== //
    // === RENDER === //
    // ============== //
    const renderMarker = ({ ref: triggerRef, ...restTriggerProps }, tooltipProps)=>{
        const { ref: tooltipRef, onFocus: onFocus, onBlur: onBlur, onClick: onClick, ...restTooltipProps } = tooltipProps ?? {};
        const handleOnFocus = (event)=>{
            onMouseEnter();
            onFocus?.(event);
        };
        const handleOnBlur = (event)=>{
            onMouseLeave();
            onBlur?.(event);
        };
        const handleOnClick = (event)=>{
            onClickContainer(event);
            onClick?.(event);
        };
        if (!isExpandable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            ...restTriggerProps,
            ...restTooltipProps,
            ref: tooltipRef ? (0, $2KzVh.mergeRefs)(triggerRef, tooltipRef) : triggerRef,
            role: "button",
            "aria-label": `${formatMessage((0, $3tlTx.default).sprintsCountLabel, {
                sprintsCount: intervals.length
            })} ${(0, $7TtsG.getSprintAriaLabel)(intervals, formatMessage)}`,
            style: {
                color: colors.color,
                backgroundColor: colors.backgroundColor,
                border: borders.border ?? 'none',
                borderRadius: borders.borderRadius,
                padding: spacing.padding,
                margin: spacing.margin,
                left: `${left}px`,
                right: `${right}px`
            },
            tabIndex: 0,
            "data-testid": "roadmap.timeline-table-kit.ui.chart-header-item.intervals.marker.content",
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            onClick: handleOnClick,
            onKeyDown: handleKeyDown,
            className: (0, $7JEyt.default)([
                "_kqswstnw _vchhusvi _4t3i7vkz _1ul9v77o _y3gn1h6o _11c81vlj _vwz4utpp _k48pmoej _80omtlke",
                "_1reo15vq _18m915vq _o5721q9c _1bto1l2s"
            ])
        }, label);
         // Temporary fix on issue where compiled/css doesn't work using "keyframes" inside props.style but only for `css` utility function (been reported as bug in #help-compiled previously)
        const animationStyles = null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ...restTriggerProps,
            ...restTooltipProps,
            ref: tooltipRef ? (0, $2KzVh.mergeRefs)(triggerRef, tooltipRef) : triggerRef,
            role: "button",
            "aria-label": `${formatMessage((0, $3tlTx.default).sprintsCountLabel, {
                sprintsCount: intervals.length
            })} ${(0, $7TtsG.getSprintAriaLabel)(intervals, formatMessage)}`,
            tabIndex: 0,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            onClick: handleOnClick,
            onKeyDown: handleKeyDown,
            className: (0, $7JEyt.default)([
                "_1e0c1txw",
                "_kqswstnw _vchhusvi _4t3i7vkz _1ul9v77o _y3gn1h6o _11c81vlj _vwz4utpp _k48pmoej _80omtlke",
                !(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-sprint-lozenge-styling') && "",
                !(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-sprint-lozenge-styling') && "_y44vebu4",
                "_v5644td3"
            ]),
            style: {
                left: `${left}px`,
                right: `${isExpanded ? rightExpanded : right}px`,
                zIndex: isExpanded ? $d2360af5f0d90697$var$EXPANDED_Z_INDEX : 'auto',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-sprint-lozenge-styling') ? {
                    margin: spacing.margin
                } : {},
                "--_1urkg9g": (0, $9t7rW.default)(isExpanded ? right : rightExpanded, "px"),
                "--_1k6byw": (0, $9t7rW.default)(isExpanded ? rightExpanded : right, "px")
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": "roadmap.timeline-table-kit.ui.chart-header-item.intervals.marker.content",
            className: (0, $7JEyt.default)([
                "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
                isExpanded && (0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-sprint-lozenge-styling') && "_16qs1nfl",
                !(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-sprint-lozenge-styling') && "_1dbz1k6l"
            ]),
            style: {
                color: colors.color,
                backgroundColor: colors.backgroundColor,
                border: borders.border ?? 'none',
                borderRadius: borders.borderRadius,
                padding: spacing.padding,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-sprint-lozenge-styling') ? {} : {
                    margin: spacing.margin
                },
                width: isExpandIndicatorVisible ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `calc(100% - ${0, $4a5f481703991dee$export$62467065a148cd06}px)` : '100%',
                "--_pu77ur": (0, $9t7rW.default)((0, $8OTV8.HEADER_BACKGROUND_COLOR)),
                "--_6xet41": (0, $9t7rW.default)((0, $8OTV8.HEADER_BACKGROUND_COLOR_OLD))
            }
        }, label), isExpandIndicatorVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gnAUm.ExpandableIndicator), {
            backgroundColor: colors.backgroundColor
        }));
    };
    /**
   * Callback to render the user selected interval flyout popup content
   */ const renderSelectedIntervalPopupContent = (0, $eUqFw.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>renderPopupContent(intervals, setInitialFocusRef), [
        intervals,
        renderPopupContent
    ]);
    const renderPopupTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQ591.IntervalsTooltip), {
            intervals: intervals
        }, (tooltipProps)=>renderMarker(triggerProps, tooltipProps));
    const onClosePopup = ()=>{
        if (!isHeaderModalActive) {
            if (isMouseEntered) setIsMouseEntered(false);
            if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) closePopup();
            else setIsPopupActive(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isPopupActive,
        onClose: onClosePopup,
        placement: "bottom-start",
        content: renderSelectedIntervalPopupContent,
        trigger: renderPopupTrigger,
        zIndex: (0, $ksGD2.OVERLAY_FLYOUT_Z_INDEX),
        autoFocus: false,
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-sprint-lozenge-styling') ? {
            role: 'dialog',
            label: formatMessage((0, $3tlTx.default).popupLabel)
        } : {}
    });
};
const $d2360af5f0d90697$export$11d6002c52c98162 = /*#__PURE__*/ (0, $eUqFw.memo)($d2360af5f0d90697$var$BaseMarker);
const $d2360af5f0d90697$var$baseContainerStyles = null;
const $d2360af5f0d90697$var$overflowStyles = null;
const $d2360af5f0d90697$var$expandedContainerStyles = null;
const $d2360af5f0d90697$var$transitionStyles = null;

});
const $4a5f481703991dee$export$62467065a148cd06 = 8;
const $4a5f481703991dee$export$462ae417bcee39bd = 2;
const $4a5f481703991dee$export$e2bd4c1faded7921 = 2;

parcelRegister("8OTV8", function(module, exports) {

$parcel$export(module.exports, "HEADER_BACKGROUND_COLOR_OLD", () => $ae9af783e318ec5a$export$ee74f9ad87ce9c8e);
$parcel$export(module.exports, "HEADER_BACKGROUND_COLOR", () => $ae9af783e318ec5a$export$cff61b214d368dd4);

const $ae9af783e318ec5a$export$ee74f9ad87ce9c8e = `var(--ds-surface-sunken, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`; // TODO: fix token https://hello.atlassian.net/wiki/spaces/ADOS/pages/1511543981/Dark+Mode+Mismatched+Colors+on+Roadmaps+issue+epic-color
const $ae9af783e318ec5a$export$cff61b214d368dd4 = `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;

});

parcelRegister("gnAUm", function(module, exports) {

$parcel$export(module.exports, "ExpandableIndicator", () => $4e7595a8667fa4b8$export$2c9bdfe109ea2701);

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

const $4e7595a8667fa4b8$var$POLYGON_COORDINATES = `0,0 ${(0, $4a5f481703991dee$export$62467065a148cd06) - (0, $4a5f481703991dee$export$462ae417bcee39bd)},${(0, $gf0vG.HEADER_CONTENT_HEIGHT) / 2} 0,${(0, $gf0vG.HEADER_CONTENT_HEIGHT)}`;
const $4e7595a8667fa4b8$export$2c9bdfe109ea2701 = ({ backgroundColor: backgroundColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: (0, $4a5f481703991dee$export$62467065a148cd06),
        height: (0, $gf0vG.HEADER_CONTENT_HEIGHT),
        style: {
            // @ts-expect-error([Part of upgrade 4.9-5.4]) - Object literal may only specify known properties, and '[`${'--icon-primary-color'}`]' does not exist in type 'Properties<number | (string & {}), string & {}>'.
            [`${'--icon-primary-color'}`]: backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: 'var(--icon-primary-color)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        points: $4e7595a8667fa4b8$var$POLYGON_COORDINATES
    })));

});

parcelRegister("3tlTx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd43b8fa2b19e4b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cd43b8fa2b19e4b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sprintsCountLabel: {
        "id": "roadmap.timeline-table-kit.chart-header-item.intervals.marker.sprints-count-label",
        "defaultMessage": "{sprintsCount} {sprintsCount, plural, one {sprint} other {sprints}}."
    },
    popupLabel: {
        "id": "roadmap.timeline-table-kit.chart-header-item.intervals.marker.popup-label",
        "defaultMessage": "Sprint info"
    }
});

});

parcelRegister("lQ591", function(module, exports) {

$parcel$export(module.exports, "IntervalsTooltip", () => $3b3e66e21293e95a$export$d653b20e86abaaf3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");

var $lfgcv = parcelRequire("lfgcv");

var $fkfMB = parcelRequire("fkfMB");

var $fRzLJ = parcelRequire("fRzLJ");
const $3b3e66e21293e95a$var$tagStyles = null;
const $3b3e66e21293e95a$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        ...props,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz"
        ])
    }));
const $3b3e66e21293e95a$export$d653b20e86abaaf3 = ({ intervals: intervals, children: children })=>{
    const renderTooltipContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, intervals.map(({ name: name, startDate: startDate, endDate: endDate }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkfMB.TooltipInterval), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRzLJ.SprintIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkfMB.ContentName), null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkfMB.ContentDateLabel), null, `
                        (${(0, $lfgcv.getDateFromTimestamp)(startDate)} - ${(0, $lfgcv.getDateFromTimestamp)(endDate)})
                    `))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        hideTooltipOnClick: true,
        tag: $3b3e66e21293e95a$var$TooltipTag,
        content: renderTooltipContent()
    }, typeof children === 'function' ? ({ 'aria-describedby': ariaDescribedby, ...tooltipProps })=>children(tooltipProps) : children);
};

});
parcelRegister("fRzLJ", function(module, exports) {

$parcel$export(module.exports, "SprintIcon", () => $e6b11f88cabe053a$export$8c2ca4d5c7ca94da);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hpJ8O = parcelRequire("hpJ8O");

var $5JgJ2 = parcelRequire("5JgJ2");

var $0l6OE = parcelRequire("0l6OE");
const $e6b11f88cabe053a$var$getIconSize = (iconSize)=>iconSize === 'small' ? 16 : 24;
const $e6b11f88cabe053a$var$wrapperStyles = null;
const $e6b11f88cabe053a$export$8c2ca4d5c7ca94da = ({ size: size })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            height: `${$e6b11f88cabe053a$var$getIconSize(size)}px`,
            width: `${$e6b11f88cabe053a$var$getIconSize(size)}px`
        },
        className: (0, $7JEyt.default)([
            "_2hwxv77o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hpJ8O))), {
        label: formatMessage((0, $0l6OE.default).sprintLabel),
        spacing: size === 'medium' ? 'spacious' : 'none',
        color: "currentColor",
        LEGACY_size: size
    }));
};
$e6b11f88cabe053a$export$8c2ca4d5c7ca94da.defaultProps = {
    size: 'small'
};

});
parcelRegister("hpJ8O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53acb4f80ce65157170d94e433cfd888>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cad7c98e94f34db6$var$_react = $cad7c98e94f34db6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cad7c98e94f34db6$var$_sprint = $cad7c98e94f34db6$var$_interopRequireDefault((parcelRequire("8TYIE")));

var $cad7c98e94f34db6$var$_sprint2 = $cad7c98e94f34db6$var$_interopRequireDefault((parcelRequire("gk7tF")));
function $cad7c98e94f34db6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SprintIcon.
 * This component is SprintIcon, with `UNSAFE_fallbackIcon` set to "SprintIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cad7c98e94f34db6$var$SprintIcon = (props)=>/*#__PURE__*/ $cad7c98e94f34db6$var$_react.default.createElement($cad7c98e94f34db6$var$_sprint.default, Object.assign({
        LEGACY_fallbackIcon: $cad7c98e94f34db6$var$_sprint2.default
    }, props));
$cad7c98e94f34db6$var$SprintIcon.Name = 'SprintIconMigration';
var $cad7c98e94f34db6$var$_default = module.exports.default = $cad7c98e94f34db6$var$SprintIcon;

});
parcelRegister("8TYIE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ac782676a50cd4df56827dce883b620>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b28f597116f9a1$var$_react = $67b28f597116f9a1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $67b28f597116f9a1$var$_UNSAFE_baseNew = $67b28f597116f9a1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $67b28f597116f9a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b28f597116f9a1$var$SprintIcon = (props)=>/*#__PURE__*/ $67b28f597116f9a1$var$_react.default.createElement($67b28f597116f9a1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
    }, props));
$67b28f597116f9a1$var$SprintIcon.displayName = 'SprintIcon';
var $67b28f597116f9a1$var$_default = module.exports.default = $67b28f597116f9a1$var$SprintIcon;

});

parcelRegister("gk7tF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be245075b7e5aee7$var$_react = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $be245075b7e5aee7$var$_sprint = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("8TYIE")));
function $be245075b7e5aee7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be245075b7e5aee7$var$SprintIcon = (props)=>/*#__PURE__*/ $be245075b7e5aee7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $be245075b7e5aee7$var$_sprint.default
    }));
$be245075b7e5aee7$var$SprintIcon.displayName = 'SprintIcon';
var $be245075b7e5aee7$var$_default = module.exports.default = $be245075b7e5aee7$var$SprintIcon;

});


parcelRegister("0l6OE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b0717b646608dc5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $5b0717b646608dc5$var$messages = (0, $90IgZ.defineMessages)({
    sprintLabel: {
        "id": "roadmap.timeline-table-kit.common.sprint-icon.sprint-label",
        "defaultMessage": "Sprint"
    }
});
var $5b0717b646608dc5$export$2e2bcd8739ae039 = $5b0717b646608dc5$var$messages;

});



parcelRegister("7TtsG", function(module, exports) {

$parcel$export(module.exports, "getLabel", () => $a8daa6183dd2359f$export$236350842f3cd9bc);
$parcel$export(module.exports, "getSprintAriaLabel", () => $a8daa6183dd2359f$export$c5109b68d3576dad);

var $lfgcv = parcelRequire("lfgcv");

var $29gy2 = parcelRequire("29gy2");
const $a8daa6183dd2359f$export$236350842f3cd9bc = ({ intervals: intervals, targetIntervalId: targetIntervalId, isLabelVisible: isLabelVisible })=>{
    if (!isLabelVisible) return null;
    if (targetIntervalId !== undefined) {
        const interval = intervals.find(({ id: id })=>id === targetIntervalId);
        return interval ? interval.name : null;
    }
    return intervals.map(({ name: name })=>name).join(', ');
};
const $a8daa6183dd2359f$export$c5109b68d3576dad = (intervals, formatMessage)=>intervals.map(({ name: name, startDate: startDate, endDate: endDate })=>formatMessage((0, $29gy2.default).sprintLabel, {
            name: name,
            startDate: (0, $lfgcv.getDateFromTimestamp)(startDate),
            endDate: (0, $lfgcv.getDateFromTimestamp)(endDate)
        })).join(', ');

});
parcelRegister("29gy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d8dd6afad49e26d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9d8dd6afad49e26d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sprintLabel: {
        "id": "roadmap.timeline-table-kit.chart-header-item.intervals.marker.utils.sprint-label",
        "defaultMessage": "{name} (from {startDate} to {endDate})"
    }
});

});


parcelRegister("jaqYt", function(module, exports) {

$parcel$export(module.exports, "getDynamicMarkerStyles", () => $9f694653711efefd$export$52788c6efbc3355a);

var $c9TLT = parcelRequire("c9TLT");



var $iDUYl = parcelRequire("iDUYl");
const $9f694653711efefd$export$b0916a2042ea04de = ({ width: width, isExpanded: isExpanded, isExpandable: isExpandable })=>{
    const isSpaceToRenderExpandIndicator = width >= 2 * (0, $4a5f481703991dee$export$62467065a148cd06);
    const isExpandIndicatorVisible = isExpandable && !isExpanded && isSpaceToRenderExpandIndicator;
    const availableLabelWidth = width - (isExpandIndicatorVisible ? (0, $4a5f481703991dee$export$62467065a148cd06) : 0);
    const isLabelVisible = availableLabelWidth >= (0, $iDUYl.APPROX_WIDTH_OF_SINGLE_CHARACTER_AND_ELLIPSIS);
    return {
        isLabelVisible: isLabelVisible,
        isExpandIndicatorVisible: isExpandIndicatorVisible
    };
};
const $9f694653711efefd$export$706101aacf0f1ff0 = ({ intervals: intervals, isHighlighted: isHighlighted })=>{
    if (isHighlighted) return 0, $iDUYl.HIGHLIGHTED_COLORS;
    if (intervals.some(({ state: state })=>state === (0, $4a21b57a573cad8c$export$2b35adb71b3f6143))) return (0, $iDUYl.MARKER_COLORS_BY_STATUS)[0, $4a21b57a573cad8c$export$2b35adb71b3f6143];
    if (intervals.some(({ state: state })=>state === (0, $4a21b57a573cad8c$export$47b7b82714c61a7c))) return (0, $iDUYl.MARKER_COLORS_BY_STATUS)[0, $4a21b57a573cad8c$export$47b7b82714c61a7c];
    return (0, $iDUYl.MARKER_COLORS_BY_STATUS)[0, $4a21b57a573cad8c$export$19c4f83398a8dbce];
};
const $9f694653711efefd$export$929cde73ea66c204 = ({ isHighlighted: isHighlighted, isLeftClipped: isLeftClipped, isRightClipped: isRightClipped })=>{
    const leftRadius = isLeftClipped ? 0 : (0, $c9TLT.borderRadius);
    const rightRadius = isRightClipped ? 0 : (0, $c9TLT.borderRadius);
    return {
        borderRadius: `${leftRadius}px ${rightRadius}px ${rightRadius}px ${leftRadius}px`,
        border: isHighlighted ? (0, $iDUYl.HIGHLIGHTED_BORDER) : 'none'
    };
};
const $9f694653711efefd$export$f63796f8a9382bfb = ({ width: width, isExpanded: isExpanded, isHighlighted: isHighlighted, isRightClipped: isRightClipped, isLabelVisible: isLabelVisible, isExpandIndicatorVisible: isExpandIndicatorVisible })=>{
    // Margins provide a gap between markers where there would otherwise be none
    const leftMargin = (0, $4a5f481703991dee$export$462ae417bcee39bd) / 2;
    const rightMargin = isRightClipped ? 0 : leftMargin;
    const margin = `0px ${rightMargin}px 0px ${leftMargin}px`;
    // Only show padding if the bar is wide enough to fit it
    const leftPadding = width > (0, $iDUYl.MIN_CONTENT_SIZE) ? (0, $iDUYl.DEFAULT_HORIZONTAL_PADDING) : 0;
    const rightPadding = leftPadding + (isExpanded ? (0, $4a5f481703991dee$export$462ae417bcee39bd) : 0);
    const topPadding = isHighlighted ? 0 : 2;
    if (!isLabelVisible || !isHighlighted) return {
        padding: `${topPadding}px ${rightPadding}px 0px ${leftPadding}px`,
        margin: margin
    };
    // Adjust for borders to keep text centred
    const rightPaddingWithOffset = leftPadding - (isExpandIndicatorVisible ? 0 : (0, $4a5f481703991dee$export$e2bd4c1faded7921));
    const leftPaddingWithOffset = leftPadding - (0, $4a5f481703991dee$export$e2bd4c1faded7921);
    return {
        padding: `${topPadding}px ${rightPaddingWithOffset}px 0px ${leftPaddingWithOffset}px`,
        margin: margin
    };
};
const $9f694653711efefd$export$52788c6efbc3355a = ({ intervalGroup: intervalGroup, isExpanded: isExpanded, isExpandable: isExpandable, isHighlighted: isHighlighted })=>{
    const { intervals: intervals, isLeftClipped: isLeftClipped } = intervalGroup;
    const width = isExpanded ? intervalGroup.widthExpanded : intervalGroup.width;
    const childVisibility = $9f694653711efefd$export$b0916a2042ea04de({
        width: width,
        isExpanded: isExpanded,
        isExpandable: isExpandable
    });
    // Flatten the right side of marker to meet at the edge of the indicator when it is visible
    const isRightClipped = intervalGroup.isRightClipped || childVisibility.isExpandIndicatorVisible;
    return {
        colors: $9f694653711efefd$export$706101aacf0f1ff0({
            intervals: intervals,
            isHighlighted: isHighlighted
        }),
        borders: $9f694653711efefd$export$929cde73ea66c204({
            isHighlighted: isHighlighted,
            isLeftClipped: isLeftClipped,
            isRightClipped: isRightClipped
        }),
        spacing: $9f694653711efefd$export$f63796f8a9382bfb({
            width: width,
            isExpanded: isExpanded,
            isHighlighted: isHighlighted,
            isRightClipped: isRightClipped,
            ...childVisibility
        }),
        childVisibility: childVisibility
    };
};

});
parcelRegister("iDUYl", function(module, exports) {

$parcel$export(module.exports, "APPROX_WIDTH_OF_SINGLE_CHARACTER_AND_ELLIPSIS", () => $57c94f9ece579356$export$35b03b828551403c);
$parcel$export(module.exports, "DEFAULT_HORIZONTAL_PADDING", () => $57c94f9ece579356$export$382aa5aaf1386a15);
$parcel$export(module.exports, "MIN_CONTENT_SIZE", () => $57c94f9ece579356$export$26fd56593e380ecc);
$parcel$export(module.exports, "HIGHLIGHTED_BORDER", () => $57c94f9ece579356$export$99f67a6c4bd713c0);
$parcel$export(module.exports, "HIGHLIGHTED_COLORS", () => $57c94f9ece579356$export$aa263ebd4566c172);
$parcel$export(module.exports, "MARKER_COLORS_BY_STATUS", () => $57c94f9ece579356$export$2dadfa510748a1b5);



const $57c94f9ece579356$export$35b03b828551403c = 30;
const $57c94f9ece579356$export$382aa5aaf1386a15 = 4;
const $57c94f9ece579356$export$26fd56593e380ecc = 2 * $57c94f9ece579356$export$382aa5aaf1386a15 + 2 * (0, $4a5f481703991dee$export$e2bd4c1faded7921);
const $57c94f9ece579356$export$99f67a6c4bd713c0 = `${(0, $4a5f481703991dee$export$e2bd4c1faded7921)}px solid ${`var(--ds-icon-brand, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`;
const $57c94f9ece579356$export$aa263ebd4566c172 = {
    color: `var(--ds-text-brand, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`
};
const $57c94f9ece579356$export$2dadfa510748a1b5 = {
    [(0, $4a21b57a573cad8c$export$2b35adb71b3f6143)]: {
        color: `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
        backgroundColor: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`
    },
    [(0, $4a21b57a573cad8c$export$47b7b82714c61a7c)]: {
        color: `var(--ds-text-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`
    },
    [(0, $4a21b57a573cad8c$export$19c4f83398a8dbce)]: {
        color: `var(--ds-text-accent-gray, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
        backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    }
};

});





parcelRegister("7ZWzX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a24916addd771a28$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a24916addd771a28$var$SprintFlyout = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("j7Heq")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/chart-header-item/sprints/flyout/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a24916addd771a28$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-sprint-flyout",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-standard-roadmap-sprint-flyout",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a24916addd771a28$var$SprintFlyout, props)));

});
parcelRegister("j7Heq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5DKLk").then(()=>parcelRequire('f9sKF'));

});





parcelRegister("83k2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d17bc2691ffd8b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $lNNXV = parcelRequire("lNNXV");

var $kbiEp = parcelRequire("kbiEp");



var $hT84n = parcelRequire("hT84n");

var $j45xj = parcelRequire("j45xj");

var $9DoTe = parcelRequire("9DoTe");

var $kbyLF = parcelRequire("kbyLF");

var $1SuDz = parcelRequire("1SuDz");

var $htXdF = parcelRequire("htXdF");

var $3rBmf = parcelRequire("3rBmf");

var $ls0VL = parcelRequire("ls0VL");
const $a8d17bc2691ffd8b$var$mapDispatchToProps = (dispatch)=>({
        onUpdate: (id, { dates: dates, meta: meta, intervalId: intervalId }, event, hasOverdueReleaseDate)=>{
            dispatch((0, $j45xj.updateAndPersistIssue)(id, intervalId !== undefined ? {
                sprintId: intervalId
            } : {
                ...dates
            }, event, {
                isDragged: !!meta?.isDragged,
                hasOverdueReleaseDate: hasOverdueReleaseDate
            }));
        },
        onLeftClick: (id, { level: level, withCmd: withCmd, withShift: withShift }, analyticsEvent)=>{
            if ((0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) return;
            dispatch((0, $htXdF.selectItems)({
                id: id,
                level: level,
                withCmd: withCmd,
                withShift: withShift
            }, analyticsEvent));
        },
        onRightClick: (id, position)=>{
            dispatch((0, $htXdF.showToolTip)({
                id: id,
                type: (0, $aba7cf5b5acfd3bc$export$a9487b0be9740846),
                position: position
            }));
        }
    });
const $a8d17bc2691ffd8b$var$mergeProps = (stateProps, dispatchProps, { id: id, isHovered: isHovered })=>({
        ...stateProps,
        ...dispatchProps,
        isHovered: isHovered,
        id: id.toString()
    });
const $a8d17bc2691ffd8b$var$DndLongTaskMetric = ({ level: level, isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hT84n.DragAndDropLongTaskMetric), {
        isDragging: isDragging,
        metricType: (0, $028d5637f56fe710$export$2475592765cae5b0),
        extraProps: {
            isBaseLevel: (0, $kbiEp.isBaseLevel)(level)
        }
    });
var $a8d17bc2691ffd8b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, { id: id })=>{
    const chartData = (0, $1SuDz.getChartDataHash)(state)[id];
    return {
        ...chartData,
        intervals: (0, $kbyLF.getSprintIntervals)(state),
        isReadOnly: !(0, $9DoTe.getCanUserEdit)(state),
        renderBarContent: $3rBmf.renderBarContent,
        DndLongTaskMetric: $a8d17bc2691ffd8b$var$DndLongTaskMetric
    };
}, $a8d17bc2691ffd8b$var$mapDispatchToProps, $a8d17bc2691ffd8b$var$mergeProps)((0, $ls0VL.default));

});
const $aba7cf5b5acfd3bc$export$4b680a32bbb87a28 = 'DEPENDENCIES_FLYOUT';
const $aba7cf5b5acfd3bc$export$a9487b0be9740846 = 'CONTEXT_MENU';

parcelRegister("3rBmf", function(module, exports) {

$parcel$export(module.exports, "renderBarContent", () => $9b3e387320e41edb$export$2c88996aa786b971);

var $eUqFw = parcelRequire("eUqFw");

var $2sNQW = parcelRequire("2sNQW");

var $e3AcU = parcelRequire("e3AcU");

var $13Vbb = parcelRequire("13Vbb");

var $bSlr9 = parcelRequire("bSlr9");
const $9b3e387320e41edb$export$2c88996aa786b971 = (barContentProps, barContentState)=>{
    const barContentRenderers = {
        renderBarIcon: ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $13Vbb.default), {
                id: id
            }),
        renderDependencyHandler: (props, state)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSlr9.default), {
                ...props,
                ...state
            }),
        renderDateLabel: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sNQW.RoadmapDateLabels), props)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e3AcU.RoadmapBarContent), {
        ...barContentProps,
        ...barContentState,
        ...barContentRenderers
    });
};

});
parcelRegister("2sNQW", function(module, exports) {

$parcel$export(module.exports, "RoadmapDateLabels", () => $9b4da58cc8a3c9de$export$b6e3ec15be9e500e);

var $eUqFw = parcelRequire("eUqFw");

var $4P2VV = parcelRequire("4P2VV");

var $fHtBB = parcelRequire("fHtBB");

var $7E8Bd = parcelRequire("7E8Bd");

var $1B9M2 = parcelRequire("1B9M2");

var $RvPFT = parcelRequire("RvPFT");

var $6iHFH = parcelRequire("6iHFH");
/* For the purpose of displaying the dates, the interaction context is important.
 * - If a date would be hidden by the viewport on one side, we attempt to display it on the other side
 * - All dates are considered explicit while dragging, as any inferred dates will be replaced after the interaction
 * - Only show the date that is being updated.
 */ const $9b4da58cc8a3c9de$export$b6e3ec15be9e500e = ({ prevStartDate: prevStartDate, prevDueDate: prevDueDate, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, dragType: dragType, getBarBoundingClientRect: getBarBoundingClientRect })=>{
    const displayStartDateType = dragType === (0, $4P2VV.LEFT) || dragType === (0, $4P2VV.LEFT_AND_RIGHT) ? (0, $fHtBB.EXPLICIT) : startDateType;
    const displayDueDateType = dragType === (0, $4P2VV.RIGHT) || dragType === (0, $4P2VV.LEFT_AND_RIGHT) ? (0, $fHtBB.EXPLICIT) : dueDateType;
    const displayPrevStartDate = dragType !== (0, $4P2VV.RIGHT) ? prevStartDate : undefined;
    const displayPrevDueDate = dragType !== (0, $4P2VV.LEFT) ? prevDueDate : undefined;
    const displayStartDate = dragType !== (0, $4P2VV.RIGHT) ? startDate : undefined;
    const displayDueDate = dragType !== (0, $4P2VV.LEFT) ? dueDate : undefined;
    const isDurationVisible = !placeholder;
    const placement = (0, $6iHFH.useDatePlacement)({
        dragType: dragType,
        startDateType: displayStartDateType,
        dueDateType: displayDueDateType,
        placeholder: placeholder,
        isDurationVisible: isDurationVisible,
        getBarBoundingClientRect: getBarBoundingClientRect
    });
    const renderDuration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1B9M2.Duration), (0, $RvPFT.getDurationProps)(displayPrevStartDate, displayPrevDueDate, displayStartDate, displayDueDate, dragType, startDate, dueDate));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7E8Bd.FormattedDate), {
        placement: placement,
        startDate: displayStartDate,
        dueDate: displayDueDate,
        startDateType: displayStartDateType,
        dueDateType: displayDueDateType,
        placeholder: placeholder,
        isDurationVisible: isDurationVisible,
        renderDuration: renderDuration
    });
};
$9b4da58cc8a3c9de$export$b6e3ec15be9e500e.defaultProps = {
    startDateType: (0, $fHtBB.EXPLICIT),
    dueDateType: (0, $fHtBB.EXPLICIT)
};

});
parcelRegister("7E8Bd", function(module, exports) {

$parcel$export(module.exports, "FormattedDate", () => $52e07480f3bfdb54$export$40ae3194919d16b);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lfgcv = parcelRequire("lfgcv");

var $4P2VV = parcelRequire("4P2VV");

var $fHtBB = parcelRequire("fHtBB");

var $cERyr = parcelRequire("cERyr");

var $1B9M2 = parcelRequire("1B9M2");

var $8i5Uy = parcelRequire("8i5Uy");

var $etu0n = parcelRequire("etu0n");
/* Combines timestamps into a human readable label that changes based upon the date type (see props).
 * - If a date is not provided it will *not* be rendered.
 * - By providing a placement, the dates will be rendered absolute to either side of their nearest relative ancestor.
 */ const $52e07480f3bfdb54$export$40ae3194919d16b = ({ startDate: startDate, dueDate: dueDate, startDateType: startDateType = (0, $fHtBB.EXPLICIT), dueDateType: dueDateType = (0, $fHtBB.EXPLICIT), placeholder: placeholder, isDurationVisible: isDurationVisible = false, placement: placement, renderDuration: renderDuration })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const startDatePlaceholderMessage = (0, $cERyr.isStartDatePlaceholder)(placeholder) ? formatMessage((0, $etu0n.default).noStartDate) : undefined;
    const dueDatePlaceholderMessage = (0, $cERyr.isDueDatePlaceholder)(placeholder) ? formatMessage((0, $etu0n.default).noDueDate) : undefined; // === RENDER === //
    const renderDurationLabel = (shouldRender = true)=>{
        const isDurationValid = startDate !== undefined || dueDate !== undefined;
        return isDurationVisible && isDurationValid && shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' ', renderDuration ? renderDuration() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1B9M2.Duration), {
            fromDate: startDate ?? 0,
            toDate: dueDate ?? 0
        })) : null;
    };
    const renderDate = (dateType, date, placeholderMessage)=>{
        if (date === undefined) return null;
        const DateContainer = (0, $8i5Uy.DATE_CONTAINER_LOOKUP)[dateType];
        const DateIcon = (0, $8i5Uy.DATE_ICON_LOOKUP)[dateType];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DateIcon, null), placeholderMessage ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DateContainer, null, (0, $lfgcv.getDateFromTimestamp)(date)));
    };
    if (placement === (0, $4P2VV.LEFT_AND_RIGHT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
            "_kqswstnw",
            "_1xi21osq _u5f3u2gc",
            "notranslate"
        ])
    }, renderDate(startDateType, startDate, startDatePlaceholderMessage), renderDurationLabel(startDate !== undefined && dueDate === undefined)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small" // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
            "_kqswstnw",
            "_1ltv1osq _19bvu2gc",
            "notranslate"
        ])
    }, renderDate(dueDateType, dueDate, dueDatePlaceholderMessage), renderDurationLabel(dueDate !== undefined)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
        "data-testid": "roadmap.timeline-table-kit.common.ui.formatted-date.formatted-date" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        ,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
            placement && "_kqswstnw",
            placement === (0, $4P2VV.LEFT) && "_1xi21osq _u5f3u2gc",
            placement === (0, $4P2VV.RIGHT) && "_1ltv1osq _19bvu2gc",
            "notranslate"
        ])
    }, renderDate(startDateType, startDate, startDatePlaceholderMessage), startDate !== undefined && dueDate !== undefined && ' - ', renderDate(dueDateType, dueDate, dueDatePlaceholderMessage), renderDurationLabel());
};
const $52e07480f3bfdb54$var$placemenetLeftStyles = null;
const $52e07480f3bfdb54$var$placemenetRightStyles = null;
const $52e07480f3bfdb54$var$defaultPlacementStyles = null;
const $52e07480f3bfdb54$var$outerContainerStyles = null;

});
parcelRegister("1B9M2", function(module, exports) {

$parcel$export(module.exports, "Duration", () => $d1fbd509c0742160$export$3b11bc38611c5941);

var $eUqFw = parcelRequire("eUqFw");

var $1Rj2M = parcelRequire("1Rj2M");

var $RvPFT = parcelRequire("RvPFT");
const $d1fbd509c0742160$export$3b11bc38611c5941 = ({ fromDate: fromDate, toDate: toDate, isSigned: isSigned, isToDateExcluded: isToDateExcluded })=>{
    const sign = toDate < fromDate ? '-' : '+';
    const duration = (0, $RvPFT.getDaysInBetween)(fromDate, toDate, isToDateExcluded);
    return duration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Rj2M.default), {
        duration: duration,
        sign: isSigned ? sign : undefined
    }) : null;
};
$d1fbd509c0742160$export$3b11bc38611c5941.defaultProps = {
    isSigned: false,
    isToDateExcluded: false
};

});
parcelRegister("1Rj2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c9db1f9748c4f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2LgCb = parcelRequire("2LgCb");
const $a1c9db1f9748c4f6$var$DurationBadge = ({ duration: duration, sign: sign })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return duration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, formatMessage((0, $2LgCb.default).duration, {
        duration: `${sign ?? ''}${duration}`
    })) : null;
};
var $a1c9db1f9748c4f6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a1c9db1f9748c4f6$var$DurationBadge);

});
parcelRegister("2LgCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cdd44f95ef063a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $35cdd44f95ef063a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    duration: {
        "id": "roadmap.timeline-table-kit.common.date-labels.duration.duration",
        "defaultMessage": "{duration}d"
    }
});

});


parcelRegister("RvPFT", function(module, exports) {

$parcel$export(module.exports, "getDaysInBetween", () => $9bb911c33738d184$export$ae6ef52daacfecd3);
$parcel$export(module.exports, "getDurationProps", () => $9bb911c33738d184$export$100189a9c6d8b999);

const $9bb911c33738d184$export$ae6ef52daacfecd3 = (fromDate, toDate, isToDateExcluded = false)=>Math.round(Math.abs(fromDate - toDate) / (0, $4975412c8fcbfa24$export$1f04624003d2da7d)) + (isToDateExcluded ? 0 : 1);
const $9bb911c33738d184$export$100189a9c6d8b999 = (prevStartDate, prevDueDate, startDate, dueDate, dragType, currentStartDate, currentDueDate)=>{
    // Show duration on hover if no dragging or dragging entire bar
    if (dragType === undefined || dragType === 'LEFT_AND_RIGHT') return {
        fromDate: currentStartDate,
        toDate: currentDueDate,
        isSigned: false,
        isToDateExcluded: false
    };
    const isDurationDiff = prevStartDate !== undefined && prevDueDate !== undefined && startDate !== undefined && dueDate !== undefined;
    const isStartDateFixed = prevDueDate !== undefined && startDate === undefined && dueDate !== undefined;
    const isDueDateFixed = prevStartDate !== undefined && startDate !== undefined && dueDate === undefined;
    const isDurationMeta = prevStartDate === undefined && prevDueDate === undefined && startDate !== undefined && dueDate !== undefined;
    if (isDurationDiff || isStartDateFixed) return {
        fromDate: prevDueDate,
        toDate: dueDate,
        isSigned: true,
        isToDateExcluded: true
    };
    if (isDueDateFixed) return {
        fromDate: startDate,
        toDate: prevStartDate,
        isSigned: true,
        isToDateExcluded: true
    };
    if (isDurationMeta) return {
        fromDate: startDate,
        toDate: dueDate,
        isSigned: false,
        isToDateExcluded: false
    };
    return {
        fromDate: startDate ?? 0,
        toDate: dueDate ?? 0,
        isSigned: false,
        isToDateExcluded: false
    };
};

});


parcelRegister("8i5Uy", function(module, exports) {

$parcel$export(module.exports, "DATE_ICON_LOOKUP", () => $9bd6902d7174b387$export$b6abe4b9e409dfb2);
$parcel$export(module.exports, "DATE_CONTAINER_LOOKUP", () => $9bd6902d7174b387$export$f3b594588fe8a99e);

var $eUqFw = parcelRequire("eUqFw");

var $fHtBB = parcelRequire("fHtBB");

var $2jWeb = parcelRequire("2jWeb");

var $fRzLJ = parcelRequire("fRzLJ");
const $9bd6902d7174b387$export$b6abe4b9e409dfb2 = {
    [(0, $fHtBB.EXPLICIT)]: (0, $eUqFw.Fragment),
    [(0, $fHtBB.ROLLUP)]: (0, $2jWeb.RollupIcon),
    [(0, $fHtBB.INTERVAL)]: (0, $fRzLJ.SprintIcon)
};
const $9bd6902d7174b387$export$f3b594588fe8a99e = {
    [(0, $fHtBB.EXPLICIT)]: (0, $eUqFw.Fragment),
    [(0, $fHtBB.ROLLUP)]: 'i',
    [(0, $fHtBB.INTERVAL)]: 'i'
};

});
parcelRegister("2jWeb", function(module, exports) {

$parcel$export(module.exports, "RollupIcon", () => $2bb69f1e183ce4ea$export$a33e84c97d0c570c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2ziLQ = parcelRequire("2ziLQ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2S19W = parcelRequire("2S19W");
const $2bb69f1e183ce4ea$var$getRollupIconGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "currentColor",
        d: "M14.586 11l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 13H10a1 1 0 0 0-1 1v7a1 1 0 0 1-2 0v-7a3 3 0 0 1 3-3h4.586z"
    }));
const $2bb69f1e183ce4ea$export$a33e84c97d0c570c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2bb69f1e183ce4ea$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $2bb69f1e183ce4ea$var$getRollupIconGlyph,
        label: formatMessage((0, $2S19W.default).rollUpIconLabel),
        size: "small"
    }));
};
const $2bb69f1e183ce4ea$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3igktf _1bsb7vkz _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2S19W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b6b7044658c652$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $c6b6b7044658c652$var$messages = (0, $90IgZ.defineMessages)({
    rollUpIconLabel: {
        "id": "roadmap.timeline-table-kit.common.rollup-icon.roll-up-icon-label",
        "defaultMessage": "Roll-up"
    }
});
var $c6b6b7044658c652$export$2e2bcd8739ae039 = $c6b6b7044658c652$var$messages;

});



parcelRegister("etu0n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c9056b40d9e646a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c9056b40d9e646a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noStartDate: {
        "id": "roadmap.timeline-table-kit.common.formatted-date.no-start-date",
        "defaultMessage": "No start date"
    },
    noDueDate: {
        "id": "roadmap.timeline-table-kit.common.formatted-date.no-due-date",
        "defaultMessage": "No due date"
    }
});

});


parcelRegister("6iHFH", function(module, exports) {

$parcel$export(module.exports, "useDatePlacement", () => $f6bfa6f4b70ce4d9$export$469d58375b7706b3);

var $6TBpb = parcelRequire("6TBpb");

var $4P2VV = parcelRequire("4P2VV");

var $k6sGo = parcelRequire("k6sGo");
const $f6bfa6f4b70ce4d9$export$469d58375b7706b3 = ({ dragType: dragType, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType, isDurationVisible: isDurationVisible, getBarBoundingClientRect: getBarBoundingClientRect })=>{
    const { requestViewportBoundingClient: requestViewportBoundingClient } = (0, $6TBpb.useViewport)();
    const rect = getBarBoundingClientRect();
    if (!rect) return 0, $4P2VV.LEFT_AND_RIGHT;
    const { isStartDateVisible: isStartDateVisible, isDueDateVisible: isDueDateVisible } = (0, $k6sGo.calculateDateVisibilities)(rect, requestViewportBoundingClient(), placeholder, startDateType, dueDateType, isDurationVisible);
    return (0, $k6sGo.getDatePlacement)(dragType, isStartDateVisible, isDueDateVisible);
};

});
parcelRegister("k6sGo", function(module, exports) {

$parcel$export(module.exports, "calculateDateVisibilities", () => $2071d5efb1937894$export$883141a0ed8178c0);
$parcel$export(module.exports, "getDatePlacement", () => $2071d5efb1937894$export$af34474977f1fefb);

var $4P2VV = parcelRequire("4P2VV");

var $fHtBB = parcelRequire("fHtBB");

var $cERyr = parcelRequire("cERyr");
const $2071d5efb1937894$var$APPROX_DATE_PIXELS = 85;
const $2071d5efb1937894$var$APPROX_PLACEHOLDER_PIXELS = 98;
const $2071d5efb1937894$var$APPROX_ICON_PIXELS = 20;
const $2071d5efb1937894$var$APPOX_DURATION_PIXELS = 33;
const $2071d5efb1937894$var$add = (accumulator, nextValue)=>accumulator + nextValue;
const $2071d5efb1937894$export$883141a0ed8178c0 = (barRect, viewportRect, placeholder, startDateType, dueDateType, isDurationVisible)=>{
    const { left: barLeft, right: barRight } = barRect;
    const { left: viewportLeft, right: viewportRight } = viewportRect;
    const availableLeftSpace = barLeft - viewportLeft;
    const availableRightSpace = viewportRight - barRight;
    const hasStartDateIcon = startDateType !== (0, $fHtBB.EXPLICIT);
    const hasDueDateIcon = dueDateType !== (0, $fHtBB.EXPLICIT);
    const spaceRequiredLeft = [
        (0, $cERyr.isStartDatePlaceholder)(placeholder) ? $2071d5efb1937894$var$APPROX_PLACEHOLDER_PIXELS : $2071d5efb1937894$var$APPROX_DATE_PIXELS,
        hasStartDateIcon ? $2071d5efb1937894$var$APPROX_ICON_PIXELS : 0
    ];
    const spaceRequiredRight = [
        (0, $cERyr.isDueDatePlaceholder)(placeholder) ? $2071d5efb1937894$var$APPROX_PLACEHOLDER_PIXELS : $2071d5efb1937894$var$APPROX_DATE_PIXELS,
        hasDueDateIcon ? $2071d5efb1937894$var$APPROX_ICON_PIXELS : 0,
        isDurationVisible ? $2071d5efb1937894$var$APPOX_DURATION_PIXELS : 0
    ];
    return {
        isStartDateVisible: spaceRequiredLeft.reduce($2071d5efb1937894$var$add, 0) <= availableLeftSpace,
        isDueDateVisible: spaceRequiredRight.reduce($2071d5efb1937894$var$add, 0) <= availableRightSpace
    };
};
const $2071d5efb1937894$export$af34474977f1fefb = (dragType, isStartDateVisible, isDueDateVisible)=>{
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT) || isStartDateVisible && isDueDateVisible || !isStartDateVisible && !isDueDateVisible) return 0, $4P2VV.LEFT_AND_RIGHT;
    return isStartDateVisible ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
};

});



parcelRegister("e3AcU", function(module, exports) {

$parcel$export(module.exports, "RoadmapBarContent", () => $9c0c7cb98a402b2d$export$6ad7b40eb111e24e);

var $eUqFw = parcelRequire("eUqFw");

var $4P2VV = parcelRequire("4P2VV");
const $9c0c7cb98a402b2d$export$6ad7b40eb111e24e = ({ id: id, dragType: dragType, leftPosition: leftPosition, rightPosition: rightPosition, prevStartDate: prevStartDate, prevDueDate: prevDueDate, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, isActive: isActive, isReadOnly: isReadOnly, isMinimumBar: isMinimumBar, renderBarIcon: renderBarIcon, renderDateLabel: renderDateLabel, renderDependencyHandler: renderDependencyHandler, onBarMouseLeave: onBarMouseLeave, getBarBoundingClientRect: getBarBoundingClientRect })=>{
    const isHovered = isActive && !dragType;
    const isDraggingExplicit = isActive && dragType !== undefined;
    const isDragging = dragType !== undefined;
    const getRenderDependencyHandler = ()=>!isDragging && !isReadOnly && renderDependencyHandler({
            id: id,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            placeholder: placeholder,
            getBarBoundingClientRect: getBarBoundingClientRect,
            onBarMouseLeave: onBarMouseLeave
        }, {
            isHovered: isHovered
        });
    const getRenderDateLabel = ()=>isDraggingExplicit || isHovered ? renderDateLabel({
            prevStartDate: prevStartDate,
            prevDueDate: prevDueDate,
            startDate: startDate,
            dueDate: dueDate,
            startDateType: startDateType,
            dueDateType: dueDateType,
            placeholder: placeholder,
            getBarBoundingClientRect: getBarBoundingClientRect,
            dragType: dragType
        }) : null;
    const getRenderBarIcon = ()=>!isMinimumBar && !isDraggingExplicit && renderBarIcon({
            id: id,
            leftPosition: leftPosition,
            rightPosition: rightPosition
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, getRenderDependencyHandler(), getRenderDateLabel(), getRenderBarIcon());
};
$9c0c7cb98a402b2d$export$6ad7b40eb111e24e.defaultProps = {
    renderBarIcon: (0, $4P2VV.DEFAULT_RENDERER),
    renderDateLabel: (0, $4P2VV.DEFAULT_RENDERER),
    renderDependencyHandler: (0, $4P2VV.DEFAULT_RENDERER)
};

});

parcelRegister("13Vbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ec6b002552f0c87$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eI5EY = parcelRequire("eI5EY");

var $lNNXV = parcelRequire("lNNXV");

var $kbiEp = parcelRequire("kbiEp");


var $6FeJk = parcelRequire("6FeJk");

var $eQTUe = parcelRequire("eQTUe");

var $9E22T = parcelRequire("9E22T");

var $htXdF = parcelRequire("htXdF");

var $2oL51 = parcelRequire("2oL51");
const $9ec6b002552f0c87$var$EMPTY_ARRAY = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9ec6b002552f0c87$var$mapDispatchToProps = (dispatch, { id: id })=>({
        onClickIcon: (fromIds, toIds, position, triggerRef)=>{
            dispatch((0, $htXdF.showToolTip)({
                id: id,
                type: (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28),
                links: {
                    fromIds: fromIds,
                    toIds: toIds
                },
                position: position,
                showImplicitDependency: true,
                ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? {
                    triggerRef: triggerRef
                } : {}
            }));
        }
    });
const $9ec6b002552f0c87$var$mergeProps = (stateProps, dispatchProps)=>({
        ...stateProps,
        ...dispatchProps
    });
var $9ec6b002552f0c87$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, { id: id })=>{
    const issueId = id;
    const level = (0, $6FeJk.getIssueLevel)(state, issueId);
    const implicitDependencyItems = !(0, $kbiEp.isBaseLevel)(level) ? (0, $eQTUe.getImplicitDependencyItemsForIssue)(state, issueId) || $9ec6b002552f0c87$var$EMPTY_ARRAY : $9ec6b002552f0c87$var$EMPTY_ARRAY;
    return {
        dependencies: (0, $9E22T.getIssueDependencies)(state, issueId) || $9ec6b002552f0c87$var$EMPTY_ARRAY,
        dependees: (0, $9E22T.getIssueDependees)(state, issueId) || $9ec6b002552f0c87$var$EMPTY_ARRAY,
        level: level,
        hasImplicitDependency: implicitDependencyItems.length > 0
    };
}, $9ec6b002552f0c87$var$mapDispatchToProps, $9ec6b002552f0c87$var$mergeProps)((0, $2oL51.default));

});
parcelRegister("eQTUe", function(module, exports) {

$parcel$export(module.exports, "getDependenciesTooltipParams", () => $5f286f88525ce8b6$export$9b579a6f4b6af263);
$parcel$export(module.exports, "getSelectedDependency", () => $5f286f88525ce8b6$export$aff715abe5e6e33c);
$parcel$export(module.exports, "getImplicitDependencyItemsForIssue", () => $5f286f88525ce8b6$export$ead33b6fc6be1605);
$parcel$export(module.exports, "getDependenciesItems", () => $5f286f88525ce8b6$export$675e7796a0dd4b1e);
$parcel$export(module.exports, "getDependencyItem", () => $5f286f88525ce8b6$export$71656e1e0a89c318);
$parcel$export(module.exports, "getDependencyItems", () => $5f286f88525ce8b6$export$d372e74aefbd38cf);

var $df4Sl = parcelRequire("df4Sl");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $11LHz = parcelRequire("11LHz");

var $9ZLrP = parcelRequire("9ZLrP");

var $9E22T = parcelRequire("9E22T");

var $kbyLF = parcelRequire("kbyLF");

var $1SuDz = parcelRequire("1SuDz");

var $as0qD = parcelRequire("as0qD");

var $fTkuC = parcelRequire("fTkuC");

var $2H5sX = parcelRequire("2H5sX");
const $5f286f88525ce8b6$var$EMPTY_DEPENDENCY = [];
const $5f286f88525ce8b6$var$getIssueAttributeHashes = (0, $df4Sl.createStructuredSelector)({
    issueSummaryHash: (0, $6FeJk.getIssueSummaryHash),
    issueTypeIdHash: (0, $6FeJk.getIssueTypeIdHash),
    issueDueDateHash: (0, $6FeJk.getIssueDueDateHash),
    issueStartDateHash: (0, $6FeJk.getIssueStartDateHash),
    issueKeyHash: (0, $6FeJk.getIssueKeyHash),
    issueParentIdHash: (0, $6FeJk.getIssueParentIdHash)
});
const $5f286f88525ce8b6$export$12d5a003c51154a3 = (0, $df4Sl.createSelector)((0, $6FeJk.getIssueIds), (0, $9E22T.getFilteredIssueIdsHash), $5f286f88525ce8b6$var$getIssueAttributeHashes, (0, $bwVWW.getFullIssueTypeHash), (0, $kbyLF.getSanitisedIssueSprintsHash), (0, $bwVWW.getIsSprintsPlanningEnabled), (0, $bwVWW.getIsChildIssuePlanningEnabled), (0, $fTkuC.getParentRolledUpDatesHash), (0, $9ZLrP.isDependenciesVisible), (issueIds, filteredIssueIdHash, { issueSummaryHash: issueSummaryHash, issueTypeIdHash: issueTypeIdHash, issueDueDateHash: issueDueDateHash, issueStartDateHash: issueStartDateHash, issueKeyHash: issueKeyHash, issueParentIdHash: issueParentIdHash }, fullIssueTypes, issueSprintsHash, isSprintsPlanning, isChildIssuePlanningEnabled, parentRolledUpDatesHash, isDependenciesVisibleValue)=>(0, $2H5sX.getIssueAttributesHashPure)(issueIds, filteredIssueIdHash, issueSummaryHash, issueTypeIdHash, fullIssueTypes, issueDueDateHash, issueStartDateHash, issueKeyHash, issueParentIdHash, issueSprintsHash, isSprintsPlanning, isChildIssuePlanningEnabled, parentRolledUpDatesHash, isDependenciesVisibleValue));
const $5f286f88525ce8b6$export$8d602178215eb1a8 = (state, issueId)=>$5f286f88525ce8b6$export$12d5a003c51154a3(state)[issueId];
const $5f286f88525ce8b6$export$9b579a6f4b6af263 = (0, $df4Sl.createSelector)((0, $11LHz.getTooltipParams), (0, $6FeJk.getIssueDependenciesHash), (0, $6FeJk.getIssueDependeesHash), (0, $2H5sX.getDependenciesTooltipParamsPure));
const $5f286f88525ce8b6$export$aff715abe5e6e33c = (0, $df4Sl.createSelector)((0, $11LHz.getTooltipParams), (0, $6FeJk.getIssueDependeesHash), (0, $2H5sX.getSelectedDependencyPure));
const $5f286f88525ce8b6$export$7627e0a994fa9128 = (0, $df4Sl.createSelector)((0, $9E22T.getFilteredIssueIds), (0, $6FeJk.getIssueParentIdHash), (0, $11LHz.getExpandedItems), (0, $9E22T.getFilteredIssueDependenciesHash), (0, $9E22T.getFilteredIssueDependeesHash), $5f286f88525ce8b6$export$12d5a003c51154a3, (0, $bwVWW.getIsChildIssuePlanningEnabled), (0, $2H5sX.getImplicitDependencyItemsHashPure));
const $5f286f88525ce8b6$export$ead33b6fc6be1605 = (state, issueId)=>$5f286f88525ce8b6$export$7627e0a994fa9128(state)[issueId] || $5f286f88525ce8b6$var$EMPTY_DEPENDENCY;
const $5f286f88525ce8b6$export$675e7796a0dd4b1e = (0, $df4Sl.createSelector)((0, $as0qD.getChartItemTopPositionHash), (0, $1SuDz.getChartDataHash), (0, $6FeJk.getIssueDependenciesHash), (0, $bwVWW.getEpicIssueTypeIds), (0, $6FeJk.getIssueTypeIdHash), (0, $1SuDz.getItemHeight), (0, $2H5sX.getDependenciesItemsPure));
const $5f286f88525ce8b6$export$71656e1e0a89c318 = (state, issueId)=>$5f286f88525ce8b6$export$8d602178215eb1a8(state, issueId);
const $5f286f88525ce8b6$export$d372e74aefbd38cf = (state, issueIds)=>issueIds.flatMap((issueId)=>$5f286f88525ce8b6$export$71656e1e0a89c318(state, issueId) || $5f286f88525ce8b6$var$EMPTY_DEPENDENCY);

});
parcelRegister("as0qD", function(module, exports) {

$parcel$export(module.exports, "getChartItemTopPositionHash", () => $0fd94b40598799e0$export$f2a9f880d7b1b487);

var $df4Sl = parcelRequire("df4Sl");

var $11LHz = parcelRequire("11LHz");

var $9E22T = parcelRequire("9E22T");

var $bkuyl = parcelRequire("bkuyl");

var $1SuDz = parcelRequire("1SuDz");
const $0fd94b40598799e0$export$f2a9f880d7b1b487 = (0, $df4Sl.createSelector)((0, $1SuDz.getTableHeaderItemsHeight), (0, $1SuDz.getItemHeight), (0, $9E22T.getFilteredNonBaseLevelIssueIds), (0, $9E22T.getFilteredChildIssueIdsHash), (0, $11LHz.getExpandedItems), (0, $11LHz.getCreateItemAnchor), (0, $bkuyl.getItemOffsetPositions));

});

parcelRegister("2H5sX", function(module, exports) {

$parcel$export(module.exports, "getIssueAttributesHashPure", () => $e8a93487a29dfbc3$export$29174164fa2c98c2);
$parcel$export(module.exports, "getSelectedDependencyPure", () => $e8a93487a29dfbc3$export$67519885927894ef);
$parcel$export(module.exports, "getDependenciesTooltipParamsPure", () => $e8a93487a29dfbc3$export$a0f4289e45235721);
$parcel$export(module.exports, "getImplicitDependencyItemsHashPure", () => $e8a93487a29dfbc3$export$db7646447e16ed5d);
$parcel$export(module.exports, "getDependenciesItemsPure", () => $e8a93487a29dfbc3$export$d1d736cec8b87807);

var $eI5EY = parcelRequire("eI5EY");

var $c3IKH = parcelRequire("c3IKH");


var $gf0vG = parcelRequire("gf0vG");

var $9e32r = parcelRequire("9e32r");

var $hVoYF = parcelRequire("hVoYF");

var $jdmzs = parcelRequire("jdmzs");
const $e8a93487a29dfbc3$var$getWarningMessage = (isHiddenByView, isHidden)=>{
    const warningMessages = [];
    if (isHiddenByView) {
        warningMessages.push((0, $jdmzs.default).hiddenByViewsConfigurationWarning);
        return warningMessages;
    }
    if (isHidden) {
        warningMessages.push((0, $jdmzs.default).hiddenByFilterWarning);
        return warningMessages;
    }
    return warningMessages;
};
// Exclude inferred placeholder dates
const $e8a93487a29dfbc3$var$getDateData = ({ startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder })=>({
        startDate: placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER) ? undefined : startDate,
        dueDate: placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER) ? undefined : dueDate,
        startDateType: startDateType,
        dueDateType: dueDateType
    });
const $e8a93487a29dfbc3$export$29174164fa2c98c2 = (issueIds, filteredIssueIdHash, issueSummaries, issueTypes, fullIssueTypes, issueDueDates, issueStartDates, issueKeyHash, parentIdHash, issueSprintsHash, isSprintsPlanning, isChildIssuePlanningEnabled, parentRolledUpDatesHash, isDependenciesVisible)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attributesHash = {};
    issueIds.forEach((issueId)=>{
        const isVisible = filteredIssueIdHash[issueId] ?? false;
        const issueType = fullIssueTypes[issueTypes[issueId]];
        const parentId = parentIdHash[issueId];
        const isChildIssue = parentId !== undefined;
        const startDate = issueStartDates[issueId];
        const dueDate = issueDueDates[issueId];
        if (!isChildIssue) {
            // parent item
            const parentDateData = $e8a93487a29dfbc3$var$getDateData((0, $hVoYF.getParentLevelDates)(startDate, dueDate, parentRolledUpDatesHash[issueId], isChildIssuePlanningEnabled));
            attributesHash[`${issueId}`] = {
                id: issueId,
                itemKey: issueKeyHash[issueId],
                title: issueSummaries[issueId],
                typeName: issueType ? issueType.name : '',
                iconUrl: issueType ? issueType.iconUrl : '',
                isHidden: !isVisible,
                warningMessages: $e8a93487a29dfbc3$var$getWarningMessage(!isDependenciesVisible, !isVisible),
                parent: undefined,
                intervalName: undefined,
                startDate: parentDateData.startDate,
                dueDate: parentDateData.dueDate,
                startDateType: parentDateData.startDateType,
                dueDateType: parentDateData.dueDateType
            };
        } else {
            // child item
            const childDateData = $e8a93487a29dfbc3$var$getDateData((0, $hVoYF.getBaseLevelDates)(startDate, dueDate, issueSprintsHash[issueId], isSprintsPlanning, isChildIssuePlanningEnabled));
            const parent = parentId && issueTypes[parentId] ? {
                iconUrl: fullIssueTypes[issueTypes[parentId]].iconUrl,
                title: issueSummaries[parentId]
            } : undefined;
            const sprintName = parentId !== undefined && isSprintsPlanning ? (0, $9e32r.getSprintNameForBaseLevelIssue)(issueId, issueSprintsHash) : undefined;
            attributesHash[`${issueId}`] = {
                id: issueId,
                itemKey: issueKeyHash[issueId],
                title: issueSummaries[issueId],
                typeName: issueType ? issueType.name : '',
                iconUrl: issueType ? issueType.iconUrl : '',
                isHidden: !isVisible,
                warningMessages: $e8a93487a29dfbc3$var$getWarningMessage(!isDependenciesVisible, !isVisible),
                parent: parent,
                intervalName: sprintName,
                startDate: childDateData.startDate,
                dueDate: childDateData.dueDate,
                startDateType: childDateData.startDateType,
                dueDateType: childDateData.dueDateType
            };
        }
    });
    return attributesHash;
};
const $e8a93487a29dfbc3$export$67519885927894ef = (tooltipParams, dependeesHash)=>{
    if (tooltipParams && tooltipParams.type === (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28)) {
        const { id: id, links: { toIds: toIds } } = tooltipParams;
        const toId = toIds.find((dependee)=>dependeesHash[id] && dependeesHash[id].includes(dependee));
        if (toId !== undefined) return {
            fromId: id,
            toId: toId
        };
    }
    return undefined;
};
const $e8a93487a29dfbc3$export$a0f4289e45235721 = (tooltipParams, dependenciesHash, dependeesHash)=>{
    if (tooltipParams && tooltipParams.type === (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28)) {
        const { id: id, position: position, links: { fromIds: fromIds, toIds: toIds }, showImplicitDependency: showImplicitDependency } = tooltipParams;
        const filteredDependencies = fromIds.filter((dependency)=>dependenciesHash[id] && dependenciesHash[id].includes(dependency));
        const filteredDependees = toIds.filter((dependee)=>dependeesHash[id] && dependeesHash[id].includes(dependee));
        return {
            position: position,
            issueId: id,
            type: tooltipParams.type,
            dependencies: filteredDependencies,
            dependees: filteredDependees,
            showImplicitDependency: showImplicitDependency,
            ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? {
                triggerRef: tooltipParams.triggerRef
            } : {}
        };
    }
    return undefined;
};
const $e8a93487a29dfbc3$export$db7646447e16ed5d = (issueIds, issueParentIdHash, expandedItems, filteredIssueDependencies, filteredIssueDependees, attributesHash, isChildIssuePlanningEnabled)=>{
    const implicitDependencyItems = {};
    isChildIssuePlanningEnabled && issueIds.forEach((issueId)=>{
        const parentId = issueParentIdHash[issueId];
        const isChildIssue = parentId !== undefined;
        const isParentIssueCollapsed = Boolean(parentId && !expandedItems[parentId]);
        if (isChildIssue && isParentIssueCollapsed) {
            const dependencies = filteredIssueDependencies[issueId]?.map((id)=>attributesHash[id]) ?? [];
            const dependees = filteredIssueDependees[issueId]?.map((id)=>attributesHash[id]) ?? [];
            if (dependencies.length > 0 || dependees.length > 0) {
                const item = attributesHash[issueId];
                if (parentId) {
                    if (implicitDependencyItems[parentId] === undefined) implicitDependencyItems[parentId] = [];
                    implicitDependencyItems[parentId].push({
                        item: item,
                        dependencies: dependencies,
                        dependees: dependees
                    });
                }
            }
        }
    });
    return implicitDependencyItems;
};
const $e8a93487a29dfbc3$export$d1d736cec8b87807 = (positionsHash, itemsHash, dependenciesHash, epicIssueTypeIds, issueTypeIdHash, defaultItemHeight)=>{
    const dependencies = [];
    Object.keys(dependenciesHash).forEach((issueId)=>{
        const blockedIssueId = issueId;
        const issueDependencies = dependenciesHash[blockedIssueId];
        if (itemsHash[blockedIssueId] && positionsHash[blockedIssueId] !== undefined) {
            const blockedItem = itemsHash[blockedIssueId];
            const blockedItemStartDate = blockedItem.startDate;
            if (blockedItemStartDate !== undefined) {
                const to = {
                    id: blockedIssueId,
                    startDate: blockedItemStartDate,
                    y: positionsHash[blockedIssueId],
                    color: blockedItem.color
                };
                issueDependencies.forEach((blockerIssueId)=>{
                    if (itemsHash[blockerIssueId] && positionsHash[blockerIssueId] !== undefined) {
                        const blockerItem = itemsHash[blockerIssueId];
                        const blockerItemDueDate = blockerItem.dueDate;
                        if (blockerItemDueDate !== undefined) {
                            const itemHeight = !epicIssueTypeIds.includes(issueTypeIdHash[blockedIssueId]) || !epicIssueTypeIds.includes(issueTypeIdHash[blockerIssueId]) ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : defaultItemHeight;
                            dependencies.push({
                                itemHeight: itemHeight,
                                from: {
                                    id: blockerIssueId,
                                    dueDate: blockerItemDueDate,
                                    y: positionsHash[blockerIssueId],
                                    color: blockerItem.color
                                },
                                to: to
                            });
                        }
                    }
                });
            }
        }
    });
    return dependencies;
};

});
parcelRegister("9e32r", function(module, exports) {

$parcel$export(module.exports, "getSprintNameForBaseLevelIssue", () => $b1f9a998f21c7ede$export$bb3e998d749b9888);
const $b1f9a998f21c7ede$export$bb3e998d749b9888 = (issueId, issueSprintsHash)=>{
    const issueSprints = issueSprintsHash[issueId];
    if (issueSprints.length > 0) {
        const recentSprint = issueSprints[0];
        return recentSprint?.name;
    }
    return undefined;
};

});

parcelRegister("jdmzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c77e74742a82570$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4c77e74742a82570$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    hiddenByFilterWarning: {
        "id": "roadmap.standard-roadmap.state.selectors.dependencies.hidden-by-filter-warning",
        "defaultMessage": "Hidden by filter"
    },
    hiddenByViewsConfigurationWarning: {
        "id": "roadmap.standard-roadmap.state.selectors.dependencies.hidden-by-views-configuration-warning",
        "defaultMessage": "Hidden by \"Views\" dropdown"
    }
});

});



parcelRegister("2oL51", function(module, exports) {

$parcel$export(module.exports, "default", () => $aef7818ee862b017$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $fKdC1 = parcelRequire("fKdC1");

var $8hFGR = parcelRequire("8hFGR");
const $aef7818ee862b017$var$BarIcon = ({ level: level, dependencies: dependencies, dependees: dependees, hasImplicitDependency: hasImplicitDependency, onClickIcon: onClickIcon })=>{
    const { shouldPreventNavigation: shouldPreventNavigation } = (0, $8hFGR.useFocusMarshal)();
    const triggerRef = (0, $eUqFw.useRef)(null);
    const onClick = (0, $eUqFw.useCallback)((position)=>{
        if ((0, $eI5EY.fg)('timeline_grid_navigation_m2')) shouldPreventNavigation(true);
        if ((0, $eI5EY.fg)('jsw_roadmaps_timeline-dependency-flyout-refocus')) onClickIcon(dependencies, dependees, position, triggerRef);
        else onClickIcon(dependencies, dependees, position);
    }, [
        shouldPreventNavigation,
        onClickIcon,
        dependencies,
        dependees
    ]);
    if (dependencies.length === 0 && dependees.length === 0 && !hasImplicitDependency) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fKdC1.RoadmapBarIcon), {
        level: level,
        onClick: onClick,
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? {
            ref: triggerRef
        } : {}
    });
};
var $aef7818ee862b017$export$2e2bcd8739ae039 = $aef7818ee862b017$var$BarIcon;

});
parcelRegister("fKdC1", function(module, exports) {

$parcel$export(module.exports, "RoadmapBarIcon", () => $d28fdf4c1cbf56b2$export$31f28142b8ae6fe0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jaTu3 = parcelRequire("jaTu3");

var $fBftA = parcelRequire("fBftA");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4q38b = parcelRequire("4q38b");

var $2eG9N = parcelRequire("2eG9N");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lqJW5 = parcelRequire("lqJW5");

var $75e8i = parcelRequire("75e8i");

var $hHcrs = parcelRequire("hHcrs");
const $d28fdf4c1cbf56b2$export$31f28142b8ae6fe0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ level: level, onClick: onClick }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleEvent = (0, $eUqFw.useCallback)(({ timeStamp: timeStamp, target: target })=>{
        (0, $75e8i.default)('timeline-dependency-clicked', timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'icon'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyIcon', {
            level: level
        });
        const { top: top, left: left, width: width } = target.getBoundingClientRect();
        const position = {
            y: top + width,
            x: left
        };
        onClick(position);
    }, [
        onClick,
        level,
        createAnalyticsEvent
    ]);
    const onClickCallback = (0, $eUqFw.useCallback)((event)=>{
        handleEvent({
            timeStamp: event.timeStamp,
            target: event.currentTarget
        });
    }, [
        handleEvent
    ]);
    const onKeyDownCallback = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $lqJW5.isEnterOrSpaceKey)(event)) {
            event.preventDefault();
            handleEvent({
                timeStamp: event.timeStamp,
                target: event.currentTarget
            });
        }
    }, [
        handleEvent
    ]);
    const CustomToolTipTag = (0, $eUqFw.useMemo)(()=>// FIXME: Chronos should fix this by extracting the forwarded component
        /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, tooltipRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ...props,
                ref: (0, $eI5EY.fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $jaTu3.mergeRefs)([
                    ref,
                    tooltipRef
                ]) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                tooltipRef,
                onClick: onClickCallback,
                role: "button",
                onKeyDown: onKeyDownCallback,
                tabIndex: 0,
                "aria-label": formatMessage((0, $hHcrs.default).viewDetail),
                className: (0, $7JEyt.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbv47k _4t3iv47k _2hwx1b66 _2rko1ssb _1pbyegat _80omtlke _p7r11txw _irr31fly"
                ])
            })), [
        ref,
        onClickCallback,
        onKeyDownCallback,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        tag: CustomToolTipTag,
        position: "top",
        content: formatMessage((0, $hHcrs.default).viewDetail)
    }, colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d28fdf4c1cbf56b2$var$opacityStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
        label: "",
        color: "var(--ds-text-inverse, #FFFFFF)",
        testId: "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.bar-icon.link-icon"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
        label: "",
        color: "var(--ds-text-inverse, #FFFFFF)",
        testId: "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.bar-icon.link-icon"
    }));
});
const $d28fdf4c1cbf56b2$var$iconWrapperStyles = null;
const $d28fdf4c1cbf56b2$var$opacityStyles = (0, $1ZAYh.xcss)({
    opacity: 0.8
});

});
parcelRegister("fBftA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ba5c183c8a258f8be0ef328c0a8b726>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5b650fc75d7cc02$var$_react = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b5b650fc75d7cc02$var$_link = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("h0HFa")));

var $b5b650fc75d7cc02$var$_link2 = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("hUwRB")));
function $b5b650fc75d7cc02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5b650fc75d7cc02$var$LinkIcon = (props)=>/*#__PURE__*/ $b5b650fc75d7cc02$var$_react.default.createElement($b5b650fc75d7cc02$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $b5b650fc75d7cc02$var$_link2.default
    }, props));
$b5b650fc75d7cc02$var$LinkIcon.Name = 'LinkIconMigration';
var $b5b650fc75d7cc02$var$_default = module.exports.default = $b5b650fc75d7cc02$var$LinkIcon;

});
parcelRegister("h0HFa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6244e4cd9ddde64$var$_react = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6244e4cd9ddde64$var$_UNSAFE_baseNew = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6244e4cd9ddde64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6244e4cd9ddde64$var$LinkIcon = (props)=>/*#__PURE__*/ $c6244e4cd9ddde64$var$_react.default.createElement($c6244e4cd9ddde64$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$c6244e4cd9ddde64$var$LinkIcon.displayName = 'LinkIcon';
var $c6244e4cd9ddde64$var$_default = module.exports.default = $c6244e4cd9ddde64$var$LinkIcon;

});

parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d0a128a0d80d703a$var$_link = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $d0a128a0d80d703a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $d0a128a0d80d703a$var$_link.default
    }));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = module.exports.default = $d0a128a0d80d703a$var$LinkIcon;

});


parcelRegister("hHcrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $89017eb46014f714$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $89017eb46014f714$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewDetail: {
        "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.bar-content.bar-icon.view-detail",
        "defaultMessage": "View dependency details"
    }
});

});




parcelRegister("bSlr9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bfa9ccf3a6b23f0$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $dBmAu = parcelRequire("dBmAu");

var $j45xj = parcelRequire("j45xj");

var $1SuDz = parcelRequire("1SuDz");
const $4bfa9ccf3a6b23f0$var$onCreateDependency = (from, to, analyticEvent)=>(0, $j45xj.createDependency)({
        dependency: to,
        dependee: from
    }, analyticEvent);
var $4bfa9ccf3a6b23f0$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, { id: id })=>{
    const chartData = (0, $1SuDz.getChartDataHash)(state)[id];
    return {
        color: chartData.color
    };
}, {
    onCreateDependency: $4bfa9ccf3a6b23f0$var$onCreateDependency
})((0, $dBmAu.RoadmapDependencyHandlers));

});
parcelRegister("dBmAu", function(module, exports) {

$parcel$export(module.exports, "RoadmapDependencyHandlers", () => $a7d6c00f5f0a4c25$export$14c359ef0e13a4a6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4P2VV = parcelRequire("4P2VV");


var $5p0tX = parcelRequire("5p0tX");

var $kjGqG = parcelRequire("kjGqG");

var $b73YN = parcelRequire("b73YN");

var $734ti = parcelRequire("734ti");
const $a7d6c00f5f0a4c25$var$containerStyles = null;
const $a7d6c00f5f0a4c25$var$suffixElementStyles = null;
const $a7d6c00f5f0a4c25$export$14c359ef0e13a4a6 = ({ id: id, color: color, leftPosition: leftPosition, rightPosition: rightPosition, isHovered: isHovered, placeholder: placeholder, onCreateDependency: onCreateDependency, getBarBoundingClientRect: getBarBoundingClientRect, onBarMouseLeave: onBarMouseLeave })=>{
    const [{ isDraggedOver: isDraggedOver }, makeDroppable, cleanupDroppable] = (0, $734ti.useDependenciesDrop)(id, onCreateDependency);
    const [currentDragHandle, setCurrentDragHandle] = (0, $eUqFw.useState)(undefined);
    const isDragging = currentDragHandle !== undefined;
    const theme = (0, $kjGqG.dependencyThemes)?.[color];
    // Callbacks //
    const onDragStart = (0, $eUqFw.useCallback)((type)=>{
        setCurrentDragHandle(type);
        onBarMouseLeave();
    }, [
        onBarMouseLeave
    ]);
    const onDragEnd = (0, $eUqFw.useCallback)(()=>{
        setCurrentDragHandle(undefined);
    }, []);
    // Effects //
    (0, $eUqFw.useEffect)(()=>()=>{
            // drop connections will be unsubscribed if NULL was passed to drop handler.
            cleanupDroppable();
        }, [
        cleanupDroppable
    ]);
    // Render //
    const renderDragHandle = (type)=>{
        const isHandleInteractive = isHovered || currentDragHandle === type;
        if (!isHandleInteractive) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b73YN.default), {
            id: id,
            type: type,
            theme: theme,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            onDrop: onCreateDependency,
            onDragEnd: onDragEnd,
            onDragStart: onDragStart,
            getBarBoundingClientRect: getBarBoundingClientRect
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderRadius: (0, $5p0tX.generateBarBorderRadius)(placeholder)
        },
        "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.dependency-drop-target-${id}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _lcxvglyw _1pbyqfx8",
            (0, $fbe90688b36d692e$export$c330e9be73819573)
        ]),
        ref: makeDroppable
    }, renderDragHandle((0, $4P2VV.TOP)), renderDragHandle((0, $4P2VV.BOTTOM)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderRadius: (0, $5p0tX.generateBarBorderRadius)(placeholder),
            boxShadow: `inset 0 0 0 2px ${theme?.border}`,
            opacity: isDragging || isDraggedOver ? 1 : 0
        },
        className: (0, $7JEyt.default)([
            "_1sb2b3bt _kqswstnw _1bsb1osq _4t3i1osq _v5641w7c"
        ])
    }));
};

});
const $fbe90688b36d692e$export$48a2b55760ce2355 = 'dependency-drag-id';
const $fbe90688b36d692e$export$c330e9be73819573 = 'dependencies-drop-target';
const $fbe90688b36d692e$export$920d6feba87a57ed = 'INCOMING';
const $fbe90688b36d692e$export$2c998d8d93f14e97 = 'OUTGOING';

parcelRegister("5p0tX", function(module, exports) {

$parcel$export(module.exports, "generateBarBorderRadius", () => $c32927331baea9a1$export$f984deddd1b0e289);

var $c3IKH = parcelRequire("c3IKH");
const $c32927331baea9a1$export$f984deddd1b0e289 = (placeholder)=>{
    if (placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)) return 0, $c3IKH.LEFT_AND_RIGHT_PLACEHOLDER_BORDER_RADIUS;
    if (placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER)) return 0, $c3IKH.LEFT_PLACEHOLDER_BORDER_RADIUS;
    if (placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER)) return 0, $c3IKH.RIGHT_PLACEHOLDER_BORDER_RADIUS;
    return 0, $c3IKH.DEFAULT_BORDER_RADIUS;
};

});

parcelRegister("kjGqG", function(module, exports) {

$parcel$export(module.exports, "dependencyThemes", () => $b846dbad7bfe357f$export$895cd5f608903fe5);

var $lPQPn = parcelRequire("lPQPn");
const $b846dbad7bfe357f$export$895cd5f608903fe5 = (0, $lPQPn.transformColorToTheme)((cs)=>({
        icon: cs.primary,
        line: cs.line,
        border: cs.border,
        handle: {
            shadow: cs.primary,
            background: cs.primary
        }
    }));

});

parcelRegister("b73YN", function(module, exports) {

$parcel$export(module.exports, "default", () => $02631d5419a72b77$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $a576Y = parcelRequire("a576Y");

var $hzcvF = parcelRequire("hzcvF");

var $kVOqJ = parcelRequire("kVOqJ");

var $bwj1b = parcelRequire("bwj1b");

var $6TBpb = parcelRequire("6TBpb");

var $4P2VV = parcelRequire("4P2VV");

var $1KNKa = parcelRequire("1KNKa");

var $h8IDk = parcelRequire("h8IDk");

var $3K5D4 = parcelRequire("3K5D4");
const $02631d5419a72b77$var$DependenciesDragHandles = ({ theme: theme, id: id, type: type, leftPosition: leftPosition, rightPosition: rightPosition, getBarBoundingClientRect: getBarBoundingClientRect, onDrop: onDrop, onDragStart: onDragStart, onDragEnd: onDragEnd })=>{
    const [handlePosition, setHandlePosition] = (0, $eUqFw.useState)(undefined);
    const { custom: custom } = (0, $bwj1b.useSideEffectMarshal)();
    const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, $6TBpb.useViewport)();
    const [{ isDragging: isDragging }, makeDraggable, cleanupDraggable] = (0, $3K5D4.useDependenciesDrag)({
        id: id,
        type: type,
        leftPosition: leftPosition,
        rightPosition: rightPosition,
        getBarBoundingClientRect: getBarBoundingClientRect,
        onDrop: onDrop
    });
    const wasDragging = (0, $hzcvF.usePreviousWithInitial)(isDragging);
    // Callbacks //
    const onUpdateBarRectPosition = (0, $eUqFw.useCallback)(()=>{
        const barClientRect = getBarBoundingClientRect();
        if (barClientRect) {
            const fixedHandlePosition = (0, $h8IDk.getFixedHandlePosition)(type, barClientRect);
            setHandlePosition(fixedHandlePosition);
        }
    }, [
        type,
        getBarBoundingClientRect
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onScrollEnd = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
        onUpdateBarRectPosition();
    }, 100), []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onScroll = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
        setHandlePosition(undefined);
        onScrollEnd();
    }, 100), []);
    // Effects //
    (0, $eUqFw.useEffect)(()=>{
        listenToViewportScroll(onScroll);
        return ()=>{
            stopListeningToViewportScroll(onScroll);
            // drag connections will be unsubscribed if NULL was passed to drag handler.
            cleanupDraggable();
        };
    }, [
        onScroll,
        cleanupDraggable,
        listenToViewportScroll,
        stopListeningToViewportScroll
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!wasDragging && isDragging) {
            onDragStart(type);
            custom.onDependencyDragStart();
        } else if (wasDragging && !isDragging) {
            onDragEnd();
            custom.onDependencyDragEnd();
        }
    }, [
        type,
        isDragging,
        wasDragging,
        onDragEnd,
        onDragStart,
        custom
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onUpdateBarRectPosition();
    }, [
        onUpdateBarRectPosition
    ]);
    // Render //
    if (!handlePosition) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kVOqJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            visibility: isDragging ? 'hidden' : 'visible',
            left: handlePosition.left,
            top: handlePosition.top
        },
        "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.dependency-handler.handle",
        ref: makeDraggable,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _1e0c1txw _2lx21bp4 _1bsb1ejb _4t3i1ejb _4cvr1h6o _1bah1h6o _2rko1ssb _lcxv1rj4 _t9ec1ooe _zdyikb7n _f1zwidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": "timeline-data-dot",
        style: {
            backgroundColor: theme.handle.background
        },
        className: (0, $7JEyt.default)([
            "_1bsbu2gc _4t3iu2gc _2rko1ssb _80omtlke _tip8kb7n _v564m7ou",
            type === (0, $4P2VV.TOP) && "",
            type === (0, $4P2VV.TOP) && "_y44vea6k",
            type !== (0, $4P2VV.TOP) && "",
            type !== (0, $4P2VV.TOP) && "_y44vg57k"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": "timeline-drag-handler",
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iv77o _1ltvv77o _80omtlke _tzy4idpf _v564m7ou"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KNKa.DependencyDragHandler), {
        color: theme.icon
    }))));
};
var $02631d5419a72b77$export$2e2bcd8739ae039 = $02631d5419a72b77$var$DependenciesDragHandles;
const $02631d5419a72b77$var$SLIDE_OFFSET = 15;
const $02631d5419a72b77$var$slideInTop = null;
const $02631d5419a72b77$var$slideInBottom = null;
const $02631d5419a72b77$var$slideInTopStyles = null;
const $02631d5419a72b77$var$slideInBottomStyles = null;
const $02631d5419a72b77$var$dragHandleDotStyles = null;
const $02631d5419a72b77$var$dragHandleWrapperStyles = null;
// Current solution for component selectors https://hello.atlassian.net/wiki/spaces/UAF/pages/1393355483/Compiled+Component+selectors#Proposed-solution---HTML-data-attribute-selectors (a WIP solution yet to be implement for better parent/child styling and will be documented)
const $02631d5419a72b77$var$dragHandleContainerStyles = null;

});
parcelRegister("kVOqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $227cdbf999c5e4d4$export$2e2bcd8739ae039);

var $lEfVV = parcelRequire("lEfVV");

var $h829Y = parcelRequire("h829Y");
const $227cdbf999c5e4d4$var$Portal = ({ children: children })=>{
    const { portalContainerElement: portalContainerElement } = (0, $h829Y.usePortalScope)();
    if (portalContainerElement) return /*#__PURE__*/ (0, $lEfVV.createPortal)(children, portalContainerElement);
    return null;
};
var $227cdbf999c5e4d4$export$2e2bcd8739ae039 = $227cdbf999c5e4d4$var$Portal;

});

parcelRegister("1KNKa", function(module, exports) {

$parcel$export(module.exports, "DependencyDragHandler", () => $dba97944697d074e$export$df820fc059ab8cf4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hUwRB = parcelRequire("hUwRB");


var $8rQuz = parcelRequire("8rQuz");
const $dba97944697d074e$var$iconWrapperStyles = null;
const $dba97944697d074e$var$iconWrapperExtraPadding = null;
const $dba97944697d074e$export$df820fc059ab8cf4 = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            backgroundColor: color
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsbgktf _4t3igktf _2rko1ssb _4cvr1h6o _1bah1h6o _16qsanr3",
            (0, $8rQuz.isVisualRefreshEnabled)() && "_1yt4v77o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        size: "small",
        label: "",
        primaryColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
    }));

});

parcelRegister("h8IDk", function(module, exports) {

$parcel$export(module.exports, "getFixedHandlePosition", () => $fe6e739d2c85baf0$export$cdacaba1feb143c8);
$parcel$export(module.exports, "getRelativeHandlePosition", () => $fe6e739d2c85baf0$export$eb8d2bc119196ff0);

var $4P2VV = parcelRequire("4P2VV");
const $fe6e739d2c85baf0$var$FIXED_OFFSET_X = 15;
const $fe6e739d2c85baf0$var$FIXED_OFFSET_Y = 8;
const $fe6e739d2c85baf0$export$cdacaba1feb143c8 = (type, barClientRect)=>{
    const { top: top, left: left, width: width, height: height } = barClientRect;
    if (type === (0, $4P2VV.TOP)) return {
        top: top - $fe6e739d2c85baf0$var$FIXED_OFFSET_Y,
        left: left + $fe6e739d2c85baf0$var$FIXED_OFFSET_X
    };
    return {
        top: top + height + $fe6e739d2c85baf0$var$FIXED_OFFSET_Y,
        left: left + width - $fe6e739d2c85baf0$var$FIXED_OFFSET_X
    };
};
const $fe6e739d2c85baf0$export$eb8d2bc119196ff0 = (type, timelineWidth, barLeftPosition, barRightPosition)=>type === (0, $4P2VV.TOP) ? barLeftPosition : timelineWidth - barRightPosition;

});

parcelRegister("3K5D4", function(module, exports) {

$parcel$export(module.exports, "useDependenciesDrag", () => $b69b720a663d9a1e$export$8d873462c415f4c3);

var $eUqFw = parcelRequire("eUqFw");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");

var $3XwA1 = parcelRequire("3XwA1");

var $6TBpb = parcelRequire("6TBpb");


var $h8IDk = parcelRequire("h8IDk");
const $b69b720a663d9a1e$export$8d873462c415f4c3 = ({ id: id, type: type, getBarBoundingClientRect: getBarBoundingClientRect, leftPosition: leftPosition, rightPosition: rightPosition })=>{
    const cleanupDragAndDrop = (0, $eUqFw.useRef)(null);
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        isDragging: false
    });
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const { requestViewportBoundingClient: requestViewportBoundingClient, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = (0, $6TBpb.useViewport)();
    const makeDraggable = (0, $eUqFw.useCallback)((dragElement)=>{
        const el = dragElement;
        if (el === null) return;
        cleanupDragAndDrop.current = (0, $3f2za.combine)((0, $eo9PV.draggable)({
            element: el,
            getInitialData: ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    type: (0, $fbe90688b36d692e$export$48a2b55760ce2355),
                    id: id,
                    handleType: type,
                    barRect: getBarBoundingClientRect(),
                    leftPosition: (0, $h8IDk.getRelativeHandlePosition)(type, timelineWidth, leftPosition, rightPosition),
                    viewportBoundingRect: requestViewportBoundingClient(),
                    initialScrollBoundingRect: requestViewportScrollBounding(),
                    requestViewportScrollBounding: requestViewportScrollBounding,
                    setViewportScroll: setViewportScroll
                }),
            onGenerateDragPreview: ({ source: source })=>{
                const { element: draggedElement } = source;
                // hide the native drag preview
                draggedElement.style.opacity = '0';
            },
            onDragStart: ({ source: source })=>{
                const { element: draggedElement } = source;
                draggedElement.style.opacity = '1';
                setDragState({
                    isDragging: true
                });
            },
            onDrop: ()=>{
                setDragState({
                    isDragging: false
                });
            }
        }));
    }, [
        id,
        type,
        leftPosition,
        rightPosition,
        timelineWidth,
        setViewportScroll,
        requestViewportScrollBounding,
        requestViewportBoundingClient,
        getBarBoundingClientRect
    ]);
    const cleanupDraggable = (0, $eUqFw.useCallback)(()=>{
        cleanupDragAndDrop.current?.();
    }, []);
    return [
        dragState,
        makeDraggable,
        cleanupDraggable
    ];
};

});


parcelRegister("734ti", function(module, exports) {

$parcel$export(module.exports, "useDependenciesDrop", () => $02c88ff16b7170ce$export$52e673c9910da4de);

var $eUqFw = parcelRequire("eUqFw");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4P2VV = parcelRequire("4P2VV");

const $02c88ff16b7170ce$export$52e673c9910da4de = (id, onDrop)=>{
    const cleanupDropTarget = (0, $eUqFw.useRef)(null);
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        isDraggedOver: false
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const makeDroppable = (0, $eUqFw.useCallback)((dropTargetElement)=>{
        const el = dropTargetElement;
        if (el === null) return;
        cleanupDropTarget.current = (0, $3f2za.combine)((0, $eo9PV.dropTargetForElements)({
            element: el,
            canDrop: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                return item.type === (0, $fbe90688b36d692e$export$48a2b55760ce2355) && item.id !== id;
            },
            onDragEnter: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $fbe90688b36d692e$export$48a2b55760ce2355) && item.id !== id) setDragState({
                    isDraggedOver: true
                });
            },
            onDragLeave: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $fbe90688b36d692e$export$48a2b55760ce2355) && item.id !== id) setDragState({
                    isDraggedOver: false
                });
            },
            onDrop: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                const analyticsEvent = createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'dropArea'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyDropArea');
                const from = item.handleType === (0, $4P2VV.TOP) ? item.id : id;
                const to = item.handleType === (0, $4P2VV.TOP) ? id : item.id;
                onDrop(from, to, analyticsEvent);
                setDragState({
                    isDraggedOver: false
                });
            }
        }));
    }, [
        id,
        onDrop,
        createAnalyticsEvent
    ]);
    const cleanupDroppable = (0, $eUqFw.useCallback)(()=>{
        cleanupDropTarget.current?.();
    }, []);
    return [
        dragState,
        makeDroppable,
        cleanupDroppable
    ];
};

});




parcelRegister("ls0VL", function(module, exports) {

$parcel$export(module.exports, "default", () => $846bd3032832fba3$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ezynO = parcelRequire("ezynO");

var $1gs0D = parcelRequire("1gs0D");

var $l5hWP = parcelRequire("l5hWP");
const $846bd3032832fba3$var$ChartItemContent = (props)=>{
    const { onUpdate: onUpdate, warnings: warnings } = props;
    const hasOverdueReleaseDate = warnings ? warnings.some((warning)=>warning.id === (0, $l5hWP.default)[`${0, $1gs0D.END_DATE_LATER_RELEASE_DATE_MESSAGE_ID}`].id) : undefined;
    const onUpdateChartItem = (0, $eUqFw.useCallback)((id, { dates: dates, meta: meta, intervalId: intervalId }, event)=>{
        onUpdate(id, {
            dates: dates,
            meta: meta,
            intervalId: intervalId
        }, event, hasOverdueReleaseDate);
    }, [
        onUpdate,
        hasOverdueReleaseDate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezynO.RoadmapChartItemContent), {
        ...props,
        onUpdate: onUpdateChartItem
    });
};
$846bd3032832fba3$var$ChartItemContent.whyDidYouRender = true;
var $846bd3032832fba3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($846bd3032832fba3$var$ChartItemContent);

});
parcelRegister("ezynO", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartItemContent", () => $8eaf7269cfb7e602$export$3b537bb5a0afaee4);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4P2VV = parcelRequire("4P2VV");

var $fHtBB = parcelRequire("fHtBB");

var $54tWw = parcelRequire("54tWw");

var $9afsD = parcelRequire("9afsD");

var $cxkGw = parcelRequire("cxkGw");
const $8eaf7269cfb7e602$export$3b537bb5a0afaee4 = ({ id: id, startDate: startDate, dueDate: dueDate, color: color, level: level, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, DndLongTaskMetric: DndLongTaskMetric, warnings: warnings, intervals: intervals, isHovered: isHovered, isReadOnly: isReadOnly, onLeftClick: onLeftClick, onRightClick: onRightClick, onUpdate: onUpdate, renderBarContent: renderBarContent })=>{
    if (startDate !== undefined && dueDate !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !isReadOnly && intervals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9afsD.IntervalDropZones), {
        id: id,
        intervals: intervals
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54tWw.DateContent), {
        id: id,
        color: color,
        level: level,
        startDate: startDate,
        dueDate: dueDate,
        startDateType: startDateType,
        dueDateType: dueDateType,
        warnings: warnings,
        placeholder: placeholder,
        isHovered: isHovered,
        isReadOnly: isReadOnly,
        onLeftClick: onLeftClick,
        onRightClick: onRightClick,
        onUpdate: onUpdate,
        renderBarContent: renderBarContent,
        DndLongTaskMetric: DndLongTaskMetric
    }));
    return !isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cxkGw.NoDateContent), {
        id: id,
        level: level,
        color: color,
        startDateType: startDateType,
        dueDateType: dueDateType,
        isHovered: isHovered,
        onUpdate: onUpdate
    }, intervals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9afsD.IntervalDropZones), {
        id: id,
        intervals: intervals,
        onClick: onUpdate
    }))) : null;
};
$8eaf7269cfb7e602$export$3b537bb5a0afaee4.defaultProps = {
    startDateType: (0, $fHtBB.EXPLICIT),
    dueDateType: (0, $fHtBB.EXPLICIT),
    DndLongTaskMetric: ()=>null,
    warnings: [],
    intervals: [],
    isReadOnly: false,
    onLeftClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    renderBarContent: (0, $4P2VV.DEFAULT_RENDERER)
};

});
parcelRegister("54tWw", function(module, exports) {

$parcel$export(module.exports, "DateContent", () => $28edd2fb3c147048$export$cede4067c9cec7c9);

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");

var $fHtBB = parcelRequire("fHtBB");

var $7E8Bd = parcelRequire("7E8Bd");

var $cww1R = parcelRequire("cww1R");

var $f2nyx = parcelRequire("f2nyx");

var $i9sDh = parcelRequire("i9sDh");
const $28edd2fb3c147048$export$cede4067c9cec7c9 = ({ id: id, color: color, level: level, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, warnings: warnings, placeholder: placeholder, isHovered: isHovered, isReadOnly: isReadOnly, DndLongTaskMetric: DndLongTaskMetric, renderBarContent: renderBarContent, onUpdate: onUpdate, onLeftClick: onLeftClick, onRightClick: onRightClick })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const barLeftPosition = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const barRightPosition = (0, $cww1R.getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
    const isBarVisible = (0, $cww1R.getIsBarVisible)(barLeftPosition, barRightPosition, timelineWidth);
    if (!isBarVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f2nyx.RoadmapBar), {
        id: id,
        left: barLeftPosition,
        right: barRightPosition,
        color: color,
        level: level,
        startDateType: startDateType,
        dueDateType: dueDateType,
        warnings: warnings,
        placeholder: placeholder,
        isReadOnly: isReadOnly,
        onUpdate: onUpdate,
        onLeftClick: onLeftClick,
        onRightClick: onRightClick,
        renderBarContent: renderBarContent,
        DndLongTaskMetric: DndLongTaskMetric
    }), isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9sDh.RoadmapNavigateButton), {
        itemMinLeftPosition: barLeftPosition,
        itemMaxRightPosition: barRightPosition,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7E8Bd.FormattedDate), {
            startDate: startDate,
            startDateType: startDateType,
            dueDate: dueDate,
            dueDateType: dueDateType,
            placeholder: placeholder,
            isDurationVisible: !placeholder
        })
    }));
};
$28edd2fb3c147048$export$cede4067c9cec7c9.defaultProps = {
    startDateType: (0, $fHtBB.EXPLICIT),
    dueDateType: (0, $fHtBB.EXPLICIT)
};

});
parcelRegister("f2nyx", function(module, exports) {

$parcel$export(module.exports, "RoadmapBar", () => $770cd89388528d6a$export$9335a0f7fb12b232);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $lkPEe = parcelRequire("lkPEe");

var $3R70n = parcelRequire("3R70n");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9WNLk = parcelRequire("9WNLk");

var $3XwA1 = parcelRequire("3XwA1");

var $lqJW5 = parcelRequire("lqJW5");

var $kadaD = parcelRequire("kadaD");

var $lfgcv = parcelRequire("lfgcv");

var $4P2VV = parcelRequire("4P2VV");

var $c3IKH = parcelRequire("c3IKH");

var $fHtBB = parcelRequire("fHtBB");

var $3qiQH = parcelRequire("3qiQH");

var $cERyr = parcelRequire("cERyr");

var $cww1R = parcelRequire("cww1R");

var $iQiGF = parcelRequire("iQiGF");

var $bxXN4 = parcelRequire("bxXN4");

var $ezwuA = parcelRequire("ezwuA");

var $65R8W = parcelRequire("65R8W");

var $5SkIe = parcelRequire("5SkIe");

var $3t0oV = parcelRequire("3t0oV");
const $770cd89388528d6a$var$StyledBar = ({ left: left, right: right, placeholder: placeholder, theme: theme, level: level, shouldAnimate: shouldAnimate, isSelectEnabled: isSelectEnabled, innerRef: innerRef, containerRef: containerRef, children: children, startDate: startDate, dueDate: dueDate, color: color, 'data-testid': testId, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onContextMenu: onContextMenu, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: containerRef,
        testId: `${testId}-container`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            ...(0, $3qiQH.getBaseBarStyles)({
                level: level,
                theme: theme,
                placeholder: placeholder
            }),
            left: `${left}px`,
            right: `${right}px`,
            cursor: isSelectEnabled ? 'pointer' : 'default',
            transition: shouldAnimate ? 'left 0.1s ease, right 0.1s ease' : 'none'
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: innerRef,
        xcss: $770cd89388528d6a$var$focusedBarStyles,
        "aria-label": formatMessage((0, $65R8W.default).gridCellAriaLabel, {
            startDate: (0, $lfgcv.getDateFromTimestamp)(startDate),
            dueDate: (0, $lfgcv.getDateFromTimestamp)(dueDate),
            color: color
        }),
        onContextMenu: onContextMenu,
        testId: testId,
        ...rest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $770cd89388528d6a$var$barContentOverlayStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $770cd89388528d6a$var$barContentWrapperStyles
    }, children)));
};
const $770cd89388528d6a$var$DraggableBar = (0, $3R70n.withDragObserver)($770cd89388528d6a$var$StyledBar);
const $770cd89388528d6a$export$9335a0f7fb12b232 = ({ id: id, color: color, level: level, left: initialLeftPosition, right: initialRightPosition, startDateType: startDateType, dueDateType: dueDateType, warnings: warnings, placeholder: placeholder, isReadOnly: isReadOnly, DndLongTaskMetric: DndLongTaskMetric, onUpdate: onUpdate, onLeftClick: onLeftClick, onRightClick: onRightClick, renderBarContent: renderBarContent })=>{
    const [{ isSelectEnabled: isSelectEnabled }] = (0, $9WNLk.useEnablements)();
    let handleClick;
    if ((0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ handleClick: handleClick } = (0, $kadaD.useItemSelect)(id));
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const barContainerRef = (0, $eUqFw.useRef)(null);
    const barButtonRef = (0, $eUqFw.useRef)(null);
    const [{ isActive: isActive, dragType: dragType, ...interactionState }, { onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onLingerStart: onLingerStart, onLingerEnd: onLingerEnd }] = (0, $bxXN4.useChartItemInteractions)(id);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isHovered = isActive && !dragType;
    const isDragging = dragType !== undefined;
    const isDragExplicit = isDragging && isActive;
    const isResizeEnabled = startDateType !== (0, $fHtBB.INTERVAL) && dueDateType !== (0, $fHtBB.INTERVAL);
    const leftPosition = interactionState.leftPosition ?? initialLeftPosition;
    const rightPosition = interactionState.rightPosition ?? initialRightPosition;
    const { minimumLeft: minimumLeft, minimumRight: minimumRight } = (0, $5SkIe.getMinimumPositions)(leftPosition, rightPosition, timelineWidth);
    const isMinimumBar = minimumLeft !== undefined && minimumRight !== undefined;
    const newLeft = (isDragExplicit || isHovered) && minimumLeft !== undefined ? minimumLeft : leftPosition;
    const newRight = (isDragExplicit || isHovered) && minimumRight !== undefined ? minimumRight : rightPosition;
    const newPlaceholder = isDragExplicit ? (0, $cERyr.getPlaceholderWhileDragging)(dragType, placeholder) : placeholder;
    const prevStartDate = (0, $cww1R.getStartDate)(initialLeftPosition, timelineDuration, timelineWidth);
    const prevDueDate = (0, $cww1R.getDueDate)(initialRightPosition, timelineDuration, timelineWidth);
    const startDate = (0, $cww1R.getStartDate)(leftPosition, timelineDuration, timelineWidth);
    const dueDate = (0, $cww1R.getDueDate)(rightPosition, timelineDuration, timelineWidth);
    const theme = (0, $iQiGF.getBarTheme)(color);
    // === CALLBACKS === //
    const getBarBoundingClientRect = (0, $eUqFw.useCallback)(()=>barContainerRef.current?.getBoundingClientRect(), []);
    const onResizeStartLeft = ()=>{
        onDragStart((0, $4P2VV.LEFT));
    };
    const onResizeStartRight = ()=>{
        onDragStart((0, $4P2VV.RIGHT));
    };
    const onBarDragStart = ()=>{
        onDragStart((0, $4P2VV.LEFT_AND_RIGHT));
    };
    const onBarDragEnd = ()=>{
        const updatedDates = (0, $5SkIe.getUpdatedDates)(startDate, dueDate, dragType);
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragEnded',
            actionSubject: 'bar'
        });
        const attributes = {
            type: (0, $5SkIe.getAnalyticsType)(updatedDates),
            level: level,
            isStartDateInferred: startDateType === (0, $fHtBB.ROLLUP) || startDateType === (0, $fHtBB.INTERVAL),
            isDueDateInferred: dueDateType === (0, $fHtBB.ROLLUP) || dueDateType === (0, $fHtBB.INTERVAL)
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueBar', attributes);
        onDragEnd();
        onUpdate(id, {
            dates: updatedDates,
            meta: {
                isDragged: true
            }
        }, analyticsEvent);
    };
    const onBarRightClick = (event)=>{
        if (onRightClick !== undefined) {
            event.preventDefault();
            const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
            const analyticsEvent = createAnalyticsEvent({
                action: 'rightClicked',
                actionSubject: 'bar'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueBar');
            onRightClick(id, {
                x: event.clientX,
                y: top + height
            });
        }
    };
    const onBarLeftClickOld = (0, $eUqFw.useCallback)(({ target: target, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey })=>{
        if (target === barButtonRef.current) {
            const withCmd = ctrlKey || metaKey;
            const withShift = shiftKey;
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'bar'
            });
            const itemClickMeta = {
                level: level,
                withCmd: withCmd,
                withShift: withShift
            };
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueBar', itemClickMeta);
            onLeftClick?.(id, itemClickMeta, analyticsEvent);
        }
    }, [
        createAnalyticsEvent,
        id,
        level,
        onLeftClick
    ]);
    const onBarLeftClickNew = (0, $eUqFw.useCallback)((event)=>{
        const { target: target, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
        if (target !== barButtonRef.current) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'bar',
            actionSubjectId: 'issueBar',
            attributes: {
                level: level,
                withCmd: ctrlKey || metaKey,
                withShift: shiftKey
            }
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        // Remove the optional chaining with project_timeline_multi-select_and_checkboxes
        handleClick?.(event, analyticsEvent);
        const itemClickMeta = {
            level: level,
            withCmd: ctrlKey || metaKey,
            withShift: shiftKey
        };
        onLeftClick?.(id, itemClickMeta, analyticsEvent);
    }, [
        createAnalyticsEvent,
        level,
        handleClick,
        onLeftClick,
        id
    ]);
    const onBarLeftClick = (0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? onBarLeftClickNew : onBarLeftClickOld;
    // === RENDER === //
    const renderDragHandle = (type, hasPlaceholder)=>{
        const shouldRenderHandle = isHovered && dragType === undefined || dragType === type && isDragExplicit;
        return shouldRenderHandle && isResizeEnabled && !isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezwuA.RoadmapDragHandle), {
            id: id,
            type: type,
            theme: theme,
            hasPlaceholder: hasPlaceholder,
            onDragStart: type === (0, $4P2VV.LEFT) ? onResizeStartLeft : onResizeStartRight,
            onDrag: onDrag,
            onDragEnd: onBarDragEnd
        }) : null;
    };
    const renderGhostBar = ()=>{
        if (!isDragging) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
                ...(0, $3qiQH.getBaseBarStyles)({
                    level: level,
                    theme: theme,
                    placeholder: placeholder
                }),
                left: `${initialLeftPosition}px`,
                right: `${initialRightPosition}px`,
                backgroundColor: theme.background,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                opacity: '0.3'
            }
        });
    };
    const barContentProps = {
        id: id,
        dragType: dragType,
        prevStartDate: prevStartDate,
        prevDueDate: prevDueDate,
        startDate: startDate,
        dueDate: dueDate,
        startDateType: startDateType,
        dueDateType: dueDateType,
        leftPosition: newLeft,
        rightPosition: newRight,
        placeholder: newPlaceholder,
        isReadOnly: isReadOnly,
        isMinimumBar: isMinimumBar,
        getBarBoundingClientRect: getBarBoundingClientRect,
        onBarMouseLeave: onLingerEnd
    };
    const barContentState = {
        isActive: isActive,
        isHovered: isHovered
    };
    const warningsDescription = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
            id: `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.warning-desc-${id}`
        }, warnings.length > 0 && `${formatMessage((0, $65R8W.default).warningsCount, {
            count: warnings.length
        })} `, warnings.map((errorMessage)=>`${formatMessage(errorMessage)} `));
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if ((0, $lqJW5.isEnterOrSpaceKey)(e) && isSelectEnabled) {
            // Prevents timeline from scrolling on space
            e.preventDefault();
            onBarLeftClick(e);
        }
    }, [
        isSelectEnabled,
        onBarLeftClick
    ]);
    const renderDraggableBar = ()=>//  NOTE: ts error needs to be fixed in withDragObserver from @atlassian/jira-drag-observer
        // @ts-expect-error - TS2322 -   Property 'children' does not exist on type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props>, never> & InexactPartial<...> & InexactPartial<...>'. */}
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($770cd89388528d6a$var$DraggableBar, {
            "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.draggable-bar-${id}`,
            innerRef: barButtonRef,
            left: newLeft,
            right: newRight,
            level: level,
            theme: theme,
            placeholder: newPlaceholder,
            shouldAnimate: isHovered && isMinimumBar && !isDragging,
            isSelectEnabled: isSelectEnabled,
            isDisabled: isReadOnly,
            onMouseEnter: onLingerStart,
            onMouseLeave: onLingerEnd,
            onDrag: onDrag,
            onDragStart: onBarDragStart,
            onDragEnd: onBarDragEnd,
            onContextMenu: !isReadOnly ? onBarRightClick : undefined,
            onClick: isSelectEnabled ? onBarLeftClick : undefined,
            containerRef: barContainerRef,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            startDate: startDate,
            dueDate: dueDate,
            color: color,
            role: "button",
            "aria-describedby": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.warning-desc-${id}`
        }, renderBarContent(barContentProps, barContentState), renderDragHandle((0, $4P2VV.LEFT), placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)), renderDragHandle((0, $4P2VV.RIGHT), placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderGhostBar(), renderDraggableBar(), warningsDescription(), !isDragExplicit && !isHovered && warnings.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3t0oV.RoadmapBarWarnings), {
        warnings: warnings,
        right: newRight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: isDragging,
        level: level
    }));
};
const $770cd89388528d6a$var$focusedBarStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    ':focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
        outlineOffset: 'space.025'
    }
});
const $770cd89388528d6a$var$barContentOverlayStyles = (0, $1ZAYh.xcss)({
    padding: '0',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    pointerEvents: 'none'
});
const $770cd89388528d6a$var$barContentWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'auto'
});

});
parcelRegister("3qiQH", function(module, exports) {

$parcel$export(module.exports, "getBaseBarStyles", () => $e0d8b0306f7fc500$export$bbdfdd7c08708e05);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kbiEp = parcelRequire("kbiEp");

var $c3IKH = parcelRequire("c3IKH");

var $ksGD2 = parcelRequire("ksGD2");

var $5p0tX = parcelRequire("5p0tX");
const $e0d8b0306f7fc500$var$generateBarBackground = ({ theme: theme, placeholder: placeholder })=>{
    if (placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.gradient} 0%, ${theme.background} 30%, ${theme.background} 70%, ${theme.gradient} 100%)`;
    if (placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.gradient} 0%, ${theme.background} 30%)`;
    if (placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.background} 70%, ${theme.gradient} 100%)`;
    return theme.background;
};
const $e0d8b0306f7fc500$export$bbdfdd7c08708e05 = ({ level: level, placeholder: placeholder, theme: theme })=>({
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minWidth: '3px',
        padding: 0,
        zIndex: `${0, $ksGD2.CHART_BAR_Z_INDEX}`,
        height: `${(0, $kbiEp.isBaseLevel)(level) ? `${0, $c3IKH.BASE_BAR_HEIGHT}px` : `${0, $c3IKH.BAR_HEIGHT}px`}`,
        borderRadius: `${(0, $5p0tX.generateBarBorderRadius)(placeholder)}`,
        background: `${$e0d8b0306f7fc500$var$generateBarBackground({
            placeholder: placeholder,
            theme: theme
        })}`
    });
const $e0d8b0306f7fc500$export$8759e0e73077886f = ({ placeholder: placeholder, left: left, right: right, theme: theme, level: level, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            left: `${left}px`,
            right: `${right}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${(0, $kbiEp.isBaseLevel)(level) ? `${0, $c3IKH.BASE_BAR_HEIGHT}px` : `${0, $c3IKH.BAR_HEIGHT}px`}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderRadius: `${(0, $5p0tX.generateBarBorderRadius)(placeholder)}`,
            background: `${$e0d8b0306f7fc500$var$generateBarBackground({
                placeholder: placeholder,
                theme: theme
            })}`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _4cvr1h6o _1bahesu3 _1ul91b66 _1yt4otz2 _1pby11wp"
        ])
    }, children);
const $e0d8b0306f7fc500$var$baseBarStyles = null;

});

parcelRegister("iQiGF", function(module, exports) {

$parcel$export(module.exports, "getBarTheme", () => $8660ece9241da453$export$9f7946b895cedb51);

var $lPQPn = parcelRequire("lPQPn");
const $8660ece9241da453$var$colorToBarTheme = (color)=>({
        background: color.primary,
        gradient: color.primaryGradient,
        handle: color.secondary,
        hasContrastSecondaryGradient: color.hasContrastSecondaryGradient
    });
const $8660ece9241da453$var$barThemes = (0, $lPQPn.transformColorToTheme)($8660ece9241da453$var$colorToBarTheme);
const $8660ece9241da453$export$9f7946b895cedb51 = (color)=>$8660ece9241da453$var$barThemes[color] || $8660ece9241da453$var$barThemes.PURPLE;

});

parcelRegister("bxXN4", function(module, exports) {

$parcel$export(module.exports, "useChartItemInteractions", () => $adb6f1ea918fa2b3$export$7de9fc62a8d2ea96);

var $eUqFw = parcelRequire("eUqFw");

var $hevaQ = parcelRequire("hevaQ");
/* A lightweight wrapper that orchestrates the interaction actions:
 * - Internally supplies the item id to the underlying actions so that the components don't have to
 * - Centralises the handling of timers (throttling, etc)
 */ const $adb6f1ea918fa2b3$export$7de9fc62a8d2ea96 = (id)=>{
    const timeoutId = (0, $eUqFw.useRef)(undefined);
    const frameId = (0, $eUqFw.useRef)(undefined);
    const [interactionState, interactionActions] = (0, $hevaQ.useInteractionData)(id);
    (0, $eUqFw.useEffect)(()=>()=>{
            frameId.current && cancelAnimationFrame(frameId.current);
            clearTimeout(timeoutId.current);
        }, []);
    const onDragStart = (0, $eUqFw.useCallback)((dragType)=>{
        interactionActions.onDragStart(id, dragType);
    }, [
        id,
        interactionActions
    ]);
    const onLingerStart = (0, $eUqFw.useCallback)(()=>{
        interactionActions.onLingerStart(id);
        timeoutId.current = setTimeout(()=>interactionActions.onLinger(), 200);
    }, [
        id,
        interactionActions
    ]);
    const onLingerEnd = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(timeoutId.current);
        interactionActions.onLingerEnd();
    }, [
        interactionActions
    ]);
    const onPreview = (0, $eUqFw.useCallback)((previewX)=>{
        if (!frameId.current) frameId.current = requestAnimationFrame(()=>{
            frameId.current = undefined;
            interactionActions.onPreview(previewX);
        });
    }, [
        interactionActions
    ]);
    return [
        interactionState,
        {
            ...interactionActions,
            onDragStart: onDragStart,
            onLingerStart: onLingerStart,
            onLingerEnd: onLingerEnd,
            onPreview: onPreview
        }
    ];
};

});

parcelRegister("ezwuA", function(module, exports) {

$parcel$export(module.exports, "RoadmapDragHandle", () => $0c682102f9ebb04f$export$fd31a6ac7f6022ac);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3R70n = parcelRequire("3R70n");
const $0c682102f9ebb04f$var$handleStyles = null;
const $0c682102f9ebb04f$var$Handle = ({ type: type, hasPlaceholder: hasPlaceholder, theme: theme, children: children, testid: testid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [type]: 0,
            backgroundColor: !theme.hasContrastSecondaryGradient && hasPlaceholder ? theme.background : theme.handle
        },
        "data-testid": testid,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _94n5idpf _1yt41b66 _1bsbi2wt _2rkoftgi _1y1m1ntv _80om11mm"
        ])
    }, children);
const $0c682102f9ebb04f$var$DraggableHandle = (0, $3R70n.withDragObserver)($0c682102f9ebb04f$var$Handle, 0.1);
const $0c682102f9ebb04f$export$fd31a6ac7f6022ac = ({ id: id, type: type, theme: theme, hasPlaceholder: hasPlaceholder, onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd })=>{
    const onDragHandleStart = (0, $eUqFw.useCallback)(()=>{
        onDragStart(type);
    }, [
        type,
        onDragStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c682102f9ebb04f$var$DraggableHandle, {
        // NOTE: ts error needs to be fixed in withDragObserver from @atlassian/jira-drag-observer
        // @ts-expect-error - TS2322 - Type '{ "testid": string; theme: BarTheme; position: HorizontalDirection; hasPlaceholder: boolean; onDragStart: () => void; onDrag: (from: Position, to: Position, start: Position) => void; onDragEnd: () => void; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props> & Readonly<...>, "children"> & Partial<...> & Partial<...>'.
        testid: `roadmap.timeline-table.components.bar.draggable.${type.toLowerCase()}-draggable-handle-${id}`,
        theme: theme,
        type: type.toLowerCase(),
        hasPlaceholder: hasPlaceholder,
        onDragStart: onDragHandleStart,
        onDrag: onDrag,
        onDragEnd: onDragEnd
    });
};

});

parcelRegister("65R8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbaa40a29f89eae9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dbaa40a29f89eae9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    gridCellAriaLabel: {
        "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.grid-cell-aria-label",
        "defaultMessage": "Start date {startDate} until due date {dueDate} with color {color}"
    },
    warningsCount: {
        "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.warnings-count",
        "defaultMessage": "{count, plural, one {# warning} other {# warnings}}"
    }
});

});

parcelRegister("5SkIe", function(module, exports) {

$parcel$export(module.exports, "getMinimumPositions", () => $2e6075c6047ad389$export$c1b6dd342ed8c79c);
$parcel$export(module.exports, "getUpdatedDates", () => $2e6075c6047ad389$export$3aa346efaf981bb1);
$parcel$export(module.exports, "getAnalyticsType", () => $2e6075c6047ad389$export$a3569ac53b82a914);

var $4P2VV = parcelRequire("4P2VV");

var $c3IKH = parcelRequire("c3IKH");
const $2e6075c6047ad389$export$c1b6dd342ed8c79c = (leftPosition, rightPosition, timelineWidth)=>{
    const barLength = timelineWidth - rightPosition - leftPosition;
    if (barLength < (0, $c3IKH.MINIMUM_BAR_LENGTH)) {
        const minimumOffset = ((0, $c3IKH.MINIMUM_BAR_LENGTH) - barLength) / 2;
        return {
            minimumLeft: leftPosition - minimumOffset,
            minimumRight: rightPosition - minimumOffset
        };
    }
    return {
        minimumLeft: undefined,
        minimumRight: undefined
    };
};
const $2e6075c6047ad389$export$3aa346efaf981bb1 = (startDate, dueDate, dragType)=>{
    if (dragType === (0, $4P2VV.LEFT)) return {
        startDate: startDate
    };
    if (dragType === (0, $4P2VV.RIGHT)) return {
        dueDate: dueDate
    };
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT)) return {
        startDate: startDate,
        dueDate: dueDate
    };
    return {};
};
const $2e6075c6047ad389$export$a3569ac53b82a914 = (updatedDates)=>{
    const { startDate: startDate, dueDate: dueDate } = updatedDates;
    if (startDate && !dueDate) return 'resizeLeft';
    if (!startDate && dueDate) return 'resizeRight';
    return 'moveBar';
};

});

parcelRegister("3t0oV", function(module, exports) {

$parcel$export(module.exports, "RoadmapBarWarnings", () => $2760de060644b8c4$export$a4e6ea3b919ca9a9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5YsMl = parcelRequire("5YsMl");


var $2eG9N = parcelRequire("2eG9N");
var $4pEpX = parcelRequire("4pEpX");

var $4ksts = parcelRequire("4ksts");
const $2760de060644b8c4$var$containerStyles = null;
const $2760de060644b8c4$var$contentWrapperStyles = null;
const $2760de060644b8c4$var$tooltipTextStyles = null;
const $2760de060644b8c4$var$iconContainerStyles = null;
const $2760de060644b8c4$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ $eUqFw.createElement("span", {
        ref: ref,
        ...props,
        className: (0, $7JEyt.default)([
            "_syaz2owi _1e0c1txw"
        ])
    }));
const $2760de060644b8c4$export$a4e6ea3b919ca9a9 = ({ right: right, warnings: warnings })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)(); // FIXME: Chronos should fix that by extracting the forwarded component
    const TooltipComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((tooltipProps, ref)=>/*#__PURE__*/ $eUqFw.createElement((0, $4pEpX.default), {
            ...tooltipProps,
            ref: ref
        }));
    const tooltipContent = warnings.map((errorMessage)=>/*#__PURE__*/ $eUqFw.createElement("div", {
            key: `${errorMessage.id}`,
            className: (0, $7JEyt.default)([
                "_1e0c1txw _1bsbp3fh _otyr1b66 _1yt41pyq _2rko1l7b _11q71bhr _16qsac02 _syaz1rn8"
            ])
        }, /*#__PURE__*/ $eUqFw.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
            size: "medium",
            label: ""
        }), /*#__PURE__*/ $eUqFw.createElement("div", {
            className: (0, $7JEyt.default)([
                "_1yt4swc3 _11c816g6 _18u0u2gc"
            ])
        }, formatMessage(errorMessage))));
    return /*#__PURE__*/ $eUqFw.createElement("div", {
        style: {
            right: `${right}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1ule _t9ecwq5g _80omtlke _1pby11wp"
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $2eG9N.default), {
        component: TooltipComponent,
        content: tooltipContent,
        position: "bottom-start",
        delay: 0,
        hideTooltipOnClick: true,
        tag: $2760de060644b8c4$var$TooltipTag
    }, /*#__PURE__*/ $eUqFw.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
        label: ""
    })));
};

});


parcelRegister("i9sDh", function(module, exports) {

$parcel$export(module.exports, "RoadmapNavigateButton", () => $76b6135759dfcd50$export$f4de1542efe44c4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $1mWtC = parcelRequire("1mWtC");

var $8Z927 = parcelRequire("8Z927");

var $c9TLT = parcelRequire("c9TLT");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hxnNZ = parcelRequire("hxnNZ");

var $6TBpb = parcelRequire("6TBpb");

// Constants //
const $76b6135759dfcd50$var$BUTTON_SIZE = 3 * (0, $c9TLT.gridSize);
const $76b6135759dfcd50$var$DATE_OFFSET = $76b6135759dfcd50$var$BUTTON_SIZE + (0, $c9TLT.gridSize);
const $76b6135759dfcd50$var$SCROLL_BAR_OFFSET = 10;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76b6135759dfcd50$var$PAST_BORDER_RADIUS = `0 ${(0, $c9TLT.borderRadius)}px ${(0, $c9TLT.borderRadius)}px 0`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76b6135759dfcd50$var$FUTURE_BORDER_RADIUS = `${(0, $c9TLT.borderRadius)}px 0 0 ${(0, $c9TLT.borderRadius)}px`;
const $76b6135759dfcd50$var$baseButtonStyles = null;
const $76b6135759dfcd50$var$pastButtonBorderRadiusStyles = null;
const $76b6135759dfcd50$var$futureButtonBorderRadiusStyles = null;
const $76b6135759dfcd50$var$pastLabelContainerStyles = null;
const $76b6135759dfcd50$var$futureLabelContainerStyles = null;
const $76b6135759dfcd50$export$f4de1542efe44c4 = ({ itemMinLeftPosition: itemMinLeftPosition, itemMaxRightPosition: itemMaxRightPosition, label: label })=>{
    const { requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = (0, $6TBpb.useViewport)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isScrollingX] = (0, $hxnNZ.useIsScrollingX)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    if (isScrollingX) return null;
    const { scrollLeft: scrollLeft, scrollRight: scrollRight, scrollWidth: scrollWidth, isOverflowY: isOverflowY } = requestViewportScrollBounding();
    const isItemInPast = scrollWidth - itemMaxRightPosition < scrollLeft;
    const isItemInFuture = scrollWidth - itemMinLeftPosition < scrollRight;
    // The chart-item-content is visible in the viewport, no need to navigate to it.
    if (!isItemInPast && !isItemInFuture) return null;
    // Callbacks //
    const onMouseEnter = ()=>{
        setIsHovered(true);
    };
    const onMouseLeave = ()=>{
        setIsHovered(false);
    };
    const onClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const analyticsAttributes = {
            direction: isItemInPast ? 'past' : 'future'
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigateButton', analyticsAttributes);
        setViewportScroll({
            scrollLeft: itemMinLeftPosition - (0, $1ee7517576a29949$export$6053dd7bb292e51e)
        });
    };
    // Render //
    const renderArrowIcon = (Icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: "",
            color: "var(--ds-icon, #44546F)"
        });
    if (isItemInPast) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.navigate-button.navigate",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onClick(),
        role: "presentation",
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _vchhusvi _1yt41b66 _bfhk1i4r _1pbyouyt _80omtlke _irr3arkb",
            "_2rko1gaq"
        ]),
        style: {
            left: `${scrollLeft}px`,
            width: `${$76b6135759dfcd50$var$BUTTON_SIZE}px`,
            "--_3j09fn": (0, $9t7rW.default)($76b6135759dfcd50$var$PAST_BORDER_RADIUS)
        }
    }, renderArrowIcon((0, (/*@__PURE__*/$parcel$interopDefault($1mWtC)))), isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvxy5q"
        ])
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.navigate-button.navigate",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _vchhusvi _1yt41b66 _bfhk1i4r _1pbyouyt _80omtlke _irr3arkb",
            "_2rkoff7z"
        ]),
        style: {
            right: `${scrollRight}px`,
            width: `${$76b6135759dfcd50$var$BUTTON_SIZE + (isOverflowY ? $76b6135759dfcd50$var$SCROLL_BAR_OFFSET : 0)}px`,
            "--_kwbool": (0, $9t7rW.default)($76b6135759dfcd50$var$FUTURE_BORDER_RADIUS)
        }
    }, renderArrowIcon((0, (/*@__PURE__*/$parcel$interopDefault($8Z927)))), isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            right: `${$76b6135759dfcd50$var$DATE_OFFSET + (isOverflowY ? $76b6135759dfcd50$var$SCROLL_BAR_OFFSET : 0)}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw"
        ])
    }, label));
};

});
parcelRegister("1mWtC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb1d2ef7c22df95c0cc88460338da8e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ff534c686384c24$var$_react = $0ff534c686384c24$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0ff534c686384c24$var$_arrowLeft = $0ff534c686384c24$var$_interopRequireDefault((parcelRequire("f4v4a")));

var $0ff534c686384c24$var$_arrowLeft2 = $0ff534c686384c24$var$_interopRequireDefault((parcelRequire("gpZWO")));
function $0ff534c686384c24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ff534c686384c24$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $0ff534c686384c24$var$_react.default.createElement($0ff534c686384c24$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $0ff534c686384c24$var$_arrowLeft2.default
    }, props));
$0ff534c686384c24$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $0ff534c686384c24$var$_default = module.exports.default = $0ff534c686384c24$var$ArrowLeftIcon;

});
parcelRegister("f4v4a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8f53d2717afebc$var$_react = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af8f53d2717afebc$var$_UNSAFE_baseNew = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $af8f53d2717afebc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af8f53d2717afebc$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $af8f53d2717afebc$var$_react.default.createElement($af8f53d2717afebc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$af8f53d2717afebc$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $af8f53d2717afebc$var$_default = module.exports.default = $af8f53d2717afebc$var$ArrowLeftIcon;

});

parcelRegister("gpZWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf3f089e16becc19$var$_react = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $bf3f089e16becc19$var$_arrowLeft = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("f4v4a")));
function $bf3f089e16becc19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf3f089e16becc19$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf3f089e16becc19$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $bf3f089e16becc19$var$_arrowLeft.default
    }));
$bf3f089e16becc19$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf3f089e16becc19$var$_default = module.exports.default = $bf3f089e16becc19$var$ArrowLeftIcon;

});


parcelRegister("8Z927", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9007430e85cec58e5f079a401c682825>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68ab070767348a55$var$_react = $68ab070767348a55$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $68ab070767348a55$var$_arrowRight = $68ab070767348a55$var$_interopRequireDefault((parcelRequire("gTPnA")));

var $68ab070767348a55$var$_arrowRight2 = $68ab070767348a55$var$_interopRequireDefault((parcelRequire("cSu9v")));
function $68ab070767348a55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68ab070767348a55$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $68ab070767348a55$var$_react.default.createElement($68ab070767348a55$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $68ab070767348a55$var$_arrowRight2.default
    }, props));
$68ab070767348a55$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $68ab070767348a55$var$_default = module.exports.default = $68ab070767348a55$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});

parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});


// When navigating to a chart item, we don't want to be aligned right to the edge of the viewport
const $1ee7517576a29949$export$6053dd7bb292e51e = 32;



parcelRegister("9afsD", function(module, exports) {

$parcel$export(module.exports, "IntervalDropZones", () => $af6ec96c04a8f46d$export$f18d47ee39e90aec);

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");

var $hevaQ = parcelRequire("hevaQ");

var $67lY7 = parcelRequire("67lY7");

var $3pD74 = parcelRequire("3pD74");
const $af6ec96c04a8f46d$var$VisibleIntervalDropZones = ({ id: id, intervals: intervals, currentIntervalId: currentIntervalId, onClick: onClick })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const activeOrFutureGroups = (0, $3pD74.getActiveOrFutureIntervalGroups)({
        intervals: intervals,
        currentIntervalId: currentIntervalId,
        timelineDuration: timelineDuration,
        timelineWidth: timelineWidth
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, activeOrFutureGroups.map((intervalGroup, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $67lY7.default), {
            id: id,
            key: index,
            left: Math.max(intervalGroup.left, intervalGroup.targetIntervalLeft),
            right: Math.max(intervalGroup.right, intervalGroup.targetIntervalRight),
            intervals: intervalGroup.intervals,
            onClick: onClick
        })));
};
const $af6ec96c04a8f46d$export$f18d47ee39e90aec = ({ id: id, intervals: intervals, onClick: onClick })=>{
    // this is where we show/hide the dropzones
    const [{ isVisible: isVisible, currentIntervalId: currentIntervalId }] = (0, $hevaQ.useIntervalDropZoneData)(id);
    return isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af6ec96c04a8f46d$var$VisibleIntervalDropZones, {
        id: id,
        intervals: intervals,
        currentIntervalId: currentIntervalId,
        onClick: onClick
    }) : null;
};
var $af6ec96c04a8f46d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($af6ec96c04a8f46d$export$f18d47ee39e90aec);

});
parcelRegister("67lY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a7260da90d7b6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hevaQ = parcelRequire("hevaQ");
const $ce5a7260da90d7b6$var$DROPZONE_BACKGROUND = `var(--ds-background-accent-blue-bolder, ${`${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)}`})`;
const $ce5a7260da90d7b6$var$INTERVAL_DROPZONE_WIDTH_EXPANSION = 2;
const $ce5a7260da90d7b6$var$dropZoneStyles = null;
const $ce5a7260da90d7b6$export$ad226bf0b5a21555 = ({ id: id, left: left, right: right, intervals: intervals, onClick: onClickDropZone })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [targetIntervalId] = (0, $hevaQ.useTargetIntervalId)(intervals);
    const { resetChartInteractionState: resetChartInteractionState } = (0, $hevaQ.useResetChartInteractionState)();
    const onClick = ()=>{
        if (onClickDropZone && targetIntervalId !== undefined) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'dropzone'
            });
            onClickDropZone(id, {
                intervalId: targetIntervalId
            }, analyticsEvent);
            resetChartInteractionState();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'intervalDropzone');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onClick: onClick,
        onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onClick(),
        role: "presentation",
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3igktf _2rko1l7b _1pbycs5v _19it1gv3 _bfhkuyzt _v5641ql7"
        ]),
        style: {
            left: `${targetIntervalId !== undefined ? left - $ce5a7260da90d7b6$var$INTERVAL_DROPZONE_WIDTH_EXPANSION : left + 1}px`,
            right: `${targetIntervalId !== undefined ? right - $ce5a7260da90d7b6$var$INTERVAL_DROPZONE_WIDTH_EXPANSION : right + 1}px`,
            opacity: targetIntervalId !== undefined ? 0.38 : 0.13,
            cursor: targetIntervalId !== undefined ? 'pointer' : 'default',
            /* border width is used to expand the dropzone vertically */ borderWidth: targetIntervalId !== undefined ? `${$ce5a7260da90d7b6$var$INTERVAL_DROPZONE_WIDTH_EXPANSION}px` : 0,
            "--_1m5or25": (0, $9t7rW.default)($ce5a7260da90d7b6$var$DROPZONE_BACKGROUND)
        }
    });
};
var $ce5a7260da90d7b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ce5a7260da90d7b6$export$ad226bf0b5a21555);

});

parcelRegister("3pD74", function(module, exports) {

$parcel$export(module.exports, "getActiveOrFutureIntervalGroups", () => $765f9e21fd77f69b$export$8d82d19c3a1af9a2);


var $9j4Ay = parcelRequire("9j4Ay");
const $765f9e21fd77f69b$export$8d82d19c3a1af9a2 = ({ intervals: intervals, currentIntervalId: currentIntervalId, timelineDuration: timelineDuration, timelineWidth: timelineWidth })=>{
    let unassignedIntervals = intervals;
    if (currentIntervalId !== undefined) unassignedIntervals = intervals.filter((interval)=>interval.id !== currentIntervalId);
    const intervalGroups = (0, $9j4Ay.getIntervalGroupPositions)(unassignedIntervals, timelineDuration, timelineWidth);
    return intervalGroups.filter((intervalGroup)=>intervalGroup.intervals.some((interval)=>interval.state !== (0, $4a21b57a573cad8c$export$19c4f83398a8dbce)));
};

});


parcelRegister("cxkGw", function(module, exports) {

$parcel$export(module.exports, "NoDateContent", () => $4daabea91b86b276$export$372da41cc9735180);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $hxnNZ = parcelRequire("hxnNZ");

var $6TBpb = parcelRequire("6TBpb");

var $bxXN4 = parcelRequire("bxXN4");

var $j1aaL = parcelRequire("j1aaL");
const $4daabea91b86b276$var$previewContainerStyles = null;
const $4daabea91b86b276$export$372da41cc9735180 = ({ id: id, level: level, color: color, startDateType: startDateType, dueDateType: dueDateType, isHovered: isHovered, onUpdate: onUpdate, children: children })=>{
    const lastScrollLeft = (0, $eUqFw.useRef)(0);
    const [isScrollingX] = (0, $hxnNZ.useIsScrollingX)();
    const wasScrollingX = (0, $hzcvF.usePreviousWithInitial)(isScrollingX);
    const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, $6TBpb.useViewport)();
    const [{ isActive: isActive, leftPosition: leftPosition, rightPosition: rightPosition, dragType: dragType }, { onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onLingerStart: onLingerStart, onLingerEnd: onLingerEnd, onPreview: onPreview }] = (0, $bxXN4.useChartItemInteractions)(id);
    // === EFFECTS === //
    /* This component is hidden while scrolling. After scrolling ends we need to update the
   * preview position to match the new scroll offset (where the user cursor *now* is).
   */ (0, $eUqFw.useEffect)(()=>{
        if (isActive && !dragType) {
            const { scrollLeft: scrollLeft } = requestViewportScrollBounding();
            if (!wasScrollingX && isScrollingX) lastScrollLeft.current = scrollLeft;
            else if (wasScrollingX && !isScrollingX && leftPosition !== undefined) {
                const scrollOffset = scrollLeft - lastScrollLeft.current;
                lastScrollLeft.current = scrollLeft;
                onPreview(leftPosition + scrollOffset);
            }
        }
    });
    // === CALLBACKS === //
    const onContainerMouseMove = ({ pageX: pageX, currentTarget: currentTarget })=>{
        // Get the left position relative to the timeline
        onPreview(pageX - currentTarget.getBoundingClientRect().left);
    };
    const onPreviewClick = (params, analyticsEvent)=>{
        onUpdate(id, params, analyticsEvent);
        onLingerEnd();
    };
    const onPreviewDragEnd = (params, analyticsEvent)=>{
        onUpdate(id, params, analyticsEvent);
        onDragEnd();
    };
    // === RENDER === //
    /* Why check the passed in hover state when we have our own mouse enter and leave listeners here?
   * 1. The hover state is passed from a table internal renderer to minimise the consumer DOM (on average).
   *    We don't need to render an extra div to track the mouse move state until necessary.
   * 2. Calling onLingerStart and onLingerEnd from a useEffect results in an item's start being called before
   *    the previous items end which results in strange behaviour.
   */ if (isHovered && !isScrollingX || isActive && dragType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.no-date-content.preview-container-${id}`,
        onMouseMove: onContainerMouseMove,
        onMouseEnter: onLingerStart,
        onMouseLeave: onLingerEnd,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1pbyouyt"
        ])
    }, children, leftPosition !== undefined && rightPosition !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1aaL.PreviewBar), {
        level: level,
        color: color,
        startDateType: startDateType,
        dueDateType: dueDateType,
        leftPosition: leftPosition,
        rightPosition: rightPosition,
        onDrag: onDrag,
        onDragStart: onDragStart,
        onDragEnd: onPreviewDragEnd,
        onClick: onPreviewClick
    }));
    return null;
};

});
parcelRegister("j1aaL", function(module, exports) {

$parcel$export(module.exports, "PreviewBar", () => $62bb2659498a4054$export$cf6bba1afb8df9b7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3R70n = parcelRequire("3R70n");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kbiEp = parcelRequire("kbiEp");

var $3XwA1 = parcelRequire("3XwA1");

var $4P2VV = parcelRequire("4P2VV");

var $fHtBB = parcelRequire("fHtBB");

var $2sNQW = parcelRequire("2sNQW");

var $cww1R = parcelRequire("cww1R");

var $iQiGF = parcelRequire("iQiGF");
const $62bb2659498a4054$var$Bar = ({ left: left, right: right, level: level, color: color, children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            left: `${left}px`,
            right: `${right}px`
        },
        "data-testid": dataTestId,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ul91b66 _4t3i1tcg _1e0c1txw _4cvr1h6o _2rko1l7b _tzy4idpf _ju25fnf5 _5sagfnf5 _j7hq3v5s _1pgl1ytf _1o51q7pw _80omtlke",
            (0, $kbiEp.isBaseLevel)(level) && "_4t3igktf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            backgroundColor: (0, $iQiGF.getBarTheme)(color).background
        },
        className: (0, $7JEyt.default)([
            "_1sb2b3bt _kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _tzy4105o _2rko1l7b"
        ])
    }), children);
const $62bb2659498a4054$var$DraggableBar = (0, $3R70n.withDragObserver)($62bb2659498a4054$var$Bar);
const $62bb2659498a4054$export$cf6bba1afb8df9b7 = ({ level: level, color: color, startDateType: startDateType, dueDateType: dueDateType, leftPosition: leftPosition, rightPosition: rightPosition, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onClick: onClick })=>{
    const elemRef = (0, $eUqFw.useRef)(null);
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const startDate = (0, $cww1R.getStartDate)(leftPosition, timelineDuration, timelineWidth);
    const dueDate = (0, $cww1R.getDueDate)(rightPosition, timelineDuration, timelineWidth);
    // === CALLBACKS === //
    const onHandleDragStart = ()=>{
        // Just a sensible default direction, this will update depending on current drag state
        onDragStart((0, $4P2VV.RIGHT));
    };
    const onHandleDragEnd = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragged',
            actionSubject: 'previewBar'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'previewBar', {
            level: level
        });
        onDragEnd({
            dates: {
                startDate: startDate,
                dueDate: dueDate
            }
        }, analyticsEvent);
    };
    const onHandleClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'previewBar'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'previewBar', {
            level: level
        });
        onClick({
            dates: {
                startDate: startDate,
                dueDate: dueDate
            }
        }, analyticsEvent);
    };
    const getBarBoundingClientRect = ()=>elemRef.current?.getBoundingClientRect();
    // === RENDER === //
    /* Interval items should:
   * - Not be draggable, since their dates only be set to existing intervals, not arbitrarily.
   * - Not display date labels, for the same reason as above.
   */ const isIntervalDateType = startDateType === (0, $fHtBB.INTERVAL) && dueDateType === (0, $fHtBB.INTERVAL);
    return(// NOTE: ts error needs to be fixed in withDragObserver from @atlassian/jira-drag-observer
    // @ts-expect-error - TS2322 - Type '{ children: false | Element; "data-testid": string; innerRef: MutableRefObject<unknown>; color: Color; left: number; right: number; isDisabled: boolean; onDrag: OnDrag; onDragStart: OnDragStart; onDragEnd: OnDragEnd; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props>, never> & InexactPartial<...> & InexactPartial<...>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62bb2659498a4054$var$DraggableBar, {
        "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.no-date-content.preview-bar.preview-bar",
        innerRef: elemRef,
        color: color,
        left: leftPosition,
        right: rightPosition,
        isDisabled: isIntervalDateType,
        onDrag: onDrag,
        onDragStart: onHandleDragStart,
        onDragEnd: onHandleDragEnd,
        onClick: onHandleClick
    }, !isIntervalDateType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sNQW.RoadmapDateLabels), {
        startDate: startDate,
        dueDate: dueDate,
        getBarBoundingClientRect: getBarBoundingClientRect
    })));
};
const $62bb2659498a4054$var$fadeInStyles = null;
const $62bb2659498a4054$var$baseLevelStyles = null;
const $62bb2659498a4054$var$barStyles = null;
// NOTE: There's no easy way atm to apply opacity to a color token without affecting its children
// Hence, a pseudo "before" element is used as a hack here for controlling the background color
const $62bb2659498a4054$var$indicatorStyles = null;

});





parcelRegister("jOFEQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5986aa7f955707$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $opsFH = parcelRequire("opsFH");

var $lNNXV = parcelRequire("lNNXV");

var $bl3ir = parcelRequire("bl3ir");

var $1SuDz = parcelRequire("1SuDz");
var $da5986aa7f955707$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, { id: id })=>{
    const issueChartData = (0, $1SuDz.getChartDataHash)(state)[id];
    if (issueChartData === undefined) return {
        startDate: undefined,
        dueDate: undefined,
        // it doesn't matter what level and color are because the component will return null if either dates are undefined
        level: 0,
        color: (0, $opsFH.PURPLE)
    };
    const { color: color, startDate: startDate, dueDate: dueDate, placeholder: placeholder, level: level } = issueChartData;
    return {
        color: color,
        startDate: startDate,
        dueDate: dueDate,
        placeholder: placeholder,
        level: level
    };
}, null, (stateProps)=>stateProps)((0, $bl3ir.RoadmapChartItemContentLite));

});
parcelRegister("bl3ir", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartItemContentLite", () => $637e09d5da9856a9$export$440d1bc6878927ac);

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");

var $3qiQH = parcelRequire("3qiQH");

var $cww1R = parcelRequire("cww1R");

var $iQiGF = parcelRequire("iQiGF");
const $637e09d5da9856a9$var$DateItemLite = ({ startDate: startDate, dueDate: dueDate, level: level, placeholder: placeholder, color: color })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const barLeftPosition = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const barRightPosition = (0, $cww1R.getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
    const isBarVisible = (0, $cww1R.getIsBarVisible)(barLeftPosition, barRightPosition, timelineWidth);
    if (!isBarVisible) return null;
    const theme = (0, $iQiGF.getBarTheme)(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            ...(0, $3qiQH.getBaseBarStyles)({
                level: level,
                theme: theme,
                placeholder: placeholder
            }),
            left: `${barLeftPosition}px`,
            right: `${barRightPosition}px`
        }
    });
};
const $637e09d5da9856a9$export$440d1bc6878927ac = ({ startDate: startDate, dueDate: dueDate, ...restProps })=>{
    if (startDate !== undefined && dueDate !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($637e09d5da9856a9$var$DateItemLite, {
        ...restProps,
        startDate: startDate,
        dueDate: dueDate
    });
    return null;
};

});


parcelRegister("jVmly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5bb4f87c8a7fb0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");


var $hT84n = parcelRequire("hT84n");

var $9DoTe = parcelRequire("9DoTe");

var $6LC5p = parcelRequire("6LC5p");
const $b5bb4f87c8a7fb0e$var$DndLongTaskMetric = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hT84n.DragAndDropLongTaskMetric), {
        ...props,
        metricType: (0, $028d5637f56fe710$export$3ac90e7f239a7193)
    });
const $b5bb4f87c8a7fb0e$var$mapStateToProps = (state)=>({
        isEditEnabled: (0, $9DoTe.getCanUserEdit)(state),
        DndLongTaskMetric: $b5bb4f87c8a7fb0e$var$DndLongTaskMetric
    });
var $b5bb4f87c8a7fb0e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($b5bb4f87c8a7fb0e$var$mapStateToProps, {})((0, $6LC5p.default));

});
parcelRegister("6LC5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $1befadaa5a65452d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");


var $4y1Ki = parcelRequire("4y1Ki");

var $3HSXN = parcelRequire("3HSXN");

var $VrUCp = parcelRequire("VrUCp");

var $i0pNk = parcelRequire("i0pNk");

var $5XPbs = parcelRequire("5XPbs");

var $5Hgly = parcelRequire("5Hgly");
const $1befadaa5a65452d$var$renderOverlayButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5XPbs.default), null);
const $1befadaa5a65452d$var$ChartOverlay = ({ isEditEnabled: isEditEnabled, DndLongTaskMetric: DndLongTaskMetric })=>{
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const renderPreview = (props)=>{
        const previewProps = (0, $5Hgly.getPreviewProps)(props);
        return previewProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0pNk.default), previewProps) : null;
    };
    const renderChartDragLayer = ()=>isEditEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4y1Ki.RoadmapChartDragLayer), {
            type: (0, $fbe90688b36d692e$export$48a2b55760ce2355),
            renderPreview: renderPreview,
            DndLongTaskMetric: DndLongTaskMetric
        }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            top: headerHeight
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2idpf _94n5idpf _1ltvidpf _1pbyilow"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3HSXN.RoadmapChartOverlay), {
        renderChartDragLayer: renderChartDragLayer,
        renderOverlayButton: $1befadaa5a65452d$var$renderOverlayButton
    }));
};
var $1befadaa5a65452d$export$2e2bcd8739ae039 = $1befadaa5a65452d$var$ChartOverlay;
const $1befadaa5a65452d$var$dragLayerContainerStyles = null;

});
parcelRegister("4y1Ki", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartDragLayer", () => $2ad5edd666f7787d$export$f32354274fa76e25);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");

var $94kLM = parcelRequire("94kLM");
const $2ad5edd666f7787d$var$getDefaultPreviewProps = (0, $5iWql.default)(()=>({
        item: undefined,
        clientOffset: {
            x: 0,
            y: 0
        },
        scrollOffset: {
            scrollLeft: 0,
            scrollTop: 0
        }
    }));
const $2ad5edd666f7787d$export$f32354274fa76e25 = ({ type: type, renderPreview: renderPreview, DndLongTaskMetric: DndLongTaskMetric = ()=>null })=>{
    const defaultPreviewProps = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>$2ad5edd666f7787d$var$getDefaultPreviewProps(), []);
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const [previewProps, setPreviewProps] = (0, $eUqFw.useState)(defaultPreviewProps);
    (0, $eUqFw.useEffect)(()=>(0, $3f2za.combine)((0, $eo9PV.monitorForElements)({
            onDrag: ({ source: source, location: location })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                const { current: { input: current }, initial: { input: initial } } = location;
                if (item.type === type) {
                    const { viewportBoundingRect: viewportBoundingRect, initialScrollBoundingRect: initialScrollBoundingRect, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = item;
                    const initialOffset = {
                        x: initial.pageX,
                        y: initial.pageY
                    };
                    const clientOffset = {
                        x: current.pageX,
                        y: current.pageY
                    };
                    if (initialOffset && clientOffset) {
                        const { scrollLeft: scrollLeft, scrollTop: scrollTop } = (0, $94kLM.adjustScrollPosition)(initialOffset, clientOffset, setViewportScroll, initialScrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect);
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const previewItem = source.data;
                        setPreviewProps({
                            item: previewItem,
                            clientOffset: clientOffset,
                            scrollOffset: {
                                scrollLeft: scrollLeft,
                                scrollTop: scrollTop
                            }
                        });
                    }
                    setIsDragging(true);
                }
            },
            onDrop ({ source: source }) {
                const item = source.data;
                if (item.type === type) {
                    setPreviewProps(defaultPreviewProps);
                    setIsDragging(false);
                }
            }
        })), [
        type,
        defaultPreviewProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ad5edd666f7787d$var$Container, null, renderPreview(previewProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: isDragging
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ad5edd666f7787d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _154iidpf _1xi2idpf _94n5idpf _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3HSXN", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartOverlay", () => $be74f6f5f99a2415$export$74441df56fec708f);

var $eUqFw = parcelRequire("eUqFw");
const $be74f6f5f99a2415$export$74441df56fec708f = ({ renderChartDragLayer: renderChartDragLayer = ()=>null, renderOverlayButton: renderOverlayButton = ()=>null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderOverlayButton(), renderChartDragLayer());

});

parcelRegister("i0pNk", function(module, exports) {

$parcel$export(module.exports, "default", () => $95615934f4347838$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9E22T = parcelRequire("9E22T");

var $4c5Cq = parcelRequire("4c5Cq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95615934f4347838$var$mergeProps = (stateProps, _, { id: id, ...ownProps })=>({
        ...stateProps,
        ...ownProps
    });
var $95615934f4347838$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, ownProps)=>({
        color: (0, $9E22T.getIssueParentColor)(state, ownProps.id)
    }), null, $95615934f4347838$var$mergeProps)((0, $4c5Cq.default));

});
parcelRegister("4c5Cq", function(module, exports) {

$parcel$export(module.exports, "default", () => $57279c57ff215814$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $opsFH = parcelRequire("opsFH");

var $kjGqG = parcelRequire("kjGqG");

var $coVET = parcelRequire("coVET");
const $57279c57ff215814$var$DependencyLinePreview = ({ x0: x0, y0: y0, x: x, y: y, width: width, height: height, color: color })=>{
    const theme = (0, $kjGqG.dependencyThemes)[color];
    const top = y - 5;
    const left = x - 5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coVET.default), {
        color: theme.icon,
        top: top,
        left: left
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: width,
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("line", {
        style: {
            stroke: theme.line
        },
        x1: x0,
        y1: y0,
        x2: left,
        y2: top,
        className: (0, $7JEyt.default)([
            "_1snbcs5v _134c892t _lswuglyw"
        ])
    })));
};
$57279c57ff215814$var$DependencyLinePreview.defaultProps = {
    color: (0, $opsFH.PURPLE)
};
var $57279c57ff215814$export$2e2bcd8739ae039 = $57279c57ff215814$var$DependencyLinePreview;
const $57279c57ff215814$var$lineStyles = null;

});
parcelRegister("coVET", function(module, exports) {

$parcel$export(module.exports, "default", () => $4db07170a733e07c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1KNKa = parcelRequire("1KNKa");
const $4db07170a733e07c$var$DependencyIcon = ({ top: top, left: left, color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4db07170a733e07c$var$wrapperStyles,
        style: {
            top: top,
            left: left
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KNKa.DependencyDragHandler), {
        color: color
    }));
var $4db07170a733e07c$export$2e2bcd8739ae039 = $4db07170a733e07c$var$DependencyIcon;
const $4db07170a733e07c$var$wrapperStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    display: 'flex',
    width: "var(--ds-space-250, 20px)",
    height: "var(--ds-space-250, 20px)",
    transform: 'translate(-10px, -10px)'
});

});



parcelRegister("5XPbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5c7ddbd9fdd9c9$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lgKTA = parcelRequire("lgKTA");

var $dg6pj = parcelRequire("dg6pj");
var $ad5c7ddbd9fdd9c9$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        isMacroView: (0, $lgKTA.hasMacroConfig)(state)
    }), {})((0, $dg6pj.OverlayButton));

});
parcelRegister("dg6pj", function(module, exports) {

$parcel$export(module.exports, "OverlayButton", () => $43eaa17cbe71064a$export$8b82a61f37322af9);

var $eUqFw = parcelRequire("eUqFw");

var $6ZVGV = parcelRequire("6ZVGV");

var $eb6jM = parcelRequire("eb6jM");

var $9pngN = parcelRequire("9pngN");

var $i6oRi = parcelRequire("i6oRi");

var $8rQuz = parcelRequire("8rQuz");

var $2YVIU = parcelRequire("2YVIU");

var $aVqO8 = parcelRequire("aVqO8");
// NOTE: We are confident that the queried elements with the given id will always be HTMLElement | null
const $43eaa17cbe71064a$var$getFullscreenRefs = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Array.from(document.querySelectorAll('[data-fullscreen-id]'));
const $43eaa17cbe71064a$export$8b82a61f37322af9 = ({ isMacroView: isMacroView })=>{
    const toolbarItems = [
        {
            id: 'today-button',
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6oRi.RoadmapTodayButton), null),
            showDivider: false
        },
        {
            id: 'timeline-mode-switcher',
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVqO8.default), null)
        },
        {
            id: 'legend',
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2YVIU.default), null)
        },
        {
            id: 'fullscreen-button',
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eb6jM.default), {
                testId: "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.fullscreen-button",
                getCustomRefs: $43eaa17cbe71064a$var$getFullscreenRefs,
                withContainerStyles: false,
                isSubtle: (0, $8rQuz.isVisualRefreshEnabled)()
            }),
            isVisible: !isMacroView,
            showDivider: false
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 2,
        id: "software-roadmap-timeline-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZVGV.default), {
        items: toolbarItems
    }));
};

});
parcelRegister("6ZVGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $757469c09e5a7167$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $9xXn5 = parcelRequire("9xXn5");

var $6EfnZ = parcelRequire("6EfnZ");

var $a4cVy = parcelRequire("a4cVy");

var $fCmfi = parcelRequire("fCmfi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $1m2F9 = parcelRequire("1m2F9");

var $6WuW8 = parcelRequire("6WuW8");
const $757469c09e5a7167$var$renderItem = (key, component, showDivider)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
        key: key
    }, showDivider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($757469c09e5a7167$var$Divider, null), component);
const $757469c09e5a7167$var$Toolbar = ({ items: items, isCollapsible: isCollapsible = true })=>{
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(true);
    const toggleIsExpanded = (0, $eUqFw.useCallback)(()=>{
        if (isCollapsible) setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        isCollapsible,
        setIsExpanded
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isExpanded && !isCollapsible) setIsExpanded(true);
    }, [
        isExpanded,
        isCollapsible,
        setIsExpanded
    ]);
    const renderContent = ()=>items.filter(({ isVisible: isVisible = true })=>isVisible).map(({ id: id, element: element, showDivider: showDivider }, index)=>$757469c09e5a7167$var$renderItem(id, element, (0, $8rQuz.isVisualRefreshEnabled)() && showDivider !== undefined ? showDivider : isCollapsible || index !== 0));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const COLLAPSED_WIDTH = (0, $8rQuz.isVisualRefreshEnabled)() ? '0px' : '32px';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($757469c09e5a7167$var$TimelineToolbarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6WuW8.default), {
        isExpanded: isExpanded,
        collapsedWidth: COLLAPSED_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($757469c09e5a7167$var$TimelineToolbarContainer, null, !(0, $8rQuz.isVisualRefreshEnabled)() && isCollapsible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "aais-timeline-toolbar.ui.container.expand-button",
        appearance: "subtle",
        onClick: toggleIsExpanded,
        iconBefore: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6EfnZ))), {
            label: formatMessage((0, $1m2F9.default).expandButtonLabel)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9xXn5))), {
            label: formatMessage((0, $1m2F9.default).collapseButtonLabel)
        }),
        "aria-expanded": isExpanded
    }), renderContent())), (0, $8rQuz.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        label: isExpanded ? formatMessage((0, $1m2F9.default).expandButtonLabel) : formatMessage((0, $1m2F9.default).collapseButtonLabel),
        "aria-expanded": isExpanded,
        testId: "aais-timeline-toolbar.ui.container.expand-button",
        appearance: "subtle",
        onClick: toggleIsExpanded,
        icon: ()=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCmfi))), {
                label: "",
                color: "currentColor"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a4cVy))), {
                label: "",
                color: "currentColor"
            })
    }));
};
var $757469c09e5a7167$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $757469c09e5a7167$var$Toolbar;
const $757469c09e5a7167$var$Divider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkb5v6 _4t3i1tcg _1bsbt94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $757469c09e5a7167$var$TimelineToolbarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhp5a _1yt41b66 _1e0c1txw _19ith6cr _2rko1l7b _16qscbcv _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $757469c09e5a7167$var$TimelineToolbarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66 _1o9zidpf _1puhidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9xXn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f35400da13b72d7$var$_react = $6f35400da13b72d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6f35400da13b72d7$var$_chevronLeft = $6f35400da13b72d7$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $6f35400da13b72d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6f35400da13b72d7$var$ChevronLeftCircleIcon = (props)=>/*#__PURE__*/ $6f35400da13b72d7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></g></svg>`
    }, props, {
        newIcon: $6f35400da13b72d7$var$_chevronLeft.default,
        iconType: "utility"
    }));
$6f35400da13b72d7$var$ChevronLeftCircleIcon.displayName = 'ChevronLeftCircleIcon';
var $6f35400da13b72d7$var$_default = module.exports.default = $6f35400da13b72d7$var$ChevronLeftCircleIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("6EfnZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d7269d0f6dcc3b2$var$_react = $4d7269d0f6dcc3b2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4d7269d0f6dcc3b2$var$_chevronRight = $4d7269d0f6dcc3b2$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $4d7269d0f6dcc3b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4d7269d0f6dcc3b2$var$ChevronRightCircleIcon = (props)=>/*#__PURE__*/ $4d7269d0f6dcc3b2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
    }, props, {
        newIcon: $4d7269d0f6dcc3b2$var$_chevronRight.default,
        iconType: "utility"
    }));
$4d7269d0f6dcc3b2$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
var $4d7269d0f6dcc3b2$var$_default = module.exports.default = $4d7269d0f6dcc3b2$var$ChevronRightCircleIcon;

});

parcelRegister("1m2F9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b5f60b33750ccdf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8b5f60b33750ccdf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    expandButtonLabel: {
        "id": "aais-timeline-toolbar.container.expand-button-label",
        "defaultMessage": "Expand timeline time period buttons"
    },
    collapseButtonLabel: {
        "id": "aais-timeline-toolbar.container.collapse-button-label",
        "defaultMessage": "Collapse timeline time period buttons"
    }
});

});

parcelRegister("6WuW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2691faf6e55dd81a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $5LHuc = parcelRequire("5LHuc");
var $8YJjX = parcelRequire("8YJjX");

var $9zysr = parcelRequire("9zysr");

var $8rQuz = parcelRequire("8rQuz");
const $2691faf6e55dd81a$var$WidthExpander = ({ isExpanded: isExpanded, collapsedWidth: collapsedWidth, children: children })=>{
    const [width, setWidth] = (0, $eUqFw.useState)(isExpanded ? 'auto' : collapsedWidth);
    const prefersReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const duration = prefersReducedMotion ? 0 : (0, $5LHuc.mediumDurationMs);
    const isFirstRender = (0, $eUqFw.useRef)(true);
    const state = (0, $eUqFw.useRef)(isExpanded ? 'expanded' : 'collapsed');
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (ref.current === null) return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
        }
        if (prefersReducedMotion) {
            setWidth(isExpanded ? 'auto' : collapsedWidth);
            return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
        }
        const expandedWidth = `${ref.current.offsetWidth}px`;
        if (state.current === 'transitioning') setWidth(isExpanded ? expandedWidth : collapsedWidth);
        else setWidth(expandedWidth);
        const immediate = setTimeout(()=>{
            if (!isExpanded) setWidth(collapsedWidth);
            state.current = 'transitioning';
        }, 1);
        const afterDuration = setTimeout(()=>{
            if (isExpanded) setWidth('auto');
            state.current = isExpanded ? 'expanded' : 'collapsed';
        }, (0, $5LHuc.mediumDurationMs));
        return ()=>{
            clearTimeout(immediate);
            clearTimeout(afterDuration);
        };
    }, [
        isExpanded,
        collapsedWidth,
        duration,
        prefersReducedMotion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2691faf6e55dd81a$var$OuterWrapper, {
        width: width,
        duration: duration,
        "data-testid": "aais-timeline-toolbar.ui.container.width-expander"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2691faf6e55dd81a$var$InnerWrapper, {
        ref: ref
    }, children));
};
var $2691faf6e55dd81a$export$2e2bcd8739ae039 = $2691faf6e55dd81a$var$WidthExpander;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2691faf6e55dd81a$var$OuterWrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { duration: duration, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width),
            "--_7nn7wk": (0, $9t7rW.default)(`width ${__cmplp.duration}ms ${(0, $d58b680a02f4d6a4$export$c07234257a03d5e9)}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu",
            __cmplp.className
        ])
    });
});
const $2691faf6e55dd81a$var$OuterWrapperNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { duration: duration, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width),
            "--_7nn7wk": (0, $9t7rW.default)(`width ${__cmplp.duration}ms ${(0, $d58b680a02f4d6a4$export$c07234257a03d5e9)}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $2691faf6e55dd81a$var$OuterWrapper = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $2691faf6e55dd81a$var$OuterWrapperNew, $2691faf6e55dd81a$var$OuterWrapperOld);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2691faf6e55dd81a$var$InnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';



parcelRegister("eb6jM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e63f1a697a100911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5kZSr = parcelRequire("5kZSr");

const $e63f1a697a100911$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $eUqFw.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kZSr.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton,
        shouldRenderContent: shouldRenderContent,
        isSubtle: isSubtle
    });
};
$e63f1a697a100911$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $e63f1a697a100911$export$2e2bcd8739ae039 = $e63f1a697a100911$var$FullscreenButton;

});
parcelRegister("5kZSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b04dcc2d32cc90b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $fuqD0 = parcelRequire("fuqD0");

var $a0tyn = parcelRequire("a0tyn");

var $2eG9N = parcelRequire("2eG9N");

var $9aFSa = parcelRequire("9aFSa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $Qx7Xg = parcelRequire("Qx7Xg");

var $6FP8W = parcelRequire("6FP8W");

var $jMP2a = parcelRequire("jMP2a");

var $eDgaT = parcelRequire("eDgaT");

var $8rQuz = parcelRequire("8rQuz");

var $ffL85 = parcelRequire("ffL85");
const $1b04dcc2d32cc90b$var$removeFullScreenStyle = (customRefs)=>{
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $1b04dcc2d32cc90b$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const customRefElements = (0, $eUqFw.useRef)(null);
    const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, $Qx7Xg.useIsFullscreen)();
    const globalStyle = document.createElement('style');
    const isFullscreen = (0, $6FP8W.getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
    const handleKeysInFullScreen = (0, $eUqFw.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
         // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (!(0, $6FP8W.getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
            // In Nav4 these keyboard shortcuts are rendered by the tab navigation
            // so they are not available in fullscreen mode
            onToggle(true, globalStyle);
            const customRefs = customRefElements.current;
            $1b04dcc2d32cc90b$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isFullscreen) window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else window?.removeEventListener('keydown', handleKeysInFullScreen, true);
        return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $eUqFw.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }";
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        globalStyle.id = 'fullscreen-global-style';
        globalStyle.appendChild(hiddenStylesNode);
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (event, analyticsEvent)=>{
        if ((0, $6FP8W.getWillShowNav4)()) {
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreenLayout
            };
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            setIsFullScreenLayout(!isFullscreenLayout);
            onToggle(!isFullscreenLayout);
        } else {
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreen
            };
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            onToggle(isFullscreen, globalStyle);
            if (isFullscreen) $1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
            else createFullScreenStyle();
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
        return ()=>$1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // exit fullscreen mode when moving to a different page
        return ()=>{
            if ((0, $6FP8W.getWillShowNav4)()) setIsFullScreenLayout(false);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderButtonWithTooltip = ()=>{
        if ((0, $8rQuz.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            label: isFullscreen ? formatMessage((0, $ffL85.default).exitFullScreen) : formatMessage((0, $ffL85.default).enterFullScreen),
            onClick: onClick,
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($a0tyn))) : (0, (/*@__PURE__*/$parcel$interopDefault($fuqD0))),
            appearance: isSubtle ? 'subtle' : 'default',
            isTooltipDisabled: false
        });
        if (renderAsResponsiveButton && !(0, $8rQuz.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $ffL85.default).exitFullScreen) : formatMessage((0, $ffL85.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($a0tyn))) : (0, (/*@__PURE__*/$parcel$interopDefault($fuqD0))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage(isFullscreen ? (0, $ffL85.default).exitFullScreen : (0, $ffL85.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a0tyn))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $ffL85.default).exitFullScreen),
                spacing: "spacious"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fuqD0))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $ffL85.default).enterFullScreen),
                spacing: "spacious"
            })
        }));
    };
    const keyMap = {
        z: {
            callback: ()=>{
                setIsFullScreenLayout(!isFullscreenLayout);
            }
        }
    };
    if (!shouldRenderContent) return null;
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b04dcc2d32cc90b$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip(), (0, $6FP8W.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderButtonWithTooltip(), (0, $6FP8W.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap
    }));
};
var $1b04dcc2d32cc90b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1b04dcc2d32cc90b$var$FullscreenButton;
const $1b04dcc2d32cc90b$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1sit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fuqD0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a044223350e041031a35374685e9a4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b46e502511b170a5$var$_react = $b46e502511b170a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b46e502511b170a5$var$_growDiagonal = $b46e502511b170a5$var$_interopRequireDefault((parcelRequire("8TYN8")));

var $b46e502511b170a5$var$_actualSize = $b46e502511b170a5$var$_interopRequireDefault((parcelRequire("22LS1")));
function $b46e502511b170a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b46e502511b170a5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $b46e502511b170a5$var$_react.default.createElement($b46e502511b170a5$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $b46e502511b170a5$var$_actualSize.default
    }, props));
$b46e502511b170a5$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $b46e502511b170a5$var$_default = module.exports.default = $b46e502511b170a5$var$GrowDiagonalIcon;

});
parcelRegister("8TYN8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f990ef7feacad13ce09338893186ed73>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b29db82a7ea305$var$_react = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $67b29db82a7ea305$var$_UNSAFE_baseNew = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $67b29db82a7ea305$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b29db82a7ea305$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $67b29db82a7ea305$var$_react.default.createElement($67b29db82a7ea305$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
    }, props));
$67b29db82a7ea305$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $67b29db82a7ea305$var$_default = module.exports.default = $67b29db82a7ea305$var$GrowDiagonalIcon;

});

parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $17d0e6b497755428$var$_growDiagonal = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("8TYN8")));
function $17d0e6b497755428$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $17d0e6b497755428$var$_growDiagonal.default
    }));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = module.exports.default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;

});


parcelRegister("a0tyn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b2e8bb6e01e7e0a7a6c4696ef5279cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7490d42ee3596654$var$_react = $7490d42ee3596654$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7490d42ee3596654$var$_shrinkDiagonal = $7490d42ee3596654$var$_interopRequireDefault((parcelRequire("34ons")));

var $7490d42ee3596654$var$_fitToPage = $7490d42ee3596654$var$_interopRequireDefault((parcelRequire("drWMe")));
function $7490d42ee3596654$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7490d42ee3596654$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $7490d42ee3596654$var$_react.default.createElement($7490d42ee3596654$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $7490d42ee3596654$var$_fitToPage.default
    }, props));
$7490d42ee3596654$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $7490d42ee3596654$var$_default = module.exports.default = $7490d42ee3596654$var$ShrinkDiagonalIcon;

});
parcelRegister("34ons", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::093b1e9b17ed5e0dd45627fbe3b0508b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23c4a7a9c7073b1c$var$_react = $23c4a7a9c7073b1c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $23c4a7a9c7073b1c$var$_UNSAFE_baseNew = $23c4a7a9c7073b1c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $23c4a7a9c7073b1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23c4a7a9c7073b1c$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $23c4a7a9c7073b1c$var$_react.default.createElement($23c4a7a9c7073b1c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
    }, props));
$23c4a7a9c7073b1c$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $23c4a7a9c7073b1c$var$_default = module.exports.default = $23c4a7a9c7073b1c$var$ShrinkDiagonalIcon;

});

parcelRegister("drWMe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cab63de7a2a3a02$var$_react = $9cab63de7a2a3a02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9cab63de7a2a3a02$var$_shrinkDiagonal = $9cab63de7a2a3a02$var$_interopRequireDefault((parcelRequire("34ons")));
function $9cab63de7a2a3a02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $9cab63de7a2a3a02$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $9cab63de7a2a3a02$var$_shrinkDiagonal.default
    }));
$9cab63de7a2a3a02$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $9cab63de7a2a3a02$var$_default = module.exports.default = $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon;

});


parcelRegister("ffL85", function(module, exports) {

$parcel$export(module.exports, "default", () => $20d24ea35e7158d0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $20d24ea35e7158d0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    }
});

});



parcelRegister("9pngN", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $c006a225e0f72214$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $5GxEP = parcelRequire("5GxEP");

var $71g00 = parcelRequire("71g00");
const $c006a225e0f72214$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    const portalWrapper = (0, $eUqFw.useRef)(document.createElement('div'));
    const container = (0, $71g00.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $71g00.useBottomRightCornerActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$StyledOutlet, null, children), portalWrapper.current);
};
const $c006a225e0f72214$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c006a225e0f72214$var$StyledOutlet = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("i6oRi", function(module, exports) {

$parcel$export(module.exports, "RoadmapTodayButton", () => $3fa52422bc3b33f8$export$5fc60be363e9a750);

var $eUqFw = parcelRequire("eUqFw");

var $1SqWq = parcelRequire("1SqWq");

var $jMP2a = parcelRequire("jMP2a");

var $3XwA1 = parcelRequire("3XwA1");

var $kAsWD = parcelRequire("kAsWD");
const $3fa52422bc3b33f8$export$5fc60be363e9a750 = ()=>{
    const [{ timelineOriginPosition: timelineOriginPosition }] = (0, $3XwA1.useTimelineState)();
    const onClickCallback = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'todayButton');
        (0, $kAsWD.timelineScroller).scrollTo({
            left: timelineOriginPosition
        });
    }, [
        timelineOriginPosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SqWq.default), {
        onClick: onClickCallback
    });
};

});
parcelRegister("1SqWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $34cf626268fb34aa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hcwQN = parcelRequire("hcwQN");
const $34cf626268fb34aa$var$TodayButton = ({ onClick: onClick, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "subtle",
        onClick: onClick
    }, formatMessage((0, $hcwQN.default).today));
};
var $34cf626268fb34aa$export$2e2bcd8739ae039 = $34cf626268fb34aa$var$TodayButton;

});
parcelRegister("hcwQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a676279f6b60d04$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$0a676279f6b60d04$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    today: {
        "id": "aais-timeline-toolbar.today-button.today",
        "defaultMessage": "Today"
    }
});

});


parcelRegister("kAsWD", function(module, exports) {

$parcel$export(module.exports, "timelineScroller", () => $b676217d7d50af48$export$e3f9523c9658dc67);
$parcel$export(module.exports, "useTimelineScroller", () => $b676217d7d50af48$export$8b6469154a100351);

var $gf0vG = parcelRequire("gf0vG");
/* Components from all over the node tree have functionality that involves scrolling the timeline.
 * React has not been able to simply fulfil our requirements, so back to vanilla JS we go.
 */ const $b676217d7d50af48$var$scrollTo = ({ left: left, top: top })=>{
    const timelineElem = document.getElementById((0, $gf0vG.TIMELINE_ID));
    if (timelineElem !== null) {
        if (left !== undefined) timelineElem.scrollLeft = left;
        if (top !== undefined) timelineElem.scrollTop = top;
    }
};
const $b676217d7d50af48$var$getScrollLeft = ()=>{
    const timelineElem = document.getElementById((0, $gf0vG.TIMELINE_ID));
    if (timelineElem !== null) return timelineElem.scrollLeft;
    return 0;
};
const $b676217d7d50af48$var$getVisibleWidth = ()=>{
    const timelineElem = document.getElementById((0, $gf0vG.TIMELINE_ID));
    if (timelineElem !== null) return timelineElem.clientWidth;
    return 0;
};
const $b676217d7d50af48$export$e3f9523c9658dc67 = {
    scrollTo: $b676217d7d50af48$var$scrollTo,
    getScrollLeft: $b676217d7d50af48$var$getScrollLeft,
    getVisibleWidth: $b676217d7d50af48$var$getVisibleWidth
};
const $b676217d7d50af48$export$8b6469154a100351 = ()=>$b676217d7d50af48$export$e3f9523c9658dc67;

});


parcelRegister("2YVIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bbeae9a27b86133$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gk7tF = parcelRequire("gk7tF");


var $5ACdq = parcelRequire("5ACdq");

var $l50sF = parcelRequire("l50sF");

var $eZlhy = parcelRequire("eZlhy");

var $3xO0T = parcelRequire("3xO0T");

var $23bph = parcelRequire("23bph");

var $1guBK = parcelRequire("1guBK");

var $52uZH = parcelRequire("52uZH");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k0eVM = parcelRequire("k0eVM");
const $7bbeae9a27b86133$var$Legend = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sprintsMessage = formatMessage((0, $k0eVM.default).sprints);
    const dependencyMessage = formatMessage((0, $k0eVM.default).dependency);
    const rollupMessage = formatMessage((0, $k0eVM.default).rollup);
    const noEndDateMessage = formatMessage((0, $k0eVM.default).noEndDate);
    const noStartDateMessage = formatMessage((0, $k0eVM.default).noStartDate);
    const releasedMessage = formatMessage((0, $k0eVM.default).released);
    const unreleasedMessage = formatMessage((0, $k0eVM.default).unreleased);
    const overdueMessage = formatMessage((0, $k0eVM.default).overdue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZlhy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $k0eVM.default).general)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gk7tF))), {
            size: "medium",
            label: sprintsMessage,
            primaryColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`
        }),
        label: sprintsMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3xO0T.default), {
            label: dependencyMessage
        }),
        label: dependencyMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $52uZH.default), {
            label: rollupMessage
        }),
        label: rollupMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $k0eVM.default).issueBars)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23bph.default), {
            type: "noEndDate"
        }),
        label: noEndDateMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23bph.default), {
            type: "noStartDate"
        }),
        label: noStartDateMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $k0eVM.default).releases)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1guBK.default), {
            type: "released"
        }),
        label: releasedMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1guBK.default), {
            type: "unreleased"
        }),
        label: unreleasedMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1guBK.default), {
            type: "overdue"
        }),
        label: overdueMessage
    })));
};
var $7bbeae9a27b86133$export$2e2bcd8739ae039 = $7bbeae9a27b86133$var$Legend;

});
parcelRegister("5ACdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ab9e08b61d1f0ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1ab9e08b61d1f0ce$var$LegendItem = ({ symbol: symbol, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ab9e08b61d1f0ce$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ab9e08b61d1f0ce$var$Symbol, null, symbol), label);
var $1ab9e08b61d1f0ce$export$2e2bcd8739ae039 = $1ab9e08b61d1f0ce$var$LegendItem;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ab9e08b61d1f0ce$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1n3s _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $1ab9e08b61d1f0ce$var$Symbol = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1ul91tcg _4t3igktf _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("l50sF", function(module, exports) {

$parcel$export(module.exports, "default", () => $43557a5716ebe6b1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $43557a5716ebe6b1$var$LegendSection = ({ title: title, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($43557a5716ebe6b1$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_syaz1gjq _11c816g6 _vwz4v47k"
        ])
    }, title), children);
var $43557a5716ebe6b1$export$2e2bcd8739ae039 = $43557a5716ebe6b1$var$LegendSection;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $43557a5716ebe6b1$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $43557a5716ebe6b1$var$TitleStyles = null;

});

parcelRegister("eZlhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d74b7a197f5296e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $h6FFs = parcelRequire("h6FFs");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $dnJL9 = parcelRequire("dnJL9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4vep8 = parcelRequire("4vep8");

var $4Rc2B = parcelRequire("4Rc2B");

var $cVePX = parcelRequire("cVePX");
const $7d74b7a197f5296e$var$Legend = ({ children: children, defaultIsOpen: defaultIsOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultIsOpen);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClose = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'legend closed');
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        setIsOpen
    ]);
    const onToggle = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'legendButton');
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `legend ${isOpen ? 'closed' : 'opened'}`);
        setIsOpen((value)=>!value);
    }, [
        isOpen
    ]);
    const renderContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVePX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $7d74b7a197f5296e$var$legendContentStyles,
            paddingInline: "space.200",
            paddingBlock: "space.250"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.250"
        }, children))), [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        isOpen: isOpen,
        placement: "top-end",
        onClose: onClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onToggle,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($h6FFs))),
                isTooltipDisabled: false,
                label: formatMessage((0, $4Rc2B.default).legend),
                tooltip: {
                    position: 'top'
                },
                appearance: "subtle"
            }),
        content: renderContent,
        label: formatMessage((0, $4Rc2B.default).legend),
        id: "timeline-legend",
        role: "dialog",
        shouldUseCaptureOnOutsideClick: true
    });
};
const $7d74b7a197f5296e$var$legendContentStyles = (0, $1ZAYh.xcss)({
    boxSizing: 'content-box',
    minWidth: `calc(${"var(--ds-space-100, 8px)"} * 35)`
});
var $7d74b7a197f5296e$export$2e2bcd8739ae039 = (0, $dnJL9.componentWithFG)('update_icon_on_timeline_legend', $7d74b7a197f5296e$var$Legend, (0, $4vep8.default));

});
parcelRegister("4vep8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3fde390a888c678$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3MV1G = parcelRequire("3MV1G");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8rBMV = parcelRequire("8rBMV");

var $cCohR = parcelRequire("cCohR");
const $c3fde390a888c678$var$Legend = ({ showLabel: showLabel = false, children: children, defaultIsOpen: defaultIsOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultIsOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const toggleLegend = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `legend ${isOpen ? 'closed' : 'opened'}`);
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'legend closed');
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        setIsOpen
    ]);
    const renderTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: triggerProps.ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rBMV.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleLegend,
            showLabel: showLabel
        })), [
        isOpen,
        showLabel,
        toggleLegend
    ]);
    const renderContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCohR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3fde390a888c678$var$LegendRoot, null, children)), [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        placement: "top-end",
        isOpen: isOpen,
        onClose: onClose,
        trigger: renderTrigger,
        content: renderContent,
        shouldUseCaptureOnOutsideClick: true
    });
};
var $c3fde390a888c678$export$2e2bcd8739ae039 = $c3fde390a888c678$var$Legend;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3fde390a888c678$var$LegendRoot = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1yt417la _zulpv47k _1ul91178",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8rBMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5798aeeb6df5288$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $2bv8J = parcelRequire("2bv8J");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $gQL4Z = parcelRequire("gQL4Z");
const $f5798aeeb6df5288$var$LegendButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, showLabel: showLabel, ...rest }, _ref)=>{
    const { isSelected: isSelected } = rest;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClickCallback = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'legendButton');
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $gQL4Z.default).legend),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
            label: formatMessage((0, $gQL4Z.default).legend),
            secondaryColor: `var(--ds-surface, ${isSelected ? (0, $73a5c9d720aa66e1$export$ad0bacf983b7ddaa) : (0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
            size: "medium"
        }),
        appearance: "subtle",
        onClick: onClickCallback,
        ...rest
    }, showLabel && formatMessage((0, $gQL4Z.default).legend)));
});
var $f5798aeeb6df5288$export$2e2bcd8739ae039 = $f5798aeeb6df5288$var$LegendButton;

});
parcelRegister("gQL4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $94a07d66b8e8e2dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$94a07d66b8e8e2dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    legend: {
        "id": "aais-timeline-legend.legend.legend-button.legend",
        "defaultMessage": "Legend"
    }
});

});


parcelRegister("cCohR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8babf5ee57252162$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $8babf5ee57252162$var$DEFAULT_OFFSET = 24;
const $8babf5ee57252162$var$ShrinkToFit = ({ children: children })=>{
    const [bottomOffset, setBottomOffset] = (0, $eUqFw.useState)($8babf5ee57252162$var$DEFAULT_OFFSET);
    const rootRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        /**
     * Wait until animation frame before taking measurement, because popup does not position correctly straight
     * away for *some reason*.
     */ const animationFrame = requestAnimationFrame(()=>{
            if (!rootRef.current) return;
            const rect = rootRef.current.getBoundingClientRect();
            const distanceFromBottom = window.innerHeight - rect.bottom;
            setBottomOffset(distanceFromBottom);
        });
        return ()=>cancelAnimationFrame(animationFrame);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8babf5ee57252162$var$Container, {
        ref: rootRef,
        bottomOffset: bottomOffset,
        topOffset: $8babf5ee57252162$var$DEFAULT_OFFSET
    }, children);
};
var $8babf5ee57252162$export$2e2bcd8739ae039 = $8babf5ee57252162$var$ShrinkToFit;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8babf5ee57252162$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { bottomOffset: bottomOffset, topOffset: topOffset, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1o4tium": (0, $9t7rW.default)(`calc(100vh - ${__cmplp.bottomOffset}px - ${__cmplp.topOffset}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l1oqz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4Rc2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b209df4ca7ccc333$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$b209df4ca7ccc333$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    legend: {
        "id": "aais-timeline-legend.legend.legend-button.legend",
        "defaultMessage": "Legend"
    }
});

});

parcelRegister("cVePX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7444b73b294f6062$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
const $7444b73b294f6062$var$DEFAULT_OFFSET = 24;
const $7444b73b294f6062$var$ShrinkToFit = ({ children: children })=>{
    const [bottomOffset, setBottomOffset] = (0, $eUqFw.useState)($7444b73b294f6062$var$DEFAULT_OFFSET);
    const rootRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        /**
		 * Wait until animation frame before taking measurement, because popup does not position correctly straight
		 * away for *some reason*.
		 */ const animationFrame = requestAnimationFrame(()=>{
            if (!rootRef.current) return;
            const rect = rootRef.current.getBoundingClientRect();
            const distanceFromBottom = window.innerHeight - rect.bottom;
            setBottomOffset(distanceFromBottom);
        });
        return ()=>cancelAnimationFrame(animationFrame);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: rootRef,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            maxHeight: `calc(100vh - ${bottomOffset}px - ${$7444b73b294f6062$var$DEFAULT_OFFSET}px)`
        }
    }, children);
};
var $7444b73b294f6062$export$2e2bcd8739ae039 = $7444b73b294f6062$var$ShrinkToFit;

});


parcelRegister("3xO0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $41146912321bd6d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3fJGp = parcelRequire("3fJGp");

const $41146912321bd6d8$var$DependenciesIcon = ({ label: label, withWarning: withWarning = false })=>withWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41146912321bd6d8$var$Container, {
        backgroundColor: `var(--ds-background-danger, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
        size: "medium",
        key: "dependencies",
        label: label,
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
        size: "medium",
        key: "dependencies",
        label: label
    });
var $41146912321bd6d8$export$2e2bcd8739ae039 = $41146912321bd6d8$var$DependenciesIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $41146912321bd6d8$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15cr _bfhk3qkl _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3fJGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e63580bbd9aab7$var$_react = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $25e63580bbd9aab7$var$_link = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $25e63580bbd9aab7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25e63580bbd9aab7$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $25e63580bbd9aab7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $25e63580bbd9aab7$var$_link.default
    }));
$25e63580bbd9aab7$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $25e63580bbd9aab7$var$_default = module.exports.default = $25e63580bbd9aab7$var$EditorLinkIcon;

});


parcelRegister("23bph", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1175ce96efe0f52$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $c1175ce96efe0f52$var$getIssueBarContents = (type)=>{
    const color = `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`;
    switch(type){
        case 'noStartDate':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "53",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
                id: "noStartDate",
                gradientUnits: "userSpaceOnUse"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
                stopColor: color,
                stopOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
                offset: ".75",
                stopColor: color
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: "url(#noStartDate)"
            }));
        case 'noEndDate':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "53",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
                id: "noEndDate",
                gradientUnits: "userSpaceOnUse"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
                offset: "0.25",
                stopColor: color
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
                offset: "1",
                stopColor: color,
                stopOpacity: "0"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: "url(#noEndDate)"
            }));
        case 'rollupDates':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "53",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("pattern", {
                id: "rollupDates",
                patternUnits: "userSpaceOnUse",
                width: "12",
                height: "12",
                x: "6",
                y: "0",
                patternTransform: "rotate(27.5)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("line", {
                x1: "3",
                y1: "0",
                x2: "3",
                y2: "12",
                opacity: "0.5",
                stroke: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$export$c2e91cbeada39b8b)})`,
                strokeWidth: "6"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: color
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: "url(#rollupDates)"
            }));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "53",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: color
            }));
    }
};
const $c1175ce96efe0f52$var$IssueBarIcon = ({ type: type })=>$c1175ce96efe0f52$var$getIssueBarContents(type);
var $c1175ce96efe0f52$export$2e2bcd8739ae039 = $c1175ce96efe0f52$var$IssueBarIcon;

});

parcelRegister("1guBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8373cd8a94a3f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $1c8373cd8a94a3f9$var$getIconColor = (type)=>{
    switch(type){
        case 'released':
            return `var(--ds-icon-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
        case 'unreleased':
            return `var(--ds-icon-information, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
        case 'overdue':
        case 'overdue-arj':
        default:
            return `var(--ds-icon-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
    }
};
const $1c8373cd8a94a3f9$var$getIconContents = (type)=>{
    switch(type){
        case 'released':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M11.707 6.707a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
                fill: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
            }));
        case 'overdue':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M7 4a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V4Zm1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
            }));
        case 'overdue-arj':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: "4",
                y: "7",
                width: "8",
                height: "2",
                rx: "1",
                fill: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
            }));
        case 'unreleased':
        default:
            return undefined;
    }
};
const $1c8373cd8a94a3f9$var$ReleaseStatusIcon = ({ type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c8373cd8a94a3f9$var$Container, {
        backgroundColor: $1c8373cd8a94a3f9$var$getIconColor(type)
    }, $1c8373cd8a94a3f9$var$getIconContents(type));
var $1c8373cd8a94a3f9$export$2e2bcd8739ae039 = $1c8373cd8a94a3f9$var$ReleaseStatusIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c8373cd8a94a3f9$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15cr _bfhk3qkl _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("52uZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e16b5a99cfd9d70$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

const $2e16b5a99cfd9d70$var$getIconContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m14.586 9-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 11H10a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0v-7a3 3 0 0 1 3-3h4.586Z",
        fill: "currentColor"
    }));
const $2e16b5a99cfd9d70$var$RollupIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $2e16b5a99cfd9d70$var$getIconContents,
        size: "medium",
        label: label,
        primaryColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`
    });
var $2e16b5a99cfd9d70$export$2e2bcd8739ae039 = $2e16b5a99cfd9d70$var$RollupIcon;

});

parcelRegister("k0eVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8721a1ab09afc6a7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$8721a1ab09afc6a7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    // Section Titles
    general: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.general",
        "defaultMessage": "General"
    },
    issueBars: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.issue-bars",
        "defaultMessage": "Issue bars"
    },
    releases: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.releases",
        "defaultMessage": "Releases"
    },
    // General
    sprints: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.sprints",
        "defaultMessage": "Sprints"
    },
    dependency: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.dependency",
        "defaultMessage": "Dependency"
    },
    rollup: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.rollup",
        "defaultMessage": "Inferred value (roll-up)"
    },
    // Issue bars
    noEndDate: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.no-end-date",
        "defaultMessage": "No end date"
    },
    noStartDate: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.no-start-date",
        "defaultMessage": "No start date"
    },
    // Releases
    released: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.released",
        "defaultMessage": "Released"
    },
    unreleased: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.unreleased",
        "defaultMessage": "Unreleased"
    },
    overdue: {
        "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.overdue",
        "defaultMessage": "Overdue"
    }
});

});


parcelRegister("aVqO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $302dbe95a8253b8b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hRgs1 = parcelRequire("hRgs1");

var $gdFA6 = parcelRequire("gdFA6");
const $302dbe95a8253b8b$var$onClick = (timelineMode)=>(0, $gdFA6.setTimelineMode)(timelineMode);
var $302dbe95a8253b8b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, {
    onClick: $302dbe95a8253b8b$var$onClick
})((0, $hRgs1.RoadmapTimelineMode));

});
parcelRegister("hRgs1", function(module, exports) {

$parcel$export(module.exports, "RoadmapTimelineMode", () => $38622c545c370c98$export$d1eb62afe3c5898c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $gf0vG = parcelRequire("gf0vG");

var $3XwA1 = parcelRequire("3XwA1");

var $75e8i = parcelRequire("75e8i");

var $i0235 = parcelRequire("i0235");

var $5Ieb0 = parcelRequire("5Ieb0");

const $38622c545c370c98$var$LazyTimelineModeSwitcher = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("ldzfw")), {
    moduleId: "./src/packages/aais/timeline-toolbar/src/ui/timeline-mode-switcher/index.tsx"
});
const $38622c545c370c98$var$MODE_DESCRIPTORS = [
    {
        type: (0, $gf0vG.WEEKS),
        title: (0, $i0235.default).weeks
    },
    {
        type: (0, $gf0vG.MONTHS),
        title: (0, $i0235.default).months
    },
    {
        type: (0, $gf0vG.QUARTERS),
        title: (0, $i0235.default).quarters
    }
];
const $38622c545c370c98$var$timelineModeContainerStyles = null;
const $38622c545c370c98$export$d1eb62afe3c5898c = ({ onClick: onClick, withContainerStyles: withContainerStyles = false })=>{
    const [{ timelineMode: timelineMode }] = (0, $3XwA1.useTimelineState)();
    const changeMode = (0, $eUqFw.useCallback)((mode, event)=>{
        (0, $75e8i.default)('timeline-mode', event.timeStamp); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onClick(mode);
    }, [
        onClick
    ]);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "timeline-mode-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Ieb0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38622c545c370c98$var$LazyTimelineModeSwitcher, {
        modes: $38622c545c370c98$var$MODE_DESCRIPTORS,
        onModeChange: changeMode,
        currentMode: timelineMode
    }));
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1l7b _1ul91lit _1yt41b66"
        ])
    }, element) : element;
};

});
parcelRegister("i0235", function(module, exports) {

$parcel$export(module.exports, "default", () => $545c82ab0a365033$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $545c82ab0a365033$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    weeks: {
        "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.weeks",
        "defaultMessage": "Weeks"
    },
    months: {
        "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.months",
        "defaultMessage": "Months"
    },
    quarters: {
        "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.quarters",
        "defaultMessage": "Quarters"
    }
});

});

parcelRegister("5Ieb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b85245f2dc01f9e0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9VPEO = parcelRequire("9VPEO");
const $b85245f2dc01f9e0$var$TimelineModeSwitcherSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b85245f2dc01f9e0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        width: "74px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        width: "74px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        width: "74px",
        height: "32px"
    }));
var $b85245f2dc01f9e0$export$2e2bcd8739ae039 = $b85245f2dc01f9e0$var$TimelineModeSwitcherSkeleton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b85245f2dc01f9e0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ldzfw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("lUlme")
]).then(()=>parcelRequire('7DlG8'));

});





parcelRegister("5Hgly", function(module, exports) {

$parcel$export(module.exports, "getPreviewProps", () => $56ed5e904c9db10a$export$746e70e91ead5d94);
const $56ed5e904c9db10a$export$746e70e91ead5d94 = ({ clientOffset: clientOffset, scrollOffset: scrollOffset, item: item })=>{
    if (!item) return undefined;
    const { id: id, barRect: barRect, leftPosition: leftPosition, viewportBoundingRect: viewportBoundingRect, requestViewportScrollBounding: requestViewportScrollBounding } = item;
    const scrollBounding = requestViewportScrollBounding();
    return {
        id: id,
        x0: leftPosition - scrollBounding.scrollLeft,
        y0: barRect.top + barRect.height / 2 - viewportBoundingRect.top + scrollOffset.scrollTop,
        x: clientOffset.x - viewportBoundingRect.left,
        y: clientOffset.y - viewportBoundingRect.top,
        width: viewportBoundingRect.width,
        height: viewportBoundingRect.height
    };
};

});



parcelRegister("7DfOL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d937dfd213fc6ebd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");

var $3DJhp = parcelRequire("3DJhp");

var $9ZLrP = parcelRequire("9ZLrP");

var $11LHz = parcelRequire("11LHz");

var $cZB6c = parcelRequire("cZB6c");

var $4z9Vr = parcelRequire("4z9Vr");

var $cIx48 = parcelRequire("cIx48");

var $4BwhT = parcelRequire("4BwhT");
const $d937dfd213fc6ebd$var$renderers = {
    renderDependencyLines: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIx48.default), null),
    renderDependencyFlyout: (props)=>// @ts-expect-error - TS2559 - Type '{ id: string; position: Position; }' has no properties in common with type 'IntrinsicAttributes & { context?: Context<ReactReduxContextValue<any, AnyAction>> | undefined; store?: Store<...> | undefined; }'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4z9Vr.default), props),
    renderContextMenu: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZB6c.default), props),
    renderHighlightLines: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4BwhT.default), null)
};
var $d937dfd213fc6ebd$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>{
    const tooltip = (0, $11LHz.getTooltipParams)(state);
    return {
        ...$d937dfd213fc6ebd$var$renderers,
        type: tooltip?.type,
        id: tooltip && 'id' in tooltip ? tooltip.id.toString() : undefined,
        position: tooltip?.position,
        isDependenciesVisible: (0, $9ZLrP.isDependenciesVisible)(state)
    };
}, {})((0, $3DJhp.RoadmapChartTimelineOverlay));

});
parcelRegister("3DJhp", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartTimelineOverlay", () => $a02b73eb1ab6ec86$export$8858e3c7842aaf2);

var $eUqFw = parcelRequire("eUqFw");

var $4P2VV = parcelRequire("4P2VV");

const $a02b73eb1ab6ec86$export$8858e3c7842aaf2 = ({ id: id, position: position, type: type, isDependenciesVisible: isDependenciesVisible, renderDependencyFlyout: renderDependencyFlyout, renderDependencyLines: renderDependencyLines, renderHighlightLines: renderHighlightLines, renderContextMenu: renderContextMenu })=>{
    const renderFlyout = ()=>{
        if (id !== undefined && type !== undefined && position !== undefined) switch(type){
            case 0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28:
                return renderDependencyFlyout({
                    id: id,
                    position: position
                });
            case 0, $aba7cf5b5acfd3bc$export$a9487b0be9740846:
                return renderContextMenu({
                    id: id,
                    position: position
                });
            default:
                return null;
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderFlyout(), isDependenciesVisible && renderDependencyLines(), renderHighlightLines());
};
$a02b73eb1ab6ec86$export$8858e3c7842aaf2.defaultProps = {
    renderDependencyFlyout: (0, $4P2VV.DEFAULT_RENDERER),
    renderDependencyLines: (0, $4P2VV.DEFAULT_RENDERER),
    renderHighlightLines: (0, $4P2VV.DEFAULT_RENDERER),
    renderContextMenu: (0, $4P2VV.DEFAULT_RENDERER)
};

});

parcelRegister("cZB6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $32d14f2bd054aed8$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $32d14f2bd054aed8$var$ContextMenu = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("d6XA0")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/chart-timeline-overlay/context-menu/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$32d14f2bd054aed8$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-context-menu",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-context-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($32d14f2bd054aed8$var$ContextMenu, props)));

});
parcelRegister("d6XA0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hVrRG").then(()=>parcelRequire('hx5kE'));

});


parcelRegister("4z9Vr", function(module, exports) {

$parcel$export(module.exports, "default", () => $21a2344cd346008d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $21a2344cd346008d$var$DependencyTooltip = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("6k3g9")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/chart-timeline-overlay/dependency-flyout/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21a2344cd346008d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-dependency-tooltip",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-dependency-tooltip",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a2344cd346008d$var$DependencyTooltip, props)));

});
parcelRegister("6k3g9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("j7x86").then(()=>parcelRequire('7rEUl'));

});


parcelRegister("cIx48", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fa52b66f03da452$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");


var $aYYDR = parcelRequire("aYYDR");

var $eQTUe = parcelRequire("eQTUe");

var $htXdF = parcelRequire("htXdF");
const $2fa52b66f03da452$var$mapStateToProps = (state)=>({
        dependencies: (0, $eQTUe.getDependenciesItems)(state),
        selectedDependency: (0, $eQTUe.getSelectedDependency)(state)
    });
const $2fa52b66f03da452$var$onDependencyClick = ({ toId: toId, fromId: fromId }, position)=>(0, $htXdF.showToolTip)({
        id: fromId,
        type: (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28),
        links: {
            fromIds: [],
            toIds: [
                toId
            ]
        },
        position: position,
        showImplicitDependency: false
    });
const $2fa52b66f03da452$var$mapDispatchToProps = {
    onDependencyClick: $2fa52b66f03da452$var$onDependencyClick
};
var $2fa52b66f03da452$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($2fa52b66f03da452$var$mapStateToProps, $2fa52b66f03da452$var$mapDispatchToProps)((0, $aYYDR.RoadmapDependencyLines));

});
parcelRegister("aYYDR", function(module, exports) {

$parcel$export(module.exports, "RoadmapDependencyLines", () => $38179f1e8688769e$export$ef4d1c7f7fde068f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bs7an = parcelRequire("bs7an");

var $3XwA1 = parcelRequire("3XwA1");

var $3bhRL = parcelRequire("3bhRL");
const $38179f1e8688769e$var$containerStyles = null;
const $38179f1e8688769e$export$ef4d1c7f7fde068f = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    // No need to recalculate positions when the selected dependency changes
    const dependenciesWithPositionsAndIsOverlap = (0, $eUqFw.useMemo)(()=>(0, $3bhRL.getDependenciesWithPositions)(dependencies, timelineDuration, timelineWidth), [
        dependencies,
        timelineDuration,
        timelineWidth
    ]);
    const onHandleDependencyClick = ({ pageX: pageX, pageY: pageY }, { toId: toId, fromId: fromId })=>{
        onDependencyClick && onDependencyClick({
            toId: toId,
            fromId: fromId
        }, {
            x: pageX,
            y: pageY
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1pbycs5v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bs7an.default), {
        dependencies: dependenciesWithPositionsAndIsOverlap,
        selectedDependency: selectedDependency,
        onDependencyClick: onHandleDependencyClick
    }));
};
$38179f1e8688769e$export$ef4d1c7f7fde068f.defaultProps = {
    selectedDependency: undefined
};

});
parcelRegister("bs7an", function(module, exports) {

$parcel$export(module.exports, "default", () => $98318066b465b791$export$2e2bcd8739ae039);
/* eslint-disable jira/restricted/styled-components-migration */ 
var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");


var $2CrYe = parcelRequire("2CrYe");
const $98318066b465b791$var$SvgOverlay = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
    const selectedDependencyLine = selectedDependency && dependencies.find((dependency)=>dependency.from.id === selectedDependency.fromId && dependency.to.id === selectedDependency.toId && dependency.from.indexOnScope === selectedDependency.fromIndex && dependency.to.indexOnScope === selectedDependency.toIndex);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98318066b465b791$var$SvgContainer, {
        className: (0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d)
    }, dependencies.map((dependency)=>{
        if (dependency !== selectedDependencyLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CrYe.default), {
            key: `${dependency.from.id}-${dependency.to.id}-${dependency.from.y}-${dependency.to.y}`,
            ...dependency,
            onClick: onDependencyClick,
            isSelected: false
        });
        return null;
    }), selectedDependencyLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CrYe.default), {
        ...selectedDependencyLine,
        onClick: onDependencyClick,
        isSelected: true
    })));
};
$98318066b465b791$var$SvgOverlay.defaultProps = {
    selectedDependency: undefined,
    onDependencyClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    dependencies: []
};
var $98318066b465b791$export$2e2bcd8739ae039 = $98318066b465b791$var$SvgOverlay;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98318066b465b791$var$SvgContainer = /*#__PURE__*/ (0, $kwce8.default).svg.withConfig({
    componentId: "sc-7b34v9-0"
})({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'opacity 0.2s ease-in-out',
    overflow: 'visible',
    pointerEvents: 'none'
});

});
/**
 * Style marshal classes
 */ const $dfce2d8dd72914ca$export$1e54f8b472a07d8d = 'dependencies-overlay';
const $dfce2d8dd72914ca$export$cd944e09ecad5145 = 'dependency-line';

parcelRegister("2CrYe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c7f5a778bca93d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hTLlD = parcelRequire("hTLlD");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lPQPn = parcelRequire("lPQPn");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $75e8i = parcelRequire("75e8i");


var $aM1JA = parcelRequire("aM1JA");

var $fR5Z4 = parcelRequire("fR5Z4");
/* Even though this component represents a single line, multiple elements are used to achieve all of the requirements.
 * 1. An additional element with a larger surface area is used to capture interactions to improve the UX.
 * 2. Gradients cannot be applied to SVG elements using CSS. For this we use a linearGradient element.
 */ const $03c7f5a778bca93d$var$DependencyLine = ({ from: from, to: to, itemHeight: itemHeight, isOverlapping: isOverlapping, isSelected: isSelected, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const onPathClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $75e8i.default)('timeline-dependency-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'line'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyLine', {
            isOverlapping: isOverlapping
        });
        onClick(event, {
            fromId: from.id,
            toId: to.id,
            isOverlapping: isOverlapping,
            fromIndexOnScope: from.indexOnScope,
            toIndexOnScope: to.indexOnScope
        });
    }, [
        createAnalyticsEvent,
        isOverlapping,
        from,
        to,
        onClick
    ]);
    const onPathMouseEnter = (0, $eUqFw.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const onPathMouseLeave = (0, $eUqFw.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const path = (0, $fR5Z4.getPath)(from, to, itemHeight);
    const gradientId = `linear-gradient-${from.id}-${to.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (isHovered || isSelected) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: gradientId,
        x1: from.x,
        x2: to.x,
        y1: from.y,
        y2: to.y,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0%",
        stopColor: (0, $lPQPn.getValueFromColor)(from.color)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "100%",
        stopColor: (0, $lPQPn.getValueFromColor)(to.color)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: path,
        fill: "transparent",
        strokeWidth: "2",
        stroke: $03c7f5a778bca93d$export$a73db48ef11a2bc3({
            isOverlapping: isOverlapping,
            isSelected: isSelected,
            isHovered: isHovered,
            gradientId: gradientId
        }),
        pointerEvents: "none",
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.dependency-line"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "mouse",
        mousePosition: "top",
        content: formatMessage((0, $aM1JA.default).viewDetail),
        tag: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03c7f5a778bca93d$var$InteractivePath // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $dfce2d8dd72914ca$export$cd944e09ecad5145),
        d: path,
        stroke: "transparent",
        strokeWidth: "9",
        fill: "none",
        cursor: "pointer",
        onClick: onPathClick,
        onMouseEnter: onPathMouseEnter,
        onMouseLeave: onPathMouseLeave,
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.interactive-path"
    })));
};
$03c7f5a778bca93d$var$DependencyLine.whyDidYouRender = true; // Custom memo to handle common case where 'from' and 'to' objects change reference but not value
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$03c7f5a778bca93d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($03c7f5a778bca93d$var$DependencyLine, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $03c7f5a778bca93d$var$InteractivePath = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "path", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxv1yxs",
            __cmplp.className
        ])
    });
});
const $03c7f5a778bca93d$export$a73db48ef11a2bc3 = ({ isOverlapping: isOverlapping, isSelected: isSelected, isHovered: isHovered, gradientId: gradientId })=>{
    const isHighlighted = isSelected || isHovered;
    if (isOverlapping) {
        if (isHighlighted) return `var(--ds-background-danger-bold-hovered, ${(0, $73a5c9d720aa66e1$exports).R500})`;
        return `var(--ds-background-danger-bold, ${(0, $73a5c9d720aa66e1$exports).R300})`;
    }
    if (isHighlighted) return `url(#${gradientId})`;
    return `var(--ds-border-bold, ${(0, $73a5c9d720aa66e1$exports).N50})`;
};

});
parcelRegister("aM1JA", function(module, exports) {

$parcel$export(module.exports, "default", () => $106a95137f755680$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $106a95137f755680$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewDetail: {
        "id": "aais-dependency-lines-overlay.common.line.view-detail",
        "defaultMessage": "View dependency detail"
    }
});

});

parcelRegister("fR5Z4", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $73e9f2077e2ffc0d$export$2aa3fd96c49a84a8);

var $5iWql = parcelRequire("5iWql");
const $73e9f2077e2ffc0d$var$calculateMidPoint = (from, to)=>({
        x: (from.x + to.x) / 2,
        y: (from.y + to.y) / 2
    });
const $73e9f2077e2ffc0d$var$getY = (p1, p2, x)=>{
    const m = (p2.y - p1.y) / (p2.x - p1.x);
    return m * (x - p1.x) + p1.y;
};
// Generates half of the complex segment
const $73e9f2077e2ffc0d$var$generateSegment = (start, end, offset)=>{
    const c1 = {
        x: start.x + offset.x,
        y: start.y
    };
    const c2 = {
        x: start.x + offset.x,
        y: start.y + offset.y
    };
    const s1 = {
        x: start.x,
        y: $73e9f2077e2ffc0d$var$getY(c2, end, start.x)
    };
    return `M${start.x} ${start.y} C${c1.x} ${c1.y} ${c2.x} ${c2.y} ${s1.x} ${s1.y} L${s1.x} ${s1.y} ${end.x} ${end.y}`;
};
const $73e9f2077e2ffc0d$var$getSegmentOffsets = (from, to, halfItemHeight)=>{
    const fromOffset = {
        x: halfItemHeight,
        y: from.y <= to.y ? halfItemHeight : -halfItemHeight
    };
    const toOffset = {
        x: -fromOffset.x,
        y: -fromOffset.y
    };
    return [
        fromOffset,
        toOffset
    ];
};
// Generates a path made up of two segments for when the dependency start is after the end
const $73e9f2077e2ffc0d$var$generateComplexPath = (from, to, halfItemHeight)=>{
    const middle = $73e9f2077e2ffc0d$var$calculateMidPoint(from, to);
    const [fromOffset, toOffset] = $73e9f2077e2ffc0d$var$getSegmentOffsets(from, to, halfItemHeight);
    return `${$73e9f2077e2ffc0d$var$generateSegment(from, middle, fromOffset)} ${$73e9f2077e2ffc0d$var$generateSegment(to, middle, toOffset)}`;
};
//  Generates a single path for when the dependency start is before the end (happy case)
const $73e9f2077e2ffc0d$var$generateSinglePath = (from, to, itemHeight)=>{
    const diffX = Math.abs(from.x - to.x);
    const progression = itemHeight + diffX * 0.1;
    return `M${from.x} ${from.y} C${from.x + progression} ${from.y} ${to.x - progression} ${to.y} ${to.x} ${to.y}`;
};
const $73e9f2077e2ffc0d$export$2aa3fd96c49a84a8 = (0, $5iWql.default)((from, to, itemHeight)=>from.x > to.x ? $73e9f2077e2ffc0d$var$generateComplexPath(from, to, itemHeight / 2) : $73e9f2077e2ffc0d$var$generateSinglePath(from, to, itemHeight));

});



parcelRegister("3bhRL", function(module, exports) {

$parcel$export(module.exports, "getDependenciesWithPositions", () => $90fe3047e59ee8d8$export$2503ae09d0c5f74);

var $fHtBB = parcelRequire("fHtBB");

var $cww1R = parcelRequire("cww1R");

var $eENQ7 = parcelRequire("eENQ7");
const $90fe3047e59ee8d8$export$2503ae09d0c5f74 = (dependencies, timelineDuration, timelineWidth)=>dependencies.map(({ itemHeight: itemHeight, from: from, to: to })=>({
            isOverlapping: (0, $eENQ7.isDependencyDatesOverlapping)(undefined, from.dueDate, to.startDate, undefined),
            itemHeight: itemHeight,
            to: {
                id: to.id,
                y: to.y,
                x: (0, $cww1R.getBarLeftPosition)(to.startDate, timelineDuration, timelineWidth),
                color: to.color
            },
            from: {
                id: from.id,
                y: from.y,
                x: (0, $cww1R.getBarLeftPosition)(from.dueDate + (0, $fHtBB.DUE_DATE_OFFSET), timelineDuration, timelineWidth),
                color: from.color
            }
        }));

});
parcelRegister("eENQ7", function(module, exports) {

$parcel$export(module.exports, "isDependencyDatesOverlapping", () => $6257ea1530e2071a$export$9fb40a5a7e47a5dd);
const $6257ea1530e2071a$export$9fb40a5a7e47a5dd = (dependencyStartDate = -1, dependencyDueDate = -1, dependeeStartDate = -1, dependeeDueDate = -1)=>{
    // happy case where dates are defined
    if (dependencyDueDate > -1 && dependeeStartDate > -1) return dependencyDueDate > dependeeStartDate;
    // no dates on either dependency or dependee
    if (dependencyStartDate === -1 && dependencyDueDate === -1 || dependeeStartDate === -1 && dependeeDueDate === -1) return false;
    // only start date on dependency and due date on dependee
    if (dependencyDueDate === -1 && dependeeStartDate === -1) return dependencyStartDate > dependeeDueDate;
    // due date of dependency and due date of dependee
    if (dependencyDueDate !== -1) return dependencyDueDate > dependeeDueDate;
    // start date of dependency and start date of dependee
    if (dependencyStartDate !== -1) return dependencyStartDate > dependeeStartDate;
    // impossible case
    return false;
};

});




parcelRegister("4BwhT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b153c0af1151095b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hjI8T = parcelRequire("hjI8T");

var $4hkaw = parcelRequire("4hkaw");
const $b153c0af1151095b$var$mapStateToProps = (state)=>({
        highlightedKeyDates: (0, $hjI8T.getHighlightedKeyDates)(state),
        getVersionsForKeyDate: (0, $hjI8T.createGetVersionsForKeyDates)(state)
    });
var $b153c0af1151095b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($b153c0af1151095b$var$mapStateToProps, {})((0, $4hkaw.HighlightLines));

});
parcelRegister("4hkaw", function(module, exports) {

$parcel$export(module.exports, "HighlightLines", () => $fd7a71332dcd01c4$export$895b3d36cc1cb0a9);

var $eUqFw = parcelRequire("eUqFw");

var $hC4CO = parcelRequire("hC4CO");

var $3XwA1 = parcelRequire("3XwA1");
const $fd7a71332dcd01c4$export$895b3d36cc1cb0a9 = ({ highlightedKeyDates: highlightedKeyDates, getVersionsForKeyDate: getVersionsForKeyDate })=>{
    const [{ today: today }] = (0, $3XwA1.useTimelineState)();
    const keyDates = getVersionsForKeyDate(today);
    return highlightedKeyDates.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hC4CO.RoadmapHighlightLines), {
        highlightedKeyDates: highlightedKeyDates,
        keyDates: keyDates
    }) : null;
};

});
parcelRegister("hC4CO", function(module, exports) {

$parcel$export(module.exports, "RoadmapHighlightLines", () => $63098f0a6e5108be$export$c255e60bcbb8c4b2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");

var $fbLos = parcelRequire("fbLos");

var $lXsQo = parcelRequire("lXsQo");

var $aL4jn = parcelRequire("aL4jn");
const $63098f0a6e5108be$export$c255e60bcbb8c4b2 = ({ highlightedKeyDates: highlightedKeyDates, keyDates: keyDates })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth, timelineMode: timelineMode }] = (0, $3XwA1.useTimelineState)();
    if (highlightedKeyDates.length === 0) return null;
    const keyDateGroups = (0, $lXsQo.getKeyDatesGroups)({
        keyDates: keyDates,
        timelineMode: timelineMode,
        timelineDuration: timelineDuration,
        timelineWidth: timelineWidth
    });
    const highlightLines = (0, $aL4jn.getHighlightLines)({
        keyDateGroups: keyDateGroups,
        highlightedKeyDates: highlightedKeyDates
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, highlightLines.map(({ left: left, id: id, status: status })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: id,
            style: {
                left: `${left}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                backgroundColor: (0, $fbLos.MARKER_COLORS)[status]
            },
            "data-testid": `roadmap.timeline-table-kit.ui.chart-timeline-overlay.highlight-lines.highlight-line-${id}`,
            className: (0, $7JEyt.default)([
                "_4t3i1osq _1bsbv77o _kqswstnw _1pby11wp"
            ])
        })));
};
const $63098f0a6e5108be$var$highlightLineStyles = null;

});




parcelRegister("igRS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e81ae022a2f62fe$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $lNNXV = parcelRequire("lNNXV");

var $bwVWW = parcelRequire("bwVWW");

var $9ZLrP = parcelRequire("9ZLrP");

var $9DoTe = parcelRequire("9DoTe");

var $gdFA6 = parcelRequire("gdFA6");

var $aSTh4 = parcelRequire("aSTh4");

var $cEVew = parcelRequire("cEVew");
const $5e81ae022a2f62fe$var$mapDispatchToProps = {
    onClearFilter: (0, $gdFA6.clearFilter),
    onClearLevelOneSetting: (0, $aSTh4.clearLevelOneSetting)
};
var $5e81ae022a2f62fe$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>{
    const { showCompleted: showCompleted, period: period } = (0, $9ZLrP.getLevelOneSetting)(state);
    return {
        levelOneName: (0, $bwVWW.getLevelOneName)(state),
        isFilterActive: (0, $9ZLrP.isFilterActive)(state),
        isLevelOneSettingActive: !(showCompleted && period === 12),
        canUserCreate: (0, $9DoTe.getCanUserCreate)(state)
    };
}, $5e81ae022a2f62fe$var$mapDispatchToProps)((0, $cEVew.StandardRoadmapListEmptyContent));

});
parcelRegister("cEVew", function(module, exports) {

$parcel$export(module.exports, "StandardRoadmapListEmptyContent", () => $3d939b3771eddbc1$export$7b119d4836ac8ade);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3o8m9 = parcelRequire("3o8m9");

var $p8HSN = parcelRequire("p8HSN");
const $3d939b3771eddbc1$export$7b119d4836ac8ade = ({ levelOneName: levelOneName, isFilterActive: isFilterActive, isLevelOneSettingActive: isLevelOneSettingActive, canUserCreate: canUserCreate, onClearFilter: onClearFilter, onClearLevelOneSetting: onClearLevelOneSetting })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isFilterActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o8m9.RoadmapListEmptyContent), {
        description: formatMessage((0, $p8HSN.default).explanationFilter),
        actionLabel: formatMessage((0, $p8HSN.default).clearFilter),
        onActionClick: onClearFilter
    });
    if (isLevelOneSettingActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o8m9.RoadmapListEmptyContent), {
        description: formatMessage((0, $p8HSN.default).explanationLevelOneSetting, {
            levelOneName: levelOneName
        }),
        actionLabel: formatMessage((0, $p8HSN.default).clearLevelOneSetting, {
            levelOneName: levelOneName
        }),
        onActionClick: onClearLevelOneSetting
    });
    if (!canUserCreate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o8m9.RoadmapListEmptyContent), {
        title: formatMessage((0, $p8HSN.default).titleNoAccess),
        description: formatMessage((0, $p8HSN.default).explanationNoAccess),
        illustration: "generic-empty-state"
    });
    return null;
};

});
parcelRegister("3o8m9", function(module, exports) {

$parcel$export(module.exports, "RoadmapListEmptyContent", () => $38e5a438ffd01248$export$6d386b1e9b37b9ba);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $eI5EY = parcelRequire("eI5EY");

var $gyaWd = parcelRequire("gyaWd");

var $YnBzc = parcelRequire("YnBzc");
const $38e5a438ffd01248$var$getIllustration = (illustration)=>{
    switch(illustration){
        case 'generic-empty-state':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gyaWd.default), {
                alt: "",
                width: "94",
                height: "84"
            });
        case 'magnifying-glass':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $YnBzc.default), {
                alt: "",
                width: "110",
                height: "84"
            });
    }
};
const $38e5a438ffd01248$export$6d386b1e9b37b9ba = ({ title: title, description: description, illustration: illustration = 'magnifying-glass', actionLabel: actionLabel, onActionClick: onActionClick })=>{
    const showActionButton = actionLabel !== undefined && onActionClick !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38e5a438ffd01248$var$Container, null, $38e5a438ffd01248$var$getIllustration(illustration), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38e5a438ffd01248$var$TextContainer, null, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: (0, $eI5EY.fg)('jira-software-aria-required-children-a11y') ? 'span' : 'h2'
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38e5a438ffd01248$var$Explanation, null, description), showActionButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onActionClick
    }, actionLabel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $38e5a438ffd01248$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1ejb _1e0c1txw _2lx21bp4 _1bsb1osq _4cvr1h6o _bfhkvuon _zulp1ejb",
            __cmplp.className
        ])
    });
});
const $38e5a438ffd01248$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _zulpv47k",
            __cmplp.className
        ])
    });
});
const $38e5a438ffd01248$var$Explanation = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ie5z _y3gn1h6o _p12f1edt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("YnBzc", function(module, exports) {

$parcel$export(module.exports, "default", () => $10beb4ee234c4cb7$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $hKkSI = parcelRequire("hKkSI");
const $10beb4ee234c4cb7$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hKkSI)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hKkSI))
});
var $10beb4ee234c4cb7$export$2e2bcd8739ae039 = $10beb4ee234c4cb7$var$Illustration;
// for advanced use only
const $10beb4ee234c4cb7$export$a179c88182cb9d56 = [
    0,
    0,
    110,
    84
];

});
parcelRegister("hKkSI", function(module, exports) {
module.exports = new URL("magnifying-glass.26424ba7.svg", import.meta.url).toString();

});



parcelRegister("p8HSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0db130d038d0fd3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f0db130d038d0fd3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    explanationFilter: {
        "id": "roadmap.standard-roadmap.common.table.list-empty-content.explanation-filter",
        "defaultMessage": "There are no issues that match your current filter."
    },
    clearFilter: {
        "id": "roadmap.standard-roadmap.common.table.list-empty-content.clear-filter",
        "defaultMessage": "Clear filter"
    },
    explanationLevelOneSetting: {
        "id": "roadmap.standard-roadmap.common.table.list-empty-content.explanation-level-one-setting",
        "defaultMessage": "There isn't a match for your current {levelOneName} display option."
    },
    clearLevelOneSetting: {
        "id": "roadmap.standard-roadmap.common.table.list-empty-content.clear-level-one-setting",
        "defaultMessage": "Clear {levelOneName} display option"
    },
    titleNoAccess: {
        "id": "roadmap.standard-roadmap.common.table.list-empty-content.title-no-access",
        "defaultMessage": "There's nothing here!"
    },
    explanationNoAccess: {
        "id": "roadmap.standard-roadmap.common.table.list-empty-content.explanation-no-access",
        "defaultMessage": "To add issues to the timeline, your Jira administrator needs to give you access to this project."
    }
});

});



parcelRegister("cy6z6", function(module, exports) {

$parcel$export(module.exports, "renderListHeaderItem", () => $aefcc496af16d02f$export$53818c92b94a5ff7);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4P2VV = parcelRequire("4P2VV");

var $ja0fS = parcelRequire("ja0fS");

var $gf0vG = parcelRequire("gf0vG");

var $8IKzq = parcelRequire("8IKzq");
const $aefcc496af16d02f$var$ListHeaderItem = ({ id: id })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    switch(id){
        case 0, $4P2VV.RELEASES_HEADER_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ja0fS.RoadmapListHeaderRow), {
                title: formatMessage((0, $8IKzq.default).releases)
            });
        case 0, $4P2VV.SPRINTS_HEADER_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ja0fS.RoadmapListHeaderRow), {
                title: formatMessage((0, $8IKzq.default).sprints)
            });
        case 0, $gf0vG.DEFAULT_HEADER_ROW_ID:
            return (0, $eI5EY.fg)('jsw_roadmaps_timeline-empty-cell-label') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, formatMessage((0, $8IKzq.default).empty)) : null;
        default:
            return null;
    }
};
const $aefcc496af16d02f$export$53818c92b94a5ff7 = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aefcc496af16d02f$var$ListHeaderItem, {
        id: id
    });

});
parcelRegister("ja0fS", function(module, exports) {

$parcel$export(module.exports, "RoadmapListHeaderRow", () => $40e3228096ebb5be$export$f962ea845bdc3e24);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");
const $40e3228096ebb5be$export$f962ea845bdc3e24 = ({ title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, title));
const $40e3228096ebb5be$var$rowTitleStyles = null;

});

parcelRegister("8IKzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac78b6a9b2f8482a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ac78b6a9b2f8482a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    releases: {
        "id": "roadmap.standard-roadmap.common.table.list-header-item.releases",
        "defaultMessage": "Releases"
    },
    sprints: {
        "id": "roadmap.standard-roadmap.common.table.list-header-item.sprints",
        "defaultMessage": "Sprints"
    },
    empty: {
        "id": "roadmap.standard-roadmap.common.table.list-header-item.empty",
        "defaultMessage": "Empty"
    }
});

});


parcelRegister("6wDSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3067ff3216967134$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $lNNXV = parcelRequire("lNNXV");

var $kbiEp = parcelRequire("kbiEp");

var $6FeJk = parcelRequire("6FeJk");

var $9ZLrP = parcelRequire("9ZLrP");

var $9E22T = parcelRequire("9E22T");

var $2ukAT = parcelRequire("2ukAT");

var $1SuDz = parcelRequire("1SuDz");

var $htXdF = parcelRequire("htXdF");

var $2pSc9 = parcelRequire("2pSc9");

var $9aFn5 = parcelRequire("9aFn5");
const $3067ff3216967134$var$onChildCreateClick = (anchor)=>(0, $htXdF.setCreateItemAnchor)(anchor);
var $3067ff3216967134$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, { id: id })=>{
    const issueType = (0, $9E22T.getIssueTypeForIssueId)(state, id);
    return {
        iconUrl: issueType?.iconUrl,
        iconAltText: issueType?.name,
        title: (0, $6FeJk.getIssueSummary)(state, id),
        itemKey: (0, $6FeJk.getIssueKeyById)(state, id),
        progress: (0, $9ZLrP.isProgressVisible)(state) ? (0, $9E22T.getProgress)(state, id) : undefined,
        isDone: (0, $6FeJk.getIsIssueResolved)(state, id),
        highlightText: (0, $9ZLrP.getFilteredText)(state),
        isNudgeEnabled: (0, $2pSc9.createGetIsNudgeVisible)(id)((0, $1SuDz.getIsCreateChildEnabled)(state), (0, $1SuDz.getItems)(state)?.[0]),
        progressMetadata: (0, $kbiEp.isBaseLevel)((0, $6FeJk.getIssueLevel)(state, id)) ? (0, $2ukAT.getIssueSubtaskProgress)(state, id) : (0, $2ukAT.DEFAULT_PROGRESS_META_DATA)
    };
}, {
    onChildCreateClick: $3067ff3216967134$var$onChildCreateClick
}, (stateProps, dispatchProps, { isHoveredOrFocused: isHoveredOrFocused, id: id })=>({
        ...stateProps,
        ...dispatchProps,
        isRichContentEnabled: isHoveredOrFocused,
        id: id
    }))((0, $9aFn5.default));

});
parcelRegister("2pSc9", function(module, exports) {

$parcel$export(module.exports, "createGetIsNudgeVisible", () => $2d40aa0d088abd10$export$3dfb8a83b7cbfb51);
const $2d40aa0d088abd10$export$3dfb8a83b7cbfb51 = (id)=>(canCreateChild, firstParentItem)=>canCreateChild && firstParentItem?.id === id;

});

parcelRegister("9aFn5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4fea1fac108035$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7dRgX = parcelRequire("7dRgX");

var $5cLMB = parcelRequire("5cLMB");

var $aoJpz = parcelRequire("aoJpz");

var $53KXE = parcelRequire("53KXE");

var $gf0vG = parcelRequire("gf0vG");

var $hZTXm = parcelRequire("hZTXm");
const $5b4fea1fac108035$var$ListItemContentWithNudge = ({ isNudgeEnabled: isNudgeEnabled, onChildCreateClick: onChildCreateClick, id: id, ...otherProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [openTask] = (0, $5cLMB.useOpenTask)();
    const [hasNudgeActive] = (0, $5cLMB.useHasNudgeActive)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        onChildCreateClick({
            parentId: id,
            position: (0, $gf0vG.INSIDE)
        });
    }, [
        id,
        onChildCreateClick
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.stopPropagation();
            onChildCreateClick({
                parentId: id,
                position: (0, $gf0vG.INSIDE)
            });
        }
    }, [
        id,
        onChildCreateClick
    ]);
    if (hasNudgeActive && openTask === (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53KXE.RoadmapListItemContent), otherProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aoJpz.RoadmapCreateEpicChildIssueButtonWrapperNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onClick: onClick,
        role: "button",
        "aria-label": formatMessage((0, $hZTXm.default).createChild),
        tabIndex: 0,
        onKeyDown: onKeyDown,
        className: (0, $7JEyt.default)([
            "_154i1grp _1xi212x7 _1bsb1ejb _4t3i1ejb _lcxv1wug _80omtlke _kqswstnw _1ywuglyw _cfu1glyw"
        ])
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53KXE.RoadmapListItemContent), otherProps);
};
const $5b4fea1fac108035$var$ListItemContent = (props)=>{
    const { isNudgeEnabled: isNudgeEnabled, onChildCreateClick: onChildCreateClick, id: id, ...otherProps } = props;
    if (!false && isNudgeEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5b4fea1fac108035$var$ListItemContentWithNudge, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53KXE.RoadmapListItemContent), otherProps);
};
$5b4fea1fac108035$var$ListItemContent.whyDidYouRender = true;
var $5b4fea1fac108035$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5b4fea1fac108035$var$ListItemContent);
const $5b4fea1fac108035$var$fakeChildCreateButtonStyles = null;

});
parcelRegister("aoJpz", function(module, exports) {

$parcel$export(module.exports, "RoadmapCreateEpicChildIssueButtonWrapperNudgeAsync", () => $b140d77228fae9c9$export$ed02c30bbe7241c5);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b140d77228fae9c9$var$RoadmapCreateEpicChildIssueButtonLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cSGpC")).then((exportedModule)=>exportedModule.RoadmapCreateEpicChildIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/roadmap-create-epic-child-issue/index.tsx"
});
const $b140d77228fae9c9$export$ed02c30bbe7241c5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$1e39959907a7f359),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$1e39959907a7f359)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-quickstart-roadmap-create-child-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b140d77228fae9c9$var$RoadmapCreateEpicChildIssueButtonLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$1e39959907a7f359)
    }, children)));

});
parcelRegister("cSGpC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("gQ0cS")
]).then(()=>parcelRequire('04qtK'));

});


parcelRegister("53KXE", function(module, exports) {

$parcel$export(module.exports, "RoadmapListItemContent", () => $d4cdf247b1ee4655$export$d822c765b9c722b8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $9WNLk = parcelRequire("9WNLk");

var $8rQuz = parcelRequire("8rQuz");

var $lodjt = parcelRequire("lodjt");

var $8CN2m = parcelRequire("8CN2m");
const $d4cdf247b1ee4655$export$d822c765b9c722b8 = ({ title: title, iconUrl: iconUrl, iconAltText: iconAltText, itemKey: itemKey, progress: progress, highlightText: highlightText, isDone: isDone, isRichContentEnabled: isRichContentEnabled, progressMetadata: progressMetadata })=>{
    let isMultiSelectEnabled;
    if ((0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, $9WNLk.useEnablements)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CN2m.default), {
        title: title,
        itemKey: itemKey,
        iconUrl: iconUrl,
        iconAltText: iconAltText,
        highlightText: highlightText,
        isDone: isDone,
        isActive: isRichContentEnabled,
        progressMetadata: progressMetadata
    }), progress && ((0, $eI5EY.fg)('project_timeline_multi-select_and_checkboxes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            left: isMultiSelectEnabled ? "var(--ds-space-1000, 80px)" : "var(--ds-space-600, 48px)",
            marginLeft: !isMultiSelectEnabled && (0, $8rQuz.isVisualRefreshEnabled)() ? "var(--ds-space-150, 12px)" : "var(--ds-space-0, 0px)"
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n51b66 _1bsb1tkr _4t3i1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lodjt.RoadmapProgressBar), {
        isRichContentEnabled: isRichContentEnabled,
        progress: progress
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvoahv _94n51b66 _1bsb1tkr _4t3i1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lodjt.RoadmapProgressBar), {
        isRichContentEnabled: isRichContentEnabled,
        progress: progress
    }))));
};
$d4cdf247b1ee4655$export$d822c765b9c722b8.defaultProps = {
    title: '',
    iconUrl: '',
    iconAltText: '',
    highlightText: '',
    isDone: false
};
const $d4cdf247b1ee4655$var$legacyContainerStyles = null;
const $d4cdf247b1ee4655$var$containerStyles = null;

});
parcelRegister("lodjt", function(module, exports) {

$parcel$export(module.exports, "RoadmapProgressBar", () => $21f28cbf2af1f6a2$export$55a41cf6644a7a92);

var $eUqFw = parcelRequire("eUqFw");

var $bcuy0 = parcelRequire("bcuy0");

var $dFSe7 = parcelRequire("dFSe7");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jh1l7 = parcelRequire("jh1l7");
const $21f28cbf2af1f6a2$export$55a41cf6644a7a92 = ({ isRichContentEnabled: isRichContentEnabled, progress: progress })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const total = progress.reduce((totalCount, entry)=>totalCount + entry.count, 0);
    /* Progress components skips adding a tooltip wrapper if tooltipContent is an empty string.
   * We use this as a performance optimisation.
   */ const getTooltipContent = ({ count: count, name: name })=>{
        if (!isRichContentEnabled) return '';
        // The progress bar will have a button role when tooltipContent is a string, so adding a fragment to avoid this.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $jh1l7.default).tooltip, {
            count: count,
            name: name,
            total: total
        }));
    };
    const fulfilledProgress = progress.slice(0, -1);
    const unfulfilledProgress = progress[progress.length - 1];
    const progressBarAriaLabel = [
        ...fulfilledProgress,
        unfulfilledProgress
    ].map(({ count: count, name: name })=>formatMessage((0, $jh1l7.default).tooltip, {
            count: count,
            name: name,
            total: total
        })).join(', ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcuy0.default), {
        "aria-label": progressBarAriaLabel,
        sum: total,
        backgroundColor: unfulfilledProgress.color,
        remainingTooltipContent: getTooltipContent(unfulfilledProgress),
        height: 4
    }, fulfilledProgress.map((entry)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFSe7.default), {
            key: entry.id,
            value: entry.count,
            color: entry.color,
            tooltipContent: getTooltipContent(entry)
        })));
};

});
parcelRegister("bcuy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e2a577faa3e6f5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");


var $dFSe7 = parcelRequire("dFSe7");
class $d5e2a577faa3e6f5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            children: null,
            sum: 0,
            remainingTooltipContent: '',
            // TODO: Use tokens for colors
            backgroundColor: (0, $73a5c9d720aa66e1$exports).N30,
            height: 10
        };
    }
    validateElementsAndCalculateElementsWidth() {
        const { children: children } = this.props;
        let sumOfElementsValues = 0;
        const validatedElements = [];
        (0, $eUqFw.Children).map(children, (child)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const childEl = child;
            if (childEl.props.value && childEl.props.value > 0) {
                sumOfElementsValues += childEl.props.value;
                validatedElements.push(childEl);
            }
        });
        return {
            validatedElements: validatedElements,
            elementsSum: sumOfElementsValues
        };
    }
    render() {
        const { children: children, remainingTooltipContent: remainingTooltipContent, sum: sum, backgroundColor: backgroundColor, height: height, borderRadius: borderRadius, tooltipHoverPadding: tooltipHoverPadding } = this.props;
        if (!children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5e2a577faa3e6f5$var$ProgressWrapper, {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: backgroundColor,
            elementsGrow: 0,
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius
        });
        const { validatedElements: validatedElements, elementsSum: elementsSum } = this.validateElementsAndCalculateElementsWidth();
        const remaining = sum - elementsSum;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5e2a577faa3e6f5$var$ProgressWrapper, {
            ...this.props,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: remaining > 0 ? backgroundColor : 'transparent',
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius,
            tooltipHoverPadding: tooltipHoverPadding,
            role: "status",
            ariaLive: "polite"
        }, validatedElements, remaining > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFSe7.default), {
            value: remaining,
            tooltipContent: remainingTooltipContent,
            color: backgroundColor,
            tooltipHoverPadding: tooltipHoverPadding
        }));
    }
}
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5e2a577faa3e6f5$var$ProgressWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1750df9-0"
})`width:100%;height:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementsHeight}px;display:flex;${({ borderRadius: borderRadius, elementsHeight: elementsHeight, tooltipHoverPadding: tooltipHoverPadding })=>!tooltipHoverPadding && `border-radius: ${borderRadius || elementsHeight / 2}px;
        overflow: hidden;
    `} & > div{${({ borderRadius: borderRadius, elementsHeight: elementsHeight })=>{
    const radius = `${borderRadius || elementsHeight / 2}px`;
    return `
                &:first-child {
                    border-top-left-radius: ${radius};
                    border-bottom-left-radius: ${radius};
                }
                &:last-child {
                    border-top-right-radius: ${radius};
                    border-bottom-right-radius: ${radius};
                }
                &:not(:last-child) {
                    margin-right: 2px;
                }
                &:last-child {
                    margin-right: 0;
                }
            `;
}}}`;
$d5e2a577faa3e6f5$var$ProgressWrapper.displayName = 'ProgressWrapper';

});
parcelRegister("dFSe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $82fb7c5bc6b12ae1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $2eG9N = parcelRequire("2eG9N");
const $82fb7c5bc6b12ae1$var$SingleElementWithTooltip = (props)=>{
    const { value: value, tooltipContent: tooltipContent, color: color, position: position, tooltipHoverPadding: tooltipHoverPadding } = props;
    const TooltipTag = (0, $eUqFw.useMemo)(()=>// FIXME: Fix that by extracting the forwarded component
        // eslint-disable-next-line react/no-unstable-nested-components
        /*#__PURE__*/ (0, $eUqFw.forwardRef)((tagProps, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb7c5bc6b12ae1$var$SingleElement, {
                elementGrow: value,
                color: color,
                // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type '((instance: any) => void) | RefObject<HTMLElement | SVGElement | Component<{}, {}, any>> | undefined'.
                innerRef: ref,
                tooltipHoverPadding: tooltipHoverPadding,
                ...tagProps,
                ...typeof tooltipContent === 'string' ? {
                    role: 'button',
                    'aria-label': tooltipContent,
                    alt: tooltipContent,
                    tabIndex: 0
                } : {}
            })), [
        color,
        value,
        tooltipContent,
        tooltipHoverPadding
    ]);
    return(// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'keyof IntrinsicElements | ComponentType<AllHTMLAttributes<HTMLElement> & { ref: Ref<HTMLElement>; }> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: tooltipContent,
        position: position,
        tag: TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null)));
};
class $82fb7c5bc6b12ae1$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            value: 0,
            tooltipContent: ''
        };
    }
    render() {
        const { value: value, tooltipContent: tooltipContent, color: color } = this.props;
        const hasTooltipContent = Boolean(tooltipContent);
        if (hasTooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb7c5bc6b12ae1$var$SingleElementWithTooltip, {
            ...this.props,
            tooltipContent: tooltipContent
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb7c5bc6b12ae1$var$SingleElement, {
            elementGrow: value,
            color: color,
            alt: tooltipContent
        });
    }
}
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82fb7c5bc6b12ae1$var$SingleElement = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-234u1k-0"
})`flex-grow:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementGrow};height:100%;min-width:5px;background-color:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.color};div{height:100%;width:100%;${({ tooltipHoverPadding: tooltipHoverPadding })=>tooltipHoverPadding && `padding-block: ${tooltipHoverPadding}px;
            margin-top: -${tooltipHoverPadding}px;`}}`;
$82fb7c5bc6b12ae1$var$SingleElement.displayName = 'SingleElement';

});


parcelRegister("jh1l7", function(module, exports) {

$parcel$export(module.exports, "default", () => $714cc4dce95e2319$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $714cc4dce95e2319$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "roadmap.timeline-table-kit.common.progress-bar.tooltip",
        "defaultMessage": "{name}: {count} of {total}"
    }
});

});


parcelRegister("8CN2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c5121bf494f93cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e63D2 = parcelRequire("e63D2");

var $bScYc = parcelRequire("bScYc");

var $jIR54 = parcelRequire("jIR54");

var $g3rFT = parcelRequire("g3rFT");
const $9c5121bf494f93cb$export$f994b46402ed991f = (event)=>{
    const withCmd = event.ctrlKey || event.metaKey;
    // We do not want to navigate away when clicking unless there is explicit intent
    // In most cases, a click should open up the item details
    withCmd ? event.stopPropagation() : event.preventDefault();
};
const $9c5121bf494f93cb$var$onPress = (e, link)=>{
    if (e.key === 'Enter') window.open(link, '_blank');
};
const $9c5121bf494f93cb$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9c5121bf494f93cb$var$tooltipTag,
        ref: ref,
        ...props
    }));
const $9c5121bf494f93cb$var$Summary = ({ title: title, iconUrl: iconUrl, isDone: isDone, itemKey: itemKey, iconAltText: iconAltText, highlightText: highlightText, isActive: isActive, progressMetadata: progressMetadata })=>{
    const highlight = (0, $eUqFw.useMemo)(()=>[
            highlightText
        ], [
        highlightText
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        const withCmd = event.ctrlKey || event.metaKey;
        // We do not want to navigate away when clicking unless there is explicit intent
        // In most cases, a click should open up the item details
        withCmd ? event.stopPropagation() : event.preventDefault();
    }, []);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Enter') return;
        event.stopPropagation();
        const link = `/browse/${itemKey}`;
        const withCmd = event.ctrlKey || event.metaKey;
        if (withCmd) {
            event.preventDefault();
            window.open(link, '_blank');
        }
    }, [
        itemKey
    ]);
    const itemKeyEl = highlightText !== '' && itemKey !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e63D2.default), {
        "data-testid": "roadmap.timeline-table-kit.ui.list-item-content.summary.item-el",
        text: itemKey,
        highlight: highlight
    }) : itemKey;
    const titleEl = highlightText !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e63D2.default), {
        "data-testid": "roadmap.timeline-table-kit.ui.list-item-content.summary.title-el",
        text: title,
        highlight: highlight
    }) : title;
    const renderSummaryTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryTitle), {
            type: "p",
            testId: "roadmap.timeline-table-kit.ui.list-item-content.summary.title"
        }, titleEl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryIcon), {
        src: iconUrl,
        alt: iconAltText
    }), itemKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryKeyLink), {
        href: `/browse/${itemKey}`,
        isDone: isDone,
        testId: "roadmap.timeline-table-kit.ui.list-item-content.summary.key",
        "aria-label": formatMessage((0, $jIR54.default).issueKeyLabel, {
            itemKey: itemKey
        }),
        onClick: (0, $eI5EY.fg)('timeline_grid_navigation_m2') ? onClick : $9c5121bf494f93cb$export$f994b46402ed991f,
        onKeyDown: (0, $eI5EY.fg)('timeline_grid_navigation_m2') ? onKeyDown : (e)=>$9c5121bf494f93cb$var$onPress(e, `/browse/${itemKey}`)
    }, itemKeyEl), title.length > 16 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "bottom-start",
        content: titleEl,
        ...(0, $eI5EY.fg)('jsw_fix_timeline_issue_summary_missing_ellipses') && {
            tag: $9c5121bf494f93cb$var$TooltipTag
        }
    }, renderSummaryTitle()) : renderSummaryTitle()), progressMetadata.total > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3rFT.default), {
        ...progressMetadata,
        isActive: isActive
    }));
};
const $9c5121bf494f93cb$var$tooltipTag = (0, $1ZAYh.xcss)({
    overflow: 'hidden'
});
const $9c5121bf494f93cb$var$DEFAULT_PROGRESS_META = {
    completed: 0,
    total: 0
};
$9c5121bf494f93cb$var$Summary.defaultProps = {
    isDone: false,
    iconAltText: '',
    highlightText: '',
    progressMetadata: $9c5121bf494f93cb$var$DEFAULT_PROGRESS_META
};
var $9c5121bf494f93cb$export$2e2bcd8739ae039 = $9c5121bf494f93cb$var$Summary;

});
parcelRegister("e63D2", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e295d31ad42542$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gttjd = parcelRequire("gttjd");

var $lbHMu = parcelRequire("lbHMu");
const $29e295d31ad42542$var$HighlightTextWithParser = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $gttjd.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbHMu.default), {
        parts: parts
    });
});
var $29e295d31ad42542$export$2e2bcd8739ae039 = $29e295d31ad42542$var$HighlightTextWithParser;

});
parcelRegister("gttjd", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $38a0e824f156ae86$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $38a0e824f156ae86$export$a3aee8a24a54661f);

var $e1vfz = parcelRequire("e1vfz");

var $hTLlD = parcelRequire("hTLlD");

var $lyOYo = parcelRequire("lyOYo");

var $5iWql = parcelRequire("5iWql");
const $38a0e824f156ae86$export$f3f2882e8b11d731 = (0, $5iWql.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $38a0e824f156ae86$export$1633667427d99697 = (0, $5iWql.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $38a0e824f156ae86$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $38a0e824f156ae86$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $38a0e824f156ae86$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $38a0e824f156ae86$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $38a0e824f156ae86$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $38a0e824f156ae86$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $38a0e824f156ae86$export$f3f2882e8b11d731(text);
    const textMatches = $38a0e824f156ae86$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $38a0e824f156ae86$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(leading));
        parts.push($38a0e824f156ae86$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("lbHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9071505b4a281f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gda1r = parcelRequire("gda1r");
const $ed9071505b4a281f$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gda1r.Mark), {
            key: i
        }, part.content);
    }));
var $ed9071505b4a281f$export$2e2bcd8739ae039 = $ed9071505b4a281f$var$HighlightText;

});
parcelRegister("gda1r", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $8f973f57522751f3$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8f973f57522751f3$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});



parcelRegister("bScYc", function(module, exports) {

$parcel$export(module.exports, "SummaryContainer", () => $547057acf71ea9b7$export$bd55427d3650a1b0);
$parcel$export(module.exports, "SummaryIcon", () => $547057acf71ea9b7$export$ced6452f422b797e);
$parcel$export(module.exports, "SummaryKeyLink", () => $547057acf71ea9b7$export$a0a8cbd1a9f0ffc8);
$parcel$export(module.exports, "SummaryKeyLabel", () => $547057acf71ea9b7$export$f769aedd3eaca4c3);
$parcel$export(module.exports, "SummaryTitle", () => $547057acf71ea9b7$export$ec39b3a5dbed0806);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dqhN0 = parcelRequire("dqhN0");
const $547057acf71ea9b7$var$containerStylesCompiledStyles = null;
const $547057acf71ea9b7$var$iconStylesCompiledStyles = null;
const $547057acf71ea9b7$var$keyStylesCompiledStyles = null;
const $547057acf71ea9b7$var$doneStylesCompiledStyles = null;
const $547057acf71ea9b7$var$titleStylesCompiledStyles = null;
const $547057acf71ea9b7$export$bd55427d3650a1b0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bto1l2s _1bsb1osq _1yt4swc3"
        ])
    }, children); // these styles are reusable, so created in a shared component
const $547057acf71ea9b7$export$ced6452f422b797e = ({ alt: alt, src: src })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: alt
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: src,
            alt: alt,
            "aria-label": // Nested ternary will be removed on FG cleanup
            // eslint-disable-next-line no-nested-ternary
            (0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-table-kit-violations') ? alt ? formatMessage((0, $dqhN0.default).iconLabel, {
                issueType: alt
            }) : undefined : formatMessage((0, $dqhN0.default).iconLabel, {
                issueType: alt
            }),
            "data-testid": "roadmap.timeline-table-kit.common.ui.summary.icon",
            ...tooltipProps,
            className: (0, $7JEyt.default)([
                "_1bsbpxbi _4t3ipxbi _2rko1l7b _16jlidpf _1o9zidpf _i0dl1wug"
            ])
        }));
}; // https://github.com/facebook/react/issues/1881 (replaces previous implementation of !important not working in React)
const $547057acf71ea9b7$export$a0a8cbd1a9f0ffc8 = ({ children: children, isDone: isDone, testId: testId, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        "data-testid": testId,
        ...rest,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _12ji1r31 _1qu2glyw _12y31o36 _18s8171m _o5721q9c _syaz1rc1 _9h8h1rc1 _f8pj1rc1 _30l31rc1 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            isDone && "_4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hms1911 _c2wa1911 _4fpr1911 _1bnx1911 _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1"
        ])
    }, children); // https://github.com/facebook/react/issues/1881 (replaces previous implementation of !important not working in React)
const $547057acf71ea9b7$export$f769aedd3eaca4c3 = ({ children: children, isDone: isDone, testId: testId, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId,
        ...rest,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _12ji1r31 _1qu2glyw _12y31o36 _18s8171m _o5721q9c _syaz1rc1 _9h8h1rc1 _f8pj1rc1 _30l31rc1 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            isDone && "_4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hms1911 _c2wa1911 _4fpr1911 _1bnx1911 _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1"
        ])
    }, children); // these styles are reusable, so created in a shared component (currently used to render as `div` and `a` elements in the codebase)
const $547057acf71ea9b7$export$ec39b3a5dbed0806 = ({ type: type, testId: testId, children: children })=>{
    switch(type){
        case 'div':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": testId,
                className: (0, $7JEyt.default)([
                    "_18s8171m _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n"
                ])
            }, children);
        case 'p':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
                "data-testid": testId,
                className: (0, $7JEyt.default)([
                    "_18s8171m _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n"
                ])
            }, children);
    }
};

});
parcelRegister("dqhN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c338c694fff6ad3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c338c694fff6ad3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    iconLabel: {
        "id": "roadmap.timeline-table-kit.common.summary.icon-label",
        "defaultMessage": "issue type {issueType}"
    }
});

});


parcelRegister("jIR54", function(module, exports) {

$parcel$export(module.exports, "default", () => $577a7bb09ebf256d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $577a7bb09ebf256d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueKeyLabel: {
        "id": "roadmap.timeline-table-kit.list-item-content.summary.issue-key-label",
        "defaultMessage": "issue key {itemKey}"
    }
});

});

parcelRegister("g3rFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $377caa169a766413$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jfQfF = parcelRequire("jfQfF");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $hCUoY = parcelRequire("hCUoY");
const $377caa169a766413$var$Indicator = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
        testId: "roadmap.timeline-table-kit.ui.list-item-content.summary.progress-indicator",
        primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
        size: "small",
        label: label
    });
const $377caa169a766413$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($377caa169a766413$var$Container, {
        ref: ref,
        ...props
    }));
const $377caa169a766413$var$ProgressIndicator = (props)=>{
    const { total: total, completed: completed, isActive: isActive } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onTooltipShow = (analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'childIssuesIcon', {
            childIssuesNum: total
        });
    };
    const message = formatMessage((0, $hCUoY.default).progressMetadataTooltip, {
        completed: completed,
        total: total
    });
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: message,
        tag: $377caa169a766413$var$TooltipTag,
        onShow: onTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($377caa169a766413$var$Indicator, {
        label: message
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($377caa169a766413$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($377caa169a766413$var$Indicator, {
        label: message
    }));
};
var $377caa169a766413$export$2e2bcd8739ae039 = $377caa169a766413$var$ProgressIndicator;
const $377caa169a766413$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz _16jlidpf _1o9zidpf _i0dlexct _1reo15vq _18m915vq _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jfQfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e047f322faad4563$var$_react = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e047f322faad4563$var$_childIssues = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("hudZr")));
function $e047f322faad4563$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e047f322faad4563$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $e047f322faad4563$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $e047f322faad4563$var$_childIssues.default
    }));
$e047f322faad4563$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $e047f322faad4563$var$_default = module.exports.default = $e047f322faad4563$var$ChildIssuesIcon;

});
parcelRegister("hudZr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::573ec388b005b16cfabb95e4ea3d026a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbb01725e51449c9$var$_react = $cbb01725e51449c9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cbb01725e51449c9$var$_UNSAFE_baseNew = $cbb01725e51449c9$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cbb01725e51449c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbb01725e51449c9$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cbb01725e51449c9$var$_react.default.createElement($cbb01725e51449c9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
    }, props));
$cbb01725e51449c9$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cbb01725e51449c9$var$_default = module.exports.default = $cbb01725e51449c9$var$ChildIssuesIcon;

});


parcelRegister("hCUoY", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b53741691748cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $51b53741691748cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    progressMetadataTooltip: {
        "id": "roadmap.timeline-table-kit.list-item-content.summary.progress-indicator.progress-metadata-tooltip",
        "defaultMessage": "{completed} of {total} child issues complete"
    }
});

});




parcelRegister("hZTXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1b2140bb15d7c06$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e1b2140bb15d7c06$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createChild: {
        "id": "roadmap.standard-roadmap.common.table.list-item-content.create-child",
        "defaultMessage": "Create child issue"
    }
});

});



parcelRegister("8xVyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4472e8a64659deca$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $lNNXV = parcelRequire("lNNXV");

var $gB4dC = parcelRequire("gB4dC");

var $6FeJk = parcelRequire("6FeJk");

var $9E22T = parcelRequire("9E22T");
var $4472e8a64659deca$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, { id: id })=>{
    const issueType = (0, $9E22T.getIssueTypeForIssueId)(state, id);
    return {
        iconUrl: issueType?.iconUrl,
        title: (0, $6FeJk.getIssueSummary)(state, id),
        itemKey: (0, $6FeJk.getIssueKeyById)(state, id),
        isDone: (0, $6FeJk.getIsIssueResolved)(state, id)
    };
}, null, (stateProps)=>({
        ...stateProps
    }))((0, $gB4dC.RoadmapListItemContentLite));

});
parcelRegister("gB4dC", function(module, exports) {

$parcel$export(module.exports, "RoadmapListItemContentLite", () => $d3ebda59fb1111bb$export$6049b0f2a203677);

var $eUqFw = parcelRequire("eUqFw");

var $bScYc = parcelRequire("bScYc");
const $d3ebda59fb1111bb$export$6049b0f2a203677 = ({ title: title, iconUrl: iconUrl, itemKey: itemKey, isDone: isDone })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryIcon), {
        src: iconUrl,
        alt: ""
    }), itemKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryKeyLabel), {
        isDone: isDone
    }, itemKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryTitle), {
        type: "div"
    }, title));
$d3ebda59fb1111bb$export$6049b0f2a203677.defaultProps = {
    iconUrl: '',
    isDone: false
};

});


parcelRegister("imbpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $012eee38137ff005$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

var $fascA = parcelRequire("fascA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $012eee38137ff005$var$ListItemCreate = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("rdi5k")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-create/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$012eee38137ff005$export$2e2bcd8739ae039 = (props)=>{
    const { isActive: isActive } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-list-item-create",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-list-item-create",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fascA.default), {
            isActive: isActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($012eee38137ff005$var$ListItemCreate, props)));
};

});
parcelRegister("fascA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d4e15a575052db$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $9VPEO = parcelRequire("9VPEO");
const $e5d4e15a575052db$var$ListItemCreateSkeleton = ({ isActive: isActive })=>isActive ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e5d4e15a575052db$var$containerStyles,
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "16px",
        height: "16px",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            marginRight: "var(--ds-space-100, 8px)"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "50%",
        height: "14px"
    })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e5d4e15a575052db$var$containerStyles,
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
        width: "35%",
        height: "20px"
    }));
var $e5d4e15a575052db$export$2e2bcd8739ae039 = $e5d4e15a575052db$var$ListItemCreateSkeleton;
const $e5d4e15a575052db$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxSizing: 'border-box'
});

});

parcelRegister("rdi5k", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cRRhw")
]).then(()=>parcelRequire('4zc9u'));

});


parcelRegister("jq8Ep", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af4043117bdd15a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $1gs0D = parcelRequire("1gs0D");

var $g6s55 = parcelRequire("g6s55");

var $yQQ9i = parcelRequire("yQQ9i");

var $fK8Yk = parcelRequire("fK8Yk");

var $imo8k = parcelRequire("imo8k");

var $h885c = parcelRequire("h885c");

var $lSzIi = parcelRequire("lSzIi");

var $2RTZR = parcelRequire("2RTZR");
const $1af4043117bdd15a$var$ListItemMenuOption = ({ optionId: optionId, id: id, setOpenModal: setOpenModal, Option: Option, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef })=>{
    switch(optionId){
        case 0, $1gs0D.CHANGE_PARENT_ISSUE:
            return (0, $eI5EY.fg)('jsw_roadmaps_timeline-meatball-reparent-menu') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RTZR.default), {
                id: id,
                Option: Option,
                setCloseMenu: setCloseMenu
            }) : null;
        case 0, $1gs0D.CHANGE_ISSUE_COLOR:
            return (0, $eI5EY.fg)('jsw_roadmaps_timeline-meatballs-change-issue-color') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yQQ9i.default), {
                id: id,
                Option: Option,
                setCloseMenu: setCloseMenu
            }) : null;
        case 0, $1gs0D.EDIT_SPRINT:
            return (0, $eI5EY.fg)('jsw_roadmaps_timeline_sprint_scheduling_a11y') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h885c.default), {
                id: id,
                Option: Option,
                setCloseMenu: setCloseMenu
            }) : null;
        case 0, $1gs0D.EDIT_DATES:
            return (0, $eI5EY.fg)('jsw_roadmaps_timeline-meatballs-date-update-modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fK8Yk.default), {
                id: id,
                setOpenModal: setOpenModal,
                Option: Option
            }) : null;
        case 0, $1gs0D.BULK_EDIT_DATES:
            return (0, $eI5EY.fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6s55.default), {
                id: id,
                setOpenModal: setOpenModal,
                Option: Option,
                setInitialFocusRef: setInitialFocusRef
            }) : null;
        case 0, $1gs0D.REMOVE_DATES:
            return (0, $eI5EY.fg)('jsw_roadmaps_timeline-meatballs-date-update-modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSzIi.default), {
                id: id,
                Option: Option,
                setCloseMenu: setCloseMenu
            }) : null;
        case 0, $1gs0D.EDIT_DEPENDENCY:
            return (0, $eI5EY.fg)('jsw_roadmaps_timeline-meatball-dependency-modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imo8k.default), {
                id: id,
                setOpenModal: setOpenModal,
                Option: Option
            }) : null;
        default:
            return null;
    }
};
var $1af4043117bdd15a$export$2e2bcd8739ae039 = $1af4043117bdd15a$var$ListItemMenuOption;

});
parcelRegister("g6s55", function(module, exports) {

$parcel$export(module.exports, "default", () => $f723940449d245e2$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $eRVKI = parcelRequire("eRVKI");

var $llrh0 = parcelRequire("llrh0");
const $f723940449d245e2$var$mapStateToProps = (state, { id: id })=>{
    const { isDateEditable: isDateEditable } = (0, $eRVKI.getBulkEditDatesOptionParams)(state, id);
    return {
        isDateEditable: isDateEditable
    };
};
var $f723940449d245e2$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($f723940449d245e2$var$mapStateToProps)((0, $llrh0.default));

});
parcelRegister("llrh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d823fc434babe4b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $75e8i = parcelRequire("75e8i");

var $4Re4A = parcelRequire("4Re4A");
const $2d823fc434babe4b$var$BulkEditDatesOption = ({ isDateEditable: isDateEditable, Option: Option, setOpenModal: setOpenModal, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        (0, $75e8i.default)('timeline-bulk-edit-dates-option-clicked', event.timeStamp);
        setOpenModal(event);
    }, [
        setOpenModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
        setInitialFocusRef: setInitialFocusRef,
        isDisabled: !isDateEditable,
        label: formatMessage((0, $4Re4A.default).bulkEditDates),
        onClick: onClick
    });
};
var $2d823fc434babe4b$export$2e2bcd8739ae039 = $2d823fc434babe4b$var$BulkEditDatesOption;

});
parcelRegister("4Re4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4435a2210b098cb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e4435a2210b098cb$var$messages = (0, $90IgZ.defineMessages)({
    bulkEditDates: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.bulk-edit-dates-option.bulk-edit-dates",
        "defaultMessage": "Edit dates"
    }
});
var $e4435a2210b098cb$export$2e2bcd8739ae039 = $e4435a2210b098cb$var$messages;

});



parcelRegister("yQQ9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $c302b0daf9bf1b7b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $eRVKI = parcelRequire("eRVKI");

var $h9saR = parcelRequire("h9saR");
const $c302b0daf9bf1b7b$var$mapStateToProps = (state, { id: id })=>{
    const changeColorOptionParams = (0, $eRVKI.getChangeColorOptionParams)(state, id);
    return {
        ...changeColorOptionParams
    };
};
var $c302b0daf9bf1b7b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($c302b0daf9bf1b7b$var$mapStateToProps)((0, $h9saR.default));

});
parcelRegister("h9saR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9af15c223dc8252$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dE07x = parcelRequire("dE07x");

var $vvQ43 = parcelRequire("vvQ43");
const $f9af15c223dc8252$var$ChangeColorOption = ({ id: id, isColorEditable: isColorEditable, color: color, Option: Option, setCloseMenu: setCloseMenu })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $dE07x.ChangeColorMenuLazy).preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
        isDisabled: !isColorEditable,
        label: formatMessage((0, $vvQ43.default).changeIssueColor)
    }, ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dE07x.ChangeColorMenuAsync), {
            id: id,
            color: color,
            setInitialFocusRef: setInitialFocusRef,
            setCloseMenu: setCloseMenu
        }));
};
var $f9af15c223dc8252$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($f9af15c223dc8252$var$ChangeColorOption);

});
parcelRegister("dE07x", function(module, exports) {

$parcel$export(module.exports, "ChangeColorMenuLazy", () => $b6ad03ce15de5d34$export$a0975b10625bf4cf);
$parcel$export(module.exports, "ChangeColorMenuAsync", () => $b6ad03ce15de5d34$export$82e69f06470e1e80);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

const $b6ad03ce15de5d34$export$a0975b10625bf4cf = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7VqTo")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-menu-option/change-color-option/change-color-menu/index.tsx"
});
const $b6ad03ce15de5d34$export$82e69f06470e1e80 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-change-color-menu",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-standard-roadmap-change-color-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b6ad03ce15de5d34$export$a0975b10625bf4cf, props)));

});
parcelRegister("7VqTo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1UJCj").then(()=>parcelRequire('dEBgV'));

});


parcelRegister("vvQ43", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f28fbaf0654b79$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $47f28fbaf0654b79$var$messages = (0, $90IgZ.defineMessages)({
    changeIssueColor: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.change-color-option.change-issue-color",
        "defaultMessage": "Change issue color"
    }
});
var $47f28fbaf0654b79$export$2e2bcd8739ae039 = $47f28fbaf0654b79$var$messages;

});



parcelRegister("fK8Yk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e010810a2606d154$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $eRVKI = parcelRequire("eRVKI");

var $9oWLK = parcelRequire("9oWLK");
const $e010810a2606d154$var$mapStateToProps = (state, { id: id })=>{
    const { isDateEditable: isDateEditable } = (0, $eRVKI.getEditDatesOptionParams)(state, id);
    return {
        isDateEditable: isDateEditable
    };
};
var $e010810a2606d154$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($e010810a2606d154$var$mapStateToProps)((0, $9oWLK.default));

});
parcelRegister("9oWLK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4a670e9576312b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $75e8i = parcelRequire("75e8i");

var $7cszw = parcelRequire("7cszw");
const $ac4a670e9576312b$var$EditDatesOption = ({ isDateEditable: isDateEditable, Option: Option, setOpenModal: setOpenModal })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        (0, $75e8i.default)('timeline-edit-dates-option-clicked', event.timeStamp);
        setOpenModal(event);
    }, [
        setOpenModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
        isDisabled: !isDateEditable,
        label: formatMessage((0, $7cszw.default).editDates),
        onClick: onClick
    });
};
var $ac4a670e9576312b$export$2e2bcd8739ae039 = $ac4a670e9576312b$var$EditDatesOption;

});
parcelRegister("7cszw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4a792e1db1b1dcd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $a4a792e1db1b1dcd$var$messages = (0, $90IgZ.defineMessages)({
    editDates: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.edit-dates-option.edit-dates",
        "defaultMessage": "Edit dates"
    }
});
var $a4a792e1db1b1dcd$export$2e2bcd8739ae039 = $a4a792e1db1b1dcd$var$messages;

});



parcelRegister("imo8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $73d1c8a03a544ee3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $2rPOt = parcelRequire("2rPOt");
const $73d1c8a03a544ee3$var$mapStateToProps = (state, { id: id })=>({
        areDependenciesSupported: (0, $bwVWW.areDependenciesSupported)(state),
        isChildIssuePlanningEnabled: (0, $bwVWW.getIsChildIssuePlanningEnabled)(state),
        level: (0, $6FeJk.getIssueLevel)(state, id)
    });
var $73d1c8a03a544ee3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($73d1c8a03a544ee3$var$mapStateToProps)((0, $2rPOt.default));

});
parcelRegister("2rPOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4acd355583cdfd27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kbiEp = parcelRequire("kbiEp");

var $75e8i = parcelRequire("75e8i");

var $eqVdo = parcelRequire("eqVdo");
const $4acd355583cdfd27$var$EditDependencyOption = ({ areDependenciesSupported: areDependenciesSupported, isChildIssuePlanningEnabled: isChildIssuePlanningEnabled, level: level, setOpenModal: setOpenModal, Option: Option })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isDisabled = !(areDependenciesSupported && (isChildIssuePlanningEnabled || (0, $kbiEp.isParentLevel)(level)));
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        (0, $75e8i.default)('timeline-edit-dependency-option-clicked', event.timeStamp);
        setOpenModal(event);
    }, [
        setOpenModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
        isDisabled: isDisabled,
        label: formatMessage((0, $eqVdo.default).editDependencies),
        onClick: onClick
    });
};
var $4acd355583cdfd27$export$2e2bcd8739ae039 = $4acd355583cdfd27$var$EditDependencyOption;

});
parcelRegister("eqVdo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b67df66f8349476$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $0b67df66f8349476$var$messages = (0, $90IgZ.defineMessages)({
    editDependencies: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.edit-dependency-option.edit-dependencies",
        "defaultMessage": "Edit dependencies"
    }
});
var $0b67df66f8349476$export$2e2bcd8739ae039 = $0b67df66f8349476$var$messages;

});



parcelRegister("h885c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd4b1695630456e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $eRVKI = parcelRequire("eRVKI");

var $5Xj4L = parcelRequire("5Xj4L");
const $6fd4b1695630456e$var$mapStateToProps = (state, { id: id })=>{
    const editSprintOptionParams = (0, $eRVKI.getEditSprintOptionParams)(state, id);
    return {
        ...editSprintOptionParams
    };
};
var $6fd4b1695630456e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($6fd4b1695630456e$var$mapStateToProps)((0, $5Xj4L.default));

});
parcelRegister("5Xj4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a21cb3dc60174da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6NmBB = parcelRequire("6NmBB");

var $hwU49 = parcelRequire("hwU49");
const $8a21cb3dc60174da$var$EditSprintOption = ({ id: id, isSprintEditable: isSprintEditable, isSprintClearable: isSprintClearable, sprints: sprints, Option: Option, setCloseMenu: setCloseMenu })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $6NmBB.EditSprintMenuLazy).preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
        isDisabled: !isSprintEditable,
        label: formatMessage((0, $hwU49.default).editSprint)
    }, ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6NmBB.EditSprintMenuAsync), {
            id: id,
            isSprintClearable: isSprintClearable,
            sprints: sprints,
            setInitialFocusRef: setInitialFocusRef,
            setCloseMenu: setCloseMenu
        }));
};
var $8a21cb3dc60174da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8a21cb3dc60174da$var$EditSprintOption);

});
parcelRegister("6NmBB", function(module, exports) {

$parcel$export(module.exports, "EditSprintMenuLazy", () => $aa374f9db7fa6b14$export$a506603a6a72df89);
$parcel$export(module.exports, "EditSprintMenuAsync", () => $aa374f9db7fa6b14$export$68015483ad69dc68);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

const $aa374f9db7fa6b14$export$a506603a6a72df89 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("535y4")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-menu-option/edit-sprint-option/edit-sprint-menu/index.tsx"
});
const $aa374f9db7fa6b14$export$68015483ad69dc68 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-edit-sprint-menu",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-standard-roadmap-edit-sprint-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa374f9db7fa6b14$export$a506603a6a72df89, props)));

});
parcelRegister("535y4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1yo4q").then(()=>parcelRequire('4aPtp'));

});


parcelRegister("hwU49", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b419eea697a4bb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $34b419eea697a4bb$var$messages = (0, $90IgZ.defineMessages)({
    editSprint: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.edit-sprint-option.edit-sprint",
        "defaultMessage": "Edit sprint"
    }
});
var $34b419eea697a4bb$export$2e2bcd8739ae039 = $34b419eea697a4bb$var$messages;

});



parcelRegister("lSzIi", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa6461bc88f835f2$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3PMIz = parcelRequire("3PMIz");

var $j45xj = parcelRequire("j45xj");

var $eRVKI = parcelRequire("eRVKI");

var $3XJQ9 = parcelRequire("3XJQ9");
const $aa6461bc88f835f2$var$mapStateToProps = (state, { id: id })=>{
    const { isDateEditable: isDateEditable, isStartDateRequired: isStartDateRequired, isDueDateRequired: isDueDateRequired, removeDatesOptionParams: removeDatesOptionParams } = (0, $eRVKI.getEditDatesOptionParams)(state, id);
    return {
        isDateEditable: isDateEditable,
        isStartDateRequired: isStartDateRequired,
        isDueDateRequired: isDueDateRequired,
        ...removeDatesOptionParams
    };
};
const $aa6461bc88f835f2$var$mapDispatchToProps = (dispatch, { id: id })=>({
        onClear: ({ isClearStart: isClearStart, isClearDue: isClearDue }, analyticsEvent)=>{
            dispatch((0, $j45xj.updateAndPersistIssue)(id, {
                clearFields: [
                    ...isClearStart ? [
                        (0, $3PMIz.START_DATE)
                    ] : [],
                    ...isClearDue ? [
                        (0, $3PMIz.DUE_DATE)
                    ] : []
                ]
            }, analyticsEvent));
        }
    });
var $aa6461bc88f835f2$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($aa6461bc88f835f2$var$mapStateToProps, $aa6461bc88f835f2$var$mapDispatchToProps)((0, $3XJQ9.default));

});
parcelRegister("3XJQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a2860d61cf1d55$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $75e8i = parcelRequire("75e8i");

var $1gs0D = parcelRequire("1gs0D");

var $36mtJ = parcelRequire("36mtJ");
const $c3a2860d61cf1d55$var$RemoveDatesOption = ({ isDateEditable: isDateEditable, isStartDateRequired: isStartDateRequired, isDueDateRequired: isDueDateRequired, isStartDateRolledUp: isStartDateRolledUp, isDueDateRolledUp: isDueDateRolledUp, isStartDateClearable: isStartDateClearable, isDueDateClearable: isDueDateClearable, Option: Option, onClear: onClear, setCloseMenu: setCloseMenu })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOnClick = (0, $eUqFw.useCallback)((isStartDateCleared, isDueDateCleared)=>(event)=>{
            event.preventDefault();
            if (isStartDateCleared || isDueDateCleared) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'option'
                });
                const attributes = {
                    isStartDateCleared: isStartDateCleared,
                    isDueDateCleared: isDueDateCleared
                };
                let ufoInteractionName = 'timeline-remove-start-date-option-clicked';
                if (isStartDateCleared && isDueDateCleared) ufoInteractionName = 'timeline-remove-both-dates-option-clicked';
                else if (isDueDateCleared) ufoInteractionName = 'timeline-remove-due-date-option-clicked';
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'removeDatesOption', attributes);
                (0, $75e8i.default)(ufoInteractionName, event.timeStamp);
                onClear({
                    isClearStart: isStartDateCleared,
                    isClearDue: isDueDateCleared
                }, analyticsEvent);
            }
            setCloseMenu(event);
        }, [
        createAnalyticsEvent,
        onClear,
        setCloseMenu
    ]);
    const getDisabledTooltip = (0, $eUqFw.useCallback)((isDateRequired, isDateRolledUp)=>{
        if (isDateRequired) return formatMessage((0, $36mtJ.default).requiredDates);
        if (isDateRolledUp) return formatMessage((0, $36mtJ.default).rolledUpDates);
        return undefined;
    }, [
        formatMessage
    ]);
    const options = (0, $eUqFw.useMemo)(()=>[
            {
                optionId: (0, $1gs0D.REMOVE_START_DATE),
                isEnabled: isStartDateClearable,
                label: formatMessage((0, $36mtJ.default).removeStartDate),
                disabledTooltip: getDisabledTooltip(isStartDateRequired, isStartDateRolledUp),
                onClick: handleOnClick(true, false)
            },
            {
                optionId: (0, $1gs0D.REMOVE_DUE_DATE),
                isEnabled: isDueDateClearable,
                label: formatMessage((0, $36mtJ.default).removeDueDate),
                disabledTooltip: getDisabledTooltip(isDueDateRequired, isDueDateRolledUp),
                onClick: handleOnClick(false, true)
            },
            {
                optionId: (0, $1gs0D.REMOVE_START_DATE_AND_DUE_DATE),
                isEnabled: isStartDateClearable && isDueDateClearable,
                label: formatMessage((0, $36mtJ.default).removeBothDates),
                disabledTooltip: getDisabledTooltip(isStartDateRequired || isDueDateRequired, isStartDateRolledUp || isDueDateRolledUp),
                onClick: handleOnClick(true, true)
            }
        ], [
        isStartDateRequired,
        isDueDateRequired,
        isStartDateRolledUp,
        isDueDateRolledUp,
        isStartDateClearable,
        isDueDateClearable,
        formatMessage,
        getDisabledTooltip,
        handleOnClick
    ]);
    const initialFocusIndex = (0, $eUqFw.useMemo)(()=>options.findIndex(({ isEnabled: isEnabled })=>isEnabled === true), [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
        isDisabled: !isDateEditable || !isStartDateClearable && !isDueDateClearable,
        label: formatMessage((0, $36mtJ.default).removeDates)
    }, ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, options.map(({ optionId: optionId, isEnabled: isEnabled, ...optionProps }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
                key: optionId,
                isDisabled: !isEnabled,
                setInitialFocusRef: index === initialFocusIndex ? setInitialFocusRef : undefined,
                ...optionProps
            })))));
};
var $c3a2860d61cf1d55$export$2e2bcd8739ae039 = $c3a2860d61cf1d55$var$RemoveDatesOption;

});
parcelRegister("36mtJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce3a2880ed70cb4b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ce3a2880ed70cb4b$var$messages = (0, $90IgZ.defineMessages)({
    removeDates: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.remove-dates",
        "defaultMessage": "Remove dates"
    },
    removeStartDate: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.remove-start-date",
        "defaultMessage": "Remove start date"
    },
    removeDueDate: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.remove-due-date",
        "defaultMessage": "Remove due date"
    },
    removeBothDates: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.remove-both-dates",
        "defaultMessage": "Remove both dates"
    },
    rolledUpDates: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.rolled-up-dates",
        "defaultMessage": "This issue uses dates rolled up from child issues."
    },
    requiredDates: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.required-dates",
        "defaultMessage": "Dates are required for this issue"
    }
});
var $ce3a2880ed70cb4b$export$2e2bcd8739ae039 = $ce3a2880ed70cb4b$var$messages;

});



parcelRegister("2RTZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f6d95568855c5c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6FeJk = parcelRequire("6FeJk");

var $dg91z = parcelRequire("dg91z");
const $37f6d95568855c5c$var$mapStateToProps = (state, { id: id })=>({
        issueLevel: (0, $6FeJk.getIssueLevel)(state, id)
    });
var $37f6d95568855c5c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($37f6d95568855c5c$var$mapStateToProps)((0, $dg91z.default));

});
parcelRegister("dg91z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b259ca4b2e2cb4e5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kbiEp = parcelRequire("kbiEp");

var $8ePbX = parcelRequire("8ePbX");

var $gv7Lc = parcelRequire("gv7Lc");
const $b259ca4b2e2cb4e5$var$ReparentMenuOption = /*#__PURE__*/ (0, $eUqFw.memo)(({ id: id, issueLevel: issueLevel, Option: MenuOption, setCloseMenu: setCloseMenu })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $gv7Lc.ReparentMenuWrapperLazy).preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuOption, {
        label: formatMessage((0, $8ePbX.default).changeParentIssue),
        isDisabled: issueLevel === (0, $kbiEp.PARENT_LEVEL)
    }, ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gv7Lc.ReparentMenuWrapperAsync), {
            id: id,
            setInitialFocusRef: setInitialFocusRef,
            setCloseMenu: setCloseMenu
        }));
});
var $b259ca4b2e2cb4e5$export$2e2bcd8739ae039 = $b259ca4b2e2cb4e5$var$ReparentMenuOption;

});
parcelRegister("8ePbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $61670e990614fcbe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $61670e990614fcbe$var$messages = (0, $90IgZ.defineMessages)({
    changeParentIssue: {
        "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.reparent-menu-option.change-parent-issue",
        "defaultMessage": "Change parent issue"
    }
});
var $61670e990614fcbe$export$2e2bcd8739ae039 = $61670e990614fcbe$var$messages;

});

parcelRegister("gv7Lc", function(module, exports) {

$parcel$export(module.exports, "ReparentMenuWrapperLazy", () => $fb2e632713a40f15$export$5d57d752ff364a69);
$parcel$export(module.exports, "ReparentMenuWrapperAsync", () => $fb2e632713a40f15$export$a904dbbf1ea9df1a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

const $fb2e632713a40f15$export$5d57d752ff364a69 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("bfI77")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-menu-option/reparent-menu-option/reparent-menu-wrapper/index.tsx"
});
const $fb2e632713a40f15$export$a904dbbf1ea9df1a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-reparent-menu",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-standard-roadmap-reparent-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb2e632713a40f15$export$5d57d752ff364a69, props)));

});
parcelRegister("bfI77", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2JX5J").then(()=>parcelRequire('emlSU'));

});





parcelRegister("1pFjT", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b3c630a5ea516f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1gs0D = parcelRequire("1gs0D");

var $16sas = parcelRequire("16sas");

var $ifxIg = parcelRequire("ifxIg");

var $4qTcV = parcelRequire("4qTcV");
const $30b3c630a5ea516f$var$ListItemModal = ({ id: id, optionId: optionId, triggerRef: triggerRef, setCloseModal: setCloseModal })=>{
    switch(optionId){
        case 0, $1gs0D.EDIT_DATES:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifxIg.RoadmapEditDatesModalAsync), {
                id: id,
                isOpen: true,
                setCloseModal: setCloseModal,
                triggerRef: triggerRef
            });
        case 0, $1gs0D.BULK_EDIT_DATES:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $16sas.RoadmapBulkEditDatesModalAsync), {
                id: id,
                isOpen: true,
                setCloseModal: setCloseModal,
                triggerRef: triggerRef
            });
        case 0, $1gs0D.EDIT_DEPENDENCY:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qTcV.RoadmapEditDependencyModalAsync), {
                id: id,
                isOpen: true,
                setCloseModal: setCloseModal,
                triggerRef: triggerRef
            });
        default:
            return null;
    }
};
var $30b3c630a5ea516f$export$2e2bcd8739ae039 = $30b3c630a5ea516f$var$ListItemModal;

});
parcelRegister("16sas", function(module, exports) {

$parcel$export(module.exports, "RoadmapBulkEditDatesModalAsync", () => $e0344b5ae57a40f7$export$664ae1536c9b5580);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e0344b5ae57a40f7$var$BulkEditDatesModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("emlRh")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-modal/bulk-edit-dates-modal/index.tsx"
});
const $e0344b5ae57a40f7$export$664ae1536c9b5580 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-bulk-edit-dates-modal",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-standard-roadmap-bulk-edit-dates-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0344b5ae57a40f7$var$BulkEditDatesModal, props)));

});
parcelRegister("emlRh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cHPA0")
]).then(()=>parcelRequire('7hB03'));

});


parcelRegister("ifxIg", function(module, exports) {

$parcel$export(module.exports, "RoadmapEditDatesModalAsync", () => $aba6401e1408c02d$export$d6828597196b3015);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aba6401e1408c02d$var$EditDatesModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8n5th")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-modal/edit-dates-modal/index.tsx"
});
const $aba6401e1408c02d$export$d6828597196b3015 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-edit-dates-modal",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-standard-roadmap-edit-dates-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aba6401e1408c02d$var$EditDatesModal, props)));

});
parcelRegister("8n5th", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7h8pe")
]).then(()=>parcelRequire('1wW1K'));

});


parcelRegister("4qTcV", function(module, exports) {

$parcel$export(module.exports, "RoadmapEditDependencyModalAsync", () => $abaa44ed92f88da1$export$64cbfe5ad163da1b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $abaa44ed92f88da1$var$EditDependencyModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("glFXa")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-modal/edit-dependency-modal/index.tsx"
});
const $abaa44ed92f88da1$export$64cbfe5ad163da1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-edit-dependency-modal",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-standard-roadmap-edit-dependency-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abaa44ed92f88da1$var$EditDependencyModal, props)));

});
parcelRegister("glFXa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1cpAi")
]).then(()=>parcelRequire('2ndkc'));

});



parcelRegister("bDb7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $e981e3fb54858870$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $lNNXV = parcelRequire("lNNXV");

var $cINvb = parcelRequire("cINvb");

var $1SuDz = parcelRequire("1SuDz");
var $e981e3fb54858870$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, { id: id })=>({
        ...(0, $1SuDz.getSecondaryFieldsHash)(state)[id]
    }), null, (stateProps)=>({
        ...stateProps
    }))((0, $cINvb.RoadmapListItemSecondaryContent));

});
parcelRegister("cINvb", function(module, exports) {

$parcel$export(module.exports, "RoadmapListItemSecondaryContent", () => $65f30e52e3471213$export$ea155116919dbf7);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $ffiyv = parcelRequire("ffiyv");

var $2eG9N = parcelRequire("2eG9N");

var $bKxX9 = parcelRequire("bKxX9");

var $8rQuz = parcelRequire("8rQuz");

var $1VUkY = parcelRequire("1VUkY");
const $65f30e52e3471213$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65f30e52e3471213$var$AvatarContainer, {
        ref: ref,
        "data-export-assignee": true,
        ...props
    }));
const $65f30e52e3471213$export$ea155116919dbf7 = ({ status: status, assignee: assignee, flagged: flagged })=>{
    if ((0, $bKxX9.ff)('jsw.timeline.return-flagged-attribute-fe')) {
        if (!status && !assignee && !flagged) return null;
    } else if (!status && !assignee) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65f30e52e3471213$var$Container, null, (0, $bKxX9.ff)('jsw.timeline.return-flagged-attribute-fe') && flagged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VUkY.FlagIcon), null), status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: status.appearance,
        maxWidth: 85,
        testId: "roadmap.timeline-table-kit.ui.list-item-secondary-content.export-status",
        isBold: (0, $8rQuz.isVisualRefreshEnabled)()
    }, status.name), assignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: assignee.name,
        tag: $65f30e52e3471213$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "roadmap.timeline-table-kit.ui.list-item-secondary-content.export-assignee" // NOTE: The testId is used by ADS Avatar component to generate testId for avatar name which is used by the image export in src/packages/software/roadmap/image-export/src/export/common/utils/convert-rasterisable-table.tsx
        ,
        appearance: "circle",
        size: "xsmall",
        src: assignee.avatarUrl,
        name: assignee.name,
        borderColor: "transparent"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $65f30e52e3471213$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _18u01b66",
            __cmplp.className
        ])
    });
});
const $65f30e52e3471213$var$AvatarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1i6y _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1VUkY", function(module, exports) {

$parcel$export(module.exports, "FlagIcon", () => $ecf87fea402d2201$export$4fd8d63cb0915eb0);

var $eUqFw = parcelRequire("eUqFw");

var $8urXR = parcelRequire("8urXR");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $5JgJ2 = parcelRequire("5JgJ2");

var $lcvNL = parcelRequire("lcvNL");
const $ecf87fea402d2201$export$4fd8d63cb0915eb0 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ecf87fea402d2201$var$flagSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8urXR))), {
        label: formatMessage((0, $lcvNL.default).flagged),
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
        size: "small"
    }));
};
const $ecf87fea402d2201$var$flagSectionStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("8urXR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62e6d140d6f5090f$var$_react = $62e6d140d6f5090f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $62e6d140d6f5090f$var$_flagFilled = $62e6d140d6f5090f$var$_interopRequireDefault((parcelRequire("4r8pw")));
function $62e6d140d6f5090f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $62e6d140d6f5090f$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $62e6d140d6f5090f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466z"/></svg>`
    }, props, {
        newIcon: $62e6d140d6f5090f$var$_flagFilled.default
    }));
$62e6d140d6f5090f$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $62e6d140d6f5090f$var$_default = module.exports.default = $62e6d140d6f5090f$var$FlagFilledIcon;

});
parcelRegister("4r8pw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a2f79b68f83f7bee45defc51e10a7e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33b035391fa932ad$var$_react = $33b035391fa932ad$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $33b035391fa932ad$var$_UNSAFE_baseNew = $33b035391fa932ad$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $33b035391fa932ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FlagFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: active feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33b035391fa932ad$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $33b035391fa932ad$var$_react.default.createElement($33b035391fa932ad$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 1.75H2.75v8H14l-3-4z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 15V9.75m0 0v-8H14l-3 4 3 4z"/>`
    }, props));
$33b035391fa932ad$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $33b035391fa932ad$var$_default = module.exports.default = $33b035391fa932ad$var$FlagFilledIcon;

});


parcelRegister("lcvNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0107f2952b1c9b2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e0107f2952b1c9b2$var$messages = (0, $90IgZ.defineMessages)({
    flagged: {
        "id": "roadmap.timeline-table-kit.list-item-secondary-content.flag-icon.flagged",
        "defaultMessage": "Flagged"
    }
});
var $e0107f2952b1c9b2$export$2e2bcd8739ae039 = $e0107f2952b1c9b2$var$messages;

});




parcelRegister("kQxvx", function(module, exports) {

$parcel$export(module.exports, "marshalOptions", () => $2aab50657c4c83f5$export$57eb6ddea50ecba1);



/**
 * Marshal action overrides
 */ const $2aab50657c4c83f5$var$onRowDragStart = ({ styleAPI: styleAPI })=>{
    styleAPI.insertStyle((0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d), (0, $3dc38c95da7b0287$export$b0ef8c040fd0c42f));
    styleAPI.insertStyle((0, $dfce2d8dd72914ca$export$cd944e09ecad5145), (0, $3dc38c95da7b0287$export$e281b974a204f69b));
};
const $2aab50657c4c83f5$var$onRowDragEnd = ({ styleAPI: styleAPI })=>{
    styleAPI.removeStyle((0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d));
    styleAPI.removeStyle((0, $dfce2d8dd72914ca$export$cd944e09ecad5145));
};
/**
 * Custom marshal actions
 */ const $2aab50657c4c83f5$var$onDependencyDragStart = ({ styleAPI: styleAPI })=>{
    styleAPI.insertStyle((0, $fbe90688b36d692e$export$c330e9be73819573), (0, $3dc38c95da7b0287$export$db54e6da0a3ca8b5));
};
const $2aab50657c4c83f5$var$onDependencyDragEnd = ({ styleAPI: styleAPI })=>{
    styleAPI.removeStyle((0, $fbe90688b36d692e$export$c330e9be73819573));
};
const $2aab50657c4c83f5$var$onBarInteractionStart = ({ styleAPI: styleAPI })=>{
    styleAPI.insertStyle((0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d), (0, $3dc38c95da7b0287$export$b0ef8c040fd0c42f));
    styleAPI.insertStyle((0, $dfce2d8dd72914ca$export$cd944e09ecad5145), (0, $3dc38c95da7b0287$export$e281b974a204f69b));
};
const $2aab50657c4c83f5$var$onBarInteractionEnd = ({ styleAPI: styleAPI })=>{
    styleAPI.removeStyle((0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d));
    styleAPI.removeStyle((0, $dfce2d8dd72914ca$export$cd944e09ecad5145));
};
const $2aab50657c4c83f5$export$57eb6ddea50ecba1 = {
    customActions: {
        onDependencyDragStart: $2aab50657c4c83f5$var$onDependencyDragStart,
        onDependencyDragEnd: $2aab50657c4c83f5$var$onDependencyDragEnd,
        onBarInteractionStart: $2aab50657c4c83f5$var$onBarInteractionStart,
        onBarInteractionEnd: $2aab50657c4c83f5$var$onBarInteractionEnd
    },
    overrideActions: {
        onRowDragStart: $2aab50657c4c83f5$var$onRowDragStart,
        onRowDragEnd: $2aab50657c4c83f5$var$onRowDragEnd
    }
};

});
const $3dc38c95da7b0287$export$b0ef8c040fd0c42f = `
    opacity: 0;
`;
const $3dc38c95da7b0287$export$e281b974a204f69b = `
    pointer-events: none;
`;
const $3dc38c95da7b0287$export$db54e6da0a3ca8b5 = `
    pointer-events: all;
`;


parcelRegister("asuJa", function(module, exports) {

$parcel$export(module.exports, "renderProvider", () => $785edb28e2ebfe0b$export$de20b5e3308d9465);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");

var $hevaQ = parcelRequire("hevaQ");

var $bwVWW = parcelRequire("bwVWW");

var $kbyLF = parcelRequire("kbyLF");

var $lqiiB = parcelRequire("lqiiB");
const $785edb28e2ebfe0b$var$Provider = (0, $lNNXV.connect)((state)=>({
        items: (0, $lqiiB.getInteractiveChartItems)(state),
        selectedItemIds: (0, $lqiiB.getSelectedItemIdsMemoized)(state),
        intervals: (0, $kbyLF.getSprintIntervals)(state),
        isDragAlongEnabled: (0, $bwVWW.getIsChildIssuePlanningEnabled)(state) && !(0, $bwVWW.getIsSprintsPlanningEnabled)(state)
    }), {})((0, $hevaQ.RoadmapChartItemInteractionProvider));
const $785edb28e2ebfe0b$export$de20b5e3308d9465 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($785edb28e2ebfe0b$var$Provider, null, children);

});
parcelRegister("lqiiB", function(module, exports) {

$parcel$export(module.exports, "getInteractiveChartItems", () => $2e48daa1d9ffcfed$export$8f9e7702b7f24610);
$parcel$export(module.exports, "getSelectedItemIdsMemoized", () => $2e48daa1d9ffcfed$export$191be9baae07fcee);

var $df4Sl = parcelRequire("df4Sl");

var $kbiEp = parcelRequire("kbiEp");

var $bwVWW = parcelRequire("bwVWW");

var $6FeJk = parcelRequire("6FeJk");

var $kbyLF = parcelRequire("kbyLF");

var $1SuDz = parcelRequire("1SuDz");

var $11LHz = parcelRequire("11LHz");
// When the new item shape is stable, we can move the isInCreation check to renderChartItemContent #ROAD-4572
const $2e48daa1d9ffcfed$var$isItemInteractive = ({ level: level, hasSprint: hasSprint, isSprintsPlanning: isSprintsPlanning, isChildIssuePlanningEnabled: isChildIssuePlanningEnabled, isInCreation: isInCreation })=>{
    /**
	 * Child items should not be interactive when child issue planning is disabled
	 * or when no active/future sprints on a Scrum roadmap
	 */ const isChildDateBasedPlanning = isChildIssuePlanningEnabled && (isSprintsPlanning && hasSprint || !isSprintsPlanning);
    if (!isInCreation && (level === (0, $kbiEp.PARENT_LEVEL) || isChildDateBasedPlanning)) return true;
    return false;
};
const $2e48daa1d9ffcfed$export$8f9e7702b7f24610 = (0, $df4Sl.createSelector)((0, $1SuDz.getChartDataHash), (0, $6FeJk.getIssueParentIdHash), (0, $11LHz.getExpandedItems), (0, $kbyLF.getSanitisedIssueSprintsHash), (0, $6FeJk.getIssueCreationTransitionHash), (0, $bwVWW.getIsSprintsPlanningEnabled), (0, $bwVWW.getIsChildIssuePlanningEnabled), (0, $bwVWW.hasActiveOrFutureSprint), (chartDataHash, parentIdHash, expandedItems, issueSprintsHash, issueIsInCreationHash, isSprintsPlanning, isChildIssuePlanningEnabled, hasSprint)=>{
    const items = [];
    Object.keys(chartDataHash).forEach((issueId)=>{
        const { dueDate: dueDate, startDate: startDate, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType } = chartDataHash[issueId];
        const parentId = parentIdHash[issueId];
        if (parentId === undefined || parentId && expandedItems[parentId]) {
            const sprints = issueSprintsHash[issueId];
            const level = parentId !== undefined ? (0, $kbiEp.BASE_LEVEL) : (0, $kbiEp.PARENT_LEVEL);
            const intervalId = (0, $kbiEp.isBaseLevel)(level) ? sprints[0]?.id.toString() : undefined;
            const isInCreation = !!issueIsInCreationHash[issueId];
            if ($2e48daa1d9ffcfed$var$isItemInteractive({
                level: level,
                hasSprint: hasSprint,
                isSprintsPlanning: isSprintsPlanning,
                isChildIssuePlanningEnabled: isChildIssuePlanningEnabled,
                isInCreation: isInCreation
            })) items.push({
                id: issueId,
                dueDate: dueDate,
                startDate: startDate,
                placeholder: placeholder,
                parentId: parentId,
                level: level,
                intervalId: intervalId,
                startDateType: startDateType,
                dueDateType: dueDateType
            });
        }
    });
    return items;
});
const $2e48daa1d9ffcfed$export$191be9baae07fcee = (0, $df4Sl.createSelector)((0, $11LHz.getSelectedItemIds), (selectedItemIds)=>selectedItemIds.map(String));

});




parcelRegister("kZoDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaafb546ee2bd681$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $aYtGv = parcelRequire("aYtGv");

var $eI5EY = parcelRequire("eI5EY");

var $gZ48R = parcelRequire("gZ48R");

var $kIY50 = parcelRequire("kIY50");

var $6FP8W = parcelRequire("6FP8W");

var $8LIba = parcelRequire("8LIba");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $gy9MQ = parcelRequire("gy9MQ");

var $fijOW = parcelRequire("fijOW");

var $gkvbX = parcelRequire("gkvbX");

var $gBYS0 = parcelRequire("gBYS0");

var $5ESJx = parcelRequire("5ESJx");

var $dQklQ = parcelRequire("dQklQ");

var $idiDE = parcelRequire("idiDE");

var $jK1pm = parcelRequire("jK1pm");

var $cDvag = parcelRequire("cDvag");

var $lQHIu = parcelRequire("lQHIu");

var $6sf1B = parcelRequire("6sf1B");

var $cNop8 = parcelRequire("cNop8");

var $kXTWm = parcelRequire("kXTWm");
// eslint-disable-next-line jira/react/no-class-components
class $eaafb546ee2bd681$var$StandardRoadmap extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isHeaderHidden: false,
            onExperienceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        const { isHealthy: isHealthy, onLoaded: onLoaded, onExperienceSuccess: onExperienceSuccess } = this.props;
        // The app was initialized in a valid state (no healthcheck)
        isHealthy && onLoaded();
        onExperienceSuccess();
    }
    shouldComponentUpdate(nextProps) {
        return this.props.isHealthy !== nextProps.isHealthy || this.props.isHeaderHidden !== nextProps.isHeaderHidden || this.props.isServer !== nextProps.isServer || this.props.isMacroView !== nextProps.isMacroView;
    }
    componentDidUpdate(prevProps) {
        const { isHealthy: isHealthy, onLoaded: onLoaded } = this.props;
        // The app was initialized in an invalid state (required healthcheck setup)
        if (isHealthy && !prevProps.isHealthy) onLoaded();
    }
    renderHeader() {
        const { Header: Header } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "roadmap-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null));
    }
    renderRoadmap() {
        const { Table: Table, isServer: isServer, RealtimeProvider: RealtimeProvider, isMacroView: isMacroView, isHeaderHidden: isHeaderHidden, issueIds: issueIds } = this.props;
        const shouldFixOverlap = (0, $eI5EY.fg)('jsw_roadmaps_timeline-fix-announcement-overlap');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isHeaderHidden ? null : this.renderHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-fullscreen-id": (0, $6FP8W.getWillShowNav4)() ? undefined : 'roadmap-container',
            "data-testid": "roadmap.standard-roadmap.roadmap-container",
            style: {
                marginLeft: isMacroView ? '-1px' : 0,
                marginTop: isHeaderHidden ? '-1px' : 0
            },
            className: (0, $7JEyt.default)([
                (0, $6FP8W.getWillShowNav4)() && "_16jlkb7n _1o9zkb7n _i0dl1wug _bfhkvuon _kqswh2mm",
                !(0, $6FP8W.getWillShowNav4)() && !shouldFixOverlap && "_16jlkb7n _1o9zkb7n _i0dl1wug _bfhkvuon _kqswh2mm _pvfm1n9t _pxxhkb7n _q639idpf _ph9didpf _1do1idpf _1yagidpf _xfk61ejb _1ownutpp",
                !(0, $6FP8W.getWillShowNav4)() && shouldFixOverlap && "_16jlkb7n _1o9zkb7n _i0dl1wug _bfhkvuon _kqswh2mm _pvfmstnw _pxxhkb7n _q639idpf _ph9didpf _1do1idpf _1yagidpf _xfk61ejb _1ownutpp"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LIba.IccProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
            name: "roadmap-table"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Table, {
            isServer: isServer
        }))), !isServer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kXTWm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gy9MQ.default), {
            issueIds: issueIds
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ESJx.AsyncScrumOnboardingModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gBYS0.AsyncKanbanOnboardingModal), null), (0, $cDvag.isCustomerTemplatesMuseumEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gkvbX.AsyncCustomerTemplatesOnboardingModal), null), !isMacroView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQklQ.AsyncWelcomeModal), {
            source: "timeline"
        }), !(0, $gZ48R.default)('roadmap_realtime') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RealtimeProvider, null) : null);
    }
    render() {
        const { isHealthy: isHealthy, isMacroView: isMacroView, isClassic: isClassic, Healthcheck: Healthcheck, DocumentTitle: DocumentTitle, RouterUpdater: RouterUpdater, boardId: boardId, projectKey: projectKey, MountAnalytic: MountAnalytic, shouldMountKeyboardShortcuts: shouldMountKeyboardShortcuts, objectId: objectId, projectId: projectId, boardType: boardType, childIssuePlanningMode: childIssuePlanningMode } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            containerType: "project",
            containerId: projectId,
            objectType: "board",
            objectId: objectId,
            attributes: {
                projectId: projectId,
                boardId: boardId,
                boardType: boardType,
                childIssuePlanningMode: childIssuePlanningMode
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQHIu.InteractionMetricsExtraData), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cNop8.default), {
            isMacroView: isMacroView
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6sf1B.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_vchhusvi _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq",
                isMacroView ? "_4t3i1kxc _19bvidpf" : "_4t3i1l47 _19bv1ylp"
            ]),
            style: {
                "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
            }
        }, isHealthy ? this.renderRoadmap() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Healthcheck, null)), shouldMountKeyboardShortcuts && (0, $kIY50.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fijOW.default), {
            boardId: boardId,
            projectKey: projectKey,
            isCMPBoard: isClassic
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RouterUpdater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MountAnalytic, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
    }
}
var $eaafb546ee2bd681$export$2e2bcd8739ae039 = $eaafb546ee2bd681$var$StandardRoadmap;
const $eaafb546ee2bd681$var$containerStyles = null;
const $eaafb546ee2bd681$var$roadmapContainerStylesOldNavigation = null;
const $eaafb546ee2bd681$var$roadmapContainerStylesOld = null;
const $eaafb546ee2bd681$var$roadmapContainerStylesNewNavigation = null;
const $eaafb546ee2bd681$var$macroViewStyles = null;
const $eaafb546ee2bd681$var$nonMacroViewStyles = null;

});
parcelRegister("8LIba", function(module, exports) {

$parcel$export(module.exports, "IccContext", () => $53ef4a1beaf15b73$export$2f62d2dfd027123d);
$parcel$export(module.exports, "useIccContext", () => $53ef4a1beaf15b73$export$f7b8d088c9ea045e);
$parcel$export(module.exports, "IccProvider", () => $53ef4a1beaf15b73$export$4a7497397d7465fc);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $53ef4a1beaf15b73$export$2f62d2dfd027123d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    initialSummary: '',
    initialCardTypeId: null,
    initialFieldValues: new Map(),
    initialProjectId: null,
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeFieldValue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $53ef4a1beaf15b73$export$f7b8d088c9ea045e = ()=>(0, $eUqFw.useContext)($53ef4a1beaf15b73$export$2f62d2dfd027123d);
// eslint-disable-next-line jira/react/no-class-components
class $53ef4a1beaf15b73$export$4a7497397d7465fc extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53ef4a1beaf15b73$export$2f62d2dfd027123d.Provider, {
            value: {
                initialSummary: this.state.initialSummary,
                initialCardTypeId: this.state.initialCardTypeId,
                initialFieldValues: this.state.initialFieldValues,
                initialProjectId: this.state.initialProjectId,
                onChangeCardType: this.onChangeCardType,
                onChangeSummary: this.onChangeSummary,
                onChangeFieldValue: this.onChangeFieldValue,
                onChangeProject: this.onChangeProject,
                onCancel: this.onCancel,
                onCreate: this.onCreate
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            initialSummary: '',
            initialCardTypeId: null,
            initialFieldValues: new Map(),
            initialProjectId: null
        };
        this.onChangeSummary = (summary)=>{
            this.setState({
                initialSummary: summary
            });
        };
        this.onChangeProject = (projectId)=>{
            this.setState({
                initialProjectId: projectId
            });
        };
        this.onChangeCardType = (cardTypeId)=>{
            this.setState({
                initialCardTypeId: cardTypeId
            });
        };
        this.onChangeFieldValue = (fieldKey, fieldValue)=>{
            this.setState(({ initialFieldValues: initialFieldValues })=>({
                    initialFieldValues: initialFieldValues.set(fieldKey, fieldValue)
                }));
        };
        this.onCancel = ()=>{
            this.setState({
                initialSummary: '',
                initialCardTypeId: null
            });
        };
        this.onCreate = ()=>{
            this.setState({
                initialSummary: ''
            });
        };
    }
}

});

parcelRegister("gy9MQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $03cc687fdc6e236f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $frztX = parcelRequire("frztX");
function $03cc687fdc6e236f$var$PrefetchClientOnly(props) {
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frztX.Prefetch), props);
}
var $03cc687fdc6e236f$export$2e2bcd8739ae039 = $03cc687fdc6e236f$var$PrefetchClientOnly;

});
parcelRegister("frztX", function(module, exports) {

$parcel$export(module.exports, "Prefetch", () => $cce652fa651eefcc$export$a92e3edabc61a974);

var $eUqFw = parcelRequire("eUqFw");

var $gZWxz = parcelRequire("gZWxz");
// eslint-disable-next-line jira/react/no-class-components
class $cce652fa651eefcc$var$Prefetch extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.fetchIssues(props.issueIds, props.issueKeys);
    }
    componentDidUpdate({ issueIds: prevIssueIds, issueKeys: prevIssueKeys }) {
        const { issueIds: issueIds, issueKeys: issueKeys } = this.props;
        if (prevIssueIds !== issueIds) {
            const newIds = issueIds.filter((issueId)=>{
                const isTemporaryId = Number(issueId) < 0;
                return !prevIssueIds.includes(issueId) && !isTemporaryId;
            });
            this.fetchIssues(newIds);
        }
        if (issueKeys && prevIssueKeys && prevIssueKeys !== issueKeys) this.fetchIssues([], issueKeys);
    }
    fetchIssues(issueIds, issueKeys) {
        if (issueIds.length > 0) this.props.dataProvider.loadIssuesById(issueIds.map((id)=>String(id)));
        if (issueKeys && issueKeys.length > 0) this.props.dataProvider.loadIssues(issueKeys);
    }
    render() {
        return null;
    }
}
// @ts-expect-error - TS2559 - Type 'Props' has no properties in common with type '{ readonly dataProvider?: DataProvider | undefined; }'.
const $cce652fa651eefcc$export$a92e3edabc61a974 = (0, $gZWxz.WithDataProvider)($cce652fa651eefcc$var$Prefetch);

});
parcelRegister("gZWxz", function(module, exports) {

$parcel$export(module.exports, "WithDataProvider", () => $e2e6d5fa5786b434$export$b0017632f1661e1);

var $eUqFw = parcelRequire("eUqFw");

var $6J3mH = parcelRequire("6J3mH");
const $e2e6d5fa5786b434$export$b0017632f1661e1 = (WrappedComponent)=>// @ts-expect-error - TS2322 - Type '(props: TProps) => JSX.Element' is not assignable to type 'AbstractComponent<TProps, any>'.
    (props)=>{
        const { dataProvider: dataProvider, ...otherProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6J3mH.DataProviderContext).Consumer, null, (contextDataProvider)=>// @ts-expect-error - TS2322 - Type 'Omit<TProps, "dataProvider"> & { dataProvider: DataProvider; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<TProps & OwnProps> & RefAttributes<any> & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...otherProps,
                dataProvider: dataProvider || contextDataProvider()
            }));
    };

});
parcelRegister("6J3mH", function(module, exports) {

$parcel$export(module.exports, "DataProviderContext", () => $4a77777697c6cfb8$export$5bce75db3a3f66c4);

var $eUqFw = parcelRequire("eUqFw");

var $7JlQ7 = parcelRequire("7JlQ7");
const $4a77777697c6cfb8$export$5bce75db3a3f66c4 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $7JlQ7.getDataProvider));

});
parcelRegister("7JlQ7", function(module, exports) {

$parcel$export(module.exports, "getDataProvider", () => $b647076092cf3969$export$add6bf8e4261fead);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");

var $e91YZ = parcelRequire("e91YZ");

var $6vrw7 = parcelRequire("6vrw7");

var $aVkxW = parcelRequire("aVkxW");
const $b647076092cf3969$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS = 3600;
const $b647076092cf3969$var$DEFAULT_MAX_SIZE = 100;
const $b647076092cf3969$var$getTenantBaseUrl = ()=>{
    try {
        return (0, $6vrw7.toBaseUrl)((0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().baseUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return (0, $6vrw7.toBaseUrl)('');
    }
};
const $b647076092cf3969$var$createConfig = (config = {})=>{
    const defaultConfig = {
        expiryThresholdSeconds: $b647076092cf3969$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS,
        maxSize: $b647076092cf3969$var$DEFAULT_MAX_SIZE,
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        baseUrl: Object.prototype.hasOwnProperty.call(config, 'baseUrl') ? config.baseUrl : $b647076092cf3969$var$getTenantBaseUrl(),
        ssrCachedIssue: null
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return Object.assign({}, defaultConfig, config);
};
const $b647076092cf3969$export$33c5e0ba77bb7d8 = (options = {})=>{
    const config = $b647076092cf3969$var$createConfig(options);
    const baseUrl = (0, $6vrw7.toBaseUrl)(config.baseUrl);
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const clearCache = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const insertSerializedIssue = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssues = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssuesById = ()=>{};
    // @ts-expect-error - TS2355 - A function whose declared type is neither 'void' nor 'any' must return a value.
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const getIssue = ()=>{};
    const loadIssue$ = ()=>(0, $3JafE.Observable).empty();
    const getIssue$ = ()=>(0, $3JafE.Observable).empty();
    const refreshIssue$ = ()=>loadIssue$();
    const getIssueRemoteData$ = (issueKey, cloudId, isIssueViewWhiteboardsStandaloneEnabled)=>isIssueViewWhiteboardsStandaloneEnabled ? (0, $aVkxW.fetchIssueRemoteDataWithWhiteboards$)((0, $6vrw7.toIssueKey)(issueKey), (0, $6vrw7.toCloudId)(cloudId)) : (0, $aVkxW.fetchIssueRemoteData$)(baseUrl, (0, $6vrw7.toIssueKey)(issueKey));
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const updateIssue = ()=>{};
    const getMetrics = ()=>({
            cacheSize: 0,
            cacheStaleCount: 0,
            cacheAvailableCapacity: 0,
            cacheHit: false,
            staleCacheHit: false
        });
    return {
        clearCache: clearCache,
        loadIssues: loadIssues,
        loadIssuesById: loadIssuesById,
        getIssue: getIssue,
        getIssue$: getIssue$,
        getIssueRemoteData$: getIssueRemoteData$,
        refreshIssue$: refreshIssue$,
        updateIssue: updateIssue,
        getMetrics: getMetrics,
        insertSerializedIssue: insertSerializedIssue
    };
};
// store it as a singleton
let $b647076092cf3969$var$dataProvider;
const $b647076092cf3969$export$add6bf8e4261fead = ()=>{
    if ($b647076092cf3969$var$dataProvider == null) $b647076092cf3969$var$dataProvider = $b647076092cf3969$export$33c5e0ba77bb7d8();
    return $b647076092cf3969$var$dataProvider;
};

});
parcelRegister("aVkxW", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData$", () => $b6c369d51634b049$export$83220ed1a595568a);
$parcel$export(module.exports, "fetchIssueRemoteDataWithWhiteboards$", () => $b6c369d51634b049$export$3aec720cf88c26cd);

var $3JafE = parcelRequire("3JafE");
parcelRequire("flmol");
parcelRequire("8OtG5");
parcelRequire("1Lcr1");
parcelRequire("8jBvP");

var $cwK3t = parcelRequire("cwK3t");

var $df9H8 = parcelRequire("df9H8");

var $dXapj = parcelRequire("dXapj");

var $aynDk = parcelRequire("aynDk");

var $6yPEx = parcelRequire("6yPEx");

var $3ElT9 = parcelRequire("3ElT9");

var $3A3OQ = parcelRequire("3A3OQ");

var $6vrw7 = parcelRequire("6vrw7");

var $l0eyw = parcelRequire("l0eyw");

var $gNavb = parcelRequire("gNavb");

const $b6c369d51634b049$var$LOG_LOCATION = 'issue.data-provider.source.issue-express';
const $b6c369d51634b049$var$getIssueKeyFromResponse = (response)=>{
    // @ts-expect-error - TS2339 - Property 'fields' does not exist on type 'ViewIssue | ViewIssueRemoteData'.
    const fields = response.fields || [];
    const issueKeyField = fields.find(// @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
    (field)=>field.__typename === $330b0f1977bf0938$export$40bed7a29c3b629);
    if (!issueKeyField) throw new Error('Issue key field missing in graphql response');
    return (0, $6vrw7.toIssueKey)(issueKeyField.stringValue);
};
const $b6c369d51634b049$var$transformGraphQlIssueRemoteData = (response, issueKey)=>{
    if (!response) return null;
    const key = issueKey || $b6c369d51634b049$var$getIssueKeyFromResponse(response);
    const now = new Date();
    const { issueId: issueId, remoteLinks: remoteLinks } = response;
    return (0, $l0eyw.createIssue)({
        key: key
    }).withMeta({
        newIssueViewLockedIn: response.meta ? response.meta.newIssueViewLockedIn : false,
        dataSource: 'issueExpress',
        fetchTime: now
    }).withId(issueId).withRemoteLinks(remoteLinks).build();
};
const $b6c369d51634b049$var$transformConfluenceWhiteboardData = (response)=>{
    const issueToWhiteboard = response?.graphStore?.issueToWhiteboard ?? {};
    const whiteboards = issueToWhiteboard.edges?.map(({ node: node })=>({
            whiteboardId: node.whiteboardId,
            author: {
                ...node.author
            },
            href: `${node.links?.base}${node.links?.webUi}`,
            type: (0, $3ElT9.CONFLUENCE_WHITEBOARD),
            id: node.id,
            title: node.title
        }));
    return {
        confluenceWhiteboards: {
            linkedWhiteboards: {
                whiteboardCount: issueToWhiteboard.totalCount,
                whiteboards: whiteboards
            }
        }
    };
};
const $b6c369d51634b049$export$83220ed1a595568a = (baseUrl, issueKey)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $gNavb.fetchIssueRemoteData)(baseUrl, issueKey).map((graphQlIssue)=>$b6c369d51634b049$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)).filter(Boolean).catch((err)=>{
        (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $3JafE.Observable).empty();
    });
const $b6c369d51634b049$export$3aec720cf88c26cd = (issueKey, cloudId)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $gNavb.fetchIssueRemoteData)('', issueKey).pipe((0, $6yPEx.switchMap)((remoteDataResponse)=>(0, $gNavb.fetchIssueConfluenceWhiteboardData)(remoteDataResponse.issueId, cloudId).pipe((0, $aynDk.map)((confluenceWhiteboardDataResponse)=>{
            const confluenceWhiteboards = $b6c369d51634b049$var$transformConfluenceWhiteboardData(confluenceWhiteboardDataResponse);
            const combinedRemoteData = {
                ...remoteDataResponse,
                remoteLinks: {
                    ...remoteDataResponse.remoteLinks,
                    ...confluenceWhiteboards
                }
            };
            return combinedRemoteData;
        }), (0, $aynDk.map)((graphQlIssue)=>$b6c369d51634b049$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)), (0, $dXapj.filter)(Boolean), (0, $df9H8.catchError)((err)=>{
            (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueConfluenceWhiteboardData: Failed to fetch confluence whiteboards from AGG', err);
            return (0, $cwK3t.of)($b6c369d51634b049$var$transformGraphQlIssueRemoteData(remoteDataResponse, issueKey));
        }))), (0, $df9H8.catchError)((err)=>{
        (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $3JafE.Observable).empty();
    }));

});
parcelRegister("3ElT9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_BLOGPOST", () => $5a00b441e09ec27d$export$b0807d3d613e535);
$parcel$export(module.exports, "CONFLUENCE_WHITEBOARD", () => $5a00b441e09ec27d$export$489cb2e515fef0c4);
$parcel$export(module.exports, "toConfluencePageType", () => $5a00b441e09ec27d$export$a7ae1ae0a3d7d205);
const $5a00b441e09ec27d$export$b0807d3d613e535 = 'blogpost';
const $5a00b441e09ec27d$export$353109fb558251b1 = 'page';
const $5a00b441e09ec27d$export$489cb2e515fef0c4 = 'whiteboard';
const $5a00b441e09ec27d$export$a7ae1ae0a3d7d205 = (type)=>type === $5a00b441e09ec27d$export$b0807d3d613e535 ? $5a00b441e09ec27d$export$b0807d3d613e535 : $5a00b441e09ec27d$export$353109fb558251b1;

});

parcelRegister("3A3OQ", function(module, exports) {

$parcel$export(module.exports, "trackOrLogClientError", () => $abf996733b47dc5f$export$2fc29872103bf255);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
const $abf996733b47dc5f$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $guiFP.default)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $abf996733b47dc5f$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $JRB5w.isClientFetchError)(error)) $abf996733b47dc5f$export$c392d6295c0a29c7(location, message, error);
    else (0, $gUUjF.default).safeErrorWithoutCustomerData(location, message, error);
};

});

parcelRegister("l0eyw", function(module, exports) {

$parcel$export(module.exports, "createIssue", () => $97e912da463a0056$export$b61347e00e271b8e);
class $97e912da463a0056$var$IssueBuilder {
    constructor({ key: key }){
        this.key = key;
        this.fields = new Map();
    }
    withMeta(meta) {
        this.meta = meta;
        return this;
    }
    // go/jfe-eslint
    withId(id) {
        this.id = id;
        return this;
    }
    // go/jfe-eslint
    withFields(fields) {
        fields.forEach(this.withField, this);
        return this;
    }
    // go/jfe-eslint
    withField(field) {
        if (field) this.fields.set(String(field.key), field);
        return this;
    }
    // go/jfe-eslint
    withRemoteLinks(remoteLinks) {
        this.remoteLinks = remoteLinks;
        return this;
    }
    // go/jfe-eslint
    withPreferences(myPreferences) {
        this.myPreferences = myPreferences;
        return this;
    }
    // go/jfe-eslint
    withComments(commentsData) {
        this.commentsData = commentsData;
        return this;
    }
    // go/jfe-eslint
    withWorkflow(workflow) {
        this.workflow = workflow;
        return this;
    }
    // go/jfe-eslint
    withActivitySortOrder(activitySortOrder) {
        this.activitySortOrder = activitySortOrder;
        return this;
    }
    build() {
        const meta = this.meta !== null && this.meta !== undefined ? this.meta : {
            dataSource: 'unknown',
            newIssueViewLockedIn: false,
            fetchTime: new Date()
        };
        const remoteLinks = this.remoteLinks !== null && this.remoteLinks !== undefined ? this.remoteLinks : {
            confluencePages: {
                linkedPages: {
                    pageCount: 0
                },
                mentionedPages: {
                    pageCount: 0
                }
            },
            confluenceWhiteboards: {
                linkedWhiteboards: {
                    whiteboardCount: 0
                }
            },
            webLinks: {
                linkCount: 0
            },
            remoteLinkedIssues: []
        };
        const myPreferences = this.myPreferences !== null && this.myPreferences !== undefined ? this.myPreferences : {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let users = {};
        let comments = {
            totalCount: 0,
            startIndex: 0,
            comments: {}
        };
        if (this.commentsData !== null && this.commentsData !== undefined) {
            comments = {
                totalCount: this.commentsData.totalCount,
                // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
                startIndex: this.commentsData.startIndex,
                comments: this.commentsData.comments
            };
            users = this.commentsData.users;
        }
        const workflow = this.workflow !== null && this.workflow !== undefined ? this.workflow : undefined;
        const activitySortOrder = this.activitySortOrder;
        const issue = {
            key: this.key,
            fields: this.fields,
            meta: meta,
            remoteLinks: remoteLinks,
            myPreferences: myPreferences,
            comments: comments,
            users: users,
            workflow: workflow,
            activitySortOrder: activitySortOrder,
            ...this.id !== null && this.id !== undefined ? {
                id: this.id
            } : undefined
        };
        return issue;
    }
}
const $97e912da463a0056$export$b61347e00e271b8e = ({ key: key })=>new $97e912da463a0056$var$IssueBuilder({
        key: key
    });

});

parcelRegister("gNavb", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData", () => $c265b6b62f0ef502$export$619c3be06a997564);
$parcel$export(module.exports, "fetchIssueConfluenceWhiteboardData", () => $c265b6b62f0ef502$export$886e1cd5d478fbe5);
parcelRequire("jyKN9");
parcelRequire("bI4RP");
parcelRequire("flmol");
parcelRequire("iects");

var $aiRd8 = parcelRequire("aiRd8");

var $gIOVj = parcelRequire("gIOVj");

var $9s86T = parcelRequire("9s86T");

var $6VKiL = parcelRequire("6VKiL");

var $5WNEZ = parcelRequire("5WNEZ");

var $fwqh1 = parcelRequire("fwqh1");

var $11LM5 = parcelRequire("11LM5");
const $c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD = 5;
const $c265b6b62f0ef502$var$CREATED_ORDER_DESCENDING = '-created';
const $c265b6b62f0ef502$var$commentParameter = ()=>{
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $9s86T.getPermalinkStatus)((0, $6VKiL.COMMENTS));
    return hasPermalink ? `, commentId: ${permalinkId}` : '';
};
const $c265b6b62f0ef502$var$LOG_LOCATION = 'issue.data-provider.source.issue-express.graphql';
const $c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $c265b6b62f0ef502$var$addQueryForRemoteLinks = ()=>`remoteLinks {
       isLinkingEnabled
       confluencePages {
         linkedPages {
            pageCount
         }
         mentionedPages {
            pageCount
         }
       }
     }`;
const $c265b6b62f0ef502$var$getCommentsQuery = ()=>{
    const commentAmountParameter = `, commentAmount: ${Math.floor($c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD / 2)}`;
    const orderByParameter = `, orderBy: "${$c265b6b62f0ef502$var$CREATED_ORDER_DESCENDING}"`;
    const query = `comments (first: 0, maxResults: ${$c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD}${orderByParameter}, isPreview: true ${$c265b6b62f0ef502$var$commentParameter()}${commentAmountParameter}) {
            nodes{
              id
              author {
                  accountId
                  displayName
                  avatarUrl
              }
              updateAuthor {
                  accountId
                  displayName
                  avatarUrl
              }
              visibility {
                  type
                  value
              }
              created
              updated
              jsdPublic
              bodyAdf
              jsdAuthorCanSeeRequest
            }
            totalCount
            startIndex
          }
        `;
    return query;
};
const $c265b6b62f0ef502$export$895cf5b64d42d88d = ()=>`
        issueId
        fields {
            __typename

            ... on ProjectField {
                fieldKey
                type
                simplified
                name
            }

            ... on TextField {
                fieldKey
                title
                isEditable
                textValue
                adf
                renderer
            }

            ... on IssueTypeField {
              fieldKey
              id
              iconUrl
              name
            }

            ... on StatusField {
              fieldKey
              name
              statusCategoryId
            }

            ... on IssueKeyField {
              fieldKey
              stringValue
            }

            ... on PriorityField {
              fieldKey
              title
              isEditable
              iconUrl
              name
              id
            }

            ... on UserField {
              fieldKey
              title
              isEditable
              userValue {
                displayName
                avatarUrl
                accountId
              }
            }

            ... on VersionsField {
              fieldKey
              title
              isEditable
              versions {
                id
                name
              }
            }

            ... on LabelsField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on ProjectComponentsField {
              fieldKey
              title
              isEditable
              componentValues {
                id
                name
              }
            }

            ... on TimeTrackingField {
              fieldKey
              title
              isEditable
              originalEstimate {
                estimateSeconds
              }
              remainingEstimate {
                estimateSeconds
              }
              timeSpent {
                estimateSeconds
              }
            }

            ... on StoryPointsField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on EpicLinkField {
              fieldKey
              title
              isEditable
              epic {
                id
                key
                name
                summary
                colorKey
                done
              }
            }

            ... on EpicNameField {
              fieldKey
              stringValue
              title
              isEditable
            }

            ... on EpicStatusField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on SprintCustomField {
              fieldKey
              title
              isEditable
              values {
                id
                name
                goal
                state
                boardId
                startDate
                endDate
                completeDate
              }
            }

            ... on SelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on CascadingSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
                  child {
                    optionId
                    value
                  }
              }
            }

            ... on UserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUser {
                displayName
                avatarUrl
              }
            }

            ... on TextAreaCustomField {
              fieldKey
              title
              isEditable
              wiki
              adf
              renderer
              textValue
            }

            ... on FloatCustomField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on DatePickerCustomField {
              fieldKey
              title
              isEditable
              stringValue
            }

            ... on DateTimeCustomField {
              fieldKey
              title
              isEditable
              dateTime
            }

            ... on TextFieldCustomField {
              fieldKey
              title
              isEditable
              wiki
            }

            ... on MultiSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValues {
                  optionId
                  value
              }
            }

            ... on LabelsCustomField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on MultiUserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUsers {
                accountId
                displayName
                avatarUrl
              }
            }

            ... on UrlCustomField {
              fieldKey
              title
              isEditable
              url
            }

            ... on VersionCustomField {
              fieldKey
              title
              isEditable
              version {
                  id
                  name
              }
            }

            ... on GroupPickerCustomField {
              fieldKey
              title
              isEditable
              group
            }

            ... on MultiVersionCustomField {
              fieldKey
              title
              isEditable
              versions {
                  id
                  name
              }
            }

            ... on MultiGroupPickerCustomField {
              fieldKey
              title
              isEditable
              groups
            }

            ... on DateField {
              fieldKey
              stringValue
              isEditable
              title
            }

            ... on CheckBoxesCustomField {
                fieldKey
                isEditable
                title
                selectedValues {
                    optionId
                    value
                }
            }

            ... on RadioButtonsCustomField {
                fieldKey
                isEditable
                title
                selectedValue {
                    optionId
                    value
                }
            }

            ... on ColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on EpicColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on ResolutionField {
                id
                fieldKey
                name
            }

            ... on FlaggedCustomField {
                fieldKey
                title
                isFlagged
                isEditable
                selectedValues {
                    optionId
                    value
                }
            }

            ... on ProjectCustomField {
              fieldKey
              key
              name
              title
              avatarUrl
              isEditable
            }
        }
        ${$c265b6b62f0ef502$var$addQueryForRemoteLinks()}
        ${$c265b6b62f0ef502$var$getCommentsQuery()}
    `;
const $c265b6b62f0ef502$var$getQueryPrefix = ()=>'_all';
const $c265b6b62f0ef502$var$getFieldPinningPreference = (projectKey)=>projectKey != null ? `"jira.user.issue.details.pinned-fields.${projectKey}",` : '';
const $c265b6b62f0ef502$var$getQueryForMyPreferences = (projectKey)=>`
    myPreferences(keys: [
        "jira.user.issue.changeboarding.lastinteracted",
        "jira.user.issue.clickthrough-banner.lastinteracted",
        "jira.user.issue.pinned-fields-banner.lastinteracted",
        ${$c265b6b62f0ef502$var$getFieldPinningPreference(projectKey)}
    ])`;
const $c265b6b62f0ef502$var$getProjectQueryFragment = (projectKey)=>`
    project(projectKey: "${projectKey}") {
        newIssueViewLockedIn
    }
`;
const $c265b6b62f0ef502$export$71eec30d9db46a56 = (projectKey)=>`query issueViewQuery($issueKey: String!) {
    ${$c265b6b62f0ef502$var$getQueryForMyPreferences(projectKey)}
    ${projectKey !== undefined ? $c265b6b62f0ef502$var$getProjectQueryFragment(projectKey) : ''}
    ${$c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS}${$c265b6b62f0ef502$var$getQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        ${$c265b6b62f0ef502$export$895cf5b64d42d88d()}
    }
    activitySortOrder
}
`;
const $c265b6b62f0ef502$var$getFieldDataOptions = (query, variables)=>({
        method: 'POST',
        body: JSON.stringify({
            query: query,
            variables: variables
        }),
        perf: (0, $5WNEZ.fetchIssueExpressPerf)
    });
const $c265b6b62f0ef502$export$619c3be06a997564 = (baseUrl, issueKey)=>(0, $aiRd8.default)((0, $gIOVj.getGiraUrl)(baseUrl, 'issueViewRemoteDataQuery'), $c265b6b62f0ef502$var$getFieldDataOptions((0, $fwqh1.getIssueRemoteDataQuery)(), {
        issueKey: issueKey
    }))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($c265b6b62f0ef502$var$LOG_LOCATION, response))// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '`bentoViewIssue${string}`' can't be used to index type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
    .map((value)=>value[`${$c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS}${(0, $fwqh1.getRemoteDataQueryPrefix)()}`]);
const $c265b6b62f0ef502$export$886e1cd5d478fbe5 = (issueId, cloudId)=>(0, $aiRd8.default)('/gateway/api/graphql?operation=issueViewRemoteConfluenceWhiteboardQuery', $c265b6b62f0ef502$var$getFieldDataOptions((0, $fwqh1.getIssueRemoteConfluenceWhiteboardQuery)(), {
        id: `ari:cloud:jira:${cloudId}:issue/${issueId}`
    })).map((response)=>(0, $11LM5.getGraphQlData)($c265b6b62f0ef502$var$LOG_LOCATION, response));

});
parcelRegister("9s86T", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $6e310a2be6a89df8$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $6e310a2be6a89df8$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $6e310a2be6a89df8$export$b66f3e03c722c21c);

var $5iWql = parcelRequire("5iWql");

var $53ciZ = parcelRequire("53ciZ");

var $6VKiL = parcelRequire("6VKiL");
const $6e310a2be6a89df8$export$58d3deae755361f = (0, $5iWql.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parseUrl(searchString).query;
    if (params[(0, $6VKiL.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $6VKiL.COMMENTS),
        permalinkId: params[(0, $6VKiL.PermalinkType).COMMENTS]
    };
    if (params[(0, $6VKiL.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $6VKiL.WORKLOG),
        permalinkId: params[(0, $6VKiL.PermalinkType).WORKLOG]
    };
    return null;
});
const $6e310a2be6a89df8$export$f72cac1fa8a03e80 = ()=>$6e310a2be6a89df8$export$58d3deae755361f(window.location.search);
const $6e310a2be6a89df8$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $6e310a2be6a89df8$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $6e310a2be6a89df8$export$b66f3e03c722c21c = (id, permalinkType)=>{
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $6VKiL.PermalinkType).WORKLOG ? (0, $6VKiL.PermalinkType).COMMENTS : (0, $6VKiL.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});
parcelRegister("6VKiL", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $5c63d4511ab79db4$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $5c63d4511ab79db4$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $5c63d4511ab79db4$export$b18d061fc042df1a);
const $5c63d4511ab79db4$export$4cab9dfa8fc858f4 = 'Comments';
const $5c63d4511ab79db4$export$df36fc05622c402 = 'Worklog';
const $5c63d4511ab79db4$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});


parcelRegister("5WNEZ", function(module, exports) {

$parcel$export(module.exports, "fetchIssueExpressPerf", () => $9e9290dca99e7c55$export$9040f8aef1f66451);
const $9e9290dca99e7c55$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $9e9290dca99e7c55$var$FETCH_ISSUE_EXPRESS_REQUEST = 'FETCH_ISSUE_EXPRESS';
const $9e9290dca99e7c55$export$9040f8aef1f66451 = {
    key: $9e9290dca99e7c55$var$FETCH_ISSUE_EXPRESS_REQUEST,
    prefix: $9e9290dca99e7c55$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});

parcelRegister("fwqh1", function(module, exports) {

$parcel$export(module.exports, "getRemoteDataQueryPrefix", () => $2acde4462d7c1f98$export$1a164444721ce2fb);
$parcel$export(module.exports, "getIssueRemoteDataQuery", () => $2acde4462d7c1f98$export$65f9808f978ee25);
$parcel$export(module.exports, "getIssueRemoteConfluenceWhiteboardQuery", () => $2acde4462d7c1f98$export$8ec691b48e552cf4);
const $2acde4462d7c1f98$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $2acde4462d7c1f98$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
const $2acde4462d7c1f98$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$2acde4462d7c1f98$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
const $2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$2acde4462d7c1f98$var$getConfluencePagesQueryFragment()}
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $2acde4462d7c1f98$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$2acde4462d7c1f98$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $2acde4462d7c1f98$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $2acde4462d7c1f98$var$getRemoteDataQueryFragment = ()=>`
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${$2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$2acde4462d7c1f98$export$761fd517f0dda983()}
        ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $2acde4462d7c1f98$export$1a164444721ce2fb = ()=>'_remote_data';
const $2acde4462d7c1f98$export$65f9808f978ee25 = ()=>`
    query issueViewRemoteDataQuery($issueKey: String!) {
        ${$2acde4462d7c1f98$var$VIEW_ISSUE_ALIAS}${$2acde4462d7c1f98$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
            ${$2acde4462d7c1f98$var$getRemoteDataQueryFragment()}
        }
    }
`;
const $2acde4462d7c1f98$export$8ec691b48e552cf4 = ()=>`
    query issueViewRemoteConfluenceWhiteboardQuery($id: ID!) {
        graphStore @optIn(to: "GraphStore") {
            issueToWhiteboard (id: $id first: 900) @optIn(to: "GraphStoreIssueToWhiteboard") {
                edges {
                    node {
                        ... on ConfluenceWhiteboard {
                            id
                            links {
                                base
                                webUi
                            }
                            author {
                                user {
                                accountId
                                accountStatus
                                name
                                picture
                                }
                            }
                            title
                            whiteboardId
                        }
                    }
                }
                totalCount
            }
        }
    }
`;

});

parcelRegister("11LM5", function(module, exports) {

$parcel$export(module.exports, "getGraphQlData", () => $c6aa0580bc22e808$export$b30cdd26702abb9d);
$parcel$export(module.exports, "checkEmptyResponse", () => $c6aa0580bc22e808$export$a0603b0ff181c30a);

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");

var $l3WD8 = parcelRequire("l3WD8");
const $c6aa0580bc22e808$export$b30cdd26702abb9d = (logLocation, graphQlResponse)=>{
    if (graphQlResponse.errors) {
        const firstError = graphQlResponse.errors[0];
        const validationError = new (0, $7byHA.ValidationError)(firstError.message);
        (0, $gUUjF.default).safeErrorWithoutCustomerData(logLocation, 'getGraphQlData: Error present in GraphQL response', validationError);
        throw validationError;
    }
    return graphQlResponse.data;
};
const $c6aa0580bc22e808$var$emptyResponseText = 'Response is either not present or has no data.';
const $c6aa0580bc22e808$export$a0603b0ff181c30a = (response)=>{
    if (!response || !Object.prototype.hasOwnProperty.call(response, 'data')) throw new (0, $l3WD8.NoDataError)($c6aa0580bc22e808$var$emptyResponseText);
    if (response.data === null) throw new (0, $l3WD8.NoDataError)($c6aa0580bc22e808$var$emptyResponseText);
    return response;
};

});
parcelRegister("l3WD8", function(module, exports) {

$parcel$export(module.exports, "NoDataError", () => $001694e1095e542c$export$5faf0a0592e30f56);
class $001694e1095e542c$export$5faf0a0592e30f56 extends Error {
}

});



const $330b0f1977bf0938$export$40bed7a29c3b629 = 'IssueKeyField';







parcelRegister("fijOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $68bf4db62e7e9525$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68bf4db62e7e9525$var$LazyProjectKeyboardShortcuts = (0, $7rh0R.lazy)(()=>(parcelRequire("b2w1X")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $68bf4db62e7e9525$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($68bf4db62e7e9525$var$LazyProjectKeyboardShortcuts, props)));
var $68bf4db62e7e9525$export$2e2bcd8739ae039 = $68bf4db62e7e9525$var$ProjectKeyboardShortcuts;

});
parcelRegister("b2w1X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("28hU0")
]).then(()=>parcelRequire('8aQut'));

});


parcelRegister("gkvbX", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomerTemplatesOnboardingModal", () => $8996671b6acbaa82$export$d0eebcb77e325be9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kMhLP = parcelRequire("kMhLP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8996671b6acbaa82$var$LazyCustomerTemplatesOnboardingModal = (0, $7rh0R.lazy)(()=>(parcelRequire("eyoc3")).then(({ CustomerTemplatesOnboardingModal: CustomerTemplatesOnboardingModal })=>CustomerTemplatesOnboardingModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/customer-templates-onboarding-modal/index.tsx"
});
const $8996671b6acbaa82$export$d0eebcb77e325be9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncCustomerTemplatesOnboardingModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-modals-customer-templates",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8996671b6acbaa82$var$LazyCustomerTemplatesOnboardingModal, null)));

});
parcelRegister("eyoc3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2n3YQ")
]).then(()=>parcelRequire('8znwe'));

});


parcelRegister("gBYS0", function(module, exports) {

$parcel$export(module.exports, "AsyncKanbanOnboardingModal", () => $d74493593d832d21$export$64da8380143ef676);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kMhLP = parcelRequire("kMhLP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d74493593d832d21$var$LazyKanbanOnboardingModal = (0, $7rh0R.lazy)(()=>(parcelRequire("dxD9g")).then(({ KanbanOnboardingModal: KanbanOnboardingModal })=>KanbanOnboardingModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/kanban-onboarding-modal/index.tsx"
});
const $d74493593d832d21$export$64da8380143ef676 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncKanbanOnboardingModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-modals-kanban-onboarding",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d74493593d832d21$var$LazyKanbanOnboardingModal, null)));

});
parcelRegister("dxD9g", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7OwPe")
]).then(()=>parcelRequire('ba13C'));

});


parcelRegister("5ESJx", function(module, exports) {

$parcel$export(module.exports, "AsyncScrumOnboardingModal", () => $afeb333d095a0efd$export$744c5f72d1694510);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kMhLP = parcelRequire("kMhLP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $afeb333d095a0efd$var$LazyScrumOnboardingModal = (0, $7rh0R.lazy)(()=>(parcelRequire("a3YvX")).then(({ ScrumOnboardingModal: ScrumOnboardingModal })=>ScrumOnboardingModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/scrum-onboarding-modal/index.tsx"
});
const $afeb333d095a0efd$export$744c5f72d1694510 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncScrumOnboardingModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-modals-scrum-onboarding",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($afeb333d095a0efd$var$LazyScrumOnboardingModal, null)));

});
parcelRegister("a3YvX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iR79G")
]).then(()=>parcelRequire('dC27m'));

});


parcelRegister("dQklQ", function(module, exports) {

$parcel$export(module.exports, "AsyncWelcomeModal", () => $dfcf260091c99929$export$d08881a6c29dfdb2);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $eI5EY = parcelRequire("eI5EY");

var $kMhLP = parcelRequire("kMhLP");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

var $kGtVJ = parcelRequire("kGtVJ");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfcf260091c99929$var$LazyWelcomeModal = (0, $7rh0R.lazy)(()=>(parcelRequire("e845X")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfcf260091c99929$var$LazyWelcomeModalVariation = (0, $7rh0R.lazy)(()=>(parcelRequire("gohDO")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/atlas-67241/index.tsx"
});
const $dfcf260091c99929$export$d08881a6c29dfdb2 = ({ source: source })=>{
    const shouldShowSelectInitialViewVariation = (0, $eI5EY.fg)('jfind-select-initial-view-enabled-gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kGtVJ.useShouldShowSelectInitialViewVariation)(source) : false;
    if (shouldShowSelectInitialViewVariation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "async-onboarding-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncWelcomeModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-modals-welcome-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dfcf260091c99929$var$LazyWelcomeModalVariation, {
        source: source
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "async-onboarding-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncWelcomeModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-modals-welcome-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dfcf260091c99929$var$LazyWelcomeModal, {
        source: source
    }))));
};

});
parcelRegister("kGtVJ", function(module, exports) {

$parcel$export(module.exports, "useShouldShowModalBasedOnSessionStorage", () => $660332f8ba92067f$export$b39cbd941f378bec);
$parcel$export(module.exports, "useShouldShowSelectInitialViewVariation", () => $660332f8ba92067f$export$ce5380956e5e806e);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");


var $lkBAJ = parcelRequire("lkBAJ");

var $2Dd39 = parcelRequire("2Dd39");
const $660332f8ba92067f$export$5f216c5aa25602ea = ()=>{
    const value = (0, $79xbN.expVal)('jfind-select-initial-view', 'cohort', 'not-enrolled');
    return value === 'variation';
};
const $660332f8ba92067f$export$b39cbd941f378bec = ()=>{
    const shouldShowModalBasedOnSessionStorage = (0, $eUqFw.useMemo)(()=>{
        const sessionStorageVal = (0, $lkBAJ.sessionStorageProvider).get((0, $8379f5d78bf6fb5a$export$e3884212029f7bef));
        if (sessionStorageVal === undefined) return false;
        if (!(0, $eI5EY.fg)('fix_welcome_modal_in_strict_mode_')) (0, $lkBAJ.sessionStorageProvider).remove((0, $8379f5d78bf6fb5a$export$e3884212029f7bef));
        return true;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // Remove the session storage value to prevent the modal showing again
        if ((0, $eI5EY.fg)('fix_welcome_modal_in_strict_mode_')) (0, $lkBAJ.sessionStorageProvider).remove((0, $8379f5d78bf6fb5a$export$e3884212029f7bef));
    }, []);
    return shouldShowModalBasedOnSessionStorage;
};
const $660332f8ba92067f$export$b01115c2f75a04f8 = (source)=>{
    const canShowNudgeTour = (0, $2Dd39.useCanShowNudgeTour)();
    const sessionStorageVal = (0, $eUqFw.useMemo)(()=>(0, $lkBAJ.sessionStorageProvider).get((0, $8379f5d78bf6fb5a$export$e3884212029f7bef)), []);
    if (sessionStorageVal === undefined) return false;
    return canShowNudgeTour(source);
};
const $660332f8ba92067f$export$ce5380956e5e806e = (source)=>{
    const shouldShowModal = $660332f8ba92067f$export$b01115c2f75a04f8(source);
    const canEnrollInSelectInitialViewBasedOnSessionStorage = (0, $eUqFw.useMemo)(()=>{
        if (!shouldShowModal) return false;
        const sessionStorageVal = (0, $lkBAJ.sessionStorageProvider).get((0, $8379f5d78bf6fb5a$export$eaf6b96a17b6476c));
        if (sessionStorageVal === undefined) return false;
        if (!$660332f8ba92067f$export$5f216c5aa25602ea()) return false;
        return true;
    }, [
        shouldShowModal
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $lkBAJ.sessionStorageProvider).remove((0, $8379f5d78bf6fb5a$export$eaf6b96a17b6476c));
    }, []);
    return canEnrollInSelectInitialViewBasedOnSessionStorage;
};

});
parcelRegister("lkBAJ", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $38ca6466cf2419a3$export$f119d83aa936d634);
$parcel$export(module.exports, "sessionStorageProvider", () => $38ca6466cf2419a3$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorage", () => $38ca6466cf2419a3$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");

var $89bO2 = parcelRequire("89bO2");




const $38ca6466cf2419a3$export$f119d83aa936d634 = (0, $89bO2.createSessionExpirableStorageProvider)('onboarding-core');
const $38ca6466cf2419a3$export$5a24cb3021127ff7 = (0, $89bO2.createSessionExpirableStorageProvider)('onboarding-core');
const $38ca6466cf2419a3$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("2Dd39", function(module, exports) {

$parcel$export(module.exports, "useCanShowNudgeTour", () => $47acbefa3aefafad$export$3381da528a252680);

var $7dRgX = parcelRequire("7dRgX");

var $5cLMB = parcelRequire("5cLMB");
const $47acbefa3aefafad$export$3381da528a252680 = ()=>{
    const [completedTaskList] = (0, $5cLMB.useCompletedTaskList)();
    const [shouldShowScrumOnboardingExperience] = (0, $5cLMB.useShouldShowScrumOnboardingExperience)();
    const [shouldShowOnboardingKanbanTour] = (0, $5cLMB.useShouldShowOnboardingKanbanTour)();
    const shouldShowOnboardingScrumTour = shouldShowScrumOnboardingExperience === true && // edge case for KURO-2088: After welcome modal failed to load, users complete welcome tour by themselves. Welcome modal should be skipped to load on refreshment.
    !completedTaskList.includes((0, $7dRgX.SCRUM_ONBOARDING_TASK));
    return (source)=>{
        switch(source){
            case 'board':
                return shouldShowOnboardingKanbanTour;
            case 'backlog':
                return shouldShowOnboardingScrumTour;
            case 'timeline':
                // display if eligible for either board/backlog scenarios
                return shouldShowOnboardingKanbanTour || shouldShowOnboardingScrumTour;
            default:
                return false;
        }
    };
};

});


parcelRegister("e845X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lEfSG")
]).then(()=>parcelRequire('gcXcS'));

});

parcelRegister("gohDO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eYjVx")
]).then(()=>parcelRequire('hPOns'));

});


parcelRegister("6sf1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d00c262f6c1cfd$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cuKcG = parcelRequire("cuKcG");

var $lmxP0 = parcelRequire("lmxP0");

var $cPQoz = parcelRequire("cPQoz");
var $56d00c262f6c1cfd$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        payloadGIC: (0, $lmxP0.getPayloadGlobalIssueCreate)(state)
    }), {
    onClearGICPayload: (0, $cuKcG.clearPayloadGlobalIssueCreate)
})((0, $cPQoz.default));

});
parcelRegister("lmxP0", function(module, exports) {

$parcel$export(module.exports, "getPayloadGlobalIssueCreate", () => $9ad8125631e7eda9$export$6d8c2c3612652d80);
const $9ad8125631e7eda9$export$6d8c2c3612652d80 = (state)=>state.entities.globalIssueCreate.payloadGIC;

});

parcelRegister("cPQoz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec3e20156ee6380$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ec3e20156ee6380$var$JiraGlobalIssueCreateDialogTrigger = (0, $7rh0R.lazy)(()=>(parcelRequire("1iJnk")), {
    moduleId: "./src/packages/software/roadmap/standard/src/view/global-issue-create/dialog-trigger/view.tsx"
});
const $6ec3e20156ee6380$var$LazyJiraGlobalIssueCreateDialogTrigger = (props)=>{
    const { payloadGIC: payloadGIC } = props;
    if (payloadGIC !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-global-issue-create",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-global-issue-create",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ec3e20156ee6380$var$JiraGlobalIssueCreateDialogTrigger, props)));
    return null;
};
var $6ec3e20156ee6380$export$2e2bcd8739ae039 = $6ec3e20156ee6380$var$LazyJiraGlobalIssueCreateDialogTrigger;

});
parcelRegister("1iJnk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cLe0S").then(()=>parcelRequire('a6lNE'));

});



parcelRegister("cNop8", function(module, exports) {

$parcel$export(module.exports, "default", () => $152ced70538f3dad$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $j45xj = parcelRequire("j45xj");

var $gIA6S = parcelRequire("gIA6S");
var $152ced70538f3dad$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, {
    onJiraGlobalIssueCreateClosed: (0, $j45xj.globalIssueCreate)
})((0, $gIA6S.default));

});
parcelRegister("gIA6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $40c2aeeb9f7873de$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $2BvS3 = parcelRequire("2BvS3");
const $40c2aeeb9f7873de$var$JiraGlobalIssueListener = ({ isMacroView: isMacroView, onJiraGlobalIssueCreateClosed: onJiraGlobalIssueCreateClosed })=>{
    const subscriptionHandle = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
    const globalIssueCreateEventHandler = (0, $eUqFw.useCallback)((event, issues)=>{
        const globalIssues = (issues || []).reduce((acc, issue)=>{
            if (issue.createdIssueDetails) acc.push({
                issueId: issue.createdIssueDetails.id,
                issueKey: issue.createdIssueDetails.key,
                projectId: issue.createdIssueDetails.fields.project.id,
                issueTypeId: issue.createdIssueDetails.fields.issuetype.id
            });
            return acc;
        }, []);
        onJiraGlobalIssueCreateClosed(globalIssues);
    }, [
        onJiraGlobalIssueCreateClosed
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isMacroView) // window.require is not available on initial script load.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/wrm/no-load-bridge
        (0, $2BvS3.loadBridge)({
            name: 'jira/util/events',
            wrmKeys: 'wrc!jira.webresources:jira-events'
        }).then((Events)=>{
            if (Events?.bind) {
                Events.bind('QuickCreateIssue.sessionComplete', globalIssueCreateEventHandler);
                subscriptionHandle.current = ()=>{
                    Events.unbind('QuickCreateIssue.sessionComplete', globalIssueCreateEventHandler);
                };
            }
        });
        return ()=>{
            subscriptionHandle.current();
            subscriptionHandle.current = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        };
    }, [
        isMacroView,
        globalIssueCreateEventHandler
    ]);
    return null;
};
var $40c2aeeb9f7873de$export$2e2bcd8739ae039 = $40c2aeeb9f7873de$var$JiraGlobalIssueListener;

});


parcelRegister("kXTWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $17857d1b4bf34a90$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $iJJay = parcelRequire("iJJay");

var $32SMV = parcelRequire("32SMV");
var $17857d1b4bf34a90$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        panelType: (0, $iJJay.getPanelType)(state)
    }), {})((0, $32SMV.default));

});
parcelRegister("32SMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f237555386952f32$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5mxwY = parcelRequire("5mxwY");
const $f237555386952f32$var$TableOverlay = ({ panelType: panelType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mxwY.default), {
        panelType: panelType
    });
var $f237555386952f32$export$2e2bcd8739ae039 = $f237555386952f32$var$TableOverlay;

});
parcelRegister("5mxwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6584a8d64f08c869$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5MpXz = parcelRequire("5MpXz");

var $9N1AA = parcelRequire("9N1AA");

var $jeciO = parcelRequire("jeciO");
var $6584a8d64f08c869$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        issuePanelRatio: (0, $9N1AA.getIssuePanelRatio)(state)
    }), {
    setIssuePanelRatio: $5MpXz.setIssuePanelRatio
})((0, $jeciO.RoadmapPanel));

});
parcelRegister("jeciO", function(module, exports) {

$parcel$export(module.exports, "RoadmapPanel", () => $4a317576de53f167$export$99a243582d86ff6);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");


var $eouHp = parcelRequire("eouHp");
const $4a317576de53f167$export$99a243582d86ff6 = ({ panelType: panelType, issuePanelRatio: issuePanelRatio, setIssuePanelRatio: setIssuePanelRatio })=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $eouHp.ResizerLazy).preload();
    }, []);
    if (panelType === (0, $fa44db75711523b7$export$e90b483346a763db)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _1bsb1osq _4t3i1osq _1pby1o8a _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zidpf _i0dlf1ug _4t3i1osq"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eouHp.default), {
        issuePanelRatio: issuePanelRatio,
        setIssuePanelRatio: setIssuePanelRatio
    }));
    return null;
};
const $4a317576de53f167$var$staticContainerStyles = null;
const $4a317576de53f167$var$resizerWrapperStyles = null;

});
parcelRegister("eouHp", function(module, exports) {

$parcel$export(module.exports, "ResizerLazy", () => $472475a2707ff1d6$export$a7e89b4c69122d77);
$parcel$export(module.exports, "default", () => $472475a2707ff1d6$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $1gs0D = parcelRequire("1gs0D");

const $472475a2707ff1d6$export$a7e89b4c69122d77 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9XrRx")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/standard/src/view/table-overlay/panel/resizer/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$472475a2707ff1d6$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-standard-roadmap-feedback",
        packageName: (0, $1gs0D.ROADMAP_PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "standard-roadmap-resizer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($472475a2707ff1d6$export$a7e89b4c69122d77, props)));

});
parcelRegister("9XrRx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("iFY8l")
]).then(()=>parcelRequire('53cMh'));

});









parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("81WTV", function(module, exports) {

$parcel$export(module.exports, "roadmapPageLoad", () => $bc4367bc96768fbf$export$c285c2b2be61e659);

var $lNfG4 = parcelRequire("lNfG4");
const $bc4367bc96768fbf$export$c285c2b2be61e659 = (0, $lNfG4.metrics).pageLoad({
    key: 'roadmap',
    ssr: {
        doneAsFmp: true
    },
    slo: {
        fmp: {
            initial: {
                threshold: 1000
            },
            transition: {
                threshold: 1000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    }
});

});


parcelRegister("fOHQR", function(module, exports) {

$parcel$export(module.exports, "withLicenseCheck", () => $446d107d239775c4$export$9c58509833e46668);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7HKaW = parcelRequire("7HKaW");

var $5p2pw = parcelRequire("5p2pw");

var $a0J8R = parcelRequire("a0J8R");

var $bhwgQ = parcelRequire("bhwgQ");

var $4nlEU = parcelRequire("4nlEU");
const $446d107d239775c4$export$9c58509833e46668 = (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components
    class WithLicenseCheck extends (0, $eUqFw.Component) {
        static{
            this.displayName = `WithLicenseCheck(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nlEU.LicenseStateCheck), {
                type: "software"
            }, ({ licenseState: licenseState })=>{
                if (licenseState === (0, $7HKaW.LICENSE_STATE_ACTIVE)) // TODO: a Readonly marker is introduced somehow, but I can't figure out where
                // @ts-expect-error - TS2322 - Type 'Readonly<LibraryManagedAttributes<WrappedComponentType, ComponentProps<WrappedComponentType>>> & Readonly<...>' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<WrappedComponentType, ComponentProps<WrappedComponentType>> & { ...; }'.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, this.props);
                if (licenseState === (0, $7HKaW.LICENSE_STATE_SUSPENDED)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a0J8R.AsyncSuspendedSoftwareLicense), null);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5p2pw.AsyncNoSoftwareLicense), null);
            }));
        }
    };

});
parcelRegister("5p2pw", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $de0deb0ce0efa641$export$52d8964299339cae);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $de0deb0ce0efa641$var$LazyNoSoftwareLicense = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4qojl")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $de0deb0ce0efa641$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de0deb0ce0efa641$var$LazyNoSoftwareLicense, null));

});
parcelRegister("4qojl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gd5QC").then(()=>parcelRequire('4kT9n'));

});


parcelRegister("a0J8R", function(module, exports) {

$parcel$export(module.exports, "AsyncSuspendedSoftwareLicense", () => $18059a552e79d4f3$export$a2b6823ff422b6ba);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $18059a552e79d4f3$var$LazySuspendedSoftwareLicense = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("akiOt")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/suspended-software-license/index.tsx"
});
const $18059a552e79d4f3$export$a2b6823ff422b6ba = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "suspended-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($18059a552e79d4f3$var$LazySuspendedSoftwareLicense, null));

});
parcelRegister("akiOt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cEByh").then(()=>parcelRequire('90aaJ'));

});


parcelRegister("4nlEU", function(module, exports) {

$parcel$export(module.exports, "LicenseStateCheck", () => $22d137a5c552acc6$export$ce623a03a46f6b64);

var $eUqFw = parcelRequire("eUqFw");

var $7HKaW = parcelRequire("7HKaW");

var $gd0Sp = parcelRequire("gd0Sp");
const $22d137a5c552acc6$var$appLicenseMapper = {
    software: 'software',
    servicedesk: 'serviceDesk'
};
const $22d137a5c552acc6$export$17fd9ec24bb0187f = (tenantContext, type)=>{
    if (tenantContext.licenseStates) return tenantContext.licenseStates[$22d137a5c552acc6$var$appLicenseMapper[type]];
    return 0, $7HKaW.LICENSE_STATE_UNLICENSED;
};
const $22d137a5c552acc6$export$ce623a03a46f6b64 = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const licenseState = $22d137a5c552acc6$export$17fd9ec24bb0187f(tenantContext, type);
        return children({
            licenseState: licenseState
        });
    });

});




//# sourceMappingURL=async-roadmap.d84404d0.js.map
